/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(571);
	module.exports = __webpack_require__(425);


/***/ },
/* 1 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(578);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 3 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 4 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2018 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString === Object.prototype.toString) {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					} else {
						classes.push(arg.toString());
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.useBootstrapPrefix = useBootstrapPrefix;
	exports.createBootstrapComponent = createBootstrapComponent;
	exports.default = exports.ThemeConsumer = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var ThemeContext = /*#__PURE__*/_react.default.createContext({});
	
	var Consumer = ThemeContext.Consumer,
	    Provider = ThemeContext.Provider;
	exports.ThemeConsumer = Consumer;
	
	function ThemeProvider(_ref) {
	  var prefixes = _ref.prefixes,
	      children = _ref.children;
	  var copiedPrefixes = (0, _react.useMemo)(function () {
	    return (0, _extends2.default)({}, prefixes);
	  }, [prefixes]);
	  return /*#__PURE__*/_react.default.createElement(Provider, {
	    value: copiedPrefixes
	  }, children);
	}
	
	function useBootstrapPrefix(prefix, defaultPrefix) {
	  var prefixes = (0, _react.useContext)(ThemeContext);
	  return prefix || prefixes[defaultPrefix] || defaultPrefix;
	}
	
	function createBootstrapComponent(Component, opts) {
	  if (typeof opts === 'string') opts = {
	    prefix: opts
	  };
	  var isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref
	
	  var _opts = opts,
	      prefix = _opts.prefix,
	      _opts$forwardRefAs = _opts.forwardRefAs,
	      forwardRefAs = _opts$forwardRefAs === void 0 ? isClassy ? 'ref' : 'innerRef' : _opts$forwardRefAs;
	
	  var Wrapped = /*#__PURE__*/_react.default.forwardRef(function (_ref2, ref) {
	    var props = (0, _extends2.default)({}, _ref2);
	    props[forwardRefAs] = ref;
	    var bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
	    return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	      bsPrefix: bsPrefix
	    }));
	  });
	
	  Wrapped.displayName = "Bootstrap(" + (Component.displayName || Component.name) + ")";
	  return Wrapped;
	}
	
	var _default = ThemeProvider;
	exports.default = _default;

/***/ },
/* 7 */
[600, 13, 95, 171, 61, 172, 173, 408, 92, 93, 166, 168, 49, 169, 170, 367, 417, 174, 396, 373, 165, 386, 392, 394, 393, 401, 388],
/* 8 */
[600, 12, 85, 147, 59, 148, 149, 320, 82, 83, 142, 144, 46, 145, 146, 280, 326, 150, 308, 286, 141, 299, 305, 307, 306, 312, 301],
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GraphQLError = GraphQLError;
	
	var _printError = __webpack_require__(185);
	
	var _location = __webpack_require__(109);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function GraphQLError( // eslint-disable-line no-redeclare
	message, nodes, source, positions, path, originalError, extensions) {
	  // Compute list of blame nodes.
	  var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [nodes] : undefined; // Compute locations in the source for the given nodes/positions.
	
	
	  var _source = source;
	
	  if (!_source && _nodes) {
	    var node = _nodes[0];
	    _source = node && node.loc && node.loc.source;
	  }
	
	  var _positions = positions;
	
	  if (!_positions && _nodes) {
	    _positions = _nodes.reduce(function (list, node) {
	      if (node.loc) {
	        list.push(node.loc.start);
	      }
	
	      return list;
	    }, []);
	  }
	
	  if (_positions && _positions.length === 0) {
	    _positions = undefined;
	  }
	
	  var _locations;
	
	  if (positions && source) {
	    _locations = positions.map(function (pos) {
	      return (0, _location.getLocation)(source, pos);
	    });
	  } else if (_nodes) {
	    _locations = _nodes.reduce(function (list, node) {
	      if (node.loc) {
	        list.push((0, _location.getLocation)(node.loc.source, node.loc.start));
	      }
	
	      return list;
	    }, []);
	  }
	
	  var _extensions = extensions || originalError && originalError.extensions;
	
	  Object.defineProperties(this, {
	    message: {
	      value: message,
	      // By being enumerable, JSON.stringify will include `message` in the
	      // resulting output. This ensures that the simplest possible GraphQL
	      // service adheres to the spec.
	      enumerable: true,
	      writable: true
	    },
	    locations: {
	      // Coercing falsey values to undefined ensures they will not be included
	      // in JSON.stringify() when not provided.
	      value: _locations || undefined,
	      // By being enumerable, JSON.stringify will include `locations` in the
	      // resulting output. This ensures that the simplest possible GraphQL
	      // service adheres to the spec.
	      enumerable: Boolean(_locations)
	    },
	    path: {
	      // Coercing falsey values to undefined ensures they will not be included
	      // in JSON.stringify() when not provided.
	      value: path || undefined,
	      // By being enumerable, JSON.stringify will include `path` in the
	      // resulting output. This ensures that the simplest possible GraphQL
	      // service adheres to the spec.
	      enumerable: Boolean(path)
	    },
	    nodes: {
	      value: _nodes || undefined
	    },
	    source: {
	      value: _source || undefined
	    },
	    positions: {
	      value: _positions || undefined
	    },
	    originalError: {
	      value: originalError
	    },
	    extensions: {
	      // Coercing falsey values to undefined ensures they will not be included
	      // in JSON.stringify() when not provided.
	      value: _extensions || undefined,
	      // By being enumerable, JSON.stringify will include `path` in the
	      // resulting output. This ensures that the simplest possible GraphQL
	      // service adheres to the spec.
	      enumerable: Boolean(_extensions)
	    }
	  }); // Include (non-enumerable) stack trace.
	
	  if (originalError && originalError.stack) {
	    Object.defineProperty(this, 'stack', {
	      value: originalError.stack,
	      writable: true,
	      configurable: true
	    });
	  } else if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, GraphQLError);
	  } else {
	    Object.defineProperty(this, 'stack', {
	      value: Error().stack,
	      writable: true,
	      configurable: true
	    });
	  }
	}
	
	GraphQLError.prototype = Object.create(Error.prototype, {
	  constructor: {
	    value: GraphQLError
	  },
	  name: {
	    value: 'GraphQLError'
	  },
	  toString: {
	    value: function toString() {
	      return (0, _printError.printError)(this);
	    }
	  }
	});

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isType = isType;
	exports.assertType = assertType;
	exports.isScalarType = isScalarType;
	exports.assertScalarType = assertScalarType;
	exports.isObjectType = isObjectType;
	exports.assertObjectType = assertObjectType;
	exports.isInterfaceType = isInterfaceType;
	exports.assertInterfaceType = assertInterfaceType;
	exports.isUnionType = isUnionType;
	exports.assertUnionType = assertUnionType;
	exports.isEnumType = isEnumType;
	exports.assertEnumType = assertEnumType;
	exports.isInputObjectType = isInputObjectType;
	exports.assertInputObjectType = assertInputObjectType;
	exports.isListType = isListType;
	exports.assertListType = assertListType;
	exports.isNonNullType = isNonNullType;
	exports.assertNonNullType = assertNonNullType;
	exports.isInputType = isInputType;
	exports.assertInputType = assertInputType;
	exports.isOutputType = isOutputType;
	exports.assertOutputType = assertOutputType;
	exports.isLeafType = isLeafType;
	exports.assertLeafType = assertLeafType;
	exports.isCompositeType = isCompositeType;
	exports.assertCompositeType = assertCompositeType;
	exports.isAbstractType = isAbstractType;
	exports.assertAbstractType = assertAbstractType;
	exports.GraphQLList = GraphQLList;
	exports.GraphQLNonNull = GraphQLNonNull;
	exports.isWrappingType = isWrappingType;
	exports.assertWrappingType = assertWrappingType;
	exports.isNullableType = isNullableType;
	exports.assertNullableType = assertNullableType;
	exports.getNullableType = getNullableType;
	exports.isNamedType = isNamedType;
	exports.assertNamedType = assertNamedType;
	exports.getNamedType = getNamedType;
	exports.isRequiredArgument = isRequiredArgument;
	exports.isRequiredInputField = isRequiredInputField;
	exports.GraphQLInputObjectType = exports.GraphQLEnumType = exports.GraphQLUnionType = exports.GraphQLInterfaceType = exports.GraphQLObjectType = exports.GraphQLScalarType = void 0;
	
	var _defineToJSON = _interopRequireDefault(__webpack_require__(186));
	
	var _defineToStringTag = _interopRequireDefault(__webpack_require__(64));
	
	var _instanceOf = _interopRequireDefault(__webpack_require__(104));
	
	var _inspect = _interopRequireDefault(__webpack_require__(16));
	
	var _invariant = _interopRequireDefault(__webpack_require__(17));
	
	var _keyMap = _interopRequireDefault(__webpack_require__(27));
	
	var _kinds = __webpack_require__(11);
	
	var _valueFromASTUntyped = __webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function isType(type) {
	  return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isInputObjectType(type) || isListType(type) || isNonNullType(type);
	}
	
	function assertType(type) {
	  !isType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL type.")) : void 0;
	  return type;
	}
	/**
	 * There are predicates for each kind of GraphQL type.
	 */
	
	
	// eslint-disable-next-line no-redeclare
	function isScalarType(type) {
	  return (0, _instanceOf.default)(type, GraphQLScalarType);
	}
	
	function assertScalarType(type) {
	  !isScalarType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL Scalar type.")) : void 0;
	  return type;
	}
	
	// eslint-disable-next-line no-redeclare
	function isObjectType(type) {
	  return (0, _instanceOf.default)(type, GraphQLObjectType);
	}
	
	function assertObjectType(type) {
	  !isObjectType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL Object type.")) : void 0;
	  return type;
	}
	
	// eslint-disable-next-line no-redeclare
	function isInterfaceType(type) {
	  return (0, _instanceOf.default)(type, GraphQLInterfaceType);
	}
	
	function assertInterfaceType(type) {
	  !isInterfaceType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL Interface type.")) : void 0;
	  return type;
	}
	
	// eslint-disable-next-line no-redeclare
	function isUnionType(type) {
	  return (0, _instanceOf.default)(type, GraphQLUnionType);
	}
	
	function assertUnionType(type) {
	  !isUnionType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL Union type.")) : void 0;
	  return type;
	}
	
	// eslint-disable-next-line no-redeclare
	function isEnumType(type) {
	  return (0, _instanceOf.default)(type, GraphQLEnumType);
	}
	
	function assertEnumType(type) {
	  !isEnumType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL Enum type.")) : void 0;
	  return type;
	}
	
	// eslint-disable-next-line no-redeclare
	function isInputObjectType(type) {
	  return (0, _instanceOf.default)(type, GraphQLInputObjectType);
	}
	
	function assertInputObjectType(type) {
	  !isInputObjectType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL Input Object type.")) : void 0;
	  return type;
	}
	
	// eslint-disable-next-line no-redeclare
	function isListType(type) {
	  return (0, _instanceOf.default)(type, GraphQLList);
	}
	
	function assertListType(type) {
	  !isListType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL List type.")) : void 0;
	  return type;
	}
	
	// eslint-disable-next-line no-redeclare
	function isNonNullType(type) {
	  return (0, _instanceOf.default)(type, GraphQLNonNull);
	}
	
	function assertNonNullType(type) {
	  !isNonNullType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL Non-Null type.")) : void 0;
	  return type;
	}
	/**
	 * These types may be used as input types for arguments and directives.
	 */
	
	
	function isInputType(type) {
	  return isScalarType(type) || isEnumType(type) || isInputObjectType(type) || isWrappingType(type) && isInputType(type.ofType);
	}
	
	function assertInputType(type) {
	  !isInputType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL input type.")) : void 0;
	  return type;
	}
	/**
	 * These types may be used as output types as the result of fields.
	 */
	
	
	function isOutputType(type) {
	  return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isWrappingType(type) && isOutputType(type.ofType);
	}
	
	function assertOutputType(type) {
	  !isOutputType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL output type.")) : void 0;
	  return type;
	}
	/**
	 * These types may describe types which may be leaf values.
	 */
	
	
	function isLeafType(type) {
	  return isScalarType(type) || isEnumType(type);
	}
	
	function assertLeafType(type) {
	  !isLeafType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL leaf type.")) : void 0;
	  return type;
	}
	/**
	 * These types may describe the parent context of a selection set.
	 */
	
	
	function isCompositeType(type) {
	  return isObjectType(type) || isInterfaceType(type) || isUnionType(type);
	}
	
	function assertCompositeType(type) {
	  !isCompositeType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL composite type.")) : void 0;
	  return type;
	}
	/**
	 * These types may describe the parent context of a selection set.
	 */
	
	
	function isAbstractType(type) {
	  return isInterfaceType(type) || isUnionType(type);
	}
	
	function assertAbstractType(type) {
	  !isAbstractType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL abstract type.")) : void 0;
	  return type;
	}
	/**
	 * List Type Wrapper
	 *
	 * A list is a wrapping type which points to another type.
	 * Lists are often created within the context of defining the fields of
	 * an object type.
	 *
	 * Example:
	 *
	 *     const PersonType = new GraphQLObjectType({
	 *       name: 'Person',
	 *       fields: () => ({
	 *         parents: { type: GraphQLList(PersonType) },
	 *         children: { type: GraphQLList(PersonType) },
	 *       })
	 *     })
	 *
	 */
	
	
	// eslint-disable-next-line no-redeclare
	function GraphQLList(ofType) {
	  if (this instanceof GraphQLList) {
	    this.ofType = assertType(ofType);
	  } else {
	    return new GraphQLList(ofType);
	  }
	} // Need to cast through any to alter the prototype.
	
	
	GraphQLList.prototype.toString = function toString() {
	  return '[' + String(this.ofType) + ']';
	};
	
	(0, _defineToJSON.default)(GraphQLList);
	/**
	 * Non-Null Type Wrapper
	 *
	 * A non-null is a wrapping type which points to another type.
	 * Non-null types enforce that their values are never null and can ensure
	 * an error is raised if this ever occurs during a request. It is useful for
	 * fields which you can make a strong guarantee on non-nullability, for example
	 * usually the id field of a database row will never be null.
	 *
	 * Example:
	 *
	 *     const RowType = new GraphQLObjectType({
	 *       name: 'Row',
	 *       fields: () => ({
	 *         id: { type: GraphQLNonNull(GraphQLString) },
	 *       })
	 *     })
	 *
	 * Note: the enforcement of non-nullability occurs within the executor.
	 */
	
	// eslint-disable-next-line no-redeclare
	function GraphQLNonNull(ofType) {
	  if (this instanceof GraphQLNonNull) {
	    this.ofType = assertNullableType(ofType);
	  } else {
	    return new GraphQLNonNull(ofType);
	  }
	} // Need to cast through any to alter the prototype.
	
	
	GraphQLNonNull.prototype.toString = function toString() {
	  return String(this.ofType) + '!';
	};
	
	(0, _defineToJSON.default)(GraphQLNonNull);
	/**
	 * These types wrap and modify other types
	 */
	
	function isWrappingType(type) {
	  return isListType(type) || isNonNullType(type);
	}
	
	function assertWrappingType(type) {
	  !isWrappingType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL wrapping type.")) : void 0;
	  return type;
	}
	/**
	 * These types can all accept null as a value.
	 */
	
	
	function isNullableType(type) {
	  return isType(type) && !isNonNullType(type);
	}
	
	function assertNullableType(type) {
	  !isNullableType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL nullable type.")) : void 0;
	  return type;
	}
	/* eslint-disable no-redeclare */
	
	
	function getNullableType(type) {
	  /* eslint-enable no-redeclare */
	  if (type) {
	    return isNonNullType(type) ? type.ofType : type;
	  }
	}
	/**
	 * These named types do not include modifiers like List or NonNull.
	 */
	
	
	function isNamedType(type) {
	  return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isInputObjectType(type);
	}
	
	function assertNamedType(type) {
	  !isNamedType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL named type.")) : void 0;
	  return type;
	}
	/* eslint-disable no-redeclare */
	
	
	function getNamedType(type) {
	  /* eslint-enable no-redeclare */
	  if (type) {
	    var unwrappedType = type;
	
	    while (isWrappingType(unwrappedType)) {
	      unwrappedType = unwrappedType.ofType;
	    }
	
	    return unwrappedType;
	  }
	}
	/**
	 * Used while defining GraphQL types to allow for circular references in
	 * otherwise immutable type definitions.
	 */
	
	
	function resolveThunk(thunk) {
	  return typeof thunk === 'function' ? thunk() : thunk;
	}
	/**
	 * Scalar Type Definition
	 *
	 * The leaf values of any request and input values to arguments are
	 * Scalars (or Enums) and are defined with a name and a series of functions
	 * used to parse input from ast or variables and to ensure validity.
	 *
	 * If a type's serialize function does not return a value (i.e. it returns
	 * `undefined`) then an error will be raised and a `null` value will be returned
	 * in the response. If the serialize function returns `null`, then no error will
	 * be included in the response.
	 *
	 * Example:
	 *
	 *     const OddType = new GraphQLScalarType({
	 *       name: 'Odd',
	 *       serialize(value) {
	 *         if (value % 2 === 1) {
	 *           return value;
	 *         }
	 *       }
	 *     });
	 *
	 */
	
	
	var GraphQLScalarType =
	/*#__PURE__*/
	function () {
	  function GraphQLScalarType(config) {
	    _defineProperty(this, "name", void 0);
	
	    _defineProperty(this, "description", void 0);
	
	    _defineProperty(this, "serialize", void 0);
	
	    _defineProperty(this, "parseValue", void 0);
	
	    _defineProperty(this, "parseLiteral", void 0);
	
	    _defineProperty(this, "astNode", void 0);
	
	    _defineProperty(this, "extensionASTNodes", void 0);
	
	    this.name = config.name;
	    this.description = config.description;
	    this.serialize = config.serialize;
	
	    this.parseValue = config.parseValue || function (value) {
	      return value;
	    };
	
	    this.parseLiteral = config.parseLiteral || _valueFromASTUntyped.valueFromASTUntyped;
	    this.astNode = config.astNode;
	    this.extensionASTNodes = config.extensionASTNodes;
	    !(typeof config.name === 'string') ? (0, _invariant.default)(0, 'Must provide name.') : void 0;
	    !(typeof config.serialize === 'function') ? (0, _invariant.default)(0, "".concat(this.name, " must provide \"serialize\" function. If this custom Scalar ") + 'is also used as an input type, ensure "parseValue" and "parseLiteral" ' + 'functions are also provided.') : void 0;
	
	    if (config.parseValue || config.parseLiteral) {
	      !(typeof config.parseValue === 'function' && typeof config.parseLiteral === 'function') ? (0, _invariant.default)(0, "".concat(this.name, " must provide both \"parseValue\" and \"parseLiteral\" ") + 'functions.') : void 0;
	    }
	  }
	
	  var _proto = GraphQLScalarType.prototype;
	
	  _proto.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLScalarType;
	}(); // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported
	
	
	exports.GraphQLScalarType = GraphQLScalarType;
	(0, _defineToStringTag.default)(GraphQLScalarType);
	(0, _defineToJSON.default)(GraphQLScalarType);
	
	/**
	 * Object Type Definition
	 *
	 * Almost all of the GraphQL types you define will be object types. Object types
	 * have a name, but most importantly describe their fields.
	 *
	 * Example:
	 *
	 *     const AddressType = new GraphQLObjectType({
	 *       name: 'Address',
	 *       fields: {
	 *         street: { type: GraphQLString },
	 *         number: { type: GraphQLInt },
	 *         formatted: {
	 *           type: GraphQLString,
	 *           resolve(obj) {
	 *             return obj.number + ' ' + obj.street
	 *           }
	 *         }
	 *       }
	 *     });
	 *
	 * When two types need to refer to each other, or a type needs to refer to
	 * itself in a field, you can use a function expression (aka a closure or a
	 * thunk) to supply the fields lazily.
	 *
	 * Example:
	 *
	 *     const PersonType = new GraphQLObjectType({
	 *       name: 'Person',
	 *       fields: () => ({
	 *         name: { type: GraphQLString },
	 *         bestFriend: { type: PersonType },
	 *       })
	 *     });
	 *
	 */
	var GraphQLObjectType =
	/*#__PURE__*/
	function () {
	  function GraphQLObjectType(config) {
	    _defineProperty(this, "name", void 0);
	
	    _defineProperty(this, "description", void 0);
	
	    _defineProperty(this, "astNode", void 0);
	
	    _defineProperty(this, "extensionASTNodes", void 0);
	
	    _defineProperty(this, "isTypeOf", void 0);
	
	    _defineProperty(this, "_fields", void 0);
	
	    _defineProperty(this, "_interfaces", void 0);
	
	    this.name = config.name;
	    this.description = config.description;
	    this.astNode = config.astNode;
	    this.extensionASTNodes = config.extensionASTNodes;
	    this.isTypeOf = config.isTypeOf;
	    this._fields = defineFieldMap.bind(undefined, config);
	    this._interfaces = defineInterfaces.bind(undefined, config);
	    !(typeof config.name === 'string') ? (0, _invariant.default)(0, 'Must provide name.') : void 0;
	    !(config.isTypeOf == null || typeof config.isTypeOf === 'function') ? (0, _invariant.default)(0, "".concat(this.name, " must provide \"isTypeOf\" as a function, ") + "but got: ".concat((0, _inspect.default)(config.isTypeOf), ".")) : void 0;
	  }
	
	  var _proto2 = GraphQLObjectType.prototype;
	
	  _proto2.getFields = function getFields() {
	    if (typeof this._fields === 'function') {
	      this._fields = this._fields();
	    }
	
	    return this._fields;
	  };
	
	  _proto2.getInterfaces = function getInterfaces() {
	    if (typeof this._interfaces === 'function') {
	      this._interfaces = this._interfaces();
	    }
	
	    return this._interfaces;
	  };
	
	  _proto2.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLObjectType;
	}(); // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported
	
	
	exports.GraphQLObjectType = GraphQLObjectType;
	(0, _defineToStringTag.default)(GraphQLObjectType);
	(0, _defineToJSON.default)(GraphQLObjectType);
	
	function defineInterfaces(config) {
	  var interfaces = resolveThunk(config.interfaces) || [];
	  !Array.isArray(interfaces) ? (0, _invariant.default)(0, "".concat(config.name, " interfaces must be an Array or a function which returns ") + 'an Array.') : void 0;
	  return interfaces;
	}
	
	function defineFieldMap(config) {
	  var fieldMap = resolveThunk(config.fields) || {};
	  !isPlainObj(fieldMap) ? (0, _invariant.default)(0, "".concat(config.name, " fields must be an object with field names as keys or a ") + 'function which returns such an object.') : void 0;
	  var resultFieldMap = Object.create(null);
	
	  var _arr = Object.keys(fieldMap);
	
	  var _loop = function _loop() {
	    var fieldName = _arr[_i];
	    var fieldConfig = fieldMap[fieldName];
	    !isPlainObj(fieldConfig) ? (0, _invariant.default)(0, "".concat(config.name, ".").concat(fieldName, " field config must be an object")) : void 0;
	    !!fieldConfig.hasOwnProperty('isDeprecated') ? (0, _invariant.default)(0, "".concat(config.name, ".").concat(fieldName, " should provide \"deprecationReason\" ") + 'instead of "isDeprecated".') : void 0;
	
	    var field = _objectSpread({}, fieldConfig, {
	      isDeprecated: Boolean(fieldConfig.deprecationReason),
	      name: fieldName
	    });
	
	    !(field.resolve == null || typeof field.resolve === 'function') ? (0, _invariant.default)(0, "".concat(config.name, ".").concat(fieldName, " field resolver must be a function if ") + "provided, but got: ".concat((0, _inspect.default)(field.resolve), ".")) : void 0;
	    var argsConfig = fieldConfig.args;
	
	    if (!argsConfig) {
	      field.args = [];
	    } else {
	      !isPlainObj(argsConfig) ? (0, _invariant.default)(0, "".concat(config.name, ".").concat(fieldName, " args must be an object with argument ") + 'names as keys.') : void 0;
	      field.args = Object.keys(argsConfig).map(function (argName) {
	        var arg = argsConfig[argName];
	        return {
	          name: argName,
	          description: arg.description === undefined ? null : arg.description,
	          type: arg.type,
	          defaultValue: arg.defaultValue,
	          astNode: arg.astNode
	        };
	      });
	    }
	
	    resultFieldMap[fieldName] = field;
	  };
	
	  for (var _i = 0; _i < _arr.length; _i++) {
	    _loop();
	  }
	
	  return resultFieldMap;
	}
	
	function isPlainObj(obj) {
	  return obj && _typeof(obj) === 'object' && !Array.isArray(obj);
	}
	
	function isRequiredArgument(arg) {
	  return isNonNullType(arg.type) && arg.defaultValue === undefined;
	}
	
	/**
	 * Interface Type Definition
	 *
	 * When a field can return one of a heterogeneous set of types, a Interface type
	 * is used to describe what types are possible, what fields are in common across
	 * all types, as well as a function to determine which type is actually used
	 * when the field is resolved.
	 *
	 * Example:
	 *
	 *     const EntityType = new GraphQLInterfaceType({
	 *       name: 'Entity',
	 *       fields: {
	 *         name: { type: GraphQLString }
	 *       }
	 *     });
	 *
	 */
	var GraphQLInterfaceType =
	/*#__PURE__*/
	function () {
	  function GraphQLInterfaceType(config) {
	    _defineProperty(this, "name", void 0);
	
	    _defineProperty(this, "description", void 0);
	
	    _defineProperty(this, "astNode", void 0);
	
	    _defineProperty(this, "extensionASTNodes", void 0);
	
	    _defineProperty(this, "resolveType", void 0);
	
	    _defineProperty(this, "_fields", void 0);
	
	    this.name = config.name;
	    this.description = config.description;
	    this.astNode = config.astNode;
	    this.extensionASTNodes = config.extensionASTNodes;
	    this.resolveType = config.resolveType;
	    this._fields = defineFieldMap.bind(undefined, config);
	    !(typeof config.name === 'string') ? (0, _invariant.default)(0, 'Must provide name.') : void 0;
	    !(config.resolveType == null || typeof config.resolveType === 'function') ? (0, _invariant.default)(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat((0, _inspect.default)(config.resolveType), ".")) : void 0;
	  }
	
	  var _proto3 = GraphQLInterfaceType.prototype;
	
	  _proto3.getFields = function getFields() {
	    if (typeof this._fields === 'function') {
	      this._fields = this._fields();
	    }
	
	    return this._fields;
	  };
	
	  _proto3.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLInterfaceType;
	}(); // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported
	
	
	exports.GraphQLInterfaceType = GraphQLInterfaceType;
	(0, _defineToStringTag.default)(GraphQLInterfaceType);
	(0, _defineToJSON.default)(GraphQLInterfaceType);
	
	/**
	 * Union Type Definition
	 *
	 * When a field can return one of a heterogeneous set of types, a Union type
	 * is used to describe what types are possible as well as providing a function
	 * to determine which type is actually used when the field is resolved.
	 *
	 * Example:
	 *
	 *     const PetType = new GraphQLUnionType({
	 *       name: 'Pet',
	 *       types: [ DogType, CatType ],
	 *       resolveType(value) {
	 *         if (value instanceof Dog) {
	 *           return DogType;
	 *         }
	 *         if (value instanceof Cat) {
	 *           return CatType;
	 *         }
	 *       }
	 *     });
	 *
	 */
	var GraphQLUnionType =
	/*#__PURE__*/
	function () {
	  function GraphQLUnionType(config) {
	    _defineProperty(this, "name", void 0);
	
	    _defineProperty(this, "description", void 0);
	
	    _defineProperty(this, "astNode", void 0);
	
	    _defineProperty(this, "extensionASTNodes", void 0);
	
	    _defineProperty(this, "resolveType", void 0);
	
	    _defineProperty(this, "_types", void 0);
	
	    this.name = config.name;
	    this.description = config.description;
	    this.astNode = config.astNode;
	    this.extensionASTNodes = config.extensionASTNodes;
	    this.resolveType = config.resolveType;
	    this._types = defineTypes.bind(undefined, config);
	    !(typeof config.name === 'string') ? (0, _invariant.default)(0, 'Must provide name.') : void 0;
	    !(config.resolveType == null || typeof config.resolveType === 'function') ? (0, _invariant.default)(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat((0, _inspect.default)(config.resolveType), ".")) : void 0;
	  }
	
	  var _proto4 = GraphQLUnionType.prototype;
	
	  _proto4.getTypes = function getTypes() {
	    if (typeof this._types === 'function') {
	      this._types = this._types();
	    }
	
	    return this._types;
	  };
	
	  _proto4.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLUnionType;
	}(); // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported
	
	
	exports.GraphQLUnionType = GraphQLUnionType;
	(0, _defineToStringTag.default)(GraphQLUnionType);
	(0, _defineToJSON.default)(GraphQLUnionType);
	
	function defineTypes(config) {
	  var types = resolveThunk(config.types) || [];
	  !Array.isArray(types) ? (0, _invariant.default)(0, 'Must provide Array of types or a function which returns ' + "such an array for Union ".concat(config.name, ".")) : void 0;
	  return types;
	}
	
	/**
	 * Enum Type Definition
	 *
	 * Some leaf values of requests and input values are Enums. GraphQL serializes
	 * Enum values as strings, however internally Enums can be represented by any
	 * kind of type, often integers.
	 *
	 * Example:
	 *
	 *     const RGBType = new GraphQLEnumType({
	 *       name: 'RGB',
	 *       values: {
	 *         RED: { value: 0 },
	 *         GREEN: { value: 1 },
	 *         BLUE: { value: 2 }
	 *       }
	 *     });
	 *
	 * Note: If a value is not provided in a definition, the name of the enum value
	 * will be used as its internal value.
	 */
	var GraphQLEnumType
	/* <T> */
	=
	/*#__PURE__*/
	function () {
	  function GraphQLEnumType(config
	  /* <T> */
	  ) {
	    _defineProperty(this, "name", void 0);
	
	    _defineProperty(this, "description", void 0);
	
	    _defineProperty(this, "astNode", void 0);
	
	    _defineProperty(this, "extensionASTNodes", void 0);
	
	    _defineProperty(this, "_values", void 0);
	
	    _defineProperty(this, "_valueLookup", void 0);
	
	    _defineProperty(this, "_nameLookup", void 0);
	
	    this.name = config.name;
	    this.description = config.description;
	    this.astNode = config.astNode;
	    this.extensionASTNodes = config.extensionASTNodes;
	    this._values = defineEnumValues(this, config.values);
	    this._valueLookup = new Map(this._values.map(function (enumValue) {
	      return [enumValue.value, enumValue];
	    }));
	    this._nameLookup = (0, _keyMap.default)(this._values, function (value) {
	      return value.name;
	    });
	    !(typeof config.name === 'string') ? (0, _invariant.default)(0, 'Must provide name.') : void 0;
	  }
	
	  var _proto5 = GraphQLEnumType.prototype;
	
	  _proto5.getValues = function getValues() {
	    return this._values;
	  };
	
	  _proto5.getValue = function getValue(name) {
	    return this._nameLookup[name];
	  };
	
	  _proto5.serialize = function serialize(value
	  /* T */
	  ) {
	    var enumValue = this._valueLookup.get(value);
	
	    if (enumValue) {
	      return enumValue.name;
	    }
	  };
	
	  _proto5.parseValue = function parseValue(value)
	  /* T */
	  {
	    if (typeof value === 'string') {
	      var enumValue = this.getValue(value);
	
	      if (enumValue) {
	        return enumValue.value;
	      }
	    }
	  };
	
	  _proto5.parseLiteral = function parseLiteral(valueNode, _variables)
	  /* T */
	  {
	    // Note: variables will be resolved to a value before calling this function.
	    if (valueNode.kind === _kinds.Kind.ENUM) {
	      var enumValue = this.getValue(valueNode.value);
	
	      if (enumValue) {
	        return enumValue.value;
	      }
	    }
	  };
	
	  _proto5.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLEnumType;
	}(); // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported
	
	
	exports.GraphQLEnumType = GraphQLEnumType;
	(0, _defineToStringTag.default)(GraphQLEnumType);
	(0, _defineToJSON.default)(GraphQLEnumType);
	
	function defineEnumValues(type, valueMap
	/* <T> */
	) {
	  !isPlainObj(valueMap) ? (0, _invariant.default)(0, "".concat(type.name, " values must be an object with value names as keys.")) : void 0;
	  return Object.keys(valueMap).map(function (valueName) {
	    var value = valueMap[valueName];
	    !isPlainObj(value) ? (0, _invariant.default)(0, "".concat(type.name, ".").concat(valueName, " must refer to an object with a \"value\" key ") + "representing an internal value but got: ".concat((0, _inspect.default)(value), ".")) : void 0;
	    !!value.hasOwnProperty('isDeprecated') ? (0, _invariant.default)(0, "".concat(type.name, ".").concat(valueName, " should provide \"deprecationReason\" instead ") + 'of "isDeprecated".') : void 0;
	    return {
	      name: valueName,
	      description: value.description,
	      isDeprecated: Boolean(value.deprecationReason),
	      deprecationReason: value.deprecationReason,
	      astNode: value.astNode,
	      value: value.hasOwnProperty('value') ? value.value : valueName
	    };
	  });
	}
	
	/**
	 * Input Object Type Definition
	 *
	 * An input object defines a structured collection of fields which may be
	 * supplied to a field argument.
	 *
	 * Using `NonNull` will ensure that a value must be provided by the query
	 *
	 * Example:
	 *
	 *     const GeoPoint = new GraphQLInputObjectType({
	 *       name: 'GeoPoint',
	 *       fields: {
	 *         lat: { type: GraphQLNonNull(GraphQLFloat) },
	 *         lon: { type: GraphQLNonNull(GraphQLFloat) },
	 *         alt: { type: GraphQLFloat, defaultValue: 0 },
	 *       }
	 *     });
	 *
	 */
	var GraphQLInputObjectType =
	/*#__PURE__*/
	function () {
	  function GraphQLInputObjectType(config) {
	    _defineProperty(this, "name", void 0);
	
	    _defineProperty(this, "description", void 0);
	
	    _defineProperty(this, "astNode", void 0);
	
	    _defineProperty(this, "extensionASTNodes", void 0);
	
	    _defineProperty(this, "_fields", void 0);
	
	    this.name = config.name;
	    this.description = config.description;
	    this.astNode = config.astNode;
	    this.extensionASTNodes = config.extensionASTNodes;
	    this._fields = defineInputFieldMap.bind(undefined, config);
	    !(typeof config.name === 'string') ? (0, _invariant.default)(0, 'Must provide name.') : void 0;
	  }
	
	  var _proto6 = GraphQLInputObjectType.prototype;
	
	  _proto6.getFields = function getFields() {
	    if (typeof this._fields === 'function') {
	      this._fields = this._fields();
	    }
	
	    return this._fields;
	  };
	
	  _proto6.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLInputObjectType;
	}(); // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported
	
	
	exports.GraphQLInputObjectType = GraphQLInputObjectType;
	(0, _defineToStringTag.default)(GraphQLInputObjectType);
	(0, _defineToJSON.default)(GraphQLInputObjectType);
	
	function defineInputFieldMap(config) {
	  var fieldMap = resolveThunk(config.fields) || {};
	  !isPlainObj(fieldMap) ? (0, _invariant.default)(0, "".concat(config.name, " fields must be an object with field names as keys or a ") + 'function which returns such an object.') : void 0;
	  var resultFieldMap = Object.create(null);
	
	  var _arr2 = Object.keys(fieldMap);
	
	  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
	    var fieldName = _arr2[_i2];
	
	    var field = _objectSpread({}, fieldMap[fieldName], {
	      name: fieldName
	    });
	
	    !!field.hasOwnProperty('resolve') ? (0, _invariant.default)(0, "".concat(config.name, ".").concat(fieldName, " field has a resolve property, but ") + 'Input Types cannot define resolvers.') : void 0;
	    resultFieldMap[fieldName] = field;
	  }
	
	  return resultFieldMap;
	}
	
	function isRequiredInputField(field) {
	  return isNonNullType(field.type) && field.defaultValue === undefined;
	}

/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Kind = void 0;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * The set of allowed kind values for AST nodes.
	 */
	var Kind = Object.freeze({
	  // Name
	  NAME: 'Name',
	  // Document
	  DOCUMENT: 'Document',
	  OPERATION_DEFINITION: 'OperationDefinition',
	  VARIABLE_DEFINITION: 'VariableDefinition',
	  SELECTION_SET: 'SelectionSet',
	  FIELD: 'Field',
	  ARGUMENT: 'Argument',
	  // Fragments
	  FRAGMENT_SPREAD: 'FragmentSpread',
	  INLINE_FRAGMENT: 'InlineFragment',
	  FRAGMENT_DEFINITION: 'FragmentDefinition',
	  // Values
	  VARIABLE: 'Variable',
	  INT: 'IntValue',
	  FLOAT: 'FloatValue',
	  STRING: 'StringValue',
	  BOOLEAN: 'BooleanValue',
	  NULL: 'NullValue',
	  ENUM: 'EnumValue',
	  LIST: 'ListValue',
	  OBJECT: 'ObjectValue',
	  OBJECT_FIELD: 'ObjectField',
	  // Directives
	  DIRECTIVE: 'Directive',
	  // Types
	  NAMED_TYPE: 'NamedType',
	  LIST_TYPE: 'ListType',
	  NON_NULL_TYPE: 'NonNullType',
	  // Type System Definitions
	  SCHEMA_DEFINITION: 'SchemaDefinition',
	  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
	  // Type Definitions
	  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
	  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
	  FIELD_DEFINITION: 'FieldDefinition',
	  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
	  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
	  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
	  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
	  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
	  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
	  // Directive Definitions
	  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
	  // Type System Extensions
	  SCHEMA_EXTENSION: 'SchemaExtension',
	  // Type Extensions
	  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
	  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
	  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
	  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
	  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
	  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
	});
	/**
	 * The enum type representing the possible kind values of AST nodes.
	 */
	
	exports.Kind = Kind;

/***/ },
/* 12 */
[649, 8, 135, 135, 8, 135, 481, 328],
/* 13 */
[649, 7, 136, 136, 7, 136, 490, 414],
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(503)();
	}


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = createWithBsPrefix;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _camelize = _interopRequireDefault(__webpack_require__(431));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["className", "bsPrefix", "as"];
	
	var pascalCase = function pascalCase(str) {
	  return str[0].toUpperCase() + (0, _camelize.default)(str).slice(1);
	};
	
	// TODO: emstricten & fix the typing here! `createWithBsPrefix<TElementType>...`
	function createWithBsPrefix(prefix, _temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$displayName = _ref.displayName,
	      displayName = _ref$displayName === void 0 ? pascalCase(prefix) : _ref$displayName,
	      Component = _ref.Component,
	      defaultProps = _ref.defaultProps;
	
	  var BsComponent = /*#__PURE__*/_react.default.forwardRef(function (_ref2, ref) {
	    var className = _ref2.className,
	        bsPrefix = _ref2.bsPrefix,
	        _ref2$as = _ref2.as,
	        Tag = _ref2$as === void 0 ? Component || 'div' : _ref2$as,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_ref2, _excluded);
	    var resolvedPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, prefix);
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	      ref: ref,
	      className: (0, _classnames.default)(className, resolvedPrefix)
	    }, props));
	  });
	
	  BsComponent.defaultProps = defaultProps;
	  BsComponent.displayName = displayName;
	  return BsComponent;
	}
	
	module.exports = exports["default"];

/***/ },
/* 16 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = inspect;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Used to print values in error messages.
	 */
	function inspect(value) {
	  return value && _typeof(value) === 'object' ? typeof value.inspect === 'function' ? value.inspect() : Array.isArray(value) ? '[' + value.map(inspect).join(', ') + ']' : '{' + Object.keys(value).map(function (k) {
	    return "".concat(k, ": ").concat(inspect(value[k]));
	  }).join(', ') + '}' : typeof value === 'string' ? '"' + value + '"' : typeof value === 'function' ? "[function ".concat(value.name, "]") : String(value);
	}

/***/ },
/* 17 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = invariant;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function invariant(condition, message) {
	  /* istanbul ignore else */
	  if (!condition) {
	    throw new Error(message);
	  }
	}

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = useEventCallback;
	
	var _react = __webpack_require__(2);
	
	var _useCommittedRef = _interopRequireDefault(__webpack_require__(160));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useEventCallback(fn) {
	  var ref = (0, _useCommittedRef.default)(fn);
	  return (0, _react.useCallback)(function () {
	    return ref.current && ref.current.apply(ref, arguments);
	  }, [ref]);
	}

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isDirective = isDirective;
	exports.isSpecifiedDirective = isSpecifiedDirective;
	exports.specifiedDirectives = exports.GraphQLDeprecatedDirective = exports.DEFAULT_DEPRECATION_REASON = exports.GraphQLSkipDirective = exports.GraphQLIncludeDirective = exports.GraphQLDirective = void 0;
	
	var _definition = __webpack_require__(10);
	
	var _scalars = __webpack_require__(28);
	
	var _defineToStringTag = _interopRequireDefault(__webpack_require__(64));
	
	var _defineToJSON = _interopRequireDefault(__webpack_require__(186));
	
	var _instanceOf = _interopRequireDefault(__webpack_require__(104));
	
	var _invariant = _interopRequireDefault(__webpack_require__(17));
	
	var _directiveLocation = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// eslint-disable-next-line no-redeclare
	function isDirective(directive) {
	  return (0, _instanceOf.default)(directive, GraphQLDirective);
	}
	/**
	 * Directives are used by the GraphQL runtime as a way of modifying execution
	 * behavior. Type system creators will usually not create these directly.
	 */
	
	
	var GraphQLDirective =
	/*#__PURE__*/
	function () {
	  function GraphQLDirective(config) {
	    _defineProperty(this, "name", void 0);
	
	    _defineProperty(this, "description", void 0);
	
	    _defineProperty(this, "locations", void 0);
	
	    _defineProperty(this, "args", void 0);
	
	    _defineProperty(this, "astNode", void 0);
	
	    this.name = config.name;
	    this.description = config.description;
	    this.locations = config.locations;
	    this.astNode = config.astNode;
	    !config.name ? (0, _invariant.default)(0, 'Directive must be named.') : void 0;
	    !Array.isArray(config.locations) ? (0, _invariant.default)(0, 'Must provide locations for directive.') : void 0;
	    var args = config.args;
	
	    if (!args) {
	      this.args = [];
	    } else {
	      !!Array.isArray(args) ? (0, _invariant.default)(0, "@".concat(config.name, " args must be an object with argument names as keys.")) : void 0;
	      this.args = Object.keys(args).map(function (argName) {
	        var arg = args[argName];
	        return {
	          name: argName,
	          description: arg.description === undefined ? null : arg.description,
	          type: arg.type,
	          defaultValue: arg.defaultValue,
	          astNode: arg.astNode
	        };
	      });
	    }
	  }
	
	  var _proto = GraphQLDirective.prototype;
	
	  _proto.toString = function toString() {
	    return '@' + this.name;
	  };
	
	  return GraphQLDirective;
	}(); // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported
	
	
	exports.GraphQLDirective = GraphQLDirective;
	(0, _defineToStringTag.default)(GraphQLDirective);
	(0, _defineToJSON.default)(GraphQLDirective);
	
	/**
	 * Used to conditionally include fields or fragments.
	 */
	var GraphQLIncludeDirective = new GraphQLDirective({
	  name: 'include',
	  description: 'Directs the executor to include this field or fragment only when ' + 'the `if` argument is true.',
	  locations: [_directiveLocation.DirectiveLocation.FIELD, _directiveLocation.DirectiveLocation.FRAGMENT_SPREAD, _directiveLocation.DirectiveLocation.INLINE_FRAGMENT],
	  args: {
	    if: {
	      type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLBoolean),
	      description: 'Included when true.'
	    }
	  }
	});
	/**
	 * Used to conditionally skip (exclude) fields or fragments.
	 */
	
	exports.GraphQLIncludeDirective = GraphQLIncludeDirective;
	var GraphQLSkipDirective = new GraphQLDirective({
	  name: 'skip',
	  description: 'Directs the executor to skip this field or fragment when the `if` ' + 'argument is true.',
	  locations: [_directiveLocation.DirectiveLocation.FIELD, _directiveLocation.DirectiveLocation.FRAGMENT_SPREAD, _directiveLocation.DirectiveLocation.INLINE_FRAGMENT],
	  args: {
	    if: {
	      type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLBoolean),
	      description: 'Skipped when true.'
	    }
	  }
	});
	/**
	 * Constant string used for default reason for a deprecation.
	 */
	
	exports.GraphQLSkipDirective = GraphQLSkipDirective;
	var DEFAULT_DEPRECATION_REASON = 'No longer supported';
	/**
	 * Used to declare element of a GraphQL schema as deprecated.
	 */
	
	exports.DEFAULT_DEPRECATION_REASON = DEFAULT_DEPRECATION_REASON;
	var GraphQLDeprecatedDirective = new GraphQLDirective({
	  name: 'deprecated',
	  description: 'Marks an element of a GraphQL schema as no longer supported.',
	  locations: [_directiveLocation.DirectiveLocation.FIELD_DEFINITION, _directiveLocation.DirectiveLocation.ENUM_VALUE],
	  args: {
	    reason: {
	      type: _scalars.GraphQLString,
	      description: 'Explains why this element was deprecated, usually also including a ' + 'suggestion for how to access supported similar data. Formatted using ' + 'the Markdown syntax (as specified by [CommonMark](https://commonmark.org/).',
	      defaultValue: DEFAULT_DEPRECATION_REASON
	    }
	  }
	});
	/**
	 * The full list of specified directives.
	 */
	
	exports.GraphQLDeprecatedDirective = GraphQLDeprecatedDirective;
	var specifiedDirectives = [GraphQLIncludeDirective, GraphQLSkipDirective, GraphQLDeprecatedDirective];
	exports.specifiedDirectives = specifiedDirectives;
	
	function isSpecifiedDirective(directive) {
	  return specifiedDirectives.some(function (specifiedDirective) {
	    return specifiedDirective.name === directive.name;
	  });
	}

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(32);
	
	exports.__esModule = true;
	exports.useUncontrolledProp = exports.uncontrollable = exports.useUncontrolled = void 0;
	
	var _hook = _interopRequireWildcard(__webpack_require__(582));
	
	exports.useUncontrolled = _hook.default;
	exports.useUncontrolledProp = _hook.useUncontrolledProp;
	
	var _uncontrollable = _interopRequireDefault(__webpack_require__(583));
	
	exports.uncontrollable = _uncontrollable.default;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(428)
	var ieee754 = __webpack_require__(477)
	var isArray = __webpack_require__(478)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.print = print;
	
	var _visitor = __webpack_require__(36);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/**
	 * Converts an AST into a string, using one set of reasonable
	 * formatting rules.
	 */
	function print(ast) {
	  return (0, _visitor.visit)(ast, {
	    leave: printDocASTReducer
	  });
	}
	
	var printDocASTReducer = {
	  Name: function Name(node) {
	    return node.value;
	  },
	  Variable: function Variable(node) {
	    return '$' + node.name;
	  },
	  // Document
	  Document: function Document(node) {
	    return join(node.definitions, '\n\n') + '\n';
	  },
	  OperationDefinition: function OperationDefinition(node) {
	    var op = node.operation;
	    var name = node.name;
	    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
	    var directives = join(node.directives, ' ');
	    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
	    // the query short form.
	
	    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
	  },
	  VariableDefinition: function VariableDefinition(_ref) {
	    var variable = _ref.variable,
	        type = _ref.type,
	        defaultValue = _ref.defaultValue,
	        directives = _ref.directives;
	    return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
	  },
	  SelectionSet: function SelectionSet(_ref2) {
	    var selections = _ref2.selections;
	    return block(selections);
	  },
	  Field: function Field(_ref3) {
	    var alias = _ref3.alias,
	        name = _ref3.name,
	        args = _ref3.arguments,
	        directives = _ref3.directives,
	        selectionSet = _ref3.selectionSet;
	    return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
	  },
	  Argument: function Argument(_ref4) {
	    var name = _ref4.name,
	        value = _ref4.value;
	    return name + ': ' + value;
	  },
	  // Fragments
	  FragmentSpread: function FragmentSpread(_ref5) {
	    var name = _ref5.name,
	        directives = _ref5.directives;
	    return '...' + name + wrap(' ', join(directives, ' '));
	  },
	  InlineFragment: function InlineFragment(_ref6) {
	    var typeCondition = _ref6.typeCondition,
	        directives = _ref6.directives,
	        selectionSet = _ref6.selectionSet;
	    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
	  },
	  FragmentDefinition: function FragmentDefinition(_ref7) {
	    var name = _ref7.name,
	        typeCondition = _ref7.typeCondition,
	        variableDefinitions = _ref7.variableDefinitions,
	        directives = _ref7.directives,
	        selectionSet = _ref7.selectionSet;
	    return (// Note: fragment variable definitions are experimental and may be changed
	      // or removed in the future.
	      "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet
	    );
	  },
	  // Value
	  IntValue: function IntValue(_ref8) {
	    var value = _ref8.value;
	    return value;
	  },
	  FloatValue: function FloatValue(_ref9) {
	    var value = _ref9.value;
	    return value;
	  },
	  StringValue: function StringValue(_ref10, key) {
	    var value = _ref10.value,
	        isBlockString = _ref10.block;
	    return isBlockString ? printBlockString(value, key === 'description') : JSON.stringify(value);
	  },
	  BooleanValue: function BooleanValue(_ref11) {
	    var value = _ref11.value;
	    return value ? 'true' : 'false';
	  },
	  NullValue: function NullValue() {
	    return 'null';
	  },
	  EnumValue: function EnumValue(_ref12) {
	    var value = _ref12.value;
	    return value;
	  },
	  ListValue: function ListValue(_ref13) {
	    var values = _ref13.values;
	    return '[' + join(values, ', ') + ']';
	  },
	  ObjectValue: function ObjectValue(_ref14) {
	    var fields = _ref14.fields;
	    return '{' + join(fields, ', ') + '}';
	  },
	  ObjectField: function ObjectField(_ref15) {
	    var name = _ref15.name,
	        value = _ref15.value;
	    return name + ': ' + value;
	  },
	  // Directive
	  Directive: function Directive(_ref16) {
	    var name = _ref16.name,
	        args = _ref16.arguments;
	    return '@' + name + wrap('(', join(args, ', '), ')');
	  },
	  // Type
	  NamedType: function NamedType(_ref17) {
	    var name = _ref17.name;
	    return name;
	  },
	  ListType: function ListType(_ref18) {
	    var type = _ref18.type;
	    return '[' + type + ']';
	  },
	  NonNullType: function NonNullType(_ref19) {
	    var type = _ref19.type;
	    return type + '!';
	  },
	  // Type System Definitions
	  SchemaDefinition: function SchemaDefinition(_ref20) {
	    var directives = _ref20.directives,
	        operationTypes = _ref20.operationTypes;
	    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
	  },
	  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
	    var operation = _ref21.operation,
	        type = _ref21.type;
	    return operation + ': ' + type;
	  },
	  ScalarTypeDefinition: addDescription(function (_ref22) {
	    var name = _ref22.name,
	        directives = _ref22.directives;
	    return join(['scalar', name, join(directives, ' ')], ' ');
	  }),
	  ObjectTypeDefinition: addDescription(function (_ref23) {
	    var name = _ref23.name,
	        interfaces = _ref23.interfaces,
	        directives = _ref23.directives,
	        fields = _ref23.fields;
	    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
	  }),
	  FieldDefinition: addDescription(function (_ref24) {
	    var name = _ref24.name,
	        args = _ref24.arguments,
	        type = _ref24.type,
	        directives = _ref24.directives;
	    return name + (args.every(function (arg) {
	      return arg.indexOf('\n') === -1;
	    }) ? wrap('(', join(args, ', '), ')') : wrap('(\n', indent(join(args, '\n')), '\n)')) + ': ' + type + wrap(' ', join(directives, ' '));
	  }),
	  InputValueDefinition: addDescription(function (_ref25) {
	    var name = _ref25.name,
	        type = _ref25.type,
	        defaultValue = _ref25.defaultValue,
	        directives = _ref25.directives;
	    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
	  }),
	  InterfaceTypeDefinition: addDescription(function (_ref26) {
	    var name = _ref26.name,
	        directives = _ref26.directives,
	        fields = _ref26.fields;
	    return join(['interface', name, join(directives, ' '), block(fields)], ' ');
	  }),
	  UnionTypeDefinition: addDescription(function (_ref27) {
	    var name = _ref27.name,
	        directives = _ref27.directives,
	        types = _ref27.types;
	    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
	  }),
	  EnumTypeDefinition: addDescription(function (_ref28) {
	    var name = _ref28.name,
	        directives = _ref28.directives,
	        values = _ref28.values;
	    return join(['enum', name, join(directives, ' '), block(values)], ' ');
	  }),
	  EnumValueDefinition: addDescription(function (_ref29) {
	    var name = _ref29.name,
	        directives = _ref29.directives;
	    return join([name, join(directives, ' ')], ' ');
	  }),
	  InputObjectTypeDefinition: addDescription(function (_ref30) {
	    var name = _ref30.name,
	        directives = _ref30.directives,
	        fields = _ref30.fields;
	    return join(['input', name, join(directives, ' '), block(fields)], ' ');
	  }),
	  DirectiveDefinition: addDescription(function (_ref31) {
	    var name = _ref31.name,
	        args = _ref31.arguments,
	        locations = _ref31.locations;
	    return 'directive @' + name + (args.every(function (arg) {
	      return arg.indexOf('\n') === -1;
	    }) ? wrap('(', join(args, ', '), ')') : wrap('(\n', indent(join(args, '\n')), '\n)')) + ' on ' + join(locations, ' | ');
	  }),
	  SchemaExtension: function SchemaExtension(_ref32) {
	    var directives = _ref32.directives,
	        operationTypes = _ref32.operationTypes;
	    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
	  },
	  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
	    var name = _ref33.name,
	        directives = _ref33.directives;
	    return join(['extend scalar', name, join(directives, ' ')], ' ');
	  },
	  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
	    var name = _ref34.name,
	        interfaces = _ref34.interfaces,
	        directives = _ref34.directives,
	        fields = _ref34.fields;
	    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
	  },
	  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
	    var name = _ref35.name,
	        directives = _ref35.directives,
	        fields = _ref35.fields;
	    return join(['extend interface', name, join(directives, ' '), block(fields)], ' ');
	  },
	  UnionTypeExtension: function UnionTypeExtension(_ref36) {
	    var name = _ref36.name,
	        directives = _ref36.directives,
	        types = _ref36.types;
	    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
	  },
	  EnumTypeExtension: function EnumTypeExtension(_ref37) {
	    var name = _ref37.name,
	        directives = _ref37.directives,
	        values = _ref37.values;
	    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
	  },
	  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
	    var name = _ref38.name,
	        directives = _ref38.directives,
	        fields = _ref38.fields;
	    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
	  }
	};
	
	function addDescription(cb) {
	  return function (node) {
	    return join([node.description, cb(node)], '\n');
	  };
	}
	/**
	 * Given maybeArray, print an empty string if it is null or empty, otherwise
	 * print all items together separated by separator if provided
	 */
	
	
	function join(maybeArray, separator) {
	  return maybeArray ? maybeArray.filter(function (x) {
	    return x;
	  }).join(separator || '') : '';
	}
	/**
	 * Given array, print each item on its own line, wrapped in an
	 * indented "{ }" block.
	 */
	
	
	function block(array) {
	  return array && array.length !== 0 ? '{\n' + indent(join(array, '\n')) + '\n}' : '';
	}
	/**
	 * If maybeString is not null or empty, then wrap with start and end, otherwise
	 * print an empty string.
	 */
	
	
	function wrap(start, maybeString, end) {
	  return maybeString ? start + maybeString + (end || '') : '';
	}
	
	function indent(maybeString) {
	  return maybeString && '  ' + maybeString.replace(/\n/g, '\n  ');
	}
	/**
	 * Print a block string in the indented block form by adding a leading and
	 * trailing blank line. However, if a block string starts with whitespace and is
	 * a single-line, adding a leading blank line would strip that whitespace.
	 */
	
	
	function printBlockString(value, isDescription) {
	  var escaped = value.replace(/"""/g, '\\"""');
	  return (value[0] === ' ' || value[0] === '\t') && value.indexOf('\n') === -1 ? "\"\"\"".concat(escaped.replace(/"$/, '"\n'), "\"\"\"") : "\"\"\"\n".concat(isDescription ? escaped : indent(escaped), "\n\"\"\"");
	}

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isIntrospectionType = isIntrospectionType;
	exports.introspectionTypes = exports.TypeNameMetaFieldDef = exports.TypeMetaFieldDef = exports.SchemaMetaFieldDef = exports.__TypeKind = exports.TypeKind = exports.__EnumValue = exports.__InputValue = exports.__Field = exports.__Type = exports.__DirectiveLocation = exports.__Directive = exports.__Schema = void 0;
	
	var _isInvalid = _interopRequireDefault(__webpack_require__(33));
	
	var _objectValues = _interopRequireDefault(__webpack_require__(34));
	
	var _astFromValue = __webpack_require__(110);
	
	var _printer = __webpack_require__(22);
	
	var _definition = __webpack_require__(10);
	
	var _scalars = __webpack_require__(28);
	
	var _directiveLocation = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	var __Schema = new _definition.GraphQLObjectType({
	  name: '__Schema',
	  description: 'A GraphQL Schema defines the capabilities of a GraphQL server. It ' + 'exposes all available types and directives on the server, as well as ' + 'the entry points for query, mutation, and subscription operations.',
	  fields: function fields() {
	    return {
	      types: {
	        description: 'A list of all types supported by this server.',
	        type: (0, _definition.GraphQLNonNull)((0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__Type))),
	        resolve: function resolve(schema) {
	          return (0, _objectValues.default)(schema.getTypeMap());
	        }
	      },
	      queryType: {
	        description: 'The type that query operations will be rooted at.',
	        type: (0, _definition.GraphQLNonNull)(__Type),
	        resolve: function resolve(schema) {
	          return schema.getQueryType();
	        }
	      },
	      mutationType: {
	        description: 'If this server supports mutation, the type that ' + 'mutation operations will be rooted at.',
	        type: __Type,
	        resolve: function resolve(schema) {
	          return schema.getMutationType();
	        }
	      },
	      subscriptionType: {
	        description: 'If this server support subscription, the type that ' + 'subscription operations will be rooted at.',
	        type: __Type,
	        resolve: function resolve(schema) {
	          return schema.getSubscriptionType();
	        }
	      },
	      directives: {
	        description: 'A list of all directives supported by this server.',
	        type: (0, _definition.GraphQLNonNull)((0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__Directive))),
	        resolve: function resolve(schema) {
	          return schema.getDirectives();
	        }
	      }
	    };
	  }
	});
	
	exports.__Schema = __Schema;
	
	var __Directive = new _definition.GraphQLObjectType({
	  name: '__Directive',
	  description: 'A Directive provides a way to describe alternate runtime execution and ' + 'type validation behavior in a GraphQL document.' + "\n\nIn some cases, you need to provide options to alter GraphQL's " + 'execution behavior in ways field arguments will not suffice, such as ' + 'conditionally including or skipping a field. Directives provide this by ' + 'describing additional information to the executor.',
	  fields: function fields() {
	    return {
	      name: {
	        type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLString),
	        resolve: function resolve(obj) {
	          return obj.name;
	        }
	      },
	      description: {
	        type: _scalars.GraphQLString,
	        resolve: function resolve(obj) {
	          return obj.description;
	        }
	      },
	      locations: {
	        type: (0, _definition.GraphQLNonNull)((0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__DirectiveLocation))),
	        resolve: function resolve(obj) {
	          return obj.locations;
	        }
	      },
	      args: {
	        type: (0, _definition.GraphQLNonNull)((0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__InputValue))),
	        resolve: function resolve(directive) {
	          return directive.args || [];
	        }
	      }
	    };
	  }
	});
	
	exports.__Directive = __Directive;
	
	var __DirectiveLocation = new _definition.GraphQLEnumType({
	  name: '__DirectiveLocation',
	  description: 'A Directive can be adjacent to many parts of the GraphQL language, a ' + '__DirectiveLocation describes one such possible adjacencies.',
	  values: {
	    QUERY: {
	      value: _directiveLocation.DirectiveLocation.QUERY,
	      description: 'Location adjacent to a query operation.'
	    },
	    MUTATION: {
	      value: _directiveLocation.DirectiveLocation.MUTATION,
	      description: 'Location adjacent to a mutation operation.'
	    },
	    SUBSCRIPTION: {
	      value: _directiveLocation.DirectiveLocation.SUBSCRIPTION,
	      description: 'Location adjacent to a subscription operation.'
	    },
	    FIELD: {
	      value: _directiveLocation.DirectiveLocation.FIELD,
	      description: 'Location adjacent to a field.'
	    },
	    FRAGMENT_DEFINITION: {
	      value: _directiveLocation.DirectiveLocation.FRAGMENT_DEFINITION,
	      description: 'Location adjacent to a fragment definition.'
	    },
	    FRAGMENT_SPREAD: {
	      value: _directiveLocation.DirectiveLocation.FRAGMENT_SPREAD,
	      description: 'Location adjacent to a fragment spread.'
	    },
	    INLINE_FRAGMENT: {
	      value: _directiveLocation.DirectiveLocation.INLINE_FRAGMENT,
	      description: 'Location adjacent to an inline fragment.'
	    },
	    VARIABLE_DEFINITION: {
	      value: _directiveLocation.DirectiveLocation.VARIABLE_DEFINITION,
	      description: 'Location adjacent to a variable definition.'
	    },
	    SCHEMA: {
	      value: _directiveLocation.DirectiveLocation.SCHEMA,
	      description: 'Location adjacent to a schema definition.'
	    },
	    SCALAR: {
	      value: _directiveLocation.DirectiveLocation.SCALAR,
	      description: 'Location adjacent to a scalar definition.'
	    },
	    OBJECT: {
	      value: _directiveLocation.DirectiveLocation.OBJECT,
	      description: 'Location adjacent to an object type definition.'
	    },
	    FIELD_DEFINITION: {
	      value: _directiveLocation.DirectiveLocation.FIELD_DEFINITION,
	      description: 'Location adjacent to a field definition.'
	    },
	    ARGUMENT_DEFINITION: {
	      value: _directiveLocation.DirectiveLocation.ARGUMENT_DEFINITION,
	      description: 'Location adjacent to an argument definition.'
	    },
	    INTERFACE: {
	      value: _directiveLocation.DirectiveLocation.INTERFACE,
	      description: 'Location adjacent to an interface definition.'
	    },
	    UNION: {
	      value: _directiveLocation.DirectiveLocation.UNION,
	      description: 'Location adjacent to a union definition.'
	    },
	    ENUM: {
	      value: _directiveLocation.DirectiveLocation.ENUM,
	      description: 'Location adjacent to an enum definition.'
	    },
	    ENUM_VALUE: {
	      value: _directiveLocation.DirectiveLocation.ENUM_VALUE,
	      description: 'Location adjacent to an enum value definition.'
	    },
	    INPUT_OBJECT: {
	      value: _directiveLocation.DirectiveLocation.INPUT_OBJECT,
	      description: 'Location adjacent to an input object type definition.'
	    },
	    INPUT_FIELD_DEFINITION: {
	      value: _directiveLocation.DirectiveLocation.INPUT_FIELD_DEFINITION,
	      description: 'Location adjacent to an input object field definition.'
	    }
	  }
	});
	
	exports.__DirectiveLocation = __DirectiveLocation;
	
	var __Type = new _definition.GraphQLObjectType({
	  name: '__Type',
	  description: 'The fundamental unit of any GraphQL Schema is the type. There are ' + 'many kinds of types in GraphQL as represented by the `__TypeKind` enum.' + '\n\nDepending on the kind of a type, certain fields describe ' + 'information about that type. Scalar types provide no information ' + 'beyond a name and description, while Enum types provide their values. ' + 'Object and Interface types provide the fields they describe. Abstract ' + 'types, Union and Interface, provide the Object types possible ' + 'at runtime. List and NonNull types compose other types.',
	  fields: function fields() {
	    return {
	      kind: {
	        type: (0, _definition.GraphQLNonNull)(__TypeKind),
	        resolve: function resolve(type) {
	          if ((0, _definition.isScalarType)(type)) {
	            return TypeKind.SCALAR;
	          } else if ((0, _definition.isObjectType)(type)) {
	            return TypeKind.OBJECT;
	          } else if ((0, _definition.isInterfaceType)(type)) {
	            return TypeKind.INTERFACE;
	          } else if ((0, _definition.isUnionType)(type)) {
	            return TypeKind.UNION;
	          } else if ((0, _definition.isEnumType)(type)) {
	            return TypeKind.ENUM;
	          } else if ((0, _definition.isInputObjectType)(type)) {
	            return TypeKind.INPUT_OBJECT;
	          } else if ((0, _definition.isListType)(type)) {
	            return TypeKind.LIST;
	          } else if ((0, _definition.isNonNullType)(type)) {
	            return TypeKind.NON_NULL;
	          }
	
	          throw new Error('Unknown kind of type: ' + type);
	        }
	      },
	      name: {
	        type: _scalars.GraphQLString,
	        resolve: function resolve(obj) {
	          return obj.name;
	        }
	      },
	      description: {
	        type: _scalars.GraphQLString,
	        resolve: function resolve(obj) {
	          return obj.description;
	        }
	      },
	      fields: {
	        type: (0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__Field)),
	        args: {
	          includeDeprecated: {
	            type: _scalars.GraphQLBoolean,
	            defaultValue: false
	          }
	        },
	        resolve: function resolve(type, _ref) {
	          var includeDeprecated = _ref.includeDeprecated;
	
	          if ((0, _definition.isObjectType)(type) || (0, _definition.isInterfaceType)(type)) {
	            var fields = (0, _objectValues.default)(type.getFields());
	
	            if (!includeDeprecated) {
	              fields = fields.filter(function (field) {
	                return !field.deprecationReason;
	              });
	            }
	
	            return fields;
	          }
	
	          return null;
	        }
	      },
	      interfaces: {
	        type: (0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__Type)),
	        resolve: function resolve(type) {
	          if ((0, _definition.isObjectType)(type)) {
	            return type.getInterfaces();
	          }
	        }
	      },
	      possibleTypes: {
	        type: (0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__Type)),
	        resolve: function resolve(type, args, context, _ref2) {
	          var schema = _ref2.schema;
	
	          if ((0, _definition.isAbstractType)(type)) {
	            return schema.getPossibleTypes(type);
	          }
	        }
	      },
	      enumValues: {
	        type: (0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__EnumValue)),
	        args: {
	          includeDeprecated: {
	            type: _scalars.GraphQLBoolean,
	            defaultValue: false
	          }
	        },
	        resolve: function resolve(type, _ref3) {
	          var includeDeprecated = _ref3.includeDeprecated;
	
	          if ((0, _definition.isEnumType)(type)) {
	            var values = type.getValues();
	
	            if (!includeDeprecated) {
	              values = values.filter(function (value) {
	                return !value.deprecationReason;
	              });
	            }
	
	            return values;
	          }
	        }
	      },
	      inputFields: {
	        type: (0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__InputValue)),
	        resolve: function resolve(type) {
	          if ((0, _definition.isInputObjectType)(type)) {
	            return (0, _objectValues.default)(type.getFields());
	          }
	        }
	      },
	      ofType: {
	        type: __Type,
	        resolve: function resolve(obj) {
	          return obj.ofType;
	        }
	      }
	    };
	  }
	});
	
	exports.__Type = __Type;
	
	var __Field = new _definition.GraphQLObjectType({
	  name: '__Field',
	  description: 'Object and Interface types are described by a list of Fields, each of ' + 'which has a name, potentially a list of arguments, and a return type.',
	  fields: function fields() {
	    return {
	      name: {
	        type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLString),
	        resolve: function resolve(obj) {
	          return obj.name;
	        }
	      },
	      description: {
	        type: _scalars.GraphQLString,
	        resolve: function resolve(obj) {
	          return obj.description;
	        }
	      },
	      args: {
	        type: (0, _definition.GraphQLNonNull)((0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__InputValue))),
	        resolve: function resolve(field) {
	          return field.args || [];
	        }
	      },
	      type: {
	        type: (0, _definition.GraphQLNonNull)(__Type),
	        resolve: function resolve(obj) {
	          return obj.type;
	        }
	      },
	      isDeprecated: {
	        type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLBoolean),
	        resolve: function resolve(obj) {
	          return obj.isDeprecated;
	        }
	      },
	      deprecationReason: {
	        type: _scalars.GraphQLString,
	        resolve: function resolve(obj) {
	          return obj.deprecationReason;
	        }
	      }
	    };
	  }
	});
	
	exports.__Field = __Field;
	
	var __InputValue = new _definition.GraphQLObjectType({
	  name: '__InputValue',
	  description: 'Arguments provided to Fields or Directives and the input fields of an ' + 'InputObject are represented as Input Values which describe their type ' + 'and optionally a default value.',
	  fields: function fields() {
	    return {
	      name: {
	        type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLString),
	        resolve: function resolve(obj) {
	          return obj.name;
	        }
	      },
	      description: {
	        type: _scalars.GraphQLString,
	        resolve: function resolve(obj) {
	          return obj.description;
	        }
	      },
	      type: {
	        type: (0, _definition.GraphQLNonNull)(__Type),
	        resolve: function resolve(obj) {
	          return obj.type;
	        }
	      },
	      defaultValue: {
	        type: _scalars.GraphQLString,
	        description: 'A GraphQL-formatted string representing the default value for this ' + 'input value.',
	        resolve: function resolve(inputVal) {
	          return (0, _isInvalid.default)(inputVal.defaultValue) ? null : (0, _printer.print)((0, _astFromValue.astFromValue)(inputVal.defaultValue, inputVal.type));
	        }
	      }
	    };
	  }
	});
	
	exports.__InputValue = __InputValue;
	
	var __EnumValue = new _definition.GraphQLObjectType({
	  name: '__EnumValue',
	  description: 'One possible value for a given Enum. Enum values are unique values, not ' + 'a placeholder for a string or numeric value. However an Enum value is ' + 'returned in a JSON response as a string.',
	  fields: function fields() {
	    return {
	      name: {
	        type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLString),
	        resolve: function resolve(obj) {
	          return obj.name;
	        }
	      },
	      description: {
	        type: _scalars.GraphQLString,
	        resolve: function resolve(obj) {
	          return obj.description;
	        }
	      },
	      isDeprecated: {
	        type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLBoolean),
	        resolve: function resolve(obj) {
	          return obj.isDeprecated;
	        }
	      },
	      deprecationReason: {
	        type: _scalars.GraphQLString,
	        resolve: function resolve(obj) {
	          return obj.deprecationReason;
	        }
	      }
	    };
	  }
	});
	
	exports.__EnumValue = __EnumValue;
	var TypeKind = {
	  SCALAR: 'SCALAR',
	  OBJECT: 'OBJECT',
	  INTERFACE: 'INTERFACE',
	  UNION: 'UNION',
	  ENUM: 'ENUM',
	  INPUT_OBJECT: 'INPUT_OBJECT',
	  LIST: 'LIST',
	  NON_NULL: 'NON_NULL'
	};
	exports.TypeKind = TypeKind;
	
	var __TypeKind = new _definition.GraphQLEnumType({
	  name: '__TypeKind',
	  description: 'An enum describing what kind of type a given `__Type` is.',
	  values: {
	    SCALAR: {
	      value: TypeKind.SCALAR,
	      description: 'Indicates this type is a scalar.'
	    },
	    OBJECT: {
	      value: TypeKind.OBJECT,
	      description: 'Indicates this type is an object. ' + '`fields` and `interfaces` are valid fields.'
	    },
	    INTERFACE: {
	      value: TypeKind.INTERFACE,
	      description: 'Indicates this type is an interface. ' + '`fields` and `possibleTypes` are valid fields.'
	    },
	    UNION: {
	      value: TypeKind.UNION,
	      description: 'Indicates this type is a union. `possibleTypes` is a valid field.'
	    },
	    ENUM: {
	      value: TypeKind.ENUM,
	      description: 'Indicates this type is an enum. `enumValues` is a valid field.'
	    },
	    INPUT_OBJECT: {
	      value: TypeKind.INPUT_OBJECT,
	      description: 'Indicates this type is an input object. ' + '`inputFields` is a valid field.'
	    },
	    LIST: {
	      value: TypeKind.LIST,
	      description: 'Indicates this type is a list. `ofType` is a valid field.'
	    },
	    NON_NULL: {
	      value: TypeKind.NON_NULL,
	      description: 'Indicates this type is a non-null. `ofType` is a valid field.'
	    }
	  }
	});
	/**
	 * Note that these are GraphQLField and not GraphQLFieldConfig,
	 * so the format for args is different.
	 */
	
	
	exports.__TypeKind = __TypeKind;
	var SchemaMetaFieldDef = {
	  name: '__schema',
	  type: (0, _definition.GraphQLNonNull)(__Schema),
	  description: 'Access the current type schema of this server.',
	  args: [],
	  resolve: function resolve(source, args, context, _ref4) {
	    var schema = _ref4.schema;
	    return schema;
	  }
	};
	exports.SchemaMetaFieldDef = SchemaMetaFieldDef;
	var TypeMetaFieldDef = {
	  name: '__type',
	  type: __Type,
	  description: 'Request the type information of a single type.',
	  args: [{
	    name: 'name',
	    type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLString)
	  }],
	  resolve: function resolve(source, _ref5, context, _ref6) {
	    var name = _ref5.name;
	    var schema = _ref6.schema;
	    return schema.getType(name);
	  }
	};
	exports.TypeMetaFieldDef = TypeMetaFieldDef;
	var TypeNameMetaFieldDef = {
	  name: '__typename',
	  type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLString),
	  description: 'The name of the current Object type at runtime.',
	  args: [],
	  resolve: function resolve(source, args, context, _ref7) {
	    var parentType = _ref7.parentType;
	    return parentType.name;
	  }
	};
	exports.TypeNameMetaFieldDef = TypeNameMetaFieldDef;
	var introspectionTypes = [__Schema, __Directive, __DirectiveLocation, __Type, __Field, __InputValue, __EnumValue, __TypeKind];
	exports.introspectionTypes = introspectionTypes;
	
	function isIntrospectionType(type) {
	  return (0, _definition.isNamedType)(type) && ( // Would prefer to use introspectionTypes.some(), however %checks needs
	  // a simple expression.
	  type.name === __Schema.name || type.name === __Directive.name || type.name === __DirectiveLocation.name || type.name === __Type.name || type.name === __Field.name || type.name === __InputValue.name || type.name === __EnumValue.name || type.name === __TypeKind.name);
	}

/***/ },
/* 24 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = exports.makeEventKey = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var SelectableContext = /*#__PURE__*/_react.default.createContext(null);
	
	var makeEventKey = function makeEventKey(eventKey, href) {
	  if (href === void 0) {
	    href = null;
	  }
	
	  if (eventKey != null) return String(eventKey);
	  return href || null;
	};
	
	exports.makeEventKey = makeEventKey;
	var _default = SelectableContext;
	exports.default = _default;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
		module.exports = __webpack_require__(277);
	} else {
		module.exports = require('./dist/aws-amplify-core.js');
	}


/***/ },
/* 27 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = keyMap;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Creates a keyed JS object from an array, given a function to produce the keys
	 * for each value in the array.
	 *
	 * This provides a convenient lookup for the array items if the key function
	 * produces unique results.
	 *
	 *     const phoneBook = [
	 *       { name: 'Jon', num: '555-1234' },
	 *       { name: 'Jenny', num: '867-5309' }
	 *     ]
	 *
	 *     // { Jon: { name: 'Jon', num: '555-1234' },
	 *     //   Jenny: { name: 'Jenny', num: '867-5309' } }
	 *     const entriesByName = keyMap(
	 *       phoneBook,
	 *       entry => entry.name
	 *     )
	 *
	 *     // { name: 'Jenny', num: '857-6309' }
	 *     const jennyEntry = entriesByName['Jenny']
	 *
	 */
	function keyMap(list, keyFn) {
	  return list.reduce(function (map, item) {
	    return map[keyFn(item)] = item, map;
	  }, Object.create(null));
	}

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isSpecifiedScalarType = isSpecifiedScalarType;
	exports.specifiedScalarTypes = exports.GraphQLID = exports.GraphQLBoolean = exports.GraphQLString = exports.GraphQLFloat = exports.GraphQLInt = void 0;
	
	var _inspect = _interopRequireDefault(__webpack_require__(16));
	
	var _isFinite = _interopRequireDefault(__webpack_require__(451));
	
	var _isInteger = _interopRequireDefault(__webpack_require__(452));
	
	var _definition = __webpack_require__(10);
	
	var _kinds = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	// As per the GraphQL Spec, Integers are only treated as valid when a valid
	// 32-bit signed integer, providing the broadest support across platforms.
	//
	// n.b. JavaScript's integers are safe between -(2^53 - 1) and 2^53 - 1 because
	// they are internally represented as IEEE 754 doubles.
	var MAX_INT = 2147483647;
	var MIN_INT = -2147483648;
	
	function serializeInt(value) {
	  if (typeof value === 'boolean') {
	    return value ? 1 : 0;
	  }
	
	  var num = value;
	
	  if (typeof value === 'string' && value !== '') {
	    num = Number(value);
	  }
	
	  if (!(0, _isInteger.default)(num)) {
	    throw new TypeError("Int cannot represent non-integer value: ".concat((0, _inspect.default)(value)));
	  }
	
	  if (num > MAX_INT || num < MIN_INT) {
	    throw new TypeError("Int cannot represent non 32-bit signed integer value: ".concat((0, _inspect.default)(value)));
	  }
	
	  return num;
	}
	
	function coerceInt(value) {
	  if (!(0, _isInteger.default)(value)) {
	    throw new TypeError("Int cannot represent non-integer value: ".concat((0, _inspect.default)(value)));
	  }
	
	  if (value > MAX_INT || value < MIN_INT) {
	    throw new TypeError("Int cannot represent non 32-bit signed integer value: ".concat((0, _inspect.default)(value)));
	  }
	
	  return value;
	}
	
	var GraphQLInt = new _definition.GraphQLScalarType({
	  name: 'Int',
	  description: 'The `Int` scalar type represents non-fractional signed whole numeric ' + 'values. Int can represent values between -(2^31) and 2^31 - 1. ',
	  serialize: serializeInt,
	  parseValue: coerceInt,
	  parseLiteral: function parseLiteral(ast) {
	    if (ast.kind === _kinds.Kind.INT) {
	      var num = parseInt(ast.value, 10);
	
	      if (num <= MAX_INT && num >= MIN_INT) {
	        return num;
	      }
	    }
	
	    return undefined;
	  }
	});
	exports.GraphQLInt = GraphQLInt;
	
	function serializeFloat(value) {
	  if (typeof value === 'boolean') {
	    return value ? 1 : 0;
	  }
	
	  var num = value;
	
	  if (typeof value === 'string' && value !== '') {
	    num = Number(value);
	  }
	
	  if (!(0, _isFinite.default)(num)) {
	    throw new TypeError("Float cannot represent non numeric value: ".concat((0, _inspect.default)(value)));
	  }
	
	  return num;
	}
	
	function coerceFloat(value) {
	  if (!(0, _isFinite.default)(value)) {
	    throw new TypeError("Float cannot represent non numeric value: ".concat((0, _inspect.default)(value)));
	  }
	
	  return value;
	}
	
	var GraphQLFloat = new _definition.GraphQLScalarType({
	  name: 'Float',
	  description: 'The `Float` scalar type represents signed double-precision fractional ' + 'values as specified by ' + '[IEEE 754](http://en.wikipedia.org/wiki/IEEE_floating_point). ',
	  serialize: serializeFloat,
	  parseValue: coerceFloat,
	  parseLiteral: function parseLiteral(ast) {
	    return ast.kind === _kinds.Kind.FLOAT || ast.kind === _kinds.Kind.INT ? parseFloat(ast.value) : undefined;
	  }
	});
	exports.GraphQLFloat = GraphQLFloat;
	
	function serializeString(value) {
	  // Support serializing objects with custom valueOf() functions - a common way
	  // to represent an complex value which can be represented as a string
	  // (ex: MongoDB id objects).
	  var result = value && typeof value.valueOf === 'function' ? value.valueOf() : value; // Serialize string, boolean and number values to a string, but do not
	  // attempt to coerce object, function, symbol, or other types as strings.
	
	  if (typeof result === 'string') {
	    return result;
	  }
	
	  if (typeof result === 'boolean') {
	    return result ? 'true' : 'false';
	  }
	
	  if ((0, _isFinite.default)(result)) {
	    return result.toString();
	  }
	
	  throw new TypeError("String cannot represent value: ".concat((0, _inspect.default)(value)));
	}
	
	function coerceString(value) {
	  if (typeof value !== 'string') {
	    throw new TypeError("String cannot represent a non string value: ".concat((0, _inspect.default)(value)));
	  }
	
	  return value;
	}
	
	var GraphQLString = new _definition.GraphQLScalarType({
	  name: 'String',
	  description: 'The `String` scalar type represents textual data, represented as UTF-8 ' + 'character sequences. The String type is most often used by GraphQL to ' + 'represent free-form human-readable text.',
	  serialize: serializeString,
	  parseValue: coerceString,
	  parseLiteral: function parseLiteral(ast) {
	    return ast.kind === _kinds.Kind.STRING ? ast.value : undefined;
	  }
	});
	exports.GraphQLString = GraphQLString;
	
	function serializeBoolean(value) {
	  if (typeof value === 'boolean') {
	    return value;
	  }
	
	  if ((0, _isFinite.default)(value)) {
	    return value !== 0;
	  }
	
	  throw new TypeError("Boolean cannot represent a non boolean value: ".concat((0, _inspect.default)(value)));
	}
	
	function coerceBoolean(value) {
	  if (typeof value !== 'boolean') {
	    throw new TypeError("Boolean cannot represent a non boolean value: ".concat((0, _inspect.default)(value)));
	  }
	
	  return value;
	}
	
	var GraphQLBoolean = new _definition.GraphQLScalarType({
	  name: 'Boolean',
	  description: 'The `Boolean` scalar type represents `true` or `false`.',
	  serialize: serializeBoolean,
	  parseValue: coerceBoolean,
	  parseLiteral: function parseLiteral(ast) {
	    return ast.kind === _kinds.Kind.BOOLEAN ? ast.value : undefined;
	  }
	});
	exports.GraphQLBoolean = GraphQLBoolean;
	
	function serializeID(value) {
	  // Support serializing objects with custom valueOf() functions - a common way
	  // to represent an object identifier (ex. MongoDB).
	  var result = value && typeof value.valueOf === 'function' ? value.valueOf() : value;
	
	  if (typeof result === 'string') {
	    return result;
	  }
	
	  if ((0, _isInteger.default)(result)) {
	    return String(result);
	  }
	
	  throw new TypeError("ID cannot represent value: ".concat((0, _inspect.default)(value)));
	}
	
	function coerceID(value) {
	  if (typeof value === 'string') {
	    return value;
	  }
	
	  if ((0, _isInteger.default)(value)) {
	    return value.toString();
	  }
	
	  throw new TypeError("ID cannot represent value: ".concat((0, _inspect.default)(value)));
	}
	
	var GraphQLID = new _definition.GraphQLScalarType({
	  name: 'ID',
	  description: 'The `ID` scalar type represents a unique identifier, often used to ' + 'refetch an object or as key for a cache. The ID type appears in a JSON ' + 'response as a String; however, it is not intended to be human-readable. ' + 'When expected as an input type, any string (such as `"4"`) or integer ' + '(such as `4`) input value will be accepted as an ID.',
	  serialize: serializeID,
	  parseValue: coerceID,
	  parseLiteral: function parseLiteral(ast) {
	    return ast.kind === _kinds.Kind.STRING || ast.kind === _kinds.Kind.INT ? ast.value : undefined;
	  }
	});
	exports.GraphQLID = GraphQLID;
	var specifiedScalarTypes = [GraphQLString, GraphQLInt, GraphQLFloat, GraphQLBoolean, GraphQLID];
	exports.specifiedScalarTypes = specifiedScalarTypes;
	
	function isSpecifiedScalarType(type) {
	  return (0, _definition.isNamedType)(type) && ( // Would prefer to use specifiedScalarTypes.some(), however %checks needs
	  // a simple expression.
	  type.name === GraphQLString.name || type.name === GraphQLInt.name || type.name === GraphQLFloat.name || type.name === GraphQLBoolean.name || type.name === GraphQLID.name);
	}

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.typeFromAST = typeFromAST;
	
	var _kinds = __webpack_require__(11);
	
	var _definition = __webpack_require__(10);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function typeFromAST(schema, typeNode) {
	  /* eslint-enable no-redeclare */
	  var innerType;
	
	  if (typeNode.kind === _kinds.Kind.LIST_TYPE) {
	    innerType = typeFromAST(schema, typeNode.type);
	    return innerType && (0, _definition.GraphQLList)(innerType);
	  }
	
	  if (typeNode.kind === _kinds.Kind.NON_NULL_TYPE) {
	    innerType = typeFromAST(schema, typeNode.type);
	    return innerType && (0, _definition.GraphQLNonNull)(innerType);
	  }
	
	  if (typeNode.kind === _kinds.Kind.NAMED_TYPE) {
	    return schema.getType(typeNode.name.value);
	  }
	  /* istanbul ignore next */
	
	
	  throw new Error("Unexpected type kind: ".concat(typeNode.kind, "."));
	}

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var FormContext = /*#__PURE__*/_react.default.createContext({
	  controlId: undefined
	});
	
	var _default = FormContext;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(156)["default"];
	
	function _getRequireWildcardCache(nodeInterop) {
	  if (typeof WeakMap !== "function") return null;
	  var cacheBabelInterop = new WeakMap();
	  var cacheNodeInterop = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
	    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
	  })(nodeInterop);
	}
	
	function _interopRequireWildcard(obj, nodeInterop) {
	  if (!nodeInterop && obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache(nodeInterop);
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 33 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isInvalid;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Returns true if a value is undefined, or NaN.
	 */
	function isInvalid(value) {
	  return value === undefined || value !== value;
	}

/***/ },
/* 34 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/* eslint-disable no-redeclare */
	// $FlowFixMe workaround for: https://github.com/facebook/flow/issues/2221
	var objectValues = Object.values || function (obj) {
	  return Object.keys(obj).map(function (key) {
	    return obj[key];
	  });
	};
	
	var _default = objectValues;
	exports.default = _default;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(127));
	
	var _excluded = ["as", "disabled", "onKeyDown"];
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, DropdownItems, etc.
	 */
	
	
	var SafeAnchor = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'a' : _ref$as,
	      disabled = _ref.disabled,
	      onKeyDown = _ref.onKeyDown,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	
	  var handleClick = function handleClick(event) {
	    var href = props.href,
	        onClick = props.onClick;
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    if (event.key === ' ') {
	      event.preventDefault();
	      handleClick(event);
	    }
	  };
	
	  if (isTrivialHref(props.href)) {
	    props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
	    // otherwise, the cursor incorrectly styled (except with role='button')
	
	    props.href = props.href || '#';
	  }
	
	  if (disabled) {
	    props.tabIndex = -1;
	    props['aria-disabled'] = true;
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    onClick: handleClick,
	    onKeyDown: (0, _createChainedFunction.default)(handleKeyDown, onKeyDown)
	  }));
	});
	
	SafeAnchor.displayName = 'SafeAnchor';
	var _default = SafeAnchor;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 36 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.visit = visit;
	exports.visitInParallel = visitInParallel;
	exports.visitWithTypeInfo = visitWithTypeInfo;
	exports.getVisitFn = getVisitFn;
	exports.BREAK = exports.QueryDocumentKeys = void 0;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * A visitor is provided to visit, it contains the collection of
	 * relevant functions to be called during the visitor's traversal.
	 */
	
	/**
	 * A visitor is comprised of visit functions, which are called on each node
	 * during the visitor's traversal.
	 */
	
	/**
	 * A KeyMap describes each the traversable properties of each kind of node.
	 */
	var QueryDocumentKeys = {
	  Name: [],
	  Document: ['definitions'],
	  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
	  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
	  Variable: ['name'],
	  SelectionSet: ['selections'],
	  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
	  Argument: ['name', 'value'],
	  FragmentSpread: ['name', 'directives'],
	  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
	  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
	  // or removed in the future.
	  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
	  IntValue: [],
	  FloatValue: [],
	  StringValue: [],
	  BooleanValue: [],
	  NullValue: [],
	  EnumValue: [],
	  ListValue: ['values'],
	  ObjectValue: ['fields'],
	  ObjectField: ['name', 'value'],
	  Directive: ['name', 'arguments'],
	  NamedType: ['name'],
	  ListType: ['type'],
	  NonNullType: ['type'],
	  SchemaDefinition: ['directives', 'operationTypes'],
	  OperationTypeDefinition: ['type'],
	  ScalarTypeDefinition: ['description', 'name', 'directives'],
	  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
	  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
	  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
	  InterfaceTypeDefinition: ['description', 'name', 'directives', 'fields'],
	  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
	  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
	  EnumValueDefinition: ['description', 'name', 'directives'],
	  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
	  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
	  SchemaExtension: ['directives', 'operationTypes'],
	  ScalarTypeExtension: ['name', 'directives'],
	  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
	  InterfaceTypeExtension: ['name', 'directives', 'fields'],
	  UnionTypeExtension: ['name', 'directives', 'types'],
	  EnumTypeExtension: ['name', 'directives', 'values'],
	  InputObjectTypeExtension: ['name', 'directives', 'fields']
	};
	exports.QueryDocumentKeys = QueryDocumentKeys;
	var BREAK = {};
	/**
	 * visit() will walk through an AST using a depth first traversal, calling
	 * the visitor's enter function at each node in the traversal, and calling the
	 * leave function after visiting that node and all of its child nodes.
	 *
	 * By returning different values from the enter and leave functions, the
	 * behavior of the visitor can be altered, including skipping over a sub-tree of
	 * the AST (by returning false), editing the AST by returning a value or null
	 * to remove the value, or to stop the whole traversal by returning BREAK.
	 *
	 * When using visit() to edit an AST, the original AST will not be modified, and
	 * a new version of the AST with the changes applied will be returned from the
	 * visit function.
	 *
	 *     const editedAST = visit(ast, {
	 *       enter(node, key, parent, path, ancestors) {
	 *         // @return
	 *         //   undefined: no action
	 *         //   false: skip visiting this node
	 *         //   visitor.BREAK: stop visiting altogether
	 *         //   null: delete this node
	 *         //   any value: replace this node with the returned value
	 *       },
	 *       leave(node, key, parent, path, ancestors) {
	 *         // @return
	 *         //   undefined: no action
	 *         //   false: no action
	 *         //   visitor.BREAK: stop visiting altogether
	 *         //   null: delete this node
	 *         //   any value: replace this node with the returned value
	 *       }
	 *     });
	 *
	 * Alternatively to providing enter() and leave() functions, a visitor can
	 * instead provide functions named the same as the kinds of AST nodes, or
	 * enter/leave visitors at a named key, leading to four permutations of
	 * visitor API:
	 *
	 * 1) Named visitors triggered when entering a node a specific kind.
	 *
	 *     visit(ast, {
	 *       Kind(node) {
	 *         // enter the "Kind" node
	 *       }
	 *     })
	 *
	 * 2) Named visitors that trigger upon entering and leaving a node of
	 *    a specific kind.
	 *
	 *     visit(ast, {
	 *       Kind: {
	 *         enter(node) {
	 *           // enter the "Kind" node
	 *         }
	 *         leave(node) {
	 *           // leave the "Kind" node
	 *         }
	 *       }
	 *     })
	 *
	 * 3) Generic visitors that trigger upon entering and leaving any node.
	 *
	 *     visit(ast, {
	 *       enter(node) {
	 *         // enter any node
	 *       },
	 *       leave(node) {
	 *         // leave any node
	 *       }
	 *     })
	 *
	 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
	 *
	 *     visit(ast, {
	 *       enter: {
	 *         Kind(node) {
	 *           // enter the "Kind" node
	 *         }
	 *       },
	 *       leave: {
	 *         Kind(node) {
	 *           // leave the "Kind" node
	 *         }
	 *       }
	 *     })
	 */
	
	exports.BREAK = BREAK;
	
	function visit(root, visitor) {
	  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;
	
	  /* eslint-disable no-undef-init */
	  var stack = undefined;
	  var inArray = Array.isArray(root);
	  var keys = [root];
	  var index = -1;
	  var edits = [];
	  var node = undefined;
	  var key = undefined;
	  var parent = undefined;
	  var path = [];
	  var ancestors = [];
	  var newRoot = root;
	  /* eslint-enable no-undef-init */
	
	  do {
	    index++;
	    var isLeaving = index === keys.length;
	    var isEdited = isLeaving && edits.length !== 0;
	
	    if (isLeaving) {
	      key = ancestors.length === 0 ? undefined : path[path.length - 1];
	      node = parent;
	      parent = ancestors.pop();
	
	      if (isEdited) {
	        if (inArray) {
	          node = node.slice();
	        } else {
	          var clone = {};
	
	          for (var k in node) {
	            if (node.hasOwnProperty(k)) {
	              clone[k] = node[k];
	            }
	          }
	
	          node = clone;
	        }
	
	        var editOffset = 0;
	
	        for (var ii = 0; ii < edits.length; ii++) {
	          var editKey = edits[ii][0];
	          var editValue = edits[ii][1];
	
	          if (inArray) {
	            editKey -= editOffset;
	          }
	
	          if (inArray && editValue === null) {
	            node.splice(editKey, 1);
	            editOffset++;
	          } else {
	            node[editKey] = editValue;
	          }
	        }
	      }
	
	      index = stack.index;
	      keys = stack.keys;
	      edits = stack.edits;
	      inArray = stack.inArray;
	      stack = stack.prev;
	    } else {
	      key = parent ? inArray ? index : keys[index] : undefined;
	      node = parent ? parent[key] : newRoot;
	
	      if (node === null || node === undefined) {
	        continue;
	      }
	
	      if (parent) {
	        path.push(key);
	      }
	    }
	
	    var result = void 0;
	
	    if (!Array.isArray(node)) {
	      if (!isNode(node)) {
	        throw new Error('Invalid AST Node: ' + JSON.stringify(node));
	      }
	
	      var visitFn = getVisitFn(visitor, node.kind, isLeaving);
	
	      if (visitFn) {
	        result = visitFn.call(visitor, node, key, parent, path, ancestors);
	
	        if (result === BREAK) {
	          break;
	        }
	
	        if (result === false) {
	          if (!isLeaving) {
	            path.pop();
	            continue;
	          }
	        } else if (result !== undefined) {
	          edits.push([key, result]);
	
	          if (!isLeaving) {
	            if (isNode(result)) {
	              node = result;
	            } else {
	              path.pop();
	              continue;
	            }
	          }
	        }
	      }
	    }
	
	    if (result === undefined && isEdited) {
	      edits.push([key, node]);
	    }
	
	    if (isLeaving) {
	      path.pop();
	    } else {
	      stack = {
	        inArray: inArray,
	        index: index,
	        keys: keys,
	        edits: edits,
	        prev: stack
	      };
	      inArray = Array.isArray(node);
	      keys = inArray ? node : visitorKeys[node.kind] || [];
	      index = -1;
	      edits = [];
	
	      if (parent) {
	        ancestors.push(parent);
	      }
	
	      parent = node;
	    }
	  } while (stack !== undefined);
	
	  if (edits.length !== 0) {
	    newRoot = edits[edits.length - 1][1];
	  }
	
	  return newRoot;
	}
	
	function isNode(maybeNode) {
	  return Boolean(maybeNode && typeof maybeNode.kind === 'string');
	}
	/**
	 * Creates a new visitor instance which delegates to many visitors to run in
	 * parallel. Each visitor will be visited for each node before moving on.
	 *
	 * If a prior visitor edits a node, no following visitors will see that node.
	 */
	
	
	function visitInParallel(visitors) {
	  var skipping = new Array(visitors.length);
	  return {
	    enter: function enter(node) {
	      for (var i = 0; i < visitors.length; i++) {
	        if (!skipping[i]) {
	          var fn = getVisitFn(visitors[i], node.kind,
	          /* isLeaving */
	          false);
	
	          if (fn) {
	            var result = fn.apply(visitors[i], arguments);
	
	            if (result === false) {
	              skipping[i] = node;
	            } else if (result === BREAK) {
	              skipping[i] = BREAK;
	            } else if (result !== undefined) {
	              return result;
	            }
	          }
	        }
	      }
	    },
	    leave: function leave(node) {
	      for (var i = 0; i < visitors.length; i++) {
	        if (!skipping[i]) {
	          var fn = getVisitFn(visitors[i], node.kind,
	          /* isLeaving */
	          true);
	
	          if (fn) {
	            var result = fn.apply(visitors[i], arguments);
	
	            if (result === BREAK) {
	              skipping[i] = BREAK;
	            } else if (result !== undefined && result !== false) {
	              return result;
	            }
	          }
	        } else if (skipping[i] === node) {
	          skipping[i] = null;
	        }
	      }
	    }
	  };
	}
	/**
	 * Creates a new visitor instance which maintains a provided TypeInfo instance
	 * along with visiting visitor.
	 */
	
	
	function visitWithTypeInfo(typeInfo, visitor) {
	  return {
	    enter: function enter(node) {
	      typeInfo.enter(node);
	      var fn = getVisitFn(visitor, node.kind,
	      /* isLeaving */
	      false);
	
	      if (fn) {
	        var result = fn.apply(visitor, arguments);
	
	        if (result !== undefined) {
	          typeInfo.leave(node);
	
	          if (isNode(result)) {
	            typeInfo.enter(result);
	          }
	        }
	
	        return result;
	      }
	    },
	    leave: function leave(node) {
	      var fn = getVisitFn(visitor, node.kind,
	      /* isLeaving */
	      true);
	      var result;
	
	      if (fn) {
	        result = fn.apply(visitor, arguments);
	      }
	
	      typeInfo.leave(node);
	      return result;
	    }
	  };
	}
	/**
	 * Given a visitor instance, if it is leaving or not, and a node kind, return
	 * the function the visitor runtime should call.
	 */
	
	
	function getVisitFn(visitor, kind, isLeaving) {
	  var kindVisitor = visitor[kind];
	
	  if (kindVisitor) {
	    if (!isLeaving && typeof kindVisitor === 'function') {
	      // { Kind() {} }
	      return kindVisitor;
	    }
	
	    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
	
	    if (typeof kindSpecificVisitor === 'function') {
	      // { Kind: { enter() {}, leave() {} } }
	      return kindSpecificVisitor;
	    }
	  } else {
	    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
	
	    if (specificVisitor) {
	      if (typeof specificVisitor === 'function') {
	        // { enter() {}, leave() {} }
	        return specificVisitor;
	      }
	
	      var specificKindVisitor = specificVisitor[kind];
	
	      if (typeof specificKindVisitor === 'function') {
	        // { enter: { Kind() {} }, leave: { Kind() {} } }
	        return specificKindVisitor;
	      }
	    }
	  }
	}

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isSchema = isSchema;
	exports.GraphQLSchema = void 0;
	
	var _definition = __webpack_require__(10);
	
	var _directives = __webpack_require__(19);
	
	var _inspect = _interopRequireDefault(__webpack_require__(16));
	
	var _introspection = __webpack_require__(23);
	
	var _defineToStringTag = _interopRequireDefault(__webpack_require__(64));
	
	var _find = _interopRequireDefault(__webpack_require__(51));
	
	var _instanceOf = _interopRequireDefault(__webpack_require__(104));
	
	var _invariant = _interopRequireDefault(__webpack_require__(17));
	
	var _objectValues = _interopRequireDefault(__webpack_require__(34));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// eslint-disable-next-line no-redeclare
	function isSchema(schema) {
	  return (0, _instanceOf.default)(schema, GraphQLSchema);
	}
	/**
	 * Schema Definition
	 *
	 * A Schema is created by supplying the root types of each type of operation,
	 * query and mutation (optional). A schema definition is then supplied to the
	 * validator and executor.
	 *
	 * Example:
	 *
	 *     const MyAppSchema = new GraphQLSchema({
	 *       query: MyAppQueryRootType,
	 *       mutation: MyAppMutationRootType,
	 *     })
	 *
	 * Note: If an array of `directives` are provided to GraphQLSchema, that will be
	 * the exact list of directives represented and allowed. If `directives` is not
	 * provided then a default set of the specified directives (e.g. @include and
	 * @skip) will be used. If you wish to provide *additional* directives to these
	 * specified directives, you must explicitly declare them. Example:
	 *
	 *     const MyAppSchema = new GraphQLSchema({
	 *       ...
	 *       directives: specifiedDirectives.concat([ myCustomDirective ]),
	 *     })
	 *
	 */
	
	
	var GraphQLSchema =
	/*#__PURE__*/
	function () {
	  // Used as a cache for validateSchema().
	  // Referenced by validateSchema().
	  function GraphQLSchema(config) {
	    _defineProperty(this, "astNode", void 0);
	
	    _defineProperty(this, "extensionASTNodes", void 0);
	
	    _defineProperty(this, "_queryType", void 0);
	
	    _defineProperty(this, "_mutationType", void 0);
	
	    _defineProperty(this, "_subscriptionType", void 0);
	
	    _defineProperty(this, "_directives", void 0);
	
	    _defineProperty(this, "_typeMap", void 0);
	
	    _defineProperty(this, "_implementations", void 0);
	
	    _defineProperty(this, "_possibleTypeMap", void 0);
	
	    _defineProperty(this, "__validationErrors", void 0);
	
	    _defineProperty(this, "__allowedLegacyNames", void 0);
	
	    // If this schema was built from a source known to be valid, then it may be
	    // marked with assumeValid to avoid an additional type system validation.
	    if (config && config.assumeValid) {
	      this.__validationErrors = [];
	    } else {
	      // Otherwise check for common mistakes during construction to produce
	      // clear and early error messages.
	      !(_typeof(config) === 'object') ? (0, _invariant.default)(0, 'Must provide configuration object.') : void 0;
	      !(!config.types || Array.isArray(config.types)) ? (0, _invariant.default)(0, "\"types\" must be Array if provided but got: ".concat((0, _inspect.default)(config.types), ".")) : void 0;
	      !(!config.directives || Array.isArray(config.directives)) ? (0, _invariant.default)(0, '"directives" must be Array if provided but got: ' + "".concat((0, _inspect.default)(config.directives), ".")) : void 0;
	      !(!config.allowedLegacyNames || Array.isArray(config.allowedLegacyNames)) ? (0, _invariant.default)(0, '"allowedLegacyNames" must be Array if provided but got: ' + "".concat((0, _inspect.default)(config.allowedLegacyNames), ".")) : void 0;
	    }
	
	    this.__allowedLegacyNames = config.allowedLegacyNames || [];
	    this._queryType = config.query;
	    this._mutationType = config.mutation;
	    this._subscriptionType = config.subscription; // Provide specified directives (e.g. @include and @skip) by default.
	
	    this._directives = config.directives || _directives.specifiedDirectives;
	    this.astNode = config.astNode;
	    this.extensionASTNodes = config.extensionASTNodes; // Build type map now to detect any errors within this schema.
	
	    var initialTypes = [this.getQueryType(), this.getMutationType(), this.getSubscriptionType(), _introspection.__Schema];
	    var types = config.types;
	
	    if (types) {
	      initialTypes = initialTypes.concat(types);
	    } // Keep track of all types referenced within the schema.
	
	
	    var typeMap = Object.create(null); // First by deeply visiting all initial types.
	
	    typeMap = initialTypes.reduce(typeMapReducer, typeMap); // Then by deeply visiting all directive types.
	
	    typeMap = this._directives.reduce(typeMapDirectiveReducer, typeMap); // Storing the resulting map for reference by the schema.
	
	    this._typeMap = typeMap; // Keep track of all implementations by interface name.
	
	    this._implementations = Object.create(null);
	
	    var _arr = Object.keys(this._typeMap);
	
	    for (var _i = 0; _i < _arr.length; _i++) {
	      var typeName = _arr[_i];
	      var type = this._typeMap[typeName];
	
	      if ((0, _definition.isObjectType)(type)) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = type.getInterfaces()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var iface = _step.value;
	
	            if ((0, _definition.isInterfaceType)(iface)) {
	              var impls = this._implementations[iface.name];
	
	              if (impls) {
	                impls.push(type);
	              } else {
	                this._implementations[iface.name] = [type];
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return != null) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      } else if ((0, _definition.isAbstractType)(type) && !this._implementations[type.name]) {
	        this._implementations[type.name] = [];
	      }
	    }
	  }
	
	  var _proto = GraphQLSchema.prototype;
	
	  _proto.getQueryType = function getQueryType() {
	    return this._queryType;
	  };
	
	  _proto.getMutationType = function getMutationType() {
	    return this._mutationType;
	  };
	
	  _proto.getSubscriptionType = function getSubscriptionType() {
	    return this._subscriptionType;
	  };
	
	  _proto.getTypeMap = function getTypeMap() {
	    return this._typeMap;
	  };
	
	  _proto.getType = function getType(name) {
	    return this.getTypeMap()[name];
	  };
	
	  _proto.getPossibleTypes = function getPossibleTypes(abstractType) {
	    if ((0, _definition.isUnionType)(abstractType)) {
	      return abstractType.getTypes();
	    }
	
	    return this._implementations[abstractType.name];
	  };
	
	  _proto.isPossibleType = function isPossibleType(abstractType, possibleType) {
	    var possibleTypeMap = this._possibleTypeMap;
	
	    if (!possibleTypeMap) {
	      this._possibleTypeMap = possibleTypeMap = Object.create(null);
	    }
	
	    if (!possibleTypeMap[abstractType.name]) {
	      var possibleTypes = this.getPossibleTypes(abstractType);
	      possibleTypeMap[abstractType.name] = possibleTypes.reduce(function (map, type) {
	        return map[type.name] = true, map;
	      }, Object.create(null));
	    }
	
	    return Boolean(possibleTypeMap[abstractType.name][possibleType.name]);
	  };
	
	  _proto.getDirectives = function getDirectives() {
	    return this._directives;
	  };
	
	  _proto.getDirective = function getDirective(name) {
	    return (0, _find.default)(this.getDirectives(), function (directive) {
	      return directive.name === name;
	    });
	  };
	
	  return GraphQLSchema;
	}(); // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported
	
	
	exports.GraphQLSchema = GraphQLSchema;
	(0, _defineToStringTag.default)(GraphQLSchema);
	
	function typeMapReducer(map, type) {
	  if (!type) {
	    return map;
	  }
	
	  if ((0, _definition.isWrappingType)(type)) {
	    return typeMapReducer(map, type.ofType);
	  }
	
	  if (map[type.name]) {
	    !(map[type.name] === type) ? (0, _invariant.default)(0, 'Schema must contain unique named types but contains multiple ' + "types named \"".concat(type.name, "\".")) : void 0;
	    return map;
	  }
	
	  map[type.name] = type;
	  var reducedMap = map;
	
	  if ((0, _definition.isUnionType)(type)) {
	    reducedMap = type.getTypes().reduce(typeMapReducer, reducedMap);
	  }
	
	  if ((0, _definition.isObjectType)(type)) {
	    reducedMap = type.getInterfaces().reduce(typeMapReducer, reducedMap);
	  }
	
	  if ((0, _definition.isObjectType)(type) || (0, _definition.isInterfaceType)(type)) {
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = (0, _objectValues.default)(type.getFields())[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var field = _step2.value;
	
	        if (field.args) {
	          var fieldArgTypes = field.args.map(function (arg) {
	            return arg.type;
	          });
	          reducedMap = fieldArgTypes.reduce(typeMapReducer, reducedMap);
	        }
	
	        reducedMap = typeMapReducer(reducedMap, field.type);
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	  }
	
	  if ((0, _definition.isInputObjectType)(type)) {
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	      for (var _iterator3 = (0, _objectValues.default)(type.getFields())[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	        var _field = _step3.value;
	        reducedMap = typeMapReducer(reducedMap, _field.type);
	      }
	    } catch (err) {
	      _didIteratorError3 = true;
	      _iteratorError3 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
	          _iterator3.return();
	        }
	      } finally {
	        if (_didIteratorError3) {
	          throw _iteratorError3;
	        }
	      }
	    }
	  }
	
	  return reducedMap;
	}
	
	function typeMapDirectiveReducer(map, directive) {
	  // Directives are not validated until validateSchema() is called.
	  if (!(0, _directives.isDirective)(directive)) {
	    return map;
	  }
	
	  return directive.args.reduce(function (_map, arg) {
	    return typeMapReducer(_map, arg.type);
	  }, map);
	}

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(155);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inheritsLoose;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 39 */
[598, 13, 368, 413, 390, 380, 7, 163, 164, 377, 374, 378, 375, 376, 407, 387],
/* 40 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	/**
	 * Returns the owner document of a given element.
	 * 
	 * @param node the element
	 */
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parse = parse;
	exports.parseValue = parseValue;
	exports.parseType = parseType;
	exports.parseConstValue = parseConstValue;
	exports.parseTypeReference = parseTypeReference;
	exports.parseNamedType = parseNamedType;
	
	var _inspect = _interopRequireDefault(__webpack_require__(16));
	
	var _source = __webpack_require__(189);
	
	var _error = __webpack_require__(101);
	
	var _lexer = __webpack_require__(108);
	
	var _kinds = __webpack_require__(11);
	
	var _directiveLocation = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Given a GraphQL source, parses it into a Document.
	 * Throws GraphQLError if a syntax error is encountered.
	 */
	function parse(source, options) {
	  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
	
	  if (!(sourceObj instanceof _source.Source)) {
	    throw new TypeError("Must provide Source. Received: ".concat((0, _inspect.default)(sourceObj)));
	  }
	
	  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
	  return parseDocument(lexer);
	}
	/**
	 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
	 * that value.
	 * Throws GraphQLError if a syntax error is encountered.
	 *
	 * This is useful within tools that operate upon GraphQL Values directly and
	 * in isolation of complete GraphQL documents.
	 *
	 * Consider providing the results to the utility function: valueFromAST().
	 */
	
	
	function parseValue(source, options) {
	  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
	  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
	  expect(lexer, _lexer.TokenKind.SOF);
	  var value = parseValueLiteral(lexer, false);
	  expect(lexer, _lexer.TokenKind.EOF);
	  return value;
	}
	/**
	 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
	 * that type.
	 * Throws GraphQLError if a syntax error is encountered.
	 *
	 * This is useful within tools that operate upon GraphQL Types directly and
	 * in isolation of complete GraphQL documents.
	 *
	 * Consider providing the results to the utility function: typeFromAST().
	 */
	
	
	function parseType(source, options) {
	  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
	  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
	  expect(lexer, _lexer.TokenKind.SOF);
	  var type = parseTypeReference(lexer);
	  expect(lexer, _lexer.TokenKind.EOF);
	  return type;
	}
	/**
	 * Converts a name lex token into a name parse node.
	 */
	
	
	function parseName(lexer) {
	  var token = expect(lexer, _lexer.TokenKind.NAME);
	  return {
	    kind: _kinds.Kind.NAME,
	    value: token.value,
	    loc: loc(lexer, token)
	  };
	} // Implements the parsing rules in the Document section.
	
	/**
	 * Document : Definition+
	 */
	
	
	function parseDocument(lexer) {
	  var start = lexer.token;
	  return {
	    kind: _kinds.Kind.DOCUMENT,
	    definitions: many(lexer, _lexer.TokenKind.SOF, parseDefinition, _lexer.TokenKind.EOF),
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * Definition :
	 *   - ExecutableDefinition
	 *   - TypeSystemDefinition
	 *   - TypeSystemExtension
	 */
	
	
	function parseDefinition(lexer) {
	  if (peek(lexer, _lexer.TokenKind.NAME)) {
	    switch (lexer.token.value) {
	      case 'query':
	      case 'mutation':
	      case 'subscription':
	      case 'fragment':
	        return parseExecutableDefinition(lexer);
	
	      case 'schema':
	      case 'scalar':
	      case 'type':
	      case 'interface':
	      case 'union':
	      case 'enum':
	      case 'input':
	      case 'directive':
	        return parseTypeSystemDefinition(lexer);
	
	      case 'extend':
	        return parseTypeSystemExtension(lexer);
	    }
	  } else if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
	    return parseExecutableDefinition(lexer);
	  } else if (peekDescription(lexer)) {
	    return parseTypeSystemDefinition(lexer);
	  }
	
	  throw unexpected(lexer);
	}
	/**
	 * ExecutableDefinition :
	 *   - OperationDefinition
	 *   - FragmentDefinition
	 */
	
	
	function parseExecutableDefinition(lexer) {
	  if (peek(lexer, _lexer.TokenKind.NAME)) {
	    switch (lexer.token.value) {
	      case 'query':
	      case 'mutation':
	      case 'subscription':
	        return parseOperationDefinition(lexer);
	
	      case 'fragment':
	        return parseFragmentDefinition(lexer);
	    }
	  } else if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
	    return parseOperationDefinition(lexer);
	  }
	
	  throw unexpected(lexer);
	} // Implements the parsing rules in the Operations section.
	
	/**
	 * OperationDefinition :
	 *  - SelectionSet
	 *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
	 */
	
	
	function parseOperationDefinition(lexer) {
	  var start = lexer.token;
	
	  if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
	    return {
	      kind: _kinds.Kind.OPERATION_DEFINITION,
	      operation: 'query',
	      name: undefined,
	      variableDefinitions: [],
	      directives: [],
	      selectionSet: parseSelectionSet(lexer),
	      loc: loc(lexer, start)
	    };
	  }
	
	  var operation = parseOperationType(lexer);
	  var name;
	
	  if (peek(lexer, _lexer.TokenKind.NAME)) {
	    name = parseName(lexer);
	  }
	
	  return {
	    kind: _kinds.Kind.OPERATION_DEFINITION,
	    operation: operation,
	    name: name,
	    variableDefinitions: parseVariableDefinitions(lexer),
	    directives: parseDirectives(lexer, false),
	    selectionSet: parseSelectionSet(lexer),
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * OperationType : one of query mutation subscription
	 */
	
	
	function parseOperationType(lexer) {
	  var operationToken = expect(lexer, _lexer.TokenKind.NAME);
	
	  switch (operationToken.value) {
	    case 'query':
	      return 'query';
	
	    case 'mutation':
	      return 'mutation';
	
	    case 'subscription':
	      return 'subscription';
	  }
	
	  throw unexpected(lexer, operationToken);
	}
	/**
	 * VariableDefinitions : ( VariableDefinition+ )
	 */
	
	
	function parseVariableDefinitions(lexer) {
	  return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, parseVariableDefinition, _lexer.TokenKind.PAREN_R) : [];
	}
	/**
	 * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
	 */
	
	
	function parseVariableDefinition(lexer) {
	  var start = lexer.token;
	
	  if (lexer.options.experimentalVariableDefinitionDirectives) {
	    return {
	      kind: _kinds.Kind.VARIABLE_DEFINITION,
	      variable: parseVariable(lexer),
	      type: (expect(lexer, _lexer.TokenKind.COLON), parseTypeReference(lexer)),
	      defaultValue: skip(lexer, _lexer.TokenKind.EQUALS) ? parseValueLiteral(lexer, true) : undefined,
	      directives: parseDirectives(lexer, true),
	      loc: loc(lexer, start)
	    };
	  }
	
	  return {
	    kind: _kinds.Kind.VARIABLE_DEFINITION,
	    variable: parseVariable(lexer),
	    type: (expect(lexer, _lexer.TokenKind.COLON), parseTypeReference(lexer)),
	    defaultValue: skip(lexer, _lexer.TokenKind.EQUALS) ? parseValueLiteral(lexer, true) : undefined,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * Variable : $ Name
	 */
	
	
	function parseVariable(lexer) {
	  var start = lexer.token;
	  expect(lexer, _lexer.TokenKind.DOLLAR);
	  return {
	    kind: _kinds.Kind.VARIABLE,
	    name: parseName(lexer),
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * SelectionSet : { Selection+ }
	 */
	
	
	function parseSelectionSet(lexer) {
	  var start = lexer.token;
	  return {
	    kind: _kinds.Kind.SELECTION_SET,
	    selections: many(lexer, _lexer.TokenKind.BRACE_L, parseSelection, _lexer.TokenKind.BRACE_R),
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * Selection :
	 *   - Field
	 *   - FragmentSpread
	 *   - InlineFragment
	 */
	
	
	function parseSelection(lexer) {
	  return peek(lexer, _lexer.TokenKind.SPREAD) ? parseFragment(lexer) : parseField(lexer);
	}
	/**
	 * Field : Alias? Name Arguments? Directives? SelectionSet?
	 *
	 * Alias : Name :
	 */
	
	
	function parseField(lexer) {
	  var start = lexer.token;
	  var nameOrAlias = parseName(lexer);
	  var alias;
	  var name;
	
	  if (skip(lexer, _lexer.TokenKind.COLON)) {
	    alias = nameOrAlias;
	    name = parseName(lexer);
	  } else {
	    name = nameOrAlias;
	  }
	
	  return {
	    kind: _kinds.Kind.FIELD,
	    alias: alias,
	    name: name,
	    arguments: parseArguments(lexer, false),
	    directives: parseDirectives(lexer, false),
	    selectionSet: peek(lexer, _lexer.TokenKind.BRACE_L) ? parseSelectionSet(lexer) : undefined,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * Arguments[Const] : ( Argument[?Const]+ )
	 */
	
	
	function parseArguments(lexer, isConst) {
	  var item = isConst ? parseConstArgument : parseArgument;
	  return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, item, _lexer.TokenKind.PAREN_R) : [];
	}
	/**
	 * Argument[Const] : Name : Value[?Const]
	 */
	
	
	function parseArgument(lexer) {
	  var start = lexer.token;
	  return {
	    kind: _kinds.Kind.ARGUMENT,
	    name: parseName(lexer),
	    value: (expect(lexer, _lexer.TokenKind.COLON), parseValueLiteral(lexer, false)),
	    loc: loc(lexer, start)
	  };
	}
	
	function parseConstArgument(lexer) {
	  var start = lexer.token;
	  return {
	    kind: _kinds.Kind.ARGUMENT,
	    name: parseName(lexer),
	    value: (expect(lexer, _lexer.TokenKind.COLON), parseConstValue(lexer)),
	    loc: loc(lexer, start)
	  };
	} // Implements the parsing rules in the Fragments section.
	
	/**
	 * Corresponds to both FragmentSpread and InlineFragment in the spec.
	 *
	 * FragmentSpread : ... FragmentName Directives?
	 *
	 * InlineFragment : ... TypeCondition? Directives? SelectionSet
	 */
	
	
	function parseFragment(lexer) {
	  var start = lexer.token;
	  expect(lexer, _lexer.TokenKind.SPREAD);
	
	  if (peek(lexer, _lexer.TokenKind.NAME) && lexer.token.value !== 'on') {
	    return {
	      kind: _kinds.Kind.FRAGMENT_SPREAD,
	      name: parseFragmentName(lexer),
	      directives: parseDirectives(lexer, false),
	      loc: loc(lexer, start)
	    };
	  }
	
	  var typeCondition;
	
	  if (lexer.token.value === 'on') {
	    lexer.advance();
	    typeCondition = parseNamedType(lexer);
	  }
	
	  return {
	    kind: _kinds.Kind.INLINE_FRAGMENT,
	    typeCondition: typeCondition,
	    directives: parseDirectives(lexer, false),
	    selectionSet: parseSelectionSet(lexer),
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * FragmentDefinition :
	 *   - fragment FragmentName on TypeCondition Directives? SelectionSet
	 *
	 * TypeCondition : NamedType
	 */
	
	
	function parseFragmentDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'fragment'); // Experimental support for defining variables within fragments changes
	  // the grammar of FragmentDefinition:
	  //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
	
	  if (lexer.options.experimentalFragmentVariables) {
	    return {
	      kind: _kinds.Kind.FRAGMENT_DEFINITION,
	      name: parseFragmentName(lexer),
	      variableDefinitions: parseVariableDefinitions(lexer),
	      typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
	      directives: parseDirectives(lexer, false),
	      selectionSet: parseSelectionSet(lexer),
	      loc: loc(lexer, start)
	    };
	  }
	
	  return {
	    kind: _kinds.Kind.FRAGMENT_DEFINITION,
	    name: parseFragmentName(lexer),
	    typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
	    directives: parseDirectives(lexer, false),
	    selectionSet: parseSelectionSet(lexer),
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * FragmentName : Name but not `on`
	 */
	
	
	function parseFragmentName(lexer) {
	  if (lexer.token.value === 'on') {
	    throw unexpected(lexer);
	  }
	
	  return parseName(lexer);
	} // Implements the parsing rules in the Values section.
	
	/**
	 * Value[Const] :
	 *   - [~Const] Variable
	 *   - IntValue
	 *   - FloatValue
	 *   - StringValue
	 *   - BooleanValue
	 *   - NullValue
	 *   - EnumValue
	 *   - ListValue[?Const]
	 *   - ObjectValue[?Const]
	 *
	 * BooleanValue : one of `true` `false`
	 *
	 * NullValue : `null`
	 *
	 * EnumValue : Name but not `true`, `false` or `null`
	 */
	
	
	function parseValueLiteral(lexer, isConst) {
	  var token = lexer.token;
	
	  switch (token.kind) {
	    case _lexer.TokenKind.BRACKET_L:
	      return parseList(lexer, isConst);
	
	    case _lexer.TokenKind.BRACE_L:
	      return parseObject(lexer, isConst);
	
	    case _lexer.TokenKind.INT:
	      lexer.advance();
	      return {
	        kind: _kinds.Kind.INT,
	        value: token.value,
	        loc: loc(lexer, token)
	      };
	
	    case _lexer.TokenKind.FLOAT:
	      lexer.advance();
	      return {
	        kind: _kinds.Kind.FLOAT,
	        value: token.value,
	        loc: loc(lexer, token)
	      };
	
	    case _lexer.TokenKind.STRING:
	    case _lexer.TokenKind.BLOCK_STRING:
	      return parseStringLiteral(lexer);
	
	    case _lexer.TokenKind.NAME:
	      if (token.value === 'true' || token.value === 'false') {
	        lexer.advance();
	        return {
	          kind: _kinds.Kind.BOOLEAN,
	          value: token.value === 'true',
	          loc: loc(lexer, token)
	        };
	      } else if (token.value === 'null') {
	        lexer.advance();
	        return {
	          kind: _kinds.Kind.NULL,
	          loc: loc(lexer, token)
	        };
	      }
	
	      lexer.advance();
	      return {
	        kind: _kinds.Kind.ENUM,
	        value: token.value,
	        loc: loc(lexer, token)
	      };
	
	    case _lexer.TokenKind.DOLLAR:
	      if (!isConst) {
	        return parseVariable(lexer);
	      }
	
	      break;
	  }
	
	  throw unexpected(lexer);
	}
	
	function parseStringLiteral(lexer) {
	  var token = lexer.token;
	  lexer.advance();
	  return {
	    kind: _kinds.Kind.STRING,
	    value: token.value,
	    block: token.kind === _lexer.TokenKind.BLOCK_STRING,
	    loc: loc(lexer, token)
	  };
	}
	
	function parseConstValue(lexer) {
	  return parseValueLiteral(lexer, true);
	}
	
	function parseValueValue(lexer) {
	  return parseValueLiteral(lexer, false);
	}
	/**
	 * ListValue[Const] :
	 *   - [ ]
	 *   - [ Value[?Const]+ ]
	 */
	
	
	function parseList(lexer, isConst) {
	  var start = lexer.token;
	  var item = isConst ? parseConstValue : parseValueValue;
	  return {
	    kind: _kinds.Kind.LIST,
	    values: any(lexer, _lexer.TokenKind.BRACKET_L, item, _lexer.TokenKind.BRACKET_R),
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * ObjectValue[Const] :
	 *   - { }
	 *   - { ObjectField[?Const]+ }
	 */
	
	
	function parseObject(lexer, isConst) {
	  var start = lexer.token;
	  expect(lexer, _lexer.TokenKind.BRACE_L);
	  var fields = [];
	
	  while (!skip(lexer, _lexer.TokenKind.BRACE_R)) {
	    fields.push(parseObjectField(lexer, isConst));
	  }
	
	  return {
	    kind: _kinds.Kind.OBJECT,
	    fields: fields,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * ObjectField[Const] : Name : Value[?Const]
	 */
	
	
	function parseObjectField(lexer, isConst) {
	  var start = lexer.token;
	  return {
	    kind: _kinds.Kind.OBJECT_FIELD,
	    name: parseName(lexer),
	    value: (expect(lexer, _lexer.TokenKind.COLON), parseValueLiteral(lexer, isConst)),
	    loc: loc(lexer, start)
	  };
	} // Implements the parsing rules in the Directives section.
	
	/**
	 * Directives[Const] : Directive[?Const]+
	 */
	
	
	function parseDirectives(lexer, isConst) {
	  var directives = [];
	
	  while (peek(lexer, _lexer.TokenKind.AT)) {
	    directives.push(parseDirective(lexer, isConst));
	  }
	
	  return directives;
	}
	/**
	 * Directive[Const] : @ Name Arguments[?Const]?
	 */
	
	
	function parseDirective(lexer, isConst) {
	  var start = lexer.token;
	  expect(lexer, _lexer.TokenKind.AT);
	  return {
	    kind: _kinds.Kind.DIRECTIVE,
	    name: parseName(lexer),
	    arguments: parseArguments(lexer, isConst),
	    loc: loc(lexer, start)
	  };
	} // Implements the parsing rules in the Types section.
	
	/**
	 * Type :
	 *   - NamedType
	 *   - ListType
	 *   - NonNullType
	 */
	
	
	function parseTypeReference(lexer) {
	  var start = lexer.token;
	  var type;
	
	  if (skip(lexer, _lexer.TokenKind.BRACKET_L)) {
	    type = parseTypeReference(lexer);
	    expect(lexer, _lexer.TokenKind.BRACKET_R);
	    type = {
	      kind: _kinds.Kind.LIST_TYPE,
	      type: type,
	      loc: loc(lexer, start)
	    };
	  } else {
	    type = parseNamedType(lexer);
	  }
	
	  if (skip(lexer, _lexer.TokenKind.BANG)) {
	    return {
	      kind: _kinds.Kind.NON_NULL_TYPE,
	      type: type,
	      loc: loc(lexer, start)
	    };
	  }
	
	  return type;
	}
	/**
	 * NamedType : Name
	 */
	
	
	function parseNamedType(lexer) {
	  var start = lexer.token;
	  return {
	    kind: _kinds.Kind.NAMED_TYPE,
	    name: parseName(lexer),
	    loc: loc(lexer, start)
	  };
	} // Implements the parsing rules in the Type Definition section.
	
	/**
	 * TypeSystemDefinition :
	 *   - SchemaDefinition
	 *   - TypeDefinition
	 *   - DirectiveDefinition
	 *
	 * TypeDefinition :
	 *   - ScalarTypeDefinition
	 *   - ObjectTypeDefinition
	 *   - InterfaceTypeDefinition
	 *   - UnionTypeDefinition
	 *   - EnumTypeDefinition
	 *   - InputObjectTypeDefinition
	 */
	
	
	function parseTypeSystemDefinition(lexer) {
	  // Many definitions begin with a description and require a lookahead.
	  var keywordToken = peekDescription(lexer) ? lexer.lookahead() : lexer.token;
	
	  if (keywordToken.kind === _lexer.TokenKind.NAME) {
	    switch (keywordToken.value) {
	      case 'schema':
	        return parseSchemaDefinition(lexer);
	
	      case 'scalar':
	        return parseScalarTypeDefinition(lexer);
	
	      case 'type':
	        return parseObjectTypeDefinition(lexer);
	
	      case 'interface':
	        return parseInterfaceTypeDefinition(lexer);
	
	      case 'union':
	        return parseUnionTypeDefinition(lexer);
	
	      case 'enum':
	        return parseEnumTypeDefinition(lexer);
	
	      case 'input':
	        return parseInputObjectTypeDefinition(lexer);
	
	      case 'directive':
	        return parseDirectiveDefinition(lexer);
	    }
	  }
	
	  throw unexpected(lexer, keywordToken);
	}
	
	function peekDescription(lexer) {
	  return peek(lexer, _lexer.TokenKind.STRING) || peek(lexer, _lexer.TokenKind.BLOCK_STRING);
	}
	/**
	 * Description : StringValue
	 */
	
	
	function parseDescription(lexer) {
	  if (peekDescription(lexer)) {
	    return parseStringLiteral(lexer);
	  }
	}
	/**
	 * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
	 */
	
	
	function parseSchemaDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'schema');
	  var directives = parseDirectives(lexer, true);
	  var operationTypes = many(lexer, _lexer.TokenKind.BRACE_L, parseOperationTypeDefinition, _lexer.TokenKind.BRACE_R);
	  return {
	    kind: _kinds.Kind.SCHEMA_DEFINITION,
	    directives: directives,
	    operationTypes: operationTypes,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * OperationTypeDefinition : OperationType : NamedType
	 */
	
	
	function parseOperationTypeDefinition(lexer) {
	  var start = lexer.token;
	  var operation = parseOperationType(lexer);
	  expect(lexer, _lexer.TokenKind.COLON);
	  var type = parseNamedType(lexer);
	  return {
	    kind: _kinds.Kind.OPERATION_TYPE_DEFINITION,
	    operation: operation,
	    type: type,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
	 */
	
	
	function parseScalarTypeDefinition(lexer) {
	  var start = lexer.token;
	  var description = parseDescription(lexer);
	  expectKeyword(lexer, 'scalar');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer, true);
	  return {
	    kind: _kinds.Kind.SCALAR_TYPE_DEFINITION,
	    description: description,
	    name: name,
	    directives: directives,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * ObjectTypeDefinition :
	 *   Description?
	 *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
	 */
	
	
	function parseObjectTypeDefinition(lexer) {
	  var start = lexer.token;
	  var description = parseDescription(lexer);
	  expectKeyword(lexer, 'type');
	  var name = parseName(lexer);
	  var interfaces = parseImplementsInterfaces(lexer);
	  var directives = parseDirectives(lexer, true);
	  var fields = parseFieldsDefinition(lexer);
	  return {
	    kind: _kinds.Kind.OBJECT_TYPE_DEFINITION,
	    description: description,
	    name: name,
	    interfaces: interfaces,
	    directives: directives,
	    fields: fields,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * ImplementsInterfaces :
	 *   - implements `&`? NamedType
	 *   - ImplementsInterfaces & NamedType
	 */
	
	
	function parseImplementsInterfaces(lexer) {
	  var types = [];
	
	  if (lexer.token.value === 'implements') {
	    lexer.advance(); // Optional leading ampersand
	
	    skip(lexer, _lexer.TokenKind.AMP);
	
	    do {
	      types.push(parseNamedType(lexer));
	    } while (skip(lexer, _lexer.TokenKind.AMP) || // Legacy support for the SDL?
	    lexer.options.allowLegacySDLImplementsInterfaces && peek(lexer, _lexer.TokenKind.NAME));
	  }
	
	  return types;
	}
	/**
	 * FieldsDefinition : { FieldDefinition+ }
	 */
	
	
	function parseFieldsDefinition(lexer) {
	  // Legacy support for the SDL?
	  if (lexer.options.allowLegacySDLEmptyFields && peek(lexer, _lexer.TokenKind.BRACE_L) && lexer.lookahead().kind === _lexer.TokenKind.BRACE_R) {
	    lexer.advance();
	    lexer.advance();
	    return [];
	  }
	
	  return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseFieldDefinition, _lexer.TokenKind.BRACE_R) : [];
	}
	/**
	 * FieldDefinition :
	 *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
	 */
	
	
	function parseFieldDefinition(lexer) {
	  var start = lexer.token;
	  var description = parseDescription(lexer);
	  var name = parseName(lexer);
	  var args = parseArgumentDefs(lexer);
	  expect(lexer, _lexer.TokenKind.COLON);
	  var type = parseTypeReference(lexer);
	  var directives = parseDirectives(lexer, true);
	  return {
	    kind: _kinds.Kind.FIELD_DEFINITION,
	    description: description,
	    name: name,
	    arguments: args,
	    type: type,
	    directives: directives,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * ArgumentsDefinition : ( InputValueDefinition+ )
	 */
	
	
	function parseArgumentDefs(lexer) {
	  if (!peek(lexer, _lexer.TokenKind.PAREN_L)) {
	    return [];
	  }
	
	  return many(lexer, _lexer.TokenKind.PAREN_L, parseInputValueDef, _lexer.TokenKind.PAREN_R);
	}
	/**
	 * InputValueDefinition :
	 *   - Description? Name : Type DefaultValue? Directives[Const]?
	 */
	
	
	function parseInputValueDef(lexer) {
	  var start = lexer.token;
	  var description = parseDescription(lexer);
	  var name = parseName(lexer);
	  expect(lexer, _lexer.TokenKind.COLON);
	  var type = parseTypeReference(lexer);
	  var defaultValue;
	
	  if (skip(lexer, _lexer.TokenKind.EQUALS)) {
	    defaultValue = parseConstValue(lexer);
	  }
	
	  var directives = parseDirectives(lexer, true);
	  return {
	    kind: _kinds.Kind.INPUT_VALUE_DEFINITION,
	    description: description,
	    name: name,
	    type: type,
	    defaultValue: defaultValue,
	    directives: directives,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * InterfaceTypeDefinition :
	 *   - Description? interface Name Directives[Const]? FieldsDefinition?
	 */
	
	
	function parseInterfaceTypeDefinition(lexer) {
	  var start = lexer.token;
	  var description = parseDescription(lexer);
	  expectKeyword(lexer, 'interface');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer, true);
	  var fields = parseFieldsDefinition(lexer);
	  return {
	    kind: _kinds.Kind.INTERFACE_TYPE_DEFINITION,
	    description: description,
	    name: name,
	    directives: directives,
	    fields: fields,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * UnionTypeDefinition :
	 *   - Description? union Name Directives[Const]? UnionMemberTypes?
	 */
	
	
	function parseUnionTypeDefinition(lexer) {
	  var start = lexer.token;
	  var description = parseDescription(lexer);
	  expectKeyword(lexer, 'union');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer, true);
	  var types = parseUnionMemberTypes(lexer);
	  return {
	    kind: _kinds.Kind.UNION_TYPE_DEFINITION,
	    description: description,
	    name: name,
	    directives: directives,
	    types: types,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * UnionMemberTypes :
	 *   - = `|`? NamedType
	 *   - UnionMemberTypes | NamedType
	 */
	
	
	function parseUnionMemberTypes(lexer) {
	  var types = [];
	
	  if (skip(lexer, _lexer.TokenKind.EQUALS)) {
	    // Optional leading pipe
	    skip(lexer, _lexer.TokenKind.PIPE);
	
	    do {
	      types.push(parseNamedType(lexer));
	    } while (skip(lexer, _lexer.TokenKind.PIPE));
	  }
	
	  return types;
	}
	/**
	 * EnumTypeDefinition :
	 *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
	 */
	
	
	function parseEnumTypeDefinition(lexer) {
	  var start = lexer.token;
	  var description = parseDescription(lexer);
	  expectKeyword(lexer, 'enum');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer, true);
	  var values = parseEnumValuesDefinition(lexer);
	  return {
	    kind: _kinds.Kind.ENUM_TYPE_DEFINITION,
	    description: description,
	    name: name,
	    directives: directives,
	    values: values,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * EnumValuesDefinition : { EnumValueDefinition+ }
	 */
	
	
	function parseEnumValuesDefinition(lexer) {
	  return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseEnumValueDefinition, _lexer.TokenKind.BRACE_R) : [];
	}
	/**
	 * EnumValueDefinition : Description? EnumValue Directives[Const]?
	 *
	 * EnumValue : Name
	 */
	
	
	function parseEnumValueDefinition(lexer) {
	  var start = lexer.token;
	  var description = parseDescription(lexer);
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer, true);
	  return {
	    kind: _kinds.Kind.ENUM_VALUE_DEFINITION,
	    description: description,
	    name: name,
	    directives: directives,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * InputObjectTypeDefinition :
	 *   - Description? input Name Directives[Const]? InputFieldsDefinition?
	 */
	
	
	function parseInputObjectTypeDefinition(lexer) {
	  var start = lexer.token;
	  var description = parseDescription(lexer);
	  expectKeyword(lexer, 'input');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer, true);
	  var fields = parseInputFieldsDefinition(lexer);
	  return {
	    kind: _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION,
	    description: description,
	    name: name,
	    directives: directives,
	    fields: fields,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * InputFieldsDefinition : { InputValueDefinition+ }
	 */
	
	
	function parseInputFieldsDefinition(lexer) {
	  return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseInputValueDef, _lexer.TokenKind.BRACE_R) : [];
	}
	/**
	 * TypeSystemExtension :
	 *   - SchemaExtension
	 *   - TypeExtension
	 *
	 * TypeExtension :
	 *   - ScalarTypeExtension
	 *   - ObjectTypeExtension
	 *   - InterfaceTypeExtension
	 *   - UnionTypeExtension
	 *   - EnumTypeExtension
	 *   - InputObjectTypeDefinition
	 */
	
	
	function parseTypeSystemExtension(lexer) {
	  var keywordToken = lexer.lookahead();
	
	  if (keywordToken.kind === _lexer.TokenKind.NAME) {
	    switch (keywordToken.value) {
	      case 'schema':
	        return parseSchemaExtension(lexer);
	
	      case 'scalar':
	        return parseScalarTypeExtension(lexer);
	
	      case 'type':
	        return parseObjectTypeExtension(lexer);
	
	      case 'interface':
	        return parseInterfaceTypeExtension(lexer);
	
	      case 'union':
	        return parseUnionTypeExtension(lexer);
	
	      case 'enum':
	        return parseEnumTypeExtension(lexer);
	
	      case 'input':
	        return parseInputObjectTypeExtension(lexer);
	    }
	  }
	
	  throw unexpected(lexer, keywordToken);
	}
	/**
	 * SchemaExtension :
	 *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
	 *  - extend schema Directives[Const]
	 */
	
	
	function parseSchemaExtension(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'extend');
	  expectKeyword(lexer, 'schema');
	  var directives = parseDirectives(lexer, true);
	  var operationTypes = peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseOperationTypeDefinition, _lexer.TokenKind.BRACE_R) : [];
	
	  if (directives.length === 0 && operationTypes.length === 0) {
	    throw unexpected(lexer);
	  }
	
	  return {
	    kind: _kinds.Kind.SCHEMA_EXTENSION,
	    directives: directives,
	    operationTypes: operationTypes,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * ScalarTypeExtension :
	 *   - extend scalar Name Directives[Const]
	 */
	
	
	function parseScalarTypeExtension(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'extend');
	  expectKeyword(lexer, 'scalar');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer, true);
	
	  if (directives.length === 0) {
	    throw unexpected(lexer);
	  }
	
	  return {
	    kind: _kinds.Kind.SCALAR_TYPE_EXTENSION,
	    name: name,
	    directives: directives,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * ObjectTypeExtension :
	 *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
	 *  - extend type Name ImplementsInterfaces? Directives[Const]
	 *  - extend type Name ImplementsInterfaces
	 */
	
	
	function parseObjectTypeExtension(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'extend');
	  expectKeyword(lexer, 'type');
	  var name = parseName(lexer);
	  var interfaces = parseImplementsInterfaces(lexer);
	  var directives = parseDirectives(lexer, true);
	  var fields = parseFieldsDefinition(lexer);
	
	  if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
	    throw unexpected(lexer);
	  }
	
	  return {
	    kind: _kinds.Kind.OBJECT_TYPE_EXTENSION,
	    name: name,
	    interfaces: interfaces,
	    directives: directives,
	    fields: fields,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * InterfaceTypeExtension :
	 *   - extend interface Name Directives[Const]? FieldsDefinition
	 *   - extend interface Name Directives[Const]
	 */
	
	
	function parseInterfaceTypeExtension(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'extend');
	  expectKeyword(lexer, 'interface');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer, true);
	  var fields = parseFieldsDefinition(lexer);
	
	  if (directives.length === 0 && fields.length === 0) {
	    throw unexpected(lexer);
	  }
	
	  return {
	    kind: _kinds.Kind.INTERFACE_TYPE_EXTENSION,
	    name: name,
	    directives: directives,
	    fields: fields,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * UnionTypeExtension :
	 *   - extend union Name Directives[Const]? UnionMemberTypes
	 *   - extend union Name Directives[Const]
	 */
	
	
	function parseUnionTypeExtension(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'extend');
	  expectKeyword(lexer, 'union');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer, true);
	  var types = parseUnionMemberTypes(lexer);
	
	  if (directives.length === 0 && types.length === 0) {
	    throw unexpected(lexer);
	  }
	
	  return {
	    kind: _kinds.Kind.UNION_TYPE_EXTENSION,
	    name: name,
	    directives: directives,
	    types: types,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * EnumTypeExtension :
	 *   - extend enum Name Directives[Const]? EnumValuesDefinition
	 *   - extend enum Name Directives[Const]
	 */
	
	
	function parseEnumTypeExtension(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'extend');
	  expectKeyword(lexer, 'enum');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer, true);
	  var values = parseEnumValuesDefinition(lexer);
	
	  if (directives.length === 0 && values.length === 0) {
	    throw unexpected(lexer);
	  }
	
	  return {
	    kind: _kinds.Kind.ENUM_TYPE_EXTENSION,
	    name: name,
	    directives: directives,
	    values: values,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * InputObjectTypeExtension :
	 *   - extend input Name Directives[Const]? InputFieldsDefinition
	 *   - extend input Name Directives[Const]
	 */
	
	
	function parseInputObjectTypeExtension(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'extend');
	  expectKeyword(lexer, 'input');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer, true);
	  var fields = parseInputFieldsDefinition(lexer);
	
	  if (directives.length === 0 && fields.length === 0) {
	    throw unexpected(lexer);
	  }
	
	  return {
	    kind: _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION,
	    name: name,
	    directives: directives,
	    fields: fields,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * DirectiveDefinition :
	 *   - Description? directive @ Name ArgumentsDefinition? on DirectiveLocations
	 */
	
	
	function parseDirectiveDefinition(lexer) {
	  var start = lexer.token;
	  var description = parseDescription(lexer);
	  expectKeyword(lexer, 'directive');
	  expect(lexer, _lexer.TokenKind.AT);
	  var name = parseName(lexer);
	  var args = parseArgumentDefs(lexer);
	  expectKeyword(lexer, 'on');
	  var locations = parseDirectiveLocations(lexer);
	  return {
	    kind: _kinds.Kind.DIRECTIVE_DEFINITION,
	    description: description,
	    name: name,
	    arguments: args,
	    locations: locations,
	    loc: loc(lexer, start)
	  };
	}
	/**
	 * DirectiveLocations :
	 *   - `|`? DirectiveLocation
	 *   - DirectiveLocations | DirectiveLocation
	 */
	
	
	function parseDirectiveLocations(lexer) {
	  // Optional leading pipe
	  skip(lexer, _lexer.TokenKind.PIPE);
	  var locations = [];
	
	  do {
	    locations.push(parseDirectiveLocation(lexer));
	  } while (skip(lexer, _lexer.TokenKind.PIPE));
	
	  return locations;
	}
	/*
	 * DirectiveLocation :
	 *   - ExecutableDirectiveLocation
	 *   - TypeSystemDirectiveLocation
	 *
	 * ExecutableDirectiveLocation : one of
	 *   `QUERY`
	 *   `MUTATION`
	 *   `SUBSCRIPTION`
	 *   `FIELD`
	 *   `FRAGMENT_DEFINITION`
	 *   `FRAGMENT_SPREAD`
	 *   `INLINE_FRAGMENT`
	 *
	 * TypeSystemDirectiveLocation : one of
	 *   `SCHEMA`
	 *   `SCALAR`
	 *   `OBJECT`
	 *   `FIELD_DEFINITION`
	 *   `ARGUMENT_DEFINITION`
	 *   `INTERFACE`
	 *   `UNION`
	 *   `ENUM`
	 *   `ENUM_VALUE`
	 *   `INPUT_OBJECT`
	 *   `INPUT_FIELD_DEFINITION`
	 */
	
	
	function parseDirectiveLocation(lexer) {
	  var start = lexer.token;
	  var name = parseName(lexer);
	
	  if (_directiveLocation.DirectiveLocation.hasOwnProperty(name.value)) {
	    return name;
	  }
	
	  throw unexpected(lexer, start);
	} // Core parsing utility functions
	
	/**
	 * Returns a location object, used to identify the place in
	 * the source that created a given parsed object.
	 */
	
	
	function loc(lexer, startToken) {
	  if (!lexer.options.noLocation) {
	    return new Loc(startToken, lexer.lastToken, lexer.source);
	  }
	}
	
	function Loc(startToken, endToken, source) {
	  this.start = startToken.start;
	  this.end = endToken.end;
	  this.startToken = startToken;
	  this.endToken = endToken;
	  this.source = source;
	} // Print a simplified form when appearing in JSON/util.inspect.
	
	
	Loc.prototype.toJSON = Loc.prototype.inspect = function toJSON() {
	  return {
	    start: this.start,
	    end: this.end
	  };
	};
	/**
	 * Determines if the next token is of a given kind
	 */
	
	
	function peek(lexer, kind) {
	  return lexer.token.kind === kind;
	}
	/**
	 * If the next token is of the given kind, return true after advancing
	 * the lexer. Otherwise, do not change the parser state and return false.
	 */
	
	
	function skip(lexer, kind) {
	  var match = lexer.token.kind === kind;
	
	  if (match) {
	    lexer.advance();
	  }
	
	  return match;
	}
	/**
	 * If the next token is of the given kind, return that token after advancing
	 * the lexer. Otherwise, do not change the parser state and throw an error.
	 */
	
	
	function expect(lexer, kind) {
	  var token = lexer.token;
	
	  if (token.kind === kind) {
	    lexer.advance();
	    return token;
	  }
	
	  throw (0, _error.syntaxError)(lexer.source, token.start, "Expected ".concat(kind, ", found ").concat((0, _lexer.getTokenDesc)(token)));
	}
	/**
	 * If the next token is a keyword with the given value, return that token after
	 * advancing the lexer. Otherwise, do not change the parser state and return
	 * false.
	 */
	
	
	function expectKeyword(lexer, value) {
	  var token = lexer.token;
	
	  if (token.kind === _lexer.TokenKind.NAME && token.value === value) {
	    lexer.advance();
	    return token;
	  }
	
	  throw (0, _error.syntaxError)(lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat((0, _lexer.getTokenDesc)(token)));
	}
	/**
	 * Helper function for creating an error when an unexpected lexed token
	 * is encountered.
	 */
	
	
	function unexpected(lexer, atToken) {
	  var token = atToken || lexer.token;
	  return (0, _error.syntaxError)(lexer.source, token.start, "Unexpected ".concat((0, _lexer.getTokenDesc)(token)));
	}
	/**
	 * Returns a possibly empty list of parse nodes, determined by
	 * the parseFn. This list begins with a lex token of openKind
	 * and ends with a lex token of closeKind. Advances the parser
	 * to the next lex token after the closing token.
	 */
	
	
	function any(lexer, openKind, parseFn, closeKind) {
	  expect(lexer, openKind);
	  var nodes = [];
	
	  while (!skip(lexer, closeKind)) {
	    nodes.push(parseFn(lexer));
	  }
	
	  return nodes;
	}
	/**
	 * Returns a non-empty list of parse nodes, determined by
	 * the parseFn. This list begins with a lex token of openKind
	 * and ends with a lex token of closeKind. Advances the parser
	 * to the next lex token after the closing token.
	 */
	
	
	function many(lexer, openKind, parseFn, closeKind) {
	  expect(lexer, openKind);
	  var nodes = [parseFn(lexer)];
	
	  while (!skip(lexer, closeKind)) {
	    nodes.push(parseFn(lexer));
	  }
	
	  return nodes;
	}

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	(function(exports) {
	  "use strict";
	
	  function isArray(obj) {
	    if (obj !== null) {
	      return Object.prototype.toString.call(obj) === "[object Array]";
	    } else {
	      return false;
	    }
	  }
	
	  function isObject(obj) {
	    if (obj !== null) {
	      return Object.prototype.toString.call(obj) === "[object Object]";
	    } else {
	      return false;
	    }
	  }
	
	  function strictDeepEqual(first, second) {
	    // Check the scalar case first.
	    if (first === second) {
	      return true;
	    }
	
	    // Check if they are the same type.
	    var firstType = Object.prototype.toString.call(first);
	    if (firstType !== Object.prototype.toString.call(second)) {
	      return false;
	    }
	    // We know that first and second have the same type so we can just check the
	    // first type from now on.
	    if (isArray(first) === true) {
	      // Short circuit if they're not the same length;
	      if (first.length !== second.length) {
	        return false;
	      }
	      for (var i = 0; i < first.length; i++) {
	        if (strictDeepEqual(first[i], second[i]) === false) {
	          return false;
	        }
	      }
	      return true;
	    }
	    if (isObject(first) === true) {
	      // An object is equal if it has the same key/value pairs.
	      var keysSeen = {};
	      for (var key in first) {
	        if (hasOwnProperty.call(first, key)) {
	          if (strictDeepEqual(first[key], second[key]) === false) {
	            return false;
	          }
	          keysSeen[key] = true;
	        }
	      }
	      // Now check that there aren't any keys in second that weren't
	      // in first.
	      for (var key2 in second) {
	        if (hasOwnProperty.call(second, key2)) {
	          if (keysSeen[key2] !== true) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	    return false;
	  }
	
	  function isFalse(obj) {
	    // From the spec:
	    // A false value corresponds to the following values:
	    // Empty list
	    // Empty object
	    // Empty string
	    // False boolean
	    // null value
	
	    // First check the scalar values.
	    if (obj === "" || obj === false || obj === null) {
	        return true;
	    } else if (isArray(obj) && obj.length === 0) {
	        // Check for an empty array.
	        return true;
	    } else if (isObject(obj)) {
	        // Check for an empty object.
	        for (var key in obj) {
	            // If there are any keys, then
	            // the object is not empty so the object
	            // is not false.
	            if (obj.hasOwnProperty(key)) {
	              return false;
	            }
	        }
	        return true;
	    } else {
	        return false;
	    }
	  }
	
	  function objValues(obj) {
	    var keys = Object.keys(obj);
	    var values = [];
	    for (var i = 0; i < keys.length; i++) {
	      values.push(obj[keys[i]]);
	    }
	    return values;
	  }
	
	  function merge(a, b) {
	      var merged = {};
	      for (var key in a) {
	          merged[key] = a[key];
	      }
	      for (var key2 in b) {
	          merged[key2] = b[key2];
	      }
	      return merged;
	  }
	
	  var trimLeft;
	  if (typeof String.prototype.trimLeft === "function") {
	    trimLeft = function(str) {
	      return str.trimLeft();
	    };
	  } else {
	    trimLeft = function(str) {
	      return str.match(/^\s*(.*)/)[1];
	    };
	  }
	
	  // Type constants used to define functions.
	  var TYPE_NUMBER = 0;
	  var TYPE_ANY = 1;
	  var TYPE_STRING = 2;
	  var TYPE_ARRAY = 3;
	  var TYPE_OBJECT = 4;
	  var TYPE_BOOLEAN = 5;
	  var TYPE_EXPREF = 6;
	  var TYPE_NULL = 7;
	  var TYPE_ARRAY_NUMBER = 8;
	  var TYPE_ARRAY_STRING = 9;
	
	  var TOK_EOF = "EOF";
	  var TOK_UNQUOTEDIDENTIFIER = "UnquotedIdentifier";
	  var TOK_QUOTEDIDENTIFIER = "QuotedIdentifier";
	  var TOK_RBRACKET = "Rbracket";
	  var TOK_RPAREN = "Rparen";
	  var TOK_COMMA = "Comma";
	  var TOK_COLON = "Colon";
	  var TOK_RBRACE = "Rbrace";
	  var TOK_NUMBER = "Number";
	  var TOK_CURRENT = "Current";
	  var TOK_EXPREF = "Expref";
	  var TOK_PIPE = "Pipe";
	  var TOK_OR = "Or";
	  var TOK_AND = "And";
	  var TOK_EQ = "EQ";
	  var TOK_GT = "GT";
	  var TOK_LT = "LT";
	  var TOK_GTE = "GTE";
	  var TOK_LTE = "LTE";
	  var TOK_NE = "NE";
	  var TOK_FLATTEN = "Flatten";
	  var TOK_STAR = "Star";
	  var TOK_FILTER = "Filter";
	  var TOK_DOT = "Dot";
	  var TOK_NOT = "Not";
	  var TOK_LBRACE = "Lbrace";
	  var TOK_LBRACKET = "Lbracket";
	  var TOK_LPAREN= "Lparen";
	  var TOK_LITERAL= "Literal";
	
	  // The "&", "[", "<", ">" tokens
	  // are not in basicToken because
	  // there are two token variants
	  // ("&&", "[?", "<=", ">=").  This is specially handled
	  // below.
	
	  var basicTokens = {
	    ".": TOK_DOT,
	    "*": TOK_STAR,
	    ",": TOK_COMMA,
	    ":": TOK_COLON,
	    "{": TOK_LBRACE,
	    "}": TOK_RBRACE,
	    "]": TOK_RBRACKET,
	    "(": TOK_LPAREN,
	    ")": TOK_RPAREN,
	    "@": TOK_CURRENT
	  };
	
	  var operatorStartToken = {
	      "<": true,
	      ">": true,
	      "=": true,
	      "!": true
	  };
	
	  var skipChars = {
	      " ": true,
	      "\t": true,
	      "\n": true
	  };
	
	
	  function isAlpha(ch) {
	      return (ch >= "a" && ch <= "z") ||
	             (ch >= "A" && ch <= "Z") ||
	             ch === "_";
	  }
	
	  function isNum(ch) {
	      return (ch >= "0" && ch <= "9") ||
	             ch === "-";
	  }
	  function isAlphaNum(ch) {
	      return (ch >= "a" && ch <= "z") ||
	             (ch >= "A" && ch <= "Z") ||
	             (ch >= "0" && ch <= "9") ||
	             ch === "_";
	  }
	
	  function Lexer() {
	  }
	  Lexer.prototype = {
	      tokenize: function(stream) {
	          var tokens = [];
	          this._current = 0;
	          var start;
	          var identifier;
	          var token;
	          while (this._current < stream.length) {
	              if (isAlpha(stream[this._current])) {
	                  start = this._current;
	                  identifier = this._consumeUnquotedIdentifier(stream);
	                  tokens.push({type: TOK_UNQUOTEDIDENTIFIER,
	                               value: identifier,
	                               start: start});
	              } else if (basicTokens[stream[this._current]] !== undefined) {
	                  tokens.push({type: basicTokens[stream[this._current]],
	                              value: stream[this._current],
	                              start: this._current});
	                  this._current++;
	              } else if (isNum(stream[this._current])) {
	                  token = this._consumeNumber(stream);
	                  tokens.push(token);
	              } else if (stream[this._current] === "[") {
	                  // No need to increment this._current.  This happens
	                  // in _consumeLBracket
	                  token = this._consumeLBracket(stream);
	                  tokens.push(token);
	              } else if (stream[this._current] === "\"") {
	                  start = this._current;
	                  identifier = this._consumeQuotedIdentifier(stream);
	                  tokens.push({type: TOK_QUOTEDIDENTIFIER,
	                               value: identifier,
	                               start: start});
	              } else if (stream[this._current] === "'") {
	                  start = this._current;
	                  identifier = this._consumeRawStringLiteral(stream);
	                  tokens.push({type: TOK_LITERAL,
	                               value: identifier,
	                               start: start});
	              } else if (stream[this._current] === "`") {
	                  start = this._current;
	                  var literal = this._consumeLiteral(stream);
	                  tokens.push({type: TOK_LITERAL,
	                               value: literal,
	                               start: start});
	              } else if (operatorStartToken[stream[this._current]] !== undefined) {
	                  tokens.push(this._consumeOperator(stream));
	              } else if (skipChars[stream[this._current]] !== undefined) {
	                  // Ignore whitespace.
	                  this._current++;
	              } else if (stream[this._current] === "&") {
	                  start = this._current;
	                  this._current++;
	                  if (stream[this._current] === "&") {
	                      this._current++;
	                      tokens.push({type: TOK_AND, value: "&&", start: start});
	                  } else {
	                      tokens.push({type: TOK_EXPREF, value: "&", start: start});
	                  }
	              } else if (stream[this._current] === "|") {
	                  start = this._current;
	                  this._current++;
	                  if (stream[this._current] === "|") {
	                      this._current++;
	                      tokens.push({type: TOK_OR, value: "||", start: start});
	                  } else {
	                      tokens.push({type: TOK_PIPE, value: "|", start: start});
	                  }
	              } else {
	                  var error = new Error("Unknown character:" + stream[this._current]);
	                  error.name = "LexerError";
	                  throw error;
	              }
	          }
	          return tokens;
	      },
	
	      _consumeUnquotedIdentifier: function(stream) {
	          var start = this._current;
	          this._current++;
	          while (this._current < stream.length && isAlphaNum(stream[this._current])) {
	              this._current++;
	          }
	          return stream.slice(start, this._current);
	      },
	
	      _consumeQuotedIdentifier: function(stream) {
	          var start = this._current;
	          this._current++;
	          var maxLength = stream.length;
	          while (stream[this._current] !== "\"" && this._current < maxLength) {
	              // You can escape a double quote and you can escape an escape.
	              var current = this._current;
	              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
	                                               stream[current + 1] === "\"")) {
	                  current += 2;
	              } else {
	                  current++;
	              }
	              this._current = current;
	          }
	          this._current++;
	          return JSON.parse(stream.slice(start, this._current));
	      },
	
	      _consumeRawStringLiteral: function(stream) {
	          var start = this._current;
	          this._current++;
	          var maxLength = stream.length;
	          while (stream[this._current] !== "'" && this._current < maxLength) {
	              // You can escape a single quote and you can escape an escape.
	              var current = this._current;
	              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
	                                               stream[current + 1] === "'")) {
	                  current += 2;
	              } else {
	                  current++;
	              }
	              this._current = current;
	          }
	          this._current++;
	          var literal = stream.slice(start + 1, this._current - 1);
	          return literal.replace("\\'", "'");
	      },
	
	      _consumeNumber: function(stream) {
	          var start = this._current;
	          this._current++;
	          var maxLength = stream.length;
	          while (isNum(stream[this._current]) && this._current < maxLength) {
	              this._current++;
	          }
	          var value = parseInt(stream.slice(start, this._current));
	          return {type: TOK_NUMBER, value: value, start: start};
	      },
	
	      _consumeLBracket: function(stream) {
	          var start = this._current;
	          this._current++;
	          if (stream[this._current] === "?") {
	              this._current++;
	              return {type: TOK_FILTER, value: "[?", start: start};
	          } else if (stream[this._current] === "]") {
	              this._current++;
	              return {type: TOK_FLATTEN, value: "[]", start: start};
	          } else {
	              return {type: TOK_LBRACKET, value: "[", start: start};
	          }
	      },
	
	      _consumeOperator: function(stream) {
	          var start = this._current;
	          var startingChar = stream[start];
	          this._current++;
	          if (startingChar === "!") {
	              if (stream[this._current] === "=") {
	                  this._current++;
	                  return {type: TOK_NE, value: "!=", start: start};
	              } else {
	                return {type: TOK_NOT, value: "!", start: start};
	              }
	          } else if (startingChar === "<") {
	              if (stream[this._current] === "=") {
	                  this._current++;
	                  return {type: TOK_LTE, value: "<=", start: start};
	              } else {
	                  return {type: TOK_LT, value: "<", start: start};
	              }
	          } else if (startingChar === ">") {
	              if (stream[this._current] === "=") {
	                  this._current++;
	                  return {type: TOK_GTE, value: ">=", start: start};
	              } else {
	                  return {type: TOK_GT, value: ">", start: start};
	              }
	          } else if (startingChar === "=") {
	              if (stream[this._current] === "=") {
	                  this._current++;
	                  return {type: TOK_EQ, value: "==", start: start};
	              }
	          }
	      },
	
	      _consumeLiteral: function(stream) {
	          this._current++;
	          var start = this._current;
	          var maxLength = stream.length;
	          var literal;
	          while(stream[this._current] !== "`" && this._current < maxLength) {
	              // You can escape a literal char or you can escape the escape.
	              var current = this._current;
	              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
	                                               stream[current + 1] === "`")) {
	                  current += 2;
	              } else {
	                  current++;
	              }
	              this._current = current;
	          }
	          var literalString = trimLeft(stream.slice(start, this._current));
	          literalString = literalString.replace("\\`", "`");
	          if (this._looksLikeJSON(literalString)) {
	              literal = JSON.parse(literalString);
	          } else {
	              // Try to JSON parse it as "<literal>"
	              literal = JSON.parse("\"" + literalString + "\"");
	          }
	          // +1 gets us to the ending "`", +1 to move on to the next char.
	          this._current++;
	          return literal;
	      },
	
	      _looksLikeJSON: function(literalString) {
	          var startingChars = "[{\"";
	          var jsonLiterals = ["true", "false", "null"];
	          var numberLooking = "-0123456789";
	
	          if (literalString === "") {
	              return false;
	          } else if (startingChars.indexOf(literalString[0]) >= 0) {
	              return true;
	          } else if (jsonLiterals.indexOf(literalString) >= 0) {
	              return true;
	          } else if (numberLooking.indexOf(literalString[0]) >= 0) {
	              try {
	                  JSON.parse(literalString);
	                  return true;
	              } catch (ex) {
	                  return false;
	              }
	          } else {
	              return false;
	          }
	      }
	  };
	
	      var bindingPower = {};
	      bindingPower[TOK_EOF] = 0;
	      bindingPower[TOK_UNQUOTEDIDENTIFIER] = 0;
	      bindingPower[TOK_QUOTEDIDENTIFIER] = 0;
	      bindingPower[TOK_RBRACKET] = 0;
	      bindingPower[TOK_RPAREN] = 0;
	      bindingPower[TOK_COMMA] = 0;
	      bindingPower[TOK_RBRACE] = 0;
	      bindingPower[TOK_NUMBER] = 0;
	      bindingPower[TOK_CURRENT] = 0;
	      bindingPower[TOK_EXPREF] = 0;
	      bindingPower[TOK_PIPE] = 1;
	      bindingPower[TOK_OR] = 2;
	      bindingPower[TOK_AND] = 3;
	      bindingPower[TOK_EQ] = 5;
	      bindingPower[TOK_GT] = 5;
	      bindingPower[TOK_LT] = 5;
	      bindingPower[TOK_GTE] = 5;
	      bindingPower[TOK_LTE] = 5;
	      bindingPower[TOK_NE] = 5;
	      bindingPower[TOK_FLATTEN] = 9;
	      bindingPower[TOK_STAR] = 20;
	      bindingPower[TOK_FILTER] = 21;
	      bindingPower[TOK_DOT] = 40;
	      bindingPower[TOK_NOT] = 45;
	      bindingPower[TOK_LBRACE] = 50;
	      bindingPower[TOK_LBRACKET] = 55;
	      bindingPower[TOK_LPAREN] = 60;
	
	  function Parser() {
	  }
	
	  Parser.prototype = {
	      parse: function(expression) {
	          this._loadTokens(expression);
	          this.index = 0;
	          var ast = this.expression(0);
	          if (this._lookahead(0) !== TOK_EOF) {
	              var t = this._lookaheadToken(0);
	              var error = new Error(
	                  "Unexpected token type: " + t.type + ", value: " + t.value);
	              error.name = "ParserError";
	              throw error;
	          }
	          return ast;
	      },
	
	      _loadTokens: function(expression) {
	          var lexer = new Lexer();
	          var tokens = lexer.tokenize(expression);
	          tokens.push({type: TOK_EOF, value: "", start: expression.length});
	          this.tokens = tokens;
	      },
	
	      expression: function(rbp) {
	          var leftToken = this._lookaheadToken(0);
	          this._advance();
	          var left = this.nud(leftToken);
	          var currentToken = this._lookahead(0);
	          while (rbp < bindingPower[currentToken]) {
	              this._advance();
	              left = this.led(currentToken, left);
	              currentToken = this._lookahead(0);
	          }
	          return left;
	      },
	
	      _lookahead: function(number) {
	          return this.tokens[this.index + number].type;
	      },
	
	      _lookaheadToken: function(number) {
	          return this.tokens[this.index + number];
	      },
	
	      _advance: function() {
	          this.index++;
	      },
	
	      nud: function(token) {
	        var left;
	        var right;
	        var expression;
	        switch (token.type) {
	          case TOK_LITERAL:
	            return {type: "Literal", value: token.value};
	          case TOK_UNQUOTEDIDENTIFIER:
	            return {type: "Field", name: token.value};
	          case TOK_QUOTEDIDENTIFIER:
	            var node = {type: "Field", name: token.value};
	            if (this._lookahead(0) === TOK_LPAREN) {
	                throw new Error("Quoted identifier not allowed for function names.");
	            } else {
	                return node;
	            }
	            break;
	          case TOK_NOT:
	            right = this.expression(bindingPower.Not);
	            return {type: "NotExpression", children: [right]};
	          case TOK_STAR:
	            left = {type: "Identity"};
	            right = null;
	            if (this._lookahead(0) === TOK_RBRACKET) {
	                // This can happen in a multiselect,
	                // [a, b, *]
	                right = {type: "Identity"};
	            } else {
	                right = this._parseProjectionRHS(bindingPower.Star);
	            }
	            return {type: "ValueProjection", children: [left, right]};
	          case TOK_FILTER:
	            return this.led(token.type, {type: "Identity"});
	          case TOK_LBRACE:
	            return this._parseMultiselectHash();
	          case TOK_FLATTEN:
	            left = {type: TOK_FLATTEN, children: [{type: "Identity"}]};
	            right = this._parseProjectionRHS(bindingPower.Flatten);
	            return {type: "Projection", children: [left, right]};
	          case TOK_LBRACKET:
	            if (this._lookahead(0) === TOK_NUMBER || this._lookahead(0) === TOK_COLON) {
	                right = this._parseIndexExpression();
	                return this._projectIfSlice({type: "Identity"}, right);
	            } else if (this._lookahead(0) === TOK_STAR &&
	                       this._lookahead(1) === TOK_RBRACKET) {
	                this._advance();
	                this._advance();
	                right = this._parseProjectionRHS(bindingPower.Star);
	                return {type: "Projection",
	                        children: [{type: "Identity"}, right]};
	            } else {
	                return this._parseMultiselectList();
	            }
	            break;
	          case TOK_CURRENT:
	            return {type: TOK_CURRENT};
	          case TOK_EXPREF:
	            expression = this.expression(bindingPower.Expref);
	            return {type: "ExpressionReference", children: [expression]};
	          case TOK_LPAREN:
	            var args = [];
	            while (this._lookahead(0) !== TOK_RPAREN) {
	              if (this._lookahead(0) === TOK_CURRENT) {
	                expression = {type: TOK_CURRENT};
	                this._advance();
	              } else {
	                expression = this.expression(0);
	              }
	              args.push(expression);
	            }
	            this._match(TOK_RPAREN);
	            return args[0];
	          default:
	            this._errorToken(token);
	        }
	      },
	
	      led: function(tokenName, left) {
	        var right;
	        switch(tokenName) {
	          case TOK_DOT:
	            var rbp = bindingPower.Dot;
	            if (this._lookahead(0) !== TOK_STAR) {
	                right = this._parseDotRHS(rbp);
	                return {type: "Subexpression", children: [left, right]};
	            } else {
	                // Creating a projection.
	                this._advance();
	                right = this._parseProjectionRHS(rbp);
	                return {type: "ValueProjection", children: [left, right]};
	            }
	            break;
	          case TOK_PIPE:
	            right = this.expression(bindingPower.Pipe);
	            return {type: TOK_PIPE, children: [left, right]};
	          case TOK_OR:
	            right = this.expression(bindingPower.Or);
	            return {type: "OrExpression", children: [left, right]};
	          case TOK_AND:
	            right = this.expression(bindingPower.And);
	            return {type: "AndExpression", children: [left, right]};
	          case TOK_LPAREN:
	            var name = left.name;
	            var args = [];
	            var expression, node;
	            while (this._lookahead(0) !== TOK_RPAREN) {
	              if (this._lookahead(0) === TOK_CURRENT) {
	                expression = {type: TOK_CURRENT};
	                this._advance();
	              } else {
	                expression = this.expression(0);
	              }
	              if (this._lookahead(0) === TOK_COMMA) {
	                this._match(TOK_COMMA);
	              }
	              args.push(expression);
	            }
	            this._match(TOK_RPAREN);
	            node = {type: "Function", name: name, children: args};
	            return node;
	          case TOK_FILTER:
	            var condition = this.expression(0);
	            this._match(TOK_RBRACKET);
	            if (this._lookahead(0) === TOK_FLATTEN) {
	              right = {type: "Identity"};
	            } else {
	              right = this._parseProjectionRHS(bindingPower.Filter);
	            }
	            return {type: "FilterProjection", children: [left, right, condition]};
	          case TOK_FLATTEN:
	            var leftNode = {type: TOK_FLATTEN, children: [left]};
	            var rightNode = this._parseProjectionRHS(bindingPower.Flatten);
	            return {type: "Projection", children: [leftNode, rightNode]};
	          case TOK_EQ:
	          case TOK_NE:
	          case TOK_GT:
	          case TOK_GTE:
	          case TOK_LT:
	          case TOK_LTE:
	            return this._parseComparator(left, tokenName);
	          case TOK_LBRACKET:
	            var token = this._lookaheadToken(0);
	            if (token.type === TOK_NUMBER || token.type === TOK_COLON) {
	                right = this._parseIndexExpression();
	                return this._projectIfSlice(left, right);
	            } else {
	                this._match(TOK_STAR);
	                this._match(TOK_RBRACKET);
	                right = this._parseProjectionRHS(bindingPower.Star);
	                return {type: "Projection", children: [left, right]};
	            }
	            break;
	          default:
	            this._errorToken(this._lookaheadToken(0));
	        }
	      },
	
	      _match: function(tokenType) {
	          if (this._lookahead(0) === tokenType) {
	              this._advance();
	          } else {
	              var t = this._lookaheadToken(0);
	              var error = new Error("Expected " + tokenType + ", got: " + t.type);
	              error.name = "ParserError";
	              throw error;
	          }
	      },
	
	      _errorToken: function(token) {
	          var error = new Error("Invalid token (" +
	                                token.type + "): \"" +
	                                token.value + "\"");
	          error.name = "ParserError";
	          throw error;
	      },
	
	
	      _parseIndexExpression: function() {
	          if (this._lookahead(0) === TOK_COLON || this._lookahead(1) === TOK_COLON) {
	              return this._parseSliceExpression();
	          } else {
	              var node = {
	                  type: "Index",
	                  value: this._lookaheadToken(0).value};
	              this._advance();
	              this._match(TOK_RBRACKET);
	              return node;
	          }
	      },
	
	      _projectIfSlice: function(left, right) {
	          var indexExpr = {type: "IndexExpression", children: [left, right]};
	          if (right.type === "Slice") {
	              return {
	                  type: "Projection",
	                  children: [indexExpr, this._parseProjectionRHS(bindingPower.Star)]
	              };
	          } else {
	              return indexExpr;
	          }
	      },
	
	      _parseSliceExpression: function() {
	          // [start:end:step] where each part is optional, as well as the last
	          // colon.
	          var parts = [null, null, null];
	          var index = 0;
	          var currentToken = this._lookahead(0);
	          while (currentToken !== TOK_RBRACKET && index < 3) {
	              if (currentToken === TOK_COLON) {
	                  index++;
	                  this._advance();
	              } else if (currentToken === TOK_NUMBER) {
	                  parts[index] = this._lookaheadToken(0).value;
	                  this._advance();
	              } else {
	                  var t = this._lookahead(0);
	                  var error = new Error("Syntax error, unexpected token: " +
	                                        t.value + "(" + t.type + ")");
	                  error.name = "Parsererror";
	                  throw error;
	              }
	              currentToken = this._lookahead(0);
	          }
	          this._match(TOK_RBRACKET);
	          return {
	              type: "Slice",
	              children: parts
	          };
	      },
	
	      _parseComparator: function(left, comparator) {
	        var right = this.expression(bindingPower[comparator]);
	        return {type: "Comparator", name: comparator, children: [left, right]};
	      },
	
	      _parseDotRHS: function(rbp) {
	          var lookahead = this._lookahead(0);
	          var exprTokens = [TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER, TOK_STAR];
	          if (exprTokens.indexOf(lookahead) >= 0) {
	              return this.expression(rbp);
	          } else if (lookahead === TOK_LBRACKET) {
	              this._match(TOK_LBRACKET);
	              return this._parseMultiselectList();
	          } else if (lookahead === TOK_LBRACE) {
	              this._match(TOK_LBRACE);
	              return this._parseMultiselectHash();
	          }
	      },
	
	      _parseProjectionRHS: function(rbp) {
	          var right;
	          if (bindingPower[this._lookahead(0)] < 10) {
	              right = {type: "Identity"};
	          } else if (this._lookahead(0) === TOK_LBRACKET) {
	              right = this.expression(rbp);
	          } else if (this._lookahead(0) === TOK_FILTER) {
	              right = this.expression(rbp);
	          } else if (this._lookahead(0) === TOK_DOT) {
	              this._match(TOK_DOT);
	              right = this._parseDotRHS(rbp);
	          } else {
	              var t = this._lookaheadToken(0);
	              var error = new Error("Sytanx error, unexpected token: " +
	                                    t.value + "(" + t.type + ")");
	              error.name = "ParserError";
	              throw error;
	          }
	          return right;
	      },
	
	      _parseMultiselectList: function() {
	          var expressions = [];
	          while (this._lookahead(0) !== TOK_RBRACKET) {
	              var expression = this.expression(0);
	              expressions.push(expression);
	              if (this._lookahead(0) === TOK_COMMA) {
	                  this._match(TOK_COMMA);
	                  if (this._lookahead(0) === TOK_RBRACKET) {
	                    throw new Error("Unexpected token Rbracket");
	                  }
	              }
	          }
	          this._match(TOK_RBRACKET);
	          return {type: "MultiSelectList", children: expressions};
	      },
	
	      _parseMultiselectHash: function() {
	        var pairs = [];
	        var identifierTypes = [TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER];
	        var keyToken, keyName, value, node;
	        for (;;) {
	          keyToken = this._lookaheadToken(0);
	          if (identifierTypes.indexOf(keyToken.type) < 0) {
	            throw new Error("Expecting an identifier token, got: " +
	                            keyToken.type);
	          }
	          keyName = keyToken.value;
	          this._advance();
	          this._match(TOK_COLON);
	          value = this.expression(0);
	          node = {type: "KeyValuePair", name: keyName, value: value};
	          pairs.push(node);
	          if (this._lookahead(0) === TOK_COMMA) {
	            this._match(TOK_COMMA);
	          } else if (this._lookahead(0) === TOK_RBRACE) {
	            this._match(TOK_RBRACE);
	            break;
	          }
	        }
	        return {type: "MultiSelectHash", children: pairs};
	      }
	  };
	
	
	  function TreeInterpreter(runtime) {
	    this.runtime = runtime;
	  }
	
	  TreeInterpreter.prototype = {
	      search: function(node, value) {
	          return this.visit(node, value);
	      },
	
	      visit: function(node, value) {
	          var matched, current, result, first, second, field, left, right, collected, i;
	          switch (node.type) {
	            case "Field":
	              if (value === null ) {
	                  return null;
	              } else if (isObject(value)) {
	                  field = value[node.name];
	                  if (field === undefined) {
	                      return null;
	                  } else {
	                      return field;
	                  }
	              } else {
	                return null;
	              }
	              break;
	            case "Subexpression":
	              result = this.visit(node.children[0], value);
	              for (i = 1; i < node.children.length; i++) {
	                  result = this.visit(node.children[1], result);
	                  if (result === null) {
	                      return null;
	                  }
	              }
	              return result;
	            case "IndexExpression":
	              left = this.visit(node.children[0], value);
	              right = this.visit(node.children[1], left);
	              return right;
	            case "Index":
	              if (!isArray(value)) {
	                return null;
	              }
	              var index = node.value;
	              if (index < 0) {
	                index = value.length + index;
	              }
	              result = value[index];
	              if (result === undefined) {
	                result = null;
	              }
	              return result;
	            case "Slice":
	              if (!isArray(value)) {
	                return null;
	              }
	              var sliceParams = node.children.slice(0);
	              var computed = this.computeSliceParams(value.length, sliceParams);
	              var start = computed[0];
	              var stop = computed[1];
	              var step = computed[2];
	              result = [];
	              if (step > 0) {
	                  for (i = start; i < stop; i += step) {
	                      result.push(value[i]);
	                  }
	              } else {
	                  for (i = start; i > stop; i += step) {
	                      result.push(value[i]);
	                  }
	              }
	              return result;
	            case "Projection":
	              // Evaluate left child.
	              var base = this.visit(node.children[0], value);
	              if (!isArray(base)) {
	                return null;
	              }
	              collected = [];
	              for (i = 0; i < base.length; i++) {
	                current = this.visit(node.children[1], base[i]);
	                if (current !== null) {
	                  collected.push(current);
	                }
	              }
	              return collected;
	            case "ValueProjection":
	              // Evaluate left child.
	              base = this.visit(node.children[0], value);
	              if (!isObject(base)) {
	                return null;
	              }
	              collected = [];
	              var values = objValues(base);
	              for (i = 0; i < values.length; i++) {
	                current = this.visit(node.children[1], values[i]);
	                if (current !== null) {
	                  collected.push(current);
	                }
	              }
	              return collected;
	            case "FilterProjection":
	              base = this.visit(node.children[0], value);
	              if (!isArray(base)) {
	                return null;
	              }
	              var filtered = [];
	              var finalResults = [];
	              for (i = 0; i < base.length; i++) {
	                matched = this.visit(node.children[2], base[i]);
	                if (!isFalse(matched)) {
	                  filtered.push(base[i]);
	                }
	              }
	              for (var j = 0; j < filtered.length; j++) {
	                current = this.visit(node.children[1], filtered[j]);
	                if (current !== null) {
	                  finalResults.push(current);
	                }
	              }
	              return finalResults;
	            case "Comparator":
	              first = this.visit(node.children[0], value);
	              second = this.visit(node.children[1], value);
	              switch(node.name) {
	                case TOK_EQ:
	                  result = strictDeepEqual(first, second);
	                  break;
	                case TOK_NE:
	                  result = !strictDeepEqual(first, second);
	                  break;
	                case TOK_GT:
	                  result = first > second;
	                  break;
	                case TOK_GTE:
	                  result = first >= second;
	                  break;
	                case TOK_LT:
	                  result = first < second;
	                  break;
	                case TOK_LTE:
	                  result = first <= second;
	                  break;
	                default:
	                  throw new Error("Unknown comparator: " + node.name);
	              }
	              return result;
	            case TOK_FLATTEN:
	              var original = this.visit(node.children[0], value);
	              if (!isArray(original)) {
	                return null;
	              }
	              var merged = [];
	              for (i = 0; i < original.length; i++) {
	                current = original[i];
	                if (isArray(current)) {
	                  merged.push.apply(merged, current);
	                } else {
	                  merged.push(current);
	                }
	              }
	              return merged;
	            case "Identity":
	              return value;
	            case "MultiSelectList":
	              if (value === null) {
	                return null;
	              }
	              collected = [];
	              for (i = 0; i < node.children.length; i++) {
	                  collected.push(this.visit(node.children[i], value));
	              }
	              return collected;
	            case "MultiSelectHash":
	              if (value === null) {
	                return null;
	              }
	              collected = {};
	              var child;
	              for (i = 0; i < node.children.length; i++) {
	                child = node.children[i];
	                collected[child.name] = this.visit(child.value, value);
	              }
	              return collected;
	            case "OrExpression":
	              matched = this.visit(node.children[0], value);
	              if (isFalse(matched)) {
	                  matched = this.visit(node.children[1], value);
	              }
	              return matched;
	            case "AndExpression":
	              first = this.visit(node.children[0], value);
	
	              if (isFalse(first) === true) {
	                return first;
	              }
	              return this.visit(node.children[1], value);
	            case "NotExpression":
	              first = this.visit(node.children[0], value);
	              return isFalse(first);
	            case "Literal":
	              return node.value;
	            case TOK_PIPE:
	              left = this.visit(node.children[0], value);
	              return this.visit(node.children[1], left);
	            case TOK_CURRENT:
	              return value;
	            case "Function":
	              var resolvedArgs = [];
	              for (i = 0; i < node.children.length; i++) {
	                  resolvedArgs.push(this.visit(node.children[i], value));
	              }
	              return this.runtime.callFunction(node.name, resolvedArgs);
	            case "ExpressionReference":
	              var refNode = node.children[0];
	              // Tag the node with a specific attribute so the type
	              // checker verify the type.
	              refNode.jmespathType = TOK_EXPREF;
	              return refNode;
	            default:
	              throw new Error("Unknown node type: " + node.type);
	          }
	      },
	
	      computeSliceParams: function(arrayLength, sliceParams) {
	        var start = sliceParams[0];
	        var stop = sliceParams[1];
	        var step = sliceParams[2];
	        var computed = [null, null, null];
	        if (step === null) {
	          step = 1;
	        } else if (step === 0) {
	          var error = new Error("Invalid slice, step cannot be 0");
	          error.name = "RuntimeError";
	          throw error;
	        }
	        var stepValueNegative = step < 0 ? true : false;
	
	        if (start === null) {
	            start = stepValueNegative ? arrayLength - 1 : 0;
	        } else {
	            start = this.capSliceRange(arrayLength, start, step);
	        }
	
	        if (stop === null) {
	            stop = stepValueNegative ? -1 : arrayLength;
	        } else {
	            stop = this.capSliceRange(arrayLength, stop, step);
	        }
	        computed[0] = start;
	        computed[1] = stop;
	        computed[2] = step;
	        return computed;
	      },
	
	      capSliceRange: function(arrayLength, actualValue, step) {
	          if (actualValue < 0) {
	              actualValue += arrayLength;
	              if (actualValue < 0) {
	                  actualValue = step < 0 ? -1 : 0;
	              }
	          } else if (actualValue >= arrayLength) {
	              actualValue = step < 0 ? arrayLength - 1 : arrayLength;
	          }
	          return actualValue;
	      }
	
	  };
	
	  function Runtime(interpreter) {
	    this._interpreter = interpreter;
	    this.functionTable = {
	        // name: [function, <signature>]
	        // The <signature> can be:
	        //
	        // {
	        //   args: [[type1, type2], [type1, type2]],
	        //   variadic: true|false
	        // }
	        //
	        // Each arg in the arg list is a list of valid types
	        // (if the function is overloaded and supports multiple
	        // types.  If the type is "any" then no type checking
	        // occurs on the argument.  Variadic is optional
	        // and if not provided is assumed to be false.
	        abs: {_func: this._functionAbs, _signature: [{types: [TYPE_NUMBER]}]},
	        avg: {_func: this._functionAvg, _signature: [{types: [TYPE_ARRAY_NUMBER]}]},
	        ceil: {_func: this._functionCeil, _signature: [{types: [TYPE_NUMBER]}]},
	        contains: {
	            _func: this._functionContains,
	            _signature: [{types: [TYPE_STRING, TYPE_ARRAY]},
	                        {types: [TYPE_ANY]}]},
	        "ends_with": {
	            _func: this._functionEndsWith,
	            _signature: [{types: [TYPE_STRING]}, {types: [TYPE_STRING]}]},
	        floor: {_func: this._functionFloor, _signature: [{types: [TYPE_NUMBER]}]},
	        length: {
	            _func: this._functionLength,
	            _signature: [{types: [TYPE_STRING, TYPE_ARRAY, TYPE_OBJECT]}]},
	        map: {
	            _func: this._functionMap,
	            _signature: [{types: [TYPE_EXPREF]}, {types: [TYPE_ARRAY]}]},
	        max: {
	            _func: this._functionMax,
	            _signature: [{types: [TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING]}]},
	        "merge": {
	            _func: this._functionMerge,
	            _signature: [{types: [TYPE_OBJECT], variadic: true}]
	        },
	        "max_by": {
	          _func: this._functionMaxBy,
	          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
	        },
	        sum: {_func: this._functionSum, _signature: [{types: [TYPE_ARRAY_NUMBER]}]},
	        "starts_with": {
	            _func: this._functionStartsWith,
	            _signature: [{types: [TYPE_STRING]}, {types: [TYPE_STRING]}]},
	        min: {
	            _func: this._functionMin,
	            _signature: [{types: [TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING]}]},
	        "min_by": {
	          _func: this._functionMinBy,
	          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
	        },
	        type: {_func: this._functionType, _signature: [{types: [TYPE_ANY]}]},
	        keys: {_func: this._functionKeys, _signature: [{types: [TYPE_OBJECT]}]},
	        values: {_func: this._functionValues, _signature: [{types: [TYPE_OBJECT]}]},
	        sort: {_func: this._functionSort, _signature: [{types: [TYPE_ARRAY_STRING, TYPE_ARRAY_NUMBER]}]},
	        "sort_by": {
	          _func: this._functionSortBy,
	          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
	        },
	        join: {
	            _func: this._functionJoin,
	            _signature: [
	                {types: [TYPE_STRING]},
	                {types: [TYPE_ARRAY_STRING]}
	            ]
	        },
	        reverse: {
	            _func: this._functionReverse,
	            _signature: [{types: [TYPE_STRING, TYPE_ARRAY]}]},
	        "to_array": {_func: this._functionToArray, _signature: [{types: [TYPE_ANY]}]},
	        "to_string": {_func: this._functionToString, _signature: [{types: [TYPE_ANY]}]},
	        "to_number": {_func: this._functionToNumber, _signature: [{types: [TYPE_ANY]}]},
	        "not_null": {
	            _func: this._functionNotNull,
	            _signature: [{types: [TYPE_ANY], variadic: true}]
	        }
	    };
	  }
	
	  Runtime.prototype = {
	    callFunction: function(name, resolvedArgs) {
	      var functionEntry = this.functionTable[name];
	      if (functionEntry === undefined) {
	          throw new Error("Unknown function: " + name + "()");
	      }
	      this._validateArgs(name, resolvedArgs, functionEntry._signature);
	      return functionEntry._func.call(this, resolvedArgs);
	    },
	
	    _validateArgs: function(name, args, signature) {
	        // Validating the args requires validating
	        // the correct arity and the correct type of each arg.
	        // If the last argument is declared as variadic, then we need
	        // a minimum number of args to be required.  Otherwise it has to
	        // be an exact amount.
	        var pluralized;
	        if (signature[signature.length - 1].variadic) {
	            if (args.length < signature.length) {
	                pluralized = signature.length === 1 ? " argument" : " arguments";
	                throw new Error("ArgumentError: " + name + "() " +
	                                "takes at least" + signature.length + pluralized +
	                                " but received " + args.length);
	            }
	        } else if (args.length !== signature.length) {
	            pluralized = signature.length === 1 ? " argument" : " arguments";
	            throw new Error("ArgumentError: " + name + "() " +
	                            "takes " + signature.length + pluralized +
	                            " but received " + args.length);
	        }
	        var currentSpec;
	        var actualType;
	        var typeMatched;
	        for (var i = 0; i < signature.length; i++) {
	            typeMatched = false;
	            currentSpec = signature[i].types;
	            actualType = this._getTypeName(args[i]);
	            for (var j = 0; j < currentSpec.length; j++) {
	                if (this._typeMatches(actualType, currentSpec[j], args[i])) {
	                    typeMatched = true;
	                    break;
	                }
	            }
	            if (!typeMatched) {
	                throw new Error("TypeError: " + name + "() " +
	                                "expected argument " + (i + 1) +
	                                " to be type " + currentSpec +
	                                " but received type " + actualType +
	                                " instead.");
	            }
	        }
	    },
	
	    _typeMatches: function(actual, expected, argValue) {
	        if (expected === TYPE_ANY) {
	            return true;
	        }
	        if (expected === TYPE_ARRAY_STRING ||
	            expected === TYPE_ARRAY_NUMBER ||
	            expected === TYPE_ARRAY) {
	            // The expected type can either just be array,
	            // or it can require a specific subtype (array of numbers).
	            //
	            // The simplest case is if "array" with no subtype is specified.
	            if (expected === TYPE_ARRAY) {
	                return actual === TYPE_ARRAY;
	            } else if (actual === TYPE_ARRAY) {
	                // Otherwise we need to check subtypes.
	                // I think this has potential to be improved.
	                var subtype;
	                if (expected === TYPE_ARRAY_NUMBER) {
	                  subtype = TYPE_NUMBER;
	                } else if (expected === TYPE_ARRAY_STRING) {
	                  subtype = TYPE_STRING;
	                }
	                for (var i = 0; i < argValue.length; i++) {
	                    if (!this._typeMatches(
	                            this._getTypeName(argValue[i]), subtype,
	                                             argValue[i])) {
	                        return false;
	                    }
	                }
	                return true;
	            }
	        } else {
	            return actual === expected;
	        }
	    },
	    _getTypeName: function(obj) {
	        switch (Object.prototype.toString.call(obj)) {
	            case "[object String]":
	              return TYPE_STRING;
	            case "[object Number]":
	              return TYPE_NUMBER;
	            case "[object Array]":
	              return TYPE_ARRAY;
	            case "[object Boolean]":
	              return TYPE_BOOLEAN;
	            case "[object Null]":
	              return TYPE_NULL;
	            case "[object Object]":
	              // Check if it's an expref.  If it has, it's been
	              // tagged with a jmespathType attr of 'Expref';
	              if (obj.jmespathType === TOK_EXPREF) {
	                return TYPE_EXPREF;
	              } else {
	                return TYPE_OBJECT;
	              }
	        }
	    },
	
	    _functionStartsWith: function(resolvedArgs) {
	        return resolvedArgs[0].lastIndexOf(resolvedArgs[1]) === 0;
	    },
	
	    _functionEndsWith: function(resolvedArgs) {
	        var searchStr = resolvedArgs[0];
	        var suffix = resolvedArgs[1];
	        return searchStr.indexOf(suffix, searchStr.length - suffix.length) !== -1;
	    },
	
	    _functionReverse: function(resolvedArgs) {
	        var typeName = this._getTypeName(resolvedArgs[0]);
	        if (typeName === TYPE_STRING) {
	          var originalStr = resolvedArgs[0];
	          var reversedStr = "";
	          for (var i = originalStr.length - 1; i >= 0; i--) {
	              reversedStr += originalStr[i];
	          }
	          return reversedStr;
	        } else {
	          var reversedArray = resolvedArgs[0].slice(0);
	          reversedArray.reverse();
	          return reversedArray;
	        }
	    },
	
	    _functionAbs: function(resolvedArgs) {
	      return Math.abs(resolvedArgs[0]);
	    },
	
	    _functionCeil: function(resolvedArgs) {
	        return Math.ceil(resolvedArgs[0]);
	    },
	
	    _functionAvg: function(resolvedArgs) {
	        var sum = 0;
	        var inputArray = resolvedArgs[0];
	        for (var i = 0; i < inputArray.length; i++) {
	            sum += inputArray[i];
	        }
	        return sum / inputArray.length;
	    },
	
	    _functionContains: function(resolvedArgs) {
	        return resolvedArgs[0].indexOf(resolvedArgs[1]) >= 0;
	    },
	
	    _functionFloor: function(resolvedArgs) {
	        return Math.floor(resolvedArgs[0]);
	    },
	
	    _functionLength: function(resolvedArgs) {
	       if (!isObject(resolvedArgs[0])) {
	         return resolvedArgs[0].length;
	       } else {
	         // As far as I can tell, there's no way to get the length
	         // of an object without O(n) iteration through the object.
	         return Object.keys(resolvedArgs[0]).length;
	       }
	    },
	
	    _functionMap: function(resolvedArgs) {
	      var mapped = [];
	      var interpreter = this._interpreter;
	      var exprefNode = resolvedArgs[0];
	      var elements = resolvedArgs[1];
	      for (var i = 0; i < elements.length; i++) {
	          mapped.push(interpreter.visit(exprefNode, elements[i]));
	      }
	      return mapped;
	    },
	
	    _functionMerge: function(resolvedArgs) {
	      var merged = {};
	      for (var i = 0; i < resolvedArgs.length; i++) {
	        var current = resolvedArgs[i];
	        for (var key in current) {
	          merged[key] = current[key];
	        }
	      }
	      return merged;
	    },
	
	    _functionMax: function(resolvedArgs) {
	      if (resolvedArgs[0].length > 0) {
	        var typeName = this._getTypeName(resolvedArgs[0][0]);
	        if (typeName === TYPE_NUMBER) {
	          return Math.max.apply(Math, resolvedArgs[0]);
	        } else {
	          var elements = resolvedArgs[0];
	          var maxElement = elements[0];
	          for (var i = 1; i < elements.length; i++) {
	              if (maxElement.localeCompare(elements[i]) < 0) {
	                  maxElement = elements[i];
	              }
	          }
	          return maxElement;
	        }
	      } else {
	          return null;
	      }
	    },
	
	    _functionMin: function(resolvedArgs) {
	      if (resolvedArgs[0].length > 0) {
	        var typeName = this._getTypeName(resolvedArgs[0][0]);
	        if (typeName === TYPE_NUMBER) {
	          return Math.min.apply(Math, resolvedArgs[0]);
	        } else {
	          var elements = resolvedArgs[0];
	          var minElement = elements[0];
	          for (var i = 1; i < elements.length; i++) {
	              if (elements[i].localeCompare(minElement) < 0) {
	                  minElement = elements[i];
	              }
	          }
	          return minElement;
	        }
	      } else {
	        return null;
	      }
	    },
	
	    _functionSum: function(resolvedArgs) {
	      var sum = 0;
	      var listToSum = resolvedArgs[0];
	      for (var i = 0; i < listToSum.length; i++) {
	        sum += listToSum[i];
	      }
	      return sum;
	    },
	
	    _functionType: function(resolvedArgs) {
	        switch (this._getTypeName(resolvedArgs[0])) {
	          case TYPE_NUMBER:
	            return "number";
	          case TYPE_STRING:
	            return "string";
	          case TYPE_ARRAY:
	            return "array";
	          case TYPE_OBJECT:
	            return "object";
	          case TYPE_BOOLEAN:
	            return "boolean";
	          case TYPE_EXPREF:
	            return "expref";
	          case TYPE_NULL:
	            return "null";
	        }
	    },
	
	    _functionKeys: function(resolvedArgs) {
	        return Object.keys(resolvedArgs[0]);
	    },
	
	    _functionValues: function(resolvedArgs) {
	        var obj = resolvedArgs[0];
	        var keys = Object.keys(obj);
	        var values = [];
	        for (var i = 0; i < keys.length; i++) {
	            values.push(obj[keys[i]]);
	        }
	        return values;
	    },
	
	    _functionJoin: function(resolvedArgs) {
	        var joinChar = resolvedArgs[0];
	        var listJoin = resolvedArgs[1];
	        return listJoin.join(joinChar);
	    },
	
	    _functionToArray: function(resolvedArgs) {
	        if (this._getTypeName(resolvedArgs[0]) === TYPE_ARRAY) {
	            return resolvedArgs[0];
	        } else {
	            return [resolvedArgs[0]];
	        }
	    },
	
	    _functionToString: function(resolvedArgs) {
	        if (this._getTypeName(resolvedArgs[0]) === TYPE_STRING) {
	            return resolvedArgs[0];
	        } else {
	            return JSON.stringify(resolvedArgs[0]);
	        }
	    },
	
	    _functionToNumber: function(resolvedArgs) {
	        var typeName = this._getTypeName(resolvedArgs[0]);
	        var convertedValue;
	        if (typeName === TYPE_NUMBER) {
	            return resolvedArgs[0];
	        } else if (typeName === TYPE_STRING) {
	            convertedValue = +resolvedArgs[0];
	            if (!isNaN(convertedValue)) {
	                return convertedValue;
	            }
	        }
	        return null;
	    },
	
	    _functionNotNull: function(resolvedArgs) {
	        for (var i = 0; i < resolvedArgs.length; i++) {
	            if (this._getTypeName(resolvedArgs[i]) !== TYPE_NULL) {
	                return resolvedArgs[i];
	            }
	        }
	        return null;
	    },
	
	    _functionSort: function(resolvedArgs) {
	        var sortedArray = resolvedArgs[0].slice(0);
	        sortedArray.sort();
	        return sortedArray;
	    },
	
	    _functionSortBy: function(resolvedArgs) {
	        var sortedArray = resolvedArgs[0].slice(0);
	        if (sortedArray.length === 0) {
	            return sortedArray;
	        }
	        var interpreter = this._interpreter;
	        var exprefNode = resolvedArgs[1];
	        var requiredType = this._getTypeName(
	            interpreter.visit(exprefNode, sortedArray[0]));
	        if ([TYPE_NUMBER, TYPE_STRING].indexOf(requiredType) < 0) {
	            throw new Error("TypeError");
	        }
	        var that = this;
	        // In order to get a stable sort out of an unstable
	        // sort algorithm, we decorate/sort/undecorate (DSU)
	        // by creating a new list of [index, element] pairs.
	        // In the cmp function, if the evaluated elements are
	        // equal, then the index will be used as the tiebreaker.
	        // After the decorated list has been sorted, it will be
	        // undecorated to extract the original elements.
	        var decorated = [];
	        for (var i = 0; i < sortedArray.length; i++) {
	          decorated.push([i, sortedArray[i]]);
	        }
	        decorated.sort(function(a, b) {
	          var exprA = interpreter.visit(exprefNode, a[1]);
	          var exprB = interpreter.visit(exprefNode, b[1]);
	          if (that._getTypeName(exprA) !== requiredType) {
	              throw new Error(
	                  "TypeError: expected " + requiredType + ", received " +
	                  that._getTypeName(exprA));
	          } else if (that._getTypeName(exprB) !== requiredType) {
	              throw new Error(
	                  "TypeError: expected " + requiredType + ", received " +
	                  that._getTypeName(exprB));
	          }
	          if (exprA > exprB) {
	            return 1;
	          } else if (exprA < exprB) {
	            return -1;
	          } else {
	            // If they're equal compare the items by their
	            // order to maintain relative order of equal keys
	            // (i.e. to get a stable sort).
	            return a[0] - b[0];
	          }
	        });
	        // Undecorate: extract out the original list elements.
	        for (var j = 0; j < decorated.length; j++) {
	          sortedArray[j] = decorated[j][1];
	        }
	        return sortedArray;
	    },
	
	    _functionMaxBy: function(resolvedArgs) {
	      var exprefNode = resolvedArgs[1];
	      var resolvedArray = resolvedArgs[0];
	      var keyFunction = this.createKeyFunction(exprefNode, [TYPE_NUMBER, TYPE_STRING]);
	      var maxNumber = -Infinity;
	      var maxRecord;
	      var current;
	      for (var i = 0; i < resolvedArray.length; i++) {
	        current = keyFunction(resolvedArray[i]);
	        if (current > maxNumber) {
	          maxNumber = current;
	          maxRecord = resolvedArray[i];
	        }
	      }
	      return maxRecord;
	    },
	
	    _functionMinBy: function(resolvedArgs) {
	      var exprefNode = resolvedArgs[1];
	      var resolvedArray = resolvedArgs[0];
	      var keyFunction = this.createKeyFunction(exprefNode, [TYPE_NUMBER, TYPE_STRING]);
	      var minNumber = Infinity;
	      var minRecord;
	      var current;
	      for (var i = 0; i < resolvedArray.length; i++) {
	        current = keyFunction(resolvedArray[i]);
	        if (current < minNumber) {
	          minNumber = current;
	          minRecord = resolvedArray[i];
	        }
	      }
	      return minRecord;
	    },
	
	    createKeyFunction: function(exprefNode, allowedTypes) {
	      var that = this;
	      var interpreter = this._interpreter;
	      var keyFunc = function(x) {
	        var current = interpreter.visit(exprefNode, x);
	        if (allowedTypes.indexOf(that._getTypeName(current)) < 0) {
	          var msg = "TypeError: expected one of " + allowedTypes +
	                    ", received " + that._getTypeName(current);
	          throw new Error(msg);
	        }
	        return current;
	      };
	      return keyFunc;
	    }
	
	  };
	
	  function compile(stream) {
	    var parser = new Parser();
	    var ast = parser.parse(stream);
	    return ast;
	  }
	
	  function tokenize(stream) {
	      var lexer = new Lexer();
	      return lexer.tokenize(stream);
	  }
	
	  function search(data, expression) {
	      var parser = new Parser();
	      // This needs to be improved.  Both the interpreter and runtime depend on
	      // each other.  The runtime needs the interpreter to support exprefs.
	      // There's likely a clean way to avoid the cyclic dependency.
	      var runtime = new Runtime();
	      var interpreter = new TreeInterpreter(runtime);
	      runtime._interpreter = interpreter;
	      var node = parser.parse(expression);
	      return interpreter.search(node, data);
	  }
	
	  exports.tokenize = tokenize;
	  exports.compile = compile;
	  exports.search = search;
	  exports.strictDeepEqual = strictDeepEqual;
	})( false ? this.jmespath = {} : exports);


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _Transition = _interopRequireWildcard(__webpack_require__(134));
	
	var _transitionEndListener = _interopRequireDefault(__webpack_require__(129));
	
	var _triggerBrowserReflow = _interopRequireDefault(__webpack_require__(130));
	
	var _excluded = ["className", "children"];
	
	var _fadeStyles;
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false
	};
	var fadeStyles = (_fadeStyles = {}, _fadeStyles[_Transition.ENTERING] = 'show', _fadeStyles[_Transition.ENTERED] = 'show', _fadeStyles);
	
	var Fade = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var className = _ref.className,
	      children = _ref.children,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var handleEnter = (0, _react.useCallback)(function (node) {
	    (0, _triggerBrowserReflow.default)(node);
	    if (props.onEnter) props.onEnter(node);
	  }, [props]);
	  return /*#__PURE__*/_react.default.createElement(_Transition.default, (0, _extends2.default)({
	    ref: ref,
	    addEndListener: _transitionEndListener.default
	  }, props, {
	    onEnter: handleEnter
	  }), function (status, innerProps) {
	    return /*#__PURE__*/_react.default.cloneElement(children, (0, _extends2.default)({}, innerProps, {
	      className: (0, _classnames.default)('fade', className, children.props.className, fadeStyles[status])
	    }));
	  });
	});
	
	Fade.defaultProps = defaultProps;
	Fade.displayName = 'Fade';
	var _default = Fade;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(555);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 45 */
[592, 81, 8, 310, 482, 483],
/* 46 */
[624, 143, 12],
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.mergeRefs = mergeRefs;
	exports.default = void 0;
	
	var _react = __webpack_require__(2);
	
	var toFnRef = function toFnRef(ref) {
	  return !ref || typeof ref === 'function' ? ref : function (value) {
	    ref.current = value;
	  };
	};
	
	function mergeRefs(refA, refB) {
	  var a = toFnRef(refA);
	  var b = toFnRef(refB);
	  return function (value) {
	    if (a) a(value);
	    if (b) b(value);
	  };
	}
	/**
	 * Create and returns a single callback ref composed from two other Refs.
	 *
	 * ```tsx
	 * const Button = React.forwardRef((props, ref) => {
	 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
	 *   const mergedRef = useMergedRefs(ref, attachRef);
	 *
	 *   return <button ref={mergedRef} {...props}/>
	 * })
	 * ```
	 *
	 * @param refA A Callback or mutable Ref
	 * @param refB A Callback or mutable Ref
	 * @category refs
	 */
	
	
	function useMergedRefs(refA, refB) {
	  return (0, _react.useMemo)(function () {
	    return mergeRefs(refA, refB);
	  }, [refA, refB]);
	}
	
	var _default = useMergedRefs;
	exports.default = _default;

/***/ },
/* 48 */
[592, 39, 7, 399, 497, 498],
/* 49 */
[624, 167, 13],
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _getComputedStyle = _interopRequireDefault(__webpack_require__(432));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(434));
	
	var _isTransform = _interopRequireDefault(__webpack_require__(436));
	
	function style(node, property) {
	  var css = '';
	  var transforms = '';
	
	  if (typeof property === 'string') {
	    return node.style.getPropertyValue((0, _hyphenateStyle.default)(property)) || (0, _getComputedStyle.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	  }
	
	  Object.keys(property).forEach(function (key) {
	    var value = property[key];
	
	    if (!value && value !== 0) {
	      node.style.removeProperty((0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += "transform: " + transforms + ";";
	  }
	
	  node.style.cssText += ";" + css;
	}
	
	var _default = style;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 51 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = find;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function find(list, predicate) {
	  for (var i = 0; i < list.length; i++) {
	    if (predicate(list[i])) {
	      return list[i];
	    }
	  }
	}

/***/ },
/* 52 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = keyValMap;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Creates a keyed JS object from an array, given a function to produce the keys
	 * and a function to produce the values from each item in the array.
	 *
	 *     const phoneBook = [
	 *       { name: 'Jon', num: '555-1234' },
	 *       { name: 'Jenny', num: '867-5309' }
	 *     ]
	 *
	 *     // { Jon: '555-1234', Jenny: '867-5309' }
	 *     const phonesByName = keyValMap(
	 *       phoneBook,
	 *       entry => entry.name,
	 *       entry => entry.num
	 *     )
	 *
	 */
	function keyValMap(list, keyFn, valFn) {
	  return list.reduce(function (map, item) {
	    return map[keyFn(item)] = valFn(item), map;
	  }, Object.create(null));
	}

/***/ },
/* 53 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = suggestionList;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Given an invalid input string and a list of valid options, returns a filtered
	 * list of valid options sorted based on their similarity with the input.
	 */
	function suggestionList(input, options) {
	  var optionsByDistance = Object.create(null);
	  var oLength = options.length;
	  var inputThreshold = input.length / 2;
	
	  for (var i = 0; i < oLength; i++) {
	    var distance = lexicalDistance(input, options[i]);
	    var threshold = Math.max(inputThreshold, options[i].length / 2, 1);
	
	    if (distance <= threshold) {
	      optionsByDistance[options[i]] = distance;
	    }
	  }
	
	  return Object.keys(optionsByDistance).sort(function (a, b) {
	    return optionsByDistance[a] - optionsByDistance[b];
	  });
	}
	/**
	 * Computes the lexical distance between strings A and B.
	 *
	 * The "distance" between two strings is given by counting the minimum number
	 * of edits needed to transform string A into string B. An edit can be an
	 * insertion, deletion, or substitution of a single character, or a swap of two
	 * adjacent characters.
	 *
	 * Includes a custom alteration from Damerau-Levenshtein to treat case changes
	 * as a single edit which helps identify mis-cased values with an edit distance
	 * of 1.
	 *
	 * This distance can be useful for detecting typos in input or sorting
	 *
	 * @param {string} a
	 * @param {string} b
	 * @return {int} distance in number of edits
	 */
	
	
	function lexicalDistance(aStr, bStr) {
	  if (aStr === bStr) {
	    return 0;
	  }
	
	  var i;
	  var j;
	  var d = [];
	  var a = aStr.toLowerCase();
	  var b = bStr.toLowerCase();
	  var aLength = a.length;
	  var bLength = b.length; // Any case change counts as a single edit
	
	  if (a === b) {
	    return 1;
	  }
	
	  for (i = 0; i <= aLength; i++) {
	    d[i] = [i];
	  }
	
	  for (j = 1; j <= bLength; j++) {
	    d[0][j] = j;
	  }
	
	  for (i = 1; i <= aLength; i++) {
	    for (j = 1; j <= bLength; j++) {
	      var cost = a[i - 1] === b[j - 1] ? 0 : 1;
	      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
	
	      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
	        d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + cost);
	      }
	    }
	  }
	
	  return d[aLength][bLength];
	}

/***/ },
/* 54 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DirectiveLocation = void 0;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * The set of allowed directive location values.
	 */
	var DirectiveLocation = Object.freeze({
	  // Request Definitions
	  QUERY: 'QUERY',
	  MUTATION: 'MUTATION',
	  SUBSCRIPTION: 'SUBSCRIPTION',
	  FIELD: 'FIELD',
	  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
	  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
	  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
	  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
	  // Type System Definitions
	  SCHEMA: 'SCHEMA',
	  SCALAR: 'SCALAR',
	  OBJECT: 'OBJECT',
	  FIELD_DEFINITION: 'FIELD_DEFINITION',
	  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
	  INTERFACE: 'INTERFACE',
	  UNION: 'UNION',
	  ENUM: 'ENUM',
	  ENUM_VALUE: 'ENUM_VALUE',
	  INPUT_OBJECT: 'INPUT_OBJECT',
	  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
	});
	/**
	 * The enum type representing the directive location values.
	 */
	
	exports.DirectiveLocation = DirectiveLocation;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TypeInfo = void 0;
	
	var _kinds = __webpack_require__(11);
	
	var _definition = __webpack_require__(10);
	
	var _introspection = __webpack_require__(23);
	
	var _typeFromAST = __webpack_require__(29);
	
	var _find = _interopRequireDefault(__webpack_require__(51));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * TypeInfo is a utility class which, given a GraphQL schema, can keep track
	 * of the current field and type definitions at any point in a GraphQL document
	 * AST during a recursive descent by calling `enter(node)` and `leave(node)`.
	 */
	var TypeInfo =
	/*#__PURE__*/
	function () {
	  function TypeInfo(schema, // NOTE: this experimental optional second parameter is only needed in order
	  // to support non-spec-compliant codebases. You should never need to use it.
	  getFieldDefFn, // Initial type may be provided in rare cases to facilitate traversals
	  initialType) {
	    _defineProperty(this, "_schema", void 0);
	
	    _defineProperty(this, "_typeStack", void 0);
	
	    _defineProperty(this, "_parentTypeStack", void 0);
	
	    _defineProperty(this, "_inputTypeStack", void 0);
	
	    _defineProperty(this, "_fieldDefStack", void 0);
	
	    _defineProperty(this, "_defaultValueStack", void 0);
	
	    _defineProperty(this, "_directive", void 0);
	
	    _defineProperty(this, "_argument", void 0);
	
	    _defineProperty(this, "_enumValue", void 0);
	
	    _defineProperty(this, "_getFieldDef", void 0);
	
	    this._schema = schema;
	    this._typeStack = [];
	    this._parentTypeStack = [];
	    this._inputTypeStack = [];
	    this._fieldDefStack = [];
	    this._defaultValueStack = [];
	    this._directive = null;
	    this._argument = null;
	    this._enumValue = null;
	    this._getFieldDef = getFieldDefFn || getFieldDef;
	
	    if (initialType) {
	      if ((0, _definition.isInputType)(initialType)) {
	        this._inputTypeStack.push(initialType);
	      }
	
	      if ((0, _definition.isCompositeType)(initialType)) {
	        this._parentTypeStack.push(initialType);
	      }
	
	      if ((0, _definition.isOutputType)(initialType)) {
	        this._typeStack.push(initialType);
	      }
	    }
	  }
	
	  var _proto = TypeInfo.prototype;
	
	  _proto.getType = function getType() {
	    if (this._typeStack.length > 0) {
	      return this._typeStack[this._typeStack.length - 1];
	    }
	  };
	
	  _proto.getParentType = function getParentType() {
	    if (this._parentTypeStack.length > 0) {
	      return this._parentTypeStack[this._parentTypeStack.length - 1];
	    }
	  };
	
	  _proto.getInputType = function getInputType() {
	    if (this._inputTypeStack.length > 0) {
	      return this._inputTypeStack[this._inputTypeStack.length - 1];
	    }
	  };
	
	  _proto.getParentInputType = function getParentInputType() {
	    if (this._inputTypeStack.length > 1) {
	      return this._inputTypeStack[this._inputTypeStack.length - 2];
	    }
	  };
	
	  _proto.getFieldDef = function getFieldDef() {
	    if (this._fieldDefStack.length > 0) {
	      return this._fieldDefStack[this._fieldDefStack.length - 1];
	    }
	  };
	
	  _proto.getDefaultValue = function getDefaultValue() {
	    if (this._defaultValueStack.length > 0) {
	      return this._defaultValueStack[this._defaultValueStack.length - 1];
	    }
	  };
	
	  _proto.getDirective = function getDirective() {
	    return this._directive;
	  };
	
	  _proto.getArgument = function getArgument() {
	    return this._argument;
	  };
	
	  _proto.getEnumValue = function getEnumValue() {
	    return this._enumValue;
	  };
	
	  _proto.enter = function enter(node) {
	    var schema = this._schema; // Note: many of the types below are explicitly typed as "mixed" to drop
	    // any assumptions of a valid schema to ensure runtime types are properly
	    // checked before continuing since TypeInfo is used as part of validation
	    // which occurs before guarantees of schema and document validity.
	
	    switch (node.kind) {
	      case _kinds.Kind.SELECTION_SET:
	        var namedType = (0, _definition.getNamedType)(this.getType());
	
	        this._parentTypeStack.push((0, _definition.isCompositeType)(namedType) ? namedType : undefined);
	
	        break;
	
	      case _kinds.Kind.FIELD:
	        var parentType = this.getParentType();
	        var fieldDef;
	        var fieldType;
	
	        if (parentType) {
	          fieldDef = this._getFieldDef(schema, parentType, node);
	
	          if (fieldDef) {
	            fieldType = fieldDef.type;
	          }
	        }
	
	        this._fieldDefStack.push(fieldDef);
	
	        this._typeStack.push((0, _definition.isOutputType)(fieldType) ? fieldType : undefined);
	
	        break;
	
	      case _kinds.Kind.DIRECTIVE:
	        this._directive = schema.getDirective(node.name.value);
	        break;
	
	      case _kinds.Kind.OPERATION_DEFINITION:
	        var type;
	
	        if (node.operation === 'query') {
	          type = schema.getQueryType();
	        } else if (node.operation === 'mutation') {
	          type = schema.getMutationType();
	        } else if (node.operation === 'subscription') {
	          type = schema.getSubscriptionType();
	        }
	
	        this._typeStack.push((0, _definition.isObjectType)(type) ? type : undefined);
	
	        break;
	
	      case _kinds.Kind.INLINE_FRAGMENT:
	      case _kinds.Kind.FRAGMENT_DEFINITION:
	        var typeConditionAST = node.typeCondition;
	        var outputType = typeConditionAST ? (0, _typeFromAST.typeFromAST)(schema, typeConditionAST) : (0, _definition.getNamedType)(this.getType());
	
	        this._typeStack.push((0, _definition.isOutputType)(outputType) ? outputType : undefined);
	
	        break;
	
	      case _kinds.Kind.VARIABLE_DEFINITION:
	        var inputType = (0, _typeFromAST.typeFromAST)(schema, node.type);
	
	        this._inputTypeStack.push((0, _definition.isInputType)(inputType) ? inputType : undefined);
	
	        break;
	
	      case _kinds.Kind.ARGUMENT:
	        var argDef;
	        var argType;
	        var fieldOrDirective = this.getDirective() || this.getFieldDef();
	
	        if (fieldOrDirective) {
	          argDef = (0, _find.default)(fieldOrDirective.args, function (arg) {
	            return arg.name === node.name.value;
	          });
	
	          if (argDef) {
	            argType = argDef.type;
	          }
	        }
	
	        this._argument = argDef;
	
	        this._defaultValueStack.push(argDef ? argDef.defaultValue : undefined);
	
	        this._inputTypeStack.push((0, _definition.isInputType)(argType) ? argType : undefined);
	
	        break;
	
	      case _kinds.Kind.LIST:
	        var listType = (0, _definition.getNullableType)(this.getInputType());
	        var itemType = (0, _definition.isListType)(listType) ? listType.ofType : listType; // List positions never have a default value.
	
	        this._defaultValueStack.push(undefined);
	
	        this._inputTypeStack.push((0, _definition.isInputType)(itemType) ? itemType : undefined);
	
	        break;
	
	      case _kinds.Kind.OBJECT_FIELD:
	        var objectType = (0, _definition.getNamedType)(this.getInputType());
	        var inputFieldType;
	        var inputField;
	
	        if ((0, _definition.isInputObjectType)(objectType)) {
	          inputField = objectType.getFields()[node.name.value];
	
	          if (inputField) {
	            inputFieldType = inputField.type;
	          }
	        }
	
	        this._defaultValueStack.push(inputField ? inputField.defaultValue : undefined);
	
	        this._inputTypeStack.push((0, _definition.isInputType)(inputFieldType) ? inputFieldType : undefined);
	
	        break;
	
	      case _kinds.Kind.ENUM:
	        var enumType = (0, _definition.getNamedType)(this.getInputType());
	        var enumValue;
	
	        if ((0, _definition.isEnumType)(enumType)) {
	          enumValue = enumType.getValue(node.value);
	        }
	
	        this._enumValue = enumValue;
	        break;
	    }
	  };
	
	  _proto.leave = function leave(node) {
	    switch (node.kind) {
	      case _kinds.Kind.SELECTION_SET:
	        this._parentTypeStack.pop();
	
	        break;
	
	      case _kinds.Kind.FIELD:
	        this._fieldDefStack.pop();
	
	        this._typeStack.pop();
	
	        break;
	
	      case _kinds.Kind.DIRECTIVE:
	        this._directive = null;
	        break;
	
	      case _kinds.Kind.OPERATION_DEFINITION:
	      case _kinds.Kind.INLINE_FRAGMENT:
	      case _kinds.Kind.FRAGMENT_DEFINITION:
	        this._typeStack.pop();
	
	        break;
	
	      case _kinds.Kind.VARIABLE_DEFINITION:
	        this._inputTypeStack.pop();
	
	        break;
	
	      case _kinds.Kind.ARGUMENT:
	        this._argument = null;
	
	        this._defaultValueStack.pop();
	
	        this._inputTypeStack.pop();
	
	        break;
	
	      case _kinds.Kind.LIST:
	      case _kinds.Kind.OBJECT_FIELD:
	        this._defaultValueStack.pop();
	
	        this._inputTypeStack.pop();
	
	        break;
	
	      case _kinds.Kind.ENUM:
	        this._enumValue = null;
	        break;
	    }
	  };
	
	  return TypeInfo;
	}();
	/**
	 * Not exactly the same as the executor's definition of getFieldDef, in this
	 * statically evaluated environment we do not always have an Object type,
	 * and need to handle Interface and Union types.
	 */
	
	
	exports.TypeInfo = TypeInfo;
	
	function getFieldDef(schema, parentType, fieldNode) {
	  var name = fieldNode.name.value;
	
	  if (name === _introspection.SchemaMetaFieldDef.name && schema.getQueryType() === parentType) {
	    return _introspection.SchemaMetaFieldDef;
	  }
	
	  if (name === _introspection.TypeMetaFieldDef.name && schema.getQueryType() === parentType) {
	    return _introspection.TypeMetaFieldDef;
	  }
	
	  if (name === _introspection.TypeNameMetaFieldDef.name && (0, _definition.isCompositeType)(parentType)) {
	    return _introspection.TypeNameMetaFieldDef;
	  }
	
	  if ((0, _definition.isObjectType)(parentType) || (0, _definition.isInterfaceType)(parentType)) {
	    return parentType.getFields()[name];
	  }
	}

/***/ },
/* 56 */
/***/ function(module, exports) {

	'use strict';
	
	exports.isIterable = isIterable;
	exports.isArrayLike = isArrayLike;
	exports.isCollection = isCollection;
	exports.getIterator = getIterator;
	exports.getIteratorMethod = getIteratorMethod;
	exports.createIterator = createIterator;
	exports.forEach = forEach;
	exports.isAsyncIterable = isAsyncIterable;
	exports.getAsyncIterator = getAsyncIterator;
	exports.getAsyncIteratorMethod = getAsyncIteratorMethod;
	exports.createAsyncIterator = createAsyncIterator;
	exports.forAwaitEach = forAwaitEach;
	
	var SYMBOL = typeof Symbol === 'function' ? Symbol : void 0;
	
	var SYMBOL_ITERATOR = SYMBOL && SYMBOL.iterator;
	
	var $$iterator = exports.$$iterator = SYMBOL_ITERATOR || '@@iterator';
	
	function isIterable(obj) {
	  return !!getIteratorMethod(obj);
	}
	
	function isArrayLike(obj) {
	  var length = obj != null && obj.length;
	  return typeof length === 'number' && length >= 0 && length % 1 === 0;
	}
	
	function isCollection(obj) {
	  return Object(obj) === obj && (isArrayLike(obj) || isIterable(obj));
	}
	
	function getIterator(iterable) {
	  var method = getIteratorMethod(iterable);
	  if (method) {
	    return method.call(iterable);
	  }
	}
	
	function getIteratorMethod(iterable) {
	  if (iterable != null) {
	    var method = SYMBOL_ITERATOR && iterable[SYMBOL_ITERATOR] || iterable['@@iterator'];
	    if (typeof method === 'function') {
	      return method;
	    }
	  }
	}
	
	function createIterator(collection) {
	  if (collection != null) {
	    var iterator = getIterator(collection);
	    if (iterator) {
	      return iterator;
	    }
	    if (isArrayLike(collection)) {
	      return new ArrayLikeIterator(collection);
	    }
	  }
	}
	
	function ArrayLikeIterator(obj) {
	  this._o = obj;
	  this._i = 0;
	}
	
	ArrayLikeIterator.prototype[$$iterator] = function () {
	  return this;
	};
	
	ArrayLikeIterator.prototype.next = function () {
	  if (this._o === void 0 || this._i >= this._o.length) {
	    this._o = void 0;
	    return { value: void 0, done: true };
	  }
	  return { value: this._o[this._i++], done: false };
	};
	
	function forEach(collection, callback, thisArg) {
	  if (collection != null) {
	    if (typeof collection.forEach === 'function') {
	      return collection.forEach(callback, thisArg);
	    }
	    var i = 0;
	    var iterator = getIterator(collection);
	    if (iterator) {
	      var step;
	      while (!(step = iterator.next()).done) {
	        callback.call(thisArg, step.value, i++, collection);
	
	        if (i > 9999999) {
	          throw new TypeError('Near-infinite iteration.');
	        }
	      }
	    } else if (isArrayLike(collection)) {
	      for (; i < collection.length; i++) {
	        if (collection.hasOwnProperty(i)) {
	          callback.call(thisArg, collection[i], i, collection);
	        }
	      }
	    }
	  }
	}
	
	var SYMBOL_ASYNC_ITERATOR = SYMBOL && SYMBOL.asyncIterator;
	
	var $$asyncIterator = exports.$$asyncIterator = SYMBOL_ASYNC_ITERATOR || '@@asyncIterator';
	
	function isAsyncIterable(obj) {
	  return !!getAsyncIteratorMethod(obj);
	}
	
	function getAsyncIterator(asyncIterable) {
	  var method = getAsyncIteratorMethod(asyncIterable);
	  if (method) {
	    return method.call(asyncIterable);
	  }
	}
	
	function getAsyncIteratorMethod(asyncIterable) {
	  if (asyncIterable != null) {
	    var method = SYMBOL_ASYNC_ITERATOR && asyncIterable[SYMBOL_ASYNC_ITERATOR] || asyncIterable['@@asyncIterator'];
	    if (typeof method === 'function') {
	      return method;
	    }
	  }
	}
	
	function createAsyncIterator(source) {
	  if (source != null) {
	    var asyncIterator = getAsyncIterator(source);
	    if (asyncIterator) {
	      return asyncIterator;
	    }
	    var iterator = createIterator(source);
	    if (iterator) {
	      return new AsyncFromSyncIterator(iterator);
	    }
	  }
	}
	
	function AsyncFromSyncIterator(iterator) {
	  this._i = iterator;
	}
	
	AsyncFromSyncIterator.prototype[$$asyncIterator] = function () {
	  return this;
	};
	
	AsyncFromSyncIterator.prototype.next = function (value) {
	  return unwrapAsyncFromSync(this._i, 'next', value);
	};
	
	AsyncFromSyncIterator.prototype.return = function (value) {
	  return this._i.return ? unwrapAsyncFromSync(this._i, 'return', value) : Promise.resolve({ value: value, done: true });
	};
	
	AsyncFromSyncIterator.prototype.throw = function (value) {
	  return this._i.throw ? unwrapAsyncFromSync(this._i, 'throw', value) : Promise.reject(value);
	};
	
	function unwrapAsyncFromSync(iterator, fn, value) {
	  var step;
	  return new Promise(function (resolve) {
	    step = iterator[fn](value);
	    resolve(step.value);
	  }).then(function (value) {
	    return { value: value, done: step.done };
	  });
	}
	
	function forAwaitEach(source, callback, thisArg) {
	  var asyncIterator = createAsyncIterator(source);
	  if (asyncIterator) {
	    var i = 0;
	    return new Promise(function (resolve, reject) {
	      function next() {
	        asyncIterator.next().then(function (step) {
	          if (!step.done) {
	            Promise.resolve(callback.call(thisArg, step.value, i++, source)).then(next).catch(reject);
	          } else {
	            resolve();
	          }
	
	          return null;
	        }).catch(reject);
	
	        return null;
	      }
	      next();
	    });
	  }
	}
	


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var context = /*#__PURE__*/_react.default.createContext(null);
	
	context.displayName = 'NavbarContext';
	var _default = context;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(21).Buffer;
	
	/**
	 * This is a polyfill for the static method `isView` of `ArrayBuffer`, which is
	 * e.g. missing in IE 10.
	 *
	 * @api private
	 */
	if (
	    typeof ArrayBuffer !== 'undefined' &&
	    typeof ArrayBuffer.isView === 'undefined'
	) {
	    ArrayBuffer.isView = function(arg) {
	        return viewStrings.indexOf(Object.prototype.toString.call(arg)) > -1;
	    };
	}
	
	/**
	 * @api private
	 */
	var viewStrings = [
	    '[object Int8Array]',
	    '[object Uint8Array]',
	    '[object Uint8ClampedArray]',
	    '[object Int16Array]',
	    '[object Uint16Array]',
	    '[object Int32Array]',
	    '[object Uint32Array]',
	    '[object Float32Array]',
	    '[object Float64Array]',
	    '[object DataView]',
	];
	
	/**
	 * @api private
	 */
	function isEmptyData(data) {
	    if (typeof data === 'string') {
	        return data.length === 0;
	    }
	    return data.byteLength === 0;
	}
	
	/**
	 * @api private
	 */
	function convertToBuffer(data) {
	    if (typeof data === 'string') {
	        data = new Buffer(data, 'utf8');
	    }
	
	    if (ArrayBuffer.isView(data)) {
	        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
	    }
	
	    return new Uint8Array(data);
	}
	
	/**
	 * @api private
	 */
	module.exports = exports = {
	    isEmptyData: isEmptyData,
	    convertToBuffer: convertToBuffer,
	};


/***/ },
/* 59 */
[629, 12, 84],
/* 60 */
58,
/* 61 */
[629, 13, 94],
/* 62 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.execute = execute;
	exports.responsePathAsArray = responsePathAsArray;
	exports.addPath = addPath;
	exports.assertValidExecutionArguments = assertValidExecutionArguments;
	exports.buildExecutionContext = buildExecutionContext;
	exports.collectFields = collectFields;
	exports.buildResolveInfo = buildResolveInfo;
	exports.resolveFieldValueOrError = resolveFieldValueOrError;
	exports.getFieldDef = getFieldDef;
	exports.defaultFieldResolver = void 0;
	
	var _iterall = __webpack_require__(56);
	
	var _GraphQLError = __webpack_require__(9);
	
	var _locatedError = __webpack_require__(102);
	
	var _inspect = _interopRequireDefault(__webpack_require__(16));
	
	var _invariant = _interopRequireDefault(__webpack_require__(17));
	
	var _isInvalid = _interopRequireDefault(__webpack_require__(33));
	
	var _isNullish = _interopRequireDefault(__webpack_require__(105));
	
	var _isPromise = _interopRequireDefault(__webpack_require__(187));
	
	var _memoize = _interopRequireDefault(__webpack_require__(453));
	
	var _promiseForObject = _interopRequireDefault(__webpack_require__(454));
	
	var _promiseReduce = _interopRequireDefault(__webpack_require__(455));
	
	var _getOperationRootType = __webpack_require__(112);
	
	var _typeFromAST = __webpack_require__(29);
	
	var _kinds = __webpack_require__(11);
	
	var _values = __webpack_require__(103);
	
	var _definition = __webpack_require__(10);
	
	var _introspection = __webpack_require__(23);
	
	var _directives = __webpack_require__(19);
	
	var _validate = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function execute(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
	  /* eslint-enable no-redeclare */
	  // Extract arguments from object args if provided.
	  return arguments.length === 1 ? executeImpl(argsOrSchema.schema, argsOrSchema.document, argsOrSchema.rootValue, argsOrSchema.contextValue, argsOrSchema.variableValues, argsOrSchema.operationName, argsOrSchema.fieldResolver) : executeImpl(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);
	}
	
	function executeImpl(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
	  // If arguments are missing or incorrect, throw an error.
	  assertValidExecutionArguments(schema, document, variableValues); // If a valid execution context cannot be created due to incorrect arguments,
	  // a "Response" with only errors is returned.
	
	  var exeContext = buildExecutionContext(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver); // Return early errors if execution context failed.
	
	  if (Array.isArray(exeContext)) {
	    return {
	      errors: exeContext
	    };
	  } // Return a Promise that will eventually resolve to the data described by
	  // The "Response" section of the GraphQL specification.
	  //
	  // If errors are encountered while executing a GraphQL field, only that
	  // field and its descendants will be omitted, and sibling fields will still
	  // be executed. An execution which encounters errors will still result in a
	  // resolved Promise.
	
	
	  var data = executeOperation(exeContext, exeContext.operation, rootValue);
	  return buildResponse(exeContext, data);
	}
	/**
	 * Given a completed execution context and data, build the { errors, data }
	 * response defined by the "Response" section of the GraphQL specification.
	 */
	
	
	function buildResponse(exeContext, data) {
	  if ((0, _isPromise.default)(data)) {
	    return data.then(function (resolved) {
	      return buildResponse(exeContext, resolved);
	    });
	  }
	
	  return exeContext.errors.length === 0 ? {
	    data: data
	  } : {
	    errors: exeContext.errors,
	    data: data
	  };
	}
	/**
	 * Given a ResponsePath (found in the `path` entry in the information provided
	 * as the last argument to a field resolver), return an Array of the path keys.
	 */
	
	
	function responsePathAsArray(path) {
	  var flattened = [];
	  var curr = path;
	
	  while (curr) {
	    flattened.push(curr.key);
	    curr = curr.prev;
	  }
	
	  return flattened.reverse();
	}
	/**
	 * Given a ResponsePath and a key, return a new ResponsePath containing the
	 * new key.
	 */
	
	
	function addPath(prev, key) {
	  return {
	    prev: prev,
	    key: key
	  };
	}
	/**
	 * Essential assertions before executing to provide developer feedback for
	 * improper use of the GraphQL library.
	 */
	
	
	function assertValidExecutionArguments(schema, document, rawVariableValues) {
	  !document ? (0, _invariant.default)(0, 'Must provide document') : void 0; // If the schema used for execution is invalid, throw an error.
	
	  (0, _validate.assertValidSchema)(schema); // Variables, if provided, must be an object.
	
	  !(!rawVariableValues || _typeof(rawVariableValues) === 'object') ? (0, _invariant.default)(0, 'Variables must be provided as an Object where each property is a ' + 'variable value. Perhaps look to see if an unparsed JSON string ' + 'was provided.') : void 0;
	}
	/**
	 * Constructs a ExecutionContext object from the arguments passed to
	 * execute, which we will pass throughout the other execution methods.
	 *
	 * Throws a GraphQLError if a valid execution context cannot be created.
	 */
	
	
	function buildExecutionContext(schema, document, rootValue, contextValue, rawVariableValues, operationName, fieldResolver) {
	  var errors = [];
	  var operation;
	  var hasMultipleAssumedOperations = false;
	  var fragments = Object.create(null);
	
	  for (var i = 0; i < document.definitions.length; i++) {
	    var definition = document.definitions[i];
	
	    switch (definition.kind) {
	      case _kinds.Kind.OPERATION_DEFINITION:
	        if (!operationName && operation) {
	          hasMultipleAssumedOperations = true;
	        } else if (!operationName || definition.name && definition.name.value === operationName) {
	          operation = definition;
	        }
	
	        break;
	
	      case _kinds.Kind.FRAGMENT_DEFINITION:
	        fragments[definition.name.value] = definition;
	        break;
	    }
	  }
	
	  if (!operation) {
	    if (operationName) {
	      errors.push(new _GraphQLError.GraphQLError("Unknown operation named \"".concat(operationName, "\".")));
	    } else {
	      errors.push(new _GraphQLError.GraphQLError('Must provide an operation.'));
	    }
	  } else if (hasMultipleAssumedOperations) {
	    errors.push(new _GraphQLError.GraphQLError('Must provide operation name if query contains ' + 'multiple operations.'));
	  }
	
	  var variableValues;
	
	  if (operation) {
	    var coercedVariableValues = (0, _values.getVariableValues)(schema, operation.variableDefinitions || [], rawVariableValues || {});
	
	    if (coercedVariableValues.errors) {
	      errors.push.apply(errors, coercedVariableValues.errors);
	    } else {
	      variableValues = coercedVariableValues.coerced;
	    }
	  }
	
	  if (errors.length !== 0) {
	    return errors;
	  }
	
	  !operation ? (0, _invariant.default)(0, 'Has operation if no errors.') : void 0;
	  !variableValues ? (0, _invariant.default)(0, 'Has variables if no errors.') : void 0;
	  return {
	    schema: schema,
	    fragments: fragments,
	    rootValue: rootValue,
	    contextValue: contextValue,
	    operation: operation,
	    variableValues: variableValues,
	    fieldResolver: fieldResolver || defaultFieldResolver,
	    errors: errors
	  };
	}
	/**
	 * Implements the "Evaluating operations" section of the spec.
	 */
	
	
	function executeOperation(exeContext, operation, rootValue) {
	  var type = (0, _getOperationRootType.getOperationRootType)(exeContext.schema, operation);
	  var fields = collectFields(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
	  var path = undefined; // Errors from sub-fields of a NonNull type may propagate to the top level,
	  // at which point we still log the error and null the parent field, which
	  // in this case is the entire response.
	  //
	  // Similar to completeValueCatchingError.
	
	  try {
	    var result = operation.operation === 'mutation' ? executeFieldsSerially(exeContext, type, rootValue, path, fields) : executeFields(exeContext, type, rootValue, path, fields);
	
	    if ((0, _isPromise.default)(result)) {
	      return result.then(undefined, function (error) {
	        exeContext.errors.push(error);
	        return Promise.resolve(null);
	      });
	    }
	
	    return result;
	  } catch (error) {
	    exeContext.errors.push(error);
	    return null;
	  }
	}
	/**
	 * Implements the "Evaluating selection sets" section of the spec
	 * for "write" mode.
	 */
	
	
	function executeFieldsSerially(exeContext, parentType, sourceValue, path, fields) {
	  return (0, _promiseReduce.default)(Object.keys(fields), function (results, responseName) {
	    var fieldNodes = fields[responseName];
	    var fieldPath = addPath(path, responseName);
	    var result = resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
	
	    if (result === undefined) {
	      return results;
	    }
	
	    if ((0, _isPromise.default)(result)) {
	      return result.then(function (resolvedResult) {
	        results[responseName] = resolvedResult;
	        return results;
	      });
	    }
	
	    results[responseName] = result;
	    return results;
	  }, Object.create(null));
	}
	/**
	 * Implements the "Evaluating selection sets" section of the spec
	 * for "read" mode.
	 */
	
	
	function executeFields(exeContext, parentType, sourceValue, path, fields) {
	  var results = Object.create(null);
	  var containsPromise = false;
	
	  for (var i = 0, keys = Object.keys(fields); i < keys.length; ++i) {
	    var responseName = keys[i];
	    var fieldNodes = fields[responseName];
	    var fieldPath = addPath(path, responseName);
	    var result = resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
	
	    if (result !== undefined) {
	      results[responseName] = result;
	
	      if (!containsPromise && (0, _isPromise.default)(result)) {
	        containsPromise = true;
	      }
	    }
	  } // If there are no promises, we can just return the object
	
	
	  if (!containsPromise) {
	    return results;
	  } // Otherwise, results is a map from field name to the result of resolving that
	  // field, which is possibly a promise. Return a promise that will return this
	  // same map, but with any promises replaced with the values they resolved to.
	
	
	  return (0, _promiseForObject.default)(results);
	}
	/**
	 * Given a selectionSet, adds all of the fields in that selection to
	 * the passed in map of fields, and returns it at the end.
	 *
	 * CollectFields requires the "runtime type" of an object. For a field which
	 * returns an Interface or Union type, the "runtime type" will be the actual
	 * Object type returned by that field.
	 */
	
	
	function collectFields(exeContext, runtimeType, selectionSet, fields, visitedFragmentNames) {
	  for (var i = 0; i < selectionSet.selections.length; i++) {
	    var selection = selectionSet.selections[i];
	
	    switch (selection.kind) {
	      case _kinds.Kind.FIELD:
	        if (!shouldIncludeNode(exeContext, selection)) {
	          continue;
	        }
	
	        var name = getFieldEntryKey(selection);
	
	        if (!fields[name]) {
	          fields[name] = [];
	        }
	
	        fields[name].push(selection);
	        break;
	
	      case _kinds.Kind.INLINE_FRAGMENT:
	        if (!shouldIncludeNode(exeContext, selection) || !doesFragmentConditionMatch(exeContext, selection, runtimeType)) {
	          continue;
	        }
	
	        collectFields(exeContext, runtimeType, selection.selectionSet, fields, visitedFragmentNames);
	        break;
	
	      case _kinds.Kind.FRAGMENT_SPREAD:
	        var fragName = selection.name.value;
	
	        if (visitedFragmentNames[fragName] || !shouldIncludeNode(exeContext, selection)) {
	          continue;
	        }
	
	        visitedFragmentNames[fragName] = true;
	        var fragment = exeContext.fragments[fragName];
	
	        if (!fragment || !doesFragmentConditionMatch(exeContext, fragment, runtimeType)) {
	          continue;
	        }
	
	        collectFields(exeContext, runtimeType, fragment.selectionSet, fields, visitedFragmentNames);
	        break;
	    }
	  }
	
	  return fields;
	}
	/**
	 * Determines if a field should be included based on the @include and @skip
	 * directives, where @skip has higher precidence than @include.
	 */
	
	
	function shouldIncludeNode(exeContext, node) {
	  var skip = (0, _values.getDirectiveValues)(_directives.GraphQLSkipDirective, node, exeContext.variableValues);
	
	  if (skip && skip.if === true) {
	    return false;
	  }
	
	  var include = (0, _values.getDirectiveValues)(_directives.GraphQLIncludeDirective, node, exeContext.variableValues);
	
	  if (include && include.if === false) {
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Determines if a fragment is applicable to the given type.
	 */
	
	
	function doesFragmentConditionMatch(exeContext, fragment, type) {
	  var typeConditionNode = fragment.typeCondition;
	
	  if (!typeConditionNode) {
	    return true;
	  }
	
	  var conditionalType = (0, _typeFromAST.typeFromAST)(exeContext.schema, typeConditionNode);
	
	  if (conditionalType === type) {
	    return true;
	  }
	
	  if ((0, _definition.isAbstractType)(conditionalType)) {
	    return exeContext.schema.isPossibleType(conditionalType, type);
	  }
	
	  return false;
	}
	/**
	 * Implements the logic to compute the key of a given field's entry
	 */
	
	
	function getFieldEntryKey(node) {
	  return node.alias ? node.alias.value : node.name.value;
	}
	/**
	 * Resolves the field on the given source object. In particular, this
	 * figures out the value that the field returns by calling its resolve function,
	 * then calls completeValue to complete promises, serialize scalars, or execute
	 * the sub-selection-set for objects.
	 */
	
	
	function resolveField(exeContext, parentType, source, fieldNodes, path) {
	  var fieldNode = fieldNodes[0];
	  var fieldName = fieldNode.name.value;
	  var fieldDef = getFieldDef(exeContext.schema, parentType, fieldName);
	
	  if (!fieldDef) {
	    return;
	  }
	
	  var resolveFn = fieldDef.resolve || exeContext.fieldResolver;
	  var info = buildResolveInfo(exeContext, fieldDef, fieldNodes, parentType, path); // Get the resolve function, regardless of if its result is normal
	  // or abrupt (error).
	
	  var result = resolveFieldValueOrError(exeContext, fieldDef, fieldNodes, resolveFn, source, info);
	  return completeValueCatchingError(exeContext, fieldDef.type, fieldNodes, info, path, result);
	}
	
	function buildResolveInfo(exeContext, fieldDef, fieldNodes, parentType, path) {
	  // The resolve function's optional fourth argument is a collection of
	  // information about the current execution state.
	  return {
	    fieldName: fieldDef.name,
	    fieldNodes: fieldNodes,
	    returnType: fieldDef.type,
	    parentType: parentType,
	    path: path,
	    schema: exeContext.schema,
	    fragments: exeContext.fragments,
	    rootValue: exeContext.rootValue,
	    operation: exeContext.operation,
	    variableValues: exeContext.variableValues
	  };
	} // Isolates the "ReturnOrAbrupt" behavior to not de-opt the `resolveField`
	// function. Returns the result of resolveFn or the abrupt-return Error object.
	
	
	function resolveFieldValueOrError(exeContext, fieldDef, fieldNodes, resolveFn, source, info) {
	  try {
	    // Build a JS object of arguments from the field.arguments AST, using the
	    // variables scope to fulfill any variable references.
	    // TODO: find a way to memoize, in case this field is within a List type.
	    var args = (0, _values.getArgumentValues)(fieldDef, fieldNodes[0], exeContext.variableValues); // The resolve function's optional third argument is a context value that
	    // is provided to every resolve function within an execution. It is commonly
	    // used to represent an authenticated user, or request-specific caches.
	
	    var _contextValue = exeContext.contextValue;
	    var result = resolveFn(source, args, _contextValue, info);
	    return (0, _isPromise.default)(result) ? result.then(undefined, asErrorInstance) : result;
	  } catch (error) {
	    return asErrorInstance(error);
	  }
	} // Sometimes a non-error is thrown, wrap it as an Error instance to ensure a
	// consistent Error interface.
	
	
	function asErrorInstance(error) {
	  return error instanceof Error ? error : new Error(error || undefined);
	} // This is a small wrapper around completeValue which detects and logs errors
	// in the execution context.
	
	
	function completeValueCatchingError(exeContext, returnType, fieldNodes, info, path, result) {
	  try {
	    var completed;
	
	    if ((0, _isPromise.default)(result)) {
	      completed = result.then(function (resolved) {
	        return completeValue(exeContext, returnType, fieldNodes, info, path, resolved);
	      });
	    } else {
	      completed = completeValue(exeContext, returnType, fieldNodes, info, path, result);
	    }
	
	    if ((0, _isPromise.default)(completed)) {
	      // Note: we don't rely on a `catch` method, but we do expect "thenable"
	      // to take a second callback for the error case.
	      return completed.then(undefined, function (error) {
	        return handleFieldError(error, fieldNodes, path, returnType, exeContext);
	      });
	    }
	
	    return completed;
	  } catch (error) {
	    return handleFieldError(error, fieldNodes, path, returnType, exeContext);
	  }
	}
	
	function handleFieldError(rawError, fieldNodes, path, returnType, exeContext) {
	  var error = (0, _locatedError.locatedError)(asErrorInstance(rawError), fieldNodes, responsePathAsArray(path)); // If the field type is non-nullable, then it is resolved without any
	  // protection from errors, however it still properly locates the error.
	
	  if ((0, _definition.isNonNullType)(returnType)) {
	    throw error;
	  } // Otherwise, error protection is applied, logging the error and resolving
	  // a null value for this field if one is encountered.
	
	
	  exeContext.errors.push(error);
	  return null;
	}
	/**
	 * Implements the instructions for completeValue as defined in the
	 * "Field entries" section of the spec.
	 *
	 * If the field type is Non-Null, then this recursively completes the value
	 * for the inner type. It throws a field error if that completion returns null,
	 * as per the "Nullability" section of the spec.
	 *
	 * If the field type is a List, then this recursively completes the value
	 * for the inner type on each item in the list.
	 *
	 * If the field type is a Scalar or Enum, ensures the completed value is a legal
	 * value of the type by calling the `serialize` method of GraphQL type
	 * definition.
	 *
	 * If the field is an abstract type, determine the runtime type of the value
	 * and then complete based on that type
	 *
	 * Otherwise, the field type expects a sub-selection set, and will complete the
	 * value by evaluating all sub-selections.
	 */
	
	
	function completeValue(exeContext, returnType, fieldNodes, info, path, result) {
	  // If result is an Error, throw a located error.
	  if (result instanceof Error) {
	    throw result;
	  } // If field type is NonNull, complete for inner type, and throw field error
	  // if result is null.
	
	
	  if ((0, _definition.isNonNullType)(returnType)) {
	    var completed = completeValue(exeContext, returnType.ofType, fieldNodes, info, path, result);
	
	    if (completed === null) {
	      throw new Error("Cannot return null for non-nullable field ".concat(info.parentType.name, ".").concat(info.fieldName, "."));
	    }
	
	    return completed;
	  } // If result value is null-ish (null, undefined, or NaN) then return null.
	
	
	  if ((0, _isNullish.default)(result)) {
	    return null;
	  } // If field type is List, complete each item in the list with the inner type
	
	
	  if ((0, _definition.isListType)(returnType)) {
	    return completeListValue(exeContext, returnType, fieldNodes, info, path, result);
	  } // If field type is a leaf type, Scalar or Enum, serialize to a valid value,
	  // returning null if serialization is not possible.
	
	
	  if ((0, _definition.isLeafType)(returnType)) {
	    return completeLeafValue(returnType, result);
	  } // If field type is an abstract type, Interface or Union, determine the
	  // runtime Object type and complete for that type.
	
	
	  if ((0, _definition.isAbstractType)(returnType)) {
	    return completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result);
	  } // If field type is Object, execute and complete all sub-selections.
	
	
	  if ((0, _definition.isObjectType)(returnType)) {
	    return completeObjectValue(exeContext, returnType, fieldNodes, info, path, result);
	  } // Not reachable. All possible output types have been considered.
	
	  /* istanbul ignore next */
	
	
	  throw new Error("Cannot complete value of unexpected type \"".concat((0, _inspect.default)(returnType), "\"."));
	}
	/**
	 * Complete a list value by completing each item in the list with the
	 * inner type
	 */
	
	
	function completeListValue(exeContext, returnType, fieldNodes, info, path, result) {
	  !(0, _iterall.isCollection)(result) ? (0, _invariant.default)(0, "Expected Iterable, but did not find one for field ".concat(info.parentType.name, ".").concat(info.fieldName, ".")) : void 0; // This is specified as a simple map, however we're optimizing the path
	  // where the list contains no Promises by avoiding creating another Promise.
	
	  var itemType = returnType.ofType;
	  var containsPromise = false;
	  var completedResults = [];
	  (0, _iterall.forEach)(result, function (item, index) {
	    // No need to modify the info object containing the path,
	    // since from here on it is not ever accessed by resolver functions.
	    var fieldPath = addPath(path, index);
	    var completedItem = completeValueCatchingError(exeContext, itemType, fieldNodes, info, fieldPath, item);
	
	    if (!containsPromise && (0, _isPromise.default)(completedItem)) {
	      containsPromise = true;
	    }
	
	    completedResults.push(completedItem);
	  });
	  return containsPromise ? Promise.all(completedResults) : completedResults;
	}
	/**
	 * Complete a Scalar or Enum by serializing to a valid value, returning
	 * null if serialization is not possible.
	 */
	
	
	function completeLeafValue(returnType, result) {
	  !returnType.serialize ? (0, _invariant.default)(0, 'Missing serialize method on type') : void 0;
	  var serializedResult = returnType.serialize(result);
	
	  if ((0, _isInvalid.default)(serializedResult)) {
	    throw new Error("Expected a value of type \"".concat((0, _inspect.default)(returnType), "\" but ") + "received: ".concat((0, _inspect.default)(result)));
	  }
	
	  return serializedResult;
	}
	/**
	 * Complete a value of an abstract type by determining the runtime object type
	 * of that value, then complete the value for that type.
	 */
	
	
	function completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result) {
	  var runtimeType = returnType.resolveType ? returnType.resolveType(result, exeContext.contextValue, info) : defaultResolveTypeFn(result, exeContext.contextValue, info, returnType);
	
	  if ((0, _isPromise.default)(runtimeType)) {
	    return runtimeType.then(function (resolvedRuntimeType) {
	      return completeObjectValue(exeContext, ensureValidRuntimeType(resolvedRuntimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
	    });
	  }
	
	  return completeObjectValue(exeContext, ensureValidRuntimeType(runtimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
	}
	
	function ensureValidRuntimeType(runtimeTypeOrName, exeContext, returnType, fieldNodes, info, result) {
	  var runtimeType = typeof runtimeTypeOrName === 'string' ? exeContext.schema.getType(runtimeTypeOrName) : runtimeTypeOrName;
	
	  if (!(0, _definition.isObjectType)(runtimeType)) {
	    throw new _GraphQLError.GraphQLError("Abstract type ".concat(returnType.name, " must resolve to an Object type at ") + "runtime for field ".concat(info.parentType.name, ".").concat(info.fieldName, " with ") + "value ".concat((0, _inspect.default)(result), ", received \"").concat((0, _inspect.default)(runtimeType), "\". ") + "Either the ".concat(returnType.name, " type should provide a \"resolveType\" ") + 'function or each possible type should provide an ' + '"isTypeOf" function.', fieldNodes);
	  }
	
	  if (!exeContext.schema.isPossibleType(returnType, runtimeType)) {
	    throw new _GraphQLError.GraphQLError("Runtime Object type \"".concat(runtimeType.name, "\" is not a possible type ") + "for \"".concat(returnType.name, "\"."), fieldNodes);
	  }
	
	  return runtimeType;
	}
	/**
	 * Complete an Object value by executing all sub-selections.
	 */
	
	
	function completeObjectValue(exeContext, returnType, fieldNodes, info, path, result) {
	  // If there is an isTypeOf predicate function, call it with the
	  // current result. If isTypeOf returns false, then raise an error rather
	  // than continuing execution.
	  if (returnType.isTypeOf) {
	    var isTypeOf = returnType.isTypeOf(result, exeContext.contextValue, info);
	
	    if ((0, _isPromise.default)(isTypeOf)) {
	      return isTypeOf.then(function (resolvedIsTypeOf) {
	        if (!resolvedIsTypeOf) {
	          throw invalidReturnTypeError(returnType, result, fieldNodes);
	        }
	
	        return collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
	      });
	    }
	
	    if (!isTypeOf) {
	      throw invalidReturnTypeError(returnType, result, fieldNodes);
	    }
	  }
	
	  return collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
	}
	
	function invalidReturnTypeError(returnType, result, fieldNodes) {
	  return new _GraphQLError.GraphQLError("Expected value of type \"".concat(returnType.name, "\" but got: ").concat((0, _inspect.default)(result), "."), fieldNodes);
	}
	
	function collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result) {
	  // Collect sub-fields to execute to complete this value.
	  var subFieldNodes = collectSubfields(exeContext, returnType, fieldNodes);
	  return executeFields(exeContext, returnType, result, path, subFieldNodes);
	}
	/**
	 * A memoized collection of relevant subfields with regard to the return
	 * type. Memoizing ensures the subfields are not repeatedly calculated, which
	 * saves overhead when resolving lists of values.
	 */
	
	
	var collectSubfields = (0, _memoize.default)(_collectSubfields);
	
	function _collectSubfields(exeContext, returnType, fieldNodes) {
	  var subFieldNodes = Object.create(null);
	  var visitedFragmentNames = Object.create(null);
	
	  for (var i = 0; i < fieldNodes.length; i++) {
	    var selectionSet = fieldNodes[i].selectionSet;
	
	    if (selectionSet) {
	      subFieldNodes = collectFields(exeContext, returnType, selectionSet, subFieldNodes, visitedFragmentNames);
	    }
	  }
	
	  return subFieldNodes;
	}
	/**
	 * If a resolveType function is not given, then a default resolve behavior is
	 * used which attempts two strategies:
	 *
	 * First, See if the provided value has a `__typename` field defined, if so, use
	 * that value as name of the resolved type.
	 *
	 * Otherwise, test each possible type for the abstract type by calling
	 * isTypeOf for the object being coerced, returning the first type that matches.
	 */
	
	
	function defaultResolveTypeFn(value, contextValue, info, abstractType) {
	  // First, look for `__typename`.
	  if (value !== null && _typeof(value) === 'object' && typeof value.__typename === 'string') {
	    return value.__typename;
	  } // Otherwise, test each possible type.
	
	
	  var possibleTypes = info.schema.getPossibleTypes(abstractType);
	  var promisedIsTypeOfResults = [];
	
	  for (var i = 0; i < possibleTypes.length; i++) {
	    var type = possibleTypes[i];
	
	    if (type.isTypeOf) {
	      var isTypeOfResult = type.isTypeOf(value, contextValue, info);
	
	      if ((0, _isPromise.default)(isTypeOfResult)) {
	        promisedIsTypeOfResults[i] = isTypeOfResult;
	      } else if (isTypeOfResult) {
	        return type;
	      }
	    }
	  }
	
	  if (promisedIsTypeOfResults.length) {
	    return Promise.all(promisedIsTypeOfResults).then(function (isTypeOfResults) {
	      for (var _i = 0; _i < isTypeOfResults.length; _i++) {
	        if (isTypeOfResults[_i]) {
	          return possibleTypes[_i];
	        }
	      }
	    });
	  }
	}
	/**
	 * If a resolve function is not given, then a default resolve behavior is used
	 * which takes the property of the source object of the same name as the field
	 * and returns it as the result, or if it's a function, returns the result
	 * of calling that function while passing along args and context value.
	 */
	
	
	var defaultFieldResolver = function defaultFieldResolver(source, args, contextValue, info) {
	  // ensure source is a value for which property access is acceptable.
	  if (_typeof(source) === 'object' || typeof source === 'function') {
	    var property = source[info.fieldName];
	
	    if (typeof property === 'function') {
	      return source[info.fieldName](args, contextValue, info);
	    }
	
	    return property;
	  }
	};
	/**
	 * This method looks up the field on the given type defintion.
	 * It has special casing for the two introspection fields, __schema
	 * and __typename. __typename is special because it can always be
	 * queried as a field, even in situations where no other fields
	 * are allowed, like on a Union. __schema could get automatically
	 * added to the query type, but that would require mutating type
	 * definitions, which would cause issues.
	 */
	
	
	exports.defaultFieldResolver = defaultFieldResolver;
	
	function getFieldDef(schema, parentType, fieldName) {
	  if (fieldName === _introspection.SchemaMetaFieldDef.name && schema.getQueryType() === parentType) {
	    return _introspection.SchemaMetaFieldDef;
	  } else if (fieldName === _introspection.TypeMetaFieldDef.name && schema.getQueryType() === parentType) {
	    return _introspection.TypeMetaFieldDef;
	  } else if (fieldName === _introspection.TypeNameMetaFieldDef.name) {
	    return _introspection.TypeNameMetaFieldDef;
	  }
	
	  return parentType.getFields()[fieldName];
	}

/***/ },
/* 64 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = applyToStringTag;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * The `applyToStringTag()` function checks first to see if the runtime
	 * supports the `Symbol` class and then if the `Symbol.toStringTag` constant
	 * is defined as a `Symbol` instance. If both conditions are met, the
	 * Symbol.toStringTag property is defined as a getter that returns the
	 * supplied class constructor's name.
	 *
	 * @method applyToStringTag
	 *
	 * @param {Class<any>} classObject a class such as Object, String, Number but
	 * typically one of your own creation through the class keyword; `class A {}`,
	 * for example.
	 */
	function applyToStringTag(classObject) {
	  if (typeof Symbol === 'function' && Symbol.toStringTag) {
	    Object.defineProperty(classObject.prototype, Symbol.toStringTag, {
	      get: function get() {
	        return this.constructor.name;
	      }
	    });
	  }
	}

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isDefinitionNode = isDefinitionNode;
	exports.isExecutableDefinitionNode = isExecutableDefinitionNode;
	exports.isSelectionNode = isSelectionNode;
	exports.isValueNode = isValueNode;
	exports.isTypeNode = isTypeNode;
	exports.isTypeSystemDefinitionNode = isTypeSystemDefinitionNode;
	exports.isTypeDefinitionNode = isTypeDefinitionNode;
	exports.isTypeSystemExtensionNode = isTypeSystemExtensionNode;
	exports.isTypeExtensionNode = isTypeExtensionNode;
	
	var _kinds = __webpack_require__(11);
	
	/**
	 * Copyright (c) 2018-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function isDefinitionNode(node) {
	  return isExecutableDefinitionNode(node) || isTypeSystemDefinitionNode(node) || isTypeSystemExtensionNode(node);
	}
	
	function isExecutableDefinitionNode(node) {
	  return node.kind === _kinds.Kind.OPERATION_DEFINITION || node.kind === _kinds.Kind.FRAGMENT_DEFINITION;
	}
	
	function isSelectionNode(node) {
	  return node.kind === _kinds.Kind.FIELD || node.kind === _kinds.Kind.FRAGMENT_SPREAD || node.kind === _kinds.Kind.INLINE_FRAGMENT;
	}
	
	function isValueNode(node) {
	  return node.kind === _kinds.Kind.VARIABLE || node.kind === _kinds.Kind.INT || node.kind === _kinds.Kind.FLOAT || node.kind === _kinds.Kind.STRING || node.kind === _kinds.Kind.BOOLEAN || node.kind === _kinds.Kind.NULL || node.kind === _kinds.Kind.ENUM || node.kind === _kinds.Kind.LIST || node.kind === _kinds.Kind.OBJECT;
	}
	
	function isTypeNode(node) {
	  return node.kind === _kinds.Kind.NAMED_TYPE || node.kind === _kinds.Kind.LIST_TYPE || node.kind === _kinds.Kind.NON_NULL_TYPE;
	}
	
	function isTypeSystemDefinitionNode(node) {
	  return node.kind === _kinds.Kind.SCHEMA_DEFINITION || isTypeDefinitionNode(node) || node.kind === _kinds.Kind.DIRECTIVE_DEFINITION;
	}
	
	function isTypeDefinitionNode(node) {
	  return node.kind === _kinds.Kind.SCALAR_TYPE_DEFINITION || node.kind === _kinds.Kind.OBJECT_TYPE_DEFINITION || node.kind === _kinds.Kind.INTERFACE_TYPE_DEFINITION || node.kind === _kinds.Kind.UNION_TYPE_DEFINITION || node.kind === _kinds.Kind.ENUM_TYPE_DEFINITION || node.kind === _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION;
	}
	
	function isTypeSystemExtensionNode(node) {
	  return node.kind === _kinds.Kind.SCHEMA_EXTENSION || isTypeExtensionNode(node);
	}
	
	function isTypeExtensionNode(node) {
	  return node.kind === _kinds.Kind.SCALAR_TYPE_EXTENSION || node.kind === _kinds.Kind.OBJECT_TYPE_EXTENSION || node.kind === _kinds.Kind.INTERFACE_TYPE_EXTENSION || node.kind === _kinds.Kind.UNION_TYPE_EXTENSION || node.kind === _kinds.Kind.ENUM_TYPE_EXTENSION || node.kind === _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION;
	}

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateSchema = validateSchema;
	exports.assertValidSchema = assertValidSchema;
	
	var _definition = __webpack_require__(10);
	
	var _directives = __webpack_require__(19);
	
	var _introspection = __webpack_require__(23);
	
	var _schema = __webpack_require__(37);
	
	var _inspect = _interopRequireDefault(__webpack_require__(16));
	
	var _find = _interopRequireDefault(__webpack_require__(51));
	
	var _invariant = _interopRequireDefault(__webpack_require__(17));
	
	var _objectValues = _interopRequireDefault(__webpack_require__(34));
	
	var _GraphQLError = __webpack_require__(9);
	
	var _assertValidName = __webpack_require__(190);
	
	var _typeComparators = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Implements the "Type Validation" sub-sections of the specification's
	 * "Type System" section.
	 *
	 * Validation runs synchronously, returning an array of encountered errors, or
	 * an empty array if no errors were encountered and the Schema is valid.
	 */
	function validateSchema(schema) {
	  // First check to ensure the provided value is in fact a GraphQLSchema.
	  !(0, _schema.isSchema)(schema) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(schema), " to be a GraphQL schema.")) : void 0; // If this Schema has already been validated, return the previous results.
	
	  if (schema.__validationErrors) {
	    return schema.__validationErrors;
	  } // Validate the schema, producing a list of errors.
	
	
	  var context = new SchemaValidationContext(schema);
	  validateRootTypes(context);
	  validateDirectives(context);
	  validateTypes(context); // Persist the results of validation before returning to ensure validation
	  // does not run multiple times for this schema.
	
	  var errors = context.getErrors();
	  schema.__validationErrors = errors;
	  return errors;
	}
	/**
	 * Utility function which asserts a schema is valid by throwing an error if
	 * it is invalid.
	 */
	
	
	function assertValidSchema(schema) {
	  var errors = validateSchema(schema);
	
	  if (errors.length !== 0) {
	    throw new Error(errors.map(function (error) {
	      return error.message;
	    }).join('\n\n'));
	  }
	}
	
	var SchemaValidationContext =
	/*#__PURE__*/
	function () {
	  function SchemaValidationContext(schema) {
	    _defineProperty(this, "_errors", void 0);
	
	    _defineProperty(this, "schema", void 0);
	
	    this._errors = [];
	    this.schema = schema;
	  }
	
	  var _proto = SchemaValidationContext.prototype;
	
	  _proto.reportError = function reportError(message, nodes) {
	    var _nodes = (Array.isArray(nodes) ? nodes : [nodes]).filter(Boolean);
	
	    this.addError(new _GraphQLError.GraphQLError(message, _nodes));
	  };
	
	  _proto.addError = function addError(error) {
	    this._errors.push(error);
	  };
	
	  _proto.getErrors = function getErrors() {
	    return this._errors;
	  };
	
	  return SchemaValidationContext;
	}();
	
	function validateRootTypes(context) {
	  var schema = context.schema;
	  var queryType = schema.getQueryType();
	
	  if (!queryType) {
	    context.reportError("Query root type must be provided.", schema.astNode);
	  } else if (!(0, _definition.isObjectType)(queryType)) {
	    context.reportError("Query root type must be Object type, it cannot be ".concat((0, _inspect.default)(queryType), "."), getOperationTypeNode(schema, queryType, 'query'));
	  }
	
	  var mutationType = schema.getMutationType();
	
	  if (mutationType && !(0, _definition.isObjectType)(mutationType)) {
	    context.reportError('Mutation root type must be Object type if provided, it cannot be ' + "".concat((0, _inspect.default)(mutationType), "."), getOperationTypeNode(schema, mutationType, 'mutation'));
	  }
	
	  var subscriptionType = schema.getSubscriptionType();
	
	  if (subscriptionType && !(0, _definition.isObjectType)(subscriptionType)) {
	    context.reportError('Subscription root type must be Object type if provided, it cannot be ' + "".concat((0, _inspect.default)(subscriptionType), "."), getOperationTypeNode(schema, subscriptionType, 'subscription'));
	  }
	}
	
	function getOperationTypeNode(schema, type, operation) {
	  var operationNodes = getAllSubNodes(schema, function (node) {
	    return node.operationTypes;
	  });
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = operationNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var node = _step.value;
	
	      if (node.operation === operation) {
	        return node.type;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return != null) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return type.astNode;
	}
	
	function validateDirectives(context) {
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = context.schema.getDirectives()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var directive = _step2.value;
	
	      // Ensure all directives are in fact GraphQL directives.
	      if (!(0, _directives.isDirective)(directive)) {
	        context.reportError("Expected directive but got: ".concat((0, _inspect.default)(directive), "."), directive && directive.astNode);
	        continue;
	      } // Ensure they are named correctly.
	
	
	      validateName(context, directive); // TODO: Ensure proper locations.
	      // Ensure the arguments are valid.
	
	      var argNames = Object.create(null);
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = directive.args[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var arg = _step3.value;
	          var argName = arg.name; // Ensure they are named correctly.
	
	          validateName(context, arg); // Ensure they are unique per directive.
	
	          if (argNames[argName]) {
	            context.reportError("Argument @".concat(directive.name, "(").concat(argName, ":) can only be defined once."), getAllDirectiveArgNodes(directive, argName));
	            continue;
	          }
	
	          argNames[argName] = true; // Ensure the type is an input type.
	
	          if (!(0, _definition.isInputType)(arg.type)) {
	            context.reportError("The type of @".concat(directive.name, "(").concat(argName, ":) must be Input Type ") + "but got: ".concat((0, _inspect.default)(arg.type), "."), getDirectiveArgTypeNode(directive, argName));
	          }
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	}
	
	function validateName(context, node) {
	  // If a schema explicitly allows some legacy name which is no longer valid,
	  // allow it to be assumed valid.
	  if (context.schema.__allowedLegacyNames.indexOf(node.name) !== -1) {
	    return;
	  } // Ensure names are valid, however introspection types opt out.
	
	
	  var error = (0, _assertValidName.isValidNameError)(node.name, node.astNode || undefined);
	
	  if (error) {
	    context.addError(error);
	  }
	}
	
	function validateTypes(context) {
	  var typeMap = context.schema.getTypeMap();
	  var _iteratorNormalCompletion4 = true;
	  var _didIteratorError4 = false;
	  var _iteratorError4 = undefined;
	
	  try {
	    for (var _iterator4 = (0, _objectValues.default)(typeMap)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	      var type = _step4.value;
	
	      // Ensure all provided types are in fact GraphQL type.
	      if (!(0, _definition.isNamedType)(type)) {
	        context.reportError("Expected GraphQL named type but got: ".concat((0, _inspect.default)(type), "."), type && type.astNode);
	        continue;
	      } // Ensure it is named correctly (excluding introspection types).
	
	
	      if (!(0, _introspection.isIntrospectionType)(type)) {
	        validateName(context, type);
	      }
	
	      if ((0, _definition.isObjectType)(type)) {
	        // Ensure fields are valid
	        validateFields(context, type); // Ensure objects implement the interfaces they claim to.
	
	        validateObjectInterfaces(context, type);
	      } else if ((0, _definition.isInterfaceType)(type)) {
	        // Ensure fields are valid.
	        validateFields(context, type);
	      } else if ((0, _definition.isUnionType)(type)) {
	        // Ensure Unions include valid member types.
	        validateUnionMembers(context, type);
	      } else if ((0, _definition.isEnumType)(type)) {
	        // Ensure Enums have valid values.
	        validateEnumValues(context, type);
	      } else if ((0, _definition.isInputObjectType)(type)) {
	        // Ensure Input Object fields are valid.
	        validateInputFields(context, type);
	      }
	    }
	  } catch (err) {
	    _didIteratorError4 = true;
	    _iteratorError4 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
	        _iterator4.return();
	      }
	    } finally {
	      if (_didIteratorError4) {
	        throw _iteratorError4;
	      }
	    }
	  }
	}
	
	function validateFields(context, type) {
	  var fields = (0, _objectValues.default)(type.getFields()); // Objects and Interfaces both must define one or more fields.
	
	  if (fields.length === 0) {
	    context.reportError("Type ".concat(type.name, " must define one or more fields."), getAllNodes(type));
	  }
	
	  var _iteratorNormalCompletion5 = true;
	  var _didIteratorError5 = false;
	  var _iteratorError5 = undefined;
	
	  try {
	    for (var _iterator5 = fields[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	      var field = _step5.value;
	      // Ensure they are named correctly.
	      validateName(context, field); // Ensure they were defined at most once.
	
	      var fieldNodes = getAllFieldNodes(type, field.name);
	
	      if (fieldNodes.length > 1) {
	        context.reportError("Field ".concat(type.name, ".").concat(field.name, " can only be defined once."), fieldNodes);
	        continue;
	      } // Ensure the type is an output type
	
	
	      if (!(0, _definition.isOutputType)(field.type)) {
	        context.reportError("The type of ".concat(type.name, ".").concat(field.name, " must be Output Type ") + "but got: ".concat((0, _inspect.default)(field.type), "."), getFieldTypeNode(type, field.name));
	      } // Ensure the arguments are valid
	
	
	      var argNames = Object.create(null);
	      var _iteratorNormalCompletion6 = true;
	      var _didIteratorError6 = false;
	      var _iteratorError6 = undefined;
	
	      try {
	        for (var _iterator6 = field.args[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	          var arg = _step6.value;
	          var argName = arg.name; // Ensure they are named correctly.
	
	          validateName(context, arg); // Ensure they are unique per field.
	
	          if (argNames[argName]) {
	            context.reportError("Field argument ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) can only ") + 'be defined once.', getAllFieldArgNodes(type, field.name, argName));
	          }
	
	          argNames[argName] = true; // Ensure the type is an input type
	
	          if (!(0, _definition.isInputType)(arg.type)) {
	            context.reportError("The type of ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) must be Input ") + "Type but got: ".concat((0, _inspect.default)(arg.type), "."), getFieldArgTypeNode(type, field.name, argName));
	          }
	        }
	      } catch (err) {
	        _didIteratorError6 = true;
	        _iteratorError6 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
	            _iterator6.return();
	          }
	        } finally {
	          if (_didIteratorError6) {
	            throw _iteratorError6;
	          }
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError5 = true;
	    _iteratorError5 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
	        _iterator5.return();
	      }
	    } finally {
	      if (_didIteratorError5) {
	        throw _iteratorError5;
	      }
	    }
	  }
	}
	
	function validateObjectInterfaces(context, object) {
	  var implementedTypeNames = Object.create(null);
	  var _iteratorNormalCompletion7 = true;
	  var _didIteratorError7 = false;
	  var _iteratorError7 = undefined;
	
	  try {
	    for (var _iterator7 = object.getInterfaces()[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	      var iface = _step7.value;
	
	      if (!(0, _definition.isInterfaceType)(iface)) {
	        context.reportError("Type ".concat((0, _inspect.default)(object), " must only implement Interface types, ") + "it cannot implement ".concat((0, _inspect.default)(iface), "."), getImplementsInterfaceNode(object, iface));
	        continue;
	      }
	
	      if (implementedTypeNames[iface.name]) {
	        context.reportError("Type ".concat(object.name, " can only implement ").concat(iface.name, " once."), getAllImplementsInterfaceNodes(object, iface));
	        continue;
	      }
	
	      implementedTypeNames[iface.name] = true;
	      validateObjectImplementsInterface(context, object, iface);
	    }
	  } catch (err) {
	    _didIteratorError7 = true;
	    _iteratorError7 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
	        _iterator7.return();
	      }
	    } finally {
	      if (_didIteratorError7) {
	        throw _iteratorError7;
	      }
	    }
	  }
	}
	
	function validateObjectImplementsInterface(context, object, iface) {
	  var objectFieldMap = object.getFields();
	  var ifaceFieldMap = iface.getFields(); // Assert each interface field is implemented.
	
	  var _arr = Object.keys(ifaceFieldMap);
	
	  for (var _i = 0; _i < _arr.length; _i++) {
	    var fieldName = _arr[_i];
	    var objectField = objectFieldMap[fieldName];
	    var ifaceField = ifaceFieldMap[fieldName]; // Assert interface field exists on object.
	
	    if (!objectField) {
	      context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expected but ") + "".concat(object.name, " does not provide it."), [getFieldNode(iface, fieldName)].concat(getAllNodes(object)));
	      continue;
	    } // Assert interface field type is satisfied by object field type, by being
	    // a valid subtype. (covariant)
	
	
	    if (!(0, _typeComparators.isTypeSubTypeOf)(context.schema, objectField.type, ifaceField.type)) {
	      context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expects type ") + "".concat((0, _inspect.default)(ifaceField.type), " but ").concat(object.name, ".").concat(fieldName, " ") + "is type ".concat((0, _inspect.default)(objectField.type), "."), [getFieldTypeNode(iface, fieldName), getFieldTypeNode(object, fieldName)]);
	    } // Assert each interface field arg is implemented.
	
	
	    var _iteratorNormalCompletion8 = true;
	    var _didIteratorError8 = false;
	    var _iteratorError8 = undefined;
	
	    try {
	      var _loop = function _loop() {
	        var ifaceArg = _step8.value;
	        var argName = ifaceArg.name;
	        var objectArg = (0, _find.default)(objectField.args, function (arg) {
	          return arg.name === argName;
	        }); // Assert interface field arg exists on object field.
	
	        if (!objectArg) {
	          context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) ") + "expected but ".concat(object.name, ".").concat(fieldName, " does not provide it."), [getFieldArgNode(iface, fieldName, argName), getFieldNode(object, fieldName)]);
	          return "continue";
	        } // Assert interface field arg type matches object field arg type.
	        // (invariant)
	        // TODO: change to contravariant?
	
	
	        if (!(0, _typeComparators.isEqualType)(ifaceArg.type, objectArg.type)) {
	          context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) ") + "expects type ".concat((0, _inspect.default)(ifaceArg.type), " but ") + "".concat(object.name, ".").concat(fieldName, "(").concat(argName, ":) is type ") + "".concat((0, _inspect.default)(objectArg.type), "."), [getFieldArgTypeNode(iface, fieldName, argName), getFieldArgTypeNode(object, fieldName, argName)]);
	        } // TODO: validate default values?
	
	      };
	
	      for (var _iterator8 = ifaceField.args[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	        var _ret = _loop();
	
	        if (_ret === "continue") continue;
	      } // Assert additional arguments must not be required.
	
	    } catch (err) {
	      _didIteratorError8 = true;
	      _iteratorError8 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
	          _iterator8.return();
	        }
	      } finally {
	        if (_didIteratorError8) {
	          throw _iteratorError8;
	        }
	      }
	    }
	
	    var _iteratorNormalCompletion9 = true;
	    var _didIteratorError9 = false;
	    var _iteratorError9 = undefined;
	
	    try {
	      var _loop2 = function _loop2() {
	        var objectArg = _step9.value;
	        var argName = objectArg.name;
	        var ifaceArg = (0, _find.default)(ifaceField.args, function (arg) {
	          return arg.name === argName;
	        });
	
	        if (!ifaceArg && (0, _definition.isRequiredArgument)(objectArg)) {
	          context.reportError("Object field ".concat(object.name, ".").concat(fieldName, " includes required ") + "argument ".concat(argName, " that is missing from the Interface field ") + "".concat(iface.name, ".").concat(fieldName, "."), [getFieldArgNode(object, fieldName, argName), getFieldNode(iface, fieldName)]);
	        }
	      };
	
	      for (var _iterator9 = objectField.args[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	        _loop2();
	      }
	    } catch (err) {
	      _didIteratorError9 = true;
	      _iteratorError9 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
	          _iterator9.return();
	        }
	      } finally {
	        if (_didIteratorError9) {
	          throw _iteratorError9;
	        }
	      }
	    }
	  }
	}
	
	function validateUnionMembers(context, union) {
	  var memberTypes = union.getTypes();
	
	  if (memberTypes.length === 0) {
	    context.reportError("Union type ".concat(union.name, " must define one or more member types."), getAllNodes(union));
	  }
	
	  var includedTypeNames = Object.create(null);
	  var _iteratorNormalCompletion10 = true;
	  var _didIteratorError10 = false;
	  var _iteratorError10 = undefined;
	
	  try {
	    for (var _iterator10 = memberTypes[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	      var memberType = _step10.value;
	
	      if (includedTypeNames[memberType.name]) {
	        context.reportError("Union type ".concat(union.name, " can only include type ") + "".concat(memberType.name, " once."), getUnionMemberTypeNodes(union, memberType.name));
	        continue;
	      }
	
	      includedTypeNames[memberType.name] = true;
	
	      if (!(0, _definition.isObjectType)(memberType)) {
	        context.reportError("Union type ".concat(union.name, " can only include Object types, ") + "it cannot include ".concat((0, _inspect.default)(memberType), "."), getUnionMemberTypeNodes(union, String(memberType)));
	      }
	    }
	  } catch (err) {
	    _didIteratorError10 = true;
	    _iteratorError10 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
	        _iterator10.return();
	      }
	    } finally {
	      if (_didIteratorError10) {
	        throw _iteratorError10;
	      }
	    }
	  }
	}
	
	function validateEnumValues(context, enumType) {
	  var enumValues = enumType.getValues();
	
	  if (enumValues.length === 0) {
	    context.reportError("Enum type ".concat(enumType.name, " must define one or more values."), getAllNodes(enumType));
	  }
	
	  var _iteratorNormalCompletion11 = true;
	  var _didIteratorError11 = false;
	  var _iteratorError11 = undefined;
	
	  try {
	    for (var _iterator11 = enumValues[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	      var enumValue = _step11.value;
	      var valueName = enumValue.name; // Ensure no duplicates.
	
	      var allNodes = getEnumValueNodes(enumType, valueName);
	
	      if (allNodes && allNodes.length > 1) {
	        context.reportError("Enum type ".concat(enumType.name, " can include value ").concat(valueName, " only once."), allNodes);
	      } // Ensure valid name.
	
	
	      validateName(context, enumValue);
	
	      if (valueName === 'true' || valueName === 'false' || valueName === 'null') {
	        context.reportError("Enum type ".concat(enumType.name, " cannot include value: ").concat(valueName, "."), enumValue.astNode);
	      }
	    }
	  } catch (err) {
	    _didIteratorError11 = true;
	    _iteratorError11 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
	        _iterator11.return();
	      }
	    } finally {
	      if (_didIteratorError11) {
	        throw _iteratorError11;
	      }
	    }
	  }
	}
	
	function validateInputFields(context, inputObj) {
	  var fields = (0, _objectValues.default)(inputObj.getFields());
	
	  if (fields.length === 0) {
	    context.reportError("Input Object type ".concat(inputObj.name, " must define one or more fields."), getAllNodes(inputObj));
	  } // Ensure the arguments are valid
	
	
	  var _iteratorNormalCompletion12 = true;
	  var _didIteratorError12 = false;
	  var _iteratorError12 = undefined;
	
	  try {
	    for (var _iterator12 = fields[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	      var field = _step12.value;
	      // Ensure they are named correctly.
	      validateName(context, field); // TODO: Ensure they are unique per field.
	      // Ensure the type is an input type
	
	      if (!(0, _definition.isInputType)(field.type)) {
	        context.reportError("The type of ".concat(inputObj.name, ".").concat(field.name, " must be Input Type ") + "but got: ".concat((0, _inspect.default)(field.type), "."), field.astNode && field.astNode.type);
	      }
	    }
	  } catch (err) {
	    _didIteratorError12 = true;
	    _iteratorError12 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
	        _iterator12.return();
	      }
	    } finally {
	      if (_didIteratorError12) {
	        throw _iteratorError12;
	      }
	    }
	  }
	}
	
	function getAllNodes(object) {
	  var astNode = object.astNode,
	      extensionASTNodes = object.extensionASTNodes;
	  return astNode ? extensionASTNodes ? [astNode].concat(extensionASTNodes) : [astNode] : extensionASTNodes || [];
	}
	
	function getAllSubNodes(object, getter) {
	  var result = [];
	  var _iteratorNormalCompletion13 = true;
	  var _didIteratorError13 = false;
	  var _iteratorError13 = undefined;
	
	  try {
	    for (var _iterator13 = getAllNodes(object)[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
	      var astNode = _step13.value;
	
	      if (astNode) {
	        var subNodes = getter(astNode);
	
	        if (subNodes) {
	          result = result.concat(subNodes);
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError13 = true;
	    _iteratorError13 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
	        _iterator13.return();
	      }
	    } finally {
	      if (_didIteratorError13) {
	        throw _iteratorError13;
	      }
	    }
	  }
	
	  return result;
	}
	
	function getImplementsInterfaceNode(type, iface) {
	  return getAllImplementsInterfaceNodes(type, iface)[0];
	}
	
	function getAllImplementsInterfaceNodes(type, iface) {
	  return getAllSubNodes(type, function (typeNode) {
	    return typeNode.interfaces;
	  }).filter(function (ifaceNode) {
	    return ifaceNode.name.value === iface.name;
	  });
	}
	
	function getFieldNode(type, fieldName) {
	  return getAllFieldNodes(type, fieldName)[0];
	}
	
	function getAllFieldNodes(type, fieldName) {
	  return getAllSubNodes(type, function (typeNode) {
	    return typeNode.fields;
	  }).filter(function (fieldNode) {
	    return fieldNode.name.value === fieldName;
	  });
	}
	
	function getFieldTypeNode(type, fieldName) {
	  var fieldNode = getFieldNode(type, fieldName);
	  return fieldNode && fieldNode.type;
	}
	
	function getFieldArgNode(type, fieldName, argName) {
	  return getAllFieldArgNodes(type, fieldName, argName)[0];
	}
	
	function getAllFieldArgNodes(type, fieldName, argName) {
	  var argNodes = [];
	  var fieldNode = getFieldNode(type, fieldName);
	
	  if (fieldNode && fieldNode.arguments) {
	    var _iteratorNormalCompletion14 = true;
	    var _didIteratorError14 = false;
	    var _iteratorError14 = undefined;
	
	    try {
	      for (var _iterator14 = fieldNode.arguments[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
	        var node = _step14.value;
	
	        if (node.name.value === argName) {
	          argNodes.push(node);
	        }
	      }
	    } catch (err) {
	      _didIteratorError14 = true;
	      _iteratorError14 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
	          _iterator14.return();
	        }
	      } finally {
	        if (_didIteratorError14) {
	          throw _iteratorError14;
	        }
	      }
	    }
	  }
	
	  return argNodes;
	}
	
	function getFieldArgTypeNode(type, fieldName, argName) {
	  var fieldArgNode = getFieldArgNode(type, fieldName, argName);
	  return fieldArgNode && fieldArgNode.type;
	}
	
	function getAllDirectiveArgNodes(directive, argName) {
	  return getAllSubNodes(directive, function (directiveNode) {
	    return directiveNode.arguments;
	  }).filter(function (argNode) {
	    return argNode.name.value === argName;
	  });
	}
	
	function getDirectiveArgTypeNode(directive, argName) {
	  var argNode = getAllDirectiveArgNodes(directive, argName)[0];
	  return argNode && argNode.type;
	}
	
	function getUnionMemberTypeNodes(union, typeName) {
	  return getAllSubNodes(union, function (unionNode) {
	    return unionNode.types;
	  }).filter(function (typeNode) {
	    return typeNode.name.value === typeName;
	  });
	}
	
	function getEnumValueNodes(enumType, valueName) {
	  return getAllSubNodes(enumType, function (enumNode) {
	    return enumNode.values;
	  }).filter(function (valueNode) {
	    return valueNode.name.value === valueName;
	  });
	}

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isEqualType = isEqualType;
	exports.isTypeSubTypeOf = isTypeSubTypeOf;
	exports.doTypesOverlap = doTypesOverlap;
	
	var _definition = __webpack_require__(10);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Provided two types, return true if the types are equal (invariant).
	 */
	function isEqualType(typeA, typeB) {
	  // Equivalent types are equal.
	  if (typeA === typeB) {
	    return true;
	  } // If either type is non-null, the other must also be non-null.
	
	
	  if ((0, _definition.isNonNullType)(typeA) && (0, _definition.isNonNullType)(typeB)) {
	    return isEqualType(typeA.ofType, typeB.ofType);
	  } // If either type is a list, the other must also be a list.
	
	
	  if ((0, _definition.isListType)(typeA) && (0, _definition.isListType)(typeB)) {
	    return isEqualType(typeA.ofType, typeB.ofType);
	  } // Otherwise the types are not equal.
	
	
	  return false;
	}
	/**
	 * Provided a type and a super type, return true if the first type is either
	 * equal or a subset of the second super type (covariant).
	 */
	
	
	function isTypeSubTypeOf(schema, maybeSubType, superType) {
	  // Equivalent type is a valid subtype
	  if (maybeSubType === superType) {
	    return true;
	  } // If superType is non-null, maybeSubType must also be non-null.
	
	
	  if ((0, _definition.isNonNullType)(superType)) {
	    if ((0, _definition.isNonNullType)(maybeSubType)) {
	      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
	    }
	
	    return false;
	  }
	
	  if ((0, _definition.isNonNullType)(maybeSubType)) {
	    // If superType is nullable, maybeSubType may be non-null or nullable.
	    return isTypeSubTypeOf(schema, maybeSubType.ofType, superType);
	  } // If superType type is a list, maybeSubType type must also be a list.
	
	
	  if ((0, _definition.isListType)(superType)) {
	    if ((0, _definition.isListType)(maybeSubType)) {
	      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
	    }
	
	    return false;
	  }
	
	  if ((0, _definition.isListType)(maybeSubType)) {
	    // If superType is not a list, maybeSubType must also be not a list.
	    return false;
	  } // If superType type is an abstract type, maybeSubType type may be a currently
	  // possible object type.
	
	
	  if ((0, _definition.isAbstractType)(superType) && (0, _definition.isObjectType)(maybeSubType) && schema.isPossibleType(superType, maybeSubType)) {
	    return true;
	  } // Otherwise, the child type is not a valid subtype of the parent type.
	
	
	  return false;
	}
	/**
	 * Provided two composite types, determine if they "overlap". Two composite
	 * types overlap when the Sets of possible concrete types for each intersect.
	 *
	 * This is often used to determine if a fragment of a given type could possibly
	 * be visited in a context of another type.
	 *
	 * This function is commutative.
	 */
	
	
	function doTypesOverlap(schema, typeA, typeB) {
	  // Equivalent types overlap
	  if (typeA === typeB) {
	    return true;
	  }
	
	  if ((0, _definition.isAbstractType)(typeA)) {
	    if ((0, _definition.isAbstractType)(typeB)) {
	      // If both types are abstract, then determine if there is any intersection
	      // between possible concrete types of each.
	      return schema.getPossibleTypes(typeA).some(function (type) {
	        return schema.isPossibleType(typeB, type);
	      });
	    } // Determine if the latter type is a possible concrete type of the former.
	
	
	    return schema.isPossibleType(typeA, typeB);
	  }
	
	  if ((0, _definition.isAbstractType)(typeB)) {
	    // Determine if the former type is a possible concrete type of the latter.
	    return schema.isPossibleType(typeB, typeA);
	  } // Otherwise the types do not overlap.
	
	
	  return false;
	}

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.valueFromAST = valueFromAST;
	
	var _keyMap = _interopRequireDefault(__webpack_require__(27));
	
	var _isInvalid = _interopRequireDefault(__webpack_require__(33));
	
	var _objectValues = _interopRequireDefault(__webpack_require__(34));
	
	var _kinds = __webpack_require__(11);
	
	var _definition = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Produces a JavaScript value given a GraphQL Value AST.
	 *
	 * A GraphQL type must be provided, which will be used to interpret different
	 * GraphQL Value literals.
	 *
	 * Returns `undefined` when the value could not be validly coerced according to
	 * the provided type.
	 *
	 * | GraphQL Value        | JSON Value    |
	 * | -------------------- | ------------- |
	 * | Input Object         | Object        |
	 * | List                 | Array         |
	 * | Boolean              | Boolean       |
	 * | String               | String        |
	 * | Int / Float          | Number        |
	 * | Enum Value           | Mixed         |
	 * | NullValue            | null          |
	 *
	 */
	function valueFromAST(valueNode, type, variables) {
	  if (!valueNode) {
	    // When there is no node, then there is also no value.
	    // Importantly, this is different from returning the value null.
	    return;
	  }
	
	  if ((0, _definition.isNonNullType)(type)) {
	    if (valueNode.kind === _kinds.Kind.NULL) {
	      return; // Invalid: intentionally return no value.
	    }
	
	    return valueFromAST(valueNode, type.ofType, variables);
	  }
	
	  if (valueNode.kind === _kinds.Kind.NULL) {
	    // This is explicitly returning the value null.
	    return null;
	  }
	
	  if (valueNode.kind === _kinds.Kind.VARIABLE) {
	    var variableName = valueNode.name.value;
	
	    if (!variables || (0, _isInvalid.default)(variables[variableName])) {
	      // No valid return value.
	      return;
	    }
	
	    var variableValue = variables[variableName];
	
	    if (variableValue === null && (0, _definition.isNonNullType)(type)) {
	      return; // Invalid: intentionally return no value.
	    } // Note: This does no further checking that this variable is correct.
	    // This assumes that this query has been validated and the variable
	    // usage here is of the correct type.
	
	
	    return variableValue;
	  }
	
	  if ((0, _definition.isListType)(type)) {
	    var itemType = type.ofType;
	
	    if (valueNode.kind === _kinds.Kind.LIST) {
	      var coercedValues = [];
	      var itemNodes = valueNode.values;
	
	      for (var i = 0; i < itemNodes.length; i++) {
	        if (isMissingVariable(itemNodes[i], variables)) {
	          // If an array contains a missing variable, it is either coerced to
	          // null or if the item type is non-null, it considered invalid.
	          if ((0, _definition.isNonNullType)(itemType)) {
	            return; // Invalid: intentionally return no value.
	          }
	
	          coercedValues.push(null);
	        } else {
	          var itemValue = valueFromAST(itemNodes[i], itemType, variables);
	
	          if ((0, _isInvalid.default)(itemValue)) {
	            return; // Invalid: intentionally return no value.
	          }
	
	          coercedValues.push(itemValue);
	        }
	      }
	
	      return coercedValues;
	    }
	
	    var coercedValue = valueFromAST(valueNode, itemType, variables);
	
	    if ((0, _isInvalid.default)(coercedValue)) {
	      return; // Invalid: intentionally return no value.
	    }
	
	    return [coercedValue];
	  }
	
	  if ((0, _definition.isInputObjectType)(type)) {
	    if (valueNode.kind !== _kinds.Kind.OBJECT) {
	      return; // Invalid: intentionally return no value.
	    }
	
	    var coercedObj = Object.create(null);
	    var fieldNodes = (0, _keyMap.default)(valueNode.fields, function (field) {
	      return field.name.value;
	    });
	    var fields = (0, _objectValues.default)(type.getFields());
	
	    for (var _i = 0; _i < fields.length; _i++) {
	      var field = fields[_i];
	      var fieldNode = fieldNodes[field.name];
	
	      if (!fieldNode || isMissingVariable(fieldNode.value, variables)) {
	        if (field.defaultValue !== undefined) {
	          coercedObj[field.name] = field.defaultValue;
	        } else if ((0, _definition.isNonNullType)(field.type)) {
	          return; // Invalid: intentionally return no value.
	        }
	
	        continue;
	      }
	
	      var fieldValue = valueFromAST(fieldNode.value, field.type, variables);
	
	      if ((0, _isInvalid.default)(fieldValue)) {
	        return; // Invalid: intentionally return no value.
	      }
	
	      coercedObj[field.name] = fieldValue;
	    }
	
	    return coercedObj;
	  }
	
	  if ((0, _definition.isEnumType)(type)) {
	    if (valueNode.kind !== _kinds.Kind.ENUM) {
	      return; // Invalid: intentionally return no value.
	    }
	
	    var enumValue = type.getValue(valueNode.value);
	
	    if (!enumValue) {
	      return; // Invalid: intentionally return no value.
	    }
	
	    return enumValue.value;
	  }
	
	  if ((0, _definition.isScalarType)(type)) {
	    // Scalars fulfill parsing a literal value via parseLiteral().
	    // Invalid values represent a failure to parse correctly, in which case
	    // no value is returned.
	    var result;
	
	    try {
	      result = type.parseLiteral(valueNode, variables);
	    } catch (_error) {
	      return; // Invalid: intentionally return no value.
	    }
	
	    if ((0, _isInvalid.default)(result)) {
	      return; // Invalid: intentionally return no value.
	    }
	
	    return result;
	  }
	  /* istanbul ignore next */
	
	
	  throw new Error("Unknown type: ".concat(type, "."));
	} // Returns true if the provided valueNode is a variable which is not defined
	// in the set of variables.
	
	
	function isMissingVariable(valueNode, variables) {
	  return valueNode.kind === _kinds.Kind.VARIABLE && (!variables || (0, _isInvalid.default)(variables[valueNode.name.value]));
	}

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validate = validate;
	exports.validateSDL = validateSDL;
	exports.assertValidSDL = assertValidSDL;
	exports.assertValidSDLExtension = assertValidSDLExtension;
	
	var _invariant = _interopRequireDefault(__webpack_require__(17));
	
	var _visitor = __webpack_require__(36);
	
	var _validate = __webpack_require__(66);
	
	var _TypeInfo = __webpack_require__(55);
	
	var _specifiedRules = __webpack_require__(218);
	
	var _ValidationContext = __webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Implements the "Validation" section of the spec.
	 *
	 * Validation runs synchronously, returning an array of encountered errors, or
	 * an empty array if no errors were encountered and the document is valid.
	 *
	 * A list of specific validation rules may be provided. If not provided, the
	 * default list of rules defined by the GraphQL specification will be used.
	 *
	 * Each validation rules is a function which returns a visitor
	 * (see the language/visitor API). Visitor methods are expected to return
	 * GraphQLErrors, or Arrays of GraphQLErrors when invalid.
	 *
	 * Optionally a custom TypeInfo instance may be provided. If not provided, one
	 * will be created from the provided schema.
	 */
	function validate(schema, documentAST) {
	  var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _specifiedRules.specifiedRules;
	  var typeInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new _TypeInfo.TypeInfo(schema);
	  !documentAST ? (0, _invariant.default)(0, 'Must provide document') : void 0; // If the schema used for validation is invalid, throw an error.
	
	  (0, _validate.assertValidSchema)(schema);
	  var context = new _ValidationContext.ValidationContext(schema, documentAST, typeInfo); // This uses a specialized visitor which runs multiple visitors in parallel,
	  // while maintaining the visitor skip and break API.
	
	  var visitor = (0, _visitor.visitInParallel)(rules.map(function (rule) {
	    return rule(context);
	  })); // Visit the whole document with each instance of all provided rules.
	
	  (0, _visitor.visit)(documentAST, (0, _visitor.visitWithTypeInfo)(typeInfo, visitor));
	  return context.getErrors();
	} // @internal
	
	
	function validateSDL(documentAST, schemaToExtend) {
	  var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _specifiedRules.specifiedSDLRules;
	  var context = new _ValidationContext.SDLValidationContext(documentAST, schemaToExtend);
	  var visitors = rules.map(function (rule) {
	    return rule(context);
	  });
	  (0, _visitor.visit)(documentAST, (0, _visitor.visitInParallel)(visitors));
	  return context.getErrors();
	}
	/**
	 * Utility function which asserts a SDL document is valid by throwing an error
	 * if it is invalid.
	 *
	 * @internal
	 */
	
	
	function assertValidSDL(documentAST) {
	  var errors = validateSDL(documentAST);
	
	  if (errors.length !== 0) {
	    throw new Error(errors.map(function (error) {
	      return error.message;
	    }).join('\n\n'));
	  }
	}
	/**
	 * Utility function which asserts a SDL document is valid by throwing an error
	 * if it is invalid.
	 *
	 * @internal
	 */
	
	
	function assertValidSDLExtension(documentAST, schema) {
	  var errors = validateSDL(documentAST, schema);
	
	  if (errors.length !== 0) {
	    throw new Error(errors.map(function (error) {
	      return error.message;
	    }).join('\n\n'));
	  }
	}

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(502);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}
	module.exports = exports['default'];

/***/ },
/* 72 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(505);
	exports.encode = exports.stringify = __webpack_require__(506);


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var context = /*#__PURE__*/_react.default.createContext(null);
	
	context.displayName = 'AccordionContext';
	var _default = context;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(35));
	
	var _excluded = ["bsPrefix", "variant", "size", "active", "className", "block", "type", "as"];
	var defaultProps = {
	  variant: 'primary',
	  active: false,
	  disabled: false
	};
	
	var Button = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      variant = _ref.variant,
	      size = _ref.size,
	      active = _ref.active,
	      className = _ref.className,
	      block = _ref.block,
	      type = _ref.type,
	      as = _ref.as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'btn');
	  var classes = (0, _classnames.default)(className, prefix, active && 'active', variant && prefix + "-" + variant, block && prefix + "-block", size && prefix + "-" + size);
	
	  if (props.href) {
	    return /*#__PURE__*/_react.default.createElement(_SafeAnchor.default, (0, _extends2.default)({}, props, {
	      as: as,
	      ref: ref,
	      className: (0, _classnames.default)(classes, props.disabled && 'disabled')
	    }));
	  }
	
	  if (ref) {
	    props.ref = ref;
	  }
	
	  if (type) {
	    props.type = type;
	  } else if (!as) {
	    props.type = 'button';
	  }
	
	  var Component = as || 'button';
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    className: classes
	  }));
	});
	
	Button.displayName = 'Button';
	Button.defaultProps = defaultProps;
	var _default = Button;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _excluded = ["label", "onClick", "className"];
	var propTypes = {
	  label: _propTypes.default.string.isRequired,
	  onClick: _propTypes.default.func
	};
	var defaultProps = {
	  label: 'Close'
	};
	
	var CloseButton = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var label = _ref.label,
	      onClick = _ref.onClick,
	      className = _ref.className,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
	    ref: ref,
	    type: "button",
	    className: (0, _classnames.default)('close', className),
	    onClick: onClick
	  }, props), /*#__PURE__*/_react.default.createElement("span", {
	    "aria-hidden": "true"
	  }, "\xD7"), /*#__PURE__*/_react.default.createElement("span", {
	    className: "sr-only"
	  }, label));
	});
	
	CloseButton.displayName = 'CloseButton';
	CloseButton.propTypes = propTypes;
	CloseButton.defaultProps = defaultProps;
	var _default = CloseButton;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(565));
	
	var _uncontrollable = __webpack_require__(20);
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(18));
	
	var _DropdownItem = _interopRequireDefault(__webpack_require__(521));
	
	var _DropdownMenu = _interopRequireDefault(__webpack_require__(118));
	
	var _DropdownToggle = _interopRequireDefault(__webpack_require__(230));
	
	var _SelectableContext = _interopRequireDefault(__webpack_require__(25));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var _excluded = ["bsPrefix", "drop", "show", "className", "alignRight", "onSelect", "onToggle", "focusFirstItemOnShow", "as", "navbar"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var DropdownHeader = (0, _createWithBsPrefix.default)('dropdown-header', {
	  defaultProps: {
	    role: 'heading'
	  }
	});
	var DropdownDivider = (0, _createWithBsPrefix.default)('dropdown-divider', {
	  defaultProps: {
	    role: 'separator'
	  }
	});
	var DropdownItemText = (0, _createWithBsPrefix.default)('dropdown-item-text', {
	  Component: 'span'
	});
	var defaultProps = {
	  navbar: false
	};
	
	var Dropdown = /*#__PURE__*/_react.default.forwardRef(function (pProps, ref) {
	  var _useUncontrolled = (0, _uncontrollable.useUncontrolled)(pProps, {
	    show: 'onToggle'
	  }),
	      bsPrefix = _useUncontrolled.bsPrefix,
	      drop = _useUncontrolled.drop,
	      show = _useUncontrolled.show,
	      className = _useUncontrolled.className,
	      alignRight = _useUncontrolled.alignRight,
	      onSelect = _useUncontrolled.onSelect,
	      onToggle = _useUncontrolled.onToggle,
	      focusFirstItemOnShow = _useUncontrolled.focusFirstItemOnShow,
	      _useUncontrolled$as = _useUncontrolled.as,
	      Component = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as,
	      _4 = _useUncontrolled.navbar,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_useUncontrolled, _excluded);
	
	  var onSelectCtx = (0, _react.useContext)(_SelectableContext.default);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown');
	  var handleToggle = (0, _useEventCallback.default)(function (nextShow, event, source) {
	    if (source === void 0) {
	      source = event.type;
	    }
	
	    if (event.currentTarget === document && (source !== 'keydown' || event.key === 'Escape')) source = 'rootClose';
	
	    if (onToggle) {
	      onToggle(nextShow, event, {
	        source: source
	      });
	    }
	  });
	  var handleSelect = (0, _useEventCallback.default)(function (key, event) {
	    if (onSelectCtx) onSelectCtx(key, event);
	    if (onSelect) onSelect(key, event);
	    handleToggle(false, event, 'select');
	  });
	  return /*#__PURE__*/_react.default.createElement(_SelectableContext.default.Provider, {
	    value: handleSelect
	  }, /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
	    drop: drop,
	    show: show,
	    alignEnd: alignRight,
	    onToggle: handleToggle,
	    focusFirstItemOnShow: focusFirstItemOnShow,
	    itemSelector: "." + prefix + "-item:not(.disabled):not(:disabled)"
	  }, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(className, show && 'show', (!drop || drop === 'down') && prefix, drop === 'up' && 'dropup', drop === 'right' && 'dropright', drop === 'left' && 'dropleft')
	  }))));
	});
	
	Dropdown.displayName = 'Dropdown';
	Dropdown.defaultProps = defaultProps;
	Dropdown.Divider = DropdownDivider;
	Dropdown.Header = DropdownHeader;
	Dropdown.Item = _DropdownItem.default;
	Dropdown.ItemText = DropdownItemText;
	Dropdown.Menu = _DropdownMenu.default;
	Dropdown.Toggle = _DropdownToggle.default;
	var _default = Dropdown;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.map = map;
	exports.forEach = forEach;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid elements".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 */
	function map(children, func) {
	  var index = 0;
	  return _react.default.Children.map(children, function (child) {
	    return /*#__PURE__*/_react.default.isValidElement(child) ? func(child, index++) : child;
	  });
	}
	/**
	 * Iterates through children that are "valid elements".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 */
	
	
	function forEach(children, func) {
	  var index = 0;
	
	  _react.default.Children.forEach(children, function (child) {
	    if ( /*#__PURE__*/_react.default.isValidElement(child)) func(child, index++);
	  });
	}

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(35));
	
	var _AbstractNavItem = _interopRequireDefault(__webpack_require__(222));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "disabled", "className", "href", "eventKey", "onSelect", "as"];
	var defaultProps = {
	  disabled: false,
	  as: _SafeAnchor.default
	};
	
	var NavLink = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      disabled = _ref.disabled,
	      className = _ref.className,
	      href = _ref.href,
	      eventKey = _ref.eventKey,
	      onSelect = _ref.onSelect,
	      as = _ref.as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'nav-link');
	  return /*#__PURE__*/_react.default.createElement(_AbstractNavItem.default, (0, _extends2.default)({}, props, {
	    href: href,
	    ref: ref,
	    eventKey: eventKey,
	    as: as,
	    disabled: disabled,
	    onSelect: onSelect,
	    className: (0, _classnames.default)(className, bsPrefix, disabled && 'disabled')
	  }));
	});
	
	NavLink.displayName = 'NavLink';
	NavLink.defaultProps = defaultProps;
	var _default = NavLink;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
		module.exports = __webpack_require__(275);
	} else {
		module.exports = require('./dist/aws-amplify-auth.js');
	}


/***/ },
/* 81 */
[598, 12, 281, 325, 303, 293, 8, 139, 140, 290, 287, 291, 288, 289, 319, 300],
/* 82 */
[617, 12],
/* 83 */
[618, 12],
/* 84 */
[626, 12, 8],
/* 85 */
[627, 12, 82, 83, 84],
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
		module.exports = __webpack_require__(335);
	} else {
		module.exports = require('./dist/aws-amplify-storage.js');
	}


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hashString = _interopDefault(__webpack_require__(349));
	var unitless = _interopDefault(__webpack_require__(352));
	var memoize = _interopDefault(__webpack_require__(350));
	
	var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
	var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
	var hyphenateRegex = /[A-Z]|^ms/g;
	var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
	
	var isCustomProperty = function isCustomProperty(property) {
	  return property.charCodeAt(1) === 45;
	};
	
	var isProcessableValue = function isProcessableValue(value) {
	  return value != null && typeof value !== 'boolean';
	};
	
	var processStyleName = memoize(function (styleName) {
	  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	
	var processStyleValue = function processStyleValue(key, value) {
	  switch (key) {
	    case 'animation':
	    case 'animationName':
	      {
	        if (typeof value === 'string') {
	          return value.replace(animationRegex, function (match, p1, p2) {
	            cursor = {
	              name: p1,
	              styles: p2,
	              next: cursor
	            };
	            return p1;
	          });
	        }
	      }
	  }
	
	  if (unitless[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	  var msPattern = /^-ms-/;
	  var hyphenPattern = /-(.)/g;
	  var hyphenatedCache = {};
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    var processed = oldProcessStyleValue(key, value);
	
	    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
	      hyphenatedCache[key] = true;
	      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
	        return _char.toUpperCase();
	      }) + "?");
	    }
	
	    return processed;
	  };
	}
	
	var shouldWarnAboutInterpolatingClassNameFromCss = true;
	
	function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
	  if (interpolation == null) {
	    return '';
	  }
	
	  if (interpolation.__emotion_styles !== undefined) {
	    if (false) {
	      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	    }
	
	    return interpolation;
	  }
	
	  switch (typeof interpolation) {
	    case 'boolean':
	      {
	        return '';
	      }
	
	    case 'object':
	      {
	        if (interpolation.anim === 1) {
	          cursor = {
	            name: interpolation.name,
	            styles: interpolation.styles,
	            next: cursor
	          };
	          return interpolation.name;
	        }
	
	        if (interpolation.styles !== undefined) {
	          var next = interpolation.next;
	
	          if (next !== undefined) {
	            // not the most efficient thing ever but this is a pretty rare case
	            // and there will be very few iterations of this generally
	            while (next !== undefined) {
	              cursor = {
	                name: next.name,
	                styles: next.styles,
	                next: cursor
	              };
	              next = next.next;
	            }
	          }
	
	          var styles = interpolation.styles + ";";
	
	          if (false) {
	            styles += interpolation.map;
	          }
	
	          return styles;
	        }
	
	        return createStringFromObject(mergedProps, registered, interpolation);
	      }
	
	    case 'function':
	      {
	        if (mergedProps !== undefined) {
	          var previousCursor = cursor;
	          var result = interpolation(mergedProps);
	          cursor = previousCursor;
	          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
	        } else if (false) {
	          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	
	        break;
	      }
	
	    case 'string':
	      if (false) {
	        var matched = [];
	        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
	          var fakeVarName = "animation" + matched.length;
	          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
	          return "${" + fakeVarName + "}";
	        });
	
	        if (matched.length) {
	          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
	        }
	      }
	
	      break;
	  } // finalize string values (regular strings and functions interpolated into css calls)
	
	
	  if (registered == null) {
	    return interpolation;
	  }
	
	  var cached = registered[interpolation];
	
	  if (false) {
	    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
	    shouldWarnAboutInterpolatingClassNameFromCss = false;
	  }
	
	  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
	}
	
	function createStringFromObject(mergedProps, registered, obj) {
	  var string = '';
	
	  if (Array.isArray(obj)) {
	    for (var i = 0; i < obj.length; i++) {
	      string += handleInterpolation(mergedProps, registered, obj[i], false);
	    }
	  } else {
	    for (var _key in obj) {
	      var value = obj[_key];
	
	      if (typeof value !== 'object') {
	        if (registered != null && registered[value] !== undefined) {
	          string += _key + "{" + registered[value] + "}";
	        } else if (isProcessableValue(value)) {
	          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
	        }
	      } else {
	        if (_key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	        }
	
	        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
	          for (var _i = 0; _i < value.length; _i++) {
	            if (isProcessableValue(value[_i])) {
	              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
	            }
	          }
	        } else {
	          var interpolated = handleInterpolation(mergedProps, registered, value, false);
	
	          switch (_key) {
	            case 'animation':
	            case 'animationName':
	              {
	                string += processStyleName(_key) + ":" + interpolated + ";";
	                break;
	              }
	
	            default:
	              {
	                if (false) {
	                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
	                }
	
	                string += _key + "{" + interpolated + "}";
	              }
	          }
	        }
	      }
	    }
	  }
	
	  return string;
	}
	
	var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	var sourceMapPattern;
	
	if (false) {
	  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
	} // this is the cursor for keyframes
	// keyframes are stored on the SerializedStyles object as a linked list
	
	
	var cursor;
	var serializeStyles = function serializeStyles(args, registered, mergedProps) {
	  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
	    return args[0];
	  }
	
	  var stringMode = true;
	  var styles = '';
	  cursor = undefined;
	  var strings = args[0];
	
	  if (strings == null || strings.raw === undefined) {
	    stringMode = false;
	    styles += handleInterpolation(mergedProps, registered, strings, false);
	  } else {
	    if (false) {
	      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	    }
	
	    styles += strings[0];
	  } // we start at 1 since we've already handled the first arg
	
	
	  for (var i = 1; i < args.length; i++) {
	    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
	
	    if (stringMode) {
	      if (false) {
	        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	      }
	
	      styles += strings[i];
	    }
	  }
	
	  var sourceMap;
	
	  if (false) {
	    styles = styles.replace(sourceMapPattern, function (match) {
	      sourceMap = match;
	      return '';
	    });
	  } // using a global regex with .exec is stateful so lastIndex has to be reset each time
	
	
	  labelPattern.lastIndex = 0;
	  var identifierName = '';
	  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
	
	  while ((match = labelPattern.exec(styles)) !== null) {
	    identifierName += '-' + // $FlowFixMe we know it's not null
	    match[1];
	  }
	
	  var name = hashString(styles) + identifierName;
	
	  if (false) {
	    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
	    return {
	      name: name,
	      styles: styles,
	      map: sourceMap,
	      next: cursor,
	      toString: function toString() {
	        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
	      }
	    };
	  }
	
	  return {
	    name: name,
	    styles: styles,
	    next: cursor
	  };
	};
	
	exports.serializeStyles = serializeStyles;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = useCallbackRef;
	
	var _react = __webpack_require__(2);
	
	/**
	 * A convenience hook around `useState` designed to be paired with
	 * the component [callback ref](https://reactjs.org/docs/refs-and-the-dom.html#callback-refs) api.
	 * Callback refs are useful over `useRef()` when you need to respond to the ref being set
	 * instead of lazily accessing it in an effect.
	 *
	 * ```ts
	 * const [element, attachRef] = useCallbackRef<HTMLDivElement>()
	 *
	 * useEffect(() => {
	 *   if (!element) return
	 *
	 *   const calendar = new FullCalendar.Calendar(element)
	 *
	 *   return () => {
	 *     calendar.destroy()
	 *   }
	 * }, [element])
	 *
	 * return <div ref={attachRef} />
	 * ```
	 *
	 * @category refs
	 */
	function useCallbackRef() {
	  return (0, _react.useState)(null);
	}

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = useMounted;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Track whether a component is current mounted. Generally less preferable than
	 * properlly canceling effects so they don't run after a component is unmounted,
	 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
	 *
	 * @returns a function that returns the current isMounted state of the component
	 *
	 * ```ts
	 * const [data, setData] = useState(null)
	 * const isMounted = useMounted()
	 *
	 * useEffect(() => {
	 *   fetchdata().then((newData) => {
	 *      if (isMounted()) {
	 *        setData(newData);
	 *      }
	 *   })
	 * })
	 * ```
	 */
	function useMounted() {
	  var mounted = (0, _react.useRef)(true);
	  var isMounted = (0, _react.useRef)(function () {
	    return mounted.current;
	  });
	  (0, _react.useEffect)(function () {
	    return function () {
	      mounted.current = false;
	    };
	  }, []);
	  return isMounted.current;
	}

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = useTimeout;
	
	var _react = __webpack_require__(2);
	
	var _useMounted = _interopRequireDefault(__webpack_require__(89));
	
	var _useWillUnmount = _interopRequireDefault(__webpack_require__(91));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
	 * delay as a 32-bit signed integer internally. This causes an integer overflow
	 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
	 * resulting in the timeout being executed immediately.
	 *
	 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
	 */
	var MAX_DELAY_MS = Math.pow(2, 31) - 1;
	
	function setChainedTimeout(handleRef, fn, timeoutAtMs) {
	  var delayMs = timeoutAtMs - Date.now();
	  handleRef.current = delayMs <= MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(function () {
	    return setChainedTimeout(handleRef, fn, timeoutAtMs);
	  }, MAX_DELAY_MS);
	}
	/**
	 * Returns a controller object for setting a timeout that is properly cleaned up
	 * once the component unmounts. New timeouts cancel and replace existing ones.
	 *
	 *
	 *
	 * ```tsx
	 * const { set, clear } = useTimeout();
	 * const [hello, showHello] = useState(false);
	 * //Display hello after 5 seconds
	 * set(() => showHello(true), 5000);
	 * return (
	 *   <div className="App">
	 *     {hello ? <h3>Hello</h3> : null}
	 *   </div>
	 * );
	 * ```
	 */
	
	
	function useTimeout() {
	  var isMounted = (0, _useMounted.default)(); // types are confused between node and web here IDK
	
	  var handleRef = (0, _react.useRef)();
	  (0, _useWillUnmount.default)(function () {
	    return clearTimeout(handleRef.current);
	  });
	  return (0, _react.useMemo)(function () {
	    var clear = function clear() {
	      return clearTimeout(handleRef.current);
	    };
	
	    function set(fn, delayMs) {
	      if (delayMs === void 0) {
	        delayMs = 0;
	      }
	
	      if (!isMounted()) return;
	      clear();
	
	      if (delayMs <= MAX_DELAY_MS) {
	        // For simplicity, if the timeout is short, just set a normal timeout.
	        handleRef.current = setTimeout(fn, delayMs);
	      } else {
	        setChainedTimeout(handleRef, fn, Date.now() + delayMs);
	      }
	    }
	
	    return {
	      set: set,
	      clear: clear
	    };
	  }, []);
	}

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = useWillUnmount;
	
	var _useUpdatedRef = _interopRequireDefault(__webpack_require__(358));
	
	var _react = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Attach a callback that fires when a component unmounts
	 *
	 * @param fn Handler to run when the component unmounts
	 * @category effects
	 */
	function useWillUnmount(fn) {
	  var onUnmount = (0, _useUpdatedRef.default)(fn);
	  (0, _react.useEffect)(function () {
	    return function () {
	      return onUnmount.current();
	    };
	  }, []);
	}

/***/ },
/* 92 */
[617, 13],
/* 93 */
[618, 13],
/* 94 */
[626, 13, 7],
/* 95 */
[627, 13, 92, 93, 94],
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = exports.onceSupported = exports.optionsSupported = void 0;
	
	var _canUseDOM = _interopRequireDefault(__webpack_require__(62));
	
	/* eslint-disable no-return-assign */
	var optionsSupported = false;
	exports.optionsSupported = optionsSupported;
	var onceSupported = false;
	exports.onceSupported = onceSupported;
	
	try {
	  var options = {
	    get passive() {
	      return exports.optionsSupported = optionsSupported = true;
	    },
	
	    get once() {
	      // eslint-disable-next-line no-multi-assign
	      return exports.onceSupported = onceSupported = exports.optionsSupported = optionsSupported = true;
	    }
	
	  };
	
	  if (_canUseDOM.default) {
	    window.addEventListener('test', options, options);
	    window.removeEventListener('test', options, true);
	  }
	} catch (e) {
	  /* */
	}
	
	/**
	 * An `addEventListener` ponyfill, supports the `once` option
	 * 
	 * @param node the element
	 * @param eventName the event name
	 * @param handle the handler
	 * @param options event options
	 */
	function addEventListener(node, eventName, handler, options) {
	  if (options && typeof options !== 'boolean' && !onceSupported) {
	    var once = options.once,
	        capture = options.capture;
	    var wrappedHandler = handler;
	
	    if (!onceSupported && once) {
	      wrappedHandler = handler.__once || function onceHandler(event) {
	        this.removeEventListener(eventName, onceHandler, capture);
	        handler.call(this, event);
	      };
	
	      handler.__once = wrappedHandler;
	    }
	
	    node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
	  }
	
	  node.addEventListener(eventName, handler, options);
	}
	
	var _default = addEventListener;
	exports.default = _default;

/***/ },
/* 97 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = contains;
	
	/* eslint-disable no-bitwise, no-cond-assign */
	
	/**
	 * Checks if an element contains another given element.
	 * 
	 * @param context the context element
	 * @param node the element to check
	 */
	function contains(context, node) {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  if (context.contains) return context.contains(node);
	  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
	}
	
	module.exports = exports["default"];

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(96));
	
	var _removeEventListener = _interopRequireDefault(__webpack_require__(182));
	
	function listen(node, eventName, handler, options) {
	  (0, _addEventListener.default)(node, eventName, handler, options);
	  return function () {
	    (0, _removeEventListener.default)(node, eventName, handler, options);
	  };
	}
	
	var _default = listen;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 99 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = qsa;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	/**
	 * Runs `querySelectorAll` on a given element.
	 * 
	 * @param element the element
	 * @param selector the selector
	 */
	
	function qsa(element, selector) {
	  return toArray(element.querySelectorAll(selector));
	}
	
	module.exports = exports["default"];

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _canUseDOM = _interopRequireDefault(__webpack_require__(62));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_canUseDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "GraphQLError", {
	  enumerable: true,
	  get: function get() {
	    return _GraphQLError.GraphQLError;
	  }
	});
	Object.defineProperty(exports, "syntaxError", {
	  enumerable: true,
	  get: function get() {
	    return _syntaxError.syntaxError;
	  }
	});
	Object.defineProperty(exports, "locatedError", {
	  enumerable: true,
	  get: function get() {
	    return _locatedError.locatedError;
	  }
	});
	Object.defineProperty(exports, "printError", {
	  enumerable: true,
	  get: function get() {
	    return _printError.printError;
	  }
	});
	Object.defineProperty(exports, "formatError", {
	  enumerable: true,
	  get: function get() {
	    return _formatError.formatError;
	  }
	});
	
	var _GraphQLError = __webpack_require__(9);
	
	var _syntaxError = __webpack_require__(447);
	
	var _locatedError = __webpack_require__(102);
	
	var _printError = __webpack_require__(185);
	
	var _formatError = __webpack_require__(446);

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.locatedError = locatedError;
	
	var _GraphQLError = __webpack_require__(9);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Given an arbitrary Error, presumably thrown while attempting to execute a
	 * GraphQL operation, produce a new GraphQLError aware of the location in the
	 * document responsible for the original Error.
	 */
	function locatedError(originalError, nodes, path) {
	  // Note: this uses a brand-check to support GraphQL errors originating from
	  // other contexts.
	  if (originalError && Array.isArray(originalError.path)) {
	    return originalError;
	  }
	
	  return new _GraphQLError.GraphQLError(originalError && originalError.message, originalError && originalError.nodes || nodes, originalError && originalError.source, originalError && originalError.positions, path, originalError);
	}

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVariableValues = getVariableValues;
	exports.getArgumentValues = getArgumentValues;
	exports.getDirectiveValues = getDirectiveValues;
	
	var _GraphQLError = __webpack_require__(9);
	
	var _find = _interopRequireDefault(__webpack_require__(51));
	
	var _inspect = _interopRequireDefault(__webpack_require__(16));
	
	var _invariant = _interopRequireDefault(__webpack_require__(17));
	
	var _keyMap = _interopRequireDefault(__webpack_require__(27));
	
	var _coerceValue = __webpack_require__(111);
	
	var _typeFromAST = __webpack_require__(29);
	
	var _valueFromAST = __webpack_require__(68);
	
	var _kinds = __webpack_require__(11);
	
	var _printer = __webpack_require__(22);
	
	var _definition = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Prepares an object map of variableValues of the correct type based on the
	 * provided variable definitions and arbitrary input. If the input cannot be
	 * parsed to match the variable definitions, a GraphQLError will be thrown.
	 *
	 * Note: The returned value is a plain Object with a prototype, since it is
	 * exposed to user code. Care should be taken to not pull values from the
	 * Object prototype.
	 */
	function getVariableValues(schema, varDefNodes, inputs) {
	  var errors = [];
	  var coercedValues = {};
	
	  for (var i = 0; i < varDefNodes.length; i++) {
	    var varDefNode = varDefNodes[i];
	    var varName = varDefNode.variable.name.value;
	    var varType = (0, _typeFromAST.typeFromAST)(schema, varDefNode.type);
	
	    if (!(0, _definition.isInputType)(varType)) {
	      // Must use input types for variables. This should be caught during
	      // validation, however is checked again here for safety.
	      errors.push(new _GraphQLError.GraphQLError("Variable \"$".concat(varName, "\" expected value of type ") + "\"".concat((0, _printer.print)(varDefNode.type), "\" which cannot be used as an input type."), [varDefNode.type]));
	    } else {
	      var hasValue = hasOwnProperty(inputs, varName);
	      var value = hasValue ? inputs[varName] : undefined;
	
	      if (!hasValue && varDefNode.defaultValue) {
	        // If no value was provided to a variable with a default value,
	        // use the default value.
	        coercedValues[varName] = (0, _valueFromAST.valueFromAST)(varDefNode.defaultValue, varType);
	      } else if ((!hasValue || value === null) && (0, _definition.isNonNullType)(varType)) {
	        // If no value or a nullish value was provided to a variable with a
	        // non-null type (required), produce an error.
	        errors.push(new _GraphQLError.GraphQLError(hasValue ? "Variable \"$".concat(varName, "\" of non-null type ") + "\"".concat((0, _inspect.default)(varType), "\" must not be null.") : "Variable \"$".concat(varName, "\" of required type ") + "\"".concat((0, _inspect.default)(varType), "\" was not provided."), [varDefNode]));
	      } else if (hasValue) {
	        if (value === null) {
	          // If the explicit value `null` was provided, an entry in the coerced
	          // values must exist as the value `null`.
	          coercedValues[varName] = null;
	        } else {
	          // Otherwise, a non-null value was provided, coerce it to the expected
	          // type or report an error if coercion fails.
	          var coerced = (0, _coerceValue.coerceValue)(value, varType, varDefNode);
	          var coercionErrors = coerced.errors;
	
	          if (coercionErrors) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = coercionErrors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var error = _step.value;
	                error.message = "Variable \"$".concat(varName, "\" got invalid ") + "value ".concat((0, _inspect.default)(value), "; ").concat(error.message);
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return != null) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            errors.push.apply(errors, coercionErrors);
	          } else {
	            coercedValues[varName] = coerced.value;
	          }
	        }
	      }
	    }
	  }
	
	  return errors.length === 0 ? {
	    errors: undefined,
	    coerced: coercedValues
	  } : {
	    errors: errors,
	    coerced: undefined
	  };
	}
	/**
	 * Prepares an object map of argument values given a list of argument
	 * definitions and list of argument AST nodes.
	 *
	 * Note: The returned value is a plain Object with a prototype, since it is
	 * exposed to user code. Care should be taken to not pull values from the
	 * Object prototype.
	 */
	
	
	function getArgumentValues(def, node, variableValues) {
	  var coercedValues = {};
	  var argDefs = def.args;
	  var argNodes = node.arguments;
	
	  if (!argDefs || !argNodes) {
	    return coercedValues;
	  }
	
	  var argNodeMap = (0, _keyMap.default)(argNodes, function (arg) {
	    return arg.name.value;
	  });
	
	  for (var i = 0; i < argDefs.length; i++) {
	    var argDef = argDefs[i];
	    var name = argDef.name;
	    var argType = argDef.type;
	    var argumentNode = argNodeMap[name];
	    var hasValue = void 0;
	    var isNull = void 0;
	
	    if (argumentNode && argumentNode.value.kind === _kinds.Kind.VARIABLE) {
	      var variableName = argumentNode.value.name.value;
	      hasValue = variableValues && hasOwnProperty(variableValues, variableName);
	      isNull = variableValues && variableValues[variableName] === null;
	    } else {
	      hasValue = argumentNode != null;
	      isNull = argumentNode && argumentNode.value.kind === _kinds.Kind.NULL;
	    }
	
	    if (!hasValue && argDef.defaultValue !== undefined) {
	      // If no argument was provided where the definition has a default value,
	      // use the default value.
	      coercedValues[name] = argDef.defaultValue;
	    } else if ((!hasValue || isNull) && (0, _definition.isNonNullType)(argType)) {
	      // If no argument or a null value was provided to an argument with a
	      // non-null type (required), produce a field error.
	      if (isNull) {
	        throw new _GraphQLError.GraphQLError("Argument \"".concat(name, "\" of non-null type \"").concat((0, _inspect.default)(argType), "\" ") + 'must not be null.', [argumentNode.value]);
	      } else if (argumentNode && argumentNode.value.kind === _kinds.Kind.VARIABLE) {
	        var _variableName = argumentNode.value.name.value;
	        throw new _GraphQLError.GraphQLError("Argument \"".concat(name, "\" of required type \"").concat((0, _inspect.default)(argType), "\" ") + "was provided the variable \"$".concat(_variableName, "\" ") + 'which was not provided a runtime value.', [argumentNode.value]);
	      } else {
	        throw new _GraphQLError.GraphQLError("Argument \"".concat(name, "\" of required type \"").concat((0, _inspect.default)(argType), "\" ") + 'was not provided.', [node]);
	      }
	    } else if (hasValue) {
	      if (argumentNode.value.kind === _kinds.Kind.NULL) {
	        // If the explicit value `null` was provided, an entry in the coerced
	        // values must exist as the value `null`.
	        coercedValues[name] = null;
	      } else if (argumentNode.value.kind === _kinds.Kind.VARIABLE) {
	        var _variableName2 = argumentNode.value.name.value;
	        !variableValues ? (0, _invariant.default)(0, 'Must exist for hasValue to be true.') : void 0; // Note: This does no further checking that this variable is correct.
	        // This assumes that this query has been validated and the variable
	        // usage here is of the correct type.
	
	        coercedValues[name] = variableValues[_variableName2];
	      } else {
	        var valueNode = argumentNode.value;
	        var coercedValue = (0, _valueFromAST.valueFromAST)(valueNode, argType, variableValues);
	
	        if (coercedValue === undefined) {
	          // Note: ValuesOfCorrectType validation should catch this before
	          // execution. This is a runtime check to ensure execution does not
	          // continue with an invalid argument value.
	          throw new _GraphQLError.GraphQLError("Argument \"".concat(name, "\" has invalid value ").concat((0, _printer.print)(valueNode), "."), [argumentNode.value]);
	        }
	
	        coercedValues[name] = coercedValue;
	      }
	    }
	  }
	
	  return coercedValues;
	}
	/**
	 * Prepares an object map of argument values given a directive definition
	 * and a AST node which may contain directives. Optionally also accepts a map
	 * of variable values.
	 *
	 * If the directive does not exist on the node, returns undefined.
	 *
	 * Note: The returned value is a plain Object with a prototype, since it is
	 * exposed to user code. Care should be taken to not pull values from the
	 * Object prototype.
	 */
	
	
	function getDirectiveValues(directiveDef, node, variableValues) {
	  var directiveNode = node.directives && (0, _find.default)(node.directives, function (directive) {
	    return directive.name.value === directiveDef.name;
	  });
	
	  if (directiveNode) {
	    return getArgumentValues(directiveDef, directiveNode, variableValues);
	  }
	}
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * A replacement for instanceof which includes an error warning when multi-realm
	 * constructors are detected.
	 */
	// See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
	// See: https://webpack.js.org/guides/production/
	var _default =  true ? // eslint-disable-next-line no-shadow
	function instanceOf(value, constructor) {
	  return value instanceof constructor;
	} : // eslint-disable-next-line no-shadow
	function instanceOf(value, constructor) {
	  if (value instanceof constructor) {
	    return true;
	  }
	
	  if (value) {
	    var valueClass = value.constructor;
	    var className = constructor.name;
	
	    if (className && valueClass && valueClass.name === className) {
	      throw new Error("Cannot use ".concat(className, " \"").concat(value, "\" from another module or realm.\n\nEnsure that there is only one instance of \"graphql\" in the node_modules\ndirectory. If different versions of \"graphql\" are the dependencies of other\nrelied on modules, use \"resolutions\" to ensure only one version is installed.\n\nhttps://yarnpkg.com/en/docs/selective-version-resolutions\n\nDuplicate \"graphql\" modules cannot be used at the same time since different\nversions may have different capabilities and behavior. The data from one\nversion used in the function from another could produce confusing and\nspurious results."));
	    }
	  }
	
	  return false;
	};
	
	exports.default = _default;

/***/ },
/* 105 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNullish;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Returns true if a value is null, undefined, or NaN.
	 */
	function isNullish(value) {
	  return value === null || value === undefined || value !== value;
	}

/***/ },
/* 106 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = orList;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	var MAX_LENGTH = 5;
	/**
	 * Given [ A, B, C ] return 'A, B, or C'.
	 */
	
	function orList(items) {
	  var selected = items.slice(0, MAX_LENGTH);
	  return selected.reduce(function (list, quoted, index) {
	    return list + (selected.length > 2 ? ', ' : ' ') + (index === selected.length - 1 ? 'or ' : '') + quoted;
	  });
	}

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quotedOrList;
	
	var _orList = _interopRequireDefault(__webpack_require__(106));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Given [ A, B, C ] return '"A", "B", or "C"'.
	 */
	function quotedOrList(items) {
	  return (0, _orList.default)(items.map(function (item) {
	    return "\"".concat(item, "\"");
	  }));
	}

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createLexer = createLexer;
	exports.getTokenDesc = getTokenDesc;
	exports.TokenKind = void 0;
	
	var _error = __webpack_require__(101);
	
	var _blockStringValue = _interopRequireDefault(__webpack_require__(188));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Given a Source object, this returns a Lexer for that source.
	 * A Lexer is a stateful stream generator in that every time
	 * it is advanced, it returns the next token in the Source. Assuming the
	 * source lexes, the final Token emitted by the lexer will be of kind
	 * EOF, after which the lexer will repeatedly return the same EOF token
	 * whenever called.
	 */
	function createLexer(source, options) {
	  var startOfFileToken = new Tok(TokenKind.SOF, 0, 0, 0, 0, null);
	  var lexer = {
	    source: source,
	    options: options,
	    lastToken: startOfFileToken,
	    token: startOfFileToken,
	    line: 1,
	    lineStart: 0,
	    advance: advanceLexer,
	    lookahead: lookahead
	  };
	  return lexer;
	}
	
	function advanceLexer() {
	  this.lastToken = this.token;
	  var token = this.token = this.lookahead();
	  return token;
	}
	
	function lookahead() {
	  var token = this.token;
	
	  if (token.kind !== TokenKind.EOF) {
	    do {
	      // Note: next is only mutable during parsing, so we cast to allow this.
	      token = token.next || (token.next = readToken(this, token));
	    } while (token.kind === TokenKind.COMMENT);
	  }
	
	  return token;
	}
	/**
	 * The return type of createLexer.
	 */
	
	
	/**
	 * An exported enum describing the different kinds of tokens that the
	 * lexer emits.
	 */
	var TokenKind = Object.freeze({
	  SOF: '<SOF>',
	  EOF: '<EOF>',
	  BANG: '!',
	  DOLLAR: '$',
	  AMP: '&',
	  PAREN_L: '(',
	  PAREN_R: ')',
	  SPREAD: '...',
	  COLON: ':',
	  EQUALS: '=',
	  AT: '@',
	  BRACKET_L: '[',
	  BRACKET_R: ']',
	  BRACE_L: '{',
	  PIPE: '|',
	  BRACE_R: '}',
	  NAME: 'Name',
	  INT: 'Int',
	  FLOAT: 'Float',
	  STRING: 'String',
	  BLOCK_STRING: 'BlockString',
	  COMMENT: 'Comment'
	});
	/**
	 * The enum type representing the token kinds values.
	 */
	
	exports.TokenKind = TokenKind;
	
	/**
	 * A helper function to describe a token as a string for debugging
	 */
	function getTokenDesc(token) {
	  var value = token.value;
	  return value ? "".concat(token.kind, " \"").concat(value, "\"") : token.kind;
	}
	
	var charCodeAt = String.prototype.charCodeAt;
	var slice = String.prototype.slice;
	/**
	 * Helper function for constructing the Token object.
	 */
	
	function Tok(kind, start, end, line, column, prev, value) {
	  this.kind = kind;
	  this.start = start;
	  this.end = end;
	  this.line = line;
	  this.column = column;
	  this.value = value;
	  this.prev = prev;
	  this.next = null;
	} // Print a simplified form when appearing in JSON/util.inspect.
	
	
	Tok.prototype.toJSON = Tok.prototype.inspect = function toJSON() {
	  return {
	    kind: this.kind,
	    value: this.value,
	    line: this.line,
	    column: this.column
	  };
	};
	
	function printCharCode(code) {
	  return (// NaN/undefined represents access beyond the end of the file.
	    isNaN(code) ? TokenKind.EOF : // Trust JSON for ASCII.
	    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
	    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
	  );
	}
	/**
	 * Gets the next token from the source starting at the given position.
	 *
	 * This skips over whitespace and comments until it finds the next lexable
	 * token, then lexes punctuators immediately or calls the appropriate helper
	 * function for more complicated tokens.
	 */
	
	
	function readToken(lexer, prev) {
	  var source = lexer.source;
	  var body = source.body;
	  var bodyLength = body.length;
	  var pos = positionAfterWhitespace(body, prev.end, lexer);
	  var line = lexer.line;
	  var col = 1 + pos - lexer.lineStart;
	
	  if (pos >= bodyLength) {
	    return new Tok(TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
	  }
	
	  var code = charCodeAt.call(body, pos); // SourceCharacter
	
	  switch (code) {
	    // !
	    case 33:
	      return new Tok(TokenKind.BANG, pos, pos + 1, line, col, prev);
	    // #
	
	    case 35:
	      return readComment(source, pos, line, col, prev);
	    // $
	
	    case 36:
	      return new Tok(TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
	    // &
	
	    case 38:
	      return new Tok(TokenKind.AMP, pos, pos + 1, line, col, prev);
	    // (
	
	    case 40:
	      return new Tok(TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
	    // )
	
	    case 41:
	      return new Tok(TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
	    // .
	
	    case 46:
	      if (charCodeAt.call(body, pos + 1) === 46 && charCodeAt.call(body, pos + 2) === 46) {
	        return new Tok(TokenKind.SPREAD, pos, pos + 3, line, col, prev);
	      }
	
	      break;
	    // :
	
	    case 58:
	      return new Tok(TokenKind.COLON, pos, pos + 1, line, col, prev);
	    // =
	
	    case 61:
	      return new Tok(TokenKind.EQUALS, pos, pos + 1, line, col, prev);
	    // @
	
	    case 64:
	      return new Tok(TokenKind.AT, pos, pos + 1, line, col, prev);
	    // [
	
	    case 91:
	      return new Tok(TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
	    // ]
	
	    case 93:
	      return new Tok(TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
	    // {
	
	    case 123:
	      return new Tok(TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
	    // |
	
	    case 124:
	      return new Tok(TokenKind.PIPE, pos, pos + 1, line, col, prev);
	    // }
	
	    case 125:
	      return new Tok(TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
	    // A-Z _ a-z
	
	    case 65:
	    case 66:
	    case 67:
	    case 68:
	    case 69:
	    case 70:
	    case 71:
	    case 72:
	    case 73:
	    case 74:
	    case 75:
	    case 76:
	    case 77:
	    case 78:
	    case 79:
	    case 80:
	    case 81:
	    case 82:
	    case 83:
	    case 84:
	    case 85:
	    case 86:
	    case 87:
	    case 88:
	    case 89:
	    case 90:
	    case 95:
	    case 97:
	    case 98:
	    case 99:
	    case 100:
	    case 101:
	    case 102:
	    case 103:
	    case 104:
	    case 105:
	    case 106:
	    case 107:
	    case 108:
	    case 109:
	    case 110:
	    case 111:
	    case 112:
	    case 113:
	    case 114:
	    case 115:
	    case 116:
	    case 117:
	    case 118:
	    case 119:
	    case 120:
	    case 121:
	    case 122:
	      return readName(source, pos, line, col, prev);
	    // - 0-9
	
	    case 45:
	    case 48:
	    case 49:
	    case 50:
	    case 51:
	    case 52:
	    case 53:
	    case 54:
	    case 55:
	    case 56:
	    case 57:
	      return readNumber(source, pos, code, line, col, prev);
	    // "
	
	    case 34:
	      if (charCodeAt.call(body, pos + 1) === 34 && charCodeAt.call(body, pos + 2) === 34) {
	        return readBlockString(source, pos, line, col, prev);
	      }
	
	      return readString(source, pos, line, col, prev);
	  }
	
	  throw (0, _error.syntaxError)(source, pos, unexpectedCharacterMessage(code));
	}
	/**
	 * Report a message that an unexpected character was encountered.
	 */
	
	
	function unexpectedCharacterMessage(code) {
	  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
	    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
	  }
	
	  if (code === 39) {
	    // '
	    return "Unexpected single quote character ('), did you mean to use " + 'a double quote (")?';
	  }
	
	  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
	}
	/**
	 * Reads from body starting at startPosition until it finds a non-whitespace
	 * or commented character, then returns the position of that character for
	 * lexing.
	 */
	
	
	function positionAfterWhitespace(body, startPosition, lexer) {
	  var bodyLength = body.length;
	  var position = startPosition;
	
	  while (position < bodyLength) {
	    var code = charCodeAt.call(body, position); // tab | space | comma | BOM
	
	    if (code === 9 || code === 32 || code === 44 || code === 0xfeff) {
	      ++position;
	    } else if (code === 10) {
	      // new line
	      ++position;
	      ++lexer.line;
	      lexer.lineStart = position;
	    } else if (code === 13) {
	      // carriage return
	      if (charCodeAt.call(body, position + 1) === 10) {
	        position += 2;
	      } else {
	        ++position;
	      }
	
	      ++lexer.line;
	      lexer.lineStart = position;
	    } else {
	      break;
	    }
	  }
	
	  return position;
	}
	/**
	 * Reads a comment token from the source file.
	 *
	 * #[\u0009\u0020-\uFFFF]*
	 */
	
	
	function readComment(source, start, line, col, prev) {
	  var body = source.body;
	  var code;
	  var position = start;
	
	  do {
	    code = charCodeAt.call(body, ++position);
	  } while (code !== null && ( // SourceCharacter but not LineTerminator
	  code > 0x001f || code === 0x0009));
	
	  return new Tok(TokenKind.COMMENT, start, position, line, col, prev, slice.call(body, start + 1, position));
	}
	/**
	 * Reads a number token from the source file, either a float
	 * or an int depending on whether a decimal point appears.
	 *
	 * Int:   -?(0|[1-9][0-9]*)
	 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
	 */
	
	
	function readNumber(source, start, firstCode, line, col, prev) {
	  var body = source.body;
	  var code = firstCode;
	  var position = start;
	  var isFloat = false;
	
	  if (code === 45) {
	    // -
	    code = charCodeAt.call(body, ++position);
	  }
	
	  if (code === 48) {
	    // 0
	    code = charCodeAt.call(body, ++position);
	
	    if (code >= 48 && code <= 57) {
	      throw (0, _error.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
	    }
	  } else {
	    position = readDigits(source, position, code);
	    code = charCodeAt.call(body, position);
	  }
	
	  if (code === 46) {
	    // .
	    isFloat = true;
	    code = charCodeAt.call(body, ++position);
	    position = readDigits(source, position, code);
	    code = charCodeAt.call(body, position);
	  }
	
	  if (code === 69 || code === 101) {
	    // E e
	    isFloat = true;
	    code = charCodeAt.call(body, ++position);
	
	    if (code === 43 || code === 45) {
	      // + -
	      code = charCodeAt.call(body, ++position);
	    }
	
	    position = readDigits(source, position, code);
	  }
	
	  return new Tok(isFloat ? TokenKind.FLOAT : TokenKind.INT, start, position, line, col, prev, slice.call(body, start, position));
	}
	/**
	 * Returns the new position in the source after reading digits.
	 */
	
	
	function readDigits(source, start, firstCode) {
	  var body = source.body;
	  var position = start;
	  var code = firstCode;
	
	  if (code >= 48 && code <= 57) {
	    // 0 - 9
	    do {
	      code = charCodeAt.call(body, ++position);
	    } while (code >= 48 && code <= 57); // 0 - 9
	
	
	    return position;
	  }
	
	  throw (0, _error.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
	}
	/**
	 * Reads a string token from the source file.
	 *
	 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
	 */
	
	
	function readString(source, start, line, col, prev) {
	  var body = source.body;
	  var position = start + 1;
	  var chunkStart = position;
	  var code = 0;
	  var value = '';
	
	  while (position < body.length && (code = charCodeAt.call(body, position)) !== null && // not LineTerminator
	  code !== 0x000a && code !== 0x000d) {
	    // Closing Quote (")
	    if (code === 34) {
	      value += slice.call(body, chunkStart, position);
	      return new Tok(TokenKind.STRING, start, position + 1, line, col, prev, value);
	    } // SourceCharacter
	
	
	    if (code < 0x0020 && code !== 0x0009) {
	      throw (0, _error.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
	    }
	
	    ++position;
	
	    if (code === 92) {
	      // \
	      value += slice.call(body, chunkStart, position - 1);
	      code = charCodeAt.call(body, position);
	
	      switch (code) {
	        case 34:
	          value += '"';
	          break;
	
	        case 47:
	          value += '/';
	          break;
	
	        case 92:
	          value += '\\';
	          break;
	
	        case 98:
	          value += '\b';
	          break;
	
	        case 102:
	          value += '\f';
	          break;
	
	        case 110:
	          value += '\n';
	          break;
	
	        case 114:
	          value += '\r';
	          break;
	
	        case 116:
	          value += '\t';
	          break;
	
	        case 117:
	          // u
	          var charCode = uniCharCode(charCodeAt.call(body, position + 1), charCodeAt.call(body, position + 2), charCodeAt.call(body, position + 3), charCodeAt.call(body, position + 4));
	
	          if (charCode < 0) {
	            throw (0, _error.syntaxError)(source, position, 'Invalid character escape sequence: ' + "\\u".concat(body.slice(position + 1, position + 5), "."));
	          }
	
	          value += String.fromCharCode(charCode);
	          position += 4;
	          break;
	
	        default:
	          throw (0, _error.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
	      }
	
	      ++position;
	      chunkStart = position;
	    }
	  }
	
	  throw (0, _error.syntaxError)(source, position, 'Unterminated string.');
	}
	/**
	 * Reads a block string token from the source file.
	 *
	 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
	 */
	
	
	function readBlockString(source, start, line, col, prev) {
	  var body = source.body;
	  var position = start + 3;
	  var chunkStart = position;
	  var code = 0;
	  var rawValue = '';
	
	  while (position < body.length && (code = charCodeAt.call(body, position)) !== null) {
	    // Closing Triple-Quote (""")
	    if (code === 34 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34) {
	      rawValue += slice.call(body, chunkStart, position);
	      return new Tok(TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0, _blockStringValue.default)(rawValue));
	    } // SourceCharacter
	
	
	    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
	      throw (0, _error.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
	    } // Escape Triple-Quote (\""")
	
	
	    if (code === 92 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34 && charCodeAt.call(body, position + 3) === 34) {
	      rawValue += slice.call(body, chunkStart, position) + '"""';
	      position += 4;
	      chunkStart = position;
	    } else {
	      ++position;
	    }
	  }
	
	  throw (0, _error.syntaxError)(source, position, 'Unterminated string.');
	}
	/**
	 * Converts four hexidecimal chars to the integer that the
	 * string represents. For example, uniCharCode('0','0','0','f')
	 * will return 15, and uniCharCode('0','0','f','f') returns 255.
	 *
	 * Returns a negative number on error, if a char was invalid.
	 *
	 * This is implemented by noting that char2hex() returns -1 on error,
	 * which means the result of ORing the char2hex() will also be negative.
	 */
	
	
	function uniCharCode(a, b, c, d) {
	  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
	}
	/**
	 * Converts a hex character to its integer value.
	 * '0' becomes 0, '9' becomes 9
	 * 'A' becomes 10, 'F' becomes 15
	 * 'a' becomes 10, 'f' becomes 15
	 *
	 * Returns -1 on error.
	 */
	
	
	function char2hex(a) {
	  return a >= 48 && a <= 57 ? a - 48 // 0-9
	  : a >= 65 && a <= 70 ? a - 55 // A-F
	  : a >= 97 && a <= 102 ? a - 87 // a-f
	  : -1;
	}
	/**
	 * Reads an alphanumeric + underscore name from the source.
	 *
	 * [_A-Za-z][_0-9A-Za-z]*
	 */
	
	
	function readName(source, start, line, col, prev) {
	  var body = source.body;
	  var bodyLength = body.length;
	  var position = start + 1;
	  var code = 0;
	
	  while (position !== bodyLength && (code = charCodeAt.call(body, position)) !== null && (code === 95 || // _
	  code >= 48 && code <= 57 || // 0-9
	  code >= 65 && code <= 90 || // A-Z
	  code >= 97 && code <= 122) // a-z
	  ) {
	    ++position;
	  }
	
	  return new Tok(TokenKind.NAME, start, position, line, col, prev, slice.call(body, start, position));
	}

/***/ },
/* 109 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLocation = getLocation;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Represents a location in a Source.
	 */
	
	/**
	 * Takes a Source and a UTF-8 character offset, and returns the corresponding
	 * line and column as a SourceLocation.
	 */
	function getLocation(source, position) {
	  var lineRegexp = /\r\n|[\n\r]/g;
	  var line = 1;
	  var column = position + 1;
	  var match;
	
	  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
	    line += 1;
	    column = position + 1 - (match.index + match[0].length);
	  }
	
	  return {
	    line: line,
	    column: column
	  };
	}

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.astFromValue = astFromValue;
	
	var _iterall = __webpack_require__(56);
	
	var _inspect = _interopRequireDefault(__webpack_require__(16));
	
	var _isNullish = _interopRequireDefault(__webpack_require__(105));
	
	var _isInvalid = _interopRequireDefault(__webpack_require__(33));
	
	var _objectValues = _interopRequireDefault(__webpack_require__(34));
	
	var _kinds = __webpack_require__(11);
	
	var _definition = __webpack_require__(10);
	
	var _scalars = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	/**
	 * Produces a GraphQL Value AST given a JavaScript value.
	 *
	 * A GraphQL type must be provided, which will be used to interpret different
	 * JavaScript values.
	 *
	 * | JSON Value    | GraphQL Value        |
	 * | ------------- | -------------------- |
	 * | Object        | Input Object         |
	 * | Array         | List                 |
	 * | Boolean       | Boolean              |
	 * | String        | String / Enum Value  |
	 * | Number        | Int / Float          |
	 * | Mixed         | Enum Value           |
	 * | null          | NullValue            |
	 *
	 */
	function astFromValue(value, type) {
	  if ((0, _definition.isNonNullType)(type)) {
	    var astValue = astFromValue(value, type.ofType);
	
	    if (astValue && astValue.kind === _kinds.Kind.NULL) {
	      return null;
	    }
	
	    return astValue;
	  } // only explicit null, not undefined, NaN
	
	
	  if (value === null) {
	    return {
	      kind: _kinds.Kind.NULL
	    };
	  } // undefined, NaN
	
	
	  if ((0, _isInvalid.default)(value)) {
	    return null;
	  } // Convert JavaScript array to GraphQL list. If the GraphQLType is a list, but
	  // the value is not an array, convert the value using the list's item type.
	
	
	  if ((0, _definition.isListType)(type)) {
	    var itemType = type.ofType;
	
	    if ((0, _iterall.isCollection)(value)) {
	      var valuesNodes = [];
	      (0, _iterall.forEach)(value, function (item) {
	        var itemNode = astFromValue(item, itemType);
	
	        if (itemNode) {
	          valuesNodes.push(itemNode);
	        }
	      });
	      return {
	        kind: _kinds.Kind.LIST,
	        values: valuesNodes
	      };
	    }
	
	    return astFromValue(value, itemType);
	  } // Populate the fields of the input object by creating ASTs from each value
	  // in the JavaScript object according to the fields in the input type.
	
	
	  if ((0, _definition.isInputObjectType)(type)) {
	    if (value === null || _typeof(value) !== 'object') {
	      return null;
	    }
	
	    var fields = (0, _objectValues.default)(type.getFields());
	    var fieldNodes = [];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var field = _step.value;
	        var fieldValue = astFromValue(value[field.name], field.type);
	
	        if (fieldValue) {
	          fieldNodes.push({
	            kind: _kinds.Kind.OBJECT_FIELD,
	            name: {
	              kind: _kinds.Kind.NAME,
	              value: field.name
	            },
	            value: fieldValue
	          });
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return != null) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return {
	      kind: _kinds.Kind.OBJECT,
	      fields: fieldNodes
	    };
	  }
	
	  if ((0, _definition.isScalarType)(type) || (0, _definition.isEnumType)(type)) {
	    // Since value is an internally represented value, it must be serialized
	    // to an externally represented value before converting into an AST.
	    var serialized = type.serialize(value);
	
	    if ((0, _isNullish.default)(serialized)) {
	      return null;
	    } // Others serialize based on their corresponding JavaScript scalar types.
	
	
	    if (typeof serialized === 'boolean') {
	      return {
	        kind: _kinds.Kind.BOOLEAN,
	        value: serialized
	      };
	    } // JavaScript numbers can be Int or Float values.
	
	
	    if (typeof serialized === 'number') {
	      var stringNum = String(serialized);
	      return integerStringRegExp.test(stringNum) ? {
	        kind: _kinds.Kind.INT,
	        value: stringNum
	      } : {
	        kind: _kinds.Kind.FLOAT,
	        value: stringNum
	      };
	    }
	
	    if (typeof serialized === 'string') {
	      // Enum types use Enum literals.
	      if ((0, _definition.isEnumType)(type)) {
	        return {
	          kind: _kinds.Kind.ENUM,
	          value: serialized
	        };
	      } // ID types can use Int literals.
	
	
	      if (type === _scalars.GraphQLID && integerStringRegExp.test(serialized)) {
	        return {
	          kind: _kinds.Kind.INT,
	          value: serialized
	        };
	      }
	
	      return {
	        kind: _kinds.Kind.STRING,
	        value: serialized
	      };
	    }
	
	    throw new TypeError("Cannot convert value to AST: ".concat((0, _inspect.default)(serialized)));
	  }
	  /* istanbul ignore next */
	
	
	  throw new Error("Unknown type: ".concat(type, "."));
	}
	/**
	 * IntValue:
	 *   - NegativeSign? 0
	 *   - NegativeSign? NonZeroDigit ( Digit+ )?
	 */
	
	
	var integerStringRegExp = /^-?(0|[1-9][0-9]*)$/;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.coerceValue = coerceValue;
	
	var _iterall = __webpack_require__(56);
	
	var _inspect = _interopRequireDefault(__webpack_require__(16));
	
	var _isInvalid = _interopRequireDefault(__webpack_require__(33));
	
	var _orList = _interopRequireDefault(__webpack_require__(106));
	
	var _suggestionList = _interopRequireDefault(__webpack_require__(53));
	
	var _GraphQLError = __webpack_require__(9);
	
	var _definition = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	/**
	 * Coerces a JavaScript value given a GraphQL Type.
	 *
	 * Returns either a value which is valid for the provided type or a list of
	 * encountered coercion errors.
	 *
	 */
	function coerceValue(value, type, blameNode, path) {
	  // A value must be provided if the type is non-null.
	  if ((0, _definition.isNonNullType)(type)) {
	    if (value == null) {
	      return ofErrors([coercionError("Expected non-nullable type ".concat((0, _inspect.default)(type), " not to be null"), blameNode, path)]);
	    }
	
	    return coerceValue(value, type.ofType, blameNode, path);
	  }
	
	  if (value == null) {
	    // Explicitly return the value null.
	    return ofValue(null);
	  }
	
	  if ((0, _definition.isScalarType)(type)) {
	    // Scalars determine if a value is valid via parseValue(), which can
	    // throw to indicate failure. If it throws, maintain a reference to
	    // the original error.
	    try {
	      var parseResult = type.parseValue(value);
	
	      if ((0, _isInvalid.default)(parseResult)) {
	        return ofErrors([coercionError("Expected type ".concat(type.name), blameNode, path)]);
	      }
	
	      return ofValue(parseResult);
	    } catch (error) {
	      return ofErrors([coercionError("Expected type ".concat(type.name), blameNode, path, error.message, error)]);
	    }
	  }
	
	  if ((0, _definition.isEnumType)(type)) {
	    if (typeof value === 'string') {
	      var enumValue = type.getValue(value);
	
	      if (enumValue) {
	        return ofValue(enumValue.value);
	      }
	    }
	
	    var suggestions = (0, _suggestionList.default)(String(value), type.getValues().map(function (enumValue) {
	      return enumValue.name;
	    }));
	    var didYouMean = suggestions.length !== 0 ? "did you mean ".concat((0, _orList.default)(suggestions), "?") : undefined;
	    return ofErrors([coercionError("Expected type ".concat(type.name), blameNode, path, didYouMean)]);
	  }
	
	  if ((0, _definition.isListType)(type)) {
	    var itemType = type.ofType;
	
	    if ((0, _iterall.isCollection)(value)) {
	      var errors;
	      var coercedValue = [];
	      (0, _iterall.forEach)(value, function (itemValue, index) {
	        var coercedItem = coerceValue(itemValue, itemType, blameNode, atPath(path, index));
	
	        if (coercedItem.errors) {
	          errors = add(errors, coercedItem.errors);
	        } else if (!errors) {
	          coercedValue.push(coercedItem.value);
	        }
	      });
	      return errors ? ofErrors(errors) : ofValue(coercedValue);
	    } // Lists accept a non-list value as a list of one.
	
	
	    var coercedItem = coerceValue(value, itemType, blameNode);
	    return coercedItem.errors ? coercedItem : ofValue([coercedItem.value]);
	  }
	
	  if ((0, _definition.isInputObjectType)(type)) {
	    if (_typeof(value) !== 'object') {
	      return ofErrors([coercionError("Expected type ".concat(type.name, " to be an object"), blameNode, path)]);
	    }
	
	    var _errors;
	
	    var _coercedValue = {};
	    var fields = type.getFields(); // Ensure every defined field is valid.
	
	    for (var fieldName in fields) {
	      if (hasOwnProperty.call(fields, fieldName)) {
	        var field = fields[fieldName];
	        var fieldValue = value[fieldName];
	
	        if ((0, _isInvalid.default)(fieldValue)) {
	          if (!(0, _isInvalid.default)(field.defaultValue)) {
	            _coercedValue[fieldName] = field.defaultValue;
	          } else if ((0, _definition.isNonNullType)(field.type)) {
	            _errors = add(_errors, coercionError("Field ".concat(printPath(atPath(path, fieldName)), " of required ") + "type ".concat((0, _inspect.default)(field.type), " was not provided"), blameNode));
	          }
	        } else {
	          var coercedField = coerceValue(fieldValue, field.type, blameNode, atPath(path, fieldName));
	
	          if (coercedField.errors) {
	            _errors = add(_errors, coercedField.errors);
	          } else if (!_errors) {
	            _coercedValue[fieldName] = coercedField.value;
	          }
	        }
	      }
	    } // Ensure every provided field is defined.
	
	
	    for (var _fieldName in value) {
	      if (hasOwnProperty.call(value, _fieldName)) {
	        if (!fields[_fieldName]) {
	          var _suggestions = (0, _suggestionList.default)(_fieldName, Object.keys(fields));
	
	          var _didYouMean = _suggestions.length !== 0 ? "did you mean ".concat((0, _orList.default)(_suggestions), "?") : undefined;
	
	          _errors = add(_errors, coercionError("Field \"".concat(_fieldName, "\" is not defined by type ").concat(type.name), blameNode, path, _didYouMean));
	        }
	      }
	    }
	
	    return _errors ? ofErrors(_errors) : ofValue(_coercedValue);
	  }
	  /* istanbul ignore next */
	
	
	  throw new Error("Unexpected type: ".concat(type, "."));
	}
	
	function ofValue(value) {
	  return {
	    errors: undefined,
	    value: value
	  };
	}
	
	function ofErrors(errors) {
	  return {
	    errors: errors,
	    value: undefined
	  };
	}
	
	function add(errors, moreErrors) {
	  return (errors || []).concat(moreErrors);
	}
	
	function atPath(prev, key) {
	  return {
	    prev: prev,
	    key: key
	  };
	}
	
	function coercionError(message, blameNode, path, subMessage, originalError) {
	  var pathStr = printPath(path); // Return a GraphQLError instance
	
	  return new _GraphQLError.GraphQLError(message + (pathStr ? ' at ' + pathStr : '') + (subMessage ? '; ' + subMessage : '.'), blameNode, undefined, undefined, undefined, originalError);
	} // Build a string describing the path into the value where the error was found
	
	
	function printPath(path) {
	  var pathStr = '';
	  var currentPath = path;
	
	  while (currentPath) {
	    pathStr = (typeof currentPath.key === 'string' ? '.' + currentPath.key : '[' + String(currentPath.key) + ']') + pathStr;
	    currentPath = currentPath.prev;
	  }
	
	  return pathStr ? 'value' + pathStr : '';
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOperationRootType = getOperationRootType;
	
	var _GraphQLError = __webpack_require__(9);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Extracts the root type of the operation from the schema.
	 */
	function getOperationRootType(schema, operation) {
	  switch (operation.operation) {
	    case 'query':
	      var queryType = schema.getQueryType();
	
	      if (!queryType) {
	        throw new _GraphQLError.GraphQLError('Schema does not define the required query root type.', [operation]);
	      }
	
	      return queryType;
	
	    case 'mutation':
	      var mutationType = schema.getMutationType();
	
	      if (!mutationType) {
	        throw new _GraphQLError.GraphQLError('Schema is not configured for mutations.', [operation]);
	      }
	
	      return mutationType;
	
	    case 'subscription':
	      var subscriptionType = schema.getSubscriptionType();
	
	      if (!subscriptionType) {
	        throw new _GraphQLError.GraphQLError('Schema is not configured for subscriptions.', [operation]);
	      }
	
	      return subscriptionType;
	
	    default:
	      throw new _GraphQLError.GraphQLError('Can only have query, mutation and subscription operations.', [operation]);
	  }
	}

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ValidationContext = exports.SDLValidationContext = exports.ASTValidationContext = void 0;
	
	var _visitor = __webpack_require__(36);
	
	var _kinds = __webpack_require__(11);
	
	var _TypeInfo = __webpack_require__(55);
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * An instance of this class is passed as the "this" context to all validators,
	 * allowing access to commonly useful contextual information from within a
	 * validation rule.
	 */
	var ASTValidationContext =
	/*#__PURE__*/
	function () {
	  function ASTValidationContext(ast) {
	    _defineProperty(this, "_ast", void 0);
	
	    _defineProperty(this, "_errors", void 0);
	
	    this._ast = ast;
	    this._errors = [];
	  }
	
	  var _proto = ASTValidationContext.prototype;
	
	  _proto.reportError = function reportError(error) {
	    this._errors.push(error);
	  };
	
	  _proto.getErrors = function getErrors() {
	    return this._errors;
	  };
	
	  _proto.getDocument = function getDocument() {
	    return this._ast;
	  };
	
	  return ASTValidationContext;
	}();
	
	exports.ASTValidationContext = ASTValidationContext;
	
	var SDLValidationContext =
	/*#__PURE__*/
	function (_ASTValidationContext) {
	  _inheritsLoose(SDLValidationContext, _ASTValidationContext);
	
	  function SDLValidationContext(ast, schema) {
	    var _this;
	
	    _this = _ASTValidationContext.call(this, ast) || this;
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_schema", void 0);
	
	    _this._schema = schema;
	    return _this;
	  }
	
	  var _proto2 = SDLValidationContext.prototype;
	
	  _proto2.getSchema = function getSchema() {
	    return this._schema;
	  };
	
	  return SDLValidationContext;
	}(ASTValidationContext);
	
	exports.SDLValidationContext = SDLValidationContext;
	
	var ValidationContext =
	/*#__PURE__*/
	function (_ASTValidationContext2) {
	  _inheritsLoose(ValidationContext, _ASTValidationContext2);
	
	  function ValidationContext(schema, ast, typeInfo) {
	    var _this2;
	
	    _this2 = _ASTValidationContext2.call(this, ast) || this;
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "_schema", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "_typeInfo", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "_fragments", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "_fragmentSpreads", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "_recursivelyReferencedFragments", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "_variableUsages", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "_recursiveVariableUsages", void 0);
	
	    _this2._schema = schema;
	    _this2._typeInfo = typeInfo;
	    _this2._fragmentSpreads = new Map();
	    _this2._recursivelyReferencedFragments = new Map();
	    _this2._variableUsages = new Map();
	    _this2._recursiveVariableUsages = new Map();
	    return _this2;
	  }
	
	  var _proto3 = ValidationContext.prototype;
	
	  _proto3.getSchema = function getSchema() {
	    return this._schema;
	  };
	
	  _proto3.getFragment = function getFragment(name) {
	    var fragments = this._fragments;
	
	    if (!fragments) {
	      this._fragments = fragments = this.getDocument().definitions.reduce(function (frags, statement) {
	        if (statement.kind === _kinds.Kind.FRAGMENT_DEFINITION) {
	          frags[statement.name.value] = statement;
	        }
	
	        return frags;
	      }, Object.create(null));
	    }
	
	    return fragments[name];
	  };
	
	  _proto3.getFragmentSpreads = function getFragmentSpreads(node) {
	    var spreads = this._fragmentSpreads.get(node);
	
	    if (!spreads) {
	      spreads = [];
	      var setsToVisit = [node];
	
	      while (setsToVisit.length !== 0) {
	        var set = setsToVisit.pop();
	
	        for (var i = 0; i < set.selections.length; i++) {
	          var selection = set.selections[i];
	
	          if (selection.kind === _kinds.Kind.FRAGMENT_SPREAD) {
	            spreads.push(selection);
	          } else if (selection.selectionSet) {
	            setsToVisit.push(selection.selectionSet);
	          }
	        }
	      }
	
	      this._fragmentSpreads.set(node, spreads);
	    }
	
	    return spreads;
	  };
	
	  _proto3.getRecursivelyReferencedFragments = function getRecursivelyReferencedFragments(operation) {
	    var fragments = this._recursivelyReferencedFragments.get(operation);
	
	    if (!fragments) {
	      fragments = [];
	      var collectedNames = Object.create(null);
	      var nodesToVisit = [operation.selectionSet];
	
	      while (nodesToVisit.length !== 0) {
	        var node = nodesToVisit.pop();
	        var spreads = this.getFragmentSpreads(node);
	
	        for (var i = 0; i < spreads.length; i++) {
	          var fragName = spreads[i].name.value;
	
	          if (collectedNames[fragName] !== true) {
	            collectedNames[fragName] = true;
	            var fragment = this.getFragment(fragName);
	
	            if (fragment) {
	              fragments.push(fragment);
	              nodesToVisit.push(fragment.selectionSet);
	            }
	          }
	        }
	      }
	
	      this._recursivelyReferencedFragments.set(operation, fragments);
	    }
	
	    return fragments;
	  };
	
	  _proto3.getVariableUsages = function getVariableUsages(node) {
	    var usages = this._variableUsages.get(node);
	
	    if (!usages) {
	      var newUsages = [];
	      var typeInfo = new _TypeInfo.TypeInfo(this._schema);
	      (0, _visitor.visit)(node, (0, _visitor.visitWithTypeInfo)(typeInfo, {
	        VariableDefinition: function VariableDefinition() {
	          return false;
	        },
	        Variable: function Variable(variable) {
	          newUsages.push({
	            node: variable,
	            type: typeInfo.getInputType(),
	            defaultValue: typeInfo.getDefaultValue()
	          });
	        }
	      }));
	      usages = newUsages;
	
	      this._variableUsages.set(node, usages);
	    }
	
	    return usages;
	  };
	
	  _proto3.getRecursiveVariableUsages = function getRecursiveVariableUsages(operation) {
	    var usages = this._recursiveVariableUsages.get(operation);
	
	    if (!usages) {
	      usages = this.getVariableUsages(operation);
	      var fragments = this.getRecursivelyReferencedFragments(operation);
	
	      for (var i = 0; i < fragments.length; i++) {
	        Array.prototype.push.apply(usages, this.getVariableUsages(fragments[i]));
	      }
	
	      this._recursiveVariableUsages.set(operation, usages);
	    }
	
	    return usages;
	  };
	
	  _proto3.getType = function getType() {
	    return this._typeInfo.getType();
	  };
	
	  _proto3.getParentType = function getParentType() {
	    return this._typeInfo.getParentType();
	  };
	
	  _proto3.getInputType = function getInputType() {
	    return this._typeInfo.getInputType();
	  };
	
	  _proto3.getParentInputType = function getParentInputType() {
	    return this._typeInfo.getParentInputType();
	  };
	
	  _proto3.getFieldDef = function getFieldDef() {
	    return this._typeInfo.getFieldDef();
	  };
	
	  _proto3.getDirective = function getDirective() {
	    return this._typeInfo.getDirective();
	  };
	
	  _proto3.getArgument = function getArgument() {
	    return this._typeInfo.getArgument();
	  };
	
	  return ValidationContext;
	}(ASTValidationContext);
	
	exports.ValidationContext = ValidationContext;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.badValueMessage = badValueMessage;
	exports.requiredFieldMessage = requiredFieldMessage;
	exports.unknownFieldMessage = unknownFieldMessage;
	exports.ValuesOfCorrectType = ValuesOfCorrectType;
	
	var _GraphQLError = __webpack_require__(9);
	
	var _printer = __webpack_require__(22);
	
	var _definition = __webpack_require__(10);
	
	var _inspect = _interopRequireDefault(__webpack_require__(16));
	
	var _isInvalid = _interopRequireDefault(__webpack_require__(33));
	
	var _keyMap = _interopRequireDefault(__webpack_require__(27));
	
	var _orList = _interopRequireDefault(__webpack_require__(106));
	
	var _suggestionList = _interopRequireDefault(__webpack_require__(53));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function badValueMessage(typeName, valueName, message) {
	  return "Expected type ".concat(typeName, ", found ").concat(valueName) + (message ? "; ".concat(message) : '.');
	}
	
	function requiredFieldMessage(typeName, fieldName, fieldTypeName) {
	  return "Field ".concat(typeName, ".").concat(fieldName, " of required type ") + "".concat(fieldTypeName, " was not provided.");
	}
	
	function unknownFieldMessage(typeName, fieldName, message) {
	  return "Field \"".concat(fieldName, "\" is not defined by type ").concat(typeName) + (message ? "; ".concat(message) : '.');
	}
	/**
	 * Value literals of correct type
	 *
	 * A GraphQL document is only valid if all value literals are of the type
	 * expected at their position.
	 */
	
	
	function ValuesOfCorrectType(context) {
	  return {
	    NullValue: function NullValue(node) {
	      var type = context.getInputType();
	
	      if ((0, _definition.isNonNullType)(type)) {
	        context.reportError(new _GraphQLError.GraphQLError(badValueMessage((0, _inspect.default)(type), (0, _printer.print)(node)), node));
	      }
	    },
	    ListValue: function ListValue(node) {
	      // Note: TypeInfo will traverse into a list's item type, so look to the
	      // parent input type to check if it is a list.
	      var type = (0, _definition.getNullableType)(context.getParentInputType());
	
	      if (!(0, _definition.isListType)(type)) {
	        isValidScalar(context, node);
	        return false; // Don't traverse further.
	      }
	    },
	    ObjectValue: function ObjectValue(node) {
	      var type = (0, _definition.getNamedType)(context.getInputType());
	
	      if (!(0, _definition.isInputObjectType)(type)) {
	        isValidScalar(context, node);
	        return false; // Don't traverse further.
	      } // Ensure every required field exists.
	
	
	      var inputFields = type.getFields();
	      var fieldNodeMap = (0, _keyMap.default)(node.fields, function (field) {
	        return field.name.value;
	      });
	
	      var _arr = Object.keys(inputFields);
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var fieldName = _arr[_i];
	        var fieldDef = inputFields[fieldName];
	        var fieldNode = fieldNodeMap[fieldName];
	
	        if (!fieldNode && (0, _definition.isRequiredInputField)(fieldDef)) {
	          var typeStr = (0, _inspect.default)(fieldDef.type);
	          context.reportError(new _GraphQLError.GraphQLError(requiredFieldMessage(type.name, fieldName, typeStr), node));
	        }
	      }
	    },
	    ObjectField: function ObjectField(node) {
	      var parentType = (0, _definition.getNamedType)(context.getParentInputType());
	      var fieldType = context.getInputType();
	
	      if (!fieldType && (0, _definition.isInputObjectType)(parentType)) {
	        var suggestions = (0, _suggestionList.default)(node.name.value, Object.keys(parentType.getFields()));
	        var didYouMean = suggestions.length !== 0 ? "Did you mean ".concat((0, _orList.default)(suggestions), "?") : undefined;
	        context.reportError(new _GraphQLError.GraphQLError(unknownFieldMessage(parentType.name, node.name.value, didYouMean), node));
	      }
	    },
	    EnumValue: function EnumValue(node) {
	      var type = (0, _definition.getNamedType)(context.getInputType());
	
	      if (!(0, _definition.isEnumType)(type)) {
	        isValidScalar(context, node);
	      } else if (!type.getValue(node.value)) {
	        context.reportError(new _GraphQLError.GraphQLError(badValueMessage(type.name, (0, _printer.print)(node), enumTypeSuggestion(type, node)), node));
	      }
	    },
	    IntValue: function IntValue(node) {
	      return isValidScalar(context, node);
	    },
	    FloatValue: function FloatValue(node) {
	      return isValidScalar(context, node);
	    },
	    StringValue: function StringValue(node) {
	      return isValidScalar(context, node);
	    },
	    BooleanValue: function BooleanValue(node) {
	      return isValidScalar(context, node);
	    }
	  };
	}
	/**
	 * Any value literal may be a valid representation of a Scalar, depending on
	 * that scalar type.
	 */
	
	
	function isValidScalar(context, node) {
	  // Report any error at the full type expected by the location.
	  var locationType = context.getInputType();
	
	  if (!locationType) {
	    return;
	  }
	
	  var type = (0, _definition.getNamedType)(locationType);
	
	  if (!(0, _definition.isScalarType)(type)) {
	    context.reportError(new _GraphQLError.GraphQLError(badValueMessage((0, _inspect.default)(locationType), (0, _printer.print)(node), enumTypeSuggestion(type, node)), node));
	    return;
	  } // Scalars determine if a literal value is valid via parseLiteral() which
	  // may throw or return an invalid value to indicate failure.
	
	
	  try {
	    var parseResult = type.parseLiteral(node, undefined
	    /* variables */
	    );
	
	    if ((0, _isInvalid.default)(parseResult)) {
	      context.reportError(new _GraphQLError.GraphQLError(badValueMessage((0, _inspect.default)(locationType), (0, _printer.print)(node)), node));
	    }
	  } catch (error) {
	    // Ensure a reference to the original error is maintained.
	    context.reportError(new _GraphQLError.GraphQLError(badValueMessage((0, _inspect.default)(locationType), (0, _printer.print)(node), error.message), node, undefined, undefined, undefined, error));
	  }
	}
	
	function enumTypeSuggestion(type, node) {
	  if ((0, _definition.isEnumType)(type)) {
	    var suggestions = (0, _suggestionList.default)((0, _printer.print)(node), type.getValues().map(function (value) {
	      return value.name;
	    }));
	
	    if (suggestions.length !== 0) {
	      return "Did you mean the enum value ".concat((0, _orList.default)(suggestions), "?");
	    }
	  }
	}

/***/ },
/* 115 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "size", "toggle", "vertical", "className", "as"];
	var defaultProps = {
	  vertical: false,
	  toggle: false,
	  role: 'group'
	};
	
	var ButtonGroup = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      size = _ref.size,
	      toggle = _ref.toggle,
	      vertical = _ref.vertical,
	      className = _ref.className,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'btn-group');
	  var baseClass = prefix;
	  if (vertical) baseClass = prefix + "-vertical";
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, rest, {
	    ref: ref,
	    className: (0, _classnames.default)(className, baseClass, size && prefix + "-" + size, toggle && prefix + "-toggle")
	  }));
	});
	
	ButtonGroup.displayName = 'ButtonGroup';
	ButtonGroup.defaultProps = defaultProps;
	var _default = ButtonGroup;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _css = _interopRequireDefault(__webpack_require__(50));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _Transition = _interopRequireWildcard(__webpack_require__(134));
	
	var _transitionEndListener = _interopRequireDefault(__webpack_require__(129));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(127));
	
	var _triggerBrowserReflow = _interopRequireDefault(__webpack_require__(130));
	
	var _excluded = ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "className", "children", "dimension", "getDimensionValue"];
	
	var _collapseStyles;
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	function getDefaultDimensionValue(dimension, elem) {
	  var offset = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
	  var value = elem[offset];
	  var margins = MARGINS[dimension];
	  return value + // @ts-ignore
	  parseInt((0, _css.default)(elem, margins[0]), 10) + // @ts-ignore
	  parseInt((0, _css.default)(elem, margins[1]), 10);
	}
	
	var collapseStyles = (_collapseStyles = {}, _collapseStyles[_Transition.EXITED] = 'collapse', _collapseStyles[_Transition.EXITING] = 'collapsing', _collapseStyles[_Transition.ENTERING] = 'collapsing', _collapseStyles[_Transition.ENTERED] = 'collapse show', _collapseStyles);
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  getDimensionValue: getDefaultDimensionValue
	};
	
	var Collapse = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var onEnter = _ref.onEnter,
	      onEntering = _ref.onEntering,
	      onEntered = _ref.onEntered,
	      onExit = _ref.onExit,
	      onExiting = _ref.onExiting,
	      className = _ref.className,
	      children = _ref.children,
	      _ref$dimension = _ref.dimension,
	      dimension = _ref$dimension === void 0 ? 'height' : _ref$dimension,
	      _ref$getDimensionValu = _ref.getDimensionValue,
	      getDimensionValue = _ref$getDimensionValu === void 0 ? getDefaultDimensionValue : _ref$getDimensionValu,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	
	  /* Compute dimension */
	  var computedDimension = typeof dimension === 'function' ? dimension() : dimension;
	  /* -- Expanding -- */
	
	  var handleEnter = (0, _react.useMemo)(function () {
	    return (0, _createChainedFunction.default)(function (elem) {
	      elem.style[computedDimension] = '0';
	    }, onEnter);
	  }, [computedDimension, onEnter]);
	  var handleEntering = (0, _react.useMemo)(function () {
	    return (0, _createChainedFunction.default)(function (elem) {
	      var scroll = "scroll" + computedDimension[0].toUpperCase() + computedDimension.slice(1);
	      elem.style[computedDimension] = elem[scroll] + "px";
	    }, onEntering);
	  }, [computedDimension, onEntering]);
	  var handleEntered = (0, _react.useMemo)(function () {
	    return (0, _createChainedFunction.default)(function (elem) {
	      elem.style[computedDimension] = null;
	    }, onEntered);
	  }, [computedDimension, onEntered]);
	  /* -- Collapsing -- */
	
	  var handleExit = (0, _react.useMemo)(function () {
	    return (0, _createChainedFunction.default)(function (elem) {
	      elem.style[computedDimension] = getDimensionValue(computedDimension, elem) + "px";
	      (0, _triggerBrowserReflow.default)(elem);
	    }, onExit);
	  }, [onExit, getDimensionValue, computedDimension]);
	  var handleExiting = (0, _react.useMemo)(function () {
	    return (0, _createChainedFunction.default)(function (elem) {
	      elem.style[computedDimension] = null;
	    }, onExiting);
	  }, [computedDimension, onExiting]);
	  return /*#__PURE__*/_react.default.createElement(_Transition.default // @ts-ignore
	  , (0, _extends2.default)({
	    ref: ref,
	    addEndListener: _transitionEndListener.default
	  }, props, {
	    "aria-expanded": props.role ? props.in : null,
	    onEnter: handleEnter,
	    onEntering: handleEntering,
	    onEntered: handleEntered,
	    onExit: handleExit,
	    onExiting: handleExiting
	  }), function (state, innerProps) {
	    return /*#__PURE__*/_react.default.cloneElement(children, (0, _extends2.default)({}, innerProps, {
	      className: (0, _classnames.default)(className, children.props.className, collapseStyles[state], computedDimension === 'width' && 'width')
	    }));
	  });
	}); // @ts-ignore
	
	
	// @ts-ignore
	Collapse.defaultProps = defaultProps;
	var _default = Collapse;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = exports.alignPropType = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _DropdownMenu = __webpack_require__(260);
	
	var _useMergedRefs = _interopRequireDefault(__webpack_require__(47));
	
	var _warning = _interopRequireDefault(__webpack_require__(31));
	
	var _NavbarContext = _interopRequireDefault(__webpack_require__(57));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _useWrappedRefWithWarning = _interopRequireDefault(__webpack_require__(255));
	
	var _usePopperMarginModifiers = _interopRequireDefault(__webpack_require__(254));
	
	var _excluded = ["bsPrefix", "className", "align", "alignRight", "rootCloseEvent", "flip", "show", "renderOnMount", "as", "popperConfig"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var alignDirection = _propTypes.default.oneOf(['left', 'right']);
	
	var alignPropType = _propTypes.default.oneOfType([alignDirection, _propTypes.default.shape({
	  sm: alignDirection
	}), _propTypes.default.shape({
	  md: alignDirection
	}), _propTypes.default.shape({
	  lg: alignDirection
	}), _propTypes.default.shape({
	  xl: alignDirection
	})]);
	
	exports.alignPropType = alignPropType;
	var defaultProps = {
	  align: 'left',
	  alignRight: false,
	  flip: true
	};
	
	var DropdownMenu = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      align = _ref.align,
	      alignRight = _ref.alignRight,
	      rootCloseEvent = _ref.rootCloseEvent,
	      flip = _ref.flip,
	      showProps = _ref.show,
	      renderOnMount = _ref.renderOnMount,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      popperConfig = _ref.popperConfig,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var isNavbar = (0, _react.useContext)(_NavbarContext.default);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-menu');
	
	  var _usePopperMarginModif = (0, _usePopperMarginModifiers.default)(),
	      popperRef = _usePopperMarginModif[0],
	      marginModifiers = _usePopperMarginModif[1];
	
	  var alignClasses = [];
	
	  if (align) {
	    if (typeof align === 'object') {
	      var keys = Object.keys(align);
	       false ? (0, _warning.default)(keys.length === 1, 'There should only be 1 breakpoint when passing an object to `align`') : void 0;
	
	      if (keys.length) {
	        var brkPoint = keys[0];
	        var direction = align[brkPoint]; // .dropdown-menu-right is required for responsively aligning
	        // left in addition to align left classes.
	        // Reuse alignRight to toggle the class below.
	
	        alignRight = direction === 'left';
	        alignClasses.push(prefix + "-" + brkPoint + "-" + direction);
	      }
	    } else if (align === 'right') {
	      alignRight = true;
	    }
	  }
	
	  var _useDropdownMenu = (0, _DropdownMenu.useDropdownMenu)({
	    flip: flip,
	    rootCloseEvent: rootCloseEvent,
	    show: showProps,
	    alignEnd: alignRight,
	    usePopper: !isNavbar && alignClasses.length === 0,
	    popperConfig: (0, _extends2.default)({}, popperConfig, {
	      modifiers: marginModifiers.concat((popperConfig == null ? void 0 : popperConfig.modifiers) || [])
	    })
	  }),
	      menuProps = _useDropdownMenu[0],
	      _useDropdownMenu$ = _useDropdownMenu[1],
	      hasShown = _useDropdownMenu$.hasShown,
	      popper = _useDropdownMenu$.popper,
	      show = _useDropdownMenu$.show,
	      alignEnd = _useDropdownMenu$.alignEnd,
	      toggle = _useDropdownMenu$.toggle;
	
	  menuProps.ref = (0, _useMergedRefs.default)(popperRef, (0, _useMergedRefs.default)((0, _useWrappedRefWithWarning.default)(ref, 'DropdownMenu'), menuProps.ref));
	  if (!hasShown && !renderOnMount) return null; // For custom components provide additional, non-DOM, props;
	
	  if (typeof Component !== 'string') {
	    menuProps.show = show;
	
	    menuProps.close = function () {
	      return toggle == null ? void 0 : toggle(false);
	    };
	
	    menuProps.alignRight = alignEnd;
	  }
	
	  var style = props.style;
	
	  if (popper != null && popper.placement) {
	    // we don't need the default popper style,
	    // menus are display: none when not shown.
	    style = (0, _extends2.default)({}, props.style, menuProps.style);
	    props['x-placement'] = popper.placement;
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, menuProps, {
	    style: style,
	    className: _classnames.default.apply(void 0, [className, prefix, show && 'show', alignEnd && prefix + "-right"].concat(alignClasses))
	  }));
	});
	
	DropdownMenu.displayName = 'DropdownMenu';
	DropdownMenu.defaultProps = defaultProps;
	var _default = DropdownMenu;
	exports.default = _default;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _excluded = ["as", "className", "type", "tooltip"];
	var propTypes = {
	  /**
	   * Specify whether the feedback is for valid or invalid fields
	   *
	   * @type {('valid'|'invalid')}
	   */
	  type: _propTypes.default.string,
	
	  /** Display feedback as a tooltip. */
	  tooltip: _propTypes.default.bool,
	  as: _propTypes.default.elementType
	};
	
	var Feedback = /*#__PURE__*/_react.default.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
	function (_ref, ref) {
	  var _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      className = _ref.className,
	      _ref$type = _ref.type,
	      type = _ref$type === void 0 ? 'valid' : _ref$type,
	      _ref$tooltip = _ref.tooltip,
	      tooltip = _ref$tooltip === void 0 ? false : _ref$tooltip,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(className, type + "-" + (tooltip ? 'tooltip' : 'feedback'))
	  }));
	});
	
	Feedback.displayName = 'Feedback';
	Feedback.propTypes = propTypes;
	var _default = Feedback;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _all = _interopRequireDefault(__webpack_require__(71));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _Feedback = _interopRequireDefault(__webpack_require__(119));
	
	var _FormCheckInput = _interopRequireDefault(__webpack_require__(526));
	
	var _FormCheckLabel = _interopRequireDefault(__webpack_require__(527));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(30));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["id", "bsPrefix", "bsCustomPrefix", "inline", "disabled", "isValid", "isInvalid", "feedbackTooltip", "feedback", "className", "style", "title", "type", "label", "children", "custom", "as"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var FormCheck = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var id = _ref.id,
	      bsPrefix = _ref.bsPrefix,
	      bsCustomPrefix = _ref.bsCustomPrefix,
	      _ref$inline = _ref.inline,
	      inline = _ref$inline === void 0 ? false : _ref$inline,
	      _ref$disabled = _ref.disabled,
	      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
	      _ref$isValid = _ref.isValid,
	      isValid = _ref$isValid === void 0 ? false : _ref$isValid,
	      _ref$isInvalid = _ref.isInvalid,
	      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
	      _ref$feedbackTooltip = _ref.feedbackTooltip,
	      feedbackTooltip = _ref$feedbackTooltip === void 0 ? false : _ref$feedbackTooltip,
	      feedback = _ref.feedback,
	      className = _ref.className,
	      style = _ref.style,
	      _ref$title = _ref.title,
	      title = _ref$title === void 0 ? '' : _ref$title,
	      _ref$type = _ref.type,
	      type = _ref$type === void 0 ? 'checkbox' : _ref$type,
	      label = _ref.label,
	      children = _ref.children,
	      propCustom = _ref.custom,
	      _ref$as = _ref.as,
	      as = _ref$as === void 0 ? 'input' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var custom = type === 'switch' ? true : propCustom;
	
	  var _ref2 = custom ? [bsCustomPrefix, 'custom-control'] : [bsPrefix, 'form-check'],
	      prefix = _ref2[0],
	      defaultPrefix = _ref2[1];
	
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(prefix, defaultPrefix);
	
	  var _useContext = (0, _react.useContext)(_FormContext.default),
	      controlId = _useContext.controlId;
	
	  var innerFormContext = (0, _react.useMemo)(function () {
	    return {
	      controlId: id || controlId,
	      custom: custom
	    };
	  }, [controlId, custom, id]);
	  var hasLabel = custom || label != null && label !== false && !children;
	
	  var input = /*#__PURE__*/_react.default.createElement(_FormCheckInput.default, (0, _extends2.default)({}, props, {
	    type: type === 'switch' ? 'checkbox' : type,
	    ref: ref,
	    isValid: isValid,
	    isInvalid: isInvalid,
	    isStatic: !hasLabel,
	    disabled: disabled,
	    as: as
	  }));
	
	  return /*#__PURE__*/_react.default.createElement(_FormContext.default.Provider, {
	    value: innerFormContext
	  }, /*#__PURE__*/_react.default.createElement("div", {
	    style: style,
	    className: (0, _classnames.default)(className, bsPrefix, custom && "custom-" + type, inline && bsPrefix + "-inline")
	  }, children || /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, input, hasLabel && /*#__PURE__*/_react.default.createElement(_FormCheckLabel.default, {
	    title: title
	  }, label), (isValid || isInvalid) && /*#__PURE__*/_react.default.createElement(_Feedback.default, {
	    type: isValid ? 'valid' : 'invalid',
	    tooltip: feedbackTooltip
	  }, feedback))));
	});
	
	FormCheck.displayName = 'FormCheck';
	FormCheck.Input = _FormCheckInput.default;
	FormCheck.Label = _FormCheckLabel.default;
	var _default = FormCheck;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var NavContext = /*#__PURE__*/_react.default.createContext(null);
	
	NavContext.displayName = 'NavContext';
	var _default = NavContext;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "className", "children", "as"];
	
	var NavItem = /*#__PURE__*/_react.default.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
	function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      children = _ref.children,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'nav-item');
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(className, bsPrefix)
	  }), children);
	});
	
	NavItem.displayName = 'NavItem';
	var _default = NavItem;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _uncontrollable = __webpack_require__(20);
	
	var _TabContext = _interopRequireDefault(__webpack_require__(125));
	
	var _SelectableContext = _interopRequireDefault(__webpack_require__(25));
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var TabContainer = function TabContainer(props) {
	  var _useUncontrolled = (0, _uncontrollable.useUncontrolled)(props, {
	    activeKey: 'onSelect'
	  }),
	      id = _useUncontrolled.id,
	      generateCustomChildId = _useUncontrolled.generateChildId,
	      onSelect = _useUncontrolled.onSelect,
	      activeKey = _useUncontrolled.activeKey,
	      transition = _useUncontrolled.transition,
	      mountOnEnter = _useUncontrolled.mountOnEnter,
	      unmountOnExit = _useUncontrolled.unmountOnExit,
	      children = _useUncontrolled.children;
	
	  var generateChildId = (0, _react.useMemo)(function () {
	    return generateCustomChildId || function (key, type) {
	      return id ? id + "-" + type + "-" + key : null;
	    };
	  }, [id, generateCustomChildId]);
	  var tabContext = (0, _react.useMemo)(function () {
	    return {
	      onSelect: onSelect,
	      activeKey: activeKey,
	      transition: transition,
	      mountOnEnter: mountOnEnter || false,
	      unmountOnExit: unmountOnExit || false,
	      getControlledId: function getControlledId(key) {
	        return generateChildId(key, 'tabpane');
	      },
	      getControllerId: function getControllerId(key) {
	        return generateChildId(key, 'tab');
	      }
	    };
	  }, [onSelect, activeKey, transition, mountOnEnter, unmountOnExit, generateChildId]);
	  return /*#__PURE__*/_react.default.createElement(_TabContext.default.Provider, {
	    value: tabContext
	  }, /*#__PURE__*/_react.default.createElement(_SelectableContext.default.Provider, {
	    value: onSelect || null
	  }, children));
	};
	
	var _default = TabContainer;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "as", "className"];
	
	var TabContent = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      className = _ref.className,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var decoratedBsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'tab-content');
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(className, decoratedBsPrefix)
	  }));
	});
	
	var _default = TabContent;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var TabContext = /*#__PURE__*/_react.default.createContext(null);
	
	var _default = TabContext;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _TabContext = _interopRequireDefault(__webpack_require__(125));
	
	var _SelectableContext = _interopRequireWildcard(__webpack_require__(25));
	
	var _Fade = _interopRequireDefault(__webpack_require__(43));
	
	var _excluded = ["activeKey", "getControlledId", "getControllerId"],
	    _excluded2 = ["bsPrefix", "className", "active", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "mountOnEnter", "unmountOnExit", "transition", "as", "eventKey"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function useTabContext(props) {
	  var context = (0, _react.useContext)(_TabContext.default);
	  if (!context) return props;
	  var activeKey = context.activeKey,
	      getControlledId = context.getControlledId,
	      getControllerId = context.getControllerId,
	      rest = (0, _objectWithoutPropertiesLoose2.default)(context, _excluded);
	  var shouldTransition = props.transition !== false && rest.transition !== false;
	  var key = (0, _SelectableContext.makeEventKey)(props.eventKey);
	  return (0, _extends2.default)({}, props, {
	    active: props.active == null && key != null ? (0, _SelectableContext.makeEventKey)(activeKey) === key : props.active,
	    id: getControlledId(props.eventKey),
	    'aria-labelledby': getControllerId(props.eventKey),
	    transition: shouldTransition && (props.transition || rest.transition || _Fade.default),
	    mountOnEnter: props.mountOnEnter != null ? props.mountOnEnter : rest.mountOnEnter,
	    unmountOnExit: props.unmountOnExit != null ? props.unmountOnExit : rest.unmountOnExit
	  });
	}
	
	var TabPane = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
	  var _useTabContext = useTabContext(props),
	      bsPrefix = _useTabContext.bsPrefix,
	      className = _useTabContext.className,
	      active = _useTabContext.active,
	      onEnter = _useTabContext.onEnter,
	      onEntering = _useTabContext.onEntering,
	      onEntered = _useTabContext.onEntered,
	      onExit = _useTabContext.onExit,
	      onExiting = _useTabContext.onExiting,
	      onExited = _useTabContext.onExited,
	      mountOnEnter = _useTabContext.mountOnEnter,
	      unmountOnExit = _useTabContext.unmountOnExit,
	      Transition = _useTabContext.transition,
	      _useTabContext$as = _useTabContext.as,
	      Component = _useTabContext$as === void 0 ? 'div' : _useTabContext$as,
	      _ = _useTabContext.eventKey,
	      rest = (0, _objectWithoutPropertiesLoose2.default)(_useTabContext, _excluded2);
	
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'tab-pane');
	  if (!active && !Transition && unmountOnExit) return null;
	
	  var pane = /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, rest, {
	    ref: ref,
	    role: "tabpanel",
	    "aria-hidden": !active,
	    className: (0, _classnames.default)(className, prefix, {
	      active: active
	    })
	  }));
	
	  if (Transition) pane = /*#__PURE__*/_react.default.createElement(Transition, {
	    in: active,
	    onEnter: onEnter,
	    onEntering: onEntering,
	    onEntered: onEntered,
	    onExit: onExit,
	    onExiting: onExiting,
	    onExited: onExited,
	    mountOnEnter: mountOnEnter,
	    unmountOnExit: unmountOnExit
	  }, pane); // We provide an empty the TabContext so `<Nav>`s in `<TabPane>`s don't
	  // conflict with the top level one.
	
	  return /*#__PURE__*/_react.default.createElement(_TabContext.default.Provider, {
	    value: null
	  }, /*#__PURE__*/_react.default.createElement(_SelectableContext.default.Provider, {
	    value: null
	  }, pane));
	});
	
	TabPane.displayName = 'TabPane';
	var _default = TabPane;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 127 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) return f;
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      // @ts-ignore
	      acc.apply(this, args); // @ts-ignore
	
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	var _default = createChainedFunction;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _default = function _default(className) {
	  return /*#__PURE__*/_react.default.forwardRef(function (p, ref) {
	    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, p, {
	      ref: ref,
	      className: (0, _classnames.default)(p.className, className)
	    }));
	  });
	};
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = transitionEndListener;
	
	var _css = _interopRequireDefault(__webpack_require__(50));
	
	var _transitionEnd = _interopRequireDefault(__webpack_require__(183));
	
	function parseDuration(node, property) {
	  var str = (0, _css.default)(node, property) || '';
	  var mult = str.indexOf('ms') === -1 ? 1000 : 1;
	  return parseFloat(str) * mult;
	}
	
	function transitionEndListener(element, handler) {
	  var duration = parseDuration(element, 'transitionDuration');
	  var delay = parseDuration(element, 'transitionDelay');
	  var remove = (0, _transitionEnd.default)(element, function (e) {
	    if (e.target === element) {
	      remove();
	      handler(e);
	    }
	  }, duration + delay);
	}
	
	module.exports = exports["default"];

/***/ },
/* 130 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = triggerBrowserReflow;
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	function triggerBrowserReflow(node) {
	  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
	  node.offsetHeight;
	}
	
	module.exports = exports["default"];

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;
	
	var _exenv = __webpack_require__(442);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EE = _exenv2.default;
	
	var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
	
	var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};
	
	var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};
	
	var canUseDOM = exports.canUseDOM = EE.canUseDOM;
	
	exports.default = SafeHTMLElement;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var DropdownContext = /*#__PURE__*/_react["default"].createContext(null);
	
	var _default = DropdownContext;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = safeFindDOMNode;
	
	var _reactDom = _interopRequireDefault(__webpack_require__(44));
	
	function safeFindDOMNode(componentOrElement) {
	  if (componentOrElement && 'setState' in componentOrElement) {
	    return _reactDom["default"].findDOMNode(componentOrElement);
	  }
	
	  return componentOrElement != null ? componentOrElement : null;
	}
	
	module.exports = exports.default;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(44));
	
	var _config = _interopRequireDefault(__webpack_require__(576));
	
	var _PropTypes = __webpack_require__(577);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(575));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 1 },
	 *   entered:  { opacity: 1 },
	 *   exiting:  { opacity: 0 },
	 *   exited:  { opacity: 0 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  } // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	  ;
	
	  var _proto = Transition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(mounting);
	      } else {
	        this.performExit();
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context ? this.context.isMounting : mounting;
	
	    var _ref2 = this.props.nodeRef ? [appearing] : [_reactDom.default.findDOMNode(this), appearing],
	        maybeNode = _ref2[0],
	        maybeAppearing = _ref2[1];
	
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter || _config.default.disabled) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(maybeNode);
	      });
	      return;
	    }
	
	    this.props.onEnter(maybeNode, maybeAppearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(maybeNode, maybeAppearing);
	
	      _this2.onTransitionEnd(enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(maybeNode, maybeAppearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit() {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts();
	    var maybeNode = this.props.nodeRef ? undefined : _reactDom.default.findDOMNode(this); // no exit animation skip right to EXITED
	
	    if (!exit || _config.default.disabled) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(maybeNode);
	      });
	      return;
	    }
	
	    this.props.onExit(maybeNode);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(maybeNode);
	
	      _this3.onTransitionEnd(timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(maybeNode);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
	    this.setNextCallback(handler);
	    var node = this.props.nodeRef ? this.props.nodeRef.current : _reactDom.default.findDOMNode(this);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
	          maybeNode = _ref3[0],
	          maybeNextCallback = _ref3[1];
	
	      this.props.addEndListener(maybeNode, maybeNextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        _in = _this$props.in,
	        _mountOnEnter = _this$props.mountOnEnter,
	        _unmountOnExit = _this$props.unmountOnExit,
	        _appear = _this$props.appear,
	        _enter = _this$props.enter,
	        _exit = _this$props.exit,
	        _timeout = _this$props.timeout,
	        _addEndListener = _this$props.addEndListener,
	        _onEnter = _this$props.onEnter,
	        _onEntering = _this$props.onEntering,
	        _onEntered = _this$props.onEntered,
	        _onExit = _this$props.onExit,
	        _onExiting = _this$props.onExiting,
	        _onExited = _this$props.onExited,
	        _nodeRef = _this$props.nodeRef,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
	
	    return (
	      /*#__PURE__*/
	      // allows for nested Transitions
	      _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, typeof children === 'function' ? children(status, childProps) : _react.default.cloneElement(_react.default.Children.only(children), childProps))
	    );
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextType = _TransitionGroupContext.default;
	Transition.propTypes =  false ? {
	  /**
	   * A React reference to DOM element that need to transition:
	   * https://stackoverflow.com/a/51127130/4671932
	   *
	   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
	   *      (e.g. `onEnter`) because user already has direct access to the node.
	   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
	   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
	   *     (see
	   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
	   */
	  nodeRef: _propTypes.default.shape({
	    current: typeof Element === 'undefined' ? _propTypes.default.any : function (propValue, key, componentName, location, propFullName, secret) {
	      var value = propValue[key];
	      return _propTypes.default.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
	    }
	  }),
	
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.func.isRequired, _propTypes.default.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: _propTypes.default.bool,
	
	  /**
	   * By default the child component does not perform the enter transition when
	   * it first mounts, regardless of the value of `in`. If you want this
	   * behavior, set both `appear` and `in` to `true`.
	   *
	   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
	   * > only adds an additional enter transition. However, in the
	   * > `<CSSTransition>` component that first enter transition does result in
	   * > additional `.appear-*` classes, that way you can choose to style it
	   * > differently.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. Timeouts are still used as a fallback if provided.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: _propTypes.default.func
	} : {}; // Name the function so it is clearer in the documentation
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = UNMOUNTED;
	Transition.EXITED = EXITED;
	Transition.ENTERING = ENTERING;
	Transition.ENTERED = ENTERED;
	Transition.EXITING = EXITING;
	var _default = Transition;
	exports.default = _default;

/***/ },
/* 135 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 136 */
135,
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
		module.exports = __webpack_require__(274);
	} else {
		module.exports = require('./dist/aws-amplify-api.js');
	}


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
		module.exports = __webpack_require__(276);
	} else {
		module.exports = require('./dist/aws-amplify-cache.js');
	}


/***/ },
/* 139 */
[601, 8],
/* 140 */
[604, 8],
/* 141 */
[615, 8],
/* 142 */
[619, 143, 144, 46, 145, 146, 12],
/* 143 */
[620, 12],
/* 144 */
[621, 46, 12],
/* 145 */
[622, 12],
/* 146 */
[623, 12],
/* 147 */
[628, 8, 12, 302, 46, 84],
/* 148 */
[630, 12, 59, 85, 82, 83],
/* 149 */
[631, 8, 12, 59],
/* 150 */
[637, 8],
/* 151 */
[645, 8],
/* 152 */
/***/ function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([bth[buf[i++]], bth[buf[i++]], 
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]],
		bth[buf[i++]], bth[buf[i++]],
		bth[buf[i++]], bth[buf[i++]]]).join('');
	}
	
	module.exports = bytesToUuid;


/***/ },
/* 153 */
/***/ function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto
	// implementation. Also, find the complete implementation of crypto on IE11.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ },
/* 154 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 155 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 156 */
/***/ function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var sheet = __webpack_require__(158);
	var Stylis = _interopDefault(__webpack_require__(351));
	__webpack_require__(353);
	
	// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
	// inlined to avoid umd wrapper and peerDep warnings/installing stylis
	// since we use stylis after closure compiler
	var delimiter = '/*|*/';
	var needle = delimiter + '}';
	
	function toSheet(block) {
	  if (block) {
	    Sheet.current.insert(block + '}');
	  }
	}
	
	var Sheet = {
	  current: null
	};
	var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
	  switch (context) {
	    // property
	    case 1:
	      {
	        switch (content.charCodeAt(0)) {
	          case 64:
	            {
	              // @import
	              Sheet.current.insert(content + ';');
	              return '';
	            }
	          // charcode for l
	
	          case 108:
	            {
	              // charcode for b
	              // this ignores label
	              if (content.charCodeAt(2) === 98) {
	                return '';
	              }
	            }
	        }
	
	        break;
	      }
	    // selector
	
	    case 2:
	      {
	        if (ns === 0) return content + delimiter;
	        break;
	      }
	    // at-rule
	
	    case 3:
	      {
	        switch (ns) {
	          // @font-face, @page
	          case 102:
	          case 112:
	            {
	              Sheet.current.insert(selectors[0] + content);
	              return '';
	            }
	
	          default:
	            {
	              return content + (at === 0 ? delimiter : '');
	            }
	        }
	      }
	
	    case -2:
	      {
	        content.split(needle).forEach(toSheet);
	      }
	  }
	};
	
	var createCache = function createCache(options) {
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var stylis = new Stylis(stylisOptions);
	
	  if (false) {
	    // $FlowFixMe
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var inserted = {}; // $FlowFixMe
	
	  var container;
	
	  {
	    container = options.container || document.head;
	    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(nodes, function (node) {
	      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
	
	      attrib.split(' ').forEach(function (id) {
	        inserted[id] = true;
	      });
	
	      if (node.parentNode !== container) {
	        container.appendChild(node);
	      }
	    });
	  }
	
	  var _insert;
	
	  {
	    stylis.use(options.stylisPlugins)(ruleSheet);
	
	    _insert = function insert(selector, serialized, sheet, shouldCache) {
	      var name = serialized.name;
	      Sheet.current = sheet;
	
	      if (false) {
	        var map = serialized.map;
	        Sheet.current = {
	          insert: function insert(rule) {
	            sheet.insert(rule + map);
	          }
	        };
	      }
	
	      stylis(selector, serialized.styles);
	
	      if (shouldCache) {
	        cache.inserted[name] = true;
	      }
	    };
	  }
	
	  if (false) {
	    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
	    var commentStart = /\/\*/g;
	    var commentEnd = /\*\//g;
	    stylis.use(function (context, content) {
	      switch (context) {
	        case -1:
	          {
	            while (commentStart.test(content)) {
	              commentEnd.lastIndex = commentStart.lastIndex;
	
	              if (commentEnd.test(content)) {
	                commentStart.lastIndex = commentEnd.lastIndex;
	                continue;
	              }
	
	              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
	            }
	
	            commentStart.lastIndex = 0;
	            break;
	          }
	      }
	    });
	    stylis.use(function (context, content, selectors) {
	      switch (context) {
	        case -1:
	          {
	            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
	            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);
	
	            if (unsafePseudoClasses && cache.compat !== true) {
	              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
	                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
	                var ignore = ignoreRegExp.test(content);
	
	                if (unsafePseudoClass && !ignore) {
	                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
	                }
	              });
	            }
	
	            break;
	          }
	      }
	    });
	  }
	
	  var cache = {
	    key: key,
	    sheet: new sheet.StyleSheet({
	      key: key,
	      container: container,
	      nonce: options.nonce,
	      speedy: options.speedy
	    }),
	    nonce: options.nonce,
	    inserted: inserted,
	    registered: {},
	    insert: _insert
	  };
	  return cache;
	};
	
	exports.default = createCache;


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*
	
	Based off glamor's StyleSheet, thanks Sunil ❤️
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	
	// usage
	
	import { StyleSheet } from '@emotion/sheet'
	
	let styleSheet = new StyleSheet({ key: '', container: document.head })
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	  /* istanbul ignore next */
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function createStyleElement(options) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', options.key);
	
	  if (options.nonce !== undefined) {
	    tag.setAttribute('nonce', options.nonce);
	  }
	
	  tag.appendChild(document.createTextNode(''));
	  return tag;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(options) {
	    this.isSpeedy = options.speedy === undefined ? ("production") === 'production' : options.speedy;
	    this.tags = [];
	    this.ctr = 0;
	    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
	
	    this.key = options.key;
	    this.container = options.container;
	    this.before = null;
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.insert = function insert(rule) {
	    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
	    // it's 1 in dev because we insert source maps that map a single rule to a location
	    // and you can only have one source map per style tag
	    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
	      var _tag = createStyleElement(this);
	
	      var before;
	
	      if (this.tags.length === 0) {
	        before = this.before;
	      } else {
	        before = this.tags[this.tags.length - 1].nextSibling;
	      }
	
	      this.container.insertBefore(_tag, before);
	      this.tags.push(_tag);
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    if (this.isSpeedy) {
	      var sheet = sheetForTag(tag);
	
	      try {
	        // this is a really hot path
	        // we check the second character first because having "i"
	        // as the second character will happen less often than
	        // having "@" as the first character
	        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
	        // the big drawback is that the css won't be editable in devtools
	
	        sheet.insertRule(rule, // we need to insert @import rules before anything else
	        // otherwise there will be an error
	        // technically this means that the @import rules will
	        // _usually_(not always since there could be multiple style tags)
	        // be the first ones in prod and generally later in dev
	        // this shouldn't really matter in the real world though
	        // @import is generally only used for font faces from google fonts and etc.
	        // so while this could be technically correct then it would be slower and larger
	        // for a tiny bit of correctness that won't matter in the real world
	        isImportRule ? 0 : sheet.cssRules.length);
	      } catch (e) {
	        if (false) {
	          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
	        }
	      }
	    } else {
	      tag.appendChild(document.createTextNode(rule));
	    }
	
	    this.ctr++;
	  };
	
	  _proto.flush = function flush() {
	    // $FlowFixMe
	    this.tags.forEach(function (tag) {
	      return tag.parentNode.removeChild(tag);
	    });
	    this.tags = [];
	    this.ctr = 0;
	  };
	
	  return StyleSheet;
	}();
	
	exports.StyleSheet = StyleSheet;


/***/ },
/* 159 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var isBrowser = "object" !== 'undefined';
	function getRegisteredStyles(registered, registeredStyles, classNames) {
	  var rawClassName = '';
	  classNames.split(' ').forEach(function (className) {
	    if (registered[className] !== undefined) {
	      registeredStyles.push(registered[className]);
	    } else {
	      rawClassName += className + " ";
	    }
	  });
	  return rawClassName;
	}
	var insertStyles = function insertStyles(cache, serialized, isStringTag) {
	  var className = cache.key + "-" + serialized.name;
	
	  if ( // we only need to add the styles to the registered cache if the
	  // class name could be used further down
	  // the tree but if it's a string tag, we know it won't
	  // so we don't have to add it to registered cache.
	  // this improves memory usage since we can avoid storing the whole style string
	  (isStringTag === false || // we need to always store it if we're in compat mode and
	  // in node since emotion-server relies on whether a style is in
	  // the registered cache to know whether a style is global or not
	  // also, note that this check will be dead code eliminated in the browser
	  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
	    cache.registered[className] = serialized.styles;
	  }
	
	  if (cache.inserted[serialized.name] === undefined) {
	    var current = serialized;
	
	    do {
	      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
	
	      current = current.next;
	    } while (current !== undefined);
	  }
	};
	
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.insertStyles = insertStyles;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
	 * value is the one rendered with. Generally only required for Concurrent mode usage
	 * where previous work in `render()` may be discarded befor being used.
	 *
	 * This is safe to access in an event handler.
	 *
	 * @param value The `Ref` value
	 */
	function useCommittedRef(value) {
	  var ref = (0, _react.useRef)(value);
	  (0, _react.useEffect)(function () {
	    ref.current = value;
	  }, [value]);
	  return ref;
	}
	
	var _default = useCommittedRef;
	exports.default = _default;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = useForceUpdate;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Returns a function that triggers a component update. the hook equivalent to
	 * `this.forceUpdate()` in a class component. In most cases using a state value directly
	 * is preferable but may be required in some advanced usages of refs for interop or
	 * when direct DOM manipulation is required.
	 *
	 * ```ts
	 * const forceUpdate = useForceUpdate();
	 *
	 * const updateOnClick = useCallback(() => {
	 *  forceUpdate()
	 * }, [forceUpdate])
	 *
	 * return <button type="button" onClick={updateOnClick}>Hi there</button>
	 * ```
	 */
	function useForceUpdate() {
	  // The toggling state value is designed to defeat React optimizations for skipping
	  // updates when they are stricting equal to the last state value
	  var _useReducer = (0, _react.useReducer)(function (state) {
	    return !state;
	  }, false),
	      dispatch = _useReducer[1];
	
	  return dispatch;
	}

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = usePrevious;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Store the last of some value. Tracked via a `Ref` only updating it
	 * after the component renders.
	 *
	 * Helpful if you need to compare a prop value to it's previous value during render.
	 *
	 * ```ts
	 * function Component(props) {
	 *   const lastProps = usePrevious(props)
	 *
	 *   if (lastProps.foo !== props.foo)
	 *     resetValueFromProps(props.foo)
	 * }
	 * ```
	 *
	 * @param value the value to track
	 */
	function usePrevious(value) {
	  var ref = (0, _react.useRef)(null);
	  (0, _react.useEffect)(function () {
	    ref.current = value;
	  });
	  return ref.current;
	}

/***/ },
/* 163 */
[601, 7],
/* 164 */
[604, 7],
/* 165 */
[615, 7],
/* 166 */
[619, 167, 168, 49, 169, 170, 13],
/* 167 */
[620, 13],
/* 168 */
[621, 49, 13],
/* 169 */
[622, 13],
/* 170 */
[623, 13],
/* 171 */
[628, 7, 13, 389, 49, 94],
/* 172 */
[630, 13, 61, 95, 92, 93],
/* 173 */
[631, 7, 13, 61],
/* 174 */
[637, 7],
/* 175 */
[645, 7],
/* 176 */
[648, 7],
/* 177 */
152,
/* 178 */
153,
/* 179 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
	
	var awsmobile = {
	    "aws_project_region": "us-east-1",
	    "aws_cognito_identity_pool_id": "us-east-1:55447ea9-7cc8-452c-9b1b-e77fa57b4973",
	    "aws_cognito_region": "us-east-1",
	    "aws_user_pools_id": "us-east-1_ueE2zXUSQ",
	    "aws_user_pools_web_client_id": "33l7noonn28gljnj6dpf1dtng3",
	    "oauth": {},
	    "aws_appsync_graphqlEndpoint": "https://4abbbl3lwrdzlnukvudasp5szy.appsync-api.us-east-1.amazonaws.com/graphql",
	    "aws_appsync_region": "us-east-1",
	    "aws_appsync_authenticationType": "AWS_IAM",
	    "aws_user_files_s3_bucket": "icam-lendinglibrary-productimages-production",
	    "aws_user_files_s3_bucket_region": "us-east-1",
	    "aws_content_delivery_bucket": "icam-lendinglibrary-20191205102512-hostingbucket-production",
	    "aws_content_delivery_bucket_region": "us-east-1",
	    "aws_content_delivery_url": "https://d1iri2okj37qu.cloudfront.net"
	};
	
	exports.default = awsmobile;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(426);


/***/ },
/* 181 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	/**
	 * Checks if a given element has a CSS class.
	 * 
	 * @param element the element
	 * @param className the CSS class name
	 */
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);
	  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 182 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	/**
	 * A `removeEventListener` ponyfill
	 * 
	 * @param node the element
	 * @param eventName the event name
	 * @param handle the handler
	 * @param options event options
	 */
	function removeEventListener(node, eventName, handler, options) {
	  var capture = options && typeof options !== 'boolean' ? options.capture : options;
	  node.removeEventListener(eventName, handler, capture);
	
	  if (handler.__once) {
	    node.removeEventListener(eventName, handler.__once, capture);
	  }
	}
	
	var _default = removeEventListener;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = transitionEnd;
	
	var _css = _interopRequireDefault(__webpack_require__(50));
	
	var _listen = _interopRequireDefault(__webpack_require__(98));
	
	var _triggerEvent = _interopRequireDefault(__webpack_require__(441));
	
	function parseDuration(node) {
	  var str = (0, _css.default)(node, 'transitionDuration') || '';
	  var mult = str.indexOf('ms') === -1 ? 1000 : 1;
	  return parseFloat(str) * mult;
	}
	
	function emulateTransitionEnd(element, duration, padding) {
	  if (padding === void 0) {
	    padding = 5;
	  }
	
	  var called = false;
	  var handle = setTimeout(function () {
	    if (!called) (0, _triggerEvent.default)(element, 'transitionend', true);
	  }, duration + padding);
	  var remove = (0, _listen.default)(element, 'transitionend', function () {
	    called = true;
	  }, {
	    once: true
	  });
	  return function () {
	    clearTimeout(handle);
	    remove();
	  };
	}
	
	function transitionEnd(element, handler, duration, padding) {
	  if (duration == null) duration = parseDuration(element) || 0;
	  var removeEmulate = emulateTransitionEnd(element, duration, padding);
	  var remove = (0, _listen.default)(element, 'transitionend', handler);
	  return function () {
	    removeEmulate();
	    remove();
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 184 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.printError = printError;
	
	var _location = __webpack_require__(109);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Prints a GraphQLError to a string, representing useful location information
	 * about the error's position in the source.
	 */
	function printError(error) {
	  var printedLocations = [];
	
	  if (error.nodes) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = error.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var node = _step.value;
	
	        if (node.loc) {
	          printedLocations.push(highlightSourceAtLocation(node.loc.source, (0, _location.getLocation)(node.loc.source, node.loc.start)));
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return != null) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  } else if (error.source && error.locations) {
	    var source = error.source;
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = error.locations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var location = _step2.value;
	        printedLocations.push(highlightSourceAtLocation(source, location));
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	  }
	
	  return printedLocations.length === 0 ? error.message : [error.message].concat(printedLocations).join('\n\n') + '\n';
	}
	/**
	 * Render a helpful description of the location of the error in the GraphQL
	 * Source document.
	 */
	
	
	function highlightSourceAtLocation(source, location) {
	  var firstLineColumnOffset = source.locationOffset.column - 1;
	  var body = whitespace(firstLineColumnOffset) + source.body;
	  var lineIndex = location.line - 1;
	  var lineOffset = source.locationOffset.line - 1;
	  var lineNum = location.line + lineOffset;
	  var columnOffset = location.line === 1 ? firstLineColumnOffset : 0;
	  var columnNum = location.column + columnOffset;
	  var lines = body.split(/\r\n|[\n\r]/g);
	  return "".concat(source.name, " (").concat(lineNum, ":").concat(columnNum, ")\n") + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
	  ["".concat(lineNum - 1, ": "), lines[lineIndex - 1]], ["".concat(lineNum, ": "), lines[lineIndex]], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1, ": "), lines[lineIndex + 1]]]);
	}
	
	function printPrefixedLines(lines) {
	  var existingLines = lines.filter(function (_ref) {
	    var _ = _ref[0],
	        line = _ref[1];
	    return line !== undefined;
	  });
	  var padLen = 0;
	  var _iteratorNormalCompletion3 = true;
	  var _didIteratorError3 = false;
	  var _iteratorError3 = undefined;
	
	  try {
	    for (var _iterator3 = existingLines[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	      var _ref4 = _step3.value;
	      var prefix = _ref4[0];
	      padLen = Math.max(padLen, prefix.length);
	    }
	  } catch (err) {
	    _didIteratorError3 = true;
	    _iteratorError3 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
	        _iterator3.return();
	      }
	    } finally {
	      if (_didIteratorError3) {
	        throw _iteratorError3;
	      }
	    }
	  }
	
	  return existingLines.map(function (_ref3) {
	    var prefix = _ref3[0],
	        line = _ref3[1];
	    return lpad(padLen, prefix) + line;
	  }).join('\n');
	}
	
	function whitespace(len) {
	  return Array(len + 1).join(' ');
	}
	
	function lpad(len, str) {
	  return whitespace(len - str.length) + str;
	}

/***/ },
/* 186 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = applyToJSON;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * The `applyToJSON()` function defines toJSON() and inspect() prototype
	 * methods which are aliases for toString().
	 */
	function applyToJSON(classObject) {
	  classObject.prototype.toJSON = classObject.prototype.inspect = classObject.prototype.toString;
	}

/***/ },
/* 187 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPromise;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Returns true if the value acts like a Promise, i.e. has a "then" function,
	 * otherwise returns false.
	 */
	// eslint-disable-next-line no-redeclare
	function isPromise(value) {
	  return Boolean(value && typeof value.then === 'function');
	}

/***/ },
/* 188 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = blockStringValue;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Produces the value of a block string from its parsed raw value, similar to
	 * Coffeescript's block string, Python's docstring trim or Ruby's strip_heredoc.
	 *
	 * This implements the GraphQL spec's BlockStringValue() static algorithm.
	 */
	function blockStringValue(rawString) {
	  // Expand a block string's raw value into independent lines.
	  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
	
	  var commonIndent = null;
	
	  for (var i = 1; i < lines.length; i++) {
	    var line = lines[i];
	    var indent = leadingWhitespace(line);
	
	    if (indent < line.length && (commonIndent === null || indent < commonIndent)) {
	      commonIndent = indent;
	
	      if (commonIndent === 0) {
	        break;
	      }
	    }
	  }
	
	  if (commonIndent) {
	    for (var _i = 1; _i < lines.length; _i++) {
	      lines[_i] = lines[_i].slice(commonIndent);
	    }
	  } // Remove leading and trailing blank lines.
	
	
	  while (lines.length > 0 && isBlank(lines[0])) {
	    lines.shift();
	  }
	
	  while (lines.length > 0 && isBlank(lines[lines.length - 1])) {
	    lines.pop();
	  } // Return a string of the lines joined with U+000A.
	
	
	  return lines.join('\n');
	}
	
	function leadingWhitespace(str) {
	  var i = 0;
	
	  while (i < str.length && (str[i] === ' ' || str[i] === '\t')) {
	    i++;
	  }
	
	  return i;
	}
	
	function isBlank(str) {
	  return leadingWhitespace(str) === str.length;
	}

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Source = void 0;
	
	var _invariant = _interopRequireDefault(__webpack_require__(17));
	
	var _defineToStringTag = _interopRequireDefault(__webpack_require__(64));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * A representation of source input to GraphQL.
	 * `name` and `locationOffset` are optional. They are useful for clients who
	 * store GraphQL documents in source files; for example, if the GraphQL input
	 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
	 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
	 * line and column in locationOffset are 1-indexed
	 */
	var Source = function Source(body, name, locationOffset) {
	  _defineProperty(this, "body", void 0);
	
	  _defineProperty(this, "name", void 0);
	
	  _defineProperty(this, "locationOffset", void 0);
	
	  this.body = body;
	  this.name = name || 'GraphQL request';
	  this.locationOffset = locationOffset || {
	    line: 1,
	    column: 1
	  };
	  !(this.locationOffset.line > 0) ? (0, _invariant.default)(0, 'line in locationOffset is 1-indexed and must be positive') : void 0;
	  !(this.locationOffset.column > 0) ? (0, _invariant.default)(0, 'column in locationOffset is 1-indexed and must be positive') : void 0;
	}; // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported
	
	
	exports.Source = Source;
	(0, _defineToStringTag.default)(Source);

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assertValidName = assertValidName;
	exports.isValidNameError = isValidNameError;
	
	var _GraphQLError = __webpack_require__(9);
	
	var _invariant = _interopRequireDefault(__webpack_require__(17));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	var NAME_RX = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
	/**
	 * Upholds the spec rules about naming.
	 */
	
	function assertValidName(name) {
	  var error = isValidNameError(name);
	
	  if (error) {
	    throw error;
	  }
	
	  return name;
	}
	/**
	 * Returns an Error if a name is invalid.
	 */
	
	
	function isValidNameError(name, node) {
	  !(typeof name === 'string') ? (0, _invariant.default)(0, 'Expected string') : void 0;
	
	  if (name.length > 1 && name[0] === '_' && name[1] === '_') {
	    return new _GraphQLError.GraphQLError("Name \"".concat(name, "\" must not begin with \"__\", which is reserved by ") + 'GraphQL introspection.', node);
	  }
	
	  if (!NAME_RX.test(name)) {
	    return new _GraphQLError.GraphQLError("Names must match /^[_a-zA-Z][_a-zA-Z0-9]*$/ but \"".concat(name, "\" does not."), node);
	  }
	}

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildASTSchema = buildASTSchema;
	exports.getDescription = getDescription;
	exports.buildSchema = buildSchema;
	exports.ASTDefinitionBuilder = void 0;
	
	var _invariant = _interopRequireDefault(__webpack_require__(17));
	
	var _keyMap = _interopRequireDefault(__webpack_require__(27));
	
	var _keyValMap = _interopRequireDefault(__webpack_require__(52));
	
	var _valueFromAST = __webpack_require__(68);
	
	var _validate = __webpack_require__(69);
	
	var _blockStringValue = _interopRequireDefault(__webpack_require__(188));
	
	var _lexer = __webpack_require__(108);
	
	var _parser = __webpack_require__(41);
	
	var _values = __webpack_require__(103);
	
	var _kinds = __webpack_require__(11);
	
	var _predicates = __webpack_require__(65);
	
	var _definition = __webpack_require__(10);
	
	var _directives = __webpack_require__(19);
	
	var _introspection = __webpack_require__(23);
	
	var _scalars = __webpack_require__(28);
	
	var _schema = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * This takes the ast of a schema document produced by the parse function in
	 * src/language/parser.js.
	 *
	 * If no schema definition is provided, then it will look for types named Query
	 * and Mutation.
	 *
	 * Given that AST it constructs a GraphQLSchema. The resulting schema
	 * has no resolve methods, so execution will use default resolvers.
	 *
	 * Accepts options as a second argument:
	 *
	 *    - commentDescriptions:
	 *        Provide true to use preceding comments as the description.
	 *
	 */
	function buildASTSchema(documentAST, options) {
	  !(documentAST && documentAST.kind === _kinds.Kind.DOCUMENT) ? (0, _invariant.default)(0, 'Must provide valid Document AST') : void 0;
	
	  if (!options || !(options.assumeValid || options.assumeValidSDL)) {
	    (0, _validate.assertValidSDL)(documentAST);
	  }
	
	  var schemaDef;
	  var typeDefs = [];
	  var nodeMap = Object.create(null);
	  var directiveDefs = [];
	
	  for (var i = 0; i < documentAST.definitions.length; i++) {
	    var def = documentAST.definitions[i];
	
	    if (def.kind === _kinds.Kind.SCHEMA_DEFINITION) {
	      schemaDef = def;
	    } else if ((0, _predicates.isTypeDefinitionNode)(def)) {
	      var typeName = def.name.value;
	
	      if (nodeMap[typeName]) {
	        throw new Error("Type \"".concat(typeName, "\" was defined more than once."));
	      }
	
	      typeDefs.push(def);
	      nodeMap[typeName] = def;
	    } else if (def.kind === _kinds.Kind.DIRECTIVE_DEFINITION) {
	      directiveDefs.push(def);
	    }
	  }
	
	  var operationTypes = schemaDef ? getOperationTypes(schemaDef) : {
	    query: nodeMap.Query,
	    mutation: nodeMap.Mutation,
	    subscription: nodeMap.Subscription
	  };
	  var definitionBuilder = new ASTDefinitionBuilder(nodeMap, options, function (typeRef) {
	    throw new Error("Type \"".concat(typeRef.name.value, "\" not found in document."));
	  });
	  var directives = directiveDefs.map(function (def) {
	    return definitionBuilder.buildDirective(def);
	  }); // If specified directives were not explicitly declared, add them.
	
	  if (!directives.some(function (directive) {
	    return directive.name === 'skip';
	  })) {
	    directives.push(_directives.GraphQLSkipDirective);
	  }
	
	  if (!directives.some(function (directive) {
	    return directive.name === 'include';
	  })) {
	    directives.push(_directives.GraphQLIncludeDirective);
	  }
	
	  if (!directives.some(function (directive) {
	    return directive.name === 'deprecated';
	  })) {
	    directives.push(_directives.GraphQLDeprecatedDirective);
	  } // Note: While this could make early assertions to get the correctly
	  // typed values below, that would throw immediately while type system
	  // validation with validateSchema() will produce more actionable results.
	
	
	  return new _schema.GraphQLSchema({
	    query: operationTypes.query ? definitionBuilder.buildType(operationTypes.query) : null,
	    mutation: operationTypes.mutation ? definitionBuilder.buildType(operationTypes.mutation) : null,
	    subscription: operationTypes.subscription ? definitionBuilder.buildType(operationTypes.subscription) : null,
	    types: typeDefs.map(function (node) {
	      return definitionBuilder.buildType(node);
	    }),
	    directives: directives,
	    astNode: schemaDef,
	    assumeValid: options && options.assumeValid,
	    allowedLegacyNames: options && options.allowedLegacyNames
	  });
	
	  function getOperationTypes(schema) {
	    var opTypes = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = schema.operationTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var operationType = _step.value;
	        var _typeName = operationType.type.name.value;
	        var operation = operationType.operation;
	
	        if (opTypes[operation]) {
	          throw new Error("Must provide only one ".concat(operation, " type in schema."));
	        }
	
	        if (!nodeMap[_typeName]) {
	          throw new Error("Specified ".concat(operation, " type \"").concat(_typeName, "\" not found in document."));
	        }
	
	        opTypes[operation] = operationType.type;
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return != null) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return opTypes;
	  }
	}
	
	var ASTDefinitionBuilder =
	/*#__PURE__*/
	function () {
	  function ASTDefinitionBuilder(typeDefinitionsMap, options, resolveType) {
	    _defineProperty(this, "_typeDefinitionsMap", void 0);
	
	    _defineProperty(this, "_options", void 0);
	
	    _defineProperty(this, "_resolveType", void 0);
	
	    _defineProperty(this, "_cache", void 0);
	
	    this._typeDefinitionsMap = typeDefinitionsMap;
	    this._options = options;
	    this._resolveType = resolveType; // Initialize to the GraphQL built in scalars and introspection types.
	
	    this._cache = (0, _keyMap.default)(_scalars.specifiedScalarTypes.concat(_introspection.introspectionTypes), function (type) {
	      return type.name;
	    });
	  }
	
	  var _proto = ASTDefinitionBuilder.prototype;
	
	  _proto.buildType = function buildType(node) {
	    var typeName = node.name.value;
	
	    if (!this._cache[typeName]) {
	      if (node.kind === _kinds.Kind.NAMED_TYPE) {
	        var defNode = this._typeDefinitionsMap[typeName];
	        this._cache[typeName] = defNode ? this._makeSchemaDef(defNode) : this._resolveType(node);
	      } else {
	        this._cache[typeName] = this._makeSchemaDef(node);
	      }
	    }
	
	    return this._cache[typeName];
	  };
	
	  _proto._buildWrappedType = function _buildWrappedType(typeNode) {
	    if (typeNode.kind === _kinds.Kind.LIST_TYPE) {
	      return (0, _definition.GraphQLList)(this._buildWrappedType(typeNode.type));
	    }
	
	    if (typeNode.kind === _kinds.Kind.NON_NULL_TYPE) {
	      return (0, _definition.GraphQLNonNull)( // Note: GraphQLNonNull constructor validates this type
	      this._buildWrappedType(typeNode.type));
	    }
	
	    return this.buildType(typeNode);
	  };
	
	  _proto.buildDirective = function buildDirective(directiveNode) {
	    return new _directives.GraphQLDirective({
	      name: directiveNode.name.value,
	      description: getDescription(directiveNode, this._options),
	      locations: directiveNode.locations.map(function (node) {
	        return node.value;
	      }),
	      args: directiveNode.arguments && this._makeInputValues(directiveNode.arguments),
	      astNode: directiveNode
	    });
	  };
	
	  _proto.buildField = function buildField(field) {
	    return {
	      // Note: While this could make assertions to get the correctly typed
	      // value, that would throw immediately while type system validation
	      // with validateSchema() will produce more actionable results.
	      type: this._buildWrappedType(field.type),
	      description: getDescription(field, this._options),
	      args: field.arguments && this._makeInputValues(field.arguments),
	      deprecationReason: getDeprecationReason(field),
	      astNode: field
	    };
	  };
	
	  _proto.buildInputField = function buildInputField(value) {
	    // Note: While this could make assertions to get the correctly typed
	    // value, that would throw immediately while type system validation
	    var type = this._buildWrappedType(value.type);
	
	    return {
	      name: value.name.value,
	      type: type,
	      description: getDescription(value, this._options),
	      defaultValue: (0, _valueFromAST.valueFromAST)(value.defaultValue, type),
	      astNode: value
	    };
	  };
	
	  _proto.buildEnumValue = function buildEnumValue(value) {
	    return {
	      description: getDescription(value, this._options),
	      deprecationReason: getDeprecationReason(value),
	      astNode: value
	    };
	  };
	
	  _proto._makeSchemaDef = function _makeSchemaDef(def) {
	    switch (def.kind) {
	      case _kinds.Kind.OBJECT_TYPE_DEFINITION:
	        return this._makeTypeDef(def);
	
	      case _kinds.Kind.INTERFACE_TYPE_DEFINITION:
	        return this._makeInterfaceDef(def);
	
	      case _kinds.Kind.ENUM_TYPE_DEFINITION:
	        return this._makeEnumDef(def);
	
	      case _kinds.Kind.UNION_TYPE_DEFINITION:
	        return this._makeUnionDef(def);
	
	      case _kinds.Kind.SCALAR_TYPE_DEFINITION:
	        return this._makeScalarDef(def);
	
	      case _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION:
	        return this._makeInputObjectDef(def);
	
	      default:
	        throw new Error("Type kind \"".concat(def.kind, "\" not supported."));
	    }
	  };
	
	  _proto._makeTypeDef = function _makeTypeDef(def) {
	    var _this = this;
	
	    var interfaces = def.interfaces;
	    return new _definition.GraphQLObjectType({
	      name: def.name.value,
	      description: getDescription(def, this._options),
	      fields: function fields() {
	        return _this._makeFieldDefMap(def);
	      },
	      // Note: While this could make early assertions to get the correctly
	      // typed values, that would throw immediately while type system
	      // validation with validateSchema() will produce more actionable results.
	      interfaces: interfaces ? function () {
	        return interfaces.map(function (ref) {
	          return _this.buildType(ref);
	        });
	      } : [],
	      astNode: def
	    });
	  };
	
	  _proto._makeFieldDefMap = function _makeFieldDefMap(def) {
	    var _this2 = this;
	
	    return def.fields ? (0, _keyValMap.default)(def.fields, function (field) {
	      return field.name.value;
	    }, function (field) {
	      return _this2.buildField(field);
	    }) : {};
	  };
	
	  _proto._makeInputValues = function _makeInputValues(values) {
	    var _this3 = this;
	
	    return (0, _keyValMap.default)(values, function (value) {
	      return value.name.value;
	    }, function (value) {
	      return _this3.buildInputField(value);
	    });
	  };
	
	  _proto._makeInterfaceDef = function _makeInterfaceDef(def) {
	    var _this4 = this;
	
	    return new _definition.GraphQLInterfaceType({
	      name: def.name.value,
	      description: getDescription(def, this._options),
	      fields: function fields() {
	        return _this4._makeFieldDefMap(def);
	      },
	      astNode: def
	    });
	  };
	
	  _proto._makeEnumDef = function _makeEnumDef(def) {
	    return new _definition.GraphQLEnumType({
	      name: def.name.value,
	      description: getDescription(def, this._options),
	      values: this._makeValueDefMap(def),
	      astNode: def
	    });
	  };
	
	  _proto._makeValueDefMap = function _makeValueDefMap(def) {
	    var _this5 = this;
	
	    return def.values ? (0, _keyValMap.default)(def.values, function (enumValue) {
	      return enumValue.name.value;
	    }, function (enumValue) {
	      return _this5.buildEnumValue(enumValue);
	    }) : {};
	  };
	
	  _proto._makeUnionDef = function _makeUnionDef(def) {
	    var _this6 = this;
	
	    var types = def.types;
	    return new _definition.GraphQLUnionType({
	      name: def.name.value,
	      description: getDescription(def, this._options),
	      // Note: While this could make assertions to get the correctly typed
	      // values below, that would throw immediately while type system
	      // validation with validateSchema() will produce more actionable results.
	      types: types ? function () {
	        return types.map(function (ref) {
	          return _this6.buildType(ref);
	        });
	      } : [],
	      astNode: def
	    });
	  };
	
	  _proto._makeScalarDef = function _makeScalarDef(def) {
	    return new _definition.GraphQLScalarType({
	      name: def.name.value,
	      description: getDescription(def, this._options),
	      astNode: def,
	      serialize: function serialize(value) {
	        return value;
	      }
	    });
	  };
	
	  _proto._makeInputObjectDef = function _makeInputObjectDef(def) {
	    var _this7 = this;
	
	    return new _definition.GraphQLInputObjectType({
	      name: def.name.value,
	      description: getDescription(def, this._options),
	      fields: function fields() {
	        return def.fields ? _this7._makeInputValues(def.fields) : {};
	      },
	      astNode: def
	    });
	  };
	
	  return ASTDefinitionBuilder;
	}();
	/**
	 * Given a field or enum value node, returns the string value for the
	 * deprecation reason.
	 */
	
	
	exports.ASTDefinitionBuilder = ASTDefinitionBuilder;
	
	function getDeprecationReason(node) {
	  var deprecated = (0, _values.getDirectiveValues)(_directives.GraphQLDeprecatedDirective, node);
	  return deprecated && deprecated.reason;
	}
	/**
	 * Given an ast node, returns its string description.
	 * @deprecated: provided to ease adoption and will be removed in v16.
	 *
	 * Accepts options as a second argument:
	 *
	 *    - commentDescriptions:
	 *        Provide true to use preceding comments as the description.
	 *
	 */
	
	
	function getDescription(node, options) {
	  if (node.description) {
	    return node.description.value;
	  }
	
	  if (options && options.commentDescriptions) {
	    var rawValue = getLeadingCommentBlock(node);
	
	    if (rawValue !== undefined) {
	      return (0, _blockStringValue.default)('\n' + rawValue);
	    }
	  }
	}
	
	function getLeadingCommentBlock(node) {
	  var loc = node.loc;
	
	  if (!loc) {
	    return;
	  }
	
	  var comments = [];
	  var token = loc.startToken.prev;
	
	  while (token && token.kind === _lexer.TokenKind.COMMENT && token.next && token.prev && token.line + 1 === token.next.line && token.line !== token.prev.line) {
	    var value = String(token.value);
	    comments.push(value);
	    token = token.prev;
	  }
	
	  return comments.reverse().join('\n');
	}
	/**
	 * A helper function to build a GraphQLSchema directly from a source
	 * document.
	 */
	
	
	function buildSchema(source, options) {
	  return buildASTSchema((0, _parser.parse)(source, options), options);
	}

/***/ },
/* 192 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIntrospectionQuery = getIntrospectionQuery;
	exports.introspectionQuery = void 0;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function getIntrospectionQuery(options) {
	  var descriptions = !(options && options.descriptions === false);
	  return "\n    query IntrospectionQuery {\n      __schema {\n        queryType { name }\n        mutationType { name }\n        subscriptionType { name }\n        types {\n          ...FullType\n        }\n        directives {\n          name\n          ".concat(descriptions ? 'description' : '', "\n          locations\n          args {\n            ...InputValue\n          }\n        }\n      }\n    }\n\n    fragment FullType on __Type {\n      kind\n      name\n      ").concat(descriptions ? 'description' : '', "\n      fields(includeDeprecated: true) {\n        name\n        ").concat(descriptions ? 'description' : '', "\n        args {\n          ...InputValue\n        }\n        type {\n          ...TypeRef\n        }\n        isDeprecated\n        deprecationReason\n      }\n      inputFields {\n        ...InputValue\n      }\n      interfaces {\n        ...TypeRef\n      }\n      enumValues(includeDeprecated: true) {\n        name\n        ").concat(descriptions ? 'description' : '', "\n        isDeprecated\n        deprecationReason\n      }\n      possibleTypes {\n        ...TypeRef\n      }\n    }\n\n    fragment InputValue on __InputValue {\n      name\n      ").concat(descriptions ? 'description' : '', "\n      type { ...TypeRef }\n      defaultValue\n    }\n\n    fragment TypeRef on __Type {\n      kind\n      name\n      ofType {\n        kind\n        name\n        ofType {\n          kind\n          name\n          ofType {\n            kind\n            name\n            ofType {\n              kind\n              name\n              ofType {\n                kind\n                name\n                ofType {\n                  kind\n                  name\n                  ofType {\n                    kind\n                    name\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  ");
	}
	/**
	 * Deprecated, call getIntrospectionQuery directly.
	 *
	 * This function will be removed in v15
	 */
	
	
	var introspectionQuery = getIntrospectionQuery();
	exports.introspectionQuery = introspectionQuery;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.valueFromASTUntyped = valueFromASTUntyped;
	
	var _keyValMap = _interopRequireDefault(__webpack_require__(52));
	
	var _isInvalid = _interopRequireDefault(__webpack_require__(33));
	
	var _kinds = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Produces a JavaScript value given a GraphQL Value AST.
	 *
	 * Unlike `valueFromAST()`, no type is provided. The resulting JavaScript value
	 * will reflect the provided GraphQL value AST.
	 *
	 * | GraphQL Value        | JavaScript Value |
	 * | -------------------- | ---------------- |
	 * | Input Object         | Object           |
	 * | List                 | Array            |
	 * | Boolean              | Boolean          |
	 * | String / Enum        | String           |
	 * | Int / Float          | Number           |
	 * | Null                 | null             |
	 *
	 */
	function valueFromASTUntyped(valueNode, variables) {
	  switch (valueNode.kind) {
	    case _kinds.Kind.NULL:
	      return null;
	
	    case _kinds.Kind.INT:
	      return parseInt(valueNode.value, 10);
	
	    case _kinds.Kind.FLOAT:
	      return parseFloat(valueNode.value);
	
	    case _kinds.Kind.STRING:
	    case _kinds.Kind.ENUM:
	    case _kinds.Kind.BOOLEAN:
	      return valueNode.value;
	
	    case _kinds.Kind.LIST:
	      return valueNode.values.map(function (node) {
	        return valueFromASTUntyped(node, variables);
	      });
	
	    case _kinds.Kind.OBJECT:
	      return (0, _keyValMap.default)(valueNode.fields, function (field) {
	        return field.name.value;
	      }, function (field) {
	        return valueFromASTUntyped(field.value, variables);
	      });
	
	    case _kinds.Kind.VARIABLE:
	      var variableName = valueNode.name.value;
	      return variables && !(0, _isInvalid.default)(variables[variableName]) ? variables[variableName] : undefined;
	  }
	  /* istanbul ignore next */
	
	
	  throw new Error('Unexpected value kind: ' + valueNode.kind);
	}

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.undefinedFieldMessage = undefinedFieldMessage;
	exports.FieldsOnCorrectType = FieldsOnCorrectType;
	
	var _GraphQLError = __webpack_require__(9);
	
	var _suggestionList = _interopRequireDefault(__webpack_require__(53));
	
	var _quotedOrList = _interopRequireDefault(__webpack_require__(107));
	
	var _definition = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function undefinedFieldMessage(fieldName, type, suggestedTypeNames, suggestedFieldNames) {
	  var message = "Cannot query field \"".concat(fieldName, "\" on type \"").concat(type, "\".");
	
	  if (suggestedTypeNames.length !== 0) {
	    var suggestions = (0, _quotedOrList.default)(suggestedTypeNames);
	    message += " Did you mean to use an inline fragment on ".concat(suggestions, "?");
	  } else if (suggestedFieldNames.length !== 0) {
	    message += " Did you mean ".concat((0, _quotedOrList.default)(suggestedFieldNames), "?");
	  }
	
	  return message;
	}
	/**
	 * Fields on correct type
	 *
	 * A GraphQL document is only valid if all fields selected are defined by the
	 * parent type, or are an allowed meta field such as __typename.
	 */
	
	
	function FieldsOnCorrectType(context) {
	  return {
	    Field: function Field(node) {
	      var type = context.getParentType();
	
	      if (type) {
	        var fieldDef = context.getFieldDef();
	
	        if (!fieldDef) {
	          // This field doesn't exist, lets look for suggestions.
	          var schema = context.getSchema();
	          var fieldName = node.name.value; // First determine if there are any suggested types to condition on.
	
	          var suggestedTypeNames = getSuggestedTypeNames(schema, type, fieldName); // If there are no suggested types, then perhaps this was a typo?
	
	          var suggestedFieldNames = suggestedTypeNames.length !== 0 ? [] : getSuggestedFieldNames(schema, type, fieldName); // Report an error, including helpful suggestions.
	
	          context.reportError(new _GraphQLError.GraphQLError(undefinedFieldMessage(fieldName, type.name, suggestedTypeNames, suggestedFieldNames), [node]));
	        }
	      }
	    }
	  };
	}
	/**
	 * Go through all of the implementations of type, as well as the interfaces that
	 * they implement. If any of those types include the provided field, suggest
	 * them, sorted by how often the type is referenced, starting with Interfaces.
	 */
	
	
	function getSuggestedTypeNames(schema, type, fieldName) {
	  if ((0, _definition.isAbstractType)(type)) {
	    var suggestedObjectTypes = [];
	    var interfaceUsageCount = Object.create(null);
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = schema.getPossibleTypes(type)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var possibleType = _step.value;
	
	        if (!possibleType.getFields()[fieldName]) {
	          continue;
	        } // This object type defines this field.
	
	
	        suggestedObjectTypes.push(possibleType.name);
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = possibleType.getInterfaces()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var possibleInterface = _step2.value;
	
	            if (!possibleInterface.getFields()[fieldName]) {
	              continue;
	            } // This interface type defines this field.
	
	
	            interfaceUsageCount[possibleInterface.name] = (interfaceUsageCount[possibleInterface.name] || 0) + 1;
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      } // Suggest interface types based on how common they are.
	
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return != null) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    var suggestedInterfaceTypes = Object.keys(interfaceUsageCount).sort(function (a, b) {
	      return interfaceUsageCount[b] - interfaceUsageCount[a];
	    }); // Suggest both interface and object types.
	
	    return suggestedInterfaceTypes.concat(suggestedObjectTypes);
	  } // Otherwise, must be an Object type, which does not have possible fields.
	
	
	  return [];
	}
	/**
	 * For the field name provided, determine if there are any similar field names
	 * that may be the result of a typo.
	 */
	
	
	function getSuggestedFieldNames(schema, type, fieldName) {
	  if ((0, _definition.isObjectType)(type) || (0, _definition.isInterfaceType)(type)) {
	    var possibleFieldNames = Object.keys(type.getFields());
	    return (0, _suggestionList.default)(fieldName, possibleFieldNames);
	  } // Otherwise, must be a Union type, which does not define fields.
	
	
	  return [];
	}

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.inlineFragmentOnNonCompositeErrorMessage = inlineFragmentOnNonCompositeErrorMessage;
	exports.fragmentOnNonCompositeErrorMessage = fragmentOnNonCompositeErrorMessage;
	exports.FragmentsOnCompositeTypes = FragmentsOnCompositeTypes;
	
	var _GraphQLError = __webpack_require__(9);
	
	var _printer = __webpack_require__(22);
	
	var _definition = __webpack_require__(10);
	
	var _typeFromAST = __webpack_require__(29);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function inlineFragmentOnNonCompositeErrorMessage(type) {
	  return "Fragment cannot condition on non composite type \"".concat(type, "\".");
	}
	
	function fragmentOnNonCompositeErrorMessage(fragName, type) {
	  return "Fragment \"".concat(fragName, "\" cannot condition on non composite ") + "type \"".concat(type, "\".");
	}
	/**
	 * Fragments on composite type
	 *
	 * Fragments use a type condition to determine if they apply, since fragments
	 * can only be spread into a composite type (object, interface, or union), the
	 * type condition must also be a composite type.
	 */
	
	
	function FragmentsOnCompositeTypes(context) {
	  return {
	    InlineFragment: function InlineFragment(node) {
	      var typeCondition = node.typeCondition;
	
	      if (typeCondition) {
	        var type = (0, _typeFromAST.typeFromAST)(context.getSchema(), typeCondition);
	
	        if (type && !(0, _definition.isCompositeType)(type)) {
	          context.reportError(new _GraphQLError.GraphQLError(inlineFragmentOnNonCompositeErrorMessage((0, _printer.print)(typeCondition)), [typeCondition]));
	        }
	      }
	    },
	    FragmentDefinition: function FragmentDefinition(node) {
	      var type = (0, _typeFromAST.typeFromAST)(context.getSchema(), node.typeCondition);
	
	      if (type && !(0, _definition.isCompositeType)(type)) {
	        context.reportError(new _GraphQLError.GraphQLError(fragmentOnNonCompositeErrorMessage(node.name.value, (0, _printer.print)(node.typeCondition)), [node.typeCondition]));
	      }
	    }
	  };
	}

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unknownArgMessage = unknownArgMessage;
	exports.unknownDirectiveArgMessage = unknownDirectiveArgMessage;
	exports.KnownArgumentNames = KnownArgumentNames;
	exports.KnownArgumentNamesOnDirectives = KnownArgumentNamesOnDirectives;
	
	var _GraphQLError = __webpack_require__(9);
	
	var _suggestionList = _interopRequireDefault(__webpack_require__(53));
	
	var _quotedOrList = _interopRequireDefault(__webpack_require__(107));
	
	var _kinds = __webpack_require__(11);
	
	var _directives = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function unknownArgMessage(argName, fieldName, typeName, suggestedArgs) {
	  var message = "Unknown argument \"".concat(argName, "\" on field \"").concat(fieldName, "\" of ") + "type \"".concat(typeName, "\".");
	
	  if (suggestedArgs.length) {
	    message += " Did you mean ".concat((0, _quotedOrList.default)(suggestedArgs), "?");
	  }
	
	  return message;
	}
	
	function unknownDirectiveArgMessage(argName, directiveName, suggestedArgs) {
	  var message = "Unknown argument \"".concat(argName, "\" on directive \"@").concat(directiveName, "\".");
	
	  if (suggestedArgs.length) {
	    message += " Did you mean ".concat((0, _quotedOrList.default)(suggestedArgs), "?");
	  }
	
	  return message;
	}
	/**
	 * Known argument names
	 *
	 * A GraphQL field is only valid if all supplied arguments are defined by
	 * that field.
	 */
	
	
	function KnownArgumentNames(context) {
	  return _objectSpread({}, KnownArgumentNamesOnDirectives(context), {
	    Argument: function Argument(argNode) {
	      var argDef = context.getArgument();
	      var fieldDef = context.getFieldDef();
	      var parentType = context.getParentType();
	
	      if (!argDef && fieldDef && parentType) {
	        var argName = argNode.name.value;
	        var knownArgsNames = fieldDef.args.map(function (arg) {
	          return arg.name;
	        });
	        context.reportError(new _GraphQLError.GraphQLError(unknownArgMessage(argName, fieldDef.name, parentType.name, (0, _suggestionList.default)(argName, knownArgsNames)), argNode));
	      }
	    }
	  });
	} // @internal
	
	
	function KnownArgumentNamesOnDirectives(context) {
	  var directiveArgs = Object.create(null);
	  var schema = context.getSchema();
	  var definedDirectives = schema ? schema.getDirectives() : _directives.specifiedDirectives;
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = definedDirectives[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var directive = _step.value;
	      directiveArgs[directive.name] = directive.args.map(function (arg) {
	        return arg.name;
	      });
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return != null) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  var astDefinitions = context.getDocument().definitions;
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = astDefinitions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var def = _step2.value;
	
	      if (def.kind === _kinds.Kind.DIRECTIVE_DEFINITION) {
	        directiveArgs[def.name.value] = def.arguments ? def.arguments.map(function (arg) {
	          return arg.name.value;
	        }) : [];
	      }
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return {
	    Directive: function Directive(directiveNode) {
	      var directiveName = directiveNode.name.value;
	      var knownArgs = directiveArgs[directiveName];
	
	      if (directiveNode.arguments && knownArgs) {
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = directiveNode.arguments[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var argNode = _step3.value;
	            var argName = argNode.name.value;
	
	            if (knownArgs.indexOf(argName) === -1) {
	              var suggestions = (0, _suggestionList.default)(argName, knownArgs);
	              context.reportError(new _GraphQLError.GraphQLError(unknownDirectiveArgMessage(argName, directiveName, suggestions), argNode));
	            }
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	      }
	
	      return false;
	    }
	  };
	}

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unknownDirectiveMessage = unknownDirectiveMessage;
	exports.misplacedDirectiveMessage = misplacedDirectiveMessage;
	exports.KnownDirectives = KnownDirectives;
	
	var _GraphQLError = __webpack_require__(9);
	
	var _kinds = __webpack_require__(11);
	
	var _directiveLocation = __webpack_require__(54);
	
	var _directives = __webpack_require__(19);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function unknownDirectiveMessage(directiveName) {
	  return "Unknown directive \"".concat(directiveName, "\".");
	}
	
	function misplacedDirectiveMessage(directiveName, location) {
	  return "Directive \"".concat(directiveName, "\" may not be used on ").concat(location, ".");
	}
	/**
	 * Known directives
	 *
	 * A GraphQL document is only valid if all `@directives` are known by the
	 * schema and legally positioned.
	 */
	
	
	function KnownDirectives(context) {
	  var locationsMap = Object.create(null);
	  var schema = context.getSchema();
	  var definedDirectives = schema ? schema.getDirectives() : _directives.specifiedDirectives;
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = definedDirectives[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var directive = _step.value;
	      locationsMap[directive.name] = directive.locations;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return != null) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  var astDefinitions = context.getDocument().definitions;
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = astDefinitions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var def = _step2.value;
	
	      if (def.kind === _kinds.Kind.DIRECTIVE_DEFINITION) {
	        locationsMap[def.name.value] = def.locations.map(function (name) {
	          return name.value;
	        });
	      }
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return {
	    Directive: function Directive(node, key, parent, path, ancestors) {
	      var name = node.name.value;
	      var locations = locationsMap[name];
	
	      if (!locations) {
	        context.reportError(new _GraphQLError.GraphQLError(unknownDirectiveMessage(name), [node]));
	        return;
	      }
	
	      var candidateLocation = getDirectiveLocationForASTPath(ancestors);
	
	      if (candidateLocation && locations.indexOf(candidateLocation) === -1) {
	        context.reportError(new _GraphQLError.GraphQLError(misplacedDirectiveMessage(name, candidateLocation), [node]));
	      }
	    }
	  };
	}
	
	function getDirectiveLocationForASTPath(ancestors) {
	  var appliedTo = ancestors[ancestors.length - 1];
	
	  if (!Array.isArray(appliedTo)) {
	    switch (appliedTo.kind) {
	      case _kinds.Kind.OPERATION_DEFINITION:
	        switch (appliedTo.operation) {
	          case 'query':
	            return _directiveLocation.DirectiveLocation.QUERY;
	
	          case 'mutation':
	            return _directiveLocation.DirectiveLocation.MUTATION;
	
	          case 'subscription':
	            return _directiveLocation.DirectiveLocation.SUBSCRIPTION;
	        }
	
	        break;
	
	      case _kinds.Kind.FIELD:
	        return _directiveLocation.DirectiveLocation.FIELD;
	
	      case _kinds.Kind.FRAGMENT_SPREAD:
	        return _directiveLocation.DirectiveLocation.FRAGMENT_SPREAD;
	
	      case _kinds.Kind.INLINE_FRAGMENT:
	        return _directiveLocation.DirectiveLocation.INLINE_FRAGMENT;
	
	      case _kinds.Kind.FRAGMENT_DEFINITION:
	        return _directiveLocation.DirectiveLocation.FRAGMENT_DEFINITION;
	
	      case _kinds.Kind.VARIABLE_DEFINITION:
	        return _directiveLocation.DirectiveLocation.VARIABLE_DEFINITION;
	
	      case _kinds.Kind.SCHEMA_DEFINITION:
	      case _kinds.Kind.SCHEMA_EXTENSION:
	        return _directiveLocation.DirectiveLocation.SCHEMA;
	
	      case _kinds.Kind.SCALAR_TYPE_DEFINITION:
	      case _kinds.Kind.SCALAR_TYPE_EXTENSION:
	        return _directiveLocation.DirectiveLocation.SCALAR;
	
	      case _kinds.Kind.OBJECT_TYPE_DEFINITION:
	      case _kinds.Kind.OBJECT_TYPE_EXTENSION:
	        return _directiveLocation.DirectiveLocation.OBJECT;
	
	      case _kinds.Kind.FIELD_DEFINITION:
	        return _directiveLocation.DirectiveLocation.FIELD_DEFINITION;
	
	      case _kinds.Kind.INTERFACE_TYPE_DEFINITION:
	      case _kinds.Kind.INTERFACE_TYPE_EXTENSION:
	        return _directiveLocation.DirectiveLocation.INTERFACE;
	
	      case _kinds.Kind.UNION_TYPE_DEFINITION:
	      case _kinds.Kind.UNION_TYPE_EXTENSION:
	        return _directiveLocation.DirectiveLocation.UNION;
	
	      case _kinds.Kind.ENUM_TYPE_DEFINITION:
	      case _kinds.Kind.ENUM_TYPE_EXTENSION:
	        return _directiveLocation.DirectiveLocation.ENUM;
	
	      case _kinds.Kind.ENUM_VALUE_DEFINITION:
	        return _directiveLocation.DirectiveLocation.ENUM_VALUE;
	
	      case _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION:
	      case _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION:
	        return _directiveLocation.DirectiveLocation.INPUT_OBJECT;
	
	      case _kinds.Kind.INPUT_VALUE_DEFINITION:
	        var parentNode = ancestors[ancestors.length - 3];
	        return parentNode.kind === _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION ? _directiveLocation.DirectiveLocation.INPUT_FIELD_DEFINITION : _directiveLocation.DirectiveLocation.ARGUMENT_DEFINITION;
	    }
	  }
	}

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unknownFragmentMessage = unknownFragmentMessage;
	exports.KnownFragmentNames = KnownFragmentNames;
	
	var _GraphQLError = __webpack_require__(9);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function unknownFragmentMessage(fragName) {
	  return "Unknown fragment \"".concat(fragName, "\".");
	}
	/**
	 * Known fragment names
	 *
	 * A GraphQL document is only valid if all `...Fragment` fragment spreads refer
	 * to fragments defined in the same document.
	 */
	
	
	function KnownFragmentNames(context) {
	  return {
	    FragmentSpread: function FragmentSpread(node) {
	      var fragmentName = node.name.value;
	      var fragment = context.getFragment(fragmentName);
	
	      if (!fragment) {
	        context.reportError(new _GraphQLError.GraphQLError(unknownFragmentMessage(fragmentName), [node.name]));
	      }
	    }
	  };
	}

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unknownTypeMessage = unknownTypeMessage;
	exports.KnownTypeNames = KnownTypeNames;
	
	var _GraphQLError = __webpack_require__(9);
	
	var _suggestionList = _interopRequireDefault(__webpack_require__(53));
	
	var _quotedOrList = _interopRequireDefault(__webpack_require__(107));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function unknownTypeMessage(typeName, suggestedTypes) {
	  var message = "Unknown type \"".concat(typeName, "\".");
	
	  if (suggestedTypes.length) {
	    message += " Did you mean ".concat((0, _quotedOrList.default)(suggestedTypes), "?");
	  }
	
	  return message;
	}
	/**
	 * Known type names
	 *
	 * A GraphQL document is only valid if referenced types (specifically
	 * variable definitions and fragment conditions) are defined by the type schema.
	 */
	
	
	function KnownTypeNames(context) {
	  return {
	    // TODO: when validating IDL, re-enable these. Experimental version does not
	    // add unreferenced types, resulting in false-positive errors. Squelched
	    // errors for now.
	    ObjectTypeDefinition: function ObjectTypeDefinition() {
	      return false;
	    },
	    InterfaceTypeDefinition: function InterfaceTypeDefinition() {
	      return false;
	    },
	    UnionTypeDefinition: function UnionTypeDefinition() {
	      return false;
	    },
	    InputObjectTypeDefinition: function InputObjectTypeDefinition() {
	      return false;
	    },
	    NamedType: function NamedType(node) {
	      var schema = context.getSchema();
	      var typeName = node.name.value;
	      var type = schema.getType(typeName);
	
	      if (!type) {
	        context.reportError(new _GraphQLError.GraphQLError(unknownTypeMessage(typeName, (0, _suggestionList.default)(typeName, Object.keys(schema.getTypeMap()))), [node]));
	      }
	    }
	  };
	}

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.anonOperationNotAloneMessage = anonOperationNotAloneMessage;
	exports.LoneAnonymousOperation = LoneAnonymousOperation;
	
	var _GraphQLError = __webpack_require__(9);
	
	var _kinds = __webpack_require__(11);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function anonOperationNotAloneMessage() {
	  return 'This anonymous operation must be the only defined operation.';
	}
	/**
	 * Lone anonymous operation
	 *
	 * A GraphQL document is only valid if when it contains an anonymous operation
	 * (the query short-hand) that it contains only that one operation definition.
	 */
	
	
	function LoneAnonymousOperation(context) {
	  var operationCount = 0;
	  return {
	    Document: function Document(node) {
	      operationCount = node.definitions.filter(function (definition) {
	        return definition.kind === _kinds.Kind.OPERATION_DEFINITION;
	      }).length;
	    },
	    OperationDefinition: function OperationDefinition(node) {
	      if (!node.name && operationCount > 1) {
	        context.reportError(new _GraphQLError.GraphQLError(anonOperationNotAloneMessage(), [node]));
	      }
	    }
	  };
	}

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cycleErrorMessage = cycleErrorMessage;
	exports.NoFragmentCycles = NoFragmentCycles;
	
	var _GraphQLError = __webpack_require__(9);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function cycleErrorMessage(fragName, spreadNames) {
	  var via = spreadNames.length ? ' via ' + spreadNames.join(', ') : '';
	  return "Cannot spread fragment \"".concat(fragName, "\" within itself").concat(via, ".");
	}
	
	function NoFragmentCycles(context) {
	  // Tracks already visited fragments to maintain O(N) and to ensure that cycles
	  // are not redundantly reported.
	  var visitedFrags = Object.create(null); // Array of AST nodes used to produce meaningful errors
	
	  var spreadPath = []; // Position in the spread path
	
	  var spreadPathIndexByName = Object.create(null);
	  return {
	    OperationDefinition: function OperationDefinition() {
	      return false;
	    },
	    FragmentDefinition: function FragmentDefinition(node) {
	      detectCycleRecursive(node);
	      return false;
	    }
	  }; // This does a straight-forward DFS to find cycles.
	  // It does not terminate when a cycle was found but continues to explore
	  // the graph to find all possible cycles.
	
	  function detectCycleRecursive(fragment) {
	    if (visitedFrags[fragment.name.value]) {
	      return;
	    }
	
	    var fragmentName = fragment.name.value;
	    visitedFrags[fragmentName] = true;
	    var spreadNodes = context.getFragmentSpreads(fragment.selectionSet);
	
	    if (spreadNodes.length === 0) {
	      return;
	    }
	
	    spreadPathIndexByName[fragmentName] = spreadPath.length;
	
	    for (var i = 0; i < spreadNodes.length; i++) {
	      var spreadNode = spreadNodes[i];
	      var spreadName = spreadNode.name.value;
	      var cycleIndex = spreadPathIndexByName[spreadName];
	      spreadPath.push(spreadNode);
	
	      if (cycleIndex === undefined) {
	        var spreadFragment = context.getFragment(spreadName);
	
	        if (spreadFragment) {
	          detectCycleRecursive(spreadFragment);
	        }
	      } else {
	        var cyclePath = spreadPath.slice(cycleIndex);
	        var fragmentNames = cyclePath.slice(0, -1).map(function (s) {
	          return s.name.value;
	        });
	        context.reportError(new _GraphQLError.GraphQLError(cycleErrorMessage(spreadName, fragmentNames), cyclePath));
	      }
	
	      spreadPath.pop();
	    }
	
	    spreadPathIndexByName[fragmentName] = undefined;
	  }
	}

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.undefinedVarMessage = undefinedVarMessage;
	exports.NoUndefinedVariables = NoUndefinedVariables;
	
	var _GraphQLError = __webpack_require__(9);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function undefinedVarMessage(varName, opName) {
	  return opName ? "Variable \"$".concat(varName, "\" is not defined by operation \"").concat(opName, "\".") : "Variable \"$".concat(varName, "\" is not defined.");
	}
	/**
	 * No undefined variables
	 *
	 * A GraphQL operation is only valid if all variables encountered, both directly
	 * and via fragment spreads, are defined by that operation.
	 */
	
	
	function NoUndefinedVariables(context) {
	  var variableNameDefined = Object.create(null);
	  return {
	    OperationDefinition: {
	      enter: function enter() {
	        variableNameDefined = Object.create(null);
	      },
	      leave: function leave(operation) {
	        var usages = context.getRecursiveVariableUsages(operation);
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = usages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _ref2 = _step.value;
	            var node = _ref2.node;
	            var varName = node.name.value;
	
	            if (variableNameDefined[varName] !== true) {
	              context.reportError(new _GraphQLError.GraphQLError(undefinedVarMessage(varName, operation.name && operation.name.value), [node, operation]));
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return != null) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	    },
	    VariableDefinition: function VariableDefinition(node) {
	      variableNameDefined[node.variable.name.value] = true;
	    }
	  };
	}

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unusedFragMessage = unusedFragMessage;
	exports.NoUnusedFragments = NoUnusedFragments;
	
	var _GraphQLError = __webpack_require__(9);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function unusedFragMessage(fragName) {
	  return "Fragment \"".concat(fragName, "\" is never used.");
	}
	/**
	 * No unused fragments
	 *
	 * A GraphQL document is only valid if all fragment definitions are spread
	 * within operations, or spread within other fragments spread within operations.
	 */
	
	
	function NoUnusedFragments(context) {
	  var operationDefs = [];
	  var fragmentDefs = [];
	  return {
	    OperationDefinition: function OperationDefinition(node) {
	      operationDefs.push(node);
	      return false;
	    },
	    FragmentDefinition: function FragmentDefinition(node) {
	      fragmentDefs.push(node);
	      return false;
	    },
	    Document: {
	      leave: function leave() {
	        var fragmentNameUsed = Object.create(null);
	
	        for (var _i = 0; _i < operationDefs.length; _i++) {
	          var operation = operationDefs[_i];
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = context.getRecursivelyReferencedFragments(operation)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var fragment = _step.value;
	              fragmentNameUsed[fragment.name.value] = true;
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return != null) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }
	
	        for (var _i2 = 0; _i2 < fragmentDefs.length; _i2++) {
	          var fragmentDef = fragmentDefs[_i2];
	          var fragName = fragmentDef.name.value;
	
	          if (fragmentNameUsed[fragName] !== true) {
	            context.reportError(new _GraphQLError.GraphQLError(unusedFragMessage(fragName), [fragmentDef]));
	          }
	        }
	      }
	    }
	  };
	}

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unusedVariableMessage = unusedVariableMessage;
	exports.NoUnusedVariables = NoUnusedVariables;
	
	var _GraphQLError = __webpack_require__(9);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function unusedVariableMessage(varName, opName) {
	  return opName ? "Variable \"$".concat(varName, "\" is never used in operation \"").concat(opName, "\".") : "Variable \"$".concat(varName, "\" is never used.");
	}
	/**
	 * No unused variables
	 *
	 * A GraphQL operation is only valid if all variables defined by an operation
	 * are used, either directly or within a spread fragment.
	 */
	
	
	function NoUnusedVariables(context) {
	  var variableDefs = [];
	  return {
	    OperationDefinition: {
	      enter: function enter() {
	        variableDefs = [];
	      },
	      leave: function leave(operation) {
	        var variableNameUsed = Object.create(null);
	        var usages = context.getRecursiveVariableUsages(operation);
	        var opName = operation.name ? operation.name.value : null;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = usages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _ref2 = _step.value;
	            var node = _ref2.node;
	            variableNameUsed[node.name.value] = true;
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return != null) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        for (var _i = 0; _i < variableDefs.length; _i++) {
	          var variableDef = variableDefs[_i];
	          var variableName = variableDef.variable.name.value;
	
	          if (variableNameUsed[variableName] !== true) {
	            context.reportError(new _GraphQLError.GraphQLError(unusedVariableMessage(variableName, opName), [variableDef]));
	          }
	        }
	      }
	    },
	    VariableDefinition: function VariableDefinition(def) {
	      variableDefs.push(def);
	    }
	  };
	}

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fieldsConflictMessage = fieldsConflictMessage;
	exports.OverlappingFieldsCanBeMerged = OverlappingFieldsCanBeMerged;
	
	var _GraphQLError = __webpack_require__(9);
	
	var _inspect = _interopRequireDefault(__webpack_require__(16));
	
	var _find = _interopRequireDefault(__webpack_require__(51));
	
	var _kinds = __webpack_require__(11);
	
	var _printer = __webpack_require__(22);
	
	var _definition = __webpack_require__(10);
	
	var _typeFromAST = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function fieldsConflictMessage(responseName, reason) {
	  return "Fields \"".concat(responseName, "\" conflict because ").concat(reasonMessage(reason)) + '. Use different aliases on the fields to fetch both if this was ' + 'intentional.';
	}
	
	function reasonMessage(reason) {
	  if (Array.isArray(reason)) {
	    return reason.map(function (_ref) {
	      var responseName = _ref[0],
	          subreason = _ref[1];
	      return "subfields \"".concat(responseName, "\" conflict because ").concat(reasonMessage(subreason));
	    }).join(' and ');
	  }
	
	  return reason;
	}
	/**
	 * Overlapping fields can be merged
	 *
	 * A selection set is only valid if all fields (including spreading any
	 * fragments) either correspond to distinct response names or can be merged
	 * without ambiguity.
	 */
	
	
	function OverlappingFieldsCanBeMerged(context) {
	  // A memoization for when two fragments are compared "between" each other for
	  // conflicts. Two fragments may be compared many times, so memoizing this can
	  // dramatically improve the performance of this validator.
	  var comparedFragmentPairs = new PairSet(); // A cache for the "field map" and list of fragment names found in any given
	  // selection set. Selection sets may be asked for this information multiple
	  // times, so this improves the performance of this validator.
	
	  var cachedFieldsAndFragmentNames = new Map();
	  return {
	    SelectionSet: function SelectionSet(selectionSet) {
	      var conflicts = findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, context.getParentType(), selectionSet);
	
	      for (var _i = 0; _i < conflicts.length; _i++) {
	        var _ref3 = conflicts[_i];
	        var _ref2$ = _ref3[0];
	        var responseName = _ref2$[0];
	        var reason = _ref2$[1];
	        var fields1 = _ref3[1];
	        var fields2 = _ref3[2];
	        context.reportError(new _GraphQLError.GraphQLError(fieldsConflictMessage(responseName, reason), fields1.concat(fields2)));
	      }
	    }
	  };
	}
	
	/**
	 * Algorithm:
	 *
	 * Conflicts occur when two fields exist in a query which will produce the same
	 * response name, but represent differing values, thus creating a conflict.
	 * The algorithm below finds all conflicts via making a series of comparisons
	 * between fields. In order to compare as few fields as possible, this makes
	 * a series of comparisons "within" sets of fields and "between" sets of fields.
	 *
	 * Given any selection set, a collection produces both a set of fields by
	 * also including all inline fragments, as well as a list of fragments
	 * referenced by fragment spreads.
	 *
	 * A) Each selection set represented in the document first compares "within" its
	 * collected set of fields, finding any conflicts between every pair of
	 * overlapping fields.
	 * Note: This is the *only time* that a the fields "within" a set are compared
	 * to each other. After this only fields "between" sets are compared.
	 *
	 * B) Also, if any fragment is referenced in a selection set, then a
	 * comparison is made "between" the original set of fields and the
	 * referenced fragment.
	 *
	 * C) Also, if multiple fragments are referenced, then comparisons
	 * are made "between" each referenced fragment.
	 *
	 * D) When comparing "between" a set of fields and a referenced fragment, first
	 * a comparison is made between each field in the original set of fields and
	 * each field in the the referenced set of fields.
	 *
	 * E) Also, if any fragment is referenced in the referenced selection set,
	 * then a comparison is made "between" the original set of fields and the
	 * referenced fragment (recursively referring to step D).
	 *
	 * F) When comparing "between" two fragments, first a comparison is made between
	 * each field in the first referenced set of fields and each field in the the
	 * second referenced set of fields.
	 *
	 * G) Also, any fragments referenced by the first must be compared to the
	 * second, and any fragments referenced by the second must be compared to the
	 * first (recursively referring to step F).
	 *
	 * H) When comparing two fields, if both have selection sets, then a comparison
	 * is made "between" both selection sets, first comparing the set of fields in
	 * the first selection set with the set of fields in the second.
	 *
	 * I) Also, if any fragment is referenced in either selection set, then a
	 * comparison is made "between" the other set of fields and the
	 * referenced fragment.
	 *
	 * J) Also, if two fragments are referenced in both selection sets, then a
	 * comparison is made "between" the two fragments.
	 *
	 */
	// Find all conflicts found "within" a selection set, including those found
	// via spreading in fragments. Called when visiting each SelectionSet in the
	// GraphQL Document.
	function findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentType, selectionSet) {
	  var conflicts = [];
	
	  var _getFieldsAndFragment = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet),
	      fieldMap = _getFieldsAndFragment[0],
	      fragmentNames = _getFieldsAndFragment[1]; // (A) Find find all conflicts "within" the fields of this selection set.
	  // Note: this is the *only place* `collectConflictsWithin` is called.
	
	
	  collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap);
	
	  if (fragmentNames.length !== 0) {
	    // (B) Then collect conflicts between these fields and those represented by
	    // each spread fragment name found.
	    var comparedFragments = Object.create(null);
	
	    for (var i = 0; i < fragmentNames.length; i++) {
	      collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, comparedFragmentPairs, false, fieldMap, fragmentNames[i]); // (C) Then compare this fragment with all other fragments found in this
	      // selection set to collect conflicts between fragments spread together.
	      // This compares each item in the list of fragment names to every other
	      // item in that same list (except for itself).
	
	      for (var j = i + 1; j < fragmentNames.length; j++) {
	        collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fragmentNames[i], fragmentNames[j]);
	      }
	    }
	  }
	
	  return conflicts;
	} // Collect all conflicts found between a set of fields and a fragment reference
	// including via spreading in any nested fragments.
	
	
	function collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentName) {
	  // Memoize so a fragment is not compared for conflicts more than once.
	  if (comparedFragments[fragmentName]) {
	    return;
	  }
	
	  comparedFragments[fragmentName] = true;
	  var fragment = context.getFragment(fragmentName);
	
	  if (!fragment) {
	    return;
	  }
	
	  var _getReferencedFieldsA = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment),
	      fieldMap2 = _getReferencedFieldsA[0],
	      fragmentNames2 = _getReferencedFieldsA[1]; // Do not compare a fragment's fieldMap to itself.
	
	
	  if (fieldMap === fieldMap2) {
	    return;
	  } // (D) First collect any conflicts between the provided collection of fields
	  // and the collection of fields represented by the given fragment.
	
	
	  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fieldMap2); // (E) Then collect any conflicts between the provided collection of fields
	  // and any fragment names found in the given fragment.
	
	  for (var i = 0; i < fragmentNames2.length; i++) {
	    collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentNames2[i]);
	  }
	} // Collect all conflicts found between two fragments, including via spreading in
	// any nested fragments.
	
	
	function collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentName2) {
	  // No need to compare a fragment to itself.
	  if (fragmentName1 === fragmentName2) {
	    return;
	  } // Memoize so two fragments are not compared for conflicts more than once.
	
	
	  if (comparedFragmentPairs.has(fragmentName1, fragmentName2, areMutuallyExclusive)) {
	    return;
	  }
	
	  comparedFragmentPairs.add(fragmentName1, fragmentName2, areMutuallyExclusive);
	  var fragment1 = context.getFragment(fragmentName1);
	  var fragment2 = context.getFragment(fragmentName2);
	
	  if (!fragment1 || !fragment2) {
	    return;
	  }
	
	  var _getReferencedFieldsA2 = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment1),
	      fieldMap1 = _getReferencedFieldsA2[0],
	      fragmentNames1 = _getReferencedFieldsA2[1];
	
	  var _getReferencedFieldsA3 = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment2),
	      fieldMap2 = _getReferencedFieldsA3[0],
	      fragmentNames2 = _getReferencedFieldsA3[1]; // (F) First, collect all conflicts between these two collections of fields
	  // (not including any nested fragments).
	
	
	  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (G) Then collect conflicts between the first fragment and any nested
	  // fragments spread in the second fragment.
	
	  for (var j = 0; j < fragmentNames2.length; j++) {
	    collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentNames2[j]);
	  } // (G) Then collect conflicts between the second fragment and any nested
	  // fragments spread in the first fragment.
	
	
	  for (var i = 0; i < fragmentNames1.length; i++) {
	    collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[i], fragmentName2);
	  }
	} // Find all conflicts found between two selection sets, including those found
	// via spreading in fragments. Called when determining if conflicts exist
	// between the sub-fields of two overlapping fields.
	
	
	function findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, parentType1, selectionSet1, parentType2, selectionSet2) {
	  var conflicts = [];
	
	  var _getFieldsAndFragment2 = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType1, selectionSet1),
	      fieldMap1 = _getFieldsAndFragment2[0],
	      fragmentNames1 = _getFieldsAndFragment2[1];
	
	  var _getFieldsAndFragment3 = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType2, selectionSet2),
	      fieldMap2 = _getFieldsAndFragment3[0],
	      fragmentNames2 = _getFieldsAndFragment3[1]; // (H) First, collect all conflicts between these two collections of field.
	
	
	  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (I) Then collect conflicts between the first collection of fields and
	  // those referenced by each fragment name associated with the second.
	
	  if (fragmentNames2.length !== 0) {
	    var comparedFragments = Object.create(null);
	
	    for (var j = 0; j < fragmentNames2.length; j++) {
	      collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fragmentNames2[j]);
	    }
	  } // (I) Then collect conflicts between the second collection of fields and
	  // those referenced by each fragment name associated with the first.
	
	
	  if (fragmentNames1.length !== 0) {
	    var _comparedFragments = Object.create(null);
	
	    for (var i = 0; i < fragmentNames1.length; i++) {
	      collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, _comparedFragments, comparedFragmentPairs, areMutuallyExclusive, fieldMap2, fragmentNames1[i]);
	    }
	  } // (J) Also collect conflicts between any fragment names by the first and
	  // fragment names by the second. This compares each item in the first set of
	  // names to each item in the second set of names.
	
	
	  for (var _i2 = 0; _i2 < fragmentNames1.length; _i2++) {
	    for (var _j = 0; _j < fragmentNames2.length; _j++) {
	      collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[_i2], fragmentNames2[_j]);
	    }
	  }
	
	  return conflicts;
	} // Collect all Conflicts "within" one collection of fields.
	
	
	function collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap) {
	  // A field map is a keyed collection, where each key represents a response
	  // name and the value at that key is a list of all fields which provide that
	  // response name. For every response name, if there are multiple fields, they
	  // must be compared to find a potential conflict.
	  var _arr = Object.keys(fieldMap);
	
	  for (var _i3 = 0; _i3 < _arr.length; _i3++) {
	    var responseName = _arr[_i3];
	    var fields = fieldMap[responseName]; // This compares every field in the list to every other field in this list
	    // (except to itself). If the list only has one item, nothing needs to
	    // be compared.
	
	    if (fields.length > 1) {
	      for (var i = 0; i < fields.length; i++) {
	        for (var j = i + 1; j < fields.length; j++) {
	          var conflict = findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, // within one collection is never mutually exclusive
	          responseName, fields[i], fields[j]);
	
	          if (conflict) {
	            conflicts.push(conflict);
	          }
	        }
	      }
	    }
	  }
	} // Collect all Conflicts between two collections of fields. This is similar to,
	// but different from the `collectConflictsWithin` function above. This check
	// assumes that `collectConflictsWithin` has already been called on each
	// provided collection of fields. This is true because this validator traverses
	// each individual selection set.
	
	
	function collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, fieldMap1, fieldMap2) {
	  // A field map is a keyed collection, where each key represents a response
	  // name and the value at that key is a list of all fields which provide that
	  // response name. For any response name which appears in both provided field
	  // maps, each field from the first field map must be compared to every field
	  // in the second field map to find potential conflicts.
	  var _arr2 = Object.keys(fieldMap1);
	
	  for (var _i4 = 0; _i4 < _arr2.length; _i4++) {
	    var responseName = _arr2[_i4];
	    var fields2 = fieldMap2[responseName];
	
	    if (fields2) {
	      var fields1 = fieldMap1[responseName];
	
	      for (var i = 0; i < fields1.length; i++) {
	        for (var j = 0; j < fields2.length; j++) {
	          var conflict = findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, fields1[i], fields2[j]);
	
	          if (conflict) {
	            conflicts.push(conflict);
	          }
	        }
	      }
	    }
	  }
	} // Determines if there is a conflict between two particular fields, including
	// comparing their sub-fields.
	
	
	function findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, field1, field2) {
	  var parentType1 = field1[0],
	      node1 = field1[1],
	      def1 = field1[2];
	  var parentType2 = field2[0],
	      node2 = field2[1],
	      def2 = field2[2]; // If it is known that two fields could not possibly apply at the same
	  // time, due to the parent types, then it is safe to permit them to diverge
	  // in aliased field or arguments used as they will not present any ambiguity
	  // by differing.
	  // It is known that two parent types could never overlap if they are
	  // different Object types. Interface or Union types might overlap - if not
	  // in the current state of the schema, then perhaps in some future version,
	  // thus may not safely diverge.
	
	  var areMutuallyExclusive = parentFieldsAreMutuallyExclusive || parentType1 !== parentType2 && (0, _definition.isObjectType)(parentType1) && (0, _definition.isObjectType)(parentType2); // The return type for each field.
	
	  var type1 = def1 && def1.type;
	  var type2 = def2 && def2.type;
	
	  if (!areMutuallyExclusive) {
	    // Two aliases must refer to the same field.
	    var name1 = node1.name.value;
	    var name2 = node2.name.value;
	
	    if (name1 !== name2) {
	      return [[responseName, "".concat(name1, " and ").concat(name2, " are different fields")], [node1], [node2]];
	    } // Two field calls must have the same arguments.
	
	
	    if (!sameArguments(node1.arguments || [], node2.arguments || [])) {
	      return [[responseName, 'they have differing arguments'], [node1], [node2]];
	    }
	  }
	
	  if (type1 && type2 && doTypesConflict(type1, type2)) {
	    return [[responseName, "they return conflicting types ".concat((0, _inspect.default)(type1), " and ").concat((0, _inspect.default)(type2))], [node1], [node2]];
	  } // Collect and compare sub-fields. Use the same "visited fragment names" list
	  // for both collections so fields in a fragment reference are never
	  // compared to themselves.
	
	
	  var selectionSet1 = node1.selectionSet;
	  var selectionSet2 = node2.selectionSet;
	
	  if (selectionSet1 && selectionSet2) {
	    var conflicts = findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, (0, _definition.getNamedType)(type1), selectionSet1, (0, _definition.getNamedType)(type2), selectionSet2);
	    return subfieldConflicts(conflicts, responseName, node1, node2);
	  }
	}
	
	function sameArguments(arguments1, arguments2) {
	  if (arguments1.length !== arguments2.length) {
	    return false;
	  }
	
	  return arguments1.every(function (argument1) {
	    var argument2 = (0, _find.default)(arguments2, function (argument) {
	      return argument.name.value === argument1.name.value;
	    });
	
	    if (!argument2) {
	      return false;
	    }
	
	    return sameValue(argument1.value, argument2.value);
	  });
	}
	
	function sameValue(value1, value2) {
	  return !value1 && !value2 || (0, _printer.print)(value1) === (0, _printer.print)(value2);
	} // Two types conflict if both types could not apply to a value simultaneously.
	// Composite types are ignored as their individual field types will be compared
	// later recursively. However List and Non-Null types must match.
	
	
	function doTypesConflict(type1, type2) {
	  if ((0, _definition.isListType)(type1)) {
	    return (0, _definition.isListType)(type2) ? doTypesConflict(type1.ofType, type2.ofType) : true;
	  }
	
	  if ((0, _definition.isListType)(type2)) {
	    return true;
	  }
	
	  if ((0, _definition.isNonNullType)(type1)) {
	    return (0, _definition.isNonNullType)(type2) ? doTypesConflict(type1.ofType, type2.ofType) : true;
	  }
	
	  if ((0, _definition.isNonNullType)(type2)) {
	    return true;
	  }
	
	  if ((0, _definition.isLeafType)(type1) || (0, _definition.isLeafType)(type2)) {
	    return type1 !== type2;
	  }
	
	  return false;
	} // Given a selection set, return the collection of fields (a mapping of response
	// name to field nodes and definitions) as well as a list of fragment names
	// referenced via fragment spreads.
	
	
	function getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet) {
	  var cached = cachedFieldsAndFragmentNames.get(selectionSet);
	
	  if (!cached) {
	    var nodeAndDefs = Object.create(null);
	    var fragmentNames = Object.create(null);
	
	    _collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames);
	
	    cached = [nodeAndDefs, Object.keys(fragmentNames)];
	    cachedFieldsAndFragmentNames.set(selectionSet, cached);
	  }
	
	  return cached;
	} // Given a reference to a fragment, return the represented collection of fields
	// as well as a list of nested fragment names referenced via fragment spreads.
	
	
	function getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment) {
	  // Short-circuit building a type from the node if possible.
	  var cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);
	
	  if (cached) {
	    return cached;
	  }
	
	  var fragmentType = (0, _typeFromAST.typeFromAST)(context.getSchema(), fragment.typeCondition);
	  return getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragmentType, fragment.selectionSet);
	}
	
	function _collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames) {
	  for (var i = 0; i < selectionSet.selections.length; i++) {
	    var selection = selectionSet.selections[i];
	
	    switch (selection.kind) {
	      case _kinds.Kind.FIELD:
	        var fieldName = selection.name.value;
	        var fieldDef = void 0;
	
	        if ((0, _definition.isObjectType)(parentType) || (0, _definition.isInterfaceType)(parentType)) {
	          fieldDef = parentType.getFields()[fieldName];
	        }
	
	        var responseName = selection.alias ? selection.alias.value : fieldName;
	
	        if (!nodeAndDefs[responseName]) {
	          nodeAndDefs[responseName] = [];
	        }
	
	        nodeAndDefs[responseName].push([parentType, selection, fieldDef]);
	        break;
	
	      case _kinds.Kind.FRAGMENT_SPREAD:
	        fragmentNames[selection.name.value] = true;
	        break;
	
	      case _kinds.Kind.INLINE_FRAGMENT:
	        var typeCondition = selection.typeCondition;
	        var inlineFragmentType = typeCondition ? (0, _typeFromAST.typeFromAST)(context.getSchema(), typeCondition) : parentType;
	
	        _collectFieldsAndFragmentNames(context, inlineFragmentType, selection.selectionSet, nodeAndDefs, fragmentNames);
	
	        break;
	    }
	  }
	} // Given a series of Conflicts which occurred between two sub-fields, generate
	// a single Conflict.
	
	
	function subfieldConflicts(conflicts, responseName, node1, node2) {
	  if (conflicts.length > 0) {
	    return [[responseName, conflicts.map(function (_ref4) {
	      var reason = _ref4[0];
	      return reason;
	    })], conflicts.reduce(function (allFields, _ref5) {
	      var fields1 = _ref5[1];
	      return allFields.concat(fields1);
	    }, [node1]), conflicts.reduce(function (allFields, _ref6) {
	      var fields2 = _ref6[2];
	      return allFields.concat(fields2);
	    }, [node2])];
	  }
	}
	/**
	 * A way to keep track of pairs of things when the ordering of the pair does
	 * not matter. We do this by maintaining a sort of double adjacency sets.
	 */
	
	
	var PairSet =
	/*#__PURE__*/
	function () {
	  function PairSet() {
	    _defineProperty(this, "_data", void 0);
	
	    this._data = Object.create(null);
	  }
	
	  var _proto = PairSet.prototype;
	
	  _proto.has = function has(a, b, areMutuallyExclusive) {
	    var first = this._data[a];
	    var result = first && first[b];
	
	    if (result === undefined) {
	      return false;
	    } // areMutuallyExclusive being false is a superset of being true,
	    // hence if we want to know if this PairSet "has" these two with no
	    // exclusivity, we have to ensure it was added as such.
	
	
	    if (areMutuallyExclusive === false) {
	      return result === false;
	    }
	
	    return true;
	  };
	
	  _proto.add = function add(a, b, areMutuallyExclusive) {
	    _pairSetAdd(this._data, a, b, areMutuallyExclusive);
	
	    _pairSetAdd(this._data, b, a, areMutuallyExclusive);
	  };
	
	  return PairSet;
	}();
	
	function _pairSetAdd(data, a, b, areMutuallyExclusive) {
	  var map = data[a];
	
	  if (!map) {
	    map = Object.create(null);
	    data[a] = map;
	  }
	
	  map[b] = areMutuallyExclusive;
	}

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.typeIncompatibleSpreadMessage = typeIncompatibleSpreadMessage;
	exports.typeIncompatibleAnonSpreadMessage = typeIncompatibleAnonSpreadMessage;
	exports.PossibleFragmentSpreads = PossibleFragmentSpreads;
	
	var _inspect = _interopRequireDefault(__webpack_require__(16));
	
	var _GraphQLError = __webpack_require__(9);
	
	var _typeComparators = __webpack_require__(67);
	
	var _typeFromAST = __webpack_require__(29);
	
	var _definition = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function typeIncompatibleSpreadMessage(fragName, parentType, fragType) {
	  return "Fragment \"".concat(fragName, "\" cannot be spread here as objects of ") + "type \"".concat(parentType, "\" can never be of type \"").concat(fragType, "\".");
	}
	
	function typeIncompatibleAnonSpreadMessage(parentType, fragType) {
	  return 'Fragment cannot be spread here as objects of ' + "type \"".concat(parentType, "\" can never be of type \"").concat(fragType, "\".");
	}
	/**
	 * Possible fragment spread
	 *
	 * A fragment spread is only valid if the type condition could ever possibly
	 * be true: if there is a non-empty intersection of the possible parent types,
	 * and possible types which pass the type condition.
	 */
	
	
	function PossibleFragmentSpreads(context) {
	  return {
	    InlineFragment: function InlineFragment(node) {
	      var fragType = context.getType();
	      var parentType = context.getParentType();
	
	      if ((0, _definition.isCompositeType)(fragType) && (0, _definition.isCompositeType)(parentType) && !(0, _typeComparators.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
	        context.reportError(new _GraphQLError.GraphQLError(typeIncompatibleAnonSpreadMessage((0, _inspect.default)(parentType), (0, _inspect.default)(fragType)), [node]));
	      }
	    },
	    FragmentSpread: function FragmentSpread(node) {
	      var fragName = node.name.value;
	      var fragType = getFragmentType(context, fragName);
	      var parentType = context.getParentType();
	
	      if (fragType && parentType && !(0, _typeComparators.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
	        context.reportError(new _GraphQLError.GraphQLError(typeIncompatibleSpreadMessage(fragName, (0, _inspect.default)(parentType), (0, _inspect.default)(fragType)), [node]));
	      }
	    }
	  };
	}
	
	function getFragmentType(context, name) {
	  var frag = context.getFragment(name);
	
	  if (frag) {
	    var type = (0, _typeFromAST.typeFromAST)(context.getSchema(), frag.typeCondition);
	
	    if ((0, _definition.isCompositeType)(type)) {
	      return type;
	    }
	  }
	}

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.missingFieldArgMessage = missingFieldArgMessage;
	exports.missingDirectiveArgMessage = missingDirectiveArgMessage;
	exports.ProvidedRequiredArguments = ProvidedRequiredArguments;
	exports.ProvidedRequiredArgumentsOnDirectives = ProvidedRequiredArgumentsOnDirectives;
	
	var _GraphQLError = __webpack_require__(9);
	
	var _kinds = __webpack_require__(11);
	
	var _inspect = _interopRequireDefault(__webpack_require__(16));
	
	var _keyMap = _interopRequireDefault(__webpack_require__(27));
	
	var _definition = __webpack_require__(10);
	
	var _printer = __webpack_require__(22);
	
	var _directives = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function missingFieldArgMessage(fieldName, argName, type) {
	  return "Field \"".concat(fieldName, "\" argument \"").concat(argName, "\" of type ") + "\"".concat(type, "\" is required but not provided.");
	}
	
	function missingDirectiveArgMessage(directiveName, argName, type) {
	  return "Directive \"@".concat(directiveName, "\" argument \"").concat(argName, "\" of type ") + "\"".concat(type, "\" is required but not provided.");
	}
	/**
	 * Provided required arguments
	 *
	 * A field or directive is only valid if all required (non-null without a
	 * default value) field arguments have been provided.
	 */
	
	
	function ProvidedRequiredArguments(context) {
	  return _objectSpread({}, ProvidedRequiredArgumentsOnDirectives(context), {
	    Field: {
	      // Validate on leave to allow for deeper errors to appear first.
	      leave: function leave(fieldNode) {
	        var fieldDef = context.getFieldDef();
	
	        if (!fieldDef) {
	          return false;
	        }
	
	        var argNodes = fieldNode.arguments || [];
	        var argNodeMap = (0, _keyMap.default)(argNodes, function (arg) {
	          return arg.name.value;
	        });
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = fieldDef.args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var argDef = _step.value;
	            var argNode = argNodeMap[argDef.name];
	
	            if (!argNode && (0, _definition.isRequiredArgument)(argDef)) {
	              context.reportError(new _GraphQLError.GraphQLError(missingFieldArgMessage(fieldDef.name, argDef.name, (0, _inspect.default)(argDef.type)), [fieldNode]));
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return != null) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	    }
	  });
	} // @internal
	
	
	function ProvidedRequiredArgumentsOnDirectives(context) {
	  var requiredArgsMap = Object.create(null);
	  var schema = context.getSchema();
	  var definedDirectives = schema ? schema.getDirectives() : _directives.specifiedDirectives;
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = definedDirectives[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var directive = _step2.value;
	      requiredArgsMap[directive.name] = (0, _keyMap.default)(directive.args.filter(_definition.isRequiredArgument), function (arg) {
	        return arg.name;
	      });
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  var astDefinitions = context.getDocument().definitions;
	  var _iteratorNormalCompletion3 = true;
	  var _didIteratorError3 = false;
	  var _iteratorError3 = undefined;
	
	  try {
	    for (var _iterator3 = astDefinitions[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	      var def = _step3.value;
	
	      if (def.kind === _kinds.Kind.DIRECTIVE_DEFINITION) {
	        requiredArgsMap[def.name.value] = (0, _keyMap.default)(def.arguments ? def.arguments.filter(isRequiredArgumentNode) : [], function (arg) {
	          return arg.name.value;
	        });
	      }
	    }
	  } catch (err) {
	    _didIteratorError3 = true;
	    _iteratorError3 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
	        _iterator3.return();
	      }
	    } finally {
	      if (_didIteratorError3) {
	        throw _iteratorError3;
	      }
	    }
	  }
	
	  return {
	    Directive: {
	      // Validate on leave to allow for deeper errors to appear first.
	      leave: function leave(directiveNode) {
	        var directiveName = directiveNode.name.value;
	        var requiredArgs = requiredArgsMap[directiveName];
	
	        if (requiredArgs) {
	          var argNodes = directiveNode.arguments || [];
	          var argNodeMap = (0, _keyMap.default)(argNodes, function (arg) {
	            return arg.name.value;
	          });
	
	          var _arr = Object.keys(requiredArgs);
	
	          for (var _i = 0; _i < _arr.length; _i++) {
	            var argName = _arr[_i];
	
	            if (!argNodeMap[argName]) {
	              var argType = requiredArgs[argName].type;
	              context.reportError(new _GraphQLError.GraphQLError(missingDirectiveArgMessage(directiveName, argName, (0, _definition.isType)(argType) ? (0, _inspect.default)(argType) : (0, _printer.print)(argType)), directiveNode));
	            }
	          }
	        }
	      }
	    }
	  };
	}
	
	function isRequiredArgumentNode(arg) {
	  return arg.type.kind === _kinds.Kind.NON_NULL_TYPE && arg.defaultValue == null;
	}

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.noSubselectionAllowedMessage = noSubselectionAllowedMessage;
	exports.requiredSubselectionMessage = requiredSubselectionMessage;
	exports.ScalarLeafs = ScalarLeafs;
	
	var _inspect = _interopRequireDefault(__webpack_require__(16));
	
	var _GraphQLError = __webpack_require__(9);
	
	var _definition = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function noSubselectionAllowedMessage(fieldName, type) {
	  return "Field \"".concat(fieldName, "\" must not have a selection since ") + "type \"".concat(type, "\" has no subfields.");
	}
	
	function requiredSubselectionMessage(fieldName, type) {
	  return "Field \"".concat(fieldName, "\" of type \"").concat(type, "\" must have a ") + "selection of subfields. Did you mean \"".concat(fieldName, " { ... }\"?");
	}
	/**
	 * Scalar leafs
	 *
	 * A GraphQL document is valid only if all leaf fields (fields without
	 * sub selections) are of scalar or enum types.
	 */
	
	
	function ScalarLeafs(context) {
	  return {
	    Field: function Field(node) {
	      var type = context.getType();
	      var selectionSet = node.selectionSet;
	
	      if (type) {
	        if ((0, _definition.isLeafType)((0, _definition.getNamedType)(type))) {
	          if (selectionSet) {
	            context.reportError(new _GraphQLError.GraphQLError(noSubselectionAllowedMessage(node.name.value, (0, _inspect.default)(type)), [selectionSet]));
	          }
	        } else if (!selectionSet) {
	          context.reportError(new _GraphQLError.GraphQLError(requiredSubselectionMessage(node.name.value, (0, _inspect.default)(type)), [node]));
	        }
	      }
	    }
	  };
	}

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.singleFieldOnlyMessage = singleFieldOnlyMessage;
	exports.SingleFieldSubscriptions = SingleFieldSubscriptions;
	
	var _GraphQLError = __webpack_require__(9);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function singleFieldOnlyMessage(name) {
	  return (name ? "Subscription \"".concat(name, "\" ") : 'Anonymous Subscription ') + 'must select only one top level field.';
	}
	/**
	 * Subscriptions must only include one field.
	 *
	 * A GraphQL subscription is valid only if it contains a single root field.
	 */
	
	
	function SingleFieldSubscriptions(context) {
	  return {
	    OperationDefinition: function OperationDefinition(node) {
	      if (node.operation === 'subscription') {
	        if (node.selectionSet.selections.length !== 1) {
	          context.reportError(new _GraphQLError.GraphQLError(singleFieldOnlyMessage(node.name && node.name.value), node.selectionSet.selections.slice(1)));
	        }
	      }
	    }
	  };
	}

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateArgMessage = duplicateArgMessage;
	exports.UniqueArgumentNames = UniqueArgumentNames;
	
	var _GraphQLError = __webpack_require__(9);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function duplicateArgMessage(argName) {
	  return "There can be only one argument named \"".concat(argName, "\".");
	}
	/**
	 * Unique argument names
	 *
	 * A GraphQL field or directive is only valid if all supplied arguments are
	 * uniquely named.
	 */
	
	
	function UniqueArgumentNames(context) {
	  var knownArgNames = Object.create(null);
	  return {
	    Field: function Field() {
	      knownArgNames = Object.create(null);
	    },
	    Directive: function Directive() {
	      knownArgNames = Object.create(null);
	    },
	    Argument: function Argument(node) {
	      var argName = node.name.value;
	
	      if (knownArgNames[argName]) {
	        context.reportError(new _GraphQLError.GraphQLError(duplicateArgMessage(argName), [knownArgNames[argName], node.name]));
	      } else {
	        knownArgNames[argName] = node.name;
	      }
	
	      return false;
	    }
	  };
	}

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateDirectiveMessage = duplicateDirectiveMessage;
	exports.UniqueDirectivesPerLocation = UniqueDirectivesPerLocation;
	
	var _GraphQLError = __webpack_require__(9);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function duplicateDirectiveMessage(directiveName) {
	  return "The directive \"".concat(directiveName, "\" can only be used once at ") + 'this location.';
	}
	/**
	 * Unique directive names per location
	 *
	 * A GraphQL document is only valid if all directives at a given location
	 * are uniquely named.
	 */
	
	
	function UniqueDirectivesPerLocation(context) {
	  return {
	    // Many different AST nodes may contain directives. Rather than listing
	    // them all, just listen for entering any node, and check to see if it
	    // defines any directives.
	    enter: function enter(node) {
	      // Flow can't refine that node.directives will only contain directives,
	      var directives = node.directives;
	
	      if (directives) {
	        var knownDirectives = Object.create(null);
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = directives[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var directive = _step.value;
	            var directiveName = directive.name.value;
	
	            if (knownDirectives[directiveName]) {
	              context.reportError(new _GraphQLError.GraphQLError(duplicateDirectiveMessage(directiveName), [knownDirectives[directiveName], directive]));
	            } else {
	              knownDirectives[directiveName] = directive;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return != null) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	    }
	  };
	}

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateFragmentNameMessage = duplicateFragmentNameMessage;
	exports.UniqueFragmentNames = UniqueFragmentNames;
	
	var _GraphQLError = __webpack_require__(9);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function duplicateFragmentNameMessage(fragName) {
	  return "There can be only one fragment named \"".concat(fragName, "\".");
	}
	/**
	 * Unique fragment names
	 *
	 * A GraphQL document is only valid if all defined fragments have unique names.
	 */
	
	
	function UniqueFragmentNames(context) {
	  var knownFragmentNames = Object.create(null);
	  return {
	    OperationDefinition: function OperationDefinition() {
	      return false;
	    },
	    FragmentDefinition: function FragmentDefinition(node) {
	      var fragmentName = node.name.value;
	
	      if (knownFragmentNames[fragmentName]) {
	        context.reportError(new _GraphQLError.GraphQLError(duplicateFragmentNameMessage(fragmentName), [knownFragmentNames[fragmentName], node.name]));
	      } else {
	        knownFragmentNames[fragmentName] = node.name;
	      }
	
	      return false;
	    }
	  };
	}

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateInputFieldMessage = duplicateInputFieldMessage;
	exports.UniqueInputFieldNames = UniqueInputFieldNames;
	
	var _GraphQLError = __webpack_require__(9);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function duplicateInputFieldMessage(fieldName) {
	  return "There can be only one input field named \"".concat(fieldName, "\".");
	}
	/**
	 * Unique input field names
	 *
	 * A GraphQL input object value is only valid if all supplied fields are
	 * uniquely named.
	 */
	
	
	function UniqueInputFieldNames(context) {
	  var knownNameStack = [];
	  var knownNames = Object.create(null);
	  return {
	    ObjectValue: {
	      enter: function enter() {
	        knownNameStack.push(knownNames);
	        knownNames = Object.create(null);
	      },
	      leave: function leave() {
	        knownNames = knownNameStack.pop();
	      }
	    },
	    ObjectField: function ObjectField(node) {
	      var fieldName = node.name.value;
	
	      if (knownNames[fieldName]) {
	        context.reportError(new _GraphQLError.GraphQLError(duplicateInputFieldMessage(fieldName), [knownNames[fieldName], node.name]));
	      } else {
	        knownNames[fieldName] = node.name;
	      }
	
	      return false;
	    }
	  };
	}

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateOperationNameMessage = duplicateOperationNameMessage;
	exports.UniqueOperationNames = UniqueOperationNames;
	
	var _GraphQLError = __webpack_require__(9);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function duplicateOperationNameMessage(operationName) {
	  return "There can be only one operation named \"".concat(operationName, "\".");
	}
	/**
	 * Unique operation names
	 *
	 * A GraphQL document is only valid if all defined operations have unique names.
	 */
	
	
	function UniqueOperationNames(context) {
	  var knownOperationNames = Object.create(null);
	  return {
	    OperationDefinition: function OperationDefinition(node) {
	      var operationName = node.name;
	
	      if (operationName) {
	        if (knownOperationNames[operationName.value]) {
	          context.reportError(new _GraphQLError.GraphQLError(duplicateOperationNameMessage(operationName.value), [knownOperationNames[operationName.value], operationName]));
	        } else {
	          knownOperationNames[operationName.value] = operationName;
	        }
	      }
	
	      return false;
	    },
	    FragmentDefinition: function FragmentDefinition() {
	      return false;
	    }
	  };
	}

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateVariableMessage = duplicateVariableMessage;
	exports.UniqueVariableNames = UniqueVariableNames;
	
	var _GraphQLError = __webpack_require__(9);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function duplicateVariableMessage(variableName) {
	  return "There can be only one variable named \"".concat(variableName, "\".");
	}
	/**
	 * Unique variable names
	 *
	 * A GraphQL operation is only valid if all its variables are uniquely named.
	 */
	
	
	function UniqueVariableNames(context) {
	  var knownVariableNames = Object.create(null);
	  return {
	    OperationDefinition: function OperationDefinition() {
	      knownVariableNames = Object.create(null);
	    },
	    VariableDefinition: function VariableDefinition(node) {
	      var variableName = node.variable.name.value;
	
	      if (knownVariableNames[variableName]) {
	        context.reportError(new _GraphQLError.GraphQLError(duplicateVariableMessage(variableName), [knownVariableNames[variableName], node.variable.name]));
	      } else {
	        knownVariableNames[variableName] = node.variable.name;
	      }
	    }
	  };
	}

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nonInputTypeOnVarMessage = nonInputTypeOnVarMessage;
	exports.VariablesAreInputTypes = VariablesAreInputTypes;
	
	var _GraphQLError = __webpack_require__(9);
	
	var _printer = __webpack_require__(22);
	
	var _definition = __webpack_require__(10);
	
	var _typeFromAST = __webpack_require__(29);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function nonInputTypeOnVarMessage(variableName, typeName) {
	  return "Variable \"$".concat(variableName, "\" cannot be non-input type \"").concat(typeName, "\".");
	}
	/**
	 * Variables are input types
	 *
	 * A GraphQL operation is only valid if all the variables it defines are of
	 * input types (scalar, enum, or input object).
	 */
	
	
	function VariablesAreInputTypes(context) {
	  return {
	    VariableDefinition: function VariableDefinition(node) {
	      var type = (0, _typeFromAST.typeFromAST)(context.getSchema(), node.type); // If the variable type is not an input type, return an error.
	
	      if (type && !(0, _definition.isInputType)(type)) {
	        var variableName = node.variable.name.value;
	        context.reportError(new _GraphQLError.GraphQLError(nonInputTypeOnVarMessage(variableName, (0, _printer.print)(node.type)), [node.type]));
	      }
	    }
	  };
	}

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.badVarPosMessage = badVarPosMessage;
	exports.VariablesInAllowedPosition = VariablesInAllowedPosition;
	
	var _inspect = _interopRequireDefault(__webpack_require__(16));
	
	var _GraphQLError = __webpack_require__(9);
	
	var _kinds = __webpack_require__(11);
	
	var _definition = __webpack_require__(10);
	
	var _typeComparators = __webpack_require__(67);
	
	var _typeFromAST = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function badVarPosMessage(varName, varType, expectedType) {
	  return "Variable \"$".concat(varName, "\" of type \"").concat(varType, "\" used in ") + "position expecting type \"".concat(expectedType, "\".");
	}
	/**
	 * Variables passed to field arguments conform to type
	 */
	
	
	function VariablesInAllowedPosition(context) {
	  var varDefMap = Object.create(null);
	  return {
	    OperationDefinition: {
	      enter: function enter() {
	        varDefMap = Object.create(null);
	      },
	      leave: function leave(operation) {
	        var usages = context.getRecursiveVariableUsages(operation);
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = usages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _ref2 = _step.value;
	            var node = _ref2.node,
	                type = _ref2.type,
	                defaultValue = _ref2.defaultValue;
	            var varName = node.name.value;
	            var varDef = varDefMap[varName];
	
	            if (varDef && type) {
	              // A var type is allowed if it is the same or more strict (e.g. is
	              // a subtype of) than the expected type. It can be more strict if
	              // the variable type is non-null when the expected type is nullable.
	              // If both are list types, the variable item type can be more strict
	              // than the expected item type (contravariant).
	              var schema = context.getSchema();
	              var varType = (0, _typeFromAST.typeFromAST)(schema, varDef.type);
	
	              if (varType && !allowedVariableUsage(schema, varType, varDef.defaultValue, type, defaultValue)) {
	                context.reportError(new _GraphQLError.GraphQLError(badVarPosMessage(varName, (0, _inspect.default)(varType), (0, _inspect.default)(type)), [varDef, node]));
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return != null) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	    },
	    VariableDefinition: function VariableDefinition(node) {
	      varDefMap[node.variable.name.value] = node;
	    }
	  };
	}
	/**
	 * Returns true if the variable is allowed in the location it was found,
	 * which includes considering if default values exist for either the variable
	 * or the location at which it is located.
	 */
	
	
	function allowedVariableUsage(schema, varType, varDefaultValue, locationType, locationDefaultValue) {
	  if ((0, _definition.isNonNullType)(locationType) && !(0, _definition.isNonNullType)(varType)) {
	    var hasNonNullVariableDefaultValue = varDefaultValue && varDefaultValue.kind !== _kinds.Kind.NULL;
	    var hasLocationDefaultValue = locationDefaultValue !== undefined;
	
	    if (!hasNonNullVariableDefaultValue && !hasLocationDefaultValue) {
	      return false;
	    }
	
	    var nullableLocationType = locationType.ofType;
	    return (0, _typeComparators.isTypeSubTypeOf)(schema, varType, nullableLocationType);
	  }
	
	  return (0, _typeComparators.isTypeSubTypeOf)(schema, varType, locationType);
	}

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.specifiedSDLRules = exports.specifiedRules = void 0;
	
	var _ExecutableDefinitions = __webpack_require__(475);
	
	var _UniqueOperationNames = __webpack_require__(214);
	
	var _LoneAnonymousOperation = __webpack_require__(200);
	
	var _SingleFieldSubscriptions = __webpack_require__(209);
	
	var _KnownTypeNames = __webpack_require__(199);
	
	var _FragmentsOnCompositeTypes = __webpack_require__(195);
	
	var _VariablesAreInputTypes = __webpack_require__(216);
	
	var _ScalarLeafs = __webpack_require__(208);
	
	var _FieldsOnCorrectType = __webpack_require__(194);
	
	var _UniqueFragmentNames = __webpack_require__(212);
	
	var _KnownFragmentNames = __webpack_require__(198);
	
	var _NoUnusedFragments = __webpack_require__(203);
	
	var _PossibleFragmentSpreads = __webpack_require__(206);
	
	var _NoFragmentCycles = __webpack_require__(201);
	
	var _UniqueVariableNames = __webpack_require__(215);
	
	var _NoUndefinedVariables = __webpack_require__(202);
	
	var _NoUnusedVariables = __webpack_require__(204);
	
	var _KnownDirectives = __webpack_require__(197);
	
	var _UniqueDirectivesPerLocation = __webpack_require__(211);
	
	var _KnownArgumentNames = __webpack_require__(196);
	
	var _UniqueArgumentNames = __webpack_require__(210);
	
	var _ValuesOfCorrectType = __webpack_require__(114);
	
	var _ProvidedRequiredArguments = __webpack_require__(207);
	
	var _VariablesInAllowedPosition = __webpack_require__(217);
	
	var _OverlappingFieldsCanBeMerged = __webpack_require__(205);
	
	var _UniqueInputFieldNames = __webpack_require__(213);
	
	var _LoneSchemaDefinition = __webpack_require__(476);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	// Spec Section: "Executable Definitions"
	// Spec Section: "Operation Name Uniqueness"
	// Spec Section: "Lone Anonymous Operation"
	// Spec Section: "Subscriptions with Single Root Field"
	// Spec Section: "Fragment Spread Type Existence"
	// Spec Section: "Fragments on Composite Types"
	// Spec Section: "Variables are Input Types"
	// Spec Section: "Leaf Field Selections"
	// Spec Section: "Field Selections on Objects, Interfaces, and Unions Types"
	// Spec Section: "Fragment Name Uniqueness"
	// Spec Section: "Fragment spread target defined"
	// Spec Section: "Fragments must be used"
	// Spec Section: "Fragment spread is possible"
	// Spec Section: "Fragments must not form cycles"
	// Spec Section: "Variable Uniqueness"
	// Spec Section: "All Variable Used Defined"
	// Spec Section: "All Variables Used"
	// Spec Section: "Directives Are Defined"
	// Spec Section: "Directives Are Unique Per Location"
	// Spec Section: "Argument Names"
	// Spec Section: "Argument Uniqueness"
	// Spec Section: "Value Type Correctness"
	// Spec Section: "Argument Optionality"
	// Spec Section: "All Variable Usages Are Allowed"
	// Spec Section: "Field Selection Merging"
	// Spec Section: "Input Object Field Uniqueness"
	
	/**
	 * This set includes all validation rules defined by the GraphQL spec.
	 *
	 * The order of the rules in this list has been adjusted to lead to the
	 * most clear output when encountering multiple validation errors.
	 */
	var specifiedRules = [_ExecutableDefinitions.ExecutableDefinitions, _UniqueOperationNames.UniqueOperationNames, _LoneAnonymousOperation.LoneAnonymousOperation, _SingleFieldSubscriptions.SingleFieldSubscriptions, _KnownTypeNames.KnownTypeNames, _FragmentsOnCompositeTypes.FragmentsOnCompositeTypes, _VariablesAreInputTypes.VariablesAreInputTypes, _ScalarLeafs.ScalarLeafs, _FieldsOnCorrectType.FieldsOnCorrectType, _UniqueFragmentNames.UniqueFragmentNames, _KnownFragmentNames.KnownFragmentNames, _NoUnusedFragments.NoUnusedFragments, _PossibleFragmentSpreads.PossibleFragmentSpreads, _NoFragmentCycles.NoFragmentCycles, _UniqueVariableNames.UniqueVariableNames, _NoUndefinedVariables.NoUndefinedVariables, _NoUnusedVariables.NoUnusedVariables, _KnownDirectives.KnownDirectives, _UniqueDirectivesPerLocation.UniqueDirectivesPerLocation, _KnownArgumentNames.KnownArgumentNames, _UniqueArgumentNames.UniqueArgumentNames, _ValuesOfCorrectType.ValuesOfCorrectType, _ProvidedRequiredArguments.ProvidedRequiredArguments, _VariablesInAllowedPosition.VariablesInAllowedPosition, _OverlappingFieldsCanBeMerged.OverlappingFieldsCanBeMerged, _UniqueInputFieldNames.UniqueInputFieldNames];
	exports.specifiedRules = specifiedRules;
	// @internal
	var specifiedSDLRules = [_LoneSchemaDefinition.LoneSchemaDefinition, _KnownDirectives.KnownDirectives, _UniqueDirectivesPerLocation.UniqueDirectivesPerLocation, _KnownArgumentNames.KnownArgumentNamesOnDirectives, _UniqueArgumentNames.UniqueArgumentNames, _UniqueInputFieldNames.UniqueInputFieldNames, _ProvidedRequiredArguments.ProvidedRequiredArgumentsOnDirectives];
	exports.specifiedSDLRules = specifiedSDLRules;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(359);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(589)(module), (function() { return this; }())))

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _querySelectorAll = _interopRequireDefault(__webpack_require__(99));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _useForceUpdate = _interopRequireDefault(__webpack_require__(161));
	
	var _useMergedRefs = _interopRequireDefault(__webpack_require__(47));
	
	var _NavContext = _interopRequireDefault(__webpack_require__(121));
	
	var _SelectableContext = _interopRequireWildcard(__webpack_require__(25));
	
	var _TabContext = _interopRequireDefault(__webpack_require__(125));
	
	var _excluded = ["as", "onSelect", "activeKey", "role", "onKeyDown"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	var noop = function noop() {};
	
	var AbstractNav = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'ul' : _ref$as,
	      onSelect = _ref.onSelect,
	      activeKey = _ref.activeKey,
	      role = _ref.role,
	      onKeyDown = _ref.onKeyDown,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
	  // and don't want to reset the set in the effect
	  var forceUpdate = (0, _useForceUpdate.default)();
	  var needsRefocusRef = (0, _react.useRef)(false);
	  var parentOnSelect = (0, _react.useContext)(_SelectableContext.default);
	  var tabContext = (0, _react.useContext)(_TabContext.default);
	  var getControlledId, getControllerId;
	
	  if (tabContext) {
	    role = role || 'tablist';
	    activeKey = tabContext.activeKey;
	    getControlledId = tabContext.getControlledId;
	    getControllerId = tabContext.getControllerId;
	  }
	
	  var listNode = (0, _react.useRef)(null);
	
	  var getNextActiveChild = function getNextActiveChild(offset) {
	    var currentListNode = listNode.current;
	    if (!currentListNode) return null;
	    var items = (0, _querySelectorAll.default)(currentListNode, '[data-rb-event-key]:not(.disabled)');
	    var activeChild = currentListNode.querySelector('.active');
	    if (!activeChild) return null;
	    var index = items.indexOf(activeChild);
	    if (index === -1) return null;
	    var nextIndex = index + offset;
	    if (nextIndex >= items.length) nextIndex = 0;
	    if (nextIndex < 0) nextIndex = items.length - 1;
	    return items[nextIndex];
	  };
	
	  var handleSelect = function handleSelect(key, event) {
	    if (key == null) return;
	    if (onSelect) onSelect(key, event);
	    if (parentOnSelect) parentOnSelect(key, event);
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    if (onKeyDown) onKeyDown(event);
	    var nextActiveChild;
	
	    switch (event.key) {
	      case 'ArrowLeft':
	      case 'ArrowUp':
	        nextActiveChild = getNextActiveChild(-1);
	        break;
	
	      case 'ArrowRight':
	      case 'ArrowDown':
	        nextActiveChild = getNextActiveChild(1);
	        break;
	
	      default:
	        return;
	    }
	
	    if (!nextActiveChild) return;
	    event.preventDefault();
	    handleSelect(nextActiveChild.dataset.rbEventKey, event);
	    needsRefocusRef.current = true;
	    forceUpdate();
	  };
	
	  (0, _react.useEffect)(function () {
	    if (listNode.current && needsRefocusRef.current) {
	      var activeChild = listNode.current.querySelector('[data-rb-event-key].active');
	      if (activeChild) activeChild.focus();
	    }
	
	    needsRefocusRef.current = false;
	  });
	  var mergedRef = (0, _useMergedRefs.default)(ref, listNode);
	  return /*#__PURE__*/_react.default.createElement(_SelectableContext.default.Provider, {
	    value: handleSelect
	  }, /*#__PURE__*/_react.default.createElement(_NavContext.default.Provider, {
	    value: {
	      role: role,
	      // used by NavLink to determine it's role
	      activeKey: (0, _SelectableContext.makeEventKey)(activeKey),
	      getControlledId: getControlledId || noop,
	      getControllerId: getControllerId || noop
	    }
	  }, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    onKeyDown: handleKeyDown,
	    ref: mergedRef,
	    role: role
	  }))));
	});
	
	var _default = AbstractNav;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(18));
	
	var _warning = _interopRequireDefault(__webpack_require__(31));
	
	var _NavContext = _interopRequireDefault(__webpack_require__(121));
	
	var _SelectableContext = _interopRequireWildcard(__webpack_require__(25));
	
	var _excluded = ["active", "className", "eventKey", "onSelect", "onClick", "as"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var defaultProps = {
	  disabled: false
	};
	
	var AbstractNavItem = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var active = _ref.active,
	      className = _ref.className,
	      eventKey = _ref.eventKey,
	      onSelect = _ref.onSelect,
	      onClick = _ref.onClick,
	      Component = _ref.as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var navKey = (0, _SelectableContext.makeEventKey)(eventKey, props.href);
	  var parentOnSelect = (0, _react.useContext)(_SelectableContext.default);
	  var navContext = (0, _react.useContext)(_NavContext.default);
	  var isActive = active;
	
	  if (navContext) {
	    if (!props.role && navContext.role === 'tablist') props.role = 'tab';
	    var contextControllerId = navContext.getControllerId(navKey);
	    var contextControlledId = navContext.getControlledId(navKey);
	     false ? (0, _warning.default)(!contextControllerId || !props.id, "[react-bootstrap] The provided id '" + props.id + "' was overwritten by the current navContext with '" + contextControllerId + "'.") : void 0;
	     false ? (0, _warning.default)(!contextControlledId || !props['aria-controls'], "[react-bootstrap] The provided aria-controls value '" + props['aria-controls'] + "' was overwritten by the current navContext with '" + contextControlledId + "'.") : void 0;
	    props['data-rb-event-key'] = navKey;
	    props.id = contextControllerId || props.id;
	    props['aria-controls'] = contextControlledId || props['aria-controls'];
	    isActive = active == null && navKey != null ? navContext.activeKey === navKey : active;
	  }
	
	  if (props.role === 'tab') {
	    if (props.disabled) {
	      props.tabIndex = -1;
	      props['aria-disabled'] = true;
	    }
	
	    props['aria-selected'] = isActive;
	  }
	
	  var handleOnclick = (0, _useEventCallback.default)(function (e) {
	    if (onClick) onClick(e);
	    if (navKey == null) return;
	    if (onSelect) onSelect(navKey, e);
	    if (parentOnSelect) parentOnSelect(navKey, e);
	  });
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    onClick: handleOnclick,
	    className: (0, _classnames.default)(className, isActive && 'active')
	  }));
	});
	
	AbstractNavItem.defaultProps = defaultProps;
	var _default = AbstractNavItem;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(117));
	
	var _AccordionContext = _interopRequireDefault(__webpack_require__(74));
	
	var _SelectableContext = _interopRequireDefault(__webpack_require__(25));
	
	var _excluded = ["children", "eventKey"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var AccordionCollapse = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var children = _ref.children,
	      eventKey = _ref.eventKey,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var contextEventKey = (0, _react.useContext)(_AccordionContext.default); // Empty SelectableContext is to prevent elements in the collapse
	  // from collapsing the accordion when clicked.
	
	  return /*#__PURE__*/_react.default.createElement(_SelectableContext.default.Provider, {
	    value: null
	  }, /*#__PURE__*/_react.default.createElement(_Collapse.default, (0, _extends2.default)({
	    ref: ref,
	    in: contextEventKey === eventKey
	  }, props), /*#__PURE__*/_react.default.createElement("div", null, _react.default.Children.only(children))));
	});
	
	AccordionCollapse.displayName = 'AccordionCollapse';
	var _default = AccordionCollapse;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.useAccordionToggle = useAccordionToggle;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _SelectableContext = _interopRequireDefault(__webpack_require__(25));
	
	var _AccordionContext = _interopRequireDefault(__webpack_require__(74));
	
	var _excluded = ["as", "children", "eventKey", "onClick"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function useAccordionToggle(eventKey, onClick) {
	  var contextEventKey = (0, _react.useContext)(_AccordionContext.default);
	  var onSelect = (0, _react.useContext)(_SelectableContext.default);
	  return function (e) {
	    /*
	      Compare the event key in context with the given event key.
	      If they are the same, then collapse the component.
	    */
	    var eventKeyPassed = eventKey === contextEventKey ? null : eventKey;
	    if (onSelect) onSelect(eventKeyPassed, e);
	    if (onClick) onClick(e);
	  };
	}
	
	var AccordionToggle = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'button' : _ref$as,
	      children = _ref.children,
	      eventKey = _ref.eventKey,
	      onClick = _ref.onClick,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var accordionOnClick = useAccordionToggle(eventKey, onClick);
	
	  if (Component === 'button') {
	    props.type = 'button';
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    onClick: accordionOnClick
	  }, props), children);
	});
	
	var _default = AccordionToggle;
	exports.default = _default;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(35));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "active", "children", "className", "as", "linkAs", "linkProps", "href", "title", "target"];
	var defaultProps = {
	  active: false,
	  linkProps: {}
	};
	
	var BreadcrumbItem = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      active = _ref.active,
	      children = _ref.children,
	      className = _ref.className,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'li' : _ref$as,
	      _ref$linkAs = _ref.linkAs,
	      LinkComponent = _ref$linkAs === void 0 ? _SafeAnchor.default : _ref$linkAs,
	      linkProps = _ref.linkProps,
	      href = _ref.href,
	      title = _ref.title,
	      target = _ref.target,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'breadcrumb-item');
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(prefix, className, {
	      active: active
	    }),
	    "aria-current": active ? 'page' : undefined
	  }), active ? children : /*#__PURE__*/_react.default.createElement(LinkComponent, (0, _extends2.default)({}, linkProps, {
	    href: href,
	    title: title,
	    target: target
	  }), children));
	});
	
	BreadcrumbItem.displayName = 'BreadcrumbItem';
	BreadcrumbItem.defaultProps = defaultProps;
	var _default = BreadcrumbItem;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var context = /*#__PURE__*/_react.default.createContext(null);
	
	context.displayName = 'CardContext';
	var _default = context;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "className", "variant", "as"];
	var defaultProps = {
	  variant: null
	};
	
	var CardImg = /*#__PURE__*/_react.default.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
	function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      variant = _ref.variant,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'img' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'card-img');
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _classnames.default)(variant ? prefix + "-" + variant : prefix, className)
	  }, props));
	});
	
	CardImg.displayName = 'CardImg';
	CardImg.defaultProps = defaultProps;
	var _default = CardImg;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["as", "bsPrefix", "children", "className"];
	
	var CarouselItem = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      bsPrefix = _ref.bsPrefix,
	      children = _ref.children,
	      className = _ref.className,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var finalClassName = (0, _classnames.default)(className, (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'carousel-item'));
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: finalClassName
	  }), children);
	});
	
	CarouselItem.displayName = 'CarouselItem';
	var _default = CarouselItem;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "className", "as"];
	var DEVICE_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
	
	var Col = /*#__PURE__*/_react.default.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
	function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'col');
	  var spans = [];
	  var classes = [];
	  DEVICE_SIZES.forEach(function (brkPoint) {
	    var propValue = props[brkPoint];
	    delete props[brkPoint];
	    var span;
	    var offset;
	    var order;
	
	    if (typeof propValue === 'object' && propValue != null) {
	      var _propValue$span = propValue.span;
	      span = _propValue$span === void 0 ? true : _propValue$span;
	      offset = propValue.offset;
	      order = propValue.order;
	    } else {
	      span = propValue;
	    }
	
	    var infix = brkPoint !== 'xs' ? "-" + brkPoint : '';
	    if (span) spans.push(span === true ? "" + prefix + infix : "" + prefix + infix + "-" + span);
	    if (order != null) classes.push("order" + infix + "-" + order);
	    if (offset != null) classes.push("offset" + infix + "-" + offset);
	  });
	
	  if (!spans.length) {
	    spans.push(prefix); // plain 'col'
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: _classnames.default.apply(void 0, [className].concat(spans, classes))
	  }));
	});
	
	Col.displayName = 'Col';
	var _default = Col;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _isRequiredForA11y = _interopRequireDefault(__webpack_require__(72));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _DropdownToggle = __webpack_require__(261);
	
	var _useMergedRefs = _interopRequireDefault(__webpack_require__(47));
	
	var _Button = _interopRequireDefault(__webpack_require__(75));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _useWrappedRefWithWarning = _interopRequireDefault(__webpack_require__(255));
	
	var _excluded = ["bsPrefix", "split", "className", "childBsPrefix", "as"];
	
	var DropdownToggle = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      split = _ref.split,
	      className = _ref.className,
	      childBsPrefix = _ref.childBsPrefix,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? _Button.default : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-toggle');
	
	  if (childBsPrefix !== undefined) {
	    props.bsPrefix = childBsPrefix;
	  }
	
	  var _useDropdownToggle = (0, _DropdownToggle.useDropdownToggle)(),
	      toggleProps = _useDropdownToggle[0];
	
	  toggleProps.ref = (0, _useMergedRefs.default)(toggleProps.ref, (0, _useWrappedRefWithWarning.default)(ref, 'DropdownToggle')); // This intentionally forwards size and variant (if set) to the
	  // underlying component, to allow it to render size and style variants.
	
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _classnames.default)(className, prefix, split && prefix + "-split")
	  }, toggleProps, props));
	});
	
	DropdownToggle.displayName = 'DropdownToggle';
	var _default = DropdownToggle;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _all = _interopRequireDefault(__webpack_require__(71));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _warning = _interopRequireDefault(__webpack_require__(31));
	
	var _Feedback = _interopRequireDefault(__webpack_require__(119));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(30));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "bsCustomPrefix", "type", "size", "htmlSize", "id", "className", "isValid", "isInvalid", "plaintext", "readOnly", "custom", "as"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var FormControl = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      bsCustomPrefix = _ref.bsCustomPrefix,
	      type = _ref.type,
	      size = _ref.size,
	      htmlSize = _ref.htmlSize,
	      id = _ref.id,
	      className = _ref.className,
	      _ref$isValid = _ref.isValid,
	      isValid = _ref$isValid === void 0 ? false : _ref$isValid,
	      _ref$isInvalid = _ref.isInvalid,
	      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
	      plaintext = _ref.plaintext,
	      readOnly = _ref.readOnly,
	      custom = _ref.custom,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'input' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	
	  var _useContext = (0, _react.useContext)(_FormContext.default),
	      controlId = _useContext.controlId;
	
	  var _ref2 = custom ? [bsCustomPrefix, 'custom'] : [bsPrefix, 'form-control'],
	      prefix = _ref2[0],
	      defaultPrefix = _ref2[1];
	
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(prefix, defaultPrefix);
	  var classes;
	
	  if (plaintext) {
	    var _classes;
	
	    classes = (_classes = {}, _classes[bsPrefix + "-plaintext"] = true, _classes);
	  } else if (type === 'file') {
	    var _classes2;
	
	    classes = (_classes2 = {}, _classes2[bsPrefix + "-file"] = true, _classes2);
	  } else if (type === 'range') {
	    var _classes3;
	
	    classes = (_classes3 = {}, _classes3[bsPrefix + "-range"] = true, _classes3);
	  } else if (Component === 'select' && custom) {
	    var _classes4;
	
	    classes = (_classes4 = {}, _classes4[bsPrefix + "-select"] = true, _classes4[bsPrefix + "-select-" + size] = size, _classes4);
	  } else {
	    var _classes5;
	
	    classes = (_classes5 = {}, _classes5[bsPrefix] = true, _classes5[bsPrefix + "-" + size] = size, _classes5);
	  }
	
	   false ? (0, _warning.default)(controlId == null || !id, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    type: type,
	    size: htmlSize,
	    ref: ref,
	    readOnly: readOnly,
	    id: id || controlId,
	    className: (0, _classnames.default)(className, classes, isValid && "is-valid", isInvalid && "is-invalid")
	  }));
	});
	
	FormControl.displayName = 'FormControl';
	
	var _default = Object.assign(FormControl, {
	  Feedback: _Feedback.default
	});
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _all = _interopRequireDefault(__webpack_require__(71));
	
	var _Feedback = _interopRequireDefault(__webpack_require__(119));
	
	var _FormFileInput = _interopRequireDefault(__webpack_require__(528));
	
	var _FormFileLabel = _interopRequireDefault(__webpack_require__(529));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(30));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["id", "bsPrefix", "bsCustomPrefix", "disabled", "isValid", "isInvalid", "feedbackTooltip", "feedback", "className", "style", "label", "children", "custom", "lang", "data-browse", "as", "inputAs"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var FormFile = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var id = _ref.id,
	      bsPrefix = _ref.bsPrefix,
	      bsCustomPrefix = _ref.bsCustomPrefix,
	      _ref$disabled = _ref.disabled,
	      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
	      _ref$isValid = _ref.isValid,
	      isValid = _ref$isValid === void 0 ? false : _ref$isValid,
	      _ref$isInvalid = _ref.isInvalid,
	      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
	      _ref$feedbackTooltip = _ref.feedbackTooltip,
	      feedbackTooltip = _ref$feedbackTooltip === void 0 ? false : _ref$feedbackTooltip,
	      feedback = _ref.feedback,
	      className = _ref.className,
	      style = _ref.style,
	      label = _ref.label,
	      children = _ref.children,
	      custom = _ref.custom,
	      lang = _ref.lang,
	      dataBrowse = _ref['data-browse'],
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      _ref$inputAs = _ref.inputAs,
	      inputAs = _ref$inputAs === void 0 ? 'input' : _ref$inputAs,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	
	  var _ref2 = custom ? [bsCustomPrefix, 'custom'] : [bsPrefix, 'form-file'],
	      prefix = _ref2[0],
	      defaultPrefix = _ref2[1];
	
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(prefix, defaultPrefix);
	  var type = 'file';
	
	  var _useContext = (0, _react.useContext)(_FormContext.default),
	      controlId = _useContext.controlId;
	
	  var innerFormContext = (0, _react.useMemo)(function () {
	    return {
	      controlId: id || controlId,
	      custom: custom
	    };
	  }, [controlId, custom, id]);
	  var hasLabel = label != null && label !== false && !children;
	
	  var input = /*#__PURE__*/_react.default.createElement(_FormFileInput.default, (0, _extends2.default)({}, props, {
	    ref: ref,
	    isValid: isValid,
	    isInvalid: isInvalid,
	    disabled: disabled,
	    as: inputAs,
	    lang: lang
	  }));
	
	  return /*#__PURE__*/_react.default.createElement(_FormContext.default.Provider, {
	    value: innerFormContext
	  }, /*#__PURE__*/_react.default.createElement(Component, {
	    style: style,
	    className: (0, _classnames.default)(className, bsPrefix, custom && "custom-" + type)
	  }, children || /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, custom ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, input, hasLabel && /*#__PURE__*/_react.default.createElement(_FormFileLabel.default, {
	    "data-browse": dataBrowse
	  }, label)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasLabel && /*#__PURE__*/_react.default.createElement(_FormFileLabel.default, null, label), input), (isValid || isInvalid) && /*#__PURE__*/_react.default.createElement(_Feedback.default, {
	    type: isValid ? 'valid' : 'invalid',
	    tooltip: feedbackTooltip
	  }, feedback))));
	});
	
	FormFile.displayName = 'FormFile';
	FormFile.Input = _FormFileInput.default;
	FormFile.Label = _FormFileLabel.default;
	var _default = FormFile;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(30));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "className", "children", "controlId", "as"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var FormGroup = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      children = _ref.children,
	      controlId = _ref.controlId,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'form-group');
	  var context = (0, _react.useMemo)(function () {
	    return {
	      controlId: controlId
	    };
	  }, [controlId]);
	  return /*#__PURE__*/_react.default.createElement(_FormContext.default.Provider, {
	    value: context
	  }, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(className, bsPrefix)
	  }), children));
	});
	
	FormGroup.displayName = 'FormGroup';
	var _default = FormGroup;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _warning = _interopRequireDefault(__webpack_require__(31));
	
	var _Col = _interopRequireDefault(__webpack_require__(229));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(30));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["as", "bsPrefix", "column", "srOnly", "className", "htmlFor"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var defaultProps = {
	  column: false,
	  srOnly: false
	};
	
	var FormLabel = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'label' : _ref$as,
	      bsPrefix = _ref.bsPrefix,
	      column = _ref.column,
	      srOnly = _ref.srOnly,
	      className = _ref.className,
	      htmlFor = _ref.htmlFor,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	
	  var _useContext = (0, _react.useContext)(_FormContext.default),
	      controlId = _useContext.controlId;
	
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'form-label');
	  var columnClass = 'col-form-label';
	  if (typeof column === 'string') columnClass = columnClass + " " + columnClass + "-" + column;
	  var classes = (0, _classnames.default)(className, bsPrefix, srOnly && 'sr-only', column && columnClass);
	   false ? (0, _warning.default)(controlId == null || !htmlFor, '`controlId` is ignored on `<FormLabel>` when `htmlFor` is specified.') : void 0;
	  htmlFor = htmlFor || controlId;
	  if (column) return /*#__PURE__*/_react.default.createElement(_Col.default, (0, _extends2.default)({
	    ref: ref,
	    as: "label",
	    className: classes,
	    htmlFor: htmlFor
	  }, props));
	  return (
	    /*#__PURE__*/
	    // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
	    _react.default.createElement(Component, (0, _extends2.default)({
	      ref: ref,
	      className: classes,
	      htmlFor: htmlFor
	    }, props))
	  );
	});
	
	FormLabel.displayName = 'FormLabel';
	FormLabel.defaultProps = defaultProps;
	var _default = FormLabel;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "className", "as", "muted"];
	
	var FormText = /*#__PURE__*/_react.default.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
	function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'small' : _ref$as,
	      muted = _ref.muted,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'form-text');
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(className, bsPrefix, muted && 'text-muted')
	  }));
	});
	
	FormText.displayName = 'FormText';
	var _default = FormText;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = exports.propTypes = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "className", "fluid", "rounded", "roundedCircle", "thumbnail"];
	var propTypes = {
	  /**
	   * @default 'img'
	   */
	  bsPrefix: _propTypes.default.string,
	
	  /**
	   * Sets image as fluid image.
	   */
	  fluid: _propTypes.default.bool,
	
	  /**
	   * Sets image shape as rounded.
	   */
	  rounded: _propTypes.default.bool,
	
	  /**
	   * Sets image shape as circle.
	   */
	  roundedCircle: _propTypes.default.bool,
	
	  /**
	   * Sets image shape as thumbnail.
	   */
	  thumbnail: _propTypes.default.bool
	};
	exports.propTypes = propTypes;
	var defaultProps = {
	  fluid: false,
	  rounded: false,
	  roundedCircle: false,
	  thumbnail: false
	};
	
	var Image = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      fluid = _ref.fluid,
	      rounded = _ref.rounded,
	      roundedCircle = _ref.roundedCircle,
	      thumbnail = _ref.thumbnail,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'img');
	  var classes = (0, _classnames.default)(fluid && bsPrefix + "-fluid", rounded && "rounded", roundedCircle && "rounded-circle", thumbnail && bsPrefix + "-thumbnail");
	  return /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({
	    // eslint-disable-line jsx-a11y/alt-text
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(className, classes)
	  }));
	});
	
	Image.displayName = 'Image';
	Image.defaultProps = defaultProps;
	var _default = Image;
	exports.default = _default;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _AbstractNavItem = _interopRequireDefault(__webpack_require__(222));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "active", "disabled", "className", "variant", "action", "as", "onClick"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var defaultProps = {
	  variant: undefined,
	  active: false,
	  disabled: false
	};
	
	var ListGroupItem = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      active = _ref.active,
	      disabled = _ref.disabled,
	      className = _ref.className,
	      variant = _ref.variant,
	      action = _ref.action,
	      as = _ref.as,
	      onClick = _ref.onClick,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'list-group-item');
	  var handleClick = (0, _react.useCallback)(function (event) {
	    if (disabled) {
	      event.preventDefault();
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) onClick(event);
	  }, [disabled, onClick]);
	
	  if (disabled && props.tabIndex === undefined) {
	    props.tabIndex = -1;
	    props['aria-disabled'] = true;
	  }
	
	  return /*#__PURE__*/_react.default.createElement(_AbstractNavItem.default, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    // eslint-disable-next-line no-nested-ternary
	    as: as || (action ? props.href ? 'a' : 'button' : 'div'),
	    onClick: handleClick,
	    className: (0, _classnames.default)(className, bsPrefix, active && 'active', disabled && 'disabled', variant && bsPrefix + "-" + variant, action && bsPrefix + "-action")
	  }));
	});
	
	ListGroupItem.defaultProps = defaultProps;
	ListGroupItem.displayName = 'ListGroupItem';
	var _default = ListGroupItem;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var _default = (0, _createWithBsPrefix.default)('modal-body');
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var ModalContext = /*#__PURE__*/_react.default.createContext({
	  // eslint-disable-next-line @typescript-eslint/no-empty-function
	  onHide: function onHide() {}
	});
	
	var _default = ModalContext;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "className", "contentClassName", "centered", "size", "children", "scrollable"];
	
	var ModalDialog = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      contentClassName = _ref.contentClassName,
	      centered = _ref.centered,
	      size = _ref.size,
	      children = _ref.children,
	      scrollable = _ref.scrollable,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'modal');
	  var dialogClass = bsPrefix + "-dialog";
	  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(dialogClass, className, size && bsPrefix + "-" + size, centered && dialogClass + "-centered", scrollable && dialogClass + "-scrollable")
	  }), /*#__PURE__*/_react.default.createElement("div", {
	    className: (0, _classnames.default)(bsPrefix + "-content", contentClassName)
	  }, children));
	});
	
	ModalDialog.displayName = 'ModalDialog';
	var _default = ModalDialog;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var _default = (0, _createWithBsPrefix.default)('modal-footer');
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var _divWithClassName = _interopRequireDefault(__webpack_require__(128));
	
	var DivStyledAsH4 = (0, _divWithClassName.default)('h4');
	
	var _default = (0, _createWithBsPrefix.default)('modal-title', {
	  Component: DivStyledAsH4
	});
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _all = _interopRequireDefault(__webpack_require__(71));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _uncontrollable = __webpack_require__(20);
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _NavbarContext = _interopRequireDefault(__webpack_require__(57));
	
	var _CardContext = _interopRequireDefault(__webpack_require__(226));
	
	var _AbstractNav = _interopRequireDefault(__webpack_require__(221));
	
	var _NavItem = _interopRequireDefault(__webpack_require__(122));
	
	var _NavLink = _interopRequireDefault(__webpack_require__(79));
	
	var _excluded = ["as", "bsPrefix", "variant", "fill", "justify", "navbar", "navbarScroll", "className", "children", "activeKey"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var defaultProps = {
	  justify: false,
	  fill: false
	};
	
	var Nav = /*#__PURE__*/_react.default.forwardRef(function (uncontrolledProps, ref) {
	  var _classNames;
	
	  var _useUncontrolled = (0, _uncontrollable.useUncontrolled)(uncontrolledProps, {
	    activeKey: 'onSelect'
	  }),
	      _useUncontrolled$as = _useUncontrolled.as,
	      as = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as,
	      initialBsPrefix = _useUncontrolled.bsPrefix,
	      variant = _useUncontrolled.variant,
	      fill = _useUncontrolled.fill,
	      justify = _useUncontrolled.justify,
	      navbar = _useUncontrolled.navbar,
	      navbarScroll = _useUncontrolled.navbarScroll,
	      className = _useUncontrolled.className,
	      children = _useUncontrolled.children,
	      activeKey = _useUncontrolled.activeKey,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_useUncontrolled, _excluded);
	
	  var bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(initialBsPrefix, 'nav');
	  var navbarBsPrefix;
	  var cardHeaderBsPrefix;
	  var isNavbar = false;
	  var navbarContext = (0, _react.useContext)(_NavbarContext.default);
	  var cardContext = (0, _react.useContext)(_CardContext.default);
	
	  if (navbarContext) {
	    navbarBsPrefix = navbarContext.bsPrefix;
	    isNavbar = navbar == null ? true : navbar;
	  } else if (cardContext) {
	    cardHeaderBsPrefix = cardContext.cardHeaderBsPrefix;
	  }
	
	  return /*#__PURE__*/_react.default.createElement(_AbstractNav.default, (0, _extends2.default)({
	    as: as,
	    ref: ref,
	    activeKey: activeKey,
	    className: (0, _classnames.default)(className, (_classNames = {}, _classNames[bsPrefix] = !isNavbar, _classNames[navbarBsPrefix + "-nav"] = isNavbar, _classNames[navbarBsPrefix + "-nav-scroll"] = isNavbar && navbarScroll, _classNames[cardHeaderBsPrefix + "-" + variant] = !!cardHeaderBsPrefix, _classNames[bsPrefix + "-" + variant] = !!variant, _classNames[bsPrefix + "-fill"] = fill, _classNames[bsPrefix + "-justified"] = justify, _classNames))
	  }, props), children);
	});
	
	Nav.displayName = 'Nav';
	Nav.defaultProps = defaultProps;
	Nav.Item = _NavItem.default;
	Nav.Link = _NavLink.default;
	var _default = Nav;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "className", "as"];
	
	var NavbarBrand = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      as = _ref.as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'navbar-brand');
	  var Component = as || (props.href ? 'a' : 'span');
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(className, bsPrefix)
	  }));
	});
	
	NavbarBrand.displayName = 'NavbarBrand';
	var _default = NavbarBrand;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _Overlay = _interopRequireDefault(__webpack_require__(567));
	
	var _safeFindDOMNode = _interopRequireDefault(__webpack_require__(133));
	
	var _usePopperMarginModifiers = _interopRequireDefault(__webpack_require__(254));
	
	var _Fade = _interopRequireDefault(__webpack_require__(43));
	
	var _excluded = ["children", "transition", "popperConfig"],
	    _excluded2 = ["props", "arrowProps", "show", "update", "forceUpdate", "placement", "state"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var defaultProps = {
	  transition: _Fade.default,
	  rootClose: false,
	  show: false,
	  placement: 'top'
	};
	
	function wrapRefs(props, arrowProps) {
	  var ref = props.ref;
	  var aRef = arrowProps.ref;
	
	  props.ref = ref.__wrapped || (ref.__wrapped = function (r) {
	    return ref((0, _safeFindDOMNode.default)(r));
	  });
	
	  arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = function (r) {
	    return aRef((0, _safeFindDOMNode.default)(r));
	  });
	}
	
	function Overlay(_ref) {
	  var overlay = _ref.children,
	      transition = _ref.transition,
	      _ref$popperConfig = _ref.popperConfig,
	      popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig,
	      outerProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var popperRef = (0, _react.useRef)({});
	
	  var _usePopperMarginModif = (0, _usePopperMarginModifiers.default)(),
	      ref = _usePopperMarginModif[0],
	      marginModifiers = _usePopperMarginModif[1];
	
	  var actualTransition = transition === true ? _Fade.default : transition || null;
	  return /*#__PURE__*/_react.default.createElement(_Overlay.default, (0, _extends2.default)({}, outerProps, {
	    ref: ref,
	    popperConfig: (0, _extends2.default)({}, popperConfig, {
	      modifiers: marginModifiers.concat(popperConfig.modifiers || [])
	    }),
	    transition: actualTransition
	  }), function (_ref2) {
	    var _state$modifiersData$;
	
	    var overlayProps = _ref2.props,
	        arrowProps = _ref2.arrowProps,
	        show = _ref2.show,
	        update = _ref2.update,
	        _ = _ref2.forceUpdate,
	        placement = _ref2.placement,
	        state = _ref2.state,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_ref2, _excluded2);
	    wrapRefs(overlayProps, arrowProps);
	    var popper = Object.assign(popperRef.current, {
	      state: state,
	      scheduleUpdate: update,
	      placement: placement,
	      outOfBoundaries: (state == null ? void 0 : (_state$modifiersData$ = state.modifiersData.hide) == null ? void 0 : _state$modifiersData$.isReferenceHidden) || false
	    });
	    if (typeof overlay === 'function') return overlay((0, _extends2.default)({}, props, overlayProps, {
	      placement: placement,
	      show: show
	    }, !transition && show && {
	      className: 'show'
	    }, {
	      popper: popper,
	      arrowProps: arrowProps
	    }));
	    return /*#__PURE__*/_react.default.cloneElement(overlay, (0, _extends2.default)({}, props, overlayProps, {
	      placement: placement,
	      arrowProps: arrowProps,
	      popper: popper,
	      className: (0, _classnames.default)(overlay.props.className, !transition && show && 'show'),
	      style: (0, _extends2.default)({}, overlay.props.style, overlayProps.style)
	    }));
	  });
	}
	
	Overlay.defaultProps = defaultProps;
	var _default = Overlay;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.Last = exports.Next = exports.Ellipsis = exports.Prev = exports.First = exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(35));
	
	var _excluded = ["active", "disabled", "className", "style", "activeLabel", "children"],
	    _excluded2 = ["children"];
	var defaultProps = {
	  active: false,
	  disabled: false,
	  activeLabel: '(current)'
	};
	
	var PageItem = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var active = _ref.active,
	      disabled = _ref.disabled,
	      className = _ref.className,
	      style = _ref.style,
	      activeLabel = _ref.activeLabel,
	      children = _ref.children,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var Component = active || disabled ? 'span' : _SafeAnchor.default;
	  return /*#__PURE__*/_react.default.createElement("li", {
	    ref: ref,
	    style: style,
	    className: (0, _classnames.default)(className, 'page-item', {
	      active: active,
	      disabled: disabled
	    })
	  }, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    className: "page-link",
	    disabled: disabled
	  }, props), children, active && activeLabel && /*#__PURE__*/_react.default.createElement("span", {
	    className: "sr-only"
	  }, activeLabel)));
	});
	
	PageItem.defaultProps = defaultProps;
	PageItem.displayName = 'PageItem';
	var _default = PageItem;
	exports.default = _default;
	
	function createButton(name, defaultValue, label) {
	  if (label === void 0) {
	    label = name;
	  }
	
	  function Button(_ref2) {
	    var children = _ref2.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_ref2, _excluded2);
	    return /*#__PURE__*/_react.default.createElement(PageItem, props, /*#__PURE__*/_react.default.createElement("span", {
	      "aria-hidden": "true"
	    }, children || defaultValue), /*#__PURE__*/_react.default.createElement("span", {
	      className: "sr-only"
	    }, label));
	  }
	
	  Button.displayName = name;
	  return Button;
	}
	
	var First = createButton('First', '«');
	exports.First = First;
	var Prev = createButton('Prev', '‹', 'Previous');
	exports.Prev = Prev;
	var Ellipsis = createButton('Ellipsis', '…', 'More');
	exports.Ellipsis = Ellipsis;
	var Next = createButton('Next', '›');
	exports.Next = Next;
	var Last = createButton('Last', '»');
	exports.Last = Last;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["as", "bsPrefix", "className", "children"];
	
	var PopoverContent = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      children = _ref.children,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'popover-body');
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(className, bsPrefix)
	  }), children);
	});
	
	var _default = PopoverContent;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["as", "bsPrefix", "className", "children"];
	
	var PopoverTitle = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      children = _ref.children,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'popover-header');
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(bsPrefix, className)
	  }), children);
	});
	
	var _default = PopoverTitle;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var _default = (0, _createWithBsPrefix.default)('toast-body');
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var ToastContext = /*#__PURE__*/_react.default.createContext({
	  // eslint-disable-next-line @typescript-eslint/no-empty-function
	  onClose: function onClose() {}
	});
	
	var _default = ToastContext;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(18));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _CloseButton = _interopRequireDefault(__webpack_require__(76));
	
	var _ToastContext = _interopRequireDefault(__webpack_require__(250));
	
	var _excluded = ["bsPrefix", "closeLabel", "closeButton", "className", "children"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var defaultProps = {
	  closeLabel: 'Close',
	  closeButton: true
	};
	
	var ToastHeader = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      closeLabel = _ref.closeLabel,
	      closeButton = _ref.closeButton,
	      className = _ref.className,
	      children = _ref.children,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'toast-header');
	  var context = (0, _react.useContext)(_ToastContext.default);
	  var handleClick = (0, _useEventCallback.default)(function (e) {
	    if (context && context.onClose) {
	      context.onClose(e);
	    }
	  });
	  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(bsPrefix, className)
	  }), children, closeButton && /*#__PURE__*/_react.default.createElement(_CloseButton.default, {
	    label: closeLabel,
	    onClick: handleClick,
	    className: "ml-2 mb-1",
	    "data-dismiss": "toast"
	  }));
	});
	
	ToastHeader.displayName = 'ToastHeader';
	ToastHeader.defaultProps = defaultProps;
	var _default = ToastHeader;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _Button = _interopRequireDefault(__webpack_require__(75));
	
	var _excluded = ["children", "name", "className", "checked", "type", "onChange", "value", "disabled", "inputRef"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var noop = function noop() {
	  return undefined;
	};
	
	var ToggleButton = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var children = _ref.children,
	      name = _ref.name,
	      className = _ref.className,
	      checked = _ref.checked,
	      type = _ref.type,
	      onChange = _ref.onChange,
	      value = _ref.value,
	      disabled = _ref.disabled,
	      inputRef = _ref.inputRef,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	
	  var _useState = (0, _react.useState)(false),
	      focused = _useState[0],
	      setFocused = _useState[1];
	
	  var handleFocus = (0, _react.useCallback)(function (e) {
	    if (e.target.tagName === 'INPUT') setFocused(true);
	  }, []);
	  var handleBlur = (0, _react.useCallback)(function (e) {
	    if (e.target.tagName === 'INPUT') setFocused(false);
	  }, []);
	  return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(className, focused && 'focus', disabled && 'disabled'),
	    type: undefined,
	    active: !!checked,
	    as: "label"
	  }), /*#__PURE__*/_react.default.createElement("input", {
	    name: name,
	    type: type,
	    value: value,
	    ref: inputRef,
	    autoComplete: "off",
	    checked: !!checked,
	    disabled: !!disabled,
	    onFocus: handleFocus,
	    onBlur: handleBlur,
	    onChange: onChange || noop
	  }), children);
	});
	
	ToggleButton.displayName = 'ToggleButton';
	var _default = ToggleButton;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.useAccordionToggle = exports.Tooltip = exports.ToggleButtonGroup = exports.ToggleButton = exports.ToastHeader = exports.ToastBody = exports.Toast = exports.ThemeProvider = exports.Tabs = exports.TabPane = exports.Table = exports.TabContent = exports.TabContainer = exports.Tab = exports.SplitButton = exports.Spinner = exports.SafeAnchor = exports.Row = exports.ResponsiveEmbed = exports.ProgressBar = exports.PopoverContent = exports.PopoverTitle = exports.Popover = exports.Pagination = exports.PageItem = exports.OverlayTrigger = exports.Overlay = exports.NavLink = exports.NavItem = exports.NavDropdown = exports.NavbarBrand = exports.Navbar = exports.Nav = exports.ModalTitle = exports.ModalFooter = exports.ModalDialog = exports.ModalBody = exports.Modal = exports.Media = exports.ListGroupItem = exports.ListGroup = exports.Jumbotron = exports.InputGroup = exports.Figure = exports.Image = exports.Container = exports.FormText = exports.FormLabel = exports.FormGroup = exports.FormFile = exports.FormCheck = exports.FormControl = exports.Form = exports.Fade = exports.DropdownButton = exports.Dropdown = exports.Collapse = exports.Col = exports.CloseButton = exports.CarouselItem = exports.Carousel = exports.CardGroup = exports.CardImg = exports.CardDeck = exports.CardColumns = exports.Card = exports.ButtonToolbar = exports.ButtonGroup = exports.Button = exports.BreadcrumbItem = exports.Breadcrumb = exports.Badge = exports.Alert = exports.AccordionToggle = exports.AccordionCollapse = exports.AccordionContext = exports.Accordion = void 0;
	
	var _Accordion = _interopRequireDefault(__webpack_require__(507));
	
	exports.Accordion = _Accordion.default;
	
	var _AccordionContext = _interopRequireDefault(__webpack_require__(74));
	
	exports.AccordionContext = _AccordionContext.default;
	
	var _AccordionCollapse = _interopRequireDefault(__webpack_require__(223));
	
	exports.AccordionCollapse = _AccordionCollapse.default;
	
	var _AccordionToggle = _interopRequireWildcard(__webpack_require__(224));
	
	exports.AccordionToggle = _AccordionToggle.default;
	exports.useAccordionToggle = _AccordionToggle.useAccordionToggle;
	
	var _Alert = _interopRequireDefault(__webpack_require__(508));
	
	exports.Alert = _Alert.default;
	
	var _Badge = _interopRequireDefault(__webpack_require__(509));
	
	exports.Badge = _Badge.default;
	
	var _Breadcrumb = _interopRequireDefault(__webpack_require__(511));
	
	exports.Breadcrumb = _Breadcrumb.default;
	
	var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(225));
	
	exports.BreadcrumbItem = _BreadcrumbItem.default;
	
	var _Button = _interopRequireDefault(__webpack_require__(75));
	
	exports.Button = _Button.default;
	
	var _ButtonGroup = _interopRequireDefault(__webpack_require__(116));
	
	exports.ButtonGroup = _ButtonGroup.default;
	
	var _ButtonToolbar = _interopRequireDefault(__webpack_require__(512));
	
	exports.ButtonToolbar = _ButtonToolbar.default;
	
	var _Card = _interopRequireDefault(__webpack_require__(513));
	
	exports.Card = _Card.default;
	
	var _CardColumns = _interopRequireDefault(__webpack_require__(514));
	
	exports.CardColumns = _CardColumns.default;
	
	var _CardDeck = _interopRequireDefault(__webpack_require__(515));
	
	exports.CardDeck = _CardDeck.default;
	
	var _CardImg = _interopRequireDefault(__webpack_require__(227));
	
	exports.CardImg = _CardImg.default;
	
	var _CardGroup = _interopRequireDefault(__webpack_require__(516));
	
	exports.CardGroup = _CardGroup.default;
	
	var _Carousel = _interopRequireDefault(__webpack_require__(517));
	
	exports.Carousel = _Carousel.default;
	
	var _CarouselItem = _interopRequireDefault(__webpack_require__(228));
	
	exports.CarouselItem = _CarouselItem.default;
	
	var _CloseButton = _interopRequireDefault(__webpack_require__(76));
	
	exports.CloseButton = _CloseButton.default;
	
	var _Col = _interopRequireDefault(__webpack_require__(229));
	
	exports.Col = _Col.default;
	
	var _Collapse = _interopRequireDefault(__webpack_require__(117));
	
	exports.Collapse = _Collapse.default;
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(77));
	
	exports.Dropdown = _Dropdown.default;
	
	var _DropdownButton = _interopRequireDefault(__webpack_require__(520));
	
	exports.DropdownButton = _DropdownButton.default;
	
	var _Fade = _interopRequireDefault(__webpack_require__(43));
	
	exports.Fade = _Fade.default;
	
	var _Form = _interopRequireDefault(__webpack_require__(525));
	
	exports.Form = _Form.default;
	
	var _FormControl = _interopRequireDefault(__webpack_require__(231));
	
	exports.FormControl = _FormControl.default;
	
	var _FormCheck = _interopRequireDefault(__webpack_require__(120));
	
	exports.FormCheck = _FormCheck.default;
	
	var _FormFile = _interopRequireDefault(__webpack_require__(232));
	
	exports.FormFile = _FormFile.default;
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(233));
	
	exports.FormGroup = _FormGroup.default;
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(234));
	
	exports.FormLabel = _FormLabel.default;
	
	var _FormText = _interopRequireDefault(__webpack_require__(235));
	
	exports.FormText = _FormText.default;
	
	var _Container = _interopRequireDefault(__webpack_require__(519));
	
	exports.Container = _Container.default;
	
	var _Image = _interopRequireDefault(__webpack_require__(236));
	
	exports.Image = _Image.default;
	
	var _Figure = _interopRequireDefault(__webpack_require__(522));
	
	exports.Figure = _Figure.default;
	
	var _InputGroup = _interopRequireDefault(__webpack_require__(530));
	
	exports.InputGroup = _InputGroup.default;
	
	var _Jumbotron = _interopRequireDefault(__webpack_require__(531));
	
	exports.Jumbotron = _Jumbotron.default;
	
	var _ListGroup = _interopRequireDefault(__webpack_require__(532));
	
	exports.ListGroup = _ListGroup.default;
	
	var _ListGroupItem = _interopRequireDefault(__webpack_require__(237));
	
	exports.ListGroupItem = _ListGroupItem.default;
	
	var _Media = _interopRequireDefault(__webpack_require__(533));
	
	exports.Media = _Media.default;
	
	var _Modal = _interopRequireDefault(__webpack_require__(534));
	
	exports.Modal = _Modal.default;
	
	var _ModalBody = _interopRequireDefault(__webpack_require__(238));
	
	exports.ModalBody = _ModalBody.default;
	
	var _ModalDialog = _interopRequireDefault(__webpack_require__(240));
	
	exports.ModalDialog = _ModalDialog.default;
	
	var _ModalFooter = _interopRequireDefault(__webpack_require__(241));
	
	exports.ModalFooter = _ModalFooter.default;
	
	var _ModalTitle = _interopRequireDefault(__webpack_require__(242));
	
	exports.ModalTitle = _ModalTitle.default;
	
	var _Nav = _interopRequireDefault(__webpack_require__(243));
	
	exports.Nav = _Nav.default;
	
	var _Navbar = _interopRequireDefault(__webpack_require__(537));
	
	exports.Navbar = _Navbar.default;
	
	var _NavbarBrand = _interopRequireDefault(__webpack_require__(244));
	
	exports.NavbarBrand = _NavbarBrand.default;
	
	var _NavDropdown = _interopRequireDefault(__webpack_require__(536));
	
	exports.NavDropdown = _NavDropdown.default;
	
	var _NavItem = _interopRequireDefault(__webpack_require__(122));
	
	exports.NavItem = _NavItem.default;
	
	var _NavLink = _interopRequireDefault(__webpack_require__(79));
	
	exports.NavLink = _NavLink.default;
	
	var _Overlay = _interopRequireDefault(__webpack_require__(245));
	
	exports.Overlay = _Overlay.default;
	
	var _OverlayTrigger = _interopRequireDefault(__webpack_require__(540));
	
	exports.OverlayTrigger = _OverlayTrigger.default;
	
	var _PageItem = _interopRequireDefault(__webpack_require__(246));
	
	exports.PageItem = _PageItem.default;
	
	var _Pagination = _interopRequireDefault(__webpack_require__(541));
	
	exports.Pagination = _Pagination.default;
	
	var _Popover = _interopRequireDefault(__webpack_require__(542));
	
	exports.Popover = _Popover.default;
	
	var _PopoverTitle = _interopRequireDefault(__webpack_require__(248));
	
	exports.PopoverTitle = _PopoverTitle.default;
	
	var _PopoverContent = _interopRequireDefault(__webpack_require__(247));
	
	exports.PopoverContent = _PopoverContent.default;
	
	var _ProgressBar = _interopRequireDefault(__webpack_require__(543));
	
	exports.ProgressBar = _ProgressBar.default;
	
	var _ResponsiveEmbed = _interopRequireDefault(__webpack_require__(544));
	
	exports.ResponsiveEmbed = _ResponsiveEmbed.default;
	
	var _Row = _interopRequireDefault(__webpack_require__(545));
	
	exports.Row = _Row.default;
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(35));
	
	exports.SafeAnchor = _SafeAnchor.default;
	
	var _Spinner = _interopRequireDefault(__webpack_require__(546));
	
	exports.Spinner = _Spinner.default;
	
	var _SplitButton = _interopRequireDefault(__webpack_require__(547));
	
	exports.SplitButton = _SplitButton.default;
	
	var _Tab = _interopRequireDefault(__webpack_require__(549));
	
	exports.Tab = _Tab.default;
	
	var _TabContainer = _interopRequireDefault(__webpack_require__(123));
	
	exports.TabContainer = _TabContainer.default;
	
	var _TabContent = _interopRequireDefault(__webpack_require__(124));
	
	exports.TabContent = _TabContent.default;
	
	var _Table = _interopRequireDefault(__webpack_require__(550));
	
	exports.Table = _Table.default;
	
	var _TabPane = _interopRequireDefault(__webpack_require__(126));
	
	exports.TabPane = _TabPane.default;
	
	var _Tabs = _interopRequireDefault(__webpack_require__(551));
	
	exports.Tabs = _Tabs.default;
	
	var _ThemeProvider = _interopRequireDefault(__webpack_require__(6));
	
	exports.ThemeProvider = _ThemeProvider.default;
	
	var _Toast = _interopRequireDefault(__webpack_require__(552));
	
	exports.Toast = _Toast.default;
	
	var _ToastBody = _interopRequireDefault(__webpack_require__(249));
	
	exports.ToastBody = _ToastBody.default;
	
	var _ToastHeader = _interopRequireDefault(__webpack_require__(251));
	
	exports.ToastHeader = _ToastHeader.default;
	
	var _ToggleButton = _interopRequireDefault(__webpack_require__(252));
	
	exports.ToggleButton = _ToggleButton.default;
	
	var _ToggleButtonGroup = _interopRequireDefault(__webpack_require__(553));
	
	exports.ToggleButtonGroup = _ToggleButtonGroup.default;
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(554));
	
	exports.Tooltip = _Tooltip.default;
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = usePopperMarginModifiers;
	
	var _react = __webpack_require__(2);
	
	var _hasClass = _interopRequireDefault(__webpack_require__(181));
	
	var _ThemeProvider = __webpack_require__(6);
	
	function getMargins(element) {
	  var styles = window.getComputedStyle(element);
	  var top = parseFloat(styles.marginTop) || 0;
	  var right = parseFloat(styles.marginRight) || 0;
	  var bottom = parseFloat(styles.marginBottom) || 0;
	  var left = parseFloat(styles.marginLeft) || 0;
	  return {
	    top: top,
	    right: right,
	    bottom: bottom,
	    left: left
	  };
	}
	
	function usePopperMarginModifiers() {
	  var overlayRef = (0, _react.useRef)(null);
	  var margins = (0, _react.useRef)(null);
	  var arrowMargins = (0, _react.useRef)(null);
	  var popoverClass = (0, _ThemeProvider.useBootstrapPrefix)(undefined, 'popover');
	  var dropdownMenuClass = (0, _ThemeProvider.useBootstrapPrefix)(undefined, 'dropdown-menu');
	  var callback = (0, _react.useCallback)(function (overlay) {
	    if (!overlay || !((0, _hasClass.default)(overlay, popoverClass) || (0, _hasClass.default)(overlay, dropdownMenuClass))) return;
	    margins.current = getMargins(overlay);
	    overlay.style.margin = '0';
	    overlayRef.current = overlay;
	  }, [popoverClass, dropdownMenuClass]);
	  var offset = (0, _react.useMemo)(function () {
	    return {
	      name: 'offset',
	      options: {
	        offset: function offset(_ref) {
	          var placement = _ref.placement;
	          if (!margins.current) return [0, 0];
	          var _margins$current = margins.current,
	              top = _margins$current.top,
	              left = _margins$current.left,
	              bottom = _margins$current.bottom,
	              right = _margins$current.right;
	
	          switch (placement.split('-')[0]) {
	            case 'top':
	              return [0, bottom];
	
	            case 'left':
	              return [0, right];
	
	            case 'bottom':
	              return [0, top];
	
	            case 'right':
	              return [0, left];
	
	            default:
	              return [0, 0];
	          }
	        }
	      }
	    };
	  }, [margins]);
	  var arrow = (0, _react.useMemo)(function () {
	    return {
	      name: 'arrow',
	      options: {
	        padding: function padding() {
	          // The options here are used for Popper 2.8.4 and up.
	          // For earlier version, padding is handled in popoverArrowMargins below.
	          if (!arrowMargins.current) {
	            return 0;
	          }
	
	          var _arrowMargins$current = arrowMargins.current,
	              top = _arrowMargins$current.top,
	              right = _arrowMargins$current.right;
	          var padding = top || right;
	          return {
	            top: padding,
	            left: padding,
	            right: padding,
	            bottom: padding
	          };
	        }
	      }
	    };
	  }, [arrowMargins]); // Converts popover arrow margin to arrow modifier padding
	
	  var popoverArrowMargins = (0, _react.useMemo)(function () {
	    return {
	      name: 'popoverArrowMargins',
	      enabled: true,
	      phase: 'main',
	      requiresIfExists: ['arrow'],
	      effect: function effect(_ref2) {
	        var state = _ref2.state;
	
	        if (!overlayRef.current || !state.elements.arrow || !(0, _hasClass.default)(overlayRef.current, popoverClass)) {
	          return undefined;
	        }
	
	        if (state.modifiersData['arrow#persistent']) {
	          // @popperjs/core <= 2.8.3 uses arrow#persistent to pass padding to arrow modifier.
	          var _getMargins = getMargins(state.elements.arrow),
	              top = _getMargins.top,
	              right = _getMargins.right;
	
	          var padding = top || right;
	          state.modifiersData['arrow#persistent'].padding = {
	            top: padding,
	            left: padding,
	            right: padding,
	            bottom: padding
	          };
	        } else {
	          // @popperjs/core >= 2.8.4 gets the padding from the arrow modifier options,
	          // so we'll get the margins here, and let the arrow modifier above pass
	          // it to popper.
	          arrowMargins.current = getMargins(state.elements.arrow);
	        }
	
	        state.elements.arrow.style.margin = '0';
	        return function () {
	          if (state.elements.arrow) state.elements.arrow.style.margin = '';
	        };
	      }
	    };
	  }, [popoverClass]);
	  return [callback, [offset, arrow, popoverArrowMargins]];
	}
	
	module.exports = exports["default"];

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = useWrappedRefWithWarning;
	
	var _invariant = _interopRequireDefault(__webpack_require__(70));
	
	var _react = __webpack_require__(2);
	
	var _useMergedRefs = _interopRequireDefault(__webpack_require__(47));
	
	function useWrappedRefWithWarning(ref, componentName) {
	  // @ts-ignore
	  if (true) return ref; // eslint-disable-next-line react-hooks/rules-of-hooks
	
	  var warningRef = (0, _react.useCallback)(function (refValue) {
	    !(refValue == null || !refValue.isReactComponent) ?  false ? (0, _invariant.default)(false, componentName + " injected a ref to a provided `as` component that resolved to a component instance instead of a DOM element. " + 'Use `React.forwardRef` to provide the injected ref to the class component as a prop in order to pass it directly to a DOM element') : invariant(false) : void 0;
	  }, [componentName]); // eslint-disable-next-line react-hooks/rules-of-hooks
	
	  return (0, _useMergedRefs.default)(warningRef, ref);
	}
	
	module.exports = exports["default"];

/***/ },
/* 256 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	exports.assertNodeList = assertNodeList;
	exports.setElement = setElement;
	exports.validateElement = validateElement;
	exports.hide = hide;
	exports.show = show;
	exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _safeHTMLElement = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalElement = null;
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function resetState() {
	  if (globalElement) {
	    if (globalElement.removeAttribute) {
	      globalElement.removeAttribute("aria-hidden");
	    } else if (globalElement.length != null) {
	      globalElement.forEach(function (element) {
	        return element.removeAttribute("aria-hidden");
	      });
	    } else {
	      document.querySelectorAll(globalElement).forEach(function (element) {
	        return element.removeAttribute("aria-hidden");
	      });
	    }
	  }
	  globalElement = null;
	}
	
	/* istanbul ignore next */
	function log() {
	  if (true) return;
	  var check = globalElement || {};
	  console.log("ariaAppHider ----------");
	  console.log(check.nodeName, check.className, check.id);
	  console.log("end ariaAppHider ----------");
	}
	/* eslint-enable no-console */
	
	function assertNodeList(nodeList, selector) {
	  if (!nodeList || !nodeList.length) {
	    throw new Error("react-modal: No elements were found for selector " + selector + ".");
	  }
	}
	
	function setElement(element) {
	  var useElement = element;
	  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
	    var el = document.querySelectorAll(useElement);
	    assertNodeList(el, useElement);
	    useElement = el;
	  }
	  globalElement = useElement || globalElement;
	  return globalElement;
	}
	
	function validateElement(appElement) {
	  var el = appElement || globalElement;
	  if (el) {
	    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
	  } else {
	    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
	
	    return [];
	  }
	}
	
	function hide(appElement) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var el = _step.value;
	
	      el.setAttribute("aria-hidden", "true");
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	}
	
	function show(appElement) {
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var el = _step2.value;
	
	      el.removeAttribute("aria-hidden");
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	}
	
	function documentNotReadyOrSSRTesting() {
	  globalElement = null;
	}

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.log = log;
	exports.resetState = resetState;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Tracks portals that are open and emits events to subscribers
	
	var PortalOpenInstances = function PortalOpenInstances() {
	  var _this = this;
	
	  _classCallCheck(this, PortalOpenInstances);
	
	  this.register = function (openInstance) {
	    if (_this.openInstances.indexOf(openInstance) !== -1) {
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn("React-Modal: Cannot register modal instance that's already open");
	      }
	      return;
	    }
	    _this.openInstances.push(openInstance);
	    _this.emit("register");
	  };
	
	  this.deregister = function (openInstance) {
	    var index = _this.openInstances.indexOf(openInstance);
	    if (index === -1) {
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
	      }
	      return;
	    }
	    _this.openInstances.splice(index, 1);
	    _this.emit("deregister");
	  };
	
	  this.subscribe = function (callback) {
	    _this.subscribers.push(callback);
	  };
	
	  this.emit = function (eventType) {
	    _this.subscribers.forEach(function (subscriber) {
	      return subscriber(eventType,
	      // shallow copy to avoid accidental mutation
	      _this.openInstances.slice());
	    });
	  };
	
	  this.openInstances = [];
	  this.subscribers = [];
	};
	
	var portalOpenInstances = new PortalOpenInstances();
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function log() {
	  console.log("portalOpenInstances ----------");
	  console.log(portalOpenInstances.openInstances.length);
	  portalOpenInstances.openInstances.forEach(function (p) {
	    return console.log(p);
	  });
	  console.log("end portalOpenInstances ----------");
	}
	
	/* istanbul ignore next */
	function resetState() {
	  portalOpenInstances = new PortalOpenInstances();
	}
	/* eslint-enable no-console */
	
	exports.default = portalOpenInstances;

/***/ },
/* 259 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	var tabbableNode = /input|select|textarea|button|object/;
	
	function hidesContents(element) {
	  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
	
	  // If the node is empty, this is good enough
	  if (zeroSize && !element.innerHTML) return true;
	
	  try {
	    // Otherwise we need to check some styles
	    var style = window.getComputedStyle(element);
	    return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
	    // if 'overflow: visible' set, check if there is actually any overflow
	    element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
	  } catch (exception) {
	    // eslint-disable-next-line no-console
	    console.warn("Failed to inspect element style");
	    return false;
	  }
	}
	
	function visible(element) {
	  var parentElement = element;
	  while (parentElement) {
	    if (parentElement === document.body) break;
	    if (hidesContents(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
	}
	module.exports = exports["default"];

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(32);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.useDropdownMenu = useDropdownMenu;
	exports["default"] = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _useCallbackRef2 = _interopRequireDefault(__webpack_require__(88));
	
	var _DropdownContext = _interopRequireDefault(__webpack_require__(132));
	
	var _usePopper = _interopRequireDefault(__webpack_require__(265));
	
	var _useRootClose = _interopRequireDefault(__webpack_require__(266));
	
	var _mergeOptionsWithPopperConfig = _interopRequireDefault(__webpack_require__(263));
	
	var noop = function noop() {};
	/**
	 * @memberOf Dropdown
	 * @param {object}  options
	 * @param {boolean} options.flip Automatically adjust the menu `drop` position based on viewport edge detection
	 * @param {[number, number]} options.offset Define an offset distance between the Menu and the Toggle
	 * @param {boolean} options.show Display the menu manually, ignored in the context of a `Dropdown`
	 * @param {boolean} options.usePopper opt in/out of using PopperJS to position menus. When disabled you must position it yourself.
	 * @param {string}  options.rootCloseEvent The pointer event to listen for when determining "clicks outside" the menu for triggering a close.
	 * @param {object}  options.popperConfig Options passed to the [`usePopper`](/api/usePopper) hook.
	 */
	
	
	function useDropdownMenu(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var context = (0, _react.useContext)(_DropdownContext["default"]);
	
	  var _useCallbackRef = (0, _useCallbackRef2["default"])(),
	      arrowElement = _useCallbackRef[0],
	      attachArrowRef = _useCallbackRef[1];
	
	  var hasShownRef = (0, _react.useRef)(false);
	  var _options = options,
	      flip = _options.flip,
	      offset = _options.offset,
	      rootCloseEvent = _options.rootCloseEvent,
	      _options$fixed = _options.fixed,
	      fixed = _options$fixed === void 0 ? false : _options$fixed,
	      _options$popperConfig = _options.popperConfig,
	      popperConfig = _options$popperConfig === void 0 ? {} : _options$popperConfig,
	      _options$usePopper = _options.usePopper,
	      shouldUsePopper = _options$usePopper === void 0 ? !!context : _options$usePopper;
	  var show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
	  var alignEnd = (context == null ? void 0 : context.alignEnd) == null ? options.alignEnd : context.alignEnd;
	
	  if (show && !hasShownRef.current) {
	    hasShownRef.current = true;
	  }
	
	  var handleClose = function handleClose(e) {
	    context == null ? void 0 : context.toggle(false, e);
	  };
	
	  var _ref = context || {},
	      drop = _ref.drop,
	      setMenu = _ref.setMenu,
	      menuElement = _ref.menuElement,
	      toggleElement = _ref.toggleElement;
	
	  var placement = alignEnd ? 'bottom-end' : 'bottom-start';
	  if (drop === 'up') placement = alignEnd ? 'top-end' : 'top-start';else if (drop === 'right') placement = alignEnd ? 'right-end' : 'right-start';else if (drop === 'left') placement = alignEnd ? 'left-end' : 'left-start';
	  var popper = (0, _usePopper["default"])(toggleElement, menuElement, (0, _mergeOptionsWithPopperConfig["default"])({
	    placement: placement,
	    enabled: !!(shouldUsePopper && show),
	    enableEvents: show,
	    offset: offset,
	    flip: flip,
	    fixed: fixed,
	    arrowElement: arrowElement,
	    popperConfig: popperConfig
	  }));
	  var menuProps = (0, _extends2["default"])({
	    ref: setMenu || noop,
	    'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
	  }, popper.attributes.popper, {
	    style: popper.styles.popper
	  });
	  var metadata = {
	    show: show,
	    alignEnd: alignEnd,
	    hasShown: hasShownRef.current,
	    toggle: context == null ? void 0 : context.toggle,
	    popper: shouldUsePopper ? popper : null,
	    arrowProps: shouldUsePopper ? (0, _extends2["default"])({
	      ref: attachArrowRef
	    }, popper.attributes.arrow, {
	      style: popper.styles.arrow
	    }) : {}
	  };
	  (0, _useRootClose["default"])(menuElement, handleClose, {
	    clickTrigger: rootCloseEvent,
	    disabled: !show
	  });
	  return [menuProps, metadata];
	}
	
	var propTypes = {
	  /**
	   * A render prop that returns a Menu element. The `props`
	   * argument should spread through to **a component that can accept a ref**.
	   *
	   * @type {Function ({
	   *   show: boolean,
	   *   alignEnd: boolean,
	   *   close: (?SyntheticEvent) => void,
	   *   placement: Placement,
	   *   update: () => void,
	   *   forceUpdate: () => void,
	   *   props: {
	   *     ref: (?HTMLElement) => void,
	   *     style: { [string]: string | number },
	   *     aria-labelledby: ?string
	   *   },
	   *   arrowProps: {
	   *     ref: (?HTMLElement) => void,
	   *     style: { [string]: string | number },
	   *   },
	   * }) => React.Element}
	   */
	  children: _propTypes["default"].func.isRequired,
	
	  /**
	   * Controls the visible state of the menu, generally this is
	   * provided by the parent `Dropdown` component,
	   * but may also be specified as a prop directly.
	   */
	  show: _propTypes["default"].bool,
	
	  /**
	   * Aligns the dropdown menu to the 'end' of it's placement position.
	   * Generally this is provided by the parent `Dropdown` component,
	   * but may also be specified as a prop directly.
	   */
	  alignEnd: _propTypes["default"].bool,
	
	  /**
	   * Enables the Popper.js `flip` modifier, allowing the Dropdown to
	   * automatically adjust it's placement in case of overlap with the viewport or toggle.
	   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
	   */
	  flip: _propTypes["default"].bool,
	  usePopper: _propTypes["default"].oneOf([true, false]),
	
	  /**
	   * A set of popper options and props passed directly to react-popper's Popper component.
	   */
	  popperConfig: _propTypes["default"].object,
	
	  /**
	   * Override the default event used by RootCloseWrapper.
	   */
	  rootCloseEvent: _propTypes["default"].string
	};
	var defaultProps = {
	  usePopper: true
	};
	
	/**
	 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
	 *
	 * @displayName DropdownMenu
	 * @memberOf Dropdown
	 */
	function DropdownMenu(_ref2) {
	  var children = _ref2.children,
	      options = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["children"]);
	
	  var _useDropdownMenu = useDropdownMenu(options),
	      props = _useDropdownMenu[0],
	      meta = _useDropdownMenu[1];
	
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, meta.hasShown ? children(props, meta) : null);
	}
	
	DropdownMenu.displayName = 'ReactOverlaysDropdownMenu';
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	/** @component */
	
	var _default = DropdownMenu;
	exports["default"] = _default;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(32);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.useDropdownToggle = useDropdownToggle;
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _DropdownContext = _interopRequireDefault(__webpack_require__(132));
	
	var noop = function noop() {};
	/**
	 * Wires up Dropdown toggle functionality, returning a set a props to attach
	 * to the element that functions as the dropdown toggle (generally a button).
	 *
	 * @memberOf Dropdown
	 */
	
	
	function useDropdownToggle() {
	  var _ref = (0, _react.useContext)(_DropdownContext["default"]) || {},
	      _ref$show = _ref.show,
	      show = _ref$show === void 0 ? false : _ref$show,
	      _ref$toggle = _ref.toggle,
	      toggle = _ref$toggle === void 0 ? noop : _ref$toggle,
	      setToggle = _ref.setToggle;
	
	  var handleClick = (0, _react.useCallback)(function (e) {
	    toggle(!show, e);
	  }, [show, toggle]);
	  return [{
	    ref: setToggle || noop,
	    onClick: handleClick,
	    'aria-haspopup': true,
	    'aria-expanded': !!show
	  }, {
	    show: show,
	    toggle: toggle
	  }];
	}
	
	var propTypes = {
	  /**
	   * A render prop that returns a Toggle element. The `props`
	   * argument should spread through to **a component that can accept a ref**. Use
	   * the `onToggle` argument to toggle the menu open or closed
	   *
	   * @type {Function ({
	   *   show: boolean,
	   *   toggle: (show: boolean) => void,
	   *   props: {
	   *     ref: (?HTMLElement) => void,
	   *     aria-haspopup: true
	   *     aria-expanded: boolean
	   *   },
	   * }) => React.Element}
	   */
	  children: _propTypes["default"].func.isRequired
	};
	
	/**
	 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
	 *
	 * @displayName DropdownToggle
	 * @memberOf Dropdown
	 */
	function DropdownToggle(_ref2) {
	  var children = _ref2.children;
	
	  var _useDropdownToggle = useDropdownToggle(),
	      props = _useDropdownToggle[0],
	      meta = _useDropdownToggle[1];
	
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children(props, meta));
	}
	
	DropdownToggle.displayName = 'ReactOverlaysDropdownToggle';
	DropdownToggle.propTypes = propTypes;
	/** @component */
	
	var _default = DropdownToggle;
	exports["default"] = _default;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(430));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(440));
	
	var _css = _interopRequireDefault(__webpack_require__(50));
	
	var _scrollbarSize = _interopRequireDefault(__webpack_require__(100));
	
	var _isOverflowing = _interopRequireDefault(__webpack_require__(568));
	
	var _manageAriaHidden = __webpack_require__(569);
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	
	    return false;
	  });
	  return idx;
	}
	
	/**
	 * Proper state management for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	var ModalManager = /*#__PURE__*/function () {
	  function ModalManager(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        _ref$hideSiblingNodes = _ref.hideSiblingNodes,
	        hideSiblingNodes = _ref$hideSiblingNodes === void 0 ? true : _ref$hideSiblingNodes,
	        _ref$handleContainerO = _ref.handleContainerOverflow,
	        handleContainerOverflow = _ref$handleContainerO === void 0 ? true : _ref$handleContainerO;
	
	    this.hideSiblingNodes = void 0;
	    this.handleContainerOverflow = void 0;
	    this.modals = void 0;
	    this.containers = void 0;
	    this.data = void 0;
	    this.scrollbarSize = void 0;
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.handleContainerOverflow = handleContainerOverflow;
	    this.modals = [];
	    this.containers = [];
	    this.data = [];
	    this.scrollbarSize = (0, _scrollbarSize["default"])();
	  }
	
	  var _proto = ModalManager.prototype;
	
	  _proto.isContainerOverflowing = function isContainerOverflowing(modal) {
	    var data = this.data[this.containerIndexFromModal(modal)];
	    return data && data.overflowing;
	  };
	
	  _proto.containerIndexFromModal = function containerIndexFromModal(modal) {
	    return findIndexOf(this.data, function (d) {
	      return d.modals.indexOf(modal) !== -1;
	    });
	  };
	
	  _proto.setContainerStyle = function setContainerStyle(containerState, container) {
	    var style = {
	      overflow: 'hidden'
	    }; // we are only interested in the actual `style` here
	    // because we will override it
	
	    containerState.style = {
	      overflow: container.style.overflow,
	      paddingRight: container.style.paddingRight
	    };
	
	    if (containerState.overflowing) {
	      // use computed style, here to get the real padding
	      // to add our scrollbar width
	      style.paddingRight = parseInt((0, _css["default"])(container, 'paddingRight') || '0', 10) + this.scrollbarSize + "px";
	    }
	
	    (0, _css["default"])(container, style);
	  };
	
	  _proto.removeContainerStyle = function removeContainerStyle(containerState, container) {
	    Object.assign(container.style, containerState.style);
	  };
	
	  _proto.add = function add(modal, container, className) {
	    var modalIdx = this.modals.indexOf(modal);
	    var containerIdx = this.containers.indexOf(container);
	
	    if (modalIdx !== -1) {
	      return modalIdx;
	    }
	
	    modalIdx = this.modals.length;
	    this.modals.push(modal);
	
	    if (this.hideSiblingNodes) {
	      (0, _manageAriaHidden.hideSiblings)(container, modal);
	    }
	
	    if (containerIdx !== -1) {
	      this.data[containerIdx].modals.push(modal);
	      return modalIdx;
	    }
	
	    var data = {
	      modals: [modal],
	      // right now only the first modal of a container will have its classes applied
	      classes: className ? className.split(/\s+/) : [],
	      overflowing: (0, _isOverflowing["default"])(container)
	    };
	
	    if (this.handleContainerOverflow) {
	      this.setContainerStyle(data, container);
	    }
	
	    data.classes.forEach(_addClass["default"].bind(null, container));
	    this.containers.push(container);
	    this.data.push(data);
	    return modalIdx;
	  };
	
	  _proto.remove = function remove(modal) {
	    var modalIdx = this.modals.indexOf(modal);
	
	    if (modalIdx === -1) {
	      return;
	    }
	
	    var containerIdx = this.containerIndexFromModal(modal);
	    var data = this.data[containerIdx];
	    var container = this.containers[containerIdx];
	    data.modals.splice(data.modals.indexOf(modal), 1);
	    this.modals.splice(modalIdx, 1); // if that was the last modal in a container,
	    // clean up the container
	
	    if (data.modals.length === 0) {
	      data.classes.forEach(_removeClass["default"].bind(null, container));
	
	      if (this.handleContainerOverflow) {
	        this.removeContainerStyle(data, container);
	      }
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.showSiblings)(container, modal);
	      }
	
	      this.containers.splice(containerIdx, 1);
	      this.data.splice(containerIdx, 1);
	    } else if (this.hideSiblingNodes) {
	      // otherwise make sure the next top modal is visible to a SR
	      var _data$modals = data.modals[data.modals.length - 1],
	          backdrop = _data$modals.backdrop,
	          dialog = _data$modals.dialog;
	      (0, _manageAriaHidden.ariaHidden)(false, dialog);
	      (0, _manageAriaHidden.ariaHidden)(false, backdrop);
	    }
	  };
	
	  _proto.isTopModal = function isTopModal(modal) {
	    return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	  };
	
	  return ModalManager;
	}();
	
	var _default = ModalManager;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.toModifierMap = toModifierMap;
	exports.toModifierArray = toModifierArray;
	exports["default"] = mergeOptionsWithPopperConfig;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	function toModifierMap(modifiers) {
	  var result = {};
	
	  if (!Array.isArray(modifiers)) {
	    return modifiers || result;
	  } // eslint-disable-next-line no-unused-expressions
	
	
	  modifiers == null ? void 0 : modifiers.forEach(function (m) {
	    result[m.name] = m;
	  });
	  return result;
	}
	
	function toModifierArray(map) {
	  if (map === void 0) {
	    map = {};
	  }
	
	  if (Array.isArray(map)) return map;
	  return Object.keys(map).map(function (k) {
	    map[k].name = k;
	    return map[k];
	  });
	}
	
	function mergeOptionsWithPopperConfig(_ref) {
	  var _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
	
	  var enabled = _ref.enabled,
	      enableEvents = _ref.enableEvents,
	      placement = _ref.placement,
	      flip = _ref.flip,
	      offset = _ref.offset,
	      fixed = _ref.fixed,
	      containerPadding = _ref.containerPadding,
	      arrowElement = _ref.arrowElement,
	      _ref$popperConfig = _ref.popperConfig,
	      popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig;
	  var modifiers = toModifierMap(popperConfig.modifiers);
	  return (0, _extends2["default"])({}, popperConfig, {
	    placement: placement,
	    enabled: enabled,
	    strategy: fixed ? 'fixed' : popperConfig.strategy,
	    modifiers: toModifierArray((0, _extends2["default"])({}, modifiers, {
	      eventListeners: {
	        enabled: enableEvents
	      },
	      preventOverflow: (0, _extends2["default"])({}, modifiers.preventOverflow, {
	        options: containerPadding ? (0, _extends2["default"])({
	          padding: containerPadding
	        }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
	      }),
	      offset: {
	        options: (0, _extends2["default"])({
	          offset: offset
	        }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
	      },
	      arrow: (0, _extends2["default"])({}, modifiers.arrow, {
	        enabled: !!arrowElement,
	        options: (0, _extends2["default"])({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
	          element: arrowElement
	        })
	      }),
	      flip: (0, _extends2["default"])({
	        enabled: !!flip
	      }, modifiers.flip)
	    }))
	  });
	}

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var top = 'top';
	var bottom = 'bottom';
	var right = 'right';
	var left = 'left';
	var auto = 'auto';
	var basePlacements = [top, bottom, right, left];
	var start = 'start';
	var end = 'end';
	var clippingParents = 'clippingParents';
	var viewport = 'viewport';
	var popper = 'popper';
	var reference = 'reference';
	var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
	  return acc.concat([placement + "-" + start, placement + "-" + end]);
	}, []);
	var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
	  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
	}, []); // modifiers that need to read the DOM
	
	var beforeRead = 'beforeRead';
	var read = 'read';
	var afterRead = 'afterRead'; // pure-logic modifiers
	
	var beforeMain = 'beforeMain';
	var main = 'main';
	var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
	
	var beforeWrite = 'beforeWrite';
	var write = 'write';
	var afterWrite = 'afterWrite';
	var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
	
	function getBasePlacement(placement) {
	  return placement.split('-')[0];
	}
	
	function getBoundingClientRect(element) {
	  var rect = element.getBoundingClientRect();
	  return {
	    width: rect.width,
	    height: rect.height,
	    top: rect.top,
	    right: rect.right,
	    bottom: rect.bottom,
	    left: rect.left,
	    x: rect.left,
	    y: rect.top
	  };
	}
	
	// means it doesn't take into account transforms.
	
	function getLayoutRect(element) {
	  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
	  // Fixes https://github.com/popperjs/popper-core/issues/1223
	
	  var width = element.offsetWidth;
	  var height = element.offsetHeight;
	
	  if (Math.abs(clientRect.width - width) <= 0.5) {
	    width = clientRect.width;
	  }
	
	  if (Math.abs(clientRect.height - height) <= 0.5) {
	    height = clientRect.height;
	  }
	
	  return {
	    x: element.offsetLeft,
	    y: element.offsetTop,
	    width: width,
	    height: height
	  };
	}
	
	/*:: import type { Window } from '../types'; */
	
	/*:: declare function getWindow(node: Node | Window): Window; */
	function getWindow(node) {
	  if (node == null) {
	    return window;
	  }
	
	  if (node.toString() !== '[object Window]') {
	    var ownerDocument = node.ownerDocument;
	    return ownerDocument ? ownerDocument.defaultView || window : window;
	  }
	
	  return node;
	}
	
	/*:: declare function isElement(node: mixed): boolean %checks(node instanceof
	  Element); */
	
	function isElement(node) {
	  var OwnElement = getWindow(node).Element;
	  return node instanceof OwnElement || node instanceof Element;
	}
	/*:: declare function isHTMLElement(node: mixed): boolean %checks(node instanceof
	  HTMLElement); */
	
	
	function isHTMLElement(node) {
	  var OwnElement = getWindow(node).HTMLElement;
	  return node instanceof OwnElement || node instanceof HTMLElement;
	}
	/*:: declare function isShadowRoot(node: mixed): boolean %checks(node instanceof
	  ShadowRoot); */
	
	
	function isShadowRoot(node) {
	  // IE 11 has no ShadowRoot
	  if (typeof ShadowRoot === 'undefined') {
	    return false;
	  }
	
	  var OwnElement = getWindow(node).ShadowRoot;
	  return node instanceof OwnElement || node instanceof ShadowRoot;
	}
	
	function contains(parent, child) {
	  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
	
	  if (parent.contains(child)) {
	    return true;
	  } // then fallback to custom implementation with Shadow DOM support
	  else if (rootNode && isShadowRoot(rootNode)) {
	      var next = child;
	
	      do {
	        if (next && parent.isSameNode(next)) {
	          return true;
	        } // $FlowFixMe[prop-missing]: need a better way to handle this...
	
	
	        next = next.parentNode || next.host;
	      } while (next);
	    } // Give up, the result is false
	
	
	  return false;
	}
	
	function getNodeName(element) {
	  return element ? (element.nodeName || '').toLowerCase() : null;
	}
	
	function getComputedStyle(element) {
	  return getWindow(element).getComputedStyle(element);
	}
	
	function isTableElement(element) {
	  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
	}
	
	function getDocumentElement(element) {
	  // $FlowFixMe[incompatible-return]: assume body is always available
	  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
	  element.document) || window.document).documentElement;
	}
	
	function getParentNode(element) {
	  if (getNodeName(element) === 'html') {
	    return element;
	  }
	
	  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
	    // $FlowFixMe[incompatible-return]
	    // $FlowFixMe[prop-missing]
	    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
	    element.parentNode || ( // DOM Element detected
	    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
	    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
	    getDocumentElement(element) // fallback
	
	  );
	}
	
	function getTrueOffsetParent(element) {
	  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
	  getComputedStyle(element).position === 'fixed') {
	    return null;
	  }
	
	  return element.offsetParent;
	} // `.offsetParent` reports `null` for fixed elements, while absolute elements
	// return the containing block
	
	
	function getContainingBlock(element) {
	  var isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
	  var currentNode = getParentNode(element);
	
	  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
	    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
	    // create a containing block.
	    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
	
	    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].includes(css.willChange) || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
	      return currentNode;
	    } else {
	      currentNode = currentNode.parentNode;
	    }
	  }
	
	  return null;
	} // Gets the closest ancestor positioned element. Handles some edge cases,
	// such as table ancestors and cross browser bugs.
	
	
	function getOffsetParent(element) {
	  var window = getWindow(element);
	  var offsetParent = getTrueOffsetParent(element);
	
	  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
	    offsetParent = getTrueOffsetParent(offsetParent);
	  }
	
	  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
	    return window;
	  }
	
	  return offsetParent || getContainingBlock(element) || window;
	}
	
	function getMainAxisFromPlacement(placement) {
	  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
	}
	
	var max = Math.max;
	var min = Math.min;
	var round = Math.round;
	
	function within(min$1, value, max$1) {
	  return max(min$1, min(value, max$1));
	}
	
	function getFreshSideObject() {
	  return {
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0
	  };
	}
	
	function mergePaddingObject(paddingObject) {
	  return Object.assign({}, getFreshSideObject(), paddingObject);
	}
	
	function expandToHashMap(value, keys) {
	  return keys.reduce(function (hashMap, key) {
	    hashMap[key] = value;
	    return hashMap;
	  }, {});
	}
	
	var toPaddingObject = function toPaddingObject(padding, state) {
	  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
	    placement: state.placement
	  })) : padding;
	  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
	};
	
	function arrow(_ref) {
	  var _state$modifiersData$;
	
	  var state = _ref.state,
	      name = _ref.name,
	      options = _ref.options;
	  var arrowElement = state.elements.arrow;
	  var popperOffsets = state.modifiersData.popperOffsets;
	  var basePlacement = getBasePlacement(state.placement);
	  var axis = getMainAxisFromPlacement(basePlacement);
	  var isVertical = [left, right].indexOf(basePlacement) >= 0;
	  var len = isVertical ? 'height' : 'width';
	
	  if (!arrowElement || !popperOffsets) {
	    return;
	  }
	
	  var paddingObject = toPaddingObject(options.padding, state);
	  var arrowRect = getLayoutRect(arrowElement);
	  var minProp = axis === 'y' ? top : left;
	  var maxProp = axis === 'y' ? bottom : right;
	  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
	  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
	  var arrowOffsetParent = getOffsetParent(arrowElement);
	  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
	  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
	  // outside of the popper bounds
	
	  var min = paddingObject[minProp];
	  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
	  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
	  var offset = within(min, center, max); // Prevents breaking syntax highlighting...
	
	  var axisProp = axis;
	  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
	}
	
	function effect$1(_ref2) {
	  var state = _ref2.state,
	      options = _ref2.options;
	  var _options$element = options.element,
	      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
	
	  if (arrowElement == null) {
	    return;
	  } // CSS selector
	
	
	  if (typeof arrowElement === 'string') {
	    arrowElement = state.elements.popper.querySelector(arrowElement);
	
	    if (!arrowElement) {
	      return;
	    }
	  }
	
	  if (false) {
	    if (!isHTMLElement(arrowElement)) {
	      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
	    }
	  }
	
	  if (!contains(state.elements.popper, arrowElement)) {
	    if (false) {
	      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
	    }
	
	    return;
	  }
	
	  state.elements.arrow = arrowElement;
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var arrow$1 = {
	  name: 'arrow',
	  enabled: true,
	  phase: 'main',
	  fn: arrow,
	  effect: effect$1,
	  requires: ['popperOffsets'],
	  requiresIfExists: ['preventOverflow']
	};
	
	var unsetSides = {
	  top: 'auto',
	  right: 'auto',
	  bottom: 'auto',
	  left: 'auto'
	}; // Round the offsets to the nearest suitable subpixel based on the DPR.
	// Zooming can change the DPR, but it seems to report a value that will
	// cleanly divide the values into the appropriate subpixels.
	
	function roundOffsetsByDPR(_ref) {
	  var x = _ref.x,
	      y = _ref.y;
	  var win = window;
	  var dpr = win.devicePixelRatio || 1;
	  return {
	    x: round(round(x * dpr) / dpr) || 0,
	    y: round(round(y * dpr) / dpr) || 0
	  };
	}
	
	function mapToStyles(_ref2) {
	  var _Object$assign2;
	
	  var popper = _ref2.popper,
	      popperRect = _ref2.popperRect,
	      placement = _ref2.placement,
	      offsets = _ref2.offsets,
	      position = _ref2.position,
	      gpuAcceleration = _ref2.gpuAcceleration,
	      adaptive = _ref2.adaptive,
	      roundOffsets = _ref2.roundOffsets;
	
	  var _ref3 = roundOffsets === true ? roundOffsetsByDPR(offsets) : typeof roundOffsets === 'function' ? roundOffsets(offsets) : offsets,
	      _ref3$x = _ref3.x,
	      x = _ref3$x === void 0 ? 0 : _ref3$x,
	      _ref3$y = _ref3.y,
	      y = _ref3$y === void 0 ? 0 : _ref3$y;
	
	  var hasX = offsets.hasOwnProperty('x');
	  var hasY = offsets.hasOwnProperty('y');
	  var sideX = left;
	  var sideY = top;
	  var win = window;
	
	  if (adaptive) {
	    var offsetParent = getOffsetParent(popper);
	    var heightProp = 'clientHeight';
	    var widthProp = 'clientWidth';
	
	    if (offsetParent === getWindow(popper)) {
	      offsetParent = getDocumentElement(popper);
	
	      if (getComputedStyle(offsetParent).position !== 'static') {
	        heightProp = 'scrollHeight';
	        widthProp = 'scrollWidth';
	      }
	    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
	
	    /*:: offsetParent = (offsetParent: Element); */
	
	
	    if (placement === top) {
	      sideY = bottom; // $FlowFixMe[prop-missing]
	
	      y -= offsetParent[heightProp] - popperRect.height;
	      y *= gpuAcceleration ? 1 : -1;
	    }
	
	    if (placement === left) {
	      sideX = right; // $FlowFixMe[prop-missing]
	
	      x -= offsetParent[widthProp] - popperRect.width;
	      x *= gpuAcceleration ? 1 : -1;
	    }
	  }
	
	  var commonStyles = Object.assign({
	    position: position
	  }, adaptive && unsetSides);
	
	  if (gpuAcceleration) {
	    var _Object$assign;
	
	    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) < 2 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
	  }
	
	  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
	}
	
	function computeStyles(_ref4) {
	  var state = _ref4.state,
	      options = _ref4.options;
	  var _options$gpuAccelerat = options.gpuAcceleration,
	      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
	      _options$adaptive = options.adaptive,
	      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
	      _options$roundOffsets = options.roundOffsets,
	      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
	
	  if (false) {
	    var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || '';
	
	    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
	      return transitionProperty.indexOf(property) >= 0;
	    })) {
	      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
	    }
	  }
	
	  var commonStyles = {
	    placement: getBasePlacement(state.placement),
	    popper: state.elements.popper,
	    popperRect: state.rects.popper,
	    gpuAcceleration: gpuAcceleration
	  };
	
	  if (state.modifiersData.popperOffsets != null) {
	    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
	      offsets: state.modifiersData.popperOffsets,
	      position: state.options.strategy,
	      adaptive: adaptive,
	      roundOffsets: roundOffsets
	    })));
	  }
	
	  if (state.modifiersData.arrow != null) {
	    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
	      offsets: state.modifiersData.arrow,
	      position: 'absolute',
	      adaptive: false,
	      roundOffsets: roundOffsets
	    })));
	  }
	
	  state.attributes.popper = Object.assign({}, state.attributes.popper, {
	    'data-popper-placement': state.placement
	  });
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var computeStyles$1 = {
	  name: 'computeStyles',
	  enabled: true,
	  phase: 'beforeWrite',
	  fn: computeStyles,
	  data: {}
	};
	
	var passive = {
	  passive: true
	};
	
	function effect(_ref) {
	  var state = _ref.state,
	      instance = _ref.instance,
	      options = _ref.options;
	  var _options$scroll = options.scroll,
	      scroll = _options$scroll === void 0 ? true : _options$scroll,
	      _options$resize = options.resize,
	      resize = _options$resize === void 0 ? true : _options$resize;
	  var window = getWindow(state.elements.popper);
	  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
	
	  if (scroll) {
	    scrollParents.forEach(function (scrollParent) {
	      scrollParent.addEventListener('scroll', instance.update, passive);
	    });
	  }
	
	  if (resize) {
	    window.addEventListener('resize', instance.update, passive);
	  }
	
	  return function () {
	    if (scroll) {
	      scrollParents.forEach(function (scrollParent) {
	        scrollParent.removeEventListener('scroll', instance.update, passive);
	      });
	    }
	
	    if (resize) {
	      window.removeEventListener('resize', instance.update, passive);
	    }
	  };
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var eventListeners = {
	  name: 'eventListeners',
	  enabled: true,
	  phase: 'write',
	  fn: function fn() {},
	  effect: effect,
	  data: {}
	};
	
	var hash$1 = {
	  left: 'right',
	  right: 'left',
	  bottom: 'top',
	  top: 'bottom'
	};
	function getOppositePlacement(placement) {
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash$1[matched];
	  });
	}
	
	var hash = {
	  start: 'end',
	  end: 'start'
	};
	function getOppositeVariationPlacement(placement) {
	  return placement.replace(/start|end/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	function getWindowScroll(node) {
	  var win = getWindow(node);
	  var scrollLeft = win.pageXOffset;
	  var scrollTop = win.pageYOffset;
	  return {
	    scrollLeft: scrollLeft,
	    scrollTop: scrollTop
	  };
	}
	
	function getWindowScrollBarX(element) {
	  // If <html> has a CSS width greater than the viewport, then this will be
	  // incorrect for RTL.
	  // Popper 1 is broken in this case and never had a bug report so let's assume
	  // it's not an issue. I don't think anyone ever specifies width on <html>
	  // anyway.
	  // Browsers where the left scrollbar doesn't cause an issue report `0` for
	  // this (e.g. Edge 2019, IE11, Safari)
	  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
	}
	
	function getViewportRect(element) {
	  var win = getWindow(element);
	  var html = getDocumentElement(element);
	  var visualViewport = win.visualViewport;
	  var width = html.clientWidth;
	  var height = html.clientHeight;
	  var x = 0;
	  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
	  // can be obscured underneath it.
	  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
	  // if it isn't open, so if this isn't available, the popper will be detected
	  // to overflow the bottom of the screen too early.
	
	  if (visualViewport) {
	    width = visualViewport.width;
	    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
	    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
	    // errors due to floating point numbers, so we need to check precision.
	    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
	    // Feature detection fails in mobile emulation mode in Chrome.
	    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
	    // 0.001
	    // Fallback here: "Not Safari" userAgent
	
	    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
	      x = visualViewport.offsetLeft;
	      y = visualViewport.offsetTop;
	    }
	  }
	
	  return {
	    width: width,
	    height: height,
	    x: x + getWindowScrollBarX(element),
	    y: y
	  };
	}
	
	// of the `<html>` and `<body>` rect bounds if horizontally scrollable
	
	function getDocumentRect(element) {
	  var _element$ownerDocumen;
	
	  var html = getDocumentElement(element);
	  var winScroll = getWindowScroll(element);
	  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
	  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
	  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
	  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
	  var y = -winScroll.scrollTop;
	
	  if (getComputedStyle(body || html).direction === 'rtl') {
	    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
	  }
	
	  return {
	    width: width,
	    height: height,
	    x: x,
	    y: y
	  };
	}
	
	function isScrollParent(element) {
	  // Firefox wants us to check `-x` and `-y` variations as well
	  var _getComputedStyle = getComputedStyle(element),
	      overflow = _getComputedStyle.overflow,
	      overflowX = _getComputedStyle.overflowX,
	      overflowY = _getComputedStyle.overflowY;
	
	  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
	}
	
	function getScrollParent(node) {
	  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
	    // $FlowFixMe[incompatible-return]: assume body is always available
	    return node.ownerDocument.body;
	  }
	
	  if (isHTMLElement(node) && isScrollParent(node)) {
	    return node;
	  }
	
	  return getScrollParent(getParentNode(node));
	}
	
	/*
	given a DOM element, return the list of all scroll parents, up the list of ancesors
	until we get to the top window object. This list is what we attach scroll listeners
	to, because if any of these parent elements scroll, we'll need to re-calculate the
	reference element's position.
	*/
	
	function listScrollParents(element, list) {
	  var _element$ownerDocumen;
	
	  if (list === void 0) {
	    list = [];
	  }
	
	  var scrollParent = getScrollParent(element);
	  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
	  var win = getWindow(scrollParent);
	  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
	  var updatedList = list.concat(target);
	  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
	  updatedList.concat(listScrollParents(getParentNode(target)));
	}
	
	function rectToClientRect(rect) {
	  return Object.assign({}, rect, {
	    left: rect.x,
	    top: rect.y,
	    right: rect.x + rect.width,
	    bottom: rect.y + rect.height
	  });
	}
	
	function getInnerBoundingClientRect(element) {
	  var rect = getBoundingClientRect(element);
	  rect.top = rect.top + element.clientTop;
	  rect.left = rect.left + element.clientLeft;
	  rect.bottom = rect.top + element.clientHeight;
	  rect.right = rect.left + element.clientWidth;
	  rect.width = element.clientWidth;
	  rect.height = element.clientHeight;
	  rect.x = rect.left;
	  rect.y = rect.top;
	  return rect;
	}
	
	function getClientRectFromMixedType(element, clippingParent) {
	  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isHTMLElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
	} // A "clipping parent" is an overflowable container with the characteristic of
	// clipping (or hiding) overflowing elements with a position different from
	// `initial`
	
	
	function getClippingParents(element) {
	  var clippingParents = listScrollParents(getParentNode(element));
	  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
	  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
	
	  if (!isElement(clipperElement)) {
	    return [];
	  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
	
	
	  return clippingParents.filter(function (clippingParent) {
	    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
	  });
	} // Gets the maximum area that the element is visible in due to any number of
	// clipping parents
	
	
	function getClippingRect(element, boundary, rootBoundary) {
	  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
	  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
	  var firstClippingParent = clippingParents[0];
	  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
	    var rect = getClientRectFromMixedType(element, clippingParent);
	    accRect.top = max(rect.top, accRect.top);
	    accRect.right = min(rect.right, accRect.right);
	    accRect.bottom = min(rect.bottom, accRect.bottom);
	    accRect.left = max(rect.left, accRect.left);
	    return accRect;
	  }, getClientRectFromMixedType(element, firstClippingParent));
	  clippingRect.width = clippingRect.right - clippingRect.left;
	  clippingRect.height = clippingRect.bottom - clippingRect.top;
	  clippingRect.x = clippingRect.left;
	  clippingRect.y = clippingRect.top;
	  return clippingRect;
	}
	
	function getVariation(placement) {
	  return placement.split('-')[1];
	}
	
	function computeOffsets(_ref) {
	  var reference = _ref.reference,
	      element = _ref.element,
	      placement = _ref.placement;
	  var basePlacement = placement ? getBasePlacement(placement) : null;
	  var variation = placement ? getVariation(placement) : null;
	  var commonX = reference.x + reference.width / 2 - element.width / 2;
	  var commonY = reference.y + reference.height / 2 - element.height / 2;
	  var offsets;
	
	  switch (basePlacement) {
	    case top:
	      offsets = {
	        x: commonX,
	        y: reference.y - element.height
	      };
	      break;
	
	    case bottom:
	      offsets = {
	        x: commonX,
	        y: reference.y + reference.height
	      };
	      break;
	
	    case right:
	      offsets = {
	        x: reference.x + reference.width,
	        y: commonY
	      };
	      break;
	
	    case left:
	      offsets = {
	        x: reference.x - element.width,
	        y: commonY
	      };
	      break;
	
	    default:
	      offsets = {
	        x: reference.x,
	        y: reference.y
	      };
	  }
	
	  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
	
	  if (mainAxis != null) {
	    var len = mainAxis === 'y' ? 'height' : 'width';
	
	    switch (variation) {
	      case start:
	        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
	        break;
	
	      case end:
	        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
	        break;
	    }
	  }
	
	  return offsets;
	}
	
	function detectOverflow(state, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var _options = options,
	      _options$placement = _options.placement,
	      placement = _options$placement === void 0 ? state.placement : _options$placement,
	      _options$boundary = _options.boundary,
	      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
	      _options$rootBoundary = _options.rootBoundary,
	      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
	      _options$elementConte = _options.elementContext,
	      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
	      _options$altBoundary = _options.altBoundary,
	      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
	      _options$padding = _options.padding,
	      padding = _options$padding === void 0 ? 0 : _options$padding;
	  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
	  var altContext = elementContext === popper ? reference : popper;
	  var referenceElement = state.elements.reference;
	  var popperRect = state.rects.popper;
	  var element = state.elements[altBoundary ? altContext : elementContext];
	  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
	  var referenceClientRect = getBoundingClientRect(referenceElement);
	  var popperOffsets = computeOffsets({
	    reference: referenceClientRect,
	    element: popperRect,
	    strategy: 'absolute',
	    placement: placement
	  });
	  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
	  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
	  // 0 or negative = within the clipping rect
	
	  var overflowOffsets = {
	    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
	    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
	    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
	    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
	  };
	  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
	
	  if (elementContext === popper && offsetData) {
	    var offset = offsetData[placement];
	    Object.keys(overflowOffsets).forEach(function (key) {
	      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
	      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
	      overflowOffsets[key] += offset[axis] * multiply;
	    });
	  }
	
	  return overflowOffsets;
	}
	
	/*:: type OverflowsMap = { [ComputedPlacement]: number }; */
	
	/*;; type OverflowsMap = { [key in ComputedPlacement]: number }; */
	function computeAutoPlacement(state, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var _options = options,
	      placement = _options.placement,
	      boundary = _options.boundary,
	      rootBoundary = _options.rootBoundary,
	      padding = _options.padding,
	      flipVariations = _options.flipVariations,
	      _options$allowedAutoP = _options.allowedAutoPlacements,
	      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
	  var variation = getVariation(placement);
	  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
	    return getVariation(placement) === variation;
	  }) : basePlacements;
	  var allowedPlacements = placements$1.filter(function (placement) {
	    return allowedAutoPlacements.indexOf(placement) >= 0;
	  });
	
	  if (allowedPlacements.length === 0) {
	    allowedPlacements = placements$1;
	
	    if (false) {
	      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
	    }
	  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
	
	
	  var overflows = allowedPlacements.reduce(function (acc, placement) {
	    acc[placement] = detectOverflow(state, {
	      placement: placement,
	      boundary: boundary,
	      rootBoundary: rootBoundary,
	      padding: padding
	    })[getBasePlacement(placement)];
	    return acc;
	  }, {});
	  return Object.keys(overflows).sort(function (a, b) {
	    return overflows[a] - overflows[b];
	  });
	}
	
	function getExpandedFallbackPlacements(placement) {
	  if (getBasePlacement(placement) === auto) {
	    return [];
	  }
	
	  var oppositePlacement = getOppositePlacement(placement);
	  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
	}
	
	function flip(_ref) {
	  var state = _ref.state,
	      options = _ref.options,
	      name = _ref.name;
	
	  if (state.modifiersData[name]._skip) {
	    return;
	  }
	
	  var _options$mainAxis = options.mainAxis,
	      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
	      _options$altAxis = options.altAxis,
	      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
	      specifiedFallbackPlacements = options.fallbackPlacements,
	      padding = options.padding,
	      boundary = options.boundary,
	      rootBoundary = options.rootBoundary,
	      altBoundary = options.altBoundary,
	      _options$flipVariatio = options.flipVariations,
	      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
	      allowedAutoPlacements = options.allowedAutoPlacements;
	  var preferredPlacement = state.options.placement;
	  var basePlacement = getBasePlacement(preferredPlacement);
	  var isBasePlacement = basePlacement === preferredPlacement;
	  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
	  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
	    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
	      placement: placement,
	      boundary: boundary,
	      rootBoundary: rootBoundary,
	      padding: padding,
	      flipVariations: flipVariations,
	      allowedAutoPlacements: allowedAutoPlacements
	    }) : placement);
	  }, []);
	  var referenceRect = state.rects.reference;
	  var popperRect = state.rects.popper;
	  var checksMap = new Map();
	  var makeFallbackChecks = true;
	  var firstFittingPlacement = placements[0];
	
	  for (var i = 0; i < placements.length; i++) {
	    var placement = placements[i];
	
	    var _basePlacement = getBasePlacement(placement);
	
	    var isStartVariation = getVariation(placement) === start;
	    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
	    var len = isVertical ? 'width' : 'height';
	    var overflow = detectOverflow(state, {
	      placement: placement,
	      boundary: boundary,
	      rootBoundary: rootBoundary,
	      altBoundary: altBoundary,
	      padding: padding
	    });
	    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
	
	    if (referenceRect[len] > popperRect[len]) {
	      mainVariationSide = getOppositePlacement(mainVariationSide);
	    }
	
	    var altVariationSide = getOppositePlacement(mainVariationSide);
	    var checks = [];
	
	    if (checkMainAxis) {
	      checks.push(overflow[_basePlacement] <= 0);
	    }
	
	    if (checkAltAxis) {
	      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
	    }
	
	    if (checks.every(function (check) {
	      return check;
	    })) {
	      firstFittingPlacement = placement;
	      makeFallbackChecks = false;
	      break;
	    }
	
	    checksMap.set(placement, checks);
	  }
	
	  if (makeFallbackChecks) {
	    // `2` may be desired in some cases – research later
	    var numberOfChecks = flipVariations ? 3 : 1;
	
	    var _loop = function _loop(_i) {
	      var fittingPlacement = placements.find(function (placement) {
	        var checks = checksMap.get(placement);
	
	        if (checks) {
	          return checks.slice(0, _i).every(function (check) {
	            return check;
	          });
	        }
	      });
	
	      if (fittingPlacement) {
	        firstFittingPlacement = fittingPlacement;
	        return "break";
	      }
	    };
	
	    for (var _i = numberOfChecks; _i > 0; _i--) {
	      var _ret = _loop(_i);
	
	      if (_ret === "break") break;
	    }
	  }
	
	  if (state.placement !== firstFittingPlacement) {
	    state.modifiersData[name]._skip = true;
	    state.placement = firstFittingPlacement;
	    state.reset = true;
	  }
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var flip$1 = {
	  name: 'flip',
	  enabled: true,
	  phase: 'main',
	  fn: flip,
	  requiresIfExists: ['offset'],
	  data: {
	    _skip: false
	  }
	};
	
	function getSideOffsets(overflow, rect, preventedOffsets) {
	  if (preventedOffsets === void 0) {
	    preventedOffsets = {
	      x: 0,
	      y: 0
	    };
	  }
	
	  return {
	    top: overflow.top - rect.height - preventedOffsets.y,
	    right: overflow.right - rect.width + preventedOffsets.x,
	    bottom: overflow.bottom - rect.height + preventedOffsets.y,
	    left: overflow.left - rect.width - preventedOffsets.x
	  };
	}
	
	function isAnySideFullyClipped(overflow) {
	  return [top, right, bottom, left].some(function (side) {
	    return overflow[side] >= 0;
	  });
	}
	
	function hide(_ref) {
	  var state = _ref.state,
	      name = _ref.name;
	  var referenceRect = state.rects.reference;
	  var popperRect = state.rects.popper;
	  var preventedOffsets = state.modifiersData.preventOverflow;
	  var referenceOverflow = detectOverflow(state, {
	    elementContext: 'reference'
	  });
	  var popperAltOverflow = detectOverflow(state, {
	    altBoundary: true
	  });
	  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
	  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
	  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
	  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
	  state.modifiersData[name] = {
	    referenceClippingOffsets: referenceClippingOffsets,
	    popperEscapeOffsets: popperEscapeOffsets,
	    isReferenceHidden: isReferenceHidden,
	    hasPopperEscaped: hasPopperEscaped
	  };
	  state.attributes.popper = Object.assign({}, state.attributes.popper, {
	    'data-popper-reference-hidden': isReferenceHidden,
	    'data-popper-escaped': hasPopperEscaped
	  });
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var hide$1 = {
	  name: 'hide',
	  enabled: true,
	  phase: 'main',
	  requiresIfExists: ['preventOverflow'],
	  fn: hide
	};
	
	function distanceAndSkiddingToXY(placement, rects, offset) {
	  var basePlacement = getBasePlacement(placement);
	  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
	
	  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
	    placement: placement
	  })) : offset,
	      skidding = _ref[0],
	      distance = _ref[1];
	
	  skidding = skidding || 0;
	  distance = (distance || 0) * invertDistance;
	  return [left, right].indexOf(basePlacement) >= 0 ? {
	    x: distance,
	    y: skidding
	  } : {
	    x: skidding,
	    y: distance
	  };
	}
	
	function offset(_ref2) {
	  var state = _ref2.state,
	      options = _ref2.options,
	      name = _ref2.name;
	  var _options$offset = options.offset,
	      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
	  var data = placements.reduce(function (acc, placement) {
	    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
	    return acc;
	  }, {});
	  var _data$state$placement = data[state.placement],
	      x = _data$state$placement.x,
	      y = _data$state$placement.y;
	
	  if (state.modifiersData.popperOffsets != null) {
	    state.modifiersData.popperOffsets.x += x;
	    state.modifiersData.popperOffsets.y += y;
	  }
	
	  state.modifiersData[name] = data;
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var offset$1 = {
	  name: 'offset',
	  enabled: true,
	  phase: 'main',
	  requires: ['popperOffsets'],
	  fn: offset
	};
	
	function popperOffsets(_ref) {
	  var state = _ref.state,
	      name = _ref.name;
	  // Offsets are the actual position the popper needs to have to be
	  // properly positioned near its reference element
	  // This is the most basic placement, and will be adjusted by
	  // the modifiers in the next step
	  state.modifiersData[name] = computeOffsets({
	    reference: state.rects.reference,
	    element: state.rects.popper,
	    strategy: 'absolute',
	    placement: state.placement
	  });
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var popperOffsets$1 = {
	  name: 'popperOffsets',
	  enabled: true,
	  phase: 'read',
	  fn: popperOffsets,
	  data: {}
	};
	
	function getAltAxis(axis) {
	  return axis === 'x' ? 'y' : 'x';
	}
	
	function preventOverflow(_ref) {
	  var state = _ref.state,
	      options = _ref.options,
	      name = _ref.name;
	  var _options$mainAxis = options.mainAxis,
	      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
	      _options$altAxis = options.altAxis,
	      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
	      boundary = options.boundary,
	      rootBoundary = options.rootBoundary,
	      altBoundary = options.altBoundary,
	      padding = options.padding,
	      _options$tether = options.tether,
	      tether = _options$tether === void 0 ? true : _options$tether,
	      _options$tetherOffset = options.tetherOffset,
	      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
	  var overflow = detectOverflow(state, {
	    boundary: boundary,
	    rootBoundary: rootBoundary,
	    padding: padding,
	    altBoundary: altBoundary
	  });
	  var basePlacement = getBasePlacement(state.placement);
	  var variation = getVariation(state.placement);
	  var isBasePlacement = !variation;
	  var mainAxis = getMainAxisFromPlacement(basePlacement);
	  var altAxis = getAltAxis(mainAxis);
	  var popperOffsets = state.modifiersData.popperOffsets;
	  var referenceRect = state.rects.reference;
	  var popperRect = state.rects.popper;
	  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
	    placement: state.placement
	  })) : tetherOffset;
	  var data = {
	    x: 0,
	    y: 0
	  };
	
	  if (!popperOffsets) {
	    return;
	  }
	
	  if (checkMainAxis || checkAltAxis) {
	    var mainSide = mainAxis === 'y' ? top : left;
	    var altSide = mainAxis === 'y' ? bottom : right;
	    var len = mainAxis === 'y' ? 'height' : 'width';
	    var offset = popperOffsets[mainAxis];
	    var min$1 = popperOffsets[mainAxis] + overflow[mainSide];
	    var max$1 = popperOffsets[mainAxis] - overflow[altSide];
	    var additive = tether ? -popperRect[len] / 2 : 0;
	    var minLen = variation === start ? referenceRect[len] : popperRect[len];
	    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
	    // outside the reference bounds
	
	    var arrowElement = state.elements.arrow;
	    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
	      width: 0,
	      height: 0
	    };
	    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
	    var arrowPaddingMin = arrowPaddingObject[mainSide];
	    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
	    // to include its full size in the calculation. If the reference is small
	    // and near the edge of a boundary, the popper can overflow even if the
	    // reference is not overflowing as well (e.g. virtual elements with no
	    // width or height)
	
	    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
	    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
	    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
	    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
	    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
	    var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
	    var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
	    var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;
	
	    if (checkMainAxis) {
	      var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
	      popperOffsets[mainAxis] = preventedOffset;
	      data[mainAxis] = preventedOffset - offset;
	    }
	
	    if (checkAltAxis) {
	      var _mainSide = mainAxis === 'x' ? top : left;
	
	      var _altSide = mainAxis === 'x' ? bottom : right;
	
	      var _offset = popperOffsets[altAxis];
	
	      var _min = _offset + overflow[_mainSide];
	
	      var _max = _offset - overflow[_altSide];
	
	      var _preventedOffset = within(tether ? min(_min, tetherMin) : _min, _offset, tether ? max(_max, tetherMax) : _max);
	
	      popperOffsets[altAxis] = _preventedOffset;
	      data[altAxis] = _preventedOffset - _offset;
	    }
	  }
	
	  state.modifiersData[name] = data;
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var preventOverflow$1 = {
	  name: 'preventOverflow',
	  enabled: true,
	  phase: 'main',
	  fn: preventOverflow,
	  requiresIfExists: ['offset']
	};
	
	function getHTMLElementScroll(element) {
	  return {
	    scrollLeft: element.scrollLeft,
	    scrollTop: element.scrollTop
	  };
	}
	
	function getNodeScroll(node) {
	  if (node === getWindow(node) || !isHTMLElement(node)) {
	    return getWindowScroll(node);
	  } else {
	    return getHTMLElementScroll(node);
	  }
	}
	
	// Composite means it takes into account transforms as well as layout.
	
	function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
	  if (isFixed === void 0) {
	    isFixed = false;
	  }
	
	  var documentElement = getDocumentElement(offsetParent);
	  var rect = getBoundingClientRect(elementOrVirtualElement);
	  var isOffsetParentAnElement = isHTMLElement(offsetParent);
	  var scroll = {
	    scrollLeft: 0,
	    scrollTop: 0
	  };
	  var offsets = {
	    x: 0,
	    y: 0
	  };
	
	  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
	    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
	    isScrollParent(documentElement)) {
	      scroll = getNodeScroll(offsetParent);
	    }
	
	    if (isHTMLElement(offsetParent)) {
	      offsets = getBoundingClientRect(offsetParent);
	      offsets.x += offsetParent.clientLeft;
	      offsets.y += offsetParent.clientTop;
	    } else if (documentElement) {
	      offsets.x = getWindowScrollBarX(documentElement);
	    }
	  }
	
	  return {
	    x: rect.left + scroll.scrollLeft - offsets.x,
	    y: rect.top + scroll.scrollTop - offsets.y,
	    width: rect.width,
	    height: rect.height
	  };
	}
	
	function order(modifiers) {
	  var map = new Map();
	  var visited = new Set();
	  var result = [];
	  modifiers.forEach(function (modifier) {
	    map.set(modifier.name, modifier);
	  }); // On visiting object, check for its dependencies and visit them recursively
	
	  function sort(modifier) {
	    visited.add(modifier.name);
	    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
	    requires.forEach(function (dep) {
	      if (!visited.has(dep)) {
	        var depModifier = map.get(dep);
	
	        if (depModifier) {
	          sort(depModifier);
	        }
	      }
	    });
	    result.push(modifier);
	  }
	
	  modifiers.forEach(function (modifier) {
	    if (!visited.has(modifier.name)) {
	      // check for visited object
	      sort(modifier);
	    }
	  });
	  return result;
	}
	
	function orderModifiers(modifiers) {
	  // order based on dependencies
	  var orderedModifiers = order(modifiers); // order based on phase
	
	  return modifierPhases.reduce(function (acc, phase) {
	    return acc.concat(orderedModifiers.filter(function (modifier) {
	      return modifier.phase === phase;
	    }));
	  }, []);
	}
	
	function debounce(fn) {
	  var pending;
	  return function () {
	    if (!pending) {
	      pending = new Promise(function (resolve) {
	        Promise.resolve().then(function () {
	          pending = undefined;
	          resolve(fn());
	        });
	      });
	    }
	
	    return pending;
	  };
	}
	
	function format(str) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return [].concat(args).reduce(function (p, c) {
	    return p.replace(/%s/, c);
	  }, str);
	}
	
	var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
	var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
	var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
	function validateModifiers(modifiers) {
	  modifiers.forEach(function (modifier) {
	    Object.keys(modifier).forEach(function (key) {
	      switch (key) {
	        case 'name':
	          if (typeof modifier.name !== 'string') {
	            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
	          }
	
	          break;
	
	        case 'enabled':
	          if (typeof modifier.enabled !== 'boolean') {
	            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
	          }
	
	        case 'phase':
	          if (modifierPhases.indexOf(modifier.phase) < 0) {
	            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
	          }
	
	          break;
	
	        case 'fn':
	          if (typeof modifier.fn !== 'function') {
	            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
	          }
	
	          break;
	
	        case 'effect':
	          if (typeof modifier.effect !== 'function') {
	            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
	          }
	
	          break;
	
	        case 'requires':
	          if (!Array.isArray(modifier.requires)) {
	            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
	          }
	
	          break;
	
	        case 'requiresIfExists':
	          if (!Array.isArray(modifier.requiresIfExists)) {
	            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
	          }
	
	          break;
	
	        case 'options':
	        case 'data':
	          break;
	
	        default:
	          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
	            return "\"" + s + "\"";
	          }).join(', ') + "; but \"" + key + "\" was provided.");
	      }
	
	      modifier.requires && modifier.requires.forEach(function (requirement) {
	        if (modifiers.find(function (mod) {
	          return mod.name === requirement;
	        }) == null) {
	          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
	        }
	      });
	    });
	  });
	}
	
	function uniqueBy(arr, fn) {
	  var identifiers = new Set();
	  return arr.filter(function (item) {
	    var identifier = fn(item);
	
	    if (!identifiers.has(identifier)) {
	      identifiers.add(identifier);
	      return true;
	    }
	  });
	}
	
	function mergeByName(modifiers) {
	  var merged = modifiers.reduce(function (merged, current) {
	    var existing = merged[current.name];
	    merged[current.name] = existing ? Object.assign({}, existing, current, {
	      options: Object.assign({}, existing.options, current.options),
	      data: Object.assign({}, existing.data, current.data)
	    }) : current;
	    return merged;
	  }, {}); // IE11 does not support Object.values
	
	  return Object.keys(merged).map(function (key) {
	    return merged[key];
	  });
	}
	
	var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
	var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
	var DEFAULT_OPTIONS = {
	  placement: 'bottom',
	  modifiers: [],
	  strategy: 'absolute'
	};
	
	function areValidElements() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return !args.some(function (element) {
	    return !(element && typeof element.getBoundingClientRect === 'function');
	  });
	}
	
	function popperGenerator(generatorOptions) {
	  if (generatorOptions === void 0) {
	    generatorOptions = {};
	  }
	
	  var _generatorOptions = generatorOptions,
	      _generatorOptions$def = _generatorOptions.defaultModifiers,
	      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
	      _generatorOptions$def2 = _generatorOptions.defaultOptions,
	      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
	  return function createPopper(reference, popper, options) {
	    if (options === void 0) {
	      options = defaultOptions;
	    }
	
	    var state = {
	      placement: 'bottom',
	      orderedModifiers: [],
	      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
	      modifiersData: {},
	      elements: {
	        reference: reference,
	        popper: popper
	      },
	      attributes: {},
	      styles: {}
	    };
	    var effectCleanupFns = [];
	    var isDestroyed = false;
	    var instance = {
	      state: state,
	      setOptions: function setOptions(options) {
	        cleanupModifierEffects();
	        state.options = Object.assign({}, defaultOptions, state.options, options);
	        state.scrollParents = {
	          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
	          popper: listScrollParents(popper)
	        }; // Orders the modifiers based on their dependencies and `phase`
	        // properties
	
	        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
	
	        state.orderedModifiers = orderedModifiers.filter(function (m) {
	          return m.enabled;
	        }); // Validate the provided modifiers so that the consumer will get warned
	        // if one of the modifiers is invalid for any reason
	
	        if (false) {
	          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
	            var name = _ref.name;
	            return name;
	          });
	          validateModifiers(modifiers);
	
	          if (getBasePlacement(state.options.placement) === auto) {
	            var flipModifier = state.orderedModifiers.find(function (_ref2) {
	              var name = _ref2.name;
	              return name === 'flip';
	            });
	
	            if (!flipModifier) {
	              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
	            }
	          }
	
	          var _getComputedStyle = getComputedStyle(popper),
	              marginTop = _getComputedStyle.marginTop,
	              marginRight = _getComputedStyle.marginRight,
	              marginBottom = _getComputedStyle.marginBottom,
	              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
	          // cause bugs with positioning, so we'll warn the consumer
	
	
	          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
	            return parseFloat(margin);
	          })) {
	            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
	          }
	        }
	
	        runModifierEffects();
	        return instance.update();
	      },
	      // Sync update – it will always be executed, even if not necessary. This
	      // is useful for low frequency updates where sync behavior simplifies the
	      // logic.
	      // For high frequency updates (e.g. `resize` and `scroll` events), always
	      // prefer the async Popper#update method
	      forceUpdate: function forceUpdate() {
	        if (isDestroyed) {
	          return;
	        }
	
	        var _state$elements = state.elements,
	            reference = _state$elements.reference,
	            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
	        // anymore
	
	        if (!areValidElements(reference, popper)) {
	          if (false) {
	            console.error(INVALID_ELEMENT_ERROR);
	          }
	
	          return;
	        } // Store the reference and popper rects to be read by modifiers
	
	
	        state.rects = {
	          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
	          popper: getLayoutRect(popper)
	        }; // Modifiers have the ability to reset the current update cycle. The
	        // most common use case for this is the `flip` modifier changing the
	        // placement, which then needs to re-run all the modifiers, because the
	        // logic was previously ran for the previous placement and is therefore
	        // stale/incorrect
	
	        state.reset = false;
	        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
	        // is filled with the initial data specified by the modifier. This means
	        // it doesn't persist and is fresh on each update.
	        // To ensure persistent data, use `${name}#persistent`
	
	        state.orderedModifiers.forEach(function (modifier) {
	          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
	        });
	        var __debug_loops__ = 0;
	
	        for (var index = 0; index < state.orderedModifiers.length; index++) {
	          if (false) {
	            __debug_loops__ += 1;
	
	            if (__debug_loops__ > 100) {
	              console.error(INFINITE_LOOP_ERROR);
	              break;
	            }
	          }
	
	          if (state.reset === true) {
	            state.reset = false;
	            index = -1;
	            continue;
	          }
	
	          var _state$orderedModifie = state.orderedModifiers[index],
	              fn = _state$orderedModifie.fn,
	              _state$orderedModifie2 = _state$orderedModifie.options,
	              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
	              name = _state$orderedModifie.name;
	
	          if (typeof fn === 'function') {
	            state = fn({
	              state: state,
	              options: _options,
	              name: name,
	              instance: instance
	            }) || state;
	          }
	        }
	      },
	      // Async and optimistically optimized update – it will not be executed if
	      // not necessary (debounced to run at most once-per-tick)
	      update: debounce(function () {
	        return new Promise(function (resolve) {
	          instance.forceUpdate();
	          resolve(state);
	        });
	      }),
	      destroy: function destroy() {
	        cleanupModifierEffects();
	        isDestroyed = true;
	      }
	    };
	
	    if (!areValidElements(reference, popper)) {
	      if (false) {
	        console.error(INVALID_ELEMENT_ERROR);
	      }
	
	      return instance;
	    }
	
	    instance.setOptions(options).then(function (state) {
	      if (!isDestroyed && options.onFirstUpdate) {
	        options.onFirstUpdate(state);
	      }
	    }); // Modifiers have the ability to execute arbitrary code before the first
	    // update cycle runs. They will be executed in the same order as the update
	    // cycle. This is useful when a modifier adds some persistent data that
	    // other modifiers need to use, but the modifier is run after the dependent
	    // one.
	
	    function runModifierEffects() {
	      state.orderedModifiers.forEach(function (_ref3) {
	        var name = _ref3.name,
	            _ref3$options = _ref3.options,
	            options = _ref3$options === void 0 ? {} : _ref3$options,
	            effect = _ref3.effect;
	
	        if (typeof effect === 'function') {
	          var cleanupFn = effect({
	            state: state,
	            name: name,
	            instance: instance,
	            options: options
	          });
	
	          var noopFn = function noopFn() {};
	
	          effectCleanupFns.push(cleanupFn || noopFn);
	        }
	      });
	    }
	
	    function cleanupModifierEffects() {
	      effectCleanupFns.forEach(function (fn) {
	        return fn();
	      });
	      effectCleanupFns = [];
	    }
	
	    return instance;
	  };
	}
	
	// For the common JS build we will turn this file into a bundle with no imports.
	// This is b/c the Popper lib is all esm files, and would break in a common js only environment
	const createPopper = popperGenerator({
	  defaultModifiers: [
	    hide$1,
	    popperOffsets$1,
	    computeStyles$1,
	    eventListeners,
	    offset$1,
	    flip$1,
	    preventOverflow$1,
	    arrow$1,
	  ],
	});
	
	exports.createPopper = createPopper;
	exports.placements = placements;


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = __webpack_require__(2);
	
	var _useSafeState2 = _interopRequireDefault(__webpack_require__(356));
	
	var _popper = __webpack_require__(264);
	
	var initialPopperStyles = function initialPopperStyles(position) {
	  return {
	    position: position,
	    top: '0',
	    left: '0',
	    opacity: '0',
	    pointerEvents: 'none'
	  };
	};
	
	var disabledApplyStylesModifier = {
	  name: 'applyStyles',
	  enabled: false
	}; // until docjs supports type exports...
	
	var ariaDescribedByModifier = {
	  name: 'ariaDescribedBy',
	  enabled: true,
	  phase: 'afterWrite',
	  effect: function effect(_ref) {
	    var state = _ref.state;
	    return function () {
	      var _state$elements = state.elements,
	          reference = _state$elements.reference,
	          popper = _state$elements.popper;
	
	      if ('removeAttribute' in reference) {
	        var ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(function (id) {
	          return id.trim() !== popper.id;
	        });
	        if (!ids.length) reference.removeAttribute('aria-describedby');else reference.setAttribute('aria-describedby', ids.join(','));
	      }
	    };
	  },
	  fn: function fn(_ref2) {
	    var _popper$getAttribute;
	
	    var state = _ref2.state;
	    var _state$elements2 = state.elements,
	        popper = _state$elements2.popper,
	        reference = _state$elements2.reference;
	    var role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
	
	    if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
	      var ids = reference.getAttribute('aria-describedby');
	
	      if (ids && ids.split(',').indexOf(popper.id) !== -1) {
	        return;
	      }
	
	      reference.setAttribute('aria-describedby', ids ? ids + "," + popper.id : popper.id);
	    }
	  }
	};
	var EMPTY_MODIFIERS = [];
	/**
	 * Position an element relative some reference element using Popper.js
	 *
	 * @param referenceElement
	 * @param popperElement
	 * @param {object}      options
	 * @param {object=}     options.modifiers Popper.js modifiers
	 * @param {boolean=}    options.enabled toggle the popper functionality on/off
	 * @param {string=}     options.placement The popper element placement relative to the reference element
	 * @param {string=}     options.strategy the positioning strategy
	 * @param {boolean=}    options.eventsEnabled have Popper listen on window resize events to reposition the element
	 * @param {function=}   options.onCreate called when the popper is created
	 * @param {function=}   options.onUpdate called when the popper is updated
	 *
	 * @returns {UsePopperState} The popper state
	 */
	
	function usePopper(referenceElement, popperElement, _temp) {
	  var _ref3 = _temp === void 0 ? {} : _temp,
	      _ref3$enabled = _ref3.enabled,
	      enabled = _ref3$enabled === void 0 ? true : _ref3$enabled,
	      _ref3$placement = _ref3.placement,
	      placement = _ref3$placement === void 0 ? 'bottom' : _ref3$placement,
	      _ref3$strategy = _ref3.strategy,
	      strategy = _ref3$strategy === void 0 ? 'absolute' : _ref3$strategy,
	      _ref3$modifiers = _ref3.modifiers,
	      modifiers = _ref3$modifiers === void 0 ? EMPTY_MODIFIERS : _ref3$modifiers,
	      config = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, ["enabled", "placement", "strategy", "modifiers"]);
	
	  var popperInstanceRef = (0, _react.useRef)();
	  var update = (0, _react.useCallback)(function () {
	    var _popperInstanceRef$cu;
	
	    (_popperInstanceRef$cu = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu.update();
	  }, []);
	  var forceUpdate = (0, _react.useCallback)(function () {
	    var _popperInstanceRef$cu2;
	
	    (_popperInstanceRef$cu2 = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu2.forceUpdate();
	  }, []);
	
	  var _useSafeState = (0, _useSafeState2["default"])((0, _react.useState)({
	    placement: placement,
	    update: update,
	    forceUpdate: forceUpdate,
	    attributes: {},
	    styles: {
	      popper: initialPopperStyles(strategy),
	      arrow: {}
	    }
	  })),
	      popperState = _useSafeState[0],
	      setState = _useSafeState[1];
	
	  var updateModifier = (0, _react.useMemo)(function () {
	    return {
	      name: 'updateStateModifier',
	      enabled: true,
	      phase: 'write',
	      requires: ['computeStyles'],
	      fn: function fn(_ref4) {
	        var state = _ref4.state;
	        var styles = {};
	        var attributes = {};
	        Object.keys(state.elements).forEach(function (element) {
	          styles[element] = state.styles[element];
	          attributes[element] = state.attributes[element];
	        });
	        setState({
	          state: state,
	          styles: styles,
	          attributes: attributes,
	          update: update,
	          forceUpdate: forceUpdate,
	          placement: state.placement
	        });
	      }
	    };
	  }, [update, forceUpdate, setState]);
	  (0, _react.useEffect)(function () {
	    if (!popperInstanceRef.current || !enabled) return;
	    popperInstanceRef.current.setOptions({
	      placement: placement,
	      strategy: strategy,
	      modifiers: [].concat(modifiers, [updateModifier, disabledApplyStylesModifier])
	    }); // intentionally NOT re-running on new modifiers
	    // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [strategy, placement, updateModifier, enabled]);
	  (0, _react.useEffect)(function () {
	    if (!enabled || referenceElement == null || popperElement == null) {
	      return undefined;
	    }
	
	    popperInstanceRef.current = (0, _popper.createPopper)(referenceElement, popperElement, (0, _extends2["default"])({}, config, {
	      placement: placement,
	      strategy: strategy,
	      modifiers: [].concat(modifiers, [ariaDescribedByModifier, updateModifier])
	    }));
	    return function () {
	      if (popperInstanceRef.current != null) {
	        popperInstanceRef.current.destroy();
	        popperInstanceRef.current = undefined;
	        setState(function (s) {
	          return (0, _extends2["default"])({}, s, {
	            attributes: {},
	            styles: {
	              popper: initialPopperStyles(strategy)
	            }
	          });
	        });
	      }
	    }; // This is only run once to _create_ the popper
	    // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [enabled, referenceElement, popperElement]);
	  return popperState;
	}
	
	var _default = usePopper;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _contains = _interopRequireDefault(__webpack_require__(97));
	
	var _listen = _interopRequireDefault(__webpack_require__(98));
	
	var _react = __webpack_require__(2);
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(18));
	
	var _warning = _interopRequireDefault(__webpack_require__(31));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(570));
	
	var escapeKeyCode = 27;
	
	var noop = function noop() {};
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	var getRefTarget = function getRefTarget(ref) {
	  return ref && ('current' in ref ? ref.current : ref);
	};
	
	/**
	 * The `useRootClose` hook registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 *
	 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
	 * @param {function} onRootClose
	 * @param {object=}  options
	 * @param {boolean=} options.disabled
	 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
	 */
	function useRootClose(ref, onRootClose, _temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      disabled = _ref.disabled,
	      _ref$clickTrigger = _ref.clickTrigger,
	      clickTrigger = _ref$clickTrigger === void 0 ? 'click' : _ref$clickTrigger;
	
	  var preventMouseRootCloseRef = (0, _react.useRef)(false);
	  var onClose = onRootClose || noop;
	  var handleMouseCapture = (0, _react.useCallback)(function (e) {
	    var currentTarget = getRefTarget(ref);
	    (0, _warning["default"])(!!currentTarget, 'RootClose captured a close event but does not have a ref to compare it to. ' + 'useRootClose(), should be passed a ref that resolves to a DOM node');
	    preventMouseRootCloseRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || !!(0, _contains["default"])(currentTarget, e.target);
	  }, [ref]);
	  var handleMouse = (0, _useEventCallback["default"])(function (e) {
	    if (!preventMouseRootCloseRef.current) {
	      onClose(e);
	    }
	  });
	  var handleKeyUp = (0, _useEventCallback["default"])(function (e) {
	    if (e.keyCode === escapeKeyCode) {
	      onClose(e);
	    }
	  });
	  (0, _react.useEffect)(function () {
	    if (disabled || ref == null) return undefined; // Store the current event to avoid triggering handlers immediately
	    // https://github.com/facebook/react/issues/20074
	
	    var currentEvent = window.event;
	    var doc = (0, _ownerDocument["default"])(getRefTarget(ref)); // Use capture for this listener so it fires before React's listener, to
	    // avoid false positives in the contains() check below if the target DOM
	    // element is removed in the React mouse callback.
	
	    var removeMouseCaptureListener = (0, _listen["default"])(doc, clickTrigger, handleMouseCapture, true);
	    var removeMouseListener = (0, _listen["default"])(doc, clickTrigger, function (e) {
	      // skip if this event is the same as the one running when we added the handlers
	      if (e === currentEvent) {
	        currentEvent = undefined;
	        return;
	      }
	
	      handleMouse(e);
	    });
	    var removeKeyupListener = (0, _listen["default"])(doc, 'keyup', function (e) {
	      // skip if this event is the same as the one running when we added the handlers
	      if (e === currentEvent) {
	        currentEvent = undefined;
	        return;
	      }
	
	      handleKeyUp(e);
	    });
	    var mobileSafariHackListeners = [];
	
	    if ('ontouchstart' in doc.documentElement) {
	      mobileSafariHackListeners = [].slice.call(doc.body.children).map(function (el) {
	        return (0, _listen["default"])(el, 'mousemove', noop);
	      });
	    }
	
	    return function () {
	      removeMouseCaptureListener();
	      removeMouseListener();
	      removeKeyupListener();
	      mobileSafariHackListeners.forEach(function (remove) {
	        return remove();
	      });
	    };
	  }, [ref, disabled, clickTrigger, handleMouseCapture, handleMouse, handleKeyUp]);
	}
	
	var _default = useRootClose;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = useWaitForDOMRef;
	exports.resolveContainerRef = void 0;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(40));
	
	var _react = __webpack_require__(2);
	
	var resolveContainerRef = function resolveContainerRef(ref) {
	  var _ref;
	
	  if (typeof document === 'undefined') return null;
	  if (ref == null) return (0, _ownerDocument["default"])().body;
	  if (typeof ref === 'function') ref = ref();
	  if (ref && 'current' in ref) ref = ref.current;
	  if ((_ref = ref) != null && _ref.nodeType) return ref || null;
	  return null;
	};
	
	exports.resolveContainerRef = resolveContainerRef;
	
	function useWaitForDOMRef(ref, onResolved) {
	  var _useState = (0, _react.useState)(function () {
	    return resolveContainerRef(ref);
	  }),
	      resolvedRef = _useState[0],
	      setRef = _useState[1];
	
	  if (!resolvedRef) {
	    var earlyRef = resolveContainerRef(ref);
	    if (earlyRef) setRef(earlyRef);
	  }
	
	  (0, _react.useEffect)(function () {
	    if (onResolved && resolvedRef) {
	      onResolved(resolvedRef);
	    }
	  }, [onResolved, resolvedRef]);
	  (0, _react.useEffect)(function () {
	    var nextRef = resolveContainerRef(ref);
	
	    if (nextRef !== resolvedRef) {
	      setRef(nextRef);
	    }
	  }, [ref, resolvedRef]);
	  return resolvedRef;
	}

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __importStar = (this && this.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	    result["default"] = mod;
	    return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @jsx jsx */
	var React = __importStar(__webpack_require__(2));
	var core_1 = __webpack_require__(346);
	var index_1 = __webpack_require__(573);
	var Loader = /** @class */ (function (_super) {
	    __extends(Loader, _super);
	    function Loader() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.thickness = function () {
	            var size = _this.props.size;
	            return size / 5;
	        };
	        _this.lat = function () {
	            var size = _this.props.size;
	            return (size - _this.thickness()) / 2;
	        };
	        _this.offset = function () { return _this.lat() - _this.thickness(); };
	        _this.color = function () {
	            var color = _this.props.color;
	            return index_1.calculateRgba(color, 0.75);
	        };
	        _this.before = function () {
	            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
	            var color = _this.color();
	            var lat = _this.lat();
	            var thickness = _this.thickness();
	            var offset = _this.offset();
	            return core_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      0% {width: ", "px;box-shadow: ", "px ", "px ", ", ", "px ", "px ", "}\n      35% {width: ", ";box-shadow: 0 ", "px ", ", 0 ", "px ", "}\n      70% {width: ", "px;box-shadow: ", "px ", "px ", ", ", "px ", "px ", "}\n      100% {box-shadow: ", "px ", "px ", ", ", "px ", "px ", "}\n    "], ["\n      0% {width: ", "px;box-shadow: ", "px ", "px ", ", ", "px ", "px ", "}\n      35% {width: ", ";box-shadow: 0 ", "px ", ", 0 ", "px ", "}\n      70% {width: ", "px;box-shadow: ", "px ", "px ", ", ", "px ", "px ", "}\n      100% {box-shadow: ", "px ", "px ", ", ", "px ", "px ", "}\n    "])), thickness, lat, -offset, color, -lat, offset, color, "" + size + sizeUnit, -offset, color, offset, color, thickness, -lat, -offset, color, lat, offset, color, lat, -offset, color, -lat, offset, color);
	        };
	        _this.after = function () {
	            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
	            var color = _this.color();
	            var lat = _this.lat();
	            var thickness = _this.thickness();
	            var offset = _this.offset();
	            return core_1.keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      0% {height: ", "px;box-shadow: ", "px ", "px ", ", ", "px ", "px ", "}\n      35% {height: ", ";box-shadow: ", "px 0 ", ", ", "px 0 ", "}\n      70% {height: ", "px;box-shadow: ", "px ", "px ", ", ", "px ", "px ", "}\n      100% {box-shadow: ", "px ", "px ", ", ", "px ", "px ", "}\n    "], ["\n      0% {height: ", "px;box-shadow: ", "px ", "px ", ", ", "px ", "px ", "}\n      35% {height: ", ";box-shadow: ", "px 0 ", ", ", "px 0 ", "}\n      70% {height: ", "px;box-shadow: ", "px ", "px ", ", ", "px ", "px ", "}\n      100% {box-shadow: ", "px ", "px ", ", ", "px ", "px ", "}\n    "])), thickness, offset, lat, color, -offset, -lat, color, "" + size + sizeUnit, offset, color, -offset, color, thickness, offset, -lat, color, -offset, lat, color, offset, lat, color, -offset, -lat, color);
	        };
	        _this.style = function (i) {
	            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
	            return core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      position: absolute;\n      content: \"\";\n      top: 50%;\n      left: 50%;\n      display: block;\n      width: ", ";\n      height: ", ";\n      border-radius: ", ";\n      transform: translate(-50%, -50%);\n      animation-fill-mode: none;\n      animation: ", " 2s infinite;\n    "], ["\n      position: absolute;\n      content: \"\";\n      top: 50%;\n      left: 50%;\n      display: block;\n      width: ", ";\n      height: ", ";\n      border-radius: ", ";\n      transform: translate(-50%, -50%);\n      animation-fill-mode: none;\n      animation: ", " 2s infinite;\n    "])), "" + size / 5 + sizeUnit, "" + size / 5 + sizeUnit, "" + size / 10 + sizeUnit, i === 1 ? _this.before() : _this.after());
	        };
	        _this.wrapper = function () {
	            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
	            return core_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      position: relative;\n      width: ", ";\n      height: ", ";\n      transform: rotate(165deg);\n    "], ["\n      position: relative;\n      width: ", ";\n      height: ", ";\n      transform: rotate(165deg);\n    "])), "" + size + sizeUnit, "" + size + sizeUnit);
	        };
	        return _this;
	    }
	    Loader.prototype.render = function () {
	        var _a = this.props, loading = _a.loading, css = _a.css;
	        return loading ? (core_1.jsx("div", { css: [this.wrapper(), css] },
	            core_1.jsx("div", { css: this.style(1) }),
	            core_1.jsx("div", { css: this.style(2) }))) : null;
	    };
	    Loader.defaultProps = index_1.sizeDefaults(50);
	    return Loader;
	}(React.PureComponent));
	exports.default = Loader;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(581);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.isProp = isProp;
	exports.defaultKey = defaultKey;
	exports.canAcceptRef = canAcceptRef;
	
	var _invariant = _interopRequireDefault(__webpack_require__(70));
	
	var noop = function noop() {};
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, displayName) {
	  var propTypes = {};
	  Object.keys(controlledValues).forEach(function (prop) {
	    // add default propTypes for folks that use runtime checks
	    propTypes[defaultKey(prop)] = noop;
	
	    if (false) {
	      var handler = controlledValues[prop];
	      !(typeof handler === 'string' && handler.trim().length) ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop) : invariant(false) : void 0;
	      propTypes[prop] = readOnlyPropType(handler, displayName);
	    }
	  });
	  return propTypes;
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	
	function canAcceptRef(component) {
	  return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
	}

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","PUBLIC_URL":""}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(585);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(584);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(24)))

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(26),__webpack_require__(138),__webpack_require__(365),__webpack_require__(363)):"function"==typeof define&&define.amd?define("aws_amplify_analytics",["@aws-amplify/core","@aws-amplify/cache","aws-sdk/clients/pinpoint","aws-sdk/clients/kinesis"],t):"object"==typeof exports?exports.aws_amplify_analytics=t(require("@aws-amplify/core"),require("@aws-amplify/cache"),require("aws-sdk/clients/pinpoint"),require("aws-sdk/clients/kinesis")):e.aws_amplify_analytics=t(e["@aws-amplify/core"],e["@aws-amplify/cache"],e["aws-sdk/clients/pinpoint"],e["aws-sdk/clients/kinesis"])}(this,(function(e,t,r,n){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=119)}([function(t,r){t.exports=e},function(e,t,r){var n={util:r(2)};({}).toString(),e.exports=n,n.util.update(n,{VERSION:"2.518.0",Signers:{},Protocol:{Json:r(14),Query:r(20),Rest:r(12),RestJson:r(22),RestXml:r(23)},XML:{Builder:r(46),Parser:null},JSON:{Builder:r(15),Parser:r(16)},Model:{Api:r(24),Operation:r(25),Shape:r(8),Paginator:r(26),ResourceWaiter:r(27)},apiLoader:r(51),EndpointCache:r(52).EndpointCache}),r(28),r(54),r(57),r(31),r(58),r(63),r(65),r(66),r(67),r(74),n.events=new n.SequentialExecutor,n.util.memoizedProperty(n,"endpointCache",(function(){return new n.EndpointCache(n.config.endpointCacheSize)}),!0)},function(e,t,r){(function(t,n){var i,o={environment:"nodejs",engine:function(){if(o.isBrowser()&&"undefined"!=typeof navigator)return navigator.userAgent;var e=t.platform+"/"+t.version;return t.env.AWS_EXECUTION_ENV&&(e+=" exec-env/"+t.env.AWS_EXECUTION_ENV),e},userAgent:function(){var e=o.environment,t="aws-sdk-"+e+"/"+r(1).VERSION;return"nodejs"===e&&(t+=" "+o.engine()),t},uriEscape:function(e){var t=encodeURIComponent(e);return t=(t=t.replace(/[^A-Za-z0-9_.~\-%]+/g,escape)).replace(/[*]/g,(function(e){return"%"+e.charCodeAt(0).toString(16).toUpperCase()}))},uriEscapePath:function(e){var t=[];return o.arrayEach(e.split("/"),(function(e){t.push(o.uriEscape(e))})),t.join("/")},urlParse:function(e){return o.url.parse(e)},urlFormat:function(e){return o.url.format(e)},queryStringParse:function(e){return o.querystring.parse(e)},queryParamsToString:function(e){var t=[],r=o.uriEscape,n=Object.keys(e).sort();return o.arrayEach(n,(function(n){var i=e[n],s=r(n),a=s+"=";if(Array.isArray(i)){var u=[];o.arrayEach(i,(function(e){u.push(r(e))})),a=s+"="+u.sort().join("&"+s+"=")}else null!=i&&(a=s+"="+r(i));t.push(a)})),t.join("&")},readFileSync:function(e){return o.isBrowser()?null:r(19).readFileSync(e,"utf-8")},base64:{encode:function(e){if("number"==typeof e)throw o.error(new Error("Cannot base64 encode number "+e));return null==e?e:o.buffer.toBuffer(e).toString("base64")},decode:function(e){if("number"==typeof e)throw o.error(new Error("Cannot base64 decode number "+e));return null==e?e:o.buffer.toBuffer(e,"base64")}},buffer:{toBuffer:function(e,t){return"function"==typeof o.Buffer.from&&o.Buffer.from!==Uint8Array.from?o.Buffer.from(e,t):new o.Buffer(e,t)},alloc:function(e,t,r){if("number"!=typeof e)throw new Error("size passed to alloc must be a number.");if("function"==typeof o.Buffer.alloc)return o.Buffer.alloc(e,t,r);var n=new o.Buffer(e);return void 0!==t&&"function"==typeof n.fill&&n.fill(t,void 0,void 0,r),n},toStream:function(e){o.Buffer.isBuffer(e)||(e=o.buffer.toBuffer(e));var t=new o.stream.Readable,r=0;return t._read=function(n){if(r>=e.length)return t.push(null);var i=r+n;i>e.length&&(i=e.length),t.push(e.slice(r,i)),r=i},t},concat:function(e){var t,r,n=0,i=0;for(r=0;r<e.length;r++)n+=e[r].length;for(t=o.buffer.alloc(n),r=0;r<e.length;r++)e[r].copy(t,i),i+=e[r].length;return t}},string:{byteLength:function(e){if(null==e)return 0;if("string"==typeof e&&(e=o.buffer.toBuffer(e)),"number"==typeof e.byteLength)return e.byteLength;if("number"==typeof e.length)return e.length;if("number"==typeof e.size)return e.size;if("string"==typeof e.path)return r(19).lstatSync(e.path).size;throw o.error(new Error("Cannot determine length of "+e),{object:e})},upperFirst:function(e){return e[0].toUpperCase()+e.substr(1)},lowerFirst:function(e){return e[0].toLowerCase()+e.substr(1)}},ini:{parse:function(e){var t,r={};return o.arrayEach(e.split(/\r?\n/),(function(e){var n=(e=e.split(/(^|\s)[;#]/)[0]).match(/^\s*\[([^\[\]]+)\]\s*$/);if(n)t=n[1];else if(t){var i=e.match(/^\s*(.+?)\s*=\s*(.+?)\s*$/);i&&(r[t]=r[t]||{},r[t][i[1]]=i[2])}})),r}},fn:{noop:function(){},callback:function(e){if(e)throw e},makeAsync:function(e,t){return t&&t<=e.length?e:function(){var t=Array.prototype.slice.call(arguments,0),r=t.pop(),n=e.apply(null,t);r(n)}}},date:{getDate:function(){return i||(i=r(1)),i.config.systemClockOffset?new Date((new Date).getTime()+i.config.systemClockOffset):new Date},iso8601:function(e){return void 0===e&&(e=o.date.getDate()),e.toISOString().replace(/\.\d{3}Z$/,"Z")},rfc822:function(e){return void 0===e&&(e=o.date.getDate()),e.toUTCString()},unixTimestamp:function(e){return void 0===e&&(e=o.date.getDate()),e.getTime()/1e3},from:function(e){return"number"==typeof e?new Date(1e3*e):new Date(e)},format:function(e,t){return t||(t="iso8601"),o.date[t](o.date.from(e))},parseTimestamp:function(e){if("number"==typeof e)return new Date(1e3*e);if(e.match(/^\d+$/))return new Date(1e3*e);if(e.match(/^\d{4}/))return new Date(e);if(e.match(/^\w{3},/))return new Date(e);throw o.error(new Error("unhandled timestamp format: "+e),{code:"TimestampParserError"})}},crypto:{crc32Table:[0,1996959894,3993919788,2567524794,124634137,1886057615,3915621685,2657392035,249268274,2044508324,3772115230,2547177864,162941995,2125561021,3887607047,2428444049,498536548,1789927666,4089016648,2227061214,450548861,1843258603,4107580753,2211677639,325883990,1684777152,4251122042,2321926636,335633487,1661365465,4195302755,2366115317,997073096,1281953886,3579855332,2724688242,1006888145,1258607687,3524101629,2768942443,901097722,1119000684,3686517206,2898065728,853044451,1172266101,3705015759,2882616665,651767980,1373503546,3369554304,3218104598,565507253,1454621731,3485111705,3099436303,671266974,1594198024,3322730930,2970347812,795835527,1483230225,3244367275,3060149565,1994146192,31158534,2563907772,4023717930,1907459465,112637215,2680153253,3904427059,2013776290,251722036,2517215374,3775830040,2137656763,141376813,2439277719,3865271297,1802195444,476864866,2238001368,4066508878,1812370925,453092731,2181625025,4111451223,1706088902,314042704,2344532202,4240017532,1658658271,366619977,2362670323,4224994405,1303535960,984961486,2747007092,3569037538,1256170817,1037604311,2765210733,3554079995,1131014506,879679996,2909243462,3663771856,1141124467,855842277,2852801631,3708648649,1342533948,654459306,3188396048,3373015174,1466479909,544179635,3110523913,3462522015,1591671054,702138776,2966460450,3352799412,1504918807,783551873,3082640443,3233442989,3988292384,2596254646,62317068,1957810842,3939845945,2647816111,81470997,1943803523,3814918930,2489596804,225274430,2053790376,3826175755,2466906013,167816743,2097651377,4027552580,2265490386,503444072,1762050814,4150417245,2154129355,426522225,1852507879,4275313526,2312317920,282753626,1742555852,4189708143,2394877945,397917763,1622183637,3604390888,2714866558,953729732,1340076626,3518719985,2797360999,1068828381,1219638859,3624741850,2936675148,906185462,1090812512,3747672003,2825379669,829329135,1181335161,3412177804,3160834842,628085408,1382605366,3423369109,3138078467,570562233,1426400815,3317316542,2998733608,733239954,1555261956,3268935591,3050360625,752459403,1541320221,2607071920,3965973030,1969922972,40735498,2617837225,3943577151,1913087877,83908371,2512341634,3803740692,2075208622,213261112,2463272603,3855990285,2094854071,198958881,2262029012,4057260610,1759359992,534414190,2176718541,4139329115,1873836001,414664567,2282248934,4279200368,1711684554,285281116,2405801727,4167216745,1634467795,376229701,2685067896,3608007406,1308918612,956543938,2808555105,3495958263,1231636301,1047427035,2932959818,3654703836,1088359270,936918e3,2847714899,3736837829,1202900863,817233897,3183342108,3401237130,1404277552,615818150,3134207493,3453421203,1423857449,601450431,3009837614,3294710456,1567103746,711928724,3020668471,3272380065,1510334235,755167117],crc32:function(e){var t=o.crypto.crc32Table,r=-1;"string"==typeof e&&(e=o.buffer.toBuffer(e));for(var n=0;n<e.length;n++){r=r>>>8^t[255&(r^e.readUInt8(n))]}return(-1^r)>>>0},hmac:function(e,t,r,n){return r||(r="binary"),"buffer"===r&&(r=void 0),n||(n="sha256"),"string"==typeof t&&(t=o.buffer.toBuffer(t)),o.crypto.lib.createHmac(n,e).update(t).digest(r)},md5:function(e,t,r){return o.crypto.hash("md5",e,t,r)},sha256:function(e,t,r){return o.crypto.hash("sha256",e,t,r)},hash:function(e,t,r,n){var i=o.crypto.createHash(e);r||(r="binary"),"buffer"===r&&(r=void 0),"string"==typeof t&&(t=o.buffer.toBuffer(t));var s=o.arraySliceFn(t),a=o.Buffer.isBuffer(t);if(o.isBrowser()&&"undefined"!=typeof ArrayBuffer&&t&&t.buffer instanceof ArrayBuffer&&(a=!0),n&&"object"==typeof t&&"function"==typeof t.on&&!a)t.on("data",(function(e){i.update(e)})),t.on("error",(function(e){n(e)})),t.on("end",(function(){n(null,i.digest(r))}));else{if(!n||!s||a||"undefined"==typeof FileReader){o.isBrowser()&&"object"==typeof t&&!a&&(t=new o.Buffer(new Uint8Array(t)));var u=i.update(t).digest(r);return n&&n(null,u),u}var c=0,f=new FileReader;f.onerror=function(){n(new Error("Failed to read data."))},f.onload=function(){var e=new o.Buffer(new Uint8Array(f.result));i.update(e),c+=e.length,f._continueReading()},f._continueReading=function(){if(c>=t.size)n(null,i.digest(r));else{var e=c+524288;e>t.size&&(e=t.size),f.readAsArrayBuffer(s.call(t,c,e))}},f._continueReading()}},toHex:function(e){for(var t=[],r=0;r<e.length;r++)t.push(("0"+e.charCodeAt(r).toString(16)).substr(-2,2));return t.join("")},createHash:function(e){return o.crypto.lib.createHash(e)}},abort:{},each:function(e,t){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))if(t.call(this,r,e[r])===o.abort)break}},arrayEach:function(e,t){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))if(t.call(this,e[r],parseInt(r,10))===o.abort)break}},update:function(e,t){return o.each(t,(function(t,r){e[t]=r})),e},merge:function(e,t){return o.update(o.copy(e),t)},copy:function(e){if(null==e)return e;var t={};for(var r in e)t[r]=e[r];return t},isEmpty:function(e){for(var t in e)if(Object.prototype.hasOwnProperty.call(e,t))return!1;return!0},arraySliceFn:function(e){var t=e.slice||e.webkitSlice||e.mozSlice;return"function"==typeof t?t:null},isType:function(e,t){return"function"==typeof t&&(t=o.typeName(t)),Object.prototype.toString.call(e)==="[object "+t+"]"},typeName:function(e){if(Object.prototype.hasOwnProperty.call(e,"name"))return e.name;var t=e.toString(),r=t.match(/^\s*function (.+)\(/);return r?r[1]:t},error:function(e,t){var r=null;return"string"==typeof e.message&&""!==e.message&&("string"==typeof t||t&&t.message)&&((r=o.copy(e)).message=e.message),e.message=e.message||null,"string"==typeof t?e.message=t:"object"==typeof t&&null!==t&&(o.update(e,t),t.message&&(e.message=t.message),(t.code||t.name)&&(e.code=t.code||t.name),t.stack&&(e.stack=t.stack)),"function"==typeof Object.defineProperty&&(Object.defineProperty(e,"name",{writable:!0,enumerable:!1}),Object.defineProperty(e,"message",{enumerable:!0})),e.name=t&&t.name||e.name||e.code||"Error",e.time=new Date,r&&(e.originalError=r),e},inherit:function(e,t){var r=null;if(void 0===t)t=e,e=Object,r={};else{var n=function(){};n.prototype=e.prototype,r=new n}return t.constructor===Object&&(t.constructor=function(){if(e!==Object)return e.apply(this,arguments)}),t.constructor.prototype=r,o.update(t.constructor.prototype,t),t.constructor.__super__=e,t.constructor},mixin:function(){for(var e=arguments[0],t=1;t<arguments.length;t++)for(var r in arguments[t].prototype){var n=arguments[t].prototype[r];"constructor"!==r&&(e.prototype[r]=n)}return e},hideProperties:function(e,t){"function"==typeof Object.defineProperty&&o.arrayEach(t,(function(t){Object.defineProperty(e,t,{enumerable:!1,writable:!0,configurable:!0})}))},property:function(e,t,r,n,i){var o={configurable:!0,enumerable:void 0===n||n};"function"!=typeof r||i?(o.value=r,o.writable=!0):o.get=r,Object.defineProperty(e,t,o)},memoizedProperty:function(e,t,r,n){var i=null;o.property(e,t,(function(){return null===i&&(i=r()),i}),n)},hoistPayloadMember:function(e){var t=e.request,r=t.operation,n=t.service.api.operations[r],i=n.output;if(i.payload&&!n.hasEventOutput){var s=i.members[i.payload],a=e.data[i.payload];"structure"===s.type&&o.each(a,(function(t,r){o.property(e.data,t,r,!1)}))}},computeSha256:function(e,t){if(o.isNode()){var n=o.stream.Stream,i=r(19);if("function"==typeof n&&e instanceof n){if("string"!=typeof e.path)return t(new Error("Non-file stream objects are not supported with SigV4"));var s={};"number"==typeof e.start&&(s.start=e.start),"number"==typeof e.end&&(s.end=e.end),e=i.createReadStream(e.path,s)}}o.crypto.sha256(e,"hex",(function(e,r){e?t(e):t(null,r)}))},isClockSkewed:function(e){if(e)return o.property(i.config,"isClockSkewed",Math.abs((new Date).getTime()-e)>=3e5,!1),i.config.isClockSkewed},applyClockOffset:function(e){e&&(i.config.systemClockOffset=e-(new Date).getTime())},extractRequestId:function(e){var t=e.httpResponse.headers["x-amz-request-id"]||e.httpResponse.headers["x-amzn-requestid"];!t&&e.data&&e.data.ResponseMetadata&&(t=e.data.ResponseMetadata.RequestId),t&&(e.requestId=t),e.error&&(e.error.requestId=t)},addPromises:function(e,t){var r=!1;void 0===t&&i&&i.config&&(t=i.config.getPromisesDependency()),void 0===t&&"undefined"!=typeof Promise&&(t=Promise),"function"!=typeof t&&(r=!0),Array.isArray(e)||(e=[e]);for(var n=0;n<e.length;n++){var o=e[n];r?o.deletePromisesFromClass&&o.deletePromisesFromClass():o.addPromisesToClass&&o.addPromisesToClass(t)}},promisifyMethod:function(e,t){return function(){var r=this;return new t((function(t,n){r[e]((function(e,r){e?n(e):t(r)}))}))}},isDualstackAvailable:function(e){if(!e)return!1;var t=r(75);return"string"!=typeof e&&(e=e.serviceIdentifier),!("string"!=typeof e||!t.hasOwnProperty(e))&&!!t[e].dualstackAvailable},calculateRetryDelay:function(e,t){t||(t={});var r=t.customBackoff||null;if("function"==typeof r)return r(e);var n="number"==typeof t.base?t.base:100;return Math.random()*(Math.pow(2,e)*n)},handleRequestWithRetries:function(e,t,r){t||(t={});var n=i.HttpClient.getInstance(),s=t.httpOptions||{},a=0,u=function(e){var n=t.maxRetries||0;if(e&&"TimeoutError"===e.code&&(e.retryable=!0),e&&e.retryable&&a<n){a++;var i=o.calculateRetryDelay(a,t.retryDelayOptions);setTimeout(c,i+(e.retryAfter||0))}else r(e)},c=function(){var t="";n.handleRequest(e,s,(function(e){e.on("data",(function(e){t+=e.toString()})),e.on("end",(function(){var n=e.statusCode;if(n<300)r(null,t);else{var i=1e3*parseInt(e.headers["retry-after"],10)||0,s=o.error(new Error,{retryable:n>=500||429===n});i&&s.retryable&&(s.retryAfter=i),u(s)}}))}),u)};i.util.defer(c)},uuid:{v4:function(){return r(76).v4()}},convertPayloadToString:function(e){var t=e.request,r=t.operation,n=t.service.api.operations[r].output||{};n.payload&&e.data[n.payload]&&(e.data[n.payload]=e.data[n.payload].toString())},defer:function(e){"object"==typeof t&&"function"==typeof t.nextTick?t.nextTick(e):"function"==typeof n?n(e):setTimeout(e,0)},getRequestPayloadShape:function(e){var t=e.service.api.operations;if(t){var r=(t||{})[e.operation];if(r&&r.input&&r.input.payload)return r.input.members[r.input.payload]}},getProfilesFromSharedConfig:function(e,r){var n={},i={};if(t.env[o.configOptInEnv])i=e.loadFrom({isConfig:!0,filename:t.env[o.sharedConfigFileEnv]});for(var s=e.loadFrom({filename:r||t.env[o.configOptInEnv]&&t.env[o.sharedCredentialsFileEnv]}),a=0,u=Object.keys(i);a<u.length;a++)n[u[a]]=i[u[a]];for(a=0,u=Object.keys(s);a<u.length;a++)n[u[a]]=s[u[a]];return n},defaultProfile:"default",configOptInEnv:"AWS_SDK_LOAD_CONFIG",sharedCredentialsFileEnv:"AWS_SHARED_CREDENTIALS_FILE",sharedConfigFileEnv:"AWS_CONFIG_FILE",imdsDisabledEnv:"AWS_EC2_METADATA_DISABLED"};e.exports=o}).call(this,r(5),r(43).setImmediate)},function(e,t,r){(function(e,n){var i;
	/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */(function(){var o="Expected a function",s="__lodash_placeholder__",a=[["ary",128],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",32],["partialRight",64],["rearg",256]],u="[object Arguments]",c="[object Array]",f="[object Boolean]",l="[object Date]",h="[object Error]",p="[object Function]",d="[object GeneratorFunction]",v="[object Map]",m="[object Number]",g="[object Object]",y="[object RegExp]",b="[object Set]",_="[object String]",w="[object Symbol]",E="[object WeakMap]",S="[object ArrayBuffer]",A="[object DataView]",x="[object Float32Array]",I="[object Float64Array]",C="[object Int8Array]",R="[object Int16Array]",T="[object Int32Array]",k="[object Uint8Array]",P="[object Uint16Array]",O="[object Uint32Array]",L=/\b__p \+= '';/g,q=/\b(__p \+=) '' \+/g,N=/(__e\(.*?\)|\b__t\)) \+\n'';/g,j=/&(?:amp|lt|gt|quot|#39);/g,D=/[&<>"']/g,U=RegExp(j.source),M=RegExp(D.source),B=/<%-([\s\S]+?)%>/g,z=/<%([\s\S]+?)%>/g,F=/<%=([\s\S]+?)%>/g,V=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,H=/^\w*$/,W=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,K=/[\\^$.*+?()[\]{}|]/g,X=RegExp(K.source),G=/^\s+|\s+$/g,Y=/^\s+/,J=/\s+$/,$=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,Z=/\{\n\/\* \[wrapped with (.+)\] \*/,Q=/,? & /,ee=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,te=/\\(\\)?/g,re=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,ne=/\w*$/,ie=/^[-+]0x[0-9a-f]+$/i,oe=/^0b[01]+$/i,se=/^\[object .+?Constructor\]$/,ae=/^0o[0-7]+$/i,ue=/^(?:0|[1-9]\d*)$/,ce=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,fe=/($^)/,le=/['\n\r\u2028\u2029\\]/g,he="\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",pe="\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",de="[\\ud800-\\udfff]",ve="["+pe+"]",me="["+he+"]",ge="\\d+",ye="[\\u2700-\\u27bf]",be="[a-z\\xdf-\\xf6\\xf8-\\xff]",_e="[^\\ud800-\\udfff"+pe+ge+"\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",we="\\ud83c[\\udffb-\\udfff]",Ee="[^\\ud800-\\udfff]",Se="(?:\\ud83c[\\udde6-\\uddff]){2}",Ae="[\\ud800-\\udbff][\\udc00-\\udfff]",xe="[A-Z\\xc0-\\xd6\\xd8-\\xde]",Ie="(?:"+be+"|"+_e+")",Ce="(?:"+xe+"|"+_e+")",Re="(?:"+me+"|"+we+")"+"?",Te="[\\ufe0e\\ufe0f]?"+Re+("(?:\\u200d(?:"+[Ee,Se,Ae].join("|")+")[\\ufe0e\\ufe0f]?"+Re+")*"),ke="(?:"+[ye,Se,Ae].join("|")+")"+Te,Pe="(?:"+[Ee+me+"?",me,Se,Ae,de].join("|")+")",Oe=RegExp("['’]","g"),Le=RegExp(me,"g"),qe=RegExp(we+"(?="+we+")|"+Pe+Te,"g"),Ne=RegExp([xe+"?"+be+"+(?:['’](?:d|ll|m|re|s|t|ve))?(?="+[ve,xe,"$"].join("|")+")",Ce+"+(?:['’](?:D|LL|M|RE|S|T|VE))?(?="+[ve,xe+Ie,"$"].join("|")+")",xe+"?"+Ie+"+(?:['’](?:d|ll|m|re|s|t|ve))?",xe+"+(?:['’](?:D|LL|M|RE|S|T|VE))?","\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])","\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",ge,ke].join("|"),"g"),je=RegExp("[\\u200d\\ud800-\\udfff"+he+"\\ufe0e\\ufe0f]"),De=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,Ue=["Array","Buffer","DataView","Date","Error","Float32Array","Float64Array","Function","Int8Array","Int16Array","Int32Array","Map","Math","Object","Promise","RegExp","Set","String","Symbol","TypeError","Uint8Array","Uint8ClampedArray","Uint16Array","Uint32Array","WeakMap","_","clearTimeout","isFinite","parseInt","setTimeout"],Me=-1,Be={};Be[x]=Be[I]=Be[C]=Be[R]=Be[T]=Be[k]=Be["[object Uint8ClampedArray]"]=Be[P]=Be[O]=!0,Be[u]=Be[c]=Be[S]=Be[f]=Be[A]=Be[l]=Be[h]=Be[p]=Be[v]=Be[m]=Be[g]=Be[y]=Be[b]=Be[_]=Be[E]=!1;var ze={};ze[u]=ze[c]=ze[S]=ze[A]=ze[f]=ze[l]=ze[x]=ze[I]=ze[C]=ze[R]=ze[T]=ze[v]=ze[m]=ze[g]=ze[y]=ze[b]=ze[_]=ze[w]=ze[k]=ze["[object Uint8ClampedArray]"]=ze[P]=ze[O]=!0,ze[h]=ze[p]=ze[E]=!1;var Fe={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Ve=parseFloat,He=parseInt,We="object"==typeof e&&e&&e.Object===Object&&e,Ke="object"==typeof self&&self&&self.Object===Object&&self,Xe=We||Ke||Function("return this")(),Ge=t&&!t.nodeType&&t,Ye=Ge&&"object"==typeof n&&n&&!n.nodeType&&n,Je=Ye&&Ye.exports===Ge,$e=Je&&We.process,Ze=function(){try{var e=Ye&&Ye.require&&Ye.require("util").types;return e||$e&&$e.binding&&$e.binding("util")}catch(e){}}(),Qe=Ze&&Ze.isArrayBuffer,et=Ze&&Ze.isDate,tt=Ze&&Ze.isMap,rt=Ze&&Ze.isRegExp,nt=Ze&&Ze.isSet,it=Ze&&Ze.isTypedArray;function ot(e,t,r){switch(r.length){case 0:return e.call(t);case 1:return e.call(t,r[0]);case 2:return e.call(t,r[0],r[1]);case 3:return e.call(t,r[0],r[1],r[2])}return e.apply(t,r)}function st(e,t,r,n){for(var i=-1,o=null==e?0:e.length;++i<o;){var s=e[i];t(n,s,r(s),e)}return n}function at(e,t){for(var r=-1,n=null==e?0:e.length;++r<n&&!1!==t(e[r],r,e););return e}function ut(e,t){for(var r=null==e?0:e.length;r--&&!1!==t(e[r],r,e););return e}function ct(e,t){for(var r=-1,n=null==e?0:e.length;++r<n;)if(!t(e[r],r,e))return!1;return!0}function ft(e,t){for(var r=-1,n=null==e?0:e.length,i=0,o=[];++r<n;){var s=e[r];t(s,r,e)&&(o[i++]=s)}return o}function lt(e,t){return!!(null==e?0:e.length)&&wt(e,t,0)>-1}function ht(e,t,r){for(var n=-1,i=null==e?0:e.length;++n<i;)if(r(t,e[n]))return!0;return!1}function pt(e,t){for(var r=-1,n=null==e?0:e.length,i=Array(n);++r<n;)i[r]=t(e[r],r,e);return i}function dt(e,t){for(var r=-1,n=t.length,i=e.length;++r<n;)e[i+r]=t[r];return e}function vt(e,t,r,n){var i=-1,o=null==e?0:e.length;for(n&&o&&(r=e[++i]);++i<o;)r=t(r,e[i],i,e);return r}function mt(e,t,r,n){var i=null==e?0:e.length;for(n&&i&&(r=e[--i]);i--;)r=t(r,e[i],i,e);return r}function gt(e,t){for(var r=-1,n=null==e?0:e.length;++r<n;)if(t(e[r],r,e))return!0;return!1}var yt=xt("length");function bt(e,t,r){var n;return r(e,(function(e,r,i){if(t(e,r,i))return n=r,!1})),n}function _t(e,t,r,n){for(var i=e.length,o=r+(n?1:-1);n?o--:++o<i;)if(t(e[o],o,e))return o;return-1}function wt(e,t,r){return t==t?function(e,t,r){var n=r-1,i=e.length;for(;++n<i;)if(e[n]===t)return n;return-1}(e,t,r):_t(e,St,r)}function Et(e,t,r,n){for(var i=r-1,o=e.length;++i<o;)if(n(e[i],t))return i;return-1}function St(e){return e!=e}function At(e,t){var r=null==e?0:e.length;return r?Rt(e,t)/r:NaN}function xt(e){return function(t){return null==t?void 0:t[e]}}function It(e){return function(t){return null==e?void 0:e[t]}}function Ct(e,t,r,n,i){return i(e,(function(e,i,o){r=n?(n=!1,e):t(r,e,i,o)})),r}function Rt(e,t){for(var r,n=-1,i=e.length;++n<i;){var o=t(e[n]);void 0!==o&&(r=void 0===r?o:r+o)}return r}function Tt(e,t){for(var r=-1,n=Array(e);++r<e;)n[r]=t(r);return n}function kt(e){return function(t){return e(t)}}function Pt(e,t){return pt(t,(function(t){return e[t]}))}function Ot(e,t){return e.has(t)}function Lt(e,t){for(var r=-1,n=e.length;++r<n&&wt(t,e[r],0)>-1;);return r}function qt(e,t){for(var r=e.length;r--&&wt(t,e[r],0)>-1;);return r}function Nt(e,t){for(var r=e.length,n=0;r--;)e[r]===t&&++n;return n}var jt=It({"À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","Ç":"C","ç":"c","Ð":"D","ð":"d","È":"E","É":"E","Ê":"E","Ë":"E","è":"e","é":"e","ê":"e","ë":"e","Ì":"I","Í":"I","Î":"I","Ï":"I","ì":"i","í":"i","î":"i","ï":"i","Ñ":"N","ñ":"n","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","Ù":"U","Ú":"U","Û":"U","Ü":"U","ù":"u","ú":"u","û":"u","ü":"u","Ý":"Y","ý":"y","ÿ":"y","Æ":"Ae","æ":"ae","Þ":"Th","þ":"th","ß":"ss","Ā":"A","Ă":"A","Ą":"A","ā":"a","ă":"a","ą":"a","Ć":"C","Ĉ":"C","Ċ":"C","Č":"C","ć":"c","ĉ":"c","ċ":"c","č":"c","Ď":"D","Đ":"D","ď":"d","đ":"d","Ē":"E","Ĕ":"E","Ė":"E","Ę":"E","Ě":"E","ē":"e","ĕ":"e","ė":"e","ę":"e","ě":"e","Ĝ":"G","Ğ":"G","Ġ":"G","Ģ":"G","ĝ":"g","ğ":"g","ġ":"g","ģ":"g","Ĥ":"H","Ħ":"H","ĥ":"h","ħ":"h","Ĩ":"I","Ī":"I","Ĭ":"I","Į":"I","İ":"I","ĩ":"i","ī":"i","ĭ":"i","į":"i","ı":"i","Ĵ":"J","ĵ":"j","Ķ":"K","ķ":"k","ĸ":"k","Ĺ":"L","Ļ":"L","Ľ":"L","Ŀ":"L","Ł":"L","ĺ":"l","ļ":"l","ľ":"l","ŀ":"l","ł":"l","Ń":"N","Ņ":"N","Ň":"N","Ŋ":"N","ń":"n","ņ":"n","ň":"n","ŋ":"n","Ō":"O","Ŏ":"O","Ő":"O","ō":"o","ŏ":"o","ő":"o","Ŕ":"R","Ŗ":"R","Ř":"R","ŕ":"r","ŗ":"r","ř":"r","Ś":"S","Ŝ":"S","Ş":"S","Š":"S","ś":"s","ŝ":"s","ş":"s","š":"s","Ţ":"T","Ť":"T","Ŧ":"T","ţ":"t","ť":"t","ŧ":"t","Ũ":"U","Ū":"U","Ŭ":"U","Ů":"U","Ű":"U","Ų":"U","ũ":"u","ū":"u","ŭ":"u","ů":"u","ű":"u","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","Ż":"Z","Ž":"Z","ź":"z","ż":"z","ž":"z","Ĳ":"IJ","ĳ":"ij","Œ":"Oe","œ":"oe","ŉ":"'n","ſ":"s"}),Dt=It({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"});function Ut(e){return"\\"+Fe[e]}function Mt(e){return je.test(e)}function Bt(e){var t=-1,r=Array(e.size);return e.forEach((function(e,n){r[++t]=[n,e]})),r}function zt(e,t){return function(r){return e(t(r))}}function Ft(e,t){for(var r=-1,n=e.length,i=0,o=[];++r<n;){var a=e[r];a!==t&&a!==s||(e[r]=s,o[i++]=r)}return o}function Vt(e){var t=-1,r=Array(e.size);return e.forEach((function(e){r[++t]=e})),r}function Ht(e){var t=-1,r=Array(e.size);return e.forEach((function(e){r[++t]=[e,e]})),r}function Wt(e){return Mt(e)?function(e){var t=qe.lastIndex=0;for(;qe.test(e);)++t;return t}(e):yt(e)}function Kt(e){return Mt(e)?function(e){return e.match(qe)||[]}(e):function(e){return e.split("")}(e)}var Xt=It({"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"});var Gt=function e(t){var r,n=(t=null==t?Xe:Gt.defaults(Xe.Object(),t,Gt.pick(Xe,Ue))).Array,i=t.Date,he=t.Error,pe=t.Function,de=t.Math,ve=t.Object,me=t.RegExp,ge=t.String,ye=t.TypeError,be=n.prototype,_e=pe.prototype,we=ve.prototype,Ee=t["__core-js_shared__"],Se=_e.toString,Ae=we.hasOwnProperty,xe=0,Ie=(r=/[^.]+$/.exec(Ee&&Ee.keys&&Ee.keys.IE_PROTO||""))?"Symbol(src)_1."+r:"",Ce=we.toString,Re=Se.call(ve),Te=Xe._,ke=me("^"+Se.call(Ae).replace(K,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),Pe=Je?t.Buffer:void 0,qe=t.Symbol,je=t.Uint8Array,Fe=Pe?Pe.allocUnsafe:void 0,We=zt(ve.getPrototypeOf,ve),Ke=ve.create,Ge=we.propertyIsEnumerable,Ye=be.splice,$e=qe?qe.isConcatSpreadable:void 0,Ze=qe?qe.iterator:void 0,yt=qe?qe.toStringTag:void 0,It=function(){try{var e=Qi(ve,"defineProperty");return e({},"",{}),e}catch(e){}}(),Yt=t.clearTimeout!==Xe.clearTimeout&&t.clearTimeout,Jt=i&&i.now!==Xe.Date.now&&i.now,$t=t.setTimeout!==Xe.setTimeout&&t.setTimeout,Zt=de.ceil,Qt=de.floor,er=ve.getOwnPropertySymbols,tr=Pe?Pe.isBuffer:void 0,rr=t.isFinite,nr=be.join,ir=zt(ve.keys,ve),or=de.max,sr=de.min,ar=i.now,ur=t.parseInt,cr=de.random,fr=be.reverse,lr=Qi(t,"DataView"),hr=Qi(t,"Map"),pr=Qi(t,"Promise"),dr=Qi(t,"Set"),vr=Qi(t,"WeakMap"),mr=Qi(ve,"create"),gr=vr&&new vr,yr={},br=Co(lr),_r=Co(hr),wr=Co(pr),Er=Co(dr),Sr=Co(vr),Ar=qe?qe.prototype:void 0,xr=Ar?Ar.valueOf:void 0,Ir=Ar?Ar.toString:void 0;function Cr(e){if(Hs(e)&&!Ls(e)&&!(e instanceof Pr)){if(e instanceof kr)return e;if(Ae.call(e,"__wrapped__"))return Ro(e)}return new kr(e)}var Rr=function(){function e(){}return function(t){if(!Vs(t))return{};if(Ke)return Ke(t);e.prototype=t;var r=new e;return e.prototype=void 0,r}}();function Tr(){}function kr(e,t){this.__wrapped__=e,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=void 0}function Pr(e){this.__wrapped__=e,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=4294967295,this.__views__=[]}function Or(e){var t=-1,r=null==e?0:e.length;for(this.clear();++t<r;){var n=e[t];this.set(n[0],n[1])}}function Lr(e){var t=-1,r=null==e?0:e.length;for(this.clear();++t<r;){var n=e[t];this.set(n[0],n[1])}}function qr(e){var t=-1,r=null==e?0:e.length;for(this.clear();++t<r;){var n=e[t];this.set(n[0],n[1])}}function Nr(e){var t=-1,r=null==e?0:e.length;for(this.__data__=new qr;++t<r;)this.add(e[t])}function jr(e){var t=this.__data__=new Lr(e);this.size=t.size}function Dr(e,t){var r=Ls(e),n=!r&&Os(e),i=!r&&!n&&Ds(e),o=!r&&!n&&!i&&Zs(e),s=r||n||i||o,a=s?Tt(e.length,ge):[],u=a.length;for(var c in e)!t&&!Ae.call(e,c)||s&&("length"==c||i&&("offset"==c||"parent"==c)||o&&("buffer"==c||"byteLength"==c||"byteOffset"==c)||so(c,u))||a.push(c);return a}function Ur(e){var t=e.length;return t?e[jn(0,t-1)]:void 0}function Mr(e,t){return Ao(gi(e),Gr(t,0,e.length))}function Br(e){return Ao(gi(e))}function zr(e,t,r){(void 0===r||Ts(e[t],r))&&(void 0!==r||t in e)||Kr(e,t,r)}function Fr(e,t,r){var n=e[t];Ae.call(e,t)&&Ts(n,r)&&(void 0!==r||t in e)||Kr(e,t,r)}function Vr(e,t){for(var r=e.length;r--;)if(Ts(e[r][0],t))return r;return-1}function Hr(e,t,r,n){return Qr(e,(function(e,i,o){t(n,e,r(e),o)})),n}function Wr(e,t){return e&&yi(t,_a(t),e)}function Kr(e,t,r){"__proto__"==t&&It?It(e,t,{configurable:!0,enumerable:!0,value:r,writable:!0}):e[t]=r}function Xr(e,t){for(var r=-1,i=t.length,o=n(i),s=null==e;++r<i;)o[r]=s?void 0:va(e,t[r]);return o}function Gr(e,t,r){return e==e&&(void 0!==r&&(e=e<=r?e:r),void 0!==t&&(e=e>=t?e:t)),e}function Yr(e,t,r,n,i,o){var s,a=1&t,c=2&t,h=4&t;if(r&&(s=i?r(e,n,i,o):r(e)),void 0!==s)return s;if(!Vs(e))return e;var E=Ls(e);if(E){if(s=function(e){var t=e.length,r=new e.constructor(t);t&&"string"==typeof e[0]&&Ae.call(e,"index")&&(r.index=e.index,r.input=e.input);return r}(e),!a)return gi(e,s)}else{var L=ro(e),q=L==p||L==d;if(Ds(e))return li(e,a);if(L==g||L==u||q&&!i){if(s=c||q?{}:io(e),!a)return c?function(e,t){return yi(e,to(e),t)}(e,function(e,t){return e&&yi(t,wa(t),e)}(s,e)):function(e,t){return yi(e,eo(e),t)}(e,Wr(s,e))}else{if(!ze[L])return i?e:{};s=function(e,t,r){var n=e.constructor;switch(t){case S:return hi(e);case f:case l:return new n(+e);case A:return function(e,t){var r=t?hi(e.buffer):e.buffer;return new e.constructor(r,e.byteOffset,e.byteLength)}(e,r);case x:case I:case C:case R:case T:case k:case"[object Uint8ClampedArray]":case P:case O:return pi(e,r);case v:return new n;case m:case _:return new n(e);case y:return function(e){var t=new e.constructor(e.source,ne.exec(e));return t.lastIndex=e.lastIndex,t}(e);case b:return new n;case w:return i=e,xr?ve(xr.call(i)):{}}var i}(e,L,a)}}o||(o=new jr);var N=o.get(e);if(N)return N;o.set(e,s),Ys(e)?e.forEach((function(n){s.add(Yr(n,t,r,n,e,o))})):Ws(e)&&e.forEach((function(n,i){s.set(i,Yr(n,t,r,i,e,o))}));var j=E?void 0:(h?c?Ki:Wi:c?wa:_a)(e);return at(j||e,(function(n,i){j&&(n=e[i=n]),Fr(s,i,Yr(n,t,r,i,e,o))})),s}function Jr(e,t,r){var n=r.length;if(null==e)return!n;for(e=ve(e);n--;){var i=r[n],o=t[i],s=e[i];if(void 0===s&&!(i in e)||!o(s))return!1}return!0}function $r(e,t,r){if("function"!=typeof e)throw new ye(o);return _o((function(){e.apply(void 0,r)}),t)}function Zr(e,t,r,n){var i=-1,o=lt,s=!0,a=e.length,u=[],c=t.length;if(!a)return u;r&&(t=pt(t,kt(r))),n?(o=ht,s=!1):t.length>=200&&(o=Ot,s=!1,t=new Nr(t));e:for(;++i<a;){var f=e[i],l=null==r?f:r(f);if(f=n||0!==f?f:0,s&&l==l){for(var h=c;h--;)if(t[h]===l)continue e;u.push(f)}else o(t,l,n)||u.push(f)}return u}Cr.templateSettings={escape:B,evaluate:z,interpolate:F,variable:"",imports:{_:Cr}},Cr.prototype=Tr.prototype,Cr.prototype.constructor=Cr,kr.prototype=Rr(Tr.prototype),kr.prototype.constructor=kr,Pr.prototype=Rr(Tr.prototype),Pr.prototype.constructor=Pr,Or.prototype.clear=function(){this.__data__=mr?mr(null):{},this.size=0},Or.prototype.delete=function(e){var t=this.has(e)&&delete this.__data__[e];return this.size-=t?1:0,t},Or.prototype.get=function(e){var t=this.__data__;if(mr){var r=t[e];return"__lodash_hash_undefined__"===r?void 0:r}return Ae.call(t,e)?t[e]:void 0},Or.prototype.has=function(e){var t=this.__data__;return mr?void 0!==t[e]:Ae.call(t,e)},Or.prototype.set=function(e,t){var r=this.__data__;return this.size+=this.has(e)?0:1,r[e]=mr&&void 0===t?"__lodash_hash_undefined__":t,this},Lr.prototype.clear=function(){this.__data__=[],this.size=0},Lr.prototype.delete=function(e){var t=this.__data__,r=Vr(t,e);return!(r<0)&&(r==t.length-1?t.pop():Ye.call(t,r,1),--this.size,!0)},Lr.prototype.get=function(e){var t=this.__data__,r=Vr(t,e);return r<0?void 0:t[r][1]},Lr.prototype.has=function(e){return Vr(this.__data__,e)>-1},Lr.prototype.set=function(e,t){var r=this.__data__,n=Vr(r,e);return n<0?(++this.size,r.push([e,t])):r[n][1]=t,this},qr.prototype.clear=function(){this.size=0,this.__data__={hash:new Or,map:new(hr||Lr),string:new Or}},qr.prototype.delete=function(e){var t=$i(this,e).delete(e);return this.size-=t?1:0,t},qr.prototype.get=function(e){return $i(this,e).get(e)},qr.prototype.has=function(e){return $i(this,e).has(e)},qr.prototype.set=function(e,t){var r=$i(this,e),n=r.size;return r.set(e,t),this.size+=r.size==n?0:1,this},Nr.prototype.add=Nr.prototype.push=function(e){return this.__data__.set(e,"__lodash_hash_undefined__"),this},Nr.prototype.has=function(e){return this.__data__.has(e)},jr.prototype.clear=function(){this.__data__=new Lr,this.size=0},jr.prototype.delete=function(e){var t=this.__data__,r=t.delete(e);return this.size=t.size,r},jr.prototype.get=function(e){return this.__data__.get(e)},jr.prototype.has=function(e){return this.__data__.has(e)},jr.prototype.set=function(e,t){var r=this.__data__;if(r instanceof Lr){var n=r.__data__;if(!hr||n.length<199)return n.push([e,t]),this.size=++r.size,this;r=this.__data__=new qr(n)}return r.set(e,t),this.size=r.size,this};var Qr=wi(un),en=wi(cn,!0);function tn(e,t){var r=!0;return Qr(e,(function(e,n,i){return r=!!t(e,n,i)})),r}function rn(e,t,r){for(var n=-1,i=e.length;++n<i;){var o=e[n],s=t(o);if(null!=s&&(void 0===a?s==s&&!$s(s):r(s,a)))var a=s,u=o}return u}function nn(e,t){var r=[];return Qr(e,(function(e,n,i){t(e,n,i)&&r.push(e)})),r}function on(e,t,r,n,i){var o=-1,s=e.length;for(r||(r=oo),i||(i=[]);++o<s;){var a=e[o];t>0&&r(a)?t>1?on(a,t-1,r,n,i):dt(i,a):n||(i[i.length]=a)}return i}var sn=Ei(),an=Ei(!0);function un(e,t){return e&&sn(e,t,_a)}function cn(e,t){return e&&an(e,t,_a)}function fn(e,t){return ft(t,(function(t){return Bs(e[t])}))}function ln(e,t){for(var r=0,n=(t=ai(t,e)).length;null!=e&&r<n;)e=e[Io(t[r++])];return r&&r==n?e:void 0}function hn(e,t,r){var n=t(e);return Ls(e)?n:dt(n,r(e))}function pn(e){return null==e?void 0===e?"[object Undefined]":"[object Null]":yt&&yt in ve(e)?function(e){var t=Ae.call(e,yt),r=e[yt];try{e[yt]=void 0;var n=!0}catch(e){}var i=Ce.call(e);n&&(t?e[yt]=r:delete e[yt]);return i}(e):function(e){return Ce.call(e)}(e)}function dn(e,t){return e>t}function vn(e,t){return null!=e&&Ae.call(e,t)}function mn(e,t){return null!=e&&t in ve(e)}function gn(e,t,r){for(var i=r?ht:lt,o=e[0].length,s=e.length,a=s,u=n(s),c=1/0,f=[];a--;){var l=e[a];a&&t&&(l=pt(l,kt(t))),c=sr(l.length,c),u[a]=!r&&(t||o>=120&&l.length>=120)?new Nr(a&&l):void 0}l=e[0];var h=-1,p=u[0];e:for(;++h<o&&f.length<c;){var d=l[h],v=t?t(d):d;if(d=r||0!==d?d:0,!(p?Ot(p,v):i(f,v,r))){for(a=s;--a;){var m=u[a];if(!(m?Ot(m,v):i(e[a],v,r)))continue e}p&&p.push(v),f.push(d)}}return f}function yn(e,t,r){var n=null==(e=mo(e,t=ai(t,e)))?e:e[Io(Mo(t))];return null==n?void 0:ot(n,e,r)}function bn(e){return Hs(e)&&pn(e)==u}function _n(e,t,r,n,i){return e===t||(null==e||null==t||!Hs(e)&&!Hs(t)?e!=e&&t!=t:function(e,t,r,n,i,o){var s=Ls(e),a=Ls(t),p=s?c:ro(e),d=a?c:ro(t),E=(p=p==u?g:p)==g,x=(d=d==u?g:d)==g,I=p==d;if(I&&Ds(e)){if(!Ds(t))return!1;s=!0,E=!1}if(I&&!E)return o||(o=new jr),s||Zs(e)?Vi(e,t,r,n,i,o):function(e,t,r,n,i,o,s){switch(r){case A:if(e.byteLength!=t.byteLength||e.byteOffset!=t.byteOffset)return!1;e=e.buffer,t=t.buffer;case S:return!(e.byteLength!=t.byteLength||!o(new je(e),new je(t)));case f:case l:case m:return Ts(+e,+t);case h:return e.name==t.name&&e.message==t.message;case y:case _:return e==t+"";case v:var a=Bt;case b:var u=1&n;if(a||(a=Vt),e.size!=t.size&&!u)return!1;var c=s.get(e);if(c)return c==t;n|=2,s.set(e,t);var p=Vi(a(e),a(t),n,i,o,s);return s.delete(e),p;case w:if(xr)return xr.call(e)==xr.call(t)}return!1}(e,t,p,r,n,i,o);if(!(1&r)){var C=E&&Ae.call(e,"__wrapped__"),R=x&&Ae.call(t,"__wrapped__");if(C||R){var T=C?e.value():e,k=R?t.value():t;return o||(o=new jr),i(T,k,r,n,o)}}if(!I)return!1;return o||(o=new jr),function(e,t,r,n,i,o){var s=1&r,a=Wi(e),u=a.length,c=Wi(t).length;if(u!=c&&!s)return!1;var f=u;for(;f--;){var l=a[f];if(!(s?l in t:Ae.call(t,l)))return!1}var h=o.get(e);if(h&&o.get(t))return h==t;var p=!0;o.set(e,t),o.set(t,e);var d=s;for(;++f<u;){l=a[f];var v=e[l],m=t[l];if(n)var g=s?n(m,v,l,t,e,o):n(v,m,l,e,t,o);if(!(void 0===g?v===m||i(v,m,r,n,o):g)){p=!1;break}d||(d="constructor"==l)}if(p&&!d){var y=e.constructor,b=t.constructor;y!=b&&"constructor"in e&&"constructor"in t&&!("function"==typeof y&&y instanceof y&&"function"==typeof b&&b instanceof b)&&(p=!1)}return o.delete(e),o.delete(t),p}(e,t,r,n,i,o)}(e,t,r,n,_n,i))}function wn(e,t,r,n){var i=r.length,o=i,s=!n;if(null==e)return!o;for(e=ve(e);i--;){var a=r[i];if(s&&a[2]?a[1]!==e[a[0]]:!(a[0]in e))return!1}for(;++i<o;){var u=(a=r[i])[0],c=e[u],f=a[1];if(s&&a[2]){if(void 0===c&&!(u in e))return!1}else{var l=new jr;if(n)var h=n(c,f,u,e,t,l);if(!(void 0===h?_n(f,c,3,n,l):h))return!1}}return!0}function En(e){return!(!Vs(e)||(t=e,Ie&&Ie in t))&&(Bs(e)?ke:se).test(Co(e));var t}function Sn(e){return"function"==typeof e?e:null==e?Ka:"object"==typeof e?Ls(e)?Tn(e[0],e[1]):Rn(e):tu(e)}function An(e){if(!lo(e))return ir(e);var t=[];for(var r in ve(e))Ae.call(e,r)&&"constructor"!=r&&t.push(r);return t}function xn(e){if(!Vs(e))return function(e){var t=[];if(null!=e)for(var r in ve(e))t.push(r);return t}(e);var t=lo(e),r=[];for(var n in e)("constructor"!=n||!t&&Ae.call(e,n))&&r.push(n);return r}function In(e,t){return e<t}function Cn(e,t){var r=-1,i=Ns(e)?n(e.length):[];return Qr(e,(function(e,n,o){i[++r]=t(e,n,o)})),i}function Rn(e){var t=Zi(e);return 1==t.length&&t[0][2]?po(t[0][0],t[0][1]):function(r){return r===e||wn(r,e,t)}}function Tn(e,t){return uo(e)&&ho(t)?po(Io(e),t):function(r){var n=va(r,e);return void 0===n&&n===t?ma(r,e):_n(t,n,3)}}function kn(e,t,r,n,i){e!==t&&sn(t,(function(o,s){if(i||(i=new jr),Vs(o))!function(e,t,r,n,i,o,s){var a=yo(e,r),u=yo(t,r),c=s.get(u);if(c)return void zr(e,r,c);var f=o?o(a,u,r+"",e,t,s):void 0,l=void 0===f;if(l){var h=Ls(u),p=!h&&Ds(u),d=!h&&!p&&Zs(u);f=u,h||p||d?Ls(a)?f=a:js(a)?f=gi(a):p?(l=!1,f=li(u,!0)):d?(l=!1,f=pi(u,!0)):f=[]:Xs(u)||Os(u)?(f=a,Os(a)?f=sa(a):Vs(a)&&!Bs(a)||(f=io(u))):l=!1}l&&(s.set(u,f),i(f,u,n,o,s),s.delete(u));zr(e,r,f)}(e,t,s,r,kn,n,i);else{var a=n?n(yo(e,s),o,s+"",e,t,i):void 0;void 0===a&&(a=o),zr(e,s,a)}}),wa)}function Pn(e,t){var r=e.length;if(r)return so(t+=t<0?r:0,r)?e[t]:void 0}function On(e,t,r){var n=-1;return t=pt(t.length?t:[Ka],kt(Ji())),function(e,t){var r=e.length;for(e.sort(t);r--;)e[r]=e[r].value;return e}(Cn(e,(function(e,r,i){return{criteria:pt(t,(function(t){return t(e)})),index:++n,value:e}})),(function(e,t){return function(e,t,r){var n=-1,i=e.criteria,o=t.criteria,s=i.length,a=r.length;for(;++n<s;){var u=di(i[n],o[n]);if(u){if(n>=a)return u;var c=r[n];return u*("desc"==c?-1:1)}}return e.index-t.index}(e,t,r)}))}function Ln(e,t,r){for(var n=-1,i=t.length,o={};++n<i;){var s=t[n],a=ln(e,s);r(a,s)&&zn(o,ai(s,e),a)}return o}function qn(e,t,r,n){var i=n?Et:wt,o=-1,s=t.length,a=e;for(e===t&&(t=gi(t)),r&&(a=pt(e,kt(r)));++o<s;)for(var u=0,c=t[o],f=r?r(c):c;(u=i(a,f,u,n))>-1;)a!==e&&Ye.call(a,u,1),Ye.call(e,u,1);return e}function Nn(e,t){for(var r=e?t.length:0,n=r-1;r--;){var i=t[r];if(r==n||i!==o){var o=i;so(i)?Ye.call(e,i,1):Qn(e,i)}}return e}function jn(e,t){return e+Qt(cr()*(t-e+1))}function Dn(e,t){var r="";if(!e||t<1||t>9007199254740991)return r;do{t%2&&(r+=e),(t=Qt(t/2))&&(e+=e)}while(t);return r}function Un(e,t){return wo(vo(e,t,Ka),e+"")}function Mn(e){return Ur(Ta(e))}function Bn(e,t){var r=Ta(e);return Ao(r,Gr(t,0,r.length))}function zn(e,t,r,n){if(!Vs(e))return e;for(var i=-1,o=(t=ai(t,e)).length,s=o-1,a=e;null!=a&&++i<o;){var u=Io(t[i]),c=r;if(i!=s){var f=a[u];void 0===(c=n?n(f,u,a):void 0)&&(c=Vs(f)?f:so(t[i+1])?[]:{})}Fr(a,u,c),a=a[u]}return e}var Fn=gr?function(e,t){return gr.set(e,t),e}:Ka,Vn=It?function(e,t){return It(e,"toString",{configurable:!0,enumerable:!1,value:Va(t),writable:!0})}:Ka;function Hn(e){return Ao(Ta(e))}function Wn(e,t,r){var i=-1,o=e.length;t<0&&(t=-t>o?0:o+t),(r=r>o?o:r)<0&&(r+=o),o=t>r?0:r-t>>>0,t>>>=0;for(var s=n(o);++i<o;)s[i]=e[i+t];return s}function Kn(e,t){var r;return Qr(e,(function(e,n,i){return!(r=t(e,n,i))})),!!r}function Xn(e,t,r){var n=0,i=null==e?n:e.length;if("number"==typeof t&&t==t&&i<=2147483647){for(;n<i;){var o=n+i>>>1,s=e[o];null!==s&&!$s(s)&&(r?s<=t:s<t)?n=o+1:i=o}return i}return Gn(e,t,Ka,r)}function Gn(e,t,r,n){t=r(t);for(var i=0,o=null==e?0:e.length,s=t!=t,a=null===t,u=$s(t),c=void 0===t;i<o;){var f=Qt((i+o)/2),l=r(e[f]),h=void 0!==l,p=null===l,d=l==l,v=$s(l);if(s)var m=n||d;else m=c?d&&(n||h):a?d&&h&&(n||!p):u?d&&h&&!p&&(n||!v):!p&&!v&&(n?l<=t:l<t);m?i=f+1:o=f}return sr(o,4294967294)}function Yn(e,t){for(var r=-1,n=e.length,i=0,o=[];++r<n;){var s=e[r],a=t?t(s):s;if(!r||!Ts(a,u)){var u=a;o[i++]=0===s?0:s}}return o}function Jn(e){return"number"==typeof e?e:$s(e)?NaN:+e}function $n(e){if("string"==typeof e)return e;if(Ls(e))return pt(e,$n)+"";if($s(e))return Ir?Ir.call(e):"";var t=e+"";return"0"==t&&1/e==-1/0?"-0":t}function Zn(e,t,r){var n=-1,i=lt,o=e.length,s=!0,a=[],u=a;if(r)s=!1,i=ht;else if(o>=200){var c=t?null:Di(e);if(c)return Vt(c);s=!1,i=Ot,u=new Nr}else u=t?[]:a;e:for(;++n<o;){var f=e[n],l=t?t(f):f;if(f=r||0!==f?f:0,s&&l==l){for(var h=u.length;h--;)if(u[h]===l)continue e;t&&u.push(l),a.push(f)}else i(u,l,r)||(u!==a&&u.push(l),a.push(f))}return a}function Qn(e,t){return null==(e=mo(e,t=ai(t,e)))||delete e[Io(Mo(t))]}function ei(e,t,r,n){return zn(e,t,r(ln(e,t)),n)}function ti(e,t,r,n){for(var i=e.length,o=n?i:-1;(n?o--:++o<i)&&t(e[o],o,e););return r?Wn(e,n?0:o,n?o+1:i):Wn(e,n?o+1:0,n?i:o)}function ri(e,t){var r=e;return r instanceof Pr&&(r=r.value()),vt(t,(function(e,t){return t.func.apply(t.thisArg,dt([e],t.args))}),r)}function ni(e,t,r){var i=e.length;if(i<2)return i?Zn(e[0]):[];for(var o=-1,s=n(i);++o<i;)for(var a=e[o],u=-1;++u<i;)u!=o&&(s[o]=Zr(s[o]||a,e[u],t,r));return Zn(on(s,1),t,r)}function ii(e,t,r){for(var n=-1,i=e.length,o=t.length,s={};++n<i;){var a=n<o?t[n]:void 0;r(s,e[n],a)}return s}function oi(e){return js(e)?e:[]}function si(e){return"function"==typeof e?e:Ka}function ai(e,t){return Ls(e)?e:uo(e,t)?[e]:xo(aa(e))}var ui=Un;function ci(e,t,r){var n=e.length;return r=void 0===r?n:r,!t&&r>=n?e:Wn(e,t,r)}var fi=Yt||function(e){return Xe.clearTimeout(e)};function li(e,t){if(t)return e.slice();var r=e.length,n=Fe?Fe(r):new e.constructor(r);return e.copy(n),n}function hi(e){var t=new e.constructor(e.byteLength);return new je(t).set(new je(e)),t}function pi(e,t){var r=t?hi(e.buffer):e.buffer;return new e.constructor(r,e.byteOffset,e.length)}function di(e,t){if(e!==t){var r=void 0!==e,n=null===e,i=e==e,o=$s(e),s=void 0!==t,a=null===t,u=t==t,c=$s(t);if(!a&&!c&&!o&&e>t||o&&s&&u&&!a&&!c||n&&s&&u||!r&&u||!i)return 1;if(!n&&!o&&!c&&e<t||c&&r&&i&&!n&&!o||a&&r&&i||!s&&i||!u)return-1}return 0}function vi(e,t,r,i){for(var o=-1,s=e.length,a=r.length,u=-1,c=t.length,f=or(s-a,0),l=n(c+f),h=!i;++u<c;)l[u]=t[u];for(;++o<a;)(h||o<s)&&(l[r[o]]=e[o]);for(;f--;)l[u++]=e[o++];return l}function mi(e,t,r,i){for(var o=-1,s=e.length,a=-1,u=r.length,c=-1,f=t.length,l=or(s-u,0),h=n(l+f),p=!i;++o<l;)h[o]=e[o];for(var d=o;++c<f;)h[d+c]=t[c];for(;++a<u;)(p||o<s)&&(h[d+r[a]]=e[o++]);return h}function gi(e,t){var r=-1,i=e.length;for(t||(t=n(i));++r<i;)t[r]=e[r];return t}function yi(e,t,r,n){var i=!r;r||(r={});for(var o=-1,s=t.length;++o<s;){var a=t[o],u=n?n(r[a],e[a],a,r,e):void 0;void 0===u&&(u=e[a]),i?Kr(r,a,u):Fr(r,a,u)}return r}function bi(e,t){return function(r,n){var i=Ls(r)?st:Hr,o=t?t():{};return i(r,e,Ji(n,2),o)}}function _i(e){return Un((function(t,r){var n=-1,i=r.length,o=i>1?r[i-1]:void 0,s=i>2?r[2]:void 0;for(o=e.length>3&&"function"==typeof o?(i--,o):void 0,s&&ao(r[0],r[1],s)&&(o=i<3?void 0:o,i=1),t=ve(t);++n<i;){var a=r[n];a&&e(t,a,n,o)}return t}))}function wi(e,t){return function(r,n){if(null==r)return r;if(!Ns(r))return e(r,n);for(var i=r.length,o=t?i:-1,s=ve(r);(t?o--:++o<i)&&!1!==n(s[o],o,s););return r}}function Ei(e){return function(t,r,n){for(var i=-1,o=ve(t),s=n(t),a=s.length;a--;){var u=s[e?a:++i];if(!1===r(o[u],u,o))break}return t}}function Si(e){return function(t){var r=Mt(t=aa(t))?Kt(t):void 0,n=r?r[0]:t.charAt(0),i=r?ci(r,1).join(""):t.slice(1);return n[e]()+i}}function Ai(e){return function(t){return vt(Ba(Oa(t).replace(Oe,"")),e,"")}}function xi(e){return function(){var t=arguments;switch(t.length){case 0:return new e;case 1:return new e(t[0]);case 2:return new e(t[0],t[1]);case 3:return new e(t[0],t[1],t[2]);case 4:return new e(t[0],t[1],t[2],t[3]);case 5:return new e(t[0],t[1],t[2],t[3],t[4]);case 6:return new e(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new e(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var r=Rr(e.prototype),n=e.apply(r,t);return Vs(n)?n:r}}function Ii(e){return function(t,r,n){var i=ve(t);if(!Ns(t)){var o=Ji(r,3);t=_a(t),r=function(e){return o(i[e],e,i)}}var s=e(t,r,n);return s>-1?i[o?t[s]:s]:void 0}}function Ci(e){return Hi((function(t){var r=t.length,n=r,i=kr.prototype.thru;for(e&&t.reverse();n--;){var s=t[n];if("function"!=typeof s)throw new ye(o);if(i&&!a&&"wrapper"==Gi(s))var a=new kr([],!0)}for(n=a?n:r;++n<r;){var u=Gi(s=t[n]),c="wrapper"==u?Xi(s):void 0;a=c&&co(c[0])&&424==c[1]&&!c[4].length&&1==c[9]?a[Gi(c[0])].apply(a,c[3]):1==s.length&&co(s)?a[u]():a.thru(s)}return function(){var e=arguments,n=e[0];if(a&&1==e.length&&Ls(n))return a.plant(n).value();for(var i=0,o=r?t[i].apply(this,e):n;++i<r;)o=t[i].call(this,o);return o}}))}function Ri(e,t,r,i,o,s,a,u,c,f){var l=128&t,h=1&t,p=2&t,d=24&t,v=512&t,m=p?void 0:xi(e);return function g(){for(var y=arguments.length,b=n(y),_=y;_--;)b[_]=arguments[_];if(d)var w=Yi(g),E=Nt(b,w);if(i&&(b=vi(b,i,o,d)),s&&(b=mi(b,s,a,d)),y-=E,d&&y<f){var S=Ft(b,w);return Ni(e,t,Ri,g.placeholder,r,b,S,u,c,f-y)}var A=h?r:this,x=p?A[e]:e;return y=b.length,u?b=go(b,u):v&&y>1&&b.reverse(),l&&c<y&&(b.length=c),this&&this!==Xe&&this instanceof g&&(x=m||xi(x)),x.apply(A,b)}}function Ti(e,t){return function(r,n){return function(e,t,r,n){return un(e,(function(e,i,o){t(n,r(e),i,o)})),n}(r,e,t(n),{})}}function ki(e,t){return function(r,n){var i;if(void 0===r&&void 0===n)return t;if(void 0!==r&&(i=r),void 0!==n){if(void 0===i)return n;"string"==typeof r||"string"==typeof n?(r=$n(r),n=$n(n)):(r=Jn(r),n=Jn(n)),i=e(r,n)}return i}}function Pi(e){return Hi((function(t){return t=pt(t,kt(Ji())),Un((function(r){var n=this;return e(t,(function(e){return ot(e,n,r)}))}))}))}function Oi(e,t){var r=(t=void 0===t?" ":$n(t)).length;if(r<2)return r?Dn(t,e):t;var n=Dn(t,Zt(e/Wt(t)));return Mt(t)?ci(Kt(n),0,e).join(""):n.slice(0,e)}function Li(e){return function(t,r,i){return i&&"number"!=typeof i&&ao(t,r,i)&&(r=i=void 0),t=ra(t),void 0===r?(r=t,t=0):r=ra(r),function(e,t,r,i){for(var o=-1,s=or(Zt((t-e)/(r||1)),0),a=n(s);s--;)a[i?s:++o]=e,e+=r;return a}(t,r,i=void 0===i?t<r?1:-1:ra(i),e)}}function qi(e){return function(t,r){return"string"==typeof t&&"string"==typeof r||(t=oa(t),r=oa(r)),e(t,r)}}function Ni(e,t,r,n,i,o,s,a,u,c){var f=8&t;t|=f?32:64,4&(t&=~(f?64:32))||(t&=-4);var l=[e,t,i,f?o:void 0,f?s:void 0,f?void 0:o,f?void 0:s,a,u,c],h=r.apply(void 0,l);return co(e)&&bo(h,l),h.placeholder=n,Eo(h,e,t)}function ji(e){var t=de[e];return function(e,r){if(e=oa(e),(r=null==r?0:sr(na(r),292))&&rr(e)){var n=(aa(e)+"e").split("e");return+((n=(aa(t(n[0]+"e"+(+n[1]+r)))+"e").split("e"))[0]+"e"+(+n[1]-r))}return t(e)}}var Di=dr&&1/Vt(new dr([,-0]))[1]==1/0?function(e){return new dr(e)}:$a;function Ui(e){return function(t){var r=ro(t);return r==v?Bt(t):r==b?Ht(t):function(e,t){return pt(t,(function(t){return[t,e[t]]}))}(t,e(t))}}function Mi(e,t,r,i,a,u,c,f){var l=2&t;if(!l&&"function"!=typeof e)throw new ye(o);var h=i?i.length:0;if(h||(t&=-97,i=a=void 0),c=void 0===c?c:or(na(c),0),f=void 0===f?f:na(f),h-=a?a.length:0,64&t){var p=i,d=a;i=a=void 0}var v=l?void 0:Xi(e),m=[e,t,r,i,a,p,d,u,c,f];if(v&&function(e,t){var r=e[1],n=t[1],i=r|n,o=i<131,a=128==n&&8==r||128==n&&256==r&&e[7].length<=t[8]||384==n&&t[7].length<=t[8]&&8==r;if(!o&&!a)return e;1&n&&(e[2]=t[2],i|=1&r?0:4);var u=t[3];if(u){var c=e[3];e[3]=c?vi(c,u,t[4]):u,e[4]=c?Ft(e[3],s):t[4]}(u=t[5])&&(c=e[5],e[5]=c?mi(c,u,t[6]):u,e[6]=c?Ft(e[5],s):t[6]);(u=t[7])&&(e[7]=u);128&n&&(e[8]=null==e[8]?t[8]:sr(e[8],t[8]));null==e[9]&&(e[9]=t[9]);e[0]=t[0],e[1]=i}(m,v),e=m[0],t=m[1],r=m[2],i=m[3],a=m[4],!(f=m[9]=void 0===m[9]?l?0:e.length:or(m[9]-h,0))&&24&t&&(t&=-25),t&&1!=t)g=8==t||16==t?function(e,t,r){var i=xi(e);return function o(){for(var s=arguments.length,a=n(s),u=s,c=Yi(o);u--;)a[u]=arguments[u];var f=s<3&&a[0]!==c&&a[s-1]!==c?[]:Ft(a,c);if((s-=f.length)<r)return Ni(e,t,Ri,o.placeholder,void 0,a,f,void 0,void 0,r-s);var l=this&&this!==Xe&&this instanceof o?i:e;return ot(l,this,a)}}(e,t,f):32!=t&&33!=t||a.length?Ri.apply(void 0,m):function(e,t,r,i){var o=1&t,s=xi(e);return function t(){for(var a=-1,u=arguments.length,c=-1,f=i.length,l=n(f+u),h=this&&this!==Xe&&this instanceof t?s:e;++c<f;)l[c]=i[c];for(;u--;)l[c++]=arguments[++a];return ot(h,o?r:this,l)}}(e,t,r,i);else var g=function(e,t,r){var n=1&t,i=xi(e);return function t(){var o=this&&this!==Xe&&this instanceof t?i:e;return o.apply(n?r:this,arguments)}}(e,t,r);return Eo((v?Fn:bo)(g,m),e,t)}function Bi(e,t,r,n){return void 0===e||Ts(e,we[r])&&!Ae.call(n,r)?t:e}function zi(e,t,r,n,i,o){return Vs(e)&&Vs(t)&&(o.set(t,e),kn(e,t,void 0,zi,o),o.delete(t)),e}function Fi(e){return Xs(e)?void 0:e}function Vi(e,t,r,n,i,o){var s=1&r,a=e.length,u=t.length;if(a!=u&&!(s&&u>a))return!1;var c=o.get(e);if(c&&o.get(t))return c==t;var f=-1,l=!0,h=2&r?new Nr:void 0;for(o.set(e,t),o.set(t,e);++f<a;){var p=e[f],d=t[f];if(n)var v=s?n(d,p,f,t,e,o):n(p,d,f,e,t,o);if(void 0!==v){if(v)continue;l=!1;break}if(h){if(!gt(t,(function(e,t){if(!Ot(h,t)&&(p===e||i(p,e,r,n,o)))return h.push(t)}))){l=!1;break}}else if(p!==d&&!i(p,d,r,n,o)){l=!1;break}}return o.delete(e),o.delete(t),l}function Hi(e){return wo(vo(e,void 0,qo),e+"")}function Wi(e){return hn(e,_a,eo)}function Ki(e){return hn(e,wa,to)}var Xi=gr?function(e){return gr.get(e)}:$a;function Gi(e){for(var t=e.name+"",r=yr[t],n=Ae.call(yr,t)?r.length:0;n--;){var i=r[n],o=i.func;if(null==o||o==e)return i.name}return t}function Yi(e){return(Ae.call(Cr,"placeholder")?Cr:e).placeholder}function Ji(){var e=Cr.iteratee||Xa;return e=e===Xa?Sn:e,arguments.length?e(arguments[0],arguments[1]):e}function $i(e,t){var r,n,i=e.__data__;return("string"==(n=typeof(r=t))||"number"==n||"symbol"==n||"boolean"==n?"__proto__"!==r:null===r)?i["string"==typeof t?"string":"hash"]:i.map}function Zi(e){for(var t=_a(e),r=t.length;r--;){var n=t[r],i=e[n];t[r]=[n,i,ho(i)]}return t}function Qi(e,t){var r=function(e,t){return null==e?void 0:e[t]}(e,t);return En(r)?r:void 0}var eo=er?function(e){return null==e?[]:(e=ve(e),ft(er(e),(function(t){return Ge.call(e,t)})))}:iu,to=er?function(e){for(var t=[];e;)dt(t,eo(e)),e=We(e);return t}:iu,ro=pn;function no(e,t,r){for(var n=-1,i=(t=ai(t,e)).length,o=!1;++n<i;){var s=Io(t[n]);if(!(o=null!=e&&r(e,s)))break;e=e[s]}return o||++n!=i?o:!!(i=null==e?0:e.length)&&Fs(i)&&so(s,i)&&(Ls(e)||Os(e))}function io(e){return"function"!=typeof e.constructor||lo(e)?{}:Rr(We(e))}function oo(e){return Ls(e)||Os(e)||!!($e&&e&&e[$e])}function so(e,t){var r=typeof e;return!!(t=null==t?9007199254740991:t)&&("number"==r||"symbol"!=r&&ue.test(e))&&e>-1&&e%1==0&&e<t}function ao(e,t,r){if(!Vs(r))return!1;var n=typeof t;return!!("number"==n?Ns(r)&&so(t,r.length):"string"==n&&t in r)&&Ts(r[t],e)}function uo(e,t){if(Ls(e))return!1;var r=typeof e;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=e&&!$s(e))||(H.test(e)||!V.test(e)||null!=t&&e in ve(t))}function co(e){var t=Gi(e),r=Cr[t];if("function"!=typeof r||!(t in Pr.prototype))return!1;if(e===r)return!0;var n=Xi(r);return!!n&&e===n[0]}(lr&&ro(new lr(new ArrayBuffer(1)))!=A||hr&&ro(new hr)!=v||pr&&"[object Promise]"!=ro(pr.resolve())||dr&&ro(new dr)!=b||vr&&ro(new vr)!=E)&&(ro=function(e){var t=pn(e),r=t==g?e.constructor:void 0,n=r?Co(r):"";if(n)switch(n){case br:return A;case _r:return v;case wr:return"[object Promise]";case Er:return b;case Sr:return E}return t});var fo=Ee?Bs:ou;function lo(e){var t=e&&e.constructor;return e===("function"==typeof t&&t.prototype||we)}function ho(e){return e==e&&!Vs(e)}function po(e,t){return function(r){return null!=r&&(r[e]===t&&(void 0!==t||e in ve(r)))}}function vo(e,t,r){return t=or(void 0===t?e.length-1:t,0),function(){for(var i=arguments,o=-1,s=or(i.length-t,0),a=n(s);++o<s;)a[o]=i[t+o];o=-1;for(var u=n(t+1);++o<t;)u[o]=i[o];return u[t]=r(a),ot(e,this,u)}}function mo(e,t){return t.length<2?e:ln(e,Wn(t,0,-1))}function go(e,t){for(var r=e.length,n=sr(t.length,r),i=gi(e);n--;){var o=t[n];e[n]=so(o,r)?i[o]:void 0}return e}function yo(e,t){if(("constructor"!==t||"function"!=typeof e[t])&&"__proto__"!=t)return e[t]}var bo=So(Fn),_o=$t||function(e,t){return Xe.setTimeout(e,t)},wo=So(Vn);function Eo(e,t,r){var n=t+"";return wo(e,function(e,t){var r=t.length;if(!r)return e;var n=r-1;return t[n]=(r>1?"& ":"")+t[n],t=t.join(r>2?", ":" "),e.replace($,"{\n/* [wrapped with "+t+"] */\n")}(n,function(e,t){return at(a,(function(r){var n="_."+r[0];t&r[1]&&!lt(e,n)&&e.push(n)})),e.sort()}(function(e){var t=e.match(Z);return t?t[1].split(Q):[]}(n),r)))}function So(e){var t=0,r=0;return function(){var n=ar(),i=16-(n-r);if(r=n,i>0){if(++t>=800)return arguments[0]}else t=0;return e.apply(void 0,arguments)}}function Ao(e,t){var r=-1,n=e.length,i=n-1;for(t=void 0===t?n:t;++r<t;){var o=jn(r,i),s=e[o];e[o]=e[r],e[r]=s}return e.length=t,e}var xo=function(e){var t=Ss(e,(function(e){return 500===r.size&&r.clear(),e})),r=t.cache;return t}((function(e){var t=[];return 46===e.charCodeAt(0)&&t.push(""),e.replace(W,(function(e,r,n,i){t.push(n?i.replace(te,"$1"):r||e)})),t}));function Io(e){if("string"==typeof e||$s(e))return e;var t=e+"";return"0"==t&&1/e==-1/0?"-0":t}function Co(e){if(null!=e){try{return Se.call(e)}catch(e){}try{return e+""}catch(e){}}return""}function Ro(e){if(e instanceof Pr)return e.clone();var t=new kr(e.__wrapped__,e.__chain__);return t.__actions__=gi(e.__actions__),t.__index__=e.__index__,t.__values__=e.__values__,t}var To=Un((function(e,t){return js(e)?Zr(e,on(t,1,js,!0)):[]})),ko=Un((function(e,t){var r=Mo(t);return js(r)&&(r=void 0),js(e)?Zr(e,on(t,1,js,!0),Ji(r,2)):[]})),Po=Un((function(e,t){var r=Mo(t);return js(r)&&(r=void 0),js(e)?Zr(e,on(t,1,js,!0),void 0,r):[]}));function Oo(e,t,r){var n=null==e?0:e.length;if(!n)return-1;var i=null==r?0:na(r);return i<0&&(i=or(n+i,0)),_t(e,Ji(t,3),i)}function Lo(e,t,r){var n=null==e?0:e.length;if(!n)return-1;var i=n-1;return void 0!==r&&(i=na(r),i=r<0?or(n+i,0):sr(i,n-1)),_t(e,Ji(t,3),i,!0)}function qo(e){return(null==e?0:e.length)?on(e,1):[]}function No(e){return e&&e.length?e[0]:void 0}var jo=Un((function(e){var t=pt(e,oi);return t.length&&t[0]===e[0]?gn(t):[]})),Do=Un((function(e){var t=Mo(e),r=pt(e,oi);return t===Mo(r)?t=void 0:r.pop(),r.length&&r[0]===e[0]?gn(r,Ji(t,2)):[]})),Uo=Un((function(e){var t=Mo(e),r=pt(e,oi);return(t="function"==typeof t?t:void 0)&&r.pop(),r.length&&r[0]===e[0]?gn(r,void 0,t):[]}));function Mo(e){var t=null==e?0:e.length;return t?e[t-1]:void 0}var Bo=Un(zo);function zo(e,t){return e&&e.length&&t&&t.length?qn(e,t):e}var Fo=Hi((function(e,t){var r=null==e?0:e.length,n=Xr(e,t);return Nn(e,pt(t,(function(e){return so(e,r)?+e:e})).sort(di)),n}));function Vo(e){return null==e?e:fr.call(e)}var Ho=Un((function(e){return Zn(on(e,1,js,!0))})),Wo=Un((function(e){var t=Mo(e);return js(t)&&(t=void 0),Zn(on(e,1,js,!0),Ji(t,2))})),Ko=Un((function(e){var t=Mo(e);return t="function"==typeof t?t:void 0,Zn(on(e,1,js,!0),void 0,t)}));function Xo(e){if(!e||!e.length)return[];var t=0;return e=ft(e,(function(e){if(js(e))return t=or(e.length,t),!0})),Tt(t,(function(t){return pt(e,xt(t))}))}function Go(e,t){if(!e||!e.length)return[];var r=Xo(e);return null==t?r:pt(r,(function(e){return ot(t,void 0,e)}))}var Yo=Un((function(e,t){return js(e)?Zr(e,t):[]})),Jo=Un((function(e){return ni(ft(e,js))})),$o=Un((function(e){var t=Mo(e);return js(t)&&(t=void 0),ni(ft(e,js),Ji(t,2))})),Zo=Un((function(e){var t=Mo(e);return t="function"==typeof t?t:void 0,ni(ft(e,js),void 0,t)})),Qo=Un(Xo);var es=Un((function(e){var t=e.length,r=t>1?e[t-1]:void 0;return r="function"==typeof r?(e.pop(),r):void 0,Go(e,r)}));function ts(e){var t=Cr(e);return t.__chain__=!0,t}function rs(e,t){return t(e)}var ns=Hi((function(e){var t=e.length,r=t?e[0]:0,n=this.__wrapped__,i=function(t){return Xr(t,e)};return!(t>1||this.__actions__.length)&&n instanceof Pr&&so(r)?((n=n.slice(r,+r+(t?1:0))).__actions__.push({func:rs,args:[i],thisArg:void 0}),new kr(n,this.__chain__).thru((function(e){return t&&!e.length&&e.push(void 0),e}))):this.thru(i)}));var is=bi((function(e,t,r){Ae.call(e,r)?++e[r]:Kr(e,r,1)}));var os=Ii(Oo),ss=Ii(Lo);function as(e,t){return(Ls(e)?at:Qr)(e,Ji(t,3))}function us(e,t){return(Ls(e)?ut:en)(e,Ji(t,3))}var cs=bi((function(e,t,r){Ae.call(e,r)?e[r].push(t):Kr(e,r,[t])}));var fs=Un((function(e,t,r){var i=-1,o="function"==typeof t,s=Ns(e)?n(e.length):[];return Qr(e,(function(e){s[++i]=o?ot(t,e,r):yn(e,t,r)})),s})),ls=bi((function(e,t,r){Kr(e,r,t)}));function hs(e,t){return(Ls(e)?pt:Cn)(e,Ji(t,3))}var ps=bi((function(e,t,r){e[r?0:1].push(t)}),(function(){return[[],[]]}));var ds=Un((function(e,t){if(null==e)return[];var r=t.length;return r>1&&ao(e,t[0],t[1])?t=[]:r>2&&ao(t[0],t[1],t[2])&&(t=[t[0]]),On(e,on(t,1),[])})),vs=Jt||function(){return Xe.Date.now()};function ms(e,t,r){return t=r?void 0:t,Mi(e,128,void 0,void 0,void 0,void 0,t=e&&null==t?e.length:t)}function gs(e,t){var r;if("function"!=typeof t)throw new ye(o);return e=na(e),function(){return--e>0&&(r=t.apply(this,arguments)),e<=1&&(t=void 0),r}}var ys=Un((function(e,t,r){var n=1;if(r.length){var i=Ft(r,Yi(ys));n|=32}return Mi(e,n,t,r,i)})),bs=Un((function(e,t,r){var n=3;if(r.length){var i=Ft(r,Yi(bs));n|=32}return Mi(t,n,e,r,i)}));function _s(e,t,r){var n,i,s,a,u,c,f=0,l=!1,h=!1,p=!0;if("function"!=typeof e)throw new ye(o);function d(t){var r=n,o=i;return n=i=void 0,f=t,a=e.apply(o,r)}function v(e){return f=e,u=_o(g,t),l?d(e):a}function m(e){var r=e-c;return void 0===c||r>=t||r<0||h&&e-f>=s}function g(){var e=vs();if(m(e))return y(e);u=_o(g,function(e){var r=t-(e-c);return h?sr(r,s-(e-f)):r}(e))}function y(e){return u=void 0,p&&n?d(e):(n=i=void 0,a)}function b(){var e=vs(),r=m(e);if(n=arguments,i=this,c=e,r){if(void 0===u)return v(c);if(h)return fi(u),u=_o(g,t),d(c)}return void 0===u&&(u=_o(g,t)),a}return t=oa(t)||0,Vs(r)&&(l=!!r.leading,s=(h="maxWait"in r)?or(oa(r.maxWait)||0,t):s,p="trailing"in r?!!r.trailing:p),b.cancel=function(){void 0!==u&&fi(u),f=0,n=c=i=u=void 0},b.flush=function(){return void 0===u?a:y(vs())},b}var ws=Un((function(e,t){return $r(e,1,t)})),Es=Un((function(e,t,r){return $r(e,oa(t)||0,r)}));function Ss(e,t){if("function"!=typeof e||null!=t&&"function"!=typeof t)throw new ye(o);var r=function(){var n=arguments,i=t?t.apply(this,n):n[0],o=r.cache;if(o.has(i))return o.get(i);var s=e.apply(this,n);return r.cache=o.set(i,s)||o,s};return r.cache=new(Ss.Cache||qr),r}function As(e){if("function"!=typeof e)throw new ye(o);return function(){var t=arguments;switch(t.length){case 0:return!e.call(this);case 1:return!e.call(this,t[0]);case 2:return!e.call(this,t[0],t[1]);case 3:return!e.call(this,t[0],t[1],t[2])}return!e.apply(this,t)}}Ss.Cache=qr;var xs=ui((function(e,t){var r=(t=1==t.length&&Ls(t[0])?pt(t[0],kt(Ji())):pt(on(t,1),kt(Ji()))).length;return Un((function(n){for(var i=-1,o=sr(n.length,r);++i<o;)n[i]=t[i].call(this,n[i]);return ot(e,this,n)}))})),Is=Un((function(e,t){return Mi(e,32,void 0,t,Ft(t,Yi(Is)))})),Cs=Un((function(e,t){return Mi(e,64,void 0,t,Ft(t,Yi(Cs)))})),Rs=Hi((function(e,t){return Mi(e,256,void 0,void 0,void 0,t)}));function Ts(e,t){return e===t||e!=e&&t!=t}var ks=qi(dn),Ps=qi((function(e,t){return e>=t})),Os=bn(function(){return arguments}())?bn:function(e){return Hs(e)&&Ae.call(e,"callee")&&!Ge.call(e,"callee")},Ls=n.isArray,qs=Qe?kt(Qe):function(e){return Hs(e)&&pn(e)==S};function Ns(e){return null!=e&&Fs(e.length)&&!Bs(e)}function js(e){return Hs(e)&&Ns(e)}var Ds=tr||ou,Us=et?kt(et):function(e){return Hs(e)&&pn(e)==l};function Ms(e){if(!Hs(e))return!1;var t=pn(e);return t==h||"[object DOMException]"==t||"string"==typeof e.message&&"string"==typeof e.name&&!Xs(e)}function Bs(e){if(!Vs(e))return!1;var t=pn(e);return t==p||t==d||"[object AsyncFunction]"==t||"[object Proxy]"==t}function zs(e){return"number"==typeof e&&e==na(e)}function Fs(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=9007199254740991}function Vs(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}function Hs(e){return null!=e&&"object"==typeof e}var Ws=tt?kt(tt):function(e){return Hs(e)&&ro(e)==v};function Ks(e){return"number"==typeof e||Hs(e)&&pn(e)==m}function Xs(e){if(!Hs(e)||pn(e)!=g)return!1;var t=We(e);if(null===t)return!0;var r=Ae.call(t,"constructor")&&t.constructor;return"function"==typeof r&&r instanceof r&&Se.call(r)==Re}var Gs=rt?kt(rt):function(e){return Hs(e)&&pn(e)==y};var Ys=nt?kt(nt):function(e){return Hs(e)&&ro(e)==b};function Js(e){return"string"==typeof e||!Ls(e)&&Hs(e)&&pn(e)==_}function $s(e){return"symbol"==typeof e||Hs(e)&&pn(e)==w}var Zs=it?kt(it):function(e){return Hs(e)&&Fs(e.length)&&!!Be[pn(e)]};var Qs=qi(In),ea=qi((function(e,t){return e<=t}));function ta(e){if(!e)return[];if(Ns(e))return Js(e)?Kt(e):gi(e);if(Ze&&e[Ze])return function(e){for(var t,r=[];!(t=e.next()).done;)r.push(t.value);return r}(e[Ze]());var t=ro(e);return(t==v?Bt:t==b?Vt:Ta)(e)}function ra(e){return e?(e=oa(e))===1/0||e===-1/0?17976931348623157e292*(e<0?-1:1):e==e?e:0:0===e?e:0}function na(e){var t=ra(e),r=t%1;return t==t?r?t-r:t:0}function ia(e){return e?Gr(na(e),0,4294967295):0}function oa(e){if("number"==typeof e)return e;if($s(e))return NaN;if(Vs(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=Vs(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(G,"");var r=oe.test(e);return r||ae.test(e)?He(e.slice(2),r?2:8):ie.test(e)?NaN:+e}function sa(e){return yi(e,wa(e))}function aa(e){return null==e?"":$n(e)}var ua=_i((function(e,t){if(lo(t)||Ns(t))yi(t,_a(t),e);else for(var r in t)Ae.call(t,r)&&Fr(e,r,t[r])})),ca=_i((function(e,t){yi(t,wa(t),e)})),fa=_i((function(e,t,r,n){yi(t,wa(t),e,n)})),la=_i((function(e,t,r,n){yi(t,_a(t),e,n)})),ha=Hi(Xr);var pa=Un((function(e,t){e=ve(e);var r=-1,n=t.length,i=n>2?t[2]:void 0;for(i&&ao(t[0],t[1],i)&&(n=1);++r<n;)for(var o=t[r],s=wa(o),a=-1,u=s.length;++a<u;){var c=s[a],f=e[c];(void 0===f||Ts(f,we[c])&&!Ae.call(e,c))&&(e[c]=o[c])}return e})),da=Un((function(e){return e.push(void 0,zi),ot(Sa,void 0,e)}));function va(e,t,r){var n=null==e?void 0:ln(e,t);return void 0===n?r:n}function ma(e,t){return null!=e&&no(e,t,mn)}var ga=Ti((function(e,t,r){null!=t&&"function"!=typeof t.toString&&(t=Ce.call(t)),e[t]=r}),Va(Ka)),ya=Ti((function(e,t,r){null!=t&&"function"!=typeof t.toString&&(t=Ce.call(t)),Ae.call(e,t)?e[t].push(r):e[t]=[r]}),Ji),ba=Un(yn);function _a(e){return Ns(e)?Dr(e):An(e)}function wa(e){return Ns(e)?Dr(e,!0):xn(e)}var Ea=_i((function(e,t,r){kn(e,t,r)})),Sa=_i((function(e,t,r,n){kn(e,t,r,n)})),Aa=Hi((function(e,t){var r={};if(null==e)return r;var n=!1;t=pt(t,(function(t){return t=ai(t,e),n||(n=t.length>1),t})),yi(e,Ki(e),r),n&&(r=Yr(r,7,Fi));for(var i=t.length;i--;)Qn(r,t[i]);return r}));var xa=Hi((function(e,t){return null==e?{}:function(e,t){return Ln(e,t,(function(t,r){return ma(e,r)}))}(e,t)}));function Ia(e,t){if(null==e)return{};var r=pt(Ki(e),(function(e){return[e]}));return t=Ji(t),Ln(e,r,(function(e,r){return t(e,r[0])}))}var Ca=Ui(_a),Ra=Ui(wa);function Ta(e){return null==e?[]:Pt(e,_a(e))}var ka=Ai((function(e,t,r){return t=t.toLowerCase(),e+(r?Pa(t):t)}));function Pa(e){return Ma(aa(e).toLowerCase())}function Oa(e){return(e=aa(e))&&e.replace(ce,jt).replace(Le,"")}var La=Ai((function(e,t,r){return e+(r?"-":"")+t.toLowerCase()})),qa=Ai((function(e,t,r){return e+(r?" ":"")+t.toLowerCase()})),Na=Si("toLowerCase");var ja=Ai((function(e,t,r){return e+(r?"_":"")+t.toLowerCase()}));var Da=Ai((function(e,t,r){return e+(r?" ":"")+Ma(t)}));var Ua=Ai((function(e,t,r){return e+(r?" ":"")+t.toUpperCase()})),Ma=Si("toUpperCase");function Ba(e,t,r){return e=aa(e),void 0===(t=r?void 0:t)?function(e){return De.test(e)}(e)?function(e){return e.match(Ne)||[]}(e):function(e){return e.match(ee)||[]}(e):e.match(t)||[]}var za=Un((function(e,t){try{return ot(e,void 0,t)}catch(e){return Ms(e)?e:new he(e)}})),Fa=Hi((function(e,t){return at(t,(function(t){t=Io(t),Kr(e,t,ys(e[t],e))})),e}));function Va(e){return function(){return e}}var Ha=Ci(),Wa=Ci(!0);function Ka(e){return e}function Xa(e){return Sn("function"==typeof e?e:Yr(e,1))}var Ga=Un((function(e,t){return function(r){return yn(r,e,t)}})),Ya=Un((function(e,t){return function(r){return yn(e,r,t)}}));function Ja(e,t,r){var n=_a(t),i=fn(t,n);null!=r||Vs(t)&&(i.length||!n.length)||(r=t,t=e,e=this,i=fn(t,_a(t)));var o=!(Vs(r)&&"chain"in r&&!r.chain),s=Bs(e);return at(i,(function(r){var n=t[r];e[r]=n,s&&(e.prototype[r]=function(){var t=this.__chain__;if(o||t){var r=e(this.__wrapped__),i=r.__actions__=gi(this.__actions__);return i.push({func:n,args:arguments,thisArg:e}),r.__chain__=t,r}return n.apply(e,dt([this.value()],arguments))})})),e}function $a(){}var Za=Pi(pt),Qa=Pi(ct),eu=Pi(gt);function tu(e){return uo(e)?xt(Io(e)):function(e){return function(t){return ln(t,e)}}(e)}var ru=Li(),nu=Li(!0);function iu(){return[]}function ou(){return!1}var su=ki((function(e,t){return e+t}),0),au=ji("ceil"),uu=ki((function(e,t){return e/t}),1),cu=ji("floor");var fu,lu=ki((function(e,t){return e*t}),1),hu=ji("round"),pu=ki((function(e,t){return e-t}),0);return Cr.after=function(e,t){if("function"!=typeof t)throw new ye(o);return e=na(e),function(){if(--e<1)return t.apply(this,arguments)}},Cr.ary=ms,Cr.assign=ua,Cr.assignIn=ca,Cr.assignInWith=fa,Cr.assignWith=la,Cr.at=ha,Cr.before=gs,Cr.bind=ys,Cr.bindAll=Fa,Cr.bindKey=bs,Cr.castArray=function(){if(!arguments.length)return[];var e=arguments[0];return Ls(e)?e:[e]},Cr.chain=ts,Cr.chunk=function(e,t,r){t=(r?ao(e,t,r):void 0===t)?1:or(na(t),0);var i=null==e?0:e.length;if(!i||t<1)return[];for(var o=0,s=0,a=n(Zt(i/t));o<i;)a[s++]=Wn(e,o,o+=t);return a},Cr.compact=function(e){for(var t=-1,r=null==e?0:e.length,n=0,i=[];++t<r;){var o=e[t];o&&(i[n++]=o)}return i},Cr.concat=function(){var e=arguments.length;if(!e)return[];for(var t=n(e-1),r=arguments[0],i=e;i--;)t[i-1]=arguments[i];return dt(Ls(r)?gi(r):[r],on(t,1))},Cr.cond=function(e){var t=null==e?0:e.length,r=Ji();return e=t?pt(e,(function(e){if("function"!=typeof e[1])throw new ye(o);return[r(e[0]),e[1]]})):[],Un((function(r){for(var n=-1;++n<t;){var i=e[n];if(ot(i[0],this,r))return ot(i[1],this,r)}}))},Cr.conforms=function(e){return function(e){var t=_a(e);return function(r){return Jr(r,e,t)}}(Yr(e,1))},Cr.constant=Va,Cr.countBy=is,Cr.create=function(e,t){var r=Rr(e);return null==t?r:Wr(r,t)},Cr.curry=function e(t,r,n){var i=Mi(t,8,void 0,void 0,void 0,void 0,void 0,r=n?void 0:r);return i.placeholder=e.placeholder,i},Cr.curryRight=function e(t,r,n){var i=Mi(t,16,void 0,void 0,void 0,void 0,void 0,r=n?void 0:r);return i.placeholder=e.placeholder,i},Cr.debounce=_s,Cr.defaults=pa,Cr.defaultsDeep=da,Cr.defer=ws,Cr.delay=Es,Cr.difference=To,Cr.differenceBy=ko,Cr.differenceWith=Po,Cr.drop=function(e,t,r){var n=null==e?0:e.length;return n?Wn(e,(t=r||void 0===t?1:na(t))<0?0:t,n):[]},Cr.dropRight=function(e,t,r){var n=null==e?0:e.length;return n?Wn(e,0,(t=n-(t=r||void 0===t?1:na(t)))<0?0:t):[]},Cr.dropRightWhile=function(e,t){return e&&e.length?ti(e,Ji(t,3),!0,!0):[]},Cr.dropWhile=function(e,t){return e&&e.length?ti(e,Ji(t,3),!0):[]},Cr.fill=function(e,t,r,n){var i=null==e?0:e.length;return i?(r&&"number"!=typeof r&&ao(e,t,r)&&(r=0,n=i),function(e,t,r,n){var i=e.length;for((r=na(r))<0&&(r=-r>i?0:i+r),(n=void 0===n||n>i?i:na(n))<0&&(n+=i),n=r>n?0:ia(n);r<n;)e[r++]=t;return e}(e,t,r,n)):[]},Cr.filter=function(e,t){return(Ls(e)?ft:nn)(e,Ji(t,3))},Cr.flatMap=function(e,t){return on(hs(e,t),1)},Cr.flatMapDeep=function(e,t){return on(hs(e,t),1/0)},Cr.flatMapDepth=function(e,t,r){return r=void 0===r?1:na(r),on(hs(e,t),r)},Cr.flatten=qo,Cr.flattenDeep=function(e){return(null==e?0:e.length)?on(e,1/0):[]},Cr.flattenDepth=function(e,t){return(null==e?0:e.length)?on(e,t=void 0===t?1:na(t)):[]},Cr.flip=function(e){return Mi(e,512)},Cr.flow=Ha,Cr.flowRight=Wa,Cr.fromPairs=function(e){for(var t=-1,r=null==e?0:e.length,n={};++t<r;){var i=e[t];n[i[0]]=i[1]}return n},Cr.functions=function(e){return null==e?[]:fn(e,_a(e))},Cr.functionsIn=function(e){return null==e?[]:fn(e,wa(e))},Cr.groupBy=cs,Cr.initial=function(e){return(null==e?0:e.length)?Wn(e,0,-1):[]},Cr.intersection=jo,Cr.intersectionBy=Do,Cr.intersectionWith=Uo,Cr.invert=ga,Cr.invertBy=ya,Cr.invokeMap=fs,Cr.iteratee=Xa,Cr.keyBy=ls,Cr.keys=_a,Cr.keysIn=wa,Cr.map=hs,Cr.mapKeys=function(e,t){var r={};return t=Ji(t,3),un(e,(function(e,n,i){Kr(r,t(e,n,i),e)})),r},Cr.mapValues=function(e,t){var r={};return t=Ji(t,3),un(e,(function(e,n,i){Kr(r,n,t(e,n,i))})),r},Cr.matches=function(e){return Rn(Yr(e,1))},Cr.matchesProperty=function(e,t){return Tn(e,Yr(t,1))},Cr.memoize=Ss,Cr.merge=Ea,Cr.mergeWith=Sa,Cr.method=Ga,Cr.methodOf=Ya,Cr.mixin=Ja,Cr.negate=As,Cr.nthArg=function(e){return e=na(e),Un((function(t){return Pn(t,e)}))},Cr.omit=Aa,Cr.omitBy=function(e,t){return Ia(e,As(Ji(t)))},Cr.once=function(e){return gs(2,e)},Cr.orderBy=function(e,t,r,n){return null==e?[]:(Ls(t)||(t=null==t?[]:[t]),Ls(r=n?void 0:r)||(r=null==r?[]:[r]),On(e,t,r))},Cr.over=Za,Cr.overArgs=xs,Cr.overEvery=Qa,Cr.overSome=eu,Cr.partial=Is,Cr.partialRight=Cs,Cr.partition=ps,Cr.pick=xa,Cr.pickBy=Ia,Cr.property=tu,Cr.propertyOf=function(e){return function(t){return null==e?void 0:ln(e,t)}},Cr.pull=Bo,Cr.pullAll=zo,Cr.pullAllBy=function(e,t,r){return e&&e.length&&t&&t.length?qn(e,t,Ji(r,2)):e},Cr.pullAllWith=function(e,t,r){return e&&e.length&&t&&t.length?qn(e,t,void 0,r):e},Cr.pullAt=Fo,Cr.range=ru,Cr.rangeRight=nu,Cr.rearg=Rs,Cr.reject=function(e,t){return(Ls(e)?ft:nn)(e,As(Ji(t,3)))},Cr.remove=function(e,t){var r=[];if(!e||!e.length)return r;var n=-1,i=[],o=e.length;for(t=Ji(t,3);++n<o;){var s=e[n];t(s,n,e)&&(r.push(s),i.push(n))}return Nn(e,i),r},Cr.rest=function(e,t){if("function"!=typeof e)throw new ye(o);return Un(e,t=void 0===t?t:na(t))},Cr.reverse=Vo,Cr.sampleSize=function(e,t,r){return t=(r?ao(e,t,r):void 0===t)?1:na(t),(Ls(e)?Mr:Bn)(e,t)},Cr.set=function(e,t,r){return null==e?e:zn(e,t,r)},Cr.setWith=function(e,t,r,n){return n="function"==typeof n?n:void 0,null==e?e:zn(e,t,r,n)},Cr.shuffle=function(e){return(Ls(e)?Br:Hn)(e)},Cr.slice=function(e,t,r){var n=null==e?0:e.length;return n?(r&&"number"!=typeof r&&ao(e,t,r)?(t=0,r=n):(t=null==t?0:na(t),r=void 0===r?n:na(r)),Wn(e,t,r)):[]},Cr.sortBy=ds,Cr.sortedUniq=function(e){return e&&e.length?Yn(e):[]},Cr.sortedUniqBy=function(e,t){return e&&e.length?Yn(e,Ji(t,2)):[]},Cr.split=function(e,t,r){return r&&"number"!=typeof r&&ao(e,t,r)&&(t=r=void 0),(r=void 0===r?4294967295:r>>>0)?(e=aa(e))&&("string"==typeof t||null!=t&&!Gs(t))&&!(t=$n(t))&&Mt(e)?ci(Kt(e),0,r):e.split(t,r):[]},Cr.spread=function(e,t){if("function"!=typeof e)throw new ye(o);return t=null==t?0:or(na(t),0),Un((function(r){var n=r[t],i=ci(r,0,t);return n&&dt(i,n),ot(e,this,i)}))},Cr.tail=function(e){var t=null==e?0:e.length;return t?Wn(e,1,t):[]},Cr.take=function(e,t,r){return e&&e.length?Wn(e,0,(t=r||void 0===t?1:na(t))<0?0:t):[]},Cr.takeRight=function(e,t,r){var n=null==e?0:e.length;return n?Wn(e,(t=n-(t=r||void 0===t?1:na(t)))<0?0:t,n):[]},Cr.takeRightWhile=function(e,t){return e&&e.length?ti(e,Ji(t,3),!1,!0):[]},Cr.takeWhile=function(e,t){return e&&e.length?ti(e,Ji(t,3)):[]},Cr.tap=function(e,t){return t(e),e},Cr.throttle=function(e,t,r){var n=!0,i=!0;if("function"!=typeof e)throw new ye(o);return Vs(r)&&(n="leading"in r?!!r.leading:n,i="trailing"in r?!!r.trailing:i),_s(e,t,{leading:n,maxWait:t,trailing:i})},Cr.thru=rs,Cr.toArray=ta,Cr.toPairs=Ca,Cr.toPairsIn=Ra,Cr.toPath=function(e){return Ls(e)?pt(e,Io):$s(e)?[e]:gi(xo(aa(e)))},Cr.toPlainObject=sa,Cr.transform=function(e,t,r){var n=Ls(e),i=n||Ds(e)||Zs(e);if(t=Ji(t,4),null==r){var o=e&&e.constructor;r=i?n?new o:[]:Vs(e)&&Bs(o)?Rr(We(e)):{}}return(i?at:un)(e,(function(e,n,i){return t(r,e,n,i)})),r},Cr.unary=function(e){return ms(e,1)},Cr.union=Ho,Cr.unionBy=Wo,Cr.unionWith=Ko,Cr.uniq=function(e){return e&&e.length?Zn(e):[]},Cr.uniqBy=function(e,t){return e&&e.length?Zn(e,Ji(t,2)):[]},Cr.uniqWith=function(e,t){return t="function"==typeof t?t:void 0,e&&e.length?Zn(e,void 0,t):[]},Cr.unset=function(e,t){return null==e||Qn(e,t)},Cr.unzip=Xo,Cr.unzipWith=Go,Cr.update=function(e,t,r){return null==e?e:ei(e,t,si(r))},Cr.updateWith=function(e,t,r,n){return n="function"==typeof n?n:void 0,null==e?e:ei(e,t,si(r),n)},Cr.values=Ta,Cr.valuesIn=function(e){return null==e?[]:Pt(e,wa(e))},Cr.without=Yo,Cr.words=Ba,Cr.wrap=function(e,t){return Is(si(t),e)},Cr.xor=Jo,Cr.xorBy=$o,Cr.xorWith=Zo,Cr.zip=Qo,Cr.zipObject=function(e,t){return ii(e||[],t||[],Fr)},Cr.zipObjectDeep=function(e,t){return ii(e||[],t||[],zn)},Cr.zipWith=es,Cr.entries=Ca,Cr.entriesIn=Ra,Cr.extend=ca,Cr.extendWith=fa,Ja(Cr,Cr),Cr.add=su,Cr.attempt=za,Cr.camelCase=ka,Cr.capitalize=Pa,Cr.ceil=au,Cr.clamp=function(e,t,r){return void 0===r&&(r=t,t=void 0),void 0!==r&&(r=(r=oa(r))==r?r:0),void 0!==t&&(t=(t=oa(t))==t?t:0),Gr(oa(e),t,r)},Cr.clone=function(e){return Yr(e,4)},Cr.cloneDeep=function(e){return Yr(e,5)},Cr.cloneDeepWith=function(e,t){return Yr(e,5,t="function"==typeof t?t:void 0)},Cr.cloneWith=function(e,t){return Yr(e,4,t="function"==typeof t?t:void 0)},Cr.conformsTo=function(e,t){return null==t||Jr(e,t,_a(t))},Cr.deburr=Oa,Cr.defaultTo=function(e,t){return null==e||e!=e?t:e},Cr.divide=uu,Cr.endsWith=function(e,t,r){e=aa(e),t=$n(t);var n=e.length,i=r=void 0===r?n:Gr(na(r),0,n);return(r-=t.length)>=0&&e.slice(r,i)==t},Cr.eq=Ts,Cr.escape=function(e){return(e=aa(e))&&M.test(e)?e.replace(D,Dt):e},Cr.escapeRegExp=function(e){return(e=aa(e))&&X.test(e)?e.replace(K,"\\$&"):e},Cr.every=function(e,t,r){var n=Ls(e)?ct:tn;return r&&ao(e,t,r)&&(t=void 0),n(e,Ji(t,3))},Cr.find=os,Cr.findIndex=Oo,Cr.findKey=function(e,t){return bt(e,Ji(t,3),un)},Cr.findLast=ss,Cr.findLastIndex=Lo,Cr.findLastKey=function(e,t){return bt(e,Ji(t,3),cn)},Cr.floor=cu,Cr.forEach=as,Cr.forEachRight=us,Cr.forIn=function(e,t){return null==e?e:sn(e,Ji(t,3),wa)},Cr.forInRight=function(e,t){return null==e?e:an(e,Ji(t,3),wa)},Cr.forOwn=function(e,t){return e&&un(e,Ji(t,3))},Cr.forOwnRight=function(e,t){return e&&cn(e,Ji(t,3))},Cr.get=va,Cr.gt=ks,Cr.gte=Ps,Cr.has=function(e,t){return null!=e&&no(e,t,vn)},Cr.hasIn=ma,Cr.head=No,Cr.identity=Ka,Cr.includes=function(e,t,r,n){e=Ns(e)?e:Ta(e),r=r&&!n?na(r):0;var i=e.length;return r<0&&(r=or(i+r,0)),Js(e)?r<=i&&e.indexOf(t,r)>-1:!!i&&wt(e,t,r)>-1},Cr.indexOf=function(e,t,r){var n=null==e?0:e.length;if(!n)return-1;var i=null==r?0:na(r);return i<0&&(i=or(n+i,0)),wt(e,t,i)},Cr.inRange=function(e,t,r){return t=ra(t),void 0===r?(r=t,t=0):r=ra(r),function(e,t,r){return e>=sr(t,r)&&e<or(t,r)}(e=oa(e),t,r)},Cr.invoke=ba,Cr.isArguments=Os,Cr.isArray=Ls,Cr.isArrayBuffer=qs,Cr.isArrayLike=Ns,Cr.isArrayLikeObject=js,Cr.isBoolean=function(e){return!0===e||!1===e||Hs(e)&&pn(e)==f},Cr.isBuffer=Ds,Cr.isDate=Us,Cr.isElement=function(e){return Hs(e)&&1===e.nodeType&&!Xs(e)},Cr.isEmpty=function(e){if(null==e)return!0;if(Ns(e)&&(Ls(e)||"string"==typeof e||"function"==typeof e.splice||Ds(e)||Zs(e)||Os(e)))return!e.length;var t=ro(e);if(t==v||t==b)return!e.size;if(lo(e))return!An(e).length;for(var r in e)if(Ae.call(e,r))return!1;return!0},Cr.isEqual=function(e,t){return _n(e,t)},Cr.isEqualWith=function(e,t,r){var n=(r="function"==typeof r?r:void 0)?r(e,t):void 0;return void 0===n?_n(e,t,void 0,r):!!n},Cr.isError=Ms,Cr.isFinite=function(e){return"number"==typeof e&&rr(e)},Cr.isFunction=Bs,Cr.isInteger=zs,Cr.isLength=Fs,Cr.isMap=Ws,Cr.isMatch=function(e,t){return e===t||wn(e,t,Zi(t))},Cr.isMatchWith=function(e,t,r){return r="function"==typeof r?r:void 0,wn(e,t,Zi(t),r)},Cr.isNaN=function(e){return Ks(e)&&e!=+e},Cr.isNative=function(e){if(fo(e))throw new he("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");return En(e)},Cr.isNil=function(e){return null==e},Cr.isNull=function(e){return null===e},Cr.isNumber=Ks,Cr.isObject=Vs,Cr.isObjectLike=Hs,Cr.isPlainObject=Xs,Cr.isRegExp=Gs,Cr.isSafeInteger=function(e){return zs(e)&&e>=-9007199254740991&&e<=9007199254740991},Cr.isSet=Ys,Cr.isString=Js,Cr.isSymbol=$s,Cr.isTypedArray=Zs,Cr.isUndefined=function(e){return void 0===e},Cr.isWeakMap=function(e){return Hs(e)&&ro(e)==E},Cr.isWeakSet=function(e){return Hs(e)&&"[object WeakSet]"==pn(e)},Cr.join=function(e,t){return null==e?"":nr.call(e,t)},Cr.kebabCase=La,Cr.last=Mo,Cr.lastIndexOf=function(e,t,r){var n=null==e?0:e.length;if(!n)return-1;var i=n;return void 0!==r&&(i=(i=na(r))<0?or(n+i,0):sr(i,n-1)),t==t?function(e,t,r){for(var n=r+1;n--;)if(e[n]===t)return n;return n}(e,t,i):_t(e,St,i,!0)},Cr.lowerCase=qa,Cr.lowerFirst=Na,Cr.lt=Qs,Cr.lte=ea,Cr.max=function(e){return e&&e.length?rn(e,Ka,dn):void 0},Cr.maxBy=function(e,t){return e&&e.length?rn(e,Ji(t,2),dn):void 0},Cr.mean=function(e){return At(e,Ka)},Cr.meanBy=function(e,t){return At(e,Ji(t,2))},Cr.min=function(e){return e&&e.length?rn(e,Ka,In):void 0},Cr.minBy=function(e,t){return e&&e.length?rn(e,Ji(t,2),In):void 0},Cr.stubArray=iu,Cr.stubFalse=ou,Cr.stubObject=function(){return{}},Cr.stubString=function(){return""},Cr.stubTrue=function(){return!0},Cr.multiply=lu,Cr.nth=function(e,t){return e&&e.length?Pn(e,na(t)):void 0},Cr.noConflict=function(){return Xe._===this&&(Xe._=Te),this},Cr.noop=$a,Cr.now=vs,Cr.pad=function(e,t,r){e=aa(e);var n=(t=na(t))?Wt(e):0;if(!t||n>=t)return e;var i=(t-n)/2;return Oi(Qt(i),r)+e+Oi(Zt(i),r)},Cr.padEnd=function(e,t,r){e=aa(e);var n=(t=na(t))?Wt(e):0;return t&&n<t?e+Oi(t-n,r):e},Cr.padStart=function(e,t,r){e=aa(e);var n=(t=na(t))?Wt(e):0;return t&&n<t?Oi(t-n,r)+e:e},Cr.parseInt=function(e,t,r){return r||null==t?t=0:t&&(t=+t),ur(aa(e).replace(Y,""),t||0)},Cr.random=function(e,t,r){if(r&&"boolean"!=typeof r&&ao(e,t,r)&&(t=r=void 0),void 0===r&&("boolean"==typeof t?(r=t,t=void 0):"boolean"==typeof e&&(r=e,e=void 0)),void 0===e&&void 0===t?(e=0,t=1):(e=ra(e),void 0===t?(t=e,e=0):t=ra(t)),e>t){var n=e;e=t,t=n}if(r||e%1||t%1){var i=cr();return sr(e+i*(t-e+Ve("1e-"+((i+"").length-1))),t)}return jn(e,t)},Cr.reduce=function(e,t,r){var n=Ls(e)?vt:Ct,i=arguments.length<3;return n(e,Ji(t,4),r,i,Qr)},Cr.reduceRight=function(e,t,r){var n=Ls(e)?mt:Ct,i=arguments.length<3;return n(e,Ji(t,4),r,i,en)},Cr.repeat=function(e,t,r){return t=(r?ao(e,t,r):void 0===t)?1:na(t),Dn(aa(e),t)},Cr.replace=function(){var e=arguments,t=aa(e[0]);return e.length<3?t:t.replace(e[1],e[2])},Cr.result=function(e,t,r){var n=-1,i=(t=ai(t,e)).length;for(i||(i=1,e=void 0);++n<i;){var o=null==e?void 0:e[Io(t[n])];void 0===o&&(n=i,o=r),e=Bs(o)?o.call(e):o}return e},Cr.round=hu,Cr.runInContext=e,Cr.sample=function(e){return(Ls(e)?Ur:Mn)(e)},Cr.size=function(e){if(null==e)return 0;if(Ns(e))return Js(e)?Wt(e):e.length;var t=ro(e);return t==v||t==b?e.size:An(e).length},Cr.snakeCase=ja,Cr.some=function(e,t,r){var n=Ls(e)?gt:Kn;return r&&ao(e,t,r)&&(t=void 0),n(e,Ji(t,3))},Cr.sortedIndex=function(e,t){return Xn(e,t)},Cr.sortedIndexBy=function(e,t,r){return Gn(e,t,Ji(r,2))},Cr.sortedIndexOf=function(e,t){var r=null==e?0:e.length;if(r){var n=Xn(e,t);if(n<r&&Ts(e[n],t))return n}return-1},Cr.sortedLastIndex=function(e,t){return Xn(e,t,!0)},Cr.sortedLastIndexBy=function(e,t,r){return Gn(e,t,Ji(r,2),!0)},Cr.sortedLastIndexOf=function(e,t){if(null==e?0:e.length){var r=Xn(e,t,!0)-1;if(Ts(e[r],t))return r}return-1},Cr.startCase=Da,Cr.startsWith=function(e,t,r){return e=aa(e),r=null==r?0:Gr(na(r),0,e.length),t=$n(t),e.slice(r,r+t.length)==t},Cr.subtract=pu,Cr.sum=function(e){return e&&e.length?Rt(e,Ka):0},Cr.sumBy=function(e,t){return e&&e.length?Rt(e,Ji(t,2)):0},Cr.template=function(e,t,r){var n=Cr.templateSettings;r&&ao(e,t,r)&&(t=void 0),e=aa(e),t=fa({},t,n,Bi);var i,o,s=fa({},t.imports,n.imports,Bi),a=_a(s),u=Pt(s,a),c=0,f=t.interpolate||fe,l="__p += '",h=me((t.escape||fe).source+"|"+f.source+"|"+(f===F?re:fe).source+"|"+(t.evaluate||fe).source+"|$","g"),p="//# sourceURL="+(Ae.call(t,"sourceURL")?(t.sourceURL+"").replace(/[\r\n]/g," "):"lodash.templateSources["+ ++Me+"]")+"\n";e.replace(h,(function(t,r,n,s,a,u){return n||(n=s),l+=e.slice(c,u).replace(le,Ut),r&&(i=!0,l+="' +\n__e("+r+") +\n'"),a&&(o=!0,l+="';\n"+a+";\n__p += '"),n&&(l+="' +\n((__t = ("+n+")) == null ? '' : __t) +\n'"),c=u+t.length,t})),l+="';\n";var d=Ae.call(t,"variable")&&t.variable;d||(l="with (obj) {\n"+l+"\n}\n"),l=(o?l.replace(L,""):l).replace(q,"$1").replace(N,"$1;"),l="function("+(d||"obj")+") {\n"+(d?"":"obj || (obj = {});\n")+"var __t, __p = ''"+(i?", __e = _.escape":"")+(o?", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n":";\n")+l+"return __p\n}";var v=za((function(){return pe(a,p+"return "+l).apply(void 0,u)}));if(v.source=l,Ms(v))throw v;return v},Cr.times=function(e,t){if((e=na(e))<1||e>9007199254740991)return[];var r=4294967295,n=sr(e,4294967295);e-=4294967295;for(var i=Tt(n,t=Ji(t));++r<e;)t(r);return i},Cr.toFinite=ra,Cr.toInteger=na,Cr.toLength=ia,Cr.toLower=function(e){return aa(e).toLowerCase()},Cr.toNumber=oa,Cr.toSafeInteger=function(e){return e?Gr(na(e),-9007199254740991,9007199254740991):0===e?e:0},Cr.toString=aa,Cr.toUpper=function(e){return aa(e).toUpperCase()},Cr.trim=function(e,t,r){if((e=aa(e))&&(r||void 0===t))return e.replace(G,"");if(!e||!(t=$n(t)))return e;var n=Kt(e),i=Kt(t);return ci(n,Lt(n,i),qt(n,i)+1).join("")},Cr.trimEnd=function(e,t,r){if((e=aa(e))&&(r||void 0===t))return e.replace(J,"");if(!e||!(t=$n(t)))return e;var n=Kt(e);return ci(n,0,qt(n,Kt(t))+1).join("")},Cr.trimStart=function(e,t,r){if((e=aa(e))&&(r||void 0===t))return e.replace(Y,"");if(!e||!(t=$n(t)))return e;var n=Kt(e);return ci(n,Lt(n,Kt(t))).join("")},Cr.truncate=function(e,t){var r=30,n="...";if(Vs(t)){var i="separator"in t?t.separator:i;r="length"in t?na(t.length):r,n="omission"in t?$n(t.omission):n}var o=(e=aa(e)).length;if(Mt(e)){var s=Kt(e);o=s.length}if(r>=o)return e;var a=r-Wt(n);if(a<1)return n;var u=s?ci(s,0,a).join(""):e.slice(0,a);if(void 0===i)return u+n;if(s&&(a+=u.length-a),Gs(i)){if(e.slice(a).search(i)){var c,f=u;for(i.global||(i=me(i.source,aa(ne.exec(i))+"g")),i.lastIndex=0;c=i.exec(f);)var l=c.index;u=u.slice(0,void 0===l?a:l)}}else if(e.indexOf($n(i),a)!=a){var h=u.lastIndexOf(i);h>-1&&(u=u.slice(0,h))}return u+n},Cr.unescape=function(e){return(e=aa(e))&&U.test(e)?e.replace(j,Xt):e},Cr.uniqueId=function(e){var t=++xe;return aa(e)+t},Cr.upperCase=Ua,Cr.upperFirst=Ma,Cr.each=as,Cr.eachRight=us,Cr.first=No,Ja(Cr,(fu={},un(Cr,(function(e,t){Ae.call(Cr.prototype,t)||(fu[t]=e)})),fu),{chain:!1}),Cr.VERSION="4.17.15",at(["bind","bindKey","curry","curryRight","partial","partialRight"],(function(e){Cr[e].placeholder=Cr})),at(["drop","take"],(function(e,t){Pr.prototype[e]=function(r){r=void 0===r?1:or(na(r),0);var n=this.__filtered__&&!t?new Pr(this):this.clone();return n.__filtered__?n.__takeCount__=sr(r,n.__takeCount__):n.__views__.push({size:sr(r,4294967295),type:e+(n.__dir__<0?"Right":"")}),n},Pr.prototype[e+"Right"]=function(t){return this.reverse()[e](t).reverse()}})),at(["filter","map","takeWhile"],(function(e,t){var r=t+1,n=1==r||3==r;Pr.prototype[e]=function(e){var t=this.clone();return t.__iteratees__.push({iteratee:Ji(e,3),type:r}),t.__filtered__=t.__filtered__||n,t}})),at(["head","last"],(function(e,t){var r="take"+(t?"Right":"");Pr.prototype[e]=function(){return this[r](1).value()[0]}})),at(["initial","tail"],(function(e,t){var r="drop"+(t?"":"Right");Pr.prototype[e]=function(){return this.__filtered__?new Pr(this):this[r](1)}})),Pr.prototype.compact=function(){return this.filter(Ka)},Pr.prototype.find=function(e){return this.filter(e).head()},Pr.prototype.findLast=function(e){return this.reverse().find(e)},Pr.prototype.invokeMap=Un((function(e,t){return"function"==typeof e?new Pr(this):this.map((function(r){return yn(r,e,t)}))})),Pr.prototype.reject=function(e){return this.filter(As(Ji(e)))},Pr.prototype.slice=function(e,t){e=na(e);var r=this;return r.__filtered__&&(e>0||t<0)?new Pr(r):(e<0?r=r.takeRight(-e):e&&(r=r.drop(e)),void 0!==t&&(r=(t=na(t))<0?r.dropRight(-t):r.take(t-e)),r)},Pr.prototype.takeRightWhile=function(e){return this.reverse().takeWhile(e).reverse()},Pr.prototype.toArray=function(){return this.take(4294967295)},un(Pr.prototype,(function(e,t){var r=/^(?:filter|find|map|reject)|While$/.test(t),n=/^(?:head|last)$/.test(t),i=Cr[n?"take"+("last"==t?"Right":""):t],o=n||/^find/.test(t);i&&(Cr.prototype[t]=function(){var t=this.__wrapped__,s=n?[1]:arguments,a=t instanceof Pr,u=s[0],c=a||Ls(t),f=function(e){var t=i.apply(Cr,dt([e],s));return n&&l?t[0]:t};c&&r&&"function"==typeof u&&1!=u.length&&(a=c=!1);var l=this.__chain__,h=!!this.__actions__.length,p=o&&!l,d=a&&!h;if(!o&&c){t=d?t:new Pr(this);var v=e.apply(t,s);return v.__actions__.push({func:rs,args:[f],thisArg:void 0}),new kr(v,l)}return p&&d?e.apply(this,s):(v=this.thru(f),p?n?v.value()[0]:v.value():v)})})),at(["pop","push","shift","sort","splice","unshift"],(function(e){var t=be[e],r=/^(?:push|sort|unshift)$/.test(e)?"tap":"thru",n=/^(?:pop|shift)$/.test(e);Cr.prototype[e]=function(){var e=arguments;if(n&&!this.__chain__){var i=this.value();return t.apply(Ls(i)?i:[],e)}return this[r]((function(r){return t.apply(Ls(r)?r:[],e)}))}})),un(Pr.prototype,(function(e,t){var r=Cr[t];if(r){var n=r.name+"";Ae.call(yr,n)||(yr[n]=[]),yr[n].push({name:t,func:r})}})),yr[Ri(void 0,2).name]=[{name:"wrapper",func:void 0}],Pr.prototype.clone=function(){var e=new Pr(this.__wrapped__);return e.__actions__=gi(this.__actions__),e.__dir__=this.__dir__,e.__filtered__=this.__filtered__,e.__iteratees__=gi(this.__iteratees__),e.__takeCount__=this.__takeCount__,e.__views__=gi(this.__views__),e},Pr.prototype.reverse=function(){if(this.__filtered__){var e=new Pr(this);e.__dir__=-1,e.__filtered__=!0}else(e=this.clone()).__dir__*=-1;return e},Pr.prototype.value=function(){var e=this.__wrapped__.value(),t=this.__dir__,r=Ls(e),n=t<0,i=r?e.length:0,o=function(e,t,r){var n=-1,i=r.length;for(;++n<i;){var o=r[n],s=o.size;switch(o.type){case"drop":e+=s;break;case"dropRight":t-=s;break;case"take":t=sr(t,e+s);break;case"takeRight":e=or(e,t-s)}}return{start:e,end:t}}(0,i,this.__views__),s=o.start,a=o.end,u=a-s,c=n?a:s-1,f=this.__iteratees__,l=f.length,h=0,p=sr(u,this.__takeCount__);if(!r||!n&&i==u&&p==u)return ri(e,this.__actions__);var d=[];e:for(;u--&&h<p;){for(var v=-1,m=e[c+=t];++v<l;){var g=f[v],y=g.iteratee,b=g.type,_=y(m);if(2==b)m=_;else if(!_){if(1==b)continue e;break e}}d[h++]=m}return d},Cr.prototype.at=ns,Cr.prototype.chain=function(){return ts(this)},Cr.prototype.commit=function(){return new kr(this.value(),this.__chain__)},Cr.prototype.next=function(){void 0===this.__values__&&(this.__values__=ta(this.value()));var e=this.__index__>=this.__values__.length;return{done:e,value:e?void 0:this.__values__[this.__index__++]}},Cr.prototype.plant=function(e){for(var t,r=this;r instanceof Tr;){var n=Ro(r);n.__index__=0,n.__values__=void 0,t?i.__wrapped__=n:t=n;var i=n;r=r.__wrapped__}return i.__wrapped__=e,t},Cr.prototype.reverse=function(){var e=this.__wrapped__;if(e instanceof Pr){var t=e;return this.__actions__.length&&(t=new Pr(this)),(t=t.reverse()).__actions__.push({func:rs,args:[Vo],thisArg:void 0}),new kr(t,this.__chain__)}return this.thru(Vo)},Cr.prototype.toJSON=Cr.prototype.valueOf=Cr.prototype.value=function(){return ri(this.__wrapped__,this.__actions__)},Cr.prototype.first=Cr.prototype.head,Ze&&(Cr.prototype[Ze]=function(){return this}),Cr}();Xe._=Gt,void 0===(i=function(){return Gt}.call(t,r,t,n))||(n.exports=i)}).call(this)}).call(this,r(7),r(35)(e))},function(e,t,r){var n=r(115),i=r(116),o=i;o.v1=n,o.v4=i,e.exports=o},function(e,t){var r,n,i=e.exports={};function o(){throw new Error("setTimeout has not been defined")}function s(){throw new Error("clearTimeout has not been defined")}function a(e){if(r===setTimeout)return setTimeout(e,0);if((r===o||!r)&&setTimeout)return r=setTimeout,setTimeout(e,0);try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}!function(){try{r="function"==typeof setTimeout?setTimeout:o}catch(e){r=o}try{n="function"==typeof clearTimeout?clearTimeout:s}catch(e){n=s}}();var u,c=[],f=!1,l=-1;function h(){f&&u&&(f=!1,u.length?c=u.concat(c):l=-1,c.length&&p())}function p(){if(!f){var e=a(h);f=!0;for(var t=c.length;t;){for(u=c,c=[];++l<t;)u&&u[l].run();l=-1,t=c.length}u=null,f=!1,function(e){if(n===clearTimeout)return clearTimeout(e);if((n===s||!n)&&clearTimeout)return n=clearTimeout,clearTimeout(e);try{n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}(e)}}function d(e,t){this.fun=e,this.array=t}function v(){}i.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var r=1;r<arguments.length;r++)t[r-1]=arguments[r];c.push(new d(e,t)),1!==c.length||f||a(p)},d.prototype.run=function(){this.fun.apply(null,this.array)},i.title="browser",i.browser=!0,i.env={},i.argv=[],i.version="",i.versions={},i.on=v,i.addListener=v,i.once=v,i.off=v,i.removeListener=v,i.removeAllListeners=v,i.emit=v,i.prependListener=v,i.prependOnceListener=v,i.listeners=function(e){return[]},i.binding=function(e){throw new Error("process.binding is not supported")},i.cwd=function(){return"/"},i.chdir=function(e){throw new Error("process.chdir is not supported")},i.umask=function(){return 0}},function(e,r){e.exports=t},function(e,t){var r;r=function(){return this}();try{r=r||new Function("return this")()}catch(e){"object"==typeof window&&(r=window)}e.exports=r},function(e,t,r){var n=r(21),i=r(2);function o(e,t,r){null!=r&&i.property.apply(this,arguments)}function s(e,t){e.constructor.prototype[t]||i.memoizedProperty.apply(this,arguments)}function a(e,t,r){t=t||{},o(this,"shape",e.shape),o(this,"api",t.api,!1),o(this,"type",e.type),o(this,"enum",e.enum),o(this,"min",e.min),o(this,"max",e.max),o(this,"pattern",e.pattern),o(this,"location",e.location||this.location||"body"),o(this,"name",this.name||e.xmlName||e.queryName||e.locationName||r),o(this,"isStreaming",e.streaming||this.isStreaming||!1),o(this,"requiresLength",e.requiresLength,!1),o(this,"isComposite",e.isComposite||!1),o(this,"isShape",!0,!1),o(this,"isQueryName",Boolean(e.queryName),!1),o(this,"isLocationName",Boolean(e.locationName),!1),o(this,"isIdempotent",!0===e.idempotencyToken),o(this,"isJsonValue",!0===e.jsonvalue),o(this,"isSensitive",!0===e.sensitive||e.prototype&&!0===e.prototype.sensitive),o(this,"isEventStream",Boolean(e.eventstream),!1),o(this,"isEvent",Boolean(e.event),!1),o(this,"isEventPayload",Boolean(e.eventpayload),!1),o(this,"isEventHeader",Boolean(e.eventheader),!1),o(this,"isTimestampFormatSet",Boolean(e.timestampFormat)||e.prototype&&!0===e.prototype.isTimestampFormatSet,!1),o(this,"endpointDiscoveryId",Boolean(e.endpointdiscoveryid),!1),o(this,"hostLabel",Boolean(e.hostLabel),!1),t.documentation&&(o(this,"documentation",e.documentation),o(this,"documentationUrl",e.documentationUrl)),e.xmlAttribute&&o(this,"isXmlAttribute",e.xmlAttribute||!1),o(this,"defaultValue",null),this.toWireFormat=function(e){return null==e?"":e},this.toType=function(e){return e}}function u(e){a.apply(this,arguments),o(this,"isComposite",!0),e.flattened&&o(this,"flattened",e.flattened||!1)}function c(e,t){var r=this,i=null,c=!this.isShape;u.apply(this,arguments),c&&(o(this,"defaultValue",(function(){return{}})),o(this,"members",{}),o(this,"memberNames",[]),o(this,"required",[]),o(this,"isRequired",(function(){return!1}))),e.members&&(o(this,"members",new n(e.members,t,(function(e,r){return a.create(r,t,e)}))),s(this,"memberNames",(function(){return e.xmlOrder||Object.keys(e.members)})),e.event&&(s(this,"eventPayloadMemberName",(function(){for(var e=r.members,t=r.memberNames,n=0,i=t.length;n<i;n++)if(e[t[n]].isEventPayload)return t[n]})),s(this,"eventHeaderMemberNames",(function(){for(var e=r.members,t=r.memberNames,n=[],i=0,o=t.length;i<o;i++)e[t[i]].isEventHeader&&n.push(t[i]);return n})))),e.required&&(o(this,"required",e.required),o(this,"isRequired",(function(t){if(!i){i={};for(var r=0;r<e.required.length;r++)i[e.required[r]]=!0}return i[t]}),!1,!0)),o(this,"resultWrapper",e.resultWrapper||null),e.payload&&o(this,"payload",e.payload),"string"==typeof e.xmlNamespace?o(this,"xmlNamespaceUri",e.xmlNamespace):"object"==typeof e.xmlNamespace&&(o(this,"xmlNamespacePrefix",e.xmlNamespace.prefix),o(this,"xmlNamespaceUri",e.xmlNamespace.uri))}function f(e,t){var r=this,n=!this.isShape;if(u.apply(this,arguments),n&&o(this,"defaultValue",(function(){return[]})),e.member&&s(this,"member",(function(){return a.create(e.member,t)})),this.flattened){var i=this.name;s(this,"name",(function(){return r.member.name||i}))}}function l(e,t){var r=!this.isShape;u.apply(this,arguments),r&&(o(this,"defaultValue",(function(){return{}})),o(this,"key",a.create({type:"string"},t)),o(this,"value",a.create({type:"string"},t))),e.key&&s(this,"key",(function(){return a.create(e.key,t)})),e.value&&s(this,"value",(function(){return a.create(e.value,t)}))}function h(){a.apply(this,arguments);var e=["rest-xml","query","ec2"];this.toType=function(t){return t=this.api&&e.indexOf(this.api.protocol)>-1?t||"":t,this.isJsonValue?JSON.parse(t):t&&"function"==typeof t.toString?t.toString():t},this.toWireFormat=function(e){return this.isJsonValue?JSON.stringify(e):e}}function p(){a.apply(this,arguments),this.toType=function(e){var t=i.base64.decode(e);if(this.isSensitive&&i.isNode()&&"function"==typeof i.Buffer.alloc){var r=i.Buffer.alloc(t.length,t);t.fill(0),t=r}return t},this.toWireFormat=i.base64.encode}function d(){p.apply(this,arguments)}function v(){a.apply(this,arguments),this.toType=function(e){return"boolean"==typeof e?e:null==e?null:"true"===e}}a.normalizedTypes={character:"string",double:"float",long:"integer",short:"integer",biginteger:"integer",bigdecimal:"float",blob:"binary"},a.types={structure:c,list:f,map:l,boolean:v,timestamp:function(e){var t=this;if(a.apply(this,arguments),e.timestampFormat)o(this,"timestampFormat",e.timestampFormat);else if(t.isTimestampFormatSet&&this.timestampFormat)o(this,"timestampFormat",this.timestampFormat);else if("header"===this.location)o(this,"timestampFormat","rfc822");else if("querystring"===this.location)o(this,"timestampFormat","iso8601");else if(this.api)switch(this.api.protocol){case"json":case"rest-json":o(this,"timestampFormat","unixTimestamp");break;case"rest-xml":case"query":case"ec2":o(this,"timestampFormat","iso8601")}this.toType=function(e){return null==e?null:"function"==typeof e.toUTCString?e:"string"==typeof e||"number"==typeof e?i.date.parseTimestamp(e):null},this.toWireFormat=function(e){return i.date.format(e,t.timestampFormat)}},float:function(){a.apply(this,arguments),this.toType=function(e){return null==e?null:parseFloat(e)},this.toWireFormat=this.toType},integer:function(){a.apply(this,arguments),this.toType=function(e){return null==e?null:parseInt(e,10)},this.toWireFormat=this.toType},string:h,base64:d,binary:p},a.resolve=function(e,t){if(e.shape){var r=t.api.shapes[e.shape];if(!r)throw new Error("Cannot find shape reference: "+e.shape);return r}return null},a.create=function(e,t,r){if(e.isShape)return e;var n=a.resolve(e,t);if(n){var i=Object.keys(e);t.documentation||(i=i.filter((function(e){return!e.match(/documentation/)})));var o=function(){n.constructor.call(this,e,t,r)};return o.prototype=n,new o}e.type||(e.members?e.type="structure":e.member?e.type="list":e.key?e.type="map":e.type="string");var s=e.type;if(a.normalizedTypes[e.type]&&(e.type=a.normalizedTypes[e.type]),a.types[e.type])return new a.types[e.type](e,t,r);throw new Error("Unrecognized shape type: "+s)},a.shapes={StructureShape:c,ListShape:f,MapShape:l,StringShape:h,BooleanShape:v,Base64Shape:d},e.exports=a},function(e,t,r){"use strict";(function(e){
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	var n=r(81),i=r(82),o=r(83);function s(){return u.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function a(e,t){if(s()<t)throw new RangeError("Invalid typed array length");return u.TYPED_ARRAY_SUPPORT?(e=new Uint8Array(t)).__proto__=u.prototype:(null===e&&(e=new u(t)),e.length=t),e}function u(e,t,r){if(!(u.TYPED_ARRAY_SUPPORT||this instanceof u))return new u(e,t,r);if("number"==typeof e){if("string"==typeof t)throw new Error("If encoding is specified then the first argument must be a string");return l(this,e)}return c(this,e,t,r)}function c(e,t,r,n){if("number"==typeof t)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&t instanceof ArrayBuffer?function(e,t,r,n){if(t.byteLength,r<0||t.byteLength<r)throw new RangeError("'offset' is out of bounds");if(t.byteLength<r+(n||0))throw new RangeError("'length' is out of bounds");t=void 0===r&&void 0===n?new Uint8Array(t):void 0===n?new Uint8Array(t,r):new Uint8Array(t,r,n);u.TYPED_ARRAY_SUPPORT?(e=t).__proto__=u.prototype:e=h(e,t);return e}(e,t,r,n):"string"==typeof t?function(e,t,r){"string"==typeof r&&""!==r||(r="utf8");if(!u.isEncoding(r))throw new TypeError('"encoding" must be a valid string encoding');var n=0|d(t,r),i=(e=a(e,n)).write(t,r);i!==n&&(e=e.slice(0,i));return e}(e,t,r):function(e,t){if(u.isBuffer(t)){var r=0|p(t.length);return 0===(e=a(e,r)).length?e:(t.copy(e,0,0,r),e)}if(t){if("undefined"!=typeof ArrayBuffer&&t.buffer instanceof ArrayBuffer||"length"in t)return"number"!=typeof t.length||(n=t.length)!=n?a(e,0):h(e,t);if("Buffer"===t.type&&o(t.data))return h(e,t.data)}var n;throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(e,t)}function f(e){if("number"!=typeof e)throw new TypeError('"size" argument must be a number');if(e<0)throw new RangeError('"size" argument must not be negative')}function l(e,t){if(f(t),e=a(e,t<0?0:0|p(t)),!u.TYPED_ARRAY_SUPPORT)for(var r=0;r<t;++r)e[r]=0;return e}function h(e,t){var r=t.length<0?0:0|p(t.length);e=a(e,r);for(var n=0;n<r;n+=1)e[n]=255&t[n];return e}function p(e){if(e>=s())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+s().toString(16)+" bytes");return 0|e}function d(e,t){if(u.isBuffer(e))return e.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(e)||e instanceof ArrayBuffer))return e.byteLength;"string"!=typeof e&&(e=""+e);var r=e.length;if(0===r)return 0;for(var n=!1;;)switch(t){case"ascii":case"latin1":case"binary":return r;case"utf8":case"utf-8":case void 0:return B(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*r;case"hex":return r>>>1;case"base64":return z(e).length;default:if(n)return B(e).length;t=(""+t).toLowerCase(),n=!0}}function v(e,t,r){var n=!1;if((void 0===t||t<0)&&(t=0),t>this.length)return"";if((void 0===r||r>this.length)&&(r=this.length),r<=0)return"";if((r>>>=0)<=(t>>>=0))return"";for(e||(e="utf8");;)switch(e){case"hex":return T(this,t,r);case"utf8":case"utf-8":return I(this,t,r);case"ascii":return C(this,t,r);case"latin1":case"binary":return R(this,t,r);case"base64":return x(this,t,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return k(this,t,r);default:if(n)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase(),n=!0}}function m(e,t,r){var n=e[t];e[t]=e[r],e[r]=n}function g(e,t,r,n,i){if(0===e.length)return-1;if("string"==typeof r?(n=r,r=0):r>2147483647?r=2147483647:r<-2147483648&&(r=-2147483648),r=+r,isNaN(r)&&(r=i?0:e.length-1),r<0&&(r=e.length+r),r>=e.length){if(i)return-1;r=e.length-1}else if(r<0){if(!i)return-1;r=0}if("string"==typeof t&&(t=u.from(t,n)),u.isBuffer(t))return 0===t.length?-1:y(e,t,r,n,i);if("number"==typeof t)return t&=255,u.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(e,t,r):Uint8Array.prototype.lastIndexOf.call(e,t,r):y(e,[t],r,n,i);throw new TypeError("val must be string, number or Buffer")}function y(e,t,r,n,i){var o,s=1,a=e.length,u=t.length;if(void 0!==n&&("ucs2"===(n=String(n).toLowerCase())||"ucs-2"===n||"utf16le"===n||"utf-16le"===n)){if(e.length<2||t.length<2)return-1;s=2,a/=2,u/=2,r/=2}function c(e,t){return 1===s?e[t]:e.readUInt16BE(t*s)}if(i){var f=-1;for(o=r;o<a;o++)if(c(e,o)===c(t,-1===f?0:o-f)){if(-1===f&&(f=o),o-f+1===u)return f*s}else-1!==f&&(o-=o-f),f=-1}else for(r+u>a&&(r=a-u),o=r;o>=0;o--){for(var l=!0,h=0;h<u;h++)if(c(e,o+h)!==c(t,h)){l=!1;break}if(l)return o}return-1}function b(e,t,r,n){r=Number(r)||0;var i=e.length-r;n?(n=Number(n))>i&&(n=i):n=i;var o=t.length;if(o%2!=0)throw new TypeError("Invalid hex string");n>o/2&&(n=o/2);for(var s=0;s<n;++s){var a=parseInt(t.substr(2*s,2),16);if(isNaN(a))return s;e[r+s]=a}return s}function _(e,t,r,n){return F(B(t,e.length-r),e,r,n)}function w(e,t,r,n){return F(function(e){for(var t=[],r=0;r<e.length;++r)t.push(255&e.charCodeAt(r));return t}(t),e,r,n)}function E(e,t,r,n){return w(e,t,r,n)}function S(e,t,r,n){return F(z(t),e,r,n)}function A(e,t,r,n){return F(function(e,t){for(var r,n,i,o=[],s=0;s<e.length&&!((t-=2)<0);++s)r=e.charCodeAt(s),n=r>>8,i=r%256,o.push(i),o.push(n);return o}(t,e.length-r),e,r,n)}function x(e,t,r){return 0===t&&r===e.length?n.fromByteArray(e):n.fromByteArray(e.slice(t,r))}function I(e,t,r){r=Math.min(e.length,r);for(var n=[],i=t;i<r;){var o,s,a,u,c=e[i],f=null,l=c>239?4:c>223?3:c>191?2:1;if(i+l<=r)switch(l){case 1:c<128&&(f=c);break;case 2:128==(192&(o=e[i+1]))&&(u=(31&c)<<6|63&o)>127&&(f=u);break;case 3:o=e[i+1],s=e[i+2],128==(192&o)&&128==(192&s)&&(u=(15&c)<<12|(63&o)<<6|63&s)>2047&&(u<55296||u>57343)&&(f=u);break;case 4:o=e[i+1],s=e[i+2],a=e[i+3],128==(192&o)&&128==(192&s)&&128==(192&a)&&(u=(15&c)<<18|(63&o)<<12|(63&s)<<6|63&a)>65535&&u<1114112&&(f=u)}null===f?(f=65533,l=1):f>65535&&(f-=65536,n.push(f>>>10&1023|55296),f=56320|1023&f),n.push(f),i+=l}return function(e){var t=e.length;if(t<=4096)return String.fromCharCode.apply(String,e);var r="",n=0;for(;n<t;)r+=String.fromCharCode.apply(String,e.slice(n,n+=4096));return r}(n)}t.Buffer=u,t.SlowBuffer=function(e){+e!=e&&(e=0);return u.alloc(+e)},t.INSPECT_MAX_BYTES=50,u.TYPED_ARRAY_SUPPORT=void 0!==e.TYPED_ARRAY_SUPPORT?e.TYPED_ARRAY_SUPPORT:function(){try{var e=new Uint8Array(1);return e.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===e.foo()&&"function"==typeof e.subarray&&0===e.subarray(1,1).byteLength}catch(e){return!1}}(),t.kMaxLength=s(),u.poolSize=8192,u._augment=function(e){return e.__proto__=u.prototype,e},u.from=function(e,t,r){return c(null,e,t,r)},u.TYPED_ARRAY_SUPPORT&&(u.prototype.__proto__=Uint8Array.prototype,u.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&u[Symbol.species]===u&&Object.defineProperty(u,Symbol.species,{value:null,configurable:!0})),u.alloc=function(e,t,r){return function(e,t,r,n){return f(t),t<=0?a(e,t):void 0!==r?"string"==typeof n?a(e,t).fill(r,n):a(e,t).fill(r):a(e,t)}(null,e,t,r)},u.allocUnsafe=function(e){return l(null,e)},u.allocUnsafeSlow=function(e){return l(null,e)},u.isBuffer=function(e){return!(null==e||!e._isBuffer)},u.compare=function(e,t){if(!u.isBuffer(e)||!u.isBuffer(t))throw new TypeError("Arguments must be Buffers");if(e===t)return 0;for(var r=e.length,n=t.length,i=0,o=Math.min(r,n);i<o;++i)if(e[i]!==t[i]){r=e[i],n=t[i];break}return r<n?-1:n<r?1:0},u.isEncoding=function(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},u.concat=function(e,t){if(!o(e))throw new TypeError('"list" argument must be an Array of Buffers');if(0===e.length)return u.alloc(0);var r;if(void 0===t)for(t=0,r=0;r<e.length;++r)t+=e[r].length;var n=u.allocUnsafe(t),i=0;for(r=0;r<e.length;++r){var s=e[r];if(!u.isBuffer(s))throw new TypeError('"list" argument must be an Array of Buffers');s.copy(n,i),i+=s.length}return n},u.byteLength=d,u.prototype._isBuffer=!0,u.prototype.swap16=function(){var e=this.length;if(e%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var t=0;t<e;t+=2)m(this,t,t+1);return this},u.prototype.swap32=function(){var e=this.length;if(e%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var t=0;t<e;t+=4)m(this,t,t+3),m(this,t+1,t+2);return this},u.prototype.swap64=function(){var e=this.length;if(e%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var t=0;t<e;t+=8)m(this,t,t+7),m(this,t+1,t+6),m(this,t+2,t+5),m(this,t+3,t+4);return this},u.prototype.toString=function(){var e=0|this.length;return 0===e?"":0===arguments.length?I(this,0,e):v.apply(this,arguments)},u.prototype.equals=function(e){if(!u.isBuffer(e))throw new TypeError("Argument must be a Buffer");return this===e||0===u.compare(this,e)},u.prototype.inspect=function(){var e="",r=t.INSPECT_MAX_BYTES;return this.length>0&&(e=this.toString("hex",0,r).match(/.{2}/g).join(" "),this.length>r&&(e+=" ... ")),"<Buffer "+e+">"},u.prototype.compare=function(e,t,r,n,i){if(!u.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(void 0===t&&(t=0),void 0===r&&(r=e?e.length:0),void 0===n&&(n=0),void 0===i&&(i=this.length),t<0||r>e.length||n<0||i>this.length)throw new RangeError("out of range index");if(n>=i&&t>=r)return 0;if(n>=i)return-1;if(t>=r)return 1;if(this===e)return 0;for(var o=(i>>>=0)-(n>>>=0),s=(r>>>=0)-(t>>>=0),a=Math.min(o,s),c=this.slice(n,i),f=e.slice(t,r),l=0;l<a;++l)if(c[l]!==f[l]){o=c[l],s=f[l];break}return o<s?-1:s<o?1:0},u.prototype.includes=function(e,t,r){return-1!==this.indexOf(e,t,r)},u.prototype.indexOf=function(e,t,r){return g(this,e,t,r,!0)},u.prototype.lastIndexOf=function(e,t,r){return g(this,e,t,r,!1)},u.prototype.write=function(e,t,r,n){if(void 0===t)n="utf8",r=this.length,t=0;else if(void 0===r&&"string"==typeof t)n=t,r=this.length,t=0;else{if(!isFinite(t))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");t|=0,isFinite(r)?(r|=0,void 0===n&&(n="utf8")):(n=r,r=void 0)}var i=this.length-t;if((void 0===r||r>i)&&(r=i),e.length>0&&(r<0||t<0)||t>this.length)throw new RangeError("Attempt to write outside buffer bounds");n||(n="utf8");for(var o=!1;;)switch(n){case"hex":return b(this,e,t,r);case"utf8":case"utf-8":return _(this,e,t,r);case"ascii":return w(this,e,t,r);case"latin1":case"binary":return E(this,e,t,r);case"base64":return S(this,e,t,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return A(this,e,t,r);default:if(o)throw new TypeError("Unknown encoding: "+n);n=(""+n).toLowerCase(),o=!0}},u.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function C(e,t,r){var n="";r=Math.min(e.length,r);for(var i=t;i<r;++i)n+=String.fromCharCode(127&e[i]);return n}function R(e,t,r){var n="";r=Math.min(e.length,r);for(var i=t;i<r;++i)n+=String.fromCharCode(e[i]);return n}function T(e,t,r){var n=e.length;(!t||t<0)&&(t=0),(!r||r<0||r>n)&&(r=n);for(var i="",o=t;o<r;++o)i+=M(e[o]);return i}function k(e,t,r){for(var n=e.slice(t,r),i="",o=0;o<n.length;o+=2)i+=String.fromCharCode(n[o]+256*n[o+1]);return i}function P(e,t,r){if(e%1!=0||e<0)throw new RangeError("offset is not uint");if(e+t>r)throw new RangeError("Trying to access beyond buffer length")}function O(e,t,r,n,i,o){if(!u.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(t>i||t<o)throw new RangeError('"value" argument is out of bounds');if(r+n>e.length)throw new RangeError("Index out of range")}function L(e,t,r,n){t<0&&(t=65535+t+1);for(var i=0,o=Math.min(e.length-r,2);i<o;++i)e[r+i]=(t&255<<8*(n?i:1-i))>>>8*(n?i:1-i)}function q(e,t,r,n){t<0&&(t=4294967295+t+1);for(var i=0,o=Math.min(e.length-r,4);i<o;++i)e[r+i]=t>>>8*(n?i:3-i)&255}function N(e,t,r,n,i,o){if(r+n>e.length)throw new RangeError("Index out of range");if(r<0)throw new RangeError("Index out of range")}function j(e,t,r,n,o){return o||N(e,0,r,4),i.write(e,t,r,n,23,4),r+4}function D(e,t,r,n,o){return o||N(e,0,r,8),i.write(e,t,r,n,52,8),r+8}u.prototype.slice=function(e,t){var r,n=this.length;if((e=~~e)<0?(e+=n)<0&&(e=0):e>n&&(e=n),(t=void 0===t?n:~~t)<0?(t+=n)<0&&(t=0):t>n&&(t=n),t<e&&(t=e),u.TYPED_ARRAY_SUPPORT)(r=this.subarray(e,t)).__proto__=u.prototype;else{var i=t-e;r=new u(i,void 0);for(var o=0;o<i;++o)r[o]=this[o+e]}return r},u.prototype.readUIntLE=function(e,t,r){e|=0,t|=0,r||P(e,t,this.length);for(var n=this[e],i=1,o=0;++o<t&&(i*=256);)n+=this[e+o]*i;return n},u.prototype.readUIntBE=function(e,t,r){e|=0,t|=0,r||P(e,t,this.length);for(var n=this[e+--t],i=1;t>0&&(i*=256);)n+=this[e+--t]*i;return n},u.prototype.readUInt8=function(e,t){return t||P(e,1,this.length),this[e]},u.prototype.readUInt16LE=function(e,t){return t||P(e,2,this.length),this[e]|this[e+1]<<8},u.prototype.readUInt16BE=function(e,t){return t||P(e,2,this.length),this[e]<<8|this[e+1]},u.prototype.readUInt32LE=function(e,t){return t||P(e,4,this.length),(this[e]|this[e+1]<<8|this[e+2]<<16)+16777216*this[e+3]},u.prototype.readUInt32BE=function(e,t){return t||P(e,4,this.length),16777216*this[e]+(this[e+1]<<16|this[e+2]<<8|this[e+3])},u.prototype.readIntLE=function(e,t,r){e|=0,t|=0,r||P(e,t,this.length);for(var n=this[e],i=1,o=0;++o<t&&(i*=256);)n+=this[e+o]*i;return n>=(i*=128)&&(n-=Math.pow(2,8*t)),n},u.prototype.readIntBE=function(e,t,r){e|=0,t|=0,r||P(e,t,this.length);for(var n=t,i=1,o=this[e+--n];n>0&&(i*=256);)o+=this[e+--n]*i;return o>=(i*=128)&&(o-=Math.pow(2,8*t)),o},u.prototype.readInt8=function(e,t){return t||P(e,1,this.length),128&this[e]?-1*(255-this[e]+1):this[e]},u.prototype.readInt16LE=function(e,t){t||P(e,2,this.length);var r=this[e]|this[e+1]<<8;return 32768&r?4294901760|r:r},u.prototype.readInt16BE=function(e,t){t||P(e,2,this.length);var r=this[e+1]|this[e]<<8;return 32768&r?4294901760|r:r},u.prototype.readInt32LE=function(e,t){return t||P(e,4,this.length),this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24},u.prototype.readInt32BE=function(e,t){return t||P(e,4,this.length),this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]},u.prototype.readFloatLE=function(e,t){return t||P(e,4,this.length),i.read(this,e,!0,23,4)},u.prototype.readFloatBE=function(e,t){return t||P(e,4,this.length),i.read(this,e,!1,23,4)},u.prototype.readDoubleLE=function(e,t){return t||P(e,8,this.length),i.read(this,e,!0,52,8)},u.prototype.readDoubleBE=function(e,t){return t||P(e,8,this.length),i.read(this,e,!1,52,8)},u.prototype.writeUIntLE=function(e,t,r,n){(e=+e,t|=0,r|=0,n)||O(this,e,t,r,Math.pow(2,8*r)-1,0);var i=1,o=0;for(this[t]=255&e;++o<r&&(i*=256);)this[t+o]=e/i&255;return t+r},u.prototype.writeUIntBE=function(e,t,r,n){(e=+e,t|=0,r|=0,n)||O(this,e,t,r,Math.pow(2,8*r)-1,0);var i=r-1,o=1;for(this[t+i]=255&e;--i>=0&&(o*=256);)this[t+i]=e/o&255;return t+r},u.prototype.writeUInt8=function(e,t,r){return e=+e,t|=0,r||O(this,e,t,1,255,0),u.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),this[t]=255&e,t+1},u.prototype.writeUInt16LE=function(e,t,r){return e=+e,t|=0,r||O(this,e,t,2,65535,0),u.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):L(this,e,t,!0),t+2},u.prototype.writeUInt16BE=function(e,t,r){return e=+e,t|=0,r||O(this,e,t,2,65535,0),u.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):L(this,e,t,!1),t+2},u.prototype.writeUInt32LE=function(e,t,r){return e=+e,t|=0,r||O(this,e,t,4,4294967295,0),u.TYPED_ARRAY_SUPPORT?(this[t+3]=e>>>24,this[t+2]=e>>>16,this[t+1]=e>>>8,this[t]=255&e):q(this,e,t,!0),t+4},u.prototype.writeUInt32BE=function(e,t,r){return e=+e,t|=0,r||O(this,e,t,4,4294967295,0),u.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):q(this,e,t,!1),t+4},u.prototype.writeIntLE=function(e,t,r,n){if(e=+e,t|=0,!n){var i=Math.pow(2,8*r-1);O(this,e,t,r,i-1,-i)}var o=0,s=1,a=0;for(this[t]=255&e;++o<r&&(s*=256);)e<0&&0===a&&0!==this[t+o-1]&&(a=1),this[t+o]=(e/s>>0)-a&255;return t+r},u.prototype.writeIntBE=function(e,t,r,n){if(e=+e,t|=0,!n){var i=Math.pow(2,8*r-1);O(this,e,t,r,i-1,-i)}var o=r-1,s=1,a=0;for(this[t+o]=255&e;--o>=0&&(s*=256);)e<0&&0===a&&0!==this[t+o+1]&&(a=1),this[t+o]=(e/s>>0)-a&255;return t+r},u.prototype.writeInt8=function(e,t,r){return e=+e,t|=0,r||O(this,e,t,1,127,-128),u.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),e<0&&(e=255+e+1),this[t]=255&e,t+1},u.prototype.writeInt16LE=function(e,t,r){return e=+e,t|=0,r||O(this,e,t,2,32767,-32768),u.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):L(this,e,t,!0),t+2},u.prototype.writeInt16BE=function(e,t,r){return e=+e,t|=0,r||O(this,e,t,2,32767,-32768),u.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):L(this,e,t,!1),t+2},u.prototype.writeInt32LE=function(e,t,r){return e=+e,t|=0,r||O(this,e,t,4,2147483647,-2147483648),u.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8,this[t+2]=e>>>16,this[t+3]=e>>>24):q(this,e,t,!0),t+4},u.prototype.writeInt32BE=function(e,t,r){return e=+e,t|=0,r||O(this,e,t,4,2147483647,-2147483648),e<0&&(e=4294967295+e+1),u.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):q(this,e,t,!1),t+4},u.prototype.writeFloatLE=function(e,t,r){return j(this,e,t,!0,r)},u.prototype.writeFloatBE=function(e,t,r){return j(this,e,t,!1,r)},u.prototype.writeDoubleLE=function(e,t,r){return D(this,e,t,!0,r)},u.prototype.writeDoubleBE=function(e,t,r){return D(this,e,t,!1,r)},u.prototype.copy=function(e,t,r,n){if(r||(r=0),n||0===n||(n=this.length),t>=e.length&&(t=e.length),t||(t=0),n>0&&n<r&&(n=r),n===r)return 0;if(0===e.length||0===this.length)return 0;if(t<0)throw new RangeError("targetStart out of bounds");if(r<0||r>=this.length)throw new RangeError("sourceStart out of bounds");if(n<0)throw new RangeError("sourceEnd out of bounds");n>this.length&&(n=this.length),e.length-t<n-r&&(n=e.length-t+r);var i,o=n-r;if(this===e&&r<t&&t<n)for(i=o-1;i>=0;--i)e[i+t]=this[i+r];else if(o<1e3||!u.TYPED_ARRAY_SUPPORT)for(i=0;i<o;++i)e[i+t]=this[i+r];else Uint8Array.prototype.set.call(e,this.subarray(r,r+o),t);return o},u.prototype.fill=function(e,t,r,n){if("string"==typeof e){if("string"==typeof t?(n=t,t=0,r=this.length):"string"==typeof r&&(n=r,r=this.length),1===e.length){var i=e.charCodeAt(0);i<256&&(e=i)}if(void 0!==n&&"string"!=typeof n)throw new TypeError("encoding must be a string");if("string"==typeof n&&!u.isEncoding(n))throw new TypeError("Unknown encoding: "+n)}else"number"==typeof e&&(e&=255);if(t<0||this.length<t||this.length<r)throw new RangeError("Out of range index");if(r<=t)return this;var o;if(t>>>=0,r=void 0===r?this.length:r>>>0,e||(e=0),"number"==typeof e)for(o=t;o<r;++o)this[o]=e;else{var s=u.isBuffer(e)?e:B(new u(e,n).toString()),a=s.length;for(o=0;o<r-t;++o)this[o+t]=s[o%a]}return this};var U=/[^+\/0-9A-Za-z-_]/g;function M(e){return e<16?"0"+e.toString(16):e.toString(16)}function B(e,t){var r;t=t||1/0;for(var n=e.length,i=null,o=[],s=0;s<n;++s){if((r=e.charCodeAt(s))>55295&&r<57344){if(!i){if(r>56319){(t-=3)>-1&&o.push(239,191,189);continue}if(s+1===n){(t-=3)>-1&&o.push(239,191,189);continue}i=r;continue}if(r<56320){(t-=3)>-1&&o.push(239,191,189),i=r;continue}r=65536+(i-55296<<10|r-56320)}else i&&(t-=3)>-1&&o.push(239,191,189);if(i=null,r<128){if((t-=1)<0)break;o.push(r)}else if(r<2048){if((t-=2)<0)break;o.push(r>>6|192,63&r|128)}else if(r<65536){if((t-=3)<0)break;o.push(r>>12|224,r>>6&63|128,63&r|128)}else{if(!(r<1114112))throw new Error("Invalid code point");if((t-=4)<0)break;o.push(r>>18|240,r>>12&63|128,r>>6&63|128,63&r|128)}}return o}function z(e){return n.toByteArray(function(e){if((e=function(e){return e.trim?e.trim():e.replace(/^\s+|\s+$/g,"")}(e).replace(U,"")).length<2)return"";for(;e.length%4!=0;)e+="=";return e}(e))}function F(e,t,r,n){for(var i=0;i<n&&!(i+r>=t.length||i>=e.length);++i)t[i+r]=e[i];return i}}).call(this,r(7))},function(e,t,r){r(11);var n=r(1),i=n.Service,o=n.apiLoader;o.services.sts={},n.STS=i.defineService("sts",["2011-06-15"]),r(100),Object.defineProperty(o.services.sts,"2011-06-15",{get:function(){var e=r(101);return e.paginators=r(102).pagination,e},enumerable:!0,configurable:!0}),e.exports=n.STS},function(e,t,r){var n=r(2);n.crypto.lib=r(79),n.Buffer=r(9).Buffer,n.url=r(87),n.querystring=r(36),n.realClock=r(92),n.environment="js",n.createEventStream=r(93).createEventStream,n.isBrowser=function(){return!0},n.isNode=function(){return!1};var i=r(1);if(e.exports=i,r(29),r(30),r(99),r(103),r(104),r(105),r(110),i.XML.Parser=r(111),r(112),void 0===o)var o={browser:!0}},function(e,t,r){var n=r(2),i=r(17).populateHostPrefix;function o(e,t,r,i){var o=[e,t].join("/");o=o.replace(/\/+/g,"/");var s={},a=!1;if(n.each(r.members,(function(e,t){var r=i[e];if(null!=r)if("uri"===t.location){var u=new RegExp("\\{"+t.name+"(\\+)?\\}");o=o.replace(u,(function(e,t){return(t?n.uriEscapePath:n.uriEscape)(String(r))}))}else"querystring"===t.location&&(a=!0,"list"===t.type?s[t.name]=r.map((function(e){return n.uriEscape(t.member.toWireFormat(e).toString())})):"map"===t.type?n.each(r,(function(e,t){Array.isArray(t)?s[e]=t.map((function(e){return n.uriEscape(String(e))})):s[e]=n.uriEscape(String(t))})):s[t.name]=n.uriEscape(t.toWireFormat(r).toString()))})),a){o+=o.indexOf("?")>=0?"&":"?";var u=[];n.arrayEach(Object.keys(s).sort(),(function(e){Array.isArray(s[e])||(s[e]=[s[e]]);for(var t=0;t<s[e].length;t++)u.push(n.uriEscape(String(e))+"="+s[e][t])})),o+=u.join("&")}return o}e.exports={buildRequest:function(e){!function(e){e.httpRequest.method=e.service.api.operations[e.operation].httpMethod}(e),function(e){var t=e.service.api.operations[e.operation],r=t.input,n=o(e.httpRequest.endpoint.path,t.httpPath,r,e.params);e.httpRequest.path=n}(e),function(e){var t=e.service.api.operations[e.operation];n.each(t.input.members,(function(t,r){var i=e.params[t];null!=i&&("headers"===r.location&&"map"===r.type?n.each(i,(function(t,n){e.httpRequest.headers[r.name+t]=n})):"header"===r.location&&(i=r.toWireFormat(i).toString(),r.isJsonValue&&(i=n.base64.encode(i)),e.httpRequest.headers[r.name]=i))}))}(e),i(e)},extractError:function(){},extractData:function(e){var t=e.request,r={},i=e.httpResponse,o=t.service.api.operations[t.operation].output,s={};n.each(i.headers,(function(e,t){s[e.toLowerCase()]=t})),n.each(o.members,(function(e,t){var o=(t.name||e).toLowerCase();if("headers"===t.location&&"map"===t.type){r[e]={};var a=t.isLocationName?t.name:"",u=new RegExp("^"+a+"(.+)","i");n.each(i.headers,(function(t,n){var i=t.match(u);null!==i&&(r[e][i[1]]=n)}))}else if("header"===t.location){if(void 0!==s[o]){var c=t.isJsonValue?n.base64.decode(s[o]):s[o];r[e]=t.toType(c)}}else"statusCode"===t.location&&(r[e]=parseInt(i.statusCode,10))})),e.data=r},generateURI:o}},function(e,t,r){var n=r(9).Buffer;"undefined"!=typeof ArrayBuffer&&void 0===ArrayBuffer.isView&&(ArrayBuffer.isView=function(e){return i.indexOf(Object.prototype.toString.call(e))>-1});var i=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]","[object DataView]"];e.exports={isEmptyData:function(e){return"string"==typeof e?0===e.length:0===e.byteLength},convertToBuffer:function(e){return"string"==typeof e&&(e=new n(e,"utf8")),ArrayBuffer.isView(e)?new Uint8Array(e.buffer,e.byteOffset,e.byteLength/Uint8Array.BYTES_PER_ELEMENT):new Uint8Array(e)}}},function(e,t,r){var n=r(2),i=r(15),o=r(16),s=r(17).populateHostPrefix;e.exports={buildRequest:function(e){var t=e.httpRequest,r=e.service.api,n=r.targetPrefix+"."+r.operations[e.operation].name,o=r.jsonVersion||"1.0",a=r.operations[e.operation].input,u=new i;1===o&&(o="1.0"),t.body=u.build(e.params||{},a),t.headers["Content-Type"]="application/x-amz-json-"+o,t.headers["X-Amz-Target"]=n,s(e)},extractError:function(e){var t={},r=e.httpResponse;if(t.code=r.headers["x-amzn-errortype"]||"UnknownError","string"==typeof t.code&&(t.code=t.code.split(":")[0]),r.body.length>0)try{var i=JSON.parse(r.body.toString());(i.__type||i.code)&&(t.code=(i.__type||i.code).split("#").pop()),"RequestEntityTooLarge"===t.code?t.message="Request body must be less than 1 MB":t.message=i.message||i.Message||null}catch(i){t.statusCode=r.statusCode,t.message=r.statusMessage}else t.statusCode=r.statusCode,t.message=r.statusCode.toString();e.error=n.error(new Error,t)},extractData:function(e){var t=e.httpResponse.body.toString()||"{}";if(!1===e.request.service.config.convertResponseTypes)e.data=JSON.parse(t);else{var r=e.request.service.api.operations[e.request.operation].output||{},n=new o;e.data=n.parse(t,r)}}}},function(e,t,r){var n=r(2);function i(){}function o(e,t){if(t&&null!=e)switch(t.type){case"structure":return function(e,t){var r={};return n.each(e,(function(e,n){var i=t.members[e];if(i){if("body"!==i.location)return;var s=i.isLocationName?i.name:e,a=o(n,i);void 0!==a&&(r[s]=a)}})),r}(e,t);case"map":return function(e,t){var r={};return n.each(e,(function(e,n){var i=o(n,t.value);void 0!==i&&(r[e]=i)})),r}(e,t);case"list":return function(e,t){var r=[];return n.arrayEach(e,(function(e){var n=o(e,t.member);void 0!==n&&r.push(n)})),r}(e,t);default:return function(e,t){return t.toWireFormat(e)}(e,t)}}i.prototype.build=function(e,t){return JSON.stringify(o(e,t))},e.exports=i},function(e,t,r){var n=r(2);function i(){}function o(e,t){if(t&&void 0!==e)switch(t.type){case"structure":return function(e,t){if(null==e)return;var r={},i=t.members;return n.each(i,(function(t,n){var i=n.isLocationName?n.name:t;if(Object.prototype.hasOwnProperty.call(e,i)){var s=o(e[i],n);void 0!==s&&(r[t]=s)}})),r}(e,t);case"map":return function(e,t){if(null==e)return;var r={};return n.each(e,(function(e,n){var i=o(n,t.value);r[e]=void 0===i?null:i})),r}(e,t);case"list":return function(e,t){if(null==e)return;var r=[];return n.arrayEach(e,(function(e){var n=o(e,t.member);void 0===n?r.push(null):r.push(n)})),r}(e,t);default:return function(e,t){return t.toType(e)}(e,t)}}i.prototype.parse=function(e,t){return o(JSON.parse(e),t)},e.exports=i},function(e,t,r){var n=r(2),i=r(1);e.exports={populateHostPrefix:function(e){if(!e.service.config.hostPrefixEnabled)return e;var t,r,o,s=e.service.api.operations[e.operation];if(function(e){var t=e.service.api,r=t.operations[e.operation],i=t.endpointOperation&&t.endpointOperation===n.string.lowerFirst(r.name);return"NULL"!==r.endpointDiscoveryRequired||!0===i}(e))return e;if(s.endpoint&&s.endpoint.hostPrefix){var a=function(e,t,r){return n.each(r.members,(function(r,i){if(!0===i.hostLabel){if("string"!=typeof t[r]||""===t[r])throw n.error(new Error,{message:"Parameter "+r+" should be a non-empty string.",code:"InvalidParameter"});var o=new RegExp("\\{"+r+"\\}","g");e=e.replace(o,t[r])}})),e}(s.endpoint.hostPrefix,e.params,s.input);!function(e,t){e.host&&(e.host=t+e.host);e.hostname&&(e.hostname=t+e.hostname)}(e.httpRequest.endpoint,a),t=e.httpRequest.endpoint.hostname,r=t.split("."),o=/^[a-zA-Z0-9]{1}$|^[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]$/,n.arrayEach(r,(function(e){if(!e.length||e.length<1||e.length>63)throw n.error(new Error,{code:"ValidationError",message:"Hostname label length should be between 1 to 63 characters, inclusive."});if(!o.test(e))throw i.util.error(new Error,{code:"ValidationError",message:e+" is not hostname compatible."})}))}return e}}},function(e,t,r){!function(e){"use strict";function t(e){return null!==e&&"[object Array]"===Object.prototype.toString.call(e)}function r(e){return null!==e&&"[object Object]"===Object.prototype.toString.call(e)}function n(e,i){if(e===i)return!0;if(Object.prototype.toString.call(e)!==Object.prototype.toString.call(i))return!1;if(!0===t(e)){if(e.length!==i.length)return!1;for(var o=0;o<e.length;o++)if(!1===n(e[o],i[o]))return!1;return!0}if(!0===r(e)){var s={};for(var a in e)if(hasOwnProperty.call(e,a)){if(!1===n(e[a],i[a]))return!1;s[a]=!0}for(var u in i)if(hasOwnProperty.call(i,u)&&!0!==s[u])return!1;return!0}return!1}function i(e){if(""===e||!1===e||null===e)return!0;if(t(e)&&0===e.length)return!0;if(r(e)){for(var n in e)if(e.hasOwnProperty(n))return!1;return!0}return!1}var o;o="function"==typeof String.prototype.trimLeft?function(e){return e.trimLeft()}:function(e){return e.match(/^\s*(.*)/)[1]};var s=0,a=2,u={".":"Dot","*":"Star",",":"Comma",":":"Colon","{":"Lbrace","}":"Rbrace","]":"Rbracket","(":"Lparen",")":"Rparen","@":"Current"},c={"<":!0,">":!0,"=":!0,"!":!0},f={" ":!0,"\t":!0,"\n":!0};function l(e){return e>="0"&&e<="9"||"-"===e}function h(){}h.prototype={tokenize:function(e){var t,r,n,i,o=[];for(this._current=0;this._current<e.length;)if((i=e[this._current])>="a"&&i<="z"||i>="A"&&i<="Z"||"_"===i)t=this._current,r=this._consumeUnquotedIdentifier(e),o.push({type:"UnquotedIdentifier",value:r,start:t});else if(void 0!==u[e[this._current]])o.push({type:u[e[this._current]],value:e[this._current],start:this._current}),this._current++;else if(l(e[this._current]))n=this._consumeNumber(e),o.push(n);else if("["===e[this._current])n=this._consumeLBracket(e),o.push(n);else if('"'===e[this._current])t=this._current,r=this._consumeQuotedIdentifier(e),o.push({type:"QuotedIdentifier",value:r,start:t});else if("'"===e[this._current])t=this._current,r=this._consumeRawStringLiteral(e),o.push({type:"Literal",value:r,start:t});else if("`"===e[this._current]){t=this._current;var s=this._consumeLiteral(e);o.push({type:"Literal",value:s,start:t})}else if(void 0!==c[e[this._current]])o.push(this._consumeOperator(e));else if(void 0!==f[e[this._current]])this._current++;else if("&"===e[this._current])t=this._current,this._current++,"&"===e[this._current]?(this._current++,o.push({type:"And",value:"&&",start:t})):o.push({type:"Expref",value:"&",start:t});else{if("|"!==e[this._current]){var a=new Error("Unknown character:"+e[this._current]);throw a.name="LexerError",a}t=this._current,this._current++,"|"===e[this._current]?(this._current++,o.push({type:"Or",value:"||",start:t})):o.push({type:"Pipe",value:"|",start:t})}return o},_consumeUnquotedIdentifier:function(e){var t,r=this._current;for(this._current++;this._current<e.length&&((t=e[this._current])>="a"&&t<="z"||t>="A"&&t<="Z"||t>="0"&&t<="9"||"_"===t);)this._current++;return e.slice(r,this._current)},_consumeQuotedIdentifier:function(e){var t=this._current;this._current++;for(var r=e.length;'"'!==e[this._current]&&this._current<r;){var n=this._current;"\\"!==e[n]||"\\"!==e[n+1]&&'"'!==e[n+1]?n++:n+=2,this._current=n}return this._current++,JSON.parse(e.slice(t,this._current))},_consumeRawStringLiteral:function(e){var t=this._current;this._current++;for(var r=e.length;"'"!==e[this._current]&&this._current<r;){var n=this._current;"\\"!==e[n]||"\\"!==e[n+1]&&"'"!==e[n+1]?n++:n+=2,this._current=n}return this._current++,e.slice(t+1,this._current-1).replace("\\'","'")},_consumeNumber:function(e){var t=this._current;this._current++;for(var r=e.length;l(e[this._current])&&this._current<r;)this._current++;return{type:"Number",value:parseInt(e.slice(t,this._current)),start:t}},_consumeLBracket:function(e){var t=this._current;return this._current++,"?"===e[this._current]?(this._current++,{type:"Filter",value:"[?",start:t}):"]"===e[this._current]?(this._current++,{type:"Flatten",value:"[]",start:t}):{type:"Lbracket",value:"[",start:t}},_consumeOperator:function(e){var t=this._current,r=e[t];return this._current++,"!"===r?"="===e[this._current]?(this._current++,{type:"NE",value:"!=",start:t}):{type:"Not",value:"!",start:t}:"<"===r?"="===e[this._current]?(this._current++,{type:"LTE",value:"<=",start:t}):{type:"LT",value:"<",start:t}:">"===r?"="===e[this._current]?(this._current++,{type:"GTE",value:">=",start:t}):{type:"GT",value:">",start:t}:"="===r&&"="===e[this._current]?(this._current++,{type:"EQ",value:"==",start:t}):void 0},_consumeLiteral:function(e){this._current++;for(var t,r=this._current,n=e.length;"`"!==e[this._current]&&this._current<n;){var i=this._current;"\\"!==e[i]||"\\"!==e[i+1]&&"`"!==e[i+1]?i++:i+=2,this._current=i}var s=o(e.slice(r,this._current));return s=s.replace("\\`","`"),t=this._looksLikeJSON(s)?JSON.parse(s):JSON.parse('"'+s+'"'),this._current++,t},_looksLikeJSON:function(e){if(""===e)return!1;if('[{"'.indexOf(e[0])>=0)return!0;if(["true","false","null"].indexOf(e)>=0)return!0;if(!("-0123456789".indexOf(e[0])>=0))return!1;try{return JSON.parse(e),!0}catch(e){return!1}}};var p={};function d(){}function v(e){this.runtime=e}function m(e){this._interpreter=e,this.functionTable={abs:{_func:this._functionAbs,_signature:[{types:[s]}]},avg:{_func:this._functionAvg,_signature:[{types:[8]}]},ceil:{_func:this._functionCeil,_signature:[{types:[s]}]},contains:{_func:this._functionContains,_signature:[{types:[a,3]},{types:[1]}]},ends_with:{_func:this._functionEndsWith,_signature:[{types:[a]},{types:[a]}]},floor:{_func:this._functionFloor,_signature:[{types:[s]}]},length:{_func:this._functionLength,_signature:[{types:[a,3,4]}]},map:{_func:this._functionMap,_signature:[{types:[6]},{types:[3]}]},max:{_func:this._functionMax,_signature:[{types:[8,9]}]},merge:{_func:this._functionMerge,_signature:[{types:[4],variadic:!0}]},max_by:{_func:this._functionMaxBy,_signature:[{types:[3]},{types:[6]}]},sum:{_func:this._functionSum,_signature:[{types:[8]}]},starts_with:{_func:this._functionStartsWith,_signature:[{types:[a]},{types:[a]}]},min:{_func:this._functionMin,_signature:[{types:[8,9]}]},min_by:{_func:this._functionMinBy,_signature:[{types:[3]},{types:[6]}]},type:{_func:this._functionType,_signature:[{types:[1]}]},keys:{_func:this._functionKeys,_signature:[{types:[4]}]},values:{_func:this._functionValues,_signature:[{types:[4]}]},sort:{_func:this._functionSort,_signature:[{types:[9,8]}]},sort_by:{_func:this._functionSortBy,_signature:[{types:[3]},{types:[6]}]},join:{_func:this._functionJoin,_signature:[{types:[a]},{types:[9]}]},reverse:{_func:this._functionReverse,_signature:[{types:[a,3]}]},to_array:{_func:this._functionToArray,_signature:[{types:[1]}]},to_string:{_func:this._functionToString,_signature:[{types:[1]}]},to_number:{_func:this._functionToNumber,_signature:[{types:[1]}]},not_null:{_func:this._functionNotNull,_signature:[{types:[1],variadic:!0}]}}}p.EOF=0,p.UnquotedIdentifier=0,p.QuotedIdentifier=0,p.Rbracket=0,p.Rparen=0,p.Comma=0,p.Rbrace=0,p.Number=0,p.Current=0,p.Expref=0,p.Pipe=1,p.Or=2,p.And=3,p.EQ=5,p.GT=5,p.LT=5,p.GTE=5,p.LTE=5,p.NE=5,p.Flatten=9,p.Star=20,p.Filter=21,p.Dot=40,p.Not=45,p.Lbrace=50,p.Lbracket=55,p.Lparen=60,d.prototype={parse:function(e){this._loadTokens(e),this.index=0;var t=this.expression(0);if("EOF"!==this._lookahead(0)){var r=this._lookaheadToken(0),n=new Error("Unexpected token type: "+r.type+", value: "+r.value);throw n.name="ParserError",n}return t},_loadTokens:function(e){var t=(new h).tokenize(e);t.push({type:"EOF",value:"",start:e.length}),this.tokens=t},expression:function(e){var t=this._lookaheadToken(0);this._advance();for(var r=this.nud(t),n=this._lookahead(0);e<p[n];)this._advance(),r=this.led(n,r),n=this._lookahead(0);return r},_lookahead:function(e){return this.tokens[this.index+e].type},_lookaheadToken:function(e){return this.tokens[this.index+e]},_advance:function(){this.index++},nud:function(e){var t,r;switch(e.type){case"Literal":return{type:"Literal",value:e.value};case"UnquotedIdentifier":return{type:"Field",name:e.value};case"QuotedIdentifier":var n={type:"Field",name:e.value};if("Lparen"===this._lookahead(0))throw new Error("Quoted identifier not allowed for function names.");return n;case"Not":return{type:"NotExpression",children:[t=this.expression(p.Not)]};case"Star":return t=null,{type:"ValueProjection",children:[{type:"Identity"},t="Rbracket"===this._lookahead(0)?{type:"Identity"}:this._parseProjectionRHS(p.Star)]};case"Filter":return this.led(e.type,{type:"Identity"});case"Lbrace":return this._parseMultiselectHash();case"Flatten":return{type:"Projection",children:[{type:"Flatten",children:[{type:"Identity"}]},t=this._parseProjectionRHS(p.Flatten)]};case"Lbracket":return"Number"===this._lookahead(0)||"Colon"===this._lookahead(0)?(t=this._parseIndexExpression(),this._projectIfSlice({type:"Identity"},t)):"Star"===this._lookahead(0)&&"Rbracket"===this._lookahead(1)?(this._advance(),this._advance(),{type:"Projection",children:[{type:"Identity"},t=this._parseProjectionRHS(p.Star)]}):this._parseMultiselectList();case"Current":return{type:"Current"};case"Expref":return{type:"ExpressionReference",children:[r=this.expression(p.Expref)]};case"Lparen":for(var i=[];"Rparen"!==this._lookahead(0);)"Current"===this._lookahead(0)?(r={type:"Current"},this._advance()):r=this.expression(0),i.push(r);return this._match("Rparen"),i[0];default:this._errorToken(e)}},led:function(e,t){var r;switch(e){case"Dot":var n=p.Dot;return"Star"!==this._lookahead(0)?{type:"Subexpression",children:[t,r=this._parseDotRHS(n)]}:(this._advance(),{type:"ValueProjection",children:[t,r=this._parseProjectionRHS(n)]});case"Pipe":return{type:"Pipe",children:[t,r=this.expression(p.Pipe)]};case"Or":return{type:"OrExpression",children:[t,r=this.expression(p.Or)]};case"And":return{type:"AndExpression",children:[t,r=this.expression(p.And)]};case"Lparen":for(var i,o=t.name,s=[];"Rparen"!==this._lookahead(0);)"Current"===this._lookahead(0)?(i={type:"Current"},this._advance()):i=this.expression(0),"Comma"===this._lookahead(0)&&this._match("Comma"),s.push(i);return this._match("Rparen"),{type:"Function",name:o,children:s};case"Filter":var a=this.expression(0);return this._match("Rbracket"),{type:"FilterProjection",children:[t,r="Flatten"===this._lookahead(0)?{type:"Identity"}:this._parseProjectionRHS(p.Filter),a]};case"Flatten":return{type:"Projection",children:[{type:"Flatten",children:[t]},this._parseProjectionRHS(p.Flatten)]};case"EQ":case"NE":case"GT":case"GTE":case"LT":case"LTE":return this._parseComparator(t,e);case"Lbracket":var u=this._lookaheadToken(0);return"Number"===u.type||"Colon"===u.type?(r=this._parseIndexExpression(),this._projectIfSlice(t,r)):(this._match("Star"),this._match("Rbracket"),{type:"Projection",children:[t,r=this._parseProjectionRHS(p.Star)]});default:this._errorToken(this._lookaheadToken(0))}},_match:function(e){if(this._lookahead(0)!==e){var t=this._lookaheadToken(0),r=new Error("Expected "+e+", got: "+t.type);throw r.name="ParserError",r}this._advance()},_errorToken:function(e){var t=new Error("Invalid token ("+e.type+'): "'+e.value+'"');throw t.name="ParserError",t},_parseIndexExpression:function(){if("Colon"===this._lookahead(0)||"Colon"===this._lookahead(1))return this._parseSliceExpression();var e={type:"Index",value:this._lookaheadToken(0).value};return this._advance(),this._match("Rbracket"),e},_projectIfSlice:function(e,t){var r={type:"IndexExpression",children:[e,t]};return"Slice"===t.type?{type:"Projection",children:[r,this._parseProjectionRHS(p.Star)]}:r},_parseSliceExpression:function(){for(var e=[null,null,null],t=0,r=this._lookahead(0);"Rbracket"!==r&&t<3;){if("Colon"===r)t++,this._advance();else{if("Number"!==r){var n=this._lookahead(0),i=new Error("Syntax error, unexpected token: "+n.value+"("+n.type+")");throw i.name="Parsererror",i}e[t]=this._lookaheadToken(0).value,this._advance()}r=this._lookahead(0)}return this._match("Rbracket"),{type:"Slice",children:e}},_parseComparator:function(e,t){return{type:"Comparator",name:t,children:[e,this.expression(p[t])]}},_parseDotRHS:function(e){var t=this._lookahead(0);return["UnquotedIdentifier","QuotedIdentifier","Star"].indexOf(t)>=0?this.expression(e):"Lbracket"===t?(this._match("Lbracket"),this._parseMultiselectList()):"Lbrace"===t?(this._match("Lbrace"),this._parseMultiselectHash()):void 0},_parseProjectionRHS:function(e){var t;if(p[this._lookahead(0)]<10)t={type:"Identity"};else if("Lbracket"===this._lookahead(0))t=this.expression(e);else if("Filter"===this._lookahead(0))t=this.expression(e);else{if("Dot"!==this._lookahead(0)){var r=this._lookaheadToken(0),n=new Error("Sytanx error, unexpected token: "+r.value+"("+r.type+")");throw n.name="ParserError",n}this._match("Dot"),t=this._parseDotRHS(e)}return t},_parseMultiselectList:function(){for(var e=[];"Rbracket"!==this._lookahead(0);){var t=this.expression(0);if(e.push(t),"Comma"===this._lookahead(0)&&(this._match("Comma"),"Rbracket"===this._lookahead(0)))throw new Error("Unexpected token Rbracket")}return this._match("Rbracket"),{type:"MultiSelectList",children:e}},_parseMultiselectHash:function(){for(var e,t,r,n=[],i=["UnquotedIdentifier","QuotedIdentifier"];;){if(e=this._lookaheadToken(0),i.indexOf(e.type)<0)throw new Error("Expecting an identifier token, got: "+e.type);if(t=e.value,this._advance(),this._match("Colon"),r={type:"KeyValuePair",name:t,value:this.expression(0)},n.push(r),"Comma"===this._lookahead(0))this._match("Comma");else if("Rbrace"===this._lookahead(0)){this._match("Rbrace");break}}return{type:"MultiSelectHash",children:n}}},v.prototype={search:function(e,t){return this.visit(e,t)},visit:function(e,o){var s,a,u,c,f,l,h,p,d;switch(e.type){case"Field":return null===o?null:r(o)?void 0===(l=o[e.name])?null:l:null;case"Subexpression":for(u=this.visit(e.children[0],o),d=1;d<e.children.length;d++)if(null===(u=this.visit(e.children[1],u)))return null;return u;case"IndexExpression":return h=this.visit(e.children[0],o),this.visit(e.children[1],h);case"Index":if(!t(o))return null;var v=e.value;return v<0&&(v=o.length+v),void 0===(u=o[v])&&(u=null),u;case"Slice":if(!t(o))return null;var m=e.children.slice(0),g=this.computeSliceParams(o.length,m),y=g[0],b=g[1],_=g[2];if(u=[],_>0)for(d=y;d<b;d+=_)u.push(o[d]);else for(d=y;d>b;d+=_)u.push(o[d]);return u;case"Projection":var w=this.visit(e.children[0],o);if(!t(w))return null;for(p=[],d=0;d<w.length;d++)null!==(a=this.visit(e.children[1],w[d]))&&p.push(a);return p;case"ValueProjection":if(!r(w=this.visit(e.children[0],o)))return null;p=[];var E=function(e){for(var t=Object.keys(e),r=[],n=0;n<t.length;n++)r.push(e[t[n]]);return r}(w);for(d=0;d<E.length;d++)null!==(a=this.visit(e.children[1],E[d]))&&p.push(a);return p;case"FilterProjection":if(!t(w=this.visit(e.children[0],o)))return null;var S=[],A=[];for(d=0;d<w.length;d++)i(s=this.visit(e.children[2],w[d]))||S.push(w[d]);for(var x=0;x<S.length;x++)null!==(a=this.visit(e.children[1],S[x]))&&A.push(a);return A;case"Comparator":switch(c=this.visit(e.children[0],o),f=this.visit(e.children[1],o),e.name){case"EQ":u=n(c,f);break;case"NE":u=!n(c,f);break;case"GT":u=c>f;break;case"GTE":u=c>=f;break;case"LT":u=c<f;break;case"LTE":u=c<=f;break;default:throw new Error("Unknown comparator: "+e.name)}return u;case"Flatten":var I=this.visit(e.children[0],o);if(!t(I))return null;var C=[];for(d=0;d<I.length;d++)t(a=I[d])?C.push.apply(C,a):C.push(a);return C;case"Identity":return o;case"MultiSelectList":if(null===o)return null;for(p=[],d=0;d<e.children.length;d++)p.push(this.visit(e.children[d],o));return p;case"MultiSelectHash":if(null===o)return null;var R;for(p={},d=0;d<e.children.length;d++)p[(R=e.children[d]).name]=this.visit(R.value,o);return p;case"OrExpression":return i(s=this.visit(e.children[0],o))&&(s=this.visit(e.children[1],o)),s;case"AndExpression":return!0===i(c=this.visit(e.children[0],o))?c:this.visit(e.children[1],o);case"NotExpression":return i(c=this.visit(e.children[0],o));case"Literal":return e.value;case"Pipe":return h=this.visit(e.children[0],o),this.visit(e.children[1],h);case"Current":return o;case"Function":var T=[];for(d=0;d<e.children.length;d++)T.push(this.visit(e.children[d],o));return this.runtime.callFunction(e.name,T);case"ExpressionReference":var k=e.children[0];return k.jmespathType="Expref",k;default:throw new Error("Unknown node type: "+e.type)}},computeSliceParams:function(e,t){var r=t[0],n=t[1],i=t[2],o=[null,null,null];if(null===i)i=1;else if(0===i){var s=new Error("Invalid slice, step cannot be 0");throw s.name="RuntimeError",s}var a=i<0;return r=null===r?a?e-1:0:this.capSliceRange(e,r,i),n=null===n?a?-1:e:this.capSliceRange(e,n,i),o[0]=r,o[1]=n,o[2]=i,o},capSliceRange:function(e,t,r){return t<0?(t+=e)<0&&(t=r<0?-1:0):t>=e&&(t=r<0?e-1:e),t}},m.prototype={callFunction:function(e,t){var r=this.functionTable[e];if(void 0===r)throw new Error("Unknown function: "+e+"()");return this._validateArgs(e,t,r._signature),r._func.call(this,t)},_validateArgs:function(e,t,r){var n,i,o,s;if(r[r.length-1].variadic){if(t.length<r.length)throw n=1===r.length?" argument":" arguments",new Error("ArgumentError: "+e+"() takes at least"+r.length+n+" but received "+t.length)}else if(t.length!==r.length)throw n=1===r.length?" argument":" arguments",new Error("ArgumentError: "+e+"() takes "+r.length+n+" but received "+t.length);for(var a=0;a<r.length;a++){s=!1,i=r[a].types,o=this._getTypeName(t[a]);for(var u=0;u<i.length;u++)if(this._typeMatches(o,i[u],t[a])){s=!0;break}if(!s)throw new Error("TypeError: "+e+"() expected argument "+(a+1)+" to be type "+i+" but received type "+o+" instead.")}},_typeMatches:function(e,t,r){if(1===t)return!0;if(9!==t&&8!==t&&3!==t)return e===t;if(3===t)return 3===e;if(3===e){var n;8===t?n=s:9===t&&(n=a);for(var i=0;i<r.length;i++)if(!this._typeMatches(this._getTypeName(r[i]),n,r[i]))return!1;return!0}},_getTypeName:function(e){switch(Object.prototype.toString.call(e)){case"[object String]":return a;case"[object Number]":return s;case"[object Array]":return 3;case"[object Boolean]":return 5;case"[object Null]":return 7;case"[object Object]":return"Expref"===e.jmespathType?6:4}},_functionStartsWith:function(e){return 0===e[0].lastIndexOf(e[1])},_functionEndsWith:function(e){var t=e[0],r=e[1];return-1!==t.indexOf(r,t.length-r.length)},_functionReverse:function(e){if(this._getTypeName(e[0])===a){for(var t=e[0],r="",n=t.length-1;n>=0;n--)r+=t[n];return r}var i=e[0].slice(0);return i.reverse(),i},_functionAbs:function(e){return Math.abs(e[0])},_functionCeil:function(e){return Math.ceil(e[0])},_functionAvg:function(e){for(var t=0,r=e[0],n=0;n<r.length;n++)t+=r[n];return t/r.length},_functionContains:function(e){return e[0].indexOf(e[1])>=0},_functionFloor:function(e){return Math.floor(e[0])},_functionLength:function(e){return r(e[0])?Object.keys(e[0]).length:e[0].length},_functionMap:function(e){for(var t=[],r=this._interpreter,n=e[0],i=e[1],o=0;o<i.length;o++)t.push(r.visit(n,i[o]));return t},_functionMerge:function(e){for(var t={},r=0;r<e.length;r++){var n=e[r];for(var i in n)t[i]=n[i]}return t},_functionMax:function(e){if(e[0].length>0){if(this._getTypeName(e[0][0])===s)return Math.max.apply(Math,e[0]);for(var t=e[0],r=t[0],n=1;n<t.length;n++)r.localeCompare(t[n])<0&&(r=t[n]);return r}return null},_functionMin:function(e){if(e[0].length>0){if(this._getTypeName(e[0][0])===s)return Math.min.apply(Math,e[0]);for(var t=e[0],r=t[0],n=1;n<t.length;n++)t[n].localeCompare(r)<0&&(r=t[n]);return r}return null},_functionSum:function(e){for(var t=0,r=e[0],n=0;n<r.length;n++)t+=r[n];return t},_functionType:function(e){switch(this._getTypeName(e[0])){case s:return"number";case a:return"string";case 3:return"array";case 4:return"object";case 5:return"boolean";case 6:return"expref";case 7:return"null"}},_functionKeys:function(e){return Object.keys(e[0])},_functionValues:function(e){for(var t=e[0],r=Object.keys(t),n=[],i=0;i<r.length;i++)n.push(t[r[i]]);return n},_functionJoin:function(e){var t=e[0];return e[1].join(t)},_functionToArray:function(e){return 3===this._getTypeName(e[0])?e[0]:[e[0]]},_functionToString:function(e){return this._getTypeName(e[0])===a?e[0]:JSON.stringify(e[0])},_functionToNumber:function(e){var t,r=this._getTypeName(e[0]);return r===s?e[0]:r!==a||(t=+e[0],isNaN(t))?null:t},_functionNotNull:function(e){for(var t=0;t<e.length;t++)if(7!==this._getTypeName(e[t]))return e[t];return null},_functionSort:function(e){var t=e[0].slice(0);return t.sort(),t},_functionSortBy:function(e){var t=e[0].slice(0);if(0===t.length)return t;var r=this._interpreter,n=e[1],i=this._getTypeName(r.visit(n,t[0]));if([s,a].indexOf(i)<0)throw new Error("TypeError");for(var o=this,u=[],c=0;c<t.length;c++)u.push([c,t[c]]);u.sort((function(e,t){var s=r.visit(n,e[1]),a=r.visit(n,t[1]);if(o._getTypeName(s)!==i)throw new Error("TypeError: expected "+i+", received "+o._getTypeName(s));if(o._getTypeName(a)!==i)throw new Error("TypeError: expected "+i+", received "+o._getTypeName(a));return s>a?1:s<a?-1:e[0]-t[0]}));for(var f=0;f<u.length;f++)t[f]=u[f][1];return t},_functionMaxBy:function(e){for(var t,r,n=e[1],i=e[0],o=this.createKeyFunction(n,[s,a]),u=-1/0,c=0;c<i.length;c++)(r=o(i[c]))>u&&(u=r,t=i[c]);return t},_functionMinBy:function(e){for(var t,r,n=e[1],i=e[0],o=this.createKeyFunction(n,[s,a]),u=1/0,c=0;c<i.length;c++)(r=o(i[c]))<u&&(u=r,t=i[c]);return t},createKeyFunction:function(e,t){var r=this,n=this._interpreter;return function(i){var o=n.visit(e,i);if(t.indexOf(r._getTypeName(o))<0){var s="TypeError: expected one of "+t+", received "+r._getTypeName(o);throw new Error(s)}return o}}},e.tokenize=function(e){return(new h).tokenize(e)},e.compile=function(e){return(new d).parse(e)},e.search=function(e,t){var r=new d,n=new m,i=new v(n);n._interpreter=i;var o=r.parse(t);return i.search(o,e)},e.strictDeepEqual=n}(t)},function(e,t){},function(e,t,r){var n=r(1),i=r(2),o=r(45),s=r(8),a=r(17).populateHostPrefix;e.exports={buildRequest:function(e){var t=e.service.api.operations[e.operation],r=e.httpRequest;r.headers["Content-Type"]="application/x-www-form-urlencoded; charset=utf-8",r.params={Version:e.service.api.apiVersion,Action:t.name},(new o).serialize(e.params,t.input,(function(e,t){r.params[e]=t})),r.body=i.queryParamsToString(r.params),a(e)},extractError:function(e){var t,r=e.httpResponse.body.toString();if(r.match("<UnknownOperationException"))t={Code:"UnknownOperation",Message:"Unknown operation "+e.request.operation};else try{t=(new n.XML.Parser).parse(r)}catch(r){t={Code:e.httpResponse.statusCode,Message:e.httpResponse.statusMessage}}t.requestId&&!e.requestId&&(e.requestId=t.requestId),t.Errors&&(t=t.Errors),t.Error&&(t=t.Error),t.Code?e.error=i.error(new Error,{code:t.Code,message:t.Message}):e.error=i.error(new Error,{code:e.httpResponse.statusCode,message:null})},extractData:function(e){var t=e.request,r=t.service.api.operations[t.operation].output||{},o=r;if(o.resultWrapper){var a=s.create({type:"structure"});a.members[o.resultWrapper]=r,a.memberNames=[o.resultWrapper],i.property(r,"name",r.resultWrapper),r=a}var u=new n.XML.Parser;if(r&&r.members&&!r.members._XAMZRequestId){var c=s.create({type:"string"},{api:{protocol:"query"}},"requestId");r.members._XAMZRequestId=c}var f=u.parse(e.httpResponse.body.toString(),r);e.requestId=f._XAMZRequestId||f.requestId,f._XAMZRequestId&&delete f._XAMZRequestId,o.resultWrapper&&f[o.resultWrapper]&&(i.update(f,f[o.resultWrapper]),delete f[o.resultWrapper]),e.data=f}}},function(e,t,r){var n=r(2).memoizedProperty;function i(e,t,r,i){n(this,i(e),(function(){return r(e,t)}))}e.exports=function(e,t,r,n,o){for(var s in n=n||String,e)Object.prototype.hasOwnProperty.call(e,s)&&(i.call(this,s,e[s],r,n),o&&o(s,e[s]))}},function(e,t,r){var n=r(2),i=r(12),o=r(14),s=r(15),a=r(16);function u(e,t){e.service.api.operations[e.operation].input;if(!e.httpRequest.headers["Content-Type"]){var r=t?"binary/octet-stream":"application/json";e.httpRequest.headers["Content-Type"]=r}}e.exports={buildRequest:function(e){i.buildRequest(e),["HEAD","DELETE"].indexOf(e.httpRequest.method)<0&&function(e){var t=new s,r=e.service.api.operations[e.operation].input;if(r.payload){var n,i=r.members[r.payload];if(void 0===(n=e.params[r.payload]))return;"structure"===i.type?(e.httpRequest.body=t.build(n,i),u(e)):(e.httpRequest.body=n,("binary"===i.type||i.isStreaming)&&u(e,!0))}else{var o=t.build(e.params,r);"{}"===o&&"GET"===e.httpRequest.method||(e.httpRequest.body=o),u(e)}}(e)},extractError:function(e){o.extractError(e)},extractData:function(e){i.extractData(e);var t=e.request,r=t.service.api.operations[t.operation],s=t.service.api.operations[t.operation].output||{};if(r.hasEventOutput,s.payload){var u=s.members[s.payload],c=e.httpResponse.body;if(u.isEventStream)f=new a,e.data[payload]=n.createEventStream(2===AWS.HttpClient.streamsApiVersion?e.httpResponse.stream:c,f,u);else if("structure"===u.type||"list"===u.type){var f=new a;e.data[s.payload]=f.parse(c,u)}else"binary"===u.type||u.isStreaming?e.data[s.payload]=c:e.data[s.payload]=u.toType(c)}else{var l=e.data;o.extractData(e),e.data=n.merge(l,e.data)}}}},function(e,t,r){var n=r(1),i=r(2),o=r(12);e.exports={buildRequest:function(e){o.buildRequest(e),["GET","HEAD"].indexOf(e.httpRequest.method)<0&&function(e){var t=e.service.api.operations[e.operation].input,r=new n.XML.Builder,o=e.params,s=t.payload;if(s){var a=t.members[s];if(void 0===(o=o[s]))return;if("structure"===a.type){var u=a.name;e.httpRequest.body=r.toXML(o,a,u,!0)}else e.httpRequest.body=o}else e.httpRequest.body=r.toXML(o,t,t.name||t.shape||i.string.upperFirst(e.operation)+"Request")}(e)},extractError:function(e){var t;o.extractError(e);try{t=(new n.XML.Parser).parse(e.httpResponse.body.toString())}catch(r){t={Code:e.httpResponse.statusCode,Message:e.httpResponse.statusMessage}}t.Errors&&(t=t.Errors),t.Error&&(t=t.Error),t.Code?e.error=i.error(new Error,{code:t.Code,message:t.Message}):e.error=i.error(new Error,{code:e.httpResponse.statusCode,message:null})},extractData:function(e){var t;o.extractData(e);var r=e.request,s=e.httpResponse.body,a=r.service.api.operations[r.operation],u=a.output,c=(a.hasEventOutput,u.payload);if(c){var f=u.members[c];f.isEventStream?(t=new n.XML.Parser,e.data[c]=i.createEventStream(2===n.HttpClient.streamsApiVersion?e.httpResponse.stream:e.httpResponse.body,t,f)):"structure"===f.type?(t=new n.XML.Parser,e.data[c]=t.parse(s.toString(),f)):"binary"===f.type||f.isStreaming?e.data[c]=s:e.data[c]=f.toType(s)}else if(s.length>0){var l=(t=new n.XML.Parser).parse(s.toString(),u);i.update(e.data,l)}}}},function(e,t,r){var n=r(21),i=r(25),o=r(8),s=r(26),a=r(27),u=r(2),c=u.property,f=u.memoizedProperty;e.exports=function(e,t){var r=this;e=e||{},(t=t||{}).api=this,e.metadata=e.metadata||{},c(this,"isApi",!0,!1),c(this,"apiVersion",e.metadata.apiVersion),c(this,"endpointPrefix",e.metadata.endpointPrefix),c(this,"signingName",e.metadata.signingName),c(this,"globalEndpoint",e.metadata.globalEndpoint),c(this,"signatureVersion",e.metadata.signatureVersion),c(this,"jsonVersion",e.metadata.jsonVersion),c(this,"targetPrefix",e.metadata.targetPrefix),c(this,"protocol",e.metadata.protocol),c(this,"timestampFormat",e.metadata.timestampFormat),c(this,"xmlNamespaceUri",e.metadata.xmlNamespace),c(this,"abbreviation",e.metadata.serviceAbbreviation),c(this,"fullName",e.metadata.serviceFullName),c(this,"serviceId",e.metadata.serviceId),f(this,"className",(function(){var t=e.metadata.serviceAbbreviation||e.metadata.serviceFullName;return t?("ElasticLoadBalancing"===(t=t.replace(/^Amazon|AWS\s*|\(.*|\s+|\W+/g,""))&&(t="ELB"),t):null})),c(this,"operations",new n(e.operations,t,(function(e,r){return new i(e,r,t)}),u.string.lowerFirst,(function(e,t){!0===t.endpointoperation&&c(r,"endpointOperation",u.string.lowerFirst(e))}))),c(this,"shapes",new n(e.shapes,t,(function(e,r){return o.create(r,t)}))),c(this,"paginators",new n(e.paginators,t,(function(e,r){return new s(e,r,t)}))),c(this,"waiters",new n(e.waiters,t,(function(e,r){return new a(e,r,t)}),u.string.lowerFirst)),t.documentation&&(c(this,"documentation",e.documentation),c(this,"documentationUrl",e.documentationUrl))}},function(e,t,r){var n=r(8),i=r(2),o=i.property,s=i.memoizedProperty;e.exports=function(e,t,r){var i=this;r=r||{},o(this,"name",t.name||e),o(this,"api",r.api,!1),t.http=t.http||{},o(this,"endpoint",t.endpoint),o(this,"httpMethod",t.http.method||"POST"),o(this,"httpPath",t.http.requestUri||"/"),o(this,"authtype",t.authtype||""),o(this,"endpointDiscoveryRequired",t.endpointdiscovery?t.endpointdiscovery.required?"REQUIRED":"OPTIONAL":"NULL"),s(this,"input",(function(){return t.input?n.create(t.input,r):new n.create({type:"structure"},r)})),s(this,"output",(function(){return t.output?n.create(t.output,r):new n.create({type:"structure"},r)})),s(this,"errors",(function(){var e=[];if(!t.errors)return null;for(var i=0;i<t.errors.length;i++)e.push(n.create(t.errors[i],r));return e})),s(this,"paginator",(function(){return r.api.paginators[e]})),r.documentation&&(o(this,"documentation",t.documentation),o(this,"documentationUrl",t.documentationUrl)),s(this,"idempotentMembers",(function(){var e=[],t=i.input,r=t.members;if(!t.members)return e;for(var n in r)r.hasOwnProperty(n)&&!0===r[n].isIdempotent&&e.push(n);return e})),s(this,"hasEventOutput",(function(){return function(e){var t=e.members,r=e.payload;if(!e.members)return!1;if(r){return t[r].isEventStream}for(var n in t)if(!t.hasOwnProperty(n)&&!0===t[n].isEventStream)return!0;return!1}(i.output)}))}},function(e,t,r){var n=r(2).property;e.exports=function(e,t){n(this,"inputToken",t.input_token),n(this,"limitKey",t.limit_key),n(this,"moreResults",t.more_results),n(this,"outputToken",t.output_token),n(this,"resultKey",t.result_key)}},function(e,t,r){var n=r(2),i=n.property;e.exports=function(e,t,r){r=r||{},i(this,"name",e),i(this,"api",r.api,!1),t.operation&&i(this,"operation",n.string.lowerFirst(t.operation));var o=this;["type","description","delay","maxAttempts","acceptors"].forEach((function(e){var r=t[e];r&&i(o,e,r)}))}},function(e,t,r){var n=r(1);n.SequentialExecutor=n.util.inherit({constructor:function(){this._events={}},listeners:function(e){return this._events[e]?this._events[e].slice(0):[]},on:function(e,t,r){return this._events[e]?r?this._events[e].unshift(t):this._events[e].push(t):this._events[e]=[t],this},onAsync:function(e,t,r){return t._isAsync=!0,this.on(e,t,r)},removeListener:function(e,t){var r=this._events[e];if(r){for(var n=r.length,i=-1,o=0;o<n;++o)r[o]===t&&(i=o);i>-1&&r.splice(i,1)}return this},removeAllListeners:function(e){return e?delete this._events[e]:this._events={},this},emit:function(e,t,r){r||(r=function(){});var n=this.listeners(e),i=n.length;return this.callListeners(n,t,r),i>0},callListeners:function(e,t,r,i){var o=this,s=i||null;function a(i){if(i&&(s=n.util.error(s||new Error,i),o._haltHandlersOnError))return r.call(o,s);o.callListeners(e,t,r,s)}for(;e.length>0;){var u=e.shift();if(u._isAsync)return void u.apply(o,t.concat([a]));try{u.apply(o,t)}catch(e){s=n.util.error(s||new Error,e)}if(s&&o._haltHandlersOnError)return void r.call(o,s)}r.call(o,s)},addListeners:function(e){var t=this;return e._events&&(e=e._events),n.util.each(e,(function(e,r){"function"==typeof r&&(r=[r]),n.util.arrayEach(r,(function(r){t.on(e,r)}))})),t},addNamedListener:function(e,t,r,n){return this[e]=r,this.addListener(t,r,n),this},addNamedAsyncListener:function(e,t,r,n){return r._isAsync=!0,this.addNamedListener(e,t,r,n)},addNamedListeners:function(e){var t=this;return e((function(){t.addNamedListener.apply(t,arguments)}),(function(){t.addNamedAsyncListener.apply(t,arguments)})),this}}),n.SequentialExecutor.prototype.addListener=n.SequentialExecutor.prototype.on,e.exports=n.SequentialExecutor},function(e,t,r){var n=r(1);n.Credentials=n.util.inherit({constructor:function(){if(n.util.hideProperties(this,["secretAccessKey"]),this.expired=!1,this.expireTime=null,this.refreshCallbacks=[],1===arguments.length&&"object"==typeof arguments[0]){var e=arguments[0].credentials||arguments[0];this.accessKeyId=e.accessKeyId,this.secretAccessKey=e.secretAccessKey,this.sessionToken=e.sessionToken}else this.accessKeyId=arguments[0],this.secretAccessKey=arguments[1],this.sessionToken=arguments[2]},expiryWindow:15,needsRefresh:function(){var e=n.util.date.getDate().getTime(),t=new Date(e+1e3*this.expiryWindow);return!!(this.expireTime&&t>this.expireTime)||(this.expired||!this.accessKeyId||!this.secretAccessKey)},get:function(e){var t=this;this.needsRefresh()?this.refresh((function(r){r||(t.expired=!1),e&&e(r)})):e&&e()},refresh:function(e){this.expired=!1,e()},coalesceRefresh:function(e,t){var r=this;1===r.refreshCallbacks.push(e)&&r.load((function(e){n.util.arrayEach(r.refreshCallbacks,(function(r){t?r(e):n.util.defer((function(){r(e)}))})),r.refreshCallbacks.length=0}))},load:function(e){e()}}),n.Credentials.addPromisesToClass=function(e){this.prototype.getPromise=n.util.promisifyMethod("get",e),this.prototype.refreshPromise=n.util.promisifyMethod("refresh",e)},n.Credentials.deletePromisesFromClass=function(){delete this.prototype.getPromise,delete this.prototype.refreshPromise},n.util.addPromises(n.Credentials)},function(e,t,r){var n=r(1);n.CredentialProviderChain=n.util.inherit(n.Credentials,{constructor:function(e){this.providers=e||n.CredentialProviderChain.defaultProviders.slice(0),this.resolveCallbacks=[]},resolve:function(e){var t=this;if(0===t.providers.length)return e(new Error("No providers")),t;if(1===t.resolveCallbacks.push(e)){var r=0,i=t.providers.slice(0);!function e(o,s){if(!o&&s||r===i.length)return n.util.arrayEach(t.resolveCallbacks,(function(e){e(o,s)})),void(t.resolveCallbacks.length=0);var a=i[r++];(s="function"==typeof a?a.call():a).get?s.get((function(t){e(t,t?null:s)})):e(null,s)}()}return t}}),n.CredentialProviderChain.defaultProviders=[],n.CredentialProviderChain.addPromisesToClass=function(e){this.prototype.resolvePromise=n.util.promisifyMethod("resolve",e)},n.CredentialProviderChain.deletePromisesFromClass=function(){delete this.prototype.resolvePromise},n.util.addPromises(n.CredentialProviderChain)},function(e,t,r){var n=r(1),i=n.util.inherit;n.Endpoint=i({constructor:function(e,t){if(n.util.hideProperties(this,["slashes","auth","hash","search","query"]),null==e)throw new Error("Invalid endpoint: "+e);if("string"!=typeof e)return n.util.copy(e);e.match(/^http/)||(e=((t&&void 0!==t.sslEnabled?t.sslEnabled:n.config.sslEnabled)?"https":"http")+"://"+e);n.util.update(this,n.util.urlParse(e)),this.port?this.port=parseInt(this.port,10):this.port="https:"===this.protocol?443:80}}),n.HttpRequest=i({constructor:function(e,t){e=new n.Endpoint(e),this.method="POST",this.path=e.path||"/",this.headers={},this.body="",this.endpoint=e,this.region=t,this._userAgent="",this.setUserAgent()},setUserAgent:function(){this._userAgent=this.headers[this.getUserAgentHeaderName()]=n.util.userAgent()},getUserAgentHeaderName:function(){return(n.util.isBrowser()?"X-Amz-":"")+"User-Agent"},appendToUserAgent:function(e){"string"==typeof e&&e&&(this._userAgent+=" "+e),this.headers[this.getUserAgentHeaderName()]=this._userAgent},getUserAgent:function(){return this._userAgent},pathname:function(){return this.path.split("?",1)[0]},search:function(){var e=this.path.split("?",2)[1];return e?(e=n.util.queryStringParse(e),n.util.queryParamsToString(e)):""},updateEndpoint:function(e){var t=new n.Endpoint(e);this.endpoint=t,this.path=t.path||"/"}}),n.HttpResponse=i({constructor:function(){this.statusCode=void 0,this.headers={},this.body=void 0,this.streaming=!1,this.stream=null},createUnbufferedStream:function(){return this.streaming=!0,this.stream}}),n.HttpClient=i({}),n.HttpClient.getInstance=function(){return void 0===this.singleton&&(this.singleton=new this),this.singleton}},function(e,t,r){var n=r(1),i=n.util.inherit;n.Signers.V3=i(n.Signers.RequestSigner,{addAuthorization:function(e,t){var r=n.util.date.rfc822(t);this.request.headers["X-Amz-Date"]=r,e.sessionToken&&(this.request.headers["x-amz-security-token"]=e.sessionToken),this.request.headers["X-Amzn-Authorization"]=this.authorization(e,r)},authorization:function(e){return"AWS3 AWSAccessKeyId="+e.accessKeyId+",Algorithm=HmacSHA256,SignedHeaders="+this.signedHeaders()+",Signature="+this.signature(e)},signedHeaders:function(){var e=[];return n.util.arrayEach(this.headersToSign(),(function(t){e.push(t.toLowerCase())})),e.sort().join(";")},canonicalHeaders:function(){var e=this.request.headers,t=[];return n.util.arrayEach(this.headersToSign(),(function(r){t.push(r.toLowerCase().trim()+":"+String(e[r]).trim())})),t.sort().join("\n")+"\n"},headersToSign:function(){var e=[];return n.util.each(this.request.headers,(function(t){("Host"===t||"Content-Encoding"===t||t.match(/^X-Amz/i))&&e.push(t)})),e},signature:function(e){return n.util.crypto.hmac(e.secretAccessKey,this.stringToSign(),"base64")},stringToSign:function(){var e=[];return e.push(this.request.method),e.push("/"),e.push(""),e.push(this.canonicalHeaders()),e.push(this.request.body),n.util.crypto.sha256(e.join("\n"))}}),e.exports=n.Signers.V3},function(e,t){var r="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof window.msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto);if(r){var n=new Uint8Array(16);e.exports=function(){return r(n),n}}else{var i=new Array(16);e.exports=function(){for(var e,t=0;t<16;t++)0==(3&t)&&(e=4294967296*Math.random()),i[t]=e>>>((3&t)<<3)&255;return i}}},function(e,t){for(var r=[],n=0;n<256;++n)r[n]=(n+256).toString(16).substr(1);e.exports=function(e,t){var n=t||0,i=r;return[i[e[n++]],i[e[n++]],i[e[n++]],i[e[n++]],"-",i[e[n++]],i[e[n++]],"-",i[e[n++]],i[e[n++]],"-",i[e[n++]],i[e[n++]],"-",i[e[n++]],i[e[n++]],i[e[n++]],i[e[n++]],i[e[n++]],i[e[n++]]].join("")}},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e}},function(e,t,r){"use strict";t.decode=t.parse=r(90),t.encode=t.stringify=r(91)},function(e,t){var r="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof window.msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto);if(r){var n=new Uint8Array(16);e.exports=function(){return r(n),n}}else{var i=new Array(16);e.exports=function(){for(var e,t=0;t<16;t++)0==(3&t)&&(e=4294967296*Math.random()),i[t]=e>>>((3&t)<<3)&255;return i}}},function(e,t){for(var r=[],n=0;n<256;++n)r[n]=(n+256).toString(16).substr(1);e.exports=function(e,t){var n=t||0,i=r;return[i[e[n++]],i[e[n++]],i[e[n++]],i[e[n++]],"-",i[e[n++]],i[e[n++]],"-",i[e[n++]],i[e[n++]],"-",i[e[n++]],i[e[n++]],"-",i[e[n++]],i[e[n++]],i[e[n++]],i[e[n++]],i[e[n++]],i[e[n++]]].join("")}},function(e,t,r){r(11);var n=r(1),i=n.Service,o=n.apiLoader;o.services.mobileanalytics={},n.MobileAnalytics=i.defineService("mobileanalytics",["2014-06-05"]),Object.defineProperty(o.services.mobileanalytics,"2014-06-05",{get:function(){return r(114)},enumerable:!0,configurable:!0}),e.exports=n.MobileAnalytics},function(e,t){e.exports=r},function(e,t){e.exports=n},function(e,t,r){r(11);var n=r(1),i=n.Service,o=n.apiLoader;o.services.personalizeevents={},n.PersonalizeEvents=i.defineService("personalizeevents",["2018-03-22"]),Object.defineProperty(o.services.personalizeevents,"2018-03-22",{get:function(){var e=r(117);return e.paginators=r(118).pagination,e},enumerable:!0,configurable:!0}),e.exports=n.PersonalizeEvents},function(e,t,r){(function(e){var n=void 0!==e&&e||"undefined"!=typeof self&&self||window,i=Function.prototype.apply;function o(e,t){this._id=e,this._clearFn=t}t.setTimeout=function(){return new o(i.call(setTimeout,n,arguments),clearTimeout)},t.setInterval=function(){return new o(i.call(setInterval,n,arguments),clearInterval)},t.clearTimeout=t.clearInterval=function(e){e&&e.close()},o.prototype.unref=o.prototype.ref=function(){},o.prototype.close=function(){this._clearFn.call(n,this._id)},t.enroll=function(e,t){clearTimeout(e._idleTimeoutId),e._idleTimeout=t},t.unenroll=function(e){clearTimeout(e._idleTimeoutId),e._idleTimeout=-1},t._unrefActive=t.active=function(e){clearTimeout(e._idleTimeoutId);var t=e._idleTimeout;t>=0&&(e._idleTimeoutId=setTimeout((function(){e._onTimeout&&e._onTimeout()}),t))},r(44),t.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==e&&e.setImmediate||this&&this.setImmediate,t.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==e&&e.clearImmediate||this&&this.clearImmediate}).call(this,r(7))},function(e,t,r){(function(e,t){!function(e,r){"use strict";if(!e.setImmediate){var n,i,o,s,a,u=1,c={},f=!1,l=e.document,h=Object.getPrototypeOf&&Object.getPrototypeOf(e);h=h&&h.setTimeout?h:e,"[object process]"==={}.toString.call(e.process)?n=function(e){t.nextTick((function(){d(e)}))}:!function(){if(e.postMessage&&!e.importScripts){var t=!0,r=e.onmessage;return e.onmessage=function(){t=!1},e.postMessage("","*"),e.onmessage=r,t}}()?e.MessageChannel?((o=new MessageChannel).port1.onmessage=function(e){d(e.data)},n=function(e){o.port2.postMessage(e)}):l&&"onreadystatechange"in l.createElement("script")?(i=l.documentElement,n=function(e){var t=l.createElement("script");t.onreadystatechange=function(){d(e),t.onreadystatechange=null,i.removeChild(t),t=null},i.appendChild(t)}):n=function(e){setTimeout(d,0,e)}:(s="setImmediate$"+Math.random()+"$",a=function(t){t.source===e&&"string"==typeof t.data&&0===t.data.indexOf(s)&&d(+t.data.slice(s.length))},e.addEventListener?e.addEventListener("message",a,!1):e.attachEvent("onmessage",a),n=function(t){e.postMessage(s+t,"*")}),h.setImmediate=function(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),r=0;r<t.length;r++)t[r]=arguments[r+1];var i={callback:e,args:t};return c[u]=i,n(u),u++},h.clearImmediate=p}function p(e){delete c[e]}function d(e){if(f)setTimeout(d,0,e);else{var t=c[e];if(t){f=!0;try{!function(e){var t=e.callback,r=e.args;switch(r.length){case 0:t();break;case 1:t(r[0]);break;case 2:t(r[0],r[1]);break;case 3:t(r[0],r[1],r[2]);break;default:t.apply(void 0,r)}}(t)}finally{p(e),f=!1}}}}}("undefined"==typeof self?void 0===e?this:e:self)}).call(this,r(7),r(5))},function(e,t,r){var n=r(2);function i(){}function o(e){return e.isQueryName||"ec2"!==e.api.protocol?e.name:e.name[0].toUpperCase()+e.name.substr(1)}function s(e,t,r,i){n.each(r.members,(function(r,n){var s=t[r];if(null!=s){var u=o(n);a(u=e?e+"."+u:u,s,n,i)}}))}function a(e,t,r,i){null!=t&&("structure"===r.type?s(e,t,r,i):"list"===r.type?function(e,t,r,i){var s=r.member||{};0!==t.length?n.arrayEach(t,(function(t,n){var u="."+(n+1);if("ec2"===r.api.protocol)u+="";else if(r.flattened){if(s.name){var c=e.split(".");c.pop(),c.push(o(s)),e=c.join(".")}}else u="."+(s.name?s.name:"member")+u;a(e+u,t,s,i)})):i.call(this,e,null)}(e,t,r,i):"map"===r.type?function(e,t,r,i){var o=1;n.each(t,(function(t,n){var s=(r.flattened?".":".entry.")+o+++".",u=s+(r.key.name||"key"),c=s+(r.value.name||"value");a(e+u,t,r.key,i),a(e+c,n,r.value,i)}))}(e,t,r,i):i(e,r.toWireFormat(t).toString()))}i.prototype.serialize=function(e,t,r){s("",e,t,r)},e.exports=i},function(e,t,r){var n=r(2),i=r(47).XmlNode,o=r(49).XmlText;function s(){}function a(e,t,r){switch(r.type){case"structure":return function(e,t,r){n.arrayEach(r.memberNames,(function(n){var o=r.members[n];if("body"===o.location){var s=t[n],c=o.name;if(null!=s)if(o.isXmlAttribute)e.addAttribute(c,s);else if(o.flattened)a(e,s,o);else{var f=new i(c);e.addChildNode(f),u(f,o),a(f,s,o)}}}))}(e,t,r);case"map":return function(e,t,r){var o=r.key.name||"key",s=r.value.name||"value";n.each(t,(function(t,n){var u=new i(r.flattened?r.name:"entry");e.addChildNode(u);var c=new i(o),f=new i(s);u.addChildNode(c),u.addChildNode(f),a(c,t,r.key),a(f,n,r.value)}))}(e,t,r);case"list":return function(e,t,r){r.flattened?n.arrayEach(t,(function(t){var n=r.member.name||r.name,o=new i(n);e.addChildNode(o),a(o,t,r.member)})):n.arrayEach(t,(function(t){var n=r.member.name||"member",o=new i(n);e.addChildNode(o),a(o,t,r.member)}))}(e,t,r);default:return function(e,t,r){e.addChildNode(new o(r.toWireFormat(t)))}(e,t,r)}}function u(e,t,r){var n,i="xmlns";t.xmlNamespaceUri?(n=t.xmlNamespaceUri,t.xmlNamespacePrefix&&(i+=":"+t.xmlNamespacePrefix)):r&&t.api.xmlNamespaceUri&&(n=t.api.xmlNamespaceUri),n&&e.addAttribute(i,n)}s.prototype.toXML=function(e,t,r,n){var o=new i(r);return u(o,t,!0),a(o,e,t),o.children.length>0||n?o.toString():""},e.exports=s},function(e,t,r){var n=r(48).escapeAttribute;function i(e,t){void 0===t&&(t=[]),this.name=e,this.children=t,this.attributes={}}i.prototype.addAttribute=function(e,t){return this.attributes[e]=t,this},i.prototype.addChildNode=function(e){return this.children.push(e),this},i.prototype.removeAttribute=function(e){return delete this.attributes[e],this},i.prototype.toString=function(){for(var e=Boolean(this.children.length),t="<"+this.name,r=this.attributes,i=0,o=Object.keys(r);i<o.length;i++){var s=o[i],a=r[s];null!=a&&(t+=" "+s+'="'+n(""+a)+'"')}return t+(e?">"+this.children.map((function(e){return e.toString()})).join("")+"</"+this.name+">":"/>")},e.exports={XmlNode:i}},function(e,t){e.exports={escapeAttribute:function(e){return e.replace(/&/g,"&amp;").replace(/'/g,"&apos;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;")}}},function(e,t,r){var n=r(50).escapeElement;function i(e){this.value=e}i.prototype.toString=function(){return n(""+this.value)},e.exports={XmlText:i}},function(e,t){e.exports={escapeElement:function(e){return e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")}}},function(e,t){function r(e,t){if(!r.services.hasOwnProperty(e))throw new Error("InvalidService: Failed to load api for "+e);return r.services[e][t]}r.services={},e.exports=r},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=r(53),i=function(){function e(e){void 0===e&&(e=1e3),this.maxSize=e,this.cache=new n.LRUCache(e)}return Object.defineProperty(e.prototype,"size",{get:function(){return this.cache.length},enumerable:!0,configurable:!0}),e.prototype.put=function(t,r){var n="string"!=typeof t?e.getKeyString(t):t,i=this.populateValue(r);this.cache.put(n,i)},e.prototype.get=function(t){var r="string"!=typeof t?e.getKeyString(t):t,n=Date.now(),i=this.cache.get(r);if(i)for(var o=0;o<i.length;o++){if(i[o].Expire<n)return void this.cache.remove(r)}return i},e.getKeyString=function(e){for(var t=[],r=Object.keys(e).sort(),n=0;n<r.length;n++){var i=r[n];void 0!==e[i]&&t.push(e[i])}return t.join(" ")},e.prototype.populateValue=function(e){var t=Date.now();return e.map((function(e){return{Address:e.Address||"",Expire:t+60*(e.CachePeriodInMinutes||1)*1e3}}))},e.prototype.empty=function(){this.cache.empty()},e.prototype.remove=function(t){var r="string"!=typeof t?e.getKeyString(t):t;this.cache.remove(r)},e}();t.EndpointCache=i},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e,t){this.key=e,this.value=t},i=function(){function e(e){if(this.nodeMap={},this.size=0,"number"!=typeof e||e<1)throw new Error("Cache size can only be positive number");this.sizeLimit=e}return Object.defineProperty(e.prototype,"length",{get:function(){return this.size},enumerable:!0,configurable:!0}),e.prototype.prependToList=function(e){this.headerNode?(this.headerNode.prev=e,e.next=this.headerNode):this.tailNode=e,this.headerNode=e,this.size++},e.prototype.removeFromTail=function(){if(this.tailNode){var e=this.tailNode,t=e.prev;return t&&(t.next=void 0),e.prev=void 0,this.tailNode=t,this.size--,e}},e.prototype.detachFromList=function(e){this.headerNode===e&&(this.headerNode=e.next),this.tailNode===e&&(this.tailNode=e.prev),e.prev&&(e.prev.next=e.next),e.next&&(e.next.prev=e.prev),e.next=void 0,e.prev=void 0,this.size--},e.prototype.get=function(e){if(this.nodeMap[e]){var t=this.nodeMap[e];return this.detachFromList(t),this.prependToList(t),t.value}},e.prototype.remove=function(e){if(this.nodeMap[e]){var t=this.nodeMap[e];this.detachFromList(t),delete this.nodeMap[e]}},e.prototype.put=function(e,t){if(this.nodeMap[e])this.remove(e);else if(this.size===this.sizeLimit){var r=this.removeFromTail().key;delete this.nodeMap[r]}var i=new n(e,t);this.nodeMap[e]=i,this.prependToList(i)},e.prototype.empty=function(){for(var e=Object.keys(this.nodeMap),t=0;t<e.length;t++){var r=e[t],n=this.nodeMap[r];this.detachFromList(n),delete this.nodeMap[r]}},e}();t.LRUCache=i},function(e,t,r){(function(t){var n=r(1),i=r(24),o=r(55),s=n.util.inherit,a=0;n.Service=s({constructor:function(e){if(!this.loadServiceClass)throw n.util.error(new Error,"Service must be constructed with `new' operator");var t=this.loadServiceClass(e||{});if(t){var r=n.util.copy(e),i=new t(e);return Object.defineProperty(i,"_originalConfig",{get:function(){return r},enumerable:!1,configurable:!0}),i._clientId=++a,i}this.initialize(e)},initialize:function(e){var r=n.config[this.serviceIdentifier];if(this.config=new n.Config(n.config),r&&this.config.update(r,!0),e&&this.config.update(e,!0),this.validateService(),this.config.endpoint||o(this),this.config.endpoint=this.endpointFromTemplate(this.config.endpoint),this.setEndpoint(this.config.endpoint),n.SequentialExecutor.call(this),n.Service.addDefaultMonitoringListeners(this),(this.config.clientSideMonitoring||n.Service._clientSideMonitoring)&&this.publisher){var i=this.publisher;this.addNamedListener("PUBLISH_API_CALL","apiCall",(function(e){t.nextTick((function(){i.eventHandler(e)}))})),this.addNamedListener("PUBLISH_API_ATTEMPT","apiCallAttempt",(function(e){t.nextTick((function(){i.eventHandler(e)}))}))}},validateService:function(){},loadServiceClass:function(e){var t=e;if(n.util.isEmpty(this.api)){if(t.apiConfig)return n.Service.defineServiceApi(this.constructor,t.apiConfig);if(this.constructor.services){(t=new n.Config(n.config)).update(e,!0);var r=t.apiVersions[this.constructor.serviceIdentifier];return r=r||t.apiVersion,this.getLatestServiceClass(r)}return null}return null},getLatestServiceClass:function(e){return e=this.getLatestServiceVersion(e),null===this.constructor.services[e]&&n.Service.defineServiceApi(this.constructor,e),this.constructor.services[e]},getLatestServiceVersion:function(e){if(!this.constructor.services||0===this.constructor.services.length)throw new Error("No services defined on "+this.constructor.serviceIdentifier);if(e?n.util.isType(e,Date)&&(e=n.util.date.iso8601(e).split("T")[0]):e="latest",Object.hasOwnProperty(this.constructor.services,e))return e;for(var t=Object.keys(this.constructor.services).sort(),r=null,i=t.length-1;i>=0;i--)if("*"!==t[i][t[i].length-1]&&(r=t[i]),t[i].substr(0,10)<=e)return r;throw new Error("Could not find "+this.constructor.serviceIdentifier+" API to satisfy version constraint `"+e+"'")},api:{},defaultRetryCount:3,customizeRequests:function(e){if(e){if("function"!=typeof e)throw new Error("Invalid callback type '"+typeof e+"' provided in customizeRequests");this.customRequestHandler=e}else this.customRequestHandler=null},makeRequest:function(e,t,r){if("function"==typeof t&&(r=t,t=null),t=t||{},this.config.params){var i=this.api.operations[e];i&&(t=n.util.copy(t),n.util.each(this.config.params,(function(e,r){i.input.members[e]&&(void 0!==t[e]&&null!==t[e]||(t[e]=r))})))}var o=new n.Request(this,e,t);return this.addAllRequestListeners(o),this.attachMonitoringEmitter(o),r&&o.send(r),o},makeUnauthenticatedRequest:function(e,t,r){"function"==typeof t&&(r=t,t={});var n=this.makeRequest(e,t).toUnauthenticated();return r?n.send(r):n},waitFor:function(e,t,r){return new n.ResourceWaiter(this,e).wait(t,r)},addAllRequestListeners:function(e){for(var t=[n.events,n.EventListeners.Core,this.serviceInterface(),n.EventListeners.CorePost],r=0;r<t.length;r++)t[r]&&e.addListeners(t[r]);this.config.paramValidation||e.removeListener("validate",n.EventListeners.Core.VALIDATE_PARAMETERS),this.config.logger&&e.addListeners(n.EventListeners.Logger),this.setupRequestListeners(e),"function"==typeof this.constructor.prototype.customRequestHandler&&this.constructor.prototype.customRequestHandler(e),Object.prototype.hasOwnProperty.call(this,"customRequestHandler")&&"function"==typeof this.customRequestHandler&&this.customRequestHandler(e)},apiCallEvent:function(e){var t=e.service.api.operations[e.operation],r={Type:"ApiCall",Api:t?t.name:e.operation,Version:1,Service:e.service.api.serviceId||e.service.api.endpointPrefix,Region:e.httpRequest.region,MaxRetriesExceeded:0,UserAgent:e.httpRequest.getUserAgent()},n=e.response;if(n.httpResponse.statusCode&&(r.FinalHttpStatusCode=n.httpResponse.statusCode),n.error){var i=n.error;n.httpResponse.statusCode>299?(i.code&&(r.FinalAwsException=i.code),i.message&&(r.FinalAwsExceptionMessage=i.message)):((i.code||i.name)&&(r.FinalSdkException=i.code||i.name),i.message&&(r.FinalSdkExceptionMessage=i.message))}return r},apiAttemptEvent:function(e){var t=e.service.api.operations[e.operation],r={Type:"ApiCallAttempt",Api:t?t.name:e.operation,Version:1,Service:e.service.api.serviceId||e.service.api.endpointPrefix,Fqdn:e.httpRequest.endpoint.hostname,UserAgent:e.httpRequest.getUserAgent()},n=e.response;return n.httpResponse.statusCode&&(r.HttpStatusCode=n.httpResponse.statusCode),!e._unAuthenticated&&e.service.config.credentials&&e.service.config.credentials.accessKeyId&&(r.AccessKey=e.service.config.credentials.accessKeyId),n.httpResponse.headers?(e.httpRequest.headers["x-amz-security-token"]&&(r.SessionToken=e.httpRequest.headers["x-amz-security-token"]),n.httpResponse.headers["x-amzn-requestid"]&&(r.XAmznRequestId=n.httpResponse.headers["x-amzn-requestid"]),n.httpResponse.headers["x-amz-request-id"]&&(r.XAmzRequestId=n.httpResponse.headers["x-amz-request-id"]),n.httpResponse.headers["x-amz-id-2"]&&(r.XAmzId2=n.httpResponse.headers["x-amz-id-2"]),r):r},attemptFailEvent:function(e){var t=this.apiAttemptEvent(e),r=e.response,n=r.error;return r.httpResponse.statusCode>299?(n.code&&(t.AwsException=n.code),n.message&&(t.AwsExceptionMessage=n.message)):((n.code||n.name)&&(t.SdkException=n.code||n.name),n.message&&(t.SdkExceptionMessage=n.message)),t},attachMonitoringEmitter:function(e){var t,r,i,o,s,a,u=0,c=this;e.on("validate",(function(){o=n.util.realClock.now(),a=Date.now()}),!0),e.on("sign",(function(){r=n.util.realClock.now(),t=Date.now(),s=e.httpRequest.region,u++}),!0),e.on("validateResponse",(function(){i=Math.round(n.util.realClock.now()-r)})),e.addNamedListener("API_CALL_ATTEMPT","success",(function(){var r=c.apiAttemptEvent(e);r.Timestamp=t,r.AttemptLatency=i>=0?i:0,r.Region=s,c.emit("apiCallAttempt",[r])})),e.addNamedListener("API_CALL_ATTEMPT_RETRY","retry",(function(){var o=c.attemptFailEvent(e);o.Timestamp=t,i=i||Math.round(n.util.realClock.now()-r),o.AttemptLatency=i>=0?i:0,o.Region=s,c.emit("apiCallAttempt",[o])})),e.addNamedListener("API_CALL","complete",(function(){var t=c.apiCallEvent(e);if(t.AttemptCount=u,!(t.AttemptCount<=0)){t.Timestamp=a;var r=Math.round(n.util.realClock.now()-o);t.Latency=r>=0?r:0;var i=e.response;"number"==typeof i.retryCount&&"number"==typeof i.maxRetries&&i.retryCount>=i.maxRetries&&(t.MaxRetriesExceeded=1),c.emit("apiCall",[t])}}))},setupRequestListeners:function(e){},getSignerClass:function(e){var t,r=null,i="";e&&(i=(r=(e.service.api.operations||{})[e.operation]||null)?r.authtype:"");return t=this.config.signatureVersion?this.config.signatureVersion:"v4"===i||"v4-unsigned-body"===i?"v4":this.api.signatureVersion,n.Signers.RequestSigner.getVersion(t)},serviceInterface:function(){switch(this.api.protocol){case"ec2":case"query":return n.EventListeners.Query;case"json":return n.EventListeners.Json;case"rest-json":return n.EventListeners.RestJson;case"rest-xml":return n.EventListeners.RestXml}if(this.api.protocol)throw new Error("Invalid service `protocol' "+this.api.protocol+" in API config")},successfulResponse:function(e){return e.httpResponse.statusCode<300},numRetries:function(){return void 0!==this.config.maxRetries?this.config.maxRetries:this.defaultRetryCount},retryDelays:function(e){return n.util.calculateRetryDelay(e,this.config.retryDelayOptions)},retryableError:function(e){return!!this.timeoutError(e)||(!!this.networkingError(e)||(!!this.expiredCredentialsError(e)||(!!this.throttledError(e)||e.statusCode>=500)))},networkingError:function(e){return"NetworkingError"===e.code},timeoutError:function(e){return"TimeoutError"===e.code},expiredCredentialsError:function(e){return"ExpiredTokenException"===e.code},clockSkewError:function(e){switch(e.code){case"RequestTimeTooSkewed":case"RequestExpired":case"InvalidSignatureException":case"SignatureDoesNotMatch":case"AuthFailure":case"RequestInTheFuture":return!0;default:return!1}},getSkewCorrectedDate:function(){return new Date(Date.now()+this.config.systemClockOffset)},applyClockOffset:function(e){e&&(this.config.systemClockOffset=e-Date.now())},isClockSkewed:function(e){if(e)return Math.abs(this.getSkewCorrectedDate().getTime()-e)>=3e4},throttledError:function(e){switch(e.code){case"ProvisionedThroughputExceededException":case"Throttling":case"ThrottlingException":case"RequestLimitExceeded":case"RequestThrottled":case"RequestThrottledException":case"TooManyRequestsException":case"TransactionInProgressException":return!0;default:return!1}},endpointFromTemplate:function(e){if("string"!=typeof e)return e;var t=e;return t=(t=(t=t.replace(/\{service\}/g,this.api.endpointPrefix)).replace(/\{region\}/g,this.config.region)).replace(/\{scheme\}/g,this.config.sslEnabled?"https":"http")},setEndpoint:function(e){this.endpoint=new n.Endpoint(e,this.config)},paginationConfig:function(e,t){var r=this.api.operations[e].paginator;if(!r){if(t){var i=new Error;throw n.util.error(i,"No pagination configuration for "+e)}return null}return r}}),n.util.update(n.Service,{defineMethods:function(e){n.util.each(e.prototype.api.operations,(function(t){e.prototype[t]||("none"===e.prototype.api.operations[t].authtype?e.prototype[t]=function(e,r){return this.makeUnauthenticatedRequest(t,e,r)}:e.prototype[t]=function(e,r){return this.makeRequest(t,e,r)})}))},defineService:function(e,t,r){n.Service._serviceMap[e]=!0,Array.isArray(t)||(r=t,t=[]);var i=s(n.Service,r||{});if("string"==typeof e){n.Service.addVersions(i,t);var o=i.serviceIdentifier||e;i.serviceIdentifier=o}else i.prototype.api=e,n.Service.defineMethods(i);if(n.SequentialExecutor.call(this.prototype),!this.prototype.publisher&&n.util.clientSideMonitoring){var a=n.util.clientSideMonitoring.Publisher,u=(0,n.util.clientSideMonitoring.configProvider)();this.prototype.publisher=new a(u),u.enabled&&(n.Service._clientSideMonitoring=!0)}return n.SequentialExecutor.call(i.prototype),n.Service.addDefaultMonitoringListeners(i.prototype),i},addVersions:function(e,t){Array.isArray(t)||(t=[t]),e.services=e.services||{};for(var r=0;r<t.length;r++)void 0===e.services[t[r]]&&(e.services[t[r]]=null);e.apiVersions=Object.keys(e.services).sort()},defineServiceApi:function(e,t,r){var o=s(e,{serviceIdentifier:e.serviceIdentifier});function a(e){e.isApi?o.prototype.api=e:o.prototype.api=new i(e)}if("string"==typeof t){if(r)a(r);else try{a(n.apiLoader(e.serviceIdentifier,t))}catch(r){throw n.util.error(r,{message:"Could not find API configuration "+e.serviceIdentifier+"-"+t})}Object.prototype.hasOwnProperty.call(e.services,t)||(e.apiVersions=e.apiVersions.concat(t).sort()),e.services[t]=o}else a(t);return n.Service.defineMethods(o),o},hasService:function(e){return Object.prototype.hasOwnProperty.call(n.Service._serviceMap,e)},addDefaultMonitoringListeners:function(e){e.addNamedListener("MONITOR_EVENTS_BUBBLE","apiCallAttempt",(function(t){var r=Object.getPrototypeOf(e);r._events&&r.emit("apiCallAttempt",[t])})),e.addNamedListener("CALL_EVENTS_BUBBLE","apiCall",(function(t){var r=Object.getPrototypeOf(e);r._events&&r.emit("apiCall",[t])}))},_serviceMap:{}}),n.util.mixin(n.Service,n.SequentialExecutor),e.exports=n.Service}).call(this,r(5))},function(e,t,r){var n=r(2),i=r(56);function o(e,t){n.each(t,(function(t,r){"globalEndpoint"!==t&&(void 0!==e.config[t]&&null!==e.config[t]||(e.config[t]=r))}))}e.exports=function(e){for(var t=function(e){var t=e.config.region,r=function(e){if(!e)return null;var t=e.split("-");return t.length<3?null:t.slice(0,t.length-2).join("-")+"-*"}(t),n=e.api.endpointPrefix;return[[t,n],[r,n],[t,"*"],[r,"*"],["*",n],["*","*"]].map((function(e){return e[0]&&e[1]?e.join("/"):null}))}(e),r=0;r<t.length;r++){var s=t[r];if(s&&Object.prototype.hasOwnProperty.call(i.rules,s)){var a=i.rules[s];return"string"==typeof a&&(a=i.patterns[a]),e.config.useDualstack&&n.isDualstackAvailable(e)&&((a=n.copy(a)).endpoint="{service}.dualstack.{region}.amazonaws.com"),e.isGlobalEndpoint=!!a.globalEndpoint,a.signatureVersion||(a.signatureVersion="v4"),void o(e,a)}}}},function(e){e.exports=JSON.parse('{"rules":{"*/*":{"endpoint":"{service}.{region}.amazonaws.com"},"cn-*/*":{"endpoint":"{service}.{region}.amazonaws.com.cn"},"*/budgets":"globalSSL","*/cloudfront":"globalSSL","*/iam":"globalSSL","*/sts":"globalSSL","*/importexport":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2","globalEndpoint":true},"*/route53":{"endpoint":"https://{service}.amazonaws.com","signatureVersion":"v3https","globalEndpoint":true},"*/waf":"globalSSL","us-gov-*/iam":"globalGovCloud","us-gov-*/sts":{"endpoint":"{service}.{region}.amazonaws.com"},"us-gov-west-1/s3":"s3signature","us-west-1/s3":"s3signature","us-west-2/s3":"s3signature","eu-west-1/s3":"s3signature","ap-southeast-1/s3":"s3signature","ap-southeast-2/s3":"s3signature","ap-northeast-1/s3":"s3signature","sa-east-1/s3":"s3signature","us-east-1/s3":{"endpoint":"{service}.amazonaws.com","signatureVersion":"s3"},"us-east-1/sdb":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2"},"*/sdb":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"v2"}},"patterns":{"globalSSL":{"endpoint":"https://{service}.amazonaws.com","globalEndpoint":true},"globalGovCloud":{"endpoint":"{service}.us-gov.amazonaws.com"},"s3signature":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"s3"}}}')},function(e,t,r){var n,i=r(1);r(29),r(30),i.Config=i.util.inherit({constructor:function(e){void 0===e&&(e={}),e=this.extractCredentials(e),i.util.each.call(this,this.keys,(function(t,r){this.set(t,e[t],r)}))},getCredentials:function(e){var t,r=this;function n(t){e(t,t?null:r.credentials)}function o(e,t){return new i.util.error(t||new Error,{code:"CredentialsError",message:e,name:"CredentialsError"})}r.credentials?"function"==typeof r.credentials.get?r.credentials.get((function(e){e&&(e=o("Could not load credentials from "+r.credentials.constructor.name,e)),n(e)})):(t=null,r.credentials.accessKeyId&&r.credentials.secretAccessKey||(t=o("Missing credentials")),n(t)):r.credentialProvider?r.credentialProvider.resolve((function(e,t){e&&(e=o("Could not load credentials from any providers",e)),r.credentials=t,n(e)})):n(o("No credentials to load"))},update:function(e,t){t=t||!1,e=this.extractCredentials(e),i.util.each.call(this,e,(function(e,r){(t||Object.prototype.hasOwnProperty.call(this.keys,e)||i.Service.hasService(e))&&this.set(e,r)}))},loadFromPath:function(e){this.clear();var t=JSON.parse(i.util.readFileSync(e)),r=new i.FileSystemCredentials(e),n=new i.CredentialProviderChain;return n.providers.unshift(r),n.resolve((function(e,r){if(e)throw e;t.credentials=r})),this.constructor(t),this},clear:function(){i.util.each.call(this,this.keys,(function(e){delete this[e]})),this.set("credentials",void 0),this.set("credentialProvider",void 0)},set:function(e,t,r){void 0===t?(void 0===r&&(r=this.keys[e]),this[e]="function"==typeof r?r.call(this):r):"httpOptions"===e&&this[e]?this[e]=i.util.merge(this[e],t):this[e]=t},keys:{credentials:null,credentialProvider:null,region:null,logger:null,apiVersions:{},apiVersion:null,endpoint:void 0,httpOptions:{timeout:12e4},maxRetries:void 0,maxRedirects:10,paramValidation:!0,sslEnabled:!0,s3ForcePathStyle:!1,s3BucketEndpoint:!1,s3DisableBodySigning:!0,computeChecksums:!0,convertResponseTypes:!0,correctClockSkew:!1,customUserAgent:null,dynamoDbCrc32:!0,systemClockOffset:0,signatureVersion:null,signatureCache:!0,retryDelayOptions:{},useAccelerateEndpoint:!1,clientSideMonitoring:!1,endpointDiscoveryEnabled:!1,endpointCacheSize:1e3,hostPrefixEnabled:!0},extractCredentials:function(e){return e.accessKeyId&&e.secretAccessKey&&((e=i.util.copy(e)).credentials=new i.Credentials(e)),e},setPromisesDependency:function(e){n=e,null===e&&"function"==typeof Promise&&(n=Promise);var t=[i.Request,i.Credentials,i.CredentialProviderChain];i.S3&&i.S3.ManagedUpload&&t.push(i.S3.ManagedUpload),i.util.addPromises(t,n)},getPromisesDependency:function(){return n}}),i.config=new i.Config},function(e,t,r){var n=r(1),i=r(28),o=r(59).discoverEndpoint;n.EventListeners={Core:{}},n.EventListeners={Core:(new i).addNamedListeners((function(e,t){t("VALIDATE_CREDENTIALS","validate",(function(e,t){if(!e.service.api.signatureVersion)return t();e.service.config.getCredentials((function(r){r&&(e.response.error=n.util.error(r,{code:"CredentialsError",message:"Missing credentials in config"})),t()}))})),e("VALIDATE_REGION","validate",(function(e){e.service.config.region||e.service.isGlobalEndpoint||(e.response.error=n.util.error(new Error,{code:"ConfigError",message:"Missing region in config"}))})),e("BUILD_IDEMPOTENCY_TOKENS","validate",(function(e){if(e.service.api.operations){var t=e.service.api.operations[e.operation];if(t){var r=t.idempotentMembers;if(r.length){for(var i=n.util.copy(e.params),o=0,s=r.length;o<s;o++)i[r[o]]||(i[r[o]]=n.util.uuid.v4());e.params=i}}}})),e("VALIDATE_PARAMETERS","validate",(function(e){if(e.service.api.operations){var t=e.service.api.operations[e.operation].input,r=e.service.config.paramValidation;new n.ParamValidator(r).validate(t,e.params)}})),t("COMPUTE_SHA256","afterBuild",(function(e,t){if(e.haltHandlersOnError(),e.service.api.operations){var r=e.service.api.operations[e.operation],i=r?r.authtype:"";if(!e.service.api.signatureVersion&&!i)return t();if(e.service.getSignerClass(e)===n.Signers.V4){var o=e.httpRequest.body||"";if(i.indexOf("unsigned-body")>=0)return e.httpRequest.headers["X-Amz-Content-Sha256"]="UNSIGNED-PAYLOAD",t();n.util.computeSha256(o,(function(r,n){r?t(r):(e.httpRequest.headers["X-Amz-Content-Sha256"]=n,t())}))}else t()}})),e("SET_CONTENT_LENGTH","afterBuild",(function(e){var t=function(e){if(!e.service.api.operations)return"";var t=e.service.api.operations[e.operation];return t?t.authtype:""}(e),r=n.util.getRequestPayloadShape(e);if(void 0===e.httpRequest.headers["Content-Length"])try{var i=n.util.string.byteLength(e.httpRequest.body);e.httpRequest.headers["Content-Length"]=i}catch(n){if(r&&r.isStreaming){if(r.requiresLength)throw n;if(t.indexOf("unsigned-body")>=0)return void(e.httpRequest.headers["Transfer-Encoding"]="chunked");throw n}throw n}})),e("SET_HTTP_HOST","afterBuild",(function(e){e.httpRequest.headers.Host=e.httpRequest.endpoint.host})),e("RESTART","restart",(function(){var e=this.response.error;e&&e.retryable&&(this.httpRequest=new n.HttpRequest(this.service.endpoint,this.service.region),this.response.retryCount<this.service.config.maxRetries?this.response.retryCount++:this.response.error=null)}));t("DISCOVER_ENDPOINT","sign",o,!0),t("SIGN","sign",(function(e,t){var r=e.service,n=(e.service.api.operations||{})[e.operation],i=n?n.authtype:"";if(!r.api.signatureVersion&&!i)return t();r.config.getCredentials((function(i,o){if(i)return e.response.error=i,t();try{var s=r.getSkewCorrectedDate(),a=new(r.getSignerClass(e))(e.httpRequest,r.api.signingName||r.api.endpointPrefix,{signatureCache:r.config.signatureCache,operation:n,signatureVersion:r.api.signatureVersion});a.setServiceClientId(r._clientId),delete e.httpRequest.headers.Authorization,delete e.httpRequest.headers.Date,delete e.httpRequest.headers["X-Amz-Date"],a.addAuthorization(o,s),e.signedAt=s}catch(t){e.response.error=t}t()}))})),e("VALIDATE_RESPONSE","validateResponse",(function(e){this.service.successfulResponse(e,this)?(e.data={},e.error=null):(e.data=null,e.error=n.util.error(new Error,{code:"UnknownError",message:"An unknown error occurred."}))})),t("SEND","send",(function(e,t){function r(r){e.httpResponse.stream=r;var i=e.request.httpRequest.stream,o=e.request.service,s=o.api,a=e.request.operation,u=s.operations[a]||{};r.on("headers",(function(i,s,a){if(e.request.emit("httpHeaders",[i,s,e,a]),!e.httpResponse.streaming)if(2===n.HttpClient.streamsApiVersion){if(u.hasEventOutput&&o.successfulResponse(e))return e.request.emit("httpDone"),void t();r.on("readable",(function(){var t=r.read();null!==t&&e.request.emit("httpData",[t,e])}))}else r.on("data",(function(t){e.request.emit("httpData",[t,e])}))})),r.on("end",(function(){if(!i||!i.didCallback){if(2===n.HttpClient.streamsApiVersion&&u.hasEventOutput&&o.successfulResponse(e))return;e.request.emit("httpDone"),t()}}))}function i(r){if("RequestAbortedError"!==r.code){var i="TimeoutError"===r.code?r.code:"NetworkingError";r=n.util.error(r,{code:i,region:e.request.httpRequest.region,hostname:e.request.httpRequest.endpoint.hostname,retryable:!0})}e.error=r,e.request.emit("httpError",[e.error,e],(function(){t()}))}function o(){var t,o=n.HttpClient.getInstance(),s=e.request.service.config.httpOptions||{};try{var a=o.handleRequest(e.request.httpRequest,s,r,i);(t=a).on("sendProgress",(function(t){e.request.emit("httpUploadProgress",[t,e])})),t.on("receiveProgress",(function(t){e.request.emit("httpDownloadProgress",[t,e])}))}catch(e){i(e)}}e.httpResponse._abortCallback=t,e.error=null,e.data=null,(e.request.service.getSkewCorrectedDate()-this.signedAt)/1e3>=600?this.emit("sign",[this],(function(e){e?t(e):o()})):o()})),e("HTTP_HEADERS","httpHeaders",(function(e,t,r,i){r.httpResponse.statusCode=e,r.httpResponse.statusMessage=i,r.httpResponse.headers=t,r.httpResponse.body=n.util.buffer.toBuffer(""),r.httpResponse.buffers=[],r.httpResponse.numBytes=0;var o=t.date||t.Date,s=r.request.service;if(o){var a=Date.parse(o);s.config.correctClockSkew&&s.isClockSkewed(a)&&s.applyClockOffset(a)}})),e("HTTP_DATA","httpData",(function(e,t){if(e){if(n.util.isNode()){t.httpResponse.numBytes+=e.length;var r=t.httpResponse.headers["content-length"],i={loaded:t.httpResponse.numBytes,total:r};t.request.emit("httpDownloadProgress",[i,t])}t.httpResponse.buffers.push(n.util.buffer.toBuffer(e))}})),e("HTTP_DONE","httpDone",(function(e){if(e.httpResponse.buffers&&e.httpResponse.buffers.length>0){var t=n.util.buffer.concat(e.httpResponse.buffers);e.httpResponse.body=t}delete e.httpResponse.numBytes,delete e.httpResponse.buffers})),e("FINALIZE_ERROR","retry",(function(e){e.httpResponse.statusCode&&(e.error.statusCode=e.httpResponse.statusCode,void 0===e.error.retryable&&(e.error.retryable=this.service.retryableError(e.error,this)))})),e("INVALIDATE_CREDENTIALS","retry",(function(e){if(e.error)switch(e.error.code){case"RequestExpired":case"ExpiredTokenException":case"ExpiredToken":e.error.retryable=!0,e.request.service.config.credentials.expired=!0}})),e("EXPIRED_SIGNATURE","retry",(function(e){var t=e.error;t&&"string"==typeof t.code&&"string"==typeof t.message&&t.code.match(/Signature/)&&t.message.match(/expired/)&&(e.error.retryable=!0)})),e("CLOCK_SKEWED","retry",(function(e){e.error&&this.service.clockSkewError(e.error)&&this.service.config.correctClockSkew&&(e.error.retryable=!0)})),e("REDIRECT","retry",(function(e){e.error&&e.error.statusCode>=300&&e.error.statusCode<400&&e.httpResponse.headers.location&&(this.httpRequest.endpoint=new n.Endpoint(e.httpResponse.headers.location),this.httpRequest.headers.Host=this.httpRequest.endpoint.host,e.error.redirect=!0,e.error.retryable=!0)})),e("RETRY_CHECK","retry",(function(e){e.error&&(e.error.redirect&&e.redirectCount<e.maxRedirects?e.error.retryDelay=0:e.retryCount<e.maxRetries&&(e.error.retryDelay=this.service.retryDelays(e.retryCount)||0))})),t("RESET_RETRY_STATE","afterRetry",(function(e,t){var r,n=!1;e.error&&(r=e.error.retryDelay||0,e.error.retryable&&e.retryCount<e.maxRetries?(e.retryCount++,n=!0):e.error.redirect&&e.redirectCount<e.maxRedirects&&(e.redirectCount++,n=!0)),n?(e.error=null,setTimeout(t,r)):t()}))})),CorePost:(new i).addNamedListeners((function(e){e("EXTRACT_REQUEST_ID","extractData",n.util.extractRequestId),e("EXTRACT_REQUEST_ID","extractError",n.util.extractRequestId),e("ENOTFOUND_ERROR","httpError",(function(e){if("NetworkingError"===e.code&&"ENOTFOUND"===e.errno){var t="Inaccessible host: `"+e.hostname+"'. This service may not be available in the `"+e.region+"' region.";this.response.error=n.util.error(new Error(t),{code:"UnknownEndpoint",region:e.region,hostname:e.hostname,retryable:!0,originalError:e})}}))})),Logger:(new i).addNamedListeners((function(e){e("LOG_REQUEST","complete",(function(e){var t=e.request,i=t.service.config.logger;if(i){var o=function(){var o=(e.request.service.getSkewCorrectedDate().getTime()-t.startTime.getTime())/1e3,s=!!i.isTTY,a=e.httpResponse.statusCode,u=t.params;t.service.api.operations&&t.service.api.operations[t.operation]&&t.service.api.operations[t.operation].input&&(u=function e(t,r){if(!r)return r;switch(t.type){case"structure":var i={};return n.util.each(r,(function(r,n){Object.prototype.hasOwnProperty.call(t.members,r)?i[r]=e(t.members[r],n):i[r]=n})),i;case"list":var o=[];return n.util.arrayEach(r,(function(r,n){o.push(e(t.member,r))})),o;case"map":var s={};return n.util.each(r,(function(r,n){s[r]=e(t.value,n)})),s;default:return t.isSensitive?"***SensitiveInformation***":r}}(t.service.api.operations[t.operation].input,t.params));var c=r(60).inspect(u,!0,null),f="";return s&&(f+="[33m"),f+="[AWS "+t.service.serviceIdentifier+" "+a,f+=" "+o.toString()+"s "+e.retryCount+" retries]",s&&(f+="[0;1m"),f+=" "+n.util.string.lowerFirst(t.operation),f+="("+c+")",s&&(f+="[0m"),f}();"function"==typeof i.log?i.log(o):"function"==typeof i.write&&i.write(o+"\n")}}))})),Json:(new i).addNamedListeners((function(e){var t=r(14);e("BUILD","build",t.buildRequest),e("EXTRACT_DATA","extractData",t.extractData),e("EXTRACT_ERROR","extractError",t.extractError)})),Rest:(new i).addNamedListeners((function(e){var t=r(12);e("BUILD","build",t.buildRequest),e("EXTRACT_DATA","extractData",t.extractData),e("EXTRACT_ERROR","extractError",t.extractError)})),RestJson:(new i).addNamedListeners((function(e){var t=r(22);e("BUILD","build",t.buildRequest),e("EXTRACT_DATA","extractData",t.extractData),e("EXTRACT_ERROR","extractError",t.extractError)})),RestXml:(new i).addNamedListeners((function(e){var t=r(23);e("BUILD","build",t.buildRequest),e("EXTRACT_DATA","extractData",t.extractData),e("EXTRACT_ERROR","extractError",t.extractError)})),Query:(new i).addNamedListeners((function(e){var t=r(20);e("BUILD","build",t.buildRequest),e("EXTRACT_DATA","extractData",t.extractData),e("EXTRACT_ERROR","extractError",t.extractError)}))}},function(e,t,r){(function(t){var n=r(1),i=r(2),o=["AWS_ENABLE_ENDPOINT_DISCOVERY","AWS_ENDPOINT_DISCOVERY_ENABLED"];function s(e){var t=e.service,r=t.api||{},n=(r.operations,{});return t.config.region&&(n.region=t.config.region),r.serviceId&&(n.serviceId=r.serviceId),t.config.credentials.accessKeyId&&(n.accessKeyId=t.config.credentials.accessKeyId),n}function a(e,t){var r={};return function e(t,r,n){n&&null!=r&&"structure"===n.type&&n.required&&n.required.length>0&&i.arrayEach(n.required,(function(i){var o=n.members[i];if(!0===o.endpointDiscoveryId){var s=o.isLocationName?o.name:i;t[s]=String(r[i])}else e(t,r[i],o)}))}(r,e.params,t),r}function u(e){var t=e.service,r=t.api,o=r.operations?r.operations[e.operation]:void 0,u=a(e,o?o.input:void 0),c=s(e);Object.keys(u).length>0&&(c=i.update(c,u),o&&(c.operation=o.name));var f=n.endpointCache.get(c);if(!f||1!==f.length||""!==f[0].Address)if(f&&f.length>0)e.httpRequest.updateEndpoint(f[0].Address);else{var h=t.makeRequest(r.endpointOperation,{Operation:o.name,Identifiers:u});l(h),h.removeListener("validate",n.EventListeners.Core.VALIDATE_PARAMETERS),h.removeListener("retry",n.EventListeners.Core.RETRY_CHECK),n.endpointCache.put(c,[{Address:"",CachePeriodInMinutes:1}]),h.send((function(e,t){t&&t.Endpoints?n.endpointCache.put(c,t.Endpoints):e&&n.endpointCache.put(c,[{Address:"",CachePeriodInMinutes:1}])}))}}var c={};function f(e,t){var r=e.service,o=r.api,u=o.operations?o.operations[e.operation]:void 0,f=u?u.input:void 0,h=a(e,f),p=s(e);Object.keys(h).length>0&&(p=i.update(p,h),u&&(p.operation=u.name));var d=n.EndpointCache.getKeyString(p),v=n.endpointCache.get(d);if(v&&1===v.length&&""===v[0].Address)return c[d]||(c[d]=[]),void c[d].push({request:e,callback:t});if(v&&v.length>0)e.httpRequest.updateEndpoint(v[0].Address),t();else{var m=r.makeRequest(o.endpointOperation,{Operation:u.name,Identifiers:h});m.removeListener("validate",n.EventListeners.Core.VALIDATE_PARAMETERS),l(m),n.endpointCache.put(d,[{Address:"",CachePeriodInMinutes:60}]),m.send((function(r,o){if(r){var s={code:"EndpointDiscoveryException",message:"Request cannot be fulfilled without specifying an endpoint",retryable:!1};if(e.response.error=i.error(r,s),n.endpointCache.remove(p),c[d]){var a=c[d];i.arrayEach(a,(function(e){e.request.response.error=i.error(r,s),e.callback()})),delete c[d]}}else if(o&&(n.endpointCache.put(d,o.Endpoints),e.httpRequest.updateEndpoint(o.Endpoints[0].Address),c[d])){a=c[d];i.arrayEach(a,(function(e){e.request.httpRequest.updateEndpoint(o.Endpoints[0].Address),e.callback()})),delete c[d]}t()}))}}function l(e){var t=e.service.api.apiVersion;t&&!e.httpRequest.headers["x-amz-api-version"]&&(e.httpRequest.headers["x-amz-api-version"]=t)}function h(e){var t=e.error,r=e.httpResponse;if(t&&("InvalidEndpointException"===t.code||421===r.statusCode)){var o=e.request,u=o.service.api.operations||{},c=a(o,u[o.operation]?u[o.operation].input:void 0),f=s(o);Object.keys(c).length>0&&(f=i.update(f,c),u[o.operation]&&(f.operation=u[o.operation].name)),n.endpointCache.remove(f)}}function p(e){return["false","0"].indexOf(e)>=0}e.exports={discoverEndpoint:function(e,r){var s=e.service||{};if(function(e){if(e._originalConfig&&e._originalConfig.endpoint&&!0===e._originalConfig.endpointDiscoveryEnabled)throw i.error(new Error,{code:"ConfigurationException",message:"Custom endpoint is supplied; endpointDiscoveryEnabled must not be true."});var t=n.config[e.serviceIdentifier]||{};return Boolean(n.config.endpoint||t.endpoint||e._originalConfig&&e._originalConfig.endpoint)}(s)||e.isPresigned())return r();if(!function(e){if(!0===(e.service||{}).config.endpointDiscoveryEnabled)return!0;if(i.isBrowser())return!1;for(var r=0;r<o.length;r++){var s=o[r];if(Object.prototype.hasOwnProperty.call(t.env,s)){if(""===t.env[s]||void 0===t.env[s])throw i.error(new Error,{code:"ConfigurationException",message:"environmental variable "+s+" cannot be set to nothing"});if(!p(t.env[s]))return!0}}var a={};try{a=n.util.iniLoader?n.util.iniLoader.loadFrom({isConfig:!0,filename:t.env[n.util.sharedConfigFileEnv]}):{}}catch(e){}var u=a[t.env.AWS_PROFILE||n.util.defaultProfile]||{};if(Object.prototype.hasOwnProperty.call(u,"endpoint_discovery_enabled")){if(void 0===u.endpoint_discovery_enabled)throw i.error(new Error,{code:"ConfigurationException",message:"config file entry 'endpoint_discovery_enabled' cannot be set to nothing"});if(!p(u.endpoint_discovery_enabled))return!0}return!1}(e))return r();e.httpRequest.appendToUserAgent("endpoint-discovery");var a=(s.api.operations||{})[e.operation];switch(a?a.endpointDiscoveryRequired:"NULL"){case"OPTIONAL":u(e),e.addNamedListener("INVALIDATE_CACHED_ENDPOINTS","extractError",h),r();break;case"REQUIRED":e.addNamedListener("INVALIDATE_CACHED_ENDPOINTS","extractError",h),f(e,r);break;case"NULL":default:r()}},requiredDiscoverEndpoint:f,optionalDiscoverEndpoint:u,marshallCustomIdentifiers:a,getCacheKey:s,invalidateCachedEndpoint:h}}).call(this,r(5))},function(e,t,r){(function(e){var n=Object.getOwnPropertyDescriptors||function(e){for(var t=Object.keys(e),r={},n=0;n<t.length;n++)r[t[n]]=Object.getOwnPropertyDescriptor(e,t[n]);return r},i=/%[sdj%]/g;t.format=function(e){if(!g(e)){for(var t=[],r=0;r<arguments.length;r++)t.push(a(arguments[r]));return t.join(" ")}r=1;for(var n=arguments,o=n.length,s=String(e).replace(i,(function(e){if("%%"===e)return"%";if(r>=o)return e;switch(e){case"%s":return String(n[r++]);case"%d":return Number(n[r++]);case"%j":try{return JSON.stringify(n[r++])}catch(e){return"[Circular]"}default:return e}})),u=n[r];r<o;u=n[++r])v(u)||!_(u)?s+=" "+u:s+=" "+a(u);return s},t.deprecate=function(r,n){if(void 0!==e&&!0===e.noDeprecation)return r;if(void 0===e)return function(){return t.deprecate(r,n).apply(this,arguments)};var i=!1;return function(){if(!i){if(e.throwDeprecation)throw new Error(n);e.traceDeprecation?console.trace(n):console.error(n),i=!0}return r.apply(this,arguments)}};var o,s={};function a(e,r){var n={seen:[],stylize:c};return arguments.length>=3&&(n.depth=arguments[2]),arguments.length>=4&&(n.colors=arguments[3]),d(r)?n.showHidden=r:r&&t._extend(n,r),y(n.showHidden)&&(n.showHidden=!1),y(n.depth)&&(n.depth=2),y(n.colors)&&(n.colors=!1),y(n.customInspect)&&(n.customInspect=!0),n.colors&&(n.stylize=u),f(n,e,n.depth)}function u(e,t){var r=a.styles[t];return r?"["+a.colors[r][0]+"m"+e+"["+a.colors[r][1]+"m":e}function c(e,t){return e}function f(e,r,n){if(e.customInspect&&r&&S(r.inspect)&&r.inspect!==t.inspect&&(!r.constructor||r.constructor.prototype!==r)){var i=r.inspect(n,e);return g(i)||(i=f(e,i,n)),i}var o=function(e,t){if(y(t))return e.stylize("undefined","undefined");if(g(t)){var r="'"+JSON.stringify(t).replace(/^"|"$/g,"").replace(/'/g,"\\'").replace(/\\"/g,'"')+"'";return e.stylize(r,"string")}if(m(t))return e.stylize(""+t,"number");if(d(t))return e.stylize(""+t,"boolean");if(v(t))return e.stylize("null","null")}(e,r);if(o)return o;var s=Object.keys(r),a=function(e){var t={};return e.forEach((function(e,r){t[e]=!0})),t}(s);if(e.showHidden&&(s=Object.getOwnPropertyNames(r)),E(r)&&(s.indexOf("message")>=0||s.indexOf("description")>=0))return l(r);if(0===s.length){if(S(r)){var u=r.name?": "+r.name:"";return e.stylize("[Function"+u+"]","special")}if(b(r))return e.stylize(RegExp.prototype.toString.call(r),"regexp");if(w(r))return e.stylize(Date.prototype.toString.call(r),"date");if(E(r))return l(r)}var c,_="",A=!1,x=["{","}"];(p(r)&&(A=!0,x=["[","]"]),S(r))&&(_=" [Function"+(r.name?": "+r.name:"")+"]");return b(r)&&(_=" "+RegExp.prototype.toString.call(r)),w(r)&&(_=" "+Date.prototype.toUTCString.call(r)),E(r)&&(_=" "+l(r)),0!==s.length||A&&0!=r.length?n<0?b(r)?e.stylize(RegExp.prototype.toString.call(r),"regexp"):e.stylize("[Object]","special"):(e.seen.push(r),c=A?function(e,t,r,n,i){for(var o=[],s=0,a=t.length;s<a;++s)R(t,String(s))?o.push(h(e,t,r,n,String(s),!0)):o.push("");return i.forEach((function(i){i.match(/^\d+$/)||o.push(h(e,t,r,n,i,!0))})),o}(e,r,n,a,s):s.map((function(t){return h(e,r,n,a,t,A)})),e.seen.pop(),function(e,t,r){if(e.reduce((function(e,t){return t.indexOf("\n")>=0&&0,e+t.replace(/\u001b\[\d\d?m/g,"").length+1}),0)>60)return r[0]+(""===t?"":t+"\n ")+" "+e.join(",\n  ")+" "+r[1];return r[0]+t+" "+e.join(", ")+" "+r[1]}(c,_,x)):x[0]+_+x[1]}function l(e){return"["+Error.prototype.toString.call(e)+"]"}function h(e,t,r,n,i,o){var s,a,u;if((u=Object.getOwnPropertyDescriptor(t,i)||{value:t[i]}).get?a=u.set?e.stylize("[Getter/Setter]","special"):e.stylize("[Getter]","special"):u.set&&(a=e.stylize("[Setter]","special")),R(n,i)||(s="["+i+"]"),a||(e.seen.indexOf(u.value)<0?(a=v(r)?f(e,u.value,null):f(e,u.value,r-1)).indexOf("\n")>-1&&(a=o?a.split("\n").map((function(e){return"  "+e})).join("\n").substr(2):"\n"+a.split("\n").map((function(e){return"   "+e})).join("\n")):a=e.stylize("[Circular]","special")),y(s)){if(o&&i.match(/^\d+$/))return a;(s=JSON.stringify(""+i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)?(s=s.substr(1,s.length-2),s=e.stylize(s,"name")):(s=s.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'"),s=e.stylize(s,"string"))}return s+": "+a}function p(e){return Array.isArray(e)}function d(e){return"boolean"==typeof e}function v(e){return null===e}function m(e){return"number"==typeof e}function g(e){return"string"==typeof e}function y(e){return void 0===e}function b(e){return _(e)&&"[object RegExp]"===A(e)}function _(e){return"object"==typeof e&&null!==e}function w(e){return _(e)&&"[object Date]"===A(e)}function E(e){return _(e)&&("[object Error]"===A(e)||e instanceof Error)}function S(e){return"function"==typeof e}function A(e){return Object.prototype.toString.call(e)}function x(e){return e<10?"0"+e.toString(10):e.toString(10)}t.debuglog=function(r){if(y(o)&&(o=e.env.NODE_DEBUG||""),r=r.toUpperCase(),!s[r])if(new RegExp("\\b"+r+"\\b","i").test(o)){var n=e.pid;s[r]=function(){var e=t.format.apply(t,arguments);console.error("%s %d: %s",r,n,e)}}else s[r]=function(){};return s[r]},t.inspect=a,a.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]},a.styles={special:"cyan",number:"yellow",boolean:"yellow",undefined:"grey",null:"bold",string:"green",date:"magenta",regexp:"red"},t.isArray=p,t.isBoolean=d,t.isNull=v,t.isNullOrUndefined=function(e){return null==e},t.isNumber=m,t.isString=g,t.isSymbol=function(e){return"symbol"==typeof e},t.isUndefined=y,t.isRegExp=b,t.isObject=_,t.isDate=w,t.isError=E,t.isFunction=S,t.isPrimitive=function(e){return null===e||"boolean"==typeof e||"number"==typeof e||"string"==typeof e||"symbol"==typeof e||void 0===e},t.isBuffer=r(61);var I=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];function C(){var e=new Date,t=[x(e.getHours()),x(e.getMinutes()),x(e.getSeconds())].join(":");return[e.getDate(),I[e.getMonth()],t].join(" ")}function R(e,t){return Object.prototype.hasOwnProperty.call(e,t)}t.log=function(){console.log("%s - %s",C(),t.format.apply(t,arguments))},t.inherits=r(62),t._extend=function(e,t){if(!t||!_(t))return e;for(var r=Object.keys(t),n=r.length;n--;)e[r[n]]=t[r[n]];return e};var T="undefined"!=typeof Symbol?Symbol("util.promisify.custom"):void 0;function k(e,t){if(!e){var r=new Error("Promise was rejected with a falsy value");r.reason=e,e=r}return t(e)}t.promisify=function(e){if("function"!=typeof e)throw new TypeError('The "original" argument must be of type Function');if(T&&e[T]){var t;if("function"!=typeof(t=e[T]))throw new TypeError('The "util.promisify.custom" argument must be of type Function');return Object.defineProperty(t,T,{value:t,enumerable:!1,writable:!1,configurable:!0}),t}function t(){for(var t,r,n=new Promise((function(e,n){t=e,r=n})),i=[],o=0;o<arguments.length;o++)i.push(arguments[o]);i.push((function(e,n){e?r(e):t(n)}));try{e.apply(this,i)}catch(e){r(e)}return n}return Object.setPrototypeOf(t,Object.getPrototypeOf(e)),T&&Object.defineProperty(t,T,{value:t,enumerable:!1,writable:!1,configurable:!0}),Object.defineProperties(t,n(e))},t.promisify.custom=T,t.callbackify=function(t){if("function"!=typeof t)throw new TypeError('The "original" argument must be of type Function');function r(){for(var r=[],n=0;n<arguments.length;n++)r.push(arguments[n]);var i=r.pop();if("function"!=typeof i)throw new TypeError("The last argument must be of type Function");var o=this,s=function(){return i.apply(o,arguments)};t.apply(this,r).then((function(t){e.nextTick(s,null,t)}),(function(t){e.nextTick(k,t,s)}))}return Object.setPrototypeOf(r,Object.getPrototypeOf(t)),Object.defineProperties(r,n(t)),r}}).call(this,r(5))},function(e,t){e.exports=function(e){return e&&"object"==typeof e&&"function"==typeof e.copy&&"function"==typeof e.fill&&"function"==typeof e.readUInt8}},function(e,t){"function"==typeof Object.create?e.exports=function(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}:e.exports=function(e,t){e.super_=t;var r=function(){};r.prototype=t.prototype,e.prototype=new r,e.prototype.constructor=e}},function(e,t,r){(function(e){var t=r(1),n=r(64),i=t.util.inherit,o=t.util.domain,s=r(18),a={success:1,error:1,complete:1};var u=new n;u.setupStates=function(){var e=function(e,t){var r=this;r._haltHandlersOnError=!1,r.emit(r._asm.currentState,(function(e){if(e)if(n=r,Object.prototype.hasOwnProperty.call(a,n._asm.currentState)){if(!(o&&r.domain instanceof o.Domain))throw e;e.domainEmitter=r,e.domain=r.domain,e.domainThrown=!1,r.domain.emit("error",e)}else r.response.error=e,t(e);else t(r.response.error);var n}))};this.addState("validate","build","error",e),this.addState("build","afterBuild","restart",e),this.addState("afterBuild","sign","restart",e),this.addState("sign","send","retry",e),this.addState("retry","afterRetry","afterRetry",e),this.addState("afterRetry","sign","error",e),this.addState("send","validateResponse","retry",e),this.addState("validateResponse","extractData","extractError",e),this.addState("extractError","extractData","retry",e),this.addState("extractData","success","retry",e),this.addState("restart","build","error",e),this.addState("success","complete","complete",e),this.addState("error","complete","complete",e),this.addState("complete",null,null,e)},u.setupStates(),t.Request=i({constructor:function(e,r,i){var s=e.endpoint,a=e.config.region,c=e.config.customUserAgent;e.isGlobalEndpoint&&(a="us-east-1"),this.domain=o&&o.active,this.service=e,this.operation=r,this.params=i||{},this.httpRequest=new t.HttpRequest(s,a),this.httpRequest.appendToUserAgent(c),this.startTime=e.getSkewCorrectedDate(),this.response=new t.Response(this),this._asm=new n(u.states,"validate"),this._haltHandlersOnError=!1,t.SequentialExecutor.call(this),this.emit=this.emitEvent},send:function(e){return e&&(this.httpRequest.appendToUserAgent("callback"),this.on("complete",(function(t){e.call(t,t.error,t.data)}))),this.runTo(),this.response},build:function(e){return this.runTo("send",e)},runTo:function(e,t){return this._asm.runTo(e,t,this),this},abort:function(){return this.removeAllListeners("validateResponse"),this.removeAllListeners("extractError"),this.on("validateResponse",(function(e){e.error=t.util.error(new Error("Request aborted by user"),{code:"RequestAbortedError",retryable:!1})})),this.httpRequest.stream&&!this.httpRequest.stream.didCallback&&(this.httpRequest.stream.abort(),this.httpRequest._abortCallback?this.httpRequest._abortCallback():this.removeAllListeners("send")),this},eachPage:function(e){e=t.util.fn.makeAsync(e,3),this.on("complete",(function r(n){e.call(n,n.error,n.data,(function(i){!1!==i&&(n.hasNextPage()?n.nextPage().on("complete",r).send():e.call(n,null,null,t.util.fn.noop))}))})).send()},eachItem:function(e){var r=this;this.eachPage((function(n,i){if(n)return e(n,null);if(null===i)return e(null,null);var o=r.service.paginationConfig(r.operation).resultKey;Array.isArray(o)&&(o=o[0]);var a=s.search(i,o),u=!0;return t.util.arrayEach(a,(function(r){if(!1===(u=e(null,r)))return t.util.abort})),u}))},isPageable:function(){return!!this.service.paginationConfig(this.operation)},createReadStream:function(){var r=t.util.stream,n=this,i=null;return 2===t.HttpClient.streamsApiVersion?(i=new r.PassThrough,e.nextTick((function(){n.send()}))):((i=new r.Stream).readable=!0,i.sent=!1,i.on("newListener",(function(t){i.sent||"data"!==t||(i.sent=!0,e.nextTick((function(){n.send()})))}))),this.on("error",(function(e){i.emit("error",e)})),this.on("httpHeaders",(function(e,o,s){if(e<300){n.removeListener("httpData",t.EventListeners.Core.HTTP_DATA),n.removeListener("httpError",t.EventListeners.Core.HTTP_ERROR),n.on("httpError",(function(e){s.error=e,s.error.retryable=!1}));var a,u=!1;if("HEAD"!==n.httpRequest.method&&(a=parseInt(o["content-length"],10)),void 0!==a&&!isNaN(a)&&a>=0){u=!0;var c=0}var f=function(){u&&c!==a?i.emit("error",t.util.error(new Error("Stream content length mismatch. Received "+c+" of "+a+" bytes."),{code:"StreamContentLengthMismatch"})):2===t.HttpClient.streamsApiVersion?i.end():i.emit("end")},l=s.httpResponse.createUnbufferedStream();if(2===t.HttpClient.streamsApiVersion)if(u){var h=new r.PassThrough;h._write=function(e){return e&&e.length&&(c+=e.length),r.PassThrough.prototype._write.apply(this,arguments)},h.on("end",f),i.on("error",(function(e){u=!1,l.unpipe(h),h.emit("end"),h.end()})),l.pipe(h).pipe(i,{end:!1})}else l.pipe(i);else u&&l.on("data",(function(e){e&&e.length&&(c+=e.length)})),l.on("data",(function(e){i.emit("data",e)})),l.on("end",f);l.on("error",(function(e){u=!1,i.emit("error",e)}))}})),i},emitEvent:function(e,r,n){"function"==typeof r&&(n=r,r=null),n||(n=function(){}),r||(r=this.eventParameters(e,this.response)),t.SequentialExecutor.prototype.emit.call(this,e,r,(function(e){e&&(this.response.error=e),n.call(this,e)}))},eventParameters:function(e){switch(e){case"restart":case"validate":case"sign":case"build":case"afterValidate":case"afterBuild":return[this];case"error":return[this.response.error,this.response];default:return[this.response]}},presign:function(e,r){return r||"function"!=typeof e||(r=e,e=null),(new t.Signers.Presign).sign(this.toGet(),e,r)},isPresigned:function(){return Object.prototype.hasOwnProperty.call(this.httpRequest.headers,"presigned-expires")},toUnauthenticated:function(){return this._unAuthenticated=!0,this.removeListener("validate",t.EventListeners.Core.VALIDATE_CREDENTIALS),this.removeListener("sign",t.EventListeners.Core.SIGN),this},toGet:function(){return"query"!==this.service.api.protocol&&"ec2"!==this.service.api.protocol||(this.removeListener("build",this.buildAsGet),this.addListener("build",this.buildAsGet)),this},buildAsGet:function(e){e.httpRequest.method="GET",e.httpRequest.path=e.service.endpoint.path+"?"+e.httpRequest.body,e.httpRequest.body="",delete e.httpRequest.headers["Content-Length"],delete e.httpRequest.headers["Content-Type"]},haltHandlersOnError:function(){this._haltHandlersOnError=!0}}),t.Request.addPromisesToClass=function(e){this.prototype.promise=function(){var t=this;return this.httpRequest.appendToUserAgent("promise"),new e((function(e,r){t.on("complete",(function(t){t.error?r(t.error):e(Object.defineProperty(t.data||{},"$response",{value:t}))})),t.runTo()}))}},t.Request.deletePromisesFromClass=function(){delete this.prototype.promise},t.util.addPromises(t.Request),t.util.mixin(t.Request,t.SequentialExecutor)}).call(this,r(5))},function(e,t){function r(e,t){this.currentState=t||null,this.states=e||{}}r.prototype.runTo=function(e,t,r,n){"function"==typeof e&&(n=r,r=t,t=e,e=null);var i=this,o=i.states[i.currentState];o.fn.call(r||i,n,(function(n){if(n){if(!o.fail)return t?t.call(r,n):null;i.currentState=o.fail}else{if(!o.accept)return t?t.call(r):null;i.currentState=o.accept}if(i.currentState===e)return t?t.call(r,n):null;i.runTo(e,t,r,n)}))},r.prototype.addState=function(e,t,r,n){return"function"==typeof t?(n=t,t=null,r=null):"function"==typeof r&&(n=r,r=null),this.currentState||(this.currentState=e),this.states[e]={accept:t,fail:r,fn:n},this},e.exports=r},function(e,t,r){var n=r(1),i=n.util.inherit,o=r(18);n.Response=i({constructor:function(e){this.request=e,this.data=null,this.error=null,this.retryCount=0,this.redirectCount=0,this.httpResponse=new n.HttpResponse,e&&(this.maxRetries=e.service.numRetries(),this.maxRedirects=e.service.config.maxRedirects)},nextPage:function(e){var t,r=this.request.service,i=this.request.operation;try{t=r.paginationConfig(i,!0)}catch(e){this.error=e}if(!this.hasNextPage()){if(e)e(this.error,null);else if(this.error)throw this.error;return null}var o=n.util.copy(this.request.params);if(this.nextPageTokens){var s=t.inputToken;"string"==typeof s&&(s=[s]);for(var a=0;a<s.length;a++)o[s[a]]=this.nextPageTokens[a];return r.makeRequest(this.request.operation,o,e)}return e?e(null,null):null},hasNextPage:function(){return this.cacheNextPageTokens(),!!this.nextPageTokens||void 0===this.nextPageTokens&&void 0},cacheNextPageTokens:function(){if(Object.prototype.hasOwnProperty.call(this,"nextPageTokens"))return this.nextPageTokens;this.nextPageTokens=void 0;var e=this.request.service.paginationConfig(this.request.operation);if(!e)return this.nextPageTokens;if(this.nextPageTokens=null,e.moreResults&&!o.search(this.data,e.moreResults))return this.nextPageTokens;var t=e.outputToken;return"string"==typeof t&&(t=[t]),n.util.arrayEach.call(this,t,(function(e){var t=o.search(this.data,e);t&&(this.nextPageTokens=this.nextPageTokens||[],this.nextPageTokens.push(t))})),this.nextPageTokens}})},function(e,t,r){var n=r(1),i=n.util.inherit,o=r(18);function s(e){var t=e.request._waiter,r=t.config.acceptors,n=!1,i="retry";r.forEach((function(r){if(!n){var o=t.matchers[r.matcher];o&&o(e,r.expected,r.argument)&&(n=!0,i=r.state)}})),!n&&e.error&&(i="failure"),"success"===i?t.setSuccess(e):t.setError(e,"retry"===i)}n.ResourceWaiter=i({constructor:function(e,t){this.service=e,this.state=t,this.loadWaiterConfig(this.state)},service:null,state:null,config:null,matchers:{path:function(e,t,r){try{var n=o.search(e.data,r)}catch(e){return!1}return o.strictDeepEqual(n,t)},pathAll:function(e,t,r){try{var n=o.search(e.data,r)}catch(e){return!1}Array.isArray(n)||(n=[n]);var i=n.length;if(!i)return!1;for(var s=0;s<i;s++)if(!o.strictDeepEqual(n[s],t))return!1;return!0},pathAny:function(e,t,r){try{var n=o.search(e.data,r)}catch(e){return!1}Array.isArray(n)||(n=[n]);for(var i=n.length,s=0;s<i;s++)if(o.strictDeepEqual(n[s],t))return!0;return!1},status:function(e,t){var r=e.httpResponse.statusCode;return"number"==typeof r&&r===t},error:function(e,t){return"string"==typeof t&&e.error?t===e.error.code:t===!!e.error}},listeners:(new n.SequentialExecutor).addNamedListeners((function(e){e("RETRY_CHECK","retry",(function(e){var t=e.request._waiter;e.error&&"ResourceNotReady"===e.error.code&&(e.error.retryDelay=1e3*(t.config.delay||0))})),e("CHECK_OUTPUT","extractData",s),e("CHECK_ERROR","extractError",s)})),wait:function(e,t){"function"==typeof e&&(t=e,e=void 0),e&&e.$waiter&&("number"==typeof(e=n.util.copy(e)).$waiter.delay&&(this.config.delay=e.$waiter.delay),"number"==typeof e.$waiter.maxAttempts&&(this.config.maxAttempts=e.$waiter.maxAttempts),delete e.$waiter);var r=this.service.makeRequest(this.config.operation,e);return r._waiter=this,r.response.maxRetries=this.config.maxAttempts,r.addListeners(this.listeners),t&&r.send(t),r},setSuccess:function(e){e.error=null,e.data=e.data||{},e.request.removeAllListeners("extractData")},setError:function(e,t){e.data=null,e.error=n.util.error(e.error||new Error,{code:"ResourceNotReady",message:"Resource is not in the state "+this.state,retryable:t})},loadWaiterConfig:function(e){if(!this.service.api.waiters[e])throw new n.util.error(new Error,{code:"StateNotFoundError",message:"State "+e+" not found."});this.config=n.util.copy(this.service.api.waiters[e])}})},function(e,t,r){var n=r(1),i=n.util.inherit;n.Signers.RequestSigner=i({constructor:function(e){this.request=e},setServiceClientId:function(e){this.serviceClientId=e},getServiceClientId:function(){return this.serviceClientId}}),n.Signers.RequestSigner.getVersion=function(e){switch(e){case"v2":return n.Signers.V2;case"v3":return n.Signers.V3;case"s3v4":case"v4":return n.Signers.V4;case"s3":return n.Signers.S3;case"v3https":return n.Signers.V3Https}throw new Error("Unknown signing version "+e)},r(68),r(32),r(69),r(70),r(72),r(73)},function(e,t,r){var n=r(1),i=n.util.inherit;n.Signers.V2=i(n.Signers.RequestSigner,{addAuthorization:function(e,t){t||(t=n.util.date.getDate());var r=this.request;r.params.Timestamp=n.util.date.iso8601(t),r.params.SignatureVersion="2",r.params.SignatureMethod="HmacSHA256",r.params.AWSAccessKeyId=e.accessKeyId,e.sessionToken&&(r.params.SecurityToken=e.sessionToken),delete r.params.Signature,r.params.Signature=this.signature(e),r.body=n.util.queryParamsToString(r.params),r.headers["Content-Length"]=r.body.length},signature:function(e){return n.util.crypto.hmac(e.secretAccessKey,this.stringToSign(),"base64")},stringToSign:function(){var e=[];return e.push(this.request.method),e.push(this.request.endpoint.host.toLowerCase()),e.push(this.request.pathname()),e.push(n.util.queryParamsToString(this.request.params)),e.join("\n")}}),e.exports=n.Signers.V2},function(e,t,r){var n=r(1),i=n.util.inherit;r(32),n.Signers.V3Https=i(n.Signers.V3,{authorization:function(e){return"AWS3-HTTPS AWSAccessKeyId="+e.accessKeyId+",Algorithm=HmacSHA256,Signature="+this.signature(e)},stringToSign:function(){return this.request.headers["X-Amz-Date"]}}),e.exports=n.Signers.V3Https},function(e,t,r){var n=r(1),i=r(71),o=n.util.inherit;n.Signers.V4=o(n.Signers.RequestSigner,{constructor:function(e,t,r){n.Signers.RequestSigner.call(this,e),this.serviceName=t,r=r||{},this.signatureCache="boolean"!=typeof r.signatureCache||r.signatureCache,this.operation=r.operation,this.signatureVersion=r.signatureVersion},algorithm:"AWS4-HMAC-SHA256",addAuthorization:function(e,t){var r=n.util.date.iso8601(t).replace(/[:\-]|\.\d{3}/g,"");this.isPresigned()?this.updateForPresigned(e,r):this.addHeaders(e,r),this.request.headers.Authorization=this.authorization(e,r)},addHeaders:function(e,t){this.request.headers["X-Amz-Date"]=t,e.sessionToken&&(this.request.headers["x-amz-security-token"]=e.sessionToken)},updateForPresigned:function(e,t){var r=this.credentialString(t),i={"X-Amz-Date":t,"X-Amz-Algorithm":this.algorithm,"X-Amz-Credential":e.accessKeyId+"/"+r,"X-Amz-Expires":this.request.headers["presigned-expires"],"X-Amz-SignedHeaders":this.signedHeaders()};e.sessionToken&&(i["X-Amz-Security-Token"]=e.sessionToken),this.request.headers["Content-Type"]&&(i["Content-Type"]=this.request.headers["Content-Type"]),this.request.headers["Content-MD5"]&&(i["Content-MD5"]=this.request.headers["Content-MD5"]),this.request.headers["Cache-Control"]&&(i["Cache-Control"]=this.request.headers["Cache-Control"]),n.util.each.call(this,this.request.headers,(function(e,t){if("presigned-expires"!==e&&this.isSignableHeader(e)){var r=e.toLowerCase();0===r.indexOf("x-amz-meta-")?i[r]=t:0===r.indexOf("x-amz-")&&(i[e]=t)}}));var o=this.request.path.indexOf("?")>=0?"&":"?";this.request.path+=o+n.util.queryParamsToString(i)},authorization:function(e,t){var r=[],n=this.credentialString(t);return r.push(this.algorithm+" Credential="+e.accessKeyId+"/"+n),r.push("SignedHeaders="+this.signedHeaders()),r.push("Signature="+this.signature(e,t)),r.join(", ")},signature:function(e,t){var r=i.getSigningKey(e,t.substr(0,8),this.request.region,this.serviceName,this.signatureCache);return n.util.crypto.hmac(r,this.stringToSign(t),"hex")},stringToSign:function(e){var t=[];return t.push("AWS4-HMAC-SHA256"),t.push(e),t.push(this.credentialString(e)),t.push(this.hexEncodedHash(this.canonicalString())),t.join("\n")},canonicalString:function(){var e=[],t=this.request.pathname();return"s3"!==this.serviceName&&"s3v4"!==this.signatureVersion&&(t=n.util.uriEscapePath(t)),e.push(this.request.method),e.push(t),e.push(this.request.search()),e.push(this.canonicalHeaders()+"\n"),e.push(this.signedHeaders()),e.push(this.hexEncodedBodyHash()),e.join("\n")},canonicalHeaders:function(){var e=[];n.util.each.call(this,this.request.headers,(function(t,r){e.push([t,r])})),e.sort((function(e,t){return e[0].toLowerCase()<t[0].toLowerCase()?-1:1}));var t=[];return n.util.arrayEach.call(this,e,(function(e){var r=e[0].toLowerCase();if(this.isSignableHeader(r)){var i=e[1];if(null==i||"function"!=typeof i.toString)throw n.util.error(new Error("Header "+r+" contains invalid value"),{code:"InvalidHeader"});t.push(r+":"+this.canonicalHeaderValues(i.toString()))}})),t.join("\n")},canonicalHeaderValues:function(e){return e.replace(/\s+/g," ").replace(/^\s+|\s+$/g,"")},signedHeaders:function(){var e=[];return n.util.each.call(this,this.request.headers,(function(t){t=t.toLowerCase(),this.isSignableHeader(t)&&e.push(t)})),e.sort().join(";")},credentialString:function(e){return i.createScope(e.substr(0,8),this.request.region,this.serviceName)},hexEncodedHash:function(e){return n.util.crypto.sha256(e,"hex")},hexEncodedBodyHash:function(){var e=this.request;return this.isPresigned()&&"s3"===this.serviceName&&!e.body?"UNSIGNED-PAYLOAD":e.headers["X-Amz-Content-Sha256"]?e.headers["X-Amz-Content-Sha256"]:this.hexEncodedHash(this.request.body||"")},unsignableHeaders:["authorization","content-type","content-length","user-agent","presigned-expires","expect","x-amzn-trace-id"],isSignableHeader:function(e){return 0===e.toLowerCase().indexOf("x-amz-")||this.unsignableHeaders.indexOf(e)<0},isPresigned:function(){return!!this.request.headers["presigned-expires"]}}),e.exports=n.Signers.V4},function(e,t,r){var n=r(1),i={},o=[],s="aws4_request";e.exports={createScope:function(e,t,r){return[e.substr(0,8),t,r,s].join("/")},getSigningKey:function(e,t,r,a,u){var c=[n.util.crypto.hmac(e.secretAccessKey,e.accessKeyId,"base64"),t,r,a].join("_");if((u=!1!==u)&&c in i)return i[c];var f=n.util.crypto.hmac("AWS4"+e.secretAccessKey,t,"buffer"),l=n.util.crypto.hmac(f,r,"buffer"),h=n.util.crypto.hmac(l,a,"buffer"),p=n.util.crypto.hmac(h,s,"buffer");return u&&(i[c]=p,o.push(c),o.length>50&&delete i[o.shift()]),p},emptyCache:function(){i={},o=[]}}},function(e,t,r){var n=r(1),i=n.util.inherit;n.Signers.S3=i(n.Signers.RequestSigner,{subResources:{acl:1,accelerate:1,analytics:1,cors:1,lifecycle:1,delete:1,inventory:1,location:1,logging:1,metrics:1,notification:1,partNumber:1,policy:1,requestPayment:1,replication:1,restore:1,tagging:1,torrent:1,uploadId:1,uploads:1,versionId:1,versioning:1,versions:1,website:1},responseHeaders:{"response-content-type":1,"response-content-language":1,"response-expires":1,"response-cache-control":1,"response-content-disposition":1,"response-content-encoding":1},addAuthorization:function(e,t){this.request.headers["presigned-expires"]||(this.request.headers["X-Amz-Date"]=n.util.date.rfc822(t)),e.sessionToken&&(this.request.headers["x-amz-security-token"]=e.sessionToken);var r=this.sign(e.secretAccessKey,this.stringToSign()),i="AWS "+e.accessKeyId+":"+r;this.request.headers.Authorization=i},stringToSign:function(){var e=this.request,t=[];t.push(e.method),t.push(e.headers["Content-MD5"]||""),t.push(e.headers["Content-Type"]||""),t.push(e.headers["presigned-expires"]||"");var r=this.canonicalizedAmzHeaders();return r&&t.push(r),t.push(this.canonicalizedResource()),t.join("\n")},canonicalizedAmzHeaders:function(){var e=[];n.util.each(this.request.headers,(function(t){t.match(/^x-amz-/i)&&e.push(t)})),e.sort((function(e,t){return e.toLowerCase()<t.toLowerCase()?-1:1}));var t=[];return n.util.arrayEach.call(this,e,(function(e){t.push(e.toLowerCase()+":"+String(this.request.headers[e]))})),t.join("\n")},canonicalizedResource:function(){var e=this.request,t=e.path.split("?"),r=t[0],i=t[1],o="";if(e.virtualHostedBucket&&(o+="/"+e.virtualHostedBucket),o+=r,i){var s=[];n.util.arrayEach.call(this,i.split("&"),(function(e){var t=e.split("=")[0],r=e.split("=")[1];if(this.subResources[t]||this.responseHeaders[t]){var n={name:t};void 0!==r&&(this.subResources[t]?n.value=r:n.value=decodeURIComponent(r)),s.push(n)}})),s.sort((function(e,t){return e.name<t.name?-1:1})),s.length&&(i=[],n.util.arrayEach(s,(function(e){void 0===e.value?i.push(e.name):i.push(e.name+"="+e.value)})),o+="?"+i.join("&"))}return o},sign:function(e,t){return n.util.crypto.hmac(e,t,"base64","sha1")}}),e.exports=n.Signers.S3},function(e,t,r){var n=r(1),i=n.util.inherit,o="presigned-expires";function s(e){var t=e.httpRequest.headers[o],r=e.service.getSignerClass(e);if(delete e.httpRequest.headers["User-Agent"],delete e.httpRequest.headers["X-Amz-User-Agent"],r===n.Signers.V4){if(t>604800){throw n.util.error(new Error,{code:"InvalidExpiryTime",message:"Presigning does not support expiry time greater than a week with SigV4 signing.",retryable:!1})}e.httpRequest.headers[o]=t}else{if(r!==n.Signers.S3)throw n.util.error(new Error,{message:"Presigning only supports S3 or SigV4 signing.",code:"UnsupportedSigner",retryable:!1});var i=e.service?e.service.getSkewCorrectedDate():n.util.date.getDate();e.httpRequest.headers[o]=parseInt(n.util.date.unixTimestamp(i)+t,10).toString()}}function a(e){var t=e.httpRequest.endpoint,r=n.util.urlParse(e.httpRequest.path),i={};r.search&&(i=n.util.queryStringParse(r.search.substr(1)));var s=e.httpRequest.headers.Authorization.split(" ");if("AWS"===s[0])s=s[1].split(":"),i.AWSAccessKeyId=s[0],i.Signature=s[1],n.util.each(e.httpRequest.headers,(function(e,t){e===o&&(e="Expires"),0===e.indexOf("x-amz-meta-")&&(delete i[e],e=e.toLowerCase()),i[e]=t})),delete e.httpRequest.headers[o],delete i.Authorization,delete i.Host;else if("AWS4-HMAC-SHA256"===s[0]){s.shift();var a=s.join(" ").match(/Signature=(.*?)(?:,|\s|\r?\n|$)/)[1];i["X-Amz-Signature"]=a,delete i.Expires}t.pathname=r.pathname,t.search=n.util.queryParamsToString(i)}n.Signers.Presign=i({sign:function(e,t,r){if(e.httpRequest.headers[o]=t||3600,e.on("build",s),e.on("sign",a),e.removeListener("afterBuild",n.EventListeners.Core.SET_CONTENT_LENGTH),e.removeListener("afterBuild",n.EventListeners.Core.COMPUTE_SHA256),e.emit("beforePresign",[e]),!r){if(e.build(),e.response.error)throw e.response.error;return n.util.urlFormat(e.httpRequest.endpoint)}e.build((function(){this.response.error?r(this.response.error):r(null,n.util.urlFormat(e.httpRequest.endpoint))}))}}),e.exports=n.Signers.Presign},function(e,t,r){var n=r(1);n.ParamValidator=n.util.inherit({constructor:function(e){!0!==e&&void 0!==e||(e={min:!0}),this.validation=e},validate:function(e,t,r){if(this.errors=[],this.validateMember(e,t||{},r||"params"),this.errors.length>1){var i=this.errors.join("\n* ");throw i="There were "+this.errors.length+" validation errors:\n* "+i,n.util.error(new Error(i),{code:"MultipleValidationErrors",errors:this.errors})}if(1===this.errors.length)throw this.errors[0];return!0},fail:function(e,t){this.errors.push(n.util.error(new Error(t),{code:e}))},validateStructure:function(e,t,r){var n;this.validateType(t,r,["object"],"structure");for(var i=0;e.required&&i<e.required.length;i++){var o=t[n=e.required[i]];null==o&&this.fail("MissingRequiredParameter","Missing required key '"+n+"' in "+r)}for(n in t)if(Object.prototype.hasOwnProperty.call(t,n)){var s=t[n],a=e.members[n];if(void 0!==a){var u=[r,n].join(".");this.validateMember(a,s,u)}else this.fail("UnexpectedParameter","Unexpected key '"+n+"' found in "+r)}return!0},validateMember:function(e,t,r){switch(e.type){case"structure":return this.validateStructure(e,t,r);case"list":return this.validateList(e,t,r);case"map":return this.validateMap(e,t,r);default:return this.validateScalar(e,t,r)}},validateList:function(e,t,r){if(this.validateType(t,r,[Array])){this.validateRange(e,t.length,r,"list member count");for(var n=0;n<t.length;n++)this.validateMember(e.member,t[n],r+"["+n+"]")}},validateMap:function(e,t,r){if(this.validateType(t,r,["object"],"map")){var n=0;for(var i in t)Object.prototype.hasOwnProperty.call(t,i)&&(this.validateMember(e.key,i,r+"[key='"+i+"']"),this.validateMember(e.value,t[i],r+"['"+i+"']"),n++);this.validateRange(e,n,r,"map member count")}},validateScalar:function(e,t,r){switch(e.type){case null:case void 0:case"string":return this.validateString(e,t,r);case"base64":case"binary":return this.validatePayload(t,r);case"integer":case"float":return this.validateNumber(e,t,r);case"boolean":return this.validateType(t,r,["boolean"]);case"timestamp":return this.validateType(t,r,[Date,/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/,"number"],"Date object, ISO-8601 string, or a UNIX timestamp");default:return this.fail("UnkownType","Unhandled type "+e.type+" for "+r)}},validateString:function(e,t,r){var n=["string"];e.isJsonValue&&(n=n.concat(["number","object","boolean"])),null!==t&&this.validateType(t,r,n)&&(this.validateEnum(e,t,r),this.validateRange(e,t.length,r,"string length"),this.validatePattern(e,t,r),this.validateUri(e,t,r))},validateUri:function(e,t,r){"uri"===e.location&&0===t.length&&this.fail("UriParameterError",'Expected uri parameter to have length >= 1, but found "'+t+'" for '+r)},validatePattern:function(e,t,r){this.validation.pattern&&void 0!==e.pattern&&(new RegExp(e.pattern).test(t)||this.fail("PatternMatchError",'Provided value "'+t+'" does not match regex pattern /'+e.pattern+"/ for "+r))},validateRange:function(e,t,r,n){this.validation.min&&void 0!==e.min&&t<e.min&&this.fail("MinRangeError","Expected "+n+" >= "+e.min+", but found "+t+" for "+r),this.validation.max&&void 0!==e.max&&t>e.max&&this.fail("MaxRangeError","Expected "+n+" <= "+e.max+", but found "+t+" for "+r)},validateEnum:function(e,t,r){this.validation.enum&&void 0!==e.enum&&-1===e.enum.indexOf(t)&&this.fail("EnumError","Found string value of "+t+", but expected "+e.enum.join("|")+" for "+r)},validateType:function(e,t,r,i){if(null==e)return!1;for(var o=!1,s=0;s<r.length;s++){if("string"==typeof r[s]){if(typeof e===r[s])return!0}else if(r[s]instanceof RegExp){if((e||"").toString().match(r[s]))return!0}else{if(e instanceof r[s])return!0;if(n.util.isType(e,r[s]))return!0;i||o||(r=r.slice()),r[s]=n.util.typeName(r[s])}o=!0}var a=i;a||(a=r.join(", ").replace(/,([^,]+)$/,", or$1"));var u=a.match(/^[aeiou]/i)?"n":"";return this.fail("InvalidParameterType","Expected "+t+" to be a"+u+" "+a),!1},validateNumber:function(e,t,r){if(null!=t){if("string"==typeof t){var n=parseFloat(t);n.toString()===t&&(t=n)}this.validateType(t,r,["number"])&&this.validateRange(e,t,r,"numeric value")}},validatePayload:function(e,t){if(null!=e&&"string"!=typeof e&&(!e||"number"!=typeof e.byteLength)){if(n.util.isNode()){var r=n.util.stream.Stream;if(n.util.Buffer.isBuffer(e)||e instanceof r)return}else if(void 0!==typeof Blob&&e instanceof Blob)return;var i=["Buffer","Stream","File","Blob","ArrayBuffer","DataView"];if(e)for(var o=0;o<i.length;o++){if(n.util.isType(e,i[o]))return;if(n.util.typeName(e.constructor)===i[o])return}this.fail("InvalidParameterType","Expected "+t+" to be a string, Buffer, Stream, Blob, or typed array object")}}})},function(e){e.exports=JSON.parse('{"acm":{"name":"ACM","cors":true},"apigateway":{"name":"APIGateway","cors":true},"applicationautoscaling":{"prefix":"application-autoscaling","name":"ApplicationAutoScaling","cors":true},"appstream":{"name":"AppStream"},"autoscaling":{"name":"AutoScaling","cors":true},"batch":{"name":"Batch"},"budgets":{"name":"Budgets"},"clouddirectory":{"name":"CloudDirectory","versions":["2016-05-10*"]},"cloudformation":{"name":"CloudFormation","cors":true},"cloudfront":{"name":"CloudFront","versions":["2013-05-12*","2013-11-11*","2014-05-31*","2014-10-21*","2014-11-06*","2015-04-17*","2015-07-27*","2015-09-17*","2016-01-13*","2016-01-28*","2016-08-01*","2016-08-20*","2016-09-07*","2016-09-29*","2016-11-25*","2017-03-25*","2017-10-30*","2018-06-18*","2018-11-05*"],"cors":true},"cloudhsm":{"name":"CloudHSM","cors":true},"cloudsearch":{"name":"CloudSearch"},"cloudsearchdomain":{"name":"CloudSearchDomain"},"cloudtrail":{"name":"CloudTrail","cors":true},"cloudwatch":{"prefix":"monitoring","name":"CloudWatch","cors":true},"cloudwatchevents":{"prefix":"events","name":"CloudWatchEvents","versions":["2014-02-03*"],"cors":true},"cloudwatchlogs":{"prefix":"logs","name":"CloudWatchLogs","cors":true},"codebuild":{"name":"CodeBuild","cors":true},"codecommit":{"name":"CodeCommit","cors":true},"codedeploy":{"name":"CodeDeploy","cors":true},"codepipeline":{"name":"CodePipeline","cors":true},"cognitoidentity":{"prefix":"cognito-identity","name":"CognitoIdentity","cors":true},"cognitoidentityserviceprovider":{"prefix":"cognito-idp","name":"CognitoIdentityServiceProvider","cors":true},"cognitosync":{"prefix":"cognito-sync","name":"CognitoSync","cors":true},"configservice":{"prefix":"config","name":"ConfigService","cors":true},"cur":{"name":"CUR","cors":true},"datapipeline":{"name":"DataPipeline"},"devicefarm":{"name":"DeviceFarm","cors":true},"directconnect":{"name":"DirectConnect","cors":true},"directoryservice":{"prefix":"ds","name":"DirectoryService"},"discovery":{"name":"Discovery"},"dms":{"name":"DMS"},"dynamodb":{"name":"DynamoDB","cors":true},"dynamodbstreams":{"prefix":"streams.dynamodb","name":"DynamoDBStreams","cors":true},"ec2":{"name":"EC2","versions":["2013-06-15*","2013-10-15*","2014-02-01*","2014-05-01*","2014-06-15*","2014-09-01*","2014-10-01*","2015-03-01*","2015-04-15*","2015-10-01*","2016-04-01*","2016-09-15*"],"cors":true},"ecr":{"name":"ECR","cors":true},"ecs":{"name":"ECS","cors":true},"efs":{"prefix":"elasticfilesystem","name":"EFS","cors":true},"elasticache":{"name":"ElastiCache","versions":["2012-11-15*","2014-03-24*","2014-07-15*","2014-09-30*"],"cors":true},"elasticbeanstalk":{"name":"ElasticBeanstalk","cors":true},"elb":{"prefix":"elasticloadbalancing","name":"ELB","cors":true},"elbv2":{"prefix":"elasticloadbalancingv2","name":"ELBv2","cors":true},"emr":{"prefix":"elasticmapreduce","name":"EMR","cors":true},"es":{"name":"ES"},"elastictranscoder":{"name":"ElasticTranscoder","cors":true},"firehose":{"name":"Firehose","cors":true},"gamelift":{"name":"GameLift","cors":true},"glacier":{"name":"Glacier"},"health":{"name":"Health"},"iam":{"name":"IAM","cors":true},"importexport":{"name":"ImportExport"},"inspector":{"name":"Inspector","versions":["2015-08-18*"],"cors":true},"iot":{"name":"Iot","cors":true},"iotdata":{"prefix":"iot-data","name":"IotData","cors":true},"kinesis":{"name":"Kinesis","cors":true},"kinesisanalytics":{"name":"KinesisAnalytics"},"kms":{"name":"KMS","cors":true},"lambda":{"name":"Lambda","cors":true},"lexruntime":{"prefix":"runtime.lex","name":"LexRuntime","cors":true},"lightsail":{"name":"Lightsail"},"machinelearning":{"name":"MachineLearning","cors":true},"marketplacecommerceanalytics":{"name":"MarketplaceCommerceAnalytics","cors":true},"marketplacemetering":{"prefix":"meteringmarketplace","name":"MarketplaceMetering"},"mturk":{"prefix":"mturk-requester","name":"MTurk","cors":true},"mobileanalytics":{"name":"MobileAnalytics","cors":true},"opsworks":{"name":"OpsWorks","cors":true},"opsworkscm":{"name":"OpsWorksCM"},"organizations":{"name":"Organizations"},"pinpoint":{"name":"Pinpoint"},"polly":{"name":"Polly","cors":true},"rds":{"name":"RDS","versions":["2014-09-01*"],"cors":true},"redshift":{"name":"Redshift","cors":true},"rekognition":{"name":"Rekognition","cors":true},"resourcegroupstaggingapi":{"name":"ResourceGroupsTaggingAPI"},"route53":{"name":"Route53","cors":true},"route53domains":{"name":"Route53Domains","cors":true},"s3":{"name":"S3","dualstackAvailable":true,"cors":true},"s3control":{"name":"S3Control","dualstackAvailable":true},"servicecatalog":{"name":"ServiceCatalog","cors":true},"ses":{"prefix":"email","name":"SES","cors":true},"shield":{"name":"Shield"},"simpledb":{"prefix":"sdb","name":"SimpleDB"},"sms":{"name":"SMS"},"snowball":{"name":"Snowball"},"sns":{"name":"SNS","cors":true},"sqs":{"name":"SQS","cors":true},"ssm":{"name":"SSM","cors":true},"storagegateway":{"name":"StorageGateway","cors":true},"stepfunctions":{"prefix":"states","name":"StepFunctions"},"sts":{"name":"STS","cors":true},"support":{"name":"Support"},"swf":{"name":"SWF"},"xray":{"name":"XRay"},"waf":{"name":"WAF","cors":true},"wafregional":{"prefix":"waf-regional","name":"WAFRegional"},"workdocs":{"name":"WorkDocs","cors":true},"workspaces":{"name":"WorkSpaces"},"codestar":{"name":"CodeStar"},"lexmodelbuildingservice":{"prefix":"lex-models","name":"LexModelBuildingService","cors":true},"marketplaceentitlementservice":{"prefix":"entitlement.marketplace","name":"MarketplaceEntitlementService"},"athena":{"name":"Athena"},"greengrass":{"name":"Greengrass"},"dax":{"name":"DAX"},"migrationhub":{"prefix":"AWSMigrationHub","name":"MigrationHub"},"cloudhsmv2":{"name":"CloudHSMV2"},"glue":{"name":"Glue"},"mobile":{"name":"Mobile"},"pricing":{"name":"Pricing","cors":true},"costexplorer":{"prefix":"ce","name":"CostExplorer","cors":true},"mediaconvert":{"name":"MediaConvert"},"medialive":{"name":"MediaLive"},"mediapackage":{"name":"MediaPackage"},"mediastore":{"name":"MediaStore"},"mediastoredata":{"prefix":"mediastore-data","name":"MediaStoreData","cors":true},"appsync":{"name":"AppSync"},"guardduty":{"name":"GuardDuty"},"mq":{"name":"MQ"},"comprehend":{"name":"Comprehend","cors":true},"iotjobsdataplane":{"prefix":"iot-jobs-data","name":"IoTJobsDataPlane"},"kinesisvideoarchivedmedia":{"prefix":"kinesis-video-archived-media","name":"KinesisVideoArchivedMedia","cors":true},"kinesisvideomedia":{"prefix":"kinesis-video-media","name":"KinesisVideoMedia","cors":true},"kinesisvideo":{"name":"KinesisVideo","cors":true},"sagemakerruntime":{"prefix":"runtime.sagemaker","name":"SageMakerRuntime"},"sagemaker":{"name":"SageMaker"},"translate":{"name":"Translate","cors":true},"resourcegroups":{"prefix":"resource-groups","name":"ResourceGroups","cors":true},"alexaforbusiness":{"name":"AlexaForBusiness"},"cloud9":{"name":"Cloud9"},"serverlessapplicationrepository":{"prefix":"serverlessrepo","name":"ServerlessApplicationRepository"},"servicediscovery":{"name":"ServiceDiscovery"},"workmail":{"name":"WorkMail"},"autoscalingplans":{"prefix":"autoscaling-plans","name":"AutoScalingPlans"},"transcribeservice":{"prefix":"transcribe","name":"TranscribeService"},"connect":{"name":"Connect"},"acmpca":{"prefix":"acm-pca","name":"ACMPCA"},"fms":{"name":"FMS"},"secretsmanager":{"name":"SecretsManager","cors":true},"iotanalytics":{"name":"IoTAnalytics"},"iot1clickdevicesservice":{"prefix":"iot1click-devices","name":"IoT1ClickDevicesService"},"iot1clickprojects":{"prefix":"iot1click-projects","name":"IoT1ClickProjects"},"pi":{"name":"PI"},"neptune":{"name":"Neptune"},"mediatailor":{"name":"MediaTailor"},"eks":{"name":"EKS"},"macie":{"name":"Macie"},"dlm":{"name":"DLM"},"signer":{"name":"Signer"},"chime":{"name":"Chime"},"pinpointemail":{"prefix":"pinpoint-email","name":"PinpointEmail"},"ram":{"name":"RAM"},"route53resolver":{"name":"Route53Resolver"},"pinpointsmsvoice":{"prefix":"sms-voice","name":"PinpointSMSVoice"},"quicksight":{"name":"QuickSight"},"rdsdataservice":{"prefix":"rds-data","name":"RDSDataService"},"amplify":{"name":"Amplify"},"datasync":{"name":"DataSync"},"robomaker":{"name":"RoboMaker"},"transfer":{"name":"Transfer"},"globalaccelerator":{"name":"GlobalAccelerator"},"comprehendmedical":{"name":"ComprehendMedical","cors":true},"kinesisanalyticsv2":{"name":"KinesisAnalyticsV2"},"mediaconnect":{"name":"MediaConnect"},"fsx":{"name":"FSx"},"securityhub":{"name":"SecurityHub"},"appmesh":{"name":"AppMesh","versions":["2018-10-01*"]},"licensemanager":{"prefix":"license-manager","name":"LicenseManager"},"kafka":{"name":"Kafka"},"apigatewaymanagementapi":{"name":"ApiGatewayManagementApi"},"apigatewayv2":{"name":"ApiGatewayV2"},"docdb":{"name":"DocDB"},"backup":{"name":"Backup"},"worklink":{"name":"WorkLink"},"textract":{"name":"Textract"},"managedblockchain":{"name":"ManagedBlockchain"},"mediapackagevod":{"prefix":"mediapackage-vod","name":"MediaPackageVod"},"groundstation":{"name":"GroundStation"},"iotthingsgraph":{"name":"IoTThingsGraph"},"iotevents":{"name":"IoTEvents"},"ioteventsdata":{"prefix":"iotevents-data","name":"IoTEventsData"},"personalize":{"name":"Personalize","cors":true},"personalizeevents":{"prefix":"personalize-events","name":"PersonalizeEvents","cors":true},"personalizeruntime":{"prefix":"personalize-runtime","name":"PersonalizeRuntime","cors":true},"applicationinsights":{"prefix":"application-insights","name":"ApplicationInsights"},"servicequotas":{"prefix":"service-quotas","name":"ServiceQuotas"},"ec2instanceconnect":{"prefix":"ec2-instance-connect","name":"EC2InstanceConnect"},"eventbridge":{"name":"EventBridge"},"lakeformation":{"name":"LakeFormation"},"forecastservice":{"prefix":"forecast","name":"ForecastService"},"forecastqueryservice":{"prefix":"forecastquery","name":"ForecastQueryService"}}')},function(e,t,r){var n=r(77),i=r(78),o=i;o.v1=n,o.v4=i,e.exports=o},function(e,t,r){var n,i,o=r(33),s=r(34),a=0,u=0;e.exports=function(e,t,r){var c=t&&r||0,f=t||[],l=(e=e||{}).node||n,h=void 0!==e.clockseq?e.clockseq:i;if(null==l||null==h){var p=o();null==l&&(l=n=[1|p[0],p[1],p[2],p[3],p[4],p[5]]),null==h&&(h=i=16383&(p[6]<<8|p[7]))}var d=void 0!==e.msecs?e.msecs:(new Date).getTime(),v=void 0!==e.nsecs?e.nsecs:u+1,m=d-a+(v-u)/1e4;if(m<0&&void 0===e.clockseq&&(h=h+1&16383),(m<0||d>a)&&void 0===e.nsecs&&(v=0),v>=1e4)throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");a=d,u=v,i=h;var g=(1e4*(268435455&(d+=122192928e5))+v)%4294967296;f[c++]=g>>>24&255,f[c++]=g>>>16&255,f[c++]=g>>>8&255,f[c++]=255&g;var y=d/4294967296*1e4&268435455;f[c++]=y>>>8&255,f[c++]=255&y,f[c++]=y>>>24&15|16,f[c++]=y>>>16&255,f[c++]=h>>>8|128,f[c++]=255&h;for(var b=0;b<6;++b)f[c+b]=l[b];return t||s(f)}},function(e,t,r){var n=r(33),i=r(34);e.exports=function(e,t,r){var o=t&&r||0;"string"==typeof e&&(t="binary"===e?new Array(16):null,e=null);var s=(e=e||{}).random||(e.rng||n)();if(s[6]=15&s[6]|64,s[8]=63&s[8]|128,t)for(var a=0;a<16;++a)t[o+a]=s[a];return t||i(s)}},function(e,t,r){var n=r(80),i=r(84),o=r(85),s=r(86);e.exports={createHash:function(e){if("md5"===(e=e.toLowerCase()))return new i;if("sha256"===e)return new s;if("sha1"===e)return new o;throw new Error("Hash algorithm "+e+" is not supported in the browser SDK")},createHmac:function(e,t){if("md5"===(e=e.toLowerCase()))return new n(i,t);if("sha256"===e)return new n(s,t);if("sha1"===e)return new n(o,t);throw new Error("HMAC algorithm "+e+" is not supported in the browser SDK")},createSign:function(){throw new Error("createSign is not implemented in the browser")}}},function(e,t,r){var n=r(13);function i(e,t){this.hash=new e,this.outer=new e;var r=function(e,t){var r=n.convertToBuffer(t);if(r.byteLength>e.BLOCK_SIZE){var i=new e;i.update(r),r=i.digest()}var o=new Uint8Array(e.BLOCK_SIZE);return o.set(r),o}(e,t),i=new Uint8Array(e.BLOCK_SIZE);i.set(r);for(var o=0;o<e.BLOCK_SIZE;o++)r[o]^=54,i[o]^=92;this.hash.update(r),this.outer.update(i);for(o=0;o<r.byteLength;o++)r[o]=0}e.exports=i,i.prototype.update=function(e){if(n.isEmptyData(e)||this.error)return this;try{this.hash.update(n.convertToBuffer(e))}catch(e){this.error=e}return this},i.prototype.digest=function(e){return this.outer.finished||this.outer.update(this.hash.digest()),this.outer.digest(e)}},function(e,t,r){"use strict";t.byteLength=function(e){var t=c(e),r=t[0],n=t[1];return 3*(r+n)/4-n},t.toByteArray=function(e){var t,r,n=c(e),s=n[0],a=n[1],u=new o(function(e,t,r){return 3*(t+r)/4-r}(0,s,a)),f=0,l=a>0?s-4:s;for(r=0;r<l;r+=4)t=i[e.charCodeAt(r)]<<18|i[e.charCodeAt(r+1)]<<12|i[e.charCodeAt(r+2)]<<6|i[e.charCodeAt(r+3)],u[f++]=t>>16&255,u[f++]=t>>8&255,u[f++]=255&t;2===a&&(t=i[e.charCodeAt(r)]<<2|i[e.charCodeAt(r+1)]>>4,u[f++]=255&t);1===a&&(t=i[e.charCodeAt(r)]<<10|i[e.charCodeAt(r+1)]<<4|i[e.charCodeAt(r+2)]>>2,u[f++]=t>>8&255,u[f++]=255&t);return u},t.fromByteArray=function(e){for(var t,r=e.length,i=r%3,o=[],s=0,a=r-i;s<a;s+=16383)o.push(f(e,s,s+16383>a?a:s+16383));1===i?(t=e[r-1],o.push(n[t>>2]+n[t<<4&63]+"==")):2===i&&(t=(e[r-2]<<8)+e[r-1],o.push(n[t>>10]+n[t>>4&63]+n[t<<2&63]+"="));return o.join("")};for(var n=[],i=[],o="undefined"!=typeof Uint8Array?Uint8Array:Array,s="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",a=0,u=s.length;a<u;++a)n[a]=s[a],i[s.charCodeAt(a)]=a;function c(e){var t=e.length;if(t%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var r=e.indexOf("=");return-1===r&&(r=t),[r,r===t?0:4-r%4]}function f(e,t,r){for(var i,o,s=[],a=t;a<r;a+=3)i=(e[a]<<16&16711680)+(e[a+1]<<8&65280)+(255&e[a+2]),s.push(n[(o=i)>>18&63]+n[o>>12&63]+n[o>>6&63]+n[63&o]);return s.join("")}i["-".charCodeAt(0)]=62,i["_".charCodeAt(0)]=63},function(e,t){t.read=function(e,t,r,n,i){var o,s,a=8*i-n-1,u=(1<<a)-1,c=u>>1,f=-7,l=r?i-1:0,h=r?-1:1,p=e[t+l];for(l+=h,o=p&(1<<-f)-1,p>>=-f,f+=a;f>0;o=256*o+e[t+l],l+=h,f-=8);for(s=o&(1<<-f)-1,o>>=-f,f+=n;f>0;s=256*s+e[t+l],l+=h,f-=8);if(0===o)o=1-c;else{if(o===u)return s?NaN:1/0*(p?-1:1);s+=Math.pow(2,n),o-=c}return(p?-1:1)*s*Math.pow(2,o-n)},t.write=function(e,t,r,n,i,o){var s,a,u,c=8*o-i-1,f=(1<<c)-1,l=f>>1,h=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,p=n?0:o-1,d=n?1:-1,v=t<0||0===t&&1/t<0?1:0;for(t=Math.abs(t),isNaN(t)||t===1/0?(a=isNaN(t)?1:0,s=f):(s=Math.floor(Math.log(t)/Math.LN2),t*(u=Math.pow(2,-s))<1&&(s--,u*=2),(t+=s+l>=1?h/u:h*Math.pow(2,1-l))*u>=2&&(s++,u/=2),s+l>=f?(a=0,s=f):s+l>=1?(a=(t*u-1)*Math.pow(2,i),s+=l):(a=t*Math.pow(2,l-1)*Math.pow(2,i),s=0));i>=8;e[r+p]=255&a,p+=d,a/=256,i-=8);for(s=s<<i|a,c+=i;c>0;e[r+p]=255&s,p+=d,s/=256,c-=8);e[r+p-d]|=128*v}},function(e,t){var r={}.toString;e.exports=Array.isArray||function(e){return"[object Array]"==r.call(e)}},function(e,t,r){var n=r(13),i=r(9).Buffer;function o(){this.state=[1732584193,4023233417,2562383102,271733878],this.buffer=new DataView(new ArrayBuffer(64)),this.bufferLength=0,this.bytesHashed=0,this.finished=!1}function s(e,t,r,n,i,o){return((t=(t+e&4294967295)+(n+o&4294967295)&4294967295)<<i|t>>>32-i)+r&4294967295}function a(e,t,r,n,i,o,a){return s(t&r|~t&n,e,t,i,o,a)}function u(e,t,r,n,i,o,a){return s(t&n|r&~n,e,t,i,o,a)}function c(e,t,r,n,i,o,a){return s(t^r^n,e,t,i,o,a)}function f(e,t,r,n,i,o,a){return s(r^(t|~n),e,t,i,o,a)}e.exports=o,o.BLOCK_SIZE=64,o.prototype.update=function(e){if(n.isEmptyData(e))return this;if(this.finished)throw new Error("Attempted to update an already finished hash.");var t=n.convertToBuffer(e),r=0,i=t.byteLength;for(this.bytesHashed+=i;i>0;)this.buffer.setUint8(this.bufferLength++,t[r++]),i--,64===this.bufferLength&&(this.hashBuffer(),this.bufferLength=0);return this},o.prototype.digest=function(e){if(!this.finished){var t=this.buffer,r=this.bufferLength,n=8*this.bytesHashed;if(t.setUint8(this.bufferLength++,128),r%64>=56){for(var o=this.bufferLength;o<64;o++)t.setUint8(o,0);this.hashBuffer(),this.bufferLength=0}for(o=this.bufferLength;o<56;o++)t.setUint8(o,0);t.setUint32(56,n>>>0,!0),t.setUint32(60,Math.floor(n/4294967296),!0),this.hashBuffer(),this.finished=!0}var s=new DataView(new ArrayBuffer(16));for(o=0;o<4;o++)s.setUint32(4*o,this.state[o],!0);var a=new i(s.buffer,s.byteOffset,s.byteLength);return e?a.toString(e):a},o.prototype.hashBuffer=function(){var e=this.buffer,t=this.state,r=t[0],n=t[1],i=t[2],o=t[3];r=a(r,n,i,o,e.getUint32(0,!0),7,3614090360),o=a(o,r,n,i,e.getUint32(4,!0),12,3905402710),i=a(i,o,r,n,e.getUint32(8,!0),17,606105819),n=a(n,i,o,r,e.getUint32(12,!0),22,3250441966),r=a(r,n,i,o,e.getUint32(16,!0),7,4118548399),o=a(o,r,n,i,e.getUint32(20,!0),12,1200080426),i=a(i,o,r,n,e.getUint32(24,!0),17,2821735955),n=a(n,i,o,r,e.getUint32(28,!0),22,4249261313),r=a(r,n,i,o,e.getUint32(32,!0),7,1770035416),o=a(o,r,n,i,e.getUint32(36,!0),12,2336552879),i=a(i,o,r,n,e.getUint32(40,!0),17,4294925233),n=a(n,i,o,r,e.getUint32(44,!0),22,2304563134),r=a(r,n,i,o,e.getUint32(48,!0),7,1804603682),o=a(o,r,n,i,e.getUint32(52,!0),12,4254626195),i=a(i,o,r,n,e.getUint32(56,!0),17,2792965006),r=u(r,n=a(n,i,o,r,e.getUint32(60,!0),22,1236535329),i,o,e.getUint32(4,!0),5,4129170786),o=u(o,r,n,i,e.getUint32(24,!0),9,3225465664),i=u(i,o,r,n,e.getUint32(44,!0),14,643717713),n=u(n,i,o,r,e.getUint32(0,!0),20,3921069994),r=u(r,n,i,o,e.getUint32(20,!0),5,3593408605),o=u(o,r,n,i,e.getUint32(40,!0),9,38016083),i=u(i,o,r,n,e.getUint32(60,!0),14,3634488961),n=u(n,i,o,r,e.getUint32(16,!0),20,3889429448),r=u(r,n,i,o,e.getUint32(36,!0),5,568446438),o=u(o,r,n,i,e.getUint32(56,!0),9,3275163606),i=u(i,o,r,n,e.getUint32(12,!0),14,4107603335),n=u(n,i,o,r,e.getUint32(32,!0),20,1163531501),r=u(r,n,i,o,e.getUint32(52,!0),5,2850285829),o=u(o,r,n,i,e.getUint32(8,!0),9,4243563512),i=u(i,o,r,n,e.getUint32(28,!0),14,1735328473),r=c(r,n=u(n,i,o,r,e.getUint32(48,!0),20,2368359562),i,o,e.getUint32(20,!0),4,4294588738),o=c(o,r,n,i,e.getUint32(32,!0),11,2272392833),i=c(i,o,r,n,e.getUint32(44,!0),16,1839030562),n=c(n,i,o,r,e.getUint32(56,!0),23,4259657740),r=c(r,n,i,o,e.getUint32(4,!0),4,2763975236),o=c(o,r,n,i,e.getUint32(16,!0),11,1272893353),i=c(i,o,r,n,e.getUint32(28,!0),16,4139469664),n=c(n,i,o,r,e.getUint32(40,!0),23,3200236656),r=c(r,n,i,o,e.getUint32(52,!0),4,681279174),o=c(o,r,n,i,e.getUint32(0,!0),11,3936430074),i=c(i,o,r,n,e.getUint32(12,!0),16,3572445317),n=c(n,i,o,r,e.getUint32(24,!0),23,76029189),r=c(r,n,i,o,e.getUint32(36,!0),4,3654602809),o=c(o,r,n,i,e.getUint32(48,!0),11,3873151461),i=c(i,o,r,n,e.getUint32(60,!0),16,530742520),r=f(r,n=c(n,i,o,r,e.getUint32(8,!0),23,3299628645),i,o,e.getUint32(0,!0),6,4096336452),o=f(o,r,n,i,e.getUint32(28,!0),10,1126891415),i=f(i,o,r,n,e.getUint32(56,!0),15,2878612391),n=f(n,i,o,r,e.getUint32(20,!0),21,4237533241),r=f(r,n,i,o,e.getUint32(48,!0),6,1700485571),o=f(o,r,n,i,e.getUint32(12,!0),10,2399980690),i=f(i,o,r,n,e.getUint32(40,!0),15,4293915773),n=f(n,i,o,r,e.getUint32(4,!0),21,2240044497),r=f(r,n,i,o,e.getUint32(32,!0),6,1873313359),o=f(o,r,n,i,e.getUint32(60,!0),10,4264355552),i=f(i,o,r,n,e.getUint32(24,!0),15,2734768916),n=f(n,i,o,r,e.getUint32(52,!0),21,1309151649),r=f(r,n,i,o,e.getUint32(16,!0),6,4149444226),o=f(o,r,n,i,e.getUint32(44,!0),10,3174756917),i=f(i,o,r,n,e.getUint32(8,!0),15,718787259),n=f(n,i,o,r,e.getUint32(36,!0),21,3951481745),t[0]=r+t[0]&4294967295,t[1]=n+t[1]&4294967295,t[2]=i+t[2]&4294967295,t[3]=o+t[3]&4294967295}},function(e,t,r){var n=r(9).Buffer,i=r(13);new Uint32Array([1518500249,1859775393,-1894007588,-899497514]),Math.pow(2,53);function o(){this.h0=1732584193,this.h1=4023233417,this.h2=2562383102,this.h3=271733878,this.h4=3285377520,this.block=new Uint32Array(80),this.offset=0,this.shift=24,this.totalLength=0}e.exports=o,o.BLOCK_SIZE=64,o.prototype.update=function(e){if(this.finished)throw new Error("Attempted to update an already finished hash.");if(i.isEmptyData(e))return this;var t=(e=i.convertToBuffer(e)).length;this.totalLength+=8*t;for(var r=0;r<t;r++)this.write(e[r]);return this},o.prototype.write=function(e){this.block[this.offset]|=(255&e)<<this.shift,this.shift?this.shift-=8:(this.offset++,this.shift=24),16===this.offset&&this.processBlock()},o.prototype.digest=function(e){this.write(128),(this.offset>14||14===this.offset&&this.shift<24)&&this.processBlock(),this.offset=14,this.shift=24,this.write(0),this.write(0),this.write(this.totalLength>0xffffffffff?this.totalLength/1099511627776:0),this.write(this.totalLength>4294967295?this.totalLength/4294967296:0);for(var t=24;t>=0;t-=8)this.write(this.totalLength>>t);var r=new n(20),i=new DataView(r.buffer);return i.setUint32(0,this.h0,!1),i.setUint32(4,this.h1,!1),i.setUint32(8,this.h2,!1),i.setUint32(12,this.h3,!1),i.setUint32(16,this.h4,!1),e?r.toString(e):r},o.prototype.processBlock=function(){for(var e=16;e<80;e++){var t=this.block[e-3]^this.block[e-8]^this.block[e-14]^this.block[e-16];this.block[e]=t<<1|t>>>31}var r,n,i=this.h0,o=this.h1,s=this.h2,a=this.h3,u=this.h4;for(e=0;e<80;e++){e<20?(r=a^o&(s^a),n=1518500249):e<40?(r=o^s^a,n=1859775393):e<60?(r=o&s|a&(o|s),n=2400959708):(r=o^s^a,n=3395469782);var c=(i<<5|i>>>27)+r+u+n+(0|this.block[e]);u=a,a=s,s=o<<30|o>>>2,o=i,i=c}for(this.h0=this.h0+i|0,this.h1=this.h1+o|0,this.h2=this.h2+s|0,this.h3=this.h3+a|0,this.h4=this.h4+u|0,this.offset=0,e=0;e<16;e++)this.block[e]=0}},function(e,t,r){var n=r(9).Buffer,i=r(13),o=new Uint32Array([1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298]),s=Math.pow(2,53)-1;function a(){this.state=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225],this.temp=new Int32Array(64),this.buffer=new Uint8Array(64),this.bufferLength=0,this.bytesHashed=0,this.finished=!1}e.exports=a,a.BLOCK_SIZE=64,a.prototype.update=function(e){if(this.finished)throw new Error("Attempted to update an already finished hash.");if(i.isEmptyData(e))return this;var t=0,r=(e=i.convertToBuffer(e)).byteLength;if(this.bytesHashed+=r,8*this.bytesHashed>s)throw new Error("Cannot hash more than 2^53 - 1 bits");for(;r>0;)this.buffer[this.bufferLength++]=e[t++],r--,64===this.bufferLength&&(this.hashBuffer(),this.bufferLength=0);return this},a.prototype.digest=function(e){if(!this.finished){var t=8*this.bytesHashed,r=new DataView(this.buffer.buffer,this.buffer.byteOffset,this.buffer.byteLength),i=this.bufferLength;if(r.setUint8(this.bufferLength++,128),i%64>=56){for(var o=this.bufferLength;o<64;o++)r.setUint8(o,0);this.hashBuffer(),this.bufferLength=0}for(o=this.bufferLength;o<56;o++)r.setUint8(o,0);r.setUint32(56,Math.floor(t/4294967296),!0),r.setUint32(60,t),this.hashBuffer(),this.finished=!0}var s=new n(32);for(o=0;o<8;o++)s[4*o]=this.state[o]>>>24&255,s[4*o+1]=this.state[o]>>>16&255,s[4*o+2]=this.state[o]>>>8&255,s[4*o+3]=this.state[o]>>>0&255;return e?s.toString(e):s},a.prototype.hashBuffer=function(){for(var e=this.buffer,t=this.state,r=t[0],n=t[1],i=t[2],s=t[3],a=t[4],u=t[5],c=t[6],f=t[7],l=0;l<64;l++){if(l<16)this.temp[l]=(255&e[4*l])<<24|(255&e[4*l+1])<<16|(255&e[4*l+2])<<8|255&e[4*l+3];else{var h=this.temp[l-2],p=(h>>>17|h<<15)^(h>>>19|h<<13)^h>>>10,d=((h=this.temp[l-15])>>>7|h<<25)^(h>>>18|h<<14)^h>>>3;this.temp[l]=(p+this.temp[l-7]|0)+(d+this.temp[l-16]|0)}var v=(((a>>>6|a<<26)^(a>>>11|a<<21)^(a>>>25|a<<7))+(a&u^~a&c)|0)+(f+(o[l]+this.temp[l]|0)|0)|0,m=((r>>>2|r<<30)^(r>>>13|r<<19)^(r>>>22|r<<10))+(r&n^r&i^n&i)|0;f=c,c=u,u=a,a=s+v|0,s=i,i=n,n=r,r=v+m|0}t[0]+=r,t[1]+=n,t[2]+=i,t[3]+=s,t[4]+=a,t[5]+=u,t[6]+=c,t[7]+=f}},function(e,t,r){"use strict";var n=r(88),i=r(89);function o(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}t.parse=b,t.resolve=function(e,t){return b(e,!1,!0).resolve(t)},t.resolveObject=function(e,t){return e?b(e,!1,!0).resolveObject(t):t},t.format=function(e){i.isString(e)&&(e=b(e));return e instanceof o?e.format():o.prototype.format.call(e)},t.Url=o;var s=/^([a-z0-9.+-]+:)/i,a=/:[0-9]*$/,u=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,c=["{","}","|","\\","^","`"].concat(["<",">",'"',"`"," ","\r","\n","\t"]),f=["'"].concat(c),l=["%","/","?",";","#"].concat(f),h=["/","?","#"],p=/^[+a-z0-9A-Z_-]{0,63}$/,d=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,v={javascript:!0,"javascript:":!0},m={javascript:!0,"javascript:":!0},g={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},y=r(36);function b(e,t,r){if(e&&i.isObject(e)&&e instanceof o)return e;var n=new o;return n.parse(e,t,r),n}o.prototype.parse=function(e,t,r){if(!i.isString(e))throw new TypeError("Parameter 'url' must be a string, not "+typeof e);var o=e.indexOf("?"),a=-1!==o&&o<e.indexOf("#")?"?":"#",c=e.split(a);c[0]=c[0].replace(/\\/g,"/");var b=e=c.join(a);if(b=b.trim(),!r&&1===e.split("#").length){var _=u.exec(b);if(_)return this.path=b,this.href=b,this.pathname=_[1],_[2]?(this.search=_[2],this.query=t?y.parse(this.search.substr(1)):this.search.substr(1)):t&&(this.search="",this.query={}),this}var w=s.exec(b);if(w){var E=(w=w[0]).toLowerCase();this.protocol=E,b=b.substr(w.length)}if(r||w||b.match(/^\/\/[^@\/]+@[^@\/]+/)){var S="//"===b.substr(0,2);!S||w&&m[w]||(b=b.substr(2),this.slashes=!0)}if(!m[w]&&(S||w&&!g[w])){for(var A,x,I=-1,C=0;C<h.length;C++){-1!==(R=b.indexOf(h[C]))&&(-1===I||R<I)&&(I=R)}-1!==(x=-1===I?b.lastIndexOf("@"):b.lastIndexOf("@",I))&&(A=b.slice(0,x),b=b.slice(x+1),this.auth=decodeURIComponent(A)),I=-1;for(C=0;C<l.length;C++){var R;-1!==(R=b.indexOf(l[C]))&&(-1===I||R<I)&&(I=R)}-1===I&&(I=b.length),this.host=b.slice(0,I),b=b.slice(I),this.parseHost(),this.hostname=this.hostname||"";var T="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!T)for(var k=this.hostname.split(/\./),P=(C=0,k.length);C<P;C++){var O=k[C];if(O&&!O.match(p)){for(var L="",q=0,N=O.length;q<N;q++)O.charCodeAt(q)>127?L+="x":L+=O[q];if(!L.match(p)){var j=k.slice(0,C),D=k.slice(C+1),U=O.match(d);U&&(j.push(U[1]),D.unshift(U[2])),D.length&&(b="/"+D.join(".")+b),this.hostname=j.join(".");break}}}this.hostname.length>255?this.hostname="":this.hostname=this.hostname.toLowerCase(),T||(this.hostname=n.toASCII(this.hostname));var M=this.port?":"+this.port:"",B=this.hostname||"";this.host=B+M,this.href+=this.host,T&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==b[0]&&(b="/"+b))}if(!v[E])for(C=0,P=f.length;C<P;C++){var z=f[C];if(-1!==b.indexOf(z)){var F=encodeURIComponent(z);F===z&&(F=escape(z)),b=b.split(z).join(F)}}var V=b.indexOf("#");-1!==V&&(this.hash=b.substr(V),b=b.slice(0,V));var H=b.indexOf("?");if(-1!==H?(this.search=b.substr(H),this.query=b.substr(H+1),t&&(this.query=y.parse(this.query)),b=b.slice(0,H)):t&&(this.search="",this.query={}),b&&(this.pathname=b),g[E]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){M=this.pathname||"";var W=this.search||"";this.path=M+W}return this.href=this.format(),this},o.prototype.format=function(){var e=this.auth||"";e&&(e=(e=encodeURIComponent(e)).replace(/%3A/i,":"),e+="@");var t=this.protocol||"",r=this.pathname||"",n=this.hash||"",o=!1,s="";this.host?o=e+this.host:this.hostname&&(o=e+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port&&(o+=":"+this.port)),this.query&&i.isObject(this.query)&&Object.keys(this.query).length&&(s=y.stringify(this.query));var a=this.search||s&&"?"+s||"";return t&&":"!==t.substr(-1)&&(t+=":"),this.slashes||(!t||g[t])&&!1!==o?(o="//"+(o||""),r&&"/"!==r.charAt(0)&&(r="/"+r)):o||(o=""),n&&"#"!==n.charAt(0)&&(n="#"+n),a&&"?"!==a.charAt(0)&&(a="?"+a),t+o+(r=r.replace(/[?#]/g,(function(e){return encodeURIComponent(e)})))+(a=a.replace("#","%23"))+n},o.prototype.resolve=function(e){return this.resolveObject(b(e,!1,!0)).format()},o.prototype.resolveObject=function(e){if(i.isString(e)){var t=new o;t.parse(e,!1,!0),e=t}for(var r=new o,n=Object.keys(this),s=0;s<n.length;s++){var a=n[s];r[a]=this[a]}if(r.hash=e.hash,""===e.href)return r.href=r.format(),r;if(e.slashes&&!e.protocol){for(var u=Object.keys(e),c=0;c<u.length;c++){var f=u[c];"protocol"!==f&&(r[f]=e[f])}return g[r.protocol]&&r.hostname&&!r.pathname&&(r.path=r.pathname="/"),r.href=r.format(),r}if(e.protocol&&e.protocol!==r.protocol){if(!g[e.protocol]){for(var l=Object.keys(e),h=0;h<l.length;h++){var p=l[h];r[p]=e[p]}return r.href=r.format(),r}if(r.protocol=e.protocol,e.host||m[e.protocol])r.pathname=e.pathname;else{for(var d=(e.pathname||"").split("/");d.length&&!(e.host=d.shift()););e.host||(e.host=""),e.hostname||(e.hostname=""),""!==d[0]&&d.unshift(""),d.length<2&&d.unshift(""),r.pathname=d.join("/")}if(r.search=e.search,r.query=e.query,r.host=e.host||"",r.auth=e.auth,r.hostname=e.hostname||e.host,r.port=e.port,r.pathname||r.search){var v=r.pathname||"",y=r.search||"";r.path=v+y}return r.slashes=r.slashes||e.slashes,r.href=r.format(),r}var b=r.pathname&&"/"===r.pathname.charAt(0),_=e.host||e.pathname&&"/"===e.pathname.charAt(0),w=_||b||r.host&&e.pathname,E=w,S=r.pathname&&r.pathname.split("/")||[],A=(d=e.pathname&&e.pathname.split("/")||[],r.protocol&&!g[r.protocol]);if(A&&(r.hostname="",r.port=null,r.host&&(""===S[0]?S[0]=r.host:S.unshift(r.host)),r.host="",e.protocol&&(e.hostname=null,e.port=null,e.host&&(""===d[0]?d[0]=e.host:d.unshift(e.host)),e.host=null),w=w&&(""===d[0]||""===S[0])),_)r.host=e.host||""===e.host?e.host:r.host,r.hostname=e.hostname||""===e.hostname?e.hostname:r.hostname,r.search=e.search,r.query=e.query,S=d;else if(d.length)S||(S=[]),S.pop(),S=S.concat(d),r.search=e.search,r.query=e.query;else if(!i.isNullOrUndefined(e.search)){if(A)r.hostname=r.host=S.shift(),(T=!!(r.host&&r.host.indexOf("@")>0)&&r.host.split("@"))&&(r.auth=T.shift(),r.host=r.hostname=T.shift());return r.search=e.search,r.query=e.query,i.isNull(r.pathname)&&i.isNull(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.href=r.format(),r}if(!S.length)return r.pathname=null,r.search?r.path="/"+r.search:r.path=null,r.href=r.format(),r;for(var x=S.slice(-1)[0],I=(r.host||e.host||S.length>1)&&("."===x||".."===x)||""===x,C=0,R=S.length;R>=0;R--)"."===(x=S[R])?S.splice(R,1):".."===x?(S.splice(R,1),C++):C&&(S.splice(R,1),C--);if(!w&&!E)for(;C--;C)S.unshift("..");!w||""===S[0]||S[0]&&"/"===S[0].charAt(0)||S.unshift(""),I&&"/"!==S.join("/").substr(-1)&&S.push("");var T,k=""===S[0]||S[0]&&"/"===S[0].charAt(0);A&&(r.hostname=r.host=k?"":S.length?S.shift():"",(T=!!(r.host&&r.host.indexOf("@")>0)&&r.host.split("@"))&&(r.auth=T.shift(),r.host=r.hostname=T.shift()));return(w=w||r.host&&S.length)&&!k&&S.unshift(""),S.length?r.pathname=S.join("/"):(r.pathname=null,r.path=null),i.isNull(r.pathname)&&i.isNull(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.auth=e.auth||r.auth,r.slashes=r.slashes||e.slashes,r.href=r.format(),r},o.prototype.parseHost=function(){var e=this.host,t=a.exec(e);t&&(":"!==(t=t[0])&&(this.port=t.substr(1)),e=e.substr(0,e.length-t.length)),e&&(this.hostname=e)}},function(e,t,r){(function(e,n){var i;/*! https://mths.be/punycode v1.4.1 by @mathias */!function(o){t&&t.nodeType,e&&e.nodeType;var s="object"==typeof n&&n;s.global!==s&&s.window!==s&&s.self;var a,u=2147483647,c=/^xn--/,f=/[^\x20-\x7E]/,l=/[\x2E\u3002\uFF0E\uFF61]/g,h={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},p=Math.floor,d=String.fromCharCode;function v(e){throw new RangeError(h[e])}function m(e,t){for(var r=e.length,n=[];r--;)n[r]=t(e[r]);return n}function g(e,t){var r=e.split("@"),n="";return r.length>1&&(n=r[0]+"@",e=r[1]),n+m((e=e.replace(l,".")).split("."),t).join(".")}function y(e){for(var t,r,n=[],i=0,o=e.length;i<o;)(t=e.charCodeAt(i++))>=55296&&t<=56319&&i<o?56320==(64512&(r=e.charCodeAt(i++)))?n.push(((1023&t)<<10)+(1023&r)+65536):(n.push(t),i--):n.push(t);return n}function b(e){return m(e,(function(e){var t="";return e>65535&&(t+=d((e-=65536)>>>10&1023|55296),e=56320|1023&e),t+=d(e)})).join("")}function _(e,t){return e+22+75*(e<26)-((0!=t)<<5)}function w(e,t,r){var n=0;for(e=r?p(e/700):e>>1,e+=p(e/t);e>455;n+=36)e=p(e/35);return p(n+36*e/(e+38))}function E(e){var t,r,n,i,o,s,a,c,f,l,h,d=[],m=e.length,g=0,y=128,_=72;for((r=e.lastIndexOf("-"))<0&&(r=0),n=0;n<r;++n)e.charCodeAt(n)>=128&&v("not-basic"),d.push(e.charCodeAt(n));for(i=r>0?r+1:0;i<m;){for(o=g,s=1,a=36;i>=m&&v("invalid-input"),((c=(h=e.charCodeAt(i++))-48<10?h-22:h-65<26?h-65:h-97<26?h-97:36)>=36||c>p((u-g)/s))&&v("overflow"),g+=c*s,!(c<(f=a<=_?1:a>=_+26?26:a-_));a+=36)s>p(u/(l=36-f))&&v("overflow"),s*=l;_=w(g-o,t=d.length+1,0==o),p(g/t)>u-y&&v("overflow"),y+=p(g/t),g%=t,d.splice(g++,0,y)}return b(d)}function S(e){var t,r,n,i,o,s,a,c,f,l,h,m,g,b,E,S=[];for(m=(e=y(e)).length,t=128,r=0,o=72,s=0;s<m;++s)(h=e[s])<128&&S.push(d(h));for(n=i=S.length,i&&S.push("-");n<m;){for(a=u,s=0;s<m;++s)(h=e[s])>=t&&h<a&&(a=h);for(a-t>p((u-r)/(g=n+1))&&v("overflow"),r+=(a-t)*g,t=a,s=0;s<m;++s)if((h=e[s])<t&&++r>u&&v("overflow"),h==t){for(c=r,f=36;!(c<(l=f<=o?1:f>=o+26?26:f-o));f+=36)E=c-l,b=36-l,S.push(d(_(l+E%b,0))),c=p(E/b);S.push(d(_(c,0))),o=w(r,g,n==i),r=0,++n}++r,++t}return S.join("")}a={version:"1.4.1",ucs2:{decode:y,encode:b},decode:E,encode:S,toASCII:function(e){return g(e,(function(e){return f.test(e)?"xn--"+S(e):e}))},toUnicode:function(e){return g(e,(function(e){return c.test(e)?E(e.slice(4).toLowerCase()):e}))}},void 0===(i=function(){return a}.call(t,r,t,e))||(e.exports=i)}()}).call(this,r(35)(e),r(7))},function(e,t,r){"use strict";e.exports={isString:function(e){return"string"==typeof e},isObject:function(e){return"object"==typeof e&&null!==e},isNull:function(e){return null===e},isNullOrUndefined:function(e){return null==e}}},function(e,t,r){"use strict";function n(e,t){return Object.prototype.hasOwnProperty.call(e,t)}e.exports=function(e,t,r,o){t=t||"&",r=r||"=";var s={};if("string"!=typeof e||0===e.length)return s;var a=/\+/g;e=e.split(t);var u=1e3;o&&"number"==typeof o.maxKeys&&(u=o.maxKeys);var c=e.length;u>0&&c>u&&(c=u);for(var f=0;f<c;++f){var l,h,p,d,v=e[f].replace(a,"%20"),m=v.indexOf(r);m>=0?(l=v.substr(0,m),h=v.substr(m+1)):(l=v,h=""),p=decodeURIComponent(l),d=decodeURIComponent(h),n(s,p)?i(s[p])?s[p].push(d):s[p]=[s[p],d]:s[p]=d}return s};var i=Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)}},function(e,t,r){"use strict";var n=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return""}};e.exports=function(e,t,r,a){return t=t||"&",r=r||"=",null===e&&(e=void 0),"object"==typeof e?o(s(e),(function(s){var a=encodeURIComponent(n(s))+r;return i(e[s])?o(e[s],(function(e){return a+encodeURIComponent(n(e))})).join(t):a+encodeURIComponent(n(e[s]))})).join(t):a?encodeURIComponent(n(a))+r+encodeURIComponent(n(e)):""};var i=Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)};function o(e,t){if(e.map)return e.map(t);for(var r=[],n=0;n<e.length;n++)r.push(t(e[n],n));return r}var s=Object.keys||function(e){var t=[];for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.push(r);return t}},function(e,t){e.exports={now:function(){return"undefined"!=typeof performance&&"function"==typeof performance.now?performance.now():Date.now()}}},function(e,t,r){var n=r(94).eventMessageChunker,i=r(95).parseEvent;e.exports={createEventStream:function(e,t,r){for(var o=n(e),s=[],a=0;a<o.length;a++)s.push(i(t,o[a],r));return s}}},function(e,t){e.exports={eventMessageChunker:function(e){for(var t=[],r=0;r<e.length;){var n=e.readInt32BE(r),i=e.slice(r,n+r);r+=n,t.push(i)}return t}}},function(e,t,r){var n=r(96).parseMessage;e.exports={parseEvent:function(e,t,r){var i=n(t),o=i.headers[":message-type"];if(o){if("error"===o.value)throw function(e){var t=e.headers[":error-code"],r=e.headers[":error-message"],n=new Error(r.value||r);return n.code=n.name=t.value||t,n}(i);if("event"!==o.value)return}var s=i.headers[":event-type"],a=r.members[s.value];if(a){var u={},c=a.eventPayloadMemberName;if(c){var f=a.members[c];"binary"===f.type?u[c]=i.body:u[c]=e.parse(i.body.toString(),f)}for(var l=a.eventHeaderMemberNames,h=0;h<l.length;h++){var p=l[h];i.headers[p]&&(u[p]=a.members[p].toType(i.headers[p].value))}var d={};return d[s.value]=u,d}}}},function(e,t,r){var n=r(97).Int64,i=r(98).splitMessage;function o(e){for(var t={},r=0;r<e.length;){var i=e.readUInt8(r++),o=e.slice(r,r+i).toString();switch(r+=i,e.readUInt8(r++)){case 0:t[o]={type:"boolean",value:!0};break;case 1:t[o]={type:"boolean",value:!1};break;case 2:t[o]={type:"byte",value:e.readInt8(r++)};break;case 3:t[o]={type:"short",value:e.readInt16BE(r)},r+=2;break;case 4:t[o]={type:"integer",value:e.readInt32BE(r)},r+=4;break;case 5:t[o]={type:"long",value:new n(e.slice(r,r+8))},r+=8;break;case 6:var s=e.readUInt16BE(r);r+=2,t[o]={type:"binary",value:e.slice(r,r+s)},r+=s;break;case 7:var a=e.readUInt16BE(r);r+=2,t[o]={type:"string",value:e.slice(r,r+a).toString()},r+=a;break;case 8:t[o]={type:"timestamp",value:new Date(new n(e.slice(r,r+8)).valueOf())},r+=8;break;case 9:var u=e.slice(r,r+16).toString("hex");r+=16,t[o]={type:"uuid",value:u.substr(0,8)+"-"+u.substr(8,4)+"-"+u.substr(12,4)+"-"+u.substr(16,4)+"-"+u.substr(20)};break;default:throw new Error("Unrecognized header type tag")}}return t}e.exports={parseMessage:function(e){var t=i(e);return{headers:o(t.headers),body:t.body}}}},function(e,t,r){var n=r(1).util,i=n.buffer.toBuffer;function o(e){if(8!==e.length)throw new Error("Int64 buffers must be exactly 8 bytes");n.Buffer.isBuffer(e)||(e=i(e)),this.bytes=e}function s(e){for(var t=0;t<8;t++)e[t]^=255;for(t=7;t>-1&&(e[t]++,0===e[t]);t--);}o.fromNumber=function(e){if(e>0x8000000000000000||e<-0x8000000000000000)throw new Error(e+" is too large (or, if negative, too small) to represent as an Int64");for(var t=new Uint8Array(8),r=7,n=Math.abs(Math.round(e));r>-1&&n>0;r--,n/=256)t[r]=n;return e<0&&s(t),new o(t)},o.prototype.valueOf=function(){var e=this.bytes.slice(0),t=128&e[0];return t&&s(e),parseInt(e.toString("hex"),16)*(t?-1:1)},o.prototype.toString=function(){return String(this.valueOf())},e.exports={Int64:o}},function(e,t,r){var n=r(1).util,i=n.buffer.toBuffer;e.exports={splitMessage:function(e){if(n.Buffer.isBuffer(e)||(e=i(e)),e.length<16)throw new Error("Provided message too short to accommodate event stream message overhead");if(e.length!==e.readUInt32BE(0))throw new Error("Reported message length does not match received message length");var t=e.readUInt32BE(8);if(t!==n.crypto.crc32(e.slice(0,8)))throw new Error("The prelude checksum specified in the message ("+t+") does not match the calculated CRC32 checksum.");var r=e.readUInt32BE(e.length-4);if(r!==n.crypto.crc32(e.slice(0,e.length-4)))throw new Error("The message checksum did not match the expected value of "+r);var o=12+e.readUInt32BE(4);return{headers:e.slice(12,o),body:e.slice(o,e.length-4)}}}},function(e,t,r){var n=r(1),i=r(10);n.TemporaryCredentials=n.util.inherit(n.Credentials,{constructor:function(e,t){n.Credentials.call(this),this.loadMasterCredentials(t),this.expired=!0,this.params=e||{},this.params.RoleArn&&(this.params.RoleSessionName=this.params.RoleSessionName||"temporary-credentials")},refresh:function(e){this.coalesceRefresh(e||n.util.fn.callback)},load:function(e){var t=this;t.createClients(),t.masterCredentials.get((function(){t.service.config.credentials=t.masterCredentials,(t.params.RoleArn?t.service.assumeRole:t.service.getSessionToken).call(t.service,(function(r,n){r||t.service.credentialsFrom(n,t),e(r)}))}))},loadMasterCredentials:function(e){for(this.masterCredentials=e||n.config.credentials;this.masterCredentials.masterCredentials;)this.masterCredentials=this.masterCredentials.masterCredentials;"function"!=typeof this.masterCredentials.get&&(this.masterCredentials=new n.Credentials(this.masterCredentials))},createClients:function(){this.service=this.service||new i({params:this.params})}})},function(e,t,r){var n=r(1);n.util.update(n.STS.prototype,{credentialsFrom:function(e,t){return e?(t||(t=new n.TemporaryCredentials),t.expired=!1,t.accessKeyId=e.Credentials.AccessKeyId,t.secretAccessKey=e.Credentials.SecretAccessKey,t.sessionToken=e.Credentials.SessionToken,t.expireTime=e.Credentials.Expiration,t):null},assumeRoleWithWebIdentity:function(e,t){return this.makeUnauthenticatedRequest("assumeRoleWithWebIdentity",e,t)},assumeRoleWithSAML:function(e,t){return this.makeUnauthenticatedRequest("assumeRoleWithSAML",e,t)}})},function(e){e.exports=JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2011-06-15","endpointPrefix":"sts","globalEndpoint":"sts.amazonaws.com","protocol":"query","serviceAbbreviation":"AWS STS","serviceFullName":"AWS Security Token Service","serviceId":"STS","signatureVersion":"v4","uid":"sts-2011-06-15","xmlNamespace":"https://sts.amazonaws.com/doc/2011-06-15/"},"operations":{"AssumeRole":{"input":{"type":"structure","required":["RoleArn","RoleSessionName"],"members":{"RoleArn":{},"RoleSessionName":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"},"ExternalId":{},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"AssumeRoleResult","type":"structure","members":{"Credentials":{"shape":"Sc"},"AssumedRoleUser":{"shape":"Sh"},"PackedPolicySize":{"type":"integer"}}}},"AssumeRoleWithSAML":{"input":{"type":"structure","required":["RoleArn","PrincipalArn","SAMLAssertion"],"members":{"RoleArn":{},"PrincipalArn":{},"SAMLAssertion":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithSAMLResult","type":"structure","members":{"Credentials":{"shape":"Sc"},"AssumedRoleUser":{"shape":"Sh"},"PackedPolicySize":{"type":"integer"},"Subject":{},"SubjectType":{},"Issuer":{},"Audience":{},"NameQualifier":{}}}},"AssumeRoleWithWebIdentity":{"input":{"type":"structure","required":["RoleArn","RoleSessionName","WebIdentityToken"],"members":{"RoleArn":{},"RoleSessionName":{},"WebIdentityToken":{},"ProviderId":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithWebIdentityResult","type":"structure","members":{"Credentials":{"shape":"Sc"},"SubjectFromWebIdentityToken":{},"AssumedRoleUser":{"shape":"Sh"},"PackedPolicySize":{"type":"integer"},"Provider":{},"Audience":{}}}},"DecodeAuthorizationMessage":{"input":{"type":"structure","required":["EncodedMessage"],"members":{"EncodedMessage":{}}},"output":{"resultWrapper":"DecodeAuthorizationMessageResult","type":"structure","members":{"DecodedMessage":{}}}},"GetAccessKeyInfo":{"input":{"type":"structure","required":["AccessKeyId"],"members":{"AccessKeyId":{}}},"output":{"resultWrapper":"GetAccessKeyInfoResult","type":"structure","members":{"Account":{}}}},"GetCallerIdentity":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"GetCallerIdentityResult","type":"structure","members":{"UserId":{},"Account":{},"Arn":{}}}},"GetFederationToken":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Policy":{},"PolicyArns":{"shape":"S4"},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"GetFederationTokenResult","type":"structure","members":{"Credentials":{"shape":"Sc"},"FederatedUser":{"type":"structure","required":["FederatedUserId","Arn"],"members":{"FederatedUserId":{},"Arn":{}}},"PackedPolicySize":{"type":"integer"}}}},"GetSessionToken":{"input":{"type":"structure","members":{"DurationSeconds":{"type":"integer"},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"GetSessionTokenResult","type":"structure","members":{"Credentials":{"shape":"Sc"}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","members":{"arn":{}}}},"Sc":{"type":"structure","required":["AccessKeyId","SecretAccessKey","SessionToken","Expiration"],"members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}},"Sh":{"type":"structure","required":["AssumedRoleId","Arn"],"members":{"AssumedRoleId":{},"Arn":{}}}}}')},function(e){e.exports=JSON.parse('{"pagination":{}}')},function(e,t,r){var n=r(1),i=r(10);n.ChainableTemporaryCredentials=n.util.inherit(n.Credentials,{constructor:function(e){n.Credentials.call(this),e=e||{},this.errorCode="ChainableTemporaryCredentialsProviderFailure",this.expired=!0,this.tokenCodeFn=null;var t=n.util.copy(e.params)||{};if(t.RoleArn&&(t.RoleSessionName=t.RoleSessionName||"temporary-credentials"),t.SerialNumber){if(!e.tokenCodeFn||"function"!=typeof e.tokenCodeFn)throw new n.util.error(new Error("tokenCodeFn must be a function when params.SerialNumber is given"),{code:this.errorCode});this.tokenCodeFn=e.tokenCodeFn}config=n.util.merge({params:t,credentials:e.masterCredentials||n.config.credentials},e.stsConfig||{}),this.service=new i(config)},refresh:function(e){this.coalesceRefresh(e||n.util.fn.callback)},load:function(e){var t=this,r=t.service.config.params.RoleArn?"assumeRole":"getSessionToken";this.getTokenCode((function(n,i){var o={};n?e(n):(i&&(o.TokenCode=i),t.service[r](o,(function(r,n){r||t.service.credentialsFrom(n,t),e(r)})))}))},getTokenCode:function(e){var t=this;this.tokenCodeFn?this.tokenCodeFn(this.service.config.params.SerialNumber,(function(r,i){if(r){var o=r;return r instanceof Error&&(o=r.message),void e(n.util.error(new Error("Error fetching MFA token: "+o),{code:t.errorCode}))}e(null,i)})):e(null)}})},function(e,t,r){var n=r(1),i=r(10);n.WebIdentityCredentials=n.util.inherit(n.Credentials,{constructor:function(e,t){n.Credentials.call(this),this.expired=!0,this.params=e,this.params.RoleSessionName=this.params.RoleSessionName||"web-identity",this.data=null,this._clientConfig=n.util.copy(t||{})},refresh:function(e){this.coalesceRefresh(e||n.util.fn.callback)},load:function(e){var t=this;t.createClients(),t.service.assumeRoleWithWebIdentity((function(r,n){t.data=null,r||(t.data=n,t.service.credentialsFrom(n,t)),e(r)}))},createClients:function(){if(!this.service){var e=n.util.merge({},this._clientConfig);e.params=this.params,this.service=new i(e)}}})},function(e,t,r){var n=r(1),i=r(106),o=r(10);n.CognitoIdentityCredentials=n.util.inherit(n.Credentials,{localStorageKey:{id:"aws.cognito.identity-id.",providers:"aws.cognito.identity-providers."},constructor:function(e,t){n.Credentials.call(this),this.expired=!0,this.params=e,this.data=null,this._identityId=null,this._clientConfig=n.util.copy(t||{}),this.loadCachedId();var r=this;Object.defineProperty(this,"identityId",{get:function(){return r.loadCachedId(),r._identityId||r.params.IdentityId},set:function(e){r._identityId=e}})},refresh:function(e){this.coalesceRefresh(e||n.util.fn.callback)},load:function(e){var t=this;t.createClients(),t.data=null,t._identityId=null,t.getId((function(r){r?(t.clearIdOnNotAuthorized(r),e(r)):t.params.RoleArn?t.getCredentialsFromSTS(e):t.getCredentialsForIdentity(e)}))},clearCachedId:function(){this._identityId=null,delete this.params.IdentityId;var e=this.params.IdentityPoolId,t=this.params.LoginId||"";delete this.storage[this.localStorageKey.id+e+t],delete this.storage[this.localStorageKey.providers+e+t]},clearIdOnNotAuthorized:function(e){"NotAuthorizedException"==e.code&&this.clearCachedId()},getId:function(e){var t=this;if("string"==typeof t.params.IdentityId)return e(null,t.params.IdentityId);t.cognito.getId((function(r,n){!r&&n.IdentityId?(t.params.IdentityId=n.IdentityId,e(null,n.IdentityId)):e(r)}))},loadCredentials:function(e,t){e&&t&&(t.expired=!1,t.accessKeyId=e.Credentials.AccessKeyId,t.secretAccessKey=e.Credentials.SecretKey,t.sessionToken=e.Credentials.SessionToken,t.expireTime=e.Credentials.Expiration)},getCredentialsForIdentity:function(e){var t=this;t.cognito.getCredentialsForIdentity((function(r,n){r?t.clearIdOnNotAuthorized(r):(t.cacheId(n),t.data=n,t.loadCredentials(t.data,t)),e(r)}))},getCredentialsFromSTS:function(e){var t=this;t.cognito.getOpenIdToken((function(r,n){r?(t.clearIdOnNotAuthorized(r),e(r)):(t.cacheId(n),t.params.WebIdentityToken=n.Token,t.webIdentityCredentials.refresh((function(r){r||(t.data=t.webIdentityCredentials.data,t.sts.credentialsFrom(t.data,t)),e(r)})))}))},loadCachedId:function(){if(n.util.isBrowser()&&!this.params.IdentityId){var e=this.getStorage("id");if(e&&this.params.Logins){var t=Object.keys(this.params.Logins);0!==(this.getStorage("providers")||"").split(",").filter((function(e){return-1!==t.indexOf(e)})).length&&(this.params.IdentityId=e)}else e&&(this.params.IdentityId=e)}},createClients:function(){var e=this._clientConfig;if(this.webIdentityCredentials=this.webIdentityCredentials||new n.WebIdentityCredentials(this.params,e),!this.cognito){var t=n.util.merge({},e);t.params=this.params,this.cognito=new i(t)}this.sts=this.sts||new o(e)},cacheId:function(e){this._identityId=e.IdentityId,this.params.IdentityId=this._identityId,n.util.isBrowser()&&(this.setStorage("id",e.IdentityId),this.params.Logins&&this.setStorage("providers",Object.keys(this.params.Logins).join(",")))},getStorage:function(e){return this.storage[this.localStorageKey[e]+this.params.IdentityPoolId+(this.params.LoginId||"")]},setStorage:function(e,t){try{this.storage[this.localStorageKey[e]+this.params.IdentityPoolId+(this.params.LoginId||"")]=t}catch(e){}},storage:function(){try{var e=n.util.isBrowser()&&null!==window.localStorage&&"object"==typeof window.localStorage?window.localStorage:{};return e["aws.test-storage"]="foobar",delete e["aws.test-storage"],e}catch(e){return{}}}()})},function(e,t,r){r(11);var n=r(1),i=n.Service,o=n.apiLoader;o.services.cognitoidentity={},n.CognitoIdentity=i.defineService("cognitoidentity",["2014-06-30"]),r(107),Object.defineProperty(o.services.cognitoidentity,"2014-06-30",{get:function(){var e=r(108);return e.paginators=r(109).pagination,e},enumerable:!0,configurable:!0}),e.exports=n.CognitoIdentity},function(e,t,r){var n=r(1);n.util.update(n.CognitoIdentity.prototype,{getOpenIdToken:function(e,t){return this.makeUnauthenticatedRequest("getOpenIdToken",e,t)},getId:function(e,t){return this.makeUnauthenticatedRequest("getId",e,t)},getCredentialsForIdentity:function(e,t){return this.makeUnauthenticatedRequest("getCredentialsForIdentity",e,t)}})},function(e){e.exports=JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-identity","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity","serviceId":"Cognito Identity","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityService","uid":"cognito-identity-2014-06-30"},"operations":{"CreateIdentityPool":{"input":{"type":"structure","required":["IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"},"IdentityPoolTags":{"shape":"Sg"}}},"output":{"shape":"Sj"}},"DeleteIdentities":{"input":{"type":"structure","required":["IdentityIdsToDelete"],"members":{"IdentityIdsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedIdentityIds":{"type":"list","member":{"type":"structure","members":{"IdentityId":{},"ErrorCode":{}}}}}}},"DeleteIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}}},"DescribeIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{}}},"output":{"shape":"Su"}},"DescribeIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"shape":"Sj"}},"GetCredentialsForIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sz"},"CustomRoleArn":{}}},"output":{"type":"structure","members":{"IdentityId":{},"Credentials":{"type":"structure","members":{"AccessKeyId":{},"SecretKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}}}},"GetId":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"AccountId":{},"IdentityPoolId":{},"Logins":{"shape":"Sz"}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"GetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Roles":{"shape":"S1b"},"RoleMappings":{"shape":"S1d"}}}},"GetOpenIdToken":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sz"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"GetOpenIdTokenForDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId","Logins"],"members":{"IdentityPoolId":{},"IdentityId":{},"Logins":{"shape":"Sz"},"TokenDuration":{"type":"long"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"ListIdentities":{"input":{"type":"structure","required":["IdentityPoolId","MaxResults"],"members":{"IdentityPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{},"HideDisabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Identities":{"type":"list","member":{"shape":"Su"}},"NextToken":{}}}},"ListIdentityPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityPools":{"type":"list","member":{"type":"structure","members":{"IdentityPoolId":{},"IdentityPoolName":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sg"}}}},"LookupDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{},"IdentityId":{},"DeveloperUserIdentifier":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityId":{},"DeveloperUserIdentifierList":{"type":"list","member":{}},"NextToken":{}}}},"MergeDeveloperIdentities":{"input":{"type":"structure","required":["SourceUserIdentifier","DestinationUserIdentifier","DeveloperProviderName","IdentityPoolId"],"members":{"SourceUserIdentifier":{},"DestinationUserIdentifier":{},"DeveloperProviderName":{},"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"SetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId","Roles"],"members":{"IdentityPoolId":{},"Roles":{"shape":"S1b"},"RoleMappings":{"shape":"S1d"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"Tags":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"UnlinkDeveloperIdentity":{"input":{"type":"structure","required":["IdentityId","IdentityPoolId","DeveloperProviderName","DeveloperUserIdentifier"],"members":{"IdentityId":{},"IdentityPoolId":{},"DeveloperProviderName":{},"DeveloperUserIdentifier":{}}}},"UnlinkIdentity":{"input":{"type":"structure","required":["IdentityId","Logins","LoginsToRemove"],"members":{"IdentityId":{},"Logins":{"shape":"Sz"},"LoginsToRemove":{"shape":"Sv"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateIdentityPool":{"input":{"shape":"Sj"},"output":{"shape":"Sj"}}},"shapes":{"S4":{"type":"map","key":{},"value":{}},"S8":{"type":"list","member":{}},"Sa":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ClientId":{},"ServerSideTokenCheck":{"type":"boolean"}}}},"Sf":{"type":"list","member":{}},"Sg":{"type":"map","key":{},"value":{}},"Sj":{"type":"structure","required":["IdentityPoolId","IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolId":{},"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"},"IdentityPoolTags":{"shape":"Sg"}}},"Su":{"type":"structure","members":{"IdentityId":{},"Logins":{"shape":"Sv"},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"}}},"Sv":{"type":"list","member":{}},"Sz":{"type":"map","key":{},"value":{}},"S1b":{"type":"map","key":{},"value":{}},"S1d":{"type":"map","key":{},"value":{"type":"structure","required":["Type"],"members":{"Type":{},"AmbiguousRoleResolution":{},"RulesConfiguration":{"type":"structure","required":["Rules"],"members":{"Rules":{"type":"list","member":{"type":"structure","required":["Claim","MatchType","Value","RoleARN"],"members":{"Claim":{},"MatchType":{},"Value":{},"RoleARN":{}}}}}}}}}}}')},function(e){e.exports=JSON.parse('{"pagination":{}}')},function(e,t,r){var n=r(1),i=r(10);n.SAMLCredentials=n.util.inherit(n.Credentials,{constructor:function(e){n.Credentials.call(this),this.expired=!0,this.params=e},refresh:function(e){this.coalesceRefresh(e||n.util.fn.callback)},load:function(e){var t=this;t.createClients(),t.service.assumeRoleWithSAML((function(r,n){r||t.service.credentialsFrom(n,t),e(r)}))},createClients:function(){this.service=this.service||new i({params:this.params})}})},function(e,t,r){var n=r(2),i=r(8);function o(){}function s(e,t){for(var r=e.getElementsByTagName(t),n=0,i=r.length;n<i;n++)if(r[n].parentNode===e)return r[n]}function a(e,t){switch(t||(t={}),t.type){case"structure":return u(e,t);case"map":return function(e,t){var r={},n=t.key.name||"key",i=t.value.name||"value",o=t.flattened?t.name:"entry",u=e.firstElementChild;for(;u;){if(u.nodeName===o){var c=s(u,n).textContent,f=s(u,i);r[c]=a(f,t.value)}u=u.nextElementSibling}return r}(e,t);case"list":return function(e,t){var r=[],n=t.flattened?t.name:t.member.name||"member",i=e.firstElementChild;for(;i;)i.nodeName===n&&r.push(a(i,t.member)),i=i.nextElementSibling;return r}(e,t);case void 0:case null:return function(e){if(null==e)return"";if(!e.firstElementChild)return null===e.parentNode.parentNode?{}:0===e.childNodes.length?"":e.textContent;var t={type:"structure",members:{}},r=e.firstElementChild;for(;r;){var n=r.nodeName;Object.prototype.hasOwnProperty.call(t.members,n)?t.members[n].type="list":t.members[n]={name:n},r=r.nextElementSibling}return u(e,t)}(e);default:return function(e,t){if(e.getAttribute){var r=e.getAttribute("encoding");"base64"===r&&(t=new i.create({type:r}))}var n=e.textContent;""===n&&(n=null);return"function"==typeof t.toType?t.toType(n):n}(e,t)}}function u(e,t){var r={};return null===e?r:(n.each(t.members,(function(t,n){if(n.isXmlAttribute){if(Object.prototype.hasOwnProperty.call(e.attributes,n.name)){var i=e.attributes[n.name].value;r[t]=a({textContent:i},n)}}else{var o=n.flattened?e:s(e,n.name);o?r[t]=a(o,n):n.flattened||"list"!==n.type||(r[t]=n.defaultValue)}})),r)}o.prototype.parse=function(e,t){if(""===e.replace(/^\s+/,""))return{};var r,i;try{if(window.DOMParser){try{r=(new DOMParser).parseFromString(e,"text/xml")}catch(e){throw n.error(new Error("Parse error in document"),{originalError:e,code:"XMLParserError",retryable:!0})}if(null===r.documentElement)throw n.error(new Error("Cannot parse empty document."),{code:"XMLParserError",retryable:!0});var o=r.getElementsByTagName("parsererror")[0];if(o&&(o.parentNode===r||"body"===o.parentNode.nodeName||o.parentNode.parentNode===r||"body"===o.parentNode.parentNode.nodeName)){var u=o.getElementsByTagName("div")[0]||o;throw n.error(new Error(u.textContent||"Parser error in document"),{code:"XMLParserError",retryable:!0})}}else{if(!window.ActiveXObject)throw new Error("Cannot load XML parser");if((r=new window.ActiveXObject("Microsoft.XMLDOM")).async=!1,!r.loadXML(e))throw n.error(new Error("Parse error in document"),{code:"XMLParserError",retryable:!0})}}catch(e){i=e}if(r&&r.documentElement&&!i){var c=a(r.documentElement,t),f=s(r.documentElement,"ResponseMetadata");return f&&(c.ResponseMetadata=a(f,{})),c}if(i)throw n.error(i||new Error,{code:"XMLParserError",retryable:!0});return{}},e.exports=o},function(e,t,r){var n=r(1),i=r(113).EventEmitter;r(31),n.XHRClient=n.util.inherit({handleRequest:function(e,t,r,o){var s=this,a=e.endpoint,u=new i,c=a.protocol+"//"+a.hostname;80!==a.port&&443!==a.port&&(c+=":"+a.port),c+=e.path;var f=new XMLHttpRequest,l=!1;e.stream=f,f.addEventListener("readystatechange",(function(){try{if(0===f.status)return}catch(e){return}this.readyState>=this.HEADERS_RECEIVED&&!l&&(u.statusCode=f.status,u.headers=s.parseHeaders(f.getAllResponseHeaders()),u.emit("headers",u.statusCode,u.headers,f.statusText),l=!0),this.readyState===this.DONE&&s.finishRequest(f,u)}),!1),f.upload.addEventListener("progress",(function(e){u.emit("sendProgress",e)})),f.addEventListener("progress",(function(e){u.emit("receiveProgress",e)}),!1),f.addEventListener("timeout",(function(){o(n.util.error(new Error("Timeout"),{code:"TimeoutError"}))}),!1),f.addEventListener("error",(function(){o(n.util.error(new Error("Network Failure"),{code:"NetworkingError"}))}),!1),f.addEventListener("abort",(function(){o(n.util.error(new Error("Request aborted"),{code:"RequestAbortedError"}))}),!1),r(u),f.open(e.method,c,!1!==t.xhrAsync),n.util.each(e.headers,(function(e,t){"Content-Length"!==e&&"User-Agent"!==e&&"Host"!==e&&f.setRequestHeader(e,t)})),t.timeout&&!1!==t.xhrAsync&&(f.timeout=t.timeout),t.xhrWithCredentials&&(f.withCredentials=!0);try{f.responseType="arraybuffer"}catch(e){}try{e.body?f.send(e.body):f.send()}catch(t){if(!e.body||"object"!=typeof e.body.buffer)throw t;f.send(e.body.buffer)}return u},parseHeaders:function(e){var t={};return n.util.arrayEach(e.split(/\r?\n/),(function(e){var r=e.split(":",1)[0],n=e.substring(r.length+2);r.length>0&&(t[r.toLowerCase()]=n)})),t},finishRequest:function(e,t){var r;if("arraybuffer"===e.responseType&&e.response){var i=e.response;r=new n.util.Buffer(i.byteLength);for(var o=new Uint8Array(i),s=0;s<r.length;++s)r[s]=o[s]}try{r||"string"!=typeof e.responseText||(r=new n.util.Buffer(e.responseText))}catch(e){}r&&t.emit("data",r),t.emit("end")}}),n.HttpClient.prototype=n.XHRClient.prototype,n.HttpClient.streamsApiVersion=1},function(e,t,r){"use strict";var n,i="object"==typeof Reflect?Reflect:null,o=i&&"function"==typeof i.apply?i.apply:function(e,t,r){return Function.prototype.apply.call(e,t,r)};n=i&&"function"==typeof i.ownKeys?i.ownKeys:Object.getOwnPropertySymbols?function(e){return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))}:function(e){return Object.getOwnPropertyNames(e)};var s=Number.isNaN||function(e){return e!=e};function a(){a.init.call(this)}e.exports=a,a.EventEmitter=a,a.prototype._events=void 0,a.prototype._eventsCount=0,a.prototype._maxListeners=void 0;var u=10;function c(e){if("function"!=typeof e)throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof e)}function f(e){return void 0===e._maxListeners?a.defaultMaxListeners:e._maxListeners}function l(e,t,r,n){var i,o,s,a;if(c(r),void 0===(o=e._events)?(o=e._events=Object.create(null),e._eventsCount=0):(void 0!==o.newListener&&(e.emit("newListener",t,r.listener?r.listener:r),o=e._events),s=o[t]),void 0===s)s=o[t]=r,++e._eventsCount;else if("function"==typeof s?s=o[t]=n?[r,s]:[s,r]:n?s.unshift(r):s.push(r),(i=f(e))>0&&s.length>i&&!s.warned){s.warned=!0;var u=new Error("Possible EventEmitter memory leak detected. "+s.length+" "+String(t)+" listeners added. Use emitter.setMaxListeners() to increase limit");u.name="MaxListenersExceededWarning",u.emitter=e,u.type=t,u.count=s.length,a=u,console&&console.warn&&console.warn(a)}return e}function h(){if(!this.fired)return this.target.removeListener(this.type,this.wrapFn),this.fired=!0,0===arguments.length?this.listener.call(this.target):this.listener.apply(this.target,arguments)}function p(e,t,r){var n={fired:!1,wrapFn:void 0,target:e,type:t,listener:r},i=h.bind(n);return i.listener=r,n.wrapFn=i,i}function d(e,t,r){var n=e._events;if(void 0===n)return[];var i=n[t];return void 0===i?[]:"function"==typeof i?r?[i.listener||i]:[i]:r?function(e){for(var t=new Array(e.length),r=0;r<t.length;++r)t[r]=e[r].listener||e[r];return t}(i):m(i,i.length)}function v(e){var t=this._events;if(void 0!==t){var r=t[e];if("function"==typeof r)return 1;if(void 0!==r)return r.length}return 0}function m(e,t){for(var r=new Array(t),n=0;n<t;++n)r[n]=e[n];return r}Object.defineProperty(a,"defaultMaxListeners",{enumerable:!0,get:function(){return u},set:function(e){if("number"!=typeof e||e<0||s(e))throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received '+e+".");u=e}}),a.init=function(){void 0!==this._events&&this._events!==Object.getPrototypeOf(this)._events||(this._events=Object.create(null),this._eventsCount=0),this._maxListeners=this._maxListeners||void 0},a.prototype.setMaxListeners=function(e){if("number"!=typeof e||e<0||s(e))throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received '+e+".");return this._maxListeners=e,this},a.prototype.getMaxListeners=function(){return f(this)},a.prototype.emit=function(e){for(var t=[],r=1;r<arguments.length;r++)t.push(arguments[r]);var n="error"===e,i=this._events;if(void 0!==i)n=n&&void 0===i.error;else if(!n)return!1;if(n){var s;if(t.length>0&&(s=t[0]),s instanceof Error)throw s;var a=new Error("Unhandled error."+(s?" ("+s.message+")":""));throw a.context=s,a}var u=i[e];if(void 0===u)return!1;if("function"==typeof u)o(u,this,t);else{var c=u.length,f=m(u,c);for(r=0;r<c;++r)o(f[r],this,t)}return!0},a.prototype.addListener=function(e,t){return l(this,e,t,!1)},a.prototype.on=a.prototype.addListener,a.prototype.prependListener=function(e,t){return l(this,e,t,!0)},a.prototype.once=function(e,t){return c(t),this.on(e,p(this,e,t)),this},a.prototype.prependOnceListener=function(e,t){return c(t),this.prependListener(e,p(this,e,t)),this},a.prototype.removeListener=function(e,t){var r,n,i,o,s;if(c(t),void 0===(n=this._events))return this;if(void 0===(r=n[e]))return this;if(r===t||r.listener===t)0==--this._eventsCount?this._events=Object.create(null):(delete n[e],n.removeListener&&this.emit("removeListener",e,r.listener||t));else if("function"!=typeof r){for(i=-1,o=r.length-1;o>=0;o--)if(r[o]===t||r[o].listener===t){s=r[o].listener,i=o;break}if(i<0)return this;0===i?r.shift():function(e,t){for(;t+1<e.length;t++)e[t]=e[t+1];e.pop()}(r,i),1===r.length&&(n[e]=r[0]),void 0!==n.removeListener&&this.emit("removeListener",e,s||t)}return this},a.prototype.off=a.prototype.removeListener,a.prototype.removeAllListeners=function(e){var t,r,n;if(void 0===(r=this._events))return this;if(void 0===r.removeListener)return 0===arguments.length?(this._events=Object.create(null),this._eventsCount=0):void 0!==r[e]&&(0==--this._eventsCount?this._events=Object.create(null):delete r[e]),this;if(0===arguments.length){var i,o=Object.keys(r);for(n=0;n<o.length;++n)"removeListener"!==(i=o[n])&&this.removeAllListeners(i);return this.removeAllListeners("removeListener"),this._events=Object.create(null),this._eventsCount=0,this}if("function"==typeof(t=r[e]))this.removeListener(e,t);else if(void 0!==t)for(n=t.length-1;n>=0;n--)this.removeListener(e,t[n]);return this},a.prototype.listeners=function(e){return d(this,e,!0)},a.prototype.rawListeners=function(e){return d(this,e,!1)},a.listenerCount=function(e,t){return"function"==typeof e.listenerCount?e.listenerCount(t):v.call(e,t)},a.prototype.listenerCount=v,a.prototype.eventNames=function(){return this._eventsCount>0?n(this._events):[]}},function(e){e.exports=JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-06-05","endpointPrefix":"mobileanalytics","serviceFullName":"Amazon Mobile Analytics","serviceId":"Mobile Analytics","signatureVersion":"v4","protocol":"rest-json"},"operations":{"PutEvents":{"http":{"requestUri":"/2014-06-05/events","responseCode":202},"input":{"type":"structure","required":["events","clientContext"],"members":{"events":{"type":"list","member":{"type":"structure","required":["eventType","timestamp"],"members":{"eventType":{},"timestamp":{},"session":{"type":"structure","members":{"id":{},"duration":{"type":"long"},"startTimestamp":{},"stopTimestamp":{}}},"version":{},"attributes":{"type":"map","key":{},"value":{}},"metrics":{"type":"map","key":{},"value":{"type":"double"}}}}},"clientContext":{"location":"header","locationName":"x-amz-Client-Context"},"clientContextEncoding":{"location":"header","locationName":"x-amz-Client-Context-Encoding"}}}}},"shapes":{}}')},function(e,t,r){var n,i,o=r(37),s=r(38),a=0,u=0;e.exports=function(e,t,r){var c=t&&r||0,f=t||[],l=(e=e||{}).node||n,h=void 0!==e.clockseq?e.clockseq:i;if(null==l||null==h){var p=o();null==l&&(l=n=[1|p[0],p[1],p[2],p[3],p[4],p[5]]),null==h&&(h=i=16383&(p[6]<<8|p[7]))}var d=void 0!==e.msecs?e.msecs:(new Date).getTime(),v=void 0!==e.nsecs?e.nsecs:u+1,m=d-a+(v-u)/1e4;if(m<0&&void 0===e.clockseq&&(h=h+1&16383),(m<0||d>a)&&void 0===e.nsecs&&(v=0),v>=1e4)throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");a=d,u=v,i=h;var g=(1e4*(268435455&(d+=122192928e5))+v)%4294967296;f[c++]=g>>>24&255,f[c++]=g>>>16&255,f[c++]=g>>>8&255,f[c++]=255&g;var y=d/4294967296*1e4&268435455;f[c++]=y>>>8&255,f[c++]=255&y,f[c++]=y>>>24&15|16,f[c++]=y>>>16&255,f[c++]=h>>>8|128,f[c++]=255&h;for(var b=0;b<6;++b)f[c+b]=l[b];return t||s(f)}},function(e,t,r){var n=r(37),i=r(38);e.exports=function(e,t,r){var o=t&&r||0;"string"==typeof e&&(t="binary"===e?new Array(16):null,e=null);var s=(e=e||{}).random||(e.rng||n)();if(s[6]=15&s[6]|64,s[8]=63&s[8]|128,t)for(var a=0;a<16;++a)t[o+a]=s[a];return t||i(s)}},function(e){e.exports=JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-03-22","endpointPrefix":"personalize-events","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Personalize Events","serviceId":"Personalize Events","signatureVersion":"v4","signingName":"personalize","uid":"personalize-events-2018-03-22"},"operations":{"PutEvents":{"http":{"requestUri":"/events"},"input":{"type":"structure","required":["trackingId","sessionId","eventList"],"members":{"trackingId":{},"userId":{},"sessionId":{},"eventList":{"type":"list","member":{"type":"structure","required":["eventType","properties","sentAt"],"members":{"eventId":{},"eventType":{},"properties":{"jsonvalue":true},"sentAt":{"type":"timestamp"}}}}}}}},"shapes":{}}')},function(e){e.exports=JSON.parse('{"pagination":{}}')},function(e,t,r){"use strict";r.r(t);var n=r(0),i=r.n(n),o=r(39),s=r(40),a=r(6),u=r.n(a),c=r(4);function f(e){return(f="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var l=function(){return(l=Object.assign||function(e){for(var t,r=1,n=arguments.length;r<n;r++)for(var i in t=arguments[r])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e}).apply(this,arguments)},h=function(e,t,r,n){return new(r||(r=Promise))((function(i,o){function s(e){try{u(n.next(e))}catch(e){o(e)}}function a(e){try{u(n.throw(e))}catch(e){o(e)}}function u(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(s,a)}u((n=n.apply(e,t||[])).next())}))},p=function(e,t){var r,n,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(r)throw new TypeError("Generator is already executing.");for(;s;)try{if(r=1,n&&(i=2&o[0]?n.return:o[0]?n.throw||((i=n.return)&&i.call(n),0):n.next)&&!(i=i.call(n,o[1])).done)return i;switch(n=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,n=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=(i=s.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=t.call(e,s)}catch(e){o=[6,e],n=0}finally{r=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}},d=function(e,t){var r={};for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var i=0;for(n=Object.getOwnPropertySymbols(e);i<n.length;i++)t.indexOf(n[i])<0&&Object.prototype.propertyIsEnumerable.call(e,n[i])&&(r[n[i]]=e[n[i]])}return r},v="undefined"!=typeof Symbol&&"function"==typeof Symbol.for?Symbol.for("amplify_default"):"@@amplify_default",m=function(e,t){n.Hub.dispatch("analytics",{event:e,data:t},"Analytics",v)},g=new n.ConsoleLogger("AWSPinpointProvider"),y=[429,500],b=[202],_=navigator&&"function"==typeof navigator.sendBeacon,w=function(){function e(e){this._endpointGenerating=!0,this._buffer=[],this._config=e||{},this._config.bufferSize=this._config.bufferSize||1e3,this._config.flushSize=this._config.flushSize||100,this._config.flushInterval=this._config.flushInterval||5e3,this._config.resendLimit=this._config.resendLimit||5,this._clientInfo=n.ClientDevice.clientInfo()}return e.prototype._setupTimer=function(){var e=this;this._timer&&clearInterval(this._timer);var t=this._config,r=t.flushSize,n=t.flushInterval,i=this;this._timer=setInterval((function(){for(var t=e._buffer.length<r?e._buffer.length:r,n=0;n<t;n+=1){var o=e._buffer.shift(),s=o.params,a=o.handlers;if(i._send(s,a),e._endpointGenerating)break}}),n)},e.prototype._putToBuffer=function(e,t){var r=this._config.bufferSize;if(!(this._buffer.length<r))return g.debug("exceed analytics events buffer size"),t.reject(new Error("Exceed the size of analytics events buffer"));this._buffer.push({params:e,handlers:t})},e.prototype.getCategory=function(){return e.category},e.prototype.getProviderName=function(){return e.providerName},e.prototype.configure=function(e){var t=this;g.debug("configure Analytics",e);var r=e||{};if(this._config=Object.assign({},this._config,r),this._config.appId&&!this._config.disabled){if(this._config.endpointId)m("pinpointProvider_configured",null);else{var n=this.getProviderName()+"_"+this._config.appId;this._getEndpointId(n).then((function(e){g.debug("setting endpoint id from the cache",e),t._config.endpointId=e,m("pinpointProvider_configured",null)})).catch((function(e){g.debug("Failed to generate endpointId",e)}))}this._setupTimer()}else this._timer&&clearInterval(this._timer);return this._config},e.prototype.record=function(e,t){return h(this,void 0,void 0,(function(){var r,n;return p(this,(function(i){switch(i.label){case 0:return[4,this._getCredentials()];case 1:return(r=i.sent())&&this._config.appId&&this._config.region?(n=(new Date).getTime(),this._generateSession(e),e.event.eventId=Object(c.v1)(),Object.assign(e,{timestamp:n,config:this._config,credentials:r}),e.event.immediate?[2,this._send(e,t)]:(this._putToBuffer(e,t),[2])):(g.debug("cannot send events without credentials, applicationId or region"),[2,t.reject(new Error("No credentials, applicationId or region"))])}}))}))},e.prototype._generateSession=function(e){this._sessionId=this._sessionId||Object(c.v1)();var t=e.event;switch(t.name){case"_session.start":this._sessionStartTimestamp=(new Date).getTime(),this._sessionId=Object(c.v1)(),t.session={Id:this._sessionId,StartTimestamp:new Date(this._sessionStartTimestamp).toISOString()};break;case"_session.stop":var r=(new Date).getTime();this._sessionStartTimestamp=this._sessionStartTimestamp||(new Date).getTime(),this._sessionId=this._sessionId||Object(c.v1)(),t.session={Id:this._sessionId,Duration:r-this._sessionStartTimestamp,StartTimestamp:new Date(this._sessionStartTimestamp).toISOString(),StopTimestamp:new Date(r).toISOString()},this._sessionId=void 0,this._sessionStartTimestamp=void 0;break;default:this._sessionStartTimestamp=this._sessionStartTimestamp||(new Date).getTime(),this._sessionId=this._sessionId||Object(c.v1)(),t.session={Id:this._sessionId,StartTimestamp:new Date(this._sessionStartTimestamp).toISOString()}}},e.prototype._send=function(e,t){return h(this,void 0,void 0,(function(){var r;return p(this,(function(n){switch(r=e.event,e.config,r.name){case"_update_endpoint":return[2,this._updateEndpoint(e,t)];case"_session.stop":return[2,this._pinpointSendStopSession(e,t)];default:return[2,this._record(e,t)]}return[2]}))}))},e.prototype._generateBatchItemContext=function(e){var t=e.event,r=e.timestamp,n=e.config,i=(e.credentials,t.name),o=t.attributes,s=t.metrics,a=t.eventId,u=t.session,c=n.appId,f=n.endpointId,l={ApplicationId:c,EventsRequest:{BatchItem:{}}};l.EventsRequest.BatchItem[f]={};var h=l.EventsRequest.BatchItem[f];return h.Endpoint={},h.Events={},h.Events[a]={EventType:i,Timestamp:new Date(r).toISOString(),Attributes:o,Metrics:s,Session:u},l},e.prototype._pinpointPutEvents=function(e,t){return h(this,void 0,void 0,(function(){var r,n,i,o,s=this;return p(this,(function(a){return r=e.event.eventId,n=e.config.endpointId,i=this._generateBatchItemContext(e),(o=this.pinpointClient.putEvents(i)).on("build",(function(){o.httpRequest.path=o.httpRequest.path+"/legacy"})),o.send((function(i,o){if(i)return g.error("record event failed. ",i),g.warn('If you have not updated your Pinpoint IAM Policy with the Action: "mobiletargeting:PutEvents" yet, please do it. This action is not necessary for now but in order to avoid breaking changes in the future, please update it as soon as possible.'),t.reject(i);var a=n,u=r,c=o.EventsResponse.Results[a].EventsItemResponse[u],f=c.StatusCode,l=c.Message;return b.includes(f)?(s._endpointGenerating=!1,g.debug("record event success. ",o),t.resolve(o)):y.includes(f)?void s._retry(e,t):(g.error("Event "+r+" is not accepted, the error is "+l),t.reject(o))})),[2]}))}))},e.prototype._pinpointSendStopSession=function(e,t){if(_){var r=this._generateBatchItemContext(e),i=this._config.region,o=r.ApplicationId,s=r.EventsRequest,a={secret_key:this._config.credentials.secretAccessKey,access_key:this._config.credentials.accessKeyId,session_token:this._config.credentials.sessionToken},u="https://pinpoint."+i+".amazonaws.com/v1/apps/"+o+"/events",c=JSON.stringify(s),f={url:u,body:c,method:"POST"},l={region:i,service:"mobiletargeting"},h=n.Signer.signUrl(f,a,l,null);return navigator.sendBeacon(h,c)?t.resolve("sendBeacon success"):t.reject("sendBeacon failure")}this._record(e,t)},e.prototype._retry=function(e,t){var r=e.config.resendLimit;e.resendLimit="number"==typeof e.resendLimit?e.resendLimit:r,e.resendLimit-- >0?(g.debug("resending event "+e.eventName+" with "+e.resendLimit+" retry times left"),this._putToBuffer(e,t)):g.debug("retry times used up for event "+e.eventName)},e.prototype._record=function(e,t){return h(this,void 0,void 0,(function(){var r,n;return p(this,(function(i){return e.event,e.timestamp,r=e.config,n=e.credentials,this._initClients(r,n),[2,this._pinpointPutEvents(e,t)]}))}))},e.prototype._updateEndpoint=function(e,t){return h(this,void 0,void 0,(function(){var r,i,o,s,a,u,c,f,l=this;return p(this,(function(h){return e.timestamp,r=e.config,i=e.credentials,o=e.event,s=r.appId,r.region,a=r.endpointId,this._initClients(r,i),u=this._endpointRequest(r,n.JS.transferKeyToLowerCase(o,[],["attributes","userAttributes","Attributes","UserAttributes"])),c={ApplicationId:s,EndpointId:a,EndpointRequest:u},f=this,g.debug("updateEndpoint with params: ",c),f.pinpointClient.updateEndpoint(c,(function(r,n){return r?(g.debug("updateEndpoint failed",r),r.message.startsWith("Exceeded maximum endpoint per user count")?void l._removeUnusedEndpoints(s,u.User.UserId).then((function(){g.debug("Remove the unused endpoints successfully"),l._retry(e,t)})).catch((function(e){return g.warn("Failed to remove unused endpoints with error: "+e),g.warn('Please ensure you have updated your Pinpoint IAM Policy with the Action: "mobiletargeting:GetUserEndpoints" in order to get endpoints info of the user'),t.reject(r)})):t.reject(r)):(g.debug("updateEndpoint success",n),l._endpointGenerating=!1,t.resolve(n))})),[2]}))}))},e.prototype._removeUnusedEndpoints=function(e,t){return h(this,void 0,void 0,(function(){var r=this;return p(this,(function(n){return[2,new Promise((function(n,i){r.pinpointClient.getUserEndpoints({ApplicationId:e,UserId:t},(function(o,s){if(o)return g.debug("Failed to get endpoints associated with the userId: "+t+" with error",o),i(o);var a=s.EndpointsResponse.Item;g.debug("get endpoints associated with the userId: "+t+" with data",a);for(var u=a[0],c=1;c<a.length;c++){var f=Date.parse(u.EffectiveDate),l=Date.parse(a[c].EffectiveDate);if(isNaN(f))break;if(isNaN(l)){u=a[c];break}l<f&&(u=a[c])}var h={ApplicationId:e,EndpointId:u.Id,EndpointRequest:{User:{UserId:""}}};r.pinpointClient.updateEndpoint(h,(function(e,t){return e?(g.debug("Failed to update the endpoint",e),i(e)):(g.debug("The old endpoint is updated with an empty string for user id"),n(t))}))}))}))]}))}))},e.prototype._initClients=function(e,t){return h(this,void 0,void 0,(function(){var r;return p(this,(function(i){return g.debug("init clients"),this.mobileAnalytics&&this.pinpointClient&&this._config.credentials&&this._config.credentials.sessionToken===t.sessionToken&&this._config.credentials.identityId===t.identityId?(g.debug("no change for aws credentials, directly return from init"),[2]):(this._config.credentials=t,r=e.region,g.debug("init clients with credentials",t),this.mobileAnalytics=new o({credentials:t,region:r}),this.pinpointClient=new s({region:r,credentials:t}),n.Platform.isReactNative&&this.pinpointClient.customizeRequests((function(e){e.on("build",(function(e){e.httpRequest.headers["user-agent"]=n.Platform.userAgent}))})),[2])}))}))},e.prototype._getEndpointId=function(e){return h(this,void 0,void 0,(function(){var t;return p(this,(function(r){switch(r.label){case 0:return[4,u.a.getItem(e)];case 1:return t=r.sent(),g.debug("endpointId from cache",t,"type",f(t)),t||(t=Object(c.v1)(),u.a.setItem(e,t)),[2,t]}}))}))},e.prototype._endpointRequest=function(e,t){var r=e.credentials,i=this._clientInfo||{},o=e.clientContext||{},s=e.endpoint||{},a={appVersion:i.appVersion,make:i.make,model:i.model,modelVersion:i.version,platform:i.platform},u=(o.clientId,o.appTitle,o.appVersionName,o.appVersionCode,o.appPackageName,d(o,["clientId","appTitle","appVersionName","appVersionCode","appPackageName"])),f=t.address?"android"===i.platform?"GCM":"APNS":void 0,h=l(l(l({channelType:f,requestId:Object(c.v1)(),effectiveDate:(new Date).toISOString()},s),t),{attributes:l(l({},s.attributes),t.attributes),demographic:l(l(l(l({},a),u),s.demographic),t.demographic),location:l(l({},s.location),t.location),metrics:l(l({},s.metrics),t.metrics),user:{userId:t.userId||s.userId||r.identityId,userAttributes:l(l({},s.userAttributes),t.userAttributes)}}),p=(h.userId,h.userAttributes,h.name,h.session,h.eventId,h.immediate,d(h,["userId","userAttributes","name","session","eventId","immediate"]));return n.JS.transferKeyToUpperCase(p,[],["metrics","userAttributes","attributes"])},e.prototype._getCredentials=function(){return n.Credentials.get().then((function(e){return e?(g.debug("set credentials for analytics",e),n.Credentials.shear(e)):null})).catch((function(e){return g.debug("ensure credentials error",e),null}))},e.category="Analytics",e.providerName="AWSPinpoint",e}(),E=[],S=function(){function e(e,t){this.context=e,this.methodName=t,this._originalMethod=e[t].bind(e)}return e.add=function(e,t,r){x(e,t).set(r)},e.remove=function(e,t){x(e,t).remove()},e.prototype.set=function(e){var t=this;this.context[this.methodName]=function(){for(var r=[],n=0;n<arguments.length;n++)r[n]=arguments[n];return e(t._originalMethod.apply(t,r))}},e.prototype.remove=function(){this.context[this.methodName]=this._originalMethod},e}(),A=S;function x(e,t){var r=E.filter((function(r){return r.context===e&&r.methodName===t}))[0];return r||(r=new S(e,t),E.push(r)),r}var I=function(e,t,r,n){return new(r||(r=Promise))((function(i,o){function s(e){try{u(n.next(e))}catch(e){o(e)}}function a(e){try{u(n.throw(e))}catch(e){o(e)}}function u(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(s,a)}u((n=n.apply(e,t||[])).next())}))},C=function(e,t){var r,n,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(r)throw new TypeError("Generator is already executing.");for(;s;)try{if(r=1,n&&(i=2&o[0]?n.return:o[0]?n.throw||((i=n.return)&&i.call(n),0):n.next)&&!(i=i.call(n,o[1])).done)return i;switch(n=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,n=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=(i=s.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=t.call(e,s)}catch(e){o=[6,e],n=0}finally{r=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}},R=new n.ConsoleLogger("PageViewTracker"),T="aws-amplify-analytics-prevUrl",k={enable:!1,provider:"AWSPinpoint",getUrl:function(){return n.JS.browserOrNode().isBrowser?window.location.origin+window.location.pathname:""}},P=function(){function e(e,t){R.debug("initialize pageview tracker with opts",t),this._config=Object.assign({},k,t),this._tracker=e,this._hasEnabled=!1,this._trackFunc=this._trackFunc.bind(this),"SPA"===this._config.type?this._pageViewTrackSPA():this._pageViewTrackDefault()}return e.prototype.configure=function(e){return Object.assign(this._config,e),"SPA"===this._config.type&&this._pageViewTrackSPA(),this._config},e.prototype._isSameUrl=function(){return sessionStorage.getItem(T)===this._config.getUrl()&&(R.debug("the url is same"),!0)},e.prototype._pageViewTrackDefault=function(){return I(this,void 0,void 0,(function(){var e,t,r,i;return C(this,(function(o){switch(o.label){case 0:return n.JS.browserOrNode().isBrowser&&window.addEventListener&&window.sessionStorage?(e=this._config.getUrl(),"function"!=typeof this._config.attributes?[3,2]:[4,this._config.attributes()]):(R.debug("not in the supported web enviroment"),[2]);case 1:return r=o.sent(),[3,3];case 2:r=this._config.attributes,o.label=3;case 3:return t=r,i=Object.assign({url:e},t),this._config.enable&&!this._isSameUrl()&&(this._tracker({name:this._config.eventName||"pageView",attributes:i},this._config.provider).catch((function(e){R.debug("Failed to record the page view event",e)})),sessionStorage.setItem(T,e)),[2]}}))}))},e.prototype._trackFunc=function(){return I(this,void 0,void 0,(function(){var e,t,r,i;return C(this,(function(o){switch(o.label){case 0:return n.JS.browserOrNode().isBrowser&&window.addEventListener&&history.pushState&&window.sessionStorage?(e=this._config.getUrl(),"function"!=typeof this._config.attributes?[3,2]:[4,this._config.attributes()]):(R.debug("not in the supported web enviroment"),[2]);case 1:return r=o.sent(),[3,3];case 2:r=this._config.attributes,o.label=3;case 3:return t=r,i=Object.assign({url:e},t),this._isSameUrl()||(this._tracker({name:this._config.eventName||"pageView",attributes:i},this._config.provider).catch((function(e){R.debug("Failed to record the page view event",e)})),sessionStorage.setItem(T,e)),[2]}}))}))},e.prototype._pageViewTrackSPA=function(){n.JS.browserOrNode().isBrowser&&window.addEventListener&&history.pushState?this._config.enable&&!this._hasEnabled?(A.add(history,"pushState",this._trackFunc),A.add(history,"replaceState",this._trackFunc),window.addEventListener("popstate",this._trackFunc),this._trackFunc(),this._hasEnabled=!0):(A.remove(history,"pushState"),A.remove(history,"replaceState"),window.removeEventListener("popstate",this._trackFunc),this._hasEnabled=!1):R.debug("not in the supported web enviroment")},e}(),O=n.JS.browserOrNode().isBrowser&&window.Element?window.Element.prototype:null,L=O?O.matches||O.matchesSelector||O.webkitMatchesSelector||O.mozMatchesSelector||O.msMatchesSelector||O.oMatchesSelector:null;function q(e,t){if(e&&1===e.nodeType&&t){if("string"==typeof t||1===t.nodeType)return e===t||N(e,t);if("length"in t)for(var r=0,n=void 0;n=t[r];r++)if(e===n||N(e,n))return!0}return!1}function N(e,t){if("string"!=typeof t)return!1;if(L)return L.call(e,t);for(var r=e.parentNode.querySelectorAll(t),n=0,i=void 0;i=r[n];n++)if(i===e)return!0;return!1}function j(e,t,r,n,i){void 0===i&&(i={});var o=function(e){var t;if(i.composed&&"function"==typeof e.composedPath)for(var o=e.composedPath(),s=0,a=void 0;a=o[s];s++)1===a.nodeType&&q(a,r)&&(t=a);else t=function(e,t,r){if(void 0===r&&(r=!1),e&&1===e.nodeType&&t)for(var n,i=(r?[e]:[]).concat(function(e){for(var t=[],r=e;r&&r.parentNode&&1===r.parentNode.nodeType;)r=r.parentNode,t.push(r);return t}(e)),o=0;n=i[o];o++)if(q(n,t))return n}(e.target,r,!0);t&&n.call(t,e,t)};return e.addEventListener(t,o,i.useCapture),{destroy:function(){e.removeEventListener(t,o,i.useCapture)}}}RegExp(":(80|443)$"),n.JS.browserOrNode().isBrowser&&document.createElement("a");var D,U,M,B=function(e,t,r,n){return new(r||(r=Promise))((function(i,o){function s(e){try{u(n.next(e))}catch(e){o(e)}}function a(e){try{u(n.throw(e))}catch(e){o(e)}}function u(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(s,a)}u((n=n.apply(e,t||[])).next())}))},z=function(e,t){var r,n,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(r)throw new TypeError("Generator is already executing.");for(;s;)try{if(r=1,n&&(i=2&o[0]?n.return:o[0]?n.throw||((i=n.return)&&i.call(n),0):n.next)&&!(i=i.call(n,o[1])).done)return i;switch(n=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,n=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=(i=s.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=t.call(e,s)}catch(e){o=[6,e],n=0}finally{r=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}},F=new n.ConsoleLogger("EventTracker"),V={enable:!1,events:["click"],selectorPrefix:"data-amplify-analytics-",provider:"AWSPinpoint"},H=function(){function e(e,t){n.JS.browserOrNode().isBrowser&&window.addEventListener?(this._config=Object.assign({},V,t),this._tracker=e,this._delegates={},this._trackFunc=this._trackFunc.bind(this),F.debug("initialize pageview tracker with opts",this._config),this.configure(this._config)):F.debug("not in the supported web environment")}return e.prototype.configure=function(e){var t=this;if(Object.assign(this._config,e),this._config.enable){if(this._config.enable&&0===Object.keys(this._delegates).length){var r="["+this._config.selectorPrefix+"on]";this._config.events.forEach((function(e){t._delegates[e]=j(document,e,r,t._trackFunc,{composed:!0,useCapture:!0})}))}}else Object.keys(this._delegates).forEach((function(e){"function"==typeof t._delegates[e].destroy&&t._delegates[e].destroy()})),this._delegates={};return this._config},e.prototype._trackFunc=function(e,t){return B(this,void 0,void 0,(function(){var r,n,i,o,s,a,u;return z(this,(function(c){switch(c.label){case 0:return r={},n=t.getAttribute(this._config.selectorPrefix+"on").split(/\s*,\s*/),i=t.getAttribute(this._config.selectorPrefix+"name"),(o=t.getAttribute(this._config.selectorPrefix+"attrs"))&&o.split(/\s*,\s*/).forEach((function(e){var t=e.trim().split(/\s*:\s*/);r[t[0]]=t[1]})),"function"!=typeof this._config.attributes?[3,2]:[4,this._config.attributes()];case 1:return a=c.sent(),[3,3];case 2:a=this._config.attributes,c.label=3;case 3:return s=a,u=Object.assign({type:e.type,target:e.target.localName+" with id "+e.target.id},s,r),F.debug("events needed to be recorded",n),F.debug("attributes needed to be attached",r),n.indexOf(e.type)<0?(F.debug("event "+e.type+" is not selected to be recorded"),[2]):(this._tracker({name:i||"event",attributes:u},this._config.provider).catch((function(t){F.debug("Failed to record the "+e.type+" event', "+t)})),[2])}}))}))},e}(),W=function(e,t,r,n){return new(r||(r=Promise))((function(i,o){function s(e){try{u(n.next(e))}catch(e){o(e)}}function a(e){try{u(n.throw(e))}catch(e){o(e)}}function u(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(s,a)}u((n=n.apply(e,t||[])).next())}))},K=function(e,t){var r,n,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(r)throw new TypeError("Generator is already executing.");for(;s;)try{if(r=1,n&&(i=2&o[0]?n.return:o[0]?n.throw||((i=n.return)&&i.call(n),0):n.next)&&!(i=i.call(n,o[1])).done)return i;switch(n=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,n=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=(i=s.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=t.call(e,s)}catch(e){o=[6,e],n=0}finally{r=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}},X=new n.ConsoleLogger("SessionTracker"),G={enable:!1,provider:"AWSPinpoint"},Y=!1,J=function(){function e(e,t){this._config=Object.assign({},G,t),this._tracker=e,this._hasEnabled=!1,this._trackFunc=this._trackFunc.bind(this),this._trackBeforeUnload=this._trackBeforeUnload.bind(this),this.configure(this._config)}return e.prototype._envCheck=function(){if(!n.JS.browserOrNode().isBrowser)return!1;if(!document||!document.addEventListener)return X.debug("not in the supported web environment"),!1;if(void 0!==document.hidden)this._hidden="hidden",this._visibilityChange="visibilitychange";else if(void 0!==document.msHidden)this._hidden="msHidden",this._visibilityChange="msvisibilitychange";else{if(void 0===document.webkitHidden)return X.debug("not in the supported web environment"),!1;this._hidden="webkitHidden",this._visibilityChange="webkitvisibilitychange"}return!0},e.prototype._trackFunc=function(){return W(this,void 0,void 0,(function(){var e,t,r;return K(this,(function(n){switch(n.label){case 0:return"function"!=typeof this._config.attributes?[3,2]:[4,this._config.attributes()];case 1:return t=n.sent(),[3,3];case 2:t=this._config.attributes,n.label=3;case 3:return e=t,r=Object.assign({},e),document.visibilityState===this._hidden?this._tracker({name:"_session.stop",attributes:r},this._config.provider).catch((function(e){X.debug("record session stop event failed.",e)})):this._tracker({name:"_session.start",attributes:r},this._config.provider).catch((function(e){X.debug("record session start event failed.",e)})),[2]}}))}))},e.prototype._trackBeforeUnload=function(e){var t=this;("function"==typeof this._config.attributes?Promise.resolve(this._config.attributes()):Promise.resolve(this._config.attributes)).then((function(e){var r=Object.assign({},e);t._tracker({name:"_session.stop",attributes:r,immediate:!0},t._config.provider).catch((function(e){X.debug("record session stop event failed.",e)}))}))},e.prototype._sendInitialEvent=function(){return W(this,void 0,void 0,(function(){var e,t,r;return K(this,(function(n){switch(n.label){case 0:return Y?(X.debug("the start session has been sent when the page is loaded"),[2]):(Y=!0,"function"!=typeof this._config.attributes?[3,2]:[4,this._config.attributes()]);case 1:return t=n.sent(),[3,3];case 2:t=this._config.attributes,n.label=3;case 3:return e=t,r=Object.assign({},e),this._tracker({name:"_session.start",attributes:r},this._config.provider).catch((function(e){X.debug("record session start event failed.",e)})),[2]}}))}))},e.prototype.configure=function(e){return this._envCheck()?(Object.assign(this._config,e),this._config.enable&&!this._hasEnabled?(this._sendInitialEvent(),document.addEventListener(this._visibilityChange,this._trackFunc,!1),window.addEventListener("beforeunload",this._trackBeforeUnload,!1),this._hasEnabled=!0):!this._config.enable&&this._hasEnabled&&(document.removeEventListener(this._visibilityChange,this._trackFunc,!1),window.removeEventListener("beforeunload",this._trackBeforeUnload,!1),this._hasEnabled=!1),this._config):this._config},e}(),$=function(){return($=Object.assign||function(e){for(var t,r=1,n=arguments.length;r<n;r++)for(var i in t=arguments[r])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e}).apply(this,arguments)},Z=function(e,t,r,n){return new(r||(r=Promise))((function(i,o){function s(e){try{u(n.next(e))}catch(e){o(e)}}function a(e){try{u(n.throw(e))}catch(e){o(e)}}function u(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(s,a)}u((n=n.apply(e,t||[])).next())}))},Q=function(e,t){var r,n,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(r)throw new TypeError("Generator is already executing.");for(;s;)try{if(r=1,n&&(i=2&o[0]?n.return:o[0]?n.throw||((i=n.return)&&i.call(n),0):n.next)&&!(i=i.call(n,o[1])).done)return i;switch(n=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,n=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=(i=s.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=t.call(e,s)}catch(e){o=[6,e],n=0}finally{r=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}},ee=new n.ConsoleLogger("AnalyticsClass"),te="undefined"!=typeof Symbol&&"function"==typeof Symbol.for?Symbol.for("amplify_default"):"@@amplify_default",re={pageView:P,event:H,session:J},ne=function(){function e(){this._config={},this._pluggables=[],this._disabled=!1,this._trackers={},this.record=this.record.bind(this)}return e.prototype.getModuleName=function(){return"Analytics"},e.prototype.configure=function(e){var t=this;if(!e)return this._config;ee.debug("configure Analytics",e);var r,i,o,s=n.Parser.parseMobilehubConfig(e);return this._config=Object.assign({},this._config,s.Analytics,e),this._config.disabled&&(this._disabled=!0),this._pluggables.forEach((function(e){var r="AWSPinpoint"!==e.getProviderName()||t._config.AWSPinpoint?t._config[e.getProviderName()]:t._config;e.configure($({disabled:t._config.disabled},r))})),0===this._pluggables.length&&this.addPluggable(new w),void 0===this._config.autoSessionRecord&&(this._config.autoSessionRecord=!0),r="configured",i=null,o="The Analytics category has been configured successfully",n.Hub.dispatch("analytics",{event:r,data:i,message:o},"Analytics",te),ee.debug("current configuration",this._config),this._config},e.prototype.addPluggable=function(e){if(e&&"Analytics"===e.getCategory()){this._pluggables.push(e);var t="AWSPinpoint"!==e.getProviderName()||this._config.AWSPinpoint?this._config[e.getProviderName()]:this._config,r=$({disabled:this._config.disabled},t);return e.configure(r),r}},e.prototype.getPluggable=function(e){for(var t=0;t<this._pluggables.length;t+=1){var r=this._pluggables[t];if(r.getProviderName()===e)return r}return ee.debug("No plugin found with providerName",e),null},e.prototype.removePluggable=function(e){for(var t=0;t<this._pluggables.length&&this._pluggables[t].getProviderName()!==e;)t+=1;return t===this._pluggables.length?void ee.debug("No plugin found with providerName",e):void this._pluggables.splice(t,t+1)},e.prototype.disable=function(){this._disabled=!0},e.prototype.enable=function(){this._disabled=!1},e.prototype.startSession=function(e){return Z(this,void 0,void 0,(function(){var t;return Q(this,(function(r){return t={event:{name:"_session.start"},provider:e},[2,this._sendEvent(t)]}))}))},e.prototype.stopSession=function(e){return Z(this,void 0,void 0,(function(){var t;return Q(this,(function(r){return t={event:{name:"_session.stop"},provider:e},[2,this._sendEvent(t)]}))}))},e.prototype.record=function(e,t,r){return Z(this,void 0,void 0,(function(){var n,i;return Q(this,(function(o){return this.isAnalyticsConfigured()?(i=null,i="string"==typeof e?{event:{name:e,attributes:t,metrics:r},provider:"AWSPinpoint"}:{event:e,provider:t},[2,this._sendEvent(i)]):(n="Analytics has not been configured",ee.debug(n),[2,Promise.reject(new Error(n))])}))}))},e.prototype.updateEndpoint=function(e,t){return Z(this,void 0,void 0,(function(){var r;return Q(this,(function(n){return r=Object.assign({name:"_update_endpoint"},e),[2,this.record(r,t)]}))}))},e.prototype._sendEvent=function(e){var t=this;if(!this.isAnalyticsConfigured()){var r="Analytics has not been configured";return ee.debug(r),Promise.reject(new Error(r))}if(this._disabled)return ee.debug("Analytics has been disabled"),Promise.resolve();var n=e.provider?e.provider:"AWSPinpoint";return new Promise((function(r,i){t._pluggables.forEach((function(t){t.getProviderName()===n&&t.record(e,{resolve:r,reject:i})}))}))},e.prototype.autoTrack=function(e,t){if(re[e]){"session"===e&&(this._config.autoSessionRecord=t.enable);var r=this._trackers[e];r?r.configure(t):this._trackers[e]=new re[e](this.record,t)}else ee.debug("invalid tracker type")},e.prototype.isAnalyticsConfigured=function(){return this._config&&Object.entries(this._config).length>0},e}(),ie=r(41),oe=function(e,t,r,n){return new(r||(r=Promise))((function(i,o){function s(e){try{u(n.next(e))}catch(e){o(e)}}function a(e){try{u(n.throw(e))}catch(e){o(e)}}function u(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(s,a)}u((n=n.apply(e,t||[])).next())}))},se=function(e,t){var r,n,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(r)throw new TypeError("Generator is already executing.");for(;s;)try{if(r=1,n&&(i=2&o[0]?n.return:o[0]?n.throw||((i=n.return)&&i.call(n),0):n.next)&&!(i=i.call(n,o[1])).done)return i;switch(n=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,n=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=(i=s.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=t.call(e,s)}catch(e){o=[6,e],n=0}finally{r=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}},ae=new n.ConsoleLogger("AWSKineisProvider"),ue=function(){function e(e){this._buffer=[],this._config=e||{},this._config.bufferSize=this._config.bufferSize||1e3,this._config.flushSize=this._config.flushSize||100,this._config.flushInterval=this._config.flushInterval||5e3,this._config.resendLimit=this._config.resendLimit||5;this._setupTimer()}return e.prototype._setupTimer=function(){var e=this;this._timer&&clearInterval(this._timer);var t=this._config,r=t.flushSize,n=t.flushInterval,i=this;this._timer=setInterval((function(){for(var t=e._buffer.length<r?e._buffer.length:r,n=[],o=0;o<t;o+=1){var s=e._buffer.shift();n.push(s)}i._sendFromBuffer(n)}),n)},e.prototype.getCategory=function(){return"Analytics"},e.prototype.getProviderName=function(){return"AWSKinesis"},e.prototype.configure=function(e){ae.debug("configure Analytics",e);var t=e||{};return this._config=Object.assign({},this._config,t),this._setupTimer(),this._config},e.prototype.record=function(e){return oe(this,void 0,void 0,(function(){var t;return se(this,(function(r){switch(r.label){case 0:return[4,this._getCredentials()];case 1:return(t=r.sent())?(Object.assign(e,{config:this._config,credentials:t}),[2,this._putToBuffer(e)]):[2,Promise.resolve(!1)]}}))}))},e.prototype.updateEndpoint=function(e){return ae.debug("updateEndpoint is not implemented in Kinesis provider"),Promise.resolve(!0)},e.prototype._putToBuffer=function(e){return this._buffer.length<1e3?(this._buffer.push(e),Promise.resolve(!0)):(ae.debug("exceed analytics events buffer size"),Promise.reject(!1))},e.prototype._sendFromBuffer=function(e){for(var t=this,r=[],n=null,i=[],o=0;o<e.length;o+=1){var s=e[o].credentials;0===o?(i.push(e[o]),n=s):s.sessionToken===n.sessionToken&&s.identityId===n.identityId?(ae.debug("no change for cred, put event in the same group"),i.push(e[o])):(r.push(i),(i=[]).push(e[o]),n=s)}r.push(i),r.map((function(e){t._sendEvents(e)}))},e.prototype._sendEvents=function(e){var t=this;if(0!==e.length){var r=e[0],n=r.config,i=r.credentials;if(!this._init(n,i))return!1;var o={};e.map((function(e){var t=e.event,r=t.streamName;void 0===o[r]&&(o[r]=[]);var n={Data:JSON.stringify(t.data),PartitionKey:t.partitionKey||"partition-"+i.identityId};o[r].push(n)})),Object.keys(o).map((function(e){ae.debug("putting records to kinesis with records",o[e]),t._kinesis.putRecords({Records:o[e],StreamName:e},(function(t,r){t?ae.debug("Failed to upload records to Kinesis",t):ae.debug("Upload records to stream",e)}))}))}},e.prototype._init=function(e,t){if(ae.debug("init clients"),this._kinesis&&this._config.credentials&&this._config.credentials.sessionToken===t.sessionToken&&this._config.credentials.identityId===t.identityId)return ae.debug("no change for analytics config, directly return from init"),!0;this._config.credentials=t;var r=e.region;return ae.debug("initialize kinesis with credentials",t),this._kinesis=new ie({apiVersion:"2013-12-02",region:r,credentials:t}),!0},e.prototype._getCredentials=function(){var e=this;return n.Credentials.get().then((function(t){return t?(ae.debug("set credentials for analytics",e._config.credentials),n.Credentials.shear(t)):null})).catch((function(e){return ae.debug("ensure credentials error",e),null}))},e}(),ce=r(42),fe=r(3),le=(new n.ConsoleLogger("AmazonPersonalizeProvider"),function(){function e(e){void 0===e&&(e=""),this._isBrowser=n.JS.browserOrNode().isBrowser,this._timerKey=Object(c.v1)().substr(0,15),this._refreshTimer()}return e.prototype._refreshTimer=function(){this._timer&&clearInterval(this._timer);var e=this;this._timer=setInterval((function(){e._timerKey=Object(c.v1)().substr(0,15)}),3e4)},e.prototype.storeValue=function(e,t){var r=new Date,n=new Date;n.setTime(r.getTime()+6048e5),u.a.setItem(this._getCachePrefix(e),t,{expires:n.getTime()})},e.prototype.retrieveValue=function(e){return u.a.getItem(this._getCachePrefix(e))},e.prototype._getCachePrefix=function(e){return this._isBrowser?e+"."+window.location.host:"peronslize"},e.prototype.getTimerKey=function(){return this._timerKey},e.prototype.updateSessionInfo=function(e,t){var r=t.userId,n=t.sessionId;if(this._isRequireNewSession(e,r,n)){var i=Object(c.v1)();this.storeValue("_awsct_uid",e),this.storeValue("_awsct_sid",i),t.sessionId=i}else this._isRequireUpdateSessionInfo(e,r,n)&&this.storeValue("_awsct_uid",e);t.userId=e},e.prototype._isRequireUpdateSessionInfo=function(e,t,r){return!Object(fe.isEmpty)(r)&&Object(fe.isEmpty)(t)&&!Object(fe.isEmpty)(e)},e.prototype.retrieveSessionInfo=function(e){var t={};return t.trackingId=e,t.sessionId=this.retrieveValue("_awsct_sid"),t.userId=this.retrieveValue("_awsct_uid"),Object(fe.isEmpty)(t.sessionId)&&(t.sessionId=Object(c.v1)(),this.storeValue("_awsct_sid",t.sessionId)),this.storeValue("_awsct",e),t},e.prototype._isRequireNewSession=function(e,t,r){var n=Object(fe.isEmpty)(r),i=Object(fe.isEmpty)(e)&&!Object(fe.isEmpty)(t),o=!Object(fe.isEmpty)(e)&&!Object(fe.isEmpty)(t)&&!Object(fe.isEqual)(e,t);return n||i||o},e}());!function(e){e.PLAY="play",e.PAUSE="pause",e.ENDED="Ended"}(D||(D={})),function(e){e.IFRAME="IFRAME",e.VIDEO="VIDEO",e.AUDIO="AUDIO"}(U||(U={})),function(e){e.PLAY="Play",e.ENDED="Ended",e.PAUSE="Pause",e.TIME_WATCHED="TimeWatched"}(M||(M={}));var he=function(){function e(e,t){var r;this.eventActionMapping=((r={})[M.ENDED]=this.endedEventAction.bind(this),r[M.PLAY]=this.playEventAction.bind(this),r[M.PAUSE]=this.pauseEventAction.bind(this),r);var n=e.eventData;this._params=e,this._mediaElement=document.getElementById(n.properties.domElementId),this._started=!1,this._provider=t,{IFRAME:this._iframeMediaTracker,VIDEO:this._html5MediaTracker,AUDIO:this._html5MediaTracker}[this._mediaElement.tagName].bind(this)(),this._initYoutubeFrame()}return e.prototype._initYoutubeFrame=function(){this._youTubeIframeLoader={src:"https://www.youtube.com/iframe_api",loading:!1,loaded:!1,listeners:[],load:function(e){var t=this;if(this.listeners.push(e),this.loaded)setTimeout((function(){t.done()}));else if(!this.loading){this.loading=!0,window.onYouTubeIframeAPIReady=function(){t.loaded=!0,t.done()};var r=document.createElement("script");r.type="text/javascript",r.src=this.src,document.body.appendChild(r)}},done:function(){for(delete window.onYouTubeIframeAPIReady;this.listeners.length;)this.listeners.pop()(window.YT)}}},e.prototype._iframeMediaTracker=function(){var e=this;setInterval((function(){e._started&&e.recordEvent(U.IFRAME,M.TIME_WATCHED)}),3e3),this._youTubeIframeLoader.load((function(t){e._iframePlayer=new t.Player(e._mediaElement.id,{events:{onStateChange:e._onPlayerStateChange.bind(e)}})}))},e.prototype._onPlayerStateChange=function(e){var t={0:M.ENDED,1:M.PLAY,2:M.PAUSE}[e.data];t&&this.eventActionMapping[t](U.IFRAME)},e.prototype._html5MediaTracker=function(){var e=this;setInterval((function(){e._started&&e.recordEvent(U.VIDEO,M.TIME_WATCHED)}),3e3),this._mediaElement.addEventListener(D.PLAY,(function(){e.eventActionMapping[M.PLAY](U.VIDEO)}),!1),this._mediaElement.addEventListener(D.PAUSE,(function(){e.eventActionMapping[M.PAUSE](U.VIDEO)}),!1),this._mediaElement.addEventListener(D.ENDED,(function(){e.eventActionMapping[M.ENDED](U.VIDEO)}),!1)},e.prototype.playEventAction=function(e){this._started=!0,this.recordEvent(e,M.PLAY)},e.prototype.pauseEventAction=function(e){this._started=!1,this.recordEvent(e,M.PAUSE)},e.prototype.endedEventAction=function(e){this._started=!1,this.recordEvent(e,M.ENDED)},e.prototype.recordEvent=function(e,t){var r=Object.assign({},this._params),n=r.eventData;n.eventType=t,e===U.VIDEO?(n.properties.timestamp=this._mediaElement.currentTime,n.properties.duration=this._mediaElement.duration):(n.properties.timestamp=this._financial(this._iframePlayer.getCurrentTime()),n.properties.duration=this._financial(this._iframePlayer.getDuration()));var i=parseFloat(n.properties.timestamp)/parseFloat(n.properties.duration);n.properties.eventValue=Number(i.toFixed(4)),delete n.properties.domElementId,this._provider.putToBuffer(r)},e.prototype._financial=function(e){return Number.parseFloat(e).toFixed(4)},e}(),pe=function(e,t,r,n){return new(r||(r=Promise))((function(i,o){function s(e){try{u(n.next(e))}catch(e){o(e)}}function a(e){try{u(n.throw(e))}catch(e){o(e)}}function u(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(s,a)}u((n=n.apply(e,t||[])).next())}))},de=function(e,t){var r,n,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(r)throw new TypeError("Generator is already executing.");for(;s;)try{if(r=1,n&&(i=2&o[0]?n.return:o[0]?n.throw||((i=n.return)&&i.call(n),0):n.next)&&!(i=i.call(n,o[1])).done)return i;switch(n=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,n=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=(i=s.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=t.call(e,s)}catch(e){o=[6,e],n=0}finally{r=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}},ve=new n.ConsoleLogger("AmazonPersonalizeProvider"),me=function(){function e(e){this._buffer=[],this._config=e||{},this._config.flushSize=this._config.flushSize>0&&this._config.flushSize<=10?this._config.flushSize:5,this._config.flushInterval=this._config.flushInterval||5e3,this._sessionManager=new le,Object(fe.isEmpty)(this._config.trackingId)||(this._sessionInfo=this._sessionManager.retrieveSessionInfo(this._config.trackingId)),this._isBrowser=n.JS.browserOrNode().isBrowser,this._setupTimer()}return e.prototype._setupTimer=function(){this._timer&&clearInterval(this._timer);var e=this._config,t=(e.flushSize,e.flushInterval),r=this;this._timer=setInterval((function(){r._sendFromBuffer()}),t)},e.prototype.record=function(e){return pe(this,void 0,void 0,(function(){var t,r,n,i,o;return de(this,(function(s){switch(s.label){case 0:return[4,this._getCredentials()];case 1:return(t=s.sent())?(Object.assign(e,{config:this._config,credentials:t,sentAt:(new Date).getTime()/1e3}),r=e.event,n=r.eventType,i=r.properties,"Identify"===n?(this._sessionManager.updateSessionInfo(i&&i.userId?i.userId:"",this._sessionInfo),[2]):(Object(fe.isEmpty)(e.event.userId)||this._sessionManager.updateSessionInfo(e.event.userId,this._sessionInfo),o=this.generateRequestParams(e,this._sessionInfo),"MediaAutoTrack"!==n?[3,7]:this._isBrowser?Object(fe.isEmpty)(Object(fe.get)(o,"eventData.properties.domElementId",null))?[3,3]:[4,this.isElementFullyLoaded(this.loadElement,o.eventData.properties.domElementId,500,5)]:[3,5])):[2,Promise.resolve(!1)];case 2:return s.sent()?new he(o,this):ve.debug("Cannot find the media element."),[3,4];case 3:ve.debug("Missing domElementId field in 'properties' for MediaAutoTrack event type."),s.label=4;case 4:return[3,6];case 5:ve.debug("MediaAutoTrack only for browser"),s.label=6;case 6:return[2];case 7:return[2,this.putToBuffer(o)]}}))}))},e.prototype.loadElement=function(e){return new Promise((function(t,r){return document.getElementById(e)&&document.getElementById(e).clientHeight?t(!0):r(!0)}))},e.prototype.isElementFullyLoaded=function(e,t,r,n){var i=this;return new Promise((function(o,s){return e(t).then(o).catch((function(a){return n-1>0?(u=r,new Promise((function(e){return setTimeout(e,u)}))).then(i.isElementFullyLoaded.bind(null,e,t,r,n-1)).then(o).catch(s):s(a);var u}))}))},e.prototype.getCategory=function(){return"Analytics"},e.prototype.getProviderName=function(){return"AmazonPersonalize"},e.prototype.configure=function(e){ve.debug("configure Analytics",e);var t=e||{};return this._config=Object.assign({},this._config,t),Object(fe.isEmpty)(this._config.trackingId)||(this._sessionInfo=this._sessionManager.retrieveSessionInfo(this._config.trackingId)),this._setupTimer(),this._config},e.prototype.generateRequestParams=function(e,t){var r={},n=e.event,i=n.eventType,o=n.properties;return r.eventData={eventType:i,properties:o},r.sessionInfo=t,r.sentAt=e.sentAt,r.credentials=e.credentials,r.config=e.config,r},e.prototype._sendEvents=function(e){var t=e.length;if(0!==t){var r=e[0],n=r.config,i=r.credentials,o=r.sessionInfo;if(!this._init(n,i))return!1;if(t>0){for(var s=[],a=0;a<t;a+=1){var u=e.shift(),c=this._generateSingleRecordPayload(u,o);s.push(c)}var f={};f.trackingId=o.trackingId,f.sessionId=o.sessionId,f.userId=o.userId,f.eventList=s,this._personalize.putEvents(f,(function(e,t){e?ve.debug("Failed to call putEvents in Personalize",e):ve.debug("Put events")}))}}else ve.debug("events array is empty, directly return")},e.prototype.putToBuffer=function(e){return this._buffer.length<this._config.flushSize?this._buffer.push(e):(this._buffer.push(e),this._sendFromBuffer()),Promise.resolve(!0)},e.prototype._sendFromBuffer=function(){var e=this,t=this._buffer.length;if(!(t<=0)){for(var r=[],n=null,i=[],o=0;o<t;o+=1){var s=this._buffer.shift(),a=s.credentials,u=s.sessionInfo;0===o?(i.push(s),n=a):Object(fe.isEqual)(u,this._sessionInfo)&&a.sessionToken===n.sessionToken&&a.identityId===n.identityId?(ve.debug("no change for cred, put event in the same group"),i.push(s)):(r.push(i),(i=[]).push(s),n=a,this._sessionInfo=u)}r.push(i),r.map((function(t){e._sendEvents(t)}))}},e.prototype._generateSingleRecordPayload=function(e,t){var r=e.eventData,n=e.sentAt,i={};return i.sentAt=n,i.properties=r.properties,i.eventId=this._sessionManager.getTimerKey()+t.sessionId,i.eventType=r.eventType,i},e.prototype._init=function(e,t){if(ve.debug("init clients"),this._personalize&&this._config.credentials&&this._config.credentials.sessionToken===t.sessionToken&&this._config.credentials.identityId===t.identityId)return ve.debug("no change for analytics config, directly return from init"),!0;this._config.credentials=t;var r=e.region;return ve.debug("initialize personalize with credentials",t),this._personalize=new ce({apiVersion:"2018-03-22",region:r,credentials:t}),!0},e.prototype._getCredentials=function(){var e=this;return n.Credentials.get().then((function(t){return t?(ve.debug("set credentials for analytics",e._config.credentials),n.Credentials.shear(t)):null})).catch((function(e){return ve.debug("ensure credentials error",e),null}))},e}();r.d(t,"AnalyticsClass",(function(){return ne})),r.d(t,"AWSPinpointProvider",(function(){return w})),r.d(t,"AWSKinesisProvider",(function(){return ue})),r.d(t,"AmazonPersonalizeProvider",(function(){return me}));var ge=new n.ConsoleLogger("Analytics"),ye=!1,be=!1,_e=!1,we=null;we||(ge.debug("Create Analytics Instance"),we=new ne);var Ee=we;i.a.register(Ee);t.default=Ee;var Se=function(e){var t=e.channel,r=e.payload;e.source;switch(ge.debug("on hub capsule "+t,r),t){case"auth":xe(r);break;case"storage":Ae(r);break;case"analytics":Ie(r)}},Ae=function(e){var t=e.data,r=t.attrs,n=t.metrics;r&&_e&&Ee.record({name:"Storage",attributes:r,metrics:n}).catch((function(e){ge.debug("Failed to send the storage event automatically",e)}))},xe=function(e){var t=e.event;if(t)switch(t){case"signIn":be&&_e&&Ee.record({name:"_userauth.sign_in"}).catch((function(e){ge.debug("Failed to send the sign in event automatically",e)}));break;case"signUp":be&&_e&&Ee.record({name:"_userauth.sign_up"}).catch((function(e){ge.debug("Failed to send the sign up event automatically",e)}));break;case"signOut":break;case"signIn_failure":be&&_e&&Ee.record({name:"_userauth.auth_fail"}).catch((function(e){ge.debug("Failed to send the sign in failure event automatically",e)}));break;case"configured":(be=!0)&&_e&&Ce()}},Ie=function(e){var t=e.event;if(t)switch(t){case"pinpointProvider_configured":_e=!0,be&&_e&&Ce()}},Ce=function(){var e=Ee.configure();!ye&&e.autoSessionRecord&&(Ee.updateEndpoint({immediate:!0}).catch((function(e){ge.debug("Failed to update the endpoint",e)})),ye=!0),Ee.autoTrack("session",{enable:e.autoSessionRecord})};n.Hub.listen("auth",Se),n.Hub.listen("storage",Se),n.Hub.listen("analytics",Se)}])}));
	//# sourceMappingURL=aws-amplify-analytics.min.js.map

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
		module.exports = __webpack_require__(272);
	} else {
		module.exports = require('./dist/aws-amplify-analytics.js');
	}


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(26),__webpack_require__(450),__webpack_require__(41),__webpack_require__(22),__webpack_require__(80),__webpack_require__(138)):"function"==typeof define&&define.amd?define("aws_amplify_api",["@aws-amplify/core","graphql","graphql/language/parser","graphql/language/printer","@aws-amplify/auth","@aws-amplify/cache"],t):"object"==typeof exports?exports.aws_amplify_api=t(require("@aws-amplify/core"),require("graphql"),require("graphql/language/parser"),require("graphql/language/printer"),require("@aws-amplify/auth"),require("@aws-amplify/cache")):e.aws_amplify_api=t(e["@aws-amplify/core"],e.graphql,e["graphql/language/parser"],e["graphql/language/printer"],e["@aws-amplify/auth"],e["@aws-amplify/cache"])}(this,(function(e,t,r,n,o,i){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var o=t[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=50)}([function(t,r){t.exports=e},function(e,t,r){"use strict";var n=r(6),o=Object.prototype.toString;function i(e){return"[object Array]"===o.call(e)}function s(e){return void 0===e}function a(e){return null!==e&&"object"==typeof e}function u(e){return"[object Function]"===o.call(e)}function c(e,t){if(null!=e)if("object"!=typeof e&&(e=[e]),i(e))for(var r=0,n=e.length;r<n;r++)t.call(null,e[r],r,e);else for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.call(null,e[o],o,e)}e.exports={isArray:i,isArrayBuffer:function(e){return"[object ArrayBuffer]"===o.call(e)},isBuffer:function(e){return null!==e&&!s(e)&&null!==e.constructor&&!s(e.constructor)&&"function"==typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)},isFormData:function(e){return"undefined"!=typeof FormData&&e instanceof FormData},isArrayBufferView:function(e){return"undefined"!=typeof ArrayBuffer&&ArrayBuffer.isView?ArrayBuffer.isView(e):e&&e.buffer&&e.buffer instanceof ArrayBuffer},isString:function(e){return"string"==typeof e},isNumber:function(e){return"number"==typeof e},isObject:a,isUndefined:s,isDate:function(e){return"[object Date]"===o.call(e)},isFile:function(e){return"[object File]"===o.call(e)},isBlob:function(e){return"[object Blob]"===o.call(e)},isFunction:u,isStream:function(e){return a(e)&&u(e.pipe)},isURLSearchParams:function(e){return"undefined"!=typeof URLSearchParams&&e instanceof URLSearchParams},isStandardBrowserEnv:function(){return("undefined"==typeof navigator||"ReactNative"!==navigator.product&&"NativeScript"!==navigator.product&&"NS"!==navigator.product)&&("undefined"!=typeof window&&"undefined"!=typeof document)},forEach:c,merge:function e(){var t={};function r(r,n){"object"==typeof t[n]&&"object"==typeof r?t[n]=e(t[n],r):t[n]=r}for(var n=0,o=arguments.length;n<o;n++)c(arguments[n],r);return t},deepMerge:function e(){var t={};function r(r,n){"object"==typeof t[n]&&"object"==typeof r?t[n]=e(t[n],r):t[n]="object"==typeof r?e({},r):r}for(var n=0,o=arguments.length;n<o;n++)c(arguments[n],r);return t},extend:function(e,t,r){return c(t,(function(t,o){e[o]=r&&"function"==typeof t?n(t,r):t})),e},trim:function(e){return e.replace(/^\s*/,"").replace(/\s*$/,"")}}},function(e,r){e.exports=t},function(e,t){e.exports=r},function(e,t){e.exports=n},function(e,t,r){e.exports=r(22)},function(e,t,r){"use strict";e.exports=function(e,t){return function(){for(var r=new Array(arguments.length),n=0;n<r.length;n++)r[n]=arguments[n];return e.apply(t,r)}}},function(e,t,r){"use strict";var n=r(1);function o(e){return encodeURIComponent(e).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}e.exports=function(e,t,r){if(!t)return e;var i;if(r)i=r(t);else if(n.isURLSearchParams(t))i=t.toString();else{var s=[];n.forEach(t,(function(e,t){null!=e&&(n.isArray(e)?t+="[]":e=[e],n.forEach(e,(function(e){n.isDate(e)?e=e.toISOString():n.isObject(e)&&(e=JSON.stringify(e)),s.push(o(t)+"="+o(e))})))})),i=s.join("&")}if(i){var a=e.indexOf("#");-1!==a&&(e=e.slice(0,a)),e+=(-1===e.indexOf("?")?"?":"&")+i}return e}},function(e,t,r){"use strict";e.exports=function(e){return!(!e||!e.__CANCEL__)}},function(e,t,r){"use strict";(function(t){var n=r(1),o=r(28),i={"Content-Type":"application/x-www-form-urlencoded"};function s(e,t){!n.isUndefined(e)&&n.isUndefined(e["Content-Type"])&&(e["Content-Type"]=t)}var a,u={adapter:("undefined"!=typeof XMLHttpRequest?a=r(10):void 0!==t&&"[object process]"===Object.prototype.toString.call(t)&&(a=r(10)),a),transformRequest:[function(e,t){return o(t,"Accept"),o(t,"Content-Type"),n.isFormData(e)||n.isArrayBuffer(e)||n.isBuffer(e)||n.isStream(e)||n.isFile(e)||n.isBlob(e)?e:n.isArrayBufferView(e)?e.buffer:n.isURLSearchParams(e)?(s(t,"application/x-www-form-urlencoded;charset=utf-8"),e.toString()):n.isObject(e)?(s(t,"application/json;charset=utf-8"),JSON.stringify(e)):e}],transformResponse:[function(e){if("string"==typeof e)try{e=JSON.parse(e)}catch(e){}return e}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,validateStatus:function(e){return e>=200&&e<300}};u.headers={common:{Accept:"application/json, text/plain, */*"}},n.forEach(["delete","get","head"],(function(e){u.headers[e]={}})),n.forEach(["post","put","patch"],(function(e){u.headers[e]=n.merge(i)})),e.exports=u}).call(this,r(27))},function(e,t,r){"use strict";var n=r(1),o=r(29),i=r(7),s=r(31),a=r(34),u=r(35),c=r(11);e.exports=function(e){return new Promise((function(t,f){var h=e.data,l=e.headers;n.isFormData(h)&&delete l["Content-Type"];var p=new XMLHttpRequest;if(e.auth){var d=e.auth.username||"",y=e.auth.password||"";l.Authorization="Basic "+btoa(d+":"+y)}var v=s(e.baseURL,e.url);if(p.open(e.method.toUpperCase(),i(v,e.params,e.paramsSerializer),!0),p.timeout=e.timeout,p.onreadystatechange=function(){if(p&&4===p.readyState&&(0!==p.status||p.responseURL&&0===p.responseURL.indexOf("file:"))){var r="getAllResponseHeaders"in p?a(p.getAllResponseHeaders()):null,n={data:e.responseType&&"text"!==e.responseType?p.response:p.responseText,status:p.status,statusText:p.statusText,headers:r,config:e,request:p};o(t,f,n),p=null}},p.onabort=function(){p&&(f(c("Request aborted",e,"ECONNABORTED",p)),p=null)},p.onerror=function(){f(c("Network Error",e,null,p)),p=null},p.ontimeout=function(){var t="timeout of "+e.timeout+"ms exceeded";e.timeoutErrorMessage&&(t=e.timeoutErrorMessage),f(c(t,e,"ECONNABORTED",p)),p=null},n.isStandardBrowserEnv()){var m=r(37),b=(e.withCredentials||u(v))&&e.xsrfCookieName?m.read(e.xsrfCookieName):void 0;b&&(l[e.xsrfHeaderName]=b)}if("setRequestHeader"in p&&n.forEach(l,(function(e,t){void 0===h&&"content-type"===t.toLowerCase()?delete l[t]:p.setRequestHeader(t,e)})),n.isUndefined(e.withCredentials)||(p.withCredentials=!!e.withCredentials),e.responseType)try{p.responseType=e.responseType}catch(t){if("json"!==e.responseType)throw t}"function"==typeof e.onDownloadProgress&&p.addEventListener("progress",e.onDownloadProgress),"function"==typeof e.onUploadProgress&&p.upload&&p.upload.addEventListener("progress",e.onUploadProgress),e.cancelToken&&e.cancelToken.promise.then((function(e){p&&(p.abort(),f(e),p=null)})),void 0===h&&(h=null),p.send(h)}))}},function(e,t,r){"use strict";var n=r(30);e.exports=function(e,t,r,o,i){var s=new Error(e);return n(s,t,r,o,i)}},function(e,t,r){"use strict";var n=r(1);e.exports=function(e,t){t=t||{};var r={},o=["url","method","params","data"],i=["headers","auth","proxy"],s=["baseURL","url","transformRequest","transformResponse","paramsSerializer","timeout","withCredentials","adapter","responseType","xsrfCookieName","xsrfHeaderName","onUploadProgress","onDownloadProgress","maxContentLength","validateStatus","maxRedirects","httpAgent","httpsAgent","cancelToken","socketPath"];n.forEach(o,(function(e){void 0!==t[e]&&(r[e]=t[e])})),n.forEach(i,(function(o){n.isObject(t[o])?r[o]=n.deepMerge(e[o],t[o]):void 0!==t[o]?r[o]=t[o]:n.isObject(e[o])?r[o]=n.deepMerge(e[o]):void 0!==e[o]&&(r[o]=e[o])})),n.forEach(s,(function(n){void 0!==t[n]?r[n]=t[n]:void 0!==e[n]&&(r[n]=e[n])}));var a=o.concat(i).concat(s),u=Object.keys(t).filter((function(e){return-1===a.indexOf(e)}));return n.forEach(u,(function(n){void 0!==t[n]?r[n]=t[n]:void 0!==e[n]&&(r[n]=e[n])})),r}},function(e,t,r){"use strict";function n(e){this.message=e}n.prototype.toString=function(){return"Cancel"+(this.message?": "+this.message:"")},n.prototype.__CANCEL__=!0,e.exports=n},function(e,t){var r="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof window.msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto);if(r){var n=new Uint8Array(16);e.exports=function(){return r(n),n}}else{var o=new Array(16);e.exports=function(){for(var e,t=0;t<16;t++)0==(3&t)&&(e=4294967296*Math.random()),o[t]=e>>>((3&t)<<3)&255;return o}}},function(e,t){for(var r=[],n=0;n<256;++n)r[n]=(n+256).toString(16).substr(1);e.exports=function(e,t){var n=t||0,o=r;return[o[e[n++]],o[e[n++]],o[e[n++]],o[e[n++]],"-",o[e[n++]],o[e[n++]],"-",o[e[n++]],o[e[n++]],"-",o[e[n++]],o[e[n++]],"-",o[e[n++]],o[e[n++]],o[e[n++]],o[e[n++]],o[e[n++]],o[e[n++]]].join("")}},function(e,t,r){e.exports=r(21).Observable},function(e,t){e.exports=o},function(e,t){e.exports=i},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="undefined"!=typeof Symbol&&"function"==typeof Symbol.for;t.INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER=n?Symbol.for("INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER"):"@@INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER"},function(e,t,r){var n=r(48),o=r(49),i=o;i.v1=n,i.v4=o,e.exports=i},function(e,t,r){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function i(e,t,r){return t&&o(e.prototype,t),r&&o(e,r),e}Object.defineProperty(t,"__esModule",{value:!0}),t.Observable=void 0;var s=function(){return"function"==typeof Symbol},a=function(e){return s()&&Boolean(Symbol[e])},u=function(e){return a(e)?Symbol[e]:"@@"+e};s()&&!a("observable")&&(Symbol.observable=Symbol("observable"));var c=u("iterator"),f=u("observable"),h=u("species");function l(e,t){var r=e[t];if(null!=r){if("function"!=typeof r)throw new TypeError(r+" is not a function");return r}}function p(e){var t=e.constructor;return void 0!==t&&null===(t=t[h])&&(t=void 0),void 0!==t?t:j}function d(e){return e instanceof j}function y(e){y.log?y.log(e):setTimeout((function(){throw e}))}function v(e){Promise.resolve().then((function(){try{e()}catch(e){y(e)}}))}function m(e){var t=e._cleanup;if(void 0!==t&&(e._cleanup=void 0,t))try{if("function"==typeof t)t();else{var r=l(t,"unsubscribe");r&&r.call(t)}}catch(e){y(e)}}function b(e){e._observer=void 0,e._queue=void 0,e._state="closed"}function g(e,t,r){e._state="running";var n=e._observer;try{var o=l(n,t);switch(t){case"next":o&&o.call(n,r);break;case"error":if(b(e),!o)throw r;o.call(n,r);break;case"complete":b(e),o&&o.call(n)}}catch(e){y(e)}"closed"===e._state?m(e):"running"===e._state&&(e._state="ready")}function w(e,t,r){if("closed"!==e._state){if("buffering"!==e._state)return"ready"!==e._state?(e._state="buffering",e._queue=[{type:t,value:r}],void v((function(){return function(e){var t=e._queue;if(t){e._queue=void 0,e._state="ready";for(var r=0;r<t.length&&(g(e,t[r].type,t[r].value),"closed"!==e._state);++r);}}(e)}))):void g(e,t,r);e._queue.push({type:t,value:r})}}var _=function(){function e(t,r){n(this,e),this._cleanup=void 0,this._observer=t,this._queue=void 0,this._state="initializing";var o=new x(this);try{this._cleanup=r.call(void 0,o)}catch(e){o.error(e)}"initializing"===this._state&&(this._state="ready")}return i(e,[{key:"unsubscribe",value:function(){"closed"!==this._state&&(b(this),m(this))}},{key:"closed",get:function(){return"closed"===this._state}}]),e}(),x=function(){function e(t){n(this,e),this._subscription=t}return i(e,[{key:"next",value:function(e){w(this._subscription,"next",e)}},{key:"error",value:function(e){w(this._subscription,"error",e)}},{key:"complete",value:function(){w(this._subscription,"complete")}},{key:"closed",get:function(){return"closed"===this._subscription._state}}]),e}(),j=function(){function e(t){if(n(this,e),!(this instanceof e))throw new TypeError("Observable cannot be called as a function");if("function"!=typeof t)throw new TypeError("Observable initializer must be a function");this._subscriber=t}return i(e,[{key:"subscribe",value:function(e){return"object"==typeof e&&null!==e||(e={next:e,error:arguments[1],complete:arguments[2]}),new _(e,this._subscriber)}},{key:"forEach",value:function(e){var t=this;return new Promise((function(r,n){if("function"==typeof e)var o=t.subscribe({next:function(t){try{e(t,i)}catch(e){n(e),o.unsubscribe()}},error:n,complete:r});else n(new TypeError(e+" is not a function"));function i(){o.unsubscribe(),r()}}))}},{key:"map",value:function(e){var t=this;if("function"!=typeof e)throw new TypeError(e+" is not a function");return new(p(this))((function(r){return t.subscribe({next:function(t){try{t=e(t)}catch(e){return r.error(e)}r.next(t)},error:function(e){r.error(e)},complete:function(){r.complete()}})}))}},{key:"filter",value:function(e){var t=this;if("function"!=typeof e)throw new TypeError(e+" is not a function");return new(p(this))((function(r){return t.subscribe({next:function(t){try{if(!e(t))return}catch(e){return r.error(e)}r.next(t)},error:function(e){r.error(e)},complete:function(){r.complete()}})}))}},{key:"reduce",value:function(e){var t=this;if("function"!=typeof e)throw new TypeError(e+" is not a function");var r=p(this),n=arguments.length>1,o=!1,i=arguments[1],s=i;return new r((function(r){return t.subscribe({next:function(t){var i=!o;if(o=!0,!i||n)try{s=e(s,t)}catch(e){return r.error(e)}else s=t},error:function(e){r.error(e)},complete:function(){if(!o&&!n)return r.error(new TypeError("Cannot reduce an empty sequence"));r.next(s),r.complete()}})}))}},{key:"concat",value:function(){for(var e=this,t=arguments.length,r=new Array(t),n=0;n<t;n++)r[n]=arguments[n];var o=p(this);return new o((function(t){var n,i=0;return function e(s){n=s.subscribe({next:function(e){t.next(e)},error:function(e){t.error(e)},complete:function(){i===r.length?(n=void 0,t.complete()):e(o.from(r[i++]))}})}(e),function(){n&&(n.unsubscribe(),n=void 0)}}))}},{key:"flatMap",value:function(e){var t=this;if("function"!=typeof e)throw new TypeError(e+" is not a function");var r=p(this);return new r((function(n){var o=[],i=t.subscribe({next:function(t){if(e)try{t=e(t)}catch(e){return n.error(e)}var i=r.from(t).subscribe({next:function(e){n.next(e)},error:function(e){n.error(e)},complete:function(){var e=o.indexOf(i);e>=0&&o.splice(e,1),s()}});o.push(i)},error:function(e){n.error(e)},complete:function(){s()}});function s(){i.closed&&0===o.length&&n.complete()}return function(){o.forEach((function(e){return e.unsubscribe()})),i.unsubscribe()}}))}},{key:f,value:function(){return this}}],[{key:"from",value:function(t){var r="function"==typeof this?this:e;if(null==t)throw new TypeError(t+" is not an object");var n=l(t,f);if(n){var o=n.call(t);if(Object(o)!==o)throw new TypeError(o+" is not an object");return d(o)&&o.constructor===r?o:new r((function(e){return o.subscribe(e)}))}if(a("iterator")&&(n=l(t,c)))return new r((function(e){v((function(){if(!e.closed){var r=!0,o=!1,i=void 0;try{for(var s,a=n.call(t)[Symbol.iterator]();!(r=(s=a.next()).done);r=!0){var u=s.value;if(e.next(u),e.closed)return}}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}e.complete()}}))}));if(Array.isArray(t))return new r((function(e){v((function(){if(!e.closed){for(var r=0;r<t.length;++r)if(e.next(t[r]),e.closed)return;e.complete()}}))}));throw new TypeError(t+" is not observable")}},{key:"of",value:function(){for(var t=arguments.length,r=new Array(t),n=0;n<t;n++)r[n]=arguments[n];var o="function"==typeof this?this:e;return new o((function(e){v((function(){if(!e.closed){for(var t=0;t<r.length;++t)if(e.next(r[t]),e.closed)return;e.complete()}}))}))}},{key:h,get:function(){return this}}]),e}();t.Observable=j,s()&&Object.defineProperty(j,Symbol("extensions"),{value:{symbol:f,hostReportError:y},configurable:!0})},function(e,t,r){"use strict";var n=r(1),o=r(6),i=r(23),s=r(12);function a(e){var t=new i(e),r=o(i.prototype.request,t);return n.extend(r,i.prototype,t),n.extend(r,t),r}var u=a(r(9));u.Axios=i,u.create=function(e){return a(s(u.defaults,e))},u.Cancel=r(13),u.CancelToken=r(38),u.isCancel=r(8),u.all=function(e){return Promise.all(e)},u.spread=r(39),e.exports=u,e.exports.default=u},function(e,t,r){"use strict";var n=r(1),o=r(7),i=r(24),s=r(25),a=r(12);function u(e){this.defaults=e,this.interceptors={request:new i,response:new i}}u.prototype.request=function(e){"string"==typeof e?(e=arguments[1]||{}).url=arguments[0]:e=e||{},(e=a(this.defaults,e)).method?e.method=e.method.toLowerCase():this.defaults.method?e.method=this.defaults.method.toLowerCase():e.method="get";var t=[s,void 0],r=Promise.resolve(e);for(this.interceptors.request.forEach((function(e){t.unshift(e.fulfilled,e.rejected)})),this.interceptors.response.forEach((function(e){t.push(e.fulfilled,e.rejected)}));t.length;)r=r.then(t.shift(),t.shift());return r},u.prototype.getUri=function(e){return e=a(this.defaults,e),o(e.url,e.params,e.paramsSerializer).replace(/^\?/,"")},n.forEach(["delete","get","head","options"],(function(e){u.prototype[e]=function(t,r){return this.request(n.merge(r||{},{method:e,url:t}))}})),n.forEach(["post","put","patch"],(function(e){u.prototype[e]=function(t,r,o){return this.request(n.merge(o||{},{method:e,url:t,data:r}))}})),e.exports=u},function(e,t,r){"use strict";var n=r(1);function o(){this.handlers=[]}o.prototype.use=function(e,t){return this.handlers.push({fulfilled:e,rejected:t}),this.handlers.length-1},o.prototype.eject=function(e){this.handlers[e]&&(this.handlers[e]=null)},o.prototype.forEach=function(e){n.forEach(this.handlers,(function(t){null!==t&&e(t)}))},e.exports=o},function(e,t,r){"use strict";var n=r(1),o=r(26),i=r(8),s=r(9);function a(e){e.cancelToken&&e.cancelToken.throwIfRequested()}e.exports=function(e){return a(e),e.headers=e.headers||{},e.data=o(e.data,e.headers,e.transformRequest),e.headers=n.merge(e.headers.common||{},e.headers[e.method]||{},e.headers),n.forEach(["delete","get","head","post","put","patch","common"],(function(t){delete e.headers[t]})),(e.adapter||s.adapter)(e).then((function(t){return a(e),t.data=o(t.data,t.headers,e.transformResponse),t}),(function(t){return i(t)||(a(e),t&&t.response&&(t.response.data=o(t.response.data,t.response.headers,e.transformResponse))),Promise.reject(t)}))}},function(e,t,r){"use strict";var n=r(1);e.exports=function(e,t,r){return n.forEach(r,(function(r){e=r(e,t)})),e}},function(e,t){var r,n,o=e.exports={};function i(){throw new Error("setTimeout has not been defined")}function s(){throw new Error("clearTimeout has not been defined")}function a(e){if(r===setTimeout)return setTimeout(e,0);if((r===i||!r)&&setTimeout)return r=setTimeout,setTimeout(e,0);try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}!function(){try{r="function"==typeof setTimeout?setTimeout:i}catch(e){r=i}try{n="function"==typeof clearTimeout?clearTimeout:s}catch(e){n=s}}();var u,c=[],f=!1,h=-1;function l(){f&&u&&(f=!1,u.length?c=u.concat(c):h=-1,c.length&&p())}function p(){if(!f){var e=a(l);f=!0;for(var t=c.length;t;){for(u=c,c=[];++h<t;)u&&u[h].run();h=-1,t=c.length}u=null,f=!1,function(e){if(n===clearTimeout)return clearTimeout(e);if((n===s||!n)&&clearTimeout)return n=clearTimeout,clearTimeout(e);try{n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}(e)}}function d(e,t){this.fun=e,this.array=t}function y(){}o.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var r=1;r<arguments.length;r++)t[r-1]=arguments[r];c.push(new d(e,t)),1!==c.length||f||a(p)},d.prototype.run=function(){this.fun.apply(null,this.array)},o.title="browser",o.browser=!0,o.env={},o.argv=[],o.version="",o.versions={},o.on=y,o.addListener=y,o.once=y,o.off=y,o.removeListener=y,o.removeAllListeners=y,o.emit=y,o.prependListener=y,o.prependOnceListener=y,o.listeners=function(e){return[]},o.binding=function(e){throw new Error("process.binding is not supported")},o.cwd=function(){return"/"},o.chdir=function(e){throw new Error("process.chdir is not supported")},o.umask=function(){return 0}},function(e,t,r){"use strict";var n=r(1);e.exports=function(e,t){n.forEach(e,(function(r,n){n!==t&&n.toUpperCase()===t.toUpperCase()&&(e[t]=r,delete e[n])}))}},function(e,t,r){"use strict";var n=r(11);e.exports=function(e,t,r){var o=r.config.validateStatus;!o||o(r.status)?e(r):t(n("Request failed with status code "+r.status,r.config,null,r.request,r))}},function(e,t,r){"use strict";e.exports=function(e,t,r,n,o){return e.config=t,r&&(e.code=r),e.request=n,e.response=o,e.isAxiosError=!0,e.toJSON=function(){return{message:this.message,name:this.name,description:this.description,number:this.number,fileName:this.fileName,lineNumber:this.lineNumber,columnNumber:this.columnNumber,stack:this.stack,config:this.config,code:this.code}},e}},function(e,t,r){"use strict";var n=r(32),o=r(33);e.exports=function(e,t){return e&&!n(t)?o(e,t):t}},function(e,t,r){"use strict";e.exports=function(e){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e)}},function(e,t,r){"use strict";e.exports=function(e,t){return t?e.replace(/\/+$/,"")+"/"+t.replace(/^\/+/,""):e}},function(e,t,r){"use strict";var n=r(1),o=["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"];e.exports=function(e){var t,r,i,s={};return e?(n.forEach(e.split("\n"),(function(e){if(i=e.indexOf(":"),t=n.trim(e.substr(0,i)).toLowerCase(),r=n.trim(e.substr(i+1)),t){if(s[t]&&o.indexOf(t)>=0)return;s[t]="set-cookie"===t?(s[t]?s[t]:[]).concat([r]):s[t]?s[t]+", "+r:r}})),s):s}},function(e,t,r){"use strict";var n=r(1),o=r(36);e.exports=n.isStandardBrowserEnv()?function(){var e,t=/(msie|trident)/i.test(navigator.userAgent),r=document.createElement("a");function i(e){var n=e;if(o(e))throw new Error("URL contains XSS injection attempt");return t&&(r.setAttribute("href",n),n=r.href),r.setAttribute("href",n),{href:r.href,protocol:r.protocol?r.protocol.replace(/:$/,""):"",host:r.host,search:r.search?r.search.replace(/^\?/,""):"",hash:r.hash?r.hash.replace(/^#/,""):"",hostname:r.hostname,port:r.port,pathname:"/"===r.pathname.charAt(0)?r.pathname:"/"+r.pathname}}return e=i(window.location.href),function(t){var r=n.isString(t)?i(t):t;return r.protocol===e.protocol&&r.host===e.host}}():function(){return!0}},function(e,t,r){"use strict";e.exports=function(e){return/(\b)(on\w+)=|javascript|(<\s*)(\/*)script/gi.test(e)}},function(e,t,r){"use strict";var n=r(1);e.exports=n.isStandardBrowserEnv()?{write:function(e,t,r,o,i,s){var a=[];a.push(e+"="+encodeURIComponent(t)),n.isNumber(r)&&a.push("expires="+new Date(r).toGMTString()),n.isString(o)&&a.push("path="+o),n.isString(i)&&a.push("domain="+i),!0===s&&a.push("secure"),document.cookie=a.join("; ")},read:function(e){var t=document.cookie.match(new RegExp("(^|;\\s*)("+e+")=([^;]*)"));return t?decodeURIComponent(t[3]):null},remove:function(e){this.write(e,"",Date.now()-864e5)}}:{write:function(){},read:function(){return null},remove:function(){}}},function(e,t,r){"use strict";var n=r(13);function o(e){if("function"!=typeof e)throw new TypeError("executor must be a function.");var t;this.promise=new Promise((function(e){t=e}));var r=this;e((function(e){r.reason||(r.reason=new n(e),t(r.reason))}))}o.prototype.throwIfRequested=function(){if(this.reason)throw this.reason},o.source=function(){var e;return{token:new o((function(t){e=t})),cancel:e}},e.exports=o},function(e,t,r){"use strict";e.exports=function(e){return function(t){return e.apply(null,t)}}},function(e,t,r){"use strict";var n=r(41),o=r(44);function i(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}t.parse=g,t.resolve=function(e,t){return g(e,!1,!0).resolve(t)},t.resolveObject=function(e,t){return e?g(e,!1,!0).resolveObject(t):t},t.format=function(e){o.isString(e)&&(e=g(e));return e instanceof i?e.format():i.prototype.format.call(e)},t.Url=i;var s=/^([a-z0-9.+-]+:)/i,a=/:[0-9]*$/,u=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,c=["{","}","|","\\","^","`"].concat(["<",">",'"',"`"," ","\r","\n","\t"]),f=["'"].concat(c),h=["%","/","?",";","#"].concat(f),l=["/","?","#"],p=/^[+a-z0-9A-Z_-]{0,63}$/,d=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,y={javascript:!0,"javascript:":!0},v={javascript:!0,"javascript:":!0},m={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},b=r(45);function g(e,t,r){if(e&&o.isObject(e)&&e instanceof i)return e;var n=new i;return n.parse(e,t,r),n}i.prototype.parse=function(e,t,r){if(!o.isString(e))throw new TypeError("Parameter 'url' must be a string, not "+typeof e);var i=e.indexOf("?"),a=-1!==i&&i<e.indexOf("#")?"?":"#",c=e.split(a);c[0]=c[0].replace(/\\/g,"/");var g=e=c.join(a);if(g=g.trim(),!r&&1===e.split("#").length){var w=u.exec(g);if(w)return this.path=g,this.href=g,this.pathname=w[1],w[2]?(this.search=w[2],this.query=t?b.parse(this.search.substr(1)):this.search.substr(1)):t&&(this.search="",this.query={}),this}var _=s.exec(g);if(_){var x=(_=_[0]).toLowerCase();this.protocol=x,g=g.substr(_.length)}if(r||_||g.match(/^\/\/[^@\/]+@[^@\/]+/)){var j="//"===g.substr(0,2);!j||_&&v[_]||(g=g.substr(2),this.slashes=!0)}if(!v[_]&&(j||_&&!m[_])){for(var O,A,P=-1,S=0;S<l.length;S++){-1!==(q=g.indexOf(l[S]))&&(-1===P||q<P)&&(P=q)}-1!==(A=-1===P?g.lastIndexOf("@"):g.lastIndexOf("@",P))&&(O=g.slice(0,A),g=g.slice(A+1),this.auth=decodeURIComponent(O)),P=-1;for(S=0;S<h.length;S++){var q;-1!==(q=g.indexOf(h[S]))&&(-1===P||q<P)&&(P=q)}-1===P&&(P=g.length),this.host=g.slice(0,P),g=g.slice(P),this.parseHost(),this.hostname=this.hostname||"";var E="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!E)for(var C=this.hostname.split(/\./),T=(S=0,C.length);S<T;S++){var I=C[S];if(I&&!I.match(p)){for(var k="",R=0,N=I.length;R<N;R++)I.charCodeAt(R)>127?k+="x":k+=I[R];if(!k.match(p)){var U=C.slice(0,S),L=C.slice(S+1),B=I.match(d);B&&(U.push(B[1]),L.unshift(B[2])),L.length&&(g="/"+L.join(".")+g),this.hostname=U.join(".");break}}}this.hostname.length>255?this.hostname="":this.hostname=this.hostname.toLowerCase(),E||(this.hostname=n.toASCII(this.hostname));var M=this.port?":"+this.port:"",D=this.hostname||"";this.host=D+M,this.href+=this.host,E&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==g[0]&&(g="/"+g))}if(!y[x])for(S=0,T=f.length;S<T;S++){var z=f[S];if(-1!==g.indexOf(z)){var F=encodeURIComponent(z);F===z&&(F=escape(z)),g=g.split(z).join(F)}}var H=g.indexOf("#");-1!==H&&(this.hash=g.substr(H),g=g.slice(0,H));var V=g.indexOf("?");if(-1!==V?(this.search=g.substr(V),this.query=g.substr(V+1),t&&(this.query=b.parse(this.query)),g=g.slice(0,V)):t&&(this.search="",this.query={}),g&&(this.pathname=g),m[x]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){M=this.pathname||"";var K=this.search||"";this.path=M+K}return this.href=this.format(),this},i.prototype.format=function(){var e=this.auth||"";e&&(e=(e=encodeURIComponent(e)).replace(/%3A/i,":"),e+="@");var t=this.protocol||"",r=this.pathname||"",n=this.hash||"",i=!1,s="";this.host?i=e+this.host:this.hostname&&(i=e+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port&&(i+=":"+this.port)),this.query&&o.isObject(this.query)&&Object.keys(this.query).length&&(s=b.stringify(this.query));var a=this.search||s&&"?"+s||"";return t&&":"!==t.substr(-1)&&(t+=":"),this.slashes||(!t||m[t])&&!1!==i?(i="//"+(i||""),r&&"/"!==r.charAt(0)&&(r="/"+r)):i||(i=""),n&&"#"!==n.charAt(0)&&(n="#"+n),a&&"?"!==a.charAt(0)&&(a="?"+a),t+i+(r=r.replace(/[?#]/g,(function(e){return encodeURIComponent(e)})))+(a=a.replace("#","%23"))+n},i.prototype.resolve=function(e){return this.resolveObject(g(e,!1,!0)).format()},i.prototype.resolveObject=function(e){if(o.isString(e)){var t=new i;t.parse(e,!1,!0),e=t}for(var r=new i,n=Object.keys(this),s=0;s<n.length;s++){var a=n[s];r[a]=this[a]}if(r.hash=e.hash,""===e.href)return r.href=r.format(),r;if(e.slashes&&!e.protocol){for(var u=Object.keys(e),c=0;c<u.length;c++){var f=u[c];"protocol"!==f&&(r[f]=e[f])}return m[r.protocol]&&r.hostname&&!r.pathname&&(r.path=r.pathname="/"),r.href=r.format(),r}if(e.protocol&&e.protocol!==r.protocol){if(!m[e.protocol]){for(var h=Object.keys(e),l=0;l<h.length;l++){var p=h[l];r[p]=e[p]}return r.href=r.format(),r}if(r.protocol=e.protocol,e.host||v[e.protocol])r.pathname=e.pathname;else{for(var d=(e.pathname||"").split("/");d.length&&!(e.host=d.shift()););e.host||(e.host=""),e.hostname||(e.hostname=""),""!==d[0]&&d.unshift(""),d.length<2&&d.unshift(""),r.pathname=d.join("/")}if(r.search=e.search,r.query=e.query,r.host=e.host||"",r.auth=e.auth,r.hostname=e.hostname||e.host,r.port=e.port,r.pathname||r.search){var y=r.pathname||"",b=r.search||"";r.path=y+b}return r.slashes=r.slashes||e.slashes,r.href=r.format(),r}var g=r.pathname&&"/"===r.pathname.charAt(0),w=e.host||e.pathname&&"/"===e.pathname.charAt(0),_=w||g||r.host&&e.pathname,x=_,j=r.pathname&&r.pathname.split("/")||[],O=(d=e.pathname&&e.pathname.split("/")||[],r.protocol&&!m[r.protocol]);if(O&&(r.hostname="",r.port=null,r.host&&(""===j[0]?j[0]=r.host:j.unshift(r.host)),r.host="",e.protocol&&(e.hostname=null,e.port=null,e.host&&(""===d[0]?d[0]=e.host:d.unshift(e.host)),e.host=null),_=_&&(""===d[0]||""===j[0])),w)r.host=e.host||""===e.host?e.host:r.host,r.hostname=e.hostname||""===e.hostname?e.hostname:r.hostname,r.search=e.search,r.query=e.query,j=d;else if(d.length)j||(j=[]),j.pop(),j=j.concat(d),r.search=e.search,r.query=e.query;else if(!o.isNullOrUndefined(e.search)){if(O)r.hostname=r.host=j.shift(),(E=!!(r.host&&r.host.indexOf("@")>0)&&r.host.split("@"))&&(r.auth=E.shift(),r.host=r.hostname=E.shift());return r.search=e.search,r.query=e.query,o.isNull(r.pathname)&&o.isNull(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.href=r.format(),r}if(!j.length)return r.pathname=null,r.search?r.path="/"+r.search:r.path=null,r.href=r.format(),r;for(var A=j.slice(-1)[0],P=(r.host||e.host||j.length>1)&&("."===A||".."===A)||""===A,S=0,q=j.length;q>=0;q--)"."===(A=j[q])?j.splice(q,1):".."===A?(j.splice(q,1),S++):S&&(j.splice(q,1),S--);if(!_&&!x)for(;S--;S)j.unshift("..");!_||""===j[0]||j[0]&&"/"===j[0].charAt(0)||j.unshift(""),P&&"/"!==j.join("/").substr(-1)&&j.push("");var E,C=""===j[0]||j[0]&&"/"===j[0].charAt(0);O&&(r.hostname=r.host=C?"":j.length?j.shift():"",(E=!!(r.host&&r.host.indexOf("@")>0)&&r.host.split("@"))&&(r.auth=E.shift(),r.host=r.hostname=E.shift()));return(_=_||r.host&&j.length)&&!C&&j.unshift(""),j.length?r.pathname=j.join("/"):(r.pathname=null,r.path=null),o.isNull(r.pathname)&&o.isNull(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.auth=e.auth||r.auth,r.slashes=r.slashes||e.slashes,r.href=r.format(),r},i.prototype.parseHost=function(){var e=this.host,t=a.exec(e);t&&(":"!==(t=t[0])&&(this.port=t.substr(1)),e=e.substr(0,e.length-t.length)),e&&(this.hostname=e)}},function(e,t,r){(function(e,n){var o;/*! https://mths.be/punycode v1.4.1 by @mathias */!function(i){t&&t.nodeType,e&&e.nodeType;var s="object"==typeof n&&n;s.global!==s&&s.window!==s&&s.self;var a,u=2147483647,c=/^xn--/,f=/[^\x20-\x7E]/,h=/[\x2E\u3002\uFF0E\uFF61]/g,l={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},p=Math.floor,d=String.fromCharCode;function y(e){throw new RangeError(l[e])}function v(e,t){for(var r=e.length,n=[];r--;)n[r]=t(e[r]);return n}function m(e,t){var r=e.split("@"),n="";return r.length>1&&(n=r[0]+"@",e=r[1]),n+v((e=e.replace(h,".")).split("."),t).join(".")}function b(e){for(var t,r,n=[],o=0,i=e.length;o<i;)(t=e.charCodeAt(o++))>=55296&&t<=56319&&o<i?56320==(64512&(r=e.charCodeAt(o++)))?n.push(((1023&t)<<10)+(1023&r)+65536):(n.push(t),o--):n.push(t);return n}function g(e){return v(e,(function(e){var t="";return e>65535&&(t+=d((e-=65536)>>>10&1023|55296),e=56320|1023&e),t+=d(e)})).join("")}function w(e,t){return e+22+75*(e<26)-((0!=t)<<5)}function _(e,t,r){var n=0;for(e=r?p(e/700):e>>1,e+=p(e/t);e>455;n+=36)e=p(e/35);return p(n+36*e/(e+38))}function x(e){var t,r,n,o,i,s,a,c,f,h,l,d=[],v=e.length,m=0,b=128,w=72;for((r=e.lastIndexOf("-"))<0&&(r=0),n=0;n<r;++n)e.charCodeAt(n)>=128&&y("not-basic"),d.push(e.charCodeAt(n));for(o=r>0?r+1:0;o<v;){for(i=m,s=1,a=36;o>=v&&y("invalid-input"),((c=(l=e.charCodeAt(o++))-48<10?l-22:l-65<26?l-65:l-97<26?l-97:36)>=36||c>p((u-m)/s))&&y("overflow"),m+=c*s,!(c<(f=a<=w?1:a>=w+26?26:a-w));a+=36)s>p(u/(h=36-f))&&y("overflow"),s*=h;w=_(m-i,t=d.length+1,0==i),p(m/t)>u-b&&y("overflow"),b+=p(m/t),m%=t,d.splice(m++,0,b)}return g(d)}function j(e){var t,r,n,o,i,s,a,c,f,h,l,v,m,g,x,j=[];for(v=(e=b(e)).length,t=128,r=0,i=72,s=0;s<v;++s)(l=e[s])<128&&j.push(d(l));for(n=o=j.length,o&&j.push("-");n<v;){for(a=u,s=0;s<v;++s)(l=e[s])>=t&&l<a&&(a=l);for(a-t>p((u-r)/(m=n+1))&&y("overflow"),r+=(a-t)*m,t=a,s=0;s<v;++s)if((l=e[s])<t&&++r>u&&y("overflow"),l==t){for(c=r,f=36;!(c<(h=f<=i?1:f>=i+26?26:f-i));f+=36)x=c-h,g=36-h,j.push(d(w(h+x%g,0))),c=p(x/g);j.push(d(w(c,0))),i=_(r,m,n==o),r=0,++n}++r,++t}return j.join("")}a={version:"1.4.1",ucs2:{decode:b,encode:g},decode:x,encode:j,toASCII:function(e){return m(e,(function(e){return f.test(e)?"xn--"+j(e):e}))},toUnicode:function(e){return m(e,(function(e){return c.test(e)?x(e.slice(4).toLowerCase()):e}))}},void 0===(o=function(){return a}.call(t,r,t,e))||(e.exports=o)}()}).call(this,r(42)(e),r(43))},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e}},function(e,t){var r;r=function(){return this}();try{r=r||new Function("return this")()}catch(e){"object"==typeof window&&(r=window)}e.exports=r},function(e,t,r){"use strict";e.exports={isString:function(e){return"string"==typeof e},isObject:function(e){return"object"==typeof e&&null!==e},isNull:function(e){return null===e},isNullOrUndefined:function(e){return null==e}}},function(e,t,r){"use strict";t.decode=t.parse=r(46),t.encode=t.stringify=r(47)},function(e,t,r){"use strict";function n(e,t){return Object.prototype.hasOwnProperty.call(e,t)}e.exports=function(e,t,r,i){t=t||"&",r=r||"=";var s={};if("string"!=typeof e||0===e.length)return s;var a=/\+/g;e=e.split(t);var u=1e3;i&&"number"==typeof i.maxKeys&&(u=i.maxKeys);var c=e.length;u>0&&c>u&&(c=u);for(var f=0;f<c;++f){var h,l,p,d,y=e[f].replace(a,"%20"),v=y.indexOf(r);v>=0?(h=y.substr(0,v),l=y.substr(v+1)):(h=y,l=""),p=decodeURIComponent(h),d=decodeURIComponent(l),n(s,p)?o(s[p])?s[p].push(d):s[p]=[s[p],d]:s[p]=d}return s};var o=Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)}},function(e,t,r){"use strict";var n=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return""}};e.exports=function(e,t,r,a){return t=t||"&",r=r||"=",null===e&&(e=void 0),"object"==typeof e?i(s(e),(function(s){var a=encodeURIComponent(n(s))+r;return o(e[s])?i(e[s],(function(e){return a+encodeURIComponent(n(e))})).join(t):a+encodeURIComponent(n(e[s]))})).join(t):a?encodeURIComponent(n(a))+r+encodeURIComponent(n(e)):""};var o=Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)};function i(e,t){if(e.map)return e.map(t);for(var r=[],n=0;n<e.length;n++)r.push(t(e[n],n));return r}var s=Object.keys||function(e){var t=[];for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.push(r);return t}},function(e,t,r){var n,o,i=r(14),s=r(15),a=0,u=0;e.exports=function(e,t,r){var c=t&&r||0,f=t||[],h=(e=e||{}).node||n,l=void 0!==e.clockseq?e.clockseq:o;if(null==h||null==l){var p=i();null==h&&(h=n=[1|p[0],p[1],p[2],p[3],p[4],p[5]]),null==l&&(l=o=16383&(p[6]<<8|p[7]))}var d=void 0!==e.msecs?e.msecs:(new Date).getTime(),y=void 0!==e.nsecs?e.nsecs:u+1,v=d-a+(y-u)/1e4;if(v<0&&void 0===e.clockseq&&(l=l+1&16383),(v<0||d>a)&&void 0===e.nsecs&&(y=0),y>=1e4)throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");a=d,u=y,o=l;var m=(1e4*(268435455&(d+=122192928e5))+y)%4294967296;f[c++]=m>>>24&255,f[c++]=m>>>16&255,f[c++]=m>>>8&255,f[c++]=255&m;var b=d/4294967296*1e4&268435455;f[c++]=b>>>8&255,f[c++]=255&b,f[c++]=b>>>24&15|16,f[c++]=b>>>16&255,f[c++]=l>>>8|128,f[c++]=255&l;for(var g=0;g<6;++g)f[c+g]=h[g];return t||s(f)}},function(e,t,r){var n=r(14),o=r(15);e.exports=function(e,t,r){var i=t&&r||0;"string"==typeof e&&(t="binary"===e?new Array(16):null,e=null);var s=(e=e||{}).random||(e.rng||n)();if(s[6]=15&s[6]|64,s[8]=63&s[8]|128,t)for(var a=0;a<16;++a)t[i+a]=s[a];return t||o(s)}},function(e,t,r){"use strict";r.r(t);var n=r(2),o=r(4),i=r(3),s=r(16),a=r(0),u=r.n(a),c=r(5),f=r.n(c),h=function(){return(h=Object.assign||function(e){for(var t,r=1,n=arguments.length;r<n;r++)for(var o in t=arguments[r])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)},l=function(e,t,r,n){return new(r||(r=Promise))((function(o,i){function s(e){try{u(n.next(e))}catch(e){i(e)}}function a(e){try{u(n.throw(e))}catch(e){i(e)}}function u(e){var t;e.done?o(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(s,a)}u((n=n.apply(e,t||[])).next())}))},p=function(e,t){var r,n,o,i,s={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(r)throw new TypeError("Generator is already executing.");for(;s;)try{if(r=1,n&&(o=2&i[0]?n.return:i[0]?n.throw||((o=n.return)&&o.call(n),0):n.next)&&!(o=o.call(n,i[1])).done)return o;switch(n=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return s.label++,{value:i[1],done:!1};case 5:s.label++,n=i[1],i=[0];continue;case 7:i=s.ops.pop(),s.trys.pop();continue;default:if(!(o=(o=s.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){s=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){s.label=i[1];break}if(6===i[0]&&s.label<o[1]){s.label=o[1],o=i;break}if(o&&s.label<o[2]){s.label=o[2],s.ops.push(i);break}o[2]&&s.ops.pop(),s.trys.pop();continue}i=t.call(e,s)}catch(e){i=[6,e],n=0}finally{r=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,a])}}},d=function(e,t){var r={};for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(n=Object.getOwnPropertySymbols(e);o<n.length;o++)t.indexOf(n[o])<0&&Object.prototype.propertyIsEnumerable.call(e,n[o])&&(r[n[o]]=e[n[o]])}return r},y=new a.ConsoleLogger("RestClient"),v=r(40),m=function(){function e(e){this._region="us-east-1",this._service="execute-api",this._custom_header=void 0;e.endpoints;this._options=e,y.debug("API Options",this._options)}return e.prototype.ajax=function(e,t,r){return l(this,void 0,void 0,(function(){var n,o,i,s,u,c,f,l,m,b,g=this;return p(this,(function(p){switch(p.label){case 0:return y.debug(t+" "+e),n=this._parseUrl(e),o={method:t,url:e,host:n.host,path:n.path,headers:{},data:null,responseType:"json",timeout:0},i={},a.Platform.isReactNative&&(s=a.Platform.userAgent||"aws-amplify/0.1.x",i={"User-Agent":s}),u=Object.assign({},r),c=u.response,u.body&&(i["Content-Type"]="application/json; charset=UTF-8",o.data=JSON.stringify(u.body)),u.responseType&&(o.responseType=u.responseType),u.withCredentials&&(o.withCredentials=u.withCredentials),u.timeout&&(o.timeout=u.timeout),o.signerServiceInfo=u.signerServiceInfo,this._custom_header?[4,this._custom_header()]:[3,2];case 1:return l=p.sent(),[3,3];case 2:l=void 0,p.label=3;case 3:return f=l,o.headers=h(h(h({},i),f),u.headers),m=v.parse(e,!0,!0),m.search,b=d(m,["search"]),o.url=v.format(h(h({},b),{query:h(h({},b.query),u.queryStringParameters||{})})),void 0!==o.headers.Authorization?(o.headers=Object.keys(o.headers).reduce((function(e,t){return o.headers[t]&&(e[t]=o.headers[t]),e}),{}),[2,this._request(o,c)]):[2,a.Credentials.get().then((function(e){return g._signed(h({},o),e,c)}),(function(e){return y.debug("No credentials available, the request will be unsigned"),g._request(o,c)}))]}}))}))},e.prototype.get=function(e,t){return this.ajax(e,"GET",t)},e.prototype.put=function(e,t){return this.ajax(e,"PUT",t)},e.prototype.patch=function(e,t){return this.ajax(e,"PATCH",t)},e.prototype.post=function(e,t){return this.ajax(e,"POST",t)},e.prototype.del=function(e,t){return this.ajax(e,"DELETE",t)},e.prototype.head=function(e,t){return this.ajax(e,"HEAD",t)},e.prototype.endpoint=function(e){var t=this,r=this._options.endpoints,n="";return Array.isArray(r)?(r.forEach((function(r){r.name===e&&(n=r.endpoint,"string"==typeof r.region?t._region=r.region:"string"==typeof t._options.region&&(t._region=t._options.region),"string"==typeof r.service?t._service=r.service||"execute-api":t._service="execute-api","function"==typeof r.custom_header?t._custom_header=r.custom_header:t._custom_header=void 0)})),n):n},e.prototype._signed=function(e,t,r){var n=e.signerServiceInfo,o=d(e,["signerServiceInfo"]),i=this._region||this._options.region,s=this._service||this._options.service,u={secret_key:t.secretAccessKey,access_key:t.accessKeyId,session_token:t.sessionToken},c={region:i,service:s},h=Object.assign(c,n),l=a.Signer.sign(o,u,h);return l.data&&(l.body=l.data),y.debug("Signed Request: ",l),delete l.headers.host,f()(l).then((function(e){return r?e:e.data})).catch((function(e){throw y.debug(e),e}))},e.prototype._request=function(e,t){return void 0===t&&(t=!1),f()(e).then((function(e){return t?e:e.data})).catch((function(e){throw y.debug(e),e}))},e.prototype._parseUrl=function(e){var t=e.split("/");return{host:t[2],path:"/"+t.slice(3).join("/")}},e}(),b=r(17),g=r.n(b),w=r(18),_=r.n(w),x=r(19),j=r(20),O=function(){return(O=Object.assign||function(e){for(var t,r=1,n=arguments.length;r<n;r++)for(var o in t=arguments[r])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)},A=function(e,t,r,n){return new(r||(r=Promise))((function(o,i){function s(e){try{u(n.next(e))}catch(e){i(e)}}function a(e){try{u(n.throw(e))}catch(e){i(e)}}function u(e){var t;e.done?o(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(s,a)}u((n=n.apply(e,t||[])).next())}))},P=function(e,t){var r,n,o,i,s={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(r)throw new TypeError("Generator is already executing.");for(;s;)try{if(r=1,n&&(o=2&i[0]?n.return:i[0]?n.throw||((o=n.return)&&o.call(n),0):n.next)&&!(o=o.call(n,i[1])).done)return o;switch(n=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return s.label++,{value:i[1],done:!1};case 5:s.label++,n=i[1],i=[0];continue;case 7:i=s.ops.pop(),s.trys.pop();continue;default:if(!(o=(o=s.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){s=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){s.label=i[1];break}if(6===i[0]&&s.label<o[1]){s.label=o[1],o=i;break}if(o&&s.label<o[2]){s.label=o[2],s.ops.push(i);break}o[2]&&s.ops.pop(),s.trys.pop();continue}i=t.call(e,s)}catch(e){i=[6,e],n=0}finally{r=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,a])}}},S=function(e,t){var r={};for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(n=Object.getOwnPropertySymbols(e);o<n.length;o++)t.indexOf(n[o])<0&&Object.prototype.propertyIsEnumerable.call(e,n[o])&&(r[n[o]]=e[n[o]])}return r},q=new a.ConsoleLogger("API"),E=function(e,t){return void 0===t&&(t={}),{query:e,variables:t}},C=function(){function e(e){this._api=null,this._pubSub=u.a.PubSub,this.clientIdentifier=Object(j.v4)(),this._options=e,q.debug("API Options",this._options)}return e.prototype.getModuleName=function(){return"API"},e.prototype.configure=function(e){var t=e||{},r=t.API,n=void 0===r?{}:r,o=S(t,["API"]),i=O(O({},o),n);if(q.debug("configure API",{opt:i}),i.aws_project_region){if(i.aws_cloud_logic_custom){var s=i.aws_cloud_logic_custom;i.endpoints="string"==typeof s?JSON.parse(s):s}i=Object.assign({},i,{region:i.aws_project_region,header:{}})}return Array.isArray(i.endpoints)||(i.endpoints=[]),i.endpoints.forEach((function(e){void 0!==e.custom_header&&"function"!=typeof e.custom_header&&(q.warn("API "+e.name+", custom_header should be a function"),e.custom_header=void 0)})),void 0!==i.graphql_headers&&"function"!=typeof i.graphql_headers&&(q.warn("graphql_headers should be a function"),i.graphql_headers=void 0),this._options=Object.assign({},this._options,i),this.createInstance(),this._options},e.prototype.createInstance=function(){return q.debug("create API instance"),this._options?(this._api=new m(this._options),!0):Promise.reject("API not configured")},e.prototype.get=function(e,t,r){return A(this,void 0,void 0,(function(){var n,o;return P(this,(function(i){switch(i.label){case 0:if(this._api)return[3,4];i.label=1;case 1:return i.trys.push([1,3,,4]),[4,this.createInstance()];case 2:return i.sent(),[3,4];case 3:return n=i.sent(),[2,Promise.reject(n)];case 4:return 0===(o=this._api.endpoint(e)).length?[2,Promise.reject("API "+e+" does not exist")]:[2,this._api.get(o+t,r)]}}))}))},e.prototype.post=function(e,t,r){return A(this,void 0,void 0,(function(){var n,o;return P(this,(function(i){switch(i.label){case 0:if(this._api)return[3,4];i.label=1;case 1:return i.trys.push([1,3,,4]),[4,this.createInstance()];case 2:return i.sent(),[3,4];case 3:return n=i.sent(),[2,Promise.reject(n)];case 4:return 0===(o=this._api.endpoint(e)).length?[2,Promise.reject("API "+e+" does not exist")]:[2,this._api.post(o+t,r)]}}))}))},e.prototype.put=function(e,t,r){return A(this,void 0,void 0,(function(){var n,o;return P(this,(function(i){switch(i.label){case 0:if(this._api)return[3,4];i.label=1;case 1:return i.trys.push([1,3,,4]),[4,this.createInstance()];case 2:return i.sent(),[3,4];case 3:return n=i.sent(),[2,Promise.reject(n)];case 4:return 0===(o=this._api.endpoint(e)).length?[2,Promise.reject("API "+e+" does not exist")]:[2,this._api.put(o+t,r)]}}))}))},e.prototype.patch=function(e,t,r){return A(this,void 0,void 0,(function(){var n,o;return P(this,(function(i){switch(i.label){case 0:if(this._api)return[3,4];i.label=1;case 1:return i.trys.push([1,3,,4]),[4,this.createInstance()];case 2:return i.sent(),[3,4];case 3:return n=i.sent(),[2,Promise.reject(n)];case 4:return 0===(o=this._api.endpoint(e)).length?[2,Promise.reject("API "+e+" does not exist")]:[2,this._api.patch(o+t,r)]}}))}))},e.prototype.del=function(e,t,r){return A(this,void 0,void 0,(function(){var n,o;return P(this,(function(i){switch(i.label){case 0:if(this._api)return[3,4];i.label=1;case 1:return i.trys.push([1,3,,4]),[4,this.createInstance()];case 2:return i.sent(),[3,4];case 3:return n=i.sent(),[2,Promise.reject(n)];case 4:return 0===(o=this._api.endpoint(e)).length?[2,Promise.reject("API "+e+" does not exist")]:[2,this._api.del(o+t,r)]}}))}))},e.prototype.head=function(e,t,r){return A(this,void 0,void 0,(function(){var n,o;return P(this,(function(i){switch(i.label){case 0:if(this._api)return[3,4];i.label=1;case 1:return i.trys.push([1,3,,4]),[4,this.createInstance()];case 2:return i.sent(),[3,4];case 3:return n=i.sent(),[2,Promise.reject(n)];case 4:return 0===(o=this._api.endpoint(e)).length?[2,Promise.reject("API "+e+" does not exist")]:[2,this._api.head(o+t,r)]}}))}))},e.prototype.endpoint=function(e){return A(this,void 0,void 0,(function(){var t;return P(this,(function(r){switch(r.label){case 0:if(this._api)return[3,4];r.label=1;case 1:return r.trys.push([1,3,,4]),[4,this.createInstance()];case 2:return r.sent(),[3,4];case 3:return t=r.sent(),[2,Promise.reject(t)];case 4:return[2,this._api.endpoint(e)]}}))}))},e.prototype._headerBasedAuth=function(e){return A(this,void 0,void 0,(function(){var t,r,n,o,i,s;return P(this,(function(a){switch(a.label){case 0:switch(t=this._options,r=t.aws_appsync_authenticationType,n=t.aws_appsync_apiKey,o={},e||r||"AWS_IAM"){case"API_KEY":return[3,1];case"AWS_IAM":return[3,2];case"OPENID_CONNECT":return[3,4];case"AMAZON_COGNITO_USER_POOLS":return[3,6]}return[3,8];case 1:if(!n)throw new Error("No api-key configured");return o={Authorization:null,"X-Api-Key":n},[3,9];case 2:return[4,this._ensureCredentials()];case 3:if(!a.sent())throw new Error("No credentials");return[3,9];case 4:return[4,_.a.getItem("federatedInfo")];case 5:if(!(i=a.sent())||!i.token)throw new Error("No federated jwt");return o={Authorization:i.token},[3,9];case 6:return[4,g.a.currentSession()];case 7:return s=a.sent(),o={Authorization:s.getAccessToken().getJwtToken()},[3,9];case 8:return o={Authorization:null},[3,9];case 9:return[2,o]}}))}))},e.prototype.getGraphqlOperationType=function(e){return Object(i.parse)(e).definitions[0].operation},e.prototype.graphql=function(e){var t=e.query,r=e.variables,n=void 0===r?{}:r,s=e.authMode,a="string"==typeof t?Object(i.parse)(t):Object(i.parse)(Object(o.print)(t)),u=a.definitions.filter((function(e){return"OperationDefinition"===e.kind}))[0],c=(void 0===u?{}:u).operation;switch(c){case"query":case"mutation":return this._graphql({query:a,variables:n,authMode:s});case"subscription":return this._graphqlSubscribe({query:a,variables:n,authMode:s})}throw new Error("invalid operation type: "+c)},e.prototype._graphql=function(e,t){var r=e.query,i=e.variables,s=e.authMode;return void 0===t&&(t={}),A(this,void 0,void 0,(function(){var e,u,c,f,h,l,p,d,y,v,m,b,g,w,_,x,j,A,S,q,E;return P(this,(function(P){switch(P.label){case 0:return this._api?[3,2]:[4,this.createInstance()];case 1:P.sent(),P.label=2;case 2:return e=this._options,u=e.aws_appsync_region,c=e.aws_appsync_graphqlEndpoint,f=e.graphql_headers,h=void 0===f?function(){return{}}:f,l=e.graphql_endpoint,p=e.graphql_endpoint_iam_region,y=[{}],(v=!l)?[4,this._headerBasedAuth(s)]:[3,4];case 3:v=P.sent(),P.label=4;case 4:return m=[O.apply(void 0,y.concat([v]))],(b=l)?p?[4,this._headerBasedAuth(s)]:[3,6]:[3,8];case 5:return g=P.sent(),[3,7];case 6:g={Authorization:null},P.label=7;case 7:b=g,P.label=8;case 8:return w=[O.apply(void 0,m.concat([b]))],[4,h({query:r,variables:i})];case 9:if(d=O.apply(void 0,[O.apply(void 0,[O.apply(void 0,w.concat([P.sent()])),t]),!l&&(E={},E["x-amz-user-agent"]=a.Constants.userAgent,E)]),_={query:Object(o.print)(r),variables:i},x={headers:d,body:_,signerServiceInfo:{service:l?"execute-api":"appsync",region:l?p:u}},!(j=l||c))throw{data:{},errors:[new n.GraphQLError("No graphql endpoint provided.")]};P.label=10;case 10:return P.trys.push([10,12,,13]),[4,this._api.post(j,x)];case 11:return A=P.sent(),[3,13];case 12:return S=P.sent(),A={data:{},errors:[new n.GraphQLError(S.message)]},[3,13];case 13:if((q=A.errors)&&q.length)throw A;return[2,A]}}))}))},e.prototype._graphqlSubscribe=function(e){var t=this,r=e.query,o=e.variables,i=e.authMode;if(u.a.PubSub&&"function"==typeof u.a.PubSub.subscribe)return new s((function(e){var s=null;return A(t,void 0,void 0,(function(){var t,a,c,f,h,l,p;return P(this,(function(d){switch(d.label){case 0:t=this._options.aws_appsync_authenticationType,a=O({},"API_KEY"===(i||t)?{"x-amz-subscriber-id":this.clientIdentifier}:{}),d.label=1;case 1:return d.trys.push([1,3,,4]),[4,this._graphql({query:r,variables:o,authMode:i},a)];case 2:return c=d.sent().extensions.subscription,f=c.newSubscriptions,h=Object.getOwnPropertyNames(f).map((function(e){return f[e].topic})),l=u.a.PubSub.subscribe(h,O(O({},c),{provider:x.INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER})),s=l.subscribe({next:function(t){return e.next(t)},complete:function(){return e.complete()},error:function(t){var r=O({},t);r.errors||(r.errors=[O({},new n.GraphQLError("Network Error"))]),e.error(r)}}),[3,4];case 3:return p=d.sent(),e.error(p),[3,4];case 4:return[2]}}))})),function(){s&&s.unsubscribe()}}));throw q.debug("No pubsub module applied for subscription"),new Error("No pubsub module applied for subscription")},e.prototype._ensureCredentials=function(){return a.Credentials.get().then((function(e){if(!e)return!1;var t=a.Credentials.shear(e);return q.debug("set credentials for api",t),!0})).catch((function(e){return q.warn("ensure credentials error",e),!1}))},e}();r.d(t,"APIClass",(function(){return C})),r.d(t,"graphqlOperation",(function(){return E}));var T=new a.ConsoleLogger("API"),I=null;I||(T.debug("Create API Instance"),I=new C(null));var k=I;u.a.register(k);t.default=k}])}));
	//# sourceMappingURL=aws-amplify-api.min.js.map

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(26)):"function"==typeof define&&define.amd?define("aws_amplify_auth",["@aws-amplify/core"],t):"object"==typeof exports?exports.aws_amplify_auth=t(require("@aws-amplify/core")):e.aws_amplify_auth=t(e["@aws-amplify/core"])}(this,(function(e){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var i=t[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)n.d(r,i,function(t){return e[t]}.bind(null,i));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=20)}([function(t,n){t.exports=e},function(e,t,n){"use strict";(function(e){
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	var r=n(10),i=n(11),o=n(12);function s(){return u.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function a(e,t){if(s()<t)throw new RangeError("Invalid typed array length");return u.TYPED_ARRAY_SUPPORT?(e=new Uint8Array(t)).__proto__=u.prototype:(null===e&&(e=new u(t)),e.length=t),e}function u(e,t,n){if(!(u.TYPED_ARRAY_SUPPORT||this instanceof u))return new u(e,t,n);if("number"==typeof e){if("string"==typeof t)throw new Error("If encoding is specified then the first argument must be a string");return f(this,e)}return c(this,e,t,n)}function c(e,t,n,r){if("number"==typeof t)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&t instanceof ArrayBuffer?function(e,t,n,r){if(t.byteLength,n<0||t.byteLength<n)throw new RangeError("'offset' is out of bounds");if(t.byteLength<n+(r||0))throw new RangeError("'length' is out of bounds");t=void 0===n&&void 0===r?new Uint8Array(t):void 0===r?new Uint8Array(t,n):new Uint8Array(t,n,r);u.TYPED_ARRAY_SUPPORT?(e=t).__proto__=u.prototype:e=l(e,t);return e}(e,t,n,r):"string"==typeof t?function(e,t,n){"string"==typeof n&&""!==n||(n="utf8");if(!u.isEncoding(n))throw new TypeError('"encoding" must be a valid string encoding');var r=0|d(t,n),i=(e=a(e,r)).write(t,n);i!==r&&(e=e.slice(0,i));return e}(e,t,n):function(e,t){if(u.isBuffer(t)){var n=0|p(t.length);return 0===(e=a(e,n)).length?e:(t.copy(e,0,0,n),e)}if(t){if("undefined"!=typeof ArrayBuffer&&t.buffer instanceof ArrayBuffer||"length"in t)return"number"!=typeof t.length||(r=t.length)!=r?a(e,0):l(e,t);if("Buffer"===t.type&&o(t.data))return l(e,t.data)}var r;throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(e,t)}function h(e){if("number"!=typeof e)throw new TypeError('"size" argument must be a number');if(e<0)throw new RangeError('"size" argument must not be negative')}function f(e,t){if(h(t),e=a(e,t<0?0:0|p(t)),!u.TYPED_ARRAY_SUPPORT)for(var n=0;n<t;++n)e[n]=0;return e}function l(e,t){var n=t.length<0?0:0|p(t.length);e=a(e,n);for(var r=0;r<n;r+=1)e[r]=255&t[r];return e}function p(e){if(e>=s())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+s().toString(16)+" bytes");return 0|e}function d(e,t){if(u.isBuffer(e))return e.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(e)||e instanceof ArrayBuffer))return e.byteLength;"string"!=typeof e&&(e=""+e);var n=e.length;if(0===n)return 0;for(var r=!1;;)switch(t){case"ascii":case"latin1":case"binary":return n;case"utf8":case"utf-8":case void 0:return V(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*n;case"hex":return n>>>1;case"base64":return K(e).length;default:if(r)return V(e).length;t=(""+t).toLowerCase(),r=!0}}function g(e,t,n){var r=!1;if((void 0===t||t<0)&&(t=0),t>this.length)return"";if((void 0===n||n>this.length)&&(n=this.length),n<=0)return"";if((n>>>=0)<=(t>>>=0))return"";for(e||(e="utf8");;)switch(e){case"hex":return P(this,t,n);case"utf8":case"utf-8":return E(this,t,n);case"ascii":return T(this,t,n);case"latin1":case"binary":return _(this,t,n);case"base64":return I(this,t,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return D(this,t,n);default:if(r)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase(),r=!0}}function y(e,t,n){var r=e[t];e[t]=e[n],e[n]=r}function m(e,t,n,r,i){if(0===e.length)return-1;if("string"==typeof n?(r=n,n=0):n>2147483647?n=2147483647:n<-2147483648&&(n=-2147483648),n=+n,isNaN(n)&&(n=i?0:e.length-1),n<0&&(n=e.length+n),n>=e.length){if(i)return-1;n=e.length-1}else if(n<0){if(!i)return-1;n=0}if("string"==typeof t&&(t=u.from(t,r)),u.isBuffer(t))return 0===t.length?-1:v(e,t,n,r,i);if("number"==typeof t)return t&=255,u.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(e,t,n):Uint8Array.prototype.lastIndexOf.call(e,t,n):v(e,[t],n,r,i);throw new TypeError("val must be string, number or Buffer")}function v(e,t,n,r,i){var o,s=1,a=e.length,u=t.length;if(void 0!==r&&("ucs2"===(r=String(r).toLowerCase())||"ucs-2"===r||"utf16le"===r||"utf-16le"===r)){if(e.length<2||t.length<2)return-1;s=2,a/=2,u/=2,n/=2}function c(e,t){return 1===s?e[t]:e.readUInt16BE(t*s)}if(i){var h=-1;for(o=n;o<a;o++)if(c(e,o)===c(t,-1===h?0:o-h)){if(-1===h&&(h=o),o-h+1===u)return h*s}else-1!==h&&(o-=o-h),h=-1}else for(n+u>a&&(n=a-u),o=n;o>=0;o--){for(var f=!0,l=0;l<u;l++)if(c(e,o+l)!==c(t,l)){f=!1;break}if(f)return o}return-1}function w(e,t,n,r){n=Number(n)||0;var i=e.length-n;r?(r=Number(r))>i&&(r=i):r=i;var o=t.length;if(o%2!=0)throw new TypeError("Invalid hex string");r>o/2&&(r=o/2);for(var s=0;s<r;++s){var a=parseInt(t.substr(2*s,2),16);if(isNaN(a))return s;e[n+s]=a}return s}function S(e,t,n,r){return q(V(t,e.length-n),e,n,r)}function A(e,t,n,r){return q(function(e){for(var t=[],n=0;n<e.length;++n)t.push(255&e.charCodeAt(n));return t}(t),e,n,r)}function b(e,t,n,r){return A(e,t,n,r)}function C(e,t,n,r){return q(K(t),e,n,r)}function U(e,t,n,r){return q(function(e,t){for(var n,r,i,o=[],s=0;s<e.length&&!((t-=2)<0);++s)n=e.charCodeAt(s),r=n>>8,i=n%256,o.push(i),o.push(r);return o}(t,e.length-n),e,n,r)}function I(e,t,n){return 0===t&&n===e.length?r.fromByteArray(e):r.fromByteArray(e.slice(t,n))}function E(e,t,n){n=Math.min(e.length,n);for(var r=[],i=t;i<n;){var o,s,a,u,c=e[i],h=null,f=c>239?4:c>223?3:c>191?2:1;if(i+f<=n)switch(f){case 1:c<128&&(h=c);break;case 2:128==(192&(o=e[i+1]))&&(u=(31&c)<<6|63&o)>127&&(h=u);break;case 3:o=e[i+1],s=e[i+2],128==(192&o)&&128==(192&s)&&(u=(15&c)<<12|(63&o)<<6|63&s)>2047&&(u<55296||u>57343)&&(h=u);break;case 4:o=e[i+1],s=e[i+2],a=e[i+3],128==(192&o)&&128==(192&s)&&128==(192&a)&&(u=(15&c)<<18|(63&o)<<12|(63&s)<<6|63&a)>65535&&u<1114112&&(h=u)}null===h?(h=65533,f=1):h>65535&&(h-=65536,r.push(h>>>10&1023|55296),h=56320|1023&h),r.push(h),i+=f}return function(e){var t=e.length;if(t<=4096)return String.fromCharCode.apply(String,e);var n="",r=0;for(;r<t;)n+=String.fromCharCode.apply(String,e.slice(r,r+=4096));return n}(r)}t.Buffer=u,t.SlowBuffer=function(e){+e!=e&&(e=0);return u.alloc(+e)},t.INSPECT_MAX_BYTES=50,u.TYPED_ARRAY_SUPPORT=void 0!==e.TYPED_ARRAY_SUPPORT?e.TYPED_ARRAY_SUPPORT:function(){try{var e=new Uint8Array(1);return e.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===e.foo()&&"function"==typeof e.subarray&&0===e.subarray(1,1).byteLength}catch(e){return!1}}(),t.kMaxLength=s(),u.poolSize=8192,u._augment=function(e){return e.__proto__=u.prototype,e},u.from=function(e,t,n){return c(null,e,t,n)},u.TYPED_ARRAY_SUPPORT&&(u.prototype.__proto__=Uint8Array.prototype,u.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&u[Symbol.species]===u&&Object.defineProperty(u,Symbol.species,{value:null,configurable:!0})),u.alloc=function(e,t,n){return function(e,t,n,r){return h(t),t<=0?a(e,t):void 0!==n?"string"==typeof r?a(e,t).fill(n,r):a(e,t).fill(n):a(e,t)}(null,e,t,n)},u.allocUnsafe=function(e){return f(null,e)},u.allocUnsafeSlow=function(e){return f(null,e)},u.isBuffer=function(e){return!(null==e||!e._isBuffer)},u.compare=function(e,t){if(!u.isBuffer(e)||!u.isBuffer(t))throw new TypeError("Arguments must be Buffers");if(e===t)return 0;for(var n=e.length,r=t.length,i=0,o=Math.min(n,r);i<o;++i)if(e[i]!==t[i]){n=e[i],r=t[i];break}return n<r?-1:r<n?1:0},u.isEncoding=function(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},u.concat=function(e,t){if(!o(e))throw new TypeError('"list" argument must be an Array of Buffers');if(0===e.length)return u.alloc(0);var n;if(void 0===t)for(t=0,n=0;n<e.length;++n)t+=e[n].length;var r=u.allocUnsafe(t),i=0;for(n=0;n<e.length;++n){var s=e[n];if(!u.isBuffer(s))throw new TypeError('"list" argument must be an Array of Buffers');s.copy(r,i),i+=s.length}return r},u.byteLength=d,u.prototype._isBuffer=!0,u.prototype.swap16=function(){var e=this.length;if(e%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var t=0;t<e;t+=2)y(this,t,t+1);return this},u.prototype.swap32=function(){var e=this.length;if(e%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var t=0;t<e;t+=4)y(this,t,t+3),y(this,t+1,t+2);return this},u.prototype.swap64=function(){var e=this.length;if(e%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var t=0;t<e;t+=8)y(this,t,t+7),y(this,t+1,t+6),y(this,t+2,t+5),y(this,t+3,t+4);return this},u.prototype.toString=function(){var e=0|this.length;return 0===e?"":0===arguments.length?E(this,0,e):g.apply(this,arguments)},u.prototype.equals=function(e){if(!u.isBuffer(e))throw new TypeError("Argument must be a Buffer");return this===e||0===u.compare(this,e)},u.prototype.inspect=function(){var e="",n=t.INSPECT_MAX_BYTES;return this.length>0&&(e=this.toString("hex",0,n).match(/.{2}/g).join(" "),this.length>n&&(e+=" ... ")),"<Buffer "+e+">"},u.prototype.compare=function(e,t,n,r,i){if(!u.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(void 0===t&&(t=0),void 0===n&&(n=e?e.length:0),void 0===r&&(r=0),void 0===i&&(i=this.length),t<0||n>e.length||r<0||i>this.length)throw new RangeError("out of range index");if(r>=i&&t>=n)return 0;if(r>=i)return-1;if(t>=n)return 1;if(this===e)return 0;for(var o=(i>>>=0)-(r>>>=0),s=(n>>>=0)-(t>>>=0),a=Math.min(o,s),c=this.slice(r,i),h=e.slice(t,n),f=0;f<a;++f)if(c[f]!==h[f]){o=c[f],s=h[f];break}return o<s?-1:s<o?1:0},u.prototype.includes=function(e,t,n){return-1!==this.indexOf(e,t,n)},u.prototype.indexOf=function(e,t,n){return m(this,e,t,n,!0)},u.prototype.lastIndexOf=function(e,t,n){return m(this,e,t,n,!1)},u.prototype.write=function(e,t,n,r){if(void 0===t)r="utf8",n=this.length,t=0;else if(void 0===n&&"string"==typeof t)r=t,n=this.length,t=0;else{if(!isFinite(t))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");t|=0,isFinite(n)?(n|=0,void 0===r&&(r="utf8")):(r=n,n=void 0)}var i=this.length-t;if((void 0===n||n>i)&&(n=i),e.length>0&&(n<0||t<0)||t>this.length)throw new RangeError("Attempt to write outside buffer bounds");r||(r="utf8");for(var o=!1;;)switch(r){case"hex":return w(this,e,t,n);case"utf8":case"utf-8":return S(this,e,t,n);case"ascii":return A(this,e,t,n);case"latin1":case"binary":return b(this,e,t,n);case"base64":return C(this,e,t,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return U(this,e,t,n);default:if(o)throw new TypeError("Unknown encoding: "+r);r=(""+r).toLowerCase(),o=!0}},u.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function T(e,t,n){var r="";n=Math.min(e.length,n);for(var i=t;i<n;++i)r+=String.fromCharCode(127&e[i]);return r}function _(e,t,n){var r="";n=Math.min(e.length,n);for(var i=t;i<n;++i)r+=String.fromCharCode(e[i]);return r}function P(e,t,n){var r=e.length;(!t||t<0)&&(t=0),(!n||n<0||n>r)&&(n=r);for(var i="",o=t;o<n;++o)i+=j(e[o]);return i}function D(e,t,n){for(var r=e.slice(t,n),i="",o=0;o<r.length;o+=2)i+=String.fromCharCode(r[o]+256*r[o+1]);return i}function R(e,t,n){if(e%1!=0||e<0)throw new RangeError("offset is not uint");if(e+t>n)throw new RangeError("Trying to access beyond buffer length")}function k(e,t,n,r,i,o){if(!u.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(t>i||t<o)throw new RangeError('"value" argument is out of bounds');if(n+r>e.length)throw new RangeError("Index out of range")}function F(e,t,n,r){t<0&&(t=65535+t+1);for(var i=0,o=Math.min(e.length-n,2);i<o;++i)e[n+i]=(t&255<<8*(r?i:1-i))>>>8*(r?i:1-i)}function O(e,t,n,r){t<0&&(t=4294967295+t+1);for(var i=0,o=Math.min(e.length-n,4);i<o;++i)e[n+i]=t>>>8*(r?i:3-i)&255}function M(e,t,n,r,i,o){if(n+r>e.length)throw new RangeError("Index out of range");if(n<0)throw new RangeError("Index out of range")}function x(e,t,n,r,o){return o||M(e,0,n,4),i.write(e,t,n,r,23,4),n+4}function B(e,t,n,r,o){return o||M(e,0,n,8),i.write(e,t,n,r,52,8),n+8}u.prototype.slice=function(e,t){var n,r=this.length;if((e=~~e)<0?(e+=r)<0&&(e=0):e>r&&(e=r),(t=void 0===t?r:~~t)<0?(t+=r)<0&&(t=0):t>r&&(t=r),t<e&&(t=e),u.TYPED_ARRAY_SUPPORT)(n=this.subarray(e,t)).__proto__=u.prototype;else{var i=t-e;n=new u(i,void 0);for(var o=0;o<i;++o)n[o]=this[o+e]}return n},u.prototype.readUIntLE=function(e,t,n){e|=0,t|=0,n||R(e,t,this.length);for(var r=this[e],i=1,o=0;++o<t&&(i*=256);)r+=this[e+o]*i;return r},u.prototype.readUIntBE=function(e,t,n){e|=0,t|=0,n||R(e,t,this.length);for(var r=this[e+--t],i=1;t>0&&(i*=256);)r+=this[e+--t]*i;return r},u.prototype.readUInt8=function(e,t){return t||R(e,1,this.length),this[e]},u.prototype.readUInt16LE=function(e,t){return t||R(e,2,this.length),this[e]|this[e+1]<<8},u.prototype.readUInt16BE=function(e,t){return t||R(e,2,this.length),this[e]<<8|this[e+1]},u.prototype.readUInt32LE=function(e,t){return t||R(e,4,this.length),(this[e]|this[e+1]<<8|this[e+2]<<16)+16777216*this[e+3]},u.prototype.readUInt32BE=function(e,t){return t||R(e,4,this.length),16777216*this[e]+(this[e+1]<<16|this[e+2]<<8|this[e+3])},u.prototype.readIntLE=function(e,t,n){e|=0,t|=0,n||R(e,t,this.length);for(var r=this[e],i=1,o=0;++o<t&&(i*=256);)r+=this[e+o]*i;return r>=(i*=128)&&(r-=Math.pow(2,8*t)),r},u.prototype.readIntBE=function(e,t,n){e|=0,t|=0,n||R(e,t,this.length);for(var r=t,i=1,o=this[e+--r];r>0&&(i*=256);)o+=this[e+--r]*i;return o>=(i*=128)&&(o-=Math.pow(2,8*t)),o},u.prototype.readInt8=function(e,t){return t||R(e,1,this.length),128&this[e]?-1*(255-this[e]+1):this[e]},u.prototype.readInt16LE=function(e,t){t||R(e,2,this.length);var n=this[e]|this[e+1]<<8;return 32768&n?4294901760|n:n},u.prototype.readInt16BE=function(e,t){t||R(e,2,this.length);var n=this[e+1]|this[e]<<8;return 32768&n?4294901760|n:n},u.prototype.readInt32LE=function(e,t){return t||R(e,4,this.length),this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24},u.prototype.readInt32BE=function(e,t){return t||R(e,4,this.length),this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]},u.prototype.readFloatLE=function(e,t){return t||R(e,4,this.length),i.read(this,e,!0,23,4)},u.prototype.readFloatBE=function(e,t){return t||R(e,4,this.length),i.read(this,e,!1,23,4)},u.prototype.readDoubleLE=function(e,t){return t||R(e,8,this.length),i.read(this,e,!0,52,8)},u.prototype.readDoubleBE=function(e,t){return t||R(e,8,this.length),i.read(this,e,!1,52,8)},u.prototype.writeUIntLE=function(e,t,n,r){(e=+e,t|=0,n|=0,r)||k(this,e,t,n,Math.pow(2,8*n)-1,0);var i=1,o=0;for(this[t]=255&e;++o<n&&(i*=256);)this[t+o]=e/i&255;return t+n},u.prototype.writeUIntBE=function(e,t,n,r){(e=+e,t|=0,n|=0,r)||k(this,e,t,n,Math.pow(2,8*n)-1,0);var i=n-1,o=1;for(this[t+i]=255&e;--i>=0&&(o*=256);)this[t+i]=e/o&255;return t+n},u.prototype.writeUInt8=function(e,t,n){return e=+e,t|=0,n||k(this,e,t,1,255,0),u.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),this[t]=255&e,t+1},u.prototype.writeUInt16LE=function(e,t,n){return e=+e,t|=0,n||k(this,e,t,2,65535,0),u.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):F(this,e,t,!0),t+2},u.prototype.writeUInt16BE=function(e,t,n){return e=+e,t|=0,n||k(this,e,t,2,65535,0),u.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):F(this,e,t,!1),t+2},u.prototype.writeUInt32LE=function(e,t,n){return e=+e,t|=0,n||k(this,e,t,4,4294967295,0),u.TYPED_ARRAY_SUPPORT?(this[t+3]=e>>>24,this[t+2]=e>>>16,this[t+1]=e>>>8,this[t]=255&e):O(this,e,t,!0),t+4},u.prototype.writeUInt32BE=function(e,t,n){return e=+e,t|=0,n||k(this,e,t,4,4294967295,0),u.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):O(this,e,t,!1),t+4},u.prototype.writeIntLE=function(e,t,n,r){if(e=+e,t|=0,!r){var i=Math.pow(2,8*n-1);k(this,e,t,n,i-1,-i)}var o=0,s=1,a=0;for(this[t]=255&e;++o<n&&(s*=256);)e<0&&0===a&&0!==this[t+o-1]&&(a=1),this[t+o]=(e/s>>0)-a&255;return t+n},u.prototype.writeIntBE=function(e,t,n,r){if(e=+e,t|=0,!r){var i=Math.pow(2,8*n-1);k(this,e,t,n,i-1,-i)}var o=n-1,s=1,a=0;for(this[t+o]=255&e;--o>=0&&(s*=256);)e<0&&0===a&&0!==this[t+o+1]&&(a=1),this[t+o]=(e/s>>0)-a&255;return t+n},u.prototype.writeInt8=function(e,t,n){return e=+e,t|=0,n||k(this,e,t,1,127,-128),u.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),e<0&&(e=255+e+1),this[t]=255&e,t+1},u.prototype.writeInt16LE=function(e,t,n){return e=+e,t|=0,n||k(this,e,t,2,32767,-32768),u.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):F(this,e,t,!0),t+2},u.prototype.writeInt16BE=function(e,t,n){return e=+e,t|=0,n||k(this,e,t,2,32767,-32768),u.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):F(this,e,t,!1),t+2},u.prototype.writeInt32LE=function(e,t,n){return e=+e,t|=0,n||k(this,e,t,4,2147483647,-2147483648),u.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8,this[t+2]=e>>>16,this[t+3]=e>>>24):O(this,e,t,!0),t+4},u.prototype.writeInt32BE=function(e,t,n){return e=+e,t|=0,n||k(this,e,t,4,2147483647,-2147483648),e<0&&(e=4294967295+e+1),u.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):O(this,e,t,!1),t+4},u.prototype.writeFloatLE=function(e,t,n){return x(this,e,t,!0,n)},u.prototype.writeFloatBE=function(e,t,n){return x(this,e,t,!1,n)},u.prototype.writeDoubleLE=function(e,t,n){return B(this,e,t,!0,n)},u.prototype.writeDoubleBE=function(e,t,n){return B(this,e,t,!1,n)},u.prototype.copy=function(e,t,n,r){if(n||(n=0),r||0===r||(r=this.length),t>=e.length&&(t=e.length),t||(t=0),r>0&&r<n&&(r=n),r===n)return 0;if(0===e.length||0===this.length)return 0;if(t<0)throw new RangeError("targetStart out of bounds");if(n<0||n>=this.length)throw new RangeError("sourceStart out of bounds");if(r<0)throw new RangeError("sourceEnd out of bounds");r>this.length&&(r=this.length),e.length-t<r-n&&(r=e.length-t+n);var i,o=r-n;if(this===e&&n<t&&t<r)for(i=o-1;i>=0;--i)e[i+t]=this[i+n];else if(o<1e3||!u.TYPED_ARRAY_SUPPORT)for(i=0;i<o;++i)e[i+t]=this[i+n];else Uint8Array.prototype.set.call(e,this.subarray(n,n+o),t);return o},u.prototype.fill=function(e,t,n,r){if("string"==typeof e){if("string"==typeof t?(r=t,t=0,n=this.length):"string"==typeof n&&(r=n,n=this.length),1===e.length){var i=e.charCodeAt(0);i<256&&(e=i)}if(void 0!==r&&"string"!=typeof r)throw new TypeError("encoding must be a string");if("string"==typeof r&&!u.isEncoding(r))throw new TypeError("Unknown encoding: "+r)}else"number"==typeof e&&(e&=255);if(t<0||this.length<t||this.length<n)throw new RangeError("Out of range index");if(n<=t)return this;var o;if(t>>>=0,n=void 0===n?this.length:n>>>0,e||(e=0),"number"==typeof e)for(o=t;o<n;++o)this[o]=e;else{var s=u.isBuffer(e)?e:V(new u(e,r).toString()),a=s.length;for(o=0;o<n-t;++o)this[o+t]=s[o%a]}return this};var N=/[^+\/0-9A-Za-z-_]/g;function j(e){return e<16?"0"+e.toString(16):e.toString(16)}function V(e,t){var n;t=t||1/0;for(var r=e.length,i=null,o=[],s=0;s<r;++s){if((n=e.charCodeAt(s))>55295&&n<57344){if(!i){if(n>56319){(t-=3)>-1&&o.push(239,191,189);continue}if(s+1===r){(t-=3)>-1&&o.push(239,191,189);continue}i=n;continue}if(n<56320){(t-=3)>-1&&o.push(239,191,189),i=n;continue}n=65536+(i-55296<<10|n-56320)}else i&&(t-=3)>-1&&o.push(239,191,189);if(i=null,n<128){if((t-=1)<0)break;o.push(n)}else if(n<2048){if((t-=2)<0)break;o.push(n>>6|192,63&n|128)}else if(n<65536){if((t-=3)<0)break;o.push(n>>12|224,n>>6&63|128,63&n|128)}else{if(!(n<1114112))throw new Error("Invalid code point");if((t-=4)<0)break;o.push(n>>18|240,n>>12&63|128,n>>6&63|128,63&n|128)}}return o}function K(e){return r.toByteArray(function(e){if((e=function(e){return e.trim?e.trim():e.replace(/^\s+|\s+$/g,"")}(e).replace(N,"")).length<2)return"";for(;e.length%4!=0;)e+="=";return e}(e))}function q(e,t,n,r){for(var i=0;i<r&&!(i+n>=t.length||i>=e.length);++i)t[i+n]=e[i];return i}}).call(this,n(8))},function(e,t,n){var r;e.exports=(r=r||function(e,t){var n=Object.create||function(){function e(){}return function(t){var n;return e.prototype=t,n=new e,e.prototype=null,n}}(),r={},i=r.lib={},o=i.Base={extend:function(e){var t=n(this);return e&&t.mixIn(e),t.hasOwnProperty("init")&&this.init!==t.init||(t.init=function(){t.$super.init.apply(this,arguments)}),t.init.prototype=t,t.$super=this,t},create:function(){var e=this.extend();return e.init.apply(e,arguments),e},init:function(){},mixIn:function(e){for(var t in e)e.hasOwnProperty(t)&&(this[t]=e[t]);e.hasOwnProperty("toString")&&(this.toString=e.toString)},clone:function(){return this.init.prototype.extend(this)}},s=i.WordArray=o.extend({init:function(e,t){e=this.words=e||[],this.sigBytes=null!=t?t:4*e.length},toString:function(e){return(e||u).stringify(this)},concat:function(e){var t=this.words,n=e.words,r=this.sigBytes,i=e.sigBytes;if(this.clamp(),r%4)for(var o=0;o<i;o++){var s=n[o>>>2]>>>24-o%4*8&255;t[r+o>>>2]|=s<<24-(r+o)%4*8}else for(o=0;o<i;o+=4)t[r+o>>>2]=n[o>>>2];return this.sigBytes+=i,this},clamp:function(){var t=this.words,n=this.sigBytes;t[n>>>2]&=4294967295<<32-n%4*8,t.length=e.ceil(n/4)},clone:function(){var e=o.clone.call(this);return e.words=this.words.slice(0),e},random:function(t){for(var n,r=[],i=function(t){t=t;var n=987654321,r=4294967295;return function(){var i=((n=36969*(65535&n)+(n>>16)&r)<<16)+(t=18e3*(65535&t)+(t>>16)&r)&r;return i/=4294967296,(i+=.5)*(e.random()>.5?1:-1)}},o=0;o<t;o+=4){var a=i(4294967296*(n||e.random()));n=987654071*a(),r.push(4294967296*a()|0)}return new s.init(r,t)}}),a=r.enc={},u=a.Hex={stringify:function(e){for(var t=e.words,n=e.sigBytes,r=[],i=0;i<n;i++){var o=t[i>>>2]>>>24-i%4*8&255;r.push((o>>>4).toString(16)),r.push((15&o).toString(16))}return r.join("")},parse:function(e){for(var t=e.length,n=[],r=0;r<t;r+=2)n[r>>>3]|=parseInt(e.substr(r,2),16)<<24-r%8*4;return new s.init(n,t/2)}},c=a.Latin1={stringify:function(e){for(var t=e.words,n=e.sigBytes,r=[],i=0;i<n;i++){var o=t[i>>>2]>>>24-i%4*8&255;r.push(String.fromCharCode(o))}return r.join("")},parse:function(e){for(var t=e.length,n=[],r=0;r<t;r++)n[r>>>2]|=(255&e.charCodeAt(r))<<24-r%4*8;return new s.init(n,t)}},h=a.Utf8={stringify:function(e){try{return decodeURIComponent(escape(c.stringify(e)))}catch(e){throw new Error("Malformed UTF-8 data")}},parse:function(e){return c.parse(unescape(encodeURIComponent(e)))}},f=i.BufferedBlockAlgorithm=o.extend({reset:function(){this._data=new s.init,this._nDataBytes=0},_append:function(e){"string"==typeof e&&(e=h.parse(e)),this._data.concat(e),this._nDataBytes+=e.sigBytes},_process:function(t){var n=this._data,r=n.words,i=n.sigBytes,o=this.blockSize,a=i/(4*o),u=(a=t?e.ceil(a):e.max((0|a)-this._minBufferSize,0))*o,c=e.min(4*u,i);if(u){for(var h=0;h<u;h+=o)this._doProcessBlock(r,h);var f=r.splice(0,u);n.sigBytes-=c}return new s.init(f,c)},clone:function(){var e=o.clone.call(this);return e._data=this._data.clone(),e},_minBufferSize:0}),l=(i.Hasher=f.extend({cfg:o.extend(),init:function(e){this.cfg=this.cfg.extend(e),this.reset()},reset:function(){f.reset.call(this),this._doReset()},update:function(e){return this._append(e),this._process(),this},finalize:function(e){return e&&this._append(e),this._doFinalize()},blockSize:16,_createHelper:function(e){return function(t,n){return new e.init(n).finalize(t)}},_createHmacHelper:function(e){return function(t,n){return new l.HMAC.init(e,n).finalize(t)}}}),r.algo={});return r}(Math),r)},function(e,t,n){"use strict";var r=n(14),i=n(16);function o(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}t.parse=w,t.resolve=function(e,t){return w(e,!1,!0).resolve(t)},t.resolveObject=function(e,t){return e?w(e,!1,!0).resolveObject(t):t},t.format=function(e){i.isString(e)&&(e=w(e));return e instanceof o?e.format():o.prototype.format.call(e)},t.Url=o;var s=/^([a-z0-9.+-]+:)/i,a=/:[0-9]*$/,u=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,c=["{","}","|","\\","^","`"].concat(["<",">",'"',"`"," ","\r","\n","\t"]),h=["'"].concat(c),f=["%","/","?",";","#"].concat(h),l=["/","?","#"],p=/^[+a-z0-9A-Z_-]{0,63}$/,d=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,g={javascript:!0,"javascript:":!0},y={javascript:!0,"javascript:":!0},m={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},v=n(17);function w(e,t,n){if(e&&i.isObject(e)&&e instanceof o)return e;var r=new o;return r.parse(e,t,n),r}o.prototype.parse=function(e,t,n){if(!i.isString(e))throw new TypeError("Parameter 'url' must be a string, not "+typeof e);var o=e.indexOf("?"),a=-1!==o&&o<e.indexOf("#")?"?":"#",c=e.split(a);c[0]=c[0].replace(/\\/g,"/");var w=e=c.join(a);if(w=w.trim(),!n&&1===e.split("#").length){var S=u.exec(w);if(S)return this.path=w,this.href=w,this.pathname=S[1],S[2]?(this.search=S[2],this.query=t?v.parse(this.search.substr(1)):this.search.substr(1)):t&&(this.search="",this.query={}),this}var A=s.exec(w);if(A){var b=(A=A[0]).toLowerCase();this.protocol=b,w=w.substr(A.length)}if(n||A||w.match(/^\/\/[^@\/]+@[^@\/]+/)){var C="//"===w.substr(0,2);!C||A&&y[A]||(w=w.substr(2),this.slashes=!0)}if(!y[A]&&(C||A&&!m[A])){for(var U,I,E=-1,T=0;T<l.length;T++){-1!==(_=w.indexOf(l[T]))&&(-1===E||_<E)&&(E=_)}-1!==(I=-1===E?w.lastIndexOf("@"):w.lastIndexOf("@",E))&&(U=w.slice(0,I),w=w.slice(I+1),this.auth=decodeURIComponent(U)),E=-1;for(T=0;T<f.length;T++){var _;-1!==(_=w.indexOf(f[T]))&&(-1===E||_<E)&&(E=_)}-1===E&&(E=w.length),this.host=w.slice(0,E),w=w.slice(E),this.parseHost(),this.hostname=this.hostname||"";var P="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!P)for(var D=this.hostname.split(/\./),R=(T=0,D.length);T<R;T++){var k=D[T];if(k&&!k.match(p)){for(var F="",O=0,M=k.length;O<M;O++)k.charCodeAt(O)>127?F+="x":F+=k[O];if(!F.match(p)){var x=D.slice(0,T),B=D.slice(T+1),N=k.match(d);N&&(x.push(N[1]),B.unshift(N[2])),B.length&&(w="/"+B.join(".")+w),this.hostname=x.join(".");break}}}this.hostname.length>255?this.hostname="":this.hostname=this.hostname.toLowerCase(),P||(this.hostname=r.toASCII(this.hostname));var j=this.port?":"+this.port:"",V=this.hostname||"";this.host=V+j,this.href+=this.host,P&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==w[0]&&(w="/"+w))}if(!g[b])for(T=0,R=h.length;T<R;T++){var K=h[T];if(-1!==w.indexOf(K)){var q=encodeURIComponent(K);q===K&&(q=escape(K)),w=w.split(K).join(q)}}var L=w.indexOf("#");-1!==L&&(this.hash=w.substr(L),w=w.slice(0,L));var H=w.indexOf("?");if(-1!==H?(this.search=w.substr(H),this.query=w.substr(H+1),t&&(this.query=v.parse(this.query)),w=w.slice(0,H)):t&&(this.search="",this.query={}),w&&(this.pathname=w),m[b]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){j=this.pathname||"";var W=this.search||"";this.path=j+W}return this.href=this.format(),this},o.prototype.format=function(){var e=this.auth||"";e&&(e=(e=encodeURIComponent(e)).replace(/%3A/i,":"),e+="@");var t=this.protocol||"",n=this.pathname||"",r=this.hash||"",o=!1,s="";this.host?o=e+this.host:this.hostname&&(o=e+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port&&(o+=":"+this.port)),this.query&&i.isObject(this.query)&&Object.keys(this.query).length&&(s=v.stringify(this.query));var a=this.search||s&&"?"+s||"";return t&&":"!==t.substr(-1)&&(t+=":"),this.slashes||(!t||m[t])&&!1!==o?(o="//"+(o||""),n&&"/"!==n.charAt(0)&&(n="/"+n)):o||(o=""),r&&"#"!==r.charAt(0)&&(r="#"+r),a&&"?"!==a.charAt(0)&&(a="?"+a),t+o+(n=n.replace(/[?#]/g,(function(e){return encodeURIComponent(e)})))+(a=a.replace("#","%23"))+r},o.prototype.resolve=function(e){return this.resolveObject(w(e,!1,!0)).format()},o.prototype.resolveObject=function(e){if(i.isString(e)){var t=new o;t.parse(e,!1,!0),e=t}for(var n=new o,r=Object.keys(this),s=0;s<r.length;s++){var a=r[s];n[a]=this[a]}if(n.hash=e.hash,""===e.href)return n.href=n.format(),n;if(e.slashes&&!e.protocol){for(var u=Object.keys(e),c=0;c<u.length;c++){var h=u[c];"protocol"!==h&&(n[h]=e[h])}return m[n.protocol]&&n.hostname&&!n.pathname&&(n.path=n.pathname="/"),n.href=n.format(),n}if(e.protocol&&e.protocol!==n.protocol){if(!m[e.protocol]){for(var f=Object.keys(e),l=0;l<f.length;l++){var p=f[l];n[p]=e[p]}return n.href=n.format(),n}if(n.protocol=e.protocol,e.host||y[e.protocol])n.pathname=e.pathname;else{for(var d=(e.pathname||"").split("/");d.length&&!(e.host=d.shift()););e.host||(e.host=""),e.hostname||(e.hostname=""),""!==d[0]&&d.unshift(""),d.length<2&&d.unshift(""),n.pathname=d.join("/")}if(n.search=e.search,n.query=e.query,n.host=e.host||"",n.auth=e.auth,n.hostname=e.hostname||e.host,n.port=e.port,n.pathname||n.search){var g=n.pathname||"",v=n.search||"";n.path=g+v}return n.slashes=n.slashes||e.slashes,n.href=n.format(),n}var w=n.pathname&&"/"===n.pathname.charAt(0),S=e.host||e.pathname&&"/"===e.pathname.charAt(0),A=S||w||n.host&&e.pathname,b=A,C=n.pathname&&n.pathname.split("/")||[],U=(d=e.pathname&&e.pathname.split("/")||[],n.protocol&&!m[n.protocol]);if(U&&(n.hostname="",n.port=null,n.host&&(""===C[0]?C[0]=n.host:C.unshift(n.host)),n.host="",e.protocol&&(e.hostname=null,e.port=null,e.host&&(""===d[0]?d[0]=e.host:d.unshift(e.host)),e.host=null),A=A&&(""===d[0]||""===C[0])),S)n.host=e.host||""===e.host?e.host:n.host,n.hostname=e.hostname||""===e.hostname?e.hostname:n.hostname,n.search=e.search,n.query=e.query,C=d;else if(d.length)C||(C=[]),C.pop(),C=C.concat(d),n.search=e.search,n.query=e.query;else if(!i.isNullOrUndefined(e.search)){if(U)n.hostname=n.host=C.shift(),(P=!!(n.host&&n.host.indexOf("@")>0)&&n.host.split("@"))&&(n.auth=P.shift(),n.host=n.hostname=P.shift());return n.search=e.search,n.query=e.query,i.isNull(n.pathname)&&i.isNull(n.search)||(n.path=(n.pathname?n.pathname:"")+(n.search?n.search:"")),n.href=n.format(),n}if(!C.length)return n.pathname=null,n.search?n.path="/"+n.search:n.path=null,n.href=n.format(),n;for(var I=C.slice(-1)[0],E=(n.host||e.host||C.length>1)&&("."===I||".."===I)||""===I,T=0,_=C.length;_>=0;_--)"."===(I=C[_])?C.splice(_,1):".."===I?(C.splice(_,1),T++):T&&(C.splice(_,1),T--);if(!A&&!b)for(;T--;T)C.unshift("..");!A||""===C[0]||C[0]&&"/"===C[0].charAt(0)||C.unshift(""),E&&"/"!==C.join("/").substr(-1)&&C.push("");var P,D=""===C[0]||C[0]&&"/"===C[0].charAt(0);U&&(n.hostname=n.host=D?"":C.length?C.shift():"",(P=!!(n.host&&n.host.indexOf("@")>0)&&n.host.split("@"))&&(n.auth=P.shift(),n.host=n.hostname=P.shift()));return(A=A||n.host&&C.length)&&!D&&C.unshift(""),C.length?n.pathname=C.join("/"):(n.pathname=null,n.path=null),i.isNull(n.pathname)&&i.isNull(n.search)||(n.path=(n.pathname?n.pathname:"")+(n.search?n.search:"")),n.auth=e.auth||n.auth,n.slashes=n.slashes||e.slashes,n.href=n.format(),n},o.prototype.parseHost=function(){var e=this.host,t=a.exec(e);t&&(":"!==(t=t[0])&&(this.port=t.substr(1)),e=e.substr(0,e.length-t.length)),e&&(this.hostname=e)}},function(e,t,n){var r,i;
	/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */!function(o){if(void 0===(i="function"==typeof(r=o)?r.call(t,n,t,e):r)||(e.exports=i),!0,e.exports=o(),!!0){var s=window.Cookies,a=window.Cookies=o();a.noConflict=function(){return window.Cookies=s,a}}}((function(){function e(){for(var e=0,t={};e<arguments.length;e++){var n=arguments[e];for(var r in n)t[r]=n[r]}return t}function t(e){return e.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent)}return function n(r){function i(){}function o(t,n,o){if("undefined"!=typeof document){"number"==typeof(o=e({path:"/"},i.defaults,o)).expires&&(o.expires=new Date(1*new Date+864e5*o.expires)),o.expires=o.expires?o.expires.toUTCString():"";try{var s=JSON.stringify(n);/^[\{\[]/.test(s)&&(n=s)}catch(e){}n=r.write?r.write(n,t):encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),t=encodeURIComponent(String(t)).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/[\(\)]/g,escape);var a="";for(var u in o)o[u]&&(a+="; "+u,!0!==o[u]&&(a+="="+o[u].split(";")[0]));return document.cookie=t+"="+n+a}}function s(e,n){if("undefined"!=typeof document){for(var i={},o=document.cookie?document.cookie.split("; "):[],s=0;s<o.length;s++){var a=o[s].split("="),u=a.slice(1).join("=");n||'"'!==u.charAt(0)||(u=u.slice(1,-1));try{var c=t(a[0]);if(u=(r.read||r)(u,c)||t(u),n)try{u=JSON.parse(u)}catch(e){}if(i[c]=u,e===c)break}catch(e){}}return e?i[e]:i}}return i.set=o,i.get=function(e){return s(e,!1)},i.getJSON=function(e){return s(e,!0)},i.remove=function(t,n){o(t,"",e(n,{expires:-1}))},i.defaults={},i.withConverter=n,i}((function(){}))}))},function(e,t,n){var r;e.exports=(r=n(2),n(6),n(13),r.HmacSHA256)},function(e,t,n){var r;e.exports=(r=n(2),function(e){var t=r,n=t.lib,i=n.WordArray,o=n.Hasher,s=t.algo,a=[],u=[];!function(){function t(t){for(var n=e.sqrt(t),r=2;r<=n;r++)if(!(t%r))return!1;return!0}function n(e){return 4294967296*(e-(0|e))|0}for(var r=2,i=0;i<64;)t(r)&&(i<8&&(a[i]=n(e.pow(r,.5))),u[i]=n(e.pow(r,1/3)),i++),r++}();var c=[],h=s.SHA256=o.extend({_doReset:function(){this._hash=new i.init(a.slice(0))},_doProcessBlock:function(e,t){for(var n=this._hash.words,r=n[0],i=n[1],o=n[2],s=n[3],a=n[4],h=n[5],f=n[6],l=n[7],p=0;p<64;p++){if(p<16)c[p]=0|e[t+p];else{var d=c[p-15],g=(d<<25|d>>>7)^(d<<14|d>>>18)^d>>>3,y=c[p-2],m=(y<<15|y>>>17)^(y<<13|y>>>19)^y>>>10;c[p]=g+c[p-7]+m+c[p-16]}var v=r&i^r&o^i&o,w=(r<<30|r>>>2)^(r<<19|r>>>13)^(r<<10|r>>>22),S=l+((a<<26|a>>>6)^(a<<21|a>>>11)^(a<<7|a>>>25))+(a&h^~a&f)+u[p]+c[p];l=f,f=h,h=a,a=s+S|0,s=o,o=i,i=r,r=S+(w+v)|0}n[0]=n[0]+r|0,n[1]=n[1]+i|0,n[2]=n[2]+o|0,n[3]=n[3]+s|0,n[4]=n[4]+a|0,n[5]=n[5]+h|0,n[6]=n[6]+f|0,n[7]=n[7]+l|0},_doFinalize:function(){var t=this._data,n=t.words,r=8*this._nDataBytes,i=8*t.sigBytes;return n[i>>>5]|=128<<24-i%32,n[14+(i+64>>>9<<4)]=e.floor(r/4294967296),n[15+(i+64>>>9<<4)]=r,t.sigBytes=4*n.length,this._process(),this._hash},clone:function(){var e=o.clone.call(this);return e._hash=this._hash.clone(),e}});t.SHA256=o._createHelper(h),t.HmacSHA256=o._createHmacHelper(h)}(Math),r.SHA256)},function(e,t,n){var r,i,o;e.exports=(o=n(2),i=(r=o).lib.WordArray,r.enc.Base64={stringify:function(e){var t=e.words,n=e.sigBytes,r=this._map;e.clamp();for(var i=[],o=0;o<n;o+=3)for(var s=(t[o>>>2]>>>24-o%4*8&255)<<16|(t[o+1>>>2]>>>24-(o+1)%4*8&255)<<8|t[o+2>>>2]>>>24-(o+2)%4*8&255,a=0;a<4&&o+.75*a<n;a++)i.push(r.charAt(s>>>6*(3-a)&63));var u=r.charAt(64);if(u)for(;i.length%4;)i.push(u);return i.join("")},parse:function(e){var t=e.length,n=this._map,r=this._reverseMap;if(!r){r=this._reverseMap=[];for(var o=0;o<n.length;o++)r[n.charCodeAt(o)]=o}var s=n.charAt(64);if(s){var a=e.indexOf(s);-1!==a&&(t=a)}return function(e,t,n){for(var r=[],o=0,s=0;s<t;s++)if(s%4){var a=n[e.charCodeAt(s-1)]<<s%4*2,u=n[e.charCodeAt(s)]>>>6-s%4*2;r[o>>>2]|=(a|u)<<24-o%4*8,o++}return i.create(r,o)}(e,t,r)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="},o.enc.Base64)},function(e,t){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){var r;e.exports=(r=n(2),function(){if("function"==typeof ArrayBuffer){var e=r.lib.WordArray,t=e.init;(e.init=function(e){if(e instanceof ArrayBuffer&&(e=new Uint8Array(e)),(e instanceof Int8Array||"undefined"!=typeof Uint8ClampedArray&&e instanceof Uint8ClampedArray||e instanceof Int16Array||e instanceof Uint16Array||e instanceof Int32Array||e instanceof Uint32Array||e instanceof Float32Array||e instanceof Float64Array)&&(e=new Uint8Array(e.buffer,e.byteOffset,e.byteLength)),e instanceof Uint8Array){for(var n=e.byteLength,r=[],i=0;i<n;i++)r[i>>>2]|=e[i]<<24-i%4*8;t.call(this,r,n)}else t.apply(this,arguments)}).prototype=e}}(),r.lib.WordArray)},function(e,t,n){"use strict";t.byteLength=function(e){var t=c(e),n=t[0],r=t[1];return 3*(n+r)/4-r},t.toByteArray=function(e){var t,n,r=c(e),s=r[0],a=r[1],u=new o(function(e,t,n){return 3*(t+n)/4-n}(0,s,a)),h=0,f=a>0?s-4:s;for(n=0;n<f;n+=4)t=i[e.charCodeAt(n)]<<18|i[e.charCodeAt(n+1)]<<12|i[e.charCodeAt(n+2)]<<6|i[e.charCodeAt(n+3)],u[h++]=t>>16&255,u[h++]=t>>8&255,u[h++]=255&t;2===a&&(t=i[e.charCodeAt(n)]<<2|i[e.charCodeAt(n+1)]>>4,u[h++]=255&t);1===a&&(t=i[e.charCodeAt(n)]<<10|i[e.charCodeAt(n+1)]<<4|i[e.charCodeAt(n+2)]>>2,u[h++]=t>>8&255,u[h++]=255&t);return u},t.fromByteArray=function(e){for(var t,n=e.length,i=n%3,o=[],s=0,a=n-i;s<a;s+=16383)o.push(h(e,s,s+16383>a?a:s+16383));1===i?(t=e[n-1],o.push(r[t>>2]+r[t<<4&63]+"==")):2===i&&(t=(e[n-2]<<8)+e[n-1],o.push(r[t>>10]+r[t>>4&63]+r[t<<2&63]+"="));return o.join("")};for(var r=[],i=[],o="undefined"!=typeof Uint8Array?Uint8Array:Array,s="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",a=0,u=s.length;a<u;++a)r[a]=s[a],i[s.charCodeAt(a)]=a;function c(e){var t=e.length;if(t%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var n=e.indexOf("=");return-1===n&&(n=t),[n,n===t?0:4-n%4]}function h(e,t,n){for(var i,o,s=[],a=t;a<n;a+=3)i=(e[a]<<16&16711680)+(e[a+1]<<8&65280)+(255&e[a+2]),s.push(r[(o=i)>>18&63]+r[o>>12&63]+r[o>>6&63]+r[63&o]);return s.join("")}i["-".charCodeAt(0)]=62,i["_".charCodeAt(0)]=63},function(e,t){t.read=function(e,t,n,r,i){var o,s,a=8*i-r-1,u=(1<<a)-1,c=u>>1,h=-7,f=n?i-1:0,l=n?-1:1,p=e[t+f];for(f+=l,o=p&(1<<-h)-1,p>>=-h,h+=a;h>0;o=256*o+e[t+f],f+=l,h-=8);for(s=o&(1<<-h)-1,o>>=-h,h+=r;h>0;s=256*s+e[t+f],f+=l,h-=8);if(0===o)o=1-c;else{if(o===u)return s?NaN:1/0*(p?-1:1);s+=Math.pow(2,r),o-=c}return(p?-1:1)*s*Math.pow(2,o-r)},t.write=function(e,t,n,r,i,o){var s,a,u,c=8*o-i-1,h=(1<<c)-1,f=h>>1,l=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,p=r?0:o-1,d=r?1:-1,g=t<0||0===t&&1/t<0?1:0;for(t=Math.abs(t),isNaN(t)||t===1/0?(a=isNaN(t)?1:0,s=h):(s=Math.floor(Math.log(t)/Math.LN2),t*(u=Math.pow(2,-s))<1&&(s--,u*=2),(t+=s+f>=1?l/u:l*Math.pow(2,1-f))*u>=2&&(s++,u/=2),s+f>=h?(a=0,s=h):s+f>=1?(a=(t*u-1)*Math.pow(2,i),s+=f):(a=t*Math.pow(2,f-1)*Math.pow(2,i),s=0));i>=8;e[n+p]=255&a,p+=d,a/=256,i-=8);for(s=s<<i|a,c+=i;c>0;e[n+p]=255&s,p+=d,s/=256,c-=8);e[n+p-d]|=128*g}},function(e,t){var n={}.toString;e.exports=Array.isArray||function(e){return"[object Array]"==n.call(e)}},function(e,t,n){var r,i,o,s;e.exports=(r=n(2),o=(i=r).lib.Base,s=i.enc.Utf8,void(i.algo.HMAC=o.extend({init:function(e,t){e=this._hasher=new e.init,"string"==typeof t&&(t=s.parse(t));var n=e.blockSize,r=4*n;t.sigBytes>r&&(t=e.finalize(t)),t.clamp();for(var i=this._oKey=t.clone(),o=this._iKey=t.clone(),a=i.words,u=o.words,c=0;c<n;c++)a[c]^=1549556828,u[c]^=909522486;i.sigBytes=o.sigBytes=r,this.reset()},reset:function(){var e=this._hasher;e.reset(),e.update(this._iKey)},update:function(e){return this._hasher.update(e),this},finalize:function(e){var t=this._hasher,n=t.finalize(e);return t.reset(),t.finalize(this._oKey.clone().concat(n))}})))},function(e,t,n){(function(e,r){var i;/*! https://mths.be/punycode v1.4.1 by @mathias */!function(o){t&&t.nodeType,e&&e.nodeType;var s="object"==typeof r&&r;s.global!==s&&s.window!==s&&s.self;var a,u=2147483647,c=/^xn--/,h=/[^\x20-\x7E]/,f=/[\x2E\u3002\uFF0E\uFF61]/g,l={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},p=Math.floor,d=String.fromCharCode;function g(e){throw new RangeError(l[e])}function y(e,t){for(var n=e.length,r=[];n--;)r[n]=t(e[n]);return r}function m(e,t){var n=e.split("@"),r="";return n.length>1&&(r=n[0]+"@",e=n[1]),r+y((e=e.replace(f,".")).split("."),t).join(".")}function v(e){for(var t,n,r=[],i=0,o=e.length;i<o;)(t=e.charCodeAt(i++))>=55296&&t<=56319&&i<o?56320==(64512&(n=e.charCodeAt(i++)))?r.push(((1023&t)<<10)+(1023&n)+65536):(r.push(t),i--):r.push(t);return r}function w(e){return y(e,(function(e){var t="";return e>65535&&(t+=d((e-=65536)>>>10&1023|55296),e=56320|1023&e),t+=d(e)})).join("")}function S(e,t){return e+22+75*(e<26)-((0!=t)<<5)}function A(e,t,n){var r=0;for(e=n?p(e/700):e>>1,e+=p(e/t);e>455;r+=36)e=p(e/35);return p(r+36*e/(e+38))}function b(e){var t,n,r,i,o,s,a,c,h,f,l,d=[],y=e.length,m=0,v=128,S=72;for((n=e.lastIndexOf("-"))<0&&(n=0),r=0;r<n;++r)e.charCodeAt(r)>=128&&g("not-basic"),d.push(e.charCodeAt(r));for(i=n>0?n+1:0;i<y;){for(o=m,s=1,a=36;i>=y&&g("invalid-input"),((c=(l=e.charCodeAt(i++))-48<10?l-22:l-65<26?l-65:l-97<26?l-97:36)>=36||c>p((u-m)/s))&&g("overflow"),m+=c*s,!(c<(h=a<=S?1:a>=S+26?26:a-S));a+=36)s>p(u/(f=36-h))&&g("overflow"),s*=f;S=A(m-o,t=d.length+1,0==o),p(m/t)>u-v&&g("overflow"),v+=p(m/t),m%=t,d.splice(m++,0,v)}return w(d)}function C(e){var t,n,r,i,o,s,a,c,h,f,l,y,m,w,b,C=[];for(y=(e=v(e)).length,t=128,n=0,o=72,s=0;s<y;++s)(l=e[s])<128&&C.push(d(l));for(r=i=C.length,i&&C.push("-");r<y;){for(a=u,s=0;s<y;++s)(l=e[s])>=t&&l<a&&(a=l);for(a-t>p((u-n)/(m=r+1))&&g("overflow"),n+=(a-t)*m,t=a,s=0;s<y;++s)if((l=e[s])<t&&++n>u&&g("overflow"),l==t){for(c=n,h=36;!(c<(f=h<=o?1:h>=o+26?26:h-o));h+=36)b=c-f,w=36-f,C.push(d(S(f+b%w,0))),c=p(b/w);C.push(d(S(c,0))),o=A(n,m,r==i),n=0,++r}++n,++t}return C.join("")}a={version:"1.4.1",ucs2:{decode:v,encode:w},decode:b,encode:C,toASCII:function(e){return m(e,(function(e){return h.test(e)?"xn--"+C(e):e}))},toUnicode:function(e){return m(e,(function(e){return c.test(e)?b(e.slice(4).toLowerCase()):e}))}},void 0===(i=function(){return a}.call(t,n,t,e))||(e.exports=i)}()}).call(this,n(15)(e),n(8))},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e}},function(e,t,n){"use strict";e.exports={isString:function(e){return"string"==typeof e},isObject:function(e){return"object"==typeof e&&null!==e},isNull:function(e){return null===e},isNullOrUndefined:function(e){return null==e}}},function(e,t,n){"use strict";t.decode=t.parse=n(18),t.encode=t.stringify=n(19)},function(e,t,n){"use strict";function r(e,t){return Object.prototype.hasOwnProperty.call(e,t)}e.exports=function(e,t,n,o){t=t||"&",n=n||"=";var s={};if("string"!=typeof e||0===e.length)return s;var a=/\+/g;e=e.split(t);var u=1e3;o&&"number"==typeof o.maxKeys&&(u=o.maxKeys);var c=e.length;u>0&&c>u&&(c=u);for(var h=0;h<c;++h){var f,l,p,d,g=e[h].replace(a,"%20"),y=g.indexOf(n);y>=0?(f=g.substr(0,y),l=g.substr(y+1)):(f=g,l=""),p=decodeURIComponent(f),d=decodeURIComponent(l),r(s,p)?i(s[p])?s[p].push(d):s[p]=[s[p],d]:s[p]=d}return s};var i=Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)}},function(e,t,n){"use strict";var r=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return""}};e.exports=function(e,t,n,a){return t=t||"&",n=n||"=",null===e&&(e=void 0),"object"==typeof e?o(s(e),(function(s){var a=encodeURIComponent(r(s))+n;return i(e[s])?o(e[s],(function(e){return a+encodeURIComponent(r(e))})).join(t):a+encodeURIComponent(r(e[s]))})).join(t):a?encodeURIComponent(r(a))+n+encodeURIComponent(r(e)):""};var i=Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)};function o(e,t){if(e.map)return e.map(t);for(var n=[],r=0;r<e.length;r++)n.push(t(e[r],r));return n}var s=Object.keys||function(e){var t=[];for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&t.push(n);return t}},function(e,t,n){"use strict";var r,i;function o(e){return e&&!!["provider","customState"].find((function(t){return e.hasOwnProperty(t)}))}function s(e){return void 0!==e.redirectSignIn}n.r(t),function(e){e.Cognito="COGNITO",e.Google="Google",e.Facebook="Facebook",e.Amazon="LoginWithAmazon"}(r||(r={})),function(e){e.NoConfig="noConfig",e.MissingAuthConfig="missingAuthConfig",e.EmptyUsername="emptyUsername",e.InvalidUsername="invalidUsername",e.EmptyPassword="emptyPassword",e.EmptyCode="emptyCode",e.SignUpError="signUpError",e.NoMFA="noMFA",e.InvalidMFA="invalidMFA",e.EmptyChallengeResponse="emptyChallengeResponse",e.NoUserSession="noUserSession",e.Default="default"}(i||(i={}));var a=n(0),u=n.n(a);
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	var c,h=function(){function e(t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e);var n=t||{},r=n.ValidationData,i=n.Username,o=n.Password,s=n.AuthParameters,a=n.ClientMetadata;this.validationData=r||{},this.authParameters=s||{},this.clientMetadata=a||{},this.username=i,this.password=o}return e.prototype.getUsername=function(){return this.username},e.prototype.getPassword=function(){return this.password},e.prototype.getValidationData=function(){return this.validationData},e.prototype.getAuthParameters=function(){return this.authParameters},e.prototype.getClientMetadata=function(){return this.clientMetadata},e}(),f=n(1),l=n(2),p=n.n(l),d=(n(9),n(6)),g=n.n(d),y=n(5),m=n.n(y),v=w;function w(e,t){null!=e&&this.fromString(e,t)}function S(){return new w(null)}var A="undefined"!=typeof navigator;A&&"Microsoft Internet Explorer"==navigator.appName?(w.prototype.am=function(e,t,n,r,i,o){for(var s=32767&t,a=t>>15;--o>=0;){var u=32767&this[e],c=this[e++]>>15,h=a*u+c*s;i=((u=s*u+((32767&h)<<15)+n[r]+(1073741823&i))>>>30)+(h>>>15)+a*c+(i>>>30),n[r++]=1073741823&u}return i},c=30):A&&"Netscape"!=navigator.appName?(w.prototype.am=function(e,t,n,r,i,o){for(;--o>=0;){var s=t*this[e++]+n[r]+i;i=Math.floor(s/67108864),n[r++]=67108863&s}return i},c=26):(w.prototype.am=function(e,t,n,r,i,o){for(var s=16383&t,a=t>>14;--o>=0;){var u=16383&this[e],c=this[e++]>>14,h=a*u+c*s;i=((u=s*u+((16383&h)<<14)+n[r]+i)>>28)+(h>>14)+a*c,n[r++]=268435455&u}return i},c=28),w.prototype.DB=c,w.prototype.DM=(1<<c)-1,w.prototype.DV=1<<c;w.prototype.FV=Math.pow(2,52),w.prototype.F1=52-c,w.prototype.F2=2*c-52;var b,C,U=new Array;for(b="0".charCodeAt(0),C=0;C<=9;++C)U[b++]=C;for(b="a".charCodeAt(0),C=10;C<36;++C)U[b++]=C;for(b="A".charCodeAt(0),C=10;C<36;++C)U[b++]=C;function I(e){return"0123456789abcdefghijklmnopqrstuvwxyz".charAt(e)}function E(e,t){var n=U[e.charCodeAt(t)];return null==n?-1:n}function T(e){var t=S();return t.fromInt(e),t}function _(e){var t,n=1;return 0!=(t=e>>>16)&&(e=t,n+=16),0!=(t=e>>8)&&(e=t,n+=8),0!=(t=e>>4)&&(e=t,n+=4),0!=(t=e>>2)&&(e=t,n+=2),0!=(t=e>>1)&&(e=t,n+=1),n}function P(e){this.m=e,this.mp=e.invDigit(),this.mpl=32767&this.mp,this.mph=this.mp>>15,this.um=(1<<e.DB-15)-1,this.mt2=2*e.t}P.prototype.convert=function(e){var t=S();return e.abs().dlShiftTo(this.m.t,t),t.divRemTo(this.m,null,t),e.s<0&&t.compareTo(w.ZERO)>0&&this.m.subTo(t,t),t},P.prototype.revert=function(e){var t=S();return e.copyTo(t),this.reduce(t),t},P.prototype.reduce=function(e){for(;e.t<=this.mt2;)e[e.t++]=0;for(var t=0;t<this.m.t;++t){var n=32767&e[t],r=n*this.mpl+((n*this.mph+(e[t]>>15)*this.mpl&this.um)<<15)&e.DM;for(e[n=t+this.m.t]+=this.m.am(0,r,e,t,0,this.m.t);e[n]>=e.DV;)e[n]-=e.DV,e[++n]++}e.clamp(),e.drShiftTo(this.m.t,e),e.compareTo(this.m)>=0&&e.subTo(this.m,e)},P.prototype.mulTo=function(e,t,n){e.multiplyTo(t,n),this.reduce(n)},P.prototype.sqrTo=function(e,t){e.squareTo(t),this.reduce(t)},w.prototype.copyTo=function(e){for(var t=this.t-1;t>=0;--t)e[t]=this[t];e.t=this.t,e.s=this.s},w.prototype.fromInt=function(e){this.t=1,this.s=e<0?-1:0,e>0?this[0]=e:e<-1?this[0]=e+this.DV:this.t=0},w.prototype.fromString=function(e,t){var n;if(16==t)n=4;else if(8==t)n=3;else if(2==t)n=1;else if(32==t)n=5;else{if(4!=t)throw new Error("Only radix 2, 4, 8, 16, 32 are supported");n=2}this.t=0,this.s=0;for(var r=e.length,i=!1,o=0;--r>=0;){var s=E(e,r);s<0?"-"==e.charAt(r)&&(i=!0):(i=!1,0==o?this[this.t++]=s:o+n>this.DB?(this[this.t-1]|=(s&(1<<this.DB-o)-1)<<o,this[this.t++]=s>>this.DB-o):this[this.t-1]|=s<<o,(o+=n)>=this.DB&&(o-=this.DB))}this.clamp(),i&&w.ZERO.subTo(this,this)},w.prototype.clamp=function(){for(var e=this.s&this.DM;this.t>0&&this[this.t-1]==e;)--this.t},w.prototype.dlShiftTo=function(e,t){var n;for(n=this.t-1;n>=0;--n)t[n+e]=this[n];for(n=e-1;n>=0;--n)t[n]=0;t.t=this.t+e,t.s=this.s},w.prototype.drShiftTo=function(e,t){for(var n=e;n<this.t;++n)t[n-e]=this[n];t.t=Math.max(this.t-e,0),t.s=this.s},w.prototype.lShiftTo=function(e,t){var n,r=e%this.DB,i=this.DB-r,o=(1<<i)-1,s=Math.floor(e/this.DB),a=this.s<<r&this.DM;for(n=this.t-1;n>=0;--n)t[n+s+1]=this[n]>>i|a,a=(this[n]&o)<<r;for(n=s-1;n>=0;--n)t[n]=0;t[s]=a,t.t=this.t+s+1,t.s=this.s,t.clamp()},w.prototype.rShiftTo=function(e,t){t.s=this.s;var n=Math.floor(e/this.DB);if(n>=this.t)t.t=0;else{var r=e%this.DB,i=this.DB-r,o=(1<<r)-1;t[0]=this[n]>>r;for(var s=n+1;s<this.t;++s)t[s-n-1]|=(this[s]&o)<<i,t[s-n]=this[s]>>r;r>0&&(t[this.t-n-1]|=(this.s&o)<<i),t.t=this.t-n,t.clamp()}},w.prototype.subTo=function(e,t){for(var n=0,r=0,i=Math.min(e.t,this.t);n<i;)r+=this[n]-e[n],t[n++]=r&this.DM,r>>=this.DB;if(e.t<this.t){for(r-=e.s;n<this.t;)r+=this[n],t[n++]=r&this.DM,r>>=this.DB;r+=this.s}else{for(r+=this.s;n<e.t;)r-=e[n],t[n++]=r&this.DM,r>>=this.DB;r-=e.s}t.s=r<0?-1:0,r<-1?t[n++]=this.DV+r:r>0&&(t[n++]=r),t.t=n,t.clamp()},w.prototype.multiplyTo=function(e,t){var n=this.abs(),r=e.abs(),i=n.t;for(t.t=i+r.t;--i>=0;)t[i]=0;for(i=0;i<r.t;++i)t[i+n.t]=n.am(0,r[i],t,i,0,n.t);t.s=0,t.clamp(),this.s!=e.s&&w.ZERO.subTo(t,t)},w.prototype.squareTo=function(e){for(var t=this.abs(),n=e.t=2*t.t;--n>=0;)e[n]=0;for(n=0;n<t.t-1;++n){var r=t.am(n,t[n],e,2*n,0,1);(e[n+t.t]+=t.am(n+1,2*t[n],e,2*n+1,r,t.t-n-1))>=t.DV&&(e[n+t.t]-=t.DV,e[n+t.t+1]=1)}e.t>0&&(e[e.t-1]+=t.am(n,t[n],e,2*n,0,1)),e.s=0,e.clamp()},w.prototype.divRemTo=function(e,t,n){var r=e.abs();if(!(r.t<=0)){var i=this.abs();if(i.t<r.t)return null!=t&&t.fromInt(0),void(null!=n&&this.copyTo(n));null==n&&(n=S());var o=S(),s=this.s,a=e.s,u=this.DB-_(r[r.t-1]);u>0?(r.lShiftTo(u,o),i.lShiftTo(u,n)):(r.copyTo(o),i.copyTo(n));var c=o.t,h=o[c-1];if(0!=h){var f=h*(1<<this.F1)+(c>1?o[c-2]>>this.F2:0),l=this.FV/f,p=(1<<this.F1)/f,d=1<<this.F2,g=n.t,y=g-c,m=null==t?S():t;for(o.dlShiftTo(y,m),n.compareTo(m)>=0&&(n[n.t++]=1,n.subTo(m,n)),w.ONE.dlShiftTo(c,m),m.subTo(o,o);o.t<c;)o[o.t++]=0;for(;--y>=0;){var v=n[--g]==h?this.DM:Math.floor(n[g]*l+(n[g-1]+d)*p);if((n[g]+=o.am(0,v,n,y,0,c))<v)for(o.dlShiftTo(y,m),n.subTo(m,n);n[g]<--v;)n.subTo(m,n)}null!=t&&(n.drShiftTo(c,t),s!=a&&w.ZERO.subTo(t,t)),n.t=c,n.clamp(),u>0&&n.rShiftTo(u,n),s<0&&w.ZERO.subTo(n,n)}}},w.prototype.invDigit=function(){if(this.t<1)return 0;var e=this[0];if(0==(1&e))return 0;var t=3&e;return(t=(t=(t=(t=t*(2-(15&e)*t)&15)*(2-(255&e)*t)&255)*(2-((65535&e)*t&65535))&65535)*(2-e*t%this.DV)%this.DV)>0?this.DV-t:-t},w.prototype.addTo=function(e,t){for(var n=0,r=0,i=Math.min(e.t,this.t);n<i;)r+=this[n]+e[n],t[n++]=r&this.DM,r>>=this.DB;if(e.t<this.t){for(r+=e.s;n<this.t;)r+=this[n],t[n++]=r&this.DM,r>>=this.DB;r+=this.s}else{for(r+=this.s;n<e.t;)r+=e[n],t[n++]=r&this.DM,r>>=this.DB;r+=e.s}t.s=r<0?-1:0,r>0?t[n++]=r:r<-1&&(t[n++]=this.DV+r),t.t=n,t.clamp()},w.prototype.toString=function(e){if(this.s<0)return"-"+this.negate().toString();var t;if(16==e)t=4;else if(8==e)t=3;else if(2==e)t=1;else if(32==e)t=5;else{if(4!=e)throw new Error("Only radix 2, 4, 8, 16, 32 are supported");t=2}var n,r=(1<<t)-1,i=!1,o="",s=this.t,a=this.DB-s*this.DB%t;if(s-- >0)for(a<this.DB&&(n=this[s]>>a)>0&&(i=!0,o=I(n));s>=0;)a<t?(n=(this[s]&(1<<a)-1)<<t-a,n|=this[--s]>>(a+=this.DB-t)):(n=this[s]>>(a-=t)&r,a<=0&&(a+=this.DB,--s)),n>0&&(i=!0),i&&(o+=I(n));return i?o:"0"},w.prototype.negate=function(){var e=S();return w.ZERO.subTo(this,e),e},w.prototype.abs=function(){return this.s<0?this.negate():this},w.prototype.compareTo=function(e){var t=this.s-e.s;if(0!=t)return t;var n=this.t;if(0!=(t=n-e.t))return this.s<0?-t:t;for(;--n>=0;)if(0!=(t=this[n]-e[n]))return t;return 0},w.prototype.bitLength=function(){return this.t<=0?0:this.DB*(this.t-1)+_(this[this.t-1]^this.s&this.DM)},w.prototype.mod=function(e){var t=S();return this.abs().divRemTo(e,null,t),this.s<0&&t.compareTo(w.ZERO)>0&&e.subTo(t,t),t},w.prototype.equals=function(e){return 0==this.compareTo(e)},w.prototype.add=function(e){var t=S();return this.addTo(e,t),t},w.prototype.subtract=function(e){var t=S();return this.subTo(e,t),t},w.prototype.multiply=function(e){var t=S();return this.multiplyTo(e,t),t},w.prototype.divide=function(e){var t=S();return this.divRemTo(e,t,null),t},w.prototype.modPow=function(e,t,n){var r,i=e.bitLength(),o=T(1),s=new P(t);if(i<=0)return o;r=i<18?1:i<48?3:i<144?4:i<768?5:6;var a=new Array,u=3,c=r-1,h=(1<<r)-1;if(a[1]=s.convert(this),r>1){var f=S();for(s.sqrTo(a[1],f);u<=h;)a[u]=S(),s.mulTo(f,a[u-2],a[u]),u+=2}var l,p,d=e.t-1,g=!0,y=S();for(i=_(e[d])-1;d>=0;){for(i>=c?l=e[d]>>i-c&h:(l=(e[d]&(1<<i+1)-1)<<c-i,d>0&&(l|=e[d-1]>>this.DB+i-c)),u=r;0==(1&l);)l>>=1,--u;if((i-=u)<0&&(i+=this.DB,--d),g)a[l].copyTo(o),g=!1;else{for(;u>1;)s.sqrTo(o,y),s.sqrTo(y,o),u-=2;u>0?s.sqrTo(o,y):(p=o,o=y,y=p),s.mulTo(y,a[l],o)}for(;d>=0&&0==(e[d]&1<<i);)s.sqrTo(o,y),p=o,o=y,y=p,--i<0&&(i=this.DB-1,--d)}var m=s.revert(o);return n(null,m),m},w.ZERO=T(0),w.ONE=T(1);
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	var D=function(e){return f.Buffer.from(p.a.lib.WordArray.random(e).toString(),"hex")},R=function(){function e(t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.N=new v("FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF",16),this.g=new v("2",16),this.k=new v(this.hexHash("00"+this.N.toString(16)+"0"+this.g.toString(16)),16),this.smallAValue=this.generateRandomSmallA(),this.getLargeAValue((function(){})),this.infoBits=f.Buffer.from("Caldera Derived Key","utf8"),this.poolName=t}return e.prototype.getSmallAValue=function(){return this.smallAValue},e.prototype.getLargeAValue=function(e){var t=this;this.largeAValue?e(null,this.largeAValue):this.calculateA(this.smallAValue,(function(n,r){n&&e(n,null),t.largeAValue=r,e(null,t.largeAValue)}))},e.prototype.generateRandomSmallA=function(){var e=D(128).toString("hex");return new v(e,16).mod(this.N)},e.prototype.generateRandomString=function(){return D(40).toString("base64")},e.prototype.getRandomPassword=function(){return this.randomPassword},e.prototype.getSaltDevices=function(){return this.SaltToHashDevices},e.prototype.getVerifierDevices=function(){return this.verifierDevices},e.prototype.generateHashDevice=function(e,t,n){var r=this;this.randomPassword=this.generateRandomString();var i=""+e+t+":"+this.randomPassword,o=this.hash(i),s=D(16).toString("hex");this.SaltToHashDevices=this.padHex(new v(s,16)),this.g.modPow(new v(this.hexHash(this.SaltToHashDevices+o),16),this.N,(function(e,t){e&&n(e,null),r.verifierDevices=r.padHex(t),n(null,null)}))},e.prototype.calculateA=function(e,t){var n=this;this.g.modPow(e,this.N,(function(e,r){e&&t(e,null),r.mod(n.N).equals(v.ZERO)&&t(new Error("Illegal paramater. A mod N cannot be 0."),null),t(null,r)}))},e.prototype.calculateU=function(e,t){return this.UHexHash=this.hexHash(this.padHex(e)+this.padHex(t)),new v(this.UHexHash,16)},e.prototype.hash=function(e){var t=e instanceof f.Buffer?p.a.lib.WordArray.create(e):e,n=g()(t).toString();return new Array(64-n.length).join("0")+n},e.prototype.hexHash=function(e){return this.hash(f.Buffer.from(e,"hex"))},e.prototype.computehkdf=function(e,t){var n=p.a.lib.WordArray.create(f.Buffer.concat([this.infoBits,f.Buffer.from(String.fromCharCode(1),"utf8")])),r=e instanceof f.Buffer?p.a.lib.WordArray.create(e):e,i=t instanceof f.Buffer?p.a.lib.WordArray.create(t):t,o=m()(r,i),s=m()(n,o);return f.Buffer.from(s.toString(),"hex").slice(0,16)},e.prototype.getPasswordAuthenticationKey=function(e,t,n,r,i){var o=this;if(n.mod(this.N).equals(v.ZERO))throw new Error("B cannot be zero.");if(this.UValue=this.calculateU(this.largeAValue,n),this.UValue.equals(v.ZERO))throw new Error("U cannot be zero.");var s=""+this.poolName+e+":"+t,a=this.hash(s),u=new v(this.hexHash(this.padHex(r)+a),16);this.calculateS(u,n,(function(e,t){e&&i(e,null);var n=o.computehkdf(f.Buffer.from(o.padHex(t),"hex"),f.Buffer.from(o.padHex(o.UValue.toString(16)),"hex"));i(null,n)}))},e.prototype.calculateS=function(e,t,n){var r=this;this.g.modPow(e,this.N,(function(i,o){i&&n(i,null),t.subtract(r.k.multiply(o)).modPow(r.smallAValue.add(r.UValue.multiply(e)),r.N,(function(e,t){e&&n(e,null),n(null,t.mod(r.N))}))}))},e.prototype.getNewPasswordRequiredChallengeUserAttributePrefix=function(){return"userAttributes."},e.prototype.padHex=function(e){var t=e.toString(16);return t.length%2==1?t="0"+t:-1!=="89ABCDEFabcdef".indexOf(t[0])&&(t="00"+t),t},e}();
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	var k=function(){function e(t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.jwtToken=t||"",this.payload=this.decodePayload()}return e.prototype.getJwtToken=function(){return this.jwtToken},e.prototype.getExpiration=function(){return this.payload.exp},e.prototype.getIssuedAt=function(){return this.payload.iat},e.prototype.decodePayload=function(){var e=this.jwtToken.split(".")[1];try{return JSON.parse(f.Buffer.from(e,"base64").toString("utf8"))}catch(e){return{}}},e}();function F(e){return(F="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function O(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function M(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==F(t)&&"function"!=typeof t?e:t}var x=function(e){function t(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=n.AccessToken;return O(this,t),M(this,e.call(this,r||""))}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+F(t));e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,e),t}(k);function B(e){return(B="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function N(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function j(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==B(t)&&"function"!=typeof t?e:t}
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	var V=function(e){function t(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=n.IdToken;return N(this,t),j(this,e.call(this,r||""))}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+B(t));e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,e),t}(k);function K(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */var q=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=t.RefreshToken;K(this,e),this.token=n||""}return e.prototype.getToken=function(){return this.token},e}(),L=n(7),H=n.n(L);function W(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */var Y=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=t.IdToken,r=t.RefreshToken,i=t.AccessToken,o=t.ClockDrift;if(W(this,e),null==i||null==n)throw new Error("Id token and Access Token must be present.");this.idToken=n,this.refreshToken=r,this.accessToken=i,this.clockDrift=void 0===o?this.calculateClockDrift():o}return e.prototype.getIdToken=function(){return this.idToken},e.prototype.getRefreshToken=function(){return this.refreshToken},e.prototype.getAccessToken=function(){return this.accessToken},e.prototype.getClockDrift=function(){return this.clockDrift},e.prototype.calculateClockDrift=function(){return Math.floor(new Date/1e3)-Math.min(this.accessToken.getIssuedAt(),this.idToken.getIssuedAt())},e.prototype.isValid=function(){var e=Math.floor(new Date/1e3)-this.clockDrift;return e<this.accessToken.getExpiration()&&e<this.idToken.getExpiration()},e}();
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	var J=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],z=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],G=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e)}return e.prototype.getNowString=function(){var e=new Date,t=z[e.getUTCDay()],n=J[e.getUTCMonth()],r=e.getUTCDate(),i=e.getUTCHours();i<10&&(i="0"+i);var o=e.getUTCMinutes();o<10&&(o="0"+o);var s=e.getUTCSeconds();return s<10&&(s="0"+s),t+" "+n+" "+r+" "+i+":"+o+":"+s+" UTC "+e.getUTCFullYear()},e}();function Z(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */var X=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=t.Name,r=t.Value;Z(this,e),this.Name=n||"",this.Value=r||""}return e.prototype.getValue=function(){return this.Value},e.prototype.setValue=function(e){return this.Value=e,this},e.prototype.getName=function(){return this.Name},e.prototype.setName=function(e){return this.Name=e,this},e.prototype.toString=function(){return JSON.stringify(this)},e.prototype.toJSON=function(){return{Name:this.Name,Value:this.Value}},e}();function Q(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */var $={},ee=function(){function e(){Q(this,e)}return e.setItem=function(e,t){return $[e]=t,$[e]},e.getItem=function(e){return Object.prototype.hasOwnProperty.call($,e)?$[e]:void 0},e.removeItem=function(e){return delete $[e]},e.clear=function(){return $={}},e}(),te=function(){function e(){Q(this,e);try{this.storageWindow=window.localStorage,this.storageWindow.setItem("aws.cognito.test-ls",1),this.storageWindow.removeItem("aws.cognito.test-ls")}catch(e){this.storageWindow=ee}}return e.prototype.getStorage=function(){return this.storageWindow},e}();
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ne=function(){function e(t){if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),null==t||null==t.Username||null==t.Pool)throw new Error("Username and pool information are required.");this.username=t.Username||"",this.pool=t.Pool,this.Session=null,this.client=t.Pool.client,this.signInUserSession=null,this.authenticationFlowType="USER_SRP_AUTH",this.storage=t.Storage||(new te).getStorage(),this.keyPrefix="CognitoIdentityServiceProvider."+this.pool.getClientId(),this.userDataKey=this.keyPrefix+"."+this.username+".userData"}return e.prototype.setSignInUserSession=function(e){this.clearCachedUserData(),this.signInUserSession=e,this.cacheTokens()},e.prototype.getSignInUserSession=function(){return this.signInUserSession},e.prototype.getUsername=function(){return this.username},e.prototype.getAuthenticationFlowType=function(){return this.authenticationFlowType},e.prototype.setAuthenticationFlowType=function(e){this.authenticationFlowType=e},e.prototype.initiateAuth=function(e,t){var n=this,r=e.getAuthParameters();r.USERNAME=this.username;var i=0!==Object.keys(e.getValidationData()).length?e.getValidationData():e.getClientMetadata(),o={AuthFlow:"CUSTOM_AUTH",ClientId:this.pool.getClientId(),AuthParameters:r,ClientMetadata:i};this.getUserContextData()&&(o.UserContextData=this.getUserContextData()),this.client.request("InitiateAuth",o,(function(e,r){if(e)return t.onFailure(e);var i=r.ChallengeName,o=r.ChallengeParameters;return"CUSTOM_CHALLENGE"===i?(n.Session=r.Session,t.customChallenge(o)):(n.signInUserSession=n.getCognitoUserSession(r.AuthenticationResult),n.cacheTokens(),t.onSuccess(n.signInUserSession))}))},e.prototype.authenticateUser=function(e,t){return"USER_PASSWORD_AUTH"===this.authenticationFlowType?this.authenticateUserPlainUsernamePassword(e,t):"USER_SRP_AUTH"===this.authenticationFlowType||"CUSTOM_AUTH"===this.authenticationFlowType?this.authenticateUserDefaultAuth(e,t):t.onFailure(new Error("Authentication flow type is invalid."))},e.prototype.authenticateUserDefaultAuth=function(e,t){var n=this,r=new R(this.pool.getUserPoolId().split("_")[1]),i=new G,o=void 0,s=void 0,a={};null!=this.deviceKey&&(a.DEVICE_KEY=this.deviceKey),a.USERNAME=this.username,r.getLargeAValue((function(u,c){u&&t.onFailure(u),a.SRP_A=c.toString(16),"CUSTOM_AUTH"===n.authenticationFlowType&&(a.CHALLENGE_NAME="SRP_A");var h=0!==Object.keys(e.getValidationData()).length?e.getValidationData():e.getClientMetadata(),l={AuthFlow:n.authenticationFlowType,ClientId:n.pool.getClientId(),AuthParameters:a,ClientMetadata:h};n.getUserContextData(n.username)&&(l.UserContextData=n.getUserContextData(n.username)),n.client.request("InitiateAuth",l,(function(a,u){if(a)return t.onFailure(a);var c=u.ChallengeParameters;n.username=c.USER_ID_FOR_SRP,o=new v(c.SRP_B,16),s=new v(c.SALT,16),n.getCachedDeviceKeyAndPassword(),r.getPasswordAuthenticationKey(n.username,e.getPassword(),o,s,(function(e,o){e&&t.onFailure(e);var s=i.getNowString(),a=p.a.lib.WordArray.create(f.Buffer.concat([f.Buffer.from(n.pool.getUserPoolId().split("_")[1],"utf8"),f.Buffer.from(n.username,"utf8"),f.Buffer.from(c.SECRET_BLOCK,"base64"),f.Buffer.from(s,"utf8")])),l=p.a.lib.WordArray.create(o),d=H.a.stringify(m()(a,l)),g={};g.USERNAME=n.username,g.PASSWORD_CLAIM_SECRET_BLOCK=c.SECRET_BLOCK,g.TIMESTAMP=s,g.PASSWORD_CLAIM_SIGNATURE=d,null!=n.deviceKey&&(g.DEVICE_KEY=n.deviceKey);var y={ChallengeName:"PASSWORD_VERIFIER",ClientId:n.pool.getClientId(),ChallengeResponses:g,Session:u.Session,ClientMetadata:h};n.getUserContextData()&&(y.UserContextData=n.getUserContextData()),function e(t,r){return n.client.request("RespondToAuthChallenge",t,(function(i,o){return i&&"ResourceNotFoundException"===i.code&&-1!==i.message.toLowerCase().indexOf("device")?(g.DEVICE_KEY=null,n.deviceKey=null,n.randomPassword=null,n.deviceGroupKey=null,n.clearCachedDeviceKeyAndPassword(),e(t,r)):r(i,o)}))}(y,(function(e,i){return e?t.onFailure(e):n.authenticateUserInternal(i,r,t)}))}))}))}))},e.prototype.authenticateUserPlainUsernamePassword=function(e,t){var n=this,r={};if(r.USERNAME=this.username,r.PASSWORD=e.getPassword(),r.PASSWORD){var i=new R(this.pool.getUserPoolId().split("_")[1]);this.getCachedDeviceKeyAndPassword(),null!=this.deviceKey&&(r.DEVICE_KEY=this.deviceKey);var o=0!==Object.keys(e.getValidationData()).length?e.getValidationData():e.getClientMetadata(),s={AuthFlow:"USER_PASSWORD_AUTH",ClientId:this.pool.getClientId(),AuthParameters:r,ClientMetadata:o};this.getUserContextData(this.username)&&(s.UserContextData=this.getUserContextData(this.username)),this.client.request("InitiateAuth",s,(function(e,r){return e?t.onFailure(e):n.authenticateUserInternal(r,i,t)}))}else t.onFailure(new Error("PASSWORD parameter is required"))},e.prototype.authenticateUserInternal=function(e,t,n){var r=this,i=e.ChallengeName,o=e.ChallengeParameters;if("SMS_MFA"===i)return this.Session=e.Session,n.mfaRequired(i,o);if("SELECT_MFA_TYPE"===i)return this.Session=e.Session,n.selectMFAType(i,o);if("MFA_SETUP"===i)return this.Session=e.Session,n.mfaSetup(i,o);if("SOFTWARE_TOKEN_MFA"===i)return this.Session=e.Session,n.totpRequired(i,o);if("CUSTOM_CHALLENGE"===i)return this.Session=e.Session,n.customChallenge(o);if("NEW_PASSWORD_REQUIRED"===i){this.Session=e.Session;var s=null,a=null,u=[],c=t.getNewPasswordRequiredChallengeUserAttributePrefix();if(o&&(s=JSON.parse(e.ChallengeParameters.userAttributes),a=JSON.parse(e.ChallengeParameters.requiredAttributes)),a)for(var h=0;h<a.length;h++)u[h]=a[h].substr(c.length);return n.newPasswordRequired(s,u)}if("DEVICE_SRP_AUTH"!==i){this.signInUserSession=this.getCognitoUserSession(e.AuthenticationResult),this.challengeName=i,this.cacheTokens();var l=e.AuthenticationResult.NewDeviceMetadata;if(null==l)return n.onSuccess(this.signInUserSession);t.generateHashDevice(e.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey,e.AuthenticationResult.NewDeviceMetadata.DeviceKey,(function(i){if(i)return n.onFailure(i);var o={Salt:f.Buffer.from(t.getSaltDevices(),"hex").toString("base64"),PasswordVerifier:f.Buffer.from(t.getVerifierDevices(),"hex").toString("base64")};r.verifierDevices=o.PasswordVerifier,r.deviceGroupKey=l.DeviceGroupKey,r.randomPassword=t.getRandomPassword(),r.client.request("ConfirmDevice",{DeviceKey:l.DeviceKey,AccessToken:r.signInUserSession.getAccessToken().getJwtToken(),DeviceSecretVerifierConfig:o,DeviceName:navigator.userAgent},(function(t,i){return t?n.onFailure(t):(r.deviceKey=e.AuthenticationResult.NewDeviceMetadata.DeviceKey,r.cacheDeviceKeyAndPassword(),!0===i.UserConfirmationNecessary?n.onSuccess(r.signInUserSession,i.UserConfirmationNecessary):n.onSuccess(r.signInUserSession))}))}))}else this.getDeviceResponse(n)},e.prototype.completeNewPasswordChallenge=function(e,t,n,r){var i=this;if(!e)return n.onFailure(new Error("New password is required."));var o=new R(this.pool.getUserPoolId().split("_")[1]),s=o.getNewPasswordRequiredChallengeUserAttributePrefix(),a={};t&&Object.keys(t).forEach((function(e){a[s+e]=t[e]})),a.NEW_PASSWORD=e,a.USERNAME=this.username;var u={ChallengeName:"NEW_PASSWORD_REQUIRED",ClientId:this.pool.getClientId(),ChallengeResponses:a,Session:this.Session,ClientMetadata:r};this.getUserContextData()&&(u.UserContextData=this.getUserContextData()),this.client.request("RespondToAuthChallenge",u,(function(e,t){return e?n.onFailure(e):i.authenticateUserInternal(t,o,n)}))},e.prototype.getDeviceResponse=function(e,t){var n=this,r=new R(this.deviceGroupKey),i=new G,o={};o.USERNAME=this.username,o.DEVICE_KEY=this.deviceKey,r.getLargeAValue((function(s,a){s&&e.onFailure(s),o.SRP_A=a.toString(16);var u={ChallengeName:"DEVICE_SRP_AUTH",ClientId:n.pool.getClientId(),ChallengeResponses:o,ClientMetadata:t};n.getUserContextData()&&(u.UserContextData=n.getUserContextData()),n.client.request("RespondToAuthChallenge",u,(function(t,o){if(t)return e.onFailure(t);var s=o.ChallengeParameters,a=new v(s.SRP_B,16),u=new v(s.SALT,16);r.getPasswordAuthenticationKey(n.deviceKey,n.randomPassword,a,u,(function(t,r){if(t)return e.onFailure(t);var a=i.getNowString(),u=p.a.lib.WordArray.create(f.Buffer.concat([f.Buffer.from(n.deviceGroupKey,"utf8"),f.Buffer.from(n.deviceKey,"utf8"),f.Buffer.from(s.SECRET_BLOCK,"base64"),f.Buffer.from(a,"utf8")])),c=p.a.lib.WordArray.create(r),h=H.a.stringify(m()(u,c)),l={};l.USERNAME=n.username,l.PASSWORD_CLAIM_SECRET_BLOCK=s.SECRET_BLOCK,l.TIMESTAMP=a,l.PASSWORD_CLAIM_SIGNATURE=h,l.DEVICE_KEY=n.deviceKey;var d={ChallengeName:"DEVICE_PASSWORD_VERIFIER",ClientId:n.pool.getClientId(),ChallengeResponses:l,Session:o.Session};n.getUserContextData()&&(d.UserContextData=n.getUserContextData()),n.client.request("RespondToAuthChallenge",d,(function(t,r){return t?e.onFailure(t):(n.signInUserSession=n.getCognitoUserSession(r.AuthenticationResult),n.cacheTokens(),e.onSuccess(n.signInUserSession))}))}))}))}))},e.prototype.confirmRegistration=function(e,t,n,r){var i={ClientId:this.pool.getClientId(),ConfirmationCode:e,Username:this.username,ForceAliasCreation:t,ClientMetadata:r};this.getUserContextData()&&(i.UserContextData=this.getUserContextData()),this.client.request("ConfirmSignUp",i,(function(e){return e?n(e,null):n(null,"SUCCESS")}))},e.prototype.sendCustomChallengeAnswer=function(e,t,n){var r=this,i={};i.USERNAME=this.username,i.ANSWER=e;var o=new R(this.pool.getUserPoolId().split("_")[1]);this.getCachedDeviceKeyAndPassword(),null!=this.deviceKey&&(i.DEVICE_KEY=this.deviceKey);var s={ChallengeName:"CUSTOM_CHALLENGE",ChallengeResponses:i,ClientId:this.pool.getClientId(),Session:this.Session,ClientMetadata:n};this.getUserContextData()&&(s.UserContextData=this.getUserContextData()),this.client.request("RespondToAuthChallenge",s,(function(e,n){return e?t.onFailure(e):r.authenticateUserInternal(n,o,t)}))},e.prototype.sendMFACode=function(e,t,n,r){var i=this,o={};o.USERNAME=this.username,o.SMS_MFA_CODE=e;var s=n||"SMS_MFA";"SOFTWARE_TOKEN_MFA"===s&&(o.SOFTWARE_TOKEN_MFA_CODE=e),null!=this.deviceKey&&(o.DEVICE_KEY=this.deviceKey);var a={ChallengeName:s,ChallengeResponses:o,ClientId:this.pool.getClientId(),Session:this.Session,ClientMetadata:r};this.getUserContextData()&&(a.UserContextData=this.getUserContextData()),this.client.request("RespondToAuthChallenge",a,(function(e,n){if(e)return t.onFailure(e);if("DEVICE_SRP_AUTH"!==n.ChallengeName){if(i.signInUserSession=i.getCognitoUserSession(n.AuthenticationResult),i.cacheTokens(),null==n.AuthenticationResult.NewDeviceMetadata)return t.onSuccess(i.signInUserSession);var r=new R(i.pool.getUserPoolId().split("_")[1]);r.generateHashDevice(n.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey,n.AuthenticationResult.NewDeviceMetadata.DeviceKey,(function(e){if(e)return t.onFailure(e);var o={Salt:f.Buffer.from(r.getSaltDevices(),"hex").toString("base64"),PasswordVerifier:f.Buffer.from(r.getVerifierDevices(),"hex").toString("base64")};i.verifierDevices=o.PasswordVerifier,i.deviceGroupKey=n.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey,i.randomPassword=r.getRandomPassword(),i.client.request("ConfirmDevice",{DeviceKey:n.AuthenticationResult.NewDeviceMetadata.DeviceKey,AccessToken:i.signInUserSession.getAccessToken().getJwtToken(),DeviceSecretVerifierConfig:o,DeviceName:navigator.userAgent},(function(e,r){return e?t.onFailure(e):(i.deviceKey=n.AuthenticationResult.NewDeviceMetadata.DeviceKey,i.cacheDeviceKeyAndPassword(),!0===r.UserConfirmationNecessary?t.onSuccess(i.signInUserSession,r.UserConfirmationNecessary):t.onSuccess(i.signInUserSession))}))}))}else i.getDeviceResponse(t)}))},e.prototype.changePassword=function(e,t,n,r){if(null==this.signInUserSession||!this.signInUserSession.isValid())return n(new Error("User is not authenticated"),null);this.client.request("ChangePassword",{PreviousPassword:e,ProposedPassword:t,AccessToken:this.signInUserSession.getAccessToken().getJwtToken(),ClientMetadata:r},(function(e){return e?n(e,null):n(null,"SUCCESS")}))},e.prototype.enableMFA=function(e){if(null==this.signInUserSession||!this.signInUserSession.isValid())return e(new Error("User is not authenticated"),null);var t=[];t.push({DeliveryMedium:"SMS",AttributeName:"phone_number"}),this.client.request("SetUserSettings",{MFAOptions:t,AccessToken:this.signInUserSession.getAccessToken().getJwtToken()},(function(t){return t?e(t,null):e(null,"SUCCESS")}))},e.prototype.setUserMfaPreference=function(e,t,n){if(null==this.signInUserSession||!this.signInUserSession.isValid())return n(new Error("User is not authenticated"),null);this.client.request("SetUserMFAPreference",{SMSMfaSettings:e,SoftwareTokenMfaSettings:t,AccessToken:this.signInUserSession.getAccessToken().getJwtToken()},(function(e){return e?n(e,null):n(null,"SUCCESS")}))},e.prototype.disableMFA=function(e){if(null==this.signInUserSession||!this.signInUserSession.isValid())return e(new Error("User is not authenticated"),null);this.client.request("SetUserSettings",{MFAOptions:[],AccessToken:this.signInUserSession.getAccessToken().getJwtToken()},(function(t){return t?e(t,null):e(null,"SUCCESS")}))},e.prototype.deleteUser=function(e,t){var n=this;if(null==this.signInUserSession||!this.signInUserSession.isValid())return e(new Error("User is not authenticated"),null);this.client.request("DeleteUser",{AccessToken:this.signInUserSession.getAccessToken().getJwtToken(),ClientMetadata:t},(function(t){return t?e(t,null):(n.clearCachedUser(),e(null,"SUCCESS"))}))},e.prototype.updateAttributes=function(e,t,n){if(null==this.signInUserSession||!this.signInUserSession.isValid())return t(new Error("User is not authenticated"),null);this.client.request("UpdateUserAttributes",{AccessToken:this.signInUserSession.getAccessToken().getJwtToken(),UserAttributes:e,ClientMetadata:n},(function(e){return e?t(e,null):t(null,"SUCCESS")}))},e.prototype.getUserAttributes=function(e){if(null==this.signInUserSession||!this.signInUserSession.isValid())return e(new Error("User is not authenticated"),null);this.client.request("GetUser",{AccessToken:this.signInUserSession.getAccessToken().getJwtToken()},(function(t,n){if(t)return e(t,null);for(var r=[],i=0;i<n.UserAttributes.length;i++){var o={Name:n.UserAttributes[i].Name,Value:n.UserAttributes[i].Value},s=new X(o);r.push(s)}return e(null,r)}))},e.prototype.getMFAOptions=function(e){if(null==this.signInUserSession||!this.signInUserSession.isValid())return e(new Error("User is not authenticated"),null);this.client.request("GetUser",{AccessToken:this.signInUserSession.getAccessToken().getJwtToken()},(function(t,n){return t?e(t,null):e(null,n.MFAOptions)}))},e.prototype.getUserData=function(e,t){var n=this;if(null==this.signInUserSession||!this.signInUserSession.isValid())return this.clearCachedUserData(),e(new Error("User is not authenticated"),null);var r=!!t&&t.bypassCache,i=this.storage.getItem(this.userDataKey);if(!i||r)this.client.request("GetUser",{AccessToken:this.signInUserSession.getAccessToken().getJwtToken()},(function(t,r){if(t)return e(t,null);n.cacheUserData(r);var i=n.signInUserSession.getRefreshToken();if(!i||!i.getToken())return e(null,r);n.refreshSession(i,(function(t,n){return t?e(t,null):e(null,r)}))}));else try{return e(null,JSON.parse(i))}catch(t){return this.clearCachedUserData(),e(t,null)}},e.prototype.deleteAttributes=function(e,t){if(null==this.signInUserSession||!this.signInUserSession.isValid())return t(new Error("User is not authenticated"),null);this.client.request("DeleteUserAttributes",{UserAttributeNames:e,AccessToken:this.signInUserSession.getAccessToken().getJwtToken()},(function(e){return e?t(e,null):t(null,"SUCCESS")}))},e.prototype.resendConfirmationCode=function(e,t){var n={ClientId:this.pool.getClientId(),Username:this.username,ClientMetadata:t};this.client.request("ResendConfirmationCode",n,(function(t,n){return t?e(t,null):e(null,n)}))},e.prototype.getSession=function(e){if(null==this.username)return e(new Error("Username is null. Cannot retrieve a new session"),null);if(null!=this.signInUserSession&&this.signInUserSession.isValid())return e(null,this.signInUserSession);var t="CognitoIdentityServiceProvider."+this.pool.getClientId()+"."+this.username,n=t+".idToken",r=t+".accessToken",i=t+".refreshToken",o=t+".clockDrift";if(this.storage.getItem(n)){var s=new V({IdToken:this.storage.getItem(n)}),a=new x({AccessToken:this.storage.getItem(r)}),u=new q({RefreshToken:this.storage.getItem(i)}),c=parseInt(this.storage.getItem(o),0)||0,h=new Y({IdToken:s,AccessToken:a,RefreshToken:u,ClockDrift:c});if(h.isValid())return this.signInUserSession=h,e(null,this.signInUserSession);if(!u.getToken())return e(new Error("Cannot retrieve a new session. Please authenticate."),null);this.refreshSession(u,e)}else e(new Error("Local storage is missing an ID Token, Please authenticate"),null)},e.prototype.refreshSession=function(e,t,n){var r=this,i={};i.REFRESH_TOKEN=e.getToken();var o="CognitoIdentityServiceProvider."+this.pool.getClientId(),s=o+".LastAuthUser";if(this.storage.getItem(s)){this.username=this.storage.getItem(s);var a=o+"."+this.username+".deviceKey";this.deviceKey=this.storage.getItem(a),i.DEVICE_KEY=this.deviceKey}var u={ClientId:this.pool.getClientId(),AuthFlow:"REFRESH_TOKEN_AUTH",AuthParameters:i,ClientMetadata:n};this.getUserContextData()&&(u.UserContextData=this.getUserContextData()),this.client.request("InitiateAuth",u,(function(n,i){if(n)return"NotAuthorizedException"===n.code&&r.clearCachedUser(),t(n,null);if(i){var o=i.AuthenticationResult;return Object.prototype.hasOwnProperty.call(o,"RefreshToken")||(o.RefreshToken=e.getToken()),r.signInUserSession=r.getCognitoUserSession(o),r.cacheTokens(),t(null,r.signInUserSession)}}))},e.prototype.cacheTokens=function(){var e="CognitoIdentityServiceProvider."+this.pool.getClientId(),t=e+"."+this.username+".idToken",n=e+"."+this.username+".accessToken",r=e+"."+this.username+".refreshToken",i=e+"."+this.username+".clockDrift",o=e+".LastAuthUser";this.storage.setItem(t,this.signInUserSession.getIdToken().getJwtToken()),this.storage.setItem(n,this.signInUserSession.getAccessToken().getJwtToken()),this.storage.setItem(r,this.signInUserSession.getRefreshToken().getToken()),this.storage.setItem(i,""+this.signInUserSession.getClockDrift()),this.storage.setItem(o,this.username)},e.prototype.cacheUserData=function(e){this.storage.setItem(this.userDataKey,JSON.stringify(e))},e.prototype.clearCachedUserData=function(){this.storage.removeItem(this.userDataKey)},e.prototype.clearCachedUser=function(){this.clearCachedTokens(),this.clearCachedUserData()},e.prototype.cacheDeviceKeyAndPassword=function(){var e="CognitoIdentityServiceProvider."+this.pool.getClientId()+"."+this.username,t=e+".deviceKey",n=e+".randomPasswordKey",r=e+".deviceGroupKey";this.storage.setItem(t,this.deviceKey),this.storage.setItem(n,this.randomPassword),this.storage.setItem(r,this.deviceGroupKey)},e.prototype.getCachedDeviceKeyAndPassword=function(){var e="CognitoIdentityServiceProvider."+this.pool.getClientId()+"."+this.username,t=e+".deviceKey",n=e+".randomPasswordKey",r=e+".deviceGroupKey";this.storage.getItem(t)&&(this.deviceKey=this.storage.getItem(t),this.randomPassword=this.storage.getItem(n),this.deviceGroupKey=this.storage.getItem(r))},e.prototype.clearCachedDeviceKeyAndPassword=function(){var e="CognitoIdentityServiceProvider."+this.pool.getClientId()+"."+this.username,t=e+".deviceKey",n=e+".randomPasswordKey",r=e+".deviceGroupKey";this.storage.removeItem(t),this.storage.removeItem(n),this.storage.removeItem(r)},e.prototype.clearCachedTokens=function(){var e="CognitoIdentityServiceProvider."+this.pool.getClientId(),t=e+"."+this.username+".idToken",n=e+"."+this.username+".accessToken",r=e+"."+this.username+".refreshToken",i=e+".LastAuthUser",o=e+"."+this.username+".clockDrift";this.storage.removeItem(t),this.storage.removeItem(n),this.storage.removeItem(r),this.storage.removeItem(i),this.storage.removeItem(o)},e.prototype.getCognitoUserSession=function(e){var t=new V(e),n=new x(e),r=new q(e);return new Y({IdToken:t,AccessToken:n,RefreshToken:r})},e.prototype.forgotPassword=function(e,t){var n={ClientId:this.pool.getClientId(),Username:this.username,ClientMetadata:t};this.getUserContextData()&&(n.UserContextData=this.getUserContextData()),this.client.request("ForgotPassword",n,(function(t,n){return t?e.onFailure(t):"function"==typeof e.inputVerificationCode?e.inputVerificationCode(n):e.onSuccess(n)}))},e.prototype.confirmPassword=function(e,t,n,r){var i={ClientId:this.pool.getClientId(),Username:this.username,ConfirmationCode:e,Password:t,ClientMetadata:r};this.getUserContextData()&&(i.UserContextData=this.getUserContextData()),this.client.request("ConfirmForgotPassword",i,(function(e){return e?n.onFailure(e):n.onSuccess()}))},e.prototype.getAttributeVerificationCode=function(e,t,n){if(null==this.signInUserSession||!this.signInUserSession.isValid())return t.onFailure(new Error("User is not authenticated"));this.client.request("GetUserAttributeVerificationCode",{AttributeName:e,AccessToken:this.signInUserSession.getAccessToken().getJwtToken(),ClientMetadata:n},(function(e,n){return e?t.onFailure(e):"function"==typeof t.inputVerificationCode?t.inputVerificationCode(n):t.onSuccess()}))},e.prototype.verifyAttribute=function(e,t,n){if(null==this.signInUserSession||!this.signInUserSession.isValid())return n.onFailure(new Error("User is not authenticated"));this.client.request("VerifyUserAttribute",{AttributeName:e,Code:t,AccessToken:this.signInUserSession.getAccessToken().getJwtToken()},(function(e){return e?n.onFailure(e):n.onSuccess("SUCCESS")}))},e.prototype.getDevice=function(e){if(null==this.signInUserSession||!this.signInUserSession.isValid())return e.onFailure(new Error("User is not authenticated"));this.client.request("GetDevice",{AccessToken:this.signInUserSession.getAccessToken().getJwtToken(),DeviceKey:this.deviceKey},(function(t,n){return t?e.onFailure(t):e.onSuccess(n)}))},e.prototype.forgetSpecificDevice=function(e,t){if(null==this.signInUserSession||!this.signInUserSession.isValid())return t.onFailure(new Error("User is not authenticated"));this.client.request("ForgetDevice",{AccessToken:this.signInUserSession.getAccessToken().getJwtToken(),DeviceKey:e},(function(e){return e?t.onFailure(e):t.onSuccess("SUCCESS")}))},e.prototype.forgetDevice=function(e){var t=this;this.forgetSpecificDevice(this.deviceKey,{onFailure:e.onFailure,onSuccess:function(n){return t.deviceKey=null,t.deviceGroupKey=null,t.randomPassword=null,t.clearCachedDeviceKeyAndPassword(),e.onSuccess(n)}})},e.prototype.setDeviceStatusRemembered=function(e){if(null==this.signInUserSession||!this.signInUserSession.isValid())return e.onFailure(new Error("User is not authenticated"));this.client.request("UpdateDeviceStatus",{AccessToken:this.signInUserSession.getAccessToken().getJwtToken(),DeviceKey:this.deviceKey,DeviceRememberedStatus:"remembered"},(function(t){return t?e.onFailure(t):e.onSuccess("SUCCESS")}))},e.prototype.setDeviceStatusNotRemembered=function(e){if(null==this.signInUserSession||!this.signInUserSession.isValid())return e.onFailure(new Error("User is not authenticated"));this.client.request("UpdateDeviceStatus",{AccessToken:this.signInUserSession.getAccessToken().getJwtToken(),DeviceKey:this.deviceKey,DeviceRememberedStatus:"not_remembered"},(function(t){return t?e.onFailure(t):e.onSuccess("SUCCESS")}))},e.prototype.listDevices=function(e,t,n){if(null==this.signInUserSession||!this.signInUserSession.isValid())return n.onFailure(new Error("User is not authenticated"));this.client.request("ListDevices",{AccessToken:this.signInUserSession.getAccessToken().getJwtToken(),Limit:e,PaginationToken:t},(function(e,t){return e?n.onFailure(e):n.onSuccess(t)}))},e.prototype.globalSignOut=function(e){var t=this;if(null==this.signInUserSession||!this.signInUserSession.isValid())return e.onFailure(new Error("User is not authenticated"));this.client.request("GlobalSignOut",{AccessToken:this.signInUserSession.getAccessToken().getJwtToken()},(function(n){return n?e.onFailure(n):(t.clearCachedUser(),e.onSuccess("SUCCESS"))}))},e.prototype.signOut=function(){this.signInUserSession=null,this.clearCachedUser()},e.prototype.sendMFASelectionAnswer=function(e,t){var n=this,r={};r.USERNAME=this.username,r.ANSWER=e;var i={ChallengeName:"SELECT_MFA_TYPE",ChallengeResponses:r,ClientId:this.pool.getClientId(),Session:this.Session};this.getUserContextData()&&(i.UserContextData=this.getUserContextData()),this.client.request("RespondToAuthChallenge",i,(function(r,i){return r?t.onFailure(r):(n.Session=i.Session,"SMS_MFA"===e?t.mfaRequired(i.challengeName,i.challengeParameters):"SOFTWARE_TOKEN_MFA"===e?t.totpRequired(i.challengeName,i.challengeParameters):void 0)}))},e.prototype.getUserContextData=function(){return this.pool.getUserContextData(this.username)},e.prototype.associateSoftwareToken=function(e){var t=this;null!=this.signInUserSession&&this.signInUserSession.isValid()?this.client.request("AssociateSoftwareToken",{AccessToken:this.signInUserSession.getAccessToken().getJwtToken()},(function(t,n){return t?e.onFailure(t):e.associateSecretCode(n.SecretCode)})):this.client.request("AssociateSoftwareToken",{Session:this.Session},(function(n,r){return n?e.onFailure(n):(t.Session=r.Session,e.associateSecretCode(r.SecretCode))}))},e.prototype.verifySoftwareToken=function(e,t,n){var r=this;null!=this.signInUserSession&&this.signInUserSession.isValid()?this.client.request("VerifySoftwareToken",{AccessToken:this.signInUserSession.getAccessToken().getJwtToken(),UserCode:e,FriendlyDeviceName:t},(function(e,t){return e?n.onFailure(e):n.onSuccess(t)})):this.client.request("VerifySoftwareToken",{Session:this.Session,UserCode:e,FriendlyDeviceName:t},(function(e,t){if(e)return n.onFailure(e);r.Session=t.Session;var i={};i.USERNAME=r.username;var o={ChallengeName:"MFA_SETUP",ClientId:r.pool.getClientId(),ChallengeResponses:i,Session:r.Session};r.getUserContextData()&&(o.UserContextData=r.getUserContextData()),r.client.request("RespondToAuthChallenge",o,(function(e,t){return e?n.onFailure(e):(r.signInUserSession=r.getCognitoUserSession(t.AuthenticationResult),r.cacheTokens(),n.onSuccess(r.signInUserSession))}))}))},e}(),re=ie;function ie(){}ie.prototype.userAgent="aws-amplify/0.1.x js";var oe=function(){function e(t,n){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.endpoint=n||"https://cognito-idp."+t+".amazonaws.com/",this.userAgent=re.prototype.userAgent||"aws-amplify/0.1.x js"}return e.prototype.request=function(e,t,n){var r={headers:{"Content-Type":"application/x-amz-json-1.1","X-Amz-Target":"AWSCognitoIdentityProviderService."+e,"X-Amz-User-Agent":this.userAgent},method:"POST",mode:"cors",cache:"no-cache",body:JSON.stringify(t)},i=void 0;fetch(this.endpoint,r).then((function(e){return i=e,e}),(function(e){if(e instanceof TypeError)throw new Error("Network error");throw e})).then((function(e){return e.json().catch((function(){return{}}))})).then((function(e){if(i.ok)return n(null,e);e;var t=(e.__type||e.code).split("#").pop(),r={code:t,name:t,message:e.message||e.Message||null};return n(r)})).catch((function(e){if(!(i&&i.headers&&i.headers.get("x-amzn-errortype"))){if(e instanceof Error&&"Network error"===e.message){var t={code:"NetworkError",name:e.name,message:e.message};return n(t)}return n(e)}try{var r=i.headers.get("x-amzn-errortype").split(":")[0],o={code:r,name:r,statusCode:i.status,message:i.status?i.status.toString():null};return n(o)}catch(t){return n(e)}}))},e}();
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	var se=function(){function e(t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e);var n=t||{},r=n.UserPoolId,i=n.ClientId,o=n.endpoint,s=n.AdvancedSecurityDataCollectionFlag;if(!r||!i)throw new Error("Both UserPoolId and ClientId are required.");if(!/^[\w-]+_.+$/.test(r))throw new Error("Invalid UserPoolId format.");var a=r.split("_")[0];this.userPoolId=r,this.clientId=i,this.client=new oe(a,o),this.advancedSecurityDataCollectionFlag=!1!==s,this.storage=t.Storage||(new te).getStorage()}return e.prototype.getUserPoolId=function(){return this.userPoolId},e.prototype.getClientId=function(){return this.clientId},e.prototype.signUp=function(e,t,n,r,i,o){var s=this,a={ClientId:this.clientId,Username:e,Password:t,UserAttributes:n,ValidationData:r,ClientMetadata:o};this.getUserContextData(e)&&(a.UserContextData=this.getUserContextData(e)),this.client.request("SignUp",a,(function(t,n){if(t)return i(t,null);var r={Username:e,Pool:s,Storage:s.storage},o={user:new ne(r),userConfirmed:n.UserConfirmed,userSub:n.UserSub,codeDeliveryDetails:n.CodeDeliveryDetails};return i(null,o)}))},e.prototype.getCurrentUser=function(){var e="CognitoIdentityServiceProvider."+this.clientId+".LastAuthUser",t=this.storage.getItem(e);if(t){var n={Username:t,Pool:this,Storage:this.storage};return new ne(n)}return null},e.prototype.getUserContextData=function(e){if("undefined"!=typeof AmazonCognitoAdvancedSecurityData){var t=AmazonCognitoAdvancedSecurityData;if(this.advancedSecurityDataCollectionFlag){var n=t.getData(e,this.userPoolId,this.clientId);if(n)return{EncodedData:n}}return{}}},e}(),ae=n(4);var ue,ce=function(){function e(t){if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),!t.domain)throw new Error("The domain of cookieStorage can not be undefined.");this.domain=t.domain,t.path?this.path=t.path:this.path="/",Object.prototype.hasOwnProperty.call(t,"expires")?this.expires=t.expires:this.expires=365,Object.prototype.hasOwnProperty.call(t,"secure")?this.secure=t.secure:this.secure=!0}return e.prototype.setItem=function(e,t){return ae.set(e,t,{path:this.path,expires:this.expires,domain:this.domain,secure:this.secure}),ae.get(e)},e.prototype.getItem=function(e){return ae.get(e)},e.prototype.removeItem=function(e){return ae.remove(e,{path:this.path,domain:this.domain,secure:this.secure})},e.prototype.clear=function(){var e=ae.get(),t=void 0;for(t=0;t<e.length;++t)ae.remove(e[t]);return{}},e}(),he=n(3),fe=function(e){var t=window.open(e,"_self");return t?Promise.resolve(t):Promise.reject()},le=function(){return(le=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e}).apply(this,arguments)},pe=function(e,t,n,r){return new(n||(n=Promise))((function(i,o){function s(e){try{u(r.next(e))}catch(e){o(e)}}function a(e){try{u(r.throw(e))}catch(e){o(e)}}function u(e){var t;e.done?i(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(s,a)}u((r=r.apply(e,t||[])).next())}))},de=function(e,t){var n,r,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(i=2&o[0]?r.return:o[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,o[1])).done)return i;switch(r=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,r=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=(i=s.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=t.call(e,s)}catch(e){o=[6,e],r=0}finally{n=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}},ge=n(6),ye=n(7),me="undefined"!=typeof Symbol&&"function"==typeof Symbol.for?Symbol.for("amplify_default"):"@@amplify_default",ve=function(e,t,n){a.Hub.dispatch("auth",{event:e,data:t,message:n},"Auth",me)},we=new a.ConsoleLogger("OAuth"),Se=function(){function e(e){var t=e.config,n=e.cognitoClientId,r=e.scopes,i=void 0===r?[]:r;this._urlOpener=t.urlOpener||fe,this._config=t,this._cognitoClientId=n,this._scopes=i}return e.prototype.oauthSignIn=function(e,t,n,i,o,s){void 0===e&&(e="code"),void 0===o&&(o=r.Cognito);var a=this._generateState(32),u=s?a+"-"+s:a;!function(e){window.sessionStorage.setItem("oauth_state",e)}(encodeURIComponent(u));var c,h=this._generateRandom(128);c=h,window.sessionStorage.setItem("ouath_pkce_key",c);var f=this._generateChallenge(h),l="https://"+t+"/oauth2/authorize?"+Object.entries(le(le({redirect_uri:n,response_type:e,client_id:i,identity_provider:o,scopes:this._scopes,state:u},"code"===e?{code_challenge:f}:{}),"code"===e?{code_challenge_method:"S256"}:{})).map((function(e){var t=e[0],n=e[1];return encodeURIComponent(t)+"="+encodeURIComponent(n)})).join("&");we.debug("Redirecting to "+l),this._urlOpener(l,n)},e.prototype._handleCodeFlow=function(e){return pe(this,void 0,void 0,(function(){var t,n,r,i,o,a,u,c,h,f,l,p;return de(this,(function(d){switch(d.label){case 0:return(t=(Object(he.parse)(e).query||"").split("&").map((function(e){return e.split("=")})).reduce((function(e,t){var n,r=t[0],i=t[1];return le(le({},e),((n={})[r]=i,n))}),{code:void 0}).code)?(n="https://"+this._config.domain+"/oauth2/token",ve("codeFlow",{},"Retrieving tokens from "+n),r=s(this._config)?this._cognitoClientId:this._config.clientID,i=s(this._config)?this._config.redirectSignIn:this._config.redirectUri,g=window.sessionStorage.getItem("ouath_pkce_key"),window.sessionStorage.removeItem("ouath_pkce_key"),a=le({grant_type:"authorization_code",code:t,client_id:r,redirect_uri:i},(o=g)?{code_verifier:o}:{}),we.debug("Calling token endpoint: "+n+" with",a),u=Object.entries(a).map((function(e){var t=e[0],n=e[1];return encodeURIComponent(t)+"="+encodeURIComponent(n)})).join("&"),[4,fetch(n,{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:u})]):[2];case 1:return[4,d.sent().json()];case 2:if(c=d.sent(),h=c.access_token,f=c.refresh_token,l=c.id_token,p=c.error)throw new Error(p);return[2,{accessToken:h,refreshToken:f,idToken:l}]}var g}))}))},e.prototype._handleImplicitFlow=function(e){return pe(this,void 0,void 0,(function(){var t,n,r;return de(this,(function(i){return t=Object(he.parse)(e).hash.substr(1).split("&").map((function(e){return e.split("=")})).reduce((function(e,t){var n,r=t[0],i=t[1];return le(le({},e),((n={})[r]=i,n))}),{id_token:void 0,access_token:void 0}),n=t.id_token,r=t.access_token,ve("implicitFlow",{},"Got tokens from "+e),we.debug("Retrieving implicit tokens from "+e+" with"),[2,{accessToken:r,idToken:n,refreshToken:null}]}))}))},e.prototype.handleAuthResponse=function(e){return pe(this,void 0,void 0,(function(){var t,n,r,i,o,s,a;return de(this,(function(u){switch(u.label){case 0:if(u.trys.push([0,5,,6]),t=e?le(le({},(Object(he.parse)(e).hash||"#").substr(1).split("&").map((function(e){return e.split("=")})).reduce((function(e,t){var n=t[0],r=t[1];return e[n]=r,e}),{})),(Object(he.parse)(e).query||"").split("&").map((function(e){return e.split("=")})).reduce((function(e,t){var n=t[0],r=t[1];return e[n]=r,e}),{})):{},n=t.error,r=t.error_description,n)throw new Error(r);return i=this._validateState(t),we.debug("Starting "+this._config.responseType+" flow with "+e),"code"!==this._config.responseType?[3,2]:(o=[{}],[4,this._handleCodeFlow(e)]);case 1:return[2,le.apply(void 0,[le.apply(void 0,o.concat([u.sent()])),{state:i}])];case 2:return s=[{}],[4,this._handleImplicitFlow(e)];case 3:return[2,le.apply(void 0,[le.apply(void 0,s.concat([u.sent()])),{state:i}])];case 4:return[3,6];case 5:return a=u.sent(),we.error("Error handling auth response.",a),[3,6];case 6:return[2]}}))}))},e.prototype._validateState=function(e){if(e){var t,n=(t=window.sessionStorage.getItem("oauth_state"),window.sessionStorage.removeItem("oauth_state"),t),r=e.state;if(n&&n!==r)throw new Error("Invalid state in OAuth flow");return r}},e.prototype.signOut=function(){return pe(this,void 0,void 0,(function(){var e,t,n;return de(this,(function(r){return e="https://"+this._config.domain+"/logout?",t=s(this._config)?this._cognitoClientId:this._config.oauth.clientID,n=s(this._config)?this._config.redirectSignOut:this._config.returnTo,e+=Object.entries({client_id:t,logout_uri:encodeURIComponent(n)}).map((function(e){return e[0]+"="+e[1]})).join("&"),ve("oAuthSignOut",{oAuth:"signOut"},"Signing out from "+e),we.debug("Signing out from "+e),[2,this._urlOpener(e)]}))}))},e.prototype._generateState=function(e){for(var t="",n=e,r="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";n>0;--n)t+=r[Math.round(Math.random()*(r.length-1))];return t},e.prototype._generateChallenge=function(e){return this._base64URL(ge(e))},e.prototype._base64URL=function(e){return e.toString(ye).replace(/=/g,"").replace(/\+/g,"-").replace(/\//g,"_")},e.prototype._generateRandom=function(e){var t=new Uint8Array(e);if("undefined"!=typeof window&&window.crypto)window.crypto.getRandomValues(t);else for(var n=0;n<e;n+=1)t[n]=Math.random()*"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~".length|0;return this._bufferToString(t)},e.prototype._bufferToString=function(e){for(var t="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",n=[],r=0;r<e.byteLength;r+=1){var i=e[r]%t.length;n.push(t[i])}return n.join("")},e}(),Ae=(ue=function(e,t){return(ue=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}ue(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),be=new a.ConsoleLogger("AuthError"),Ce=function(e){function t(n){var r=this,i=Ie[n],o=i.message,s=i.log;return(r=e.call(this,o)||this).constructor=t,Object.setPrototypeOf(r,t.prototype),r.name="AuthError",r.log=s||o,be.error(r.log),r}return Ae(t,e),t}(Error),Ue=function(e){function t(n){var r=e.call(this,n)||this;return r.constructor=t,Object.setPrototypeOf(r,t.prototype),r.name="NoUserPoolError",r}return Ae(t,e),t}(Ce),Ie={noConfig:{message:"Authentication Error",log:"\n            Error: Amplify has not been configured correctly.\n            This error is typically caused by one of the following scenarios:\n\n            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point\n                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information\n            \n            2. There might be multiple conflicting versions of aws-amplify or amplify packages in your node_modules.\n                Try deleting your node_modules folder and reinstalling the dependencies with `yarn install`\n        "},missingAuthConfig:{message:"Authentication Error",log:"\n            Error: Amplify has not been configured correctly. \n            The configuration object is missing required auth properties. \n            Did you run `amplify push` after adding auth via `amplify add auth`?\n            See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information\n        "},emptyUsername:{message:"Username cannot be empty"},invalidUsername:{message:"The username should either be a string or one of the sign in types"},emptyPassword:{message:"Password cannot be empty"},emptyCode:{message:"Confirmation code cannot be empty"},signUpError:{message:"Error creating account",log:"The first parameter should either be non-null string or object"},noMFA:{message:"No valid MFA method provided"},invalidMFA:{message:"Invalid MFA type"},emptyChallengeResponse:{message:"Challenge response cannot be empty"},noUserSession:{message:"Failed to get the session because the user is empty"},default:{message:"Authentication Error"}};function Ee(e){return(Ee="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var Te,_e=function(e,t,n,r){return new(n||(n=Promise))((function(i,o){function s(e){try{u(r.next(e))}catch(e){o(e)}}function a(e){try{u(r.throw(e))}catch(e){o(e)}}function u(e){var t;e.done?i(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(s,a)}u((r=r.apply(e,t||[])).next())}))},Pe=function(e,t){var n,r,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(i=2&o[0]?r.return:o[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,o[1])).done)return i;switch(r=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,r=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=(i=s.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=t.call(e,s)}catch(e){o=[6,e],r=0}finally{n=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}},De=new a.ConsoleLogger("AuthClass"),Re="undefined"!=typeof Symbol&&"function"==typeof Symbol.for?Symbol.for("amplify_default"):"@@amplify_default",ke=function(e,t,n){a.Hub.dispatch("auth",{event:e,data:t,message:n},"Auth",Re)};!function(e){e.Cognito="COGNITO",e.Google="Google",e.Facebook="Facebook",e.Amazon="LoginWithAmazon"}(Te||(Te={}));var Fe=function(){function e(e){var t=this;this.userPool=null,this.user=null,this.configure(e),this.currentUserCredentials=this.currentUserCredentials.bind(this),a.AWS.config?a.AWS.config.update({customUserAgent:a.Constants.userAgent}):De.warn("No AWS.config"),a.Hub.listen("auth",(function(e){switch(e.payload.event){case"signIn":t._storage.setItem("amplify-signin-with-hostedUI","false");break;case"signOut":t._storage.removeItem("amplify-signin-with-hostedUI");break;case"cognitoHostedUI":t._storage.setItem("amplify-signin-with-hostedUI","true")}}))}return e.prototype.getModuleName=function(){return"Auth"},e.prototype.configure=function(e){var t=this;if(!e)return this._config||{};De.debug("configure Auth");var n=Object.assign({},this._config,a.Parser.parseMobilehubConfig(e).Auth,e);this._config=n;var r=this._config,i=r.userPoolId,o=r.userPoolWebClientId,u=r.cookieStorage,c=r.oauth,h=r.region,f=r.identityPoolId,l=r.mandatorySignIn,p=r.refreshHandlers,d=r.identityPoolRegion,g=r.clientMetadata;if(this._config.storage){if(!this._isValidAuthStorage(this._config.storage))throw De.error("The storage in the Auth config is not valid!"),new Error("Empty storage object");this._storage=this._config.storage}else this._storage=u?new ce(u):(new a.StorageHelper).getStorage();if(this._storageSync=Promise.resolve(),"function"==typeof this._storage.sync&&(this._storageSync=this._storage.sync()),i){var y={UserPoolId:i,ClientId:o};y.Storage=this._storage,this.userPool=new se(y)}a.Credentials.configure({mandatorySignIn:l,region:d||h,userPoolId:i,identityPoolId:f,refreshHandlers:p,storage:this._storage});var m=c?s(this._config.oauth)?c:c.awsCognito:void 0;if(m){var v=Object.assign({cognitoClientId:o,UserPoolId:i,domain:m.domain,scopes:m.scope,redirectSignIn:m.redirectSignIn,redirectSignOut:m.redirectSignOut,responseType:m.responseType,Storage:this._storage,urlOpener:m.urlOpener,clientMetadata:g},m.options);this._oAuthHandler=new Se({scopes:v.scopes,config:v,cognitoClientId:v.cognitoClientId}),function(e){if(a.JS.browserOrNode().isBrowser&&window.location)e({url:window.location.href});else if(!a.JS.browserOrNode().isNode)throw new Error("Not supported")}((function(e){var n=e.url;t._handleAuthResponse(n)}))}return ke("configured",null,"The Auth category has been configured successfully"),this._config},e.prototype.signUp=function(e){for(var t=this,n=[],r=1;r<arguments.length;r++)n[r-1]=arguments[r];if(!this.userPool)return this.rejectNoUserPool();var o,s=null,a=null,u=[],c=null;if(e&&"string"==typeof e){s=e,a=n?n[0]:null;var h=n?n[1]:null,f=n?n[2]:null;h&&u.push({Name:"email",Value:h}),f&&u.push({Name:"phone_number",Value:f})}else{if(!e||"object"!==Ee(e))return this.rejectAuthError(i.SignUpError);s=e.username,a=e.password,e&&e.clientMetadata?o=e.clientMetadata:this._config.clientMetadata&&(o=this._config.clientMetadata);var l=e.attributes;l&&Object.keys(l).map((function(e){var t={Name:e,Value:l[e]};u.push(t)})),c=e.validationData||null}return s?a?(De.debug("signUp attrs:",u),De.debug("signUp validation data:",c),new Promise((function(e,n){t.userPool.signUp(s,a,u,c,(function(t,r){t?(ke("signUp_failure",t,s+" failed to signup"),n(t)):(ke("signUp",r,s+" has signed up successfully"),e(r))}),o)}))):this.rejectAuthError(i.EmptyPassword):this.rejectAuthError(i.EmptyUsername)},e.prototype.confirmSignUp=function(e,t,n){if(!this.userPool)return this.rejectNoUserPool();if(!e)return this.rejectAuthError(i.EmptyUsername);if(!t)return this.rejectAuthError(i.EmptyCode);var r,o=this.createCognitoUser(e),s=!n||"boolean"!=typeof n.forceAliasCreation||n.forceAliasCreation;return n&&n.clientMetadata?r=n.clientMetadata:this._config.clientMetadata&&(r=this._config.clientMetadata),new Promise((function(e,n){o.confirmRegistration(t,s,(function(t,r){t?n(t):e(r)}),r)}))},e.prototype.resendSignUp=function(e,t){if(void 0===t&&(t=this._config.clientMetadata),!this.userPool)return this.rejectNoUserPool();if(!e)return this.rejectAuthError(i.EmptyUsername);var n=this.createCognitoUser(e);return new Promise((function(e,r){n.resendConfirmationCode((function(t,n){t?r(t):e(n)}),t)}))},e.prototype.signIn=function(e,t,n){if(void 0===n&&(n=this._config.clientMetadata),!this.userPool)return this.rejectNoUserPool();var r=null,o=null,s={};if("string"==typeof e)r=e,o=t;else{if(!e.username)return this.rejectAuthError(i.InvalidUsername);void 0!==t&&De.warn("The password should be defined under the first parameter object!"),r=e.username,o=e.password,s=e.validationData}if(!r)return this.rejectAuthError(i.EmptyUsername);var a=new h({Username:r,Password:o,ValidationData:s,ClientMetadata:n});return o?this.signInWithPassword(a):this.signInWithoutPassword(a)},e.prototype.authCallbacks=function(e,t,n){var r=this,i=this;return{onSuccess:function(o){return _e(r,void 0,void 0,(function(){var r,s,u,c;return Pe(this,(function(h){switch(h.label){case 0:De.debug(o),delete e.challengeName,delete e.challengeParam,h.label=1;case 1:return h.trys.push([1,4,5,9]),[4,a.Credentials.clear()];case 2:return h.sent(),[4,a.Credentials.set(o,"session")];case 3:return r=h.sent(),De.debug("succeed to get cognito credentials",r),[3,9];case 4:return s=h.sent(),De.debug("cannot get cognito credentials",s),[3,9];case 5:return h.trys.push([5,7,,8]),[4,this.currentUserPoolUser()];case 6:return u=h.sent(),i.user=u,ke("signIn",u,"A user "+e.getUsername()+" has been signed in"),t(u),[3,8];case 7:return c=h.sent(),De.error("Failed to get the signed in user",c),n(c),[3,8];case 8:return[7];case 9:return[2]}}))}))},onFailure:function(t){De.debug("signIn failure",t),ke("signIn_failure",t,e.getUsername()+" failed to signin"),n(t)},customChallenge:function(n){De.debug("signIn custom challenge answer required"),e.challengeName="CUSTOM_CHALLENGE",e.challengeParam=n,t(e)},mfaRequired:function(n,r){De.debug("signIn MFA required"),e.challengeName=n,e.challengeParam=r,t(e)},mfaSetup:function(n,r){De.debug("signIn mfa setup",n),e.challengeName=n,e.challengeParam=r,t(e)},newPasswordRequired:function(n,r){De.debug("signIn new password"),e.challengeName="NEW_PASSWORD_REQUIRED",e.challengeParam={userAttributes:n,requiredAttributes:r},t(e)},totpRequired:function(n,r){De.debug("signIn totpRequired"),e.challengeName=n,e.challengeParam=r,t(e)},selectMFAType:function(n,r){De.debug("signIn selectMFAType",n),e.challengeName=n,e.challengeParam=r,t(e)}}},e.prototype.signInWithPassword=function(e){var t=this,n=this.createCognitoUser(e.getUsername());return new Promise((function(r,i){n.authenticateUser(e,t.authCallbacks(n,r,i))}))},e.prototype.signInWithoutPassword=function(e){var t=this,n=this.createCognitoUser(e.getUsername());return n.setAuthenticationFlowType("CUSTOM_AUTH"),new Promise((function(r,i){n.initiateAuth(e,t.authCallbacks(n,r,i))}))},e.prototype.getMFAOptions=function(e){return new Promise((function(t,n){e.getMFAOptions((function(e,r){if(e)return De.debug("get MFA Options failed",e),void n(e);De.debug("get MFA options success",r),t(r)}))}))},e.prototype.getPreferredMFA=function(e,t){var n=this;return new Promise((function(r,i){var o=!!t&&t.bypassCache;e.getUserData((function(e,t){if(e)return De.debug("getting preferred mfa failed",e),void i(e);var o=n._getMfaTypeFromUserData(t);return o?void r(o):void i("invalid MFA Type")}),{bypassCache:o})}))},e.prototype._getMfaTypeFromUserData=function(e){var t=null,n=e.PreferredMfaSetting;if(n)t=n;else{var r=e.UserMFASettingList;if(r)0===r.length?t="NOMFA":De.debug("invalid case for getPreferredMFA",e);else t=e.MFAOptions?"SMS_MFA":"NOMFA"}return t},e.prototype._getUserData=function(e,t){return new Promise((function(n,r){e.getUserData((function(e,t){return e?(De.debug("getting user data failed",e),void r(e)):void n(t)}),t)}))},e.prototype.setPreferredMFA=function(e,t){return _e(this,void 0,void 0,(function(){var n,r,o,s,a;return Pe(this,(function(u){switch(u.label){case 0:return[4,this._getUserData(e,{bypassCache:!0})];case 1:switch(n=u.sent(),r=null,o=null,t){case"TOTP":return[3,2];case"SMS":return[3,3];case"NOMFA":return[3,4]}return[3,6];case 2:return o={PreferredMfa:!0,Enabled:!0},[3,7];case 3:return r={PreferredMfa:!0,Enabled:!0},[3,7];case 4:return s=n.UserMFASettingList,[4,this._getMfaTypeFromUserData(n)];case 5:if("NOMFA"===(a=u.sent()))return[2,Promise.resolve("No change for mfa type")];if("SMS_MFA"===a)r={PreferredMfa:!1,Enabled:!1};else{if("SOFTWARE_TOKEN_MFA"!==a)return[2,this.rejectAuthError(i.InvalidMFA)];o={PreferredMfa:!1,Enabled:!1}}return s&&0!==s.length&&s.forEach((function(e){"SMS_MFA"===e?r={PreferredMfa:!1,Enabled:!1}:"SOFTWARE_TOKEN_MFA"===e&&(o={PreferredMfa:!1,Enabled:!1})})),[3,7];case 6:return De.debug("no validmfa method provided"),[2,this.rejectAuthError(i.NoMFA)];case 7:return this,[2,new Promise((function(t,n){e.setUserMfaPreference(r,o,(function(r,i){if(r)return De.debug("Set user mfa preference error",r),n(r);De.debug("Set user mfa success",i),De.debug("Caching the latest user data into local"),e.getUserData((function(e,r){return e?(De.debug("getting user data failed",e),n(e)):t(i)}),{bypassCache:!0})}))}))]}}))}))},e.prototype.disableSMS=function(e){return new Promise((function(t,n){e.disableMFA((function(e,r){if(e)return De.debug("disable mfa failed",e),void n(e);De.debug("disable mfa succeed",r),t(r)}))}))},e.prototype.enableSMS=function(e){return new Promise((function(t,n){e.enableMFA((function(e,r){if(e)return De.debug("enable mfa failed",e),void n(e);De.debug("enable mfa succeed",r),t(r)}))}))},e.prototype.setupTOTP=function(e){return new Promise((function(t,n){e.associateSoftwareToken({onFailure:function(e){De.debug("associateSoftwareToken failed",e),n(e)},associateSecretCode:function(e){De.debug("associateSoftwareToken sucess",e),t(e)}})}))},e.prototype.verifyTotpToken=function(e,t){return De.debug("verfication totp token",e,t),new Promise((function(n,r){e.verifySoftwareToken(t,"My TOTP device",{onFailure:function(e){De.debug("verifyTotpToken failed",e),r(e)},onSuccess:function(e){De.debug("verifyTotpToken success",e),n(e)}})}))},e.prototype.confirmSignIn=function(e,t,n,r){var o=this;if(void 0===r&&(r=this._config.clientMetadata),!t)return this.rejectAuthError(i.EmptyCode);var s=this;return new Promise((function(i,u){e.sendMFACode(t,{onSuccess:function(t){return _e(o,void 0,void 0,(function(){var n,r;return Pe(this,(function(o){switch(o.label){case 0:De.debug(t),o.label=1;case 1:return o.trys.push([1,4,5,6]),[4,a.Credentials.clear()];case 2:return o.sent(),[4,a.Credentials.set(t,"session")];case 3:return n=o.sent(),De.debug("succeed to get cognito credentials",n),[3,6];case 4:return r=o.sent(),De.debug("cannot get cognito credentials",r),[3,6];case 5:return s.user=e,ke("signIn",e,e+" has signed in"),i(e),[7];case 6:return[2]}}))}))},onFailure:function(e){De.debug("confirm signIn failure",e),u(e)}},n,r)}))},e.prototype.completeNewPassword=function(e,t,n,r){var o=this;if(void 0===r&&(r=this._config.clientMetadata),!t)return this.rejectAuthError(i.EmptyPassword);var s=this;return new Promise((function(i,u){e.completeNewPasswordChallenge(t,n,{onSuccess:function(t){return _e(o,void 0,void 0,(function(){var n,r;return Pe(this,(function(o){switch(o.label){case 0:De.debug(t),o.label=1;case 1:return o.trys.push([1,4,5,6]),[4,a.Credentials.clear()];case 2:return o.sent(),[4,a.Credentials.set(t,"session")];case 3:return n=o.sent(),De.debug("succeed to get cognito credentials",n),[3,6];case 4:return r=o.sent(),De.debug("cannot get cognito credentials",r),[3,6];case 5:return s.user=e,ke("signIn",e,e+" has signed in"),i(e),[7];case 6:return[2]}}))}))},onFailure:function(e){De.debug("completeNewPassword failure",e),ke("completeNewPassword_failure",e,o.user+" failed to complete the new password flow"),u(e)},mfaRequired:function(t,n){De.debug("signIn MFA required"),e.challengeName=t,e.challengeParam=n,i(e)},mfaSetup:function(t,n){De.debug("signIn mfa setup",t),e.challengeName=t,e.challengeParam=n,i(e)}},r)}))},e.prototype.sendCustomChallengeAnswer=function(e,t,n){var r=this;if(void 0===n&&(n=this._config.clientMetadata),!this.userPool)return this.rejectNoUserPool();if(!t)return this.rejectAuthError(i.EmptyChallengeResponse);return new Promise((function(i,o){e.sendCustomChallengeAnswer(t,r.authCallbacks(e,i,o),n)}))},e.prototype.updateUserAttributes=function(e,t,n){void 0===n&&(n=this._config.clientMetadata);var r=[],i=this;return new Promise((function(o,s){i.userSession(e).then((function(i){for(var a in t)if("sub"!==a&&a.indexOf("_verified")<0){var u={Name:a,Value:t[a]};r.push(u)}e.updateAttributes(r,(function(e,t){return e?s(e):o(t)}),n)}))}))},e.prototype.userAttributes=function(e){var t=this;return new Promise((function(n,r){t.userSession(e).then((function(t){e.getUserAttributes((function(e,t){e?r(e):n(t)}))}))}))},e.prototype.verifiedContact=function(e){var t=this;return this.userAttributes(e).then((function(e){var n=t.attributesToObject(e),r={},i={};return n.email&&(n.email_verified?i.email=n.email:r.email=n.email),n.phone_number&&(n.phone_number_verified?i.phone_number=n.phone_number:r.phone_number=n.phone_number),{verified:i,unverified:r}}))},e.prototype.currentUserPoolUser=function(e){var t=this;if(!this.userPool)return this.rejectNoUserPool();var n=this;return new Promise((function(r,i){t._storageSync.then((function(){var t=n.userPool.getCurrentUser();if(!t)return De.debug("Failed to get user from user pool"),void i("No current user");t.getSession((function(o,s){if(o)return De.debug("Failed to get the user session",o),void i(o);var a=!!e&&e.bypassCache,u=s.getAccessToken().decodePayload().scope;if(!(void 0===u?"":u).split(" ").includes("aws.cognito.signin.user.admin"))return De.debug("Unable to get the user data because the aws.cognito.signin.user.admin is not in the scopes of the access token"),r(t);t.getUserData((function(e,o){if(e)return De.debug("getting user data failed",e),void("User is disabled"===e.message||"User does not exist."===e.message?i(e):r(t));for(var s=o.PreferredMfaSetting||"NOMFA",a=[],u=0;u<o.UserAttributes.length;u++){var c={Name:o.UserAttributes[u].Name,Value:o.UserAttributes[u].Value},h=new X(c);a.push(h)}var f=n.attributesToObject(a);return Object.assign(t,{attributes:f,preferredMFA:s}),r(t)}),{bypassCache:a})}))})).catch((function(e){return De.debug("Failed to sync cache info into memory",e),i(e)}))}))},e.prototype.currentAuthenticatedUser=function(e){return _e(this,void 0,void 0,(function(){var t,n,r,i;return Pe(this,(function(o){switch(o.label){case 0:De.debug("getting current authenticated user"),t=null,o.label=1;case 1:return o.trys.push([1,3,,4]),[4,this._storageSync];case 2:return o.sent(),[3,4];case 3:throw n=o.sent(),De.debug("Failed to sync cache info into memory",n),n;case 4:try{t=JSON.parse(this._storage.getItem("aws-amplify-federatedInfo")).user}catch(e){De.debug("cannot load federated user from auth storage")}return t?(this.user=t,De.debug("get current authenticated federated user",this.user),[2,this.user]):[3,5];case 5:De.debug("get current authenticated userpool user"),r=null,o.label=6;case 6:return o.trys.push([6,8,,9]),[4,this.currentUserPoolUser(e)];case 7:return r=o.sent(),[3,9];case 8:throw"No userPool"===(i=o.sent())&&De.error("Cannot get the current user because the user pool is missing. Please make sure the Auth module is configured with a valid Cognito User Pool ID"),De.debug("The user is not authenticated by the error",i),"not authenticated";case 9:return this.user=r,[2,this.user]}}))}))},e.prototype.currentSession=function(){var e=this;return De.debug("Getting current session"),this.userPool?new Promise((function(t,n){e.currentUserPoolUser().then((function(r){e.userSession(r).then((function(e){t(e)})).catch((function(e){De.debug("Failed to get the current session",e),n(e)}))})).catch((function(e){De.debug("Failed to get the current user",e),n(e)}))})):Promise.reject()},e.prototype.userSession=function(e){return e?new Promise((function(t,n){De.debug("Getting the session from this user:",e),e.getSession((function(r,i){return r?(De.debug("Failed to get the session from user",e),void n(r)):(De.debug("Succeed to get the user session",i),void t(i))}))})):(De.debug("the user is null"),this.rejectAuthError(i.NoUserSession))},e.prototype.currentUserCredentials=function(){return _e(this,void 0,void 0,(function(){var e,t;return Pe(this,(function(n){switch(n.label){case 0:this,De.debug("Getting current user credentials"),n.label=1;case 1:return n.trys.push([1,3,,4]),[4,this._storageSync];case 2:return n.sent(),[3,4];case 3:throw e=n.sent(),De.debug("Failed to sync cache info into memory",e),e;case 4:t=null;try{t=JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"))}catch(e){De.debug("failed to get or parse item aws-amplify-federatedInfo",e)}return t?[2,a.Credentials.refreshFederatedToken(t)]:[2,this.currentSession().then((function(e){return De.debug("getting session success",e),a.Credentials.set(e,"session")})).catch((function(e){return De.debug("getting session failed",e),a.Credentials.set(null,"guest")}))]}}))}))},e.prototype.currentCredentials=function(){return De.debug("getting current credntials"),a.Credentials.get()},e.prototype.verifyUserAttribute=function(e,t,n){return void 0===n&&(n=this._config.clientMetadata),new Promise((function(r,i){e.getAttributeVerificationCode(t,{onSuccess:function(){return r()},onFailure:function(e){return i(e)},clientMetadata:n})}))},e.prototype.verifyUserAttributeSubmit=function(e,t,n){return n?new Promise((function(r,i){e.verifyAttribute(t,n,{onSuccess:function(e){r(e)},onFailure:function(e){i(e)}})})):this.rejectAuthError(i.EmptyCode)},e.prototype.verifyCurrentUserAttribute=function(e){var t=this;return t.currentUserPoolUser().then((function(n){return t.verifyUserAttribute(n,e)}))},e.prototype.verifyCurrentUserAttributeSubmit=function(e,t){var n=this;return n.currentUserPoolUser().then((function(r){return n.verifyUserAttributeSubmit(r,e,t)}))},e.prototype.cognitoIdentitySignOut=function(e,t){return _e(this,void 0,void 0,(function(){var n,r,i=this;return Pe(this,(function(o){switch(o.label){case 0:return o.trys.push([0,2,,3]),[4,this._storageSync];case 1:return o.sent(),[3,3];case 2:throw n=o.sent(),De.debug("Failed to sync cache info into memory",n),n;case 3:return r=this._oAuthHandler&&"true"===this._storage.getItem("amplify-signin-with-hostedUI"),[2,new Promise((function(n,o){if(!e||!e.global)return De.debug("user sign out",t),t.signOut(),r?n(i._oAuthHandler.signOut()):n();De.debug("user global sign out",t),t.getSession((function(e,s){if(e)return De.debug("failed to get the user session",e),o(e);t.globalSignOut({onSuccess:function(e){return De.debug("global sign out success"),r?n(i._oAuthHandler.signOut()):n()},onFailure:function(e){return De.debug("global sign out failed",e),o(e)}})}))}))]}}))}))},e.prototype.signOut=function(e){return _e(this,void 0,void 0,(function(){var t;return Pe(this,(function(n){switch(n.label){case 0:return n.trys.push([0,2,,3]),[4,this.cleanCachedItems()];case 1:return n.sent(),[3,3];case 2:return n.sent(),De.debug("failed to clear cached items"),[3,3];case 3:return this.userPool?(t=this.userPool.getCurrentUser())?[4,this.cognitoIdentitySignOut(e,t)]:[3,5]:[3,7];case 4:return n.sent(),[3,6];case 5:De.debug("no current Cognito user"),n.label=6;case 6:return[3,8];case 7:De.debug("no Congito User pool"),n.label=8;case 8:return ke("signOut",this.user,"A user has been signed out"),this.user=null,[2]}}))}))},e.prototype.cleanCachedItems=function(){return _e(this,void 0,void 0,(function(){return Pe(this,(function(e){switch(e.label){case 0:return[4,a.Credentials.clear()];case 1:return e.sent(),[2]}}))}))},e.prototype.changePassword=function(e,t,n,r){var i=this;return void 0===r&&(r=this._config.clientMetadata),new Promise((function(o,s){i.userSession(e).then((function(i){e.changePassword(t,n,(function(e,t){return e?(De.debug("change password failure",e),s(e)):o(t)}),r)}))}))},e.prototype.forgotPassword=function(e,t){if(void 0===t&&(t=this._config.clientMetadata),!this.userPool)return this.rejectNoUserPool();if(!e)return this.rejectAuthError(i.EmptyUsername);var n=this.createCognitoUser(e);return new Promise((function(r,i){n.forgotPassword({onSuccess:function(){r()},onFailure:function(t){De.debug("forgot password failure",t),ke("forgotPassword_failure",t,e+" forgotPassword failed"),i(t)},inputVerificationCode:function(t){ke("forgotPassword",n,e+" has initiated forgot password flow"),r(t)}},t)}))},e.prototype.forgotPasswordSubmit=function(e,t,n,r){if(void 0===r&&(r=this._config.clientMetadata),!this.userPool)return this.rejectNoUserPool();if(!e)return this.rejectAuthError(i.EmptyUsername);if(!t)return this.rejectAuthError(i.EmptyCode);if(!n)return this.rejectAuthError(i.EmptyPassword);var o=this.createCognitoUser(e);return new Promise((function(i,s){o.confirmPassword(t,n,{onSuccess:function(){ke("forgotPasswordSubmit",o,e+" forgotPasswordSubmit successful"),i()},onFailure:function(t){ke("forgotPasswordSubmit_failure",t,e+" forgotPasswordSubmit failed"),s(t)}},r)}))},e.prototype.currentUserInfo=function(){return _e(this,void 0,void 0,(function(){var e,t,n,r,i,o,s;return Pe(this,(function(u){switch(u.label){case 0:return(e=a.Credentials.getCredSource())&&"aws"!==e&&"userPool"!==e?[3,9]:[4,this.currentUserPoolUser().catch((function(e){return De.debug(e)}))];case 1:if(!(s=u.sent()))return[2,null];u.label=2;case 2:return u.trys.push([2,8,,9]),[4,this.userAttributes(s)];case 3:t=u.sent(),n=this.attributesToObject(t),r=null,u.label=4;case 4:return u.trys.push([4,6,,7]),[4,this.currentCredentials()];case 5:return r=u.sent(),[3,7];case 6:return i=u.sent(),De.debug("Failed to retrieve credentials while getting current user info",i),[3,7];case 7:return[2,{id:r?r.identityId:void 0,username:s.getUsername(),attributes:n}];case 8:return o=u.sent(),De.debug("currentUserInfo error",o),[2,{}];case 9:return"federated"===e?[2,(s=this.user)||{}]:[2]}}))}))},e.prototype.federatedSignIn=function(e,t,n){return _e(this,void 0,void 0,(function(){var r,i,u,c,h,f,l,p,d,g,y;return Pe(this,(function(m){switch(m.label){case 0:if(!this._config.identityPoolId&&!this._config.userPoolId)throw new Error("Federation requires either a User Pool or Identity Pool in config");if(void 0===e&&this._config.identityPoolId&&!this._config.userPoolId)throw new Error("Federation with Identity Pools requires tokens passed as arguments");return o(e)||(v=e)&&["customProvider","customState"].find((function(e){return v.hasOwnProperty(e)}))||void 0===e?(r=e||{provider:Te.Cognito},h=o(r)?r.provider:r.customProvider,o(r),i=r.customState,this._config.userPoolId&&(u=s(this._config.oauth)?this._config.userPoolWebClientId:this._config.oauth.clientID,c=s(this._config.oauth)?this._config.oauth.redirectSignIn:this._config.oauth.redirectUri,this._oAuthHandler.oauthSignIn(this._config.oauth.responseType,this._config.oauth.domain,c,u,h,i)),[3,4]):[3,1];case 1:h=e;try{(f=JSON.stringify(JSON.parse(this._storage.getItem("aws-amplify-federatedInfo")).user))&&De.warn("There is already a signed in user: "+f+" in your app.\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tYou should not call Auth.federatedSignIn method again as it may cause unexpected behavior.")}catch(e){}return l=t.token,p=t.identity_id,d=t.expires_at,[4,a.Credentials.set({provider:h,token:l,identity_id:p,user:n,expires_at:d},"federation")];case 2:return g=m.sent(),[4,this.currentAuthenticatedUser()];case 3:return y=m.sent(),ke("signIn",y,"A user "+y.username+" has been signed in"),De.debug("federated sign in credentials",g),[2,g];case 4:return[2]}var v}))}))},e.prototype._handleAuthResponse=function(e){return _e(this,void 0,void 0,(function(){var t,n,r,i,o,s,u,c,h,f,l,p,d,g,y;return Pe(this,(function(m){switch(m.label){case 0:if(!this._config.userPoolId)throw new Error("OAuth responses require a User Pool defined in config");if(ke("parsingCallbackUrl",{url:e},"The callback url is being parsed"),t=e||(a.JS.browserOrNode().isBrowser?window.location.href:""),n=!!(Object(he.parse)(t).query||"").split("&").map((function(e){return e.split("=")})).find((function(e){var t=e[0];return"code"===t||"error"===t})),r=!!(Object(he.parse)(t).hash||"#").substr(1).split("&").map((function(e){return e.split("=")})).find((function(e){var t=e[0];return"access_token"===t||"error"===t})),!n&&!r)return[3,6];m.label=1;case 1:return m.trys.push([1,5,,6]),[4,this._oAuthHandler.handleAuthResponse(t)];case 2:return i=m.sent(),o=i.accessToken,s=i.idToken,u=i.refreshToken,c=i.state,h=new Y({IdToken:new V({IdToken:s}),RefreshToken:new q({RefreshToken:u}),AccessToken:new x({AccessToken:o})}),f=void 0,this._config.identityPoolId?[4,a.Credentials.set(h,"session")]:[3,4];case 3:f=m.sent(),De.debug("AWS credentials",f),m.label=4;case 4:return l=/-/.test(c),p=this.createCognitoUser(h.getIdToken().decodePayload()["cognito:username"]),ke("signIn",p,"A user "+p.getUsername()+" has been signed in"),ke("cognitoHostedUI",p,"A user "+p.getUsername()+" has been signed in via Cognito Hosted UI"),l&&(d=c.split("-"),g=d[1],ke("customOAuthState",g,"State for user "+p.getUsername())),p.setSignInUserSession(h),window&&void 0!==window.history&&window.history.replaceState({},null,this._config.oauth.redirectSignIn),[2,f];case 5:throw y=m.sent(),De.debug("Error in cognito hosted auth response",y),ke("signIn_failure",y,"The OAuth response flow failed"),ke("cognitoHostedUI_failure",y,"A failure occurred when returning to the Cognito Hosted UI"),ke("customState_failure",y,"A failure occurred when returning state"),y;case 6:return[2]}}))}))},e.prototype.essentialCredentials=function(e){return{accessKeyId:e.accessKeyId,sessionToken:e.sessionToken,secretAccessKey:e.secretAccessKey,identityId:e.identityId,authenticated:e.authenticated}},e.prototype.attributesToObject=function(e){var t={};return e&&e.map((function(e){"true"===e.Value?t[e.Name]=!0:"false"===e.Value?t[e.Name]=!1:t[e.Name]=e.Value})),t},e.prototype.createCognitoUser=function(e){var t={Username:e,Pool:this.userPool};t.Storage=this._storage;var n=this._config.authenticationFlowType,r=new ne(t);return n&&r.setAuthenticationFlowType(n),r},e.prototype._isValidAuthStorage=function(e){return!!e&&"function"==typeof e.getItem&&"function"==typeof e.setItem&&"function"==typeof e.removeItem&&"function"==typeof e.clear},e.prototype.noUserPoolErrorHandler=function(e){return!e||e.userPoolId&&e.identityPoolId?i.NoConfig:i.MissingAuthConfig},e.prototype.rejectAuthError=function(e){return Promise.reject(new Ce(e))},e.prototype.rejectNoUserPool=function(){var e=this.noUserPoolErrorHandler(this._config);return Promise.reject(new Ue(e))},e}();n.d(t,"AuthClass",(function(){return Fe})),n.d(t,"CognitoUser",(function(){return ne})),n.d(t,"CookieStorage",(function(){return ce})),n.d(t,"CognitoHostedUIIdentityProvider",(function(){return Te}));var Oe=new a.ConsoleLogger("Auth"),Me=null;Me||(Oe.debug("Create Auth Instance"),Me=new Fe(null));var xe=Me;u.a.register(xe);t.default=xe}])}));
	//# sourceMappingURL=aws-amplify-auth.min.js.map

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(26)):"function"==typeof define&&define.amd?define("aws_amplify_cache",["@aws-amplify/core"],t):"object"==typeof exports?exports.aws_amplify_cache=t(require("@aws-amplify/core")):e.aws_amplify_cache=t(e["@aws-amplify/core"])}(this,(function(e){return function(e){var t={};function i(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,i),o.l=!0,o.exports}return i.m=e,i.c=t,i.d=function(e,t,r){i.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},i.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},i.t=function(e,t){if(1&t&&(e=i(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(i.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)i.d(r,o,function(t){return e[t]}.bind(null,o));return r},i.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return i.d(t,"a",t),t},i.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},i.p="",i(i.s=1)}([function(t,i){t.exports=e},function(e,t,i){"use strict";i.r(t);var r=i(0),o=i.n(r),n={keyPrefix:"aws-amplify-cache",capacityInBytes:1048576,itemMaxSize:21e4,defaultTTL:2592e5,defaultPriority:5,warningThreshold:.8,storage:(new r.StorageHelper).getStorage()};function s(e){var t=0;t=e.length;for(var i=e.length;i>=0;i-=1){var r=e.charCodeAt(i);r>127&&r<=2047?t+=1:r>2047&&r<=65535&&(t+=2),r>=56320&&r<=57343&&(i-=1)}return t}function a(){return(new Date).getTime()}function c(e){return Number.isInteger?Number.isInteger(e):function(e){return"number"==typeof e&&isFinite(e)&&Math.floor(e)===e}(e)}var h={},f=function(){function e(){}return e.clear=function(){h={}},e.getItem=function(e){return h[e]||null},e.setItem=function(e,t){h[e]=t},e.removeItem=function(e){delete h[e]},e}(),u=function(e){this.key=e||"",this.prevNode=null,this.nextNode=null},y=function(){function e(){this.head=new u,this.tail=new u,this.hashtable={},this.length=0,this.head.nextNode=this.tail,this.tail.prevNode=this.head}return e.prototype.insertNodeToHead=function(e){var t=this.head.nextNode;this.head.nextNode=e,e.nextNode=t,e.prevNode=this.head,t.prevNode=e,this.length=this.length+1},e.prototype.removeNode=function(e){e.prevNode.nextNode=e.nextNode,e.nextNode.prevNode=e.prevNode,e.prevNode=null,e.nextNode=null,this.length=this.length-1},e.prototype.isEmpty=function(){return 0===this.length},e.prototype.refresh=function(e){var t=this.hashtable[e];this.removeNode(t),this.insertNodeToHead(t)},e.prototype.insertItem=function(e){var t=new u(e);this.hashtable[e]=t,this.insertNodeToHead(t)},e.prototype.getLastItem=function(){return this.tail.prevNode.key},e.prototype.removeItem=function(e){var t=this.hashtable[e];this.removeNode(t),delete this.hashtable[e]},e.prototype.getSize=function(){return this.length},e.prototype.containsKey=function(e){return e in this.hashtable},e.prototype.clearList=function(){for(var e=0,t=Object.keys(this.hashtable);e<t.length;e++){var i=t[e];this.hashtable.hasOwnProperty(i)&&delete this.hashtable[i]}this.head.nextNode=this.tail,this.tail.prevNode=this.head,this.length=0},e.prototype.getKeys=function(){return Object.keys(this.hashtable)},e.prototype.isHeadNode=function(e){return this.hashtable[e].prevNode===this.head},e.prototype.isTailNode=function(e){return this.hashtable[e].nextNode===this.tail},e}();function p(e){return(p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var l,g=new r.ConsoleLogger("StorageCache"),d=function(){function e(e){this.config=Object.assign({},e),this.cacheCurSizeKey=this.config.keyPrefix+"CurSize",this.checkConfig()}return e.prototype.getModuleName=function(){return"Cache"},e.prototype.checkConfig=function(){c(this.config.capacityInBytes)||(g.error("Invalid parameter: capacityInBytes. It should be an Integer. Setting back to default."),this.config.capacityInBytes=n.capacityInBytes),c(this.config.itemMaxSize)||(g.error("Invalid parameter: itemMaxSize. It should be an Integer. Setting back to default."),this.config.itemMaxSize=n.itemMaxSize),c(this.config.defaultTTL)||(g.error("Invalid parameter: defaultTTL. It should be an Integer. Setting back to default."),this.config.defaultTTL=n.defaultTTL),c(this.config.defaultPriority)||(g.error("Invalid parameter: defaultPriority. It should be an Integer. Setting back to default."),this.config.defaultPriority=n.defaultPriority),this.config.itemMaxSize>this.config.capacityInBytes&&(g.error("Invalid parameter: itemMaxSize. It should be smaller than capacityInBytes. Setting back to default."),this.config.itemMaxSize=n.itemMaxSize),(this.config.defaultPriority>5||this.config.defaultPriority<1)&&(g.error("Invalid parameter: defaultPriority. It should be between 1 and 5. Setting back to default."),this.config.defaultPriority=n.defaultPriority),(Number(this.config.warningThreshold)>1||Number(this.config.warningThreshold)<0)&&(g.error("Invalid parameter: warningThreshold. It should be between 0 and 1. Setting back to default."),this.config.warningThreshold=n.warningThreshold);this.config.capacityInBytes>5242880&&(g.error("Cache Capacity should be less than 5MB. Setting back to default. Setting back to default."),this.config.capacityInBytes=n.capacityInBytes)},e.prototype.fillCacheItem=function(e,t,i){var r={key:e,data:t,timestamp:a(),visitedTime:a(),priority:i.priority,expires:i.expires,type:p(t),byteSize:0};return r.byteSize=s(JSON.stringify(r)),r.byteSize=s(JSON.stringify(r)),r},e.prototype.configure=function(e){return e?(e.keyPrefix&&g.warn("Don't try to configure keyPrefix!"),this.config=Object.assign({},this.config,e,e.Cache),this.checkConfig(),this.config):this.config},e}(),m=(l=function(e,t){return(l=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(e,t)},function(e,t){function i(){this.constructor=e}l(e,t),e.prototype=null===t?Object.create(t):(i.prototype=t.prototype,new i)}),v=new r.ConsoleLogger("Cache"),I=new(function(e){function t(t){var i=this,r=t?Object.assign({},n,t):n;return(i=e.call(this,r)||this).config.storage=r.storage,i.getItem=i.getItem.bind(i),i.setItem=i.setItem.bind(i),i.removeItem=i.removeItem.bind(i),i}return m(t,e),t.prototype._decreaseCurSizeInBytes=function(e){var t=this.getCacheCurSize();this.config.storage.setItem(this.cacheCurSizeKey,(t-e).toString())},t.prototype._increaseCurSizeInBytes=function(e){var t=this.getCacheCurSize();this.config.storage.setItem(this.cacheCurSizeKey,(t+e).toString())},t.prototype._refreshItem=function(e,t){return e.visitedTime=a(),this.config.storage.setItem(t,JSON.stringify(e)),e},t.prototype._isExpired=function(e){var t=this.config.storage.getItem(e),i=JSON.parse(t);return a()>=i.expires},t.prototype._removeItem=function(e,t){var i=t||JSON.parse(this.config.storage.getItem(e)).byteSize;this._decreaseCurSizeInBytes(i),this.config.storage.removeItem(e)},t.prototype._setItem=function(e,t){this._increaseCurSizeInBytes(t.byteSize);try{this.config.storage.setItem(e,JSON.stringify(t))}catch(e){this._decreaseCurSizeInBytes(t.byteSize),v.error("Failed to set item "+e)}},t.prototype._sizeToPop=function(e){var t=this.getCacheCurSize()+e-this.config.capacityInBytes,i=(1-this.config.warningThreshold)*this.config.capacityInBytes;return t>i?t:i},t.prototype._isCacheFull=function(e){return e+this.getCacheCurSize()>this.config.capacityInBytes},t.prototype._findValidKeys=function(){for(var e=[],t=[],i=0;i<this.config.storage.length;i+=1)t.push(this.config.storage.key(i));for(i=0;i<t.length;i+=1){var r=t[i];0===r.indexOf(this.config.keyPrefix)&&r!==this.cacheCurSizeKey&&(this._isExpired(r)?this._removeItem(r):e.push(r))}return e},t.prototype._popOutItems=function(e,t){for(var i=[],r=t,o=0;o<e.length;o+=1){var n=this.config.storage.getItem(e[o]);if(null!=n){var s=JSON.parse(n);i.push(s)}}i.sort((function(e,t){return e.priority>t.priority?-1:e.priority<t.priority?1:e.visitedTime<t.visitedTime?-1:1}));for(o=0;o<i.length;o+=1)if(this._removeItem(i[o].key,i[o].byteSize),(r-=i[o].byteSize)<=0)return},t.prototype.setItem=function(e,t,i){v.log("Set item: key is "+e+", value is "+t+" with options: "+i);var r=this.config.keyPrefix+e;if(r!==this.config.keyPrefix&&r!==this.cacheCurSizeKey)if(void 0!==t){var o={priority:i&&void 0!==i.priority?i.priority:this.config.defaultPriority,expires:i&&void 0!==i.expires?i.expires:this.config.defaultTTL+a()};if(o.priority<1||o.priority>5)v.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");else{var n=this.fillCacheItem(r,t,o);if(n.byteSize>this.config.itemMaxSize)v.warn("Item with key: "+e+" you are trying to put into is too big!");else try{var s=this.config.storage.getItem(r);if(s&&this._removeItem(r,JSON.parse(s).byteSize),this._isCacheFull(n.byteSize)){var c=this._findValidKeys();if(this._isCacheFull(n.byteSize)){var h=this._sizeToPop(n.byteSize);this._popOutItems(c,h)}}this._setItem(r,n)}catch(e){v.warn("setItem failed! "+e)}}}else v.warn("The value of item should not be undefined!");else v.warn("Invalid key: should not be empty or 'CurSize'")},t.prototype.getItem=function(e,t){v.log("Get item: key is "+e+" with options "+t);var i=null,r=this.config.keyPrefix+e;if(r===this.config.keyPrefix||r===this.cacheCurSizeKey)return v.warn("Invalid key: should not be empty or 'CurSize'"),null;try{if(null!=(i=this.config.storage.getItem(r))){if(!this._isExpired(r)){var o=JSON.parse(i);return(o=this._refreshItem(o,r)).data}this._removeItem(r,JSON.parse(i).byteSize),i=null}if(t&&void 0!==t.callback){var n=t.callback();return null!==n&&this.setItem(e,n,t),n}return null}catch(e){return v.warn("getItem failed! "+e),null}},t.prototype.removeItem=function(e){v.log("Remove item: key is "+e);var t=this.config.keyPrefix+e;if(t!==this.config.keyPrefix&&t!==this.cacheCurSizeKey)try{var i=this.config.storage.getItem(t);i&&this._removeItem(t,JSON.parse(i).byteSize)}catch(e){v.warn("removeItem failed! "+e)}},t.prototype.clear=function(){v.log("Clear Cache");for(var e=[],t=0;t<this.config.storage.length;t+=1){var i=this.config.storage.key(t);0===i.indexOf(this.config.keyPrefix)&&e.push(i)}try{for(t=0;t<e.length;t+=1)this.config.storage.removeItem(e[t])}catch(e){v.warn("clear failed! "+e)}},t.prototype.getAllKeys=function(){for(var e=[],t=0;t<this.config.storage.length;t+=1){var i=this.config.storage.key(t);0===i.indexOf(this.config.keyPrefix)&&i!==this.cacheCurSizeKey&&e.push(i.substring(this.config.keyPrefix.length))}return e},t.prototype.getCacheCurSize=function(){var e=this.config.storage.getItem(this.cacheCurSizeKey);return e||(this.config.storage.setItem(this.cacheCurSizeKey,"0"),e="0"),Number(e)},t.prototype.createInstance=function(e){return e.keyPrefix&&e.keyPrefix!==n.keyPrefix||(v.error("invalid keyPrefix, setting keyPrefix with timeStamp"),e.keyPrefix=a.toString()),new t(e)},t}(d)),b=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),S=new r.ConsoleLogger("InMemoryCache"),x=new(function(e){function t(t){var i=this,r=t?Object.assign({},n,t):n;i=e.call(this,r)||this,S.debug("now we start!"),i.cacheList=[],i.curSizeInBytes=0,i.maxPriority=5,i.getItem=i.getItem.bind(i),i.setItem=i.setItem.bind(i),i.removeItem=i.removeItem.bind(i);for(var o=0;o<i.maxPriority;o+=1)i.cacheList[o]=new y;return i}return b(t,e),t.prototype._decreaseCurSizeInBytes=function(e){this.curSizeInBytes-=e},t.prototype._increaseCurSizeInBytes=function(e){this.curSizeInBytes+=e},t.prototype._isExpired=function(e){var t=f.getItem(e),i=JSON.parse(t);return a()>=i.expires},t.prototype._removeItem=function(e,t){this.cacheList[t].removeItem(e),this._decreaseCurSizeInBytes(JSON.parse(f.getItem(e)).byteSize),f.removeItem(e)},t.prototype._setItem=function(e,t,i){this.cacheList[i].insertItem(e),this._increaseCurSizeInBytes(t.byteSize),f.setItem(e,JSON.stringify(t))},t.prototype._isCacheFull=function(e){return this.curSizeInBytes+e>this.config.capacityInBytes},t.prototype.containsKey=function(e){for(var t=this.config.keyPrefix+e,i=0;i<this.maxPriority;i+=1)if(this.cacheList[i].containsKey(t))return i+1;return-1},t.prototype.setItem=function(e,t,i){var r=this.config.keyPrefix+e;if(r!==this.config.keyPrefix&&r!==this.cacheCurSizeKey)if(void 0!==t){var o={priority:i&&void 0!==i.priority?i.priority:this.config.defaultPriority,expires:i&&void 0!==i.expires?i.expires:this.config.defaultTTL+a()};if(o.priority<1||o.priority>5)S.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");else{var n=this.fillCacheItem(r,t,o);if(n.byteSize>this.config.itemMaxSize)S.warn("Item with key: "+e+" you are trying to put into is too big!");else{var s=this.containsKey(e);-1!==s&&this._removeItem(r,s-1);for(var c=this.maxPriority-1;this._isCacheFull(n.byteSize)&&c>=0;)if(this.cacheList[c].isEmpty())c-=1;else{var h=this.cacheList[c].getLastItem();this._removeItem(h,c)}this._setItem(r,n,Number(n.priority)-1)}}}else S.warn("The value of item should not be undefined!");else S.warn("Invalid key: should not be empty or 'CurSize'")},t.prototype.getItem=function(e,t){var i=null,r=this.config.keyPrefix+e;if(r===this.config.keyPrefix||r===this.cacheCurSizeKey)return S.warn("Invalid key: should not be empty or 'CurSize'"),null;var o=this.containsKey(e);if(-1!==o){if(!this._isExpired(r)){i=f.getItem(r);var n=JSON.parse(i);return this.cacheList[n.priority-1].refresh(r),n.data}this._removeItem(r,o-1)}if(t&&void 0!==t.callback){var s=t.callback();return null!==s&&this.setItem(e,s,t),s}return null},t.prototype.removeItem=function(e){var t=this.config.keyPrefix+e,i=this.containsKey(e);-1!==i&&this._removeItem(t,i-1)},t.prototype.clear=function(){for(var e=0;e<this.maxPriority;e+=1)for(var t=0,i=this.cacheList[e].getKeys();t<i.length;t++){var r=i[t];this._removeItem(r,e)}},t.prototype.getAllKeys=function(){for(var e=[],t=0;t<this.maxPriority;t+=1)for(var i=0,r=this.cacheList[t].getKeys();i<r.length;i++){var o=r[i];e.push(o.substring(this.config.keyPrefix.length))}return e},t.prototype.getCacheCurSize=function(){return this.curSizeInBytes},t.prototype.createInstance=function(e){return new t(e)},t}(d));i.d(t,"BrowserStorageCache",(function(){return I})),i.d(t,"InMemoryCache",(function(){return x}));t.default=I;o.a.register(I)}])}));
	//# sourceMappingURL=aws-amplify-cache.min.js.map

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(278)):"function"==typeof define&&define.amd?define("aws_amplify_core",["aws-sdk/global"],t):"object"==typeof exports?exports.aws_amplify_core=t(require("aws-sdk/global")):e.aws_amplify_core=t(e["aws-sdk/global"])}(this,(function(e){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=12)}([function(e,t,n){"use strict";(function(e){var n=[{type:"text/plain",ext:"txt"},{type:"text/html",ext:"html"},{type:"text/javascript",ext:"js"},{type:"text/css",ext:"css"},{type:"text/csv",ext:"csv"},{type:"text/yaml",ext:"yml"},{type:"text/yaml",ext:"yaml"},{type:"text/calendar",ext:"ics"},{type:"text/calendar",ext:"ical"},{type:"image/png",ext:"png"},{type:"image/gif",ext:"gif"},{type:"image/jpeg",ext:"jpg"},{type:"image/jpeg",ext:"jpeg"},{type:"image/bmp",ext:"bmp"},{type:"image/x-icon",ext:"ico"},{type:"image/tiff",ext:"tif"},{type:"image/tiff",ext:"tiff"},{type:"image/svg+xml",ext:"svg"},{type:"application/json",ext:"json"},{type:"application/xml",ext:"xml"},{type:"application/x-sh",ext:"sh"},{type:"application/zip",ext:"zip"},{type:"application/x-rar-compressed",ext:"rar"},{type:"application/x-tar",ext:"tar"},{type:"application/x-bzip",ext:"bz"},{type:"application/x-bzip2",ext:"bz2"},{type:"application/pdf",ext:"pdf"},{type:"application/java-archive",ext:"jar"},{type:"application/msword",ext:"doc"},{type:"application/vnd.ms-excel",ext:"xls"},{type:"application/vnd.ms-excel",ext:"xlsx"},{type:"message/rfc822",ext:"eml"}],r=function(){function t(){}return t.isEmpty=function(e){return 0===Object.keys(e).length},t.sortByField=function(e,t,n){if(!e||!e.sort)return!1;var r=n&&"desc"===n?-1:1;return e.sort((function(e,n){var o=e[t],i=n[t];return void 0===i?void 0===o?0:1*r:void 0===o?-1*r:o<i?-1*r:o>i?1*r:0})),!0},t.objectLessAttributes=function(e,t){var n=Object.assign({},e);return t&&("string"==typeof t?delete n[t]:t.forEach((function(e){delete n[e]}))),n},t.filenameToContentType=function(e,t){void 0===t&&(t="application/octet-stream");var r=e.toLowerCase(),o=n.filter((function(e){return r.endsWith("."+e.ext)}));return o.length>0?o[0].type:t},t.isTextFile=function(e){var t=e.toLowerCase();return!!t.startsWith("text/")||("application/json"===t||"application/xml"===t||"application/sh"===t)},t.generateRandomString=function(){for(var e="",t="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",n=32;n>0;n-=1)e+=t[Math.floor(Math.random()*t.length)];return e},t.makeQuerablePromise=function(e){if(e.isResolved)return e;var t=!0,n=!1,r=!1,o=e.then((function(e){return r=!0,t=!1,e}),(function(e){throw n=!0,t=!1,e}));return o.isFullfilled=function(){return r},o.isPending=function(){return t},o.isRejected=function(){return n},o},t.browserOrNode=function(){return{isBrowser:"undefined"!=typeof window&&void 0!==window.document,isNode:void 0!==e&&null!=e.versions&&null!=e.versions.node}},t.transferKeyToLowerCase=function(e,n,r){if(void 0===n&&(n=[]),void 0===r&&(r=[]),!t.isStrictObject(e))return e;var o={};for(var i in e){if(e.hasOwnProperty(i))o[n.includes(i)?i:i[0].toLowerCase()+i.slice(1)]=r.includes(i)?e[i]:t.transferKeyToLowerCase(e[i],n,r)}return o},t.transferKeyToUpperCase=function(e,n,r){if(void 0===n&&(n=[]),void 0===r&&(r=[]),!t.isStrictObject(e))return e;var o={};for(var i in e){if(e.hasOwnProperty(i))o[n.includes(i)?i:i[0].toUpperCase()+i.slice(1)]=r.includes(i)?e[i]:t.transferKeyToUpperCase(e[i],n,r)}return o},t.isStrictObject=function(e){return!(!(e instanceof Object)||e instanceof Array||e instanceof Function||e instanceof Number||e instanceof String||e instanceof Boolean)},t}();t.a=r}).call(this,n(2))},function(t,n){t.exports=e},function(e,t){var n,r,o=e.exports={};function i(){throw new Error("setTimeout has not been defined")}function s(){throw new Error("clearTimeout has not been defined")}function a(e){if(n===setTimeout)return setTimeout(e,0);if((n===i||!n)&&setTimeout)return n=setTimeout,setTimeout(e,0);try{return n(e,0)}catch(t){try{return n.call(null,e,0)}catch(t){return n.call(this,e,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:i}catch(e){n=i}try{r="function"==typeof clearTimeout?clearTimeout:s}catch(e){r=s}}();var u,c=[],l=!1,f=-1;function h(){l&&u&&(l=!1,u.length?c=u.concat(c):f=-1,c.length&&p())}function p(){if(!l){var e=a(h);l=!0;for(var t=c.length;t;){for(u=c,c=[];++f<t;)u&&u[f].run();f=-1,t=c.length}u=null,l=!1,function(e){if(r===clearTimeout)return clearTimeout(e);if((r===s||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(e);try{r(e)}catch(t){try{return r.call(null,e)}catch(t){return r.call(this,e)}}}(e)}}function d(e,t){this.fun=e,this.array=t}function g(){}o.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];c.push(new d(e,t)),1!==c.length||l||a(p)},d.prototype.run=function(){this.fun.apply(null,this.array)},o.title="browser",o.browser=!0,o.env={},o.argv=[],o.version="",o.versions={},o.on=g,o.addListener=g,o.once=g,o.off=g,o.removeListener=g,o.removeAllListeners=g,o.emit=g,o.prependListener=g,o.prependOnceListener=g,o.listeners=function(e){return[]},o.binding=function(e){throw new Error("process.binding is not supported")},o.cwd=function(){return"/"},o.chdir=function(e){throw new Error("process.chdir is not supported")},o.umask=function(){return 0}},function(e,t,n){"use strict";var r=n(4),o=n(7);function i(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}t.parse=b,t.resolve=function(e,t){return b(e,!1,!0).resolve(t)},t.resolveObject=function(e,t){return e?b(e,!1,!0).resolveObject(t):t},t.format=function(e){o.isString(e)&&(e=b(e));return e instanceof i?e.format():i.prototype.format.call(e)},t.Url=i;var s=/^([a-z0-9.+-]+:)/i,a=/:[0-9]*$/,u=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,c=["{","}","|","\\","^","`"].concat(["<",">",'"',"`"," ","\r","\n","\t"]),l=["'"].concat(c),f=["%","/","?",";","#"].concat(l),h=["/","?","#"],p=/^[+a-z0-9A-Z_-]{0,63}$/,d=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,g={javascript:!0,"javascript:":!0},y={javascript:!0,"javascript:":!0},v={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},m=n(8);function b(e,t,n){if(e&&o.isObject(e)&&e instanceof i)return e;var r=new i;return r.parse(e,t,n),r}i.prototype.parse=function(e,t,n){if(!o.isString(e))throw new TypeError("Parameter 'url' must be a string, not "+typeof e);var i=e.indexOf("?"),a=-1!==i&&i<e.indexOf("#")?"?":"#",c=e.split(a);c[0]=c[0].replace(/\\/g,"/");var b=e=c.join(a);if(b=b.trim(),!n&&1===e.split("#").length){var w=u.exec(b);if(w)return this.path=b,this.href=b,this.pathname=w[1],w[2]?(this.search=w[2],this.query=t?m.parse(this.search.substr(1)):this.search.substr(1)):t&&(this.search="",this.query={}),this}var _=s.exec(b);if(_){var x=(_=_[0]).toLowerCase();this.protocol=x,b=b.substr(_.length)}if(n||_||b.match(/^\/\/[^@\/]+@[^@\/]+/)){var k="//"===b.substr(0,2);!k||_&&y[_]||(b=b.substr(2),this.slashes=!0)}if(!y[_]&&(k||_&&!v[_])){for(var j,C,I=-1,S=0;S<h.length;S++){-1!==(A=b.indexOf(h[S]))&&(-1===I||A<I)&&(I=A)}-1!==(C=-1===I?b.lastIndexOf("@"):b.lastIndexOf("@",I))&&(j=b.slice(0,C),b=b.slice(C+1),this.auth=decodeURIComponent(j)),I=-1;for(S=0;S<f.length;S++){var A;-1!==(A=b.indexOf(f[S]))&&(-1===I||A<I)&&(I=A)}-1===I&&(I=b.length),this.host=b.slice(0,I),b=b.slice(I),this.parseHost(),this.hostname=this.hostname||"";var O="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!O)for(var P=this.hostname.split(/\./),T=(S=0,P.length);S<T;S++){var F=P[S];if(F&&!F.match(p)){for(var N="",E=0,L=F.length;E<L;E++)F.charCodeAt(E)>127?N+="x":N+=F[E];if(!N.match(p)){var W=P.slice(0,S),R=P.slice(S+1),U=F.match(d);U&&(W.push(U[1]),R.unshift(U[2])),R.length&&(b="/"+R.join(".")+b),this.hostname=W.join(".");break}}}this.hostname.length>255?this.hostname="":this.hostname=this.hostname.toLowerCase(),O||(this.hostname=r.toASCII(this.hostname));var z=this.port?":"+this.port:"",H=this.hostname||"";this.host=H+z,this.href+=this.host,O&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==b[0]&&(b="/"+b))}if(!g[x])for(S=0,T=l.length;S<T;S++){var q=l[S];if(-1!==b.indexOf(q)){var G=encodeURIComponent(q);G===q&&(G=escape(q)),b=b.split(q).join(G)}}var B=b.indexOf("#");-1!==B&&(this.hash=b.substr(B),b=b.slice(0,B));var M=b.indexOf("?");if(-1!==M?(this.search=b.substr(M),this.query=b.substr(M+1),t&&(this.query=m.parse(this.query)),b=b.slice(0,M)):t&&(this.search="",this.query={}),b&&(this.pathname=b),v[x]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){z=this.pathname||"";var D=this.search||"";this.path=z+D}return this.href=this.format(),this},i.prototype.format=function(){var e=this.auth||"";e&&(e=(e=encodeURIComponent(e)).replace(/%3A/i,":"),e+="@");var t=this.protocol||"",n=this.pathname||"",r=this.hash||"",i=!1,s="";this.host?i=e+this.host:this.hostname&&(i=e+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port&&(i+=":"+this.port)),this.query&&o.isObject(this.query)&&Object.keys(this.query).length&&(s=m.stringify(this.query));var a=this.search||s&&"?"+s||"";return t&&":"!==t.substr(-1)&&(t+=":"),this.slashes||(!t||v[t])&&!1!==i?(i="//"+(i||""),n&&"/"!==n.charAt(0)&&(n="/"+n)):i||(i=""),r&&"#"!==r.charAt(0)&&(r="#"+r),a&&"?"!==a.charAt(0)&&(a="?"+a),t+i+(n=n.replace(/[?#]/g,(function(e){return encodeURIComponent(e)})))+(a=a.replace("#","%23"))+r},i.prototype.resolve=function(e){return this.resolveObject(b(e,!1,!0)).format()},i.prototype.resolveObject=function(e){if(o.isString(e)){var t=new i;t.parse(e,!1,!0),e=t}for(var n=new i,r=Object.keys(this),s=0;s<r.length;s++){var a=r[s];n[a]=this[a]}if(n.hash=e.hash,""===e.href)return n.href=n.format(),n;if(e.slashes&&!e.protocol){for(var u=Object.keys(e),c=0;c<u.length;c++){var l=u[c];"protocol"!==l&&(n[l]=e[l])}return v[n.protocol]&&n.hostname&&!n.pathname&&(n.path=n.pathname="/"),n.href=n.format(),n}if(e.protocol&&e.protocol!==n.protocol){if(!v[e.protocol]){for(var f=Object.keys(e),h=0;h<f.length;h++){var p=f[h];n[p]=e[p]}return n.href=n.format(),n}if(n.protocol=e.protocol,e.host||y[e.protocol])n.pathname=e.pathname;else{for(var d=(e.pathname||"").split("/");d.length&&!(e.host=d.shift()););e.host||(e.host=""),e.hostname||(e.hostname=""),""!==d[0]&&d.unshift(""),d.length<2&&d.unshift(""),n.pathname=d.join("/")}if(n.search=e.search,n.query=e.query,n.host=e.host||"",n.auth=e.auth,n.hostname=e.hostname||e.host,n.port=e.port,n.pathname||n.search){var g=n.pathname||"",m=n.search||"";n.path=g+m}return n.slashes=n.slashes||e.slashes,n.href=n.format(),n}var b=n.pathname&&"/"===n.pathname.charAt(0),w=e.host||e.pathname&&"/"===e.pathname.charAt(0),_=w||b||n.host&&e.pathname,x=_,k=n.pathname&&n.pathname.split("/")||[],j=(d=e.pathname&&e.pathname.split("/")||[],n.protocol&&!v[n.protocol]);if(j&&(n.hostname="",n.port=null,n.host&&(""===k[0]?k[0]=n.host:k.unshift(n.host)),n.host="",e.protocol&&(e.hostname=null,e.port=null,e.host&&(""===d[0]?d[0]=e.host:d.unshift(e.host)),e.host=null),_=_&&(""===d[0]||""===k[0])),w)n.host=e.host||""===e.host?e.host:n.host,n.hostname=e.hostname||""===e.hostname?e.hostname:n.hostname,n.search=e.search,n.query=e.query,k=d;else if(d.length)k||(k=[]),k.pop(),k=k.concat(d),n.search=e.search,n.query=e.query;else if(!o.isNullOrUndefined(e.search)){if(j)n.hostname=n.host=k.shift(),(O=!!(n.host&&n.host.indexOf("@")>0)&&n.host.split("@"))&&(n.auth=O.shift(),n.host=n.hostname=O.shift());return n.search=e.search,n.query=e.query,o.isNull(n.pathname)&&o.isNull(n.search)||(n.path=(n.pathname?n.pathname:"")+(n.search?n.search:"")),n.href=n.format(),n}if(!k.length)return n.pathname=null,n.search?n.path="/"+n.search:n.path=null,n.href=n.format(),n;for(var C=k.slice(-1)[0],I=(n.host||e.host||k.length>1)&&("."===C||".."===C)||""===C,S=0,A=k.length;A>=0;A--)"."===(C=k[A])?k.splice(A,1):".."===C?(k.splice(A,1),S++):S&&(k.splice(A,1),S--);if(!_&&!x)for(;S--;S)k.unshift("..");!_||""===k[0]||k[0]&&"/"===k[0].charAt(0)||k.unshift(""),I&&"/"!==k.join("/").substr(-1)&&k.push("");var O,P=""===k[0]||k[0]&&"/"===k[0].charAt(0);j&&(n.hostname=n.host=P?"":k.length?k.shift():"",(O=!!(n.host&&n.host.indexOf("@")>0)&&n.host.split("@"))&&(n.auth=O.shift(),n.host=n.hostname=O.shift()));return(_=_||n.host&&k.length)&&!P&&k.unshift(""),k.length?n.pathname=k.join("/"):(n.pathname=null,n.path=null),o.isNull(n.pathname)&&o.isNull(n.search)||(n.path=(n.pathname?n.pathname:"")+(n.search?n.search:"")),n.auth=e.auth||n.auth,n.slashes=n.slashes||e.slashes,n.href=n.format(),n},i.prototype.parseHost=function(){var e=this.host,t=a.exec(e);t&&(":"!==(t=t[0])&&(this.port=t.substr(1)),e=e.substr(0,e.length-t.length)),e&&(this.hostname=e)}},function(e,t,n){(function(e,r){var o;/*! https://mths.be/punycode v1.4.1 by @mathias */!function(i){t&&t.nodeType,e&&e.nodeType;var s="object"==typeof r&&r;s.global!==s&&s.window!==s&&s.self;var a,u=2147483647,c=/^xn--/,l=/[^\x20-\x7E]/,f=/[\x2E\u3002\uFF0E\uFF61]/g,h={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},p=Math.floor,d=String.fromCharCode;function g(e){throw new RangeError(h[e])}function y(e,t){for(var n=e.length,r=[];n--;)r[n]=t(e[n]);return r}function v(e,t){var n=e.split("@"),r="";return n.length>1&&(r=n[0]+"@",e=n[1]),r+y((e=e.replace(f,".")).split("."),t).join(".")}function m(e){for(var t,n,r=[],o=0,i=e.length;o<i;)(t=e.charCodeAt(o++))>=55296&&t<=56319&&o<i?56320==(64512&(n=e.charCodeAt(o++)))?r.push(((1023&t)<<10)+(1023&n)+65536):(r.push(t),o--):r.push(t);return r}function b(e){return y(e,(function(e){var t="";return e>65535&&(t+=d((e-=65536)>>>10&1023|55296),e=56320|1023&e),t+=d(e)})).join("")}function w(e,t){return e+22+75*(e<26)-((0!=t)<<5)}function _(e,t,n){var r=0;for(e=n?p(e/700):e>>1,e+=p(e/t);e>455;r+=36)e=p(e/35);return p(r+36*e/(e+38))}function x(e){var t,n,r,o,i,s,a,c,l,f,h,d=[],y=e.length,v=0,m=128,w=72;for((n=e.lastIndexOf("-"))<0&&(n=0),r=0;r<n;++r)e.charCodeAt(r)>=128&&g("not-basic"),d.push(e.charCodeAt(r));for(o=n>0?n+1:0;o<y;){for(i=v,s=1,a=36;o>=y&&g("invalid-input"),((c=(h=e.charCodeAt(o++))-48<10?h-22:h-65<26?h-65:h-97<26?h-97:36)>=36||c>p((u-v)/s))&&g("overflow"),v+=c*s,!(c<(l=a<=w?1:a>=w+26?26:a-w));a+=36)s>p(u/(f=36-l))&&g("overflow"),s*=f;w=_(v-i,t=d.length+1,0==i),p(v/t)>u-m&&g("overflow"),m+=p(v/t),v%=t,d.splice(v++,0,m)}return b(d)}function k(e){var t,n,r,o,i,s,a,c,l,f,h,y,v,b,x,k=[];for(y=(e=m(e)).length,t=128,n=0,i=72,s=0;s<y;++s)(h=e[s])<128&&k.push(d(h));for(r=o=k.length,o&&k.push("-");r<y;){for(a=u,s=0;s<y;++s)(h=e[s])>=t&&h<a&&(a=h);for(a-t>p((u-n)/(v=r+1))&&g("overflow"),n+=(a-t)*v,t=a,s=0;s<y;++s)if((h=e[s])<t&&++n>u&&g("overflow"),h==t){for(c=n,l=36;!(c<(f=l<=i?1:l>=i+26?26:l-i));l+=36)x=c-f,b=36-f,k.push(d(w(f+x%b,0))),c=p(x/b);k.push(d(w(c,0))),i=_(n,v,r==o),n=0,++r}++n,++t}return k.join("")}a={version:"1.4.1",ucs2:{decode:m,encode:b},decode:x,encode:k,toASCII:function(e){return v(e,(function(e){return l.test(e)?"xn--"+k(e):e}))},toUnicode:function(e){return v(e,(function(e){return c.test(e)?x(e.slice(4).toLowerCase()):e}))}},void 0===(o=function(){return a}.call(t,n,t,e))||(e.exports=o)}()}).call(this,n(5)(e),n(6))},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e}},function(e,t){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){"use strict";e.exports={isString:function(e){return"string"==typeof e},isObject:function(e){return"object"==typeof e&&null!==e},isNull:function(e){return null===e},isNullOrUndefined:function(e){return null==e}}},function(e,t,n){"use strict";t.decode=t.parse=n(9),t.encode=t.stringify=n(10)},function(e,t,n){"use strict";function r(e,t){return Object.prototype.hasOwnProperty.call(e,t)}e.exports=function(e,t,n,i){t=t||"&",n=n||"=";var s={};if("string"!=typeof e||0===e.length)return s;var a=/\+/g;e=e.split(t);var u=1e3;i&&"number"==typeof i.maxKeys&&(u=i.maxKeys);var c=e.length;u>0&&c>u&&(c=u);for(var l=0;l<c;++l){var f,h,p,d,g=e[l].replace(a,"%20"),y=g.indexOf(n);y>=0?(f=g.substr(0,y),h=g.substr(y+1)):(f=g,h=""),p=decodeURIComponent(f),d=decodeURIComponent(h),r(s,p)?o(s[p])?s[p].push(d):s[p]=[s[p],d]:s[p]=d}return s};var o=Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)}},function(e,t,n){"use strict";var r=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return""}};e.exports=function(e,t,n,a){return t=t||"&",n=n||"=",null===e&&(e=void 0),"object"==typeof e?i(s(e),(function(s){var a=encodeURIComponent(r(s))+n;return o(e[s])?i(e[s],(function(e){return a+encodeURIComponent(r(e))})).join(t):a+encodeURIComponent(r(e[s]))})).join(t):a?encodeURIComponent(r(a))+n+encodeURIComponent(r(e)):""};var o=Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)};function i(e,t){if(e.map)return e.map(t);for(var n=[],r=0;r<e.length;r++)n.push(t(e[r],r));return n}var s=Object.keys||function(e){var t=[];for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&t.push(n);return t}},function(e){e.exports=JSON.parse('{"name":"@aws-amplify/core","version":"1.3.2","description":"Core category of aws-amplify","main":"./index.js","module":"./lib-esm/index.js","typings":"./lib-esm/index.d.ts","publishConfig":{"access":"public"},"scripts":{"test":"tslint \'src/**/*.ts\' && jest -w 1 --coverage","build-with-test":"npm test && npm run build","build:cjs":"node ./build es5 && webpack && webpack --config ./webpack.config.dev.js","build:esm":"node ./build es6","build":"npm run clean && npm run build:esm && npm run build:cjs","clean":"rimraf lib-esm lib dist","format":"echo \\"Not implemented\\"","lint":"tslint \'src/**/*.ts\'"},"react-native":{"./lib/ClientDevice":"./lib/ClientDevice/reactnative.js","./lib/RNComponents":"./lib/RNComponents/reactnative.js","./lib/StorageHelper":"./lib/StorageHelper/reactnative.js"},"repository":{"type":"git","url":"https://github.com/aws-amplify/amplify-js.git"},"author":"Amazon Web Services","license":"Apache-2.0","bugs":{"url":"https://github.com/aws/aws-amplify/issues"},"homepage":"https://aws-amplify.github.io/","devDependencies":{"find":"^0.2.7","prepend-file":"^1.3.1","prettier":"^1.7.4","typescript":"^3.2.2"},"dependencies":{"aws-sdk":"2.518.0","url":"^0.11.0"},"jest":{"globals":{"ts-jest":{"diagnostics":false,"tsConfig":{"lib":["es5","es2015","dom","esnext.asynciterable","es2017.object"],"allowJs":true}}},"transform":{"^.+\\\\.(js|jsx|ts|tsx)$":"ts-jest"},"testRegex":"(/__tests__/.*|\\\\.(test|spec))\\\\.(tsx?|jsx?)$","moduleFileExtensions":["ts","tsx","js","json","jsx"],"testEnvironment":"jsdom","coverageThreshold":{"global":{"branches":0,"functions":0,"lines":0,"statements":0}},"testURL":"http://localhost/","coveragePathIgnorePatterns":["/node_modules/"]}}')},function(e,t,n){"use strict";n.r(t);var r=n(1),o=function(){for(var e=0,t=0,n=arguments.length;t<n;t++)e+=arguments[t].length;var r=Array(e),o=0;for(t=0;t<n;t++)for(var i=arguments[t],s=0,a=i.length;s<a;s++,o++)r[o]=i[s];return r},i={VERBOSE:1,DEBUG:2,INFO:3,WARN:4,ERROR:5},s=function(){function e(e,t){void 0===t&&(t="WARN"),this.name=e,this.level=t}return e.prototype._padding=function(e){return e<10?"0"+e:""+e},e.prototype._ts=function(){var e=new Date;return[this._padding(e.getMinutes()),this._padding(e.getSeconds())].join(":")+"."+e.getMilliseconds()},e.prototype._log=function(t){for(var n=[],r=1;r<arguments.length;r++)n[r-1]=arguments[r];var o=this.level;e.LOG_LEVEL&&(o=e.LOG_LEVEL),"undefined"!=typeof window&&window.LOG_LEVEL&&(o=window.LOG_LEVEL);var s=i[o],a=i[t];if(a>=s){var u=console.log.bind(console);"ERROR"===t&&console.error&&(u=console.error.bind(console)),"WARN"===t&&console.warn&&(u=console.warn.bind(console));var c="["+t+"] "+this._ts()+" "+this.name;if(1===n.length&&"string"==typeof n[0])u(c+" - "+n[0]);else if(1===n.length)u(c,n[0]);else if("string"==typeof n[0]){var l=n.slice(1);1===l.length&&(l=l[0]),u(c+" - "+n[0],l)}else u(c,n)}},e.prototype.log=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];this._log.apply(this,o(["INFO"],e))},e.prototype.info=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];this._log.apply(this,o(["INFO"],e))},e.prototype.warn=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];this._log.apply(this,o(["WARN"],e))},e.prototype.error=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];this._log.apply(this,o(["ERROR"],e))},e.prototype.debug=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];this._log.apply(this,o(["DEBUG"],e))},e.prototype.verbose=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];this._log.apply(this,o(["VERBOSE"],e))},e.LOG_LEVEL=null,e}(),a=new s("Amplify"),u=function(){function e(){}return e.register=function(t){a.debug("component registered in amplify",t),this._components.push(t),"function"==typeof t.getModuleName?e[t.getModuleName()]=t:a.debug("no getModuleName method for component",t)},e.configure=function(e){var t=this;return e?(this._config=Object.assign(this._config,e),a.debug("amplify config",this._config),this._components.map((function(e){e.configure(t._config)})),this._config):this._config},e.addPluggable=function(e){e&&e.getCategory&&"function"==typeof e.getCategory&&this._components.map((function(t){t.addPluggable&&"function"==typeof t.addPluggable&&t.addPluggable(e)}))},e._components=[],e._config={},e.Auth=null,e.Analytics=null,e.API=null,e.Storage=null,e.I18n=null,e.Cache=null,e.PubSub=null,e.Interactions=null,e.Pushnotification=null,e.UI=null,e.XR=null,e.Predictions=null,e.Logger=s,e.ServiceWorker=null,e}(),c=new s("ClientDevice_Browser");function l(){return"undefined"==typeof window?{}:function(){if("undefined"==typeof window)return c.warn("No window object available to get browser client info"),{};var e=window.navigator;if(!e)return c.warn("No navigator object available to get browser client info"),{};var t=e.platform,n=e.product,r=e.vendor,o=e.userAgent,i=e.language,s=function(e){var t=/.+(Opera[\s[A-Z]*|OPR[\sA-Z]*)\/([0-9\.]+).*/i.exec(e);if(t)return{type:t[1],version:t[2]};var n=/.+(Trident|Edge)\/([0-9\.]+).*/i.exec(e);if(n)return{type:n[1],version:n[2]};var r=/.+(Chrome|Firefox|FxiOS)\/([0-9\.]+).*/i.exec(e);if(r)return{type:r[1],version:r[2]};var o=/.+(Safari)\/([0-9\.]+).*/i.exec(e);if(o)return{type:o[1],version:o[2]};var i=/.+(AppleWebKit)\/([0-9\.]+).*/i.exec(e);if(i)return{type:i[1],version:i[2]};var s=/.*([A-Z]+)\/([0-9\.]+).*/i.exec(e);if(s)return{type:s[1],version:s[2]};return{type:"",version:""}}(o),a=(u=/\(([A-Za-z\s].*)\)/.exec((new Date).toString()),u&&u[1]||"");var u;return{platform:t,make:n||r,model:s.type,version:s.version,appVersion:[s.type,s.version].join("/"),language:i,timezone:a}}()}var f=function(){function e(){}return e.clientInfo=function(){return l()},e.dimension=function(){return"undefined"==typeof window?(c.warn("No window object available to get browser client info"),{width:320,height:320}):{width:window.innerWidth,height:window.innerHeight}},e}();function h(e){return new Error("Missing config value of "+e)}function p(e){return new Error("Invalid parameter value of "+e)}var d=function(){return(d=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)},g=function(){for(var e=0,t=0,n=arguments.length;t<n;t++)e+=arguments[t].length;var r=Array(e),o=0;for(t=0;t<n;t++)for(var i=arguments[t],s=0,a=i.length;s<a;s++,o++)r[o]=i[s];return r},y=new s("Hub"),v="undefined"!=typeof Symbol&&"function"==typeof Symbol.for?Symbol.for("amplify_default"):"@@amplify_default";var m=new(function(){function e(e){this.listeners=[],this.patterns=[],this.protectedChannels=["core","auth","api","analytics","interactions","pubsub","storage","xr"],this.name=e}return e.prototype.remove=function(e,t){if(e instanceof RegExp){var n=this.patterns.find((function(t){return t.pattern.source===e.source}));if(!n)return void y.warn("No listeners for "+e);this.patterns=g(this.patterns.filter((function(e){return e!==n})))}else{var r=this.listeners[e];if(!r)return void y.warn("No listeners for "+e);this.listeners[e]=g(r.filter((function(e){return e.callback!==t})))}},e.prototype.dispatch=function(e,t,n,r){(void 0===n&&(n=""),this.protectedChannels.indexOf(e)>-1)&&(r===v||y.warn("WARNING: "+e+" is protected and dispatching on it can have unintended consequences"));var o={channel:e,payload:d({},t),source:n,patternInfo:[]};try{this._toListeners(o)}catch(e){y.error(e)}},e.prototype.listen=function(e,t,n){var r;if(void 0===n&&(n="noname"),function(e){return void 0!==e.onHubCapsule}(t))y.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback."),r=t.onHubCapsule.bind(t);else{if("function"!=typeof t)throw new Error("No callback supplied to Hub");r=t}if(e instanceof RegExp)this.patterns.push({pattern:e,callback:r});else{var o=this.listeners[e];o||(o=[],this.listeners[e]=o),o.push({name:n,callback:r})}},e.prototype._toListeners=function(e){var t=e.channel,n=e.payload,r=this.listeners[t];if(r&&r.forEach((function(r){y.debug("Dispatching to "+t+" with ",n);try{r.callback(e)}catch(e){y.error(e)}})),this.patterns.length>0){if(!n.message)return void y.warn("Cannot perform pattern matching without a message key");var o=n.message;this.patterns.forEach((function(t){var n=o.match(t.pattern);if(n){var r=n.slice(1),i=d(d({},e),{patternInfo:r});try{t.callback(i)}catch(e){y.error(e)}}}))}},e}())("__default__"),b=new s("I18n"),w=function(){function e(e){this._options=null,this._lang=null,this._dict={},this._options=Object.assign({},e),this._lang=this._options.language,!this._lang&&"undefined"!=typeof window&&window&&window.navigator&&(this._lang=window.navigator.language),b.debug(this._lang)}return e.prototype.setLanguage=function(e){this._lang=e},e.prototype.get=function(e,t){if(void 0===t&&(t=void 0),!this._lang)return void 0!==t?t:e;var n=this._lang,r=this.getByLanguage(e,n);return r||(n.indexOf("-")>0&&(r=this.getByLanguage(e,n.split("-")[0])),r||(void 0!==t?t:e))},e.prototype.getByLanguage=function(e,t,n){if(void 0===n&&(n=null),!t)return n;var r=this._dict[t];return r?r[e]:n},e.prototype.putVocabulariesForLanguage=function(e,t){var n=this._dict[e];n||(n=this._dict[e]={}),Object.assign(n,t)},e.prototype.putVocabularies=function(e){var t=this;Object.keys(e).map((function(n){t.putVocabulariesForLanguage(n,e[n])}))},e}(),_=new s("I18n"),x=null,k=null,j=function(){function e(){}return e.configure=function(t){return _.debug("configure I18n"),t?(x=Object.assign({},x,t.I18n||t),e.createInstance(),x):x},e.getModuleName=function(){return"I18n"},e.createInstance=function(){_.debug("create I18n instance"),k||(k=new w(x))},e.setLanguage=function(t){return e.checkConfig(),k.setLanguage(t)},e.get=function(t,n){return e.checkConfig()?k.get(t,n):void 0===n?t:n},e.putVocabulariesForLanguage=function(t,n){return e.checkConfig(),k.putVocabulariesForLanguage(t,n)},e.putVocabularies=function(t){return e.checkConfig(),k.putVocabularies(t)},e.checkConfig=function(){return k||(k=new w(x)),!0},e}();u.register(j);var C=j,I=n(0);function S(e){return(S="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var A=function(){return(A=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)},O=function(e,t){var n={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(e);o<r.length;o++)t.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(e,r[o])&&(n[r[o]]=e[r[o]])}return n},P=new s("Signer"),T=n(3),F=r.util.crypto,N=function(e,t,n){return F.lib.createHmac("sha256",e).update(t,"utf8").digest(n)},E=function(e){var t=e||"";return F.createHash("sha256").update(t,"utf8").digest("hex")},L=function(e){return Object.keys(e).map((function(e){return e.toLowerCase()})).sort().join(";")},W=function(e){var t,n,r=T.parse(e.url);return[e.method||"/",encodeURIComponent(r.pathname).replace(/%2F/gi,"/"),(n=r.query,n&&0!==n.length?n.split("&").map((function(e){var t=e.split("=");if(1===t.length)return e;var n=t[1].replace(/[!'()*]/g,(function(e){return"%"+e.charCodeAt(0).toString(16).toUpperCase()}));return t[0]+"="+n})).sort((function(e,t){var n=e.split("=")[0],r=t.split("=")[0];return n===r?e<t?-1:1:n<r?-1:1})).join("&"):""),(t=e.headers,t&&0!==Object.keys(t).length?Object.keys(t).map((function(e){return{key:e.toLowerCase(),value:t[e]?t[e].trim().replace(/\s+/g," "):""}})).sort((function(e,t){return e.key<t.key?-1:1})).map((function(e){return e.key+":"+e.value})).join("\n")+"\n":""),L(e.headers),E(e.data)].join("\n")},R=function(e){var t=(T.parse(e.url).host.match(/([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com$/)||[]).slice(1,3);return"es"===t[1]&&(t=t.reverse()),{service:e.service||t[0],region:e.region||t[1]}},U=function(e,t,n){return[e,t,n,"aws4_request"].join("/")},z=function(e,t,n,r){return[e,n,r,E(t)].join("\n")},H=function(e,t,n){P.debug(n);var r=N("AWS4"+e,t),o=N(r,n.region),i=N(o,n.service);return N(i,"aws4_request")},q=function(e,t){return N(e,t,"hex")},G=function(){function e(){}return e.sign=function(e,t,n){void 0===n&&(n=null),e.headers=e.headers||{};var r=(new Date).toISOString().replace(/[:\-]|\.\d{3}/g,""),o=r.substr(0,8),i=T.parse(e.url);e.headers.host=i.host,e.headers["x-amz-date"]=r,t.session_token&&(e.headers["X-Amz-Security-Token"]=t.session_token);var s=W(e);P.debug(s);var a=n||R(e),u=U(o,a.region,a.service),c=z("AWS4-HMAC-SHA256",s,r,u),l=H(t.secret_key,o,a),f=q(l,c),h=function(e,t,n,r,o){return[e+" Credential="+t+"/"+n,"SignedHeaders="+r,"Signature="+o].join(", ")}("AWS4-HMAC-SHA256",t.access_key,u,L(e.headers),f);return e.headers.Authorization=h,e},e.signUrl=function(e,t,n,r){var o="object"===S(e)?e.url:e,i="object"===S(e)?e.method:"GET",s="object"===S(e)?e.body:void 0,a=(new Date).toISOString().replace(/[:\-]|\.\d{3}/g,""),u=a.substr(0,8),c=T.parse(o,!0,!0),l=(c.search,O(c,["search"])),f={host:l.host},h=n||R({url:T.format(l)}),p=h.region,d=h.service,g=U(u,p,d),y=t.session_token&&"iotdevicegateway"!==d,v=A(A(A({"X-Amz-Algorithm":"AWS4-HMAC-SHA256","X-Amz-Credential":[t.access_key,g].join("/"),"X-Amz-Date":a.substr(0,16)},y?{"X-Amz-Security-Token":""+t.session_token}:{}),r?{"X-Amz-Expires":""+r}:{}),{"X-Amz-SignedHeaders":Object.keys(f).join(",")}),m=W({method:i,url:T.format(A(A({},l),{query:A(A({},l.query),v)})),headers:f,data:s}),b=z("AWS4-HMAC-SHA256",m,a,g),w=H(t.secret_key,u,{region:p,service:d}),_=q(w,b),x=A({"X-Amz-Signature":_},t.session_token&&{"X-Amz-Security-Token":t.session_token});return T.format({protocol:l.protocol,slashes:!0,hostname:l.hostname,port:l.port,pathname:l.pathname,query:A(A(A({},l.query),v),x)})},e}(),B=new s("Parser"),M=function(){function e(){}return e.parseMobilehubConfig=function(e){var t,n={};if(e.aws_mobile_analytics_app_id){var r={AWSPinpoint:{appId:e.aws_mobile_analytics_app_id,region:e.aws_mobile_analytics_app_region}};n.Analytics=r}if(e.aws_cognito_identity_pool_id||e.aws_user_pools_id){var o={userPoolId:e.aws_user_pools_id,userPoolWebClientId:e.aws_user_pools_web_client_id,region:e.aws_cognito_region,identityPoolId:e.aws_cognito_identity_pool_id,mandatorySignIn:"enable"===e.aws_mandatory_sign_in};n.Auth=o}return t=e.aws_user_files_s3_bucket?{AWSS3:{bucket:e.aws_user_files_s3_bucket,region:e.aws_user_files_s3_bucket_region,dangerouslyConnectToHttpEndpointForTesting:e.aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing}}:e?e.Storage||e:{},n.Analytics=Object.assign({},n.Analytics,e.Analytics),n.Auth=Object.assign({},n.Auth,e.Auth),n.Storage=Object.assign({},t),B.debug("parse config",e,"to amplifyconfig",n),n},e}(),D=function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function s(e){try{u(r.next(e))}catch(e){i(e)}}function a(e){try{u(r.throw(e))}catch(e){i(e)}}function u(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(s,a)}u((r=r.apply(e,t||[])).next())}))},K=function(e,t){var n,r,o,i,s={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return s.label++,{value:i[1],done:!1};case 5:s.label++,r=i[1],i=[0];continue;case 7:i=s.ops.pop(),s.trys.pop();continue;default:if(!(o=(o=s.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){s=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){s.label=i[1];break}if(6===i[0]&&s.label<o[1]){s.label=o[1],o=i;break}if(o&&s.label<o[2]){s.label=o[2],s.ops.push(i);break}o[2]&&s.ops.pop(),s.trys.pop();continue}i=t.call(e,s)}catch(e){i=[6,e],r=0}finally{n=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,a])}}},V=new s("CognitoCredentials"),X=new Promise((function(e,t){return I.a.browserOrNode().isBrowser?(window.gapi&&window.gapi.auth2?window.gapi.auth2:null)?(V.debug("google api already loaded"),e()):void setTimeout((function(){return e()}),2e3):(V.debug("not in the browser, directly resolved"),e())})),J=function(){function e(){this.initialized=!1,this.refreshGoogleToken=this.refreshGoogleToken.bind(this),this._refreshGoogleTokenImpl=this._refreshGoogleTokenImpl.bind(this)}return e.prototype.refreshGoogleToken=function(){return D(this,void 0,void 0,(function(){return K(this,(function(e){switch(e.label){case 0:return this.initialized?[3,2]:(V.debug("need to wait for the Google SDK loaded"),[4,X]);case 1:e.sent(),this.initialized=!0,V.debug("finish waiting"),e.label=2;case 2:return[2,this._refreshGoogleTokenImpl()]}}))}))},e.prototype._refreshGoogleTokenImpl=function(){var e=null;return I.a.browserOrNode().isBrowser&&(e=window.gapi&&window.gapi.auth2?window.gapi.auth2:null),e?new Promise((function(t,n){e.getAuthInstance().then((function(e){e||(console.log("google Auth undefiend"),n("google Auth undefiend"));var r=e.currentUser.get();r.isSignedIn()?(V.debug("refreshing the google access token"),r.reloadAuthResponse().then((function(e){var n=e.id_token,o=e.expires_at,i=r.getBasicProfile();i.getEmail(),i.getName();t({token:n,expires_at:o})}))):n("User is not signed in with Google")})).catch((function(e){V.debug("Failed to refresh google token",e),n("Failed to refresh google token")}))})):(V.debug("no gapi auth2 available"),Promise.reject("no gapi auth2 available"))},e}(),Z=function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function s(e){try{u(r.next(e))}catch(e){i(e)}}function a(e){try{u(r.throw(e))}catch(e){i(e)}}function u(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(s,a)}u((r=r.apply(e,t||[])).next())}))},$=function(e,t){var n,r,o,i,s={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return s.label++,{value:i[1],done:!1};case 5:s.label++,r=i[1],i=[0];continue;case 7:i=s.ops.pop(),s.trys.pop();continue;default:if(!(o=(o=s.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){s=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){s.label=i[1];break}if(6===i[0]&&s.label<o[1]){s.label=o[1],o=i;break}if(o&&s.label<o[2]){s.label=o[2],s.ops.push(i);break}o[2]&&s.ops.pop(),s.trys.pop();continue}i=t.call(e,s)}catch(e){i=[6,e],r=0}finally{n=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,a])}}},Q=new s("CognitoCredentials"),Y=new Promise((function(e,t){return I.a.browserOrNode().isBrowser?window.FB?(Q.debug("FB SDK already loaded"),e()):void setTimeout((function(){return e()}),2e3):(Q.debug("not in the browser, directly resolved"),e())})),ee=function(){function e(){this.initialized=!1,this.refreshFacebookToken=this.refreshFacebookToken.bind(this),this._refreshFacebookTokenImpl=this._refreshFacebookTokenImpl.bind(this)}return e.prototype.refreshFacebookToken=function(){return Z(this,void 0,void 0,(function(){return $(this,(function(e){switch(e.label){case 0:return this.initialized?[3,2]:(Q.debug("need to wait for the Facebook SDK loaded"),[4,Y]);case 1:e.sent(),this.initialized=!0,Q.debug("finish waiting"),e.label=2;case 2:return[2,this._refreshFacebookTokenImpl()]}}))}))},e.prototype._refreshFacebookTokenImpl=function(){var e=null;return I.a.browserOrNode().isBrowser&&(e=window.FB),e?new Promise((function(t,n){e.getLoginStatus((function(e){e&&e.authResponse||(Q.debug("no response from facebook when refreshing the jwt token"),n("no response from facebook when refreshing the jwt token"));var r=e.authResponse,o=r.accessToken,i=1e3*r.expiresIn+(new Date).getTime();o||(Q.debug("the jwtToken is undefined"),n("the jwtToken is undefined")),t({token:o,expires_at:i})}),{scope:"public_profile,email"})})):(Q.debug("no fb sdk available"),Promise.reject("no fb sdk available"))},e}(),te=new J,ne=new ee,re={},oe=function(){function e(){}return e.setItem=function(e,t){return re[e]=t,re[e]},e.getItem=function(e){return Object.prototype.hasOwnProperty.call(re,e)?re[e]:void 0},e.removeItem=function(e){return delete re[e]},e.clear=function(){return re={}},e}(),ie=function(){function e(){try{this.storageWindow=window.localStorage,this.storageWindow.setItem("aws.amplify.test-ls",1),this.storageWindow.removeItem("aws.amplify.test-ls")}catch(e){this.storageWindow=oe}}return e.prototype.getStorage=function(){return this.storageWindow},e}(),se={},ae={addEventListener:function(e,t){}},ue=I.a.browserOrNode().isBrowser?(new ie).getStorage():void 0,ce=function(){return(ce=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)},le=function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function s(e){try{u(r.next(e))}catch(e){i(e)}}function a(e){try{u(r.throw(e))}catch(e){i(e)}}function u(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(s,a)}u((r=r.apply(e,t||[])).next())}))},fe=function(e,t){var n,r,o,i,s={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return s.label++,{value:i[1],done:!1};case 5:s.label++,r=i[1],i=[0];continue;case 7:i=s.ops.pop(),s.trys.pop();continue;default:if(!(o=(o=s.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){s=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){s.label=i[1];break}if(6===i[0]&&s.label<o[1]){s.label=o[1],o=i;break}if(o&&s.label<o[2]){s.label=o[2],s.ops.push(i);break}o[2]&&s.ops.pop(),s.trys.pop();continue}i=t.call(e,s)}catch(e){i=[6,e],r=0}finally{n=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,a])}}},he=new s("Credentials"),pe=new(function(){function e(e){this._gettingCredPromise=null,this._refreshHandlers={},this.configure(e),this._refreshHandlers.google=te.refreshGoogleToken,this._refreshHandlers.facebook=ne.refreshFacebookToken}return e.prototype.getCredSource=function(){return this._credentials_source},e.prototype.configure=function(e){if(!e)return this._config||{};this._config=Object.assign({},this._config,e);var t=this._config.refreshHandlers;return t&&(this._refreshHandlers=ce(ce({},this._refreshHandlers),t)),this._storage=this._config.storage,this._storage||(this._storage=(new ie).getStorage()),this._storageSync=Promise.resolve(),"function"==typeof this._storage.sync&&(this._storageSync=this._storage.sync()),this._config},e.prototype.get=function(){return he.debug("getting credentials"),this._pickupCredentials()},e.prototype._pickupCredentials=function(){return he.debug("picking up credentials"),this._gettingCredPromise&&this._gettingCredPromise.isPending()?he.debug("getting old cred promise"):(he.debug("getting new cred promise"),r.config&&r.config.credentials&&r.config.credentials instanceof r.Credentials?this._gettingCredPromise=I.a.makeQuerablePromise(this._setCredentialsFromAWS()):this._gettingCredPromise=I.a.makeQuerablePromise(this._keepAlive())),this._gettingCredPromise},e.prototype._keepAlive=function(){he.debug("checking if credentials exists and not expired");var e=this._credentials;return e&&!this._isExpired(e)?(he.debug("credentials not changed and not expired, directly return"),Promise.resolve(e)):(he.debug("need to get a new credential or refresh the existing one"),u.Auth&&"function"==typeof u.Auth.currentUserCredentials?u.Auth.currentUserCredentials():Promise.reject("No Auth module registered in Amplify"))},e.prototype.refreshFederatedToken=function(e){var t=this;he.debug("Getting federated credentials");var n=e.provider,r=e.user,o=e.token,i=e.expires_at,s=e.identity_id,a=this;return he.debug("checking if federated jwt token expired"),i>(new Date).getTime()?(he.debug("token not expired"),this._setCredentialsFromFederation({provider:n,token:o,user:r,identity_id:s,expires_at:i})):a._refreshHandlers[n]&&"function"==typeof a._refreshHandlers[n]?(he.debug("getting refreshed jwt token from federation provider"),a._refreshHandlers[n]().then((function(e){return he.debug("refresh federated token sucessfully",e),o=e.token,s=e.identity_id,i=e.expires_at,a._setCredentialsFromFederation({provider:n,token:o,user:r,identity_id:s,expires_at:i})})).catch((function(e){return he.debug("refresh federated token failed",e),t.clear(),Promise.reject("refreshing federation token failed: "+e)}))):(he.debug("no refresh handler for provider:",n),this.clear(),Promise.reject("no refresh handler for provider"))},e.prototype._isExpired=function(e){if(!e)return he.debug("no credentials for expiration check"),!0;he.debug("is this credentials expired?",e);var t=(new Date).getTime(),n=e.expired,r=e.expireTime;return!(!n&&r>t+6e5)},e.prototype._setCredentialsForGuest=function(){return le(this,void 0,void 0,(function(){var e,t,n,o,i,s,a,u=this;return fe(this,(function(c){switch(c.label){case 0:if(e=!1,he.debug("setting credentials for guest"),t=this._config,n=t.identityPoolId,o=t.region,t.mandatorySignIn)return[2,Promise.reject("cannot get guest credentials when mandatory signin enabled")];if(!n)return he.debug("No Cognito Federated Identity pool provided"),[2,Promise.reject("No Cognito Federated Identity pool provided")];i=void 0,c.label=1;case 1:return c.trys.push([1,3,,4]),[4,this._storageSync];case 2:return c.sent(),i=this._storage.getItem("CognitoIdentityId-"+n),[3,4];case 3:return s=c.sent(),he.debug("Failed to get the cached identityId",s),[3,4];case 4:return a=new r.CognitoIdentityCredentials({IdentityPoolId:n,IdentityId:i||void 0},{region:o}),this,[2,this._loadCredentials(a,"guest",!1,null).then((function(e){return e})).catch((function(t){return le(u,void 0,void 0,(function(){var s;return fe(this,(function(u){return"ResourceNotFoundException"!==t.code||t.message!=="Identity '"+i+"' not found."||e?[2,t]:(e=!0,he.debug("Failed to load guest credentials"),this._storage.removeItem("CognitoIdentityId-"+n),a.clearCachedId(),s=new r.CognitoIdentityCredentials({IdentityPoolId:n,IdentityId:void 0},{region:o}),[2,this._loadCredentials(s,"guest",!1,null)])}))}))}))]}}))}))},e.prototype._setCredentialsFromAWS=function(){var e=r.config.credentials;he.debug("setting credentials from aws");return e instanceof r.Credentials?Promise.resolve(e):(he.debug("AWS.config.credentials is not an instance of AWS Credentials"),Promise.reject("AWS.config.credentials is not an instance of AWS Credentials"))},e.prototype._setCredentialsFromFederation=function(e){var t=e.provider,n=e.token,o=e.identity_id,i=(e.user,e.expires_at,{google:"accounts.google.com",facebook:"graph.facebook.com",amazon:"www.amazon.com",developer:"cognito-identity.amazonaws.com"}[t]||t);if(!i)return Promise.reject("You must specify a federated provider");var s={};s[i]=n;var a=this._config,u=a.identityPoolId,c=a.region;if(!u)return he.debug("No Cognito Federated Identity pool provided"),Promise.reject("No Cognito Federated Identity pool provided");var l=new r.CognitoIdentityCredentials({IdentityPoolId:u,IdentityId:o,Logins:s},{region:c});return this._loadCredentials(l,"federated",!0,e)},e.prototype._setCredentialsFromSession=function(e){he.debug("set credentials from session");var t=e.getIdToken().getJwtToken(),n=this._config,o=n.region,i=n.userPoolId,s=n.identityPoolId;if(!s)return he.debug("No Cognito Federated Identity pool provided"),Promise.reject("No Cognito Federated Identity pool provided");var a={};a["cognito-idp."+o+".amazonaws.com/"+i]=t;var u=new r.CognitoIdentityCredentials({IdentityPoolId:s,Logins:a},{region:o});return this._loadCredentials(u,"userPool",!0,null)},e.prototype._loadCredentials=function(e,t,n,r){var o=this,i=this,s=this._config.identityPoolId;return new Promise((function(a,c){e.get((function(l){return le(o,void 0,void 0,(function(){var o,f,h,p,d,g;return fe(this,(function(y){switch(y.label){case 0:if(l)return he.debug("Failed to load credentials",e),c(l),[2];if(he.debug("Load credentials successfully",e),i._credentials=e,i._credentials.authenticated=n,i._credentials_source=t,"federated"!==t)return[3,3];o=Object.assign({id:this._credentials.identityId},r.user),f=r.provider,h=r.token,p=r.expires_at,d=r.identity_id;try{this._storage.setItem("aws-amplify-federatedInfo",JSON.stringify({provider:f,token:h,user:o,expires_at:p,identity_id:d}))}catch(e){he.debug("Failed to put federated info into auth storage",e)}return u.Cache&&"function"==typeof u.Cache.setItem?[4,u.Cache.setItem("federatedInfo",{provider:f,token:h,user:o,expires_at:p,identity_id:d},{priority:1})]:[3,2];case 1:return y.sent(),[3,3];case 2:he.debug("No Cache module registered in Amplify"),y.label=3;case 3:if("guest"!==t)return[3,7];y.label=4;case 4:return y.trys.push([4,6,,7]),[4,this._storageSync];case 5:return y.sent(),this._storage.setItem("CognitoIdentityId-"+s,e.identityId),[3,7];case 6:return g=y.sent(),he.debug("Failed to cache identityId",g),[3,7];case 7:return a(i._credentials),[2]}}))}))}))}))},e.prototype.set=function(e,t){return"session"===t?this._setCredentialsFromSession(e):"federation"===t?this._setCredentialsFromFederation(e):"guest"===t?this._setCredentialsForGuest():(he.debug("no source specified for setting credentials"),Promise.reject("invalid source"))},e.prototype.clear=function(){return le(this,void 0,void 0,(function(){var e,t,n;return fe(this,(function(o){switch(o.label){case 0:return e=this._config,t=e.identityPoolId,n=e.region,t&&new r.CognitoIdentityCredentials({IdentityPoolId:t},{region:n}).clearCachedId(),this._credentials=null,this._credentials_source=null,this._storage.removeItem("aws-amplify-federatedInfo"),u.Cache&&"function"==typeof u.Cache.setItem?[4,u.Cache.removeItem("federatedInfo")]:[3,2];case 1:return o.sent(),[3,3];case 2:he.debug("No Cache module registered in Amplify"),o.label=3;case 3:return[2]}}))}))},e.prototype.shear=function(e){return{accessKeyId:e.accessKeyId,sessionToken:e.sessionToken,secretAccessKey:e.secretAccessKey,identityId:e.identityId,authenticated:e.authenticated}},e}())(null);function de(e){return(de="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var ge=function(){function e(){this._logger=new s("ServiceWorker")}return Object.defineProperty(e.prototype,"serviceWorker",{get:function(){return this._serviceWorker},enumerable:!0,configurable:!0}),e.prototype.register=function(e,t){var n=this;return void 0===e&&(e="/service-worker.js"),void 0===t&&(t="/"),this._logger.debug("registering "+e),this._logger.debug("registering service worker with scope "+t),new Promise((function(r,o){if(!(navigator&&"serviceWorker"in navigator))return o(new Error("Service Worker not available"));navigator.serviceWorker.register(e,{scope:t}).then((function(e){return e.installing?n._serviceWorker=e.installing:e.waiting?n._serviceWorker=e.waiting:e.active&&(n._serviceWorker=e.active),n._registration=e,n._setupListeners(),n._logger.debug("Service Worker Registration Success: "+e),r(e)})).catch((function(e){return n._logger.debug("Service Worker Registration Failed "+e),o(e)}))}))},e.prototype.enablePush=function(e){var t=this;if(!this._registration)throw new Error("Service Worker not registered");return this._publicKey=e,new Promise((function(n,r){if(!I.a.browserOrNode().isBrowser)return r(new Error("Service Worker not available"));t._registration.pushManager.getSubscription().then((function(r){if(!r)return t._logger.debug("User is NOT subscribed to push"),t._registration.pushManager.subscribe({userVisibleOnly:!0,applicationServerKey:t._urlB64ToUint8Array(e)}).then((function(e){t._subscription=e,t._logger.debug("User subscribed: "+JSON.stringify(e)),n(e)})).catch((function(e){t._logger.error(e)}));t._subscription=r,t._logger.debug("User is subscribed to push: "+JSON.stringify(r)),n(r)}))}))},e.prototype._urlB64ToUint8Array=function(e){for(var t=(e+"=".repeat((4-e.length%4)%4)).replace(/\-/g,"+").replace(/_/g,"/"),n=window.atob(t),r=new Uint8Array(n.length),o=0;o<n.length;++o)r[o]=n.charCodeAt(o);return r},e.prototype.send=function(e){this._serviceWorker&&this._serviceWorker.postMessage("object"===de(e)?JSON.stringify(e):e)},e.prototype._setupListeners=function(){var e=this;this._serviceWorker.addEventListener("statechange",(function(t){var n=e._serviceWorker.state;e._logger.debug("ServiceWorker statechange: "+n),u.Analytics&&"function"==typeof u.Analytics.record&&u.Analytics.record({name:"ServiceWorker",attributes:{state:n}})})),this._serviceWorker.addEventListener("message",(function(t){e._logger.debug("ServiceWorker message event: "+t)}))},e}(),ye=n(11),ve={userAgent:"aws-amplify/"+ye.version+" js",product:"",navigator:null,isReactNative:!1};if("undefined"!=typeof navigator&&navigator.product)switch(ve.product=navigator.product||"",ve.navigator=navigator||null,navigator.product){case"ReactNative":ve.userAgent="aws-amplify/"+ye.version+" react-native",ve.isReactNative=!0;break;default:ve.userAgent="aws-amplify/"+ye.version+" js",ve.isReactNative=!1}var me=ve;n.d(t,"Constants",(function(){return be})),n.d(t,"AWS",(function(){return r})),n.d(t,"ClientDevice",(function(){return f})),n.d(t,"ConsoleLogger",(function(){return s})),n.d(t,"Logger",(function(){return s})),n.d(t,"missingConfig",(function(){return h})),n.d(t,"invalidParameter",(function(){return p})),n.d(t,"Hub",(function(){return m})),n.d(t,"I18n",(function(){return C})),n.d(t,"JS",(function(){return I.a})),n.d(t,"Signer",(function(){return G})),n.d(t,"Parser",(function(){return M})),n.d(t,"FacebookOAuth",(function(){return ne})),n.d(t,"GoogleOAuth",(function(){return te})),n.d(t,"Linking",(function(){return se})),n.d(t,"AppState",(function(){return ae})),n.d(t,"AsyncStorage",(function(){return ue})),n.d(t,"Credentials",(function(){return pe})),n.d(t,"ServiceWorker",(function(){return ge})),n.d(t,"StorageHelper",(function(){return ie})),n.d(t,"MemoryStorage",(function(){return oe})),n.d(t,"Platform",(function(){return me}));var be={userAgent:me.userAgent},we=(t.default=u,new s("Core"));r.util?r.util.userAgent=function(){return be.userAgent}:r.config?r.config.update({customUserAgent:be.userAgent}):we.warn("No AWS.config")}])}));
	//# sourceMappingURL=aws-amplify-core.min.js.map

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(81);
	
	var AWS = __webpack_require__(8);
	if (typeof window !== 'undefined') window.AWS = AWS;
	if (true) module.exports = AWS;
	if (typeof self !== 'undefined') self.AWS = AWS;

/***/ },
/* 279 */
[591, 81, 8, 309, 479, 480],
/* 280 */
/***/ function(module, exports) {

	function apiLoader(svc, version) {
	  if (!apiLoader.services.hasOwnProperty(svc)) {
	    throw new Error('InvalidService: Failed to load api for ' + svc);
	  }
	  return apiLoader.services[svc][version];
	}
	
	/**
	 * @api private
	 *
	 * This member of AWS.apiLoader is private, but changing it will necessitate a
	 * change to ../scripts/services-table-generator.ts
	 */
	apiLoader.services = {};
	
	/**
	 * @api private
	 */
	module.exports = apiLoader;


/***/ },
/* 281 */
[593, 282, 283, 284, 285],
/* 282 */
[594, 58],
/* 283 */
[595, 58],
/* 284 */
[596, 58],
/* 285 */
[597, 58],
/* 286 */
[599, 8, 139, 140],
/* 287 */
[602, 8, 45],
/* 288 */
[603, 8, 279, 45],
/* 289 */
[605, 8, 45],
/* 290 */
[606, 8, 45],
/* 291 */
[607, 8, 45],
/* 292 */
[608, 8, 12],
/* 293 */
[609, 294, 296],
/* 294 */
/***/ function(module, exports) {

	/**
	 * Takes in a buffer of event messages and splits them into individual messages.
	 * @param {Buffer} buffer
	 * @api private
	 */
	function eventMessageChunker(buffer) {
	    /** @type Buffer[] */
	    var messages = [];
	    var offset = 0;
	
	    while (offset < buffer.length) {
	        var totalLength = buffer.readInt32BE(offset);
	
	        // create new buffer for individual message (shares memory with original)
	        var message = buffer.slice(offset, totalLength + offset);
	        // increment offset to it starts at the next message
	        offset += totalLength;
	
	        messages.push(message);
	    }
	
	    return messages;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    eventMessageChunker: eventMessageChunker
	};


/***/ },
/* 295 */
[610, 8],
/* 296 */
[611, 297],
/* 297 */
[612, 295, 298],
/* 298 */
[613, 8],
/* 299 */
[614, 8, 150, 292, 85, 59, 148, 149, 147],
/* 300 */
[616, 8, 141],
/* 301 */
[625, 8],
/* 302 */
[632, 12],
/* 303 */
/***/ function(module, exports) {

	module.exports = {
	  //provide realtime clock for performance measurement
	  now: function now() {
	    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
	      return performance.now();
	    }
	    return Date.now();
	  }
	};


/***/ },
/* 304 */
[633, 12, 484],
/* 305 */
[634, 8, 318],
/* 306 */
[635, 8],
/* 307 */
[636, 8],
/* 308 */
[638, 8, 142, 304],
/* 309 */
[639, 8],
/* 310 */
[640, 8],
/* 311 */
[641, 8],
/* 312 */
[642, 8, 314, 151, 315, 316, 313, 311],
/* 313 */
[643, 8],
/* 314 */
[644, 8],
/* 315 */
[646, 8, 151],
/* 316 */
[647, 8, 317],
/* 317 */
[648, 8],
/* 318 */
/***/ function(module, exports) {

	function AcceptorStateMachine(states, state) {
	  this.currentState = state || null;
	  this.states = states || {};
	}
	
	AcceptorStateMachine.prototype.runTo = function runTo(finalState, done, bindObject, inputError) {
	  if (typeof finalState === 'function') {
	    inputError = bindObject; bindObject = done;
	    done = finalState; finalState = null;
	  }
	
	  var self = this;
	  var state = self.states[self.currentState];
	  state.fn.call(bindObject || self, inputError, function(err) {
	    if (err) {
	      if (state.fail) self.currentState = state.fail;
	      else return done ? done.call(bindObject, err) : null;
	    } else {
	      if (state.accept) self.currentState = state.accept;
	      else return done ? done.call(bindObject) : null;
	    }
	    if (self.currentState === finalState) {
	      return done ? done.call(bindObject, err) : null;
	    }
	
	    self.runTo(finalState, done, bindObject, err);
	  });
	};
	
	AcceptorStateMachine.prototype.addState = function addState(name, acceptState, failState, fn) {
	  if (typeof acceptState === 'function') {
	    fn = acceptState; acceptState = null; failState = null;
	  } else if (typeof failState === 'function') {
	    fn = failState; failState = null;
	  }
	
	  if (!this.currentState) this.currentState = name;
	  this.states[name] = { accept: acceptState, fail: failState, fn: fn };
	  return this;
	};
	
	/**
	 * @api private
	 */
	module.exports = AcceptorStateMachine;


/***/ },
/* 319 */
[650, 12, 46],
/* 320 */
[651, 12, 323, 324],
/* 321 */
/***/ function(module, exports) {

	/**
	 * Escapes characters that can not be in an XML attribute.
	 */
	function escapeAttribute(value) {
	    return value.replace(/&/g, '&amp;').replace(/'/g, '&apos;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    escapeAttribute: escapeAttribute
	};


/***/ },
/* 322 */
/***/ function(module, exports) {

	/**
	 * Escapes characters that can not be in an XML element.
	 */
	function escapeElement(value) {
	    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    escapeElement: escapeElement
	};


/***/ },
/* 323 */
[652, 321],
/* 324 */
[653, 322],
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var punycode = __webpack_require__(220);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(73);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a puny coded representation of "domain".
	      // It only converts the part of the domain name that
	      // has non ASCII characters. I.e. it dosent matter if
	      // you call it with a domain that already is in ASCII.
	      var domainArray = this.hostname.split('.');
	      var newOut = [];
	      for (var i = 0; i < domainArray.length; ++i) {
	        var s = domainArray[i];
	        newOut.push(s.match(/[^A-Za-z0-9_-]/) ?
	            'xn--' + punycode.encode(s) : s);
	      }
	      this.hostname = newOut.join('.');
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  Object.keys(this).forEach(function(k) {
	    result[k] = this[k];
	  }, this);
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    Object.keys(relative).forEach(function(k) {
	      if (k !== 'protocol')
	        result[k] = relative[k];
	    });
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      Object.keys(relative).forEach(function(k) {
	        result[k] = relative[k];
	      });
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especialy happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!isNull(result.pathname) || !isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host) && (last === '.' || last === '..') ||
	      last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last == '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especialy happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!isNull(result.pathname) || !isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};
	
	function isString(arg) {
	  return typeof arg === "string";
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isNull(arg) {
	  return arg === null;
	}
	function isNullOrUndefined(arg) {
	  return  arg == null;
	}


/***/ },
/* 326 */
[654, 327],
/* 327 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var LinkedListNode = /** @class */ (function () {
	    function LinkedListNode(key, value) {
	        this.key = key;
	        this.value = value;
	    }
	    return LinkedListNode;
	}());
	var LRUCache = /** @class */ (function () {
	    function LRUCache(size) {
	        this.nodeMap = {};
	        this.size = 0;
	        if (typeof size !== 'number' || size < 1) {
	            throw new Error('Cache size can only be positive number');
	        }
	        this.sizeLimit = size;
	    }
	    Object.defineProperty(LRUCache.prototype, "length", {
	        get: function () {
	            return this.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    LRUCache.prototype.prependToList = function (node) {
	        if (!this.headerNode) {
	            this.tailNode = node;
	        }
	        else {
	            this.headerNode.prev = node;
	            node.next = this.headerNode;
	        }
	        this.headerNode = node;
	        this.size++;
	    };
	    LRUCache.prototype.removeFromTail = function () {
	        if (!this.tailNode) {
	            return undefined;
	        }
	        var node = this.tailNode;
	        var prevNode = node.prev;
	        if (prevNode) {
	            prevNode.next = undefined;
	        }
	        node.prev = undefined;
	        this.tailNode = prevNode;
	        this.size--;
	        return node;
	    };
	    LRUCache.prototype.detachFromList = function (node) {
	        if (this.headerNode === node) {
	            this.headerNode = node.next;
	        }
	        if (this.tailNode === node) {
	            this.tailNode = node.prev;
	        }
	        if (node.prev) {
	            node.prev.next = node.next;
	        }
	        if (node.next) {
	            node.next.prev = node.prev;
	        }
	        node.next = undefined;
	        node.prev = undefined;
	        this.size--;
	    };
	    LRUCache.prototype.get = function (key) {
	        if (this.nodeMap[key]) {
	            var node = this.nodeMap[key];
	            this.detachFromList(node);
	            this.prependToList(node);
	            return node.value;
	        }
	    };
	    LRUCache.prototype.remove = function (key) {
	        if (this.nodeMap[key]) {
	            var node = this.nodeMap[key];
	            this.detachFromList(node);
	            delete this.nodeMap[key];
	        }
	    };
	    LRUCache.prototype.put = function (key, value) {
	        if (this.nodeMap[key]) {
	            this.remove(key);
	        }
	        else if (this.size === this.sizeLimit) {
	            var tailNode = this.removeFromTail();
	            var key_1 = tailNode.key;
	            delete this.nodeMap[key_1];
	        }
	        var newNode = new LinkedListNode(key, value);
	        this.nodeMap[key] = newNode;
	        this.prependToList(newNode);
	    };
	    LRUCache.prototype.empty = function () {
	        var keys = Object.keys(this.nodeMap);
	        for (var i = 0; i < keys.length; i++) {
	            var key = keys[i];
	            var node = this.nodeMap[key];
	            this.detachFromList(node);
	            delete this.nodeMap[key];
	        }
	    };
	    return LRUCache;
	}());
	exports.LRUCache = LRUCache;

/***/ },
/* 328 */
[655, 329, 330],
/* 329 */
[656, 153, 152],
/* 330 */
[657, 153, 152],
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e(__webpack_require__(26),__webpack_require__(364)):"function"==typeof define&&define.amd?define("aws_amplify_interactions",["@aws-amplify/core","aws-sdk/clients/lexruntime"],e):"object"==typeof exports?exports.aws_amplify_interactions=e(require("@aws-amplify/core"),require("aws-sdk/clients/lexruntime")):t.aws_amplify_interactions=e(t["@aws-amplify/core"],t["aws-sdk/clients/lexruntime"])}(this,(function(t,e){return function(t){var e={};function n(o){if(e[o])return e[o].exports;var r=e[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=t,n.c=e,n.d=function(t,e,o){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:o})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)n.d(o,r,function(e){return t[e]}.bind(null,r));return o},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=2)}([function(e,n){e.exports=t},function(t,n){t.exports=e},function(t,e,n){"use strict";n.r(e);var o,r=n(0),i=n.n(r),s=function(){return(s=Object.assign||function(t){for(var e,n=1,o=arguments.length;n<o;n++)for(var r in e=arguments[n])Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r]);return t}).apply(this,arguments)},a=new r.ConsoleLogger("AbstractInteractionsProvider"),u=function(){function t(t){void 0===t&&(t={}),this._config=t}return t.prototype.configure=function(t){return void 0===t&&(t={}),this._config=s(s({},this._config),t),a.debug("configure "+this.getProviderName(),this._config),this.options},t.prototype.getCategory=function(){return"Interactions"},Object.defineProperty(t.prototype,"options",{get:function(){return s({},this._config)},enumerable:!0,configurable:!0}),t}(),l=n(1),c=(o=function(t,e){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(t,e)},function(t,e){function n(){this.constructor=t}o(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)}),f=function(t,e,n,o){return new(n||(n=Promise))((function(r,i){function s(t){try{u(o.next(t))}catch(t){i(t)}}function a(t){try{u(o.throw(t))}catch(t){i(t)}}function u(t){var e;t.done?r(t.value):(e=t.value,e instanceof n?e:new n((function(t){t(e)}))).then(s,a)}u((o=o.apply(t,e||[])).next())}))},p=function(t,e){var n,o,r,i,s={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,o&&(r=2&i[0]?o.return:i[0]?o.throw||((r=o.return)&&r.call(o),0):o.next)&&!(r=r.call(o,i[1])).done)return r;switch(o=0,r&&(i=[2&i[0],r.value]),i[0]){case 0:case 1:r=i;break;case 4:return s.label++,{value:i[1],done:!1};case 5:s.label++,o=i[1],i=[0];continue;case 7:i=s.ops.pop(),s.trys.pop();continue;default:if(!(r=(r=s.trys).length>0&&r[r.length-1])&&(6===i[0]||2===i[0])){s=0;continue}if(3===i[0]&&(!r||i[1]>r[0]&&i[1]<r[3])){s.label=i[1];break}if(6===i[0]&&s.label<r[1]){s.label=r[1],r=i;break}if(r&&s.label<r[2]){s.label=r[2],s.ops.push(i);break}r[2]&&s.ops.pop(),s.trys.pop();continue}i=e.call(t,s)}catch(t){i=[6,t],o=0}finally{n=r=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,a])}}},d=new r.ConsoleLogger("AWSLexProvider"),g=function(t){function e(e){void 0===e&&(e={});var n=t.call(this,e)||this;return n.aws_lex=new l({region:n._config.region}),n._botsCompleteCallback={},n}return c(e,t),e.prototype.getProviderName=function(){return"AWSLexProvider"},e.prototype.responseCallback=function(t,e,n,o,r){var i=this;t?o(t):(d.debug("postContent state",e.dialogState),"ReadyForFulfillment"!==e.dialogState&&"Fulfilled"!==e.dialogState||("function"==typeof this._botsCompleteCallback[r]&&setTimeout((function(){return i._botsCompleteCallback[r](null,{slots:e.slots})}),0),this._config&&"function"==typeof this._config[r].onComplete&&setTimeout((function(){return i._config[r].onComplete(null,{slots:e.slots})}),0)),n(e),"Failed"===e.dialogState&&("function"==typeof this._botsCompleteCallback[r]&&setTimeout((function(){return i._botsCompleteCallback[r]("Bot conversation failed")}),0),this._config&&"function"==typeof this._config[r].onComplete&&setTimeout((function(){return i._config[r].onComplete("Bot conversation failed")}),0)))},e.prototype.sendMessage=function(t,e){var n=this;return new Promise((function(o,i){return f(n,void 0,void 0,(function(){var n,s,a=this;return p(this,(function(u){switch(u.label){case 0:return this._config[t]?[4,r.Credentials.get()]:[2,i("Bot "+t+" does not exist")];case 1:return(n=u.sent())?(r.AWS.config.update({credentials:n}),this.aws_lex=new l({region:this._config[t].region,credentials:n}),"string"==typeof e?(s={botAlias:this._config[t].alias,botName:t,inputText:e,userId:n.identityId},d.debug("postText to lex",e),this.aws_lex.postText(s,(function(e,n){a.responseCallback(e,n,o,i,t)}))):(s="voice"===e.options.messageType?{botAlias:this._config[t].alias,botName:t,contentType:"audio/x-l16; sample-rate=16000",inputStream:e.content,userId:n.identityId,accept:"audio/mpeg"}:{botAlias:this._config[t].alias,botName:t,contentType:"text/plain; charset=utf-8",inputStream:e.content,userId:n.identityId,accept:"audio/mpeg"},d.debug("postContent to lex",e),this.aws_lex.postContent(s,(function(e,n){a.responseCallback(e,n,o,i,t)}))),[2]):[2,i("No credentials")]}}))}))}))},e.prototype.onComplete=function(t,e){if(!this._config[t])throw new ErrorEvent("Bot "+t+" does not exist");this._botsCompleteCallback[t]=e},e}(u),b=function(){return(b=Object.assign||function(t){for(var e,n=1,o=arguments.length;n<o;n++)for(var r in e=arguments[n])Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r]);return t}).apply(this,arguments)},h=function(t,e,n,o){return new(n||(n=Promise))((function(r,i){function s(t){try{u(o.next(t))}catch(t){i(t)}}function a(t){try{u(o.throw(t))}catch(t){i(t)}}function u(t){var e;t.done?r(t.value):(e=t.value,e instanceof n?e:new n((function(t){t(e)}))).then(s,a)}u((o=o.apply(t,e||[])).next())}))},y=function(t,e){var n,o,r,i,s={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,o&&(r=2&i[0]?o.return:i[0]?o.throw||((r=o.return)&&r.call(o),0):o.next)&&!(r=r.call(o,i[1])).done)return r;switch(o=0,r&&(i=[2&i[0],r.value]),i[0]){case 0:case 1:r=i;break;case 4:return s.label++,{value:i[1],done:!1};case 5:s.label++,o=i[1],i=[0];continue;case 7:i=s.ops.pop(),s.trys.pop();continue;default:if(!(r=(r=s.trys).length>0&&r[r.length-1])&&(6===i[0]||2===i[0])){s=0;continue}if(3===i[0]&&(!r||i[1]>r[0]&&i[1]<r[3])){s.label=i[1];break}if(6===i[0]&&s.label<r[1]){s.label=r[1],r=i;break}if(r&&s.label<r[2]){s.label=r[2],s.ops.push(i);break}r[2]&&s.ops.pop(),s.trys.pop();continue}i=e.call(t,s)}catch(t){i=[6,t],o=0}finally{n=r=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,a])}}},_=new r.ConsoleLogger("Interactions"),v=function(){function t(t){this._options=t,_.debug("Interactions Options",this._options),this._pluggables={}}return t.prototype.getModuleName=function(){return"Interactions"},t.prototype.configure=function(t){var e=this,n=t?t.Interactions||t:{};_.debug("configure Interactions",{opt:n}),this._options=b(b({bots:{}},n),n.Interactions);var o=this._options.aws_bots_config,r=this._options.bots;return!Object.keys(r).length&&o&&Array.isArray(o)&&o.forEach((function(t){e._options.bots[t.name]=t})),!this._pluggables.AWSLexProvider&&r&&Object.keys(r).map((function(t){return r[t]})).find((function(t){return!t.providerName||"AWSLexProvider"===t.providerName}))&&(this._pluggables.AWSLexProvider=new g),Object.keys(this._pluggables).map((function(t){e._pluggables[t].configure(e._options.bots)})),this._options},t.prototype.addPluggable=function(t){if(t&&"Interactions"===t.getCategory()){if(this._pluggables[t.getProviderName()])throw new Error("Bot "+t.getProviderName()+" already plugged");return t.configure(this._options.bots),void(this._pluggables[t.getProviderName()]=t)}},t.prototype.send=function(t,e){return h(this,void 0,void 0,(function(){var n;return y(this,(function(o){switch(o.label){case 0:if(!this._options.bots||!this._options.bots[t])throw new Error("Bot "+t+" does not exist");if(n=this._options.bots[t].providerName||"AWSLexProvider",!this._pluggables[n])throw new Error("Bot "+n+" does not have valid pluggin did you try addPluggable first?");return[4,this._pluggables[n].sendMessage(t,e)];case 1:return[2,o.sent()]}}))}))},t.prototype.onComplete=function(t,e){if(!this._options.bots||!this._options.bots[t])throw new Error("Bot "+t+" does not exist");var n=this._options.bots[t].providerName||"AWSLexProvider";if(!this._pluggables[n])throw new Error("Bot "+n+" does not have valid pluggin did you try addPluggable first?");this._pluggables[n].onComplete(t,e)},t}();n.d(e,"AWSLexProvider",(function(){return g})),n.d(e,"InteractionsClass",(function(){return v}));var m=new r.ConsoleLogger("Interactions"),w=null;w||(m.debug("Create Interactions Instance"),w=new v(null));var x=w;i.a.register(x);e.default=x}])}));
	//# sourceMappingURL=aws-amplify-interactions.min.js.map

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
		module.exports = __webpack_require__(331);
	} else {
		module.exports = require('./dist/aws-amplify-interactions.js');
	}


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(26)):"function"==typeof define&&define.amd?define("aws_amplify_pubsub",["@aws-amplify/core"],t):"object"==typeof exports?exports.aws_amplify_pubsub=t(require("@aws-amplify/core")):e.aws_amplify_pubsub=t(e["@aws-amplify/core"])}(this,(function(e){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=11)}([function(t,n){t.exports=e},function(e,t,n){e.exports=n(7).Observable},function(e,t){var n="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof window.msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto);if(n){var r=new Uint8Array(16);e.exports=function(){return n(r),r}}else{var o=new Array(16);e.exports=function(){for(var e,t=0;t<16;t++)0==(3&t)&&(e=4294967296*Math.random()),o[t]=e>>>((3&t)<<3)&255;return o}}},function(e,t){for(var n=[],r=0;r<256;++r)n[r]=(r+256).toString(16).substr(1);e.exports=function(e,t){var r=t||0,o=n;return[o[e[r++]],o[e[r++]],o[e[r++]],o[e[r++]],"-",o[e[r++]],o[e[r++]],"-",o[e[r++]],o[e[r++]],"-",o[e[r++]],o[e[r++]],"-",o[e[r++]],o[e[r++]],o[e[r++]],o[e[r++]],o[e[r++]],o[e[r++]]].join("")}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r="undefined"!=typeof Symbol&&"function"==typeof Symbol.for;t.INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER=r?Symbol.for("INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER"):"@@INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER"},function(e,t,n){(function(t){var n;n=function(){return function(e){var t,n=e.localStorage||(t={},{setItem:function(e,n){t[e]=n},getItem:function(e){return t[e]},removeItem:function(e){delete t[e]}}),r=1,o=2,i=3,s=4,c=5,a=6,u=7,f=8,l=9,h=10,p=11,d=12,_=13,g=14,v=function(e,t){for(var n in e)if(e.hasOwnProperty(n)){if(!t.hasOwnProperty(n)){var r="Unknown property, "+n+". Valid properties are:";for(var o in t)t.hasOwnProperty(o)&&(r=r+" "+o);throw new Error(r)}if(typeof e[n]!==t[n])throw new Error(m(b.INVALID_TYPE,[typeof e[n],n]))}},y=function(e,t){return function(){return e.apply(t,arguments)}},b={OK:{code:0,text:"AMQJSC0000I OK."},CONNECT_TIMEOUT:{code:1,text:"AMQJSC0001E Connect timed out."},SUBSCRIBE_TIMEOUT:{code:2,text:"AMQJS0002E Subscribe timed out."},UNSUBSCRIBE_TIMEOUT:{code:3,text:"AMQJS0003E Unsubscribe timed out."},PING_TIMEOUT:{code:4,text:"AMQJS0004E Ping timed out."},INTERNAL_ERROR:{code:5,text:"AMQJS0005E Internal error. Error Message: {0}, Stack trace: {1}"},CONNACK_RETURNCODE:{code:6,text:"AMQJS0006E Bad Connack return code:{0} {1}."},SOCKET_ERROR:{code:7,text:"AMQJS0007E Socket error:{0}."},SOCKET_CLOSE:{code:8,text:"AMQJS0008I Socket closed."},MALFORMED_UTF:{code:9,text:"AMQJS0009E Malformed UTF data:{0} {1} {2}."},UNSUPPORTED:{code:10,text:"AMQJS0010E {0} is not supported by this browser."},INVALID_STATE:{code:11,text:"AMQJS0011E Invalid state {0}."},INVALID_TYPE:{code:12,text:"AMQJS0012E Invalid type {0} for {1}."},INVALID_ARGUMENT:{code:13,text:"AMQJS0013E Invalid argument {0} for {1}."},UNSUPPORTED_OPERATION:{code:14,text:"AMQJS0014E Unsupported operation."},INVALID_STORED_DATA:{code:15,text:"AMQJS0015E Invalid data in local storage key={0} value={1}."},INVALID_MQTT_MESSAGE_TYPE:{code:16,text:"AMQJS0016E Invalid MQTT message type {0}."},MALFORMED_UNICODE:{code:17,text:"AMQJS0017E Malformed Unicode string:{0} {1}."},BUFFER_FULL:{code:18,text:"AMQJS0018E Message buffer is full, maximum buffer size: {0}."}},w={0:"Connection Accepted",1:"Connection Refused: unacceptable protocol version",2:"Connection Refused: identifier rejected",3:"Connection Refused: server unavailable",4:"Connection Refused: bad user name or password",5:"Connection Refused: not authorized"},m=function(e,t){var n=e.text;if(t)for(var r,o,i=0;i<t.length;i++)if(r="{"+i+"}",(o=n.indexOf(r))>0){var s=n.substring(0,o),c=n.substring(o+r.length);n=s+t[i]+c}return n},E=[0,6,77,81,73,115,100,112,3],I=[0,4,77,81,84,84,4],O=function(e,t){for(var n in this.type=e,t)t.hasOwnProperty(n)&&(this[n]=t[n])};function S(e,t){var n,r=t,f=e[t],h=f>>4,d=f&=15;t+=1;var _=0,g=1;do{if(t==e.length)return[null,r];_+=(127&(n=e[t++]))*g,g*=128}while(0!=(128&n));var v=t+_;if(v>e.length)return[null,r];var y=new O(h);switch(h){case o:1&e[t++]&&(y.sessionPresent=!0),y.returnCode=e[t++];break;case i:var b=d>>1&3,w=T(e,t),m=C(e,t+=2,w);t+=w,b>0&&(y.messageIdentifier=T(e,t),t+=2);var E=new U(e.subarray(t,v));1==(1&d)&&(E.retained=!0),8==(8&d)&&(E.duplicate=!0),E.qos=b,E.destinationName=m,y.payloadMessage=E;break;case s:case c:case a:case u:case p:y.messageIdentifier=T(e,t);break;case l:y.messageIdentifier=T(e,t),t+=2,y.returnCode=e.subarray(t,v)}return[y,v]}function M(e,t,n){return t[n++]=e>>8,t[n++]=e%256,n}function A(e,t,n,r){return P(e,n,r=M(t,n,r)),r+t}function T(e,t){return 256*e[t]+e[t+1]}function N(e){for(var t=0,n=0;n<e.length;n++){var r=e.charCodeAt(n);r>2047?(55296<=r&&r<=56319&&(n++,t++),t+=3):r>127?t+=2:t++}return t}function P(e,t,n){for(var r=n,o=0;o<e.length;o++){var i=e.charCodeAt(o);if(55296<=i&&i<=56319){var s=e.charCodeAt(++o);if(isNaN(s))throw new Error(m(b.MALFORMED_UNICODE,[i,s]));i=s-56320+(i-55296<<10)+65536}i<=127?t[r++]=i:i<=2047?(t[r++]=i>>6&31|192,t[r++]=63&i|128):i<=65535?(t[r++]=i>>12&15|224,t[r++]=i>>6&63|128,t[r++]=63&i|128):(t[r++]=i>>18&7|240,t[r++]=i>>12&63|128,t[r++]=i>>6&63|128,t[r++]=63&i|128)}return t}function C(e,t,n){for(var r,o="",i=t;i<t+n;){var s=e[i++];if(s<128)r=s;else{var c=e[i++]-128;if(c<0)throw new Error(m(b.MALFORMED_UTF,[s.toString(16),c.toString(16),""]));if(s<224)r=64*(s-192)+c;else{var a=e[i++]-128;if(a<0)throw new Error(m(b.MALFORMED_UTF,[s.toString(16),c.toString(16),a.toString(16)]));if(s<240)r=4096*(s-224)+64*c+a;else{var u=e[i++]-128;if(u<0)throw new Error(m(b.MALFORMED_UTF,[s.toString(16),c.toString(16),a.toString(16),u.toString(16)]));if(!(s<248))throw new Error(m(b.MALFORMED_UTF,[s.toString(16),c.toString(16),a.toString(16),u.toString(16)]));r=262144*(s-240)+4096*c+64*a+u}}}r>65535&&(r-=65536,o+=String.fromCharCode(55296+(r>>10)),r=56320+(1023&r)),o+=String.fromCharCode(r)}return o}O.prototype.encode=function(){var e,t=(15&this.type)<<4,n=0,o=[],s=0;switch(void 0!==this.messageIdentifier&&(n+=2),this.type){case r:switch(this.mqttVersion){case 3:n+=E.length+3;break;case 4:n+=I.length+3}n+=N(this.clientId)+2,void 0!==this.willMessage&&(n+=N(this.willMessage.destinationName)+2,(e=this.willMessage.payloadBytes)instanceof Uint8Array||(e=new Uint8Array(u)),n+=e.byteLength+2),void 0!==this.userName&&(n+=N(this.userName)+2),void 0!==this.password&&(n+=N(this.password)+2);break;case f:t|=2;for(var c=0;c<this.topics.length;c++)o[c]=N(this.topics[c]),n+=o[c]+2;n+=this.requestedQos.length;break;case h:for(t|=2,c=0;c<this.topics.length;c++)o[c]=N(this.topics[c]),n+=o[c]+2;break;case a:t|=2;break;case i:this.payloadMessage.duplicate&&(t|=8),t=t|=this.payloadMessage.qos<<1,this.payloadMessage.retained&&(t|=1),n+=(s=N(this.payloadMessage.destinationName))+2;var u=this.payloadMessage.payloadBytes;n+=u.byteLength,u instanceof ArrayBuffer?u=new Uint8Array(u):u instanceof Uint8Array||(u=new Uint8Array(u.buffer))}var l=function(e){var t=new Array(1),n=0;do{var r=e%128;(e>>=7)>0&&(r|=128),t[n++]=r}while(e>0&&n<4);return t}(n),p=l.length+1,d=new ArrayBuffer(n+p),_=new Uint8Array(d);if(_[0]=t,_.set(l,1),this.type==i)p=A(this.payloadMessage.destinationName,s,_,p);else if(this.type==r){switch(this.mqttVersion){case 3:_.set(E,p),p+=E.length;break;case 4:_.set(I,p),p+=I.length}var g=0;this.cleanSession&&(g=2),void 0!==this.willMessage&&(g|=4,g|=this.willMessage.qos<<3,this.willMessage.retained&&(g|=32)),void 0!==this.userName&&(g|=128),void 0!==this.password&&(g|=64),_[p++]=g,p=M(this.keepAliveInterval,_,p)}switch(void 0!==this.messageIdentifier&&(p=M(this.messageIdentifier,_,p)),this.type){case r:p=A(this.clientId,N(this.clientId),_,p),void 0!==this.willMessage&&(p=A(this.willMessage.destinationName,N(this.willMessage.destinationName),_,p),p=M(e.byteLength,_,p),_.set(e,p),p+=e.byteLength),void 0!==this.userName&&(p=A(this.userName,N(this.userName),_,p)),void 0!==this.password&&(p=A(this.password,N(this.password),_,p));break;case i:_.set(u,p);break;case f:for(c=0;c<this.topics.length;c++)p=A(this.topics[c],o[c],_,p),_[p++]=this.requestedQos[c];break;case h:for(c=0;c<this.topics.length;c++)p=A(this.topics[c],o[c],_,p)}return d};var k=function(e,t){this._client=e,this._keepAliveInterval=1e3*t,this.isReset=!1;var n=new O(d).encode(),r=function(e){return function(){return o.apply(e)}},o=function(){this.isReset?(this.isReset=!1,this._client._trace("Pinger.doPing","send PINGREQ"),this._client.socket.send(n),this.timeout=setTimeout(r(this),this._keepAliveInterval)):(this._client._trace("Pinger.doPing","Timed out"),this._client._disconnected(b.PING_TIMEOUT.code,m(b.PING_TIMEOUT)))};this.reset=function(){this.isReset=!0,clearTimeout(this.timeout),this._keepAliveInterval>0&&(this.timeout=setTimeout(r(this),this._keepAliveInterval))},this.cancel=function(){clearTimeout(this.timeout)}},x=function(e,t,n,r){t||(t=30),this.timeout=setTimeout(function(e,t,n){return function(){return e.apply(t,n)}}(n,e,r),1e3*t),this.cancel=function(){clearTimeout(this.timeout)}},R=function(t,r,o,i,s){if(!("WebSocket"in e&&null!==e.WebSocket))throw new Error(m(b.UNSUPPORTED,["WebSocket"]));if(!("ArrayBuffer"in e&&null!==e.ArrayBuffer))throw new Error(m(b.UNSUPPORTED,["ArrayBuffer"]));for(var c in this._trace("Paho.Client",t,r,o,i,s),this.host=r,this.port=o,this.path=i,this.uri=t,this.clientId=s,this._wsuri=null,this._localKey=r+":"+o+("/mqtt"!=i?":"+i:"")+":"+s+":",this._msg_queue=[],this._buffered_msg_queue=[],this._sentMessages={},this._receivedMessages={},this._notify_msg_sent={},this._message_identifier=1,this._sequence=0,n)0!==c.indexOf("Sent:"+this._localKey)&&0!==c.indexOf("Received:"+this._localKey)||this.restore(c)};R.prototype.host=null,R.prototype.port=null,R.prototype.path=null,R.prototype.uri=null,R.prototype.clientId=null,R.prototype.socket=null,R.prototype.connected=!1,R.prototype.maxMessageIdentifier=65536,R.prototype.connectOptions=null,R.prototype.hostIndex=null,R.prototype.onConnected=null,R.prototype.onConnectionLost=null,R.prototype.onMessageDelivered=null,R.prototype.onMessageArrived=null,R.prototype.traceFunction=null,R.prototype._msg_queue=null,R.prototype._buffered_msg_queue=null,R.prototype._connectTimeout=null,R.prototype.sendPinger=null,R.prototype.receivePinger=null,R.prototype._reconnectInterval=1,R.prototype._reconnecting=!1,R.prototype._reconnectTimeout=null,R.prototype.disconnectedPublishing=!1,R.prototype.disconnectedBufferSize=5e3,R.prototype.receiveBuffer=null,R.prototype._traceBuffer=null,R.prototype._MAX_TRACE_ENTRIES=100,R.prototype.connect=function(e){var t=this._traceMask(e,"password");if(this._trace("Client.connect",t,this.socket,this.connected),this.connected)throw new Error(m(b.INVALID_STATE,["already connected"]));if(this.socket)throw new Error(m(b.INVALID_STATE,["already connected"]));this._reconnecting&&(this._reconnectTimeout.cancel(),this._reconnectTimeout=null,this._reconnecting=!1),this.connectOptions=e,this._reconnectInterval=1,this._reconnecting=!1,e.uris?(this.hostIndex=0,this._doConnect(e.uris[0])):this._doConnect(this.uri)},R.prototype.subscribe=function(e,t){if(this._trace("Client.subscribe",e,t),!this.connected)throw new Error(m(b.INVALID_STATE,["not connected"]));var n=new O(f);n.topics=e.constructor===Array?e:[e],void 0===t.qos&&(t.qos=0),n.requestedQos=[];for(var r=0;r<n.topics.length;r++)n.requestedQos[r]=t.qos;t.onSuccess&&(n.onSuccess=function(e){t.onSuccess({invocationContext:t.invocationContext,grantedQos:e})}),t.onFailure&&(n.onFailure=function(e){t.onFailure({invocationContext:t.invocationContext,errorCode:e,errorMessage:m(e)})}),t.timeout&&(n.timeOut=new x(this,t.timeout,t.onFailure,[{invocationContext:t.invocationContext,errorCode:b.SUBSCRIBE_TIMEOUT.code,errorMessage:m(b.SUBSCRIBE_TIMEOUT)}])),this._requires_ack(n),this._schedule_message(n)},R.prototype.unsubscribe=function(e,t){if(this._trace("Client.unsubscribe",e,t),!this.connected)throw new Error(m(b.INVALID_STATE,["not connected"]));var n=new O(h);n.topics=e.constructor===Array?e:[e],t.onSuccess&&(n.callback=function(){t.onSuccess({invocationContext:t.invocationContext})}),t.timeout&&(n.timeOut=new x(this,t.timeout,t.onFailure,[{invocationContext:t.invocationContext,errorCode:b.UNSUBSCRIBE_TIMEOUT.code,errorMessage:m(b.UNSUBSCRIBE_TIMEOUT)}])),this._requires_ack(n),this._schedule_message(n)},R.prototype.send=function(e){this._trace("Client.send",e);var t=new O(i);if(t.payloadMessage=e,this.connected)e.qos>0?this._requires_ack(t):this.onMessageDelivered&&(this._notify_msg_sent[t]=this.onMessageDelivered(t.payloadMessage)),this._schedule_message(t);else{if(!this._reconnecting||!this.disconnectedPublishing)throw new Error(m(b.INVALID_STATE,["not connected"]));if(Object.keys(this._sentMessages).length+this._buffered_msg_queue.length>this.disconnectedBufferSize)throw new Error(m(b.BUFFER_FULL,[this.disconnectedBufferSize]));e.qos>0?this._requires_ack(t):(t.sequence=++this._sequence,this._buffered_msg_queue.unshift(t))}},R.prototype.disconnect=function(){if(this._trace("Client.disconnect"),this._reconnecting&&(this._reconnectTimeout.cancel(),this._reconnectTimeout=null,this._reconnecting=!1),!this.socket)throw new Error(m(b.INVALID_STATE,["not connecting or connected"]));var e=new O(g);this._notify_msg_sent[e]=y(this._disconnected,this),this._schedule_message(e)},R.prototype.getTraceLog=function(){if(null!==this._traceBuffer){for(var e in this._trace("Client.getTraceLog",new Date),this._trace("Client.getTraceLog in flight messages",this._sentMessages.length),this._sentMessages)this._trace("_sentMessages ",e,this._sentMessages[e]);for(var e in this._receivedMessages)this._trace("_receivedMessages ",e,this._receivedMessages[e]);return this._traceBuffer}},R.prototype.startTrace=function(){null===this._traceBuffer&&(this._traceBuffer=[]),this._trace("Client.startTrace",new Date,"@VERSION@-@BUILDLEVEL@")},R.prototype.stopTrace=function(){delete this._traceBuffer},R.prototype._doConnect=function(e){if(this.connectOptions.useSSL){var t=e.split(":");t[0]="wss",e=t.join(":")}this._wsuri=e,this.connected=!1,this.connectOptions.mqttVersion<4?this.socket=new WebSocket(e,["mqttv3.1"]):this.socket=new WebSocket(e,["mqtt"]),this.socket.binaryType="arraybuffer",this.socket.onopen=y(this._on_socket_open,this),this.socket.onmessage=y(this._on_socket_message,this),this.socket.onerror=y(this._on_socket_error,this),this.socket.onclose=y(this._on_socket_close,this),this.sendPinger=new k(this,this.connectOptions.keepAliveInterval),this.receivePinger=new k(this,this.connectOptions.keepAliveInterval),this._connectTimeout&&(this._connectTimeout.cancel(),this._connectTimeout=null),this._connectTimeout=new x(this,this.connectOptions.timeout,this._disconnected,[b.CONNECT_TIMEOUT.code,m(b.CONNECT_TIMEOUT)])},R.prototype._schedule_message=function(e){this._msg_queue.unshift(e),this.connected&&this._process_queue()},R.prototype.store=function(e,t){var r={type:t.type,messageIdentifier:t.messageIdentifier,version:1};switch(t.type){case i:t.pubRecReceived&&(r.pubRecReceived=!0),r.payloadMessage={};for(var o="",s=t.payloadMessage.payloadBytes,c=0;c<s.length;c++)s[c]<=15?o=o+"0"+s[c].toString(16):o+=s[c].toString(16);r.payloadMessage.payloadHex=o,r.payloadMessage.qos=t.payloadMessage.qos,r.payloadMessage.destinationName=t.payloadMessage.destinationName,t.payloadMessage.duplicate&&(r.payloadMessage.duplicate=!0),t.payloadMessage.retained&&(r.payloadMessage.retained=!0),0===e.indexOf("Sent:")&&(void 0===t.sequence&&(t.sequence=++this._sequence),r.sequence=t.sequence);break;default:throw Error(m(b.INVALID_STORED_DATA,[e+this._localKey+t.messageIdentifier,r]))}n.setItem(e+this._localKey+t.messageIdentifier,JSON.stringify(r))},R.prototype.restore=function(e){var t=n.getItem(e),r=JSON.parse(t),o=new O(r.type,r);switch(r.type){case i:for(var s=r.payloadMessage.payloadHex,c=new ArrayBuffer(s.length/2),a=new Uint8Array(c),u=0;s.length>=2;){var f=parseInt(s.substring(0,2),16);s=s.substring(2,s.length),a[u++]=f}var l=new U(a);l.qos=r.payloadMessage.qos,l.destinationName=r.payloadMessage.destinationName,r.payloadMessage.duplicate&&(l.duplicate=!0),r.payloadMessage.retained&&(l.retained=!0),o.payloadMessage=l;break;default:throw Error(m(b.INVALID_STORED_DATA,[e,t]))}0===e.indexOf("Sent:"+this._localKey)?(o.payloadMessage.duplicate=!0,this._sentMessages[o.messageIdentifier]=o):0===e.indexOf("Received:"+this._localKey)&&(this._receivedMessages[o.messageIdentifier]=o)},R.prototype._process_queue=function(){for(var e=null;e=this._msg_queue.pop();)this._socket_send(e),this._notify_msg_sent[e]&&(this._notify_msg_sent[e](),delete this._notify_msg_sent[e])},R.prototype._requires_ack=function(e){var t=Object.keys(this._sentMessages).length;if(t>this.maxMessageIdentifier)throw Error("Too many messages:"+t);for(;void 0!==this._sentMessages[this._message_identifier];)this._message_identifier++;e.messageIdentifier=this._message_identifier,this._sentMessages[e.messageIdentifier]=e,e.type===i&&this.store("Sent:",e),this._message_identifier===this.maxMessageIdentifier&&(this._message_identifier=1)},R.prototype._on_socket_open=function(){var e=new O(r,this.connectOptions);e.clientId=this.clientId,this._socket_send(e)},R.prototype._on_socket_message=function(e){this._trace("Client._on_socket_message",e.data);for(var t=this._deframeMessages(e.data),n=0;n<t.length;n+=1)this._handleMessage(t[n])},R.prototype._deframeMessages=function(e){var t=new Uint8Array(e),n=[];if(this.receiveBuffer){var r=new Uint8Array(this.receiveBuffer.length+t.length);r.set(this.receiveBuffer),r.set(t,this.receiveBuffer.length),t=r,delete this.receiveBuffer}try{for(var o=0;o<t.length;){var i=S(t,o),s=i[0];if(o=i[1],null===s)break;n.push(s)}o<t.length&&(this.receiveBuffer=t.subarray(o))}catch(e){var c="undefined"==e.hasOwnProperty("stack")?e.stack.toString():"No Error Stack Available";return void this._disconnected(b.INTERNAL_ERROR.code,m(b.INTERNAL_ERROR,[e.message,c]))}return n},R.prototype._handleMessage=function(e){this._trace("Client._handleMessage",e);try{switch(e.type){case o:if(this._connectTimeout.cancel(),this._reconnectTimeout&&this._reconnectTimeout.cancel(),this.connectOptions.cleanSession){for(var t in this._sentMessages){var r=this._sentMessages[t];n.removeItem("Sent:"+this._localKey+r.messageIdentifier)}for(var t in this._sentMessages={},this._receivedMessages){var f=this._receivedMessages[t];n.removeItem("Received:"+this._localKey+f.messageIdentifier)}this._receivedMessages={}}if(0!==e.returnCode){this._disconnected(b.CONNACK_RETURNCODE.code,m(b.CONNACK_RETURNCODE,[e.returnCode,w[e.returnCode]]));break}this.connected=!0,this.connectOptions.uris&&(this.hostIndex=this.connectOptions.uris.length);var h=[];for(var d in this._sentMessages)this._sentMessages.hasOwnProperty(d)&&h.push(this._sentMessages[d]);if(this._buffered_msg_queue.length>0)for(var v=null;v=this._buffered_msg_queue.pop();)h.push(v),this.onMessageDelivered&&(this._notify_msg_sent[v]=this.onMessageDelivered(v.payloadMessage));h=h.sort((function(e,t){return e.sequence-t.sequence}));for(var y=0,E=h.length;y<E;y++)if((r=h[y]).type==i&&r.pubRecReceived){var I=new O(a,{messageIdentifier:r.messageIdentifier});this._schedule_message(I)}else this._schedule_message(r);this.connectOptions.onSuccess&&this.connectOptions.onSuccess({invocationContext:this.connectOptions.invocationContext});var S=!1;this._reconnecting&&(S=!0,this._reconnectInterval=1,this._reconnecting=!1),this._connected(S,this._wsuri),this._process_queue();break;case i:this._receivePublish(e);break;case s:(r=this._sentMessages[e.messageIdentifier])&&(delete this._sentMessages[e.messageIdentifier],n.removeItem("Sent:"+this._localKey+e.messageIdentifier),this.onMessageDelivered&&this.onMessageDelivered(r.payloadMessage));break;case c:(r=this._sentMessages[e.messageIdentifier])&&(r.pubRecReceived=!0,I=new O(a,{messageIdentifier:e.messageIdentifier}),this.store("Sent:",r),this._schedule_message(I));break;case a:f=this._receivedMessages[e.messageIdentifier],n.removeItem("Received:"+this._localKey+e.messageIdentifier),f&&(this._receiveMessage(f),delete this._receivedMessages[e.messageIdentifier]);var M=new O(u,{messageIdentifier:e.messageIdentifier});this._schedule_message(M);break;case u:r=this._sentMessages[e.messageIdentifier],delete this._sentMessages[e.messageIdentifier],n.removeItem("Sent:"+this._localKey+e.messageIdentifier),this.onMessageDelivered&&this.onMessageDelivered(r.payloadMessage);break;case l:(r=this._sentMessages[e.messageIdentifier])&&(r.timeOut&&r.timeOut.cancel(),128===e.returnCode[0]?r.onFailure&&r.onFailure(e.returnCode):r.onSuccess&&r.onSuccess(e.returnCode),delete this._sentMessages[e.messageIdentifier]);break;case p:(r=this._sentMessages[e.messageIdentifier])&&(r.timeOut&&r.timeOut.cancel(),r.callback&&r.callback(),delete this._sentMessages[e.messageIdentifier]);break;case _:this.sendPinger.reset();break;case g:this._disconnected(b.INVALID_MQTT_MESSAGE_TYPE.code,m(b.INVALID_MQTT_MESSAGE_TYPE,[e.type]));break;default:this._disconnected(b.INVALID_MQTT_MESSAGE_TYPE.code,m(b.INVALID_MQTT_MESSAGE_TYPE,[e.type]))}}catch(e){var A="undefined"==e.hasOwnProperty("stack")?e.stack.toString():"No Error Stack Available";return void this._disconnected(b.INTERNAL_ERROR.code,m(b.INTERNAL_ERROR,[e.message,A]))}},R.prototype._on_socket_error=function(e){this._reconnecting||this._disconnected(b.SOCKET_ERROR.code,m(b.SOCKET_ERROR,[e.data]))},R.prototype._on_socket_close=function(){this._reconnecting||this._disconnected(b.SOCKET_CLOSE.code,m(b.SOCKET_CLOSE))},R.prototype._socket_send=function(e){if(1==e.type){var t=this._traceMask(e,"password");this._trace("Client._socket_send",t)}else this._trace("Client._socket_send",e);this.socket.send(e.encode()),this.sendPinger.reset()},R.prototype._receivePublish=function(e){switch(e.payloadMessage.qos){case"undefined":case 0:this._receiveMessage(e);break;case 1:var t=new O(s,{messageIdentifier:e.messageIdentifier});this._schedule_message(t),this._receiveMessage(e);break;case 2:this._receivedMessages[e.messageIdentifier]=e,this.store("Received:",e);var n=new O(c,{messageIdentifier:e.messageIdentifier});this._schedule_message(n);break;default:throw Error("Invaild qos="+e.payloadMessage.qos)}},R.prototype._receiveMessage=function(e){this.onMessageArrived&&this.onMessageArrived(e.payloadMessage)},R.prototype._connected=function(e,t){this.onConnected&&this.onConnected(e,t)},R.prototype._reconnect=function(){this._trace("Client._reconnect"),this.connected||(this._reconnecting=!0,this.sendPinger.cancel(),this.receivePinger.cancel(),this._reconnectInterval<128&&(this._reconnectInterval=2*this._reconnectInterval),this.connectOptions.uris?(this.hostIndex=0,this._doConnect(this.connectOptions.uris[0])):this._doConnect(this.uri))},R.prototype._disconnected=function(e,t){if(this._trace("Client._disconnected",e,t),void 0!==e&&this._reconnecting)this._reconnectTimeout=new x(this,this._reconnectInterval,this._reconnect);else if(this.sendPinger.cancel(),this.receivePinger.cancel(),this._connectTimeout&&(this._connectTimeout.cancel(),this._connectTimeout=null),this._msg_queue=[],this._buffered_msg_queue=[],this._notify_msg_sent={},this.socket&&(this.socket.onopen=null,this.socket.onmessage=null,this.socket.onerror=null,this.socket.onclose=null,1===this.socket.readyState&&this.socket.close(),delete this.socket),this.connectOptions.uris&&this.hostIndex<this.connectOptions.uris.length-1)this.hostIndex++,this._doConnect(this.connectOptions.uris[this.hostIndex]);else if(void 0===e&&(e=b.OK.code,t=m(b.OK)),this.connected){if(this.connected=!1,this.onConnectionLost&&this.onConnectionLost({errorCode:e,errorMessage:t,reconnect:this.connectOptions.reconnect,uri:this._wsuri}),e!==b.OK.code&&this.connectOptions.reconnect)return this._reconnectInterval=1,void this._reconnect()}else 4===this.connectOptions.mqttVersion&&!1===this.connectOptions.mqttVersionExplicit?(this._trace("Failed to connect V4, dropping back to V3"),this.connectOptions.mqttVersion=3,this.connectOptions.uris?(this.hostIndex=0,this._doConnect(this.connectOptions.uris[0])):this._doConnect(this.uri)):this.connectOptions.onFailure&&this.connectOptions.onFailure({invocationContext:this.connectOptions.invocationContext,errorCode:e,errorMessage:t})},R.prototype._trace=function(){if(this.traceFunction){var e=Array.prototype.slice.call(arguments);for(var t in e)void 0!==e[t]&&e.splice(t,1,JSON.stringify(e[t]));var n=e.join("");this.traceFunction({severity:"Debug",message:n})}if(null!==this._traceBuffer){t=0;for(var r=arguments.length;t<r;t++)this._traceBuffer.length==this._MAX_TRACE_ENTRIES&&this._traceBuffer.shift(),0===t?this._traceBuffer.push(arguments[t]):void 0===arguments[t]?this._traceBuffer.push(arguments[t]):this._traceBuffer.push("  "+JSON.stringify(arguments[t]))}},R.prototype._traceMask=function(e,t){var n={};for(var r in e)e.hasOwnProperty(r)&&(n[r]=r==t?"******":e[r]);return n};var U=function(e){var t,n;if(!("string"==typeof e||e instanceof ArrayBuffer||ArrayBuffer.isView(e)&&!(e instanceof DataView)))throw m(b.INVALID_ARGUMENT,[e,"newPayload"]);t=e;var r=0,o=!1,i=!1;Object.defineProperties(this,{payloadString:{enumerable:!0,get:function(){return"string"==typeof t?t:C(t,0,t.length)}},payloadBytes:{enumerable:!0,get:function(){if("string"==typeof t){var e=new ArrayBuffer(N(t)),n=new Uint8Array(e);return P(t,n,0),n}return t}},destinationName:{enumerable:!0,get:function(){return n},set:function(e){if("string"!=typeof e)throw new Error(m(b.INVALID_ARGUMENT,[e,"newDestinationName"]));n=e}},qos:{enumerable:!0,get:function(){return r},set:function(e){if(0!==e&&1!==e&&2!==e)throw new Error("Invalid argument:"+e);r=e}},retained:{enumerable:!0,get:function(){return o},set:function(e){if("boolean"!=typeof e)throw new Error(m(b.INVALID_ARGUMENT,[e,"newRetained"]));o=e}},topic:{enumerable:!0,get:function(){return n},set:function(e){n=e}},duplicate:{enumerable:!0,get:function(){return i},set:function(e){i=e}}})};return{Client:function(e,t,n,r){var o;if("string"!=typeof e)throw new Error(m(b.INVALID_TYPE,[typeof e,"host"]));if(2==arguments.length){r=t;var i=(o=e).match(/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/);if(!i)throw new Error(m(b.INVALID_ARGUMENT,[e,"host"]));e=i[4]||i[2],t=parseInt(i[7]),n=i[8]}else{if(3==arguments.length&&(r=n,n="/mqtt"),"number"!=typeof t||t<0)throw new Error(m(b.INVALID_TYPE,[typeof t,"port"]));if("string"!=typeof n)throw new Error(m(b.INVALID_TYPE,[typeof n,"path"]));var s=-1!==e.indexOf(":")&&"["!==e.slice(0,1)&&"]"!==e.slice(-1);o="ws://"+(s?"["+e+"]":e)+":"+t+n}for(var c=0,a=0;a<r.length;a++){var u=r.charCodeAt(a);55296<=u&&u<=56319&&a++,c++}if("string"!=typeof r||c>65535)throw new Error(m(b.INVALID_ARGUMENT,[r,"clientId"]));var f=new R(o,e,t,n,r);Object.defineProperties(this,{host:{get:function(){return e},set:function(){throw new Error(m(b.UNSUPPORTED_OPERATION))}},port:{get:function(){return t},set:function(){throw new Error(m(b.UNSUPPORTED_OPERATION))}},path:{get:function(){return n},set:function(){throw new Error(m(b.UNSUPPORTED_OPERATION))}},uri:{get:function(){return o},set:function(){throw new Error(m(b.UNSUPPORTED_OPERATION))}},clientId:{get:function(){return f.clientId},set:function(){throw new Error(m(b.UNSUPPORTED_OPERATION))}},onConnected:{get:function(){return f.onConnected},set:function(e){if("function"!=typeof e)throw new Error(m(b.INVALID_TYPE,[typeof e,"onConnected"]));f.onConnected=e}},disconnectedPublishing:{get:function(){return f.disconnectedPublishing},set:function(e){f.disconnectedPublishing=e}},disconnectedBufferSize:{get:function(){return f.disconnectedBufferSize},set:function(e){f.disconnectedBufferSize=e}},onConnectionLost:{get:function(){return f.onConnectionLost},set:function(e){if("function"!=typeof e)throw new Error(m(b.INVALID_TYPE,[typeof e,"onConnectionLost"]));f.onConnectionLost=e}},onMessageDelivered:{get:function(){return f.onMessageDelivered},set:function(e){if("function"!=typeof e)throw new Error(m(b.INVALID_TYPE,[typeof e,"onMessageDelivered"]));f.onMessageDelivered=e}},onMessageArrived:{get:function(){return f.onMessageArrived},set:function(e){if("function"!=typeof e)throw new Error(m(b.INVALID_TYPE,[typeof e,"onMessageArrived"]));f.onMessageArrived=e}},trace:{get:function(){return f.traceFunction},set:function(e){if("function"!=typeof e)throw new Error(m(b.INVALID_TYPE,[typeof e,"onTrace"]));f.traceFunction=e}}}),this.connect=function(e){if(v(e=e||{},{timeout:"number",userName:"string",password:"string",willMessage:"object",keepAliveInterval:"number",cleanSession:"boolean",useSSL:"boolean",invocationContext:"object",onSuccess:"function",onFailure:"function",hosts:"object",ports:"object",reconnect:"boolean",mqttVersion:"number",mqttVersionExplicit:"boolean",uris:"object"}),void 0===e.keepAliveInterval&&(e.keepAliveInterval=60),e.mqttVersion>4||e.mqttVersion<3)throw new Error(m(b.INVALID_ARGUMENT,[e.mqttVersion,"connectOptions.mqttVersion"]));if(void 0===e.mqttVersion?(e.mqttVersionExplicit=!1,e.mqttVersion=4):e.mqttVersionExplicit=!0,void 0!==e.password&&void 0===e.userName)throw new Error(m(b.INVALID_ARGUMENT,[e.password,"connectOptions.password"]));if(e.willMessage){if(!(e.willMessage instanceof U))throw new Error(m(b.INVALID_TYPE,[e.willMessage,"connectOptions.willMessage"]));if(e.willMessage.stringPayload=null,void 0===e.willMessage.destinationName)throw new Error(m(b.INVALID_TYPE,[typeof e.willMessage.destinationName,"connectOptions.willMessage.destinationName"]))}if(void 0===e.cleanSession&&(e.cleanSession=!0),e.hosts){if(!(e.hosts instanceof Array))throw new Error(m(b.INVALID_ARGUMENT,[e.hosts,"connectOptions.hosts"]));if(e.hosts.length<1)throw new Error(m(b.INVALID_ARGUMENT,[e.hosts,"connectOptions.hosts"]));for(var t=!1,r=0;r<e.hosts.length;r++){if("string"!=typeof e.hosts[r])throw new Error(m(b.INVALID_TYPE,[typeof e.hosts[r],"connectOptions.hosts["+r+"]"]));if(/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/.test(e.hosts[r])){if(0===r)t=!0;else if(!t)throw new Error(m(b.INVALID_ARGUMENT,[e.hosts[r],"connectOptions.hosts["+r+"]"]))}else if(t)throw new Error(m(b.INVALID_ARGUMENT,[e.hosts[r],"connectOptions.hosts["+r+"]"]))}if(t)e.uris=e.hosts;else{if(!e.ports)throw new Error(m(b.INVALID_ARGUMENT,[e.ports,"connectOptions.ports"]));if(!(e.ports instanceof Array))throw new Error(m(b.INVALID_ARGUMENT,[e.ports,"connectOptions.ports"]));if(e.hosts.length!==e.ports.length)throw new Error(m(b.INVALID_ARGUMENT,[e.ports,"connectOptions.ports"]));for(e.uris=[],r=0;r<e.hosts.length;r++){if("number"!=typeof e.ports[r]||e.ports[r]<0)throw new Error(m(b.INVALID_TYPE,[typeof e.ports[r],"connectOptions.ports["+r+"]"]));var i=e.hosts[r],s=e.ports[r],c=-1!==i.indexOf(":");o="ws://"+(c?"["+i+"]":i)+":"+s+n,e.uris.push(o)}}}f.connect(e)},this.subscribe=function(e,t){if("string"!=typeof e&&e.constructor!==Array)throw new Error("Invalid argument:"+e);if(v(t=t||{},{qos:"number",invocationContext:"object",onSuccess:"function",onFailure:"function",timeout:"number"}),t.timeout&&!t.onFailure)throw new Error("subscribeOptions.timeout specified with no onFailure callback.");if(void 0!==t.qos&&0!==t.qos&&1!==t.qos&&2!==t.qos)throw new Error(m(b.INVALID_ARGUMENT,[t.qos,"subscribeOptions.qos"]));f.subscribe(e,t)},this.unsubscribe=function(e,t){if("string"!=typeof e&&e.constructor!==Array)throw new Error("Invalid argument:"+e);if(v(t=t||{},{invocationContext:"object",onSuccess:"function",onFailure:"function",timeout:"number"}),t.timeout&&!t.onFailure)throw new Error("unsubscribeOptions.timeout specified with no onFailure callback.");f.unsubscribe(e,t)},this.send=function(e,t,n,r){var o;if(0===arguments.length)throw new Error("Invalid argument.length");if(1==arguments.length){if(!(e instanceof U)&&"string"!=typeof e)throw new Error("Invalid argument:"+typeof e);if(void 0===(o=e).destinationName)throw new Error(m(b.INVALID_ARGUMENT,[o.destinationName,"Message.destinationName"]));f.send(o)}else(o=new U(t)).destinationName=e,arguments.length>=3&&(o.qos=n),arguments.length>=4&&(o.retained=r),f.send(o)},this.publish=function(e,t,n,r){var o;if(0===arguments.length)throw new Error("Invalid argument.length");if(1==arguments.length){if(!(e instanceof U)&&"string"!=typeof e)throw new Error("Invalid argument:"+typeof e);if(void 0===(o=e).destinationName)throw new Error(m(b.INVALID_ARGUMENT,[o.destinationName,"Message.destinationName"]));f.send(o)}else(o=new U(t)).destinationName=e,arguments.length>=3&&(o.qos=n),arguments.length>=4&&(o.retained=r),f.send(o)},this.disconnect=function(){f.disconnect()},this.getTraceLog=function(){return f.getTraceLog()},this.startTrace=function(){f.startTrace()},this.stopTrace=function(){f.stopTrace()},this.isConnected=function(){return f.connected}},Message:U}}(void 0!==t?t:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},e.exports=n()}).call(this,n(8))},function(e,t,n){var r=n(9),o=n(10),i=o;i.v1=r,i.v4=o,e.exports=i},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function i(e,t,n){return t&&o(e.prototype,t),n&&o(e,n),e}Object.defineProperty(t,"__esModule",{value:!0}),t.Observable=void 0;var s=function(){return"function"==typeof Symbol},c=function(e){return s()&&Boolean(Symbol[e])},a=function(e){return c(e)?Symbol[e]:"@@"+e};s()&&!c("observable")&&(Symbol.observable=Symbol("observable"));var u=a("iterator"),f=a("observable"),l=a("species");function h(e,t){var n=e[t];if(null!=n){if("function"!=typeof n)throw new TypeError(n+" is not a function");return n}}function p(e){var t=e.constructor;return void 0!==t&&null===(t=t[l])&&(t=void 0),void 0!==t?t:I}function d(e){return e instanceof I}function _(e){_.log?_.log(e):setTimeout((function(){throw e}))}function g(e){Promise.resolve().then((function(){try{e()}catch(e){_(e)}}))}function v(e){var t=e._cleanup;if(void 0!==t&&(e._cleanup=void 0,t))try{if("function"==typeof t)t();else{var n=h(t,"unsubscribe");n&&n.call(t)}}catch(e){_(e)}}function y(e){e._observer=void 0,e._queue=void 0,e._state="closed"}function b(e,t,n){e._state="running";var r=e._observer;try{var o=h(r,t);switch(t){case"next":o&&o.call(r,n);break;case"error":if(y(e),!o)throw n;o.call(r,n);break;case"complete":y(e),o&&o.call(r)}}catch(e){_(e)}"closed"===e._state?v(e):"running"===e._state&&(e._state="ready")}function w(e,t,n){if("closed"!==e._state){if("buffering"!==e._state)return"ready"!==e._state?(e._state="buffering",e._queue=[{type:t,value:n}],void g((function(){return function(e){var t=e._queue;if(t){e._queue=void 0,e._state="ready";for(var n=0;n<t.length&&(b(e,t[n].type,t[n].value),"closed"!==e._state);++n);}}(e)}))):void b(e,t,n);e._queue.push({type:t,value:n})}}var m=function(){function e(t,n){r(this,e),this._cleanup=void 0,this._observer=t,this._queue=void 0,this._state="initializing";var o=new E(this);try{this._cleanup=n.call(void 0,o)}catch(e){o.error(e)}"initializing"===this._state&&(this._state="ready")}return i(e,[{key:"unsubscribe",value:function(){"closed"!==this._state&&(y(this),v(this))}},{key:"closed",get:function(){return"closed"===this._state}}]),e}(),E=function(){function e(t){r(this,e),this._subscription=t}return i(e,[{key:"next",value:function(e){w(this._subscription,"next",e)}},{key:"error",value:function(e){w(this._subscription,"error",e)}},{key:"complete",value:function(){w(this._subscription,"complete")}},{key:"closed",get:function(){return"closed"===this._subscription._state}}]),e}(),I=function(){function e(t){if(r(this,e),!(this instanceof e))throw new TypeError("Observable cannot be called as a function");if("function"!=typeof t)throw new TypeError("Observable initializer must be a function");this._subscriber=t}return i(e,[{key:"subscribe",value:function(e){return"object"==typeof e&&null!==e||(e={next:e,error:arguments[1],complete:arguments[2]}),new m(e,this._subscriber)}},{key:"forEach",value:function(e){var t=this;return new Promise((function(n,r){if("function"==typeof e)var o=t.subscribe({next:function(t){try{e(t,i)}catch(e){r(e),o.unsubscribe()}},error:r,complete:n});else r(new TypeError(e+" is not a function"));function i(){o.unsubscribe(),n()}}))}},{key:"map",value:function(e){var t=this;if("function"!=typeof e)throw new TypeError(e+" is not a function");return new(p(this))((function(n){return t.subscribe({next:function(t){try{t=e(t)}catch(e){return n.error(e)}n.next(t)},error:function(e){n.error(e)},complete:function(){n.complete()}})}))}},{key:"filter",value:function(e){var t=this;if("function"!=typeof e)throw new TypeError(e+" is not a function");return new(p(this))((function(n){return t.subscribe({next:function(t){try{if(!e(t))return}catch(e){return n.error(e)}n.next(t)},error:function(e){n.error(e)},complete:function(){n.complete()}})}))}},{key:"reduce",value:function(e){var t=this;if("function"!=typeof e)throw new TypeError(e+" is not a function");var n=p(this),r=arguments.length>1,o=!1,i=arguments[1],s=i;return new n((function(n){return t.subscribe({next:function(t){var i=!o;if(o=!0,!i||r)try{s=e(s,t)}catch(e){return n.error(e)}else s=t},error:function(e){n.error(e)},complete:function(){if(!o&&!r)return n.error(new TypeError("Cannot reduce an empty sequence"));n.next(s),n.complete()}})}))}},{key:"concat",value:function(){for(var e=this,t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];var o=p(this);return new o((function(t){var r,i=0;return function e(s){r=s.subscribe({next:function(e){t.next(e)},error:function(e){t.error(e)},complete:function(){i===n.length?(r=void 0,t.complete()):e(o.from(n[i++]))}})}(e),function(){r&&(r.unsubscribe(),r=void 0)}}))}},{key:"flatMap",value:function(e){var t=this;if("function"!=typeof e)throw new TypeError(e+" is not a function");var n=p(this);return new n((function(r){var o=[],i=t.subscribe({next:function(t){if(e)try{t=e(t)}catch(e){return r.error(e)}var i=n.from(t).subscribe({next:function(e){r.next(e)},error:function(e){r.error(e)},complete:function(){var e=o.indexOf(i);e>=0&&o.splice(e,1),s()}});o.push(i)},error:function(e){r.error(e)},complete:function(){s()}});function s(){i.closed&&0===o.length&&r.complete()}return function(){o.forEach((function(e){return e.unsubscribe()})),i.unsubscribe()}}))}},{key:f,value:function(){return this}}],[{key:"from",value:function(t){var n="function"==typeof this?this:e;if(null==t)throw new TypeError(t+" is not an object");var r=h(t,f);if(r){var o=r.call(t);if(Object(o)!==o)throw new TypeError(o+" is not an object");return d(o)&&o.constructor===n?o:new n((function(e){return o.subscribe(e)}))}if(c("iterator")&&(r=h(t,u)))return new n((function(e){g((function(){if(!e.closed){var n=!0,o=!1,i=void 0;try{for(var s,c=r.call(t)[Symbol.iterator]();!(n=(s=c.next()).done);n=!0){var a=s.value;if(e.next(a),e.closed)return}}catch(e){o=!0,i=e}finally{try{n||null==c.return||c.return()}finally{if(o)throw i}}e.complete()}}))}));if(Array.isArray(t))return new n((function(e){g((function(){if(!e.closed){for(var n=0;n<t.length;++n)if(e.next(t[n]),e.closed)return;e.complete()}}))}));throw new TypeError(t+" is not observable")}},{key:"of",value:function(){for(var t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];var o="function"==typeof this?this:e;return new o((function(e){g((function(){if(!e.closed){for(var t=0;t<n.length;++t)if(e.next(n[t]),e.closed)return;e.complete()}}))}))}},{key:l,get:function(){return this}}]),e}();t.Observable=I,s()&&Object.defineProperty(I,Symbol("extensions"),{value:{symbol:f,hostReportError:_},configurable:!0})},function(e,t){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){var r,o,i=n(2),s=n(3),c=0,a=0;e.exports=function(e,t,n){var u=t&&n||0,f=t||[],l=(e=e||{}).node||r,h=void 0!==e.clockseq?e.clockseq:o;if(null==l||null==h){var p=i();null==l&&(l=r=[1|p[0],p[1],p[2],p[3],p[4],p[5]]),null==h&&(h=o=16383&(p[6]<<8|p[7]))}var d=void 0!==e.msecs?e.msecs:(new Date).getTime(),_=void 0!==e.nsecs?e.nsecs:a+1,g=d-c+(_-a)/1e4;if(g<0&&void 0===e.clockseq&&(h=h+1&16383),(g<0||d>c)&&void 0===e.nsecs&&(_=0),_>=1e4)throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");c=d,a=_,o=h;var v=(1e4*(268435455&(d+=122192928e5))+_)%4294967296;f[u++]=v>>>24&255,f[u++]=v>>>16&255,f[u++]=v>>>8&255,f[u++]=255&v;var y=d/4294967296*1e4&268435455;f[u++]=y>>>8&255,f[u++]=255&y,f[u++]=y>>>24&15|16,f[u++]=y>>>16&255,f[u++]=h>>>8|128,f[u++]=255&h;for(var b=0;b<6;++b)f[u+b]=l[b];return t||s(f)}},function(e,t,n){var r=n(2),o=n(3);e.exports=function(e,t,n){var i=t&&n||0;"string"==typeof e&&(t="binary"===e?new Array(16):null,e=null);var s=(e=e||{}).random||(e.rng||r)();if(s[6]=15&s[6]|64,s[8]=63&s[8]|128,t)for(var c=0;c<16;++c)t[i+c]=s[c];return t||o(s)}},function(e,t,n){"use strict";n.r(t);var r=n(1),o=n(0),i=n.n(o),s=n(4),c=function(){return(c=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)},a=new o.ConsoleLogger("AbstractPubSubProvider"),u=function(){function e(e){void 0===e&&(e={}),this._config=e}return e.prototype.configure=function(e){return void 0===e&&(e={}),this._config=c(c({},e),this._config),a.debug("configure "+this.getProviderName(),this._config),this.options},e.prototype.getCategory=function(){return"PubSub"},Object.defineProperty(e.prototype,"options",{get:function(){return c({},this._config)},enumerable:!0,configurable:!0}),e}(),f=n(5),l=n(6);function h(e){return(h="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var p,d=(p=function(e,t){return(p=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}p(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),_=function(){return(_=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)},g=function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function s(e){try{a(r.next(e))}catch(e){i(e)}}function c(e){try{a(r.throw(e))}catch(e){i(e)}}function a(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(s,c)}a((r=r.apply(e,t||[])).next())}))},v=function(e,t){var n,r,o,i,s={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(i){return function(c){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return s.label++,{value:i[1],done:!1};case 5:s.label++,r=i[1],i=[0];continue;case 7:i=s.ops.pop(),s.trys.pop();continue;default:if(!(o=(o=s.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){s=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){s.label=i[1];break}if(6===i[0]&&s.label<o[1]){s.label=o[1],o=i;break}if(o&&s.label<o[2]){s.label=o[2],s.ops.push(i);break}o[2]&&s.ops.pop(),s.trys.pop();continue}i=t.call(e,s)}catch(e){i=[6,e],r=0}finally{n=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,c])}}},y=function(e,t){var n={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(e);o<r.length;o++)t.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(e,r[o])&&(n[r[o]]=e[r[o]])}return n},b=new o.ConsoleLogger("MqttOverWSProvider");var w=function(){function e(){this.promises=new Map}return e.prototype.get=function(e,t){return g(this,void 0,void 0,(function(){var n;return v(this,(function(r){return(n=this.promises.get(e))?[2,n]:(n=t(e),this.promises.set(e,n),[2,n])}))}))},Object.defineProperty(e.prototype,"allClients",{get:function(){return Array.from(this.promises.keys())},enumerable:!0,configurable:!0}),e.prototype.remove=function(e){this.promises.delete(e)},e}(),m="undefined"!=typeof Symbol?Symbol("topic"):"@@topic",E=function(e){function t(t){void 0===t&&(t={});var n=e.call(this,_(_({},t),{clientId:t.clientId||Object(l.v4)()}))||this;return n._clientsQueue=new w,n._topicObservers=new Map,n._clientIdObservers=new Map,n}return d(t,e),Object.defineProperty(t.prototype,"clientId",{get:function(){return this.options.clientId},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"endpoint",{get:function(){return this.options.aws_pubsub_endpoint},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"clientsQueue",{get:function(){return this._clientsQueue},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isSSLEnabled",{get:function(){return!this.options.aws_appsync_dangerously_connect_to_http_endpoint_for_testing},enumerable:!0,configurable:!0}),t.prototype.getTopicForValue=function(e){return"object"===h(e)&&e[m]},t.prototype.getProviderName=function(){return"MqttOverWSProvider"},t.prototype.onDisconnect=function(e){var t=e.clientId,n=e.errorCode,r=y(e,["clientId","errorCode"]);0!==n&&(b.warn(t,JSON.stringify(_({errorCode:n},r),null,2)),this._topicObservers.forEach((function(e,t){e.forEach((function(e){e.error("Disconnected, error code: "+n),e.complete()}))}))),this._topicObservers=new Map},t.prototype.newClient=function(e){var t=e.url,n=e.clientId;return g(this,void 0,void 0,(function(){var e,r=this;return v(this,(function(o){switch(o.label){case 0:return b.debug("Creating new MQTT client",n),(e=new f.Client(t,n)).onMessageArrived=function(e){var t=e.destinationName,n=e.payloadString;r._onMessage(t,n)},e.onConnectionLost=function(e){var t=e.errorCode,o=y(e,["errorCode"]);r.onDisconnect(_({clientId:n,errorCode:t},o))},[4,new Promise((function(t,n){e.connect({useSSL:r.isSSLEnabled,mqttVersion:3,onSuccess:function(){return t(e)},onFailure:n})}))];case 1:return o.sent(),[2,e]}}))}))},t.prototype.connect=function(e,t){return void 0===t&&(t={}),g(this,void 0,void 0,(function(){var n=this;return v(this,(function(r){switch(r.label){case 0:return[4,this.clientsQueue.get(e,(function(e){return n.newClient(_(_({},t),{clientId:e}))}))];case 1:return[2,r.sent()]}}))}))},t.prototype.disconnect=function(e){return g(this,void 0,void 0,(function(){var t;return v(this,(function(n){switch(n.label){case 0:return[4,this.clientsQueue.get(e,(function(){return null}))];case 1:return(t=n.sent())&&t.isConnected()&&t.disconnect(),this.clientsQueue.remove(e),[2]}}))}))},t.prototype.publish=function(e,t){return g(this,void 0,void 0,(function(){var n,r,o,i;return v(this,(function(s){switch(s.label){case 0:return n=[].concat(e),r=JSON.stringify(t),[4,this.endpoint];case 1:return o=s.sent(),[4,this.connect(this.clientId,{url:o})];case 2:return i=s.sent(),b.debug("Publishing to topic(s)",n.join(","),r),n.forEach((function(e){return i.send(e,r)})),[2]}}))}))},t.prototype._onMessage=function(e,t){try{var n=[];this._topicObservers.forEach((function(t,r){(function(e,t){for(var n=e.split("/"),r=n.length,o=t.split("/"),i=0;i<r;++i){var s=n[i],c=o[i];if("#"===s)return o.length>=r;if("+"!==s&&s!==c)return!1}return r===o.length})(r,e)&&n.push(t)}));var r=JSON.parse(t);"object"===h(r)&&(r[m]=e),n.forEach((function(e){e.forEach((function(e){return e.next(r)}))}))}catch(e){b.warn("Error handling message",e,t)}},t.prototype.subscribe=function(e,t){var n=this;void 0===t&&(t={});var o=[].concat(e);return b.debug("Subscribing to topic(s)",o.join(",")),new r((function(e){var r;o.forEach((function(t){var r=n._topicObservers.get(t);r||(r=new Set,n._topicObservers.set(t,r)),r.add(e)}));var i=t.clientId,s=void 0===i?n.clientId:i,c=n._clientIdObservers.get(s);return c||(c=new Set),c.add(e),n._clientIdObservers.set(s,c),g(n,void 0,void 0,(function(){var n,i,c,a;return v(this,(function(u){switch(u.label){case 0:return void 0!==(n=t.url)?[3,2]:[4,this.endpoint];case 1:return c=u.sent(),[3,3];case 2:c=n,u.label=3;case 3:i=c,u.label=4;case 4:return u.trys.push([4,6,,7]),[4,this.connect(s,{url:i})];case 5:return r=u.sent(),o.forEach((function(e){r.subscribe(e)})),[3,7];case 6:return a=u.sent(),e.error(a),[3,7];case 7:return[2]}}))})),function(){return b.debug("Unsubscribing from topic(s)",o.join(",")),r&&(n._clientIdObservers.get(s).delete(e),o.forEach((function(e){r.isConnected()&&r.unsubscribe(e);var t=n._topicObservers.get(e)||new Set;t.forEach((function(e){return e.complete()})),t.clear()})),0===n._clientIdObservers.get(s).size&&(n.disconnect(s),n._clientIdObservers.delete(s))),null}}))},t}(u),I=function(){var e=function(t,n){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(t,n)};return function(t,n){function r(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}(),O=function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function s(e){try{a(r.next(e))}catch(e){i(e)}}function c(e){try{a(r.throw(e))}catch(e){i(e)}}function a(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(s,c)}a((r=r.apply(e,t||[])).next())}))},S=function(e,t){var n,r,o,i,s={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(i){return function(c){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return s.label++,{value:i[1],done:!1};case 5:s.label++,r=i[1],i=[0];continue;case 7:i=s.ops.pop(),s.trys.pop();continue;default:if(!(o=(o=s.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){s=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){s.label=i[1];break}if(6===i[0]&&s.label<o[1]){s.label=o[1],o=i;break}if(o&&s.label<o[2]){s.label=o[2],s.ops.push(i);break}o[2]&&s.ops.pop(),s.trys.pop();continue}i=t.call(e,s)}catch(e){i=[6,e],r=0}finally{n=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,c])}}},M=function(e,t){var n={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(e);o<r.length;o++)t.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(e,r[o])&&(n[r[o]]=e[r[o]])}return n},A=function(){for(var e=0,t=0,n=arguments.length;t<n;t++)e+=arguments[t].length;var r=Array(e),o=0;for(t=0;t<n;t++)for(var i=arguments[t],s=0,c=i.length;s<c;s++,o++)r[o]=i[s];return r},T=new o.ConsoleLogger("AWSAppSyncProvider"),N=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t._topicClient=new Map,t._topicAlias=new Map,t}return I(t,e),Object.defineProperty(t.prototype,"endpoint",{get:function(){throw new Error("Not supported")},enumerable:!0,configurable:!0}),t.prototype.getProviderName=function(){return"AWSAppSyncProvider"},t.prototype.publish=function(e,t,n){return O(this,void 0,void 0,(function(){return S(this,(function(e){throw new Error("Operation not supported")}))}))},t.prototype._cleanUp=function(e){var t=this;Array.from(this._topicClient.entries()).filter((function(t){return t[1].clientId===e})).map((function(e){return e[0]})).forEach((function(e){return t._cleanUpForTopic(e)}))},t.prototype._cleanUpForTopic=function(e){this._topicClient.delete(e),this._topicAlias.delete(e)},t.prototype.onDisconnect=function(e){var t=this,n=e.clientId,r=e.errorCode,o=M(e,["clientId","errorCode"]);0!==r&&(Array.from(this._topicClient.entries()).filter((function(e){return e[1].clientId===n})).map((function(e){return e[0]})).forEach((function(e){t._topicObservers.has(e)&&(t._topicObservers.get(e).forEach((function(e){e.closed||e.error(o)})),t._topicObservers.delete(e))})),this._cleanUp(n))},t.prototype.disconnect=function(t){return O(this,void 0,void 0,(function(){return S(this,(function(n){switch(n.label){case 0:return[4,this.clientsQueue.get(t,(function(){return null}))];case 1:return n.sent(),[4,e.prototype.disconnect.call(this,t)];case 2:return n.sent(),this._cleanUp(t),[2]}}))}))},t.prototype.subscribe=function(e,t){var n=this;void 0===t&&(t={});var o=new r((function(r){var o=[].concat(e);return T.debug("Subscribing to topic(s)",o.join(",")),O(n,void 0,void 0,(function(){var e,n,i,s,c,a=this;return S(this,(function(u){switch(u.label){case 0:return o.forEach((function(e){a._topicObservers.has(e)||a._topicObservers.set(e,new Set),a._topicObservers.get(e).add(r)})),e=t.mqttConnections,n=void 0===e?[]:e,i=t.newSubscriptions,s=Object.entries(i).map((function(e){var t=e[0];return[e[1].topic,t]})),this._topicAlias=new Map(A(Array.from(this._topicAlias.entries()),s)),c=Object.entries(o.reduce((function(e,t){var r=n.find((function(e){return e.topics.indexOf(t)>-1}));if(r){var o=r.client,i=r.url;e[o]||(e[o]={url:i,topics:new Set}),e[o].topics.add(t)}return e}),{})),[4,Promise.all(c.map((function(e){var t=e[0],n=e[1],o=n.url,i=n.topics;return O(a,void 0,void 0,(function(){var e,n,s=this;return S(this,(function(c){switch(c.label){case 0:e=null,c.label=1;case 1:return c.trys.push([1,3,,4]),[4,this.connect(t,{clientId:t,url:o})];case 2:return e=c.sent(),[3,4];case 3:return n=c.sent(),r.error({message:"Failed to connect",error:n}),r.complete(),[2,void 0];case 4:return i.forEach((function(t){e.isConnected()&&(e.subscribe(t),s._topicClient.set(t,e))})),[2,e]}}))}))})))];case 1:return u.sent(),[2]}}))})),function(){T.debug("Unsubscribing from topic(s)",o.join(",")),o.forEach((function(e){var t=n._topicClient.get(e);t&&t.isConnected()&&(t.unsubscribe(e),n._topicClient.delete(e),Array.from(n._topicClient.values()).some((function(e){return e===t}))||n.disconnect(t.clientId)),n._topicObservers.delete(e)}))}}));return r.from(o).map((function(e){var t=n.getTopicForValue(e),r=n._topicAlias.get(t);return e.data=Object.entries(e.data).reduce((function(e,t){var n=t[0],o=t[1];return e[r||n]=o,e}),{}),e}))},t}(E),P=function(){var e=function(t,n){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(t,n)};return function(t,n){function r(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}(),C=function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function s(e){try{a(r.next(e))}catch(e){i(e)}}function c(e){try{a(r.throw(e))}catch(e){i(e)}}function a(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(s,c)}a((r=r.apply(e,t||[])).next())}))},k=function(e,t){var n,r,o,i,s={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(i){return function(c){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return s.label++,{value:i[1],done:!1};case 5:s.label++,r=i[1],i=[0];continue;case 7:i=s.ops.pop(),s.trys.pop();continue;default:if(!(o=(o=s.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){s=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){s.label=i[1];break}if(6===i[0]&&s.label<o[1]){s.label=o[1],o=i;break}if(o&&s.label<o[2]){s.label=o[2],s.ops.push(i);break}o[2]&&s.ops.pop(),s.trys.pop();continue}i=t.call(e,s)}catch(e){i=[6,e],r=0}finally{n=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,c])}}},x=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return P(t,e),Object.defineProperty(t.prototype,"region",{get:function(){return this.options.aws_pubsub_region},enumerable:!0,configurable:!0}),t.prototype.getProviderName=function(){return"AWSIoTProvider"},Object.defineProperty(t.prototype,"endpoint",{get:function(){return C(this,void 0,void 0,(function(){var e,t,n,r,i,s;return k(this,(function(c){switch(c.label){case 0:return e=this.options.aws_pubsub_endpoint,t={service:"iotdevicegateway",region:this.region},[4,o.Credentials.get()];case 1:return n=c.sent(),r=n.accessKeyId,i=n.secretAccessKey,s=n.sessionToken,[2,o.Signer.signUrl(e,{access_key:r,secret_key:i,session_token:s},t)]}}))}))},enumerable:!0,configurable:!0}),t}(E),R=function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function s(e){try{a(r.next(e))}catch(e){i(e)}}function c(e){try{a(r.throw(e))}catch(e){i(e)}}function a(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(s,c)}a((r=r.apply(e,t||[])).next())}))},U=function(e,t){var n,r,o,i,s={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(i){return function(c){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return s.label++,{value:i[1],done:!1};case 5:s.label++,r=i[1],i=[0];continue;case 7:i=s.ops.pop(),s.trys.pop();continue;default:if(!(o=(o=s.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){s=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){s.label=i[1];break}if(6===i[0]&&s.label<o[1]){s.label=o[1],o=i;break}if(o&&s.label<o[2]){s.label=o[2],s.ops.push(i);break}o[2]&&s.ops.pop(),s.trys.pop();continue}i=t.call(e,s)}catch(e){i=[6,e],r=0}finally{n=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,c])}}},D=new o.ConsoleLogger("PubSub"),L=function(){function e(e){this._options=e,D.debug("PubSub Options",this._options),this._pluggables=[],this.subscribe=this.subscribe.bind(this)}return Object.defineProperty(e.prototype,"awsAppSyncProvider",{get:function(){return this._awsAppSyncProvider||(this._awsAppSyncProvider=new N(this._options)),this._awsAppSyncProvider},enumerable:!0,configurable:!0}),e.prototype.getModuleName=function(){return"PubSub"},e.prototype.configure=function(e){var t=this,n=e?e.PubSub||e:{};return D.debug("configure PubSub",{opt:n}),this._options=Object.assign({},this._options,n),this._pluggables.map((function(e){return e.configure(t._options)})),this._options},e.prototype.addPluggable=function(e){return R(this,void 0,void 0,(function(){return U(this,(function(t){return e&&"PubSub"===e.getCategory()?(this._pluggables.push(e),[2,e.configure(this._options)]):[2]}))}))},e.prototype.getProviderByName=function(e){return e===s.INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER?this.awsAppSyncProvider:this._pluggables.find((function(t){return t.getProviderName()===e}))},e.prototype.getProviders=function(e){void 0===e&&(e={});var t=e.provider;if(!t)return this._pluggables;var n=this.getProviderByName(t);if(!n)throw new Error("Could not find provider named "+t);return[n]},e.prototype.publish=function(e,t,n){return R(this,void 0,void 0,(function(){return U(this,(function(r){return[2,Promise.all(this.getProviders(n).map((function(r){return r.publish(e,t,n)})))]}))}))},e.prototype.subscribe=function(e,t){D.debug("subscribe options",t);var n=this.getProviders(t);return new r((function(r){var o=n.map((function(n){return{provider:n,observable:n.subscribe(e,t)}})).map((function(e){var t=e.provider;return e.observable.subscribe({start:console.error,next:function(e){return r.next({provider:t,value:e})},error:function(e){return r.error({provider:t,error:e})}})}));return function(){return o.forEach((function(e){return e.unsubscribe()}))}}))},e}();n.d(t,"AWSIoTProvider",(function(){return x})),n.d(t,"PubSubClass",(function(){return L}));var q=new o.ConsoleLogger("PubSub"),V=null;V||(q.debug("Create PubSub Instance"),V=new L(null));var j=V;i.a.register(j);t.default=j}])}));
	//# sourceMappingURL=aws-amplify-pubsub.min.js.map

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
		module.exports = __webpack_require__(333);
	} else {
		module.exports = require('./dist/aws-amplify-pubsub.js');
	}


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(26),__webpack_require__(366)):"function"==typeof define&&define.amd?define("aws_amplify_storage",["@aws-amplify/core","aws-sdk/clients/s3"],t):"object"==typeof exports?exports.aws_amplify_storage=t(require("@aws-amplify/core"),require("aws-sdk/clients/s3")):e.aws_amplify_storage=t(e["@aws-amplify/core"],e["aws-sdk/clients/s3"])}(this,(function(e,t){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var o=t[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=2)}([function(t,r){t.exports=e},function(e,r){e.exports=t},function(e,t,r){"use strict";r.r(t);var n=r(0),o=r.n(n),i=r(1);function u(e){return(u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var s=function(){return(s=Object.assign||function(e){for(var t,r=1,n=arguments.length;r<n;r++)for(var o in t=arguments[r])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)},a=function(e,t,r,n){return new(r||(r=Promise))((function(o,i){function u(e){try{a(n.next(e))}catch(e){i(e)}}function s(e){try{a(n.throw(e))}catch(e){i(e)}}function a(e){var t;e.done?o(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(u,s)}a((n=n.apply(e,t||[])).next())}))},c=function(e,t){var r,n,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function s(i){return function(s){return function(i){if(r)throw new TypeError("Generator is already executing.");for(;u;)try{if(r=1,n&&(o=2&i[0]?n.return:i[0]?n.throw||((o=n.return)&&o.call(n),0):n.next)&&!(o=o.call(n,i[1])).done)return o;switch(n=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,n=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=t.call(e,u)}catch(e){i=[6,e],n=0}finally{r=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,s])}}},l=new n.ConsoleLogger("AWSS3Provider"),f="undefined"!=typeof Symbol&&"function"==typeof Symbol.for?Symbol.for("amplify_default"):"@@amplify_default",d=function(e,t,r,o,i){e&&n.Hub.dispatch("storage",{event:t,data:{attrs:r,metrics:o},message:i},"Storage",f)},p=function(){function e(e){this._config=e||{},l.debug("Storage Options",this._config)}return e.prototype.getCategory=function(){return e.CATEGORY},e.prototype.getProviderName=function(){return e.PROVIDER_NAME},e.prototype.configure=function(e){if(l.debug("configure Storage",e),!e)return this._config;var t=n.Parser.parseMobilehubConfig(e);return this._config=Object.assign({},this._config,t.Storage),this._config.bucket||l.debug("Do not have bucket yet"),this._config},e.prototype.get=function(e,t){return a(this,void 0,void 0,(function(){var r,n,o,i,u,s,a,f,p;return c(this,(function(c){switch(c.label){case 0:return[4,this._ensureCredentials()];case 1:return c.sent()?(r=Object.assign({},this._config,t),n=r.bucket,o=r.download,i=r.track,u=r.expires,s=this._prefix(r),a=s+e,f=this._createS3(r),l.debug("get "+e+" from "+a),p={Bucket:n,Key:a},!0===o?[2,new Promise((function(t,r){f.getObject(p,(function(n,o){n?(d(i,"download",{method:"get",result:"failed"},null,"Download failed with "+n.message),r(n)):(d(i,"download",{method:"get",result:"success"},{fileSize:Number(o.Body.length)},"Download success for "+e),t(o))}))}))]:(u&&(p.Expires=u),[2,new Promise((function(t,r){try{var n=f.getSignedUrl("getObject",p);d(i,"getSignedUrl",{method:"get",result:"success"},null,"Signed URL: "+n),t(n)}catch(t){l.warn("get signed url error",t),d(i,"getSignedUrl",{method:"get",result:"failed"},null,"Could not get a signed URL for "+e),r(t)}}))])):[2,Promise.reject("No credentials")]}}))}))},e.prototype.put=function(e,t,r){return a(this,void 0,void 0,(function(){var n,o,i,s,a,f,p,g,h,b,y,v,m,S,w,_,P,k,C,j,O,x;return c(this,(function(c){switch(c.label){case 0:return[4,this._ensureCredentials()];case 1:if(!c.sent())return[2,Promise.reject("No credentials")];n=Object.assign({},this._config,r),o=n.bucket,i=n.track,s=n.progressCallback,a=n.contentType,f=n.contentDisposition,p=n.cacheControl,g=n.expires,h=n.metadata,b=n.tagging,y=n.serverSideEncryption,v=n.SSECustomerAlgorithm,m=n.SSECustomerKey,S=n.SSECustomerKeyMD5,w=n.SSEKMSKeyId,_=a||"binary/octet-stream",P=this._prefix(n),k=P+e,C=this._createS3(n),l.debug("put "+e+" to "+k),j={Bucket:o,Key:k,Body:t,ContentType:_},p&&(j.CacheControl=p),f&&(j.ContentDisposition=f),g&&(j.Expires=g),h&&(j.Metadata=h),b&&(j.Tagging=b),y&&(j.ServerSideEncryption=y,v&&(j.SSECustomerAlgorithm=v),m&&(j.SSECustomerKey=m),S&&(j.SSECustomerKeyMD5=S),w&&(j.SSEKMSKeyId=w)),c.label=2;case 2:return c.trys.push([2,4,,5]),[4,C.upload(j).on("httpUploadProgress",(function(e){s&&("function"==typeof s?s(e):l.warn("progressCallback should be a function, not a "+u(s)))})).promise()];case 3:return O=c.sent(),l.debug("upload result",O),d(i,"upload",{method:"put",result:"success"},null,"Upload success for "+e),[2,{key:O.Key.substr(P.length)}];case 4:throw x=c.sent(),l.warn("error uploading",x),d(i,"upload",{method:"put",result:"failed"},null,"Error uploading "+e),x;case 5:return[2]}}))}))},e.prototype.remove=function(e,t){return a(this,void 0,void 0,(function(){var r,n,o,i,u,s,a;return c(this,(function(c){switch(c.label){case 0:return[4,this._ensureCredentials()];case 1:return c.sent()?(r=Object.assign({},this._config,t),n=r.bucket,o=r.track,i=this._prefix(r),u=i+e,s=this._createS3(r),l.debug("remove "+e+" from "+u),a={Bucket:n,Key:u},[2,new Promise((function(t,r){s.deleteObject(a,(function(n,i){n?(d(o,"delete",{method:"remove",result:"failed"},null,"Deletion of "+e+" failed with "+n),r(n)):(d(o,"delete",{method:"remove",result:"success"},null,"Deleted "+e+" successfully"),t(i))}))}))]):[2,Promise.reject("No credentials")]}}))}))},e.prototype.list=function(e,t){return a(this,void 0,void 0,(function(){var r,n,o,i,u,s,a;return c(this,(function(c){switch(c.label){case 0:return[4,this._ensureCredentials()];case 1:return c.sent()?(r=Object.assign({},this._config,t),n=r.bucket,o=r.track,i=this._prefix(r),u=i+e,s=this._createS3(r),l.debug("list "+e+" from "+u),a={Bucket:n,Prefix:u},[2,new Promise((function(e,t){s.listObjects(a,(function(r,n){if(r)l.warn("list error",r),d(o,"list",{method:"list",result:"failed"},null,"Listing items failed: "+r.message),t(r);else{var u=n.Contents.map((function(e){return{key:e.Key.substr(i.length),eTag:e.ETag,lastModified:e.LastModified,size:e.Size}}));d(o,"list",{method:"list",result:"success"},null,u.length+" items returned from list operation"),l.debug("list",u),e(u)}}))}))]):[2,Promise.reject("No credentials")]}}))}))},e.prototype._ensureCredentials=function(){var e=this;return n.Credentials.get().then((function(t){if(!t)return!1;var r=n.Credentials.shear(t);return l.debug("set credentials for storage",r),e._config.credentials=r,!0})).catch((function(e){return l.warn("ensure credentials error",e),!1}))},e.prototype._prefix=function(e){var t=e.credentials,r=e.level,n=e.customPrefix||{},o=e.identityId||t.identityId,i=(void 0!==n.private?n.private:"private/")+o+"/",u=(void 0!==n.protected?n.protected:"protected/")+o+"/",s=void 0!==n.public?n.public:"public/";switch(r){case"private":return i;case"protected":return u;default:return s}},e.prototype._createS3=function(e){var t=e.bucket,r=e.region,n=e.credentials,o={};return e.dangerouslyConnectToHttpEndpointForTesting&&(o={endpoint:"http://localhost:20005",s3BucketEndpoint:!0,s3ForcePathStyle:!0}),new i(s({apiVersion:"2006-03-01",params:{Bucket:t},signatureVersion:"v4",region:r,credentials:n},o))},e.CATEGORY="Storage",e.PROVIDER_NAME="AWSS3",e}(),g=function(){return(g=Object.assign||function(e){for(var t,r=1,n=arguments.length;r<n;r++)for(var o in t=arguments[r])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)},h=function(e,t,r,n){return new(r||(r=Promise))((function(o,i){function u(e){try{a(n.next(e))}catch(e){i(e)}}function s(e){try{a(n.throw(e))}catch(e){i(e)}}function a(e){var t;e.done?o(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(u,s)}a((n=n.apply(e,t||[])).next())}))},b=function(e,t){var r,n,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function s(i){return function(s){return function(i){if(r)throw new TypeError("Generator is already executing.");for(;u;)try{if(r=1,n&&(o=2&i[0]?n.return:i[0]?n.throw||((o=n.return)&&o.call(n),0):n.next)&&!(o=o.call(n,i[1])).done)return o;switch(n=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,n=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=t.call(e,u)}catch(e){i=[6,e],n=0}finally{r=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,s])}}},y=new n.ConsoleLogger("StorageClass"),v=function(){function e(){this._config={},this._pluggables=[],y.debug("Storage Options",this._config),this.get=this.get.bind(this),this.put=this.put.bind(this),this.remove=this.remove.bind(this),this.list=this.list.bind(this)}return e.prototype.getModuleName=function(){return"Storage"},e.prototype.addPluggable=function(e){if(e&&"Storage"===e.getCategory()){this._pluggables.push(e);return e.configure(this._config[e.getProviderName()])}},e.prototype.getPluggable=function(e){var t=this._pluggables.find((function(t){return t.getProviderName()===e}));return void 0===t?(y.debug("No plugin found with providerName",e),null):t},e.prototype.removePluggable=function(e){this._pluggables=this._pluggables.filter((function(t){return t.getProviderName()!==e}))},e.prototype.configure=function(e){var t=this;if(y.debug("configure Storage"),!e)return this._config;var r=n.Parser.parseMobilehubConfig(e),o=Object.keys(r.Storage),i=["bucket","region","level","track","customPrefix","serverSideEncryption","SSECustomerAlgorithm","SSECustomerKey","SSECustomerKeyMD5","SSEKMSKeyId"],u=function(e){return i.some((function(t){return t===e}))};return o&&o.find((function(e){return u(e)}))&&!r.Storage.AWSS3&&(r.Storage.AWSS3={}),Object.entries(r.Storage).map((function(e){var t=e[0],n=e[1];t&&u(t)&&void 0!==n&&(r.Storage.AWSS3[t]=n,delete r.Storage[t])})),Object.keys(r.Storage).forEach((function(e){"string"!=typeof r.Storage[e]&&(t._config[e]=g(g({},t._config[e]),r.Storage[e]))})),this._pluggables.forEach((function(e){e.configure(t._config[e.getProviderName()])})),0===this._pluggables.length&&this.addPluggable(new p),this._config},e.prototype.get=function(e,t){return h(this,void 0,void 0,(function(){var r,n,o;return b(this,(function(i){return r=(t||{}).provider,n=void 0===r?"AWSS3":r,void 0===(o=this._pluggables.find((function(e){return e.getProviderName()===n})))&&(y.debug("No plugin found with providerName",n),Promise.reject("No plugin found in Storage for the provider")),[2,o.get(e,t)]}))}))},e.prototype.put=function(e,t,r){return h(this,void 0,void 0,(function(){var n,o,i;return b(this,(function(u){return n=(r||{}).provider,o=void 0===n?"AWSS3":n,void 0===(i=this._pluggables.find((function(e){return e.getProviderName()===o})))&&(y.debug("No plugin found with providerName",o),Promise.reject("No plugin found in Storage for the provider")),[2,i.put(e,t,r)]}))}))},e.prototype.remove=function(e,t){return h(this,void 0,void 0,(function(){var r,n,o;return b(this,(function(i){return r=(t||{}).provider,n=void 0===r?"AWSS3":r,void 0===(o=this._pluggables.find((function(e){return e.getProviderName()===n})))&&(y.debug("No plugin found with providerName",n),Promise.reject("No plugin found in Storage for the provider")),[2,o.remove(e,t)]}))}))},e.prototype.list=function(e,t){return h(this,void 0,void 0,(function(){var r,n,o;return b(this,(function(i){return r=(t||{}).provider,n=void 0===r?"AWSS3":r,void 0===(o=this._pluggables.find((function(e){return e.getProviderName()===n})))&&(y.debug("No plugin found with providerName",n),Promise.reject("No plugin found in Storage for the provider")),[2,o.list(e,t)]}))}))},e}();r.d(t,"StorageClass",(function(){return v})),r.d(t,"AWSS3Provider",(function(){return p}));var m=function(){return(m=Object.assign||function(e){for(var t,r=1,n=arguments.length;r<n;r++)for(var o in t=arguments[r])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)},S=new n.ConsoleLogger("Storage"),w=null;if(!w){S.debug("Create Storage Instance"),(w=new v).vault=new v;var _=w.configure;w.configure=function(e){S.debug("storage configure called");var t=m({},_.call(w,e));Object.keys(t).forEach((function(e){"string"!=typeof t[e]&&(t[e]=m(m({},t[e]),{level:"private"}))})),S.debug("storage vault configure called"),w.vault.configure(t)}}var P=w;o.a.register(P);t.default=P}])}));
	//# sourceMappingURL=aws-amplify-storage.min.js.map

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	!function(t,_){ true?module.exports=_():"function"==typeof define&&define.amd?define("aws_amplify_ui",[],_):"object"==typeof exports?exports.aws_amplify_ui=_():t.aws_amplify_ui=_()}(this,(function(){return function(t){var _={};function n(o){if(_[o])return _[o].exports;var e=_[o]={i:o,l:!1,exports:{}};return t[o].call(e.exports,e,e.exports,n),e.l=!0,e.exports}return n.m=t,n.c=_,n.d=function(t,_,o){n.o(t,_)||Object.defineProperty(t,_,{enumerable:!0,get:o})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,_){if(1&_&&(t=n(t)),8&_)return t;if(4&_&&"object"==typeof t&&t&&t.__esModule)return t;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:t}),2&_&&"string"!=typeof t)for(var e in t)n.d(o,e,function(_){return t[_]}.bind(null,e));return o},n.n=function(t){var _=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(_,"a",_),_},n.o=function(t,_){return Object.prototype.hasOwnProperty.call(t,_)},n.p="",n(n.s=0)}([function(t,_,n){"use strict";function o(t){for(var n in t)_.hasOwnProperty(n)||(_[n]=t[n])}Object.defineProperty(_,"__esModule",{value:!0}),o(n(1)),o(n(2)),o(n(3)),o(n(4)),o(n(5)),o(n(6)),o(n(7)),o(n(8)),o(n(9)),o(n(10)),o(n(11)),o(n(12)),o(n(13))},function(t,_,n){t.exports={a:"Anchor__a___1_Iz8"}},function(t,_,n){t.exports={button:"Button__button___vS7Mv",signInButton:"Button__signInButton___3bUH-",googleSignInButton:"Button__googleSignInButton___1YiCu",signInButtonIcon:"Button__signInButtonIcon___ihN75",auth0SignInButton:"Button__auth0SignInButton___znnCj",facebookSignInButton:"Button__facebookSignInButton___34Txh",amazonSignInButton:"Button__amazonSignInButton___2EMtl",oAuthSignInButton:"Button__oAuthSignInButton___3UGOl",signInButtonContent:"Button__signInButtonContent___xqTXJ"}},function(t,_,n){t.exports={formContainer:"Form__formContainer___1GA3x",formSection:"Form__formSection___1PPvW",formField:"Form__formField___38Ikl",formRow:"Form__formRow___2mwRs"}},function(t,_,n){t.exports={hint:"Hint__hint___2XngB"}},function(t,_,n){t.exports={input:"Input__input___3e_bf",inputLabel:"Input__inputLabel___3VF0S",label:"Input__label___23sO8",radio:"Input__radio___2hllK"}},function(t,_,n){t.exports={navBar:"Nav__navBar___xtCFA",navRight:"Nav__navRight___1QG2J",nav:"Nav__nav___2Dx2Y",navItem:"Nav__navItem___1LtFQ"}},function(t,_,n){t.exports={photoPickerButton:"PhotoPicker__photoPickerButton___2XdVn",photoPlaceholder:"PhotoPicker__photoPlaceholder___2JXO4",photoPlaceholderIcon:"PhotoPicker__photoPlaceholderIcon___3Et71"}},function(t,_,n){t.exports={container:"Section__container___3YYTG",actionRow:"Section__actionRow___2LWSU",sectionHeader:"Section__sectionHeader___2djyg",sectionHeaderHint:"Section__sectionHeaderHint___3Wxdc",sectionBody:"Section__sectionBody___ihqqd",sectionHeaderContent:"Section__sectionHeaderContent___1UCqa",sectionFooter:"Section__sectionFooter___1T54C",sectionFooterPrimaryContent:"Section__sectionFooterPrimaryContent___2r9ZX",sectionFooterSecondaryContent:"Section__sectionFooterSecondaryContent___Nj41Q"}},function(t,_,n){t.exports={selectInput:"SelectInput__selectInput___3efO4"}},function(t,_,n){t.exports={strike:"Strike__strike___1XV1b",strikeContent:"Strike__strikeContent___10gLb"}},function(t,_,n){t.exports={toast:"Toast__toast___XXr3v",toastClose:"Toast__toastClose___18lU4"}},function(t,_,n){t.exports={totpQrcode:"Totp__totpQrcode___1crLx"}},function(t,_,n){t.exports={sumerianSceneContainer:"XR__sumerianSceneContainer___3nVMt",sumerianScene:"XR__sumerianScene___2Tt7-",loadingOverlay:"XR__loadingOverlay___IbqcI",loadingContainer:"XR__loadingContainer___2Itxb",loadingLogo:"XR__loadingLogo___Ub7xQ",loadingSceneName:"XR__loadingSceneName___3__ne",loadingBar:"XR__loadingBar___2vcke",loadingBarFill:"XR__loadingBarFill___3M-D9",sceneErrorText:"XR__sceneErrorText___2y0tp",sceneBar:"XR__sceneBar___2ShrP",sceneName:"XR__sceneName___1ApHr",sceneActions:"XR__sceneActions___7plGs",actionButton:"XR__actionButton___2poIM",tooltip:"XR__tooltip___UYyhn",actionIcon:"XR__actionIcon___2qnd2",autoShowTooltip:"XR__autoShowTooltip___V1QH7"}}])}));
	//# sourceMappingURL=aws-amplify-ui.js.map

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(26)):"function"==typeof define&&define.amd?define("aws_amplify_xr",["@aws-amplify/core"],t):"object"==typeof exports?exports.aws_amplify_xr=t(require("@aws-amplify/core")):e.aws_amplify_xr=t(e["@aws-amplify/core"])}(this,(function(e){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=1)}([function(t,n){t.exports=e},function(e,t,n){"use strict";n.r(t);var r,o=n(0),i=n.n(o),u=function(){return(u=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)},s=new o.ConsoleLogger("AbstractXRProvider"),c=function(){function e(e){void 0===e&&(e={}),this._config=e}return e.prototype.configure=function(e){return void 0===e&&(e={}),this._config=u(u({},e),this._config),s.debug("configure "+this.getProviderName(),this._config),this.options},e.prototype.getCategory=function(){return"XR"},Object.defineProperty(e.prototype,"options",{get:function(){return u({},this._config)},enumerable:!0,configurable:!0}),e}(),a=(r=function(e,t){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}r(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),l=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return a(t,e),t}(Error),f=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return a(t,e),t}(l),p=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return a(t,e),t}(l),d=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return a(t,e),t}(l),h=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return a(t,e),t}(l),g=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return a(t,e),t}(l),v=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return a(t,e),t}(l),y=function(){var e=function(t,n){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(t,n)};return function(t,n){function r(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}(),b=function(){return(b=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)},w=function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function u(e){try{c(r.next(e))}catch(e){i(e)}}function s(e){try{c(r.throw(e))}catch(e){i(e)}}function c(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(u,s)}c((r=r.apply(e,t||[])).next())}))},_=function(e,t){var n,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function s(i){return function(s){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;u;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,r=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=t.call(e,u)}catch(e){i=[6,e],r=0}finally{n=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,s])}}},P=new o.ConsoleLogger("SumerianProvider"),m=function(e){function t(t){return void 0===t&&(t={}),e.call(this,t)||this}return y(t,e),t.prototype.getProviderName=function(){return"SumerianProvider"},t.prototype.loadScript=function(e){return w(this,void 0,void 0,(function(){return _(this,(function(t){return[2,new Promise((function(t,n){var r=document.createElement("script");r.src=e,r.addEventListener("load",(function(e){t()})),r.addEventListener("error",(function(t){n(new Error("Failed to load script: "+e))})),document.head.appendChild(r)}))]}))}))},t.prototype.loadScene=function(e,t,n){return w(this,void 0,void 0,(function(){var r,i,u,s,c,a,l,f,p,d,v,y,w,m,S,C,O,R,x,j,X,A,E,N,k;return _(this,(function(_){switch(_.label){case 0:if(!e)throw a="No scene name passed into loadScene",P.error(a),new g(a);if(!t)throw a="No dom element id passed into loadScene",P.error(a),new h(a);if(!(r=document.getElementById(t)))throw a="DOM element id, "+t+" not found",P.error(a),new h(a);if(!(i=this.getScene(e)).sceneConfig)throw a="No scene config configured for scene: "+e,P.error(a),new g(a);if(u=i.sceneConfig.url,s=i.sceneConfig.sceneId,i.sceneConfig.hasOwnProperty("region"))c=i.sceneConfig.region;else{if(!this.options.hasOwnProperty("region"))throw a="No region configured for scene: "+e,P.error(a),new g(a);c=this.options.region}l={region:c,customUserAgent:o.Constants.userAgent+"-SumerianScene"},f={headers:{"X-Amz-User-Agent":o.Constants.userAgent}},p=u,_.label=1;case 1:return _.trys.push([1,3,,4]),[4,o.Credentials.get()];case 2:return d=_.sent(),l.credentials=d,v={secret_key:d.secretAccessKey,access_key:d.accessKeyId,session_token:d.sessionToken},y={region:c,service:"sumerian"},w=o.Signer.sign({method:"GET",url:u},v,y),f.headers=b(b({},f.headers),w.headers),p=w.url,[3,4];case 3:return _.sent(),P.debug("No credentials available, the request will be unsigned"),[3,4];case 4:return[4,fetch(p,f)];case 5:return[4,(m=_.sent()).json()];case 6:if(S=_.sent(),403===m.status)throw S.message?(P.error("Failure to authenticate user: "+S.message),new g("Failure to authenticate user: "+S.message)):(P.error("Failure to authenticate user"),new g("Failure to authenticate user"));return C=S.bundleData[s],[4,fetch(C.url,{headers:C.headers})];case 7:return[4,_.sent().json()];case 8:O=_.sent(),_.label=9;case 9:return _.trys.push([9,11,,12]),[4,this.loadScript(O[s].bootstrapperUrl)];case 10:return _.sent(),[3,12];case 11:throw R=_.sent(),P.error(R),new g(R);case 12:return x=n.progressCallback?n.progressCallback:void 0,j=i.publishParamOverrides?i.publishParamOverrides:void 0,X={element:r,sceneId:s,sceneBundle:O,apiResponse:S,progressCallback:x,publishParamOverrides:j,awsSDKConfigOverride:l},[4,window.SumerianBootstrapper.loadScene(X)];case 13:for(A=_.sent(),i.sceneController=A,i.isLoaded=!0,E=0,N=A.sceneLoadWarnings;E<N.length;E++)k=N[E],P.warn("loadScene warning: "+k);return[2]}}))}))},t.prototype.isSceneLoaded=function(e){return this.getScene(e).isLoaded||!1},t.prototype.getScene=function(e){if(!this.options.scenes){var t="No scenes were defined in the configuration";throw P.error(t),new f(t)}if(!e){t="No scene name was passed";throw P.error(t),new p(t)}if(!this.options.scenes[e]){t="Scene '"+e+"' is not configured";throw P.error(t),new p(t)}return this.options.scenes[e]},t.prototype.getSceneController=function(e){if(!this.options.scenes){var t="No scenes were defined in the configuration";throw P.error(t),new f(t)}var n=this.options.scenes[e];if(!n){t="Scene '"+e+"' is not configured";throw P.error(t),new p(t)}var r=n.sceneController;if(!r){t="Scene controller for '"+e+"' has not been loaded";throw P.error(t),new d(t)}return r},t.prototype.isVRCapable=function(e){return this.getSceneController(e).vrCapable},t.prototype.isVRPresentationActive=function(e){return this.getSceneController(e).vrPresentationActive},t.prototype.start=function(e){this.getSceneController(e).start()},t.prototype.enterVR=function(e){this.getSceneController(e).enterVR()},t.prototype.exitVR=function(e){this.getSceneController(e).exitVR()},t.prototype.isMuted=function(e){return this.getSceneController(e).muted},t.prototype.setMuted=function(e,t){this.getSceneController(e).muted=t},t.prototype.onSceneEvent=function(e,t,n){this.getSceneController(e).on(t,n)},t.prototype.enableAudio=function(e){this.getSceneController(e).enableAudio()},t}(c),S=function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function u(e){try{c(r.next(e))}catch(e){i(e)}}function s(e){try{c(r.throw(e))}catch(e){i(e)}}function c(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(u,s)}c((r=r.apply(e,t||[])).next())}))},C=function(e,t){var n,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function s(i){return function(s){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;u;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,r=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=t.call(e,u)}catch(e){i=[6,e],r=0}finally{n=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,s])}}},O=new o.ConsoleLogger("XR"),R=function(){function e(e){this._options=e,O.debug("XR Options",this._options),this._defaultProvider="SumerianProvider",this._pluggables={},this.addPluggable(new m)}return e.prototype.configure=function(e){var t=this,n=e?e.XR||e:{};return O.debug("configure XR",{opt:n}),this._options=Object.assign({},this._options,n),Object.entries(this._pluggables).map((function(e){var r=e[0],o=e[1];r!==t._defaultProvider||n[t._defaultProvider]?o.configure(t._options[r]):o.configure(t._options)})),this._options},e.prototype.addPluggable=function(e){return S(this,void 0,void 0,(function(){return C(this,(function(t){return e&&"XR"===e.getCategory()?(this._pluggables[e.getProviderName()]=e,[2,e.configure(this._options)]):[2]}))}))},e.prototype.loadScene=function(e,t,n,r){return void 0===n&&(n={}),void 0===r&&(r=this._defaultProvider),S(this,void 0,void 0,(function(){return C(this,(function(o){switch(o.label){case 0:if(!this._pluggables[r])throw new v("Provider '"+r+"' not configured");return[4,this._pluggables[r].loadScene(e,t,n)];case 1:return[2,o.sent()]}}))}))},e.prototype.isSceneLoaded=function(e,t){if(void 0===t&&(t=this._defaultProvider),!this._pluggables[t])throw new v("Provider '"+t+"' not configured");return this._pluggables[t].isSceneLoaded(e)},e.prototype.getSceneController=function(e,t){if(void 0===t&&(t=this._defaultProvider),!this._pluggables[t])throw new v("Provider '"+t+"' not configured");return this._pluggables[t].getSceneController(e)},e.prototype.isVRCapable=function(e,t){if(void 0===t&&(t=this._defaultProvider),!this._pluggables[t])throw new v("Provider '"+t+"' not configured");return this._pluggables[t].isVRCapable(e)},e.prototype.isVRPresentationActive=function(e,t){if(void 0===t&&(t=this._defaultProvider),!this._pluggables[t])throw new v("Provider '"+t+"' not configured");return this._pluggables[t].isVRPresentationActive(e)},e.prototype.start=function(e,t){if(void 0===t&&(t=this._defaultProvider),!this._pluggables[t])throw new v("Provider '"+t+"' not configured");return this._pluggables[t].start(e)},e.prototype.enterVR=function(e,t){if(void 0===t&&(t=this._defaultProvider),!this._pluggables[t])throw new v("Provider '"+t+"' not configured");return this._pluggables[t].enterVR(e)},e.prototype.exitVR=function(e,t){if(void 0===t&&(t=this._defaultProvider),!this._pluggables[t])throw new v("Provider '"+t+"' not configured");return this._pluggables[t].exitVR(e)},e.prototype.isMuted=function(e,t){if(void 0===t&&(t=this._defaultProvider),!this._pluggables[t])throw new v("Provider '"+t+"' not configured");return this._pluggables[t].isMuted(e)},e.prototype.setMuted=function(e,t,n){if(void 0===n&&(n=this._defaultProvider),!this._pluggables[n])throw new v("Provider '"+n+"' not configured");return this._pluggables[n].setMuted(e,t)},e.prototype.onSceneEvent=function(e,t,n,r){if(void 0===r&&(r=this._defaultProvider),!this._pluggables[r])throw new v("Provider '"+r+"' not configured");return this._pluggables[r].onSceneEvent(e,t,n)},e.prototype.enableAudio=function(e,t){if(void 0===t&&(t=this._defaultProvider),!this._pluggables[t])throw new v("Provider '"+t+"' not configured");return this._pluggables[t].enableAudio(e)},e}();n.d(t,"SumerianProvider",(function(){return m})),n.d(t,"XRClass",(function(){return R})),n.d(t,"XRError",(function(){return l})),n.d(t,"XRNoSceneConfiguredError",(function(){return f})),n.d(t,"XRSceneNotFoundError",(function(){return p})),n.d(t,"XRSceneNotLoadedError",(function(){return d})),n.d(t,"XRNoDomElement",(function(){return h})),n.d(t,"XRSceneLoadFailure",(function(){return g})),n.d(t,"XRProviderNotConfigured",(function(){return v}));var x=new o.ConsoleLogger("XR"),j=null;j||(x.debug("Create XR Instance"),j=new R(null));var X=j;i.a.register(X);t.default=X}])}));
	//# sourceMappingURL=aws-amplify-xr.min.js.map

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
		module.exports = __webpack_require__(337);
	} else {
		module.exports = require('./dist/aws-amplify-xr.js');
	}


/***/ },
/* 339 */
/***/ function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 340 */
/***/ function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 341 */
/***/ function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 342 */
/***/ function(module, exports) {

	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _getPrototypeOf(o);
	}
	
	module.exports = _getPrototypeOf;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(155);
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inherits;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(4);
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(156)["default"];
	
	var assertThisInitialized = __webpack_require__(154);
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return assertThisInitialized(self);
	}
	
	module.exports = _possibleConstructorReturn;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _inheritsLoose = __webpack_require__(38);
	var React = __webpack_require__(2);
	__webpack_require__(157);
	var emotionElement = __webpack_require__(347);
	var utils = __webpack_require__(159);
	var serialize = __webpack_require__(87);
	var sheet = __webpack_require__(158);
	var css = __webpack_require__(348);
	
	function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }
	
	var _inheritsLoose__default = /*#__PURE__*/_interopDefault(_inheritsLoose);
	var css__default = /*#__PURE__*/_interopDefault(css);
	
	var jsx = function jsx(type, props) {
	  var args = arguments;
	
	  if (props == null || !emotionElement.hasOwnProperty.call(props, 'css')) {
	    // $FlowFixMe
	    return React.createElement.apply(undefined, args);
	  }
	
	  var argsLength = args.length;
	  var createElementArgArray = new Array(argsLength);
	  createElementArgArray[0] = emotionElement.Emotion;
	  createElementArgArray[1] = emotionElement.createEmotionProps(type, props);
	
	  for (var i = 2; i < argsLength; i++) {
	    createElementArgArray[i] = args[i];
	  } // $FlowFixMe
	
	
	  return React.createElement.apply(null, createElementArgArray);
	};
	
	var warnedAboutCssPropForGlobal = false;
	var Global = /* #__PURE__ */emotionElement.withEmotionCache(function (props, cache) {
	  if (false) {
	    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
	    warnedAboutCssPropForGlobal = true;
	  }
	
	  var styles = props.styles;
	
	  if (typeof styles === 'function') {
	    return /*#__PURE__*/React.createElement(emotionElement.ThemeContext.Consumer, null, function (theme) {
	      var serialized = serialize.serializeStyles([styles(theme)]);
	      return /*#__PURE__*/React.createElement(InnerGlobal, {
	        serialized: serialized,
	        cache: cache
	      });
	    });
	  }
	
	  var serialized = serialize.serializeStyles([styles]);
	  return /*#__PURE__*/React.createElement(InnerGlobal, {
	    serialized: serialized,
	    cache: cache
	  });
	});
	
	// maintain place over rerenders.
	// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
	// initial client-side render from SSR, use place of hydrating tag
	var InnerGlobal = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose__default['default'](InnerGlobal, _React$Component);
	
	  function InnerGlobal(props, context, updater) {
	    return _React$Component.call(this, props, context, updater) || this;
	  }
	
	  var _proto = InnerGlobal.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.sheet = new sheet.StyleSheet({
	      key: this.props.cache.key + "-global",
	      nonce: this.props.cache.sheet.nonce,
	      container: this.props.cache.sheet.container
	    }); // $FlowFixMe
	
	    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
	
	    if (node !== null) {
	      this.sheet.tags.push(node);
	    }
	
	    if (this.props.cache.sheet.tags.length) {
	      this.sheet.before = this.props.cache.sheet.tags[0];
	    }
	
	    this.insertStyles();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.serialized.name !== this.props.serialized.name) {
	      this.insertStyles();
	    }
	  };
	
	  _proto.insertStyles = function insertStyles() {
	    if (this.props.serialized.next !== undefined) {
	      // insert keyframes
	      utils.insertStyles(this.props.cache, this.props.serialized.next, true);
	    }
	
	    if (this.sheet.tags.length) {
	      // if this doesn't exist then it will be null so the style element will be appended
	      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
	      this.sheet.before = element;
	      this.sheet.flush();
	    }
	
	    this.props.cache.insert("", this.props.serialized, this.sheet, false);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.sheet.flush();
	  };
	
	  _proto.render = function render() {
	
	    return null;
	  };
	
	  return InnerGlobal;
	}(React.Component);
	
	var keyframes = function keyframes() {
	  var insertable = css__default['default'].apply(void 0, arguments);
	  var name = "animation-" + insertable.name; // $FlowFixMe
	
	  return {
	    name: name,
	    styles: "@keyframes " + name + "{" + insertable.styles + "}",
	    anim: 1,
	    toString: function toString() {
	      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
	    }
	  };
	};
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	
	function merge(registered, css, className) {
	  var registeredStyles = [];
	  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
	
	  if (registeredStyles.length < 2) {
	    return className;
	  }
	
	  return rawClassName + css(registeredStyles);
	}
	
	var ClassNames = emotionElement.withEmotionCache(function (props, context) {
	  return /*#__PURE__*/React.createElement(emotionElement.ThemeContext.Consumer, null, function (theme) {
	    var hasRendered = false;
	
	    var css = function css() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('css can only be used during render');
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var serialized = serialize.serializeStyles(args, context.registered);
	
	      {
	        utils.insertStyles(context, serialized, false);
	      }
	
	      return context.key + "-" + serialized.name;
	    };
	
	    var cx = function cx() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('cx can only be used during render');
	      }
	
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return merge(context.registered, css, classnames(args));
	    };
	
	    var content = {
	      css: css,
	      cx: cx,
	      theme: theme
	    };
	    var ele = props.children(content);
	    hasRendered = true;
	
	    return ele;
	  });
	});
	
	exports.CacheProvider = emotionElement.CacheProvider;
	exports.ThemeContext = emotionElement.ThemeContext;
	exports.withEmotionCache = emotionElement.withEmotionCache;
	Object.defineProperty(exports, 'css', {
	  enumerable: true,
	  get: function () {
	    return css__default['default'];
	  }
	});
	exports.ClassNames = ClassNames;
	exports.Global = Global;
	exports.createElement = jsx;
	exports.jsx = jsx;
	exports.keyframes = keyframes;


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(38);
	var React = __webpack_require__(2);
	var createCache = __webpack_require__(157);
	var utils = __webpack_require__(159);
	var serialize = __webpack_require__(87);
	
	function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }
	
	var createCache__default = /*#__PURE__*/_interopDefault(createCache);
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var EmotionCacheContext = /*#__PURE__*/React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
	// because this module is primarily intended for the browser and node
	// but it's also required in react native and similar environments sometimes
	// and we could have a special build just for that
	// but this is much easier and the native packages
	// might use a different theme context in the future anyway
	typeof HTMLElement !== 'undefined' ? createCache__default['default']() : null);
	var ThemeContext = /*#__PURE__*/React.createContext({});
	var CacheProvider = EmotionCacheContext.Provider;
	
	var withEmotionCache = function withEmotionCache(func) {
	  var render = function render(props, ref) {
	    return /*#__PURE__*/React.createElement(EmotionCacheContext.Consumer, null, function (cache) {
	      return func(props, cache, ref);
	    });
	  }; // $FlowFixMe
	
	
	  return /*#__PURE__*/React.forwardRef(render);
	};
	
	// thus we only need to replace what is a valid character for JS, but not for CSS
	
	var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
	  return identifier.replace(/\$/g, '-');
	};
	
	var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
	var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
	var createEmotionProps = function createEmotionProps(type, props) {
	  if (false) {
	    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
	  }
	
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions
	
	  if (false) {
	    var error = new Error();
	
	    if (error.stack) {
	      // chrome
	      var match = error.stack.match(/at (?:Object\.|Module\.|)(?:jsx|createEmotionProps).*\n\s+at (?:Object\.|)([A-Z][A-Za-z$]+) /);
	
	      if (!match) {
	        // safari and firefox
	        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
	      }
	
	      if (match) {
	        newProps[labelPropName] = sanitizeIdentifier(match[1]);
	      }
	    }
	  }
	
	  return newProps;
	};
	
	var render = function render(cache, props, theme, ref) {
	  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
	  // not passing the registered cache to serializeStyles because it would
	  // make certain babel optimisations not possible
	
	  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
	    cssProp = cache.registered[cssProp];
	  }
	
	  var type = props[typePropName];
	  var registeredStyles = [cssProp];
	  var className = '';
	
	  if (typeof props.className === 'string') {
	    className = utils.getRegisteredStyles(cache.registered, registeredStyles, props.className);
	  } else if (props.className != null) {
	    className = props.className + " ";
	  }
	
	  var serialized = serialize.serializeStyles(registeredStyles);
	
	  if (false) {
	    var labelFromStack = props[labelPropName];
	
	    if (labelFromStack) {
	      serialized = serialize.serializeStyles([serialized, 'label:' + labelFromStack + ';']);
	    }
	  }
	
	  var rules = utils.insertStyles(cache, serialized, typeof type === 'string');
	  className += cache.key + "-" + serialized.name;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (("production") === 'production' || key !== labelPropName)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps.ref = ref;
	  newProps.className = className;
	  var ele = /*#__PURE__*/React.createElement(type, newProps);
	
	  return ele;
	}; // eslint-disable-next-line no-undef
	
	
	var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
	  if (typeof props.css === 'function') {
	    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
	      return render(cache, props, theme, ref);
	    });
	  }
	
	  return render(cache, props, null, ref);
	});
	
	if (false) {
	  Emotion.displayName = 'EmotionCssPropInternal';
	}
	
	exports.CacheProvider = CacheProvider;
	exports.Emotion = Emotion;
	exports.ThemeContext = ThemeContext;
	exports.createEmotionProps = createEmotionProps;
	exports.hasOwnProperty = hasOwnProperty;
	exports.withEmotionCache = withEmotionCache;


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var serialize = __webpack_require__(87);
	
	function css() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return serialize.serializeStyles(args);
	}
	
	exports.default = css;


/***/ },
/* 349 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/* eslint-disable */
	// Inspired by https://github.com/garycourt/murmurhash-js
	// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
	function murmur2(str) {
	  // 'm' and 'r' are mixing constants generated offline.
	  // They're not really 'magic', they just happen to work well.
	  // const m = 0x5bd1e995;
	  // const r = 24;
	  // Initialize the hash
	  var h = 0; // Mix 4 bytes at a time into the hash
	
	  var k,
	      i = 0,
	      len = str.length;
	
	  for (; len >= 4; ++i, len -= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k =
	    /* Math.imul(k, m): */
	    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
	    k ^=
	    /* k >>> r: */
	    k >>> 24;
	    h =
	    /* Math.imul(k, m): */
	    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
	    /* Math.imul(h, m): */
	    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
	  } // Handle the last few bytes of the input array
	
	
	  switch (len) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h =
	      /* Math.imul(h, m): */
	      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
	  } // Do a few final mixes of the hash to ensure the last few
	  // bytes are well-incorporated.
	
	
	  h ^= h >>> 13;
	  h =
	  /* Math.imul(h, m): */
	  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
	  return ((h ^ h >>> 15) >>> 0).toString(36);
	}
	
	exports.default = murmur2;


/***/ },
/* 350 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	exports.default = memoize;


/***/ },
/* 351 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function stylis_min (W) {
	  function M(d, c, e, h, a) {
	    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
	      g = e.charCodeAt(l);
	      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
	
	      if (0 === b + n + v + m) {
	        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
	          switch (g) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              f += e.charAt(l);
	          }
	
	          g = 59;
	        }
	
	        switch (g) {
	          case 123:
	            f = f.trim();
	            q = f.charCodeAt(0);
	            k = 1;
	
	            for (t = ++l; l < B;) {
	              switch (g = e.charCodeAt(l)) {
	                case 123:
	                  k++;
	                  break;
	
	                case 125:
	                  k--;
	                  break;
	
	                case 47:
	                  switch (g = e.charCodeAt(l + 1)) {
	                    case 42:
	                    case 47:
	                      a: {
	                        for (u = l + 1; u < J; ++u) {
	                          switch (e.charCodeAt(u)) {
	                            case 47:
	                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                              break;
	
	                            case 10:
	                              if (47 === g) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                          }
	                        }
	
	                        l = u;
	                      }
	
	                  }
	
	                  break;
	
	                case 91:
	                  g++;
	
	                case 40:
	                  g++;
	
	                case 34:
	                case 39:
	                  for (; l++ < J && e.charCodeAt(l) !== g;) {
	                  }
	
	              }
	
	              if (0 === k) break;
	              l++;
	            }
	
	            k = e.substring(t, l);
	            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < r && (f = f.replace(N, ''));
	                g = f.charCodeAt(1);
	
	                switch (g) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                k = M(c, r, k, g, a + 1);
	                t = k.length;
	                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
	                if (0 < t) switch (g) {
	                  case 115:
	                    f = f.replace(da, ea);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    k = f + '{' + k + '}';
	                    break;
	
	                  case 107:
	                    f = f.replace(fa, '$1 $2');
	                    k = f + '{' + k + '}';
	                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
	                    break;
	
	                  default:
	                    k = f + k, 112 === h && (k = (p += k, ''));
	                } else k = '';
	                break;
	
	              default:
	                k = M(c, X(c, f, I), k, h, a + 1);
	            }
	
	            F += k;
	            k = I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	            break;
	
	          case 125:
	          case 59:
	            f = (0 < r ? f.replace(N, '') : f).trim();
	            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
	              case 0:
	                break;
	
	              case 64:
	                if (105 === g || 99 === g) {
	                  G += f + e.charAt(l);
	                  break;
	                }
	
	              default:
	                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
	            }
	            I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	        }
	      }
	
	      switch (g) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
	          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
	          z = 1;
	          D++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + n + v + m) {
	            z++;
	            break;
	          }
	
	        default:
	          z++;
	          y = e.charAt(l);
	
	          switch (g) {
	            case 9:
	            case 32:
	              if (0 === n + m + b) switch (x) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  y = '';
	                  break;
	
	                default:
	                  32 !== g && (y = ' ');
	              }
	              break;
	
	            case 0:
	              y = '\\0';
	              break;
	
	            case 12:
	              y = '\\f';
	              break;
	
	            case 11:
	              y = '\\v';
	              break;
	
	            case 38:
	              0 === n + b + m && (r = I = 1, y = '\f' + y);
	              break;
	
	            case 108:
	              if (0 === n + b + m + E && 0 < u) switch (l - u) {
	                case 2:
	                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
	
	                case 8:
	                  111 === K && (E = K);
	              }
	              break;
	
	            case 58:
	              0 === n + b + m && (u = l);
	              break;
	
	            case 44:
	              0 === b + v + n + m && (r = 1, y += '\r');
	              break;
	
	            case 34:
	            case 39:
	              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
	              break;
	
	            case 91:
	              0 === n + b + v && m++;
	              break;
	
	            case 93:
	              0 === n + b + v && m--;
	              break;
	
	            case 41:
	              0 === n + b + m && v--;
	              break;
	
	            case 40:
	              if (0 === n + b + m) {
	                if (0 === q) switch (2 * x + 3 * K) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                v++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + v + n + m + u + k && (k = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < n + m + v)) switch (b) {
	                case 0:
	                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = l, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
	              }
	          }
	
	          0 === b && (f += y);
	      }
	
	      K = x;
	      x = g;
	      l++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
	      p = r.join(',') + '{' + p + '}';
	
	      if (0 !== w * E) {
	        2 !== w || L(p, 2) || (E = 0);
	
	        switch (E) {
	          case 111:
	            p = p.replace(ha, ':-moz-$1') + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
	        }
	
	        E = 0;
	      }
	    }
	
	    return G + p + F;
	  }
	
	  function X(d, c, e) {
	    var h = c.trim().split(ia);
	    c = h;
	    var a = h.length,
	        m = d.length;
	
	    switch (m) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
	          c[b] = Z(d, c[b], e).trim();
	        }
	
	        break;
	
	      default:
	        var v = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var n = 0; n < m; ++n) {
	            c[v++] = Z(d[n] + ' ', h[b], e).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(d, c, e) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, '$1' + d.trim());
	
	      case 58:
	        return d.trim() + c.replace(F, '$1' + d.trim());
	
	      default:
	        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
	    }
	
	    return d + c;
	  }
	
	  function P(d, c, e, h) {
	    var a = d + ';',
	        m = 2 * c + 3 * e + 4 * h;
	
	    if (944 === m) {
	      d = a.indexOf(':', 9) + 1;
	      var b = a.substring(d, a.length - 1).trim();
	      b = a.substring(0, d).trim() + b + ';';
	      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
	    }
	
	    if (0 === w || 2 === w && !L(a, 1)) return a;
	
	    switch (m) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return '-webkit-' + a + a;
	
	      case 978:
	        return '-webkit-' + a + '-moz-' + a + a;
	
	      case 1019:
	      case 983:
	        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
	
	      case 883:
	        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
	        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
	        break;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
	
	          case 98:
	            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
	        }
	        return '-webkit-' + a + '-ms-' + a + a;
	
	      case 964:
	        return '-webkit-' + a + '-ms-flex-' + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
	        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf('-') + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, 'tb');
	            break;
	
	          case 232:
	            b = a.replace(G, 'tb-rl');
	            break;
	
	          case 220:
	            b = a.replace(G, 'lr');
	            break;
	
	          default:
	            return a;
	        }
	
	        return '-webkit-' + a + '-ms-' + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf('sticky', 9)) break;
	
	      case 975:
	        c = (a = d).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
	
	        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, '-webkit-' + b) + ';' + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
	        }
	
	        return a + ';';
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
	
	          default:
	            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
	        break;
	
	      case 962:
	        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
	    }
	
	    return a;
	  }
	
	  function L(d, c) {
	    var e = d.indexOf(1 === c ? ':' : '{'),
	        h = d.substring(0, 3 !== c ? e : 10);
	    e = d.substring(e + 1, d.length - 1);
	    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
	  }
	
	  function ea(d, c) {
	    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
	  }
	
	  function H(d, c, e, h, a, m, b, v, n, q) {
	    for (var g = 0, x = c, w; g < A; ++g) {
	      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          x = w;
	      }
	    }
	
	    if (x !== c) return x;
	  }
	
	  function T(d) {
	    switch (d) {
	      case void 0:
	      case null:
	        A = S.length = 0;
	        break;
	
	      default:
	        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
	          T(d[c]);
	        } else Y = !!d | 0;
	    }
	
	    return T;
	  }
	
	  function U(d) {
	    d = d.prefix;
	    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
	    return U;
	  }
	
	  function B(d, c) {
	    var e = d;
	    33 > e.charCodeAt(0) && (e = e.trim());
	    V = e;
	    e = [V];
	
	    if (0 < A) {
	      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
	      void 0 !== h && 'string' === typeof h && (c = h);
	    }
	
	    var a = M(O, e, c, 0, 0);
	    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    V = '';
	    E = 0;
	    z = D = 1;
	    return a;
	  }
	
	  var ca = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ia = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      fa = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ha = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      da = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      ja = /([^-])(image-set\()/,
	      z = 1,
	      D = 1,
	      E = 0,
	      w = 1,
	      O = [],
	      S = [],
	      A = 0,
	      R = null,
	      Y = 0,
	      V = '';
	  B.use = T;
	  B.set = U;
	  void 0 !== W && U(W);
	  return B;
	}
	
	exports.default = stylis_min;


/***/ },
/* 352 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  msGridRow: 1,
	  msGridRowSpan: 1,
	  msGridColumn: 1,
	  msGridColumnSpan: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports.default = unitlessKeys;


/***/ },
/* 353 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var weakMemoize = function weakMemoize(func) {
	  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
	  var cache = new WeakMap();
	  return function (arg) {
	    if (cache.has(arg)) {
	      // $FlowFixMe
	      return cache.get(arg);
	    }
	
	    var ret = func(arg);
	    cache.set(arg, ret);
	    return ret;
	  };
	};
	
	exports.default = weakMemoize;


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = useEventListener;
	
	var _react = __webpack_require__(2);
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(18));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Attaches an event handler outside directly to specified DOM element
	 * bypassing the react synthetic event system.
	 *
	 * @param element The target to listen for events on
	 * @param event The DOM event name
	 * @param handler An event handler
	 * @param capture Whether or not to listen during the capture event phase
	 */
	function useEventListener(eventTarget, event, listener, capture) {
	  if (capture === void 0) {
	    capture = false;
	  }
	
	  var handler = (0, _useEventCallback.default)(listener);
	  (0, _react.useEffect)(function () {
	    var target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
	    target.addEventListener(event, handler, capture);
	    return function () {
	      return target.removeEventListener(event, handler, capture);
	    };
	  }, [eventTarget]);
	}

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = useGlobalListener;
	
	var _useEventListener = _interopRequireDefault(__webpack_require__(354));
	
	var _react = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Attaches an event handler outside directly to the `document`,
	 * bypassing the react synthetic event system.
	 *
	 * ```ts
	 * useGlobalListener('keydown', (event) => {
	 *  console.log(event.key)
	 * })
	 * ```
	 *
	 * @param event The DOM event name
	 * @param handler An event handler
	 * @param capture Whether or not to listen during the capture event phase
	 */
	function useGlobalListener(event, handler, capture) {
	  if (capture === void 0) {
	    capture = false;
	  }
	
	  var documentTarget = (0, _react.useCallback)(function () {
	    return document;
	  }, []);
	  return (0, _useEventListener.default)(documentTarget, event, handler, capture);
	}

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = __webpack_require__(2);
	
	var _useMounted = _interopRequireDefault(__webpack_require__(89));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useSafeState(state) {
	  var isMounted = (0, _useMounted.default)();
	  return [state[0], (0, _react.useCallback)(function (nextState) {
	    if (!isMounted()) return;
	    return state[1](nextState);
	  }, [isMounted, state[1]])];
	}
	
	var _default = useSafeState;
	exports.default = _default;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Runs an effect only when the dependencies have changed, skipping the
	 * initial "on mount" run. Caution, if the dependency list never changes,
	 * the effect is **never run**
	 *
	 * ```ts
	 *  const ref = useRef<HTMLInput>(null);
	 *
	 *  // focuses an element only if the focus changes, and not on mount
	 *  useUpdateEffect(() => {
	 *    const element = ref.current?.children[focusedIdx] as HTMLElement
	 *
	 *    element?.focus()
	 *
	 *  }, [focusedIndex])
	 * ```
	 * @param effect An effect to run on mount
	 *
	 * @category effects
	 */
	function useUpdateEffect(fn, deps) {
	  var isFirst = (0, _react.useRef)(true);
	  (0, _react.useEffect)(function () {
	    if (isFirst.current) {
	      isFirst.current = false;
	      return;
	    }
	
	    return fn();
	  }, deps);
	}
	
	var _default = useUpdateEffect;
	exports.default = _default;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = useUpdatedRef;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Returns a ref that is immediately updated with the new value
	 *
	 * @param value The Ref value
	 * @category refs
	 */
	function useUpdatedRef(value) {
	  var valueRef = (0, _react.useRef)(value);
	  valueRef.current = value;
	  return valueRef;
	}

/***/ },
/* 359 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(2),__webpack_require__(26),__webpack_require__(80),__webpack_require__(336),__webpack_require__(86),__webpack_require__(273),__webpack_require__(443),__webpack_require__(137),__webpack_require__(332),__webpack_require__(338)):"function"==typeof define&&define.amd?define("aws_amplify_react",["react","@aws-amplify/core","@aws-amplify/auth","@aws-amplify/ui","@aws-amplify/storage","@aws-amplify/analytics","@aws-amplify/ui/dist/style.css","@aws-amplify/api","@aws-amplify/interactions","@aws-amplify/xr"],t):"object"==typeof exports?exports.aws_amplify_react=t(require("react"),require("@aws-amplify/core"),require("@aws-amplify/auth"),require("@aws-amplify/ui"),require("@aws-amplify/storage"),require("@aws-amplify/analytics"),require("@aws-amplify/ui/dist/style.css"),require("@aws-amplify/api"),require("@aws-amplify/interactions"),require("@aws-amplify/xr")):e.aws_amplify_react=t(e.react,e["@aws-amplify/core"],e["@aws-amplify/auth"],e["@aws-amplify/ui"],e["@aws-amplify/storage"],e["@aws-amplify/analytics"],e["@aws-amplify/ui/dist/style.css"],e["@aws-amplify/api"],e["@aws-amplify/interactions"],e["@aws-amplify/xr"])}(this,(function(e,t,n,o,r,i,a,s,u,c){return function(e){var t={};function n(o){if(t[o])return t[o].exports;var r=t[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,o){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:o})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)n.d(o,r,function(t){return e[t]}.bind(null,r));return o},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=48)}([function(t,n){t.exports=e},function(e,n){e.exports=t},function(e,t,n){"use strict";var o=this&&this.__assign||function(){return(o=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0});var r=n(0),i=n(1);n(51);var a=n(7),s=n(4);t.Container=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.container),c=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},c,{className:a.container,style:u}),e.children))},t.FormContainer=function(e){var n=e.theme||s.default;return t.beforeAfter(r.createElement("div",{className:a.formContainer,style:n.formContainer},e.children))},t.FormSection=function(e){var n=e.theme||s.default,o=t.propStyle(e,n.formSection);return r.createElement(t.FormContainer,{theme:n},t.beforeAfter(r.createElement("div",{className:a.formSection,style:o},e.children)))},t.SectionHeader=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.sectionHeader),c=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},c,{className:a.sectionHeader,style:u}),r.createElement(t.SectionHeaderContent,{theme:n},e.children,e.hint&&r.createElement("div",{className:a.sectionHeaderHint},e.hint))))},t.SectionHeaderContent=function(e){var n=e.theme||s.default,o=t.propStyle(e,n.sectionHeaderContent);return t.beforeAfter(r.createElement("span",{className:a.sectionHeaderContent,style:o},e.children))},t.SectionFooter=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.sectionFooter),c=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},c,{className:a.sectionFooter,style:u}),e.children))},t.SectionFooterPrimaryContent=function(e){var n=e.theme||s.default,o=t.propStyle(e,n.sectionFooterPrimaryContent);return t.beforeAfter(r.createElement("span",{className:a.sectionFooterPrimaryContent,style:o},e.children))},t.SectionFooterSecondaryContent=function(e){var n=e.theme||s.default,o=t.propStyle(e,n.sectionFooterSecondaryContent);return t.beforeAfter(r.createElement("span",{className:a.sectionFooterSecondaryContent,style:o},e.children))},t.SectionBody=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.sectionBody),c=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},c,{className:a.sectionBody,style:u}),e.children))},t.ActionRow=function(e){var n=e.theme||s.default,a=t.propStyle(e,n.actionRow),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},u,{className:"amplify-action-row",style:a}),e.children))},t.Strike=function(e){var n=e.theme||s.default,o=t.propStyle(e,n.strike);return t.beforeAfter(r.createElement("div",{className:a.strike,style:o},r.createElement(t.StrikeContent,{theme:n},e.children)))},t.StrikeContent=function(e){var n=e.theme||s.default;return t.beforeAfter(r.createElement("span",{className:a.strikeContent,style:n.strikeContent},e.children))},t.FormRow=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.formRow),c=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},c,{className:a.formRow,style:u}),e.children))},t.RadioRow=function(e){var n=e.id||"_"+e.value,i=e.theme||s.default;return r.createElement(t.FormRow,{theme:i},r.createElement(t.Radio,o({},e,{id:n})),r.createElement(t.Label,{htmlFor:n,theme:i},e.placeholder))},t.Radio=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.radio),c=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("input",o({},c,{type:"radio",className:a.radio,style:u})))},t.InputRow=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.input),c=i.JS.objectLessAttributes(e,"theme");return r.createElement(t.FormRow,{theme:n},t.beforeAfter(r.createElement("input",o({},c,{className:a.input,style:u}))))},t.Input=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.input),c=i.JS.objectLessAttributes(e,"theme");return r.createElement("input",o({},c,{className:a.input,style:u}))},t.SelectInput=function(e){var n=e.theme||s.default,o=t.propStyle(e,n.selectInput);return r.createElement("div",{className:a.selectInput,style:o},e.children)},t.FormField=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.formField),c=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},c,{className:a.formField,style:u}),e.children))},t.Button=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.button),c=e.disabled||!1,l=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("button",o({},l,{className:a.button,style:u,disabled:c}),e.children))},t.PhotoPickerButton=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.photoPickerButton),c=i.JS.objectLessAttributes(e,"theme");return r.createElement("button",o({},c,{className:[a.photoPickerButton,a.button].join(" "),style:u}),e.children)},t.SignInButton=function(e){var n=e.theme||s.default,u=Object.assign({},n.signInButton,n[e.variant]),c=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("button",o({},c,{className:a.signInButton,style:u}),e.children))},t.SignInButtonIcon=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.signInButtonIcon),c=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("span",o({},c,{className:a.signInButtonIcon,style:u}),e.children))},t.SignInButtonContent=function(e){var n=e.theme||s.default,o=t.propStyle(e,n.signInButtonContent);return t.beforeAfter(r.createElement("span",{className:a.signInButtonContent,style:o},e.children))},t.Link=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.a),c=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("a",o({},c,{className:a.a,style:u}),e.children))},t.Label=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.label),c=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("label",o({},c,{className:a.label,style:u}),e.children))},t.Hint=function(e){var n=e.theme||s.default,o=t.propStyle(e,n.hint);return t.beforeAfter(r.createElement("div",{className:a.hint,style:o},e.children))},t.InputLabel=function(e){var n=e.theme||s.default,o=t.propStyle(e,n.inputLabel);return t.beforeAfter(r.createElement("div",{className:a.inputLabel,style:o},e.children))},t.NavBar=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.navBar),c=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},c,{className:a.navBar,style:u}),e.children))},t.Nav=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.nav),c=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},c,{className:a.nav,style:u}),e.children))},t.NavRight=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.navRight),c=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},c,{className:a.navRight,style:u}),e.children))},t.NavItem=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.navItem),c=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},c,{className:a.navItem,style:u}),e.children))},t.NavButton=function(e){var n=e.theme||s.default,u=t.propStyle(e,n.navButton),c=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("button",o({},c,{className:a.button,style:u}),t.beforeAfter(r.createElement("span",null,e.children))))},t.Toast=function(e){var t=e.onClose,n=e.theme||s.default;return r.createElement("div",o({},e,{theme:n,className:a.toast,style:n.toast}),r.createElement("span",null,e.children),r.createElement("a",{className:a.toastClose,onClick:t}))},t.Toast.defaultProps={onClose:function(){}},t.PhotoPlaceholder=function(e){var n=e.theme||s.default,o=t.propStyle(e,n.photoPlaceholder);return r.createElement("div",{className:a.photoPlaceholder,style:o},r.createElement("div",{className:a.photoPlaceholderIcon},r.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"64",height:"64",viewBox:"0 0 24 24"},r.createElement("circle",{cx:"12",cy:"12",r:"3.2"}),r.createElement("path",{d:"M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"}),r.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}))))},t.beforeAfter=function(e){var t=e.props.style||{},n=t.before,o=t.after;return n||o?r.createElement("span",{style:{position:"relative"}},n?r.createElement("span",{style:n},n.content):null,e,o?r.createElement("span",{style:o},o.content):null):e},t.propStyle=function(e,t){var n=e.id,o=e.style,r=Object.assign({},o,t);if(!n)return r;var i="#"+n;return Object.assign(r,r[i]),r}},function(e,t){e.exports=n},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.Container={},t.FormContainer={},t.FormSection={},t.FormField={},t.SectionHeader={},t.SectionBody={},t.SectionFooter={},t.SectionFooterPrimaryContent={},t.SectionFooterSecondaryContent={},t.Input={},t.Button={},t.PhotoPickerButton={},t.PhotoPlaceholder={},t.SignInButton={},t.SignInButtonIcon={},t.SignInButtonContent={},t.Strike={},t.StrikeContent={},t.ActionRow={},t.FormRow={},t.A={},t.Hint={},t.Radio={},t.Label={},t.InputLabel={},t.AmazonSignInButton={},t.FacebookSignInButton={},t.GoogleSignInButton={},t.OAuthSignInButton={},t.Toast={},t.NavBar={},t.NavRight={},t.Nav={},t.NavItem={},t.NavButton={};var o={container:t.Container,formContainer:t.FormContainer,formSection:t.FormSection,formField:t.FormField,sectionHeader:t.SectionHeader,sectionBody:t.SectionBody,sectionFooter:t.SectionFooter,sectionFooterPrimaryContent:t.SectionFooterPrimaryContent,sectionFooterSecondaryContent:t.SectionFooterSecondaryContent,input:t.Input,button:t.Button,photoPickerButton:t.PhotoPickerButton,photoPlaceholder:t.PhotoPlaceholder,signInButton:t.SignInButton,signInButtonIcon:t.SignInButtonIcon,signInButtonContent:t.SignInButtonContent,amazonSignInButton:t.AmazonSignInButton,facebookSignInButton:t.FacebookSignInButton,googleSignInButton:t.GoogleSignInButton,oAuthSignInButton:t.OAuthSignInButton,formRow:t.FormRow,strike:t.Strike,strikeContent:t.StrikeContent,actionRow:t.ActionRow,a:t.A,hint:t.Hint,radio:t.Radio,label:t.Label,inputLabel:t.InputLabel,toast:t.Toast,navBar:t.NavBar,nav:t.Nav,navRight:t.NavRight,navItem:t.NavItem,navButton:t.NavButton};t.default=o},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});t.sumerianScene={container:"sumerian-scene-container",sumerianScene:"sumerian-scene",loading:"sumerian-scene-loading",loadingLogo:"sumerian-scene-loading-logo",loadingSceneName:"sumerian-scene-loading-scene-name",loadingBar:"sumerian-scene-loading-bar",errorText:"sumerian-scene-error-text",bar:"sumerian-scene-bar",actions:"sumerian-scene-actions"},t.genericAttrs={usernameInput:"username-input",emailInput:"email-input",phoneNumberInput:"phone-number-input",dialCodeSelect:"dial-code-select"},t.auth={signIn:{section:"sign-in-section",headerSection:"sign-in-header-section",bodySection:"sign-in-body-section",footerSection:"sign-in-footer-section",usernameInput:"username-input",passwordInput:"sign-in-password-input",forgotPasswordLink:"sign-in-forgot-password-link",signInButton:"sign-in-sign-in-button",createAccountLink:"sign-in-create-account-link",signInError:"authenticator-error"},signOut:{button:"sign-out-button",section:"sign-out-section"},signUp:{section:"sign-up-section",headerSection:"sign-up-header-section",bodySection:"sign-up-body-section",nonPhoneNumberInput:"sign-up-non-phone-number-input",phoneNumberInput:"sign-up-phone-number-input",dialCodeSelect:"sign-up-dial-code-select",footerSection:"sign-up-footer-section",createAccountButton:"sign-up-create-account-button",signInLink:"sign-up-sign-in-link",signUpButton:"sign-up-sign-up-button",signInButton:"sign-up-sign-in-button",confirmButton:"sign-up-confirm-button"},verifyContact:{section:"verify-contact-section",headerSection:"verify-contact-header-section",bodySection:"verify-contact-body-section",submitButton:"verify-contact-submit-button",verifyButton:"verify-contact-verify-button",skipLink:"verify-contact-skip-link"},TOTPSetup:{component:"totp-setup-component"},requireNewPassword:{section:"require-new-password-section",headerSection:"require-new-password-header-section",footerSection:"require-new-password-footer-section",bodySection:"require-new-password-body-section",newPasswordInput:"require-new-password-new-password-input",backToSignInLink:"require-new-password-back-to-sign-in-link",submitButton:"require-new-password-submit-button"},loading:{section:"loading-secton"},genericAttrs:t.genericAttrs,greetings:{navBar:"greetings-nav-bar",nav:"greetings-nav",navRight:"greetings-nav-right"},greeting:{signOutButton:"sign-out-button",signOutLink:"greeting-sign-out-link",navRight:"greetings-nav-right"},federatedSignIn:{section:"federated-sign-in-section",bodySection:"federated-sign-in-body-section",signInButtons:"federated-sign-in-buttons"},confirmSignUp:{section:"confirm-sign-up-section",headerSection:"confirm-sign-up-header-section",bodySection:"confirm-sign-up-body-section",usernameInput:"confirm-sign-up-username-input",confirmationCodeInput:"confirm-sign-up-confirmation-code-input",resendCodeLink:"confirm-sign-up-resend-code-link",confirmButton:"confirm-sign-up-confirm-button",backToSignInLink:"confirm-sign-up-back-to-sign-in-link"},confirmSignIn:{section:"confirm-sign-in-section",headerSection:"confirm-sign-in-header-section",bodySection:"confirm-sign-in-body-section",codeInput:"confirm-sign-in-code-input",confirmButton:"confirm-sign-in-confirm-button",backToSignInLink:"confirm-sign-in-back-to-sign-in-link"},setMFAComp:{section:"set-mfa-section",headerSection:"set-mfa-header-section",bodySection:"set-mfa-header-body-section",smsInput:"set-mfa-sms-input",totpInput:"set-mfa-totp-input",noMfaInput:"set-mfa-nomfa-input",verificationCodeInput:"set-mfa-verification-code-input",setMfaButton:"set-mfa-set-mfa-button",verifyTotpTokenButton:"set-mfa-verify-totp-token-button",cancelButton:"set-mfa-cancel-button"},forgotPassword:{section:"forgot-password-section",headerSection:"forgot-password-header-section",bodySection:"forgot-password-body-section",submitButton:"forgot-password-submit-button",sendCodeButton:"forgot-password-send-code-button",resendCodeLink:"forgot-password-resend-code-link",backToSignInLink:"forgot-password-back-to-sign-in-link",usernameInput:"username-input",codeInput:"forgot-password-code-input",newPasswordInput:"forgot-password-new-password-input"}}},function(e,t,n){"use strict";function o(e){return(o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var r,i,a=this&&this.__extends||(r=function(e,t){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}r(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var s=n(0),u=n(1),c=n(2),l=n(12),p=n(20),d=n(5),f=n(4),h=((i={})[l.UsernameAttributes.EMAIL]="Email",i[l.UsernameAttributes.PHONE_NUMBER]="Phone Number",i[l.UsernameAttributes.USERNAME]="Username",i),m=function(e){function t(t){var n=e.call(this,t)||this;return n.inputs={},n._isHidden=!0,n._validAuthStates=[],n.phone_number="",n.changeState=n.changeState.bind(n),n.error=n.error.bind(n),n.handleInputChange=n.handleInputChange.bind(n),n.renderUsernameField=n.renderUsernameField.bind(n),n.getUsernameFromInput=n.getUsernameFromInput.bind(n),n.onPhoneNumberChanged=n.onPhoneNumberChanged.bind(n),n}return a(t,e),t.prototype.componentDidMount=function(){if(window&&window.location&&window.location.search&&(!this.props.authData||!this.props.authData.username)){var e=new URLSearchParams(window.location.search),t=e?e.get("username"):void 0;this.setState({username:t})}},t.prototype.getUsernameFromInput=function(){var e=this.props.usernameAttributes;switch(void 0===e?"username":e){case l.UsernameAttributes.EMAIL:return this.inputs.email;case l.UsernameAttributes.PHONE_NUMBER:return this.phone_number;default:return this.inputs.username||this.state.username}},t.prototype.onPhoneNumberChanged=function(e){this.phone_number=e},t.prototype.renderUsernameField=function(e){var t=this.props.usernameAttributes,n=void 0===t?[]:t;return n===l.UsernameAttributes.EMAIL?s.createElement(c.FormField,{theme:e},s.createElement(c.InputLabel,{theme:e},u.I18n.get("Email")," *"),s.createElement(c.Input,{autoFocus:!0,placeholder:u.I18n.get("Enter your email"),theme:e,key:"email",name:"email",type:"email",onChange:this.handleInputChange,"data-test":d.auth.genericAttrs.emailInput})):n===l.UsernameAttributes.PHONE_NUMBER?s.createElement(p.PhoneField,{theme:e,onChangeText:this.onPhoneNumberChanged}):s.createElement(c.FormField,{theme:e},s.createElement(c.InputLabel,{theme:e},u.I18n.get(this.getUsernameLabel())," *"),s.createElement(c.Input,{defaultValue:this.state.username,autoFocus:!0,placeholder:u.I18n.get("Enter your username"),theme:e,key:"username",name:"username",onChange:this.handleInputChange,"data-test":d.auth.genericAttrs.usernameInput}))},t.prototype.getUsernameLabel=function(){var e=this.props.usernameAttributes,t=void 0===e?l.UsernameAttributes.USERNAME:e;return h[t]||t},t.prototype.usernameFromAuthData=function(){var e=this.props.authData;if(!e)return"";return"object"===o(e)?e.user?e.user.username:e.username:e},t.prototype.errorMessage=function(e){return"string"==typeof e?e:e.message?e.message:JSON.stringify(e)},t.prototype.triggerAuthEvent=function(e){var t=this.props.authState;this.props.onAuthEvent&&this.props.onAuthEvent(t,e)},t.prototype.changeState=function(e,t){this.props.onStateChange&&this.props.onStateChange(e,t),this.triggerAuthEvent({type:"stateChange",data:e})},t.prototype.error=function(e){this.triggerAuthEvent({type:"error",data:this.errorMessage(e)})},t.prototype.handleInputChange=function(e){this.inputs=this.inputs||{};var t=e.target,n=t.name,o=t.value,r=t.type,i=t.checked,a=["radio","checkbox"].includes(r);this.inputs[n]=a?i:o,this.inputs.checkedValue=a?o:null},t.prototype.render=function(){if(!this._validAuthStates.includes(this.props.authState))return this._isHidden=!0,this.inputs={},null;if(this._isHidden){this.inputs={};var e=this.props.track;e&&e()}return this._isHidden=!1,this.showComponent(this.props.theme||f.default)},t.prototype.showComponent=function(e){throw"You must implement showComponent(theme) and don't forget to set this._validAuthStates."},t}(s.Component);t.default=m},function(e,t){e.exports=o},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.Container={fontFamily:'-apple-system,\n                BlinkMacSystemFont,\n                "Segoe UI",\n                Roboto,\n                "Helvetica Neue",\n                Arial,\n                sans-serif,\n                "Apple Color Emoji",\n                "Segoe UI Emoji",\n                "Segoe UI Symbol"',fontWeight:"400",lineHeight:"1.5",color:"#212529",textAlign:"left",paddingLeft:"15px",paddingRight:"15px"},t.NavBar={position:"relative",border:"1px solid transparent",borderColor:"#e7e7e7"},t.NavRight={textAlign:"right"},t.Nav={margin:"7.5px"},t.NavItem={display:"inline-block",padding:"10px 5px",lineHeight:"20px"},t.NavButton={display:"inline-block",padding:"6px 12px",marginTop:"8px",marginBottom:"8px",fontSize:"14px",fontWeight:400,lineHeight:"1.42857143",textAlign:"center",whiteSpace:"nowrap",verticalAlign:"middle",touchAction:"manipulation",cursor:"pointer",userSelect:"none",backgroundImage:"none",border:"1px solid transparent",borderRadius:"4px",color:"#333",backgroundColor:"#fff",borderColor:"#ccc"},t.FormContainer={textAlign:"center"},t.FormSection={marginBottom:"20px",backgroundColor:"#fff",border:"1px solid #ddd",borderRadius:"4px",textAlign:"left",width:"400px",display:"inline-block"},t.ErrorSection={marginBottom:"20px",color:"#fff",backgroundColor:"#f0ad4e",border:"1px solid #eea236",borderRadius:"4px",textAlign:"left"},t.SectionHeader={color:"#fff",backgroundColor:"#337ab7",borderColor:"#337ab7",padding:"10px 15px",borderBottom:"1px solid transparent",borderTopLeftRadius:"3px",borderTopRightRadius:"3px",textAlign:"center"},t.SectionFooter={color:"#333",backgroundColor:"#f5f5f5",padding:"10px 15px",borderTop:"1px solid #ddd",borderTopLeftRadius:"3px",borderTopRightRadius:"3px"},t.SectionBody={padding:"15px"},t.FormRow={marginBottom:"15px"},t.ActionRow={marginBottom:"15px"},t.Input={display:"block",width:"100%",height:"34px",padding:"6px 12px",fontSize:"14px",lineHeight:"1.42857143",color:"#555",backgroundColor:"#fff",backgroundImage:"none",border:"1px solid #ccc",borderRadius:"4px",boxShadow:"inset 0 1px 1px rgba(0,0,0,.075)",boxSizing:"border-box",transition:"border-color ease-in-out .15s,box-shadow ease-in-out .15s"},t.Button={display:"inline-block",padding:"6px 12px",marginBottom:"0",fontSize:"14px",fontWeight:400,lineHeight:"1.42857143",textAlign:"center",whiteSpace:"nowrap",verticalAlign:"middle",touchAction:"manipulation",cursor:"pointer",userSelect:"none",backgroundImage:"none",border:"1px solid transparent",borderRadius:"4px",color:"#333",backgroundColor:"#fff",borderColor:"#ccc"},t.SignInButton={position:"relative",padding:"6px 12px 6px 44px",fontSize:"14px",textAlign:"left",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",display:"block",width:"100%",marginTop:"2px","#google_signin_btn":{color:"#fff",backgroundColor:"#dd4b39",borderColor:"rgba(0,0,0,0.2)"},"#facebook_signin_btn":{color:"#fff",backgroundColor:"#3b5998",borderColor:"rgba(0,0,0,0.2)"}},t.Space={display:"inline-block",width:"20px"},t.A={color:"#007bff",cursor:"pointer"},t.Pre={overflow:"auto",fontFamily:'Menlo,\n                Monaco,\n                Consolas,\n                "Courier New",\n                monospace',display:"block",padding:"9.5px",margin:"0 0 10px",fontSize:"13px",lineHeight:"1.42857143",color:"#333",wordBreak:"break-all",wordWrap:"break-word",backgroundColor:"#f5f5f5",border:"1px solid #ccc",borderRadius:"4px"},t.Col1={display:"inline-block",width:"8.33333333%"},t.Col2={display:"inline-block",width:"16.66666667%"},t.Col3={display:"inline-block",width:"25%"},t.Col4={display:"inline-block",width:"33.33333333%"},t.Col5={display:"inline-block",width:"41.66666667%"},t.Col6={display:"inline-block",width:"50%"},t.Col7={display:"inline-block",width:"58.33333333%"},t.Col8={display:"inline-block",width:"66.66666667%"},t.Col9={display:"inline-block",width:"75%"},t.Col10={display:"inline-block",width:"83.33333333%"},t.Col11={display:"inline-block",width:"91.66666667%"},t.Col12={display:"inline-block",width:"100%"},t.Hidden={display:"none"};var o={container:t.Container,navBar:t.NavBar,nav:t.Nav,navRight:t.NavRight,navItem:t.NavItem,navButton:t.NavButton,formContainer:t.FormContainer,formSection:t.FormSection,errorSection:t.ErrorSection,sectionHeader:t.SectionHeader,sectionBody:t.SectionBody,sectionFooter:t.SectionFooter,formRow:t.FormRow,actionRow:t.ActionRow,space:t.Space,signInButton:t.SignInButton,input:t.Input,button:t.Button,a:t.A,pre:t.Pre,col1:t.Col1,col2:t.Col2,col3:t.Col3,col4:t.Col4,col5:t.Col5,col6:t.Col6,col7:t.Col7,col8:t.Col8,col9:t.Col9,col10:t.Col10,col11:t.Col11,col12:t.Col12,hidden:t.Hidden};t.default=o},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});t.default={AUTH_SOURCE_KEY:"amplify-react-auth-source",AUTH0:"auth0",GOOGLE:"google",FACEBOOK:"facebook",AMAZON:"amazon",SIGNING_IN_WITH_HOSTEDUI_KEY:"amplify-signin-with-hostedUI"}},function(e,t,n){"use strict";var o=this&&this.__assign||function(){return(o=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0});var r=n(0),i=n(1),a=n(8);t.Container=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.container),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},u,{className:"amplify-container",style:s}),e.children))},t.FormContainer=function(e){var n=e.theme||a.default,o=t.propStyle(e,n.formContainer);return t.beforeAfter(r.createElement("div",{className:"amplify-form-container",style:o},e.children))},t.FormSection=function(e){var n=e.theme||a.default,o=t.propStyle(e,n.formSection);return r.createElement(t.FormContainer,{theme:n},t.beforeAfter(r.createElement("div",{className:"amplify-form-section",style:o},e.children)))},t.ErrorSection=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.errorSection),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},u,{className:"amplify-error-section",style:s}),r.createElement(t.ErrorSectionContent,null,e.children)))},t.ErrorSectionContent=function(e){var n=e.theme||a.default,o=t.propStyle(e,n.errorSectionContent);return t.beforeAfter(r.createElement("span",{className:"amplify-error-section-content",style:o},e.children))},t.SectionHeader=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.sectionHeader),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},u,{className:"amplify-section-header",style:s}),r.createElement(t.SectionHeaderContent,{theme:n},e.children)))},t.SectionHeaderContent=function(e){var n=e.theme||a.default,o=t.propStyle(e,n.sectionHeaderContent);return t.beforeAfter(r.createElement("span",{className:"amplify-section-header-content",style:o},e.children))},t.SectionFooter=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.sectionFooter),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},u,{className:"amplify-section-footer",style:s}),r.createElement(t.SectionFooterContent,null,e.children)))},t.SectionFooterContent=function(e){var n=e.theme||a.default,o=t.propStyle(e,n.sectionFooterContent);return t.beforeAfter(r.createElement("span",{className:"amplify-section-footer-content",style:o},e.children))},t.SectionBody=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.sectionBody),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},u,{className:"amplify-section-body",style:s}),e.children))},t.ActionRow=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.actionRow),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},u,{className:"amplify-action-row",style:s}),e.children))},t.FormRow=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.formRow),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},u,{className:"amplify-form-row",style:s}),e.children))},t.InputRow=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.input),u=i.JS.objectLessAttributes(e,"theme");return r.createElement(t.FormRow,{theme:n},t.beforeAfter(r.createElement("input",o({},u,{className:"amplify-input",style:s}))))},t.RadioRow=function(e){var n=e.id||"_"+e.value,i=e.theme||a.default;return r.createElement(t.FormRow,{theme:i},r.createElement(t.Radio,o({},e,{id:n})),r.createElement(t.Label,{htmlFor:n,theme:i},e.placeholder))},t.Radio=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.radio),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("input",o({},u,{type:"radio",className:"amplify-radio",style:s})))},t.CheckboxRow=function(e){var n=e.id||"_"+e.name,i=e.theme||a.default;return r.createElement(t.FormRow,{theme:i},r.createElement(t.Checkbox,o({},e,{id:n})),r.createElement(t.Label,{htmlFor:n,theme:i},e.placeholder))},t.Checkbox=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.checkbox),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("input",o({},u,{type:"checkbox",className:"amplify-checkbox",style:s})))},t.MessageRow=function(e){var n=e.theme||a.default;return r.createElement(t.FormRow,{theme:n},r.createElement(t.MessageContent,{theme:n},e.children))},t.MessageContent=function(e){var n=e.theme||a.default;return t.beforeAfter(r.createElement("span",{className:"amplify-message-content",style:n.messageContent},e.children))},t.ButtonRow=function(e){var n=e.theme||a.default;return t.beforeAfter(r.createElement("div",{className:"amplify-action-row",style:n.actionRow},r.createElement(t.Button,o({},e))))},t.Button=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.button),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("button",o({},u,{className:"amplify-button",style:s}),r.createElement(t.ButtonContent,{theme:n},e.children)))},t.ButtonContent=function(e){var n=e.theme||a.default;return t.beforeAfter(r.createElement("span",{className:"amplify-button-content",style:n.buttonContent},e.children))},t.SignInButton=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.signInButton),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("button",o({},u,{className:"amplify-signin-button",style:s}),e.children))},t.Link=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.a),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("a",o({},u,{className:"amplify-a",style:s}),e.children))},t.Label=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.label),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("label",o({},u,{className:"amplify-label",style:s}),e.children))},t.Space=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.space),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("span",o({},u,{className:"amplify-space",style:s}),e.children))},t.NavBar=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.navBar),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},u,{className:"amplify-nav-bar",style:s}),e.children))},t.Nav=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.nav),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},u,{className:"amplify-nav",style:s}),e.children))},t.NavRight=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.navRight),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},u,{className:"amplify-nav-right",style:s}),e.children))},t.NavItem=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.navItem),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("div",o({},u,{className:"amplify-nav-item",style:s}),e.children))},t.NavButton=function(e){var n=e.theme||a.default,s=t.propStyle(e,n.navButton),u=i.JS.objectLessAttributes(e,"theme");return t.beforeAfter(r.createElement("button",o({},u,{className:"amplify-nav-button",style:s}),t.beforeAfter(r.createElement("span",{style:n.navButtonContent},e.children))))},t.beforeAfter=function(e){var t=e.props.style||{},n=t.before,o=t.after;return n||o?r.createElement("span",{style:{position:"relative"}},n?r.createElement("span",{style:n},n.content):null,e,o?r.createElement("span",{style:o},o.content):null):e},t.propStyle=function(e,t){var n=e.id,o=e.style,r=Object.assign({},o,t);if(!n)return r;var i="#"+n;return Object.assign(r,r[i]),r},t.transparent1X1="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",t.white1X1="data:image/gif;base64,R0lGODlhAQABAIAAAP7//wAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),a=n(0),s=n(1),u=n(4),c=n(2),l={width:"100%",height:"100%",display:"inline-block",position:"absolute",left:0,top:0,opacity:0,cursor:"pointer"},p=new s.ConsoleLogger("Picker"),d=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return r(t,e),t.prototype.handleInput=function(e){var t=e.target.files[0];if(t){var n=t.name,o=t.size,r=t.type;p.debug(t);var i=this.props.onPick;i&&i({file:t,name:n,size:o,type:r})}},t.prototype.render=function(){var e=this,t=this.props.title||"Pick a File",n=this.props.accept||"*/*",o=this.props.theme||u.default,r=Object.assign({},{position:"relative"},o.pickerPicker),a=Object.assign({},l,o.pickerInput);return i.createElement("div",{style:r},i.createElement(c.PhotoPickerButton,{theme:o},s.I18n.get(t)),i.createElement("input",{title:s.I18n.get(t),type:"file",accept:n,style:a,onChange:function(t){return e.handleInput(t)}}))},t}(a.Component);t.default=d},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),function(e){e.EMAIL="email",e.PHONE_NUMBER="phone_number",e.USERNAME="username"}(t.UsernameAttributes||(t.UsernameAttributes={}))},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),i=this&&this.__assign||function(){return(i=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),s=n(23),u=n(24),c=n(25),l=n(26),p=n(27),d=n(23);t.withGoogle=d.default,t.GoogleButton=d.GoogleButton;var f=n(24);t.withFacebook=f.default,t.FacebookButton=f.FacebookButton;var h=n(25);t.withAmazon=h.default,t.AmazonButton=h.AmazonButton;var m=n(26);t.withOAuth=m.default,t.OAuthButton=m.OAuthButton;var g=n(27);t.withAuth0=g.default,t.Auth0Button=g.Auth0Button,t.withFederated=function(e){var t=p.default(l.default(c.default(s.default(u.default(e)))));return(function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return r(n,e),n.prototype.render=function(){var e=this.props.federated||{};return a.createElement(t,i({},this.props,e))},n}(a.Component))}},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),a=n(1),s=n(3),u=n(6),c=n(2),l=n(5),p=n(21),d=n(52),f=n(12),h=n(20),m=new a.ConsoleLogger("SignUp"),g=function(e){function t(t){var n=e.call(this,t)||this;n.state={requestPending:!1},n._validAuthStates=["signUp"],n.signUp=n.signUp.bind(n),n.sortFields=n.sortFields.bind(n),n.getDefaultDialCode=n.getDefaultDialCode.bind(n),n.checkCustomSignUpFields=n.checkCustomSignUpFields.bind(n),n.needPrefix=n.needPrefix.bind(n),n.header=n.props&&n.props.signUpConfig&&n.props.signUpConfig.header?n.props.signUpConfig.header:"Create a new account";var o=(n.props||{}).usernameAttributes,r=void 0===o?f.UsernameAttributes.USERNAME:o;return r===f.UsernameAttributes.EMAIL?n.defaultSignUpFields=d.signUpWithEmailFields:r===f.UsernameAttributes.PHONE_NUMBER?n.defaultSignUpFields=d.signUpWithPhoneNumberFields:n.defaultSignUpFields=d.default,n}return r(t,e),t.prototype.validate=function(){var e=this,t=[];return this.signUpFields.map((function(n){"phone_number"!==n.key?n.required&&!e.inputs[n.key]?(n.invalid=!0,t.push(n.label)):n.invalid=!1:n.required&&!e.phone_number?(n.invalid=!0,t.push(n.label)):n.invalid=!1})),t},t.prototype.sortFields=function(){var e=this;this.props.signUpConfig&&this.props.signUpConfig.hiddenDefaults&&this.props.signUpConfig.hiddenDefaults.length>0&&(this.defaultSignUpFields=this.defaultSignUpFields.filter((function(t){return!e.props.signUpConfig.hiddenDefaults.includes(t.key)}))),this.checkCustomSignUpFields()?(this.props.signUpConfig&&this.props.signUpConfig.hideAllDefaults||this.defaultSignUpFields.forEach((function(t){-1===e.signUpFields.findIndex((function(e){return e.key===t.key}))&&e.signUpFields.push(t)})),this.signUpFields.sort((function(e,t){return e.displayOrder&&t.displayOrder?e.displayOrder<t.displayOrder?-1:e.displayOrder>t.displayOrder?1:e.key<t.key?-1:1:!e.displayOrder&&t.displayOrder?1:e.displayOrder&&!t.displayOrder?-1:e.displayOrder||t.displayOrder?void 0:e.key<t.key?-1:1}))):this.signUpFields=this.defaultSignUpFields},t.prototype.needPrefix=function(e){var t=this.signUpFields.find((function(t){return t.key===e}));return 0!==e.indexOf("custom:")?t.custom:(0===e.indexOf("custom:")&&!1===t.custom&&m.warn("Custom prefix prepended to key but custom field flag is set to false; retaining manually entered prefix"),null)},t.prototype.getDefaultDialCode=function(){return this.props.signUpConfig&&this.props.signUpConfig.defaultCountryCode&&-1!==p.default.indexOf("+"+this.props.signUpConfig.defaultCountryCode)?"+"+this.props.signUpConfig.defaultCountryCode:"+1"},t.prototype.checkCustomSignUpFields=function(){return this.props.signUpConfig&&this.props.signUpConfig.signUpFields&&this.props.signUpConfig.signUpFields.length>0},t.prototype.signUp=function(){var e=this;this.setState({requestPending:!0}),this.inputs.dial_code||(this.inputs.dial_code=this.getDefaultDialCode());var t=this.validate();if(t&&t.length>0)return this.error("The following fields need to be filled out: "+t.join(", "));if(!s.default||"function"!=typeof s.default.signUp)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");var n={username:this.inputs.username,password:this.inputs.password,attributes:{}},o=Object.keys(this.inputs),r=Object.values(this.inputs);o.forEach((function(t,o){if(!["username","password","checkedValue","dial_code"].includes(t)&&"phone_line_number"!==t&&"dial_code"!==t&&"error"!==t){var i=(e.needPrefix(t)?"custom:":"")+t;n.attributes[i]=r[o]}})),this.phone_number&&(n.attributes.phone_number=this.phone_number);var i=!1;if(this.signUpFields.forEach((function(t){t.label===e.getUsernameLabel()&&(m.debug("Changing the username to the value of "+t.label),n.username=n.attributes[t.key]||n.username,i=!0)})),!i&&!n.username)throw new Error("Couldn't find the label: "+this.getUsernameLabel()+", in sign up fields according to usernameAttributes!");s.default.signUp(n).then((function(t){e.setState({requestPending:!1}),e.changeState("confirmSignUp",t.user.username)})).catch((function(t){return e.setState({requestPending:!1}),e.error(t)}))},t.prototype.showComponent=function(e){var n=this,o=this.props.hide;return o&&o.includes(t)?null:(this.checkCustomSignUpFields()&&(this.signUpFields=this.props.signUpConfig.signUpFields),this.sortFields(),i.createElement(c.FormSection,{theme:e,"data-test":l.auth.signUp.section},i.createElement(c.SectionHeader,{theme:e,"data-test":l.auth.signUp.headerSection},a.I18n.get(this.header)),i.createElement(c.SectionBody,{theme:e,"data-test":l.auth.signUp.bodySection},this.signUpFields.map((function(t){return"phone_number"!==t.key?i.createElement(c.FormField,{theme:e,key:t.key},t.required?i.createElement(c.InputLabel,{theme:e},a.I18n.get(t.label)," *"):i.createElement(c.InputLabel,{theme:e},a.I18n.get(t.label)),i.createElement(c.Input,{autoFocus:0===n.signUpFields.findIndex((function(e){return e.key===t.key})),placeholder:a.I18n.get(t.placeholder),theme:e,type:t.type,name:t.key,key:t.key,onChange:n.handleInputChange,"data-test":l.auth.signUp.nonPhoneNumberInput})):i.createElement(h.PhoneField,{theme:e,required:t.required,defaultDialCode:n.getDefaultDialCode(),label:t.label,placeholder:t.placeholder,onChangeText:n.onPhoneNumberChanged,key:"phone_number"})}))),i.createElement(c.SectionFooter,{theme:e,"data-test":l.auth.signUp.footerSection},i.createElement(c.SectionFooterPrimaryContent,{theme:e},i.createElement(c.Button,{disabled:this.state.requestPending,onClick:this.signUp,theme:e,"data-test":l.auth.signUp.createAccountButton},a.I18n.get("Create Account"))),i.createElement(c.SectionFooterSecondaryContent,{theme:e},a.I18n.get("Have an account? "),i.createElement(c.Link,{theme:e,onClick:function(){return n.changeState("signIn")},"data-test":l.auth.signUp.signInLink},a.I18n.get("Sign in"))))))},t}(u.default);t.default=g},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),a=n(1),s=n(3),u=n(6),c=n(4),l=n(2),p=n(5),d=new a.ConsoleLogger("ForgotPassword"),f=function(e){function t(t){var n=e.call(this,t)||this;return n.send=n.send.bind(n),n.submit=n.submit.bind(n),n._validAuthStates=["forgotPassword"],n.state={delivery:null},n}return r(t,e),t.prototype.send=function(){var e=this,t=this.props.authData,n=void 0===t?{}:t,o=this.getUsernameFromInput()||n.username;if(!s.default||"function"!=typeof s.default.forgotPassword)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");s.default.forgotPassword(o).then((function(t){d.debug(t),e.setState({delivery:t.CodeDeliveryDetails})})).catch((function(t){return e.error(t)}))},t.prototype.submit=function(){var e=this,t=this.props.authData,n=void 0===t?{}:t,o=this.inputs,r=o.code,i=o.password,a=this.getUsernameFromInput()||n.username;if(!s.default||"function"!=typeof s.default.forgotPasswordSubmit)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");s.default.forgotPasswordSubmit(a,r,i).then((function(t){d.debug(t),e.changeState("signIn"),e.setState({delivery:null})})).catch((function(t){return e.error(t)}))},t.prototype.sendView=function(){var e=this.props.theme||c.default;return i.createElement("div",null,this.renderUsernameField(e))},t.prototype.submitView=function(){var e=this.props.theme||c.default;return i.createElement("div",null,i.createElement(l.FormField,{theme:e},i.createElement(l.InputLabel,{theme:e},a.I18n.get("Code")," *"),i.createElement(l.Input,{placeholder:a.I18n.get("Code"),theme:e,key:"code",name:"code",autoComplete:"off",onChange:this.handleInputChange})),i.createElement(l.FormField,{theme:e},i.createElement(l.InputLabel,{theme:e},a.I18n.get("New Password")," *"),i.createElement(l.Input,{placeholder:a.I18n.get("New Password"),theme:e,type:"password",key:"password",name:"password",autoComplete:"off",onChange:this.handleInputChange})))},t.prototype.showComponent=function(e){var n=this,o=this.props,r=(o.authState,o.hide),s=o.authData,u=void 0===s?{}:s;return r&&r.includes(t)?null:i.createElement(l.FormSection,{theme:e,"data-test":p.auth.forgotPassword.section},i.createElement(l.SectionHeader,{theme:e,"data-test":p.auth.forgotPassword.headerSection},a.I18n.get("Reset your password")),i.createElement(l.SectionBody,{theme:e,"data-test":p.auth.forgotPassword.bodySection},this.state.delivery||u.username?this.submitView():this.sendView()),i.createElement(l.SectionFooter,{theme:e},i.createElement(l.SectionFooterPrimaryContent,{theme:e},this.state.delivery||u.username?i.createElement(l.Button,{theme:e,onClick:this.submit,"data-test":p.auth.forgotPassword.submitButton},a.I18n.get("Submit")):i.createElement(l.Button,{theme:e,onClick:this.send,"data-test":p.auth.forgotPassword.sendCodeButton},a.I18n.get("Send Code"))),i.createElement(l.SectionFooterSecondaryContent,{theme:e},this.state.delivery||u.username?i.createElement(l.Link,{theme:e,onClick:this.send,"data-test":p.auth.forgotPassword.resendCodeLink},a.I18n.get("Resend Code")):i.createElement(l.Link,{theme:e,onClick:function(){return n.changeState("signIn")},"data-test":p.auth.forgotPassword.backToSignInLink},a.I18n.get("Back to Sign In")))))},t}(u.default);t.default=f},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),a=n(0),s=n(1),u=n(3),c=n(4),l=n(2),p=n(7),d=n(53),f=new s.ConsoleLogger("TOTPSetupComp"),h=function(e){function t(t){var n=e.call(this,t)||this;return n.setup=n.setup.bind(n),n.showSecretCode=n.showSecretCode.bind(n),n.verifyTotpToken=n.verifyTotpToken.bind(n),n.handleInputChange=n.handleInputChange.bind(n),n.triggerTOTPEvent=n.triggerTOTPEvent.bind(n),n.state={code:null,setupMessage:null},n}return r(t,e),t.prototype.componentDidMount=function(){this.setup()},t.prototype.triggerTOTPEvent=function(e,t,n){this.props.onTOTPEvent&&this.props.onTOTPEvent(e,t,n)},t.prototype.handleInputChange=function(e){this.setState({setupMessage:null}),this.inputs={};var t=e.target,n=t.name,o=t.value,r=t.type,i=t.checked,a=["radio","checkbox"].includes(r);this.inputs[n]=a?i:o},t.prototype.setup=function(){var e=this;this.setState({setupMessage:null});var t=this.props.authData,n=encodeURI(s.I18n.get("AWSCognito"));if(!u.default||"function"!=typeof u.default.setupTOTP)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");u.default.setupTOTP(t).then((function(o){f.debug("secret key",o);var r="otpauth://totp/"+n+":"+t.username+"?secret="+o+"&issuer="+n;e.setState({code:r})})).catch((function(e){return f.debug("totp setup failed",e)}))},t.prototype.verifyTotpToken=function(){var e=this;if(this.inputs){var t=this.props.authData,n=this.inputs.totpCode;if(!u.default||"function"!=typeof u.default.verifyTotpToken||"function"!=typeof u.default.setPreferredMFA)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");u.default.verifyTotpToken(t,n).then((function(){u.default.setPreferredMFA(t,"TOTP"),e.setState({setupMessage:"Setup TOTP successfully!"}),f.debug("set up totp success!"),e.triggerTOTPEvent("Setup TOTP","SUCCESS",t)})).catch((function(t){e.setState({setupMessage:"Setup TOTP failed!"}),f.error(t)}))}else f.debug("no input")},t.prototype.showSecretCode=function(e,t){return e?i.createElement("div",null,i.createElement("div",{className:p.totpQrcode},i.createElement(d,{value:e})),i.createElement(l.InputLabel,{theme:t},s.I18n.get("Enter Security Code:")),i.createElement(l.Input,{autoFocus:!0,theme:t,key:"totpCode",name:"totpCode",onChange:this.handleInputChange})):null},t.prototype.render=function(){var e=this.props.theme?this.props.theme:c.default,t=this.state.code;return i.createElement(l.FormSection,{theme:e},this.state.setupMessage&&i.createElement(l.Toast,null,s.I18n.get(this.state.setupMessage)),i.createElement(l.SectionHeader,{theme:e},s.I18n.get("Scan then enter verification code")),i.createElement(l.SectionBody,{theme:e},this.showSecretCode(t,e),this.state.setupMessage&&s.I18n.get(this.state.setupMessage)),i.createElement(l.SectionFooter,{theme:e},i.createElement(l.Button,{theme:e,onClick:this.verifyTotpToken,style:{width:"100%"}},s.I18n.get("Verify Security Token"))))},t}(a.Component);t.default=h},function(e,t){e.exports=r},function(e,t,n){"use strict";function o(e){return(o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var r,i=this&&this.__extends||(r=function(e,t){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}r(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),s=n(1),u=n(3),c=n(19),l=n(28),p=n(30),d=n(31),f=n(14),h=n(32),m=n(33),g=n(34),y=n(15),v=n(35),b=n(9),S=n(4),C=n(40),w=n(2),E=n(5),_=new s.ConsoleLogger("Authenticator");t.EmptyContainer=function(e){var t=e.children;return a.createElement(a.Fragment,null,t)};var I=function(e){function n(t){var n=e.call(this,t)||this;return n.handleStateChange=n.handleStateChange.bind(n),n.handleAuthEvent=n.handleAuthEvent.bind(n),n.onHubCapsule=n.onHubCapsule.bind(n),n._initialAuthState=n.props.authState||"signIn",n.state={authState:"loading"},s.Hub.listen("auth",n.onHubCapsule),n}return i(n,e),n.prototype.componentDidMount=function(){var e=this.props.amplifyConfig;e&&s.default.configure(e),this._isMounted=!0;var t=localStorage.getItem(b.default.SIGNING_IN_WITH_HOSTEDUI_KEY);localStorage.removeItem(b.default.SIGNING_IN_WITH_HOSTEDUI_KEY),"true"!==t&&this.checkUser()},n.prototype.componentWillUnmount=function(){this._isMounted=!1},n.prototype.checkUser=function(){var e=this;if(!u.default||"function"!=typeof u.default.currentAuthenticatedUser)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");return u.default.currentAuthenticatedUser().then((function(t){e._isMounted&&e.handleStateChange("signedIn",t)})).catch((function(t){if(e._isMounted){var n=null;try{n=localStorage.getItem("amplify-authenticator-authState")}catch(e){_.debug("Failed to get the auth state from local storage",e)}("signedIn"===n?u.default.signOut():Promise.resolve()).then((function(){return e.handleStateChange(e._initialAuthState)})).catch((function(e){_.debug("Failed to sign out",e)}))}}))},n.prototype.onHubCapsule=function(e){var t=e.channel,n=e.payload;e.source;if("auth"===t)switch(n.event){case"cognitoHostedUI":this.handleStateChange("signedIn",n.data);break;case"cognitoHostedUI_failure":case"parsingUrl_failure":case"signOut":case"customGreetingSignOut":this.handleStateChange("signIn",null);break;case"parsingCallbackUrl":localStorage.setItem(b.default.SIGNING_IN_WITH_HOSTEDUI_KEY,"true")}},n.prototype.handleStateChange=function(e,t){if(_.debug("authenticator state change "+e,t),e!==this.state.authState){"signedOut"===e&&(e="signIn");try{localStorage.setItem("amplify-authenticator-authState",e)}catch(e){_.debug("Failed to set the auth state into local storage",e)}this._isMounted&&this.setState({authState:e,authData:t,error:null,showToast:!1}),this.props.onStateChange&&this.props.onStateChange(e,t)}},n.prototype.handleAuthEvent=function(e,t,n){if(void 0===n&&(n=!0),"error"===t.type){var o=this.props.errorMessage||C.default,r="string"==typeof o?o:o(t.data);this.setState({error:r,showToast:n})}},n.prototype.render=function(){var e=this,n=this.state,r=n.authState,i=n.authData,u=this.props.theme||S.default,b=this.props.errorMessage||C.default,_=void 0===this.props.container?w.Container:this.props.container||t.EmptyContainer,I=this.props,A=I.hideDefault,O=I.hide,k=void 0===O?[]:O,P=I.federated,x=I.signUpConfig,L=I.usernameAttributes;A&&(k=k.concat([c.default,l.default,p.default,d.default,f.default,m.default,g.default,y.default,v.default,h.default]));var N=[];"object"===o(this.props.children)&&(Array.isArray(this.props.children)?N=this.props.children:N.push(this.props.children));var B=[a.createElement(c.default,{federated:P}),a.createElement(l.default,{federated:P}),a.createElement(p.default,null),a.createElement(d.default,null),a.createElement(f.default,{signUpConfig:x}),a.createElement(m.default,null),a.createElement(g.default,null),a.createElement(y.default,null),a.createElement(v.default,null),a.createElement(h.default,null)],T=a.Children.map(N,(function(e){return e.props.override}));k=k.filter((function(e){return!N.find((function(t){return t.type===e}))}));var F=a.Children.map(N,(function(t,n){return a.cloneElement(t,{key:"aws-amplify-authenticator-props-children-"+n,theme:u,messageMap:b,authState:r,authData:i,onStateChange:e.handleStateChange,onAuthEvent:e.handleAuthEvent,hide:k,override:T,usernameAttributes:L})})),M=(A?[]:a.Children.map(B,(function(t,n){return a.cloneElement(t,{key:"aws-amplify-authenticator-default-children-"+n,theme:u,messageMap:b,authState:r,authData:i,onStateChange:e.handleStateChange,onAuthEvent:e.handleAuthEvent,hide:k,override:T,usernameAttributes:L})}))).concat(F),U=this.state.error;return a.createElement(_,{theme:u},this.state.showToast&&a.createElement(w.Toast,{theme:u,onClose:function(){return e.setState({showToast:!1})},"data-test":E.auth.signIn.signInError},s.I18n.get(U)),M)},n}(a.Component);t.default=I},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),i=this&&this.__assign||function(){return(i=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),s=n(1),u=n(3),c=n(6),l=n(2),p=n(5),d=n(4),f=n(22),h=n(13),m=n(12),g=new s.ConsoleLogger("Greetings"),y=function(e){function t(t){var n=e.call(this,t)||this;return n.state={},n.onHubCapsule=n.onHubCapsule.bind(n),n.inGreeting=n.inGreeting.bind(n),s.Hub.listen("auth",n.onHubCapsule),n._validAuthStates=["signedIn"],n}return r(t,e),t.prototype.componentDidMount=function(){this._isMounted=!0,this.findState()},t.prototype.componentWillUnmount=function(){this._isMounted=!1},t.prototype.findState=function(){var e=this;this.props.authState||this.props.authData||u.default.currentAuthenticatedUser().then((function(t){e.setState({authState:"signedIn",authData:t,stateFromStorage:!0})})).catch((function(e){return g.debug(e)}))},t.prototype.onHubCapsule=function(e){if(this._isMounted){var t=e.channel,n=e.payload;"auth"===t&&"signIn"===n.event?(this.setState({authState:"signedIn",authData:n.data}),this.props.authState||this.setState({stateFromStorage:!0})):"auth"!==t||"signOut"!==n.event||this.props.authState||this.setState({authState:"signIn"})}},t.prototype.inGreeting=function(e){var t=this.props.usernameAttributes;return""+((void 0===t?m.UsernameAttributes.USERNAME:t)===m.UsernameAttributes.USERNAME?s.I18n.get("Hello")+" ":"")+e},t.prototype.outGreeting=function(){return""},t.prototype.userGreetings=function(e){var t=this.props.authData||this.state.authData,n=this.props.inGreeting||this.inGreeting,o=this.props.usernameAttributes,r="";switch(void 0===o?"username":o){case m.UsernameAttributes.EMAIL:r=t.attributes?t.attributes.email:t.username;break;case m.UsernameAttributes.PHONE_NUMBER:r=t.attributes?t.attributes.phone_number:t.username;break;default:r=(t.attributes?t.attributes.name||(t.attributes.given_name?t.attributes.given_name+" "+t.attributes.family_name:void 0):void 0)||t.name||t.username}var i="function"==typeof n?n(r):n;return a.createElement("span",null,a.createElement(l.NavItem,{theme:e},i),this.renderSignOutButton())},t.prototype.renderSignOutButton=function(){var e=this.props.federated,t=void 0===e?{}:e,n=t.google_client_id,o=t.facebook_app_id,r=t.amazon_client_id,s=t.auth0,c=u.default.configure(),l=c.oauth,p=void 0===l?{}:l,d=n||c.googleClientId,m=o||c.facebookClientId,g=r||c.amazonClientId,y=s||p.auth0,v=f.default;d&&(v=h.withGoogle(f.default)),m&&(v=h.withFacebook(f.default)),g&&(v=h.withAmazon(f.default)),y&&(v=h.withAuth0(f.default));var b=Object.assign({},this.props,this.state);return a.createElement(v,i({},b))},t.prototype.noUserGreetings=function(e){var t=this.props.outGreeting||this.outGreeting,n="function"==typeof t?t():t;return n?a.createElement(l.NavItem,{theme:e},n):null},t.prototype.render=function(){var e=this.props.hide;if(e&&e.includes(t))return null;var n="signedIn"===(this.props.authState||this.state.authState),o=this.props.theme||d.default,r=n?this.userGreetings(o):this.noUserGreetings(o);return r?a.createElement(l.NavBar,{theme:o,"data-test":p.auth.greetings.navBar},a.createElement(l.Nav,{theme:o,"data-test":p.auth.greetings.nav},a.createElement(l.NavRight,{theme:o,"data-test":p.auth.greetings.navRight},r))):null},t}(c.default);t.default=y},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),a=n(2),s=n(4),u=n(21),c=n(1),l=n(5),p=function(e){function t(t){var n=e.call(this,t)||this;return n.handleInputChange=n.handleInputChange.bind(n),n.composePhoneNumber=n.composePhoneNumber.bind(n),n.inputs={dial_code:n.props.defaultDialCode||"+1",phone_line_number:""},n}return r(t,e),t.prototype.composePhoneNumber=function(e,t){return""+(e||"+1")+t.replace(/[-()]/g,"")},t.prototype.handleInputChange=function(e){var t=e.target,n=t.name,o=t.value;this.inputs[n]=o,this.props.onChangeText&&this.props.onChangeText(this.composePhoneNumber(this.inputs.dial_code,this.inputs.phone_line_number))},t.prototype.render=function(){var e=this.props,t=e.theme,n=void 0===t?s.default:t,o=e.required,r=void 0===o||o,p=e.defaultDialCode,d=void 0===p?"+1":p,f=e.label,h=void 0===f?"Phone Number":f,m=e.placeholder,g=void 0===m?"Enter your phone number":m;return i.createElement(a.FormField,{theme:n,key:"phone_number"},r?i.createElement(a.InputLabel,{theme:n},c.I18n.get(h)," *"):i.createElement(a.InputLabel,{theme:n},c.I18n.get(h)),i.createElement(a.SelectInput,{theme:n},i.createElement("select",{name:"dial_code",defaultValue:d,onChange:this.handleInputChange,"data-test":l.auth.genericAttrs.dialCodeSelect},u.default.map((function(e){return i.createElement("option",{key:e,value:e},e)}))),i.createElement(a.Input,{placeholder:c.I18n.get(g),theme:n,type:"tel",id:"phone_line_number",key:"phone_line_number",name:"phone_line_number",onChange:this.handleInputChange,"data-test":l.auth.genericAttrs.phoneNumberInput})))},t}(i.Component);t.PhoneField=p,t.default=p},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=["+1","+7","+20","+27","+30","+31","+32","+33","+34","+36","+39","+40","+41","+43","+44","+45","+46","+47","+48","+49","+51","+52","+53","+54","+55","+56","+57","+58","+60","+61","+62","+63","+64","+65","+66","+81","+82","+84","+86","+90","+91","+92","+93","+94","+95","+98","+212","+213","+216","+218","+220","+221","+222","+223","+224","+225","+226","+227","+228","+229","+230","+231","+232","+233","+234","+235","+236","+237","+238","+239","+240","+241","+242","+243","+244","+245","+246","+248","+249","+250","+251","+252","+253","+254","+255","+256","+257","+258","+260","+261","+262","+263","+264","+265","+266","+267","+268","+269","+290","+291","+297","+298","+299","+345","+350","+351","+352","+353","+354","+355","+356","+357","+358","+359","+370","+371","+372","+373","+374","+375","+376","+377","+378","+379","+380","+381","+382","+385","+386","+387","+389","+420","+421","+423","+500","+501","+502","+503","+504","+505","+506","+507","+508","+509","+537","+590","+591","+593","+594","+595","+596","+597","+598","+599","+670","+672","+673","+674","+675","+676","+677","+678","+679","+680","+681","+682","+683","+685","+686","+687","+688","+689","+690","+691","+692","+850","+852","+853","+855","+856","+872","+880","+886","+960","+961","+962","+963","+964","+965","+966","+967","+968","+970","+971","+972","+973","+974","+975","+976","+977","+992","+993","+994","+995","+996","+998"]},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),a=n(1),s=n(3),u=n(6),c=n(2),l=n(4),p=n(9),d=n(5),f=new a.ConsoleLogger("SignOut"),h=function(e){function t(t){var n=e.call(this,t)||this;return n.signOut=n.signOut.bind(n),n.onHubCapsule=n.onHubCapsule.bind(n),a.Hub.listen("auth",n.onHubCapsule),n.state={},n}return r(t,e),t.prototype.componentDidMount=function(){this._isMounted=!0,this.findState()},t.prototype.componentWillUnmount=function(){this._isMounted=!1},t.prototype.findState=function(){var e=this;this.props.authState||this.props.authData?this.props.stateFromStorage&&this.setState({stateFromStorage:!0}):s.default.currentAuthenticatedUser().then((function(t){e.setState({authState:"signedIn",authData:t,stateFromStorage:!0})})).catch((function(e){return f.error(e)}))},t.prototype.onHubCapsule=function(e){if(this._isMounted){var t=e.channel,n=e.payload;e.source;"auth"===t&&"signIn"===n.event?this.setState({authState:"signedIn",authData:n.data}):"auth"!==t||"signOut"!==n.event||this.props.authState||this.setState({authState:"signIn"}),"auth"!==t||"signIn"!==n.event||this.props.authState||this.setState({stateFromStorage:!0})}},t.prototype.signOut=function(){var e=this,t={};try{t=JSON.parse(localStorage.getItem(p.default.AUTH_SOURCE_KEY))||{},localStorage.removeItem(p.default.AUTH_SOURCE_KEY)}catch(e){f.debug("Failed to parse the info from "+p.default.AUTH_SOURCE_KEY+" from localStorage with "+e)}f.debug("sign out from the source",t);var n=this.props,o=n.googleSignOut,r=n.facebookSignOut,i=n.amazonSignOut,a=n.auth0SignOut;switch(t.provider){case p.default.GOOGLE:o?o():f.debug("No Google signout method provided");break;case p.default.FACEBOOK:r?r():f.debug("No Facebook signout method provided");break;case p.default.AMAZON:i?i():f.debug("No Amazon signout method provided");break;case p.default.AUTH0:a?a(t.opts):f.debug("No Auth0 signout method provided")}if(!s.default||"function"!=typeof s.default.signOut)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");s.default.signOut().then((function(){e.state.stateFromStorage||e.changeState("signedOut")})).catch((function(t){f.debug(t),e.error(t)}))},t.prototype.render=function(){var e=this.props.hide;if(e&&e.includes(t))return null;var n="signedIn"===(this.props.authState||this.state.authState),o=this.props.theme||l.default;return n?i.createElement(c.NavButton,{theme:o,onClick:this.signOut,"data-test":d.auth.signOut.button},a.I18n.get("Sign Out")):null},t}(u.default);t.default=h},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),i=this&&this.__assign||function(){return(i=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)},a=this&&this.__awaiter||function(e,t,n,o){return new(n||(n=Promise))((function(r,i){function a(e){try{u(o.next(e))}catch(e){i(e)}}function s(e){try{u(o.throw(e))}catch(e){i(e)}}function u(e){var t;e.done?r(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(a,s)}u((o=o.apply(e,t||[])).next())}))},s=this&&this.__generator||function(e,t){var n,o,r,i,a={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return i={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function s(i){return function(s){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,o&&(r=2&i[0]?o.return:i[0]?o.throw||((r=o.return)&&r.call(o),0):o.next)&&!(r=r.call(o,i[1])).done)return r;switch(o=0,r&&(i=[2&i[0],r.value]),i[0]){case 0:case 1:r=i;break;case 4:return a.label++,{value:i[1],done:!1};case 5:a.label++,o=i[1],i=[0];continue;case 7:i=a.ops.pop(),a.trys.pop();continue;default:if(!(r=(r=a.trys).length>0&&r[r.length-1])&&(6===i[0]||2===i[0])){a=0;continue}if(3===i[0]&&(!r||i[1]>r[0]&&i[1]<r[3])){a.label=i[1];break}if(6===i[0]&&a.label<r[1]){a.label=r[1],r=i;break}if(r&&a.label<r[2]){a.label=r[2],a.ops.push(i);break}r[2]&&a.ops.pop(),a.trys.pop();continue}i=t.call(e,a)}catch(e){i=[6,e],o=0}finally{n=r=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,s])}}};Object.defineProperty(t,"__esModule",{value:!0});var u=n(0),c=n(1),l=n(3),p=n(4),d=n(7),f=n(2),h=n(9),m=new c.ConsoleLogger("withGoogle");function g(e){return function(t){function n(e){var n=t.call(this,e)||this;return n.initGapi=n.initGapi.bind(n),n.signIn=n.signIn.bind(n),n.signOut=n.signOut.bind(n),n.federatedSignIn=n.federatedSignIn.bind(n),n.state={},n}return r(n,t),n.prototype.signIn=function(){var e=this,t=window.gapi.auth2.getAuthInstance(),n=this.props.onError;t.signIn().then((function(t){e.federatedSignIn(t);var n={provider:h.default.GOOGLE};try{localStorage.setItem(h.default.AUTH_SOURCE_KEY,JSON.stringify(n))}catch(e){m.debug("Failed to cache auth source into localStorage",e)}}),(function(e){if(!n)throw e;n(e)}))},n.prototype.federatedSignIn=function(e){return a(this,void 0,void 0,(function(){var t,n,o,r,i,a;return s(this,(function(s){switch(s.label){case 0:if(t=e.getAuthResponse(),n=t.id_token,o=t.expires_at,r=e.getBasicProfile(),i={email:r.getEmail(),name:r.getName(),picture:r.getImageUrl()},a=this.props.onStateChange,!l.default||"function"!=typeof l.default.federatedSignIn||"function"!=typeof l.default.currentAuthenticatedUser)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");return[4,l.default.federatedSignIn("google",{token:n,expires_at:o},i)];case 1:return s.sent(),[4,l.default.currentAuthenticatedUser()];case 2:return i=s.sent(),a&&a("signedIn",i),[2]}}))}))},n.prototype.signOut=function(){var e=window.gapi&&window.gapi.auth2?window.gapi.auth2.getAuthInstance():null;if(!e)return Promise.resolve();e.then((function(e){return e?(m.debug("google signing out"),e.signOut()):(m.debug("google Auth undefined"),Promise.resolve())}))},n.prototype.componentDidMount=function(){var e=this.props.google_client_id,t=window.gapi&&window.gapi.auth2?window.gapi.auth2.getAuthInstance():null;e&&!t&&this.createScript()},n.prototype.createScript=function(){var e=document.createElement("script");e.src="https://apis.google.com/js/platform.js",e.async=!0,e.onload=this.initGapi,document.body.appendChild(e)},n.prototype.initGapi=function(){m.debug("init gapi");var e=this.props.google_client_id,t=window.gapi;t.load("auth2",(function(){t.auth2.init({client_id:e,scope:"profile email openid"})}))},n.prototype.render=function(){var t=window.gapi&&window.gapi.auth2?window.gapi.auth2.getAuthInstance():null;return u.createElement(e,i({},this.props,{ga:t,googleSignIn:this.signIn,googleSignOut:this.signOut}))},n}(u.Component)}t.default=g;t.GoogleButton=g((function(e){return u.createElement(f.SignInButton,{id:d.googleSignInButton,onClick:e.googleSignIn,theme:e.theme||p.default,variant:"googleSignInButton"},u.createElement(f.SignInButtonIcon,{theme:e.theme||p.default},u.createElement("svg",{viewBox:"0 0 256 262",xmlns:"http://ww0w.w3.org/2000/svg",preserveAspectRatio:"xMidYMid"},u.createElement("path",{d:"M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027",fill:"#4285F4"}),u.createElement("path",{d:"M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1",fill:"#34A853"}),u.createElement("path",{d:"M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782",fill:"#FBBC05"}),u.createElement("path",{d:"M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251",fill:"#EB4335"}))),u.createElement(f.SignInButtonContent,{theme:e.theme||p.default},c.I18n.get("Sign In with Google")))}))},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),i=this&&this.__assign||function(){return(i=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),s=n(1),u=n(3),c=n(4),l=n(7),p=n(2),d=n(9),f=new s.ConsoleLogger("withFacebook");function h(e){return function(t){function n(e){var n=t.call(this,e)||this;return n.fbAsyncInit=n.fbAsyncInit.bind(n),n.initFB=n.initFB.bind(n),n.signIn=n.signIn.bind(n),n.signOut=n.signOut.bind(n),n.federatedSignIn=n.federatedSignIn.bind(n),n.state={},n}return r(n,t),n.prototype.signIn=function(){var e=this,t=window.FB;t.getLoginStatus((function(n){var o={provider:d.default.FACEBOOK};try{localStorage.setItem(d.default.AUTH_SOURCE_KEY,JSON.stringify(o))}catch(e){f.debug("Failed to cache auth source into localStorage",e)}"connected"===n.status?e.federatedSignIn(n.authResponse):t.login((function(t){t&&t.authResponse&&e.federatedSignIn(t.authResponse)}),{scope:"public_profile,email"})}))},n.prototype.federatedSignIn=function(e){f.debug(e);var t=this.props.onStateChange,n=e.accessToken,o=1e3*e.expiresIn+(new Date).getTime();n&&window.FB.api("/me",{fields:"name,email"},(function(e){var r={name:e.name,email:e.email};if(!u.default||"function"!=typeof u.default.federatedSignIn||"function"!=typeof u.default.currentAuthenticatedUser)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");u.default.federatedSignIn("facebook",{token:n,expires_at:o},r).then((function(e){return u.default.currentAuthenticatedUser()})).then((function(e){t&&t("signedIn",e)}))}))},n.prototype.signOut=function(){var e=window.FB;if(!e)return f.debug("FB sdk undefined"),Promise.resolve();e.getLoginStatus((function(t){return"connected"===t.status?new Promise((function(t,n){f.debug("facebook signing out"),e.logout((function(e){t(e)}))})):Promise.resolve()}))},n.prototype.componentDidMount=function(){this.props.facebook_app_id&&!window.FB&&this.createScript()},n.prototype.fbAsyncInit=function(){f.debug("init FB");var e=this.props.facebook_app_id,t=window.FB;t.init({appId:e,cookie:!0,xfbml:!0,version:"v2.11"}),t.getLoginStatus((function(e){return f.debug(e)}))},n.prototype.initFB=function(){window.FB;f.debug("FB inited")},n.prototype.createScript=function(){window.fbAsyncInit=this.fbAsyncInit;var e=document.createElement("script");e.src="https://connect.facebook.net/en_US/sdk.js",e.async=!0,e.onload=this.initFB,document.body.appendChild(e)},n.prototype.render=function(){var t=window.FB;return a.createElement(e,i({},this.props,{fb:t,facebookSignIn:this.signIn,facebookSignOut:this.signOut}))},n}(a.Component)}t.default=h;t.FacebookButton=h((function(e){return a.createElement(p.SignInButton,{id:l.facebookSignInButton,onClick:e.facebookSignIn,theme:e.theme||c.default,variant:"facebookSignInButton"},a.createElement(p.SignInButtonIcon,{theme:e.theme||c.default},a.createElement("svg",{viewBox:"0 0 279 538",xmlns:"http://www.w3.org/2000/svg"},a.createElement("g",{id:"Page-1",fill:"none",fillRule:"evenodd"},a.createElement("g",{id:"Artboard",fill:"#FFF"},a.createElement("path",{d:"M82.3409742,538 L82.3409742,292.936652 L0,292.936652 L0,196.990154 L82.2410458,196.990154 L82.2410458,126.4295 C82.2410458,44.575144 132.205229,0 205.252865,0 C240.227794,0 270.306232,2.59855099 279,3.79788222 L279,89.2502322 L228.536175,89.2502322 C188.964542,89.2502322 181.270057,108.139699 181.270057,135.824262 L181.270057,196.89021 L276.202006,196.89021 L263.810888,292.836708 L181.16913,292.836708 L181.16913,538 L82.3409742,538 Z",id:"Fill-1"}))))),a.createElement(p.SignInButtonContent,{theme:e.theme||c.default},s.I18n.get("Sign In with Facebook")))}))},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),i=this&&this.__assign||function(){return(i=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),s=n(1),u=n(3),c=n(4),l=n(7),p=n(2),d=n(9),f=new s.ConsoleLogger("withAmazon");function h(e){return function(t){function n(e){var n=t.call(this,e)||this;return n.initAmazon=n.initAmazon.bind(n),n.signIn=n.signIn.bind(n),n.signOut=n.signOut.bind(n),n.federatedSignIn=n.federatedSignIn.bind(n),n.state={},n}return r(n,t),n.prototype.signIn=function(){var e=this;window.amazon.Login.authorize({scope:"profile"},(function(t){if(t.error)f.debug("Failed to login with amazon: "+t.error);else{var n={provider:d.default.AMAZON};try{localStorage.setItem(d.default.AUTH_SOURCE_KEY,JSON.stringify(n))}catch(e){f.debug("Failed to cache auth source into localStorage",e)}e.federatedSignIn(t)}}))},n.prototype.federatedSignIn=function(e){var t=e.access_token,n=e.expires_in,o=this.props.onStateChange,r=1e3*n+(new Date).getTime();t&&window.amazon.Login.retrieveProfile((function(e){if(e.success){var n={name:e.profile.Name,email:e.profile.PrimaryEmail};if(!u.default||"function"!=typeof u.default.federatedSignIn||"function"!=typeof u.default.currentAuthenticatedUser)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");u.default.federatedSignIn("amazon",{token:t,expires_at:r},n).then((function(e){return u.default.currentAuthenticatedUser()})).then((function(e){o&&o("signedIn",e)}))}else f.debug("Get user Info failed")}))},n.prototype.signOut=function(){var e=window.amazon;if(!e)return f.debug("Amazon Login sdk undefined"),Promise.resolve();f.debug("Amazon signing out"),e.Login.logout()},n.prototype.componentDidMount=function(){this.props.amazon_client_id&&!window.amazon&&this.createScript()},n.prototype.createScript=function(){var e=document.createElement("script");e.src="https://api-cdn.amazon.com/sdk/login1.js",e.async=!0,e.onload=this.initAmazon,document.body.appendChild(e)},n.prototype.initAmazon=function(){f.debug("init amazon");var e=this.props.amazon_client_id;window.amazon.Login.setClientId(e)},n.prototype.render=function(){var t=window.amazon;return a.createElement(e,i({},this.props,{amz:t,amazonSignIn:this.signIn,amazonSignOut:this.signOut}))},n}(a.Component)}t.default=h;t.AmazonButton=h((function(e){return a.createElement(p.SignInButton,{id:l.amazonSignInButton,onClick:e.amazonSignIn,theme:e.theme||c.default,variant:"amazonSignInButton"},a.createElement(p.SignInButtonIcon,{theme:e.theme||c.default},a.createElement("svg",{viewBox:"0 0 248 268",xmlns:"http://www.w3.org/2000/svg"},a.createElement("g",{id:"Artboard-Copy-2",fill:"none",fillRule:"evenodd"},a.createElement("path",{d:"M139.056521,147.024612 C133.548808,156.744524 124.782731,162.726926 115.087401,162.726926 C101.790721,162.726926 93.9937779,152.612964 93.9937779,137.68681 C93.9937779,108.224571 120.447551,102.879017 145.533369,102.879017 L145.533369,110.365976 C145.533369,123.831358 145.876354,135.063787 139.056521,147.024612 M207.206992,162.579655 C209.400505,165.692256 209.887066,169.437725 207.063416,171.770186 C199.996315,177.653081 187.429476,188.590967 180.513926,194.716661 L180.46208,194.621133 C178.176838,196.663031 174.862638,196.810303 172.27828,195.445057 C160.780281,185.9162 158.686473,181.494078 152.405048,172.403055 C133.405233,191.751331 119.909143,197.534719 95.309886,197.534719 C66.1281801,197.534719 43.4791563,179.599451 43.4791563,143.669212 C43.4791563,115.616003 58.6782107,96.5105248 80.4019706,87.1727225 C99.2063636,78.9096034 125.464714,77.4528107 145.533369,75.1641337 L145.533369,70.694248 C145.533369,62.4749122 146.167493,52.7510201 141.297893,45.6541312 C137.110277,39.2856386 129.018206,36.6586354 121.859376,36.6586354 C108.658413,36.6586354 96.9171331,43.4171982 94.0416364,57.4199213 C93.4593582,60.532522 91.1701278,63.5933787 88.003492,63.7406501 L54.4387473,60.1424518 C51.6150972,59.5095829 48.4484614,57.2248862 49.2740201,52.8982915 C56.9712583,12.2553679 93.7983558,0 126.732964,0 C143.587124,0 165.606011,4.47386604 178.902691,17.2148315 C195.760839,32.917146 194.149604,53.8694866 194.149604,76.6726704 L194.149604,130.542157 C194.149604,146.734049 200.87372,153.830938 207.206992,162.579655 Z M233.826346,208.038962 C230.467669,203.683255 211.550709,205.9821 203.056405,206.998432 C200.470662,207.321077 200.076227,205.042397 202.406981,203.404973 C217.475208,192.664928 242.201125,195.766353 245.081698,199.363845 C247.966255,202.981502 244.336653,228.071183 230.172839,240.049379 C228.001452,241.888455 225.929671,240.904388 226.89783,238.468418 C230.077218,230.430525 237.204944,212.418868 233.826346,208.038962 Z M126.768855,264 C74.0234043,264 42.0764048,241.955028 17.7852554,217.541992 C12.9733903,212.705982 6.71799208,206.295994 3.31151296,200.690918 C1.90227474,198.372135 5.59096074,195.021875 8.0442063,196.84375 C38.2390146,219.267578 82.1011654,239.538304 125.529506,239.538304 C154.819967,239.538304 191.046475,227.469543 220.66851,214.867659 C225.146771,212.966167 225.146771,219.180222 224.511585,221.060516 C224.183264,222.03242 209.514625,236.221149 189.247207,247.047411 C170.304273,257.166172 146.397132,264 126.768855,264 Z",id:"Fill-6",fill:"#FFF"})))),a.createElement(p.SignInButtonContent,{theme:e.theme||c.default},s.I18n.get("Sign In with Amazon")))}))},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),i=this&&this.__assign||function(){return(i=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),s=n(1),u=n(3),c=n(4),l=n(7),p=n(2);function d(e){return function(t){function n(e){var n=t.call(this,e)||this;return n.signIn=n.signIn.bind(n),n}return r(n,t),n.prototype.signIn=function(e,t){u.default.federatedSignIn({provider:t})},n.prototype.render=function(){return a.createElement(e,i({},this.props,{OAuthSignIn:this.signIn}))},n}(a.Component)}t.default=d;t.OAuthButton=d((function(e){return a.createElement(p.SignInButton,{id:l.oAuthSignInButton,onClick:function(){return e.OAuthSignIn()},theme:e.theme||c.default,variant:"oAuthSignInButton"},a.createElement(p.SignInButtonContent,{theme:e.theme||c.default},s.I18n.get(e.label||"Sign in with AWS")))}))},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),i=this&&this.__assign||function(){return(i=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)},a=this&&this.__awaiter||function(e,t,n,o){return new(n||(n=Promise))((function(r,i){function a(e){try{u(o.next(e))}catch(e){i(e)}}function s(e){try{u(o.throw(e))}catch(e){i(e)}}function u(e){var t;e.done?r(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(a,s)}u((o=o.apply(e,t||[])).next())}))},s=this&&this.__generator||function(e,t){var n,o,r,i,a={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return i={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function s(i){return function(s){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,o&&(r=2&i[0]?o.return:i[0]?o.throw||((r=o.return)&&r.call(o),0):o.next)&&!(r=r.call(o,i[1])).done)return r;switch(o=0,r&&(i=[2&i[0],r.value]),i[0]){case 0:case 1:r=i;break;case 4:return a.label++,{value:i[1],done:!1};case 5:a.label++,o=i[1],i=[0];continue;case 7:i=a.ops.pop(),a.trys.pop();continue;default:if(!(r=(r=a.trys).length>0&&r[r.length-1])&&(6===i[0]||2===i[0])){a=0;continue}if(3===i[0]&&(!r||i[1]>r[0]&&i[1]<r[3])){a.label=i[1];break}if(6===i[0]&&a.label<r[1]){a.label=r[1],r=i;break}if(r&&a.label<r[2]){a.label=r[2],a.ops.push(i);break}r[2]&&a.ops.pop(),a.trys.pop();continue}i=t.call(e,a)}catch(e){i=[6,e],o=0}finally{n=r=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,s])}}};Object.defineProperty(t,"__esModule",{value:!0});var u=n(0),c=n(1),l=n(3),p=n(4),d=n(7),f=n(2),h=n(9),m=new c.ConsoleLogger("withAuth0");function g(e,t){return function(n){function o(e){var t=n.call(this,e)||this;return t._auth0=null,t.initialize=t.initialize.bind(t),t.signIn=t.signIn.bind(t),t.signOut=t.signOut.bind(t),t}return r(o,n),o.prototype.componentDidMount=function(){window.auth0?this.initialize():this.createScript()},o.prototype.createScript=function(){var e=document.createElement("script");e.src="https://cdn.auth0.com/js/auth0/9.8.1/auth0.min.js",e.async=!0,e.onload=this.initialize,document.body.appendChild(e)},o.prototype.initialize=function(){var e=this,n=l.default.configure().oauth,o=void 0===n?{}:n,r=this.props.auth0||t||o.auth0,i=this.props,a=i.onError,s=i.onStateChange,u=i.authState;r?(m.debug("withAuth0 configuration",r),this._auth0||(this._auth0=new window.auth0.WebAuth(r),window.auth0_client=this._auth0),"signedIn"!==u&&this._auth0.parseHash((function(t,n){if(!t&&n){var o={provider:h.default.AUTH0,opts:{returnTo:r.returnTo,clientID:r.clientID,federated:r.federated}};try{localStorage.setItem(h.default.AUTH_SOURCE_KEY,JSON.stringify(o))}catch(e){m.debug("Failed to cache auth source into localStorage",e)}e._auth0.client.userInfo(n.accessToken,(function(e,t){var o=void 0,i=void 0;e?m.debug("Failed to get the user info",e):(o=t.name,i=t.email),l.default.federatedSignIn(r.domain,{token:n.idToken,expires_at:1e3*n.expiresIn+(new Date).getTime()},{name:o,email:i}).then((function(){s&&l.default.currentAuthenticatedUser().then((function(e){s("signedIn",e)}))})).catch((function(e){m.debug("Failed to get the aws credentials",e),a&&a(e)}))}))}else m.debug("Failed to parse the url for Auth0",t)}))):m.debug("Auth0 is not configured")},o.prototype.signIn=function(){return a(this,void 0,void 0,(function(){return s(this,(function(e){if(!this._auth0)throw new Error("the auth0 client is not configured");return this._auth0.authorize(),[2]}))}))},o.prototype.signOut=function(e){void 0===e&&(e={});var t=window.auth0_client,n=e.returnTo,o=e.clientID,r=e.federated;if(!t)return m.debug("auth0 sdk undefined"),Promise.resolve();t.logout({returnTo:n,clientID:o,federated:r})},o.prototype.render=function(){return u.createElement(e,i({},this.props,{auth0:this._auth0,auth0SignIn:this.signIn,auth0SignOut:this.signOut}))},o}(u.Component)}t.default=g;t.Auth0Button=g((function(e){return u.createElement(f.SignInButton,{id:d.auth0SignInButton,onClick:e.auth0SignIn,theme:e.theme||p.default,variant:"auth0SignInButton"},u.createElement(f.SignInButtonIcon,{theme:e.theme||p.default},u.createElement("svg",{id:"artwork",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 193.7 216.6"},u.createElement("path",{id:"NEW",className:"st0",d:"M189,66.9L167.2,0H96.8l21.8,66.9H189z M96.8,0H26.5L4.8,66.9h70.4L96.8,0z M4.8,66.9L4.8,66.9\tc-13,39.9,1.2,83.6,35.2,108.3l21.7-66.9L4.8,66.9z M189,66.9L189,66.9l-57,41.4l21.7,66.9l0,0C187.7,150.6,201.9,106.8,189,66.9\tL189,66.9z M39.9,175.2L39.9,175.2l56.9,41.4l56.9-41.4l-56.9-41.4L39.9,175.2z"}))),u.createElement(f.SignInButtonContent,{theme:e.theme||p.default},e.label||"Sign In with Auth0"))}))},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),i=this&&this.__awaiter||function(e,t,n,o){return new(n||(n=Promise))((function(r,i){function a(e){try{u(o.next(e))}catch(e){i(e)}}function s(e){try{u(o.throw(e))}catch(e){i(e)}}function u(e){var t;e.done?r(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(a,s)}u((o=o.apply(e,t||[])).next())}))},a=this&&this.__generator||function(e,t){var n,o,r,i,a={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return i={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function s(i){return function(s){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,o&&(r=2&i[0]?o.return:i[0]?o.throw||((r=o.return)&&r.call(o),0):o.next)&&!(r=r.call(o,i[1])).done)return r;switch(o=0,r&&(i=[2&i[0],r.value]),i[0]){case 0:case 1:r=i;break;case 4:return a.label++,{value:i[1],done:!1};case 5:a.label++,o=i[1],i=[0];continue;case 7:i=a.ops.pop(),a.trys.pop();continue;default:if(!(r=(r=a.trys).length>0&&r[r.length-1])&&(6===i[0]||2===i[0])){a=0;continue}if(3===i[0]&&(!r||i[1]>r[0]&&i[1]<r[3])){a.label=i[1];break}if(6===i[0]&&a.label<r[1]){a.label=r[1],r=i;break}if(r&&a.label<r[2]){a.label=r[2],a.ops.push(i);break}r[2]&&a.ops.pop(),a.trys.pop();continue}i=t.call(e,a)}catch(e){i=[6,e],o=0}finally{n=r=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,s])}}};Object.defineProperty(t,"__esModule",{value:!0});var s=n(0),u=n(1),c=n(3),l=n(6),p=n(29),d=n(14),f=n(15),h=n(2),m=n(5),g=new u.ConsoleLogger("SignIn"),y=function(e){function t(t){var n=e.call(this,t)||this;return n.checkContact=n.checkContact.bind(n),n.signIn=n.signIn.bind(n),n._validAuthStates=["signIn","signedOut","signedUp"],n.state={},n}return r(t,e),t.prototype.checkContact=function(e){var t=this;if(!c.default||"function"!=typeof c.default.verifiedContact)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");c.default.verifiedContact(e).then((function(n){u.JS.isEmpty(n.verified)?(e=Object.assign(e,n),t.changeState("verifyContact",e)):t.changeState("signedIn",e)}))},t.prototype.signIn=function(e){return i(this,void 0,void 0,(function(){var t,n,o,r;return a(this,(function(i){switch(i.label){case 0:if(e&&e.preventDefault(),t=this.getUsernameFromInput()||"",n=this.inputs.password,!c.default||"function"!=typeof c.default.signIn)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");this.setState({loading:!0}),i.label=1;case 1:return i.trys.push([1,3,4,5]),[4,c.default.signIn(t,n)];case 2:return o=i.sent(),g.debug(o),"SMS_MFA"===o.challengeName||"SOFTWARE_TOKEN_MFA"===o.challengeName?(g.debug("confirm user with "+o.challengeName),this.changeState("confirmSignIn",o)):"NEW_PASSWORD_REQUIRED"===o.challengeName?(g.debug("require new password",o.challengeParam),this.changeState("requireNewPassword",o)):"MFA_SETUP"===o.challengeName?(g.debug("TOTP setup",o.challengeParam),this.changeState("TOTPSetup",o)):"CUSTOM_CHALLENGE"===o.challengeName&&o.challengeParam&&"true"===o.challengeParam.trigger?(g.debug("custom challenge",o.challengeParam),this.changeState("customConfirmSignIn",o)):this.checkContact(o),[3,5];case 3:return"UserNotConfirmedException"===(r=i.sent()).code?(g.debug("the user is not confirmed"),this.changeState("confirmSignUp",{username:t})):"PasswordResetRequiredException"===r.code?(g.debug("the user requires a new password"),this.changeState("forgotPassword",{username:t})):this.error(r),[3,5];case 4:return this.setState({loading:!1}),[7];case 5:return[2]}}))}))},t.prototype.showComponent=function(e){var n=this,o=this.props,r=o.authState,i=o.hide,a=void 0===i?[]:i,c=o.federated,l=o.onStateChange,g=o.onAuthEvent,y=o.override,v=void 0===y?[]:y;if(a&&a.includes(t))return null;var b=!v.includes("SignUp")&&a.some((function(e){return e===d.default})),S=!v.includes("ForgotPassword")&&a.some((function(e){return e===f.default}));return s.createElement(h.FormSection,{theme:e,"data-test":m.auth.signIn.section},s.createElement(h.SectionHeader,{theme:e,"data-test":m.auth.signIn.headerSection},u.I18n.get("Sign in to your account")),s.createElement(p.FederatedButtons,{federated:c,theme:e,authState:r,onStateChange:l,onAuthEvent:g}),s.createElement("form",{onSubmit:this.signIn},s.createElement(h.SectionBody,{theme:e},this.renderUsernameField(e),s.createElement(h.FormField,{theme:e},s.createElement(h.InputLabel,{theme:e},u.I18n.get("Password")," *"),s.createElement(h.Input,{placeholder:u.I18n.get("Enter your password"),theme:e,key:"password",type:"password",name:"password",onChange:this.handleInputChange,"data-test":m.auth.signIn.passwordInput}),!S&&s.createElement(h.Hint,{theme:e},u.I18n.get("Forget your password? "),s.createElement(h.Link,{theme:e,onClick:function(){return n.changeState("forgotPassword")},"data-test":m.auth.signIn.forgotPasswordLink},u.I18n.get("Reset password"))))),s.createElement(h.SectionFooter,{theme:e,"data-test":m.auth.signIn.footerSection},s.createElement(h.SectionFooterPrimaryContent,{theme:e},s.createElement(h.Button,{theme:e,type:"submit",disabled:this.state.loading,"data-test":m.auth.signIn.signInButton},u.I18n.get("Sign In"))),!b&&s.createElement(h.SectionFooterSecondaryContent,{theme:e},u.I18n.get("No account? "),s.createElement(h.Link,{theme:e,onClick:function(){return n.changeState("signUp")},"data-test":m.auth.signIn.createAccountLink},u.I18n.get("Create account"))))))},t}(l.default);t.default=y},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),a=n(1),s=n(3),u=n(4),c=n(2),l=n(5),p=n(13),d=new a.ConsoleLogger("FederatedSignIn"),f=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return r(t,e),t.prototype.google=function(e){if(!e)return null;var t=this.props,n=t.theme,o=t.onStateChange;return i.createElement(p.GoogleButton,{google_client_id:e,theme:n,onStateChange:o})},t.prototype.facebook=function(e){if(!e)return null;var t=this.props,n=t.theme,o=t.onStateChange;return i.createElement(p.FacebookButton,{facebook_app_id:e,theme:n,onStateChange:o})},t.prototype.amazon=function(e){if(!e)return null;var t=this.props,n=t.theme,o=t.onStateChange;return i.createElement(p.AmazonButton,{amazon_client_id:e,theme:n,onStateChange:o})},t.prototype.OAuth=function(e){if(!e)return null;var t=this.props,n=t.theme,o=t.onStateChange;return i.createElement(p.OAuthButton,{label:e?e.label:void 0,theme:n,onStateChange:o})},t.prototype.auth0=function(e){if(!e)return null;var t=this.props,n=t.theme,o=t.onStateChange;return i.createElement(p.Auth0Button,{label:e?e.label:void 0,theme:n,onStateChange:o,auth0:e})},t.prototype.render=function(){var e=this.props.authState;if(!["signIn","signedOut","signedUp"].includes(e))return null;var t=this.props.federated||{};if(!s.default||"function"!=typeof s.default.configure)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");var n=s.default.configure().oauth,o=void 0===n?{}:n;if(o.domain?t.oauth_config=Object.assign({},t.oauth_config,o):o.awsCognito&&(t.oauth_config=Object.assign({},t.oauth_config,o.awsCognito)),o.auth0&&(t.auth0=Object.assign({},t.auth0,o.auth0)),a.JS.isEmpty(t))return null;var r=t.google_client_id,l=t.facebook_app_id,p=t.amazon_client_id,d=t.oauth_config,f=t.auth0,h=this.props.theme||u.default;return i.createElement("div",null,i.createElement("div",null,this.google(r)),i.createElement("div",null,this.facebook(l)),i.createElement("div",null,this.amazon(p)),i.createElement("div",null,this.OAuth(d)),i.createElement("div",null,this.auth0(f)),i.createElement(c.Strike,{theme:h},a.I18n.get("or")))},t}(i.Component);t.FederatedButtons=f;var h=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return r(t,e),t.prototype.render=function(){var e=this.props,t=e.authState,n=e.onStateChange,o=this.props.federated||{};if(!s.default||"function"!=typeof s.default.configure)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");var r=s.default.configure().oauth,a=void 0===r?{}:r;if(a.domain?o.oauth_config=Object.assign({},o.oauth_config,a):a.awsCognito&&(o.oauth_config=Object.assign({},o.oauth_config,a.awsCognito)),a.auth0&&(o.auth0=Object.assign({},o.auth0,a.auth0)),!o)return d.debug("federated prop is empty. show nothing"),d.debug("federated={google_client_id: , facebook_app_id: , amazon_client_id}"),null;if(!["signIn","signedOut","signedUp"].includes(t))return null;d.debug("federated Config is",o);var p=this.props.theme||u.default;return i.createElement(c.FormSection,{theme:p,"data-test":l.auth.federatedSignIn.section},i.createElement(c.SectionBody,{theme:p,"data-test":l.auth.federatedSignIn.bodySection},i.createElement(f,{federated:o,theme:p,authState:t,onStateChange:n,"data-test":l.auth.federatedSignIn.signInButtons})))},t}(i.Component);t.default=h},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),a=n(1),s=n(3),u=n(6),c=n(2),l=n(5),p=function(e){function t(t){var n=e.call(this,t)||this;return n._validAuthStates=["confirmSignIn"],n.confirm=n.confirm.bind(n),n.checkContact=n.checkContact.bind(n),n.state={mfaType:"SMS"},n}return r(t,e),t.prototype.checkContact=function(e){var t=this;if(!s.default||"function"!=typeof s.default.verifiedContact)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");s.default.verifiedContact(e).then((function(n){if(a.JS.isEmpty(n.verified)){var o=Object.assign(e,n);t.changeState("verifyContact",o)}else t.changeState("signedIn",e)}))},t.prototype.confirm=function(e){var t=this;e&&e.preventDefault();var n=this.props.authData,o=this.inputs.code,r="SOFTWARE_TOKEN_MFA"===n.challengeName?"SOFTWARE_TOKEN_MFA":null;if(!s.default||"function"!=typeof s.default.confirmSignIn)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");s.default.confirmSignIn(n,o,r).then((function(){t.checkContact(n)})).catch((function(e){return t.error(e)}))},t.prototype.componentDidUpdate=function(){var e=this.props.authData,t=e&&"SOFTWARE_TOKEN_MFA"===e.challengeName?"TOTP":"SMS";this.state.mfaType!==t&&this.setState({mfaType:t})},t.prototype.showComponent=function(e){var n=this,o=this.props.hide;return o&&o.includes(t)?null:i.createElement(c.FormSection,{theme:e,"data-test":l.auth.confirmSignIn.section},i.createElement(c.SectionHeader,{theme:e,"data-test":l.auth.confirmSignIn.headerSection},a.I18n.get("Confirm "+this.state.mfaType+" Code")),i.createElement("form",{onSubmit:this.confirm,"data-test":l.auth.confirmSignIn.bodySection},i.createElement(c.SectionBody,{theme:e},i.createElement(c.FormField,{theme:e},i.createElement(c.InputLabel,{theme:e},a.I18n.get("Code")," *"),i.createElement(c.Input,{autoFocus:!0,placeholder:a.I18n.get("Code"),theme:e,key:"code",name:"code",autoComplete:"off",onChange:this.handleInputChange,"data-test":l.auth.confirmSignIn.codeInput}))),i.createElement(c.SectionFooter,{theme:e},i.createElement(c.SectionFooterPrimaryContent,{theme:e,"data-test":l.auth.confirmSignIn.confirmButton},i.createElement(c.Button,{theme:e,type:"submit"},a.I18n.get("Confirm"))),i.createElement(c.SectionFooterSecondaryContent,{theme:e},i.createElement(c.Link,{theme:e,onClick:function(){return n.changeState("signIn")},"data-test":l.auth.confirmSignIn.backToSignInLink},a.I18n.get("Back to Sign In"))))))},t}(u.default);t.default=p},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),a=n(1),s=n(3),u=n(6),c=n(2),l=n(5),p=new a.ConsoleLogger("RequireNewPassword"),d=function(e){function t(t){var n=e.call(this,t)||this;return n._validAuthStates=["requireNewPassword"],n.change=n.change.bind(n),n.checkContact=n.checkContact.bind(n),n}return r(t,e),t.prototype.checkContact=function(e){var t=this;if(!s.default||"function"!=typeof s.default.verifiedContact)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");s.default.verifiedContact(e).then((function(n){a.JS.isEmpty(n.verified)?(e=Object.assign(e,n),t.changeState("verifyContact",e)):t.changeState("signedIn",e)}))},t.prototype.change=function(){var e=this,t=this.props.authData,n=this.inputs.password,o=t.challengeParam.requiredAttributes,r=function(e,t){var n={};for(var o in e)-1!==t.indexOf(o)&&Object.prototype.hasOwnProperty.call(e,o)&&(n[o]=e[o]);return n}(this.inputs,o);if(!s.default||"function"!=typeof s.default.completeNewPassword)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");s.default.completeNewPassword(t,n,r).then((function(t){p.debug("complete new password",t),"SMS_MFA"===t.challengeName?e.changeState("confirmSignIn",t):"MFA_SETUP"===t.challengeName?(p.debug("TOTP setup",t.challengeParam),e.changeState("TOTPSetup",t)):e.checkContact(t)})).catch((function(t){return e.error(t)}))},t.prototype.showComponent=function(e){var n=this,o=this.props.hide;if(o&&o.includes(t))return null;var r=this.props.authData.challengeParam.requiredAttributes;return i.createElement(c.FormSection,{theme:e,"data-test":l.auth.requireNewPassword.section},i.createElement(c.SectionHeader,{theme:e,"data-test":l.auth.requireNewPassword.headerSection},a.I18n.get("Change Password")),i.createElement(c.SectionBody,{theme:e,"data-test":l.auth.requireNewPassword.bodySection},i.createElement(c.Input,{autoFocus:!0,placeholder:a.I18n.get("New Password"),theme:e,key:"password",name:"password",type:"password",onChange:this.handleInputChange,"data-test":l.auth.requireNewPassword.newPasswordInput}),r.map((function(t){return i.createElement(c.Input,{placeholder:a.I18n.get((o=t,o.split("_").map((function(e){return e.charAt(0).toUpperCase()+e.substr(1).toLowerCase()})).join(" "))),theme:e,key:t,name:t,type:"text",onChange:n.handleInputChange});var o}))),i.createElement(c.SectionFooter,{theme:e},i.createElement(c.SectionFooterPrimaryContent,{theme:e},i.createElement(c.Button,{theme:e,onClick:this.change},a.I18n.get("Change"))),i.createElement(c.SectionFooterSecondaryContent,{theme:e},i.createElement(c.Link,{theme:e,onClick:function(){return n.changeState("signIn")},"data-test":l.auth.requireNewPassword.backToSignInLink},a.I18n.get("Back to Sign In")))))},t}(u.default);t.default=d},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),a=n(1),s=n(6),u=n(2),c=n(5),l=function(e){function t(t){var n=e.call(this,t)||this;return n._validAuthStates=["loading"],n}return r(t,e),t.prototype.showComponent=function(e){var n=this.props.hide;return n&&n.includes(t)?null:i.createElement(u.FormSection,{theme:e,"data-test":c.auth.loading.section},i.createElement(u.SectionBody,{theme:e},a.I18n.get("Loading...")))},t}(s.default);t.default=l},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),a=n(1),s=n(3),u=n(6),c=n(2),l=n(5),p=new a.ConsoleLogger("ConfirmSignUp"),d=function(e){function t(t){var n=e.call(this,t)||this;return n._validAuthStates=["confirmSignUp"],n.confirm=n.confirm.bind(n),n.resend=n.resend.bind(n),n}return r(t,e),t.prototype.confirm=function(){var e=this,t=this.usernameFromAuthData()||this.inputs.username,n=this.inputs.code;if(!s.default||"function"!=typeof s.default.confirmSignUp)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");s.default.confirmSignUp(t,n).then((function(){return e.changeState("signedUp")})).catch((function(t){return e.error(t)}))},t.prototype.resend=function(){var e=this,t=this.usernameFromAuthData()||this.inputs.username;if(!s.default||"function"!=typeof s.default.resendSignUp)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");s.default.resendSignUp(t).then((function(){return p.debug("code resent")})).catch((function(t){return e.error(t)}))},t.prototype.showComponent=function(e){var n=this,o=this.props.hide,r=this.usernameFromAuthData();return o&&o.includes(t)?null:i.createElement(c.FormSection,{theme:e,"data-test":l.auth.confirmSignUp.section},i.createElement(c.SectionHeader,{theme:e,"data-test":l.auth.confirmSignUp.headerSection},a.I18n.get("Confirm Sign Up")),i.createElement(c.SectionBody,{theme:e,"data-test":l.auth.confirmSignUp.bodySection},i.createElement(c.FormField,{theme:e},i.createElement(c.InputLabel,{theme:e},a.I18n.get(this.getUsernameLabel())," *"),i.createElement(c.Input,{placeholder:a.I18n.get("Username"),theme:e,key:"username",name:"username",onChange:this.handleInputChange,disabled:r,value:r||"","data-test":l.auth.confirmSignUp.usernameInput})),i.createElement(c.FormField,{theme:e},i.createElement(c.InputLabel,{theme:e},a.I18n.get("Confirmation Code")," *"),i.createElement(c.Input,{autoFocus:!0,placeholder:a.I18n.get("Enter your code"),theme:e,key:"code",name:"code",autoComplete:"off",onChange:this.handleInputChange,"data-test":l.auth.confirmSignUp.confirmationCodeInput}),i.createElement(c.Hint,{theme:e},a.I18n.get("Lost your code? "),i.createElement(c.Link,{theme:e,onClick:this.resend,"data-test":l.auth.confirmSignUp.resendCodeLink},a.I18n.get("Resend Code"))))),i.createElement(c.SectionFooter,{theme:e},i.createElement(c.SectionFooterPrimaryContent,{theme:e},i.createElement(c.Button,{theme:e,onClick:this.confirm,"data-test":l.auth.confirmSignUp.confirmButton},a.I18n.get("Confirm"))),i.createElement(c.SectionFooterSecondaryContent,{theme:e},i.createElement(c.Link,{theme:e,onClick:function(){return n.changeState("signIn")},"data-test":l.auth.confirmSignUp.backToSignInLink},a.I18n.get("Back to Sign In")))))},t}(u.default);t.default=d},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),a=n(1),s=n(3),u=n(6),c=n(8),l=n(2),p=n(5),d=new a.ConsoleLogger("VerifyContact"),f=function(e){function t(t){var n=e.call(this,t)||this;return n._validAuthStates=["verifyContact"],n.verify=n.verify.bind(n),n.submit=n.submit.bind(n),n.state={verifyAttr:null},n}return r(t,e),t.prototype.verify=function(){var e=this,t=this.inputs,n=t.contact,o=t.checkedValue;if(n){if(!s.default||"function"!=typeof s.default.verifyCurrentUserAttribute)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");s.default.verifyCurrentUserAttribute(o).then((function(t){d.debug(t),e.setState({verifyAttr:o})})).catch((function(t){return e.error(t)}))}else this.error("Neither Email nor Phone Number selected")},t.prototype.submit=function(){var e=this,t=this.state.verifyAttr,n=this.inputs.code;if(!s.default||"function"!=typeof s.default.verifyCurrentUserAttributeSubmit)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");s.default.verifyCurrentUserAttributeSubmit(t,n).then((function(t){d.debug(t),e.changeState("signedIn",e.props.authData),e.setState({verifyAttr:null})})).catch((function(t){return e.error(t)}))},t.prototype.verifyView=function(){var e=this.props.authData;if(!e)return d.debug("no user for verify"),null;var t=e.unverified;if(!t)return d.debug("no unverified on user"),null;var n=t.email,o=t.phone_number,r=this.props.theme||c.default;return i.createElement("div",null,n?i.createElement(l.RadioRow,{placeholder:a.I18n.get("Email"),theme:r,key:"email",name:"contact",value:"email",onChange:this.handleInputChange}):null,o?i.createElement(l.RadioRow,{placeholder:a.I18n.get("Phone Number"),theme:r,key:"phone_number",name:"contact",value:"phone_number",onChange:this.handleInputChange}):null)},t.prototype.submitView=function(){var e=this.props.theme||c.default;return i.createElement("div",null,i.createElement(l.Input,{placeholder:a.I18n.get("Code"),theme:e,key:"code",name:"code",autoComplete:"off",onChange:this.handleInputChange}))},t.prototype.showComponent=function(e){var n=this,o=this.props,r=o.authData,s=o.hide;return s&&s.includes(t)?null:i.createElement(l.FormSection,{theme:e,"data-test":p.auth.verifyContact.section},i.createElement(l.SectionHeader,{theme:e,"data-test":p.auth.verifyContact.headerSection},a.I18n.get("Account recovery requires verified contact information")),i.createElement(l.SectionBody,{theme:e,"data-test":p.auth.verifyContact.bodySection},this.state.verifyAttr?this.submitView():this.verifyView()),i.createElement(l.SectionFooter,{theme:e},i.createElement(l.SectionFooterPrimaryContent,{theme:e},this.state.verifyAttr?i.createElement(l.Button,{theme:e,onClick:this.submit,"data-test":p.auth.verifyContact.submitButton},a.I18n.get("Submit")):i.createElement(l.Button,{theme:e,onClick:this.verify,"data-test":p.auth.verifyContact.verifyButton},a.I18n.get("Verify"))),i.createElement(l.SectionFooterSecondaryContent,{theme:e},i.createElement(l.Link,{theme:e,onClick:function(){return n.changeState("signedIn",r)},"data-test":p.auth.verifyContact.skipLink},a.I18n.get("Skip")))))},t}(u.default);t.default=f},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),i=this&&this.__assign||function(){return(i=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),s=n(1),u=n(3),c=n(6),l=n(16),p=n(5),d=new s.ConsoleLogger("TOTPSetup"),f=function(e){function t(t){var n=e.call(this,t)||this;return n._validAuthStates=["TOTPSetup"],n.onTOTPEvent=n.onTOTPEvent.bind(n),n.checkContact=n.checkContact.bind(n),n}return r(t,e),t.prototype.checkContact=function(e){var t=this;if(!u.default||"function"!=typeof u.default.verifiedContact)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");u.default.verifiedContact(e).then((function(n){if(s.JS.isEmpty(n.verified)){var o=Object.assign(e,n);t.changeState("verifyContact",o)}else t.changeState("signedIn",e)}))},t.prototype.onTOTPEvent=function(e,t,n){d.debug("on totp event",e,t),"Setup TOTP"===e&&"SUCCESS"===t&&this.checkContact(n)},t.prototype.showComponent=function(e){var n=this.props.hide;return n&&n.includes(t)?null:a.createElement(l.default,i({},this.props,{onTOTPEvent:this.onTOTPEvent,"data-test":p.auth.TOTPSetup.component}))},t}(c.default);t.default=f},function(e,t){e.exports={MODE_NUMBER:1,MODE_ALPHA_NUM:2,MODE_8BIT_BYTE:4,MODE_KANJI:8}},function(e,t){e.exports={L:1,M:0,Q:3,H:2}},function(e,t,n){var o=n(39);function r(e,t){if(null==e.length)throw new Error(e.length+"/"+t);for(var n=0;n<e.length&&0==e[n];)n++;this.num=new Array(e.length-n+t);for(var o=0;o<e.length-n;o++)this.num[o]=e[o+n]}r.prototype={get:function(e){return this.num[e]},getLength:function(){return this.num.length},multiply:function(e){for(var t=new Array(this.getLength()+e.getLength()-1),n=0;n<this.getLength();n++)for(var i=0;i<e.getLength();i++)t[n+i]^=o.gexp(o.glog(this.get(n))+o.glog(e.get(i)));return new r(t,0)},mod:function(e){if(this.getLength()-e.getLength()<0)return this;for(var t=o.glog(this.get(0))-o.glog(e.get(0)),n=new Array(this.getLength()),i=0;i<this.getLength();i++)n[i]=this.get(i);for(i=0;i<e.getLength();i++)n[i]^=o.gexp(o.glog(e.get(i))+t);return new r(n,0).mod(e)}},e.exports=r},function(e,t){for(var n={glog:function(e){if(e<1)throw new Error("glog("+e+")");return n.LOG_TABLE[e]},gexp:function(e){for(;e<0;)e+=255;for(;e>=256;)e-=255;return n.EXP_TABLE[e]},EXP_TABLE:new Array(256),LOG_TABLE:new Array(256)},o=0;o<8;o++)n.EXP_TABLE[o]=1<<o;for(o=8;o<256;o++)n.EXP_TABLE[o]=n.EXP_TABLE[o-4]^n.EXP_TABLE[o-5]^n.EXP_TABLE[o-6]^n.EXP_TABLE[o-8];for(o=0;o<255;o++)n.LOG_TABLE[n.EXP_TABLE[o]]=o;e.exports=n},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var o=n(1);t.MapEntries=[["User does not exist",/user.*not.*exist/i],["User already exists",/user.*already.*exist/i],["Incorrect username or password",/incorrect.*username.*password/i],["Invalid password format",/validation.*password/i],["Invalid phone number format",/invalid.*phone/i,"Invalid phone number format. Please use a phone number format of +12345678900"]],t.default=function(e){var n=t.MapEntries.filter((function(t){return t[1].test(e)}));if(0===n.length)return e;var r=n[0],i=r.length>2?r[2]:r[0];return o.I18n.get(r[0],i)}},function(e,t){e.exports=i},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),a=n(0),s=n(1),u=n(17),c=n(8),l=n(10),p=n(43),d=n(44),f=new s.ConsoleLogger("Storage.S3Image"),h=function(e){function t(t){var n=e.call(this,t)||this;n._isMounted=!1,n.handleOnLoad=n.handleOnLoad.bind(n),n.handleOnError=n.handleOnError.bind(n),n.handlePick=n.handlePick.bind(n),n.handleClick=n.handleClick.bind(n);var o=n.props.src||l.transparent1X1;return n.state={src:o},n}return r(t,e),t.prototype.getImageSource=function(e,t,n,o){var r=this;if(!u.default||"function"!=typeof u.default.get)throw new Error("No Storage module found, please ensure @aws-amplify/storage is imported");u.default.get(e,{level:t||"public",track:n,identityId:o}).then((function(e){r._isMounted&&r.setState({src:e})})).catch((function(e){return f.debug(e)}))},t.prototype.load=function(){var e=this.props,t=e.imgKey,n=e.path,o=e.body,r=e.contentType,i=e.level,a=e.track,s=e.identityId;if(t||n){var c=this,l=t||n;if(f.debug("loading "+l+"..."),o){var p=r||"binary/octet-stream";if(!u.default||"function"!=typeof u.default.put)throw new Error("No Storage module found, please ensure @aws-amplify/storage is imported");u.default.put(l,o,{contentType:p,level:i||"public",track:a}).then((function(e){f.debug(e),c.getImageSource(l,i,a,s)})).catch((function(e){return f.debug(e)}))}else c.getImageSource(l,i,a,s)}else f.debug("empty imgKey and path")},t.prototype.handleOnLoad=function(e){var t=this.props.onLoad;t&&t(this.state.src)},t.prototype.handleOnError=function(e){var t=this.props.onError;t&&t(this.state.src)},t.prototype.handlePick=function(e){var t=this,n=this.props.path||"",o=this.props,r=o.imgKey,i=o.level,a=o.fileToKey,s=o.track,c=o.identityId,l=e.file,p=(e.name,e.size,e.type),h=r||n+d.calcKey(e,a);if(!u.default||"function"!=typeof u.default.put)throw new Error("No Storage module found, please ensure @aws-amplify/storage is imported");u.default.put(h,l,{level:i||"public",contentType:p,track:s}).then((function(e){f.debug("handle pick data",e),t.getImageSource(h,i,s,c)})).catch((function(e){return f.debug("handle pick error",e)}))},t.prototype.handleClick=function(e){var t=this.props.onClick;t&&t(e)},t.prototype.componentDidMount=function(){this._isMounted=!0,this.load()},t.prototype.componentWillUnmount=function(){this._isMounted=!1},t.prototype.componentDidUpdate=function(e){(e.path!==this.props.path||e.imgKey!==this.props.imgKey||e.body!==this.props.body||e.level!==this.props.level)&&this.load()},t.prototype.imageEl=function(e,t){if(!e)return null;var n=this.props.selected;return i.createElement("div",{style:{position:"relative"},onClick:this.handleClick},i.createElement("img",{style:t.photoImg,src:e,onLoad:this.handleOnLoad,onError:this.handleOnError}),i.createElement("div",{style:n?t.overlaySelected:t.overlay}))},t.prototype.render=function(){var e=this.props,t=e.hidden,n=e.style,o=e.picker,r=e.translate,a=e.imgKey,s=this.state.src;if(r&&(s="string"==typeof r?r:r({type:"image",key:a,content:s})),!s&&!o)return null;var u=this.props.theme||c.default,l=t?c.default.hidden:Object.assign({},u.photo,n);return i.createElement("div",{style:l},l?this.imageEl(s,u):null,o?i.createElement("div",null,i.createElement(p.default,{key:"picker",onPick:this.handlePick,theme:u})):null)},t}(a.Component);t.default=h},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),a=n(0),s=n(1),u=n(11),c=n(4),l=n(2),p={maxWidth:"100%"},d=(new s.ConsoleLogger("PhotoPicker"),function(e){function t(t){var n=e.call(this,t)||this;return n.handlePick=n.handlePick.bind(n),n.state={previewSrc:t.previewSrc},n}return r(t,e),t.prototype.handlePick=function(e){var t=this,n=e.file,o=(e.name,e.size,e.type,this.props),r=o.preview,i=o.onPick,a=o.onLoad;if(i&&i(e),r){var s=new FileReader;s.onload=function(e){var n=e.target.result;t.setState({previewSrc:n}),a&&a(n)},s.readAsDataURL(n)}},t.prototype.render=function(){var e=this.props.preview,t=this.state.previewSrc,n=this.props.headerText||"Photos",o=this.props.headerHint||"Add your photos by clicking below",r=this.props.title||"Select a Photo",a=this.props.theme||c.default,d=Object.assign({},p,a.pickerPreview),f=!(e&&"hidden"!==e);return i.createElement(l.FormSection,{theme:a},i.createElement(l.SectionHeader,{theme:a,hint:o},s.I18n.get(n)),i.createElement(l.SectionBody,{theme:a},t?f?"The image has been selected":i.createElement("img",{src:t,style:d}):i.createElement(l.PhotoPlaceholder,{theme:a})),i.createElement(u.default,{title:r,accept:"image/*",theme:a,onPick:this.handlePick}))},t}(a.Component));t.default=d},function(e,t,n){"use strict";function o(e){return(o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.calcKey=function(e,t){var n=e.name,r=e.size,i=e.type,a=encodeURI(n);if(t){var s=o(t);(a="string"===s?t:"function"===s?t({name:n,size:r,type:i}):encodeURI(JSON.stringify(t)))||(a="empty_key")}return a.replace(/\s/g,"_")}},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),a=n(0),s=n(1),u=n(17),c=n(8),l=n(46),p=n(44),d=new s.ConsoleLogger("Storage.S3Text"),f=function(e){function t(t){var n=e.call(this,t)||this;n._isMounted=!1,n.handleOnLoad=n.handleOnLoad.bind(n),n.handleOnError=n.handleOnError.bind(n),n.handlePick=n.handlePick.bind(n),n.handleClick=n.handleClick.bind(n);var o=t.text,r=t.textKey;return n.state={text:o||"",textKey:r||""},n}return r(t,e),t.prototype.getText=function(e,t,n,o){var r=this;if(!u.default||"function"!=typeof u.default.get)throw new Error("No Storage module found, please ensure @aws-amplify/storage is imported");u.default.get(e,{download:!0,level:t||"public",track:n,identityId:o}).then((function(e){d.debug(e);var t=e.Body.toString("utf8");r._isMounted&&r.setState({text:t}),r.handleOnLoad(t)})).catch((function(e){d.debug(e),r.handleOnError(e)}))},t.prototype.load=function(){var e=this.props,t=e.path,n=e.textKey,o=e.body,r=e.contentType,i=e.level,a=e.track,s=e.identityId;if(n||t){var c=this,l=n||t;if(d.debug("loading "+l+"..."),o){var p=r||"text/*";if(!u.default||"function"!=typeof u.default.put)throw new Error("No Storage module found, please ensure @aws-amplify/storage is imported");u.default.put(l,o,{contentType:p,level:i||"public",track:a}).then((function(e){d.debug(e),c.getText(l,i,a,s)})).catch((function(e){return d.debug(e)}))}else c.getText(l,i,a,s)}else d.debug("empty textKey and path")},t.prototype.handleOnLoad=function(e){var t=this.props.onLoad;t&&t(e)},t.prototype.handleOnError=function(e){var t=this.props.onError;t&&t(e)},t.prototype.handlePick=function(e){var t=this,n=this.props.path||"",o=this.props,r=o.textKey,i=o.level,a=o.fileToKey,s=o.track,c=o.identityId,l=e.file,f=(e.name,e.size,e.type),h=r||n+p.calcKey(e,a);if(!u.default||"function"!=typeof u.default.put)throw new Error("No Storage module found, please ensure @aws-amplify/storage is imported");u.default.put(h,l,{level:i||"public",contentType:f,track:s}).then((function(e){d.debug("handle pick data",e),t.getText(h,i,s,c)})).catch((function(e){return d.debug("handle pick error",e)}))},t.prototype.handleClick=function(e){var t=this.props.onClick;t&&t(e)},t.prototype.componentDidMount=function(){this._isMounted=!0,this.load()},t.prototype.componentWillUnmount=function(){this._isMounted=!1},t.prototype.componentDidUpdate=function(e){(e.path!==this.props.path||e.textKey!==this.props.textKey||e.body!==this.props.body)&&this.load()},t.prototype.textEl=function(e,t){if(!e)return null;var n=this.props.selected;return i.createElement("div",{style:{position:"relative"},onClick:this.handleClick},i.createElement("pre",{style:t.pre},e),i.createElement("div",{style:n?t.overlaySelected:t.overlay}))},t.prototype.render=function(){var e=this.props,t=e.hidden,n=e.style,o=e.picker,r=e.translate,a=e.textKey,s=this.state.text;if(r&&(s="string"==typeof r?r:r({type:"text",key:a,content:s})),!s&&!o)return null;var u=this.props.theme||c.default,p=t?c.default.hidden:Object.assign({},u.text,n);return i.createElement("div",{style:p},p?this.textEl(s,u):null,o?i.createElement("div",null,i.createElement(l.default,{key:"picker",onPick:this.handlePick,theme:u})):null)},t}(a.Component);t.default=f},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),a=n(0),s=n(1),u=n(8),c=n(11),l={},p={maxWidth:"100%"},d=(new s.ConsoleLogger("TextPicker"),function(e){function t(t){var n=e.call(this,t)||this;return n.handlePick=n.handlePick.bind(n),n.state={previewText:t.previewText},n}return r(t,e),t.prototype.handlePick=function(e){var t=this,n=e.file,o=(e.name,e.size,e.type,this.props),r=o.preview,i=o.onPick,a=o.onLoad;if(i&&i(e),r){var s=new FileReader;s.onload=function(e){var n=e.target.result;t.setState({previewText:n}),a&&a(n)},s.readAsText(n)}},t.prototype.render=function(){var e=this.props.preview,t=this.state.previewText,n=this.props.title||"Pick a File",o=this.props.theme||u.default,r=Object.assign({},l,o.picker),a=Object.assign({},p,o.pickerPreview,o.halfHeight,e&&"hidden"!==e?{}:u.default.hidden);return i.createElement("div",{style:r},t?i.createElement("div",{style:a},i.createElement("pre",{style:o.pre},t)):null,i.createElement(c.default,{title:n,accept:"text/*",theme:o,onPick:this.handlePick}))},t}(a.Component));t.default=d},function(e,t){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){"use strict";function o(e){for(var n in e)t.hasOwnProperty(n)||(t[n]=e[n])}Object.defineProperty(t,"__esModule",{value:!0});var r=n(1),i=n(49);o(n(10)),o(n(50)),o(n(62)),o(n(65)),o(n(67)),o(n(69)),o(n(73)),o(n(77));var a=n(8);t.AmplifyTheme=a.default;var s=n(40);t.AmplifyMessageMapEntries=s.MapEntries;var u=n(10);t.transparent1X1=u.transparent1X1,t.white1X1=u.white1X1,r.I18n.putVocabularies(i.default)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});t.default={de:{"Sign In":"Anmelden","Sign Up":"Registrieren","Sign Out":"Abmelden","Sign in to your account":"Melden Sie sich mit Ihrem Account an",Username:"Benutzername",Password:"Passwort","Enter your username":"Geben Sie Ihren Benutzernamen ein","Enter your password":"Geben Sie Ihr Passwort ein","No account? ":"Kein Account? ","Forget your password? ":"Passwort vergessen? ","Reset password":"Passwort zurücksetzen","User does not exist":"Dieser Benutzer existiert nicht","User already exists":"Dieser Benutzer existiert bereits","Incorrect username or password":"Falscher Benutzername oder falsches Passwort","Invalid password format":"Ungültiges Passwort-Format","Create account":"Hier registrieren","Forgot Password":"Passwort vergessen","Change Password":"Passwort ändern","New Password":"Neues Passwort",Email:"Email","Phone Number":"Telefonnummer","Confirm a Code":"Code bestätigen","Confirm Sign In":"Anmeldung bestätigen","Confirm Sign Up":"Registrierung bestätigen","Back to Sign In":"Zurück zur Anmeldung","Send Code":"Code senden",Confirm:"Bestätigen","Resend Code":"Code erneut senden",Submit:"Abschicken",Skip:"Überspringen",Verify:"Verifizieren","Verify Contact":"Kontakt verifizieren",Code:"Code","Confirmation Code":"Bestätigungs-Code","Lost your code? ":"Code verloren? ","Account recovery requires verified contact information":"Zurücksetzen des Account benötigt einen verifizierten Account","Invalid phone number format":"Ungültiges Telefonummern-Format.\n            Benutze eine Nummer im Format: +12345678900","Create Account":"Account erstellen","Have an account? ":"Schon registriert? ","Sign in":"Anmelden","Create a new account":"Erstelle einen neuen Account","Reset your password":"Zurücksetzen des Passworts","An account with the given email already exists.":"Ein Account mit dieser Email existiert bereits.","Username cannot be empty":"Benutzername darf nicht leer sein","Password attempts exceeded":"Die maximale Anzahl der fehlerhaften Anmeldeversuche wurde erreicht"},fr:{"Sign In":"Se connecter","Sign Up":"S'inscrire","Sign Out":"Déconnexion","Forgot Password":"Mot de passe oublié",Username:"Nom d'utilisateur",Password:"Mot de passe","Change Password":"Changer le mot de passe","New Password":"nouveau mot de passe",Email:"Email","Phone Number":"Numéro de téléphone","Confirm a Code":"Confirmer un code","Confirm Sign In":"Confirmer la connexion","Confirm Sign Up":"Confirmer l'inscription","Back to Sign In":"Retour à la connexion","Send Code":"Envoyer le code",Confirm:"Confirmer","Resend a Code":"Renvoyer un code",Submit:"Soumettre",Skip:"Sauter",Verify:"Vérifier","Verify Contact":"Vérifier le contact",Code:"Code","Account recovery requires verified contact information":"La récupération du compte nécessite des informations de contact vérifiées","User does not exist":"L'utilisateur n'existe pas","User already exists":"L'utilisateur existe déjà","Incorrect username or password":"identifiant ou mot de passe incorrect","Invalid password format":"format de mot de passe invalide","Invalid phone number format":"Format de numéro de téléphone invalide.\nVeuillez utiliser un format de numéro de téléphone du +12345678900","Sign in to your account":"Connectez-vous à votre compte","Forget your password? ":"Mot de passe oublié ? ","Reset password":"Réinitialisez votre mot de passe","No account? ":"Pas de compte ? ","Create account":"Créer un compte","Create Account":"Créer un compte","Have an account? ":"Déjà un compte ? ","Sign in":"Se connecter","Create a new account":"Créer un nouveau compte","Reset your password":"Réinitialisez votre mot de passe","Enter your username":"Saisissez votre nom d'utilisateur","Enter your password":"Saisissez votre mot de passe","An account with the given email already exists.":"Un utilisateur avec cette adresse email existe déjà.","Username cannot be empty":"Le nom d'utilisateur doit être renseigné"},es:{"Sign In":"Registrarse","Sign Up":"Regístrate","Sign Out":"Desconectar","Forgot Password":"Se te olvidó tu contraseña",Username:"Nombre de usuario",Password:"Contraseña","Change Password":"Cambia la contraseña","New Password":"Nueva contraseña",Email:"Email","Phone Number":"Número de teléfono","Confirm a Code":"Confirmar un código","Confirm Sign In":"Confirmar inicio de sesión","Confirm Sign Up":"Confirmar Registrarse","Back to Sign In":"Volver a Iniciar sesión","Send Code":"Enviar código",Confirm:"Confirmar","Resend a Code":"Reenviar un código",Submit:"Enviar",Skip:"Omitir",Verify:"Verificar","Verify Contact":"Verificar contacto",Code:"Código","Account recovery requires verified contact information":"La recuperación de la cuenta requiere información de contacto verificada","User does not exist":"el usuario no existe","User already exists":"El usuario ya existe","Incorrect username or password":"Nombre de usuario o contraseña incorrecta","Invalid password format":"Formato de contraseña inválido","Invalid phone number format":"Formato de número de teléfono inválido.\nUtilice el formato de número de teléfono +12345678900"},it:{"Account recovery requires verified contact information":"Ripristino del conto richiede un account verificati","An account with the given email already exists.":"Un account con questa email esiste già.","Back to Sign In":"Torna alla Accesso","Change Password":"Cambia la password",Code:"Codice",Confirm:"Conferma","Confirm Sign In":"Conferma di applicazione","Confirm Sign Up":"Registrazione Conferma","Confirm a Code":"Codice Conferma","Confirmation Code":"Codice di verifica","Create Account":"Crea account","Create a new account":"Creare un nuovo account","Create account":"Registrati",Email:"E-mail","Enter your password":"Inserire la password","Enter your username":"Inserisci il tuo nome utente","Forget your password?":"Password dimenticata?","Forgot Password":"Password dimenticata","Have an account? ":"Già registrato?","Incorrect username or password":"Nome utente o password errati","Invalid password format":"Formato della password non valido","Invalid phone number format":"Utilizzo non valido Telefonummern formattare un numero nel formato :. 12.345.678,9 mille","Lost your code?":"Perso codice?","New Password":"Nuova password","No account? ":"Nessun account?",Password:"Password","Password attempts exceeded":"Il numero massimo di tentativi di accesso falliti è stato raggiunto","Phone Number":"Numero di telefono","Resend Code":"Codice Rispedisci","Reset password":"Ripristina password","Reset your password":"Resetta password","Send Code":"Invia codice","Sign In":"Accesso","Sign Out":"Esci","Sign Up":"Iscriviti","Sign in":"Accesso","Sign in to your account":"Accedi con il tuo account a",Skip:"Salta",Submit:"Sottoscrivi","User already exists":"Questo utente esiste già","User does not exist":"Questo utente non esiste",Username:"Nome utente","Username cannot be empty":"Nome utente non può essere vuoto",Verify:"Verifica","Verify Contact":"Contatto verifica"},zh:{"Sign In":"登录","Sign Up":"注册","Sign Out":"退出","Forgot Password":"忘记密码",Username:"用户名",Password:"密码","Change Password":"改变密码","New Password":"新密码",Email:"邮箱","Phone Number":"电话","Confirm a Code":"确认码","Confirm Sign In":"确认登录","Confirm Sign Up":"确认注册","Back to Sign In":"回到登录","Send Code":"发送确认码",Confirm:"确认","Resend a Code":"重发确认码",Submit:"提交",Skip:"跳过",Verify:"验证","Verify Contact":"验证联系方式",Code:"确认码","Account recovery requires verified contact information":"账户恢复需要验证过的联系方式","User does not exist":"用户不存在","User already exists":"用户已经存在","Incorrect username or password":"用户名或密码错误","Invalid password format":"密码格式错误","Invalid phone number format":"电话格式错误，请使用格式 +12345678900"}}},function(e,t,n){"use strict";function o(e){return(o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var r,i=this&&this.__extends||(r=function(e,t){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}r(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),a=this&&this.__assign||function(){return(a=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0});var s=n(0),u=n(18),c=n(18);t.Authenticator=c.default;var l=n(6);t.AuthPiece=l.default;var p=n(28);t.SignIn=p.default;var d=n(30);t.ConfirmSignIn=d.default;var f=n(22);t.SignOut=f.default;var h=n(31);t.RequireNewPassword=h.default;var m=n(14);t.SignUp=m.default;var g=n(33);t.ConfirmSignUp=g.default;var y=n(34);t.VerifyContact=y.default;var v=n(15);t.ForgotPassword=v.default;var b=n(19);t.Greetings=b.default;var S=n(29);t.FederatedSignIn=S.default,t.FederatedButtons=S.FederatedButtons;var C=n(35);t.TOTPSetup=C.default;var w=n(32);t.Loading=w.default,function(e){for(var n in e)t.hasOwnProperty(n)||(t[n]=e[n])}(n(13)),t.withAuthenticator=function(e,t,n,r,c,l){return void 0===t&&(t=!1),void 0===n&&(n=[]),void 0===r&&(r=null),void 0===c&&(c=null),void 0===l&&(l={}),function(p){function d(e){var i=p.call(this,e)||this;return i.handleAuthStateChange=i.handleAuthStateChange.bind(i),i.state={authState:e.authState||null,authData:e.authData||null},i.authConfig={},"object"===o(t)&&null!==t?i.authConfig=Object.assign(i.authConfig,t):i.authConfig={includeGreetings:t,authenticatorComponents:n,federated:r,theme:c,signUpConfig:l},i}return i(d,p),d.prototype.handleAuthStateChange=function(e,t){this.setState({authState:e,authData:t})},d.prototype.render=function(){var t=this.state,n=t.authState,o=t.authData;return"signedIn"===n?s.createElement(s.Fragment,null,this.authConfig.includeGreetings?s.createElement(u.default,a({},this.props,{theme:this.authConfig.theme,federated:this.authConfig.federated||this.props.federated,hideDefault:this.authConfig.authenticatorComponents&&this.authConfig.authenticatorComponents.length>0,signUpConfig:this.authConfig.signUpConfig,usernameAttributes:this.authConfig.usernameAttributes,onStateChange:this.handleAuthStateChange,children:this.authConfig.authenticatorComponents||[]})):null,s.createElement(e,a({},this.props,{authState:n,authData:o,onStateChange:this.handleAuthStateChange}))):s.createElement(u.default,a({},this.props,{theme:this.authConfig.theme,federated:this.authConfig.federated||this.props.federated,hideDefault:this.authConfig.authenticatorComponents&&this.authConfig.authenticatorComponents.length>0,signUpConfig:this.authConfig.signUpConfig,usernameAttributes:this.authConfig.usernameAttributes,onStateChange:this.handleAuthStateChange,children:this.authConfig.authenticatorComponents||[]}))},d}(s.Component)};var E=function(e){function t(t){var n=e.call(this,t)||this;return n.state={auth:"init"},n.handleAuthState=n.handleAuthState.bind(n),n.renderChildren=n.renderChildren.bind(n),n}return i(t,e),t.prototype.handleAuthState=function(e,t){this.setState({auth:e,authData:t})},t.prototype.renderChildren=function(){return this.props.children(this.state.auth)},t.prototype.render=function(){return s.createElement("div",null,s.createElement(u.default,a({},this.props,{onStateChange:this.handleAuthState})),this.renderChildren())},t}(s.Component);t.AuthenticatorWrapper=E},function(e,t){e.exports=a},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=[{label:"Username",key:"username",required:!0,placeholder:"Username",displayOrder:1},{label:"Password",key:"password",required:!0,placeholder:"Password",type:"password",displayOrder:2},{label:"Email",key:"email",required:!0,placeholder:"Email",type:"email",displayOrder:3},{label:"Phone Number",key:"phone_number",placeholder:"Phone Number",required:!0,displayOrder:4}],t.signUpWithEmailFields=[{label:"Email",key:"email",required:!0,placeholder:"Email",type:"email",displayOrder:1},{label:"Password",key:"password",required:!0,placeholder:"Password",type:"password",displayOrder:2},{label:"Phone Number",key:"phone_number",placeholder:"Phone Number",required:!0,displayOrder:3}],t.signUpWithPhoneNumberFields=[{label:"Phone Number",key:"phone_number",placeholder:"Phone Number",required:!0,displayOrder:1},{label:"Password",key:"password",required:!0,placeholder:"Password",type:"password",displayOrder:2},{label:"Email",key:"email",required:!0,placeholder:"Email",type:"email",displayOrder:3}]},function(e,t,n){"use strict";function o(e){return(o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function r(){return(r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e}).apply(this,arguments)}function i(e,t){if(null==e)return{};var n,o,r={},i=Object.keys(e);for(o=0;o<i.length;o++)n=i[o],t.indexOf(n)>=0||(r[n]=e[n]);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);for(o=0;o<a.length;o++)n=a[o],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(r[n]=e[n])}return r}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}function u(e,t,n){return t&&s(e.prototype,t),n&&s(e,n),e}function c(e,t){if(t&&("object"===o(t)||"function"==typeof t))return t;if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function l(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function p(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var d=n(0),f=n(54),h=n(57),m=n(37);function g(e){for(var t="",n=0;n<e.length;n++){var o=e.charCodeAt(n);o<128?t+=String.fromCharCode(o):o<2048?(t+=String.fromCharCode(192|o>>6),t+=String.fromCharCode(128|63&o)):o<55296||o>=57344?(t+=String.fromCharCode(224|o>>12),t+=String.fromCharCode(128|o>>6&63),t+=String.fromCharCode(128|63&o)):(n++,o=65536+((1023&o)<<10|1023&e.charCodeAt(n)),t+=String.fromCharCode(240|o>>18),t+=String.fromCharCode(128|o>>12&63),t+=String.fromCharCode(128|o>>6&63),t+=String.fromCharCode(128|63&o))}return t}var y={size:128,level:"L",bgColor:"#FFFFFF",fgColor:"#000000"},v={value:f.string.isRequired,size:f.number,level:f.oneOf(["L","M","Q","H"]),bgColor:f.string,fgColor:f.string},b=function(e){function t(){var e,n,o;a(this,t);for(var r=arguments.length,i=new Array(r),s=0;s<r;s++)i[s]=arguments[s];return c(o,(n=o=c(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(i))),Object.defineProperty(p(o),"_canvas",{configurable:!0,enumerable:!0,writable:!0,value:void 0}),n))}return l(t,e),u(t,[{key:"shouldComponentUpdate",value:function(e){var n=this;return Object.keys(t.propTypes).some((function(t){return n.props[t]!==e[t]}))}},{key:"componentDidMount",value:function(){this.update()}},{key:"componentDidUpdate",value:function(){this.update()}},{key:"update",value:function(){var e=this.props,t=e.value,n=e.size,o=e.level,r=e.bgColor,i=e.fgColor,a=new h(-1,m[o]);if(a.addData(g(t)),a.make(),null!=this._canvas){var s=this._canvas,u=s.getContext("2d");if(!u)return;var c=a.modules;if(null===c)return;var l=n/c.length,p=n/c.length,d=(window.devicePixelRatio||1)/function(e){return e.webkitBackingStorePixelRatio||e.mozBackingStorePixelRatio||e.msBackingStorePixelRatio||e.oBackingStorePixelRatio||e.backingStorePixelRatio||1}(u);s.height=s.width=n*d,u.scale(d,d),c.forEach((function(e,t){e.forEach((function(e,n){u&&(u.fillStyle=e?i:r);var o=Math.ceil((n+1)*l)-Math.floor(n*l),a=Math.ceil((t+1)*p)-Math.floor(t*p);u&&u.fillRect(Math.round(n*l),Math.round(t*p),o,a)}))}))}}},{key:"render",value:function(){var e=this,t=this.props,n=(t.value,t.size),o=(t.level,t.bgColor,t.fgColor,t.style),a=i(t,["value","size","level","bgColor","fgColor","style"]),s=r({height:n,width:n},o);return d.createElement("canvas",r({style:s,height:n,width:n,ref:function(t){return e._canvas=t}},a))}}]),t}(d.Component);Object.defineProperty(b,"defaultProps",{configurable:!0,enumerable:!0,writable:!0,value:y}),Object.defineProperty(b,"propTypes",{configurable:!0,enumerable:!0,writable:!0,value:v});var S=function(e){function t(){return a(this,t),c(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return l(t,e),u(t,[{key:"shouldComponentUpdate",value:function(e){var t=this;return Object.keys(b.propTypes).some((function(n){return t.props[n]!==e[n]}))}},{key:"render",value:function(){var e=this.props,t=e.value,n=e.size,o=e.level,a=e.bgColor,s=e.fgColor,u=i(e,["value","size","level","bgColor","fgColor"]),c=new h(-1,m[o]);c.addData(g(t)),c.make();var l=c.modules;if(null!==l){var p=[];return l.forEach((function(e,t){var n=null;e.forEach((function(o,r){if(!o&&null!==n)return p.push("M".concat(n," ").concat(t,"h").concat(r-n,"v1H").concat(n,"z")),void(n=null);if(r!==e.length-1)o&&null===n&&(n=r);else{if(!o)return;null===n?p.push("M".concat(r,",").concat(t," h1v1H").concat(r,"z")):p.push("M".concat(n,",").concat(t," h").concat(r+1-n,"v1H").concat(n,"z"))}}))})),d.createElement("svg",r({shapeRendering:"crispEdges",height:n,width:n,viewBox:"0 0 ".concat(l.length," ").concat(l.length)},u),d.createElement("path",{fill:a,d:"M0,0 h".concat(l.length,"v").concat(l.length,"H0z")}),d.createElement("path",{fill:s,d:p.join("")}))}}}]),t}(d.Component);Object.defineProperty(S,"defaultProps",{configurable:!0,enumerable:!0,writable:!0,value:y}),Object.defineProperty(S,"propTypes",{configurable:!0,enumerable:!0,writable:!0,value:v});var C=function(e){var t=e.renderAs,n=i(e,["renderAs"]),o="svg"===t?S:b;return d.createElement(o,n)};C.defaultProps=r({renderAs:"canvas"},y),e.exports=C},function(e,t,n){e.exports=n(55)()},function(e,t,n){"use strict";var o=n(56);function r(){}function i(){}i.resetWarningCache=r,e.exports=function(){function e(e,t,n,r,i,a){if(a!==o){var s=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw s.name="Invariant Violation",s}}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:i,resetWarningCache:r};return n.PropTypes=n,n}},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){var o=n(58),r=n(59),i=n(60),a=n(61),s=n(38);function u(e,t){this.typeNumber=e,this.errorCorrectLevel=t,this.modules=null,this.moduleCount=0,this.dataCache=null,this.dataList=[]}var c=u.prototype;c.addData=function(e){var t=new o(e);this.dataList.push(t),this.dataCache=null},c.isDark=function(e,t){if(e<0||this.moduleCount<=e||t<0||this.moduleCount<=t)throw new Error(e+","+t);return this.modules[e][t]},c.getModuleCount=function(){return this.moduleCount},c.make=function(){if(this.typeNumber<1){var e=1;for(e=1;e<40;e++){for(var t=r.getRSBlocks(e,this.errorCorrectLevel),n=new i,o=0,s=0;s<t.length;s++)o+=t[s].dataCount;for(s=0;s<this.dataList.length;s++){var u=this.dataList[s];n.put(u.mode,4),n.put(u.getLength(),a.getLengthInBits(u.mode,e)),u.write(n)}if(n.getLengthInBits()<=8*o)break}this.typeNumber=e}this.makeImpl(!1,this.getBestMaskPattern())},c.makeImpl=function(e,t){this.moduleCount=4*this.typeNumber+17,this.modules=new Array(this.moduleCount);for(var n=0;n<this.moduleCount;n++){this.modules[n]=new Array(this.moduleCount);for(var o=0;o<this.moduleCount;o++)this.modules[n][o]=null}this.setupPositionProbePattern(0,0),this.setupPositionProbePattern(this.moduleCount-7,0),this.setupPositionProbePattern(0,this.moduleCount-7),this.setupPositionAdjustPattern(),this.setupTimingPattern(),this.setupTypeInfo(e,t),this.typeNumber>=7&&this.setupTypeNumber(e),null==this.dataCache&&(this.dataCache=u.createData(this.typeNumber,this.errorCorrectLevel,this.dataList)),this.mapData(this.dataCache,t)},c.setupPositionProbePattern=function(e,t){for(var n=-1;n<=7;n++)if(!(e+n<=-1||this.moduleCount<=e+n))for(var o=-1;o<=7;o++)t+o<=-1||this.moduleCount<=t+o||(this.modules[e+n][t+o]=0<=n&&n<=6&&(0==o||6==o)||0<=o&&o<=6&&(0==n||6==n)||2<=n&&n<=4&&2<=o&&o<=4)},c.getBestMaskPattern=function(){for(var e=0,t=0,n=0;n<8;n++){this.makeImpl(!0,n);var o=a.getLostPoint(this);(0==n||e>o)&&(e=o,t=n)}return t},c.createMovieClip=function(e,t,n){var o=e.createEmptyMovieClip(t,n);this.make();for(var r=0;r<this.modules.length;r++)for(var i=1*r,a=0;a<this.modules[r].length;a++){var s=1*a;this.modules[r][a]&&(o.beginFill(0,100),o.moveTo(s,i),o.lineTo(s+1,i),o.lineTo(s+1,i+1),o.lineTo(s,i+1),o.endFill())}return o},c.setupTimingPattern=function(){for(var e=8;e<this.moduleCount-8;e++)null==this.modules[e][6]&&(this.modules[e][6]=e%2==0);for(var t=8;t<this.moduleCount-8;t++)null==this.modules[6][t]&&(this.modules[6][t]=t%2==0)},c.setupPositionAdjustPattern=function(){for(var e=a.getPatternPosition(this.typeNumber),t=0;t<e.length;t++)for(var n=0;n<e.length;n++){var o=e[t],r=e[n];if(null==this.modules[o][r])for(var i=-2;i<=2;i++)for(var s=-2;s<=2;s++)this.modules[o+i][r+s]=-2==i||2==i||-2==s||2==s||0==i&&0==s}},c.setupTypeNumber=function(e){for(var t=a.getBCHTypeNumber(this.typeNumber),n=0;n<18;n++){var o=!e&&1==(t>>n&1);this.modules[Math.floor(n/3)][n%3+this.moduleCount-8-3]=o}for(n=0;n<18;n++){o=!e&&1==(t>>n&1);this.modules[n%3+this.moduleCount-8-3][Math.floor(n/3)]=o}},c.setupTypeInfo=function(e,t){for(var n=this.errorCorrectLevel<<3|t,o=a.getBCHTypeInfo(n),r=0;r<15;r++){var i=!e&&1==(o>>r&1);r<6?this.modules[r][8]=i:r<8?this.modules[r+1][8]=i:this.modules[this.moduleCount-15+r][8]=i}for(r=0;r<15;r++){i=!e&&1==(o>>r&1);r<8?this.modules[8][this.moduleCount-r-1]=i:r<9?this.modules[8][15-r-1+1]=i:this.modules[8][15-r-1]=i}this.modules[this.moduleCount-8][8]=!e},c.mapData=function(e,t){for(var n=-1,o=this.moduleCount-1,r=7,i=0,s=this.moduleCount-1;s>0;s-=2)for(6==s&&s--;;){for(var u=0;u<2;u++)if(null==this.modules[o][s-u]){var c=!1;i<e.length&&(c=1==(e[i]>>>r&1)),a.getMask(t,o,s-u)&&(c=!c),this.modules[o][s-u]=c,-1==--r&&(i++,r=7)}if((o+=n)<0||this.moduleCount<=o){o-=n,n=-n;break}}},u.PAD0=236,u.PAD1=17,u.createData=function(e,t,n){for(var o=r.getRSBlocks(e,t),s=new i,c=0;c<n.length;c++){var l=n[c];s.put(l.mode,4),s.put(l.getLength(),a.getLengthInBits(l.mode,e)),l.write(s)}var p=0;for(c=0;c<o.length;c++)p+=o[c].dataCount;if(s.getLengthInBits()>8*p)throw new Error("code length overflow. ("+s.getLengthInBits()+">"+8*p+")");for(s.getLengthInBits()+4<=8*p&&s.put(0,4);s.getLengthInBits()%8!=0;)s.putBit(!1);for(;!(s.getLengthInBits()>=8*p||(s.put(u.PAD0,8),s.getLengthInBits()>=8*p));)s.put(u.PAD1,8);return u.createBytes(s,o)},u.createBytes=function(e,t){for(var n=0,o=0,r=0,i=new Array(t.length),u=new Array(t.length),c=0;c<t.length;c++){var l=t[c].dataCount,p=t[c].totalCount-l;o=Math.max(o,l),r=Math.max(r,p),i[c]=new Array(l);for(var d=0;d<i[c].length;d++)i[c][d]=255&e.buffer[d+n];n+=l;var f=a.getErrorCorrectPolynomial(p),h=new s(i[c],f.getLength()-1).mod(f);u[c]=new Array(f.getLength()-1);for(d=0;d<u[c].length;d++){var m=d+h.getLength()-u[c].length;u[c][d]=m>=0?h.get(m):0}}var g=0;for(d=0;d<t.length;d++)g+=t[d].totalCount;var y=new Array(g),v=0;for(d=0;d<o;d++)for(c=0;c<t.length;c++)d<i[c].length&&(y[v++]=i[c][d]);for(d=0;d<r;d++)for(c=0;c<t.length;c++)d<u[c].length&&(y[v++]=u[c][d]);return y},e.exports=u},function(e,t,n){var o=n(36);function r(e){this.mode=o.MODE_8BIT_BYTE,this.data=e}r.prototype={getLength:function(e){return this.data.length},write:function(e){for(var t=0;t<this.data.length;t++)e.put(this.data.charCodeAt(t),8)}},e.exports=r},function(e,t,n){var o=n(37);function r(e,t){this.totalCount=e,this.dataCount=t}r.RS_BLOCK_TABLE=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]],r.getRSBlocks=function(e,t){var n=r.getRsBlockTable(e,t);if(null==n)throw new Error("bad rs block @ typeNumber:"+e+"/errorCorrectLevel:"+t);for(var o=n.length/3,i=new Array,a=0;a<o;a++)for(var s=n[3*a+0],u=n[3*a+1],c=n[3*a+2],l=0;l<s;l++)i.push(new r(u,c));return i},r.getRsBlockTable=function(e,t){switch(t){case o.L:return r.RS_BLOCK_TABLE[4*(e-1)+0];case o.M:return r.RS_BLOCK_TABLE[4*(e-1)+1];case o.Q:return r.RS_BLOCK_TABLE[4*(e-1)+2];case o.H:return r.RS_BLOCK_TABLE[4*(e-1)+3];default:return}},e.exports=r},function(e,t){function n(){this.buffer=new Array,this.length=0}n.prototype={get:function(e){var t=Math.floor(e/8);return 1==(this.buffer[t]>>>7-e%8&1)},put:function(e,t){for(var n=0;n<t;n++)this.putBit(1==(e>>>t-n-1&1))},getLengthInBits:function(){return this.length},putBit:function(e){var t=Math.floor(this.length/8);this.buffer.length<=t&&this.buffer.push(0),e&&(this.buffer[t]|=128>>>this.length%8),this.length++}},e.exports=n},function(e,t,n){var o=n(36),r=n(38),i=n(39),a=0,s=1,u=2,c=3,l=4,p=5,d=6,f=7,h={PATTERN_POSITION_TABLE:[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],G15:1335,G18:7973,G15_MASK:21522,getBCHTypeInfo:function(e){for(var t=e<<10;h.getBCHDigit(t)-h.getBCHDigit(h.G15)>=0;)t^=h.G15<<h.getBCHDigit(t)-h.getBCHDigit(h.G15);return(e<<10|t)^h.G15_MASK},getBCHTypeNumber:function(e){for(var t=e<<12;h.getBCHDigit(t)-h.getBCHDigit(h.G18)>=0;)t^=h.G18<<h.getBCHDigit(t)-h.getBCHDigit(h.G18);return e<<12|t},getBCHDigit:function(e){for(var t=0;0!=e;)t++,e>>>=1;return t},getPatternPosition:function(e){return h.PATTERN_POSITION_TABLE[e-1]},getMask:function(e,t,n){switch(e){case a:return(t+n)%2==0;case s:return t%2==0;case u:return n%3==0;case c:return(t+n)%3==0;case l:return(Math.floor(t/2)+Math.floor(n/3))%2==0;case p:return t*n%2+t*n%3==0;case d:return(t*n%2+t*n%3)%2==0;case f:return(t*n%3+(t+n)%2)%2==0;default:throw new Error("bad maskPattern:"+e)}},getErrorCorrectPolynomial:function(e){for(var t=new r([1],0),n=0;n<e;n++)t=t.multiply(new r([1,i.gexp(n)],0));return t},getLengthInBits:function(e,t){if(1<=t&&t<10)switch(e){case o.MODE_NUMBER:return 10;case o.MODE_ALPHA_NUM:return 9;case o.MODE_8BIT_BYTE:case o.MODE_KANJI:return 8;default:throw new Error("mode:"+e)}else if(t<27)switch(e){case o.MODE_NUMBER:return 12;case o.MODE_ALPHA_NUM:return 11;case o.MODE_8BIT_BYTE:return 16;case o.MODE_KANJI:return 10;default:throw new Error("mode:"+e)}else{if(!(t<41))throw new Error("type:"+t);switch(e){case o.MODE_NUMBER:return 14;case o.MODE_ALPHA_NUM:return 13;case o.MODE_8BIT_BYTE:return 16;case o.MODE_KANJI:return 12;default:throw new Error("mode:"+e)}}},getLostPoint:function(e){for(var t=e.getModuleCount(),n=0,o=0;o<t;o++)for(var r=0;r<t;r++){for(var i=0,a=e.isDark(o,r),s=-1;s<=1;s++)if(!(o+s<0||t<=o+s))for(var u=-1;u<=1;u++)r+u<0||t<=r+u||0==s&&0==u||a==e.isDark(o+s,r+u)&&i++;i>5&&(n+=3+i-5)}for(o=0;o<t-1;o++)for(r=0;r<t-1;r++){var c=0;e.isDark(o,r)&&c++,e.isDark(o+1,r)&&c++,e.isDark(o,r+1)&&c++,e.isDark(o+1,r+1)&&c++,0!=c&&4!=c||(n+=3)}for(o=0;o<t;o++)for(r=0;r<t-6;r++)e.isDark(o,r)&&!e.isDark(o,r+1)&&e.isDark(o,r+2)&&e.isDark(o,r+3)&&e.isDark(o,r+4)&&!e.isDark(o,r+5)&&e.isDark(o,r+6)&&(n+=40);for(r=0;r<t;r++)for(o=0;o<t-6;o++)e.isDark(o,r)&&!e.isDark(o+1,r)&&e.isDark(o+2,r)&&e.isDark(o+3,r)&&e.isDark(o+4,r)&&!e.isDark(o+5,r)&&e.isDark(o+6,r)&&(n+=40);var l=0;for(r=0;r<t;r++)for(o=0;o<t;o++)e.isDark(o,r)&&l++;return n+=10*(Math.abs(100*l/t/t-50)/5)}};e.exports=h},function(e,t,n){"use strict";function o(e){for(var n in e)t.hasOwnProperty(n)||(t[n]=e[n])}Object.defineProperty(t,"__esModule",{value:!0}),o(n(63)),o(n(64))},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),i=this&&this.__assign||function(){return(i=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),s=n(0),u=n(41),c=["componentDidMount","componentDidUpdate","compomentWillUnmount","compomentDidCatch","render"];t.trackLifecycle=function(e,t,n){return void 0===n&&(n=c),function(o){function s(e){var r=o.call(this,e)||this;return r.trackerName=t,r.trackEvents=n,r.track("constructor"),r}return r(s,o),s.prototype.track=function(e){if(this.trackEvents.filter((function(t){return t===e})).length>0){if(!u.default||"function"!=typeof u.default.record)throw new Error("No Analytics module found, please ensure @aws-amplify/analytics is imported");u.default.record({name:this.trackerName,attributes:{event:e}})}},s.prototype.componentWillMount=function(){this.track("componentWillMount")},s.prototype.componentDidMount=function(){this.track("componentDidMount")},s.prototype.componentWillUnmount=function(){this.track("componentWillUnmount")},s.prototype.componentDidCatch=function(){this.track("componentDidCatch")},s.prototype.componentWillReceiveProps=function(){this.track("componentWillReceiveProps")},s.prototype.shouldComponentUpdate=function(){return this.track("shouldComponentUpdate"),!0},s.prototype.componentWillUpdate=function(){this.track("componentWillUpdate")},s.prototype.componentDidUpdate=function(){this.track("componentDidUpdate")},s.prototype.setState=function(){this.track("setState")},s.prototype.forceUpdate=function(){this.track("forceUpdate")},s.prototype.render=function(){return this.track("render"),a.createElement(e,i({},this.props))},s}(s.Component)}},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),i=this&&this.__assign||function(){return(i=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),s=n(0),u=n(41);t.trackUpdate=function(e,t){return function(n){function o(e){var o=n.call(this,e)||this;return o.trackerName=t,o}return r(o,n),o.prototype.componentDidUpdate=function(e,t){var n=Object.assign({},this.props,this.state);if(!u.default||"function"!=typeof u.default.record)throw new Error("No Analytics module found, please ensure @aws-amplify/analytics is imported");u.default.record({name:this.trackerName,attributes:n})},o.prototype.render=function(){return a.createElement(e,i({},this.props))},o}(s.Component)}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var o=n(66);t.S3Album=o.default;var r=n(42);t.S3Image=r.default;var i=n(45);t.S3Text=i.default},function(e,t,n){"use strict";function o(e){return(o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var r,i=this&&this.__extends||(r=function(e,t){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}r(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)});Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),s=n(0),u=n(1),c=n(17),l=n(11),p=n(8),d=n(42),f=n(45),h=new u.ConsoleLogger("Storage.S3Album"),m=function(e){function t(t){var n=e.call(this,t)||this;return n._isMounted=!1,n.handlePick=n.handlePick.bind(n),n.handleClick=n.handleClick.bind(n),n.list=n.list.bind(n),n.marshal=n.marshal.bind(n),n.state={items:[],ts:(new Date).getTime()},n}return i(t,e),t.prototype.getKey=function(e){var t=this.props.fileToKey,n=e.name,r=e.size,i=e.type,a=encodeURI(n);if(t){var s=o(t);(a="string"===s?t:"function"===s?t({name:n,size:r,type:i}):encodeURI(JSON.stringify(t)))||(h.debug("key is empty"),a="empty_key")}return a.replace(/\s/g,"_")},t.prototype.handlePick=function(e){var t=this,n=this.props,o=n.onPick,r=n.onLoad,i=n.onError,a=n.track,s=n.level;o&&o(e);var u=this.props.path||"",l=e.file,p=(e.name,e.size,e.type),d=u+this.getKey(e);if(!c.default||"function"!=typeof c.default.put)throw new Error("No Storage module found, please ensure @aws-amplify/storage is imported");c.default.put(d,l,{level:s||"public",contentType:p,track:a}).then((function(e){h.debug("handle pick data",e);var n=t.state.items;if(0===n.filter((function(e){return e.key===d})).length){var o=n.concat(e);t.marshal(o)}else h.debug("update an item");r&&r(e)})).catch((function(e){h.debug("handle pick error",e),i&&i(e)})),this._isMounted&&this.setState({ts:(new Date).getTime()})},t.prototype.handleClick=function(e){var t=this.props,n=t.onClickItem,o=t.select,r=t.onSelect;(n&&n(e),o)&&(e.selected=!e.selected,this._isMounted&&this.setState({items:this.state.items.slice()}),r&&r(e,this.state.items.filter((function(e){return e.selected}))))},t.prototype.componentDidMount=function(){this._isMounted=!0,this.list()},t.prototype.componentWillUnmount=function(){this._isMounted=!1},t.prototype.componentDidUpdate=function(e,t){this.props.path===e.path&&this.props.ts===e.ts&&this.props.select===e.select||(this.props.select||this.state.items.forEach((function(e){return e.selected=!1})),this.props.onSelect&&this.props.onSelect(null,[]),this.list())},t.prototype.list=function(){var e=this,t=this.props,n=t.path,o=t.level,r=t.track,i=t.identityId;if(h.debug("Album path: "+n),!c.default||"function"!=typeof c.default.list)throw new Error("No Storage module found, please ensure @aws-amplify/storage is imported");return c.default.list(n,{level:o||"public",track:r,identityId:i}).then((function(t){h.debug("album list",t),e.marshal(t)})).catch((function(e){return h.warn(e),[]}))},t.prototype.contentType=function(e){return u.JS.filenameToContentType(e.key,"image/*")},t.prototype.marshal=function(e){var t=this,n=this.props.contentType||"";e.forEach((function(e){if(!e.contentType){var o="string"==typeof n;e.contentType=o?n:n(e),e.contentType||(e.contentType=t.contentType(e))}}));var o=this.filter(e);o=this.sort(o),this._isMounted&&this.setState({items:o})},t.prototype.filter=function(e){var t=this.props.filter;return t?t(e):e},t.prototype.sort=function(e){var t=this.props.sort,n=o(t);if("function"===n)return t(e);if(["string","undefined"].includes(n)){var r=(t||"lastModified").split(/\s+/),i=r[0],a=r.length>1?r[1]:"";return a="lastModified"===i?"asc"===a?"asc":"desc":"desc"===a?"desc":"asc",u.JS.sortByField(e,i,a),e}return h.warn("invalid sort. done nothing. should be a string or function"),e},t.prototype.render=function(){var e=this,t=this.props,n=t.picker,o=t.translateItem,r=t.level,i=t.identityId,s=this.state,c=s.items,h=s.ts,m=this.props.pickerTitle||"Pick",g=this.props.theme||p.default,y=c.map((function(t){return t.contentType&&u.JS.isTextFile(t.contentType)?a.createElement(f.default,{key:t.key,textKey:t.key,theme:g,style:g.albumText,selected:t.selected,translate:o,level:r,identityId:i,onClick:function(){return e.handleClick(t)}}):a.createElement(d.default,{key:t.key,imgKey:t.key,theme:g,style:g.albumPhoto,selected:t.selected,translate:o,level:r,identityId:i,onClick:function(){return e.handleClick(t)}})}));return a.createElement("div",null,a.createElement("div",{style:g.album},y),n?a.createElement(l.default,{key:h,title:m,accept:"image/*, text/*",onPick:this.handlePick,theme:g}):null)},t}(s.Component);t.default=m},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var o=n(11);t.Picker=o.default;var r=n(43);t.PhotoPicker=r.default;var i=n(46);t.TextPicker=i.default;var a=n(68);t.SelectMFAType=a.default;var s=n(16);t.TOTPSetupComp=s.default},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),i=this&&this.__assign||function(){return(i=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),s=n(0),u=n(1),c=n(3),l=n(4),p=n(2),d=n(16),f=new u.ConsoleLogger("SelectMFAType"),h=function(e){function t(t){var n=e.call(this,t)||this;return n.verify=n.verify.bind(n),n.handleInputChange=n.handleInputChange.bind(n),n.state={TOTPSetup:!1,selectMessage:null},n}return r(t,e),t.prototype.handleInputChange=function(e){this.setState({TOTPSetup:!1,selectMessage:null}),this.inputs={};var t=e.target,n=(t.name,t.value),o=t.type,r=t.checked,i=["radio","checkbox"].includes(o);this.inputs[n]=i?r:n},t.prototype.verify=function(){var e=this;if(f.debug("mfatypes inputs",this.inputs),this.inputs){var t=this.inputs,n=t.TOTP,o=t.SMS,r=t.NOMFA,i=null;n?i="TOTP":o?i="SMS":r&&(i="NOMFA");var a=this.props.authData;if(!c.default||"function"!=typeof c.default.setPreferredMFA)throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");c.default.setPreferredMFA(a,i).then((function(t){f.debug("set preferred mfa success",t),e.setState({selectMessage:"Success! Your MFA Type is now: "+i,showToast:!0})})).catch((function(t){var n=t.message;"User has not set up software token mfa"===n||"User has not verified software token mfa"===n?e.setState({TOTPSetup:!0,selectMessage:"You need to setup TOTP",showToast:!0}):(f.debug("set preferred mfa failed",t),e.setState({selectMessage:"Failed! You cannot select MFA Type for now!",showToast:!0}))}))}else f.debug("No mfa type selected")},t.prototype.selectView=function(e){var t=this,n=this.props.MFATypes;if(!n||Object.keys(n).length<2)return f.debug("less than 2 mfa types available"),a.createElement("div",null,a.createElement("a",null,"less than 2 mfa types available"));var o=n.SMS,r=n.TOTP,i=n.Optional;return a.createElement(p.FormSection,{theme:e},this.state.showToast&&this.state.selectMessage&&a.createElement(p.Toast,{theme:e,onClose:function(){return t.setState({showToast:!1})}},u.I18n.get(this.state.selectMessage)),a.createElement(p.SectionHeader,{theme:e},u.I18n.get("Select MFA Type")),a.createElement(p.SectionBody,{theme:e},a.createElement("div",null,o?a.createElement(p.RadioRow,{placeholder:u.I18n.get("SMS"),theme:e,key:"sms",name:"MFAType",value:"SMS",onChange:this.handleInputChange}):null,r?a.createElement(p.RadioRow,{placeholder:u.I18n.get("TOTP"),theme:e,key:"totp",name:"MFAType",value:"TOTP",onChange:this.handleInputChange}):null,i?a.createElement(p.RadioRow,{placeholder:u.I18n.get("No MFA"),theme:e,key:"noMFA",name:"MFAType",value:"NOMFA",onChange:this.handleInputChange}):null)),a.createElement(p.SectionFooter,{theme:e},a.createElement(p.Button,{theme:e,onClick:this.verify},u.I18n.get("Verify"))))},t.prototype.render=function(){var e=this.props.theme?this.props.theme:l.default;return a.createElement("div",null,this.selectView(e),this.state.TOTPSetup?a.createElement(d.default,i({},this.props)):null)},t}(s.Component);t.default=h},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),function(e){for(var n in e)t.hasOwnProperty(n)||(t[n]=e[n])}(n(70))},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var o=n(71);t.Connect=o.default},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),i=this&&this.__awaiter||function(e,t,n,o){return new(n||(n=Promise))((function(r,i){function a(e){try{u(o.next(e))}catch(e){i(e)}}function s(e){try{u(o.throw(e))}catch(e){i(e)}}function u(e){var t;e.done?r(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(a,s)}u((o=o.apply(e,t||[])).next())}))},a=this&&this.__generator||function(e,t){var n,o,r,i,a={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return i={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function s(i){return function(s){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,o&&(r=2&i[0]?o.return:i[0]?o.throw||((r=o.return)&&r.call(o),0):o.next)&&!(r=r.call(o,i[1])).done)return r;switch(o=0,r&&(i=[2&i[0],r.value]),i[0]){case 0:case 1:r=i;break;case 4:return a.label++,{value:i[1],done:!1};case 5:a.label++,o=i[1],i=[0];continue;case 7:i=a.ops.pop(),a.trys.pop();continue;default:if(!(r=(r=a.trys).length>0&&r[r.length-1])&&(6===i[0]||2===i[0])){a=0;continue}if(3===i[0]&&(!r||i[1]>r[0]&&i[1]<r[3])){a.label=i[1];break}if(6===i[0]&&a.label<r[1]){a.label=r[1],r=i;break}if(r&&a.label<r[2]){a.label=r[2],a.ops.push(i);break}r[2]&&a.ops.pop(),a.trys.pop();continue}i=t.call(e,a)}catch(e){i=[6,e],o=0}finally{n=r=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,s])}}};Object.defineProperty(t,"__esModule",{value:!0});var s=n(0),u=n(72),c=function(e){function t(t){var n=e.call(this,t)||this;return n.state=n.getInitialState(),n.subSubscription=null,n}return r(t,e),t.prototype.getInitialState=function(){var e=this.props.query;return{loading:e&&!!e.query,data:{},errors:[],mutation:function(){return console.warn("Not implemented")}}},t.prototype.getDefaultState=function(){return{loading:!1,data:{},errors:[],mutation:function(){return console.warn("Not implemented")}}},t.prototype._fetchData=function(){return i(this,void 0,void 0,(function(){var e,t,n,o,r,s,c,l,p,d,f,h,m,g,y,v,b,S,C,w,E,_,I,A,O,k=this;return a(this,(function(P){switch(P.label){case 0:if(this._unsubscribe(),this.setState({loading:!0}),e=this.props,t=e.query,o=(n=void 0===t?{}:t).query,r=n.variables,s=void 0===r?{}:r,c=e.mutation,p=(l=void 0===c?{}:c).query,d=l.mutationVariables,void 0===d?{}:d,f=e.subscription,h=e.onSubscriptionMsg,m=void 0===h?function(e){return e}:h,g=this.getDefaultState(),y=g.data,v=g.mutation,b=g.errors,!u.default||"function"!=typeof u.default.graphql||"function"!=typeof u.default.getGraphqlOperationType)throw new Error("No API module found, please ensure @aws-amplify/api is imported");if(S=o&&"query"===u.default.getGraphqlOperationType(o),C=p&&"mutation"===u.default.getGraphqlOperationType(p),w=f&&"subscription"===u.default.getGraphqlOperationType(f.query),S||C||w||console.warn("No query, mutation or subscription was specified"),!S)return[3,4];P.label=1;case 1:return P.trys.push([1,3,,4]),y=null,[4,u.default.graphql({query:o,variables:s})];case 2:return E=P.sent(),y=E.data,[3,4];case 3:return _=P.sent(),y=_.data,b=_.errors,[3,4];case 4:if(C&&(v=function(e){return i(k,void 0,void 0,(function(){var t;return a(this,(function(n){switch(n.label){case 0:return[4,u.default.graphql({query:p,variables:e})];case 1:return t=n.sent(),this.forceUpdate(),[2,t]}}))}))}),w){I=f.query,A=f.variables;try{O=u.default.graphql({query:I,variables:A}),this.subSubscription=O.subscribe({next:function(e){var t=e.value.data,n=k.state.data,o=m(n,t);k.mounted&&k.setState({data:o})},error:function(e){return console.error(e)}})}catch(e){b=e.errors}}return this.setState({data:y,errors:b,mutation:v,loading:!1}),[2]}}))}))},t.prototype._unsubscribe=function(){this.subSubscription&&this.subSubscription.unsubscribe()},t.prototype.componentDidMount=function(){return i(this,void 0,void 0,(function(){return a(this,(function(e){return this._fetchData(),this.mounted=!0,[2]}))}))},t.prototype.componentWillUnmount=function(){this._unsubscribe(),this.mounted=!1},t.prototype.componentDidUpdate=function(e){var t=this.state.loading,n=this.props,o=n.query,r=n.mutation,i=e.query,a=e.mutation,s=o||{},u=s.query,c=s.variables,l=i||{},p=l.query,d=l.variables,f=p!==u||JSON.stringify(d)!==JSON.stringify(c),h=r||{},m=h.query,g=h.variables,y=a||{},v=y.query,b=y.variables,S=v!==m||JSON.stringify(b)!==JSON.stringify(g);t||!f&&!S||this._fetchData()},t.prototype.render=function(){var e=this.state,t=e.data,n=e.loading,o=e.mutation,r=e.errors;return this.props.children({data:t,errors:r,loading:n,mutation:o})||null},t}(s.Component);t.default=c},function(e,t){e.exports=s},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),function(e){for(var n in e)t.hasOwnProperty(n)||(t[n]=e[n])}(n(74))},function(e,t,n){"use strict";(function(e){var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),i=this&&this.__awaiter||function(e,t,n,o){return new(n||(n=Promise))((function(r,i){function a(e){try{u(o.next(e))}catch(e){i(e)}}function s(e){try{u(o.throw(e))}catch(e){i(e)}}function u(e){var t;e.done?r(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(a,s)}u((o=o.apply(e,t||[])).next())}))},a=this&&this.__generator||function(e,t){var n,o,r,i,a={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return i={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function s(i){return function(s){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,o&&(r=2&i[0]?o.return:i[0]?o.throw||((r=o.return)&&r.call(o),0):o.next)&&!(r=r.call(o,i[1])).done)return r;switch(o=0,r&&(i=[2&i[0],r.value]),i[0]){case 0:case 1:r=i;break;case 4:return a.label++,{value:i[1],done:!1};case 5:a.label++,o=i[1],i=[0];continue;case 7:i=a.ops.pop(),a.trys.pop();continue;default:if(!(r=(r=a.trys).length>0&&r[r.length-1])&&(6===i[0]||2===i[0])){a=0;continue}if(3===i[0]&&(!r||i[1]>r[0]&&i[1]<r[3])){a.label=i[1];break}if(6===i[0]&&a.label<r[1]){a.label=r[1],r=i;break}if(r&&a.label<r[2]){a.label=r[2],a.ops.push(i);break}r[2]&&a.ops.pop(),a.trys.pop();continue}i=t.call(e,a)}catch(e){i=[6,e],o=0}finally{n=r=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,s])}}},s=this&&this.__spreadArrays||function(){for(var e=0,t=0,n=arguments.length;t<n;t++)e+=arguments[t].length;var o=Array(e),r=0;for(t=0;t<n;t++)for(var i=arguments[t],a=0,s=i.length;a<s;a++,r++)o[r]=i[a];return o};Object.defineProperty(t,"__esModule",{value:!0});var u,c=n(0),l=n(0),p=n(10),d=n(8),f=n(1),h=n(75),m=(new(n(1).ConsoleLogger)("ChatBot"),{itemMe:{padding:10,fontSize:12,color:"gray",marginTop:4,textAlign:"right"},itemBot:{fontSize:12,textAlign:"left"},list:{height:"300px",overflow:"auto"},textInput:Object.assign({},d.Input,{display:"inline-block",width:"calc(100% - 90px - 15px)"}),button:Object.assign({},d.Button,{width:"60px",float:"right"}),mic:Object.assign({},d.Button,{width:"40px",float:"right"})}),g={INITIAL:{MESSAGE:"Type your message or click  🎤",ICON:"🎤"},LISTENING:{MESSAGE:"Listening... click 🔴 again to cancel",ICON:"🔴"},SENDING:{MESSAGE:"Please wait...",ICON:"🔊"},SPEAKING:{MESSAGE:"Speaking...",ICON:"..."}},y=function(t){function o(o){var r=t.call(this,o)||this;if(r.props.voiceEnabled&&(n(76),u=new e.LexAudio.audioControl),!r.props.textEnabled&&r.props.voiceEnabled&&(g.INITIAL.MESSAGE="Click the mic button",m.textInput=Object.assign({},d.Input,{display:"inline-block",width:"calc(100% - 40px - 15px)"})),r.props.textEnabled&&!r.props.voiceEnabled&&(g.INITIAL.MESSAGE="Type a message",m.textInput=Object.assign({},d.Input,{display:"inline-block",width:"calc(100% - 60px - 15px)"})),!r.props.voiceConfig.silenceDetectionConfig)throw new Error("voiceConfig prop is missing silenceDetectionConfig");return r.state={dialog:[{message:r.props.welcomeMessage||"Welcome to Lex",from:"system"}],inputText:"",currentVoiceState:g.INITIAL,inputDisabled:!1,micText:g.INITIAL.ICON,continueConversation:!1,micButtonDisabled:!1},r.micButtonHandler=r.micButtonHandler.bind(r),r.changeInputText=r.changeInputText.bind(r),r.listItems=r.listItems.bind(r),r.submit=r.submit.bind(r),r.listItemsRef=c.createRef(),r.onSilenceHandler=r.onSilenceHandler.bind(r),r.doneSpeakingHandler=r.doneSpeakingHandler.bind(r),r.lexResponseHandler=r.lexResponseHandler.bind(r),r}return r(o,t),o.prototype.micButtonHandler=function(){return i(this,void 0,void 0,(function(){var e=this;return a(this,(function(t){return this.state.continueConversation?this.reset():this.setState({inputDisabled:!0,continueConversation:!0,currentVoiceState:g.LISTENING,micText:g.LISTENING.ICON,micButtonDisabled:!1},(function(){u.startRecording(e.onSilenceHandler,null,e.props.voiceConfig.silenceDetectionConfig)})),[2]}))}))},o.prototype.onSilenceHandler=function(){var e=this;u.stopRecording(),this.state.continueConversation&&u.exportWAV((function(t){e.setState({currentVoiceState:g.SENDING,audioInput:t,micText:g.SENDING.ICON,micButtonDisabled:!0},(function(){e.lexResponseHandler()}))}))},o.prototype.lexResponseHandler=function(){return i(this,void 0,void 0,(function(){var e,t,n=this;return a(this,(function(o){switch(o.label){case 0:if(!h.default||"function"!=typeof h.default.send)throw new Error("No Interactions module found, please ensure @aws-amplify/interactions is imported");return this.state.continueConversation?(e={content:this.state.audioInput,options:{messageType:"voice"}},[4,h.default.send(this.props.botName,e)]):[2];case 1:return t=o.sent(),this.setState({lexResponse:t,currentVoiceState:g.SPEAKING,micText:g.SPEAKING.ICON,micButtonDisabled:!0,dialog:s(this.state.dialog,[{message:t.inputTranscript,from:"me"},t&&{from:"bot",message:t.message}]),inputText:""},(function(){n.doneSpeakingHandler()})),this.listItemsRef.current.scrollTop=this.listItemsRef.current.scrollHeight,[2]}}))}))},o.prototype.doneSpeakingHandler=function(){var e=this;this.state.continueConversation&&("audio/mpeg"===this.state.lexResponse.contentType?u.play(this.state.lexResponse.audioStream,(function(){"ReadyForFulfillment"!==e.state.lexResponse.dialogState&&"Fulfilled"!==e.state.lexResponse.dialogState&&"Failed"!==e.state.lexResponse.dialogState&&e.props.conversationModeOn?e.setState({currentVoiceState:g.LISTENING,micText:g.LISTENING.ICON,micButtonDisabled:!1},(function(){u.startRecording(e.onSilenceHandler,null,e.props.voiceConfig.silenceDetectionConfig)})):e.setState({inputDisabled:!1,currentVoiceState:g.INITIAL,micText:g.INITIAL.ICON,micButtonDisabled:!1,continueConversation:!1})})):this.setState({inputDisabled:!1,currentVoiceState:g.INITIAL,micText:g.INITIAL.ICON,micButtonDisabled:!1,continueConversation:!1}))},o.prototype.reset=function(){this.setState({inputText:"",currentVoiceState:g.INITIAL,inputDisabled:!1,micText:g.INITIAL.ICON,continueConversation:!1,micButtonDisabled:!1},(function(){u.clear()}))},o.prototype.listItems=function(){return this.state.dialog.map((function(e,t){return"me"===e.from?c.createElement("div",{key:t,style:m.itemMe},e.message):(e.from,c.createElement("div",{key:t,style:m.itemBot},e.message))}))},o.prototype.submit=function(e){return i(this,void 0,void 0,(function(){var t,n=this;return a(this,(function(o){switch(o.label){case 0:return e.preventDefault(),this.state.inputText?[4,new Promise((function(e){return n.setState({dialog:s(n.state.dialog,[{message:n.state.inputText,from:"me"}])},e)}))]:[2];case 1:if(o.sent(),!h.default||"function"!=typeof h.default.send)throw new Error("No Interactions module found, please ensure @aws-amplify/interactions is imported");return[4,h.default.send(this.props.botName,this.state.inputText)];case 2:return t=o.sent(),this.setState({dialog:s(this.state.dialog,[t&&{from:"bot",message:t.message}]),inputText:""}),this.listItemsRef.current.scrollTop=this.listItemsRef.current.scrollHeight,[2]}}))}))},o.prototype.changeInputText=function(e){return i(this,void 0,void 0,(function(){return a(this,(function(t){switch(t.label){case 0:return[4,this.setState({inputText:e.target.value})];case 1:return t.sent(),[2]}}))}))},o.prototype.getOnComplete=function(e){var t=this;return function(){for(var n=[],o=0;o<arguments.length;o++)n[o]=arguments[o];var r=t.props.clearOnComplete,i=e.apply(void 0,n);t.setState({dialog:s(!r&&t.state.dialog,[i&&{from:"bot",message:i}]).filter(Boolean)},(function(){t.listItemsRef.current.scrollTop=t.listItemsRef.current.scrollHeight}))}},o.prototype.componentDidMount=function(){var e=this.props,t=e.onComplete,n=e.botName;if(t&&n){if(!h.default||"function"!=typeof h.default.onComplete)throw new Error("No Interactions module found, please ensure @aws-amplify/interactions is imported");h.default.onComplete(n,this.getOnComplete(t,this))}},o.prototype.componentDidUpdate=function(e){var t=this.props,n=t.onComplete,o=t.botName;if(o&&this.props.onComplete!==e.onComplete){if(!h.default||"function"!=typeof h.default.onComplete)throw new Error("No Interactions module found, please ensure @aws-amplify/interactions is imported");h.default.onComplete(o,this.getOnComplete(n,this))}},o.prototype.render=function(){var e=this.props,t=e.title,n=e.theme;e.onComplete;return c.createElement(p.FormSection,{theme:n},t&&c.createElement(p.SectionHeader,{theme:n},f.I18n.get(t)),c.createElement(p.SectionBody,{theme:n},c.createElement("div",{ref:this.listItemsRef,style:m.list},this.listItems())),c.createElement(p.SectionFooter,{theme:n},c.createElement(C,{micText:this.state.micText,voiceEnabled:this.props.voiceEnabled,textEnabled:this.props.textEnabled,styles:m,onChange:this.changeInputText,inputText:this.state.inputText,onSubmit:this.submit,inputDisabled:this.state.inputDisabled,micButtonDisabled:this.state.micButtonDisabled,handleMicButton:this.micButtonHandler,currentVoiceState:this.state.currentVoiceState})))},o}(l.Component);function v(e){var t=e.styles,n=e.onChange,o=e.inputText,r=e.inputDisabled,i=e.currentVoiceState;return c.createElement("input",{style:t.textInput,type:"text",placeholder:f.I18n.get(i.MESSAGE),onChange:n,value:o,disabled:r})}function b(e){var t=e.voiceEnabled,n=e.styles,o=e.micButtonDisabled,r=e.handleMicButton,i=e.micText;return t?c.createElement("button",{style:n.mic,disabled:o,onClick:r},i):null}function S(e){var t=e.textEnabled,n=e.styles,o=e.inputDisabled;return t?c.createElement("button",{type:"submit",style:n.button,disabled:o},f.I18n.get("Send")):null}function C(e){var t=e.voiceEnabled,n=e.textEnabled,o=e.styles,r=e.onChange,i=e.inputDisabled,a=e.micButtonDisabled,s=e.inputText,u=e.onSubmit,l=e.handleMicButton,p=e.micText,d=e.currentVoiceState;return t&&!n&&(i=!0),t||n?c.createElement("form",{onSubmit:u},c.createElement(v,{onSubmit:u,styles:o,type:"text",currentVoiceState:d,onChange:r,inputText:s,inputDisabled:i}),c.createElement(S,{onSubmit:u,type:"submit",styles:o,inputDisabled:i,textEnabled:n}),c.createElement(b,{styles:o,micButtonDisabled:a,handleMicButton:l,micText:p,voiceEnabled:t})):c.createElement("div",null,"No Chatbot inputs enabled. Set at least one of voiceEnabled or textEnabled in the props."," ")}t.ChatBot=y,y.defaultProps={title:"",botName:"",onComplete:void 0,clearOnComplete:!1,voiceConfig:{silenceDetectionConfig:{time:2e3,amplitude:.2}},conversationModeOn:!1,voiceEnabled:!1,textEnabled:!0},t.default=y}).call(this,n(47))},function(e,t){e.exports=u},function(e,t,n){(function(e){!function e(t,n,o){function r(a,s){if(!n[a]){if(!t[a]){if(i)return i(a,!0);var u=new Error("Cannot find module '"+a+"'");throw u.code="MODULE_NOT_FOUND",u}var c=n[a]={exports:{}};t[a][0].call(c.exports,(function(e){var n=t[a][1][e];return r(n||e)}),c,c.exports,e,t,n,o)}return n[a].exports}for(var i=!1,a=0;a<o.length;a++)r(o[a]);return r}({1:[function(e,t,n){!function(){"use strict";var t,o,r,i,a=e("./recorder.js"),s="Audio is not supported.";n.audioControl=function(e){e=e||{},this.checkAudioSupport=!1!==e.checkAudioSupport;var n=function(e){e=e||function(){},navigator.mediaDevices&&navigator.mediaDevices.getUserMedia?(o=a.audioRecorder()).requestDevice().then((function(t){e(r=!0)})).catch((function(t){e(r=!1)})):e(r=!1)};return this.checkAudioSupport&&n(),{startRecording:function(e,n,i){if(e=e||function(){},n=n||function(){},!(r=!1!==r))throw new Error(s);(t=o.createRecorder(i)).record(e,n)},stopRecording:function(){if(!(r=!1!==r))throw new Error(s);t.stop()},exportWAV:function(e,n){if(!(r=!1!==r))throw new Error(s);if(!e||"function"!=typeof e)throw new Error("You must pass a callback function to export.");n=void 0!==n?n:16e3,t.exportWAV(e,n),t.clear()},play:function(e,t){if(void 0!==e){var n=new Blob([e]),r=new FileReader;r.onload=function(){i=o.audioContext().createBufferSource(),o.audioContext().decodeAudioData(this.result,(function(e){i.buffer=e,i.connect(o.audioContext().destination),i.onended=function(e){"function"==typeof t&&t()},i.start(0)}))},r.readAsArrayBuffer(n)}},stop:function(){void 0!==i&&i.stop()},clear:function(){t.clear()},playHtmlAudioElement:function(e,t){if(void 0!==e){var n=new Blob([e]),o=document.createElement("audio"),r=window.URL.createObjectURL(n);o.src=r,o.addEventListener("ended",(function(){o.currentTime=0,"function"==typeof t&&t()})),o.play()}},supportsAudio:n}}}()},{"./recorder.js":5}],2:[function(e,t,n){!function(){"use strict";var t,o=e("./control.js").audioControl,r=Object.freeze({PASSIVE:"Passive",LISTENING:"Listening",SENDING:"Sending",SPEAKING:"Speaking"}),i=new o({checkAudioSupport:!1});n.conversation=function(e,n,o,s,u){var c;if(this.config=l(e),this.lexConfig=this.config.lexConfig,this.messages=r,n=n||function(){},this.onSuccess=o||function(){},this.onError=s||function(){},this.onAudioData=u||function(){},this.config.lexConfig.botName)if(AWS.config.credentials){if(AWS.config.region)return t=new AWS.LexRuntime,this.onSilence=function(){e.silenceDetection&&(i.stopRecording(),c.advanceConversation())},this.transition=function(e){var t=(c=e).state;n(t.message),t.message!==t.messages.SENDING&&t.message!==t.messages.SPEAKING||c.advanceConversation(),t.message!==t.messages.SENDING||this.config.silenceDetection||i.stopRecording()},this.advanceConversation=function(){i.supportsAudio((function(e){e?c.advanceConversation():s("Audio is not supported.")}))},this.updateConfig=function(e){this.config=l(e),this.lexConfig=this.config.lexConfig},this.reset=function(){i.clear(),c=new a(c.state)},c=new a(this),{advanceConversation:this.advanceConversation,updateConfig:this.updateConfig,reset:this.reset};this.onError("A Region value must be provided.")}else this.onError("AWS Credentials must be provided.");else this.onError("A Bot name must be provided.")};var a=function(e){this.state=e,e.message=e.messages.PASSIVE,this.advanceConversation=function(){i.startRecording(e.onSilence,e.onAudioData,e.config.silenceDetectionConfig),e.transition(new s(e))}},s=function(e){this.state=e,e.message=e.messages.LISTENING,this.advanceConversation=function(){i.exportWAV((function(t){e.audioInput=t,e.transition(new u(e))}))}},u=function(e){this.state=e,e.message=e.messages.SENDING,this.advanceConversation=function(){e.lexConfig.inputStream=e.audioInput,t.postContent(e.lexConfig,(function(t,n){t?(e.onError(t),e.transition(new a(e))):(e.audioOutput=n,e.transition(new c(e)),e.onSuccess(n))}))}},c=function(e){this.state=e,e.message=e.messages.SPEAKING,this.advanceConversation=function(){"audio/mpeg"===e.audioOutput.contentType?i.play(e.audioOutput.audioStream,(function(){"ReadyForFulfillment"!==e.audioOutput.dialogState&&"Fulfilled"!==e.audioOutput.dialogState&&"Failed"!==e.audioOutput.dialogState&&e.config.silenceDetection?(i.startRecording(e.onSilence,e.onAudioData,e.config.silenceDetectionConfig),e.transition(new s(e))):e.transition(new a(e))})):e.transition(new a(e))}},l=function(e){(e=e||{}).silenceDetection=!e.hasOwnProperty("silenceDetection")||e.silenceDetection;var t=e.lexConfig||{};return t.botAlias=t.hasOwnProperty("botAlias")?t.botAlias:"$LATEST",t.botName=t.hasOwnProperty("botName")?t.botName:"",t.contentType=t.hasOwnProperty("contentType")?t.contentType:"audio/x-l16; sample-rate=16000",t.userId=t.hasOwnProperty("userId")?t.userId:"userId",t.accept=t.hasOwnProperty("accept")?t.accept:"audio/mpeg",e.lexConfig=t,e}}()},{"./control.js":1}],3:[function(t,n,o){(function(e){e.LexAudio=e.LexAudio||{},e.LexAudio.audioControl=t("./control.js").audioControl,e.LexAudio.conversation=t("./conversation.js").conversation,n.exports=e.LexAudio}).call(this,void 0!==e?e:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./control.js":1,"./conversation.js":2}],4:[function(e,t,n){var o=arguments[3],r=arguments[4],i=arguments[5],a=JSON.stringify;t.exports=function(e,t){for(var n,s=Object.keys(i),u=0,c=s.length;u<c;u++){var l=s[u],p=i[l].exports;if(p===e||p&&p.default===e){n=l;break}}if(!n){n=Math.floor(Math.pow(16,8)*Math.random()).toString(16);var d={};for(u=0,c=s.length;u<c;u++){d[l=s[u]]=l}r[n]=[Function(["require","module","exports"],"("+e+")(self)"),d]}var f=Math.floor(Math.pow(16,8)*Math.random()).toString(16),h={};h[n]=n,r[f]=[Function(["require"],"var f = require("+a(n)+");(f.default ? f.default : f)(self);"),h];var m={};!function e(t){for(var n in m[t]=!0,r[t][1]){var o=r[t][1][n];m[o]||e(o)}}(f);var g="("+o+")({"+Object.keys(m).map((function(e){return a(e)+":["+r[e][0]+","+a(r[e][1])+"]"})).join(",")+"},{},["+a(f)+"])",y=window.URL||window.webkitURL||window.mozURL||window.msURL,v=new Blob([g],{type:"text/javascript"});if(t&&t.bare)return v;var b=y.createObjectURL(v),S=new Worker(b);return S.objectURL=b,S}},{}],5:[function(e,t,n){!function(){"use strict";var t,o,r=e("webworkify")(e("./worker.js")),i=function(e,t){(t=t||{}).time=t.hasOwnProperty("time")?t.time:1500,t.amplitude=t.hasOwnProperty("amplitude")?t.amplitude:.2;var n,o,i,a,s=!1,u=e.context.createScriptProcessor(4096,1,1);r.onmessage=function(e){var t=e.data;n(t)},r.postMessage({command:"init",config:{sampleRate:e.context.sampleRate}});var c=function(){s=!1};u.onaudioprocess=function(e){s&&(r.postMessage({command:"record",buffer:[e.inputBuffer.getChannelData(0)]}),function(){l.fftSize=2048;var e=l.fftSize,n=new Uint8Array(e),r=t.amplitude,s=t.time;l.getByteTimeDomainData(n),"function"==typeof a&&a(n,e);for(var u=0;u<e;u++){var c=n[u]/128-1;(c>r||c<-1*r)&&(o=Date.now())}Date.now()-o>s&&i()}())};var l=e.context.createAnalyser();return l.minDecibels=-90,l.maxDecibels=-10,l.smoothingTimeConstant=.85,e.connect(l),l.connect(u),u.connect(e.context.destination),{record:function(e,t){i=e,a=t,o=Date.now(),s=!0},stop:c,clear:function(){c(),r.postMessage({command:"clear"})},exportWAV:function(e,t){n=e,r.postMessage({command:"export",sampleRate:t})}}};n.audioRecorder=function(){return{requestDevice:function(){return void 0===t&&(window.AudioContext=window.AudioContext||window.webkitAudioContext,t=new AudioContext),navigator.mediaDevices.getUserMedia({audio:!0}).then((function(e){o=e}))},createRecorder:function(e){return i(t.createMediaStreamSource(o),e)},audioContext:function(){return t}}}}()},{"./worker.js":6,webworkify:4}],6:[function(e,t,n){t.exports=function(e){"use strict";var t,n=0,o=[];function r(e,t,n){for(var o=0;o<n.length;o++)e.setUint8(t+o,n.charCodeAt(o))}e.addEventListener("message",(function(e){switch(e.data.command){case"init":c=e.data.config,t=c.sampleRate;break;case"record":u=e.data.buffer,o.push(u[0]),n+=u[0].length;break;case"export":i=e.data.sampleRate,a=function(e){var n=new ArrayBuffer(44+2*e.length),o=new DataView(n);return r(o,0,"RIFF"),o.setUint32(4,32+2*e.length,!0),r(o,8,"WAVE"),r(o,12,"fmt "),o.setUint32(16,16,!0),o.setUint16(20,1,!0),o.setUint16(22,1,!0),o.setUint32(24,t,!0),o.setUint32(28,2*t,!0),o.setUint16(32,2,!0),o.setUint16(34,16,!0),r(o,36,"data"),o.setUint32(40,2*e.length,!0),function(e,t,n){for(var o=0;o<n.length;o++,t+=2){var r=Math.max(-1,Math.min(1,n[o]));e.setInt16(t,r<0?32768*r:32767*r,!0)}}(o,44,e),o}(function(e,n){if(n===t)return e;for(var o=t/n,r=Math.round(e.length/o),i=new Float32Array(r),a=0,s=0;a<i.length;){for(var u=Math.round((a+1)*o),c=0,l=0,p=s;p<u&&p<e.length;p++)c+=e[p],l++;i[a]=c/l,a++,s=u}return i}(function(e,t){for(var n=new Float32Array(t),o=0,r=0;r<e.length;r++)n.set(e[r],o),o+=e[r].length;return n}(o,n),i)),s=new Blob([a],{type:"application/octet-stream"}),postMessage(s);break;case"clear":n=0,o=[]}var i,a,s,u,c}))}},{}]},{},[3])}).call(this,n(47))},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var o=n(78);t.SumerianScene=o.default},function(e,t,n){"use strict";var o,r=this&&this.__extends||(o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),i=this&&this.__awaiter||function(e,t,n,o){return new(n||(n=Promise))((function(r,i){function a(e){try{u(o.next(e))}catch(e){i(e)}}function s(e){try{u(o.throw(e))}catch(e){i(e)}}function u(e){var t;e.done?r(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(a,s)}u((o=o.apply(e,t||[])).next())}))},a=this&&this.__generator||function(e,t){var n,o,r,i,a={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return i={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function s(i){return function(s){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,o&&(r=2&i[0]?o.return:i[0]?o.throw||((r=o.return)&&r.call(o),0):o.next)&&!(r=r.call(o,i[1])).done)return r;switch(o=0,r&&(i=[2&i[0],r.value]),i[0]){case 0:case 1:r=i;break;case 4:return a.label++,{value:i[1],done:!1};case 5:a.label++,o=i[1],i=[0];continue;case 7:i=a.ops.pop(),a.trys.pop();continue;default:if(!(r=(r=a.trys).length>0&&r[r.length-1])&&(6===i[0]||2===i[0])){a=0;continue}if(3===i[0]&&(!r||i[1]>r[0]&&i[1]<r[3])){a.label=i[1];break}if(6===i[0]&&a.label<r[1]){a.label=r[1],r=i;break}if(r&&a.label<r[2]){a.label=r[2],a.ops.push(i);break}r[2]&&a.ops.pop(),a.trys.pop();continue}i=t.call(e,a)}catch(e){i=[6,e],o=0}finally{n=r=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,s])}}};Object.defineProperty(t,"__esModule",{value:!0});var s=n(0),u=n(79),c=n(1),l=n(80),p=n(82),d=n(7),f=n(5),h=new c.ConsoleLogger("SumerianScene"),m=function(e){function t(t){var n=e.call(this,t)||this;return n.state={showEnableAudio:!1,muted:!1,loading:!0,percentage:0,isFullscreen:!1,sceneError:null,isVRPresentationActive:!1},n}return r(t,e),t.prototype.setStateAsync=function(e){var t=this;return new Promise((function(n){t.setState(e,n)}))},t.prototype.componentDidMount=function(){document.addEventListener("fullscreenchange",this.onFullscreenChange.bind(this)),document.addEventListener("webkitfullscreenchange",this.onFullscreenChange.bind(this)),document.addEventListener("mozfullscreenchange",this.onFullscreenChange.bind(this)),document.addEventListener("MSFullscreenChange",this.onFullscreenChange.bind(this)),this.loadAndSetupScene(this.props.sceneName,"scene-dom-id")},t.prototype.componentWillUnmount=function(){document.removeEventListener("fullscreenchange",this.onFullscreenChange.bind(this)),document.removeEventListener("webkitfullscreenchange",this.onFullscreenChange.bind(this)),document.removeEventListener("mozfullscreenchange",this.onFullscreenChange.bind(this)),document.removeEventListener("MSFullscreenChange",this.onFullscreenChange.bind(this))},t.prototype.loadAndSetupScene=function(e,t){return i(this,void 0,void 0,(function(){var n,o,r,i=this;return a(this,(function(a){switch(a.label){case 0:this.setStateAsync({loading:!0}),n={progressCallback:function(e){var t=100*e;i.setState({percentage:t})}},a.label=1;case 1:return a.trys.push([1,3,,4]),[4,u.default.loadScene(e,t,n)];case 2:return a.sent(),[3,4];case 3:return o=a.sent(),r={displayText:"Failed to load scene",error:o},h.error(r.displayText,r.error),this.setStateAsync({sceneError:r}),[2];case 4:return u.default.start(e),this.setStateAsync({muted:u.default.isMuted(e),isVRPresentationActive:u.default.isVRPresentationActive(e),loading:!1}),u.default.onSceneEvent(e,"AudioEnabled",(function(){return i.setStateAsync({showEnableAudio:!1})})),u.default.onSceneEvent(e,"AudioDisabled",(function(){return i.setStateAsync({showEnableAudio:!0})})),[2]}}))}))},t.prototype.setMuted=function(e){this.state.showEnableAudio&&(u.default.enableAudio(this.props.sceneName),this.setState({showEnableAudio:!1})),u.default.setMuted(this.props.sceneName,e),this.setState({muted:e})},t.prototype.onFullscreenChange=function(){var e=document;this.setState({isFullscreen:null!==e.fullscreenElement})},t.prototype.maximize=function(){return i(this,void 0,void 0,(function(){return a(this,(function(e){switch(e.label){case 0:return[4,document.getElementById("scene-container-dom-id").requestFullscreen()];case 1:return e.sent(),[2]}}))}))},t.prototype.minimize=function(){return i(this,void 0,void 0,(function(){var e;return a(this,(function(t){return(e=document).exitFullscreen?e.exitFullscreen():e.mozCancelFullScreen?e.mozCancelFullScreen():e.webkitExitFullscreen&&e.webkitExitFullscreen(),[2]}))}))},t.prototype.toggleVRPresentation=function(){try{this.state.isVRPresentationActive?u.default.exitVR(this.props.sceneName):u.default.enterVR(this.props.sceneName)}catch(e){return void h.error("Unable to start/stop WebVR System: "+e.message)}this.setState({isVRPresentationActive:!this.state.isVRPresentationActive})},t.prototype.render=function(){var e,t,n,o=this;return u.default.isSceneLoaded(this.props.sceneName)&&(e=this.state.showEnableAudio?s.createElement(l.default,{variant:"sound-mute",tooltip:"The scene is muted. Click to unmute.",onClick:function(){return o.setMuted(!1)},autoShowTooltip:!0}):u.default.isMuted(this.props.sceneName)?s.createElement(l.default,{variant:"sound-mute",tooltip:"Unmute",onClick:function(){return o.setMuted(!1)}}):s.createElement(l.default,{variant:"sound",tooltip:"Mute",onClick:function(){return o.setMuted(!0)}}),u.default.isVRCapable(this.props.sceneName)&&(this.state.isVRPresentationActive?(h.info("VR Presentation Active"),t=s.createElement(l.default,{variant:"exit-vr",tooltip:"Exit VR",onClick:function(){return o.toggleVRPresentation()}})):(h.info("VR Presentation Inactive"),t=s.createElement(l.default,{variant:"enter-vr",tooltip:"Enter VR",onClick:function(){return o.toggleVRPresentation()}}))),n=this.state.isFullscreen?s.createElement(l.default,{variant:"minimize",tooltip:"Exit Fullscreen",onClick:function(){return o.minimize()}}):s.createElement(l.default,{variant:"maximize",tooltip:"Fullscreen",onClick:function(){return o.maximize()}})),s.createElement("div",{id:"scene-container-dom-id",className:d.sumerianSceneContainer,"data-test":f.sumerianScene.container},s.createElement("div",{id:"scene-dom-id",className:d.sumerianScene,"data-test":f.sumerianScene.sumerianScene},this.state.loading&&s.createElement(p.default,{sceneName:this.props.sceneName,percentage:this.state.percentage,sceneError:this.state.sceneError})),s.createElement("div",{className:d.sceneBar,"data-test":f.sumerianScene.bar},s.createElement("span",{className:d.sceneActions,"data-test":f.sumerianScene.actions},e,t,n)))},t}(s.Component);t.default=m},function(e,t){e.exports=c},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var o=n(0),r=n(81),i=n(7);t.default=function(e){var t;switch(e.variant){case"sound-mute":t=o.createElement("svg",{width:"19",height:"19",viewBox:"0 0 19 19",xmlns:"http://www.w3.org/2000/svg"},o.createElement("g",{id:"icons/minis/volumeOff",fill:"none",fillRule:"evenodd"},o.createElement("path",{d:"M3.48026899,12.9630494 C3.63825091,12.9630494 3.79237961,13.0108921 3.92264322,13.1003479 L8.77467683,16.8113609 C9.29423971,17.1679383 10,16.7950396 10,16.1637406 L10,3.78619489 C10,3.15489596 9.29423971,2.78199725 8.77467683,3.13857463 L3.92264322,6.84545211 C3.79237961,6.93490793 3.63825091,6.9827506 3.48026899,6.9827506 L1.78294894,6.9827506 C1.3505185,6.9827506 1,7.33409518 1,7.76754476 L1,12.1781306 C1,12.6117048 1.3505185,12.9630494 1.78294894,12.9630494 L3.48026899,12.9630494 Z M17.2118156,7 L15.0918385,9.11997713 L12.9718614,7 L12,7.97174685 L14.1200917,10.091724 L12,12.2118156 L12.9718614,13.1835625 L15.0918385,11.0635854 L17.2118156,13.1835625 L18.1835625,12.2118156 L16.0635854,10.091724 L18.1835625,7.97174685 L17.2118156,7 Z",id:"Fill-2",fill:"#FFF"})));break;case"sound":t=o.createElement("svg",{width:"19",height:"19",viewBox:"0 0 19 19",xmlns:"http://www.w3.org/2000/svg"},o.createElement("g",{id:"icons/minis/volumeOn",fill:"none",fillRule:"evenodd"},o.createElement("path",{d:"M3.48026899,12.9630494 L1.78294894,12.9630494 C1.3505185,12.9630494 1,12.6117048 1,12.1781306 L1,7.76754476 C1,7.33409518 1.3505185,6.9827506 1.78294894,6.9827506 L3.48026899,6.9827506 C3.63825091,6.9827506 3.79237961,6.93490793 3.92264322,6.84545211 L8.77467683,3.13857463 C9.29423971,2.78199725 10,3.15489596 10,3.78619489 L10,16.1637406 C10,16.7950396 9.29423971,17.1679383 8.77467683,16.8113609 L3.92264322,13.1003479 C3.79237961,13.0108921 3.63825091,12.9630494 3.48026899,12.9630494 Z M14.9270376,3.03232286 C15.1729267,3.03232286 15.4040399,3.12815658 15.5777627,3.3022351 C17.3699891,5.09889099 18.3570052,7.48235058 18.3570052,10.0135053 C18.3570052,12.54466 17.3699891,14.9281196 15.5777627,16.7247755 C15.4041045,16.898854 15.1729914,16.9947524 14.9270052,16.9947524 C14.6820861,16.9947524 14.4515549,16.899436 14.2777674,16.7263598 C13.9192316,16.3684383 13.9185203,15.7852882 14.2762477,15.4264291 C15.7222893,13.9769926 16.5186727,12.0545954 16.5186727,10.0135053 C16.5186727,7.97241524 15.7222893,6.05001801 14.2762154,4.60058152 C13.9184879,4.24175473 13.9191992,3.65857229 14.277832,3.30065081 C14.4514256,3.1275746 14.6819567,3.03232286 14.9270376,3.03232286 Z M13.5730665,6.11570485 C14.6133991,7.15574642 15.1862998,8.54003279 15.1862998,10.0134924 C15.1862998,11.4892799 14.6113945,12.8741159 13.5675376,13.9128965 C13.3942351,14.0855848 13.1639626,14.1806425 12.9191727,14.1806425 C12.6727016,14.1806425 12.4412975,14.0844531 12.2677039,13.9097926 C12.0944984,13.7358111 11.9994406,13.5047303 11.9999903,13.2592291 C12.0005723,13.0136956 12.096794,12.7831644 12.2708079,12.6100882 C12.9654406,11.9185917 13.3479995,10.996467 13.3479995,10.0134924 C13.3479995,9.03119677 12.966346,8.1086194 12.2733298,7.4157649 C11.9150203,7.05745543 11.9149233,6.47436998 12.2731358,6.11589885 C12.4467617,5.94224065 12.6775838,5.84666559 12.923085,5.84666559 C13.1685538,5.84666559 13.3993436,5.94220831 13.5730665,6.11570485 Z",id:"Fill-2",fill:"#FFF"})));break;case"maximize":t=o.createElement("svg",{width:"19",height:"19",viewBox:"0 0 19 19",xmlns:"http://www.w3.org/2000/svg"},o.createElement("g",{id:"icons/minis/screenfull",fill:"none",fillRule:"evenodd"},o.createElement("path",{d:"M2.04162598,3 L2.04162598,16 L17.0147705,16 L17.0147705,3 L2.04162598,3 Z M1,2 L18,2 L18,17 L1,17 L1,2 Z M3,4 L16,4 L16,15 L3,15 L3,4 Z",id:"Rectangle-Copy",fill:"#FFF",fillRule:"nonzero"})));break;case"minimize":t=o.createElement("svg",{width:"19",height:"19",viewBox:"0 0 19 19",xmlns:"http://www.w3.org/2000/svg"},o.createElement("g",{id:"icons/minis/screensmall",fill:"none",fillRule:"evenodd"},o.createElement("path",{d:"M11,16 L17.0147705,16 L17.0147705,3 L2.04162598,3 L2.04162598,10 L11,10 L11,16 Z M1,2 L18,2 L18,17 L1,17 L1,2 Z",id:"Rectangle",fill:"#FFF",fillRule:"nonzero"})));break;case"enter-vr":t=o.createElement("svg",{width:"19",height:"19",viewBox:"0 0 17 10",xmlns:"http://www.w3.org/2000/svg"},o.createElement("g",{id:"Page-1",fill:"none",fillRule:"evenodd"},o.createElement("g",{id:"VRon",fill:"#FFF",fillRule:"nonzero"},o.createElement("path",{d:"M15.7856977,0.02395184 L15.8915734,0.02395184 C16.5037405,0.02395184 17,0.520211324 17,1.13237842 L17,1.54663675 L17,8.8915038 C17,9.5034193 16.4560011,10 15.7856977,10 L12.0095825,10 C9.98324439,7.1593807 8.80676009,5.741338 8.48012959,5.74587199 C8.16206045,5.75028714 7.01003321,7.1683298 5.02404785,10 L1.21426911,10 C0.543965735,10 3.32031236e-05,9.5034193 3.32031236e-05,8.8915038 L3.32031236e-05,1.54663675 L3.32031236e-05,1.13237842 L3.32031236e-05,1.13237842 C3.32031236e-05,0.520211324 0.496292687,0.02395184 1.10845978,0.02395184 L1.21426911,0.02395184 L15.7856977,0.02395184 Z M4.5,6 C5.32842712,6 6,5.32842712 6,4.5 C6,3.67157288 5.32842712,3 4.5,3 C3.67157288,3 3,3.67157288 3,4.5 C3,5.32842712 3.67157288,6 4.5,6 Z M12.5,6 C13.3284271,6 14,5.32842712 14,4.5 C14,3.67157288 13.3284271,3 12.5,3 C11.6715729,3 11,3.67157288 11,4.5 C11,5.32842712 11.6715729,6 12.5,6 Z",id:"Fill-1"}))));break;case"exit-vr":t=o.createElement("svg",{width:"19",height:"19",viewBox:"0 0 19 19",xmlns:"http://www.w3.org/2000/svg"},o.createElement("g",{id:"icons/minis/VRon-Copy",fill:"none",fillRule:"evenodd"},o.createElement("g",{id:"Group-7-Copy",transform:"translate(1 3)",fill:"#FFF"},o.createElement("path",{d:"M15.7856977,3.02395184 L17,3.02395184 L17,4.13237842 L17,4.54663675 L17,11.8915038 C17,12.5034193 16.4560011,13 15.7856977,13 L12.0095825,13 C9.98324439,10.1593807 8.80676009,8.741338 8.48012959,8.74587199 C8.16206045,8.75028714 7.01003321,10.1683298 5.02404785,13 L1.21426911,13 C0.543965735,13 3.32031236e-05,12.5034193 3.32031236e-05,11.8915038 L3.32031236e-05,4.54663675 L3.32031236e-05,4.13237842 L3.32031236e-05,3.02395184 L1.21426911,3.02395184 L15.7856977,3.02395184 Z M4.5,9 C5.32842712,9 6,8.32842712 6,7.5 C6,6.67157288 5.32842712,6 4.5,6 C3.67157288,6 3,6.67157288 3,7.5 C3,8.32842712 3.67157288,9 4.5,9 Z M12.5,9 C13.3284271,9 14,8.32842712 14,7.5 C14,6.67157288 13.3284271,6 12.5,6 C11.6715729,6 11,6.67157288 11,7.5 C11,8.32842712 11.6715729,9 12.5,9 Z M2.5486669,0 L14.420089,0 C14.7977406,0 15.1613805,0.149260956 15.4374308,0.417695511 L16.9999668,2.00634766 L0,2.00634766 L1.58537972,0.395493117 C1.84682061,0.141306827 2.19106994,0 2.5486669,0 Z",id:"Fill-1"}))));break;default:t=null}return o.createElement(r.default,{text:e.tooltip,autoShowTooltip:e.autoShowTooltip},o.createElement("button",{className:i.actionButton,onClick:e.onClick},t))}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var o=n(0),r=n(7);t.default=function(e){var t=""+r.tooltip;return e.autoShowTooltip&&(t=r.tooltip+" "+r.autoShowTooltip),o.createElement("div",{className:t,"data-text":e.text},e.children)}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var o=n(0),r=n(7),i=n(5);t.default=function(e){return o.createElement("div",{className:r.loadingOverlay,"data-test":i.sumerianScene.loading},o.createElement("div",{className:r.loadingContainer},o.createElement("div",{className:r.loadingLogo,"data-test":i.sumerianScene.loadingLogo},o.createElement("svg",{viewBox:"0 0 800 481",xmlns:"http://www.w3.org/2000/svg"},o.createElement("g",{id:"Page-1",fillRule:"evenodd"},o.createElement("g",{id:"AWS_logo_RGB-(1)",transform:"translate(-16 -17)",fillRule:"nonzero"},o.createElement("path",{d:"M241.371,190.172 C241.371,197.487 241.371,204.801 245.028,212.115 C245.028,219.43 248.685,226.744 252.343,234.058 C252.343,234.058 252.343,237.715 256,241.373 C256,245.03 252.343,248.688 252.343,248.688 L234.058,256.002 C230.401,256.002 230.401,259.659 226.743,259.659 C223.085,259.659 219.428,259.659 219.428,256.002 C219.428,252.345 212.113,248.687 208.457,245.031 C208.457,237.716 204.8,234.06 201.142,226.745 C182.856,248.688 153.599,263.317 124.342,263.317 C106.057,263.317 84.114,256.002 69.485,245.031 C54.856,230.402 51.2,212.116 51.2,193.831 C51.2,171.888 58.515,153.603 73.143,138.974 C91.428,124.345 113.371,117.031 138.972,117.031 C149.943,117.031 157.258,117.031 168.229,120.688 C179.2,120.688 186.515,124.345 197.486,128.003 L197.486,106.06 C197.486,91.431 193.829,76.803 186.515,62.174 C171.886,54.859 157.258,51.203 142.629,51.203 C131.658,51.203 124.344,51.203 113.372,54.86 C102.4,58.517 95.087,62.175 84.115,65.832 C80.458,65.832 76.801,69.489 73.143,69.489 L69.486,69.489 C65.829,69.489 62.171,65.832 62.171,62.174 L62.171,47.545 C62.171,43.888 62.171,40.23 65.828,36.574 C69.485,36.574 73.142,32.917 73.142,32.917 C84.114,29.26 95.085,25.603 109.714,21.946 C124.343,18.289 138.971,18.289 149.942,18.289 C175.542,14.632 201.142,21.946 219.428,36.574 C234.057,54.859 245.028,76.802 241.371,102.403 L241.371,190.175 L241.371,190.172 Z M131.657,230.4 C142.628,230.4 149.942,230.4 160.914,226.743 C171.886,223.086 179.199,215.772 186.514,208.457 C190.171,204.8 193.829,197.486 193.829,193.828 C197.486,182.857 197.486,175.543 197.486,168.228 L197.486,157.257 C190.171,157.257 182.857,153.6 171.886,153.6 C164.571,153.6 153.6,153.6 146.286,153.6 C135.315,149.943 120.686,153.6 109.714,160.915 C98.742,168.23 95.085,179.2 95.085,190.172 C95.085,201.143 98.742,212.115 106.057,219.429 C113.372,226.743 124.342,230.4 131.657,230.4 Z M347.428,259.657 C343.771,259.657 340.113,259.657 336.457,256 C332.801,252.343 332.8,248.685 332.8,245.029 L270.629,40.229 C270.629,36.572 266.972,32.914 266.972,29.258 C266.972,29.258 266.972,25.601 266.972,25.601 C266.972,25.601 270.629,21.944 270.629,25.601 L296.229,25.601 C299.886,25.601 303.544,25.601 307.2,29.258 C310.857,29.258 314.515,32.915 314.515,36.573 L358.4,212.116 L402.285,36.573 C402.285,32.916 405.942,29.259 405.942,25.602 C409.599,21.945 413.257,21.945 416.913,21.945 L438.856,21.945 C442.513,21.945 446.171,21.945 449.827,25.602 C453.483,29.259 453.484,32.917 453.484,36.573 L493.712,215.773 L541.255,36.573 C541.255,32.916 544.912,29.259 544.912,25.602 C548.569,21.945 552.226,21.945 555.883,21.945 L581.483,21.945 C581.483,21.945 585.14,21.945 585.14,21.945 C585.14,21.945 588.797,25.602 585.14,25.602 C585.14,25.602 585.14,29.259 585.14,29.259 C585.14,32.916 585.14,32.916 581.483,36.573 L515.655,241.373 C515.655,245.03 511.998,248.688 508.34,252.344 C504.682,256 501.025,256.001 497.369,256.001 L475.426,256.001 C471.769,256.001 468.111,256.001 464.455,252.344 C460.799,248.687 460.798,245.029 460.798,241.373 L427.884,73.145 L387.656,245.031 C387.656,248.688 383.999,252.346 383.999,256.002 C380.342,259.659 376.684,259.659 373.028,259.659 L347.428,259.659 L347.428,259.657 Z M687.543,266.971 C672.914,266.971 658.286,266.971 647.314,263.314 C636.342,259.657 625.371,255.999 618.057,252.343 C610.743,248.686 607.086,245.028 607.086,237.714 L607.086,223.085 C607.086,215.77 610.743,215.77 614.4,215.77 C614.4,215.77 618.057,215.77 618.057,215.77 L625.371,219.427 C636.342,223.084 643.656,226.742 654.628,230.398 C665.6,234.054 676.571,234.055 687.542,234.055 C702.171,234.055 713.142,230.398 727.771,226.74 C735.085,223.083 742.4,212.111 742.4,201.14 C742.4,193.825 738.743,186.511 735.086,182.855 C727.772,175.54 716.801,171.884 705.829,168.226 L665.6,157.255 C650.971,153.598 636.343,142.626 625.372,131.655 C618.058,120.683 610.743,106.055 610.743,91.427 C610.743,80.455 614.4,69.484 618.057,62.17 C621.714,54.856 629.028,47.541 636.342,40.227 C643.656,32.912 654.627,29.256 661.942,25.598 C672.913,21.941 683.885,21.941 694.856,21.941 C702.17,21.941 705.827,21.941 713.141,21.941 C720.455,21.941 724.112,21.941 731.426,25.598 C735.083,25.598 742.397,29.255 746.055,29.255 C749.713,29.255 753.369,32.912 757.026,32.912 C760.683,32.912 764.34,36.569 764.34,40.227 C767.997,36.57 767.997,40.227 767.997,43.884 L767.997,54.855 C767.997,62.17 764.34,62.17 760.683,62.17 C757.026,62.17 753.369,62.17 749.712,58.513 C735.083,51.198 716.798,47.542 698.512,47.542 C687.541,47.542 672.912,51.199 661.94,54.857 C658.283,65.829 654.626,73.142 654.626,84.114 C654.626,91.428 658.283,98.743 661.94,102.399 C669.254,109.713 680.225,113.371 691.197,117.028 L727.769,128 C742.398,131.657 757.026,142.629 767.997,153.6 C775.311,164.571 782.626,179.2 778.968,193.828 C778.968,204.799 775.311,215.771 771.654,223.085 C767.997,234.056 760.683,241.37 753.369,245.028 C746.055,252.343 735.084,255.999 724.112,259.656 C713.14,263.313 702.169,266.971 687.54,266.971 L687.543,266.971 Z",id:"Shape"}),o.createElement("path",{d:"M738.743,398.628 C650.972,464.457 522.972,497.371 416.914,497.371 C270.628,497.371 128,446.171 21.943,347.428 C10.971,336.457 18.286,329.142 29.257,332.8 C149.943,402.286 285.257,438.857 424.228,438.857 C526.628,438.857 629.028,416.914 727.771,376.686 C742.4,369.371 753.371,387.657 738.742,398.629 L738.743,398.628 Z",id:"Shape"}),o.createElement("path",{d:"M775.314,354.743 C764.343,340.115 702.171,347.428 672.914,351.086 C665.6,351.086 661.943,343.771 669.257,340.115 C720.457,303.543 800.914,314.515 811.886,325.487 C822.858,336.459 808.229,420.572 760.686,460.802 C753.372,468.117 746.057,464.459 749.715,457.145 C764.344,427.888 786.287,369.373 775.315,354.745 L775.314,354.743 Z",id:"Shape"}))))),o.createElement("div",{className:r.loadingSceneName,"data-test":i.sumerianScene.loadingSceneName},e.sceneName),e.sceneError?o.createElement("div",{className:r.sceneErrorText,"data-test":i.sumerianScene.errorText},e.sceneError.displayText):o.createElement("div",{className:r.loadingBar,"data-test":i.sumerianScene.loadingBar},o.createElement("div",{className:r.loadingBarFill,style:{width:e.percentage+"%"}}))))}}])}));
	//# sourceMappingURL=aws-amplify-react.min.js.map

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
		module.exports = __webpack_require__(360);
	} else {
		module.exports = require('./dist/aws-amplify-react.js');
	}


/***/ },
/* 362 */
[591, 39, 7, 397, 485, 486],
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(39);
	var AWS = __webpack_require__(7);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['kinesis'] = {};
	AWS.Kinesis = Service.defineService('kinesis', ['2013-12-02']);
	Object.defineProperty(apiLoader.services['kinesis'], '2013-12-02', {
	  get: function get() {
	    var model = __webpack_require__(487);
	    model.paginators = __webpack_require__(488).pagination;
	    model.waiters = __webpack_require__(489).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Kinesis;


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(39);
	var AWS = __webpack_require__(7);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['lexruntime'] = {};
	AWS.LexRuntime = Service.defineService('lexruntime', ['2016-11-28']);
	Object.defineProperty(apiLoader.services['lexruntime'], '2016-11-28', {
	  get: function get() {
	    var model = __webpack_require__(492);
	    model.paginators = __webpack_require__(493).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.LexRuntime;


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(39);
	var AWS = __webpack_require__(7);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['pinpoint'] = {};
	AWS.Pinpoint = Service.defineService('pinpoint', ['2016-12-01']);
	Object.defineProperty(apiLoader.services['pinpoint'], '2016-12-01', {
	  get: function get() {
	    var model = __webpack_require__(491);
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Pinpoint;


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(39);
	var AWS = __webpack_require__(7);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['s3'] = {};
	AWS.S3 = Service.defineService('s3', ['2006-03-01']);
	__webpack_require__(398);
	Object.defineProperty(apiLoader.services['s3'], '2006-03-01', {
	  get: function get() {
	    var model = __webpack_require__(494);
	    model.paginators = __webpack_require__(495).pagination;
	    model.waiters = __webpack_require__(496).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.S3;


/***/ },
/* 367 */
280,
/* 368 */
[593, 369, 370, 371, 372],
/* 369 */
[594, 60],
/* 370 */
[595, 60],
/* 371 */
[596, 60],
/* 372 */
[597, 60],
/* 373 */
[599, 7, 163, 164],
/* 374 */
[602, 7, 48],
/* 375 */
[603, 7, 362, 48],
/* 376 */
[605, 7, 48],
/* 377 */
[606, 7, 48],
/* 378 */
[607, 7, 48],
/* 379 */
[608, 7, 13],
/* 380 */
[609, 381, 383],
/* 381 */
294,
/* 382 */
[610, 7],
/* 383 */
[611, 384],
/* 384 */
[612, 382, 385],
/* 385 */
[613, 7],
/* 386 */
[614, 7, 174, 379, 95, 61, 172, 173, 171],
/* 387 */
[616, 7, 165],
/* 388 */
[625, 7],
/* 389 */
[632, 13],
/* 390 */
303,
/* 391 */
[633, 13, 499],
/* 392 */
[634, 7, 406],
/* 393 */
[635, 7],
/* 394 */
[636, 7],
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(7);
	var byteLength = AWS.util.string.byteLength;
	var Buffer = AWS.util.Buffer;
	
	/**
	 * The managed uploader allows for easy and efficient uploading of buffers,
	 * blobs, or streams, using a configurable amount of concurrency to perform
	 * multipart uploads where possible. This abstraction also enables uploading
	 * streams of unknown size due to the use of multipart uploads.
	 *
	 * To construct a managed upload object, see the {constructor} function.
	 *
	 * ## Tracking upload progress
	 *
	 * The managed upload object can also track progress by attaching an
	 * 'httpUploadProgress' listener to the upload manager. This event is similar
	 * to {AWS.Request~httpUploadProgress} but groups all concurrent upload progress
	 * into a single event. See {AWS.S3.ManagedUpload~httpUploadProgress} for more
	 * information.
	 *
	 * ## Handling Multipart Cleanup
	 *
	 * By default, this class will automatically clean up any multipart uploads
	 * when an individual part upload fails. This behavior can be disabled in order
	 * to manually handle failures by setting the `leavePartsOnError` configuration
	 * option to `true` when initializing the upload object.
	 *
	 * @!event httpUploadProgress(progress)
	 *   Triggered when the uploader has uploaded more data.
	 *   @note The `total` property may not be set if the stream being uploaded has
	 *     not yet finished chunking. In this case the `total` will be undefined
	 *     until the total stream size is known.
	 *   @note This event will not be emitted in Node.js 0.8.x.
	 *   @param progress [map] An object containing the `loaded` and `total` bytes
	 *     of the request and the `key` of the S3 object. Note that `total` may be undefined until the payload
	 *     size is known.
	 *   @context (see AWS.Request~send)
	 */
	AWS.S3.ManagedUpload = AWS.util.inherit({
	  /**
	   * Creates a managed upload object with a set of configuration options.
	   *
	   * @note A "Body" parameter is required to be set prior to calling {send}.
	   * @note In Node.js, sending "Body" as {https://nodejs.org/dist/latest/docs/api/stream.html#stream_object_mode object-mode stream}
	   *   may result in upload hangs. Using buffer stream is preferable.
	   * @option options params [map] a map of parameters to pass to the upload
	   *   requests. The "Body" parameter is required to be specified either on
	   *   the service or in the params option.
	   * @note ContentMD5 should not be provided when using the managed upload object.
	   *   Instead, setting "computeChecksums" to true will enable automatic ContentMD5 generation
	   *   by the managed upload object.
	   * @option options queueSize [Number] (4) the size of the concurrent queue
	   *   manager to upload parts in parallel. Set to 1 for synchronous uploading
	   *   of parts. Note that the uploader will buffer at most queueSize * partSize
	   *   bytes into memory at any given time.
	   * @option options partSize [Number] (5mb) the size in bytes for each
	   *   individual part to be uploaded. Adjust the part size to ensure the number
	   *   of parts does not exceed {maxTotalParts}. See {minPartSize} for the
	   *   minimum allowed part size.
	   * @option options leavePartsOnError [Boolean] (false) whether to abort the
	   *   multipart upload if an error occurs. Set to true if you want to handle
	   *   failures manually.
	   * @option options service [AWS.S3] an optional S3 service object to use for
	   *   requests. This object might have bound parameters used by the uploader.
	   * @option options tags [Array<map>] The tags to apply to the uploaded object.
	   *   Each tag should have a `Key` and `Value` keys.
	   * @example Creating a default uploader for a stream object
	   *   var upload = new AWS.S3.ManagedUpload({
	   *     params: {Bucket: 'bucket', Key: 'key', Body: stream}
	   *   });
	   * @example Creating an uploader with concurrency of 1 and partSize of 10mb
	   *   var upload = new AWS.S3.ManagedUpload({
	   *     partSize: 10 * 1024 * 1024, queueSize: 1,
	   *     params: {Bucket: 'bucket', Key: 'key', Body: stream}
	   *   });
	   * @example Creating an uploader with tags
	   *   var upload = new AWS.S3.ManagedUpload({
	   *     params: {Bucket: 'bucket', Key: 'key', Body: stream},
	   *     tags: [{Key: 'tag1', Value: 'value1'}, {Key: 'tag2', Value: 'value2'}]
	   *   });
	   * @see send
	   */
	  constructor: function ManagedUpload(options) {
	    var self = this;
	    AWS.SequentialExecutor.call(self);
	    self.body = null;
	    self.sliceFn = null;
	    self.callback = null;
	    self.parts = {};
	    self.completeInfo = [];
	    self.fillQueue = function() {
	      self.callback(new Error('Unsupported body payload ' + typeof self.body));
	    };
	
	    self.configure(options);
	  },
	
	  /**
	   * @api private
	   */
	  configure: function configure(options) {
	    options = options || {};
	    this.partSize = this.minPartSize;
	
	    if (options.queueSize) this.queueSize = options.queueSize;
	    if (options.partSize) this.partSize = options.partSize;
	    if (options.leavePartsOnError) this.leavePartsOnError = true;
	    if (options.tags) {
	      if (!Array.isArray(options.tags)) {
	        throw new Error('Tags must be specified as an array; ' +
	          typeof options.tags + ' provided.');
	      }
	      this.tags = options.tags;
	    }
	
	    if (this.partSize < this.minPartSize) {
	      throw new Error('partSize must be greater than ' +
	                      this.minPartSize);
	    }
	
	    this.service = options.service;
	    this.bindServiceObject(options.params);
	    this.validateBody();
	    this.adjustTotalBytes();
	  },
	
	  /**
	   * @api private
	   */
	  leavePartsOnError: false,
	
	  /**
	   * @api private
	   */
	  queueSize: 4,
	
	  /**
	   * @api private
	   */
	  partSize: null,
	
	  /**
	   * @readonly
	   * @return [Number] the minimum number of bytes for an individual part
	   *   upload.
	   */
	  minPartSize: 1024 * 1024 * 5,
	
	  /**
	   * @readonly
	   * @return [Number] the maximum allowed number of parts in a multipart upload.
	   */
	  maxTotalParts: 10000,
	
	  /**
	   * Initiates the managed upload for the payload.
	   *
	   * @callback callback function(err, data)
	   *   @param err [Error] an error or null if no error occurred.
	   *   @param data [map] The response data from the successful upload:
	   *     * `Location` (String) the URL of the uploaded object
	   *     * `ETag` (String) the ETag of the uploaded object
	   *     * `Bucket` (String) the bucket to which the object was uploaded
	   *     * `Key` (String) the key to which the object was uploaded
	   * @example Sending a managed upload object
	   *   var params = {Bucket: 'bucket', Key: 'key', Body: stream};
	   *   var upload = new AWS.S3.ManagedUpload({params: params});
	   *   upload.send(function(err, data) {
	   *     console.log(err, data);
	   *   });
	   */
	  send: function(callback) {
	    var self = this;
	    self.failed = false;
	    self.callback = callback || function(err) { if (err) throw err; };
	
	    var runFill = true;
	    if (self.sliceFn) {
	      self.fillQueue = self.fillBuffer;
	    } else if (AWS.util.isNode()) {
	      var Stream = AWS.util.stream.Stream;
	      if (self.body instanceof Stream) {
	        runFill = false;
	        self.fillQueue = self.fillStream;
	        self.partBuffers = [];
	        self.body.
	          on('error', function(err) { self.cleanup(err); }).
	          on('readable', function() { self.fillQueue(); }).
	          on('end', function() {
	            self.isDoneChunking = true;
	            self.numParts = self.totalPartNumbers;
	            self.fillQueue.call(self);
	
	            if (self.isDoneChunking && self.totalPartNumbers >= 1 && self.doneParts === self.numParts) {
	              self.finishMultiPart();
	            }
	          });
	      }
	    }
	
	    if (runFill) self.fillQueue.call(self);
	  },
	
	  /**
	   * @!method  promise()
	   *   Returns a 'thenable' promise.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function(data)
	   *     Called if the promise is fulfilled.
	   *     @param data [map] The response data from the successful upload:
	   *       `Location` (String) the URL of the uploaded object
	   *       `ETag` (String) the ETag of the uploaded object
	   *       `Bucket` (String) the bucket to which the object was uploaded
	   *       `Key` (String) the key to which the object was uploaded
	   *   @callback rejectedCallback function(err)
	   *     Called if the promise is rejected.
	   *     @param err [Error] an error or null if no error occurred.
	   *   @return [Promise] A promise that represents the state of the upload request.
	   *   @example Sending an upload request using promises.
	   *     var upload = s3.upload({Bucket: 'bucket', Key: 'key', Body: stream});
	   *     var promise = upload.promise();
	   *     promise.then(function(data) { ... }, function(err) { ... });
	   */
	
	  /**
	   * Aborts a managed upload, including all concurrent upload requests.
	   * @note By default, calling this function will cleanup a multipart upload
	   *   if one was created. To leave the multipart upload around after aborting
	   *   a request, configure `leavePartsOnError` to `true` in the {constructor}.
	   * @note Calling {abort} in the browser environment will not abort any requests
	   *   that are already in flight. If a multipart upload was created, any parts
	   *   not yet uploaded will not be sent, and the multipart upload will be cleaned up.
	   * @example Aborting an upload
	   *   var params = {
	   *     Bucket: 'bucket', Key: 'key',
	   *     Body: Buffer.alloc(1024 * 1024 * 25) // 25MB payload
	   *   };
	   *   var upload = s3.upload(params);
	   *   upload.send(function (err, data) {
	   *     if (err) console.log("Error:", err.code, err.message);
	   *     else console.log(data);
	   *   });
	   *
	   *   // abort request in 1 second
	   *   setTimeout(upload.abort.bind(upload), 1000);
	   */
	  abort: function() {
	    var self = this;
	    //abort putObject request
	    if (self.isDoneChunking === true && self.totalPartNumbers === 1 && self.singlePart) {
	      self.singlePart.abort();
	    } else {
	      self.cleanup(AWS.util.error(new Error('Request aborted by user'), {
	        code: 'RequestAbortedError', retryable: false
	      }));
	    }
	  },
	
	  /**
	   * @api private
	   */
	  validateBody: function validateBody() {
	    var self = this;
	    self.body = self.service.config.params.Body;
	    if (typeof self.body === 'string') {
	      self.body = AWS.util.buffer.toBuffer(self.body);
	    } else if (!self.body) {
	      throw new Error('params.Body is required');
	    }
	    self.sliceFn = AWS.util.arraySliceFn(self.body);
	  },
	
	  /**
	   * @api private
	   */
	  bindServiceObject: function bindServiceObject(params) {
	    params = params || {};
	    var self = this;
	    // bind parameters to new service object
	    if (!self.service) {
	      self.service = new AWS.S3({params: params});
	    } else {
	      var service = self.service;
	      var config = AWS.util.copy(service.config);
	      config.signatureVersion = service.getSignatureVersion();
	      self.service = new service.constructor.__super__(config);
	      self.service.config.params =
	        AWS.util.merge(self.service.config.params || {}, params);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  adjustTotalBytes: function adjustTotalBytes() {
	    var self = this;
	    try { // try to get totalBytes
	      self.totalBytes = byteLength(self.body);
	    } catch (e) { }
	
	    // try to adjust partSize if we know payload length
	    if (self.totalBytes) {
	      var newPartSize = Math.ceil(self.totalBytes / self.maxTotalParts);
	      if (newPartSize > self.partSize) self.partSize = newPartSize;
	    } else {
	      self.totalBytes = undefined;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  isDoneChunking: false,
	
	  /**
	   * @api private
	   */
	  partPos: 0,
	
	  /**
	   * @api private
	   */
	  totalChunkedBytes: 0,
	
	  /**
	   * @api private
	   */
	  totalUploadedBytes: 0,
	
	  /**
	   * @api private
	   */
	  totalBytes: undefined,
	
	  /**
	   * @api private
	   */
	  numParts: 0,
	
	  /**
	   * @api private
	   */
	  totalPartNumbers: 0,
	
	  /**
	   * @api private
	   */
	  activeParts: 0,
	
	  /**
	   * @api private
	   */
	  doneParts: 0,
	
	  /**
	   * @api private
	   */
	  parts: null,
	
	  /**
	   * @api private
	   */
	  completeInfo: null,
	
	  /**
	   * @api private
	   */
	  failed: false,
	
	  /**
	   * @api private
	   */
	  multipartReq: null,
	
	  /**
	   * @api private
	   */
	  partBuffers: null,
	
	  /**
	   * @api private
	   */
	  partBufferLength: 0,
	
	  /**
	   * @api private
	   */
	  fillBuffer: function fillBuffer() {
	    var self = this;
	    var bodyLen = byteLength(self.body);
	
	    if (bodyLen === 0) {
	      self.isDoneChunking = true;
	      self.numParts = 1;
	      self.nextChunk(self.body);
	      return;
	    }
	
	    while (self.activeParts < self.queueSize && self.partPos < bodyLen) {
	      var endPos = Math.min(self.partPos + self.partSize, bodyLen);
	      var buf = self.sliceFn.call(self.body, self.partPos, endPos);
	      self.partPos += self.partSize;
	
	      if (byteLength(buf) < self.partSize || self.partPos === bodyLen) {
	        self.isDoneChunking = true;
	        self.numParts = self.totalPartNumbers + 1;
	      }
	      self.nextChunk(buf);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  fillStream: function fillStream() {
	    var self = this;
	    if (self.activeParts >= self.queueSize) return;
	
	    var buf = self.body.read(self.partSize - self.partBufferLength) ||
	              self.body.read();
	    if (buf) {
	      self.partBuffers.push(buf);
	      self.partBufferLength += buf.length;
	      self.totalChunkedBytes += buf.length;
	    }
	
	    if (self.partBufferLength >= self.partSize) {
	      // if we have single buffer we avoid copyfull concat
	      var pbuf = self.partBuffers.length === 1 ?
	        self.partBuffers[0] : Buffer.concat(self.partBuffers);
	      self.partBuffers = [];
	      self.partBufferLength = 0;
	
	      // if we have more than partSize, push the rest back on the queue
	      if (pbuf.length > self.partSize) {
	        var rest = pbuf.slice(self.partSize);
	        self.partBuffers.push(rest);
	        self.partBufferLength += rest.length;
	        pbuf = pbuf.slice(0, self.partSize);
	      }
	
	      self.nextChunk(pbuf);
	    }
	
	    if (self.isDoneChunking && !self.isDoneSending) {
	      // if we have single buffer we avoid copyfull concat
	      pbuf = self.partBuffers.length === 1 ?
	          self.partBuffers[0] : Buffer.concat(self.partBuffers);
	      self.partBuffers = [];
	      self.partBufferLength = 0;
	      self.totalBytes = self.totalChunkedBytes;
	      self.isDoneSending = true;
	
	      if (self.numParts === 0 || pbuf.length > 0) {
	        self.numParts++;
	        self.nextChunk(pbuf);
	      }
	    }
	
	    self.body.read(0);
	  },
	
	  /**
	   * @api private
	   */
	  nextChunk: function nextChunk(chunk) {
	    var self = this;
	    if (self.failed) return null;
	
	    var partNumber = ++self.totalPartNumbers;
	    if (self.isDoneChunking && partNumber === 1) {
	      var params = {Body: chunk};
	      if (this.tags) {
	        params.Tagging = this.getTaggingHeader();
	      }
	      var req = self.service.putObject(params);
	      req._managedUpload = self;
	      req.on('httpUploadProgress', self.progress).send(self.finishSinglePart);
	      self.singlePart = req; //save the single part request
	      return null;
	    } else if (self.service.config.params.ContentMD5) {
	      var err = AWS.util.error(new Error('The Content-MD5 you specified is invalid for multi-part uploads.'), {
	        code: 'InvalidDigest', retryable: false
	      });
	
	      self.cleanup(err);
	      return null;
	    }
	
	    if (self.completeInfo[partNumber] && self.completeInfo[partNumber].ETag !== null) {
	      return null; // Already uploaded this part.
	    }
	
	    self.activeParts++;
	    if (!self.service.config.params.UploadId) {
	
	      if (!self.multipartReq) { // create multipart
	        self.multipartReq = self.service.createMultipartUpload();
	        self.multipartReq.on('success', function(resp) {
	          self.service.config.params.UploadId = resp.data.UploadId;
	          self.multipartReq = null;
	        });
	        self.queueChunks(chunk, partNumber);
	        self.multipartReq.on('error', function(err) {
	          self.cleanup(err);
	        });
	        self.multipartReq.send();
	      } else {
	        self.queueChunks(chunk, partNumber);
	      }
	    } else { // multipart is created, just send
	      self.uploadPart(chunk, partNumber);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getTaggingHeader: function getTaggingHeader() {
	    var kvPairStrings = [];
	    for (var i = 0; i < this.tags.length; i++) {
	      kvPairStrings.push(AWS.util.uriEscape(this.tags[i].Key) + '=' +
	        AWS.util.uriEscape(this.tags[i].Value));
	    }
	
	    return kvPairStrings.join('&');
	  },
	
	  /**
	   * @api private
	   */
	  uploadPart: function uploadPart(chunk, partNumber) {
	    var self = this;
	
	    var partParams = {
	      Body: chunk,
	      ContentLength: AWS.util.string.byteLength(chunk),
	      PartNumber: partNumber
	    };
	
	    var partInfo = {ETag: null, PartNumber: partNumber};
	    self.completeInfo[partNumber] = partInfo;
	
	    var req = self.service.uploadPart(partParams);
	    self.parts[partNumber] = req;
	    req._lastUploadedBytes = 0;
	    req._managedUpload = self;
	    req.on('httpUploadProgress', self.progress);
	    req.send(function(err, data) {
	      delete self.parts[partParams.PartNumber];
	      self.activeParts--;
	
	      if (!err && (!data || !data.ETag)) {
	        var message = 'No access to ETag property on response.';
	        if (AWS.util.isBrowser()) {
	          message += ' Check CORS configuration to expose ETag header.';
	        }
	
	        err = AWS.util.error(new Error(message), {
	          code: 'ETagMissing', retryable: false
	        });
	      }
	      if (err) return self.cleanup(err);
	      //prevent sending part being returned twice (https://github.com/aws/aws-sdk-js/issues/2304)
	      if (self.completeInfo[partNumber] && self.completeInfo[partNumber].ETag !== null) return null;
	      partInfo.ETag = data.ETag;
	      self.doneParts++;
	      if (self.isDoneChunking && self.doneParts === self.numParts) {
	        self.finishMultiPart();
	      } else {
	        self.fillQueue.call(self);
	      }
	    });
	  },
	
	  /**
	   * @api private
	   */
	  queueChunks: function queueChunks(chunk, partNumber) {
	    var self = this;
	    self.multipartReq.on('success', function() {
	      self.uploadPart(chunk, partNumber);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  cleanup: function cleanup(err) {
	    var self = this;
	    if (self.failed) return;
	
	    // clean up stream
	    if (typeof self.body.removeAllListeners === 'function' &&
	        typeof self.body.resume === 'function') {
	      self.body.removeAllListeners('readable');
	      self.body.removeAllListeners('end');
	      self.body.resume();
	    }
	
	    // cleanup multipartReq listeners
	    if (self.multipartReq) {
	      self.multipartReq.removeAllListeners('success');
	      self.multipartReq.removeAllListeners('error');
	      self.multipartReq.removeAllListeners('complete');
	      delete self.multipartReq;
	    }
	
	    if (self.service.config.params.UploadId && !self.leavePartsOnError) {
	      self.service.abortMultipartUpload().send();
	    } else if (self.leavePartsOnError) {
	      self.isDoneChunking = false;
	    }
	
	    AWS.util.each(self.parts, function(partNumber, part) {
	      part.removeAllListeners('complete');
	      part.abort();
	    });
	
	    self.activeParts = 0;
	    self.partPos = 0;
	    self.numParts = 0;
	    self.totalPartNumbers = 0;
	    self.parts = {};
	    self.failed = true;
	    self.callback(err);
	  },
	
	  /**
	   * @api private
	   */
	  finishMultiPart: function finishMultiPart() {
	    var self = this;
	    var completeParams = { MultipartUpload: { Parts: self.completeInfo.slice(1) } };
	    self.service.completeMultipartUpload(completeParams, function(err, data) {
	      if (err) {
	        return self.cleanup(err);
	      }
	
	      if (data && typeof data.Location === 'string') {
	        data.Location = data.Location.replace(/%2F/g, '/');
	      }
	
	      if (Array.isArray(self.tags)) {
	        for (var i = 0; i < self.tags.length; i++) {
	          self.tags[i].Value = String(self.tags[i].Value);
	        }
	        self.service.putObjectTagging(
	          {Tagging: {TagSet: self.tags}},
	          function(e, d) {
	            if (e) {
	              self.callback(e);
	            } else {
	              self.callback(e, data);
	            }
	          }
	        );
	      } else {
	        self.callback(err, data);
	      }
	    });
	  },
	
	  /**
	   * @api private
	   */
	  finishSinglePart: function finishSinglePart(err, data) {
	    var upload = this.request._managedUpload;
	    var httpReq = this.request.httpRequest;
	    var endpoint = httpReq.endpoint;
	    if (err) return upload.callback(err);
	    data.Location =
	      [endpoint.protocol, '//', endpoint.host, httpReq.path].join('');
	    data.key = this.request.params.Key; // will stay undocumented
	    data.Key = this.request.params.Key;
	    data.Bucket = this.request.params.Bucket;
	    upload.callback(err, data);
	  },
	
	  /**
	   * @api private
	   */
	  progress: function progress(info) {
	    var upload = this._managedUpload;
	    if (this.operation === 'putObject') {
	      info.part = 1;
	      info.key = this.params.Key;
	    } else {
	      upload.totalUploadedBytes += info.loaded - this._lastUploadedBytes;
	      this._lastUploadedBytes = info.loaded;
	      info = {
	        loaded: upload.totalUploadedBytes,
	        total: upload.totalBytes,
	        part: this.params.PartNumber,
	        key: this.params.Key
	      };
	    }
	    upload.emit('httpUploadProgress', [info]);
	  }
	});
	
	AWS.util.mixin(AWS.S3.ManagedUpload, AWS.SequentialExecutor);
	
	/**
	 * @api private
	 */
	AWS.S3.ManagedUpload.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.promise = AWS.util.promisifyMethod('send', PromiseDependency);
	};
	
	/**
	 * @api private
	 */
	AWS.S3.ManagedUpload.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.promise;
	};
	
	AWS.util.addPromises(AWS.S3.ManagedUpload);
	
	/**
	 * @api private
	 */
	module.exports = AWS.S3.ManagedUpload;


/***/ },
/* 396 */
[638, 7, 166, 391],
/* 397 */
[639, 7],
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(7);
	var v4Credentials = __webpack_require__(176);
	
	// Pull in managed upload extension
	__webpack_require__(395);
	
	/**
	 * @api private
	 */
	var operationsWith200StatusCodeError = {
	  'completeMultipartUpload': true,
	  'copyObject': true,
	  'uploadPartCopy': true
	};
	
	/**
	 * @api private
	 */
	 var regionRedirectErrorCodes = [
	  'AuthorizationHeaderMalformed', // non-head operations on virtual-hosted global bucket endpoints
	  'BadRequest', // head operations on virtual-hosted global bucket endpoints
	  'PermanentRedirect', // non-head operations on path-style or regional endpoints
	  301 // head operations on path-style or regional endpoints
	 ];
	
	AWS.util.update(AWS.S3.prototype, {
	  /**
	   * @api private
	   */
	  getSignatureVersion: function getSignatureVersion(request) {
	    var defaultApiVersion = this.api.signatureVersion;
	    var userDefinedVersion = this._originalConfig ? this._originalConfig.signatureVersion : null;
	    var regionDefinedVersion = this.config.signatureVersion;
	    var isPresigned = request ? request.isPresigned() : false;
	    /*
	      1) User defined version specified:
	        a) always return user defined version
	      2) No user defined version specified:
	        a) default to lowest version the region supports
	        b) If using presigned urls, default to lowest version the region supports
	    */
	    if (userDefinedVersion) {
	      userDefinedVersion = userDefinedVersion === 'v2' ? 's3' : userDefinedVersion;
	      return userDefinedVersion;
	    }
	    if (isPresigned !== true) {
	      defaultApiVersion = 'v4';
	    } else if (regionDefinedVersion) {
	      defaultApiVersion = regionDefinedVersion;
	    }
	    return defaultApiVersion;
	  },
	
	  /**
	   * @api private
	   */
	  getSignerClass: function getSignerClass(request) {
	    var signatureVersion = this.getSignatureVersion(request);
	    return AWS.Signers.RequestSigner.getVersion(signatureVersion);
	  },
	
	  /**
	   * @api private
	   */
	  validateService: function validateService() {
	    var msg;
	    var messages = [];
	
	    // default to us-east-1 when no region is provided
	    if (!this.config.region) this.config.region = 'us-east-1';
	
	    if (!this.config.endpoint && this.config.s3BucketEndpoint) {
	      messages.push('An endpoint must be provided when configuring ' +
	                    '`s3BucketEndpoint` to true.');
	    }
	    if (messages.length === 1) {
	      msg = messages[0];
	    } else if (messages.length > 1) {
	      msg = 'Multiple configuration errors:\n' + messages.join('\n');
	    }
	    if (msg) {
	      throw AWS.util.error(new Error(),
	        {name: 'InvalidEndpoint', message: msg});
	    }
	  },
	
	  /**
	   * @api private
	   */
	  shouldDisableBodySigning: function shouldDisableBodySigning(request) {
	    var signerClass = this.getSignerClass();
	    if (this.config.s3DisableBodySigning === true && signerClass === AWS.Signers.V4
	        && request.httpRequest.endpoint.protocol === 'https:') {
	      return true;
	    }
	    return false;
	  },
	
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    var prependListener = true;
	    request.addListener('validate', this.validateScheme);
	    request.addListener('validate', this.validateBucketEndpoint);
	    request.addListener('validate', this.correctBucketRegionFromCache);
	    request.addListener('validate', this.validateBucketName, prependListener);
	
	    request.addListener('build', this.addContentType);
	    request.addListener('build', this.populateURI);
	    request.addListener('build', this.computeContentMd5);
	    request.addListener('build', this.computeSseCustomerKeyMd5);
	    request.addListener('afterBuild', this.addExpect100Continue);
	    request.removeListener('validate',
	      AWS.EventListeners.Core.VALIDATE_REGION);
	    request.addListener('extractError', this.extractError);
	    request.onAsync('extractError', this.requestBucketRegion);
	    request.addListener('extractData', this.extractData);
	    request.addListener('extractData', AWS.util.hoistPayloadMember);
	    request.addListener('beforePresign', this.prepareSignedUrl);
	    if (AWS.util.isBrowser()) {
	      request.onAsync('retry', this.reqRegionForNetworkingError);
	    }
	    if (this.shouldDisableBodySigning(request))  {
	      request.removeListener('afterBuild', AWS.EventListeners.Core.COMPUTE_SHA256);
	      request.addListener('afterBuild', this.disableBodySigning);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  validateScheme: function(req) {
	    var params = req.params,
	        scheme = req.httpRequest.endpoint.protocol,
	        sensitive = params.SSECustomerKey || params.CopySourceSSECustomerKey;
	    if (sensitive && scheme !== 'https:') {
	      var msg = 'Cannot send SSE keys over HTTP. Set \'sslEnabled\'' +
	        'to \'true\' in your configuration';
	      throw AWS.util.error(new Error(),
	        { code: 'ConfigError', message: msg });
	    }
	  },
	
	  /**
	   * @api private
	   */
	  validateBucketEndpoint: function(req) {
	    if (!req.params.Bucket && req.service.config.s3BucketEndpoint) {
	      var msg = 'Cannot send requests to root API with `s3BucketEndpoint` set.';
	      throw AWS.util.error(new Error(),
	        { code: 'ConfigError', message: msg });
	    }
	  },
	
	  /**
	   * @api private
	   */
	  validateBucketName: function validateBucketName(req) {
	    var service = req.service;
	    var signatureVersion = service.getSignatureVersion(req);
	    var bucket = req.params && req.params.Bucket;
	    var key = req.params && req.params.Key;
	    var slashIndex = bucket && bucket.indexOf('/');
	    if (bucket && slashIndex >= 0) {
	      if (typeof key === 'string' && slashIndex > 0) {
	        req.params = AWS.util.copy(req.params);
	        // Need to include trailing slash to match sigv2 behavior
	        var prefix = bucket.substr(slashIndex + 1) || '';
	        req.params.Key = prefix + '/' + key;
	        req.params.Bucket = bucket.substr(0, slashIndex);
	      } else if (signatureVersion === 'v4') {
	        var msg = 'Bucket names cannot contain forward slashes. Bucket: ' + bucket;
	        throw AWS.util.error(new Error(),
	          { code: 'InvalidBucket', message: msg });
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  isValidAccelerateOperation: function isValidAccelerateOperation(operation) {
	    var invalidOperations = [
	      'createBucket',
	      'deleteBucket',
	      'listBuckets'
	    ];
	    return invalidOperations.indexOf(operation) === -1;
	  },
	
	
	  /**
	   * S3 prefers dns-compatible bucket names to be moved from the uri path
	   * to the hostname as a sub-domain.  This is not possible, even for dns-compat
	   * buckets when using SSL and the bucket name contains a dot ('.').  The
	   * ssl wildcard certificate is only 1-level deep.
	   *
	   * @api private
	   */
	  populateURI: function populateURI(req) {
	    var httpRequest = req.httpRequest;
	    var b = req.params.Bucket;
	    var service = req.service;
	    var endpoint = httpRequest.endpoint;
	    if (b) {
	      if (!service.pathStyleBucketName(b)) {
	        if (service.config.useAccelerateEndpoint && service.isValidAccelerateOperation(req.operation)) {
	          if (service.config.useDualstack) {
	            endpoint.hostname = b + '.s3-accelerate.dualstack.amazonaws.com';
	          } else {
	            endpoint.hostname = b + '.s3-accelerate.amazonaws.com';
	          }
	        } else if (!service.config.s3BucketEndpoint) {
	          endpoint.hostname =
	            b + '.' + endpoint.hostname;
	        }
	
	        var port = endpoint.port;
	        if (port !== 80 && port !== 443) {
	          endpoint.host = endpoint.hostname + ':' +
	            endpoint.port;
	        } else {
	          endpoint.host = endpoint.hostname;
	        }
	
	        httpRequest.virtualHostedBucket = b; // needed for signing the request
	        service.removeVirtualHostedBucketFromPath(req);
	      }
	    }
	  },
	
	  /**
	   * Takes the bucket name out of the path if bucket is virtual-hosted
	   *
	   * @api private
	   */
	  removeVirtualHostedBucketFromPath: function removeVirtualHostedBucketFromPath(req) {
	    var httpRequest = req.httpRequest;
	    var bucket = httpRequest.virtualHostedBucket;
	    if (bucket && httpRequest.path) {
	      if (req.params && req.params.Key) {
	        var encodedS3Key = '/' + AWS.util.uriEscapePath(req.params.Key);
	        if (httpRequest.path.indexOf(encodedS3Key) === 0 && (httpRequest.path.length === encodedS3Key.length || httpRequest.path[encodedS3Key.length] === '?')) {
	          //path only contains key or path contains only key and querystring
	          return;
	        }
	      }
	      httpRequest.path = httpRequest.path.replace(new RegExp('/' + bucket), '');
	      if (httpRequest.path[0] !== '/') {
	        httpRequest.path = '/' + httpRequest.path;
	      }
	    }
	  },
	
	  /**
	   * Adds Expect: 100-continue header if payload is greater-or-equal 1MB
	   * @api private
	   */
	  addExpect100Continue: function addExpect100Continue(req) {
	    var len = req.httpRequest.headers['Content-Length'];
	    if (AWS.util.isNode() && (len >= 1024 * 1024 || req.params.Body instanceof AWS.util.stream.Stream)) {
	      req.httpRequest.headers['Expect'] = '100-continue';
	    }
	  },
	
	  /**
	   * Adds a default content type if none is supplied.
	   *
	   * @api private
	   */
	  addContentType: function addContentType(req) {
	    var httpRequest = req.httpRequest;
	    if (httpRequest.method === 'GET' || httpRequest.method === 'HEAD') {
	      // Content-Type is not set in GET/HEAD requests
	      delete httpRequest.headers['Content-Type'];
	      return;
	    }
	
	    if (!httpRequest.headers['Content-Type']) { // always have a Content-Type
	      httpRequest.headers['Content-Type'] = 'application/octet-stream';
	    }
	
	    var contentType = httpRequest.headers['Content-Type'];
	    if (AWS.util.isBrowser()) {
	      if (typeof httpRequest.body === 'string' && !contentType.match(/;\s*charset=/)) {
	        var charset = '; charset=UTF-8';
	        httpRequest.headers['Content-Type'] += charset;
	      } else {
	        var replaceFn = function(_, prefix, charsetName) {
	          return prefix + charsetName.toUpperCase();
	        };
	
	        httpRequest.headers['Content-Type'] =
	          contentType.replace(/(;\s*charset=)(.+)$/, replaceFn);
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  computableChecksumOperations: {
	    putBucketCors: true,
	    putBucketLifecycle: true,
	    putBucketLifecycleConfiguration: true,
	    putBucketTagging: true,
	    deleteObjects: true,
	    putBucketReplication: true,
	    putObjectLegalHold: true,
	    putObjectRetention: true,
	    putObjectLockConfiguration: true
	  },
	
	  /**
	   * Checks whether checksums should be computed for the request.
	   * If the request requires checksums to be computed, this will always
	   * return true, otherwise it depends on whether {AWS.Config.computeChecksums}
	   * is set.
	   *
	   * @param req [AWS.Request] the request to check against
	   * @return [Boolean] whether to compute checksums for a request.
	   * @api private
	   */
	  willComputeChecksums: function willComputeChecksums(req) {
	    if (this.computableChecksumOperations[req.operation]) return true;
	    if (!this.config.computeChecksums) return false;
	
	    // TODO: compute checksums for Stream objects
	    if (!AWS.util.Buffer.isBuffer(req.httpRequest.body) &&
	        typeof req.httpRequest.body !== 'string') {
	      return false;
	    }
	
	    var rules = req.service.api.operations[req.operation].input.members;
	
	    // Sha256 signing disabled, and not a presigned url
	    if (req.service.shouldDisableBodySigning(req) && !Object.prototype.hasOwnProperty.call(req.httpRequest.headers, 'presigned-expires')) {
	      if (rules.ContentMD5 && !req.params.ContentMD5) {
	        return true;
	      }
	    }
	
	    // V4 signer uses SHA256 signatures so only compute MD5 if it is required
	    if (req.service.getSignerClass(req) === AWS.Signers.V4) {
	      if (rules.ContentMD5 && !rules.ContentMD5.required) return false;
	    }
	
	    if (rules.ContentMD5 && !req.params.ContentMD5) return true;
	  },
	
	  /**
	   * A listener that computes the Content-MD5 and sets it in the header.
	   * @see AWS.S3.willComputeChecksums
	   * @api private
	   */
	  computeContentMd5: function computeContentMd5(req) {
	    if (req.service.willComputeChecksums(req)) {
	      var md5 = AWS.util.crypto.md5(req.httpRequest.body, 'base64');
	      req.httpRequest.headers['Content-MD5'] = md5;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  computeSseCustomerKeyMd5: function computeSseCustomerKeyMd5(req) {
	    var keys = {
	      SSECustomerKey: 'x-amz-server-side-encryption-customer-key-MD5',
	      CopySourceSSECustomerKey: 'x-amz-copy-source-server-side-encryption-customer-key-MD5'
	    };
	    AWS.util.each(keys, function(key, header) {
	      if (req.params[key]) {
	        var value = AWS.util.crypto.md5(req.params[key], 'base64');
	        req.httpRequest.headers[header] = value;
	      }
	    });
	  },
	
	  /**
	   * Returns true if the bucket name should be left in the URI path for
	   * a request to S3.  This function takes into account the current
	   * endpoint protocol (e.g. http or https).
	   *
	   * @api private
	   */
	  pathStyleBucketName: function pathStyleBucketName(bucketName) {
	    // user can force path style requests via the configuration
	    if (this.config.s3ForcePathStyle) return true;
	    if (this.config.s3BucketEndpoint) return false;
	
	    if (this.dnsCompatibleBucketName(bucketName)) {
	      return (this.config.sslEnabled && bucketName.match(/\./)) ? true : false;
	    } else {
	      return true; // not dns compatible names must always use path style
	    }
	  },
	
	  /**
	   * Returns true if the bucket name is DNS compatible.  Buckets created
	   * outside of the classic region MUST be DNS compatible.
	   *
	   * @api private
	   */
	  dnsCompatibleBucketName: function dnsCompatibleBucketName(bucketName) {
	    var b = bucketName;
	    var domain = new RegExp(/^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/);
	    var ipAddress = new RegExp(/(\d+\.){3}\d+/);
	    var dots = new RegExp(/\.\./);
	    return (b.match(domain) && !b.match(ipAddress) && !b.match(dots)) ? true : false;
	  },
	
	  /**
	   * @return [Boolean] whether response contains an error
	   * @api private
	   */
	  successfulResponse: function successfulResponse(resp) {
	    var req = resp.request;
	    var httpResponse = resp.httpResponse;
	    if (operationsWith200StatusCodeError[req.operation] &&
	        httpResponse.body.toString().match('<Error>')) {
	      return false;
	    } else {
	      return httpResponse.statusCode < 300;
	    }
	  },
	
	  /**
	   * @return [Boolean] whether the error can be retried
	   * @api private
	   */
	  retryableError: function retryableError(error, request) {
	    if (operationsWith200StatusCodeError[request.operation] &&
	        error.statusCode === 200) {
	      return true;
	    } else if (request._requestRegionForBucket &&
	        request.service.bucketRegionCache[request._requestRegionForBucket]) {
	      return false;
	    } else if (error && error.code === 'RequestTimeout') {
	      return true;
	    } else if (error &&
	        regionRedirectErrorCodes.indexOf(error.code) != -1 &&
	        error.region && error.region != request.httpRequest.region) {
	      request.httpRequest.region = error.region;
	      if (error.statusCode === 301) {
	        request.service.updateReqBucketRegion(request);
	      }
	      return true;
	    } else {
	      var _super = AWS.Service.prototype.retryableError;
	      return _super.call(this, error, request);
	    }
	  },
	
	  /**
	   * Updates httpRequest with region. If region is not provided, then
	   * the httpRequest will be updated based on httpRequest.region
	   *
	   * @api private
	   */
	  updateReqBucketRegion: function updateReqBucketRegion(request, region) {
	    var httpRequest = request.httpRequest;
	    if (typeof region === 'string' && region.length) {
	      httpRequest.region = region;
	    }
	    if (!httpRequest.endpoint.host.match(/s3(?!-accelerate).*\.amazonaws\.com$/)) {
	      return;
	    }
	    var service = request.service;
	    var s3Config = service.config;
	    var s3BucketEndpoint = s3Config.s3BucketEndpoint;
	    if (s3BucketEndpoint) {
	      delete s3Config.s3BucketEndpoint;
	    }
	    var newConfig = AWS.util.copy(s3Config);
	    delete newConfig.endpoint;
	    newConfig.region = httpRequest.region;
	
	    httpRequest.endpoint = (new AWS.S3(newConfig)).endpoint;
	    service.populateURI(request);
	    s3Config.s3BucketEndpoint = s3BucketEndpoint;
	    httpRequest.headers.Host = httpRequest.endpoint.host;
	
	    if (request._asm.currentState === 'validate') {
	      request.removeListener('build', service.populateURI);
	      request.addListener('build', service.removeVirtualHostedBucketFromPath);
	    }
	  },
	
	  /**
	   * Provides a specialized parser for getBucketLocation -- all other
	   * operations are parsed by the super class.
	   *
	   * @api private
	   */
	  extractData: function extractData(resp) {
	    var req = resp.request;
	    if (req.operation === 'getBucketLocation') {
	      var match = resp.httpResponse.body.toString().match(/>(.+)<\/Location/);
	      delete resp.data['_'];
	      if (match) {
	        resp.data.LocationConstraint = match[1];
	      } else {
	        resp.data.LocationConstraint = '';
	      }
	    }
	    var bucket = req.params.Bucket || null;
	    if (req.operation === 'deleteBucket' && typeof bucket === 'string' && !resp.error) {
	      req.service.clearBucketRegionCache(bucket);
	    } else {
	      var headers = resp.httpResponse.headers || {};
	      var region = headers['x-amz-bucket-region'] || null;
	      if (!region && req.operation === 'createBucket' && !resp.error) {
	        var createBucketConfiguration = req.params.CreateBucketConfiguration;
	        if (!createBucketConfiguration) {
	          region = 'us-east-1';
	        } else if (createBucketConfiguration.LocationConstraint === 'EU') {
	          region = 'eu-west-1';
	        } else {
	          region = createBucketConfiguration.LocationConstraint;
	        }
	      }
	      if (region) {
	          if (bucket && region !== req.service.bucketRegionCache[bucket]) {
	            req.service.bucketRegionCache[bucket] = region;
	          }
	      }
	    }
	    req.service.extractRequestIds(resp);
	  },
	
	  /**
	   * Extracts an error object from the http response.
	   *
	   * @api private
	   */
	  extractError: function extractError(resp) {
	    var codes = {
	      304: 'NotModified',
	      403: 'Forbidden',
	      400: 'BadRequest',
	      404: 'NotFound'
	    };
	
	    var req = resp.request;
	    var code = resp.httpResponse.statusCode;
	    var body = resp.httpResponse.body || '';
	
	    var headers = resp.httpResponse.headers || {};
	    var region = headers['x-amz-bucket-region'] || null;
	    var bucket = req.params.Bucket || null;
	    var bucketRegionCache = req.service.bucketRegionCache;
	    if (region && bucket && region !== bucketRegionCache[bucket]) {
	      bucketRegionCache[bucket] = region;
	    }
	
	    var cachedRegion;
	    if (codes[code] && body.length === 0) {
	      if (bucket && !region) {
	        cachedRegion = bucketRegionCache[bucket] || null;
	        if (cachedRegion !== req.httpRequest.region) {
	          region = cachedRegion;
	        }
	      }
	      resp.error = AWS.util.error(new Error(), {
	        code: codes[code],
	        message: null,
	        region: region
	      });
	    } else {
	      var data = new AWS.XML.Parser().parse(body.toString());
	
	      if (data.Region && !region) {
	        region = data.Region;
	        if (bucket && region !== bucketRegionCache[bucket]) {
	          bucketRegionCache[bucket] = region;
	        }
	      } else if (bucket && !region && !data.Region) {
	        cachedRegion = bucketRegionCache[bucket] || null;
	        if (cachedRegion !== req.httpRequest.region) {
	          region = cachedRegion;
	        }
	      }
	
	      resp.error = AWS.util.error(new Error(), {
	        code: data.Code || code,
	        message: data.Message || null,
	        region: region
	      });
	    }
	    req.service.extractRequestIds(resp);
	  },
	
	  /**
	   * If region was not obtained synchronously, then send async request
	   * to get bucket region for errors resulting from wrong region.
	   *
	   * @api private
	   */
	  requestBucketRegion: function requestBucketRegion(resp, done) {
	    var error = resp.error;
	    var req = resp.request;
	    var bucket = req.params.Bucket || null;
	
	    if (!error || !bucket || error.region || req.operation === 'listObjects' ||
	        (AWS.util.isNode() && req.operation === 'headBucket') ||
	        (error.statusCode === 400 && req.operation !== 'headObject') ||
	        regionRedirectErrorCodes.indexOf(error.code) === -1) {
	      return done();
	    }
	    var reqOperation = AWS.util.isNode() ? 'headBucket' : 'listObjects';
	    var reqParams = {Bucket: bucket};
	    if (reqOperation === 'listObjects') reqParams.MaxKeys = 0;
	    var regionReq = req.service[reqOperation](reqParams);
	    regionReq._requestRegionForBucket = bucket;
	    regionReq.send(function() {
	      var region = req.service.bucketRegionCache[bucket] || null;
	      error.region = region;
	      done();
	    });
	  },
	
	   /**
	   * For browser only. If NetworkingError received, will attempt to obtain
	   * the bucket region.
	   *
	   * @api private
	   */
	   reqRegionForNetworkingError: function reqRegionForNetworkingError(resp, done) {
	    if (!AWS.util.isBrowser()) {
	      return done();
	    }
	    var error = resp.error;
	    var request = resp.request;
	    var bucket = request.params.Bucket;
	    if (!error || error.code !== 'NetworkingError' || !bucket ||
	        request.httpRequest.region === 'us-east-1') {
	      return done();
	    }
	    var service = request.service;
	    var bucketRegionCache = service.bucketRegionCache;
	    var cachedRegion = bucketRegionCache[bucket] || null;
	
	    if (cachedRegion && cachedRegion !== request.httpRequest.region) {
	      service.updateReqBucketRegion(request, cachedRegion);
	      done();
	    } else if (!service.dnsCompatibleBucketName(bucket)) {
	      service.updateReqBucketRegion(request, 'us-east-1');
	      if (bucketRegionCache[bucket] !== 'us-east-1') {
	        bucketRegionCache[bucket] = 'us-east-1';
	      }
	      done();
	    } else if (request.httpRequest.virtualHostedBucket) {
	      var getRegionReq = service.listObjects({Bucket: bucket, MaxKeys: 0});
	      service.updateReqBucketRegion(getRegionReq, 'us-east-1');
	      getRegionReq._requestRegionForBucket = bucket;
	
	      getRegionReq.send(function() {
	        var region = service.bucketRegionCache[bucket] || null;
	        if (region && region !== request.httpRequest.region) {
	          service.updateReqBucketRegion(request, region);
	        }
	        done();
	      });
	    } else {
	      // DNS-compatible path-style
	      // (s3ForcePathStyle or bucket name with dot over https)
	      // Cannot obtain region information for this case
	      done();
	    }
	   },
	
	  /**
	   * Cache for bucket region.
	   *
	   * @api private
	   */
	   bucketRegionCache: {},
	
	  /**
	   * Clears bucket region cache.
	   *
	   * @api private
	   */
	   clearBucketRegionCache: function(buckets) {
	    var bucketRegionCache = this.bucketRegionCache;
	    if (!buckets) {
	      buckets = Object.keys(bucketRegionCache);
	    } else if (typeof buckets === 'string') {
	      buckets = [buckets];
	    }
	    for (var i = 0; i < buckets.length; i++) {
	      delete bucketRegionCache[buckets[i]];
	    }
	    return bucketRegionCache;
	   },
	
	   /**
	    * Corrects request region if bucket's cached region is different
	    *
	    * @api private
	    */
	  correctBucketRegionFromCache: function correctBucketRegionFromCache(req) {
	    var bucket = req.params.Bucket || null;
	    if (bucket) {
	      var service = req.service;
	      var requestRegion = req.httpRequest.region;
	      var cachedRegion = service.bucketRegionCache[bucket];
	      if (cachedRegion && cachedRegion !== requestRegion) {
	        service.updateReqBucketRegion(req, cachedRegion);
	      }
	    }
	  },
	
	  /**
	   * Extracts S3 specific request ids from the http response.
	   *
	   * @api private
	   */
	  extractRequestIds: function extractRequestIds(resp) {
	    var extendedRequestId = resp.httpResponse.headers ? resp.httpResponse.headers['x-amz-id-2'] : null;
	    var cfId = resp.httpResponse.headers ? resp.httpResponse.headers['x-amz-cf-id'] : null;
	    resp.extendedRequestId = extendedRequestId;
	    resp.cfId = cfId;
	
	    if (resp.error) {
	      resp.error.requestId = resp.requestId || null;
	      resp.error.extendedRequestId = extendedRequestId;
	      resp.error.cfId = cfId;
	    }
	  },
	
	  /**
	   * Get a pre-signed URL for a given operation name.
	   *
	   * @note You must ensure that you have static or previously resolved
	   *   credentials if you call this method synchronously (with no callback),
	   *   otherwise it may not properly sign the request. If you cannot guarantee
	   *   this (you are using an asynchronous credential provider, i.e., EC2
	   *   IAM roles), you should always call this method with an asynchronous
	   *   callback.
	   * @note Not all operation parameters are supported when using pre-signed
	   *   URLs. Certain parameters, such as `SSECustomerKey`, `ACL`, `Expires`,
	   *   `ContentLength`, or `Tagging` must be provided as headers when sending a
	   *   request. If you are using pre-signed URLs to upload from a browser and
	   *   need to use these fields, see {createPresignedPost}.
	   * @note The default signer allows altering the request by adding corresponding
	   *   headers to set some parameters (e.g. Range) and these added parameters
	   *   won't be signed. You must use signatureVersion v4 to to include these
	   *   parameters in the signed portion of the URL and enforce exact matching
	   *   between headers and signed params in the URL.
	   * @note This operation cannot be used with a promise. See note above regarding
	   *   asynchronous credentials and use with a callback.
	   * @param operation [String] the name of the operation to call
	   * @param params [map] parameters to pass to the operation. See the given
	   *   operation for the expected operation parameters. In addition, you can
	   *   also pass the "Expires" parameter to inform S3 how long the URL should
	   *   work for.
	   * @option params Expires [Integer] (900) the number of seconds to expire
	   *   the pre-signed URL operation in. Defaults to 15 minutes.
	   * @param callback [Function] if a callback is provided, this function will
	   *   pass the URL as the second parameter (after the error parameter) to
	   *   the callback function.
	   * @return [String] if called synchronously (with no callback), returns the
	   *   signed URL.
	   * @return [null] nothing is returned if a callback is provided.
	   * @example Pre-signing a getObject operation (synchronously)
	   *   var params = {Bucket: 'bucket', Key: 'key'};
	   *   var url = s3.getSignedUrl('getObject', params);
	   *   console.log('The URL is', url);
	   * @example Pre-signing a putObject (asynchronously)
	   *   var params = {Bucket: 'bucket', Key: 'key'};
	   *   s3.getSignedUrl('putObject', params, function (err, url) {
	   *     console.log('The URL is', url);
	   *   });
	   * @example Pre-signing a putObject operation with a specific payload
	   *   var params = {Bucket: 'bucket', Key: 'key', Body: 'body'};
	   *   var url = s3.getSignedUrl('putObject', params);
	   *   console.log('The URL is', url);
	   * @example Passing in a 1-minute expiry time for a pre-signed URL
	   *   var params = {Bucket: 'bucket', Key: 'key', Expires: 60};
	   *   var url = s3.getSignedUrl('getObject', params);
	   *   console.log('The URL is', url); // expires in 60 seconds
	   */
	  getSignedUrl: function getSignedUrl(operation, params, callback) {
	    params = AWS.util.copy(params || {});
	    var expires = params.Expires || 900;
	
	    if (typeof expires !== 'number') {
	      throw AWS.util.error(new Error(),
	        { code: 'InvalidParameterException', message: 'The expiration must be a number, received ' + typeof expires });
	    }
	
	    delete params.Expires; // we can't validate this
	    var request = this.makeRequest(operation, params);
	
	    if (callback) {
	      AWS.util.defer(function() {
	        request.presign(expires, callback);
	      });
	    } else {
	      return request.presign(expires, callback);
	    }
	  },
	
	
	  /**
	   * Get a pre-signed POST policy to support uploading to S3 directly from an
	   * HTML form.
	   *
	   * @param params [map]
	   * @option params Bucket [String]     The bucket to which the post should be
	   *                                    uploaded
	   * @option params Expires [Integer]   (3600) The number of seconds for which
	   *                                    the presigned policy should be valid.
	   * @option params Conditions [Array]  An array of conditions that must be met
	   *                                    for the presigned policy to allow the
	   *                                    upload. This can include required tags,
	   *                                    the accepted range for content lengths,
	   *                                    etc.
	   * @see http://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-HTTPPOSTConstructPolicy.html
	   * @option params Fields [map]        Fields to include in the form. All
	   *                                    values passed in as fields will be
	   *                                    signed as exact match conditions.
	   * @param callback [Function]
	   *
	   * @note All fields passed in when creating presigned post data will be signed
	   *   as exact match conditions. Any fields that will be interpolated by S3
	   *   must be added to the fields hash after signing, and an appropriate
	   *   condition for such fields must be explicitly added to the Conditions
	   *   array passed to this function before signing.
	   *
	   * @example Presiging post data with a known key
	   *   var params = {
	   *     Bucket: 'bucket',
	   *     Fields: {
	   *       key: 'key'
	   *     }
	   *   };
	   *   s3.createPresignedPost(params, function(err, data) {
	   *     if (err) {
	   *       console.error('Presigning post data encountered an error', err);
	   *     } else {
	   *       console.log('The post data is', data);
	   *     }
	   *   });
	   *
	   * @example Presigning post data with an interpolated key
	   *   var params = {
	   *     Bucket: 'bucket',
	   *     Conditions: [
	   *       ['starts-with', '$key', 'path/to/uploads/']
	   *     ]
	   *   };
	   *   s3.createPresignedPost(params, function(err, data) {
	   *     if (err) {
	   *       console.error('Presigning post data encountered an error', err);
	   *     } else {
	   *       data.Fields.key = 'path/to/uploads/${filename}';
	   *       console.log('The post data is', data);
	   *     }
	   *   });
	   *
	   * @note You must ensure that you have static or previously resolved
	   *   credentials if you call this method synchronously (with no callback),
	   *   otherwise it may not properly sign the request. If you cannot guarantee
	   *   this (you are using an asynchronous credential provider, i.e., EC2
	   *   IAM roles), you should always call this method with an asynchronous
	   *   callback.
	   *
	   * @return [map]  If called synchronously (with no callback), returns a hash
	   *                with the url to set as the form action and a hash of fields
	   *                to include in the form.
	   * @return [null] Nothing is returned if a callback is provided.
	   *
	   * @callback callback function (err, data)
	   *  @param err [Error] the error object returned from the policy signer
	   *  @param data [map] The data necessary to construct an HTML form
	   *  @param data.url [String] The URL to use as the action of the form
	   *  @param data.fields [map] A hash of fields that must be included in the
	   *                           form for the upload to succeed. This hash will
	   *                           include the signed POST policy, your access key
	   *                           ID and security token (if present), etc. These
	   *                           may be safely included as input elements of type
	   *                           'hidden.'
	   */
	  createPresignedPost: function createPresignedPost(params, callback) {
	    if (typeof params === 'function' && callback === undefined) {
	      callback = params;
	      params = null;
	    }
	
	    params = AWS.util.copy(params || {});
	    var boundParams = this.config.params || {};
	    var bucket = params.Bucket || boundParams.Bucket,
	      self = this,
	      config = this.config,
	      endpoint = AWS.util.copy(this.endpoint);
	    if (!config.s3BucketEndpoint) {
	      endpoint.pathname = '/' + bucket;
	    }
	
	    function finalizePost() {
	      return {
	        url: AWS.util.urlFormat(endpoint),
	        fields: self.preparePostFields(
	          config.credentials,
	          config.region,
	          bucket,
	          params.Fields,
	          params.Conditions,
	          params.Expires
	        )
	      };
	    }
	
	    if (callback) {
	      config.getCredentials(function (err) {
	        if (err) {
	          callback(err);
	        }
	
	        callback(null, finalizePost());
	      });
	    } else {
	      return finalizePost();
	    }
	  },
	
	  /**
	   * @api private
	   */
	  preparePostFields: function preparePostFields(
	    credentials,
	    region,
	    bucket,
	    fields,
	    conditions,
	    expiresInSeconds
	  ) {
	    var now = this.getSkewCorrectedDate();
	    if (!credentials || !region || !bucket) {
	      throw new Error('Unable to create a POST object policy without a bucket,'
	        + ' region, and credentials');
	    }
	    fields = AWS.util.copy(fields || {});
	    conditions = (conditions || []).slice(0);
	    expiresInSeconds = expiresInSeconds || 3600;
	
	    var signingDate = AWS.util.date.iso8601(now).replace(/[:\-]|\.\d{3}/g, '');
	    var shortDate = signingDate.substr(0, 8);
	    var scope = v4Credentials.createScope(shortDate, region, 's3');
	    var credential = credentials.accessKeyId + '/' + scope;
	
	    fields['bucket'] = bucket;
	    fields['X-Amz-Algorithm'] = 'AWS4-HMAC-SHA256';
	    fields['X-Amz-Credential'] = credential;
	    fields['X-Amz-Date'] = signingDate;
	    if (credentials.sessionToken) {
	      fields['X-Amz-Security-Token'] = credentials.sessionToken;
	    }
	    for (var field in fields) {
	      if (fields.hasOwnProperty(field)) {
	        var condition = {};
	        condition[field] = fields[field];
	        conditions.push(condition);
	      }
	    }
	
	    fields.Policy = this.preparePostPolicy(
	      new Date(now.valueOf() + expiresInSeconds * 1000),
	      conditions
	    );
	    fields['X-Amz-Signature'] = AWS.util.crypto.hmac(
	      v4Credentials.getSigningKey(credentials, shortDate, region, 's3', true),
	      fields.Policy,
	      'hex'
	    );
	
	    return fields;
	  },
	
	  /**
	   * @api private
	   */
	  preparePostPolicy: function preparePostPolicy(expiration, conditions) {
	    return AWS.util.base64.encode(JSON.stringify({
	      expiration: AWS.util.date.iso8601(expiration),
	      conditions: conditions
	    }));
	  },
	
	  /**
	   * @api private
	   */
	  prepareSignedUrl: function prepareSignedUrl(request) {
	    request.addListener('validate', request.service.noPresignedContentLength);
	    request.removeListener('build', request.service.addContentType);
	    if (!request.params.Body) {
	      // no Content-MD5/SHA-256 if body is not provided
	      request.removeListener('build', request.service.computeContentMd5);
	    } else {
	      request.addListener('afterBuild', AWS.EventListeners.Core.COMPUTE_SHA256);
	    }
	  },
	
	  /**
	   * @api private
	   * @param request
	   */
	  disableBodySigning: function disableBodySigning(request) {
	    var headers = request.httpRequest.headers;
	    // Add the header to anything that isn't a presigned url, unless that presigned url had a body defined
	    if (!Object.prototype.hasOwnProperty.call(headers, 'presigned-expires')) {
	      headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
	    }
	  },
	
	  /**
	   * @api private
	   */
	  noPresignedContentLength: function noPresignedContentLength(request) {
	    if (request.params.ContentLength !== undefined) {
	      throw AWS.util.error(new Error(), {code: 'UnexpectedParameter',
	        message: 'ContentLength is not supported in pre-signed URLs.'});
	    }
	  },
	
	  createBucket: function createBucket(params, callback) {
	    // When creating a bucket *outside* the classic region, the location
	    // constraint must be set for the bucket and it must match the endpoint.
	    // This chunk of code will set the location constraint param based
	    // on the region (when possible), but it will not override a passed-in
	    // location constraint.
	    if (typeof params === 'function' || !params) {
	      callback = callback || params;
	      params = {};
	    }
	    var hostname = this.endpoint.hostname;
	    if (hostname !== this.api.globalEndpoint && !params.CreateBucketConfiguration) {
	      params.CreateBucketConfiguration = { LocationConstraint: this.config.region };
	    }
	    return this.makeRequest('createBucket', params, callback);
	  },
	
	  /**
	   * @see AWS.S3.ManagedUpload
	   * @overload upload(params = {}, [options], [callback])
	   *   Uploads an arbitrarily sized buffer, blob, or stream, using intelligent
	   *   concurrent handling of parts if the payload is large enough. You can
	   *   configure the concurrent queue size by setting `options`. Note that this
	   *   is the only operation for which the SDK can retry requests with stream
	   *   bodies.
	   *
	   *   @param (see AWS.S3.putObject)
	   *   @option (see AWS.S3.ManagedUpload.constructor)
	   *   @return [AWS.S3.ManagedUpload] the managed upload object that can call
	   *     `send()` or track progress.
	   *   @example Uploading a stream object
	   *     var params = {Bucket: 'bucket', Key: 'key', Body: stream};
	   *     s3.upload(params, function(err, data) {
	   *       console.log(err, data);
	   *     });
	   *   @example Uploading a stream with concurrency of 1 and partSize of 10mb
	   *     var params = {Bucket: 'bucket', Key: 'key', Body: stream};
	   *     var options = {partSize: 10 * 1024 * 1024, queueSize: 1};
	   *     s3.upload(params, options, function(err, data) {
	   *       console.log(err, data);
	   *     });
	   * @callback callback function(err, data)
	   *   @param err [Error] an error or null if no error occurred.
	   *   @param data [map] The response data from the successful upload:
	   *   @param data.Location [String] the URL of the uploaded object
	   *   @param data.ETag [String] the ETag of the uploaded object
	   *   @param data.Bucket [String]  the bucket to which the object was uploaded
	   *   @param data.Key [String] the key to which the object was uploaded
	   */
	  upload: function upload(params, options, callback) {
	    if (typeof options === 'function' && callback === undefined) {
	      callback = options;
	      options = null;
	    }
	
	    options = options || {};
	    options = AWS.util.merge(options || {}, {service: this, params: params});
	
	    var uploader = new AWS.S3.ManagedUpload(options);
	    if (typeof callback === 'function') uploader.send(callback);
	    return uploader;
	  }
	});


/***/ },
/* 399 */
[640, 7],
/* 400 */
[641, 7],
/* 401 */
[642, 7, 403, 175, 404, 405, 402, 400],
/* 402 */
[643, 7],
/* 403 */
[644, 7],
/* 404 */
[646, 7, 175],
/* 405 */
[647, 7, 176],
/* 406 */
318,
/* 407 */
[650, 13, 49],
/* 408 */
[651, 13, 411, 412],
/* 409 */
321,
/* 410 */
322,
/* 411 */
[652, 409],
/* 412 */
[653, 410],
/* 413 */
325,
/* 414 */
[655, 415, 416],
/* 415 */
[656, 178, 177],
/* 416 */
[657, 178, 177],
/* 417 */
[654, 418],
/* 418 */
327,
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(180);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(564);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _api = __webpack_require__(137);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _awsAmplifyReact = __webpack_require__(361);
	
	var _pubsub = __webpack_require__(334);
	
	var _pubsub2 = _interopRequireDefault(_pubsub);
	
	var _auth = __webpack_require__(80);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _storage = __webpack_require__(86);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _HashLoader = __webpack_require__(268);
	
	var _HashLoader2 = _interopRequireDefault(_HashLoader);
	
	var _reactBootstrap = __webpack_require__(253);
	
	var _mutations = __webpack_require__(422);
	
	var _queries = __webpack_require__(423);
	
	var _subscriptions = __webpack_require__(424);
	
	var _reactImage = __webpack_require__(557);
	
	var _reactImage2 = _interopRequireDefault(_reactImage);
	
	var _awsExports = __webpack_require__(179);
	
	var _awsExports2 = _interopRequireDefault(_awsExports);
	
	var _detailView = __webpack_require__(421);
	
	var _detailView2 = _interopRequireDefault(_detailView);
	
	var _reactGa = __webpack_require__(556);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	_reactGa2.default.initialize('G-5LSJTQCHMC');
	
	_reactModal2.default.setAppElement('#root');
	
	_api2.default.configure(_awsExports2.default);
	_pubsub2.default.configure(_awsExports2.default);
	_auth2.default.configure(_awsExports2.default);
	
	// Action Types
	var QUERY = 'QUERY';
	var SUBSCRIPTION = 'SUBSCRIPTION';
	var APPEND = 'APPEND';
	
	function sorter(a, b) {
	  if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;else if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;else return 0;
	}
	
	var reducer = function reducer(state, action) {
	  switch (action.type) {
	    case QUERY:
	      return Object.assign({}, state, { items: action.items.sort(sorter) });
	    case APPEND:
	      return Object.assign({}, state, { items: state.items.concat(action.items).sort(sorter) });
	    case SUBSCRIPTION:
	      return Object.assign({}, state, { items: [].concat(_toConsumableArray(state.items), [action.item]) });
	    default:
	      return state;
	  }
	};
	
	var cardCss = {
	  width: "100%",
	  backgroundColor: "lightyellow",
	  borderRadius: 5,
	  margin: 10,
	  padding: 10,
	  border: "1px solid gray"
	};
	
	var timeout = void 0;
	
	function App() {
	  var persistData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(values) {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!values.createNew) {
	                _context.next = 7;
	                break;
	              }
	
	              delete values.createNew;
	              delete values.deleteItem;
	              _context.next = 5;
	              return _api2.default.graphql({ query: _mutations.createItem, variables: { input: values }, authMode: "AMAZON_COGNITO_USER_POOLS" });
	
	            case 5:
	              _context.next = 18;
	              break;
	
	            case 7:
	              if (!values.deleteItem) {
	                _context.next = 14;
	                break;
	              }
	
	              delete values.createNew;
	              delete values.deleteItem;
	              _context.next = 12;
	              return _api2.default.graphql({ query: _mutations.deleteItem, variables: { input: values }, authMode: "AMAZON_COGNITO_USER_POOLS" });
	
	            case 12:
	              _context.next = 18;
	              break;
	
	            case 14:
	              delete values.createNew;
	              delete values.deleteItem;
	              _context.next = 18;
	              return _api2.default.graphql({ query: _mutations.updateItem, variables: { input: values }, authMode: "AMAZON_COGNITO_USER_POOLS" });
	
	            case 18:
	
	              closeModal();
	
	            case 19:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    return function persistData(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var getImageUrl = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(item) {
	      var key, url;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              key = item.id + "/product.jpg";
	              _context2.next = 3;
	              return _storage2.default.get(key);
	
	            case 3:
	              url = _context2.sent;
	              return _context2.abrupt('return', url);
	
	            case 5:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this);
	    }));
	
	    return function getImageUrl(_x2) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var openModal = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(item) {
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	
	              setItemValues(item);
	
	              // check if valid session AND user has admin role
	              if (isAdmin) setModalEditIsOpen(true);else setModalViewIsOpen(true);
	
	            case 2:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, this);
	    }));
	
	    return function openModal(_x3) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  // localIsAdmin so that updating state doesn't trigger useEffect again.
	  // check session to know if we are viewing or editing
	  // then: load the data,
	  var getData = function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(nextToken) {
	      var filter, itemData, enrichedItems, i;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	
	              setLoadingMessage("Loading...");
	
	              _context4.prev = 1;
	              _context4.next = 4;
	              return _auth2.default.currentSession();
	
	            case 4:
	              session = _context4.sent;
	              _context4.next = 10;
	              break;
	
	            case 7:
	              _context4.prev = 7;
	              _context4.t0 = _context4['catch'](1);
	
	              session = null;
	
	            case 10:
	              if (!session) {
	                _context4.next = 15;
	                break;
	              }
	
	              _context4.next = 13;
	              return _auth2.default.currentAuthenticatedUser();
	
	            case 13:
	              usr = _context4.sent;
	
	
	              if (usr && usr.signInUserSession && usr.signInUserSession.accessToken && usr.signInUserSession.accessToken.payload && usr.signInUserSession.accessToken.payload["cognito:groups"]) {
	                if (usr.signInUserSession.accessToken.payload["cognito:groups"].includes("Admins")) {
	                  localIsAdmin = true;
	                  setIsAdmin(true);
	                }
	              }
	
	            case 15:
	              filter = void 0;
	
	              if (searchValue) {
	                filter = {
	                  filter: {
	                    or: [{
	                      name: {
	                        contains: searchValue
	                      }
	                    }, {
	                      description: {
	                        contains: searchValue
	                      }
	                    }, {
	                      category: {
	                        contains: searchValue
	                      }
	                    }]
	                  }
	                };
	              } else {
	                filter = null;
	              }
	
	              _context4.next = 19;
	              return _api2.default.graphql({ query: _queries.listItems, variables: Object.assign({ nextToken: nextToken }, filter, { limit: 500 }), authMode: localIsAdmin ? "AMAZON_COGNITO_USER_POOLS" : "AWS_IAM" });
	
	            case 19:
	              itemData = _context4.sent;
	              enrichedItems = itemData.data.listItems.items;
	              i = 0;
	
	            case 22:
	              if (!(i < enrichedItems.length)) {
	                _context4.next = 29;
	                break;
	              }
	
	              _context4.next = 25;
	              return getImageUrl(enrichedItems[i]);
	
	            case 25:
	              enrichedItems[i]["imageUrl"] = _context4.sent;
	
	            case 26:
	              i++;
	              _context4.next = 22;
	              break;
	
	            case 29:
	
	              if (!enrichedItems.length) {
	                setLoadingMessage("No items found.");
	              }
	
	              dispatch({ type: nextToken ? APPEND : QUERY, items: enrichedItems });
	
	              if (itemData.data.listItems.nextToken) {
	                getData(itemData.data.listItems.nextToken);
	              }
	
	            case 32:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, this, [[1, 7]]);
	    }));
	
	    return function getData(_x4) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	
	  var _useReducer = (0, _react.useReducer)(reducer, { items: [] }),
	      _useReducer2 = _slicedToArray(_useReducer, 2),
	      state = _useReducer2[0],
	      dispatch = _useReducer2[1];
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      modalEditIsOpen = _useState2[0],
	      setModalEditIsOpen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      modalViewIsOpen = _useState4[0],
	      setModalViewIsOpen = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({}),
	      _useState6 = _slicedToArray(_useState5, 2),
	      itemValues = _useState6[0],
	      setItemValues = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(""),
	      _useState8 = _slicedToArray(_useState7, 2),
	      searchValue = _useState8[0],
	      setSearchValue = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(""),
	      _useState10 = _slicedToArray(_useState9, 2),
	      searchDisplayText = _useState10[0],
	      setsearchDisplayText = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      attemptLogin = _useState12[0],
	      setAttemptLogin = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      isAdmin = _useState14[0],
	      setIsAdmin = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      loadingMessage = _useState16[0],
	      setLoadingMessage = _useState16[1];
	
	  function delaySearch(value) {
	
	    setsearchDisplayText(value);
	
	    // Clear the timeout if it has already been set.
	    // This will prevent the previous task from executing
	    // if it has been less than <MILLISECONDS>
	    clearTimeout(timeout);
	
	    // Make a new timeout set to go off in 800ms
	    timeout = setTimeout(function () {
	      setSearchValue(value);
	    }, 1500);
	  }
	
	  function afterOpenModal() {}
	  function closeModal() {
	    setModalEditIsOpen(false);
	    setModalViewIsOpen(false);
	  }
	
	  var session = void 0,
	      usr = void 0,
	      localIsAdmin = void 0;
	
	  (0, _react.useEffect)(function () {
	
	    getData().then(function () {
	      if (localIsAdmin) {
	        var subscriptionCreate = _api2.default.graphql((0, _api.graphqlOperation)(_subscriptions.onCreateItem)).subscribe({
	          next: function next(eventData) {
	            getData();
	          }
	        });
	
	        var subscriptionUpdate = _api2.default.graphql((0, _api.graphqlOperation)(_subscriptions.onUpdateItem)).subscribe({
	          next: function next(eventData) {
	            getData();
	          }
	        });
	
	        var subscriptionDelete = _api2.default.graphql((0, _api.graphqlOperation)(_subscriptions.onDeleteItem)).subscribe({
	          next: function next(eventData) {
	            getData();
	          }
	        });
	
	        return function () {
	          subscriptionCreate.unsubscribe();subscriptionUpdate.unsubscribe();subscriptionDelete.unsubscribe();
	        };
	      } else {
	        return {};
	      }
	    });
	  }, [searchValue]);
	
	  _reactGa2.default.pageview(window.location.pathname + window.location.search);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'App', style: { margin: 20 } },
	    _react2.default.createElement(_awsAmplifyReact.Greetings, null),
	    _react2.default.createElement(
	      _reactBootstrap.ButtonToolbar,
	      { style: { flexDirection: "row", justifyContent: "center", marginBottom: 30 } },
	      isAdmin && _react2.default.createElement(
	        _reactBootstrap.Button,
	        { variant: 'primary', onClick: openModal },
	        '+ New Item'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { marginLeft: 20, verticalAlign: "center" } },
	        _react2.default.createElement(_reactBootstrap.Form.Control, { type: 'text', placeholder: 'Search', value: searchDisplayText, onChange: function onChange(event) {
	            return delaySearch(event.target.value);
	          } })
	      )
	    ),
	    _react2.default.createElement(
	      _reactModal2.default,
	      {
	        className: 'Modal',
	        isOpen: attemptLogin
	      },
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { variant: 'secondary', type: 'submit', style: { float: "right" }, onClick: function onClick() {
	            return setAttemptLogin(false);
	          } },
	        'Close'
	      ),
	      _react2.default.createElement(
	        _awsAmplifyReact.Authenticator,
	        {
	          authState: ''
	          // hide all the default components
	          , hideDefault: true
	          // Pass in an aws-exports configuration
	          , amplifyConfig: _awsExports2.default,
	          onStateChange: function onStateChange(authState) {
	            setAttemptLogin(authState !== "signedIn");setIsAdmin(authState === "signedIn");
	          }
	        },
	        _react2.default.createElement(_awsAmplifyReact.SignIn, null),
	        _react2.default.createElement(_awsAmplifyReact.ConfirmSignIn, null),
	        _react2.default.createElement(_awsAmplifyReact.RequireNewPassword, null),
	        _react2.default.createElement(_awsAmplifyReact.VerifyContact, null),
	        _react2.default.createElement(_awsAmplifyReact.ForgotPassword, null),
	        _react2.default.createElement(_awsAmplifyReact.Loading, null)
	      )
	    ),
	    _react2.default.createElement(
	      _reactModal2.default,
	      {
	        className: 'Modal',
	        isOpen: modalEditIsOpen || modalViewIsOpen,
	        onAfterOpen: afterOpenModal,
	        onRequestClose: closeModal,
	        contentLabel: 'Example Modal'
	      },
	      _react2.default.createElement(_detailView2.default, { itemValues: itemValues, onSubmit: persistData, allowEdits: modalEditIsOpen, onDelete: persistData })
	    ),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Lending Library Catalog'
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      state.items.length > 0 ? state.items.map(function (item) {
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          { style: cardCss, onClick: function onClick() {
	              openModal(item);
	            }, key: item.id },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { style: { textAlign: "left" } },
	            _react2.default.createElement(
	              'span',
	              { style: { marginRight: 10 } },
	              _react2.default.createElement(
	                'b',
	                null,
	                'Name:'
	              ),
	              ' ',
	              item.name
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'span',
	              { style: { marginRight: 10 } },
	              _react2.default.createElement(
	                'b',
	                null,
	                'Cost:'
	              ),
	              ' $',
	              (item.cost || 0).toFixed(2)
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'span',
	              { style: { marginRight: 10 } },
	              _react2.default.createElement(
	                'b',
	                null,
	                'Vendor:'
	              ),
	              ' ',
	              item.vendor
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'span',
	              { style: { marginRight: 10 } },
	              _react2.default.createElement(
	                'b',
	                null,
	                'Category:'
	              ),
	              ' ',
	              item.category
	            ),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { style: { textAlign: "left" } },
	            _react2.default.createElement(
	              'span',
	              { style: { marginRight: 10 } },
	              item.description
	            )
	          )
	        );
	      }) : _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          loadingMessage
	        ),
	        _react2.default.createElement(_HashLoader2.default, { css: { marginTop: 30, position: "fixed", left: "50%", transform: "translate(-50%, -50%)" }, sizeUnit: "px", size: 40, loading: loadingMessage === "Loading..." })
	      )
	    ),
	    !isAdmin && _react2.default.createElement(
	      _reactBootstrap.Button,
	      { variant: 'secondary', type: 'submit', style: { float: "right" }, onClick: function onClick() {
	          return setAttemptLogin(true);
	        } },
	      'Login'
	    )
	  );
	};
	
	//export default withAuthenticator(App);
	exports.default = App;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(180);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _storage = __webpack_require__(86);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _awsExports = __webpack_require__(179);
	
	var _awsExports2 = _interopRequireDefault(_awsExports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_storage2.default.configure(_awsExports2.default);
	
	var S3ImageUpload = function (_React$Component) {
	    _inherits(S3ImageUpload, _React$Component);
	
	    function S3ImageUpload() {
	        _classCallCheck(this, S3ImageUpload);
	
	        return _possibleConstructorReturn(this, (S3ImageUpload.__proto__ || Object.getPrototypeOf(S3ImageUpload)).apply(this, arguments));
	    }
	
	    _createClass(S3ImageUpload, [{
	        key: 'onChange',
	        value: function onChange(e) {
	            var _this2 = this;
	
	            var file = e.target.files[0];
	            var key = this.props.productId + '/product.jpg';
	            _storage2.default.put(key, file, {
	                contentType: 'image/png'
	            }).then(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var event;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                if (!_this2.props.onSubmit) {
	                                    _context.next = 7;
	                                    break;
	                                }
	
	                                _context.next = 3;
	                                return _storage2.default.get(key);
	
	                            case 3:
	                                _context.t0 = _context.sent;
	                                _context.t1 = {
	                                    name: "imageUrl",
	                                    value: _context.t0
	                                };
	                                event = {
	                                    target: _context.t1
	                                };
	
	                                _this2.props.onSubmit(event);
	
	                            case 7:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this2);
	            }))).catch(function (err) {
	                return console.log(err);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement('input', {
	                type: 'file', accept: 'image/*',
	                onChange: function onChange(e) {
	                    return _this3.onChange(e);
	                }
	            });
	        }
	    }]);
	
	    return S3ImageUpload;
	}(_react2.default.Component);
	
	exports.default = S3ImageUpload;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(253);
	
	var _HashLoader = __webpack_require__(268);
	
	var _HashLoader2 = _interopRequireDefault(_HashLoader);
	
	var _S3ImageUpload = __webpack_require__(420);
	
	var _S3ImageUpload2 = _interopRequireDefault(_S3ImageUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Render Prop
	
	
	var uuid = __webpack_require__(588);
	
	var DetailView = function (_React$Component) {
	    _inherits(DetailView, _React$Component);
	
	    function DetailView(props) {
	        _classCallCheck(this, DetailView);
	
	        var _this = _possibleConstructorReturn(this, (DetailView.__proto__ || Object.getPrototypeOf(DetailView)).call(this, props));
	
	        _this.state = {
	            name: "",
	            description: "",
	            category: "",
	            vendor: "",
	            vendorLink: "",
	            cost: 0,
	            itemNumber: "",
	            swItemNumber: "",
	            nwItemNumber: "",
	            id: "",
	            createNew: true,
	            imageUrl: "",
	            isSubmitting: false,
	            isDeleting: false,
	            deleteItem: false
	        };
	        return _this;
	    }
	
	    _createClass(DetailView, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setState({
	                name: this.props.itemValues.name || "",
	                description: this.props.itemValues.description || "",
	                category: this.props.itemValues.category || "",
	                vendor: this.props.itemValues.vendor || "",
	                vendorLink: this.props.itemValues.vendorLink || "",
	                cost: this.props.itemValues.cost || "",
	                itemNumber: this.props.itemValues.itemNumber || "",
	                swItemNumber: this.props.itemValues.swItemNumber || "",
	                nwItemNumber: this.props.itemValues.nwItemNumber || "",
	                id: this.props.itemValues.id || uuid(),
	                createNew: this.props.itemValues.id ? false : true,
	                imageUrl: this.props.itemValues.imageUrl,
	                isSubmitting: false,
	                isDeleting: false,
	                deleteItem: false
	            });
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(event) {
	            var name = event.target.name;
	            this.setState(_defineProperty({}, name, event.target.value));
	        }
	    }, {
	        key: 'doSubmit',
	        value: function doSubmit(event) {
	
	            this.setState({
	                isSubmitting: true
	            });
	
	            event.preventDefault();
	
	            function blankStringRemover(obj) {
	
	                var newObj = {};
	                Object.keys(obj).forEach(function (key, ind) {
	                    if (obj[key] === "") newObj[key] = null;else newObj[key] = obj[key];
	                });
	
	                return newObj;
	            }
	
	            var itemValues = {
	                name: this.state.name,
	                description: this.state.description,
	                category: this.state.category,
	                vendor: this.state.vendor,
	                vendorLink: this.state.vendorLink,
	                cost: this.state.cost,
	                itemNumber: this.state.itemNumber,
	                swItemNumber: this.state.swItemNumber,
	                nwItemNumber: this.state.nwItemNumber,
	                id: this.state.id,
	                createNew: this.state.createNew,
	                deleteItem: this.state.deleteItem
	            };
	
	            itemValues = blankStringRemover(itemValues);
	
	            this.props.onSubmit(itemValues);
	        }
	    }, {
	        key: 'doDelete',
	        value: function doDelete(event) {
	
	            this.setState({
	                isDeleting: true
	            });
	
	            event.preventDefault();
	
	            var itemValues = {
	                id: this.state.id,
	                deleteItem: this.state.deleteItem
	            };
	
	            this.props.onDelete(itemValues);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _reactBootstrap.Form,
	                { onSubmit: this.doSubmit.bind(this) },
	                this.props.allowEdits && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { variant: 'outline-danger', disabled: this.state.isDeleting, onClick: function onClick() {
	                                _this2.setState({ deleteItem: true });
	                            }, style: { float: "right" } },
	                        _react2.default.createElement(_HashLoader2.default, { sizeUnit: "px", size: 15, loading: this.state.isDeleting }),
	                        ' ',
	                        this.state.isDeleting ? 'Deleting...' : 'Delete'
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { variant: 'primary', type: 'submit', disabled: this.state.isSubmitting, style: { float: "right", marginRight: 10 } },
	                        _react2.default.createElement(_HashLoader2.default, { sizeUnit: "px", size: 15, loading: this.state.isSubmitting }),
	                        ' ',
	                        this.state.isSubmitting ? 'Saving...' : 'Save'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    { show: this.state.deleteItem },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Header,
	                        { closeButton: true },
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Title,
	                            null,
	                            'Are you sure?'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        'This item will be deleted. Continue?'
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Footer,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { variant: 'secondary', onClick: function onClick() {
	                                    _this2.setState({ deleteItem: false });
	                                } },
	                            'Cancel'
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { variant: 'danger', onClick: this.doDelete.bind(this) },
	                            'Delete'
	                        )
	                    )
	                ),
	                this.props.allowEdits ? _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Library Item'
	                ) : _react2.default.createElement(
	                    'h2',
	                    null,
	                    this.state.name
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { style: { marginRight: 40 } },
	                        this.props.allowEdits && _react2.default.createElement(
	                            _reactBootstrap.Form.Group,
	                            { controlId: 'formName' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Form.Label,
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(_reactBootstrap.Form.Control, { name: 'name', onChange: this.handleChange.bind(this), value: this.state.name, type: 'text', placeholder: 'Item Name' }),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Form.Text,
	                                    { className: 'text-muted' },
	                                    'The name of this item'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Form.Group,
	                            { controlId: 'formCategory' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Form.Label,
	                                null,
	                                'Category'
	                            ),
	                            this.props.allowEdits ? _react2.default.createElement(_reactBootstrap.Form.Control, { name: 'category', onChange: this.handleChange.bind(this), value: this.state.category, type: 'text', placeholder: 'Category' }) : _react2.default.createElement(
	                                'div',
	                                null,
	                                this.state.category
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Form.Group,
	                            { controlId: 'formDescription' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Form.Label,
	                                null,
	                                'Description'
	                            ),
	                            this.props.allowEdits ? _react2.default.createElement(_reactBootstrap.Form.Control, { name: 'description', onChange: this.handleChange.bind(this), value: this.state.description, as: 'textarea', placeholder: 'Item Description' }) : _react2.default.createElement(
	                                'div',
	                                null,
	                                this.state.description
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Form.Group,
	                            { controlId: 'formVendor' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Form.Label,
	                                null,
	                                'Vendor'
	                            ),
	                            this.props.allowEdits ? _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(_reactBootstrap.Form.Control, { name: 'vendor', onChange: this.handleChange.bind(this), value: this.state.vendor, type: 'text', placeholder: 'Vendor' }),
	                                _react2.default.createElement(_reactBootstrap.Form.Control, { name: 'vendorLink', onChange: this.handleChange.bind(this), value: this.state.vendorLink, type: 'text', placeholder: 'Vendor URL' })
	                            ) : _react2.default.createElement(
	                                'div',
	                                null,
	                                this.state.vendor,
	                                _react2.default.createElement('br', null),
	                                this.state.vendorLink && _react2.default.createElement(
	                                    'a',
	                                    { href: this.state.vendorLink },
	                                    this.state.vendorLink
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        null,
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'cost' },
	                            'Cost'
	                        ),
	                        this.props.allowEdits ? _react2.default.createElement(
	                            _reactBootstrap.InputGroup,
	                            { className: 'mb-3' },
	                            _react2.default.createElement(
	                                _reactBootstrap.InputGroup.Prepend,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.InputGroup.Text,
	                                    null,
	                                    '$'
	                                )
	                            ),
	                            _react2.default.createElement(_reactBootstrap.FormControl, { name: 'cost', onChange: this.handleChange.bind(this), value: this.state.cost, id: 'cost', placeholder: '00.00' })
	                        ) : _react2.default.createElement(
	                            'div',
	                            null,
	                            '$',
	                            this.state.cost
	                        ),
	                        this.props.allowEdits ? _react2.default.createElement(
	                            _reactBootstrap.Form.Group,
	                            { controlId: 'formItemNumber' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Form.Label,
	                                null,
	                                'Item Number'
	                            ),
	                            _react2.default.createElement(_reactBootstrap.Form.Control, { name: 'itemNumber', onChange: this.handleChange.bind(this), value: this.state.itemNumber, type: 'text', placeholder: 'Item Number' }),
	                            _react2.default.createElement(
	                                _reactBootstrap.Form.Label,
	                                null,
	                                'SW Item Number'
	                            ),
	                            _react2.default.createElement(_reactBootstrap.Form.Control, { name: 'swItemNumber', onChange: this.handleChange.bind(this), value: this.state.swItemNumber, type: 'text', placeholder: 'SW Item Number' }),
	                            _react2.default.createElement(
	                                _reactBootstrap.Form.Label,
	                                null,
	                                'NW Item Number'
	                            ),
	                            _react2.default.createElement(_reactBootstrap.Form.Control, { name: 'nwItemNumber', onChange: this.handleChange.bind(this), value: this.state.nwItemNumber, type: 'text', placeholder: 'NW Item Number' })
	                        ) : _react2.default.createElement('img', { src: this.state.imageUrl, style: { marginTop: 20, maxWidth: 400 } })
	                    )
	                ),
	                this.props.allowEdits && _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Form.Group,
	                            null,
	                            _react2.default.createElement('img', { src: this.state.imageUrl, style: { height: 150 } }),
	                            this.props.allowEdits && _react2.default.createElement(_S3ImageUpload2.default, { productId: this.state.id, onSubmit: this.handleChange.bind(this) })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DetailView;
	}(_react2.default.Component);
	
	exports.default = DetailView;

/***/ },
/* 422 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable */
	// this is an auto generated file. This will be overwritten
	
	var createItem = exports.createItem = "mutation CreateItem($input: CreateItemInput!) {\n  createItem(input: $input) {\n    id\n    name\n    description\n    category\n    cost\n    vendor\n    itemNumber\n    location\n    vendorLink\n    nwItemNumber\n    swItemNumber\n    imageUrl\n  }\n}\n";
	var updateItem = exports.updateItem = "mutation UpdateItem($input: UpdateItemInput!) {\n  updateItem(input: $input) {\n    id\n    name\n    description\n    category\n    cost\n    vendor\n    itemNumber\n    location\n    vendorLink\n    nwItemNumber\n    swItemNumber\n    imageUrl\n  }\n}\n";
	var deleteItem = exports.deleteItem = "mutation DeleteItem($input: DeleteItemInput!) {\n  deleteItem(input: $input) {\n    id\n    name\n    description\n    category\n    cost\n    vendor\n    itemNumber\n    location\n    vendorLink\n    nwItemNumber\n    swItemNumber\n    imageUrl\n  }\n}\n";

/***/ },
/* 423 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable */
	// this is an auto generated file. This will be overwritten
	
	var getItem = exports.getItem = "query GetItem($id: ID!) {\n  getItem(id: $id) {\n    id\n    name\n    description\n    category\n    cost\n    vendor\n    itemNumber\n    location\n    vendorLink\n    nwItemNumber\n    swItemNumber\n    imageUrl\n  }\n}\n";
	var listItems = exports.listItems = "query ListItems(\n  $filter: ModelItemFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  listItems(filter: $filter, limit: $limit, nextToken: $nextToken) {\n    items {\n      id\n      name\n      description\n      category\n      cost\n      vendor\n      itemNumber\n      location\n      vendorLink\n      nwItemNumber\n      swItemNumber\n      imageUrl\n    }\n    nextToken\n  }\n}\n";

/***/ },
/* 424 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable */
	// this is an auto generated file. This will be overwritten
	
	var onCreateItem = exports.onCreateItem = "subscription OnCreateItem {\n  onCreateItem {\n    id\n    name\n    description\n    category\n    cost\n    vendor\n    itemNumber\n    location\n    vendorLink\n    nwItemNumber\n    swItemNumber\n    imageUrl\n  }\n}\n";
	var onUpdateItem = exports.onUpdateItem = "subscription OnUpdateItem {\n  onUpdateItem {\n    id\n    name\n    description\n    category\n    cost\n    vendor\n    itemNumber\n    location\n    vendorLink\n    nwItemNumber\n    swItemNumber\n    imageUrl\n  }\n}\n";
	var onDeleteItem = exports.onDeleteItem = "subscription OnDeleteItem {\n  onDeleteItem {\n    id\n    name\n    description\n    category\n    cost\n    vendor\n    itemNumber\n    location\n    vendorLink\n    nwItemNumber\n    swItemNumber\n    imageUrl\n  }\n}\n";

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(44);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(419);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(445);
	
	__webpack_require__(444);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(427);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 427 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 428 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(40));
	
	/**
	 * Returns the actively focused element safely.
	 *
	 * @param doc the document to check
	 */
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  // Support: IE 9 only
	  // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
	  try {
	    var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
	    // document.activeElement from an <iframe>
	
	    if (!active || !active.nodeName) return null;
	    return active;
	  } catch (e) {
	    /* ie throws if no active element */
	    return doc.body;
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(181));
	
	/**
	 * Adds a CSS class to a given element.
	 * 
	 * @param element the element
	 * @param className the CSS class name
	 */
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 431 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = getComputedStyle;
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(439));
	
	/**
	 * Returns one or all computed style properties of an element.
	 * 
	 * @param node the element
	 * @param psuedoElement the style property
	 */
	function getComputedStyle(node, psuedoElement) {
	  return (0, _ownerWindow.default)(node).getComputedStyle(node, psuedoElement);
	}
	
	module.exports = exports["default"];

/***/ },
/* 433 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(433));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ },
/* 435 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isDocument;
	
	function isDocument(element) {
	  return 'nodeType' in element && element.nodeType === document.DOCUMENT_NODE;
	}
	
	module.exports = exports["default"];

/***/ },
/* 436 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(value) {
	  return !!(value && supportedTransforms.test(value));
	}
	
	module.exports = exports["default"];

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = isWindow;
	
	var _isDocument = _interopRequireDefault(__webpack_require__(435));
	
	function isWindow(node) {
	  if ('window' in node && node.window === node) return node;
	  if ((0, _isDocument.default)(node)) return node.defaultView || false;
	  return false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 438 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = matches;
	var matchesImpl;
	/**
	 * Checks if a given element matches a selector.
	 * 
	 * @param node the element
	 * @param selector the selector
	 */
	
	function matches(node, selector) {
	  if (!matchesImpl) {
	    var body = document.body;
	    var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;
	
	    matchesImpl = function matchesImpl(n, s) {
	      return nativeMatch.call(n, s);
	    };
	  }
	
	  return matchesImpl(node, selector);
	}
	
	module.exports = exports["default"];

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = ownerWindow;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(40));
	
	/**
	 * Returns the owner window of a given element.
	 * 
	 * @param node the element
	 */
	function ownerWindow(node) {
	  var doc = (0, _ownerDocument.default)(node);
	  return doc && doc.defaultView || window;
	}
	
	module.exports = exports["default"];

/***/ },
/* 440 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeClass;
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	/**
	 * Removes a CSS class from a given element.
	 * 
	 * @param element the element
	 * @param className the CSS class name
	 */
	
	
	function removeClass(element, className) {
	  if (element.classList) {
	    element.classList.remove(className);
	  } else if (typeof element.className === 'string') {
	    element.className = replaceClassName(element.className, className);
	  } else {
	    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 441 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = triggerEvent;
	
	/**
	 * Triggers an event on a given element.
	 * 
	 * @param node the element
	 * @param eventName the event name to trigger
	 * @param bubbles whether the event should bubble up
	 * @param cancelable whether the event should be cancelable
	 */
	function triggerEvent(node, eventName, bubbles, cancelable) {
	  if (bubbles === void 0) {
	    bubbles = false;
	  }
	
	  if (cancelable === void 0) {
	    cancelable = true;
	  }
	
	  if (node) {
	    var event = document.createEvent('HTMLEvents');
	    event.initEvent(eventName, bubbles, cancelable);
	    node.dispatchEvent(event);
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 443 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 444 */
443,
/* 445 */
443,
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatError = formatError;
	
	var _invariant = _interopRequireDefault(__webpack_require__(17));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Given a GraphQLError, format it according to the rules described by the
	 * Response Format, Errors section of the GraphQL Specification.
	 */
	function formatError(error) {
	  !error ? (0, _invariant.default)(0, 'Received null or undefined error.') : void 0;
	  var message = error.message || 'An unknown error occurred.';
	  var locations = error.locations;
	  var path = error.path;
	  var extensions = error.extensions;
	  return extensions ? {
	    message: message,
	    locations: locations,
	    path: path,
	    extensions: extensions
	  } : {
	    message: message,
	    locations: locations,
	    path: path
	  };
	}

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.syntaxError = syntaxError;
	
	var _GraphQLError = __webpack_require__(9);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Produces a GraphQLError representing a syntax error, containing useful
	 * descriptive information about the syntax error's position in the source.
	 */
	function syntaxError(source, position, description) {
	  return new _GraphQLError.GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
	}

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "execute", {
	  enumerable: true,
	  get: function get() {
	    return _execute.execute;
	  }
	});
	Object.defineProperty(exports, "defaultFieldResolver", {
	  enumerable: true,
	  get: function get() {
	    return _execute.defaultFieldResolver;
	  }
	});
	Object.defineProperty(exports, "responsePathAsArray", {
	  enumerable: true,
	  get: function get() {
	    return _execute.responsePathAsArray;
	  }
	});
	Object.defineProperty(exports, "getDirectiveValues", {
	  enumerable: true,
	  get: function get() {
	    return _values.getDirectiveValues;
	  }
	});
	
	var _execute = __webpack_require__(63);
	
	var _values = __webpack_require__(103);

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.graphql = graphql;
	exports.graphqlSync = graphqlSync;
	
	var _validate = __webpack_require__(66);
	
	var _parser = __webpack_require__(41);
	
	var _validate2 = __webpack_require__(69);
	
	var _execute = __webpack_require__(63);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function graphql(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver) {
	  var _arguments = arguments;
	
	  /* eslint-enable no-redeclare */
	  // Always return a Promise for a consistent API.
	  return new Promise(function (resolve) {
	    return resolve( // Extract arguments from object args if provided.
	    _arguments.length === 1 ? graphqlImpl(argsOrSchema.schema, argsOrSchema.source, argsOrSchema.rootValue, argsOrSchema.contextValue, argsOrSchema.variableValues, argsOrSchema.operationName, argsOrSchema.fieldResolver) : graphqlImpl(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver));
	  });
	}
	/**
	 * The graphqlSync function also fulfills GraphQL operations by parsing,
	 * validating, and executing a GraphQL document along side a GraphQL schema.
	 * However, it guarantees to complete synchronously (or throw an error) assuming
	 * that all field resolvers are also synchronous.
	 */
	
	
	function graphqlSync(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver) {
	  /* eslint-enable no-redeclare */
	  // Extract arguments from object args if provided.
	  var result = arguments.length === 1 ? graphqlImpl(argsOrSchema.schema, argsOrSchema.source, argsOrSchema.rootValue, argsOrSchema.contextValue, argsOrSchema.variableValues, argsOrSchema.operationName, argsOrSchema.fieldResolver) : graphqlImpl(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver); // Assert that the execution was synchronous.
	
	  if (result.then) {
	    throw new Error('GraphQL execution failed to complete synchronously.');
	  }
	
	  return result;
	}
	
	function graphqlImpl(schema, source, rootValue, contextValue, variableValues, operationName, fieldResolver) {
	  // Validate Schema
	  var schemaValidationErrors = (0, _validate.validateSchema)(schema);
	
	  if (schemaValidationErrors.length > 0) {
	    return {
	      errors: schemaValidationErrors
	    };
	  } // Parse
	
	
	  var document;
	
	  try {
	    document = (0, _parser.parse)(source);
	  } catch (syntaxError) {
	    return {
	      errors: [syntaxError]
	    };
	  } // Validate
	
	
	  var validationErrors = (0, _validate2.validate)(schema, document);
	
	  if (validationErrors.length > 0) {
	    return {
	      errors: validationErrors
	    };
	  } // Execute
	
	
	  return (0, _execute.execute)(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);
	}

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "graphql", {
	  enumerable: true,
	  get: function get() {
	    return _graphql.graphql;
	  }
	});
	Object.defineProperty(exports, "graphqlSync", {
	  enumerable: true,
	  get: function get() {
	    return _graphql.graphqlSync;
	  }
	});
	Object.defineProperty(exports, "GraphQLSchema", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLSchema;
	  }
	});
	Object.defineProperty(exports, "GraphQLScalarType", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLScalarType;
	  }
	});
	Object.defineProperty(exports, "GraphQLObjectType", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLObjectType;
	  }
	});
	Object.defineProperty(exports, "GraphQLInterfaceType", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLInterfaceType;
	  }
	});
	Object.defineProperty(exports, "GraphQLUnionType", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLUnionType;
	  }
	});
	Object.defineProperty(exports, "GraphQLEnumType", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLEnumType;
	  }
	});
	Object.defineProperty(exports, "GraphQLInputObjectType", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLInputObjectType;
	  }
	});
	Object.defineProperty(exports, "GraphQLList", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLList;
	  }
	});
	Object.defineProperty(exports, "GraphQLNonNull", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLNonNull;
	  }
	});
	Object.defineProperty(exports, "GraphQLDirective", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLDirective;
	  }
	});
	Object.defineProperty(exports, "TypeKind", {
	  enumerable: true,
	  get: function get() {
	    return _type.TypeKind;
	  }
	});
	Object.defineProperty(exports, "specifiedScalarTypes", {
	  enumerable: true,
	  get: function get() {
	    return _type.specifiedScalarTypes;
	  }
	});
	Object.defineProperty(exports, "GraphQLInt", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLInt;
	  }
	});
	Object.defineProperty(exports, "GraphQLFloat", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLFloat;
	  }
	});
	Object.defineProperty(exports, "GraphQLString", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLString;
	  }
	});
	Object.defineProperty(exports, "GraphQLBoolean", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLBoolean;
	  }
	});
	Object.defineProperty(exports, "GraphQLID", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLID;
	  }
	});
	Object.defineProperty(exports, "specifiedDirectives", {
	  enumerable: true,
	  get: function get() {
	    return _type.specifiedDirectives;
	  }
	});
	Object.defineProperty(exports, "GraphQLIncludeDirective", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLIncludeDirective;
	  }
	});
	Object.defineProperty(exports, "GraphQLSkipDirective", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLSkipDirective;
	  }
	});
	Object.defineProperty(exports, "GraphQLDeprecatedDirective", {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLDeprecatedDirective;
	  }
	});
	Object.defineProperty(exports, "DEFAULT_DEPRECATION_REASON", {
	  enumerable: true,
	  get: function get() {
	    return _type.DEFAULT_DEPRECATION_REASON;
	  }
	});
	Object.defineProperty(exports, "SchemaMetaFieldDef", {
	  enumerable: true,
	  get: function get() {
	    return _type.SchemaMetaFieldDef;
	  }
	});
	Object.defineProperty(exports, "TypeMetaFieldDef", {
	  enumerable: true,
	  get: function get() {
	    return _type.TypeMetaFieldDef;
	  }
	});
	Object.defineProperty(exports, "TypeNameMetaFieldDef", {
	  enumerable: true,
	  get: function get() {
	    return _type.TypeNameMetaFieldDef;
	  }
	});
	Object.defineProperty(exports, "introspectionTypes", {
	  enumerable: true,
	  get: function get() {
	    return _type.introspectionTypes;
	  }
	});
	Object.defineProperty(exports, "__Schema", {
	  enumerable: true,
	  get: function get() {
	    return _type.__Schema;
	  }
	});
	Object.defineProperty(exports, "__Directive", {
	  enumerable: true,
	  get: function get() {
	    return _type.__Directive;
	  }
	});
	Object.defineProperty(exports, "__DirectiveLocation", {
	  enumerable: true,
	  get: function get() {
	    return _type.__DirectiveLocation;
	  }
	});
	Object.defineProperty(exports, "__Type", {
	  enumerable: true,
	  get: function get() {
	    return _type.__Type;
	  }
	});
	Object.defineProperty(exports, "__Field", {
	  enumerable: true,
	  get: function get() {
	    return _type.__Field;
	  }
	});
	Object.defineProperty(exports, "__InputValue", {
	  enumerable: true,
	  get: function get() {
	    return _type.__InputValue;
	  }
	});
	Object.defineProperty(exports, "__EnumValue", {
	  enumerable: true,
	  get: function get() {
	    return _type.__EnumValue;
	  }
	});
	Object.defineProperty(exports, "__TypeKind", {
	  enumerable: true,
	  get: function get() {
	    return _type.__TypeKind;
	  }
	});
	Object.defineProperty(exports, "isSchema", {
	  enumerable: true,
	  get: function get() {
	    return _type.isSchema;
	  }
	});
	Object.defineProperty(exports, "isDirective", {
	  enumerable: true,
	  get: function get() {
	    return _type.isDirective;
	  }
	});
	Object.defineProperty(exports, "isType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isType;
	  }
	});
	Object.defineProperty(exports, "isScalarType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isScalarType;
	  }
	});
	Object.defineProperty(exports, "isObjectType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isObjectType;
	  }
	});
	Object.defineProperty(exports, "isInterfaceType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isInterfaceType;
	  }
	});
	Object.defineProperty(exports, "isUnionType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isUnionType;
	  }
	});
	Object.defineProperty(exports, "isEnumType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isEnumType;
	  }
	});
	Object.defineProperty(exports, "isInputObjectType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isInputObjectType;
	  }
	});
	Object.defineProperty(exports, "isListType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isListType;
	  }
	});
	Object.defineProperty(exports, "isNonNullType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isNonNullType;
	  }
	});
	Object.defineProperty(exports, "isInputType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isInputType;
	  }
	});
	Object.defineProperty(exports, "isOutputType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isOutputType;
	  }
	});
	Object.defineProperty(exports, "isLeafType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isLeafType;
	  }
	});
	Object.defineProperty(exports, "isCompositeType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isCompositeType;
	  }
	});
	Object.defineProperty(exports, "isAbstractType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isAbstractType;
	  }
	});
	Object.defineProperty(exports, "isWrappingType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isWrappingType;
	  }
	});
	Object.defineProperty(exports, "isNullableType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isNullableType;
	  }
	});
	Object.defineProperty(exports, "isNamedType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isNamedType;
	  }
	});
	Object.defineProperty(exports, "isRequiredArgument", {
	  enumerable: true,
	  get: function get() {
	    return _type.isRequiredArgument;
	  }
	});
	Object.defineProperty(exports, "isRequiredInputField", {
	  enumerable: true,
	  get: function get() {
	    return _type.isRequiredInputField;
	  }
	});
	Object.defineProperty(exports, "isSpecifiedScalarType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isSpecifiedScalarType;
	  }
	});
	Object.defineProperty(exports, "isIntrospectionType", {
	  enumerable: true,
	  get: function get() {
	    return _type.isIntrospectionType;
	  }
	});
	Object.defineProperty(exports, "isSpecifiedDirective", {
	  enumerable: true,
	  get: function get() {
	    return _type.isSpecifiedDirective;
	  }
	});
	Object.defineProperty(exports, "assertType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertType;
	  }
	});
	Object.defineProperty(exports, "assertScalarType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertScalarType;
	  }
	});
	Object.defineProperty(exports, "assertObjectType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertObjectType;
	  }
	});
	Object.defineProperty(exports, "assertInterfaceType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertInterfaceType;
	  }
	});
	Object.defineProperty(exports, "assertUnionType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertUnionType;
	  }
	});
	Object.defineProperty(exports, "assertEnumType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertEnumType;
	  }
	});
	Object.defineProperty(exports, "assertInputObjectType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertInputObjectType;
	  }
	});
	Object.defineProperty(exports, "assertListType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertListType;
	  }
	});
	Object.defineProperty(exports, "assertNonNullType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertNonNullType;
	  }
	});
	Object.defineProperty(exports, "assertInputType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertInputType;
	  }
	});
	Object.defineProperty(exports, "assertOutputType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertOutputType;
	  }
	});
	Object.defineProperty(exports, "assertLeafType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertLeafType;
	  }
	});
	Object.defineProperty(exports, "assertCompositeType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertCompositeType;
	  }
	});
	Object.defineProperty(exports, "assertAbstractType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertAbstractType;
	  }
	});
	Object.defineProperty(exports, "assertWrappingType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertWrappingType;
	  }
	});
	Object.defineProperty(exports, "assertNullableType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertNullableType;
	  }
	});
	Object.defineProperty(exports, "assertNamedType", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertNamedType;
	  }
	});
	Object.defineProperty(exports, "getNullableType", {
	  enumerable: true,
	  get: function get() {
	    return _type.getNullableType;
	  }
	});
	Object.defineProperty(exports, "getNamedType", {
	  enumerable: true,
	  get: function get() {
	    return _type.getNamedType;
	  }
	});
	Object.defineProperty(exports, "validateSchema", {
	  enumerable: true,
	  get: function get() {
	    return _type.validateSchema;
	  }
	});
	Object.defineProperty(exports, "assertValidSchema", {
	  enumerable: true,
	  get: function get() {
	    return _type.assertValidSchema;
	  }
	});
	Object.defineProperty(exports, "Source", {
	  enumerable: true,
	  get: function get() {
	    return _language.Source;
	  }
	});
	Object.defineProperty(exports, "getLocation", {
	  enumerable: true,
	  get: function get() {
	    return _language.getLocation;
	  }
	});
	Object.defineProperty(exports, "parse", {
	  enumerable: true,
	  get: function get() {
	    return _language.parse;
	  }
	});
	Object.defineProperty(exports, "parseValue", {
	  enumerable: true,
	  get: function get() {
	    return _language.parseValue;
	  }
	});
	Object.defineProperty(exports, "parseType", {
	  enumerable: true,
	  get: function get() {
	    return _language.parseType;
	  }
	});
	Object.defineProperty(exports, "print", {
	  enumerable: true,
	  get: function get() {
	    return _language.print;
	  }
	});
	Object.defineProperty(exports, "visit", {
	  enumerable: true,
	  get: function get() {
	    return _language.visit;
	  }
	});
	Object.defineProperty(exports, "visitInParallel", {
	  enumerable: true,
	  get: function get() {
	    return _language.visitInParallel;
	  }
	});
	Object.defineProperty(exports, "visitWithTypeInfo", {
	  enumerable: true,
	  get: function get() {
	    return _language.visitWithTypeInfo;
	  }
	});
	Object.defineProperty(exports, "getVisitFn", {
	  enumerable: true,
	  get: function get() {
	    return _language.getVisitFn;
	  }
	});
	Object.defineProperty(exports, "Kind", {
	  enumerable: true,
	  get: function get() {
	    return _language.Kind;
	  }
	});
	Object.defineProperty(exports, "TokenKind", {
	  enumerable: true,
	  get: function get() {
	    return _language.TokenKind;
	  }
	});
	Object.defineProperty(exports, "DirectiveLocation", {
	  enumerable: true,
	  get: function get() {
	    return _language.DirectiveLocation;
	  }
	});
	Object.defineProperty(exports, "BREAK", {
	  enumerable: true,
	  get: function get() {
	    return _language.BREAK;
	  }
	});
	Object.defineProperty(exports, "isDefinitionNode", {
	  enumerable: true,
	  get: function get() {
	    return _language.isDefinitionNode;
	  }
	});
	Object.defineProperty(exports, "isExecutableDefinitionNode", {
	  enumerable: true,
	  get: function get() {
	    return _language.isExecutableDefinitionNode;
	  }
	});
	Object.defineProperty(exports, "isSelectionNode", {
	  enumerable: true,
	  get: function get() {
	    return _language.isSelectionNode;
	  }
	});
	Object.defineProperty(exports, "isValueNode", {
	  enumerable: true,
	  get: function get() {
	    return _language.isValueNode;
	  }
	});
	Object.defineProperty(exports, "isTypeNode", {
	  enumerable: true,
	  get: function get() {
	    return _language.isTypeNode;
	  }
	});
	Object.defineProperty(exports, "isTypeSystemDefinitionNode", {
	  enumerable: true,
	  get: function get() {
	    return _language.isTypeSystemDefinitionNode;
	  }
	});
	Object.defineProperty(exports, "isTypeDefinitionNode", {
	  enumerable: true,
	  get: function get() {
	    return _language.isTypeDefinitionNode;
	  }
	});
	Object.defineProperty(exports, "isTypeSystemExtensionNode", {
	  enumerable: true,
	  get: function get() {
	    return _language.isTypeSystemExtensionNode;
	  }
	});
	Object.defineProperty(exports, "isTypeExtensionNode", {
	  enumerable: true,
	  get: function get() {
	    return _language.isTypeExtensionNode;
	  }
	});
	Object.defineProperty(exports, "execute", {
	  enumerable: true,
	  get: function get() {
	    return _execution.execute;
	  }
	});
	Object.defineProperty(exports, "defaultFieldResolver", {
	  enumerable: true,
	  get: function get() {
	    return _execution.defaultFieldResolver;
	  }
	});
	Object.defineProperty(exports, "responsePathAsArray", {
	  enumerable: true,
	  get: function get() {
	    return _execution.responsePathAsArray;
	  }
	});
	Object.defineProperty(exports, "getDirectiveValues", {
	  enumerable: true,
	  get: function get() {
	    return _execution.getDirectiveValues;
	  }
	});
	Object.defineProperty(exports, "subscribe", {
	  enumerable: true,
	  get: function get() {
	    return _subscription.subscribe;
	  }
	});
	Object.defineProperty(exports, "createSourceEventStream", {
	  enumerable: true,
	  get: function get() {
	    return _subscription.createSourceEventStream;
	  }
	});
	Object.defineProperty(exports, "validate", {
	  enumerable: true,
	  get: function get() {
	    return _validation.validate;
	  }
	});
	Object.defineProperty(exports, "ValidationContext", {
	  enumerable: true,
	  get: function get() {
	    return _validation.ValidationContext;
	  }
	});
	Object.defineProperty(exports, "specifiedRules", {
	  enumerable: true,
	  get: function get() {
	    return _validation.specifiedRules;
	  }
	});
	Object.defineProperty(exports, "FieldsOnCorrectTypeRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.FieldsOnCorrectTypeRule;
	  }
	});
	Object.defineProperty(exports, "FragmentsOnCompositeTypesRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.FragmentsOnCompositeTypesRule;
	  }
	});
	Object.defineProperty(exports, "KnownArgumentNamesRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.KnownArgumentNamesRule;
	  }
	});
	Object.defineProperty(exports, "KnownDirectivesRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.KnownDirectivesRule;
	  }
	});
	Object.defineProperty(exports, "KnownFragmentNamesRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.KnownFragmentNamesRule;
	  }
	});
	Object.defineProperty(exports, "KnownTypeNamesRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.KnownTypeNamesRule;
	  }
	});
	Object.defineProperty(exports, "LoneAnonymousOperationRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.LoneAnonymousOperationRule;
	  }
	});
	Object.defineProperty(exports, "NoFragmentCyclesRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.NoFragmentCyclesRule;
	  }
	});
	Object.defineProperty(exports, "NoUndefinedVariablesRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.NoUndefinedVariablesRule;
	  }
	});
	Object.defineProperty(exports, "NoUnusedFragmentsRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.NoUnusedFragmentsRule;
	  }
	});
	Object.defineProperty(exports, "NoUnusedVariablesRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.NoUnusedVariablesRule;
	  }
	});
	Object.defineProperty(exports, "OverlappingFieldsCanBeMergedRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.OverlappingFieldsCanBeMergedRule;
	  }
	});
	Object.defineProperty(exports, "PossibleFragmentSpreadsRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.PossibleFragmentSpreadsRule;
	  }
	});
	Object.defineProperty(exports, "ProvidedRequiredArgumentsRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.ProvidedRequiredArgumentsRule;
	  }
	});
	Object.defineProperty(exports, "ScalarLeafsRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.ScalarLeafsRule;
	  }
	});
	Object.defineProperty(exports, "SingleFieldSubscriptionsRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.SingleFieldSubscriptionsRule;
	  }
	});
	Object.defineProperty(exports, "UniqueArgumentNamesRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.UniqueArgumentNamesRule;
	  }
	});
	Object.defineProperty(exports, "UniqueDirectivesPerLocationRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.UniqueDirectivesPerLocationRule;
	  }
	});
	Object.defineProperty(exports, "UniqueFragmentNamesRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.UniqueFragmentNamesRule;
	  }
	});
	Object.defineProperty(exports, "UniqueInputFieldNamesRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.UniqueInputFieldNamesRule;
	  }
	});
	Object.defineProperty(exports, "UniqueOperationNamesRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.UniqueOperationNamesRule;
	  }
	});
	Object.defineProperty(exports, "UniqueVariableNamesRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.UniqueVariableNamesRule;
	  }
	});
	Object.defineProperty(exports, "ValuesOfCorrectTypeRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.ValuesOfCorrectTypeRule;
	  }
	});
	Object.defineProperty(exports, "VariablesAreInputTypesRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.VariablesAreInputTypesRule;
	  }
	});
	Object.defineProperty(exports, "VariablesInAllowedPositionRule", {
	  enumerable: true,
	  get: function get() {
	    return _validation.VariablesInAllowedPositionRule;
	  }
	});
	Object.defineProperty(exports, "GraphQLError", {
	  enumerable: true,
	  get: function get() {
	    return _error.GraphQLError;
	  }
	});
	Object.defineProperty(exports, "formatError", {
	  enumerable: true,
	  get: function get() {
	    return _error.formatError;
	  }
	});
	Object.defineProperty(exports, "printError", {
	  enumerable: true,
	  get: function get() {
	    return _error.printError;
	  }
	});
	Object.defineProperty(exports, "getIntrospectionQuery", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.getIntrospectionQuery;
	  }
	});
	Object.defineProperty(exports, "introspectionQuery", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.introspectionQuery;
	  }
	});
	Object.defineProperty(exports, "getOperationAST", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.getOperationAST;
	  }
	});
	Object.defineProperty(exports, "getOperationRootType", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.getOperationRootType;
	  }
	});
	Object.defineProperty(exports, "introspectionFromSchema", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.introspectionFromSchema;
	  }
	});
	Object.defineProperty(exports, "buildClientSchema", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.buildClientSchema;
	  }
	});
	Object.defineProperty(exports, "buildASTSchema", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.buildASTSchema;
	  }
	});
	Object.defineProperty(exports, "buildSchema", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.buildSchema;
	  }
	});
	Object.defineProperty(exports, "getDescription", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.getDescription;
	  }
	});
	Object.defineProperty(exports, "extendSchema", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.extendSchema;
	  }
	});
	Object.defineProperty(exports, "lexicographicSortSchema", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.lexicographicSortSchema;
	  }
	});
	Object.defineProperty(exports, "printSchema", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.printSchema;
	  }
	});
	Object.defineProperty(exports, "printIntrospectionSchema", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.printIntrospectionSchema;
	  }
	});
	Object.defineProperty(exports, "printType", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.printType;
	  }
	});
	Object.defineProperty(exports, "typeFromAST", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.typeFromAST;
	  }
	});
	Object.defineProperty(exports, "valueFromAST", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.valueFromAST;
	  }
	});
	Object.defineProperty(exports, "valueFromASTUntyped", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.valueFromASTUntyped;
	  }
	});
	Object.defineProperty(exports, "astFromValue", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.astFromValue;
	  }
	});
	Object.defineProperty(exports, "TypeInfo", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.TypeInfo;
	  }
	});
	Object.defineProperty(exports, "coerceValue", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.coerceValue;
	  }
	});
	Object.defineProperty(exports, "isValidJSValue", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.isValidJSValue;
	  }
	});
	Object.defineProperty(exports, "isValidLiteralValue", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.isValidLiteralValue;
	  }
	});
	Object.defineProperty(exports, "concatAST", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.concatAST;
	  }
	});
	Object.defineProperty(exports, "separateOperations", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.separateOperations;
	  }
	});
	Object.defineProperty(exports, "isEqualType", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.isEqualType;
	  }
	});
	Object.defineProperty(exports, "isTypeSubTypeOf", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.isTypeSubTypeOf;
	  }
	});
	Object.defineProperty(exports, "doTypesOverlap", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.doTypesOverlap;
	  }
	});
	Object.defineProperty(exports, "assertValidName", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.assertValidName;
	  }
	});
	Object.defineProperty(exports, "isValidNameError", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.isValidNameError;
	  }
	});
	Object.defineProperty(exports, "findBreakingChanges", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.findBreakingChanges;
	  }
	});
	Object.defineProperty(exports, "findDangerousChanges", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.findDangerousChanges;
	  }
	});
	Object.defineProperty(exports, "BreakingChangeType", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.BreakingChangeType;
	  }
	});
	Object.defineProperty(exports, "DangerousChangeType", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.DangerousChangeType;
	  }
	});
	Object.defineProperty(exports, "findDeprecatedUsages", {
	  enumerable: true,
	  get: function get() {
	    return _utilities.findDeprecatedUsages;
	  }
	});
	
	var _graphql = __webpack_require__(449);
	
	var _type = __webpack_require__(460);
	
	var _language = __webpack_require__(456);
	
	var _execution = __webpack_require__(448);
	
	var _subscription = __webpack_require__(457);
	
	var _validation = __webpack_require__(474);
	
	var _error = __webpack_require__(101);
	
	var _utilities = __webpack_require__(467);

/***/ },
/* 451 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * Copyright (c) 2018-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/* eslint-disable no-redeclare */
	// $FlowFixMe workaround for: https://github.com/facebook/flow/issues/4441
	var isFinite = Number.isFinite || function (value) {
	  return typeof value === 'number' && isFinite(value);
	};
	
	var _default = isFinite;
	exports.default = _default;

/***/ },
/* 452 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * Copyright (c) 2018-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/* eslint-disable no-redeclare */
	// $FlowFixMe workaround for: https://github.com/facebook/flow/issues/4441
	var isInteger = Number.isInteger || function (value) {
	  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
	};
	
	var _default = isInteger;
	exports.default = _default;

/***/ },
/* 453 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = memoize3;
	
	/**
	 * Copyright (c) 2017-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Memoizes the provided three-argument function.
	 */
	function memoize3(fn) {
	  var cache0;
	
	  function memoized(a1, a2, a3) {
	    if (!cache0) {
	      cache0 = new WeakMap();
	    }
	
	    var cache1 = cache0.get(a1);
	    var cache2;
	
	    if (cache1) {
	      cache2 = cache1.get(a2);
	
	      if (cache2) {
	        var cachedValue = cache2.get(a3);
	
	        if (cachedValue !== undefined) {
	          return cachedValue;
	        }
	      }
	    } else {
	      cache1 = new WeakMap();
	      cache0.set(a1, cache1);
	    }
	
	    if (!cache2) {
	      cache2 = new WeakMap();
	      cache1.set(a2, cache2);
	    }
	
	    var newValue = fn.apply(this, arguments);
	    cache2.set(a3, newValue);
	    return newValue;
	  }
	
	  return memoized;
	}

/***/ },
/* 454 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = promiseForObject;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * This function transforms a JS object `ObjMap<Promise<T>>` into
	 * a `Promise<ObjMap<T>>`
	 *
	 * This is akin to bluebird's `Promise.props`, but implemented only using
	 * `Promise.all` so it will work with any implementation of ES6 promises.
	 */
	function promiseForObject(object) {
	  var keys = Object.keys(object);
	  var valuesAndPromises = keys.map(function (name) {
	    return object[name];
	  });
	  return Promise.all(valuesAndPromises).then(function (values) {
	    return values.reduce(function (resolvedObject, value, i) {
	      resolvedObject[keys[i]] = value;
	      return resolvedObject;
	    }, Object.create(null));
	  });
	}

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = promiseReduce;
	
	var _isPromise = _interopRequireDefault(__webpack_require__(187));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Similar to Array.prototype.reduce(), however the reducing callback may return
	 * a Promise, in which case reduction will continue after each promise resolves.
	 *
	 * If the callback does not return a Promise, then this function will also not
	 * return a Promise.
	 */
	function promiseReduce(values, callback, initialValue) {
	  return values.reduce(function (previous, value) {
	    return (0, _isPromise.default)(previous) ? previous.then(function (resolved) {
	      return callback(resolved, value);
	    }) : callback(previous, value);
	  }, initialValue);
	}

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "getLocation", {
	  enumerable: true,
	  get: function get() {
	    return _location.getLocation;
	  }
	});
	Object.defineProperty(exports, "Kind", {
	  enumerable: true,
	  get: function get() {
	    return _kinds.Kind;
	  }
	});
	Object.defineProperty(exports, "createLexer", {
	  enumerable: true,
	  get: function get() {
	    return _lexer.createLexer;
	  }
	});
	Object.defineProperty(exports, "TokenKind", {
	  enumerable: true,
	  get: function get() {
	    return _lexer.TokenKind;
	  }
	});
	Object.defineProperty(exports, "parse", {
	  enumerable: true,
	  get: function get() {
	    return _parser.parse;
	  }
	});
	Object.defineProperty(exports, "parseValue", {
	  enumerable: true,
	  get: function get() {
	    return _parser.parseValue;
	  }
	});
	Object.defineProperty(exports, "parseType", {
	  enumerable: true,
	  get: function get() {
	    return _parser.parseType;
	  }
	});
	Object.defineProperty(exports, "print", {
	  enumerable: true,
	  get: function get() {
	    return _printer.print;
	  }
	});
	Object.defineProperty(exports, "Source", {
	  enumerable: true,
	  get: function get() {
	    return _source.Source;
	  }
	});
	Object.defineProperty(exports, "visit", {
	  enumerable: true,
	  get: function get() {
	    return _visitor.visit;
	  }
	});
	Object.defineProperty(exports, "visitInParallel", {
	  enumerable: true,
	  get: function get() {
	    return _visitor.visitInParallel;
	  }
	});
	Object.defineProperty(exports, "visitWithTypeInfo", {
	  enumerable: true,
	  get: function get() {
	    return _visitor.visitWithTypeInfo;
	  }
	});
	Object.defineProperty(exports, "getVisitFn", {
	  enumerable: true,
	  get: function get() {
	    return _visitor.getVisitFn;
	  }
	});
	Object.defineProperty(exports, "BREAK", {
	  enumerable: true,
	  get: function get() {
	    return _visitor.BREAK;
	  }
	});
	Object.defineProperty(exports, "isDefinitionNode", {
	  enumerable: true,
	  get: function get() {
	    return _predicates.isDefinitionNode;
	  }
	});
	Object.defineProperty(exports, "isExecutableDefinitionNode", {
	  enumerable: true,
	  get: function get() {
	    return _predicates.isExecutableDefinitionNode;
	  }
	});
	Object.defineProperty(exports, "isSelectionNode", {
	  enumerable: true,
	  get: function get() {
	    return _predicates.isSelectionNode;
	  }
	});
	Object.defineProperty(exports, "isValueNode", {
	  enumerable: true,
	  get: function get() {
	    return _predicates.isValueNode;
	  }
	});
	Object.defineProperty(exports, "isTypeNode", {
	  enumerable: true,
	  get: function get() {
	    return _predicates.isTypeNode;
	  }
	});
	Object.defineProperty(exports, "isTypeSystemDefinitionNode", {
	  enumerable: true,
	  get: function get() {
	    return _predicates.isTypeSystemDefinitionNode;
	  }
	});
	Object.defineProperty(exports, "isTypeDefinitionNode", {
	  enumerable: true,
	  get: function get() {
	    return _predicates.isTypeDefinitionNode;
	  }
	});
	Object.defineProperty(exports, "isTypeSystemExtensionNode", {
	  enumerable: true,
	  get: function get() {
	    return _predicates.isTypeSystemExtensionNode;
	  }
	});
	Object.defineProperty(exports, "isTypeExtensionNode", {
	  enumerable: true,
	  get: function get() {
	    return _predicates.isTypeExtensionNode;
	  }
	});
	Object.defineProperty(exports, "DirectiveLocation", {
	  enumerable: true,
	  get: function get() {
	    return _directiveLocation.DirectiveLocation;
	  }
	});
	
	var _location = __webpack_require__(109);
	
	var _kinds = __webpack_require__(11);
	
	var _lexer = __webpack_require__(108);
	
	var _parser = __webpack_require__(41);
	
	var _printer = __webpack_require__(22);
	
	var _source = __webpack_require__(189);
	
	var _visitor = __webpack_require__(36);
	
	var _predicates = __webpack_require__(65);
	
	var _directiveLocation = __webpack_require__(54);

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "subscribe", {
	  enumerable: true,
	  get: function get() {
	    return _subscribe.subscribe;
	  }
	});
	Object.defineProperty(exports, "createSourceEventStream", {
	  enumerable: true,
	  get: function get() {
	    return _subscribe.createSourceEventStream;
	  }
	});
	
	var _subscribe = __webpack_require__(459);

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mapAsyncIterator;
	
	var _iterall = __webpack_require__(56);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Given an AsyncIterable and a callback function, return an AsyncIterator
	 * which produces values mapped via calling the callback function.
	 */
	function mapAsyncIterator(iterable, callback, rejectCallback) {
	  var iterator = (0, _iterall.getAsyncIterator)(iterable);
	  var $return;
	  var abruptClose; // $FlowFixMe(>=0.68.0)
	
	  if (typeof iterator.return === 'function') {
	    $return = iterator.return;
	
	    abruptClose = function abruptClose(error) {
	      var rethrow = function rethrow() {
	        return Promise.reject(error);
	      };
	
	      return $return.call(iterator).then(rethrow, rethrow);
	    };
	  }
	
	  function mapResult(result) {
	    return result.done ? result : asyncMapValue(result.value, callback).then(iteratorResult, abruptClose);
	  }
	
	  var mapReject;
	
	  if (rejectCallback) {
	    // Capture rejectCallback to ensure it cannot be null.
	    var reject = rejectCallback;
	
	    mapReject = function mapReject(error) {
	      return asyncMapValue(error, reject).then(iteratorResult, abruptClose);
	    };
	  }
	  /* TODO: Flow doesn't support symbols as keys:
	     https://github.com/facebook/flow/issues/3258 */
	
	
	  return _defineProperty({
	    next: function next() {
	      return iterator.next().then(mapResult, mapReject);
	    },
	    return: function _return() {
	      return $return ? $return.call(iterator).then(mapResult, mapReject) : Promise.resolve({
	        value: undefined,
	        done: true
	      });
	    },
	    throw: function _throw(error) {
	      // $FlowFixMe(>=0.68.0)
	      if (typeof iterator.throw === 'function') {
	        return iterator.throw(error).then(mapResult, mapReject);
	      }
	
	      return Promise.reject(error).catch(abruptClose);
	    }
	  }, _iterall.$$asyncIterator, function () {
	    return this;
	  });
	}
	
	function asyncMapValue(value, callback) {
	  return new Promise(function (resolve) {
	    return resolve(callback(value));
	  });
	}
	
	function iteratorResult(value) {
	  return {
	    value: value,
	    done: false
	  };
	}

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subscribe = subscribe;
	exports.createSourceEventStream = createSourceEventStream;
	
	var _iterall = __webpack_require__(56);
	
	var _inspect = _interopRequireDefault(__webpack_require__(16));
	
	var _GraphQLError = __webpack_require__(9);
	
	var _locatedError = __webpack_require__(102);
	
	var _execute = __webpack_require__(63);
	
	var _mapAsyncIterator = _interopRequireDefault(__webpack_require__(458));
	
	var _getOperationRootType = __webpack_require__(112);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2017-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function subscribe(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver) {
	  /* eslint-enable no-redeclare */
	  // Extract arguments from object args if provided.
	  return arguments.length === 1 ? subscribeImpl(argsOrSchema.schema, argsOrSchema.document, argsOrSchema.rootValue, argsOrSchema.contextValue, argsOrSchema.variableValues, argsOrSchema.operationName, argsOrSchema.fieldResolver, argsOrSchema.subscribeFieldResolver) : subscribeImpl(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver);
	}
	/**
	 * This function checks if the error is a GraphQLError. If it is, report it as
	 * an ExecutionResult, containing only errors and no data. Otherwise treat the
	 * error as a system-class error and re-throw it.
	 */
	
	
	function reportGraphQLError(error) {
	  if (error instanceof _GraphQLError.GraphQLError) {
	    return {
	      errors: [error]
	    };
	  }
	
	  throw error;
	}
	
	function subscribeImpl(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver) {
	  var sourcePromise = createSourceEventStream(schema, document, rootValue, contextValue, variableValues, operationName, subscribeFieldResolver); // For each payload yielded from a subscription, map it over the normal
	  // GraphQL `execute` function, with `payload` as the rootValue.
	  // This implements the "MapSourceToResponseEvent" algorithm described in
	  // the GraphQL specification. The `execute` function provides the
	  // "ExecuteSubscriptionEvent" algorithm, as it is nearly identical to the
	  // "ExecuteQuery" algorithm, for which `execute` is also used.
	
	  var mapSourceToResponse = function mapSourceToResponse(payload) {
	    return (0, _execute.execute)(schema, document, payload, contextValue, variableValues, operationName, fieldResolver);
	  }; // Resolve the Source Stream, then map every source value to a
	  // ExecutionResult value as described above.
	
	
	  return sourcePromise.then(function (resultOrStream) {
	    return (// Note: Flow can't refine isAsyncIterable, so explicit casts are used.
	      (0, _iterall.isAsyncIterable)(resultOrStream) ? (0, _mapAsyncIterator.default)(resultOrStream, mapSourceToResponse, reportGraphQLError) : resultOrStream
	    );
	  }, reportGraphQLError);
	}
	/**
	 * Implements the "CreateSourceEventStream" algorithm described in the
	 * GraphQL specification, resolving the subscription source event stream.
	 *
	 * Returns a Promise<AsyncIterable>.
	 *
	 * If the client-provided invalid arguments, the source stream could not be
	 * created, or the resolver did not return an AsyncIterable, this function will
	 * will throw an error, which should be caught and handled by the caller.
	 *
	 * A Source Event Stream represents a sequence of events, each of which triggers
	 * a GraphQL execution for that event.
	 *
	 * This may be useful when hosting the stateful subscription service in a
	 * different process or machine than the stateless GraphQL execution engine,
	 * or otherwise separating these two steps. For more on this, see the
	 * "Supporting Subscriptions at Scale" information in the GraphQL specification.
	 */
	
	
	function createSourceEventStream(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
	  // If arguments are missing or incorrectly typed, this is an internal
	  // developer mistake which should throw an early error.
	  (0, _execute.assertValidExecutionArguments)(schema, document, variableValues);
	
	  try {
	    // If a valid context cannot be created due to incorrect arguments,
	    // this will throw an error.
	    var exeContext = (0, _execute.buildExecutionContext)(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver); // Return early errors if execution context failed.
	
	    if (Array.isArray(exeContext)) {
	      return Promise.resolve({
	        errors: exeContext
	      });
	    }
	
	    var type = (0, _getOperationRootType.getOperationRootType)(schema, exeContext.operation);
	    var fields = (0, _execute.collectFields)(exeContext, type, exeContext.operation.selectionSet, Object.create(null), Object.create(null));
	    var responseNames = Object.keys(fields);
	    var responseName = responseNames[0];
	    var fieldNodes = fields[responseName];
	    var fieldNode = fieldNodes[0];
	    var fieldName = fieldNode.name.value;
	    var fieldDef = (0, _execute.getFieldDef)(schema, type, fieldName);
	
	    if (!fieldDef) {
	      throw new _GraphQLError.GraphQLError("The subscription field \"".concat(fieldName, "\" is not defined."), fieldNodes);
	    } // Call the `subscribe()` resolver or the default resolver to produce an
	    // AsyncIterable yielding raw payloads.
	
	
	    var resolveFn = fieldDef.subscribe || exeContext.fieldResolver;
	    var path = (0, _execute.addPath)(undefined, responseName);
	    var info = (0, _execute.buildResolveInfo)(exeContext, fieldDef, fieldNodes, type, path); // resolveFieldValueOrError implements the "ResolveFieldEventStream"
	    // algorithm from GraphQL specification. It differs from
	    // "ResolveFieldValue" due to providing a different `resolveFn`.
	
	    var result = (0, _execute.resolveFieldValueOrError)(exeContext, fieldDef, fieldNodes, resolveFn, rootValue, info); // Coerce to Promise for easier error handling and consistent return type.
	
	    return Promise.resolve(result).then(function (eventStream) {
	      // If eventStream is an Error, rethrow a located error.
	      if (eventStream instanceof Error) {
	        throw (0, _locatedError.locatedError)(eventStream, fieldNodes, (0, _execute.responsePathAsArray)(path));
	      } // Assert field returned an event stream, otherwise yield an error.
	
	
	      if ((0, _iterall.isAsyncIterable)(eventStream)) {
	        // Note: isAsyncIterable above ensures this will be correct.
	        return eventStream;
	      }
	
	      throw new Error('Subscription field must return Async Iterable. Received: ' + (0, _inspect.default)(eventStream));
	    });
	  } catch (error) {
	    return Promise.reject(error);
	  }
	}

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "isSchema", {
	  enumerable: true,
	  get: function get() {
	    return _schema.isSchema;
	  }
	});
	Object.defineProperty(exports, "GraphQLSchema", {
	  enumerable: true,
	  get: function get() {
	    return _schema.GraphQLSchema;
	  }
	});
	Object.defineProperty(exports, "isType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isType;
	  }
	});
	Object.defineProperty(exports, "isScalarType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isScalarType;
	  }
	});
	Object.defineProperty(exports, "isObjectType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isObjectType;
	  }
	});
	Object.defineProperty(exports, "isInterfaceType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isInterfaceType;
	  }
	});
	Object.defineProperty(exports, "isUnionType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isUnionType;
	  }
	});
	Object.defineProperty(exports, "isEnumType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isEnumType;
	  }
	});
	Object.defineProperty(exports, "isInputObjectType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isInputObjectType;
	  }
	});
	Object.defineProperty(exports, "isListType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isListType;
	  }
	});
	Object.defineProperty(exports, "isNonNullType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isNonNullType;
	  }
	});
	Object.defineProperty(exports, "isInputType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isInputType;
	  }
	});
	Object.defineProperty(exports, "isOutputType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isOutputType;
	  }
	});
	Object.defineProperty(exports, "isLeafType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isLeafType;
	  }
	});
	Object.defineProperty(exports, "isCompositeType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isCompositeType;
	  }
	});
	Object.defineProperty(exports, "isAbstractType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isAbstractType;
	  }
	});
	Object.defineProperty(exports, "isWrappingType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isWrappingType;
	  }
	});
	Object.defineProperty(exports, "isNullableType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isNullableType;
	  }
	});
	Object.defineProperty(exports, "isNamedType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isNamedType;
	  }
	});
	Object.defineProperty(exports, "isRequiredArgument", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isRequiredArgument;
	  }
	});
	Object.defineProperty(exports, "isRequiredInputField", {
	  enumerable: true,
	  get: function get() {
	    return _definition.isRequiredInputField;
	  }
	});
	Object.defineProperty(exports, "assertType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertType;
	  }
	});
	Object.defineProperty(exports, "assertScalarType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertScalarType;
	  }
	});
	Object.defineProperty(exports, "assertObjectType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertObjectType;
	  }
	});
	Object.defineProperty(exports, "assertInterfaceType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertInterfaceType;
	  }
	});
	Object.defineProperty(exports, "assertUnionType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertUnionType;
	  }
	});
	Object.defineProperty(exports, "assertEnumType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertEnumType;
	  }
	});
	Object.defineProperty(exports, "assertInputObjectType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertInputObjectType;
	  }
	});
	Object.defineProperty(exports, "assertListType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertListType;
	  }
	});
	Object.defineProperty(exports, "assertNonNullType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertNonNullType;
	  }
	});
	Object.defineProperty(exports, "assertInputType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertInputType;
	  }
	});
	Object.defineProperty(exports, "assertOutputType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertOutputType;
	  }
	});
	Object.defineProperty(exports, "assertLeafType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertLeafType;
	  }
	});
	Object.defineProperty(exports, "assertCompositeType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertCompositeType;
	  }
	});
	Object.defineProperty(exports, "assertAbstractType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertAbstractType;
	  }
	});
	Object.defineProperty(exports, "assertWrappingType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertWrappingType;
	  }
	});
	Object.defineProperty(exports, "assertNullableType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertNullableType;
	  }
	});
	Object.defineProperty(exports, "assertNamedType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertNamedType;
	  }
	});
	Object.defineProperty(exports, "getNullableType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.getNullableType;
	  }
	});
	Object.defineProperty(exports, "getNamedType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.getNamedType;
	  }
	});
	Object.defineProperty(exports, "GraphQLScalarType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLScalarType;
	  }
	});
	Object.defineProperty(exports, "GraphQLObjectType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLObjectType;
	  }
	});
	Object.defineProperty(exports, "GraphQLInterfaceType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLInterfaceType;
	  }
	});
	Object.defineProperty(exports, "GraphQLUnionType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLUnionType;
	  }
	});
	Object.defineProperty(exports, "GraphQLEnumType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLEnumType;
	  }
	});
	Object.defineProperty(exports, "GraphQLInputObjectType", {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLInputObjectType;
	  }
	});
	Object.defineProperty(exports, "GraphQLList", {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLList;
	  }
	});
	Object.defineProperty(exports, "GraphQLNonNull", {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLNonNull;
	  }
	});
	Object.defineProperty(exports, "isDirective", {
	  enumerable: true,
	  get: function get() {
	    return _directives.isDirective;
	  }
	});
	Object.defineProperty(exports, "GraphQLDirective", {
	  enumerable: true,
	  get: function get() {
	    return _directives.GraphQLDirective;
	  }
	});
	Object.defineProperty(exports, "isSpecifiedDirective", {
	  enumerable: true,
	  get: function get() {
	    return _directives.isSpecifiedDirective;
	  }
	});
	Object.defineProperty(exports, "specifiedDirectives", {
	  enumerable: true,
	  get: function get() {
	    return _directives.specifiedDirectives;
	  }
	});
	Object.defineProperty(exports, "GraphQLIncludeDirective", {
	  enumerable: true,
	  get: function get() {
	    return _directives.GraphQLIncludeDirective;
	  }
	});
	Object.defineProperty(exports, "GraphQLSkipDirective", {
	  enumerable: true,
	  get: function get() {
	    return _directives.GraphQLSkipDirective;
	  }
	});
	Object.defineProperty(exports, "GraphQLDeprecatedDirective", {
	  enumerable: true,
	  get: function get() {
	    return _directives.GraphQLDeprecatedDirective;
	  }
	});
	Object.defineProperty(exports, "DEFAULT_DEPRECATION_REASON", {
	  enumerable: true,
	  get: function get() {
	    return _directives.DEFAULT_DEPRECATION_REASON;
	  }
	});
	Object.defineProperty(exports, "isSpecifiedScalarType", {
	  enumerable: true,
	  get: function get() {
	    return _scalars.isSpecifiedScalarType;
	  }
	});
	Object.defineProperty(exports, "specifiedScalarTypes", {
	  enumerable: true,
	  get: function get() {
	    return _scalars.specifiedScalarTypes;
	  }
	});
	Object.defineProperty(exports, "GraphQLInt", {
	  enumerable: true,
	  get: function get() {
	    return _scalars.GraphQLInt;
	  }
	});
	Object.defineProperty(exports, "GraphQLFloat", {
	  enumerable: true,
	  get: function get() {
	    return _scalars.GraphQLFloat;
	  }
	});
	Object.defineProperty(exports, "GraphQLString", {
	  enumerable: true,
	  get: function get() {
	    return _scalars.GraphQLString;
	  }
	});
	Object.defineProperty(exports, "GraphQLBoolean", {
	  enumerable: true,
	  get: function get() {
	    return _scalars.GraphQLBoolean;
	  }
	});
	Object.defineProperty(exports, "GraphQLID", {
	  enumerable: true,
	  get: function get() {
	    return _scalars.GraphQLID;
	  }
	});
	Object.defineProperty(exports, "TypeKind", {
	  enumerable: true,
	  get: function get() {
	    return _introspection.TypeKind;
	  }
	});
	Object.defineProperty(exports, "isIntrospectionType", {
	  enumerable: true,
	  get: function get() {
	    return _introspection.isIntrospectionType;
	  }
	});
	Object.defineProperty(exports, "introspectionTypes", {
	  enumerable: true,
	  get: function get() {
	    return _introspection.introspectionTypes;
	  }
	});
	Object.defineProperty(exports, "__Schema", {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__Schema;
	  }
	});
	Object.defineProperty(exports, "__Directive", {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__Directive;
	  }
	});
	Object.defineProperty(exports, "__DirectiveLocation", {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__DirectiveLocation;
	  }
	});
	Object.defineProperty(exports, "__Type", {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__Type;
	  }
	});
	Object.defineProperty(exports, "__Field", {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__Field;
	  }
	});
	Object.defineProperty(exports, "__InputValue", {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__InputValue;
	  }
	});
	Object.defineProperty(exports, "__EnumValue", {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__EnumValue;
	  }
	});
	Object.defineProperty(exports, "__TypeKind", {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__TypeKind;
	  }
	});
	Object.defineProperty(exports, "SchemaMetaFieldDef", {
	  enumerable: true,
	  get: function get() {
	    return _introspection.SchemaMetaFieldDef;
	  }
	});
	Object.defineProperty(exports, "TypeMetaFieldDef", {
	  enumerable: true,
	  get: function get() {
	    return _introspection.TypeMetaFieldDef;
	  }
	});
	Object.defineProperty(exports, "TypeNameMetaFieldDef", {
	  enumerable: true,
	  get: function get() {
	    return _introspection.TypeNameMetaFieldDef;
	  }
	});
	Object.defineProperty(exports, "validateSchema", {
	  enumerable: true,
	  get: function get() {
	    return _validate.validateSchema;
	  }
	});
	Object.defineProperty(exports, "assertValidSchema", {
	  enumerable: true,
	  get: function get() {
	    return _validate.assertValidSchema;
	  }
	});
	
	var _schema = __webpack_require__(37);
	
	var _definition = __webpack_require__(10);
	
	var _directives = __webpack_require__(19);
	
	var _scalars = __webpack_require__(28);
	
	var _introspection = __webpack_require__(23);
	
	var _validate = __webpack_require__(66);

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildClientSchema = buildClientSchema;
	
	var _invariant = _interopRequireDefault(__webpack_require__(17));
	
	var _keyMap = _interopRequireDefault(__webpack_require__(27));
	
	var _keyValMap = _interopRequireDefault(__webpack_require__(52));
	
	var _valueFromAST = __webpack_require__(68);
	
	var _parser = __webpack_require__(41);
	
	var _schema = __webpack_require__(37);
	
	var _definition = __webpack_require__(10);
	
	var _directives = __webpack_require__(19);
	
	var _introspection = __webpack_require__(23);
	
	var _scalars = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Build a GraphQLSchema for use by client tools.
	 *
	 * Given the result of a client running the introspection query, creates and
	 * returns a GraphQLSchema instance which can be then used with all graphql-js
	 * tools, but cannot be used to execute a query, as introspection does not
	 * represent the "resolver", "parse" or "serialize" functions or any other
	 * server-internal mechanisms.
	 *
	 * This function expects a complete introspection result. Don't forget to check
	 * the "errors" field of a server response before calling this function.
	 */
	function buildClientSchema(introspection, options) {
	  // Get the schema from the introspection result.
	  var schemaIntrospection = introspection.__schema; // Converts the list of types into a keyMap based on the type names.
	
	  var typeIntrospectionMap = (0, _keyMap.default)(schemaIntrospection.types, function (type) {
	    return type.name;
	  }); // A cache to use to store the actual GraphQLType definition objects by name.
	  // Initialize to the GraphQL built in scalars. All functions below are inline
	  // so that this type def cache is within the scope of the closure.
	
	  var typeDefCache = (0, _keyMap.default)(_scalars.specifiedScalarTypes.concat(_introspection.introspectionTypes), function (type) {
	    return type.name;
	  }); // Given a type reference in introspection, return the GraphQLType instance.
	  // preferring cached instances before building new instances.
	
	  function getType(typeRef) {
	    if (typeRef.kind === _introspection.TypeKind.LIST) {
	      var itemRef = typeRef.ofType;
	
	      if (!itemRef) {
	        throw new Error('Decorated type deeper than introspection query.');
	      }
	
	      return (0, _definition.GraphQLList)(getType(itemRef));
	    }
	
	    if (typeRef.kind === _introspection.TypeKind.NON_NULL) {
	      var nullableRef = typeRef.ofType;
	
	      if (!nullableRef) {
	        throw new Error('Decorated type deeper than introspection query.');
	      }
	
	      var nullableType = getType(nullableRef);
	      return (0, _definition.GraphQLNonNull)((0, _definition.assertNullableType)(nullableType));
	    }
	
	    if (!typeRef.name) {
	      throw new Error('Unknown type reference: ' + JSON.stringify(typeRef));
	    }
	
	    return getNamedType(typeRef.name);
	  }
	
	  function getNamedType(typeName) {
	    if (typeDefCache[typeName]) {
	      return typeDefCache[typeName];
	    }
	
	    var typeIntrospection = typeIntrospectionMap[typeName];
	
	    if (!typeIntrospection) {
	      throw new Error("Invalid or incomplete schema, unknown type: ".concat(typeName, ". Ensure ") + 'that a full introspection query is used in order to build a ' + 'client schema.');
	    }
	
	    var typeDef = buildType(typeIntrospection);
	    typeDefCache[typeName] = typeDef;
	    return typeDef;
	  }
	
	  function getInputType(typeRef) {
	    var type = getType(typeRef);
	    !(0, _definition.isInputType)(type) ? (0, _invariant.default)(0, 'Introspection must provide input type for arguments.') : void 0;
	    return type;
	  }
	
	  function getOutputType(typeRef) {
	    var type = getType(typeRef);
	    !(0, _definition.isOutputType)(type) ? (0, _invariant.default)(0, 'Introspection must provide output type for fields.') : void 0;
	    return type;
	  }
	
	  function getObjectType(typeRef) {
	    var type = getType(typeRef);
	    return (0, _definition.assertObjectType)(type);
	  }
	
	  function getInterfaceType(typeRef) {
	    var type = getType(typeRef);
	    return (0, _definition.assertInterfaceType)(type);
	  } // Given a type's introspection result, construct the correct
	  // GraphQLType instance.
	
	
	  function buildType(type) {
	    if (type && type.name && type.kind) {
	      switch (type.kind) {
	        case _introspection.TypeKind.SCALAR:
	          return buildScalarDef(type);
	
	        case _introspection.TypeKind.OBJECT:
	          return buildObjectDef(type);
	
	        case _introspection.TypeKind.INTERFACE:
	          return buildInterfaceDef(type);
	
	        case _introspection.TypeKind.UNION:
	          return buildUnionDef(type);
	
	        case _introspection.TypeKind.ENUM:
	          return buildEnumDef(type);
	
	        case _introspection.TypeKind.INPUT_OBJECT:
	          return buildInputObjectDef(type);
	      }
	    }
	
	    throw new Error('Invalid or incomplete introspection result. Ensure that a full ' + 'introspection query is used in order to build a client schema:' + JSON.stringify(type));
	  }
	
	  function buildScalarDef(scalarIntrospection) {
	    return new _definition.GraphQLScalarType({
	      name: scalarIntrospection.name,
	      description: scalarIntrospection.description,
	      serialize: function serialize(value) {
	        return value;
	      }
	    });
	  }
	
	  function buildObjectDef(objectIntrospection) {
	    if (!objectIntrospection.interfaces) {
	      throw new Error('Introspection result missing interfaces: ' + JSON.stringify(objectIntrospection));
	    }
	
	    return new _definition.GraphQLObjectType({
	      name: objectIntrospection.name,
	      description: objectIntrospection.description,
	      interfaces: objectIntrospection.interfaces.map(getInterfaceType),
	      fields: function fields() {
	        return buildFieldDefMap(objectIntrospection);
	      }
	    });
	  }
	
	  function buildInterfaceDef(interfaceIntrospection) {
	    return new _definition.GraphQLInterfaceType({
	      name: interfaceIntrospection.name,
	      description: interfaceIntrospection.description,
	      fields: function fields() {
	        return buildFieldDefMap(interfaceIntrospection);
	      }
	    });
	  }
	
	  function buildUnionDef(unionIntrospection) {
	    if (!unionIntrospection.possibleTypes) {
	      throw new Error('Introspection result missing possibleTypes: ' + JSON.stringify(unionIntrospection));
	    }
	
	    return new _definition.GraphQLUnionType({
	      name: unionIntrospection.name,
	      description: unionIntrospection.description,
	      types: unionIntrospection.possibleTypes.map(getObjectType)
	    });
	  }
	
	  function buildEnumDef(enumIntrospection) {
	    if (!enumIntrospection.enumValues) {
	      throw new Error('Introspection result missing enumValues: ' + JSON.stringify(enumIntrospection));
	    }
	
	    return new _definition.GraphQLEnumType({
	      name: enumIntrospection.name,
	      description: enumIntrospection.description,
	      values: (0, _keyValMap.default)(enumIntrospection.enumValues, function (valueIntrospection) {
	        return valueIntrospection.name;
	      }, function (valueIntrospection) {
	        return {
	          description: valueIntrospection.description,
	          deprecationReason: valueIntrospection.deprecationReason
	        };
	      })
	    });
	  }
	
	  function buildInputObjectDef(inputObjectIntrospection) {
	    if (!inputObjectIntrospection.inputFields) {
	      throw new Error('Introspection result missing inputFields: ' + JSON.stringify(inputObjectIntrospection));
	    }
	
	    return new _definition.GraphQLInputObjectType({
	      name: inputObjectIntrospection.name,
	      description: inputObjectIntrospection.description,
	      fields: function fields() {
	        return buildInputValueDefMap(inputObjectIntrospection.inputFields);
	      }
	    });
	  }
	
	  function buildFieldDefMap(typeIntrospection) {
	    if (!typeIntrospection.fields) {
	      throw new Error('Introspection result missing fields: ' + JSON.stringify(typeIntrospection));
	    }
	
	    return (0, _keyValMap.default)(typeIntrospection.fields, function (fieldIntrospection) {
	      return fieldIntrospection.name;
	    }, function (fieldIntrospection) {
	      if (!fieldIntrospection.args) {
	        throw new Error('Introspection result missing field args: ' + JSON.stringify(fieldIntrospection));
	      }
	
	      return {
	        description: fieldIntrospection.description,
	        deprecationReason: fieldIntrospection.deprecationReason,
	        type: getOutputType(fieldIntrospection.type),
	        args: buildInputValueDefMap(fieldIntrospection.args)
	      };
	    });
	  }
	
	  function buildInputValueDefMap(inputValueIntrospections) {
	    return (0, _keyValMap.default)(inputValueIntrospections, function (inputValue) {
	      return inputValue.name;
	    }, buildInputValue);
	  }
	
	  function buildInputValue(inputValueIntrospection) {
	    var type = getInputType(inputValueIntrospection.type);
	    var defaultValue = inputValueIntrospection.defaultValue ? (0, _valueFromAST.valueFromAST)((0, _parser.parseValue)(inputValueIntrospection.defaultValue), type) : undefined;
	    return {
	      description: inputValueIntrospection.description,
	      type: type,
	      defaultValue: defaultValue
	    };
	  }
	
	  function buildDirective(directiveIntrospection) {
	    if (!directiveIntrospection.args) {
	      throw new Error('Introspection result missing directive args: ' + JSON.stringify(directiveIntrospection));
	    }
	
	    return new _directives.GraphQLDirective({
	      name: directiveIntrospection.name,
	      description: directiveIntrospection.description,
	      locations: directiveIntrospection.locations.slice(),
	      args: buildInputValueDefMap(directiveIntrospection.args)
	    });
	  } // Iterate through all types, getting the type definition for each, ensuring
	  // that any type not directly referenced by a field will get created.
	
	
	  var types = schemaIntrospection.types.map(function (typeIntrospection) {
	    return getNamedType(typeIntrospection.name);
	  }); // Get the root Query, Mutation, and Subscription types.
	
	  var queryType = schemaIntrospection.queryType ? getObjectType(schemaIntrospection.queryType) : null;
	  var mutationType = schemaIntrospection.mutationType ? getObjectType(schemaIntrospection.mutationType) : null;
	  var subscriptionType = schemaIntrospection.subscriptionType ? getObjectType(schemaIntrospection.subscriptionType) : null; // Get the directives supported by Introspection, assuming empty-set if
	  // directives were not queried for.
	
	  var directives = schemaIntrospection.directives ? schemaIntrospection.directives.map(buildDirective) : []; // Then produce and return a Schema with these types.
	
	  return new _schema.GraphQLSchema({
	    query: queryType,
	    mutation: mutationType,
	    subscription: subscriptionType,
	    types: types,
	    directives: directives,
	    assumeValid: options && options.assumeValid,
	    allowedLegacyNames: options && options.allowedLegacyNames
	  });
	}

/***/ },
/* 462 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.concatAST = concatAST;
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Provided a collection of ASTs, presumably each from different files,
	 * concatenate the ASTs together into batched AST, useful for validating many
	 * GraphQL source files which together represent one conceptual application.
	 */
	function concatAST(asts) {
	  var batchDefinitions = [];
	
	  for (var i = 0; i < asts.length; i++) {
	    var definitions = asts[i].definitions;
	
	    for (var j = 0; j < definitions.length; j++) {
	      batchDefinitions.push(definitions[j]);
	    }
	  }
	
	  return {
	    kind: 'Document',
	    definitions: batchDefinitions
	  };
	}

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.extendSchema = extendSchema;
	
	var _invariant = _interopRequireDefault(__webpack_require__(17));
	
	var _keyMap = _interopRequireDefault(__webpack_require__(27));
	
	var _keyValMap = _interopRequireDefault(__webpack_require__(52));
	
	var _objectValues = _interopRequireDefault(__webpack_require__(34));
	
	var _buildASTSchema = __webpack_require__(191);
	
	var _validate = __webpack_require__(69);
	
	var _GraphQLError = __webpack_require__(9);
	
	var _schema = __webpack_require__(37);
	
	var _introspection = __webpack_require__(23);
	
	var _scalars = __webpack_require__(28);
	
	var _definition = __webpack_require__(10);
	
	var _directives = __webpack_require__(19);
	
	var _kinds = __webpack_require__(11);
	
	var _predicates = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Produces a new schema given an existing schema and a document which may
	 * contain GraphQL type extensions and definitions. The original schema will
	 * remain unaltered.
	 *
	 * Because a schema represents a graph of references, a schema cannot be
	 * extended without effectively making an entire copy. We do not know until it's
	 * too late if subgraphs remain unchanged.
	 *
	 * This algorithm copies the provided schema, applying extensions while
	 * producing the copy. The original schema remains unaltered.
	 *
	 * Accepts options as a third argument:
	 *
	 *    - commentDescriptions:
	 *        Provide true to use preceding comments as the description.
	 *
	 */
	function extendSchema(schema, documentAST, options) {
	  !(0, _schema.isSchema)(schema) ? (0, _invariant.default)(0, 'Must provide valid GraphQLSchema') : void 0;
	  !(documentAST && documentAST.kind === _kinds.Kind.DOCUMENT) ? (0, _invariant.default)(0, 'Must provide valid Document AST') : void 0;
	
	  if (!options || !(options.assumeValid || options.assumeValidSDL)) {
	    (0, _validate.assertValidSDLExtension)(documentAST, schema);
	  } // Collect the type definitions and extensions found in the document.
	
	
	  var typeDefinitionMap = Object.create(null);
	  var typeExtensionsMap = Object.create(null); // New directives and types are separate because a directives and types can
	  // have the same name. For example, a type named "skip".
	
	  var directiveDefinitions = [];
	  var schemaDef; // Schema extensions are collected which may add additional operation types.
	
	  var schemaExtensions = [];
	
	  for (var i = 0; i < documentAST.definitions.length; i++) {
	    var def = documentAST.definitions[i];
	
	    if (def.kind === _kinds.Kind.SCHEMA_DEFINITION) {
	      schemaDef = def;
	    } else if (def.kind === _kinds.Kind.SCHEMA_EXTENSION) {
	      schemaExtensions.push(def);
	    } else if ((0, _predicates.isTypeDefinitionNode)(def)) {
	      // Sanity check that none of the defined types conflict with the
	      // schema's existing types.
	      var typeName = def.name.value;
	
	      if (schema.getType(typeName)) {
	        throw new _GraphQLError.GraphQLError("Type \"".concat(typeName, "\" already exists in the schema. It cannot also ") + 'be defined in this type definition.', [def]);
	      }
	
	      typeDefinitionMap[typeName] = def;
	    } else if ((0, _predicates.isTypeExtensionNode)(def)) {
	      // Sanity check that this type extension exists within the
	      // schema's existing types.
	      var extendedTypeName = def.name.value;
	      var existingType = schema.getType(extendedTypeName);
	
	      if (!existingType) {
	        throw new _GraphQLError.GraphQLError("Cannot extend type \"".concat(extendedTypeName, "\" because it does not ") + 'exist in the existing schema.', [def]);
	      }
	
	      checkExtensionNode(existingType, def);
	      var existingTypeExtensions = typeExtensionsMap[extendedTypeName];
	      typeExtensionsMap[extendedTypeName] = existingTypeExtensions ? existingTypeExtensions.concat([def]) : [def];
	    } else if (def.kind === _kinds.Kind.DIRECTIVE_DEFINITION) {
	      var directiveName = def.name.value;
	      var existingDirective = schema.getDirective(directiveName);
	
	      if (existingDirective) {
	        throw new _GraphQLError.GraphQLError("Directive \"".concat(directiveName, "\" already exists in the schema. It ") + 'cannot be redefined.', [def]);
	      }
	
	      directiveDefinitions.push(def);
	    }
	  } // If this document contains no new types, extensions, or directives then
	  // return the same unmodified GraphQLSchema instance.
	
	
	  if (Object.keys(typeExtensionsMap).length === 0 && Object.keys(typeDefinitionMap).length === 0 && directiveDefinitions.length === 0 && schemaExtensions.length === 0 && !schemaDef) {
	    return schema;
	  }
	
	  var astBuilder = new _buildASTSchema.ASTDefinitionBuilder(typeDefinitionMap, options, function (typeRef) {
	    var typeName = typeRef.name.value;
	    var existingType = schema.getType(typeName);
	
	    if (existingType) {
	      return extendNamedType(existingType);
	    }
	
	    throw new _GraphQLError.GraphQLError("Unknown type: \"".concat(typeName, "\". Ensure that this type exists ") + 'either in the original schema, or is added in a type definition.', [typeRef]);
	  });
	  var extendTypeCache = Object.create(null); // Get the extended root operation types.
	
	  var operationTypes = {
	    query: extendMaybeNamedType(schema.getQueryType()),
	    mutation: extendMaybeNamedType(schema.getMutationType()),
	    subscription: extendMaybeNamedType(schema.getSubscriptionType())
	  };
	
	  if (schemaDef) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = schemaDef.operationTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var _ref2 = _step.value;
	        var operation = _ref2.operation,
	            type = _ref2.type;
	
	        if (operationTypes[operation]) {
	          throw new Error("Must provide only one ".concat(operation, " type in schema."));
	        } // Note: While this could make early assertions to get the correctly
	        // typed values, that would throw immediately while type system
	        // validation with validateSchema() will produce more actionable results.
	
	
	        operationTypes[operation] = astBuilder.buildType(type);
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return != null) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  } // Then, incorporate schema definition and all schema extensions.
	
	
	  for (var _i = 0; _i < schemaExtensions.length; _i++) {
	    var schemaExtension = schemaExtensions[_i];
	
	    if (schemaExtension.operationTypes) {
	      var _iteratorNormalCompletion12 = true;
	      var _didIteratorError12 = false;
	      var _iteratorError12 = undefined;
	
	      try {
	        for (var _iterator12 = schemaExtension.operationTypes[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	          var _ref4 = _step12.value;
	          var operation = _ref4.operation,
	              type = _ref4.type;
	
	          if (operationTypes[operation]) {
	            throw new Error("Must provide only one ".concat(operation, " type in schema."));
	          } // Note: While this could make early assertions to get the correctly
	          // typed values, that would throw immediately while type system
	          // validation with validateSchema() will produce more actionable results.
	
	
	          operationTypes[operation] = astBuilder.buildType(type);
	        }
	      } catch (err) {
	        _didIteratorError12 = true;
	        _iteratorError12 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
	            _iterator12.return();
	          }
	        } finally {
	          if (_didIteratorError12) {
	            throw _iteratorError12;
	          }
	        }
	      }
	    }
	  }
	
	  var schemaExtensionASTNodes = schemaExtensions ? schema.extensionASTNodes ? schema.extensionASTNodes.concat(schemaExtensions) : schemaExtensions : schema.extensionASTNodes;
	  var types = (0, _objectValues.default)(schema.getTypeMap()).map(function (type) {
	    return extendNamedType(type);
	  }).concat((0, _objectValues.default)(typeDefinitionMap).map(function (type) {
	    return astBuilder.buildType(type);
	  })); // Support both original legacy names and extended legacy names.
	
	  var allowedLegacyNames = schema.__allowedLegacyNames.concat(options && options.allowedLegacyNames || []); // Then produce and return a Schema with these types.
	
	
	  return new _schema.GraphQLSchema(_objectSpread({}, operationTypes, {
	    types: types,
	    directives: getMergedDirectives(),
	    astNode: schema.astNode,
	    extensionASTNodes: schemaExtensionASTNodes,
	    allowedLegacyNames: allowedLegacyNames
	  })); // Below are functions used for producing this schema that have closed over
	  // this scope and have access to the schema, cache, and newly defined types.
	
	  function getMergedDirectives() {
	    var existingDirectives = schema.getDirectives().map(extendDirective);
	    !existingDirectives ? (0, _invariant.default)(0, 'schema must have default directives') : void 0;
	    return existingDirectives.concat(directiveDefinitions.map(function (node) {
	      return astBuilder.buildDirective(node);
	    }));
	  }
	
	  function extendMaybeNamedType(type) {
	    return type ? extendNamedType(type) : null;
	  }
	
	  function extendNamedType(type) {
	    if ((0, _introspection.isIntrospectionType)(type) || (0, _scalars.isSpecifiedScalarType)(type)) {
	      // Builtin types are not extended.
	      return type;
	    }
	
	    var name = type.name;
	
	    if (!extendTypeCache[name]) {
	      if ((0, _definition.isScalarType)(type)) {
	        extendTypeCache[name] = extendScalarType(type);
	      } else if ((0, _definition.isObjectType)(type)) {
	        extendTypeCache[name] = extendObjectType(type);
	      } else if ((0, _definition.isInterfaceType)(type)) {
	        extendTypeCache[name] = extendInterfaceType(type);
	      } else if ((0, _definition.isUnionType)(type)) {
	        extendTypeCache[name] = extendUnionType(type);
	      } else if ((0, _definition.isEnumType)(type)) {
	        extendTypeCache[name] = extendEnumType(type);
	      } else if ((0, _definition.isInputObjectType)(type)) {
	        extendTypeCache[name] = extendInputObjectType(type);
	      }
	    }
	
	    return extendTypeCache[name];
	  }
	
	  function extendDirective(directive) {
	    return new _directives.GraphQLDirective({
	      name: directive.name,
	      description: directive.description,
	      locations: directive.locations,
	      args: extendArgs(directive.args),
	      astNode: directive.astNode
	    });
	  }
	
	  function extendInputObjectType(type) {
	    var name = type.name;
	    var extensionASTNodes = typeExtensionsMap[name] ? type.extensionASTNodes ? type.extensionASTNodes.concat(typeExtensionsMap[name]) : typeExtensionsMap[name] : type.extensionASTNodes;
	    return new _definition.GraphQLInputObjectType({
	      name: name,
	      description: type.description,
	      fields: function fields() {
	        return extendInputFieldMap(type);
	      },
	      astNode: type.astNode,
	      extensionASTNodes: extensionASTNodes
	    });
	  }
	
	  function extendInputFieldMap(type) {
	    var newFieldMap = Object.create(null);
	    var oldFieldMap = type.getFields();
	
	    var _arr = Object.keys(oldFieldMap);
	
	    for (var _i2 = 0; _i2 < _arr.length; _i2++) {
	      var _fieldName = _arr[_i2];
	      var _field = oldFieldMap[_fieldName];
	      newFieldMap[_fieldName] = {
	        description: _field.description,
	        type: extendType(_field.type),
	        defaultValue: _field.defaultValue,
	        astNode: _field.astNode
	      };
	    } // If there are any extensions to the fields, apply those here.
	
	
	    var extensions = typeExtensionsMap[type.name];
	
	    if (extensions) {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = extensions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var extension = _step2.value;
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = extension.fields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var field = _step3.value;
	              var fieldName = field.name.value;
	
	              if (oldFieldMap[fieldName]) {
	                throw new _GraphQLError.GraphQLError("Field \"".concat(type.name, ".").concat(fieldName, "\" already exists in the ") + 'schema. It cannot also be defined in this type extension.', [field]);
	              }
	
	              newFieldMap[fieldName] = astBuilder.buildInputField(field);
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	
	    return newFieldMap;
	  }
	
	  function extendEnumType(type) {
	    var name = type.name;
	    var extensionASTNodes = typeExtensionsMap[name] ? type.extensionASTNodes ? type.extensionASTNodes.concat(typeExtensionsMap[name]) : typeExtensionsMap[name] : type.extensionASTNodes;
	    return new _definition.GraphQLEnumType({
	      name: name,
	      description: type.description,
	      values: extendValueMap(type),
	      astNode: type.astNode,
	      extensionASTNodes: extensionASTNodes
	    });
	  }
	
	  function extendValueMap(type) {
	    var newValueMap = Object.create(null);
	    var oldValueMap = (0, _keyMap.default)(type.getValues(), function (value) {
	      return value.name;
	    });
	
	    var _arr2 = Object.keys(oldValueMap);
	
	    for (var _i3 = 0; _i3 < _arr2.length; _i3++) {
	      var _valueName = _arr2[_i3];
	      var _value = oldValueMap[_valueName];
	      newValueMap[_valueName] = {
	        name: _value.name,
	        description: _value.description,
	        value: _value.value,
	        deprecationReason: _value.deprecationReason,
	        astNode: _value.astNode
	      };
	    } // If there are any extensions to the values, apply those here.
	
	
	    var extensions = typeExtensionsMap[type.name];
	
	    if (extensions) {
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = extensions[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var extension = _step4.value;
	          var _iteratorNormalCompletion5 = true;
	          var _didIteratorError5 = false;
	          var _iteratorError5 = undefined;
	
	          try {
	            for (var _iterator5 = extension.values[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	              var value = _step5.value;
	              var valueName = value.name.value;
	
	              if (oldValueMap[valueName]) {
	                throw new _GraphQLError.GraphQLError("Enum value \"".concat(type.name, ".").concat(valueName, "\" already exists in the ") + 'schema. It cannot also be defined in this type extension.', [value]);
	              }
	
	              newValueMap[valueName] = astBuilder.buildEnumValue(value);
	            }
	          } catch (err) {
	            _didIteratorError5 = true;
	            _iteratorError5 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
	                _iterator5.return();
	              }
	            } finally {
	              if (_didIteratorError5) {
	                throw _iteratorError5;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	    }
	
	    return newValueMap;
	  }
	
	  function extendScalarType(type) {
	    var name = type.name;
	    var extensionASTNodes = typeExtensionsMap[name] ? type.extensionASTNodes ? type.extensionASTNodes.concat(typeExtensionsMap[name]) : typeExtensionsMap[name] : type.extensionASTNodes;
	    return new _definition.GraphQLScalarType({
	      name: name,
	      description: type.description,
	      astNode: type.astNode,
	      extensionASTNodes: extensionASTNodes,
	      serialize: type.serialize,
	      parseValue: type.parseValue,
	      parseLiteral: type.parseLiteral
	    });
	  }
	
	  function extendObjectType(type) {
	    var name = type.name;
	    var extensionASTNodes = typeExtensionsMap[name] ? type.extensionASTNodes ? type.extensionASTNodes.concat(typeExtensionsMap[name]) : typeExtensionsMap[name] : type.extensionASTNodes;
	    return new _definition.GraphQLObjectType({
	      name: name,
	      description: type.description,
	      interfaces: function interfaces() {
	        return extendImplementedInterfaces(type);
	      },
	      fields: function fields() {
	        return extendFieldMap(type);
	      },
	      astNode: type.astNode,
	      extensionASTNodes: extensionASTNodes,
	      isTypeOf: type.isTypeOf
	    });
	  }
	
	  function extendArgs(args) {
	    return (0, _keyValMap.default)(args, function (arg) {
	      return arg.name;
	    }, function (arg) {
	      return {
	        type: extendType(arg.type),
	        defaultValue: arg.defaultValue,
	        description: arg.description,
	        astNode: arg.astNode
	      };
	    });
	  }
	
	  function extendInterfaceType(type) {
	    var name = type.name;
	    var extensionASTNodes = typeExtensionsMap[name] ? type.extensionASTNodes ? type.extensionASTNodes.concat(typeExtensionsMap[name]) : typeExtensionsMap[name] : type.extensionASTNodes;
	    return new _definition.GraphQLInterfaceType({
	      name: type.name,
	      description: type.description,
	      fields: function fields() {
	        return extendFieldMap(type);
	      },
	      astNode: type.astNode,
	      extensionASTNodes: extensionASTNodes,
	      resolveType: type.resolveType
	    });
	  }
	
	  function extendUnionType(type) {
	    var name = type.name;
	    var extensionASTNodes = typeExtensionsMap[name] ? type.extensionASTNodes ? type.extensionASTNodes.concat(typeExtensionsMap[name]) : typeExtensionsMap[name] : type.extensionASTNodes;
	    return new _definition.GraphQLUnionType({
	      name: name,
	      description: type.description,
	      types: function types() {
	        return extendPossibleTypes(type);
	      },
	      astNode: type.astNode,
	      resolveType: type.resolveType,
	      extensionASTNodes: extensionASTNodes
	    });
	  }
	
	  function extendPossibleTypes(type) {
	    var possibleTypes = type.getTypes().map(extendNamedType); // If there are any extensions to the union, apply those here.
	
	    var extensions = typeExtensionsMap[type.name];
	
	    if (extensions) {
	      var _iteratorNormalCompletion6 = true;
	      var _didIteratorError6 = false;
	      var _iteratorError6 = undefined;
	
	      try {
	        for (var _iterator6 = extensions[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	          var extension = _step6.value;
	          var _iteratorNormalCompletion7 = true;
	          var _didIteratorError7 = false;
	          var _iteratorError7 = undefined;
	
	          try {
	            for (var _iterator7 = extension.types[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	              var namedType = _step7.value;
	              // Note: While this could make early assertions to get the correctly
	              // typed values, that would throw immediately while type system
	              // validation with validateSchema() will produce more actionable results.
	              possibleTypes.push(astBuilder.buildType(namedType));
	            }
	          } catch (err) {
	            _didIteratorError7 = true;
	            _iteratorError7 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
	                _iterator7.return();
	              }
	            } finally {
	              if (_didIteratorError7) {
	                throw _iteratorError7;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError6 = true;
	        _iteratorError6 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
	            _iterator6.return();
	          }
	        } finally {
	          if (_didIteratorError6) {
	            throw _iteratorError6;
	          }
	        }
	      }
	    }
	
	    return possibleTypes;
	  }
	
	  function extendImplementedInterfaces(type) {
	    var interfaces = type.getInterfaces().map(extendNamedType); // If there are any extensions to the interfaces, apply those here.
	
	    var extensions = typeExtensionsMap[type.name];
	
	    if (extensions) {
	      var _iteratorNormalCompletion8 = true;
	      var _didIteratorError8 = false;
	      var _iteratorError8 = undefined;
	
	      try {
	        for (var _iterator8 = extensions[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	          var extension = _step8.value;
	          var _iteratorNormalCompletion9 = true;
	          var _didIteratorError9 = false;
	          var _iteratorError9 = undefined;
	
	          try {
	            for (var _iterator9 = extension.interfaces[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	              var namedType = _step9.value;
	              // Note: While this could make early assertions to get the correctly
	              // typed values, that would throw immediately while type system
	              // validation with validateSchema() will produce more actionable results.
	              interfaces.push(astBuilder.buildType(namedType));
	            }
	          } catch (err) {
	            _didIteratorError9 = true;
	            _iteratorError9 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
	                _iterator9.return();
	              }
	            } finally {
	              if (_didIteratorError9) {
	                throw _iteratorError9;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError8 = true;
	        _iteratorError8 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
	            _iterator8.return();
	          }
	        } finally {
	          if (_didIteratorError8) {
	            throw _iteratorError8;
	          }
	        }
	      }
	    }
	
	    return interfaces;
	  }
	
	  function extendFieldMap(type) {
	    var newFieldMap = Object.create(null);
	    var oldFieldMap = type.getFields();
	
	    var _arr3 = Object.keys(oldFieldMap);
	
	    for (var _i4 = 0; _i4 < _arr3.length; _i4++) {
	      var _fieldName2 = _arr3[_i4];
	      var _field2 = oldFieldMap[_fieldName2];
	      newFieldMap[_fieldName2] = {
	        description: _field2.description,
	        deprecationReason: _field2.deprecationReason,
	        type: extendType(_field2.type),
	        args: extendArgs(_field2.args),
	        astNode: _field2.astNode,
	        resolve: _field2.resolve
	      };
	    } // If there are any extensions to the fields, apply those here.
	
	
	    var extensions = typeExtensionsMap[type.name];
	
	    if (extensions) {
	      var _iteratorNormalCompletion10 = true;
	      var _didIteratorError10 = false;
	      var _iteratorError10 = undefined;
	
	      try {
	        for (var _iterator10 = extensions[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	          var extension = _step10.value;
	          var _iteratorNormalCompletion11 = true;
	          var _didIteratorError11 = false;
	          var _iteratorError11 = undefined;
	
	          try {
	            for (var _iterator11 = extension.fields[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	              var field = _step11.value;
	              var fieldName = field.name.value;
	
	              if (oldFieldMap[fieldName]) {
	                throw new _GraphQLError.GraphQLError("Field \"".concat(type.name, ".").concat(fieldName, "\" already exists in the ") + 'schema. It cannot also be defined in this type extension.', [field]);
	              }
	
	              newFieldMap[fieldName] = astBuilder.buildField(field);
	            }
	          } catch (err) {
	            _didIteratorError11 = true;
	            _iteratorError11 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
	                _iterator11.return();
	              }
	            } finally {
	              if (_didIteratorError11) {
	                throw _iteratorError11;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError10 = true;
	        _iteratorError10 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
	            _iterator10.return();
	          }
	        } finally {
	          if (_didIteratorError10) {
	            throw _iteratorError10;
	          }
	        }
	      }
	    }
	
	    return newFieldMap;
	  }
	
	  function extendType(typeDef) {
	    if ((0, _definition.isListType)(typeDef)) {
	      return (0, _definition.GraphQLList)(extendType(typeDef.ofType));
	    }
	
	    if ((0, _definition.isNonNullType)(typeDef)) {
	      return (0, _definition.GraphQLNonNull)(extendType(typeDef.ofType));
	    }
	
	    return extendNamedType(typeDef);
	  }
	}
	
	function checkExtensionNode(type, node) {
	  switch (node.kind) {
	    case _kinds.Kind.OBJECT_TYPE_EXTENSION:
	      if (!(0, _definition.isObjectType)(type)) {
	        throw new _GraphQLError.GraphQLError("Cannot extend non-object type \"".concat(type.name, "\"."), [node]);
	      }
	
	      break;
	
	    case _kinds.Kind.INTERFACE_TYPE_EXTENSION:
	      if (!(0, _definition.isInterfaceType)(type)) {
	        throw new _GraphQLError.GraphQLError("Cannot extend non-interface type \"".concat(type.name, "\"."), [node]);
	      }
	
	      break;
	
	    case _kinds.Kind.ENUM_TYPE_EXTENSION:
	      if (!(0, _definition.isEnumType)(type)) {
	        throw new _GraphQLError.GraphQLError("Cannot extend non-enum type \"".concat(type.name, "\"."), [node]);
	      }
	
	      break;
	
	    case _kinds.Kind.UNION_TYPE_EXTENSION:
	      if (!(0, _definition.isUnionType)(type)) {
	        throw new _GraphQLError.GraphQLError("Cannot extend non-union type \"".concat(type.name, "\"."), [node]);
	      }
	
	      break;
	
	    case _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION:
	      if (!(0, _definition.isInputObjectType)(type)) {
	        throw new _GraphQLError.GraphQLError("Cannot extend non-input object type \"".concat(type.name, "\"."), [node]);
	      }
	
	      break;
	  }
	}

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findBreakingChanges = findBreakingChanges;
	exports.findDangerousChanges = findDangerousChanges;
	exports.findRemovedTypes = findRemovedTypes;
	exports.findTypesThatChangedKind = findTypesThatChangedKind;
	exports.findArgChanges = findArgChanges;
	exports.findFieldsThatChangedTypeOnObjectOrInterfaceTypes = findFieldsThatChangedTypeOnObjectOrInterfaceTypes;
	exports.findFieldsThatChangedTypeOnInputObjectTypes = findFieldsThatChangedTypeOnInputObjectTypes;
	exports.findTypesRemovedFromUnions = findTypesRemovedFromUnions;
	exports.findTypesAddedToUnions = findTypesAddedToUnions;
	exports.findValuesRemovedFromEnums = findValuesRemovedFromEnums;
	exports.findValuesAddedToEnums = findValuesAddedToEnums;
	exports.findInterfacesRemovedFromObjectTypes = findInterfacesRemovedFromObjectTypes;
	exports.findInterfacesAddedToObjectTypes = findInterfacesAddedToObjectTypes;
	exports.findRemovedDirectives = findRemovedDirectives;
	exports.findRemovedDirectiveArgs = findRemovedDirectiveArgs;
	exports.findAddedNonNullDirectiveArgs = findAddedNonNullDirectiveArgs;
	exports.findRemovedLocationsForDirective = findRemovedLocationsForDirective;
	exports.findRemovedDirectiveLocations = findRemovedDirectiveLocations;
	exports.DangerousChangeType = exports.BreakingChangeType = void 0;
	
	var _definition = __webpack_require__(10);
	
	var _keyMap = _interopRequireDefault(__webpack_require__(27));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	var BreakingChangeType = {
	  FIELD_CHANGED_KIND: 'FIELD_CHANGED_KIND',
	  FIELD_REMOVED: 'FIELD_REMOVED',
	  TYPE_CHANGED_KIND: 'TYPE_CHANGED_KIND',
	  TYPE_REMOVED: 'TYPE_REMOVED',
	  TYPE_REMOVED_FROM_UNION: 'TYPE_REMOVED_FROM_UNION',
	  VALUE_REMOVED_FROM_ENUM: 'VALUE_REMOVED_FROM_ENUM',
	  ARG_REMOVED: 'ARG_REMOVED',
	  ARG_CHANGED_KIND: 'ARG_CHANGED_KIND',
	  REQUIRED_ARG_ADDED: 'REQUIRED_ARG_ADDED',
	  REQUIRED_INPUT_FIELD_ADDED: 'REQUIRED_INPUT_FIELD_ADDED',
	  INTERFACE_REMOVED_FROM_OBJECT: 'INTERFACE_REMOVED_FROM_OBJECT',
	  DIRECTIVE_REMOVED: 'DIRECTIVE_REMOVED',
	  DIRECTIVE_ARG_REMOVED: 'DIRECTIVE_ARG_REMOVED',
	  DIRECTIVE_LOCATION_REMOVED: 'DIRECTIVE_LOCATION_REMOVED',
	  REQUIRED_DIRECTIVE_ARG_ADDED: 'REQUIRED_DIRECTIVE_ARG_ADDED'
	};
	exports.BreakingChangeType = BreakingChangeType;
	var DangerousChangeType = {
	  ARG_DEFAULT_VALUE_CHANGE: 'ARG_DEFAULT_VALUE_CHANGE',
	  VALUE_ADDED_TO_ENUM: 'VALUE_ADDED_TO_ENUM',
	  INTERFACE_ADDED_TO_OBJECT: 'INTERFACE_ADDED_TO_OBJECT',
	  TYPE_ADDED_TO_UNION: 'TYPE_ADDED_TO_UNION',
	  OPTIONAL_INPUT_FIELD_ADDED: 'OPTIONAL_INPUT_FIELD_ADDED',
	  OPTIONAL_ARG_ADDED: 'OPTIONAL_ARG_ADDED'
	};
	exports.DangerousChangeType = DangerousChangeType;
	
	/**
	 * Given two schemas, returns an Array containing descriptions of all the types
	 * of breaking changes covered by the other functions down below.
	 */
	function findBreakingChanges(oldSchema, newSchema) {
	  return findRemovedTypes(oldSchema, newSchema).concat(findTypesThatChangedKind(oldSchema, newSchema), findFieldsThatChangedTypeOnObjectOrInterfaceTypes(oldSchema, newSchema), findFieldsThatChangedTypeOnInputObjectTypes(oldSchema, newSchema).breakingChanges, findTypesRemovedFromUnions(oldSchema, newSchema), findValuesRemovedFromEnums(oldSchema, newSchema), findArgChanges(oldSchema, newSchema).breakingChanges, findInterfacesRemovedFromObjectTypes(oldSchema, newSchema), findRemovedDirectives(oldSchema, newSchema), findRemovedDirectiveArgs(oldSchema, newSchema), findAddedNonNullDirectiveArgs(oldSchema, newSchema), findRemovedDirectiveLocations(oldSchema, newSchema));
	}
	/**
	 * Given two schemas, returns an Array containing descriptions of all the types
	 * of potentially dangerous changes covered by the other functions down below.
	 */
	
	
	function findDangerousChanges(oldSchema, newSchema) {
	  return findArgChanges(oldSchema, newSchema).dangerousChanges.concat(findValuesAddedToEnums(oldSchema, newSchema), findInterfacesAddedToObjectTypes(oldSchema, newSchema), findTypesAddedToUnions(oldSchema, newSchema), findFieldsThatChangedTypeOnInputObjectTypes(oldSchema, newSchema).dangerousChanges);
	}
	/**
	 * Given two schemas, returns an Array containing descriptions of any breaking
	 * changes in the newSchema related to removing an entire type.
	 */
	
	
	function findRemovedTypes(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	  var breakingChanges = [];
	
	  var _arr = Object.keys(oldTypeMap);
	
	  for (var _i = 0; _i < _arr.length; _i++) {
	    var typeName = _arr[_i];
	
	    if (!newTypeMap[typeName]) {
	      breakingChanges.push({
	        type: BreakingChangeType.TYPE_REMOVED,
	        description: "".concat(typeName, " was removed.")
	      });
	    }
	  }
	
	  return breakingChanges;
	}
	/**
	 * Given two schemas, returns an Array containing descriptions of any breaking
	 * changes in the newSchema related to changing the type of a type.
	 */
	
	
	function findTypesThatChangedKind(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	  var breakingChanges = [];
	
	  var _arr2 = Object.keys(oldTypeMap);
	
	  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
	    var typeName = _arr2[_i2];
	
	    if (!newTypeMap[typeName]) {
	      continue;
	    }
	
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	
	    if (oldType.constructor !== newType.constructor) {
	      breakingChanges.push({
	        type: BreakingChangeType.TYPE_CHANGED_KIND,
	        description: "".concat(typeName, " changed from ") + "".concat(typeKindName(oldType), " to ").concat(typeKindName(newType), ".")
	      });
	    }
	  }
	
	  return breakingChanges;
	}
	/**
	 * Given two schemas, returns an Array containing descriptions of any
	 * breaking or dangerous changes in the newSchema related to arguments
	 * (such as removal or change of type of an argument, or a change in an
	 * argument's default value).
	 */
	
	
	function findArgChanges(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	  var breakingChanges = [];
	  var dangerousChanges = [];
	
	  var _arr3 = Object.keys(oldTypeMap);
	
	  for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
	    var typeName = _arr3[_i3];
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	
	    if (!((0, _definition.isObjectType)(oldType) || (0, _definition.isInterfaceType)(oldType)) || !((0, _definition.isObjectType)(newType) || (0, _definition.isInterfaceType)(newType)) || newType.constructor !== oldType.constructor) {
	      continue;
	    }
	
	    var oldTypeFields = oldType.getFields();
	    var newTypeFields = newType.getFields();
	
	    var _arr4 = Object.keys(oldTypeFields);
	
	    for (var _i4 = 0; _i4 < _arr4.length; _i4++) {
	      var fieldName = _arr4[_i4];
	
	      if (!newTypeFields[fieldName]) {
	        continue;
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        var _loop = function _loop() {
	          var oldArgDef = _step.value;
	          var newArgs = newTypeFields[fieldName].args;
	          var newArgDef = newArgs.find(function (arg) {
	            return arg.name === oldArgDef.name;
	          }); // Arg not present
	
	          if (!newArgDef) {
	            breakingChanges.push({
	              type: BreakingChangeType.ARG_REMOVED,
	              description: "".concat(oldType.name, ".").concat(fieldName, " arg ") + "".concat(oldArgDef.name, " was removed")
	            });
	          } else {
	            var isSafe = isChangeSafeForInputObjectFieldOrFieldArg(oldArgDef.type, newArgDef.type);
	
	            if (!isSafe) {
	              breakingChanges.push({
	                type: BreakingChangeType.ARG_CHANGED_KIND,
	                description: "".concat(oldType.name, ".").concat(fieldName, " arg ") + "".concat(oldArgDef.name, " has changed type from ") + "".concat(oldArgDef.type.toString(), " to ").concat(newArgDef.type.toString())
	              });
	            } else if (oldArgDef.defaultValue !== undefined && oldArgDef.defaultValue !== newArgDef.defaultValue) {
	              dangerousChanges.push({
	                type: DangerousChangeType.ARG_DEFAULT_VALUE_CHANGE,
	                description: "".concat(oldType.name, ".").concat(fieldName, " arg ") + "".concat(oldArgDef.name, " has changed defaultValue")
	              });
	            }
	          }
	        };
	
	        for (var _iterator = oldTypeFields[fieldName].args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          _loop();
	        } // Check if arg was added to the field
	
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return != null) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        var _loop2 = function _loop2() {
	          var newArgDef = _step2.value;
	          var oldArgs = oldTypeFields[fieldName].args;
	          var oldArgDef = oldArgs.find(function (arg) {
	            return arg.name === newArgDef.name;
	          });
	
	          if (!oldArgDef) {
	            var argName = newArgDef.name;
	
	            if ((0, _definition.isRequiredArgument)(newArgDef)) {
	              breakingChanges.push({
	                type: BreakingChangeType.REQUIRED_ARG_ADDED,
	                description: "A required arg ".concat(argName, " on ") + "".concat(typeName, ".").concat(fieldName, " was added")
	              });
	            } else {
	              dangerousChanges.push({
	                type: DangerousChangeType.OPTIONAL_ARG_ADDED,
	                description: "An optional arg ".concat(argName, " on ") + "".concat(typeName, ".").concat(fieldName, " was added")
	              });
	            }
	          }
	        };
	
	        for (var _iterator2 = newTypeFields[fieldName].args[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          _loop2();
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }
	
	  return {
	    breakingChanges: breakingChanges,
	    dangerousChanges: dangerousChanges
	  };
	}
	
	function typeKindName(type) {
	  if ((0, _definition.isScalarType)(type)) {
	    return 'a Scalar type';
	  }
	
	  if ((0, _definition.isObjectType)(type)) {
	    return 'an Object type';
	  }
	
	  if ((0, _definition.isInterfaceType)(type)) {
	    return 'an Interface type';
	  }
	
	  if ((0, _definition.isUnionType)(type)) {
	    return 'a Union type';
	  }
	
	  if ((0, _definition.isEnumType)(type)) {
	    return 'an Enum type';
	  }
	
	  if ((0, _definition.isInputObjectType)(type)) {
	    return 'an Input type';
	  }
	
	  throw new TypeError('Unknown type ' + type.constructor.name);
	}
	
	function findFieldsThatChangedTypeOnObjectOrInterfaceTypes(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	  var breakingChanges = [];
	
	  var _arr5 = Object.keys(oldTypeMap);
	
	  for (var _i5 = 0; _i5 < _arr5.length; _i5++) {
	    var typeName = _arr5[_i5];
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	
	    if (!((0, _definition.isObjectType)(oldType) || (0, _definition.isInterfaceType)(oldType)) || !((0, _definition.isObjectType)(newType) || (0, _definition.isInterfaceType)(newType)) || newType.constructor !== oldType.constructor) {
	      continue;
	    }
	
	    var oldTypeFieldsDef = oldType.getFields();
	    var newTypeFieldsDef = newType.getFields();
	
	    var _arr6 = Object.keys(oldTypeFieldsDef);
	
	    for (var _i6 = 0; _i6 < _arr6.length; _i6++) {
	      var fieldName = _arr6[_i6];
	
	      // Check if the field is missing on the type in the new schema.
	      if (!(fieldName in newTypeFieldsDef)) {
	        breakingChanges.push({
	          type: BreakingChangeType.FIELD_REMOVED,
	          description: "".concat(typeName, ".").concat(fieldName, " was removed.")
	        });
	      } else {
	        var oldFieldType = oldTypeFieldsDef[fieldName].type;
	        var newFieldType = newTypeFieldsDef[fieldName].type;
	        var isSafe = isChangeSafeForObjectOrInterfaceField(oldFieldType, newFieldType);
	
	        if (!isSafe) {
	          var oldFieldTypeString = (0, _definition.isNamedType)(oldFieldType) ? oldFieldType.name : oldFieldType.toString();
	          var newFieldTypeString = (0, _definition.isNamedType)(newFieldType) ? newFieldType.name : newFieldType.toString();
	          breakingChanges.push({
	            type: BreakingChangeType.FIELD_CHANGED_KIND,
	            description: "".concat(typeName, ".").concat(fieldName, " changed type from ") + "".concat(oldFieldTypeString, " to ").concat(newFieldTypeString, ".")
	          });
	        }
	      }
	    }
	  }
	
	  return breakingChanges;
	}
	
	function findFieldsThatChangedTypeOnInputObjectTypes(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	  var breakingChanges = [];
	  var dangerousChanges = [];
	
	  var _arr7 = Object.keys(oldTypeMap);
	
	  for (var _i7 = 0; _i7 < _arr7.length; _i7++) {
	    var typeName = _arr7[_i7];
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	
	    if (!(0, _definition.isInputObjectType)(oldType) || !(0, _definition.isInputObjectType)(newType)) {
	      continue;
	    }
	
	    var oldTypeFieldsDef = oldType.getFields();
	    var newTypeFieldsDef = newType.getFields();
	
	    var _arr8 = Object.keys(oldTypeFieldsDef);
	
	    for (var _i8 = 0; _i8 < _arr8.length; _i8++) {
	      var fieldName = _arr8[_i8];
	
	      // Check if the field is missing on the type in the new schema.
	      if (!(fieldName in newTypeFieldsDef)) {
	        breakingChanges.push({
	          type: BreakingChangeType.FIELD_REMOVED,
	          description: "".concat(typeName, ".").concat(fieldName, " was removed.")
	        });
	      } else {
	        var oldFieldType = oldTypeFieldsDef[fieldName].type;
	        var newFieldType = newTypeFieldsDef[fieldName].type;
	        var isSafe = isChangeSafeForInputObjectFieldOrFieldArg(oldFieldType, newFieldType);
	
	        if (!isSafe) {
	          var oldFieldTypeString = (0, _definition.isNamedType)(oldFieldType) ? oldFieldType.name : oldFieldType.toString();
	          var newFieldTypeString = (0, _definition.isNamedType)(newFieldType) ? newFieldType.name : newFieldType.toString();
	          breakingChanges.push({
	            type: BreakingChangeType.FIELD_CHANGED_KIND,
	            description: "".concat(typeName, ".").concat(fieldName, " changed type from ") + "".concat(oldFieldTypeString, " to ").concat(newFieldTypeString, ".")
	          });
	        }
	      }
	    } // Check if a field was added to the input object type
	
	
	    var _arr9 = Object.keys(newTypeFieldsDef);
	
	    for (var _i9 = 0; _i9 < _arr9.length; _i9++) {
	      var _fieldName = _arr9[_i9];
	
	      if (!(_fieldName in oldTypeFieldsDef)) {
	        if ((0, _definition.isRequiredInputField)(newTypeFieldsDef[_fieldName])) {
	          breakingChanges.push({
	            type: BreakingChangeType.REQUIRED_INPUT_FIELD_ADDED,
	            description: "A required field ".concat(_fieldName, " on ") + "input type ".concat(typeName, " was added.")
	          });
	        } else {
	          dangerousChanges.push({
	            type: DangerousChangeType.OPTIONAL_INPUT_FIELD_ADDED,
	            description: "An optional field ".concat(_fieldName, " on ") + "input type ".concat(typeName, " was added.")
	          });
	        }
	      }
	    }
	  }
	
	  return {
	    breakingChanges: breakingChanges,
	    dangerousChanges: dangerousChanges
	  };
	}
	
	function isChangeSafeForObjectOrInterfaceField(oldType, newType) {
	  if ((0, _definition.isNamedType)(oldType)) {
	    return (// if they're both named types, see if their names are equivalent
	      (0, _definition.isNamedType)(newType) && oldType.name === newType.name || // moving from nullable to non-null of the same underlying type is safe
	      (0, _definition.isNonNullType)(newType) && isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType)
	    );
	  } else if ((0, _definition.isListType)(oldType)) {
	    return (// if they're both lists, make sure the underlying types are compatible
	      (0, _definition.isListType)(newType) && isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType) || // moving from nullable to non-null of the same underlying type is safe
	      (0, _definition.isNonNullType)(newType) && isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType)
	    );
	  } else if ((0, _definition.isNonNullType)(oldType)) {
	    // if they're both non-null, make sure the underlying types are compatible
	    return (0, _definition.isNonNullType)(newType) && isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType);
	  }
	
	  return false;
	}
	
	function isChangeSafeForInputObjectFieldOrFieldArg(oldType, newType) {
	  if ((0, _definition.isNamedType)(oldType)) {
	    // if they're both named types, see if their names are equivalent
	    return (0, _definition.isNamedType)(newType) && oldType.name === newType.name;
	  } else if ((0, _definition.isListType)(oldType)) {
	    // if they're both lists, make sure the underlying types are compatible
	    return (0, _definition.isListType)(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType);
	  } else if ((0, _definition.isNonNullType)(oldType)) {
	    return (// if they're both non-null, make sure the underlying types are
	      // compatible
	      (0, _definition.isNonNullType)(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType) || // moving from non-null to nullable of the same underlying type is safe
	      !(0, _definition.isNonNullType)(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType)
	    );
	  }
	
	  return false;
	}
	/**
	 * Given two schemas, returns an Array containing descriptions of any breaking
	 * changes in the newSchema related to removing types from a union type.
	 */
	
	
	function findTypesRemovedFromUnions(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	  var typesRemovedFromUnion = [];
	
	  var _arr10 = Object.keys(oldTypeMap);
	
	  for (var _i10 = 0; _i10 < _arr10.length; _i10++) {
	    var typeName = _arr10[_i10];
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	
	    if (!(0, _definition.isUnionType)(oldType) || !(0, _definition.isUnionType)(newType)) {
	      continue;
	    }
	
	    var typeNamesInNewUnion = Object.create(null);
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	      for (var _iterator3 = newType.getTypes()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	        var type = _step3.value;
	        typeNamesInNewUnion[type.name] = true;
	      }
	    } catch (err) {
	      _didIteratorError3 = true;
	      _iteratorError3 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
	          _iterator3.return();
	        }
	      } finally {
	        if (_didIteratorError3) {
	          throw _iteratorError3;
	        }
	      }
	    }
	
	    var _iteratorNormalCompletion4 = true;
	    var _didIteratorError4 = false;
	    var _iteratorError4 = undefined;
	
	    try {
	      for (var _iterator4 = oldType.getTypes()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	        var _type = _step4.value;
	
	        if (!typeNamesInNewUnion[_type.name]) {
	          typesRemovedFromUnion.push({
	            type: BreakingChangeType.TYPE_REMOVED_FROM_UNION,
	            description: "".concat(_type.name, " was removed from union type ").concat(typeName, ".")
	          });
	        }
	      }
	    } catch (err) {
	      _didIteratorError4 = true;
	      _iteratorError4 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
	          _iterator4.return();
	        }
	      } finally {
	        if (_didIteratorError4) {
	          throw _iteratorError4;
	        }
	      }
	    }
	  }
	
	  return typesRemovedFromUnion;
	}
	/**
	 * Given two schemas, returns an Array containing descriptions of any dangerous
	 * changes in the newSchema related to adding types to a union type.
	 */
	
	
	function findTypesAddedToUnions(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	  var typesAddedToUnion = [];
	
	  var _arr11 = Object.keys(newTypeMap);
	
	  for (var _i11 = 0; _i11 < _arr11.length; _i11++) {
	    var typeName = _arr11[_i11];
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	
	    if (!(0, _definition.isUnionType)(oldType) || !(0, _definition.isUnionType)(newType)) {
	      continue;
	    }
	
	    var typeNamesInOldUnion = Object.create(null);
	    var _iteratorNormalCompletion5 = true;
	    var _didIteratorError5 = false;
	    var _iteratorError5 = undefined;
	
	    try {
	      for (var _iterator5 = oldType.getTypes()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	        var type = _step5.value;
	        typeNamesInOldUnion[type.name] = true;
	      }
	    } catch (err) {
	      _didIteratorError5 = true;
	      _iteratorError5 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
	          _iterator5.return();
	        }
	      } finally {
	        if (_didIteratorError5) {
	          throw _iteratorError5;
	        }
	      }
	    }
	
	    var _iteratorNormalCompletion6 = true;
	    var _didIteratorError6 = false;
	    var _iteratorError6 = undefined;
	
	    try {
	      for (var _iterator6 = newType.getTypes()[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	        var _type2 = _step6.value;
	
	        if (!typeNamesInOldUnion[_type2.name]) {
	          typesAddedToUnion.push({
	            type: DangerousChangeType.TYPE_ADDED_TO_UNION,
	            description: "".concat(_type2.name, " was added to union type ").concat(typeName, ".")
	          });
	        }
	      }
	    } catch (err) {
	      _didIteratorError6 = true;
	      _iteratorError6 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
	          _iterator6.return();
	        }
	      } finally {
	        if (_didIteratorError6) {
	          throw _iteratorError6;
	        }
	      }
	    }
	  }
	
	  return typesAddedToUnion;
	}
	/**
	 * Given two schemas, returns an Array containing descriptions of any breaking
	 * changes in the newSchema related to removing values from an enum type.
	 */
	
	
	function findValuesRemovedFromEnums(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	  var valuesRemovedFromEnums = [];
	
	  var _arr12 = Object.keys(oldTypeMap);
	
	  for (var _i12 = 0; _i12 < _arr12.length; _i12++) {
	    var typeName = _arr12[_i12];
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	
	    if (!(0, _definition.isEnumType)(oldType) || !(0, _definition.isEnumType)(newType)) {
	      continue;
	    }
	
	    var valuesInNewEnum = Object.create(null);
	    var _iteratorNormalCompletion7 = true;
	    var _didIteratorError7 = false;
	    var _iteratorError7 = undefined;
	
	    try {
	      for (var _iterator7 = newType.getValues()[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	        var value = _step7.value;
	        valuesInNewEnum[value.name] = true;
	      }
	    } catch (err) {
	      _didIteratorError7 = true;
	      _iteratorError7 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
	          _iterator7.return();
	        }
	      } finally {
	        if (_didIteratorError7) {
	          throw _iteratorError7;
	        }
	      }
	    }
	
	    var _iteratorNormalCompletion8 = true;
	    var _didIteratorError8 = false;
	    var _iteratorError8 = undefined;
	
	    try {
	      for (var _iterator8 = oldType.getValues()[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	        var _value = _step8.value;
	
	        if (!valuesInNewEnum[_value.name]) {
	          valuesRemovedFromEnums.push({
	            type: BreakingChangeType.VALUE_REMOVED_FROM_ENUM,
	            description: "".concat(_value.name, " was removed from enum type ").concat(typeName, ".")
	          });
	        }
	      }
	    } catch (err) {
	      _didIteratorError8 = true;
	      _iteratorError8 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
	          _iterator8.return();
	        }
	      } finally {
	        if (_didIteratorError8) {
	          throw _iteratorError8;
	        }
	      }
	    }
	  }
	
	  return valuesRemovedFromEnums;
	}
	/**
	 * Given two schemas, returns an Array containing descriptions of any dangerous
	 * changes in the newSchema related to adding values to an enum type.
	 */
	
	
	function findValuesAddedToEnums(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	  var valuesAddedToEnums = [];
	
	  var _arr13 = Object.keys(oldTypeMap);
	
	  for (var _i13 = 0; _i13 < _arr13.length; _i13++) {
	    var typeName = _arr13[_i13];
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	
	    if (!(0, _definition.isEnumType)(oldType) || !(0, _definition.isEnumType)(newType)) {
	      continue;
	    }
	
	    var valuesInOldEnum = Object.create(null);
	    var _iteratorNormalCompletion9 = true;
	    var _didIteratorError9 = false;
	    var _iteratorError9 = undefined;
	
	    try {
	      for (var _iterator9 = oldType.getValues()[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	        var value = _step9.value;
	        valuesInOldEnum[value.name] = true;
	      }
	    } catch (err) {
	      _didIteratorError9 = true;
	      _iteratorError9 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
	          _iterator9.return();
	        }
	      } finally {
	        if (_didIteratorError9) {
	          throw _iteratorError9;
	        }
	      }
	    }
	
	    var _iteratorNormalCompletion10 = true;
	    var _didIteratorError10 = false;
	    var _iteratorError10 = undefined;
	
	    try {
	      for (var _iterator10 = newType.getValues()[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	        var _value2 = _step10.value;
	
	        if (!valuesInOldEnum[_value2.name]) {
	          valuesAddedToEnums.push({
	            type: DangerousChangeType.VALUE_ADDED_TO_ENUM,
	            description: "".concat(_value2.name, " was added to enum type ").concat(typeName, ".")
	          });
	        }
	      }
	    } catch (err) {
	      _didIteratorError10 = true;
	      _iteratorError10 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
	          _iterator10.return();
	        }
	      } finally {
	        if (_didIteratorError10) {
	          throw _iteratorError10;
	        }
	      }
	    }
	  }
	
	  return valuesAddedToEnums;
	}
	
	function findInterfacesRemovedFromObjectTypes(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	  var breakingChanges = [];
	
	  var _arr14 = Object.keys(oldTypeMap);
	
	  for (var _i14 = 0; _i14 < _arr14.length; _i14++) {
	    var typeName = _arr14[_i14];
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	
	    if (!(0, _definition.isObjectType)(oldType) || !(0, _definition.isObjectType)(newType)) {
	      continue;
	    }
	
	    var oldInterfaces = oldType.getInterfaces();
	    var newInterfaces = newType.getInterfaces();
	    var _iteratorNormalCompletion11 = true;
	    var _didIteratorError11 = false;
	    var _iteratorError11 = undefined;
	
	    try {
	      var _loop3 = function _loop3() {
	        var oldInterface = _step11.value;
	
	        if (!newInterfaces.some(function (int) {
	          return int.name === oldInterface.name;
	        })) {
	          breakingChanges.push({
	            type: BreakingChangeType.INTERFACE_REMOVED_FROM_OBJECT,
	            description: "".concat(typeName, " no longer implements interface ") + "".concat(oldInterface.name, ".")
	          });
	        }
	      };
	
	      for (var _iterator11 = oldInterfaces[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	        _loop3();
	      }
	    } catch (err) {
	      _didIteratorError11 = true;
	      _iteratorError11 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
	          _iterator11.return();
	        }
	      } finally {
	        if (_didIteratorError11) {
	          throw _iteratorError11;
	        }
	      }
	    }
	  }
	
	  return breakingChanges;
	}
	
	function findInterfacesAddedToObjectTypes(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	  var interfacesAddedToObjectTypes = [];
	
	  var _arr15 = Object.keys(newTypeMap);
	
	  for (var _i15 = 0; _i15 < _arr15.length; _i15++) {
	    var typeName = _arr15[_i15];
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	
	    if (!(0, _definition.isObjectType)(oldType) || !(0, _definition.isObjectType)(newType)) {
	      continue;
	    }
	
	    var oldInterfaces = oldType.getInterfaces();
	    var newInterfaces = newType.getInterfaces();
	    var _iteratorNormalCompletion12 = true;
	    var _didIteratorError12 = false;
	    var _iteratorError12 = undefined;
	
	    try {
	      var _loop4 = function _loop4() {
	        var newInterface = _step12.value;
	
	        if (!oldInterfaces.some(function (int) {
	          return int.name === newInterface.name;
	        })) {
	          interfacesAddedToObjectTypes.push({
	            type: DangerousChangeType.INTERFACE_ADDED_TO_OBJECT,
	            description: "".concat(newInterface.name, " added to interfaces implemented ") + "by ".concat(typeName, ".")
	          });
	        }
	      };
	
	      for (var _iterator12 = newInterfaces[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	        _loop4();
	      }
	    } catch (err) {
	      _didIteratorError12 = true;
	      _iteratorError12 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
	          _iterator12.return();
	        }
	      } finally {
	        if (_didIteratorError12) {
	          throw _iteratorError12;
	        }
	      }
	    }
	  }
	
	  return interfacesAddedToObjectTypes;
	}
	
	function findRemovedDirectives(oldSchema, newSchema) {
	  var removedDirectives = [];
	  var newSchemaDirectiveMap = getDirectiveMapForSchema(newSchema);
	  var _iteratorNormalCompletion13 = true;
	  var _didIteratorError13 = false;
	  var _iteratorError13 = undefined;
	
	  try {
	    for (var _iterator13 = oldSchema.getDirectives()[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
	      var directive = _step13.value;
	
	      if (!newSchemaDirectiveMap[directive.name]) {
	        removedDirectives.push({
	          type: BreakingChangeType.DIRECTIVE_REMOVED,
	          description: "".concat(directive.name, " was removed")
	        });
	      }
	    }
	  } catch (err) {
	    _didIteratorError13 = true;
	    _iteratorError13 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
	        _iterator13.return();
	      }
	    } finally {
	      if (_didIteratorError13) {
	        throw _iteratorError13;
	      }
	    }
	  }
	
	  return removedDirectives;
	}
	
	function findRemovedArgsForDirective(oldDirective, newDirective) {
	  var removedArgs = [];
	  var newArgMap = getArgumentMapForDirective(newDirective);
	  var _iteratorNormalCompletion14 = true;
	  var _didIteratorError14 = false;
	  var _iteratorError14 = undefined;
	
	  try {
	    for (var _iterator14 = oldDirective.args[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
	      var arg = _step14.value;
	
	      if (!newArgMap[arg.name]) {
	        removedArgs.push(arg);
	      }
	    }
	  } catch (err) {
	    _didIteratorError14 = true;
	    _iteratorError14 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
	        _iterator14.return();
	      }
	    } finally {
	      if (_didIteratorError14) {
	        throw _iteratorError14;
	      }
	    }
	  }
	
	  return removedArgs;
	}
	
	function findRemovedDirectiveArgs(oldSchema, newSchema) {
	  var removedDirectiveArgs = [];
	  var oldSchemaDirectiveMap = getDirectiveMapForSchema(oldSchema);
	  var _iteratorNormalCompletion15 = true;
	  var _didIteratorError15 = false;
	  var _iteratorError15 = undefined;
	
	  try {
	    for (var _iterator15 = newSchema.getDirectives()[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
	      var newDirective = _step15.value;
	      var oldDirective = oldSchemaDirectiveMap[newDirective.name];
	
	      if (!oldDirective) {
	        continue;
	      }
	
	      var _iteratorNormalCompletion16 = true;
	      var _didIteratorError16 = false;
	      var _iteratorError16 = undefined;
	
	      try {
	        for (var _iterator16 = findRemovedArgsForDirective(oldDirective, newDirective)[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
	          var arg = _step16.value;
	          removedDirectiveArgs.push({
	            type: BreakingChangeType.DIRECTIVE_ARG_REMOVED,
	            description: "".concat(arg.name, " was removed from ").concat(newDirective.name)
	          });
	        }
	      } catch (err) {
	        _didIteratorError16 = true;
	        _iteratorError16 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
	            _iterator16.return();
	          }
	        } finally {
	          if (_didIteratorError16) {
	            throw _iteratorError16;
	          }
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError15 = true;
	    _iteratorError15 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
	        _iterator15.return();
	      }
	    } finally {
	      if (_didIteratorError15) {
	        throw _iteratorError15;
	      }
	    }
	  }
	
	  return removedDirectiveArgs;
	}
	
	function findAddedArgsForDirective(oldDirective, newDirective) {
	  var addedArgs = [];
	  var oldArgMap = getArgumentMapForDirective(oldDirective);
	  var _iteratorNormalCompletion17 = true;
	  var _didIteratorError17 = false;
	  var _iteratorError17 = undefined;
	
	  try {
	    for (var _iterator17 = newDirective.args[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
	      var arg = _step17.value;
	
	      if (!oldArgMap[arg.name]) {
	        addedArgs.push(arg);
	      }
	    }
	  } catch (err) {
	    _didIteratorError17 = true;
	    _iteratorError17 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion17 && _iterator17.return != null) {
	        _iterator17.return();
	      }
	    } finally {
	      if (_didIteratorError17) {
	        throw _iteratorError17;
	      }
	    }
	  }
	
	  return addedArgs;
	}
	
	function findAddedNonNullDirectiveArgs(oldSchema, newSchema) {
	  var addedNonNullableArgs = [];
	  var oldSchemaDirectiveMap = getDirectiveMapForSchema(oldSchema);
	  var _iteratorNormalCompletion18 = true;
	  var _didIteratorError18 = false;
	  var _iteratorError18 = undefined;
	
	  try {
	    for (var _iterator18 = newSchema.getDirectives()[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
	      var newDirective = _step18.value;
	      var oldDirective = oldSchemaDirectiveMap[newDirective.name];
	
	      if (!oldDirective) {
	        continue;
	      }
	
	      var _iteratorNormalCompletion19 = true;
	      var _didIteratorError19 = false;
	      var _iteratorError19 = undefined;
	
	      try {
	        for (var _iterator19 = findAddedArgsForDirective(oldDirective, newDirective)[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
	          var arg = _step19.value;
	
	          if ((0, _definition.isRequiredArgument)(arg)) {
	            addedNonNullableArgs.push({
	              type: BreakingChangeType.REQUIRED_DIRECTIVE_ARG_ADDED,
	              description: "A required arg ".concat(arg.name, " on directive ") + "".concat(newDirective.name, " was added")
	            });
	          }
	        }
	      } catch (err) {
	        _didIteratorError19 = true;
	        _iteratorError19 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion19 && _iterator19.return != null) {
	            _iterator19.return();
	          }
	        } finally {
	          if (_didIteratorError19) {
	            throw _iteratorError19;
	          }
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError18 = true;
	    _iteratorError18 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion18 && _iterator18.return != null) {
	        _iterator18.return();
	      }
	    } finally {
	      if (_didIteratorError18) {
	        throw _iteratorError18;
	      }
	    }
	  }
	
	  return addedNonNullableArgs;
	}
	
	function findRemovedLocationsForDirective(oldDirective, newDirective) {
	  var removedLocations = [];
	  var newLocationSet = new Set(newDirective.locations);
	  var _iteratorNormalCompletion20 = true;
	  var _didIteratorError20 = false;
	  var _iteratorError20 = undefined;
	
	  try {
	    for (var _iterator20 = oldDirective.locations[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
	      var oldLocation = _step20.value;
	
	      if (!newLocationSet.has(oldLocation)) {
	        removedLocations.push(oldLocation);
	      }
	    }
	  } catch (err) {
	    _didIteratorError20 = true;
	    _iteratorError20 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion20 && _iterator20.return != null) {
	        _iterator20.return();
	      }
	    } finally {
	      if (_didIteratorError20) {
	        throw _iteratorError20;
	      }
	    }
	  }
	
	  return removedLocations;
	}
	
	function findRemovedDirectiveLocations(oldSchema, newSchema) {
	  var removedLocations = [];
	  var oldSchemaDirectiveMap = getDirectiveMapForSchema(oldSchema);
	  var _iteratorNormalCompletion21 = true;
	  var _didIteratorError21 = false;
	  var _iteratorError21 = undefined;
	
	  try {
	    for (var _iterator21 = newSchema.getDirectives()[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
	      var newDirective = _step21.value;
	      var oldDirective = oldSchemaDirectiveMap[newDirective.name];
	
	      if (!oldDirective) {
	        continue;
	      }
	
	      var _iteratorNormalCompletion22 = true;
	      var _didIteratorError22 = false;
	      var _iteratorError22 = undefined;
	
	      try {
	        for (var _iterator22 = findRemovedLocationsForDirective(oldDirective, newDirective)[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
	          var location = _step22.value;
	          removedLocations.push({
	            type: BreakingChangeType.DIRECTIVE_LOCATION_REMOVED,
	            description: "".concat(location, " was removed from ").concat(newDirective.name)
	          });
	        }
	      } catch (err) {
	        _didIteratorError22 = true;
	        _iteratorError22 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion22 && _iterator22.return != null) {
	            _iterator22.return();
	          }
	        } finally {
	          if (_didIteratorError22) {
	            throw _iteratorError22;
	          }
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError21 = true;
	    _iteratorError21 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion21 && _iterator21.return != null) {
	        _iterator21.return();
	      }
	    } finally {
	      if (_didIteratorError21) {
	        throw _iteratorError21;
	      }
	    }
	  }
	
	  return removedLocations;
	}
	
	function getDirectiveMapForSchema(schema) {
	  return (0, _keyMap.default)(schema.getDirectives(), function (dir) {
	    return dir.name;
	  });
	}
	
	function getArgumentMapForDirective(directive) {
	  return (0, _keyMap.default)(directive.args, function (arg) {
	    return arg.name;
	  });
	}

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findDeprecatedUsages = findDeprecatedUsages;
	
	var _GraphQLError = __webpack_require__(9);
	
	var _visitor = __webpack_require__(36);
	
	var _definition = __webpack_require__(10);
	
	var _TypeInfo = __webpack_require__(55);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * A validation rule which reports deprecated usages.
	 *
	 * Returns a list of GraphQLError instances describing each deprecated use.
	 */
	function findDeprecatedUsages(schema, ast) {
	  var errors = [];
	  var typeInfo = new _TypeInfo.TypeInfo(schema);
	  (0, _visitor.visit)(ast, (0, _visitor.visitWithTypeInfo)(typeInfo, {
	    Field: function Field(node) {
	      var fieldDef = typeInfo.getFieldDef();
	
	      if (fieldDef && fieldDef.isDeprecated) {
	        var parentType = typeInfo.getParentType();
	
	        if (parentType) {
	          var reason = fieldDef.deprecationReason;
	          errors.push(new _GraphQLError.GraphQLError("The field ".concat(parentType.name, ".").concat(fieldDef.name, " is deprecated.") + (reason ? ' ' + reason : ''), [node]));
	        }
	      }
	    },
	    EnumValue: function EnumValue(node) {
	      var enumVal = typeInfo.getEnumValue();
	
	      if (enumVal && enumVal.isDeprecated) {
	        var type = (0, _definition.getNamedType)(typeInfo.getInputType());
	
	        if (type) {
	          var reason = enumVal.deprecationReason;
	          errors.push(new _GraphQLError.GraphQLError("The enum value ".concat(type.name, ".").concat(enumVal.name, " is deprecated.") + (reason ? ' ' + reason : ''), [node]));
	        }
	      }
	    }
	  }));
	  return errors;
	}

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOperationAST = getOperationAST;
	
	var _kinds = __webpack_require__(11);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Returns an operation AST given a document AST and optionally an operation
	 * name. If a name is not provided, an operation is only returned if only one is
	 * provided in the document.
	 */
	function getOperationAST(documentAST, operationName) {
	  var operation = null;
	
	  for (var i = 0; i < documentAST.definitions.length; i++) {
	    var definition = documentAST.definitions[i];
	
	    if (definition.kind === _kinds.Kind.OPERATION_DEFINITION) {
	      if (!operationName) {
	        // If no operation name was provided, only return an Operation if there
	        // is one defined in the document. Upon encountering the second, return
	        // null.
	        if (operation) {
	          return null;
	        }
	
	        operation = definition;
	      } else if (definition.name && definition.name.value === operationName) {
	        return definition;
	      }
	    }
	  }
	
	  return operation;
	}

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "getIntrospectionQuery", {
	  enumerable: true,
	  get: function get() {
	    return _introspectionQuery.getIntrospectionQuery;
	  }
	});
	Object.defineProperty(exports, "introspectionQuery", {
	  enumerable: true,
	  get: function get() {
	    return _introspectionQuery.introspectionQuery;
	  }
	});
	Object.defineProperty(exports, "getOperationAST", {
	  enumerable: true,
	  get: function get() {
	    return _getOperationAST.getOperationAST;
	  }
	});
	Object.defineProperty(exports, "getOperationRootType", {
	  enumerable: true,
	  get: function get() {
	    return _getOperationRootType.getOperationRootType;
	  }
	});
	Object.defineProperty(exports, "introspectionFromSchema", {
	  enumerable: true,
	  get: function get() {
	    return _introspectionFromSchema.introspectionFromSchema;
	  }
	});
	Object.defineProperty(exports, "buildClientSchema", {
	  enumerable: true,
	  get: function get() {
	    return _buildClientSchema.buildClientSchema;
	  }
	});
	Object.defineProperty(exports, "buildASTSchema", {
	  enumerable: true,
	  get: function get() {
	    return _buildASTSchema.buildASTSchema;
	  }
	});
	Object.defineProperty(exports, "buildSchema", {
	  enumerable: true,
	  get: function get() {
	    return _buildASTSchema.buildSchema;
	  }
	});
	Object.defineProperty(exports, "getDescription", {
	  enumerable: true,
	  get: function get() {
	    return _buildASTSchema.getDescription;
	  }
	});
	Object.defineProperty(exports, "extendSchema", {
	  enumerable: true,
	  get: function get() {
	    return _extendSchema.extendSchema;
	  }
	});
	Object.defineProperty(exports, "lexicographicSortSchema", {
	  enumerable: true,
	  get: function get() {
	    return _lexicographicSortSchema.lexicographicSortSchema;
	  }
	});
	Object.defineProperty(exports, "printSchema", {
	  enumerable: true,
	  get: function get() {
	    return _schemaPrinter.printSchema;
	  }
	});
	Object.defineProperty(exports, "printType", {
	  enumerable: true,
	  get: function get() {
	    return _schemaPrinter.printType;
	  }
	});
	Object.defineProperty(exports, "printIntrospectionSchema", {
	  enumerable: true,
	  get: function get() {
	    return _schemaPrinter.printIntrospectionSchema;
	  }
	});
	Object.defineProperty(exports, "typeFromAST", {
	  enumerable: true,
	  get: function get() {
	    return _typeFromAST.typeFromAST;
	  }
	});
	Object.defineProperty(exports, "valueFromAST", {
	  enumerable: true,
	  get: function get() {
	    return _valueFromAST.valueFromAST;
	  }
	});
	Object.defineProperty(exports, "valueFromASTUntyped", {
	  enumerable: true,
	  get: function get() {
	    return _valueFromASTUntyped.valueFromASTUntyped;
	  }
	});
	Object.defineProperty(exports, "astFromValue", {
	  enumerable: true,
	  get: function get() {
	    return _astFromValue.astFromValue;
	  }
	});
	Object.defineProperty(exports, "TypeInfo", {
	  enumerable: true,
	  get: function get() {
	    return _TypeInfo.TypeInfo;
	  }
	});
	Object.defineProperty(exports, "coerceValue", {
	  enumerable: true,
	  get: function get() {
	    return _coerceValue.coerceValue;
	  }
	});
	Object.defineProperty(exports, "isValidJSValue", {
	  enumerable: true,
	  get: function get() {
	    return _isValidJSValue.isValidJSValue;
	  }
	});
	Object.defineProperty(exports, "isValidLiteralValue", {
	  enumerable: true,
	  get: function get() {
	    return _isValidLiteralValue.isValidLiteralValue;
	  }
	});
	Object.defineProperty(exports, "concatAST", {
	  enumerable: true,
	  get: function get() {
	    return _concatAST.concatAST;
	  }
	});
	Object.defineProperty(exports, "separateOperations", {
	  enumerable: true,
	  get: function get() {
	    return _separateOperations.separateOperations;
	  }
	});
	Object.defineProperty(exports, "isEqualType", {
	  enumerable: true,
	  get: function get() {
	    return _typeComparators.isEqualType;
	  }
	});
	Object.defineProperty(exports, "isTypeSubTypeOf", {
	  enumerable: true,
	  get: function get() {
	    return _typeComparators.isTypeSubTypeOf;
	  }
	});
	Object.defineProperty(exports, "doTypesOverlap", {
	  enumerable: true,
	  get: function get() {
	    return _typeComparators.doTypesOverlap;
	  }
	});
	Object.defineProperty(exports, "assertValidName", {
	  enumerable: true,
	  get: function get() {
	    return _assertValidName.assertValidName;
	  }
	});
	Object.defineProperty(exports, "isValidNameError", {
	  enumerable: true,
	  get: function get() {
	    return _assertValidName.isValidNameError;
	  }
	});
	Object.defineProperty(exports, "BreakingChangeType", {
	  enumerable: true,
	  get: function get() {
	    return _findBreakingChanges.BreakingChangeType;
	  }
	});
	Object.defineProperty(exports, "DangerousChangeType", {
	  enumerable: true,
	  get: function get() {
	    return _findBreakingChanges.DangerousChangeType;
	  }
	});
	Object.defineProperty(exports, "findBreakingChanges", {
	  enumerable: true,
	  get: function get() {
	    return _findBreakingChanges.findBreakingChanges;
	  }
	});
	Object.defineProperty(exports, "findDangerousChanges", {
	  enumerable: true,
	  get: function get() {
	    return _findBreakingChanges.findDangerousChanges;
	  }
	});
	Object.defineProperty(exports, "findDeprecatedUsages", {
	  enumerable: true,
	  get: function get() {
	    return _findDeprecatedUsages.findDeprecatedUsages;
	  }
	});
	
	var _introspectionQuery = __webpack_require__(192);
	
	var _getOperationAST = __webpack_require__(466);
	
	var _getOperationRootType = __webpack_require__(112);
	
	var _introspectionFromSchema = __webpack_require__(468);
	
	var _buildClientSchema = __webpack_require__(461);
	
	var _buildASTSchema = __webpack_require__(191);
	
	var _extendSchema = __webpack_require__(463);
	
	var _lexicographicSortSchema = __webpack_require__(471);
	
	var _schemaPrinter = __webpack_require__(472);
	
	var _typeFromAST = __webpack_require__(29);
	
	var _valueFromAST = __webpack_require__(68);
	
	var _valueFromASTUntyped = __webpack_require__(193);
	
	var _astFromValue = __webpack_require__(110);
	
	var _TypeInfo = __webpack_require__(55);
	
	var _coerceValue = __webpack_require__(111);
	
	var _isValidJSValue = __webpack_require__(469);
	
	var _isValidLiteralValue = __webpack_require__(470);
	
	var _concatAST = __webpack_require__(462);
	
	var _separateOperations = __webpack_require__(473);
	
	var _typeComparators = __webpack_require__(67);
	
	var _assertValidName = __webpack_require__(190);
	
	var _findBreakingChanges = __webpack_require__(464);
	
	var _findDeprecatedUsages = __webpack_require__(465);

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.introspectionFromSchema = introspectionFromSchema;
	
	var _invariant = _interopRequireDefault(__webpack_require__(17));
	
	var _introspectionQuery = __webpack_require__(192);
	
	var _execute = __webpack_require__(63);
	
	var _parser = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Build an IntrospectionQuery from a GraphQLSchema
	 *
	 * IntrospectionQuery is useful for utilities that care about type and field
	 * relationships, but do not need to traverse through those relationships.
	 *
	 * This is the inverse of buildClientSchema. The primary use case is outside
	 * of the server context, for instance when doing schema comparisons.
	 */
	function introspectionFromSchema(schema, options) {
	  var queryAST = (0, _parser.parse)((0, _introspectionQuery.getIntrospectionQuery)(options));
	  var result = (0, _execute.execute)(schema, queryAST);
	  !(!result.then && !result.errors && result.data) ? (0, _invariant.default)(0) : void 0;
	  return result.data;
	}

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isValidJSValue = isValidJSValue;
	
	var _coerceValue = __webpack_require__(111);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Deprecated. Use coerceValue() directly for richer information.
	 *
	 * This function will be removed in v15
	 */
	function isValidJSValue(value, type) {
	  var errors = (0, _coerceValue.coerceValue)(value, type).errors;
	  return errors ? errors.map(function (error) {
	    return error.message;
	  }) : [];
	}

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isValidLiteralValue = isValidLiteralValue;
	
	var _TypeInfo = __webpack_require__(55);
	
	var _kinds = __webpack_require__(11);
	
	var _visitor = __webpack_require__(36);
	
	var _schema = __webpack_require__(37);
	
	var _ValuesOfCorrectType = __webpack_require__(114);
	
	var _ValidationContext = __webpack_require__(113);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Utility which determines if a value literal node is valid for an input type.
	 *
	 * Deprecated. Rely on validation for documents containing literal values.
	 *
	 * This function will be removed in v15
	 */
	function isValidLiteralValue(type, valueNode) {
	  var emptySchema = new _schema.GraphQLSchema({});
	  var emptyDoc = {
	    kind: _kinds.Kind.DOCUMENT,
	    definitions: []
	  };
	  var typeInfo = new _TypeInfo.TypeInfo(emptySchema, undefined, type);
	  var context = new _ValidationContext.ValidationContext(emptySchema, emptyDoc, typeInfo);
	  var visitor = (0, _ValuesOfCorrectType.ValuesOfCorrectType)(context);
	  (0, _visitor.visit)(valueNode, (0, _visitor.visitWithTypeInfo)(typeInfo, visitor));
	  return context.getErrors();
	}

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.lexicographicSortSchema = lexicographicSortSchema;
	
	var _keyValMap = _interopRequireDefault(__webpack_require__(52));
	
	var _objectValues = _interopRequireDefault(__webpack_require__(34));
	
	var _schema = __webpack_require__(37);
	
	var _directives = __webpack_require__(19);
	
	var _definition = __webpack_require__(10);
	
	var _scalars = __webpack_require__(28);
	
	var _introspection = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Sort GraphQLSchema.
	 */
	function lexicographicSortSchema(schema) {
	  var cache = Object.create(null);
	
	  var sortMaybeType = function sortMaybeType(maybeType) {
	    return maybeType && sortNamedType(maybeType);
	  };
	
	  return new _schema.GraphQLSchema({
	    types: sortTypes((0, _objectValues.default)(schema.getTypeMap())),
	    directives: sortByName(schema.getDirectives()).map(sortDirective),
	    query: sortMaybeType(schema.getQueryType()),
	    mutation: sortMaybeType(schema.getMutationType()),
	    subscription: sortMaybeType(schema.getSubscriptionType()),
	    astNode: schema.astNode
	  });
	
	  function sortDirective(directive) {
	    return new _directives.GraphQLDirective({
	      name: directive.name,
	      description: directive.description,
	      locations: sortBy(directive.locations, function (x) {
	        return x;
	      }),
	      args: sortArgs(directive.args),
	      astNode: directive.astNode
	    });
	  }
	
	  function sortArgs(args) {
	    return (0, _keyValMap.default)(sortByName(args), function (arg) {
	      return arg.name;
	    }, function (arg) {
	      return _objectSpread({}, arg, {
	        type: sortType(arg.type)
	      });
	    });
	  }
	
	  function sortFields(fieldsMap) {
	    return sortObjMap(fieldsMap, function (field) {
	      return {
	        type: sortType(field.type),
	        args: sortArgs(field.args),
	        resolve: field.resolve,
	        subscribe: field.subscribe,
	        deprecationReason: field.deprecationReason,
	        description: field.description,
	        astNode: field.astNode
	      };
	    });
	  }
	
	  function sortInputFields(fieldsMap) {
	    return sortObjMap(fieldsMap, function (field) {
	      return {
	        type: sortType(field.type),
	        defaultValue: field.defaultValue,
	        description: field.description,
	        astNode: field.astNode
	      };
	    });
	  }
	
	  function sortType(type) {
	    if ((0, _definition.isListType)(type)) {
	      return new _definition.GraphQLList(sortType(type.ofType));
	    } else if ((0, _definition.isNonNullType)(type)) {
	      return new _definition.GraphQLNonNull(sortType(type.ofType));
	    }
	
	    return sortNamedType(type);
	  }
	
	  function sortTypes(arr) {
	    return sortByName(arr).map(sortNamedType);
	  }
	
	  function sortNamedType(type) {
	    if ((0, _scalars.isSpecifiedScalarType)(type) || (0, _introspection.isIntrospectionType)(type)) {
	      return type;
	    }
	
	    var sortedType = cache[type.name];
	
	    if (!sortedType) {
	      sortedType = sortNamedTypeImpl(type);
	      cache[type.name] = sortedType;
	    }
	
	    return sortedType;
	  }
	
	  function sortNamedTypeImpl(type) {
	    if ((0, _definition.isScalarType)(type)) {
	      return type;
	    } else if ((0, _definition.isObjectType)(type)) {
	      return new _definition.GraphQLObjectType({
	        name: type.name,
	        interfaces: function interfaces() {
	          return sortTypes(type.getInterfaces());
	        },
	        fields: function fields() {
	          return sortFields(type.getFields());
	        },
	        isTypeOf: type.isTypeOf,
	        description: type.description,
	        astNode: type.astNode,
	        extensionASTNodes: type.extensionASTNodes
	      });
	    } else if ((0, _definition.isInterfaceType)(type)) {
	      return new _definition.GraphQLInterfaceType({
	        name: type.name,
	        fields: function fields() {
	          return sortFields(type.getFields());
	        },
	        resolveType: type.resolveType,
	        description: type.description,
	        astNode: type.astNode,
	        extensionASTNodes: type.extensionASTNodes
	      });
	    } else if ((0, _definition.isUnionType)(type)) {
	      return new _definition.GraphQLUnionType({
	        name: type.name,
	        types: function types() {
	          return sortTypes(type.getTypes());
	        },
	        resolveType: type.resolveType,
	        description: type.description,
	        astNode: type.astNode
	      });
	    } else if ((0, _definition.isEnumType)(type)) {
	      return new _definition.GraphQLEnumType({
	        name: type.name,
	        values: (0, _keyValMap.default)(sortByName(type.getValues()), function (val) {
	          return val.name;
	        }, function (val) {
	          return {
	            value: val.value,
	            deprecationReason: val.deprecationReason,
	            description: val.description,
	            astNode: val.astNode
	          };
	        }),
	        description: type.description,
	        astNode: type.astNode
	      });
	    } else if ((0, _definition.isInputObjectType)(type)) {
	      return new _definition.GraphQLInputObjectType({
	        name: type.name,
	        fields: function fields() {
	          return sortInputFields(type.getFields());
	        },
	        description: type.description,
	        astNode: type.astNode
	      });
	    }
	
	    throw new Error("Unknown type: \"".concat(type, "\""));
	  }
	}
	
	function sortObjMap(map, sortValueFn) {
	  var sortedMap = Object.create(null);
	  var sortedKeys = sortBy(Object.keys(map), function (x) {
	    return x;
	  });
	
	  for (var _i = 0; _i < sortedKeys.length; _i++) {
	    var key = sortedKeys[_i];
	    var value = map[key];
	    sortedMap[key] = sortValueFn ? sortValueFn(value) : value;
	  }
	
	  return sortedMap;
	}
	
	function sortByName(array) {
	  return sortBy(array, function (obj) {
	    return obj.name;
	  });
	}
	
	function sortBy(array, mapToKey) {
	  return array.slice().sort(function (obj1, obj2) {
	    var key1 = mapToKey(obj1);
	    var key2 = mapToKey(obj2);
	    return key1.localeCompare(key2);
	  });
	}

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.printSchema = printSchema;
	exports.printIntrospectionSchema = printIntrospectionSchema;
	exports.printType = printType;
	
	var _isNullish = _interopRequireDefault(__webpack_require__(105));
	
	var _isInvalid = _interopRequireDefault(__webpack_require__(33));
	
	var _objectValues = _interopRequireDefault(__webpack_require__(34));
	
	var _astFromValue = __webpack_require__(110);
	
	var _printer = __webpack_require__(22);
	
	var _definition = __webpack_require__(10);
	
	var _scalars = __webpack_require__(28);
	
	var _directives = __webpack_require__(19);
	
	var _introspection = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * Accepts options as a second argument:
	 *
	 *    - commentDescriptions:
	 *        Provide true to use preceding comments as the description.
	 *
	 */
	function printSchema(schema, options) {
	  return printFilteredSchema(schema, function (n) {
	    return !(0, _directives.isSpecifiedDirective)(n);
	  }, isDefinedType, options);
	}
	
	function printIntrospectionSchema(schema, options) {
	  return printFilteredSchema(schema, _directives.isSpecifiedDirective, _introspection.isIntrospectionType, options);
	}
	
	function isDefinedType(type) {
	  return !(0, _scalars.isSpecifiedScalarType)(type) && !(0, _introspection.isIntrospectionType)(type);
	}
	
	function printFilteredSchema(schema, directiveFilter, typeFilter, options) {
	  var directives = schema.getDirectives().filter(directiveFilter);
	  var typeMap = schema.getTypeMap();
	  var types = (0, _objectValues.default)(typeMap).sort(function (type1, type2) {
	    return type1.name.localeCompare(type2.name);
	  }).filter(typeFilter);
	  return [printSchemaDefinition(schema)].concat(directives.map(function (directive) {
	    return printDirective(directive, options);
	  }), types.map(function (type) {
	    return printType(type, options);
	  })).filter(Boolean).join('\n\n') + '\n';
	}
	
	function printSchemaDefinition(schema) {
	  if (isSchemaOfCommonNames(schema)) {
	    return;
	  }
	
	  var operationTypes = [];
	  var queryType = schema.getQueryType();
	
	  if (queryType) {
	    operationTypes.push("  query: ".concat(queryType.name));
	  }
	
	  var mutationType = schema.getMutationType();
	
	  if (mutationType) {
	    operationTypes.push("  mutation: ".concat(mutationType.name));
	  }
	
	  var subscriptionType = schema.getSubscriptionType();
	
	  if (subscriptionType) {
	    operationTypes.push("  subscription: ".concat(subscriptionType.name));
	  }
	
	  return "schema {\n".concat(operationTypes.join('\n'), "\n}");
	}
	/**
	 * GraphQL schema define root types for each type of operation. These types are
	 * the same as any other type and can be named in any manner, however there is
	 * a common naming convention:
	 *
	 *   schema {
	 *     query: Query
	 *     mutation: Mutation
	 *   }
	 *
	 * When using this naming convention, the schema description can be omitted.
	 */
	
	
	function isSchemaOfCommonNames(schema) {
	  var queryType = schema.getQueryType();
	
	  if (queryType && queryType.name !== 'Query') {
	    return false;
	  }
	
	  var mutationType = schema.getMutationType();
	
	  if (mutationType && mutationType.name !== 'Mutation') {
	    return false;
	  }
	
	  var subscriptionType = schema.getSubscriptionType();
	
	  if (subscriptionType && subscriptionType.name !== 'Subscription') {
	    return false;
	  }
	
	  return true;
	}
	
	function printType(type, options) {
	  if ((0, _definition.isScalarType)(type)) {
	    return printScalar(type, options);
	  } else if ((0, _definition.isObjectType)(type)) {
	    return printObject(type, options);
	  } else if ((0, _definition.isInterfaceType)(type)) {
	    return printInterface(type, options);
	  } else if ((0, _definition.isUnionType)(type)) {
	    return printUnion(type, options);
	  } else if ((0, _definition.isEnumType)(type)) {
	    return printEnum(type, options);
	  } else if ((0, _definition.isInputObjectType)(type)) {
	    return printInputObject(type, options);
	  }
	  /* istanbul ignore next */
	
	
	  throw new Error("Unknown type: ".concat(type, "."));
	}
	
	function printScalar(type, options) {
	  return printDescription(options, type) + "scalar ".concat(type.name);
	}
	
	function printObject(type, options) {
	  var interfaces = type.getInterfaces();
	  var implementedInterfaces = interfaces.length ? ' implements ' + interfaces.map(function (i) {
	    return i.name;
	  }).join(' & ') : '';
	  return printDescription(options, type) + "type ".concat(type.name).concat(implementedInterfaces, " {\n") + printFields(options, type) + '\n' + '}';
	}
	
	function printInterface(type, options) {
	  return printDescription(options, type) + "interface ".concat(type.name, " {\n") + printFields(options, type) + '\n' + '}';
	}
	
	function printUnion(type, options) {
	  return printDescription(options, type) + "union ".concat(type.name, " = ").concat(type.getTypes().join(' | '));
	}
	
	function printEnum(type, options) {
	  return printDescription(options, type) + "enum ".concat(type.name, " {\n") + printEnumValues(type.getValues(), options) + '\n' + '}';
	}
	
	function printEnumValues(values, options) {
	  return values.map(function (value, i) {
	    return printDescription(options, value, '  ', !i) + '  ' + value.name + printDeprecated(value);
	  }).join('\n');
	}
	
	function printInputObject(type, options) {
	  var fields = (0, _objectValues.default)(type.getFields());
	  return printDescription(options, type) + "input ".concat(type.name, " {\n") + fields.map(function (f, i) {
	    return printDescription(options, f, '  ', !i) + '  ' + printInputValue(f);
	  }).join('\n') + '\n' + '}';
	}
	
	function printFields(options, type) {
	  var fields = (0, _objectValues.default)(type.getFields());
	  return fields.map(function (f, i) {
	    return printDescription(options, f, '  ', !i) + '  ' + f.name + printArgs(options, f.args, '  ') + ': ' + String(f.type) + printDeprecated(f);
	  }).join('\n');
	}
	
	function printArgs(options, args) {
	  var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  if (args.length === 0) {
	    return '';
	  } // If every arg does not have a description, print them on one line.
	
	
	  if (args.every(function (arg) {
	    return !arg.description;
	  })) {
	    return '(' + args.map(printInputValue).join(', ') + ')';
	  }
	
	  return '(\n' + args.map(function (arg, i) {
	    return printDescription(options, arg, '  ' + indentation, !i) + '  ' + indentation + printInputValue(arg);
	  }).join('\n') + '\n' + indentation + ')';
	}
	
	function printInputValue(arg) {
	  var argDecl = arg.name + ': ' + String(arg.type);
	
	  if (!(0, _isInvalid.default)(arg.defaultValue)) {
	    argDecl += " = ".concat((0, _printer.print)((0, _astFromValue.astFromValue)(arg.defaultValue, arg.type)));
	  }
	
	  return argDecl;
	}
	
	function printDirective(directive, options) {
	  return printDescription(options, directive) + 'directive @' + directive.name + printArgs(options, directive.args) + ' on ' + directive.locations.join(' | ');
	}
	
	function printDeprecated(fieldOrEnumVal) {
	  if (!fieldOrEnumVal.isDeprecated) {
	    return '';
	  }
	
	  var reason = fieldOrEnumVal.deprecationReason;
	
	  if ((0, _isNullish.default)(reason) || reason === '' || reason === _directives.DEFAULT_DEPRECATION_REASON) {
	    return ' @deprecated';
	  }
	
	  return ' @deprecated(reason: ' + (0, _printer.print)((0, _astFromValue.astFromValue)(reason, _scalars.GraphQLString)) + ')';
	}
	
	function printDescription(options, def) {
	  var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var firstInBlock = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  if (!def.description) {
	    return '';
	  }
	
	  var lines = descriptionLines(def.description, 120 - indentation.length);
	
	  if (options && options.commentDescriptions) {
	    return printDescriptionWithComments(lines, indentation, firstInBlock);
	  }
	
	  var description = indentation && !firstInBlock ? '\n' + indentation + '"""' : indentation + '"""'; // In some circumstances, a single line can be used for the description.
	
	  if (lines.length === 1 && lines[0].length < 70 && lines[0][lines[0].length - 1] !== '"') {
	    return description + escapeQuote(lines[0]) + '"""\n';
	  } // Format a multi-line block quote to account for leading space.
	
	
	  var hasLeadingSpace = lines[0][0] === ' ' || lines[0][0] === '\t';
	
	  if (!hasLeadingSpace) {
	    description += '\n';
	  }
	
	  for (var i = 0; i < lines.length; i++) {
	    if (i !== 0 || !hasLeadingSpace) {
	      description += indentation;
	    }
	
	    description += escapeQuote(lines[i]) + '\n';
	  }
	
	  description += indentation + '"""\n';
	  return description;
	}
	
	function escapeQuote(line) {
	  return line.replace(/"""/g, '\\"""');
	}
	
	function printDescriptionWithComments(lines, indentation, firstInBlock) {
	  var description = indentation && !firstInBlock ? '\n' : '';
	
	  for (var i = 0; i < lines.length; i++) {
	    if (lines[i] === '') {
	      description += indentation + '#\n';
	    } else {
	      description += indentation + '# ' + lines[i] + '\n';
	    }
	  }
	
	  return description;
	}
	
	function descriptionLines(description, maxLen) {
	  var lines = [];
	  var rawLines = description.split('\n');
	
	  for (var i = 0; i < rawLines.length; i++) {
	    if (rawLines[i] === '') {
	      lines.push(rawLines[i]);
	    } else {
	      // For > 120 character long lines, cut at space boundaries into sublines
	      // of ~80 chars.
	      var sublines = breakLine(rawLines[i], maxLen);
	
	      for (var j = 0; j < sublines.length; j++) {
	        lines.push(sublines[j]);
	      }
	    }
	  }
	
	  return lines;
	}
	
	function breakLine(line, maxLen) {
	  if (line.length < maxLen + 5) {
	    return [line];
	  }
	
	  var parts = line.split(new RegExp("((?: |^).{15,".concat(maxLen - 40, "}(?= |$))")));
	
	  if (parts.length < 4) {
	    return [line];
	  }
	
	  var sublines = [parts[0] + parts[1] + parts[2]];
	
	  for (var i = 3; i < parts.length; i += 2) {
	    sublines.push(parts[i].slice(1) + parts[i + 1]);
	  }
	
	  return sublines;
	}

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.separateOperations = separateOperations;
	
	var _visitor = __webpack_require__(36);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	
	/**
	 * separateOperations accepts a single AST document which may contain many
	 * operations and fragments and returns a collection of AST documents each of
	 * which contains a single operation as well the fragment definitions it
	 * refers to.
	 */
	function separateOperations(documentAST) {
	  var operations = [];
	  var fragments = Object.create(null);
	  var positions = new Map();
	  var depGraph = Object.create(null);
	  var fromName;
	  var idx = 0; // Populate metadata and build a dependency graph.
	
	  (0, _visitor.visit)(documentAST, {
	    OperationDefinition: function OperationDefinition(node) {
	      fromName = opName(node);
	      operations.push(node);
	      positions.set(node, idx++);
	    },
	    FragmentDefinition: function FragmentDefinition(node) {
	      fromName = node.name.value;
	      fragments[fromName] = node;
	      positions.set(node, idx++);
	    },
	    FragmentSpread: function FragmentSpread(node) {
	      var toName = node.name.value;
	      (depGraph[fromName] || (depGraph[fromName] = Object.create(null)))[toName] = true;
	    }
	  }); // For each operation, produce a new synthesized AST which includes only what
	  // is necessary for completing that operation.
	
	  var separatedDocumentASTs = Object.create(null);
	
	  for (var _i = 0; _i < operations.length; _i++) {
	    var operation = operations[_i];
	    var operationName = opName(operation);
	    var dependencies = Object.create(null);
	    collectTransitiveDependencies(dependencies, depGraph, operationName); // The list of definition nodes to be included for this operation, sorted
	    // to retain the same order as the original document.
	
	    var definitions = [operation];
	
	    var _arr = Object.keys(dependencies);
	
	    for (var _i2 = 0; _i2 < _arr.length; _i2++) {
	      var name = _arr[_i2];
	      definitions.push(fragments[name]);
	    }
	
	    definitions.sort(function (n1, n2) {
	      return (positions.get(n1) || 0) - (positions.get(n2) || 0);
	    });
	    separatedDocumentASTs[operationName] = {
	      kind: 'Document',
	      definitions: definitions
	    };
	  }
	
	  return separatedDocumentASTs;
	}
	
	// Provides the empty string for anonymous operations.
	function opName(operation) {
	  return operation.name ? operation.name.value : '';
	} // From a dependency graph, collects a list of transitive dependencies by
	// recursing through a dependency graph.
	
	
	function collectTransitiveDependencies(collected, depGraph, fromName) {
	  var immediateDeps = depGraph[fromName];
	
	  if (immediateDeps) {
	    var _arr2 = Object.keys(immediateDeps);
	
	    for (var _i3 = 0; _i3 < _arr2.length; _i3++) {
	      var toName = _arr2[_i3];
	
	      if (!collected[toName]) {
	        collected[toName] = true;
	        collectTransitiveDependencies(collected, depGraph, toName);
	      }
	    }
	  }
	}

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "validate", {
	  enumerable: true,
	  get: function get() {
	    return _validate.validate;
	  }
	});
	Object.defineProperty(exports, "ValidationContext", {
	  enumerable: true,
	  get: function get() {
	    return _ValidationContext.ValidationContext;
	  }
	});
	Object.defineProperty(exports, "specifiedRules", {
	  enumerable: true,
	  get: function get() {
	    return _specifiedRules.specifiedRules;
	  }
	});
	Object.defineProperty(exports, "FieldsOnCorrectTypeRule", {
	  enumerable: true,
	  get: function get() {
	    return _FieldsOnCorrectType.FieldsOnCorrectType;
	  }
	});
	Object.defineProperty(exports, "FragmentsOnCompositeTypesRule", {
	  enumerable: true,
	  get: function get() {
	    return _FragmentsOnCompositeTypes.FragmentsOnCompositeTypes;
	  }
	});
	Object.defineProperty(exports, "KnownArgumentNamesRule", {
	  enumerable: true,
	  get: function get() {
	    return _KnownArgumentNames.KnownArgumentNames;
	  }
	});
	Object.defineProperty(exports, "KnownDirectivesRule", {
	  enumerable: true,
	  get: function get() {
	    return _KnownDirectives.KnownDirectives;
	  }
	});
	Object.defineProperty(exports, "KnownFragmentNamesRule", {
	  enumerable: true,
	  get: function get() {
	    return _KnownFragmentNames.KnownFragmentNames;
	  }
	});
	Object.defineProperty(exports, "KnownTypeNamesRule", {
	  enumerable: true,
	  get: function get() {
	    return _KnownTypeNames.KnownTypeNames;
	  }
	});
	Object.defineProperty(exports, "LoneAnonymousOperationRule", {
	  enumerable: true,
	  get: function get() {
	    return _LoneAnonymousOperation.LoneAnonymousOperation;
	  }
	});
	Object.defineProperty(exports, "NoFragmentCyclesRule", {
	  enumerable: true,
	  get: function get() {
	    return _NoFragmentCycles.NoFragmentCycles;
	  }
	});
	Object.defineProperty(exports, "NoUndefinedVariablesRule", {
	  enumerable: true,
	  get: function get() {
	    return _NoUndefinedVariables.NoUndefinedVariables;
	  }
	});
	Object.defineProperty(exports, "NoUnusedFragmentsRule", {
	  enumerable: true,
	  get: function get() {
	    return _NoUnusedFragments.NoUnusedFragments;
	  }
	});
	Object.defineProperty(exports, "NoUnusedVariablesRule", {
	  enumerable: true,
	  get: function get() {
	    return _NoUnusedVariables.NoUnusedVariables;
	  }
	});
	Object.defineProperty(exports, "OverlappingFieldsCanBeMergedRule", {
	  enumerable: true,
	  get: function get() {
	    return _OverlappingFieldsCanBeMerged.OverlappingFieldsCanBeMerged;
	  }
	});
	Object.defineProperty(exports, "PossibleFragmentSpreadsRule", {
	  enumerable: true,
	  get: function get() {
	    return _PossibleFragmentSpreads.PossibleFragmentSpreads;
	  }
	});
	Object.defineProperty(exports, "ProvidedRequiredArgumentsRule", {
	  enumerable: true,
	  get: function get() {
	    return _ProvidedRequiredArguments.ProvidedRequiredArguments;
	  }
	});
	Object.defineProperty(exports, "ScalarLeafsRule", {
	  enumerable: true,
	  get: function get() {
	    return _ScalarLeafs.ScalarLeafs;
	  }
	});
	Object.defineProperty(exports, "SingleFieldSubscriptionsRule", {
	  enumerable: true,
	  get: function get() {
	    return _SingleFieldSubscriptions.SingleFieldSubscriptions;
	  }
	});
	Object.defineProperty(exports, "UniqueArgumentNamesRule", {
	  enumerable: true,
	  get: function get() {
	    return _UniqueArgumentNames.UniqueArgumentNames;
	  }
	});
	Object.defineProperty(exports, "UniqueDirectivesPerLocationRule", {
	  enumerable: true,
	  get: function get() {
	    return _UniqueDirectivesPerLocation.UniqueDirectivesPerLocation;
	  }
	});
	Object.defineProperty(exports, "UniqueFragmentNamesRule", {
	  enumerable: true,
	  get: function get() {
	    return _UniqueFragmentNames.UniqueFragmentNames;
	  }
	});
	Object.defineProperty(exports, "UniqueInputFieldNamesRule", {
	  enumerable: true,
	  get: function get() {
	    return _UniqueInputFieldNames.UniqueInputFieldNames;
	  }
	});
	Object.defineProperty(exports, "UniqueOperationNamesRule", {
	  enumerable: true,
	  get: function get() {
	    return _UniqueOperationNames.UniqueOperationNames;
	  }
	});
	Object.defineProperty(exports, "UniqueVariableNamesRule", {
	  enumerable: true,
	  get: function get() {
	    return _UniqueVariableNames.UniqueVariableNames;
	  }
	});
	Object.defineProperty(exports, "ValuesOfCorrectTypeRule", {
	  enumerable: true,
	  get: function get() {
	    return _ValuesOfCorrectType.ValuesOfCorrectType;
	  }
	});
	Object.defineProperty(exports, "VariablesAreInputTypesRule", {
	  enumerable: true,
	  get: function get() {
	    return _VariablesAreInputTypes.VariablesAreInputTypes;
	  }
	});
	Object.defineProperty(exports, "VariablesInAllowedPositionRule", {
	  enumerable: true,
	  get: function get() {
	    return _VariablesInAllowedPosition.VariablesInAllowedPosition;
	  }
	});
	
	var _validate = __webpack_require__(69);
	
	var _ValidationContext = __webpack_require__(113);
	
	var _specifiedRules = __webpack_require__(218);
	
	var _FieldsOnCorrectType = __webpack_require__(194);
	
	var _FragmentsOnCompositeTypes = __webpack_require__(195);
	
	var _KnownArgumentNames = __webpack_require__(196);
	
	var _KnownDirectives = __webpack_require__(197);
	
	var _KnownFragmentNames = __webpack_require__(198);
	
	var _KnownTypeNames = __webpack_require__(199);
	
	var _LoneAnonymousOperation = __webpack_require__(200);
	
	var _NoFragmentCycles = __webpack_require__(201);
	
	var _NoUndefinedVariables = __webpack_require__(202);
	
	var _NoUnusedFragments = __webpack_require__(203);
	
	var _NoUnusedVariables = __webpack_require__(204);
	
	var _OverlappingFieldsCanBeMerged = __webpack_require__(205);
	
	var _PossibleFragmentSpreads = __webpack_require__(206);
	
	var _ProvidedRequiredArguments = __webpack_require__(207);
	
	var _ScalarLeafs = __webpack_require__(208);
	
	var _SingleFieldSubscriptions = __webpack_require__(209);
	
	var _UniqueArgumentNames = __webpack_require__(210);
	
	var _UniqueDirectivesPerLocation = __webpack_require__(211);
	
	var _UniqueFragmentNames = __webpack_require__(212);
	
	var _UniqueInputFieldNames = __webpack_require__(213);
	
	var _UniqueOperationNames = __webpack_require__(214);
	
	var _UniqueVariableNames = __webpack_require__(215);
	
	var _ValuesOfCorrectType = __webpack_require__(114);
	
	var _VariablesAreInputTypes = __webpack_require__(216);
	
	var _VariablesInAllowedPosition = __webpack_require__(217);

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nonExecutableDefinitionMessage = nonExecutableDefinitionMessage;
	exports.ExecutableDefinitions = ExecutableDefinitions;
	
	var _GraphQLError = __webpack_require__(9);
	
	var _kinds = __webpack_require__(11);
	
	var _predicates = __webpack_require__(65);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function nonExecutableDefinitionMessage(defName) {
	  return "The ".concat(defName, " definition is not executable.");
	}
	/**
	 * Executable definitions
	 *
	 * A GraphQL document is only valid for execution if all definitions are either
	 * operation or fragment definitions.
	 */
	
	
	function ExecutableDefinitions(context) {
	  return {
	    Document: function Document(node) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = node.definitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var definition = _step.value;
	
	          if (!(0, _predicates.isExecutableDefinitionNode)(definition)) {
	            context.reportError(new _GraphQLError.GraphQLError(nonExecutableDefinitionMessage(definition.kind === _kinds.Kind.SCHEMA_DEFINITION || definition.kind === _kinds.Kind.SCHEMA_EXTENSION ? 'schema' : definition.name.value), [definition]));
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return != null) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return false;
	    }
	  };
	}

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.schemaDefinitionNotAloneMessage = schemaDefinitionNotAloneMessage;
	exports.canNotDefineSchemaWithinExtensionMessage = canNotDefineSchemaWithinExtensionMessage;
	exports.LoneSchemaDefinition = LoneSchemaDefinition;
	
	var _GraphQLError = __webpack_require__(9);
	
	/**
	 * Copyright (c) 2018-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 *  strict
	 */
	function schemaDefinitionNotAloneMessage() {
	  return 'Must provide only one schema definition.';
	}
	
	function canNotDefineSchemaWithinExtensionMessage() {
	  return 'Cannot define a new schema within a schema extension.';
	}
	/**
	 * Lone Schema definition
	 *
	 * A GraphQL document is only valid if it contains only one schema definition.
	 */
	
	
	function LoneSchemaDefinition(context) {
	  var oldSchema = context.getSchema();
	  var alreadyDefined = oldSchema && (oldSchema.astNode || oldSchema.getQueryType() || oldSchema.getMutationType() || oldSchema.getSubscriptionType());
	  var schemaDefinitionsCount = 0;
	  return {
	    SchemaDefinition: function SchemaDefinition(node) {
	      if (alreadyDefined) {
	        context.reportError(new _GraphQLError.GraphQLError(canNotDefineSchemaWithinExtensionMessage(), node));
	        return;
	      }
	
	      if (schemaDefinitionsCount > 0) {
	        context.reportError(new _GraphQLError.GraphQLError(schemaDefinitionNotAloneMessage(), node));
	      }
	
	      ++schemaDefinitionsCount;
	    }
	  };
	}

/***/ },
/* 477 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 478 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 479 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-06-30",
			"endpointPrefix": "cognito-identity",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon Cognito Identity",
			"serviceId": "Cognito Identity",
			"signatureVersion": "v4",
			"targetPrefix": "AWSCognitoIdentityService",
			"uid": "cognito-identity-2014-06-30"
		},
		"operations": {
			"CreateIdentityPool": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolName",
						"AllowUnauthenticatedIdentities"
					],
					"members": {
						"IdentityPoolName": {},
						"AllowUnauthenticatedIdentities": {
							"type": "boolean"
						},
						"SupportedLoginProviders": {
							"shape": "S4"
						},
						"DeveloperProviderName": {},
						"OpenIdConnectProviderARNs": {
							"shape": "S8"
						},
						"CognitoIdentityProviders": {
							"shape": "Sa"
						},
						"SamlProviderARNs": {
							"shape": "Sf"
						},
						"IdentityPoolTags": {
							"shape": "Sg"
						}
					}
				},
				"output": {
					"shape": "Sj"
				}
			},
			"DeleteIdentities": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityIdsToDelete"
					],
					"members": {
						"IdentityIdsToDelete": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UnprocessedIdentityIds": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"IdentityId": {},
									"ErrorCode": {}
								}
							}
						}
					}
				}
			},
			"DeleteIdentityPool": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {}
					}
				}
			},
			"DescribeIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId"
					],
					"members": {
						"IdentityId": {}
					}
				},
				"output": {
					"shape": "Su"
				}
			},
			"DescribeIdentityPool": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {}
					}
				},
				"output": {
					"shape": "Sj"
				}
			},
			"GetCredentialsForIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId"
					],
					"members": {
						"IdentityId": {},
						"Logins": {
							"shape": "Sz"
						},
						"CustomRoleArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {},
						"Credentials": {
							"type": "structure",
							"members": {
								"AccessKeyId": {},
								"SecretKey": {},
								"SessionToken": {},
								"Expiration": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			},
			"GetId": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"AccountId": {},
						"IdentityPoolId": {},
						"Logins": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {}
					}
				}
			},
			"GetIdentityPoolRoles": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolId": {},
						"Roles": {
							"shape": "S1b"
						},
						"RoleMappings": {
							"shape": "S1d"
						}
					}
				}
			},
			"GetOpenIdToken": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId"
					],
					"members": {
						"IdentityId": {},
						"Logins": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {},
						"Token": {}
					}
				}
			},
			"GetOpenIdTokenForDeveloperIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"Logins"
					],
					"members": {
						"IdentityPoolId": {},
						"IdentityId": {},
						"Logins": {
							"shape": "Sz"
						},
						"TokenDuration": {
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {},
						"Token": {}
					}
				}
			},
			"ListIdentities": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"MaxResults"
					],
					"members": {
						"IdentityPoolId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"HideDisabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolId": {},
						"Identities": {
							"type": "list",
							"member": {
								"shape": "Su"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListIdentityPools": {
				"input": {
					"type": "structure",
					"required": [
						"MaxResults"
					],
					"members": {
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPools": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"IdentityPoolId": {},
									"IdentityPoolName": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "Sg"
						}
					}
				}
			},
			"LookupDeveloperIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {},
						"IdentityId": {},
						"DeveloperUserIdentifier": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {},
						"DeveloperUserIdentifierList": {
							"type": "list",
							"member": {}
						},
						"NextToken": {}
					}
				}
			},
			"MergeDeveloperIdentities": {
				"input": {
					"type": "structure",
					"required": [
						"SourceUserIdentifier",
						"DestinationUserIdentifier",
						"DeveloperProviderName",
						"IdentityPoolId"
					],
					"members": {
						"SourceUserIdentifier": {},
						"DestinationUserIdentifier": {},
						"DeveloperProviderName": {},
						"IdentityPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {}
					}
				}
			},
			"SetIdentityPoolRoles": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"Roles"
					],
					"members": {
						"IdentityPoolId": {},
						"Roles": {
							"shape": "S1b"
						},
						"RoleMappings": {
							"shape": "S1d"
						}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {},
						"Tags": {
							"shape": "Sg"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UnlinkDeveloperIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId",
						"IdentityPoolId",
						"DeveloperProviderName",
						"DeveloperUserIdentifier"
					],
					"members": {
						"IdentityId": {},
						"IdentityPoolId": {},
						"DeveloperProviderName": {},
						"DeveloperUserIdentifier": {}
					}
				}
			},
			"UnlinkIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId",
						"Logins",
						"LoginsToRemove"
					],
					"members": {
						"IdentityId": {},
						"Logins": {
							"shape": "Sz"
						},
						"LoginsToRemove": {
							"shape": "Sv"
						}
					}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateIdentityPool": {
				"input": {
					"shape": "Sj"
				},
				"output": {
					"shape": "Sj"
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S8": {
				"type": "list",
				"member": {}
			},
			"Sa": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ProviderName": {},
						"ClientId": {},
						"ServerSideTokenCheck": {
							"type": "boolean"
						}
					}
				}
			},
			"Sf": {
				"type": "list",
				"member": {}
			},
			"Sg": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sj": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"IdentityPoolName",
					"AllowUnauthenticatedIdentities"
				],
				"members": {
					"IdentityPoolId": {},
					"IdentityPoolName": {},
					"AllowUnauthenticatedIdentities": {
						"type": "boolean"
					},
					"SupportedLoginProviders": {
						"shape": "S4"
					},
					"DeveloperProviderName": {},
					"OpenIdConnectProviderARNs": {
						"shape": "S8"
					},
					"CognitoIdentityProviders": {
						"shape": "Sa"
					},
					"SamlProviderARNs": {
						"shape": "Sf"
					},
					"IdentityPoolTags": {
						"shape": "Sg"
					}
				}
			},
			"Su": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"Logins": {
						"shape": "Sv"
					},
					"CreationDate": {
						"type": "timestamp"
					},
					"LastModifiedDate": {
						"type": "timestamp"
					}
				}
			},
			"Sv": {
				"type": "list",
				"member": {}
			},
			"Sz": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1b": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1d": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"required": [
						"Type"
					],
					"members": {
						"Type": {},
						"AmbiguousRoleResolution": {},
						"RulesConfiguration": {
							"type": "structure",
							"required": [
								"Rules"
							],
							"members": {
								"Rules": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"Claim",
											"MatchType",
											"Value",
											"RoleARN"
										],
										"members": {
											"Claim": {},
											"MatchType": {},
											"Value": {},
											"RoleARN": {}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	};

/***/ },
/* 480 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {}
	};

/***/ },
/* 481 */
/***/ function(module, exports) {

	module.exports = {
		"acm": {
			"name": "ACM",
			"cors": true
		},
		"apigateway": {
			"name": "APIGateway",
			"cors": true
		},
		"applicationautoscaling": {
			"prefix": "application-autoscaling",
			"name": "ApplicationAutoScaling",
			"cors": true
		},
		"appstream": {
			"name": "AppStream"
		},
		"autoscaling": {
			"name": "AutoScaling",
			"cors": true
		},
		"batch": {
			"name": "Batch"
		},
		"budgets": {
			"name": "Budgets"
		},
		"clouddirectory": {
			"name": "CloudDirectory",
			"versions": [
				"2016-05-10*"
			]
		},
		"cloudformation": {
			"name": "CloudFormation",
			"cors": true
		},
		"cloudfront": {
			"name": "CloudFront",
			"versions": [
				"2013-05-12*",
				"2013-11-11*",
				"2014-05-31*",
				"2014-10-21*",
				"2014-11-06*",
				"2015-04-17*",
				"2015-07-27*",
				"2015-09-17*",
				"2016-01-13*",
				"2016-01-28*",
				"2016-08-01*",
				"2016-08-20*",
				"2016-09-07*",
				"2016-09-29*",
				"2016-11-25*",
				"2017-03-25*",
				"2017-10-30*",
				"2018-06-18*",
				"2018-11-05*"
			],
			"cors": true
		},
		"cloudhsm": {
			"name": "CloudHSM",
			"cors": true
		},
		"cloudsearch": {
			"name": "CloudSearch"
		},
		"cloudsearchdomain": {
			"name": "CloudSearchDomain"
		},
		"cloudtrail": {
			"name": "CloudTrail",
			"cors": true
		},
		"cloudwatch": {
			"prefix": "monitoring",
			"name": "CloudWatch",
			"cors": true
		},
		"cloudwatchevents": {
			"prefix": "events",
			"name": "CloudWatchEvents",
			"versions": [
				"2014-02-03*"
			],
			"cors": true
		},
		"cloudwatchlogs": {
			"prefix": "logs",
			"name": "CloudWatchLogs",
			"cors": true
		},
		"codebuild": {
			"name": "CodeBuild",
			"cors": true
		},
		"codecommit": {
			"name": "CodeCommit",
			"cors": true
		},
		"codedeploy": {
			"name": "CodeDeploy",
			"cors": true
		},
		"codepipeline": {
			"name": "CodePipeline",
			"cors": true
		},
		"cognitoidentity": {
			"prefix": "cognito-identity",
			"name": "CognitoIdentity",
			"cors": true
		},
		"cognitoidentityserviceprovider": {
			"prefix": "cognito-idp",
			"name": "CognitoIdentityServiceProvider",
			"cors": true
		},
		"cognitosync": {
			"prefix": "cognito-sync",
			"name": "CognitoSync",
			"cors": true
		},
		"configservice": {
			"prefix": "config",
			"name": "ConfigService",
			"cors": true
		},
		"cur": {
			"name": "CUR",
			"cors": true
		},
		"datapipeline": {
			"name": "DataPipeline"
		},
		"devicefarm": {
			"name": "DeviceFarm",
			"cors": true
		},
		"directconnect": {
			"name": "DirectConnect",
			"cors": true
		},
		"directoryservice": {
			"prefix": "ds",
			"name": "DirectoryService"
		},
		"discovery": {
			"name": "Discovery"
		},
		"dms": {
			"name": "DMS"
		},
		"dynamodb": {
			"name": "DynamoDB",
			"cors": true
		},
		"dynamodbstreams": {
			"prefix": "streams.dynamodb",
			"name": "DynamoDBStreams",
			"cors": true
		},
		"ec2": {
			"name": "EC2",
			"versions": [
				"2013-06-15*",
				"2013-10-15*",
				"2014-02-01*",
				"2014-05-01*",
				"2014-06-15*",
				"2014-09-01*",
				"2014-10-01*",
				"2015-03-01*",
				"2015-04-15*",
				"2015-10-01*",
				"2016-04-01*",
				"2016-09-15*"
			],
			"cors": true
		},
		"ecr": {
			"name": "ECR",
			"cors": true
		},
		"ecs": {
			"name": "ECS",
			"cors": true
		},
		"efs": {
			"prefix": "elasticfilesystem",
			"name": "EFS",
			"cors": true
		},
		"elasticache": {
			"name": "ElastiCache",
			"versions": [
				"2012-11-15*",
				"2014-03-24*",
				"2014-07-15*",
				"2014-09-30*"
			],
			"cors": true
		},
		"elasticbeanstalk": {
			"name": "ElasticBeanstalk",
			"cors": true
		},
		"elb": {
			"prefix": "elasticloadbalancing",
			"name": "ELB",
			"cors": true
		},
		"elbv2": {
			"prefix": "elasticloadbalancingv2",
			"name": "ELBv2",
			"cors": true
		},
		"emr": {
			"prefix": "elasticmapreduce",
			"name": "EMR",
			"cors": true
		},
		"es": {
			"name": "ES"
		},
		"elastictranscoder": {
			"name": "ElasticTranscoder",
			"cors": true
		},
		"firehose": {
			"name": "Firehose",
			"cors": true
		},
		"gamelift": {
			"name": "GameLift",
			"cors": true
		},
		"glacier": {
			"name": "Glacier"
		},
		"health": {
			"name": "Health"
		},
		"iam": {
			"name": "IAM",
			"cors": true
		},
		"importexport": {
			"name": "ImportExport"
		},
		"inspector": {
			"name": "Inspector",
			"versions": [
				"2015-08-18*"
			],
			"cors": true
		},
		"iot": {
			"name": "Iot",
			"cors": true
		},
		"iotdata": {
			"prefix": "iot-data",
			"name": "IotData",
			"cors": true
		},
		"kinesis": {
			"name": "Kinesis",
			"cors": true
		},
		"kinesisanalytics": {
			"name": "KinesisAnalytics"
		},
		"kms": {
			"name": "KMS",
			"cors": true
		},
		"lambda": {
			"name": "Lambda",
			"cors": true
		},
		"lexruntime": {
			"prefix": "runtime.lex",
			"name": "LexRuntime",
			"cors": true
		},
		"lightsail": {
			"name": "Lightsail"
		},
		"machinelearning": {
			"name": "MachineLearning",
			"cors": true
		},
		"marketplacecommerceanalytics": {
			"name": "MarketplaceCommerceAnalytics",
			"cors": true
		},
		"marketplacemetering": {
			"prefix": "meteringmarketplace",
			"name": "MarketplaceMetering"
		},
		"mturk": {
			"prefix": "mturk-requester",
			"name": "MTurk",
			"cors": true
		},
		"mobileanalytics": {
			"name": "MobileAnalytics",
			"cors": true
		},
		"opsworks": {
			"name": "OpsWorks",
			"cors": true
		},
		"opsworkscm": {
			"name": "OpsWorksCM"
		},
		"organizations": {
			"name": "Organizations"
		},
		"pinpoint": {
			"name": "Pinpoint"
		},
		"polly": {
			"name": "Polly",
			"cors": true
		},
		"rds": {
			"name": "RDS",
			"versions": [
				"2014-09-01*"
			],
			"cors": true
		},
		"redshift": {
			"name": "Redshift",
			"cors": true
		},
		"rekognition": {
			"name": "Rekognition",
			"cors": true
		},
		"resourcegroupstaggingapi": {
			"name": "ResourceGroupsTaggingAPI"
		},
		"route53": {
			"name": "Route53",
			"cors": true
		},
		"route53domains": {
			"name": "Route53Domains",
			"cors": true
		},
		"s3": {
			"name": "S3",
			"dualstackAvailable": true,
			"cors": true
		},
		"s3control": {
			"name": "S3Control",
			"dualstackAvailable": true
		},
		"servicecatalog": {
			"name": "ServiceCatalog",
			"cors": true
		},
		"ses": {
			"prefix": "email",
			"name": "SES",
			"cors": true
		},
		"shield": {
			"name": "Shield"
		},
		"simpledb": {
			"prefix": "sdb",
			"name": "SimpleDB"
		},
		"sms": {
			"name": "SMS"
		},
		"snowball": {
			"name": "Snowball"
		},
		"sns": {
			"name": "SNS",
			"cors": true
		},
		"sqs": {
			"name": "SQS",
			"cors": true
		},
		"ssm": {
			"name": "SSM",
			"cors": true
		},
		"storagegateway": {
			"name": "StorageGateway",
			"cors": true
		},
		"stepfunctions": {
			"prefix": "states",
			"name": "StepFunctions"
		},
		"sts": {
			"name": "STS",
			"cors": true
		},
		"support": {
			"name": "Support"
		},
		"swf": {
			"name": "SWF"
		},
		"xray": {
			"name": "XRay"
		},
		"waf": {
			"name": "WAF",
			"cors": true
		},
		"wafregional": {
			"prefix": "waf-regional",
			"name": "WAFRegional"
		},
		"workdocs": {
			"name": "WorkDocs",
			"cors": true
		},
		"workspaces": {
			"name": "WorkSpaces"
		},
		"codestar": {
			"name": "CodeStar"
		},
		"lexmodelbuildingservice": {
			"prefix": "lex-models",
			"name": "LexModelBuildingService",
			"cors": true
		},
		"marketplaceentitlementservice": {
			"prefix": "entitlement.marketplace",
			"name": "MarketplaceEntitlementService"
		},
		"athena": {
			"name": "Athena"
		},
		"greengrass": {
			"name": "Greengrass"
		},
		"dax": {
			"name": "DAX"
		},
		"migrationhub": {
			"prefix": "AWSMigrationHub",
			"name": "MigrationHub"
		},
		"cloudhsmv2": {
			"name": "CloudHSMV2"
		},
		"glue": {
			"name": "Glue"
		},
		"mobile": {
			"name": "Mobile"
		},
		"pricing": {
			"name": "Pricing",
			"cors": true
		},
		"costexplorer": {
			"prefix": "ce",
			"name": "CostExplorer",
			"cors": true
		},
		"mediaconvert": {
			"name": "MediaConvert"
		},
		"medialive": {
			"name": "MediaLive"
		},
		"mediapackage": {
			"name": "MediaPackage"
		},
		"mediastore": {
			"name": "MediaStore"
		},
		"mediastoredata": {
			"prefix": "mediastore-data",
			"name": "MediaStoreData",
			"cors": true
		},
		"appsync": {
			"name": "AppSync"
		},
		"guardduty": {
			"name": "GuardDuty"
		},
		"mq": {
			"name": "MQ"
		},
		"comprehend": {
			"name": "Comprehend",
			"cors": true
		},
		"iotjobsdataplane": {
			"prefix": "iot-jobs-data",
			"name": "IoTJobsDataPlane"
		},
		"kinesisvideoarchivedmedia": {
			"prefix": "kinesis-video-archived-media",
			"name": "KinesisVideoArchivedMedia",
			"cors": true
		},
		"kinesisvideomedia": {
			"prefix": "kinesis-video-media",
			"name": "KinesisVideoMedia",
			"cors": true
		},
		"kinesisvideo": {
			"name": "KinesisVideo",
			"cors": true
		},
		"sagemakerruntime": {
			"prefix": "runtime.sagemaker",
			"name": "SageMakerRuntime"
		},
		"sagemaker": {
			"name": "SageMaker"
		},
		"translate": {
			"name": "Translate",
			"cors": true
		},
		"resourcegroups": {
			"prefix": "resource-groups",
			"name": "ResourceGroups",
			"cors": true
		},
		"alexaforbusiness": {
			"name": "AlexaForBusiness"
		},
		"cloud9": {
			"name": "Cloud9"
		},
		"serverlessapplicationrepository": {
			"prefix": "serverlessrepo",
			"name": "ServerlessApplicationRepository"
		},
		"servicediscovery": {
			"name": "ServiceDiscovery"
		},
		"workmail": {
			"name": "WorkMail"
		},
		"autoscalingplans": {
			"prefix": "autoscaling-plans",
			"name": "AutoScalingPlans"
		},
		"transcribeservice": {
			"prefix": "transcribe",
			"name": "TranscribeService"
		},
		"connect": {
			"name": "Connect"
		},
		"acmpca": {
			"prefix": "acm-pca",
			"name": "ACMPCA"
		},
		"fms": {
			"name": "FMS"
		},
		"secretsmanager": {
			"name": "SecretsManager",
			"cors": true
		},
		"iotanalytics": {
			"name": "IoTAnalytics"
		},
		"iot1clickdevicesservice": {
			"prefix": "iot1click-devices",
			"name": "IoT1ClickDevicesService"
		},
		"iot1clickprojects": {
			"prefix": "iot1click-projects",
			"name": "IoT1ClickProjects"
		},
		"pi": {
			"name": "PI"
		},
		"neptune": {
			"name": "Neptune"
		},
		"mediatailor": {
			"name": "MediaTailor"
		},
		"eks": {
			"name": "EKS"
		},
		"macie": {
			"name": "Macie"
		},
		"dlm": {
			"name": "DLM"
		},
		"signer": {
			"name": "Signer"
		},
		"chime": {
			"name": "Chime"
		},
		"pinpointemail": {
			"prefix": "pinpoint-email",
			"name": "PinpointEmail"
		},
		"ram": {
			"name": "RAM"
		},
		"route53resolver": {
			"name": "Route53Resolver"
		},
		"pinpointsmsvoice": {
			"prefix": "sms-voice",
			"name": "PinpointSMSVoice"
		},
		"quicksight": {
			"name": "QuickSight"
		},
		"rdsdataservice": {
			"prefix": "rds-data",
			"name": "RDSDataService"
		},
		"amplify": {
			"name": "Amplify"
		},
		"datasync": {
			"name": "DataSync"
		},
		"robomaker": {
			"name": "RoboMaker"
		},
		"transfer": {
			"name": "Transfer"
		},
		"globalaccelerator": {
			"name": "GlobalAccelerator"
		},
		"comprehendmedical": {
			"name": "ComprehendMedical",
			"cors": true
		},
		"kinesisanalyticsv2": {
			"name": "KinesisAnalyticsV2"
		},
		"mediaconnect": {
			"name": "MediaConnect"
		},
		"fsx": {
			"name": "FSx"
		},
		"securityhub": {
			"name": "SecurityHub"
		},
		"appmesh": {
			"name": "AppMesh",
			"versions": [
				"2018-10-01*"
			]
		},
		"licensemanager": {
			"prefix": "license-manager",
			"name": "LicenseManager"
		},
		"kafka": {
			"name": "Kafka"
		},
		"apigatewaymanagementapi": {
			"name": "ApiGatewayManagementApi"
		},
		"apigatewayv2": {
			"name": "ApiGatewayV2"
		},
		"docdb": {
			"name": "DocDB"
		},
		"backup": {
			"name": "Backup"
		},
		"worklink": {
			"name": "WorkLink"
		},
		"textract": {
			"name": "Textract"
		},
		"managedblockchain": {
			"name": "ManagedBlockchain"
		},
		"mediapackagevod": {
			"prefix": "mediapackage-vod",
			"name": "MediaPackageVod"
		},
		"groundstation": {
			"name": "GroundStation"
		},
		"iotthingsgraph": {
			"name": "IoTThingsGraph"
		},
		"iotevents": {
			"name": "IoTEvents"
		},
		"ioteventsdata": {
			"prefix": "iotevents-data",
			"name": "IoTEventsData"
		},
		"personalize": {
			"name": "Personalize",
			"cors": true
		},
		"personalizeevents": {
			"prefix": "personalize-events",
			"name": "PersonalizeEvents",
			"cors": true
		},
		"personalizeruntime": {
			"prefix": "personalize-runtime",
			"name": "PersonalizeRuntime",
			"cors": true
		},
		"applicationinsights": {
			"prefix": "application-insights",
			"name": "ApplicationInsights"
		},
		"servicequotas": {
			"prefix": "service-quotas",
			"name": "ServiceQuotas"
		},
		"ec2instanceconnect": {
			"prefix": "ec2-instance-connect",
			"name": "EC2InstanceConnect"
		},
		"eventbridge": {
			"name": "EventBridge"
		},
		"lakeformation": {
			"name": "LakeFormation"
		},
		"forecastservice": {
			"prefix": "forecast",
			"name": "ForecastService"
		},
		"forecastqueryservice": {
			"prefix": "forecastquery",
			"name": "ForecastQueryService"
		}
	};

/***/ },
/* 482 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2011-06-15",
			"endpointPrefix": "sts",
			"globalEndpoint": "sts.amazonaws.com",
			"protocol": "query",
			"serviceAbbreviation": "AWS STS",
			"serviceFullName": "AWS Security Token Service",
			"serviceId": "STS",
			"signatureVersion": "v4",
			"uid": "sts-2011-06-15",
			"xmlNamespace": "https://sts.amazonaws.com/doc/2011-06-15/"
		},
		"operations": {
			"AssumeRole": {
				"input": {
					"type": "structure",
					"required": [
						"RoleArn",
						"RoleSessionName"
					],
					"members": {
						"RoleArn": {},
						"RoleSessionName": {},
						"PolicyArns": {
							"shape": "S4"
						},
						"Policy": {},
						"DurationSeconds": {
							"type": "integer"
						},
						"ExternalId": {},
						"SerialNumber": {},
						"TokenCode": {}
					}
				},
				"output": {
					"resultWrapper": "AssumeRoleResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sc"
						},
						"AssumedRoleUser": {
							"shape": "Sh"
						},
						"PackedPolicySize": {
							"type": "integer"
						}
					}
				}
			},
			"AssumeRoleWithSAML": {
				"input": {
					"type": "structure",
					"required": [
						"RoleArn",
						"PrincipalArn",
						"SAMLAssertion"
					],
					"members": {
						"RoleArn": {},
						"PrincipalArn": {},
						"SAMLAssertion": {},
						"PolicyArns": {
							"shape": "S4"
						},
						"Policy": {},
						"DurationSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "AssumeRoleWithSAMLResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sc"
						},
						"AssumedRoleUser": {
							"shape": "Sh"
						},
						"PackedPolicySize": {
							"type": "integer"
						},
						"Subject": {},
						"SubjectType": {},
						"Issuer": {},
						"Audience": {},
						"NameQualifier": {}
					}
				}
			},
			"AssumeRoleWithWebIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"RoleArn",
						"RoleSessionName",
						"WebIdentityToken"
					],
					"members": {
						"RoleArn": {},
						"RoleSessionName": {},
						"WebIdentityToken": {},
						"ProviderId": {},
						"PolicyArns": {
							"shape": "S4"
						},
						"Policy": {},
						"DurationSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "AssumeRoleWithWebIdentityResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sc"
						},
						"SubjectFromWebIdentityToken": {},
						"AssumedRoleUser": {
							"shape": "Sh"
						},
						"PackedPolicySize": {
							"type": "integer"
						},
						"Provider": {},
						"Audience": {}
					}
				}
			},
			"DecodeAuthorizationMessage": {
				"input": {
					"type": "structure",
					"required": [
						"EncodedMessage"
					],
					"members": {
						"EncodedMessage": {}
					}
				},
				"output": {
					"resultWrapper": "DecodeAuthorizationMessageResult",
					"type": "structure",
					"members": {
						"DecodedMessage": {}
					}
				}
			},
			"GetAccessKeyInfo": {
				"input": {
					"type": "structure",
					"required": [
						"AccessKeyId"
					],
					"members": {
						"AccessKeyId": {}
					}
				},
				"output": {
					"resultWrapper": "GetAccessKeyInfoResult",
					"type": "structure",
					"members": {
						"Account": {}
					}
				}
			},
			"GetCallerIdentity": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"resultWrapper": "GetCallerIdentityResult",
					"type": "structure",
					"members": {
						"UserId": {},
						"Account": {},
						"Arn": {}
					}
				}
			},
			"GetFederationToken": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"Policy": {},
						"PolicyArns": {
							"shape": "S4"
						},
						"DurationSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "GetFederationTokenResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sc"
						},
						"FederatedUser": {
							"type": "structure",
							"required": [
								"FederatedUserId",
								"Arn"
							],
							"members": {
								"FederatedUserId": {},
								"Arn": {}
							}
						},
						"PackedPolicySize": {
							"type": "integer"
						}
					}
				}
			},
			"GetSessionToken": {
				"input": {
					"type": "structure",
					"members": {
						"DurationSeconds": {
							"type": "integer"
						},
						"SerialNumber": {},
						"TokenCode": {}
					}
				},
				"output": {
					"resultWrapper": "GetSessionTokenResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sc"
						}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"arn": {}
					}
				}
			},
			"Sc": {
				"type": "structure",
				"required": [
					"AccessKeyId",
					"SecretAccessKey",
					"SessionToken",
					"Expiration"
				],
				"members": {
					"AccessKeyId": {},
					"SecretAccessKey": {},
					"SessionToken": {},
					"Expiration": {
						"type": "timestamp"
					}
				}
			},
			"Sh": {
				"type": "structure",
				"required": [
					"AssumedRoleId",
					"Arn"
				],
				"members": {
					"AssumedRoleId": {},
					"Arn": {}
				}
			}
		}
	};

/***/ },
/* 483 */
480,
/* 484 */
/***/ function(module, exports) {

	module.exports = {
		"rules": {
			"*/*": {
				"endpoint": "{service}.{region}.amazonaws.com"
			},
			"cn-*/*": {
				"endpoint": "{service}.{region}.amazonaws.com.cn"
			},
			"*/budgets": "globalSSL",
			"*/cloudfront": "globalSSL",
			"*/iam": "globalSSL",
			"*/sts": "globalSSL",
			"*/importexport": {
				"endpoint": "{service}.amazonaws.com",
				"signatureVersion": "v2",
				"globalEndpoint": true
			},
			"*/route53": {
				"endpoint": "https://{service}.amazonaws.com",
				"signatureVersion": "v3https",
				"globalEndpoint": true
			},
			"*/waf": "globalSSL",
			"us-gov-*/iam": "globalGovCloud",
			"us-gov-*/sts": {
				"endpoint": "{service}.{region}.amazonaws.com"
			},
			"us-gov-west-1/s3": "s3signature",
			"us-west-1/s3": "s3signature",
			"us-west-2/s3": "s3signature",
			"eu-west-1/s3": "s3signature",
			"ap-southeast-1/s3": "s3signature",
			"ap-southeast-2/s3": "s3signature",
			"ap-northeast-1/s3": "s3signature",
			"sa-east-1/s3": "s3signature",
			"us-east-1/s3": {
				"endpoint": "{service}.amazonaws.com",
				"signatureVersion": "s3"
			},
			"us-east-1/sdb": {
				"endpoint": "{service}.amazonaws.com",
				"signatureVersion": "v2"
			},
			"*/sdb": {
				"endpoint": "{service}.{region}.amazonaws.com",
				"signatureVersion": "v2"
			}
		},
		"patterns": {
			"globalSSL": {
				"endpoint": "https://{service}.amazonaws.com",
				"globalEndpoint": true
			},
			"globalGovCloud": {
				"endpoint": "{service}.us-gov.amazonaws.com"
			},
			"s3signature": {
				"endpoint": "{service}.{region}.amazonaws.com",
				"signatureVersion": "s3"
			}
		}
	};

/***/ },
/* 485 */
479,
/* 486 */
480,
/* 487 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2013-12-02",
			"endpointPrefix": "kinesis",
			"jsonVersion": "1.1",
			"protocol": "json",
			"protocolSettings": {
				"h2": "eventstream"
			},
			"serviceAbbreviation": "Kinesis",
			"serviceFullName": "Amazon Kinesis",
			"serviceId": "Kinesis",
			"signatureVersion": "v4",
			"targetPrefix": "Kinesis_20131202",
			"uid": "kinesis-2013-12-02"
		},
		"operations": {
			"AddTagsToStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"Tags"
					],
					"members": {
						"StreamName": {},
						"Tags": {
							"type": "map",
							"key": {},
							"value": {}
						}
					}
				}
			},
			"CreateStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardCount"
					],
					"members": {
						"StreamName": {},
						"ShardCount": {
							"type": "integer"
						}
					}
				}
			},
			"DecreaseStreamRetentionPeriod": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"RetentionPeriodHours"
					],
					"members": {
						"StreamName": {},
						"RetentionPeriodHours": {
							"type": "integer"
						}
					}
				}
			},
			"DeleteStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName"
					],
					"members": {
						"StreamName": {},
						"EnforceConsumerDeletion": {
							"type": "boolean"
						}
					}
				}
			},
			"DeregisterStreamConsumer": {
				"input": {
					"type": "structure",
					"members": {
						"StreamARN": {},
						"ConsumerName": {},
						"ConsumerARN": {}
					}
				}
			},
			"DescribeLimits": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"required": [
						"ShardLimit",
						"OpenShardCount"
					],
					"members": {
						"ShardLimit": {
							"type": "integer"
						},
						"OpenShardCount": {
							"type": "integer"
						}
					}
				}
			},
			"DescribeStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName"
					],
					"members": {
						"StreamName": {},
						"Limit": {
							"type": "integer"
						},
						"ExclusiveStartShardId": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"StreamDescription"
					],
					"members": {
						"StreamDescription": {
							"type": "structure",
							"required": [
								"StreamName",
								"StreamARN",
								"StreamStatus",
								"Shards",
								"HasMoreShards",
								"RetentionPeriodHours",
								"StreamCreationTimestamp",
								"EnhancedMonitoring"
							],
							"members": {
								"StreamName": {},
								"StreamARN": {},
								"StreamStatus": {},
								"Shards": {
									"shape": "Sp"
								},
								"HasMoreShards": {
									"type": "boolean"
								},
								"RetentionPeriodHours": {
									"type": "integer"
								},
								"StreamCreationTimestamp": {
									"type": "timestamp"
								},
								"EnhancedMonitoring": {
									"shape": "Sw"
								},
								"EncryptionType": {},
								"KeyId": {}
							}
						}
					}
				}
			},
			"DescribeStreamConsumer": {
				"input": {
					"type": "structure",
					"members": {
						"StreamARN": {},
						"ConsumerName": {},
						"ConsumerARN": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ConsumerDescription"
					],
					"members": {
						"ConsumerDescription": {
							"type": "structure",
							"required": [
								"ConsumerName",
								"ConsumerARN",
								"ConsumerStatus",
								"ConsumerCreationTimestamp",
								"StreamARN"
							],
							"members": {
								"ConsumerName": {},
								"ConsumerARN": {},
								"ConsumerStatus": {},
								"ConsumerCreationTimestamp": {
									"type": "timestamp"
								},
								"StreamARN": {}
							}
						}
					}
				}
			},
			"DescribeStreamSummary": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName"
					],
					"members": {
						"StreamName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"StreamDescriptionSummary"
					],
					"members": {
						"StreamDescriptionSummary": {
							"type": "structure",
							"required": [
								"StreamName",
								"StreamARN",
								"StreamStatus",
								"RetentionPeriodHours",
								"StreamCreationTimestamp",
								"EnhancedMonitoring",
								"OpenShardCount"
							],
							"members": {
								"StreamName": {},
								"StreamARN": {},
								"StreamStatus": {},
								"RetentionPeriodHours": {
									"type": "integer"
								},
								"StreamCreationTimestamp": {
									"type": "timestamp"
								},
								"EnhancedMonitoring": {
									"shape": "Sw"
								},
								"EncryptionType": {},
								"KeyId": {},
								"OpenShardCount": {
									"type": "integer"
								},
								"ConsumerCount": {
									"type": "integer"
								}
							}
						}
					}
				}
			},
			"DisableEnhancedMonitoring": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardLevelMetrics"
					],
					"members": {
						"StreamName": {},
						"ShardLevelMetrics": {
							"shape": "Sy"
						}
					}
				},
				"output": {
					"shape": "S1b"
				}
			},
			"EnableEnhancedMonitoring": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardLevelMetrics"
					],
					"members": {
						"StreamName": {},
						"ShardLevelMetrics": {
							"shape": "Sy"
						}
					}
				},
				"output": {
					"shape": "S1b"
				}
			},
			"GetRecords": {
				"input": {
					"type": "structure",
					"required": [
						"ShardIterator"
					],
					"members": {
						"ShardIterator": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Records"
					],
					"members": {
						"Records": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"SequenceNumber",
									"Data",
									"PartitionKey"
								],
								"members": {
									"SequenceNumber": {},
									"ApproximateArrivalTimestamp": {
										"type": "timestamp"
									},
									"Data": {
										"type": "blob"
									},
									"PartitionKey": {},
									"EncryptionType": {}
								}
							}
						},
						"NextShardIterator": {},
						"MillisBehindLatest": {
							"type": "long"
						}
					}
				}
			},
			"GetShardIterator": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardId",
						"ShardIteratorType"
					],
					"members": {
						"StreamName": {},
						"ShardId": {},
						"ShardIteratorType": {},
						"StartingSequenceNumber": {},
						"Timestamp": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ShardIterator": {}
					}
				}
			},
			"IncreaseStreamRetentionPeriod": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"RetentionPeriodHours"
					],
					"members": {
						"StreamName": {},
						"RetentionPeriodHours": {
							"type": "integer"
						}
					}
				}
			},
			"ListShards": {
				"input": {
					"type": "structure",
					"members": {
						"StreamName": {},
						"NextToken": {},
						"ExclusiveStartShardId": {},
						"MaxResults": {
							"type": "integer"
						},
						"StreamCreationTimestamp": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Shards": {
							"shape": "Sp"
						},
						"NextToken": {}
					}
				}
			},
			"ListStreamConsumers": {
				"input": {
					"type": "structure",
					"required": [
						"StreamARN"
					],
					"members": {
						"StreamARN": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"StreamCreationTimestamp": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Consumers": {
							"type": "list",
							"member": {
								"shape": "S1y"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListStreams": {
				"input": {
					"type": "structure",
					"members": {
						"Limit": {
							"type": "integer"
						},
						"ExclusiveStartStreamName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"StreamNames",
						"HasMoreStreams"
					],
					"members": {
						"StreamNames": {
							"type": "list",
							"member": {}
						},
						"HasMoreStreams": {
							"type": "boolean"
						}
					}
				}
			},
			"ListTagsForStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName"
					],
					"members": {
						"StreamName": {},
						"ExclusiveStartTagKey": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Tags",
						"HasMoreTags"
					],
					"members": {
						"Tags": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Key"
								],
								"members": {
									"Key": {},
									"Value": {}
								}
							}
						},
						"HasMoreTags": {
							"type": "boolean"
						}
					}
				}
			},
			"MergeShards": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardToMerge",
						"AdjacentShardToMerge"
					],
					"members": {
						"StreamName": {},
						"ShardToMerge": {},
						"AdjacentShardToMerge": {}
					}
				}
			},
			"PutRecord": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"Data",
						"PartitionKey"
					],
					"members": {
						"StreamName": {},
						"Data": {
							"type": "blob"
						},
						"PartitionKey": {},
						"ExplicitHashKey": {},
						"SequenceNumberForOrdering": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ShardId",
						"SequenceNumber"
					],
					"members": {
						"ShardId": {},
						"SequenceNumber": {},
						"EncryptionType": {}
					}
				}
			},
			"PutRecords": {
				"input": {
					"type": "structure",
					"required": [
						"Records",
						"StreamName"
					],
					"members": {
						"Records": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Data",
									"PartitionKey"
								],
								"members": {
									"Data": {
										"type": "blob"
									},
									"ExplicitHashKey": {},
									"PartitionKey": {}
								}
							}
						},
						"StreamName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Records"
					],
					"members": {
						"FailedRecordCount": {
							"type": "integer"
						},
						"Records": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"SequenceNumber": {},
									"ShardId": {},
									"ErrorCode": {},
									"ErrorMessage": {}
								}
							}
						},
						"EncryptionType": {}
					}
				}
			},
			"RegisterStreamConsumer": {
				"input": {
					"type": "structure",
					"required": [
						"StreamARN",
						"ConsumerName"
					],
					"members": {
						"StreamARN": {},
						"ConsumerName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Consumer"
					],
					"members": {
						"Consumer": {
							"shape": "S1y"
						}
					}
				}
			},
			"RemoveTagsFromStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"TagKeys"
					],
					"members": {
						"StreamName": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"SplitShard": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardToSplit",
						"NewStartingHashKey"
					],
					"members": {
						"StreamName": {},
						"ShardToSplit": {},
						"NewStartingHashKey": {}
					}
				}
			},
			"StartStreamEncryption": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"EncryptionType",
						"KeyId"
					],
					"members": {
						"StreamName": {},
						"EncryptionType": {},
						"KeyId": {}
					}
				}
			},
			"StopStreamEncryption": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"EncryptionType",
						"KeyId"
					],
					"members": {
						"StreamName": {},
						"EncryptionType": {},
						"KeyId": {}
					}
				}
			},
			"UpdateShardCount": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"TargetShardCount",
						"ScalingType"
					],
					"members": {
						"StreamName": {},
						"TargetShardCount": {
							"type": "integer"
						},
						"ScalingType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamName": {},
						"CurrentShardCount": {
							"type": "integer"
						},
						"TargetShardCount": {
							"type": "integer"
						}
					}
				}
			}
		},
		"shapes": {
			"Sp": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"ShardId",
						"HashKeyRange",
						"SequenceNumberRange"
					],
					"members": {
						"ShardId": {},
						"ParentShardId": {},
						"AdjacentParentShardId": {},
						"HashKeyRange": {
							"type": "structure",
							"required": [
								"StartingHashKey",
								"EndingHashKey"
							],
							"members": {
								"StartingHashKey": {},
								"EndingHashKey": {}
							}
						},
						"SequenceNumberRange": {
							"type": "structure",
							"required": [
								"StartingSequenceNumber"
							],
							"members": {
								"StartingSequenceNumber": {},
								"EndingSequenceNumber": {}
							}
						}
					}
				}
			},
			"Sw": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ShardLevelMetrics": {
							"shape": "Sy"
						}
					}
				}
			},
			"Sy": {
				"type": "list",
				"member": {}
			},
			"S1b": {
				"type": "structure",
				"members": {
					"StreamName": {},
					"CurrentShardLevelMetrics": {
						"shape": "Sy"
					},
					"DesiredShardLevelMetrics": {
						"shape": "Sy"
					}
				}
			},
			"S1y": {
				"type": "structure",
				"required": [
					"ConsumerName",
					"ConsumerARN",
					"ConsumerStatus",
					"ConsumerCreationTimestamp"
				],
				"members": {
					"ConsumerName": {},
					"ConsumerARN": {},
					"ConsumerStatus": {},
					"ConsumerCreationTimestamp": {
						"type": "timestamp"
					}
				}
			}
		}
	};

/***/ },
/* 488 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeStream": {
				"input_token": "ExclusiveStartShardId",
				"limit_key": "Limit",
				"more_results": "StreamDescription.HasMoreShards",
				"output_token": "StreamDescription.Shards[-1].ShardId",
				"result_key": "StreamDescription.Shards"
			},
			"ListStreamConsumers": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken"
			},
			"ListStreams": {
				"input_token": "ExclusiveStartStreamName",
				"limit_key": "Limit",
				"more_results": "HasMoreStreams",
				"output_token": "StreamNames[-1]",
				"result_key": "StreamNames"
			}
		}
	};

/***/ },
/* 489 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"StreamExists": {
				"delay": 10,
				"operation": "DescribeStream",
				"maxAttempts": 18,
				"acceptors": [
					{
						"expected": "ACTIVE",
						"matcher": "path",
						"state": "success",
						"argument": "StreamDescription.StreamStatus"
					}
				]
			},
			"StreamNotExists": {
				"delay": 10,
				"operation": "DescribeStream",
				"maxAttempts": 18,
				"acceptors": [
					{
						"expected": "ResourceNotFoundException",
						"matcher": "error",
						"state": "success"
					}
				]
			}
		}
	};

/***/ },
/* 490 */
481,
/* 491 */
/***/ function(module, exports) {

	module.exports = {
		"metadata": {
			"apiVersion": "2016-12-01",
			"endpointPrefix": "pinpoint",
			"signingName": "mobiletargeting",
			"serviceFullName": "Amazon Pinpoint",
			"serviceId": "Pinpoint",
			"protocol": "rest-json",
			"jsonVersion": "1.1",
			"uid": "pinpoint-2016-12-01",
			"signatureVersion": "v4"
		},
		"operations": {
			"CreateApp": {
				"http": {
					"requestUri": "/v1/apps",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"members": {
						"CreateApplicationRequest": {
							"type": "structure",
							"members": {
								"Name": {},
								"tags": {
									"shape": "S4",
									"locationName": "tags"
								}
							},
							"required": [
								"Name"
							]
						}
					},
					"required": [
						"CreateApplicationRequest"
					],
					"payload": "CreateApplicationRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"ApplicationResponse": {
							"shape": "S6"
						}
					},
					"required": [
						"ApplicationResponse"
					],
					"payload": "ApplicationResponse"
				}
			},
			"CreateCampaign": {
				"http": {
					"requestUri": "/v1/apps/{application-id}/campaigns",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"WriteCampaignRequest": {
							"shape": "S8"
						}
					},
					"required": [
						"ApplicationId",
						"WriteCampaignRequest"
					],
					"payload": "WriteCampaignRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"CampaignResponse": {
							"shape": "S12"
						}
					},
					"required": [
						"CampaignResponse"
					],
					"payload": "CampaignResponse"
				}
			},
			"CreateExportJob": {
				"http": {
					"requestUri": "/v1/apps/{application-id}/jobs/export",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"ExportJobRequest": {
							"type": "structure",
							"members": {
								"RoleArn": {},
								"S3UrlPrefix": {},
								"SegmentId": {},
								"SegmentVersion": {
									"type": "integer"
								}
							},
							"required": [
								"S3UrlPrefix",
								"RoleArn"
							]
						}
					},
					"required": [
						"ApplicationId",
						"ExportJobRequest"
					],
					"payload": "ExportJobRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"ExportJobResponse": {
							"shape": "S1a"
						}
					},
					"required": [
						"ExportJobResponse"
					],
					"payload": "ExportJobResponse"
				}
			},
			"CreateImportJob": {
				"http": {
					"requestUri": "/v1/apps/{application-id}/jobs/import",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"ImportJobRequest": {
							"type": "structure",
							"members": {
								"DefineSegment": {
									"type": "boolean"
								},
								"ExternalId": {},
								"Format": {},
								"RegisterEndpoints": {
									"type": "boolean"
								},
								"RoleArn": {},
								"S3Url": {},
								"SegmentId": {},
								"SegmentName": {}
							},
							"required": [
								"Format",
								"S3Url",
								"RoleArn"
							]
						}
					},
					"required": [
						"ApplicationId",
						"ImportJobRequest"
					],
					"payload": "ImportJobRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"ImportJobResponse": {
							"shape": "S1h"
						}
					},
					"required": [
						"ImportJobResponse"
					],
					"payload": "ImportJobResponse"
				}
			},
			"CreateSegment": {
				"http": {
					"requestUri": "/v1/apps/{application-id}/segments",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"WriteSegmentRequest": {
							"shape": "S1k"
						}
					},
					"required": [
						"ApplicationId",
						"WriteSegmentRequest"
					],
					"payload": "WriteSegmentRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"SegmentResponse": {
							"shape": "S24"
						}
					},
					"required": [
						"SegmentResponse"
					],
					"payload": "SegmentResponse"
				}
			},
			"DeleteAdmChannel": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/apps/{application-id}/channels/adm",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"ADMChannelResponse": {
							"shape": "S2a"
						}
					},
					"required": [
						"ADMChannelResponse"
					],
					"payload": "ADMChannelResponse"
				}
			},
			"DeleteApnsChannel": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/apps/{application-id}/channels/apns",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"APNSChannelResponse": {
							"shape": "S2d"
						}
					},
					"required": [
						"APNSChannelResponse"
					],
					"payload": "APNSChannelResponse"
				}
			},
			"DeleteApnsSandboxChannel": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/apps/{application-id}/channels/apns_sandbox",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"APNSSandboxChannelResponse": {
							"shape": "S2g"
						}
					},
					"required": [
						"APNSSandboxChannelResponse"
					],
					"payload": "APNSSandboxChannelResponse"
				}
			},
			"DeleteApnsVoipChannel": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/apps/{application-id}/channels/apns_voip",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"APNSVoipChannelResponse": {
							"shape": "S2j"
						}
					},
					"required": [
						"APNSVoipChannelResponse"
					],
					"payload": "APNSVoipChannelResponse"
				}
			},
			"DeleteApnsVoipSandboxChannel": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/apps/{application-id}/channels/apns_voip_sandbox",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"APNSVoipSandboxChannelResponse": {
							"shape": "S2m"
						}
					},
					"required": [
						"APNSVoipSandboxChannelResponse"
					],
					"payload": "APNSVoipSandboxChannelResponse"
				}
			},
			"DeleteApp": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/apps/{application-id}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"ApplicationResponse": {
							"shape": "S6"
						}
					},
					"required": [
						"ApplicationResponse"
					],
					"payload": "ApplicationResponse"
				}
			},
			"DeleteBaiduChannel": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/apps/{application-id}/channels/baidu",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"BaiduChannelResponse": {
							"shape": "S2r"
						}
					},
					"required": [
						"BaiduChannelResponse"
					],
					"payload": "BaiduChannelResponse"
				}
			},
			"DeleteCampaign": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/apps/{application-id}/campaigns/{campaign-id}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"CampaignId": {
							"location": "uri",
							"locationName": "campaign-id"
						}
					},
					"required": [
						"CampaignId",
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"CampaignResponse": {
							"shape": "S12"
						}
					},
					"required": [
						"CampaignResponse"
					],
					"payload": "CampaignResponse"
				}
			},
			"DeleteEmailChannel": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/apps/{application-id}/channels/email",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"EmailChannelResponse": {
							"shape": "S2w"
						}
					},
					"required": [
						"EmailChannelResponse"
					],
					"payload": "EmailChannelResponse"
				}
			},
			"DeleteEndpoint": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/apps/{application-id}/endpoints/{endpoint-id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"EndpointId": {
							"location": "uri",
							"locationName": "endpoint-id"
						}
					},
					"required": [
						"ApplicationId",
						"EndpointId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"EndpointResponse": {
							"shape": "S2z"
						}
					},
					"required": [
						"EndpointResponse"
					],
					"payload": "EndpointResponse"
				}
			},
			"DeleteEventStream": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/apps/{application-id}/eventstream",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"EventStream": {
							"shape": "S38"
						}
					},
					"required": [
						"EventStream"
					],
					"payload": "EventStream"
				}
			},
			"DeleteGcmChannel": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/apps/{application-id}/channels/gcm",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"GCMChannelResponse": {
							"shape": "S3b"
						}
					},
					"required": [
						"GCMChannelResponse"
					],
					"payload": "GCMChannelResponse"
				}
			},
			"DeleteSegment": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/apps/{application-id}/segments/{segment-id}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"SegmentId": {
							"location": "uri",
							"locationName": "segment-id"
						}
					},
					"required": [
						"SegmentId",
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"SegmentResponse": {
							"shape": "S24"
						}
					},
					"required": [
						"SegmentResponse"
					],
					"payload": "SegmentResponse"
				}
			},
			"DeleteSmsChannel": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/apps/{application-id}/channels/sms",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"SMSChannelResponse": {
							"shape": "S3g"
						}
					},
					"required": [
						"SMSChannelResponse"
					],
					"payload": "SMSChannelResponse"
				}
			},
			"DeleteUserEndpoints": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/apps/{application-id}/users/{user-id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"UserId": {
							"location": "uri",
							"locationName": "user-id"
						}
					},
					"required": [
						"ApplicationId",
						"UserId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"EndpointsResponse": {
							"shape": "S3j"
						}
					},
					"required": [
						"EndpointsResponse"
					],
					"payload": "EndpointsResponse"
				}
			},
			"DeleteVoiceChannel": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/apps/{application-id}/channels/voice",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"VoiceChannelResponse": {
							"shape": "S3n"
						}
					},
					"required": [
						"VoiceChannelResponse"
					],
					"payload": "VoiceChannelResponse"
				}
			},
			"GetAdmChannel": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/channels/adm",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"ADMChannelResponse": {
							"shape": "S2a"
						}
					},
					"required": [
						"ADMChannelResponse"
					],
					"payload": "ADMChannelResponse"
				}
			},
			"GetApnsChannel": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/channels/apns",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"APNSChannelResponse": {
							"shape": "S2d"
						}
					},
					"required": [
						"APNSChannelResponse"
					],
					"payload": "APNSChannelResponse"
				}
			},
			"GetApnsSandboxChannel": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/channels/apns_sandbox",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"APNSSandboxChannelResponse": {
							"shape": "S2g"
						}
					},
					"required": [
						"APNSSandboxChannelResponse"
					],
					"payload": "APNSSandboxChannelResponse"
				}
			},
			"GetApnsVoipChannel": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/channels/apns_voip",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"APNSVoipChannelResponse": {
							"shape": "S2j"
						}
					},
					"required": [
						"APNSVoipChannelResponse"
					],
					"payload": "APNSVoipChannelResponse"
				}
			},
			"GetApnsVoipSandboxChannel": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/channels/apns_voip_sandbox",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"APNSVoipSandboxChannelResponse": {
							"shape": "S2m"
						}
					},
					"required": [
						"APNSVoipSandboxChannelResponse"
					],
					"payload": "APNSVoipSandboxChannelResponse"
				}
			},
			"GetApp": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"ApplicationResponse": {
							"shape": "S6"
						}
					},
					"required": [
						"ApplicationResponse"
					],
					"payload": "ApplicationResponse"
				}
			},
			"GetApplicationDateRangeKpi": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/kpis/daterange/{kpi-name}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"EndTime": {
							"shape": "S41",
							"location": "querystring",
							"locationName": "end-time"
						},
						"KpiName": {
							"location": "uri",
							"locationName": "kpi-name"
						},
						"NextToken": {
							"location": "querystring",
							"locationName": "next-token"
						},
						"PageSize": {
							"location": "querystring",
							"locationName": "page-size"
						},
						"StartTime": {
							"shape": "S41",
							"location": "querystring",
							"locationName": "start-time"
						}
					},
					"required": [
						"ApplicationId",
						"KpiName"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"ApplicationDateRangeKpiResponse": {
							"type": "structure",
							"members": {
								"ApplicationId": {},
								"EndTime": {
									"shape": "S41"
								},
								"KpiName": {},
								"KpiResult": {
									"shape": "S44"
								},
								"NextToken": {},
								"StartTime": {
									"shape": "S41"
								}
							},
							"required": [
								"KpiResult",
								"KpiName",
								"EndTime",
								"StartTime",
								"ApplicationId"
							]
						}
					},
					"required": [
						"ApplicationDateRangeKpiResponse"
					],
					"payload": "ApplicationDateRangeKpiResponse"
				}
			},
			"GetApplicationSettings": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/settings",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"ApplicationSettingsResource": {
							"shape": "S4b"
						}
					},
					"required": [
						"ApplicationSettingsResource"
					],
					"payload": "ApplicationSettingsResource"
				}
			},
			"GetApps": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"PageSize": {
							"location": "querystring",
							"locationName": "page-size"
						},
						"Token": {
							"location": "querystring",
							"locationName": "token"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ApplicationsResponse": {
							"type": "structure",
							"members": {
								"Item": {
									"type": "list",
									"member": {
										"shape": "S6"
									}
								},
								"NextToken": {}
							}
						}
					},
					"required": [
						"ApplicationsResponse"
					],
					"payload": "ApplicationsResponse"
				}
			},
			"GetBaiduChannel": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/channels/baidu",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"BaiduChannelResponse": {
							"shape": "S2r"
						}
					},
					"required": [
						"BaiduChannelResponse"
					],
					"payload": "BaiduChannelResponse"
				}
			},
			"GetCampaign": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/campaigns/{campaign-id}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"CampaignId": {
							"location": "uri",
							"locationName": "campaign-id"
						}
					},
					"required": [
						"CampaignId",
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"CampaignResponse": {
							"shape": "S12"
						}
					},
					"required": [
						"CampaignResponse"
					],
					"payload": "CampaignResponse"
				}
			},
			"GetCampaignActivities": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/campaigns/{campaign-id}/activities",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"CampaignId": {
							"location": "uri",
							"locationName": "campaign-id"
						},
						"PageSize": {
							"location": "querystring",
							"locationName": "page-size"
						},
						"Token": {
							"location": "querystring",
							"locationName": "token"
						}
					},
					"required": [
						"ApplicationId",
						"CampaignId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"ActivitiesResponse": {
							"type": "structure",
							"members": {
								"Item": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"ApplicationId": {},
											"CampaignId": {},
											"End": {},
											"Id": {},
											"Result": {},
											"ScheduledStart": {},
											"Start": {},
											"State": {},
											"SuccessfulEndpointCount": {
												"type": "integer"
											},
											"TimezonesCompletedCount": {
												"type": "integer"
											},
											"TimezonesTotalCount": {
												"type": "integer"
											},
											"TotalEndpointCount": {
												"type": "integer"
											},
											"TreatmentId": {}
										},
										"required": [
											"CampaignId",
											"Id",
											"ApplicationId"
										]
									}
								},
								"NextToken": {}
							},
							"required": [
								"Item"
							]
						}
					},
					"required": [
						"ActivitiesResponse"
					],
					"payload": "ActivitiesResponse"
				}
			},
			"GetCampaignDateRangeKpi": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/campaigns/{campaign-id}/kpis/daterange/{kpi-name}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"CampaignId": {
							"location": "uri",
							"locationName": "campaign-id"
						},
						"EndTime": {
							"shape": "S41",
							"location": "querystring",
							"locationName": "end-time"
						},
						"KpiName": {
							"location": "uri",
							"locationName": "kpi-name"
						},
						"NextToken": {
							"location": "querystring",
							"locationName": "next-token"
						},
						"PageSize": {
							"location": "querystring",
							"locationName": "page-size"
						},
						"StartTime": {
							"shape": "S41",
							"location": "querystring",
							"locationName": "start-time"
						}
					},
					"required": [
						"ApplicationId",
						"KpiName",
						"CampaignId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"CampaignDateRangeKpiResponse": {
							"type": "structure",
							"members": {
								"ApplicationId": {},
								"CampaignId": {},
								"EndTime": {
									"shape": "S41"
								},
								"KpiName": {},
								"KpiResult": {
									"shape": "S44"
								},
								"NextToken": {},
								"StartTime": {
									"shape": "S41"
								}
							},
							"required": [
								"KpiResult",
								"KpiName",
								"EndTime",
								"CampaignId",
								"StartTime",
								"ApplicationId"
							]
						}
					},
					"required": [
						"CampaignDateRangeKpiResponse"
					],
					"payload": "CampaignDateRangeKpiResponse"
				}
			},
			"GetCampaignVersion": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/campaigns/{campaign-id}/versions/{version}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"CampaignId": {
							"location": "uri",
							"locationName": "campaign-id"
						},
						"Version": {
							"location": "uri",
							"locationName": "version"
						}
					},
					"required": [
						"Version",
						"ApplicationId",
						"CampaignId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"CampaignResponse": {
							"shape": "S12"
						}
					},
					"required": [
						"CampaignResponse"
					],
					"payload": "CampaignResponse"
				}
			},
			"GetCampaignVersions": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/campaigns/{campaign-id}/versions",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"CampaignId": {
							"location": "uri",
							"locationName": "campaign-id"
						},
						"PageSize": {
							"location": "querystring",
							"locationName": "page-size"
						},
						"Token": {
							"location": "querystring",
							"locationName": "token"
						}
					},
					"required": [
						"ApplicationId",
						"CampaignId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"CampaignsResponse": {
							"shape": "S4w"
						}
					},
					"required": [
						"CampaignsResponse"
					],
					"payload": "CampaignsResponse"
				}
			},
			"GetCampaigns": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/campaigns",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"PageSize": {
							"location": "querystring",
							"locationName": "page-size"
						},
						"Token": {
							"location": "querystring",
							"locationName": "token"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"CampaignsResponse": {
							"shape": "S4w"
						}
					},
					"required": [
						"CampaignsResponse"
					],
					"payload": "CampaignsResponse"
				}
			},
			"GetChannels": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/channels",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"ChannelsResponse": {
							"type": "structure",
							"members": {
								"Channels": {
									"type": "map",
									"key": {},
									"value": {
										"type": "structure",
										"members": {
											"ApplicationId": {},
											"CreationDate": {},
											"Enabled": {
												"type": "boolean"
											},
											"HasCredential": {
												"type": "boolean"
											},
											"Id": {},
											"IsArchived": {
												"type": "boolean"
											},
											"LastModifiedBy": {},
											"LastModifiedDate": {},
											"Version": {
												"type": "integer"
											}
										}
									}
								}
							},
							"required": [
								"Channels"
							]
						}
					},
					"required": [
						"ChannelsResponse"
					],
					"payload": "ChannelsResponse"
				}
			},
			"GetEmailChannel": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/channels/email",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"EmailChannelResponse": {
							"shape": "S2w"
						}
					},
					"required": [
						"EmailChannelResponse"
					],
					"payload": "EmailChannelResponse"
				}
			},
			"GetEndpoint": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/endpoints/{endpoint-id}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"EndpointId": {
							"location": "uri",
							"locationName": "endpoint-id"
						}
					},
					"required": [
						"ApplicationId",
						"EndpointId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"EndpointResponse": {
							"shape": "S2z"
						}
					},
					"required": [
						"EndpointResponse"
					],
					"payload": "EndpointResponse"
				}
			},
			"GetEventStream": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/eventstream",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"EventStream": {
							"shape": "S38"
						}
					},
					"required": [
						"EventStream"
					],
					"payload": "EventStream"
				}
			},
			"GetExportJob": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/jobs/export/{job-id}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"JobId": {
							"location": "uri",
							"locationName": "job-id"
						}
					},
					"required": [
						"ApplicationId",
						"JobId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"ExportJobResponse": {
							"shape": "S1a"
						}
					},
					"required": [
						"ExportJobResponse"
					],
					"payload": "ExportJobResponse"
				}
			},
			"GetExportJobs": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/jobs/export",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"PageSize": {
							"location": "querystring",
							"locationName": "page-size"
						},
						"Token": {
							"location": "querystring",
							"locationName": "token"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"ExportJobsResponse": {
							"shape": "S5f"
						}
					},
					"required": [
						"ExportJobsResponse"
					],
					"payload": "ExportJobsResponse"
				}
			},
			"GetGcmChannel": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/channels/gcm",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"GCMChannelResponse": {
							"shape": "S3b"
						}
					},
					"required": [
						"GCMChannelResponse"
					],
					"payload": "GCMChannelResponse"
				}
			},
			"GetImportJob": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/jobs/import/{job-id}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"JobId": {
							"location": "uri",
							"locationName": "job-id"
						}
					},
					"required": [
						"ApplicationId",
						"JobId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"ImportJobResponse": {
							"shape": "S1h"
						}
					},
					"required": [
						"ImportJobResponse"
					],
					"payload": "ImportJobResponse"
				}
			},
			"GetImportJobs": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/jobs/import",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"PageSize": {
							"location": "querystring",
							"locationName": "page-size"
						},
						"Token": {
							"location": "querystring",
							"locationName": "token"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"ImportJobsResponse": {
							"shape": "S5n"
						}
					},
					"required": [
						"ImportJobsResponse"
					],
					"payload": "ImportJobsResponse"
				}
			},
			"GetSegment": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/segments/{segment-id}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"SegmentId": {
							"location": "uri",
							"locationName": "segment-id"
						}
					},
					"required": [
						"SegmentId",
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"SegmentResponse": {
							"shape": "S24"
						}
					},
					"required": [
						"SegmentResponse"
					],
					"payload": "SegmentResponse"
				}
			},
			"GetSegmentExportJobs": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/segments/{segment-id}/jobs/export",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"PageSize": {
							"location": "querystring",
							"locationName": "page-size"
						},
						"SegmentId": {
							"location": "uri",
							"locationName": "segment-id"
						},
						"Token": {
							"location": "querystring",
							"locationName": "token"
						}
					},
					"required": [
						"SegmentId",
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"ExportJobsResponse": {
							"shape": "S5f"
						}
					},
					"required": [
						"ExportJobsResponse"
					],
					"payload": "ExportJobsResponse"
				}
			},
			"GetSegmentImportJobs": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/segments/{segment-id}/jobs/import",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"PageSize": {
							"location": "querystring",
							"locationName": "page-size"
						},
						"SegmentId": {
							"location": "uri",
							"locationName": "segment-id"
						},
						"Token": {
							"location": "querystring",
							"locationName": "token"
						}
					},
					"required": [
						"SegmentId",
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"ImportJobsResponse": {
							"shape": "S5n"
						}
					},
					"required": [
						"ImportJobsResponse"
					],
					"payload": "ImportJobsResponse"
				}
			},
			"GetSegmentVersion": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/segments/{segment-id}/versions/{version}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"SegmentId": {
							"location": "uri",
							"locationName": "segment-id"
						},
						"Version": {
							"location": "uri",
							"locationName": "version"
						}
					},
					"required": [
						"SegmentId",
						"Version",
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"SegmentResponse": {
							"shape": "S24"
						}
					},
					"required": [
						"SegmentResponse"
					],
					"payload": "SegmentResponse"
				}
			},
			"GetSegmentVersions": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/segments/{segment-id}/versions",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"PageSize": {
							"location": "querystring",
							"locationName": "page-size"
						},
						"SegmentId": {
							"location": "uri",
							"locationName": "segment-id"
						},
						"Token": {
							"location": "querystring",
							"locationName": "token"
						}
					},
					"required": [
						"SegmentId",
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"SegmentsResponse": {
							"shape": "S5z"
						}
					},
					"required": [
						"SegmentsResponse"
					],
					"payload": "SegmentsResponse"
				}
			},
			"GetSegments": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/segments",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"PageSize": {
							"location": "querystring",
							"locationName": "page-size"
						},
						"Token": {
							"location": "querystring",
							"locationName": "token"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"SegmentsResponse": {
							"shape": "S5z"
						}
					},
					"required": [
						"SegmentsResponse"
					],
					"payload": "SegmentsResponse"
				}
			},
			"GetSmsChannel": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/channels/sms",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"SMSChannelResponse": {
							"shape": "S3g"
						}
					},
					"required": [
						"SMSChannelResponse"
					],
					"payload": "SMSChannelResponse"
				}
			},
			"GetUserEndpoints": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/users/{user-id}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"UserId": {
							"location": "uri",
							"locationName": "user-id"
						}
					},
					"required": [
						"ApplicationId",
						"UserId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"EndpointsResponse": {
							"shape": "S3j"
						}
					},
					"required": [
						"EndpointsResponse"
					],
					"payload": "EndpointsResponse"
				}
			},
			"GetVoiceChannel": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/apps/{application-id}/channels/voice",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"VoiceChannelResponse": {
							"shape": "S3n"
						}
					},
					"required": [
						"VoiceChannelResponse"
					],
					"payload": "VoiceChannelResponse"
				}
			},
			"ListTagsForResource": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/tags/{resource-arn}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ResourceArn": {
							"location": "uri",
							"locationName": "resource-arn"
						}
					},
					"required": [
						"ResourceArn"
					]
				},
				"output": {
					"type": "structure",
					"members": {
						"TagsModel": {
							"shape": "S6b"
						}
					},
					"required": [
						"TagsModel"
					],
					"payload": "TagsModel"
				}
			},
			"PhoneNumberValidate": {
				"http": {
					"requestUri": "/v1/phone/number/validate",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"NumberValidateRequest": {
							"type": "structure",
							"members": {
								"IsoCountryCode": {},
								"PhoneNumber": {}
							}
						}
					},
					"required": [
						"NumberValidateRequest"
					],
					"payload": "NumberValidateRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"NumberValidateResponse": {
							"type": "structure",
							"members": {
								"Carrier": {},
								"City": {},
								"CleansedPhoneNumberE164": {},
								"CleansedPhoneNumberNational": {},
								"Country": {},
								"CountryCodeIso2": {},
								"CountryCodeNumeric": {},
								"County": {},
								"OriginalCountryCodeIso2": {},
								"OriginalPhoneNumber": {},
								"PhoneType": {},
								"PhoneTypeCode": {
									"type": "integer"
								},
								"Timezone": {},
								"ZipCode": {}
							}
						}
					},
					"required": [
						"NumberValidateResponse"
					],
					"payload": "NumberValidateResponse"
				}
			},
			"PutEventStream": {
				"http": {
					"requestUri": "/v1/apps/{application-id}/eventstream",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"WriteEventStream": {
							"type": "structure",
							"members": {
								"DestinationStreamArn": {},
								"RoleArn": {}
							},
							"required": [
								"RoleArn",
								"DestinationStreamArn"
							]
						}
					},
					"required": [
						"ApplicationId",
						"WriteEventStream"
					],
					"payload": "WriteEventStream"
				},
				"output": {
					"type": "structure",
					"members": {
						"EventStream": {
							"shape": "S38"
						}
					},
					"required": [
						"EventStream"
					],
					"payload": "EventStream"
				}
			},
			"PutEvents": {
				"http": {
					"requestUri": "/v1/apps/{application-id}/events",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"EventsRequest": {
							"type": "structure",
							"members": {
								"BatchItem": {
									"type": "map",
									"key": {},
									"value": {
										"type": "structure",
										"members": {
											"Endpoint": {
												"type": "structure",
												"members": {
													"Address": {},
													"Attributes": {
														"shape": "S30"
													},
													"ChannelType": {},
													"Demographic": {
														"shape": "S32"
													},
													"EffectiveDate": {},
													"EndpointStatus": {},
													"Location": {
														"shape": "S33"
													},
													"Metrics": {
														"shape": "S34"
													},
													"OptOut": {},
													"RequestId": {},
													"User": {
														"shape": "S35"
													}
												}
											},
											"Events": {
												"type": "map",
												"key": {},
												"value": {
													"type": "structure",
													"members": {
														"AppPackageName": {},
														"AppTitle": {},
														"AppVersionCode": {},
														"Attributes": {
															"shape": "S4"
														},
														"ClientSdkVersion": {},
														"EventType": {},
														"Metrics": {
															"shape": "S34"
														},
														"SdkName": {},
														"Session": {
															"type": "structure",
															"members": {
																"Duration": {
																	"type": "integer"
																},
																"Id": {},
																"StartTimestamp": {},
																"StopTimestamp": {}
															},
															"required": [
																"StartTimestamp",
																"Id"
															]
														},
														"Timestamp": {}
													},
													"required": [
														"EventType",
														"Timestamp"
													]
												}
											}
										},
										"required": [
											"Endpoint",
											"Events"
										]
									}
								}
							},
							"required": [
								"BatchItem"
							]
						}
					},
					"required": [
						"ApplicationId",
						"EventsRequest"
					],
					"payload": "EventsRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"EventsResponse": {
							"type": "structure",
							"members": {
								"Results": {
									"type": "map",
									"key": {},
									"value": {
										"type": "structure",
										"members": {
											"EndpointItemResponse": {
												"type": "structure",
												"members": {
													"Message": {},
													"StatusCode": {
														"type": "integer"
													}
												}
											},
											"EventsItemResponse": {
												"type": "map",
												"key": {},
												"value": {
													"type": "structure",
													"members": {
														"Message": {},
														"StatusCode": {
															"type": "integer"
														}
													}
												}
											}
										}
									}
								}
							}
						}
					},
					"required": [
						"EventsResponse"
					],
					"payload": "EventsResponse"
				}
			},
			"RemoveAttributes": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/apps/{application-id}/attributes/{attribute-type}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"AttributeType": {
							"location": "uri",
							"locationName": "attribute-type"
						},
						"UpdateAttributesRequest": {
							"type": "structure",
							"members": {
								"Blacklist": {
									"shape": "Sp"
								}
							}
						}
					},
					"required": [
						"AttributeType",
						"ApplicationId",
						"UpdateAttributesRequest"
					],
					"payload": "UpdateAttributesRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"AttributesResource": {
							"type": "structure",
							"members": {
								"ApplicationId": {},
								"AttributeType": {},
								"Attributes": {
									"shape": "Sp"
								}
							},
							"required": [
								"AttributeType",
								"ApplicationId"
							]
						}
					},
					"required": [
						"AttributesResource"
					],
					"payload": "AttributesResource"
				}
			},
			"SendMessages": {
				"http": {
					"requestUri": "/v1/apps/{application-id}/messages",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"MessageRequest": {
							"type": "structure",
							"members": {
								"Addresses": {
									"type": "map",
									"key": {},
									"value": {
										"type": "structure",
										"members": {
											"BodyOverride": {},
											"ChannelType": {},
											"Context": {
												"shape": "S4"
											},
											"RawContent": {},
											"Substitutions": {
												"shape": "S30"
											},
											"TitleOverride": {}
										}
									}
								},
								"Context": {
									"shape": "S4"
								},
								"Endpoints": {
									"shape": "S76"
								},
								"MessageConfiguration": {
									"shape": "S78"
								},
								"TraceId": {}
							},
							"required": [
								"MessageConfiguration"
							]
						}
					},
					"required": [
						"ApplicationId",
						"MessageRequest"
					],
					"payload": "MessageRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"MessageResponse": {
							"type": "structure",
							"members": {
								"ApplicationId": {},
								"EndpointResult": {
									"shape": "S7o"
								},
								"RequestId": {},
								"Result": {
									"type": "map",
									"key": {},
									"value": {
										"type": "structure",
										"members": {
											"DeliveryStatus": {},
											"MessageId": {},
											"StatusCode": {
												"type": "integer"
											},
											"StatusMessage": {},
											"UpdatedToken": {}
										},
										"required": [
											"DeliveryStatus",
											"StatusCode"
										]
									}
								}
							},
							"required": [
								"ApplicationId"
							]
						}
					},
					"required": [
						"MessageResponse"
					],
					"payload": "MessageResponse"
				}
			},
			"SendUsersMessages": {
				"http": {
					"requestUri": "/v1/apps/{application-id}/users-messages",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"SendUsersMessageRequest": {
							"type": "structure",
							"members": {
								"Context": {
									"shape": "S4"
								},
								"MessageConfiguration": {
									"shape": "S78"
								},
								"TraceId": {},
								"Users": {
									"shape": "S76"
								}
							},
							"required": [
								"MessageConfiguration",
								"Users"
							]
						}
					},
					"required": [
						"ApplicationId",
						"SendUsersMessageRequest"
					],
					"payload": "SendUsersMessageRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"SendUsersMessageResponse": {
							"type": "structure",
							"members": {
								"ApplicationId": {},
								"RequestId": {},
								"Result": {
									"type": "map",
									"key": {},
									"value": {
										"shape": "S7o"
									}
								}
							},
							"required": [
								"ApplicationId"
							]
						}
					},
					"required": [
						"SendUsersMessageResponse"
					],
					"payload": "SendUsersMessageResponse"
				}
			},
			"TagResource": {
				"http": {
					"requestUri": "/v1/tags/{resource-arn}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"members": {
						"ResourceArn": {
							"location": "uri",
							"locationName": "resource-arn"
						},
						"TagsModel": {
							"shape": "S6b"
						}
					},
					"required": [
						"ResourceArn",
						"TagsModel"
					],
					"payload": "TagsModel"
				}
			},
			"UntagResource": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/tags/{resource-arn}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"members": {
						"ResourceArn": {
							"location": "uri",
							"locationName": "resource-arn"
						},
						"TagKeys": {
							"shape": "Sp",
							"location": "querystring",
							"locationName": "tagKeys"
						}
					},
					"required": [
						"TagKeys",
						"ResourceArn"
					]
				}
			},
			"UpdateAdmChannel": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/apps/{application-id}/channels/adm",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ADMChannelRequest": {
							"type": "structure",
							"members": {
								"ClientId": {},
								"ClientSecret": {},
								"Enabled": {
									"type": "boolean"
								}
							},
							"required": [
								"ClientSecret",
								"ClientId"
							]
						},
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId",
						"ADMChannelRequest"
					],
					"payload": "ADMChannelRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"ADMChannelResponse": {
							"shape": "S2a"
						}
					},
					"required": [
						"ADMChannelResponse"
					],
					"payload": "ADMChannelResponse"
				}
			},
			"UpdateApnsChannel": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/apps/{application-id}/channels/apns",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"APNSChannelRequest": {
							"type": "structure",
							"members": {
								"BundleId": {},
								"Certificate": {},
								"DefaultAuthenticationMethod": {},
								"Enabled": {
									"type": "boolean"
								},
								"PrivateKey": {},
								"TeamId": {},
								"TokenKey": {},
								"TokenKeyId": {}
							}
						},
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId",
						"APNSChannelRequest"
					],
					"payload": "APNSChannelRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"APNSChannelResponse": {
							"shape": "S2d"
						}
					},
					"required": [
						"APNSChannelResponse"
					],
					"payload": "APNSChannelResponse"
				}
			},
			"UpdateApnsSandboxChannel": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/apps/{application-id}/channels/apns_sandbox",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"APNSSandboxChannelRequest": {
							"type": "structure",
							"members": {
								"BundleId": {},
								"Certificate": {},
								"DefaultAuthenticationMethod": {},
								"Enabled": {
									"type": "boolean"
								},
								"PrivateKey": {},
								"TeamId": {},
								"TokenKey": {},
								"TokenKeyId": {}
							}
						},
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId",
						"APNSSandboxChannelRequest"
					],
					"payload": "APNSSandboxChannelRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"APNSSandboxChannelResponse": {
							"shape": "S2g"
						}
					},
					"required": [
						"APNSSandboxChannelResponse"
					],
					"payload": "APNSSandboxChannelResponse"
				}
			},
			"UpdateApnsVoipChannel": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/apps/{application-id}/channels/apns_voip",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"APNSVoipChannelRequest": {
							"type": "structure",
							"members": {
								"BundleId": {},
								"Certificate": {},
								"DefaultAuthenticationMethod": {},
								"Enabled": {
									"type": "boolean"
								},
								"PrivateKey": {},
								"TeamId": {},
								"TokenKey": {},
								"TokenKeyId": {}
							}
						},
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId",
						"APNSVoipChannelRequest"
					],
					"payload": "APNSVoipChannelRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"APNSVoipChannelResponse": {
							"shape": "S2j"
						}
					},
					"required": [
						"APNSVoipChannelResponse"
					],
					"payload": "APNSVoipChannelResponse"
				}
			},
			"UpdateApnsVoipSandboxChannel": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/apps/{application-id}/channels/apns_voip_sandbox",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"APNSVoipSandboxChannelRequest": {
							"type": "structure",
							"members": {
								"BundleId": {},
								"Certificate": {},
								"DefaultAuthenticationMethod": {},
								"Enabled": {
									"type": "boolean"
								},
								"PrivateKey": {},
								"TeamId": {},
								"TokenKey": {},
								"TokenKeyId": {}
							}
						},
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						}
					},
					"required": [
						"ApplicationId",
						"APNSVoipSandboxChannelRequest"
					],
					"payload": "APNSVoipSandboxChannelRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"APNSVoipSandboxChannelResponse": {
							"shape": "S2m"
						}
					},
					"required": [
						"APNSVoipSandboxChannelResponse"
					],
					"payload": "APNSVoipSandboxChannelResponse"
				}
			},
			"UpdateApplicationSettings": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/apps/{application-id}/settings",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"WriteApplicationSettingsRequest": {
							"type": "structure",
							"members": {
								"CampaignHook": {
									"shape": "Sy"
								},
								"CloudWatchMetricsEnabled": {
									"type": "boolean"
								},
								"Limits": {
									"shape": "S10"
								},
								"QuietTime": {
									"shape": "Sx"
								}
							}
						}
					},
					"required": [
						"ApplicationId",
						"WriteApplicationSettingsRequest"
					],
					"payload": "WriteApplicationSettingsRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"ApplicationSettingsResource": {
							"shape": "S4b"
						}
					},
					"required": [
						"ApplicationSettingsResource"
					],
					"payload": "ApplicationSettingsResource"
				}
			},
			"UpdateBaiduChannel": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/apps/{application-id}/channels/baidu",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"BaiduChannelRequest": {
							"type": "structure",
							"members": {
								"ApiKey": {},
								"Enabled": {
									"type": "boolean"
								},
								"SecretKey": {}
							},
							"required": [
								"SecretKey",
								"ApiKey"
							]
						}
					},
					"required": [
						"ApplicationId",
						"BaiduChannelRequest"
					],
					"payload": "BaiduChannelRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"BaiduChannelResponse": {
							"shape": "S2r"
						}
					},
					"required": [
						"BaiduChannelResponse"
					],
					"payload": "BaiduChannelResponse"
				}
			},
			"UpdateCampaign": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/apps/{application-id}/campaigns/{campaign-id}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"CampaignId": {
							"location": "uri",
							"locationName": "campaign-id"
						},
						"WriteCampaignRequest": {
							"shape": "S8"
						}
					},
					"required": [
						"CampaignId",
						"ApplicationId",
						"WriteCampaignRequest"
					],
					"payload": "WriteCampaignRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"CampaignResponse": {
							"shape": "S12"
						}
					},
					"required": [
						"CampaignResponse"
					],
					"payload": "CampaignResponse"
				}
			},
			"UpdateEmailChannel": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/apps/{application-id}/channels/email",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"EmailChannelRequest": {
							"type": "structure",
							"members": {
								"ConfigurationSet": {},
								"Enabled": {
									"type": "boolean"
								},
								"FromAddress": {},
								"Identity": {},
								"RoleArn": {}
							},
							"required": [
								"FromAddress",
								"Identity"
							]
						}
					},
					"required": [
						"ApplicationId",
						"EmailChannelRequest"
					],
					"payload": "EmailChannelRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"EmailChannelResponse": {
							"shape": "S2w"
						}
					},
					"required": [
						"EmailChannelResponse"
					],
					"payload": "EmailChannelResponse"
				}
			},
			"UpdateEndpoint": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/apps/{application-id}/endpoints/{endpoint-id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"EndpointId": {
							"location": "uri",
							"locationName": "endpoint-id"
						},
						"EndpointRequest": {
							"type": "structure",
							"members": {
								"Address": {},
								"Attributes": {
									"shape": "S30"
								},
								"ChannelType": {},
								"Demographic": {
									"shape": "S32"
								},
								"EffectiveDate": {},
								"EndpointStatus": {},
								"Location": {
									"shape": "S33"
								},
								"Metrics": {
									"shape": "S34"
								},
								"OptOut": {},
								"RequestId": {},
								"User": {
									"shape": "S35"
								}
							}
						}
					},
					"required": [
						"ApplicationId",
						"EndpointId",
						"EndpointRequest"
					],
					"payload": "EndpointRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"MessageBody": {
							"shape": "S8t"
						}
					},
					"required": [
						"MessageBody"
					],
					"payload": "MessageBody"
				}
			},
			"UpdateEndpointsBatch": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/apps/{application-id}/endpoints",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"EndpointBatchRequest": {
							"type": "structure",
							"members": {
								"Item": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Address": {},
											"Attributes": {
												"shape": "S30"
											},
											"ChannelType": {},
											"Demographic": {
												"shape": "S32"
											},
											"EffectiveDate": {},
											"EndpointStatus": {},
											"Id": {},
											"Location": {
												"shape": "S33"
											},
											"Metrics": {
												"shape": "S34"
											},
											"OptOut": {},
											"RequestId": {},
											"User": {
												"shape": "S35"
											}
										}
									}
								}
							},
							"required": [
								"Item"
							]
						}
					},
					"required": [
						"ApplicationId",
						"EndpointBatchRequest"
					],
					"payload": "EndpointBatchRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"MessageBody": {
							"shape": "S8t"
						}
					},
					"required": [
						"MessageBody"
					],
					"payload": "MessageBody"
				}
			},
			"UpdateGcmChannel": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/apps/{application-id}/channels/gcm",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"GCMChannelRequest": {
							"type": "structure",
							"members": {
								"ApiKey": {},
								"Enabled": {
									"type": "boolean"
								}
							},
							"required": [
								"ApiKey"
							]
						}
					},
					"required": [
						"ApplicationId",
						"GCMChannelRequest"
					],
					"payload": "GCMChannelRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"GCMChannelResponse": {
							"shape": "S3b"
						}
					},
					"required": [
						"GCMChannelResponse"
					],
					"payload": "GCMChannelResponse"
				}
			},
			"UpdateSegment": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/apps/{application-id}/segments/{segment-id}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"SegmentId": {
							"location": "uri",
							"locationName": "segment-id"
						},
						"WriteSegmentRequest": {
							"shape": "S1k"
						}
					},
					"required": [
						"SegmentId",
						"ApplicationId",
						"WriteSegmentRequest"
					],
					"payload": "WriteSegmentRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"SegmentResponse": {
							"shape": "S24"
						}
					},
					"required": [
						"SegmentResponse"
					],
					"payload": "SegmentResponse"
				}
			},
			"UpdateSmsChannel": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/apps/{application-id}/channels/sms",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"SMSChannelRequest": {
							"type": "structure",
							"members": {
								"Enabled": {
									"type": "boolean"
								},
								"SenderId": {},
								"ShortCode": {}
							}
						}
					},
					"required": [
						"ApplicationId",
						"SMSChannelRequest"
					],
					"payload": "SMSChannelRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"SMSChannelResponse": {
							"shape": "S3g"
						}
					},
					"required": [
						"SMSChannelResponse"
					],
					"payload": "SMSChannelResponse"
				}
			},
			"UpdateVoiceChannel": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/apps/{application-id}/channels/voice",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"ApplicationId": {
							"location": "uri",
							"locationName": "application-id"
						},
						"VoiceChannelRequest": {
							"type": "structure",
							"members": {
								"Enabled": {
									"type": "boolean"
								}
							}
						}
					},
					"required": [
						"ApplicationId",
						"VoiceChannelRequest"
					],
					"payload": "VoiceChannelRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"VoiceChannelResponse": {
							"shape": "S3n"
						}
					},
					"required": [
						"VoiceChannelResponse"
					],
					"payload": "VoiceChannelResponse"
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S6": {
				"type": "structure",
				"members": {
					"Arn": {},
					"Id": {},
					"Name": {},
					"tags": {
						"shape": "S4",
						"locationName": "tags"
					}
				},
				"required": [
					"Id",
					"Arn",
					"Name"
				]
			},
			"S8": {
				"type": "structure",
				"members": {
					"AdditionalTreatments": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"MessageConfiguration": {
									"shape": "Sb"
								},
								"Schedule": {
									"shape": "Sj"
								},
								"SizePercent": {
									"type": "integer"
								},
								"TreatmentDescription": {},
								"TreatmentName": {}
							},
							"required": [
								"SizePercent"
							]
						}
					},
					"Description": {},
					"HoldoutPercent": {
						"type": "integer"
					},
					"Hook": {
						"shape": "Sy"
					},
					"IsPaused": {
						"type": "boolean"
					},
					"Limits": {
						"shape": "S10"
					},
					"MessageConfiguration": {
						"shape": "Sb"
					},
					"Name": {},
					"Schedule": {
						"shape": "Sj"
					},
					"SegmentId": {},
					"SegmentVersion": {
						"type": "integer"
					},
					"tags": {
						"shape": "S4",
						"locationName": "tags"
					},
					"TreatmentDescription": {},
					"TreatmentName": {}
				}
			},
			"Sb": {
				"type": "structure",
				"members": {
					"ADMMessage": {
						"shape": "Sc"
					},
					"APNSMessage": {
						"shape": "Sc"
					},
					"BaiduMessage": {
						"shape": "Sc"
					},
					"DefaultMessage": {
						"shape": "Sc"
					},
					"EmailMessage": {
						"type": "structure",
						"members": {
							"Body": {},
							"FromAddress": {},
							"HtmlBody": {},
							"Title": {}
						},
						"required": [
							"Title"
						]
					},
					"GCMMessage": {
						"shape": "Sc"
					},
					"SMSMessage": {
						"type": "structure",
						"members": {
							"Body": {},
							"MessageType": {},
							"SenderId": {}
						}
					}
				}
			},
			"Sc": {
				"type": "structure",
				"members": {
					"Action": {},
					"Body": {},
					"ImageIconUrl": {},
					"ImageSmallIconUrl": {},
					"ImageUrl": {},
					"JsonBody": {},
					"MediaUrl": {},
					"RawContent": {},
					"SilentPush": {
						"type": "boolean"
					},
					"TimeToLive": {
						"type": "integer"
					},
					"Title": {},
					"Url": {}
				}
			},
			"Sj": {
				"type": "structure",
				"members": {
					"EndTime": {},
					"EventFilter": {
						"type": "structure",
						"members": {
							"Dimensions": {
								"type": "structure",
								"members": {
									"Attributes": {
										"shape": "Sm"
									},
									"EventType": {
										"shape": "Sq"
									},
									"Metrics": {
										"shape": "Ss"
									}
								}
							},
							"FilterType": {}
						},
						"required": [
							"FilterType",
							"Dimensions"
						]
					},
					"Frequency": {},
					"IsLocalTime": {
						"type": "boolean"
					},
					"QuietTime": {
						"shape": "Sx"
					},
					"StartTime": {},
					"Timezone": {}
				},
				"required": [
					"StartTime"
				]
			},
			"Sm": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"members": {
						"AttributeType": {},
						"Values": {
							"shape": "Sp"
						}
					},
					"required": [
						"Values"
					]
				}
			},
			"Sp": {
				"type": "list",
				"member": {}
			},
			"Sq": {
				"type": "structure",
				"members": {
					"DimensionType": {},
					"Values": {
						"shape": "Sp"
					}
				},
				"required": [
					"Values"
				]
			},
			"Ss": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"members": {
						"ComparisonOperator": {},
						"Value": {
							"type": "double"
						}
					},
					"required": [
						"ComparisonOperator",
						"Value"
					]
				}
			},
			"Sx": {
				"type": "structure",
				"members": {
					"End": {},
					"Start": {}
				}
			},
			"Sy": {
				"type": "structure",
				"members": {
					"LambdaFunctionName": {},
					"Mode": {},
					"WebUrl": {}
				}
			},
			"S10": {
				"type": "structure",
				"members": {
					"Daily": {
						"type": "integer"
					},
					"MaximumDuration": {
						"type": "integer"
					},
					"MessagesPerSecond": {
						"type": "integer"
					},
					"Total": {
						"type": "integer"
					}
				}
			},
			"S12": {
				"type": "structure",
				"members": {
					"AdditionalTreatments": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"MessageConfiguration": {
									"shape": "Sb"
								},
								"Schedule": {
									"shape": "Sj"
								},
								"SizePercent": {
									"type": "integer"
								},
								"State": {
									"shape": "S15"
								},
								"TreatmentDescription": {},
								"TreatmentName": {}
							},
							"required": [
								"Id",
								"SizePercent"
							]
						}
					},
					"ApplicationId": {},
					"Arn": {},
					"CreationDate": {},
					"DefaultState": {
						"shape": "S15"
					},
					"Description": {},
					"HoldoutPercent": {
						"type": "integer"
					},
					"Hook": {
						"shape": "Sy"
					},
					"Id": {},
					"IsPaused": {
						"type": "boolean"
					},
					"LastModifiedDate": {},
					"Limits": {
						"shape": "S10"
					},
					"MessageConfiguration": {
						"shape": "Sb"
					},
					"Name": {},
					"Schedule": {
						"shape": "Sj"
					},
					"SegmentId": {},
					"SegmentVersion": {
						"type": "integer"
					},
					"State": {
						"shape": "S15"
					},
					"tags": {
						"shape": "S4",
						"locationName": "tags"
					},
					"TreatmentDescription": {},
					"TreatmentName": {},
					"Version": {
						"type": "integer"
					}
				},
				"required": [
					"LastModifiedDate",
					"CreationDate",
					"SegmentId",
					"SegmentVersion",
					"Id",
					"Arn",
					"ApplicationId"
				]
			},
			"S15": {
				"type": "structure",
				"members": {
					"CampaignStatus": {}
				}
			},
			"S1a": {
				"type": "structure",
				"members": {
					"ApplicationId": {},
					"CompletedPieces": {
						"type": "integer"
					},
					"CompletionDate": {},
					"CreationDate": {},
					"Definition": {
						"type": "structure",
						"members": {
							"RoleArn": {},
							"S3UrlPrefix": {},
							"SegmentId": {},
							"SegmentVersion": {
								"type": "integer"
							}
						},
						"required": [
							"S3UrlPrefix",
							"RoleArn"
						]
					},
					"FailedPieces": {
						"type": "integer"
					},
					"Failures": {
						"shape": "Sp"
					},
					"Id": {},
					"JobStatus": {},
					"TotalFailures": {
						"type": "integer"
					},
					"TotalPieces": {
						"type": "integer"
					},
					"TotalProcessed": {
						"type": "integer"
					},
					"Type": {}
				},
				"required": [
					"JobStatus",
					"CreationDate",
					"Type",
					"Definition",
					"Id",
					"ApplicationId"
				]
			},
			"S1h": {
				"type": "structure",
				"members": {
					"ApplicationId": {},
					"CompletedPieces": {
						"type": "integer"
					},
					"CompletionDate": {},
					"CreationDate": {},
					"Definition": {
						"type": "structure",
						"members": {
							"DefineSegment": {
								"type": "boolean"
							},
							"ExternalId": {},
							"Format": {},
							"RegisterEndpoints": {
								"type": "boolean"
							},
							"RoleArn": {},
							"S3Url": {},
							"SegmentId": {},
							"SegmentName": {}
						},
						"required": [
							"Format",
							"S3Url",
							"RoleArn"
						]
					},
					"FailedPieces": {
						"type": "integer"
					},
					"Failures": {
						"shape": "Sp"
					},
					"Id": {},
					"JobStatus": {},
					"TotalFailures": {
						"type": "integer"
					},
					"TotalPieces": {
						"type": "integer"
					},
					"TotalProcessed": {
						"type": "integer"
					},
					"Type": {}
				},
				"required": [
					"JobStatus",
					"CreationDate",
					"Type",
					"Definition",
					"Id",
					"ApplicationId"
				]
			},
			"S1k": {
				"type": "structure",
				"members": {
					"Dimensions": {
						"shape": "S1l"
					},
					"Name": {},
					"SegmentGroups": {
						"shape": "S1u"
					},
					"tags": {
						"shape": "S4",
						"locationName": "tags"
					}
				}
			},
			"S1l": {
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "Sm"
					},
					"Behavior": {
						"type": "structure",
						"members": {
							"Recency": {
								"type": "structure",
								"members": {
									"Duration": {},
									"RecencyType": {}
								},
								"required": [
									"Duration",
									"RecencyType"
								]
							}
						}
					},
					"Demographic": {
						"type": "structure",
						"members": {
							"AppVersion": {
								"shape": "Sq"
							},
							"Channel": {
								"shape": "Sq"
							},
							"DeviceType": {
								"shape": "Sq"
							},
							"Make": {
								"shape": "Sq"
							},
							"Model": {
								"shape": "Sq"
							},
							"Platform": {
								"shape": "Sq"
							}
						}
					},
					"Location": {
						"type": "structure",
						"members": {
							"Country": {
								"shape": "Sq"
							},
							"GPSPoint": {
								"type": "structure",
								"members": {
									"Coordinates": {
										"type": "structure",
										"members": {
											"Latitude": {
												"type": "double"
											},
											"Longitude": {
												"type": "double"
											}
										},
										"required": [
											"Latitude",
											"Longitude"
										]
									},
									"RangeInKilometers": {
										"type": "double"
									}
								},
								"required": [
									"Coordinates"
								]
							}
						}
					},
					"Metrics": {
						"shape": "Ss"
					},
					"UserAttributes": {
						"shape": "Sm"
					}
				}
			},
			"S1u": {
				"type": "structure",
				"members": {
					"Groups": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Dimensions": {
									"type": "list",
									"member": {
										"shape": "S1l"
									}
								},
								"SourceSegments": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Id": {},
											"Version": {
												"type": "integer"
											}
										},
										"required": [
											"Id"
										]
									}
								},
								"SourceType": {},
								"Type": {}
							}
						}
					},
					"Include": {}
				}
			},
			"S24": {
				"type": "structure",
				"members": {
					"ApplicationId": {},
					"Arn": {},
					"CreationDate": {},
					"Dimensions": {
						"shape": "S1l"
					},
					"Id": {},
					"ImportDefinition": {
						"type": "structure",
						"members": {
							"ChannelCounts": {
								"type": "map",
								"key": {},
								"value": {
									"type": "integer"
								}
							},
							"ExternalId": {},
							"Format": {},
							"RoleArn": {},
							"S3Url": {},
							"Size": {
								"type": "integer"
							}
						},
						"required": [
							"Format",
							"S3Url",
							"Size",
							"ExternalId",
							"RoleArn"
						]
					},
					"LastModifiedDate": {},
					"Name": {},
					"SegmentGroups": {
						"shape": "S1u"
					},
					"SegmentType": {},
					"tags": {
						"shape": "S4",
						"locationName": "tags"
					},
					"Version": {
						"type": "integer"
					}
				},
				"required": [
					"SegmentType",
					"CreationDate",
					"Id",
					"Arn",
					"ApplicationId"
				]
			},
			"S2a": {
				"type": "structure",
				"members": {
					"ApplicationId": {},
					"CreationDate": {},
					"Enabled": {
						"type": "boolean"
					},
					"HasCredential": {
						"type": "boolean"
					},
					"Id": {},
					"IsArchived": {
						"type": "boolean"
					},
					"LastModifiedBy": {},
					"LastModifiedDate": {},
					"Platform": {},
					"Version": {
						"type": "integer"
					}
				},
				"required": [
					"Platform"
				]
			},
			"S2d": {
				"type": "structure",
				"members": {
					"ApplicationId": {},
					"CreationDate": {},
					"DefaultAuthenticationMethod": {},
					"Enabled": {
						"type": "boolean"
					},
					"HasCredential": {
						"type": "boolean"
					},
					"HasTokenKey": {
						"type": "boolean"
					},
					"Id": {},
					"IsArchived": {
						"type": "boolean"
					},
					"LastModifiedBy": {},
					"LastModifiedDate": {},
					"Platform": {},
					"Version": {
						"type": "integer"
					}
				},
				"required": [
					"Platform"
				]
			},
			"S2g": {
				"type": "structure",
				"members": {
					"ApplicationId": {},
					"CreationDate": {},
					"DefaultAuthenticationMethod": {},
					"Enabled": {
						"type": "boolean"
					},
					"HasCredential": {
						"type": "boolean"
					},
					"HasTokenKey": {
						"type": "boolean"
					},
					"Id": {},
					"IsArchived": {
						"type": "boolean"
					},
					"LastModifiedBy": {},
					"LastModifiedDate": {},
					"Platform": {},
					"Version": {
						"type": "integer"
					}
				},
				"required": [
					"Platform"
				]
			},
			"S2j": {
				"type": "structure",
				"members": {
					"ApplicationId": {},
					"CreationDate": {},
					"DefaultAuthenticationMethod": {},
					"Enabled": {
						"type": "boolean"
					},
					"HasCredential": {
						"type": "boolean"
					},
					"HasTokenKey": {
						"type": "boolean"
					},
					"Id": {},
					"IsArchived": {
						"type": "boolean"
					},
					"LastModifiedBy": {},
					"LastModifiedDate": {},
					"Platform": {},
					"Version": {
						"type": "integer"
					}
				},
				"required": [
					"Platform"
				]
			},
			"S2m": {
				"type": "structure",
				"members": {
					"ApplicationId": {},
					"CreationDate": {},
					"DefaultAuthenticationMethod": {},
					"Enabled": {
						"type": "boolean"
					},
					"HasCredential": {
						"type": "boolean"
					},
					"HasTokenKey": {
						"type": "boolean"
					},
					"Id": {},
					"IsArchived": {
						"type": "boolean"
					},
					"LastModifiedBy": {},
					"LastModifiedDate": {},
					"Platform": {},
					"Version": {
						"type": "integer"
					}
				},
				"required": [
					"Platform"
				]
			},
			"S2r": {
				"type": "structure",
				"members": {
					"ApplicationId": {},
					"CreationDate": {},
					"Credential": {},
					"Enabled": {
						"type": "boolean"
					},
					"HasCredential": {
						"type": "boolean"
					},
					"Id": {},
					"IsArchived": {
						"type": "boolean"
					},
					"LastModifiedBy": {},
					"LastModifiedDate": {},
					"Platform": {},
					"Version": {
						"type": "integer"
					}
				},
				"required": [
					"Credential",
					"Platform"
				]
			},
			"S2w": {
				"type": "structure",
				"members": {
					"ApplicationId": {},
					"ConfigurationSet": {},
					"CreationDate": {},
					"Enabled": {
						"type": "boolean"
					},
					"FromAddress": {},
					"HasCredential": {
						"type": "boolean"
					},
					"Id": {},
					"Identity": {},
					"IsArchived": {
						"type": "boolean"
					},
					"LastModifiedBy": {},
					"LastModifiedDate": {},
					"MessagesPerSecond": {
						"type": "integer"
					},
					"Platform": {},
					"RoleArn": {},
					"Version": {
						"type": "integer"
					}
				},
				"required": [
					"Platform"
				]
			},
			"S2z": {
				"type": "structure",
				"members": {
					"Address": {},
					"ApplicationId": {},
					"Attributes": {
						"shape": "S30"
					},
					"ChannelType": {},
					"CohortId": {},
					"CreationDate": {},
					"Demographic": {
						"shape": "S32"
					},
					"EffectiveDate": {},
					"EndpointStatus": {},
					"Id": {},
					"Location": {
						"shape": "S33"
					},
					"Metrics": {
						"shape": "S34"
					},
					"OptOut": {},
					"RequestId": {},
					"User": {
						"shape": "S35"
					}
				}
			},
			"S30": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "Sp"
				}
			},
			"S32": {
				"type": "structure",
				"members": {
					"AppVersion": {},
					"Locale": {},
					"Make": {},
					"Model": {},
					"ModelVersion": {},
					"Platform": {},
					"PlatformVersion": {},
					"Timezone": {}
				}
			},
			"S33": {
				"type": "structure",
				"members": {
					"City": {},
					"Country": {},
					"Latitude": {
						"type": "double"
					},
					"Longitude": {
						"type": "double"
					},
					"PostalCode": {},
					"Region": {}
				}
			},
			"S34": {
				"type": "map",
				"key": {},
				"value": {
					"type": "double"
				}
			},
			"S35": {
				"type": "structure",
				"members": {
					"UserAttributes": {
						"shape": "S30"
					},
					"UserId": {}
				}
			},
			"S38": {
				"type": "structure",
				"members": {
					"ApplicationId": {},
					"DestinationStreamArn": {},
					"ExternalId": {},
					"LastModifiedDate": {},
					"LastUpdatedBy": {},
					"RoleArn": {}
				},
				"required": [
					"ApplicationId",
					"RoleArn",
					"DestinationStreamArn"
				]
			},
			"S3b": {
				"type": "structure",
				"members": {
					"ApplicationId": {},
					"CreationDate": {},
					"Credential": {},
					"Enabled": {
						"type": "boolean"
					},
					"HasCredential": {
						"type": "boolean"
					},
					"Id": {},
					"IsArchived": {
						"type": "boolean"
					},
					"LastModifiedBy": {},
					"LastModifiedDate": {},
					"Platform": {},
					"Version": {
						"type": "integer"
					}
				},
				"required": [
					"Credential",
					"Platform"
				]
			},
			"S3g": {
				"type": "structure",
				"members": {
					"ApplicationId": {},
					"CreationDate": {},
					"Enabled": {
						"type": "boolean"
					},
					"HasCredential": {
						"type": "boolean"
					},
					"Id": {},
					"IsArchived": {
						"type": "boolean"
					},
					"LastModifiedBy": {},
					"LastModifiedDate": {},
					"Platform": {},
					"PromotionalMessagesPerSecond": {
						"type": "integer"
					},
					"SenderId": {},
					"ShortCode": {},
					"TransactionalMessagesPerSecond": {
						"type": "integer"
					},
					"Version": {
						"type": "integer"
					}
				},
				"required": [
					"Platform"
				]
			},
			"S3j": {
				"type": "structure",
				"members": {
					"Item": {
						"type": "list",
						"member": {
							"shape": "S2z"
						}
					}
				},
				"required": [
					"Item"
				]
			},
			"S3n": {
				"type": "structure",
				"members": {
					"ApplicationId": {},
					"CreationDate": {},
					"Enabled": {
						"type": "boolean"
					},
					"HasCredential": {
						"type": "boolean"
					},
					"Id": {},
					"IsArchived": {
						"type": "boolean"
					},
					"LastModifiedBy": {},
					"LastModifiedDate": {},
					"Platform": {},
					"Version": {
						"type": "integer"
					}
				},
				"required": [
					"Platform"
				]
			},
			"S41": {
				"type": "timestamp",
				"timestampFormat": "iso8601"
			},
			"S44": {
				"type": "structure",
				"members": {
					"Rows": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"GroupedBys": {
									"shape": "S47"
								},
								"Values": {
									"shape": "S47"
								}
							},
							"required": [
								"GroupedBys",
								"Values"
							]
						}
					}
				},
				"required": [
					"Rows"
				]
			},
			"S47": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Type": {},
						"Value": {}
					},
					"required": [
						"Type",
						"Value",
						"Key"
					]
				}
			},
			"S4b": {
				"type": "structure",
				"members": {
					"ApplicationId": {},
					"CampaignHook": {
						"shape": "Sy"
					},
					"LastModifiedDate": {},
					"Limits": {
						"shape": "S10"
					},
					"QuietTime": {
						"shape": "Sx"
					}
				},
				"required": [
					"ApplicationId"
				]
			},
			"S4w": {
				"type": "structure",
				"members": {
					"Item": {
						"type": "list",
						"member": {
							"shape": "S12"
						}
					},
					"NextToken": {}
				},
				"required": [
					"Item"
				]
			},
			"S5f": {
				"type": "structure",
				"members": {
					"Item": {
						"type": "list",
						"member": {
							"shape": "S1a"
						}
					},
					"NextToken": {}
				},
				"required": [
					"Item"
				]
			},
			"S5n": {
				"type": "structure",
				"members": {
					"Item": {
						"type": "list",
						"member": {
							"shape": "S1h"
						}
					},
					"NextToken": {}
				},
				"required": [
					"Item"
				]
			},
			"S5z": {
				"type": "structure",
				"members": {
					"Item": {
						"type": "list",
						"member": {
							"shape": "S24"
						}
					},
					"NextToken": {}
				},
				"required": [
					"Item"
				]
			},
			"S6b": {
				"type": "structure",
				"members": {
					"tags": {
						"shape": "S4",
						"locationName": "tags"
					}
				},
				"required": [
					"tags"
				]
			},
			"S76": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"members": {
						"BodyOverride": {},
						"Context": {
							"shape": "S4"
						},
						"RawContent": {},
						"Substitutions": {
							"shape": "S30"
						},
						"TitleOverride": {}
					}
				}
			},
			"S78": {
				"type": "structure",
				"members": {
					"ADMMessage": {
						"type": "structure",
						"members": {
							"Action": {},
							"Body": {},
							"ConsolidationKey": {},
							"Data": {
								"shape": "S4"
							},
							"ExpiresAfter": {},
							"IconReference": {},
							"ImageIconUrl": {},
							"ImageUrl": {},
							"MD5": {},
							"RawContent": {},
							"SilentPush": {
								"type": "boolean"
							},
							"SmallImageIconUrl": {},
							"Sound": {},
							"Substitutions": {
								"shape": "S30"
							},
							"Title": {},
							"Url": {}
						}
					},
					"APNSMessage": {
						"type": "structure",
						"members": {
							"Action": {},
							"Badge": {
								"type": "integer"
							},
							"Body": {},
							"Category": {},
							"CollapseId": {},
							"Data": {
								"shape": "S4"
							},
							"MediaUrl": {},
							"PreferredAuthenticationMethod": {},
							"Priority": {},
							"RawContent": {},
							"SilentPush": {
								"type": "boolean"
							},
							"Sound": {},
							"Substitutions": {
								"shape": "S30"
							},
							"ThreadId": {},
							"TimeToLive": {
								"type": "integer"
							},
							"Title": {},
							"Url": {}
						}
					},
					"BaiduMessage": {
						"type": "structure",
						"members": {
							"Action": {},
							"Body": {},
							"Data": {
								"shape": "S4"
							},
							"IconReference": {},
							"ImageIconUrl": {},
							"ImageUrl": {},
							"RawContent": {},
							"SilentPush": {
								"type": "boolean"
							},
							"SmallImageIconUrl": {},
							"Sound": {},
							"Substitutions": {
								"shape": "S30"
							},
							"TimeToLive": {
								"type": "integer"
							},
							"Title": {},
							"Url": {}
						}
					},
					"DefaultMessage": {
						"type": "structure",
						"members": {
							"Body": {},
							"Substitutions": {
								"shape": "S30"
							}
						}
					},
					"DefaultPushNotificationMessage": {
						"type": "structure",
						"members": {
							"Action": {},
							"Body": {},
							"Data": {
								"shape": "S4"
							},
							"SilentPush": {
								"type": "boolean"
							},
							"Substitutions": {
								"shape": "S30"
							},
							"Title": {},
							"Url": {}
						}
					},
					"EmailMessage": {
						"type": "structure",
						"members": {
							"Body": {},
							"FeedbackForwardingAddress": {},
							"FromAddress": {},
							"RawEmail": {
								"type": "structure",
								"members": {
									"Data": {
										"type": "blob"
									}
								}
							},
							"ReplyToAddresses": {
								"shape": "Sp"
							},
							"SimpleEmail": {
								"type": "structure",
								"members": {
									"HtmlPart": {
										"shape": "S7i"
									},
									"Subject": {
										"shape": "S7i"
									},
									"TextPart": {
										"shape": "S7i"
									}
								}
							},
							"Substitutions": {
								"shape": "S30"
							}
						}
					},
					"GCMMessage": {
						"type": "structure",
						"members": {
							"Action": {},
							"Body": {},
							"CollapseKey": {},
							"Data": {
								"shape": "S4"
							},
							"IconReference": {},
							"ImageIconUrl": {},
							"ImageUrl": {},
							"Priority": {},
							"RawContent": {},
							"RestrictedPackageName": {},
							"SilentPush": {
								"type": "boolean"
							},
							"SmallImageIconUrl": {},
							"Sound": {},
							"Substitutions": {
								"shape": "S30"
							},
							"TimeToLive": {
								"type": "integer"
							},
							"Title": {},
							"Url": {}
						}
					},
					"SMSMessage": {
						"type": "structure",
						"members": {
							"Body": {},
							"Keyword": {},
							"MessageType": {},
							"OriginationNumber": {},
							"SenderId": {},
							"Substitutions": {
								"shape": "S30"
							}
						}
					},
					"VoiceMessage": {
						"type": "structure",
						"members": {
							"Body": {},
							"LanguageCode": {},
							"OriginationNumber": {},
							"Substitutions": {
								"shape": "S30"
							},
							"VoiceId": {}
						}
					}
				}
			},
			"S7i": {
				"type": "structure",
				"members": {
					"Charset": {},
					"Data": {}
				}
			},
			"S7o": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"members": {
						"Address": {},
						"DeliveryStatus": {},
						"MessageId": {},
						"StatusCode": {
							"type": "integer"
						},
						"StatusMessage": {},
						"UpdatedToken": {}
					},
					"required": [
						"DeliveryStatus",
						"StatusCode"
					]
				}
			},
			"S8t": {
				"type": "structure",
				"members": {
					"Message": {},
					"RequestID": {}
				}
			}
		}
	};

/***/ },
/* 492 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-11-28",
			"endpointPrefix": "runtime.lex",
			"jsonVersion": "1.1",
			"protocol": "rest-json",
			"serviceFullName": "Amazon Lex Runtime Service",
			"serviceId": "Lex Runtime Service",
			"signatureVersion": "v4",
			"signingName": "lex",
			"uid": "runtime.lex-2016-11-28"
		},
		"operations": {
			"DeleteSession": {
				"http": {
					"method": "DELETE",
					"requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/session"
				},
				"input": {
					"type": "structure",
					"required": [
						"botName",
						"botAlias",
						"userId"
					],
					"members": {
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"botAlias": {
							"location": "uri",
							"locationName": "botAlias"
						},
						"userId": {
							"location": "uri",
							"locationName": "userId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"botName": {},
						"botAlias": {},
						"userId": {},
						"sessionId": {}
					}
				}
			},
			"GetSession": {
				"http": {
					"method": "GET",
					"requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/session"
				},
				"input": {
					"type": "structure",
					"required": [
						"botName",
						"botAlias",
						"userId"
					],
					"members": {
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"botAlias": {
							"location": "uri",
							"locationName": "botAlias"
						},
						"userId": {
							"location": "uri",
							"locationName": "userId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"recentIntentSummaryView": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"dialogActionType"
								],
								"members": {
									"intentName": {},
									"slots": {
										"shape": "Sc"
									},
									"confirmationStatus": {},
									"dialogActionType": {},
									"fulfillmentState": {},
									"slotToElicit": {}
								}
							}
						},
						"sessionAttributes": {
							"shape": "Sc"
						},
						"sessionId": {},
						"dialogAction": {
							"shape": "Sg"
						}
					}
				}
			},
			"PostContent": {
				"http": {
					"requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/content"
				},
				"input": {
					"type": "structure",
					"required": [
						"botName",
						"botAlias",
						"userId",
						"contentType",
						"inputStream"
					],
					"members": {
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"botAlias": {
							"location": "uri",
							"locationName": "botAlias"
						},
						"userId": {
							"location": "uri",
							"locationName": "userId"
						},
						"sessionAttributes": {
							"shape": "Sk",
							"jsonvalue": true,
							"location": "header",
							"locationName": "x-amz-lex-session-attributes"
						},
						"requestAttributes": {
							"shape": "Sk",
							"jsonvalue": true,
							"location": "header",
							"locationName": "x-amz-lex-request-attributes"
						},
						"contentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"accept": {
							"location": "header",
							"locationName": "Accept"
						},
						"inputStream": {
							"shape": "Sn"
						}
					},
					"payload": "inputStream"
				},
				"output": {
					"type": "structure",
					"members": {
						"contentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"intentName": {
							"location": "header",
							"locationName": "x-amz-lex-intent-name"
						},
						"slots": {
							"jsonvalue": true,
							"location": "header",
							"locationName": "x-amz-lex-slots"
						},
						"sessionAttributes": {
							"jsonvalue": true,
							"location": "header",
							"locationName": "x-amz-lex-session-attributes"
						},
						"message": {
							"shape": "Sh",
							"location": "header",
							"locationName": "x-amz-lex-message"
						},
						"messageFormat": {
							"location": "header",
							"locationName": "x-amz-lex-message-format"
						},
						"dialogState": {
							"location": "header",
							"locationName": "x-amz-lex-dialog-state"
						},
						"slotToElicit": {
							"location": "header",
							"locationName": "x-amz-lex-slot-to-elicit"
						},
						"inputTranscript": {
							"location": "header",
							"locationName": "x-amz-lex-input-transcript"
						},
						"audioStream": {
							"shape": "Sn"
						}
					},
					"payload": "audioStream"
				},
				"authtype": "v4-unsigned-body"
			},
			"PostText": {
				"http": {
					"requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/text"
				},
				"input": {
					"type": "structure",
					"required": [
						"botName",
						"botAlias",
						"userId",
						"inputText"
					],
					"members": {
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"botAlias": {
							"location": "uri",
							"locationName": "botAlias"
						},
						"userId": {
							"location": "uri",
							"locationName": "userId"
						},
						"sessionAttributes": {
							"shape": "Sc"
						},
						"requestAttributes": {
							"shape": "Sc"
						},
						"inputText": {
							"shape": "Sh"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"intentName": {},
						"slots": {
							"shape": "Sc"
						},
						"sessionAttributes": {
							"shape": "Sc"
						},
						"message": {
							"shape": "Sh"
						},
						"messageFormat": {},
						"dialogState": {},
						"slotToElicit": {},
						"responseCard": {
							"type": "structure",
							"members": {
								"version": {},
								"contentType": {},
								"genericAttachments": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"title": {},
											"subTitle": {},
											"attachmentLinkUrl": {},
											"imageUrl": {},
											"buttons": {
												"type": "list",
												"member": {
													"type": "structure",
													"required": [
														"text",
														"value"
													],
													"members": {
														"text": {},
														"value": {}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"PutSession": {
				"http": {
					"requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/session"
				},
				"input": {
					"type": "structure",
					"required": [
						"botName",
						"botAlias",
						"userId"
					],
					"members": {
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"botAlias": {
							"location": "uri",
							"locationName": "botAlias"
						},
						"userId": {
							"location": "uri",
							"locationName": "userId"
						},
						"sessionAttributes": {
							"shape": "Sc"
						},
						"dialogAction": {
							"shape": "Sg"
						},
						"accept": {
							"location": "header",
							"locationName": "Accept"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"contentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"intentName": {
							"location": "header",
							"locationName": "x-amz-lex-intent-name"
						},
						"slots": {
							"jsonvalue": true,
							"location": "header",
							"locationName": "x-amz-lex-slots"
						},
						"sessionAttributes": {
							"jsonvalue": true,
							"location": "header",
							"locationName": "x-amz-lex-session-attributes"
						},
						"message": {
							"shape": "Sh",
							"location": "header",
							"locationName": "x-amz-lex-message"
						},
						"messageFormat": {
							"location": "header",
							"locationName": "x-amz-lex-message-format"
						},
						"dialogState": {
							"location": "header",
							"locationName": "x-amz-lex-dialog-state"
						},
						"slotToElicit": {
							"location": "header",
							"locationName": "x-amz-lex-slot-to-elicit"
						},
						"audioStream": {
							"shape": "Sn"
						},
						"sessionId": {
							"location": "header",
							"locationName": "x-amz-lex-session-id"
						}
					},
					"payload": "audioStream"
				}
			}
		},
		"shapes": {
			"Sc": {
				"type": "map",
				"key": {},
				"value": {},
				"sensitive": true
			},
			"Sg": {
				"type": "structure",
				"required": [
					"type"
				],
				"members": {
					"type": {},
					"intentName": {},
					"slots": {
						"shape": "Sc"
					},
					"slotToElicit": {},
					"fulfillmentState": {},
					"message": {
						"shape": "Sh"
					},
					"messageFormat": {}
				}
			},
			"Sh": {
				"type": "string",
				"sensitive": true
			},
			"Sk": {
				"type": "string",
				"sensitive": true
			},
			"Sn": {
				"type": "blob",
				"streaming": true
			}
		}
	};

/***/ },
/* 493 */
480,
/* 494 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2006-03-01",
			"checksumFormat": "md5",
			"endpointPrefix": "s3",
			"globalEndpoint": "s3.amazonaws.com",
			"protocol": "rest-xml",
			"serviceAbbreviation": "Amazon S3",
			"serviceFullName": "Amazon Simple Storage Service",
			"serviceId": "S3",
			"signatureVersion": "s3",
			"uid": "s3-2006-03-01"
		},
		"operations": {
			"AbortMultipartUpload": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}/{Key+}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"UploadId"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"UploadId": {
							"location": "querystring",
							"locationName": "uploadId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"CompleteMultipartUpload": {
				"http": {
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"UploadId"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"MultipartUpload": {
							"locationName": "CompleteMultipartUpload",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"Parts": {
									"locationName": "Part",
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"ETag": {},
											"PartNumber": {
												"type": "integer"
											}
										}
									},
									"flattened": true
								}
							}
						},
						"UploadId": {
							"location": "querystring",
							"locationName": "uploadId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					},
					"payload": "MultipartUpload"
				},
				"output": {
					"type": "structure",
					"members": {
						"Location": {},
						"Bucket": {},
						"Key": {},
						"Expiration": {
							"location": "header",
							"locationName": "x-amz-expiration"
						},
						"ETag": {},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"CopyObject": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"CopySource",
						"Key"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"ContentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"ContentEncoding": {
							"location": "header",
							"locationName": "Content-Encoding"
						},
						"ContentLanguage": {
							"location": "header",
							"locationName": "Content-Language"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"CopySource": {
							"location": "header",
							"locationName": "x-amz-copy-source"
						},
						"CopySourceIfMatch": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-match"
						},
						"CopySourceIfModifiedSince": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-modified-since",
							"type": "timestamp"
						},
						"CopySourceIfNoneMatch": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-none-match"
						},
						"CopySourceIfUnmodifiedSince": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-unmodified-since",
							"type": "timestamp"
						},
						"Expires": {
							"location": "header",
							"locationName": "Expires",
							"type": "timestamp"
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Metadata": {
							"shape": "S11",
							"location": "headers",
							"locationName": "x-amz-meta-"
						},
						"MetadataDirective": {
							"location": "header",
							"locationName": "x-amz-metadata-directive"
						},
						"TaggingDirective": {
							"location": "header",
							"locationName": "x-amz-tagging-directive"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"StorageClass": {
							"location": "header",
							"locationName": "x-amz-storage-class"
						},
						"WebsiteRedirectLocation": {
							"location": "header",
							"locationName": "x-amz-website-redirect-location"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"SSEKMSEncryptionContext": {
							"shape": "S1b",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-context"
						},
						"CopySourceSSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-algorithm"
						},
						"CopySourceSSECustomerKey": {
							"shape": "S1d",
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-key"
						},
						"CopySourceSSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-key-MD5"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"Tagging": {
							"location": "header",
							"locationName": "x-amz-tagging"
						},
						"ObjectLockMode": {
							"location": "header",
							"locationName": "x-amz-object-lock-mode"
						},
						"ObjectLockRetainUntilDate": {
							"shape": "S1h",
							"location": "header",
							"locationName": "x-amz-object-lock-retain-until-date"
						},
						"ObjectLockLegalHoldStatus": {
							"location": "header",
							"locationName": "x-amz-object-lock-legal-hold"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CopyObjectResult": {
							"type": "structure",
							"members": {
								"ETag": {},
								"LastModified": {
									"type": "timestamp"
								}
							}
						},
						"Expiration": {
							"location": "header",
							"locationName": "x-amz-expiration"
						},
						"CopySourceVersionId": {
							"location": "header",
							"locationName": "x-amz-copy-source-version-id"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"SSEKMSEncryptionContext": {
							"shape": "S1b",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-context"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					},
					"payload": "CopyObjectResult"
				},
				"alias": "PutObjectCopy"
			},
			"CreateBucket": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CreateBucketConfiguration": {
							"locationName": "CreateBucketConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"LocationConstraint": {}
							}
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWrite": {
							"location": "header",
							"locationName": "x-amz-grant-write"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						},
						"ObjectLockEnabledForBucket": {
							"location": "header",
							"locationName": "x-amz-bucket-object-lock-enabled",
							"type": "boolean"
						}
					},
					"payload": "CreateBucketConfiguration"
				},
				"output": {
					"type": "structure",
					"members": {
						"Location": {
							"location": "header",
							"locationName": "Location"
						}
					}
				},
				"alias": "PutBucket"
			},
			"CreateMultipartUpload": {
				"http": {
					"requestUri": "/{Bucket}/{Key+}?uploads"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"ContentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"ContentEncoding": {
							"location": "header",
							"locationName": "Content-Encoding"
						},
						"ContentLanguage": {
							"location": "header",
							"locationName": "Content-Language"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"Expires": {
							"location": "header",
							"locationName": "Expires",
							"type": "timestamp"
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Metadata": {
							"shape": "S11",
							"location": "headers",
							"locationName": "x-amz-meta-"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"StorageClass": {
							"location": "header",
							"locationName": "x-amz-storage-class"
						},
						"WebsiteRedirectLocation": {
							"location": "header",
							"locationName": "x-amz-website-redirect-location"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"SSEKMSEncryptionContext": {
							"shape": "S1b",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-context"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"Tagging": {
							"location": "header",
							"locationName": "x-amz-tagging"
						},
						"ObjectLockMode": {
							"location": "header",
							"locationName": "x-amz-object-lock-mode"
						},
						"ObjectLockRetainUntilDate": {
							"shape": "S1h",
							"location": "header",
							"locationName": "x-amz-object-lock-retain-until-date"
						},
						"ObjectLockLegalHoldStatus": {
							"location": "header",
							"locationName": "x-amz-object-lock-legal-hold"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AbortDate": {
							"location": "header",
							"locationName": "x-amz-abort-date",
							"type": "timestamp"
						},
						"AbortRuleId": {
							"location": "header",
							"locationName": "x-amz-abort-rule-id"
						},
						"Bucket": {
							"locationName": "Bucket"
						},
						"Key": {},
						"UploadId": {},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"SSEKMSEncryptionContext": {
							"shape": "S1b",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-context"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				},
				"alias": "InitiateMultipartUpload"
			},
			"DeleteBucket": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketAnalyticsConfiguration": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?analytics",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				}
			},
			"DeleteBucketCors": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?cors",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketEncryption": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?encryption",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketInventoryConfiguration": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?inventory",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				}
			},
			"DeleteBucketLifecycle": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?lifecycle",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketMetricsConfiguration": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?metrics",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				}
			},
			"DeleteBucketPolicy": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?policy",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketReplication": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?replication",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketTagging": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?tagging",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketWebsite": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?website",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteObject": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}/{Key+}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"MFA": {
							"location": "header",
							"locationName": "x-amz-mfa"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"BypassGovernanceRetention": {
							"location": "header",
							"locationName": "x-amz-bypass-governance-retention",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeleteMarker": {
							"location": "header",
							"locationName": "x-amz-delete-marker",
							"type": "boolean"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"DeleteObjectTagging": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}/{Key+}?tagging",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						}
					}
				}
			},
			"DeleteObjects": {
				"http": {
					"requestUri": "/{Bucket}?delete"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Delete"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Delete": {
							"locationName": "Delete",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"required": [
								"Objects"
							],
							"members": {
								"Objects": {
									"locationName": "Object",
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"Key"
										],
										"members": {
											"Key": {},
											"VersionId": {}
										}
									},
									"flattened": true
								},
								"Quiet": {
									"type": "boolean"
								}
							}
						},
						"MFA": {
							"location": "header",
							"locationName": "x-amz-mfa"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"BypassGovernanceRetention": {
							"location": "header",
							"locationName": "x-amz-bypass-governance-retention",
							"type": "boolean"
						}
					},
					"payload": "Delete"
				},
				"output": {
					"type": "structure",
					"members": {
						"Deleted": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Key": {},
									"VersionId": {},
									"DeleteMarker": {
										"type": "boolean"
									},
									"DeleteMarkerVersionId": {}
								}
							},
							"flattened": true
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						},
						"Errors": {
							"locationName": "Error",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Key": {},
									"VersionId": {},
									"Code": {},
									"Message": {}
								}
							},
							"flattened": true
						}
					}
				},
				"alias": "DeleteMultipleObjects"
			},
			"DeletePublicAccessBlock": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?publicAccessBlock",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"GetBucketAccelerateConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?accelerate"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {}
					}
				}
			},
			"GetBucketAcl": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?acl"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Owner": {
							"shape": "S32"
						},
						"Grants": {
							"shape": "S35",
							"locationName": "AccessControlList"
						}
					}
				}
			},
			"GetBucketAnalyticsConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?analytics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AnalyticsConfiguration": {
							"shape": "S3e"
						}
					},
					"payload": "AnalyticsConfiguration"
				}
			},
			"GetBucketCors": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?cors"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CORSRules": {
							"shape": "S3u",
							"locationName": "CORSRule"
						}
					}
				}
			},
			"GetBucketEncryption": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?encryption"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ServerSideEncryptionConfiguration": {
							"shape": "S47"
						}
					},
					"payload": "ServerSideEncryptionConfiguration"
				}
			},
			"GetBucketInventoryConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?inventory"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InventoryConfiguration": {
							"shape": "S4d"
						}
					},
					"payload": "InventoryConfiguration"
				}
			},
			"GetBucketLifecycle": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?lifecycle"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Rules": {
							"shape": "S4t",
							"locationName": "Rule"
						}
					}
				},
				"deprecated": true
			},
			"GetBucketLifecycleConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?lifecycle"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Rules": {
							"shape": "S58",
							"locationName": "Rule"
						}
					}
				}
			},
			"GetBucketLocation": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?location"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LocationConstraint": {}
					}
				}
			},
			"GetBucketLogging": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?logging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LoggingEnabled": {
							"shape": "S5i"
						}
					}
				}
			},
			"GetBucketMetricsConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?metrics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MetricsConfiguration": {
							"shape": "S5q"
						}
					},
					"payload": "MetricsConfiguration"
				}
			},
			"GetBucketNotification": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?notification"
				},
				"input": {
					"shape": "S5t"
				},
				"output": {
					"shape": "S5u"
				},
				"deprecated": true
			},
			"GetBucketNotificationConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?notification"
				},
				"input": {
					"shape": "S5t"
				},
				"output": {
					"shape": "S65"
				}
			},
			"GetBucketPolicy": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?policy"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Policy": {}
					},
					"payload": "Policy"
				}
			},
			"GetBucketPolicyStatus": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?policyStatus"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PolicyStatus": {
							"type": "structure",
							"members": {
								"IsPublic": {
									"locationName": "IsPublic",
									"type": "boolean"
								}
							}
						}
					},
					"payload": "PolicyStatus"
				}
			},
			"GetBucketReplication": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?replication"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReplicationConfiguration": {
							"shape": "S6s"
						}
					},
					"payload": "ReplicationConfiguration"
				}
			},
			"GetBucketRequestPayment": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?requestPayment"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Payer": {}
					}
				}
			},
			"GetBucketTagging": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TagSet"
					],
					"members": {
						"TagSet": {
							"shape": "S3k"
						}
					}
				}
			},
			"GetBucketVersioning": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?versioning"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {},
						"MFADelete": {
							"locationName": "MfaDelete"
						}
					}
				}
			},
			"GetBucketWebsite": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?website"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RedirectAllRequestsTo": {
							"shape": "S7l"
						},
						"IndexDocument": {
							"shape": "S7o"
						},
						"ErrorDocument": {
							"shape": "S7q"
						},
						"RoutingRules": {
							"shape": "S7r"
						}
					}
				}
			},
			"GetObject": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						},
						"IfModifiedSince": {
							"location": "header",
							"locationName": "If-Modified-Since",
							"type": "timestamp"
						},
						"IfNoneMatch": {
							"location": "header",
							"locationName": "If-None-Match"
						},
						"IfUnmodifiedSince": {
							"location": "header",
							"locationName": "If-Unmodified-Since",
							"type": "timestamp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Range": {
							"location": "header",
							"locationName": "Range"
						},
						"ResponseCacheControl": {
							"location": "querystring",
							"locationName": "response-cache-control"
						},
						"ResponseContentDisposition": {
							"location": "querystring",
							"locationName": "response-content-disposition"
						},
						"ResponseContentEncoding": {
							"location": "querystring",
							"locationName": "response-content-encoding"
						},
						"ResponseContentLanguage": {
							"location": "querystring",
							"locationName": "response-content-language"
						},
						"ResponseContentType": {
							"location": "querystring",
							"locationName": "response-content-type"
						},
						"ResponseExpires": {
							"location": "querystring",
							"locationName": "response-expires",
							"type": "timestamp"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"PartNumber": {
							"location": "querystring",
							"locationName": "partNumber",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Body": {
							"streaming": true,
							"type": "blob"
						},
						"DeleteMarker": {
							"location": "header",
							"locationName": "x-amz-delete-marker",
							"type": "boolean"
						},
						"AcceptRanges": {
							"location": "header",
							"locationName": "accept-ranges"
						},
						"Expiration": {
							"location": "header",
							"locationName": "x-amz-expiration"
						},
						"Restore": {
							"location": "header",
							"locationName": "x-amz-restore"
						},
						"LastModified": {
							"location": "header",
							"locationName": "Last-Modified",
							"type": "timestamp"
						},
						"ContentLength": {
							"location": "header",
							"locationName": "Content-Length",
							"type": "long"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						},
						"MissingMeta": {
							"location": "header",
							"locationName": "x-amz-missing-meta",
							"type": "integer"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"ContentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"ContentEncoding": {
							"location": "header",
							"locationName": "Content-Encoding"
						},
						"ContentLanguage": {
							"location": "header",
							"locationName": "Content-Language"
						},
						"ContentRange": {
							"location": "header",
							"locationName": "Content-Range"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"Expires": {
							"location": "header",
							"locationName": "Expires",
							"type": "timestamp"
						},
						"WebsiteRedirectLocation": {
							"location": "header",
							"locationName": "x-amz-website-redirect-location"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"Metadata": {
							"shape": "S11",
							"location": "headers",
							"locationName": "x-amz-meta-"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"StorageClass": {
							"location": "header",
							"locationName": "x-amz-storage-class"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						},
						"ReplicationStatus": {
							"location": "header",
							"locationName": "x-amz-replication-status"
						},
						"PartsCount": {
							"location": "header",
							"locationName": "x-amz-mp-parts-count",
							"type": "integer"
						},
						"TagCount": {
							"location": "header",
							"locationName": "x-amz-tagging-count",
							"type": "integer"
						},
						"ObjectLockMode": {
							"location": "header",
							"locationName": "x-amz-object-lock-mode"
						},
						"ObjectLockRetainUntilDate": {
							"shape": "S1h",
							"location": "header",
							"locationName": "x-amz-object-lock-retain-until-date"
						},
						"ObjectLockLegalHoldStatus": {
							"location": "header",
							"locationName": "x-amz-object-lock-legal-hold"
						}
					},
					"payload": "Body"
				}
			},
			"GetObjectAcl": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}?acl"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Owner": {
							"shape": "S32"
						},
						"Grants": {
							"shape": "S35",
							"locationName": "AccessControlList"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"GetObjectLegalHold": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}?legal-hold"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LegalHold": {
							"shape": "S8q"
						}
					},
					"payload": "LegalHold"
				}
			},
			"GetObjectLockConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?object-lock"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ObjectLockConfiguration": {
							"shape": "S8t"
						}
					},
					"payload": "ObjectLockConfiguration"
				}
			},
			"GetObjectRetention": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}?retention"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Retention": {
							"shape": "S91"
						}
					},
					"payload": "Retention"
				}
			},
			"GetObjectTagging": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}?tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TagSet"
					],
					"members": {
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"TagSet": {
							"shape": "S3k"
						}
					}
				}
			},
			"GetObjectTorrent": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}?torrent"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Body": {
							"streaming": true,
							"type": "blob"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					},
					"payload": "Body"
				}
			},
			"GetPublicAccessBlock": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?publicAccessBlock"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicAccessBlockConfiguration": {
							"shape": "S98"
						}
					},
					"payload": "PublicAccessBlockConfiguration"
				}
			},
			"HeadBucket": {
				"http": {
					"method": "HEAD",
					"requestUri": "/{Bucket}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"HeadObject": {
				"http": {
					"method": "HEAD",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						},
						"IfModifiedSince": {
							"location": "header",
							"locationName": "If-Modified-Since",
							"type": "timestamp"
						},
						"IfNoneMatch": {
							"location": "header",
							"locationName": "If-None-Match"
						},
						"IfUnmodifiedSince": {
							"location": "header",
							"locationName": "If-Unmodified-Since",
							"type": "timestamp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Range": {
							"location": "header",
							"locationName": "Range"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"PartNumber": {
							"location": "querystring",
							"locationName": "partNumber",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeleteMarker": {
							"location": "header",
							"locationName": "x-amz-delete-marker",
							"type": "boolean"
						},
						"AcceptRanges": {
							"location": "header",
							"locationName": "accept-ranges"
						},
						"Expiration": {
							"location": "header",
							"locationName": "x-amz-expiration"
						},
						"Restore": {
							"location": "header",
							"locationName": "x-amz-restore"
						},
						"LastModified": {
							"location": "header",
							"locationName": "Last-Modified",
							"type": "timestamp"
						},
						"ContentLength": {
							"location": "header",
							"locationName": "Content-Length",
							"type": "long"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						},
						"MissingMeta": {
							"location": "header",
							"locationName": "x-amz-missing-meta",
							"type": "integer"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"ContentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"ContentEncoding": {
							"location": "header",
							"locationName": "Content-Encoding"
						},
						"ContentLanguage": {
							"location": "header",
							"locationName": "Content-Language"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"Expires": {
							"location": "header",
							"locationName": "Expires",
							"type": "timestamp"
						},
						"WebsiteRedirectLocation": {
							"location": "header",
							"locationName": "x-amz-website-redirect-location"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"Metadata": {
							"shape": "S11",
							"location": "headers",
							"locationName": "x-amz-meta-"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"StorageClass": {
							"location": "header",
							"locationName": "x-amz-storage-class"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						},
						"ReplicationStatus": {
							"location": "header",
							"locationName": "x-amz-replication-status"
						},
						"PartsCount": {
							"location": "header",
							"locationName": "x-amz-mp-parts-count",
							"type": "integer"
						},
						"ObjectLockMode": {
							"location": "header",
							"locationName": "x-amz-object-lock-mode"
						},
						"ObjectLockRetainUntilDate": {
							"shape": "S1h",
							"location": "header",
							"locationName": "x-amz-object-lock-retain-until-date"
						},
						"ObjectLockLegalHoldStatus": {
							"location": "header",
							"locationName": "x-amz-object-lock-legal-hold"
						}
					}
				}
			},
			"ListBucketAnalyticsConfigurations": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?analytics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContinuationToken": {
							"location": "querystring",
							"locationName": "continuation-token"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsTruncated": {
							"type": "boolean"
						},
						"ContinuationToken": {},
						"NextContinuationToken": {},
						"AnalyticsConfigurationList": {
							"locationName": "AnalyticsConfiguration",
							"type": "list",
							"member": {
								"shape": "S3e"
							},
							"flattened": true
						}
					}
				}
			},
			"ListBucketInventoryConfigurations": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?inventory"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContinuationToken": {
							"location": "querystring",
							"locationName": "continuation-token"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ContinuationToken": {},
						"InventoryConfigurationList": {
							"locationName": "InventoryConfiguration",
							"type": "list",
							"member": {
								"shape": "S4d"
							},
							"flattened": true
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"NextContinuationToken": {}
					}
				}
			},
			"ListBucketMetricsConfigurations": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?metrics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContinuationToken": {
							"location": "querystring",
							"locationName": "continuation-token"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsTruncated": {
							"type": "boolean"
						},
						"ContinuationToken": {},
						"NextContinuationToken": {},
						"MetricsConfigurationList": {
							"locationName": "MetricsConfiguration",
							"type": "list",
							"member": {
								"shape": "S5q"
							},
							"flattened": true
						}
					}
				}
			},
			"ListBuckets": {
				"http": {
					"method": "GET"
				},
				"output": {
					"type": "structure",
					"members": {
						"Buckets": {
							"type": "list",
							"member": {
								"locationName": "Bucket",
								"type": "structure",
								"members": {
									"Name": {},
									"CreationDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"Owner": {
							"shape": "S32"
						}
					}
				},
				"alias": "GetService"
			},
			"ListMultipartUploads": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?uploads"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Delimiter": {
							"location": "querystring",
							"locationName": "delimiter"
						},
						"EncodingType": {
							"location": "querystring",
							"locationName": "encoding-type"
						},
						"KeyMarker": {
							"location": "querystring",
							"locationName": "key-marker"
						},
						"MaxUploads": {
							"location": "querystring",
							"locationName": "max-uploads",
							"type": "integer"
						},
						"Prefix": {
							"location": "querystring",
							"locationName": "prefix"
						},
						"UploadIdMarker": {
							"location": "querystring",
							"locationName": "upload-id-marker"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Bucket": {},
						"KeyMarker": {},
						"UploadIdMarker": {},
						"NextKeyMarker": {},
						"Prefix": {},
						"Delimiter": {},
						"NextUploadIdMarker": {},
						"MaxUploads": {
							"type": "integer"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Uploads": {
							"locationName": "Upload",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"UploadId": {},
									"Key": {},
									"Initiated": {
										"type": "timestamp"
									},
									"StorageClass": {},
									"Owner": {
										"shape": "S32"
									},
									"Initiator": {
										"shape": "Sa5"
									}
								}
							},
							"flattened": true
						},
						"CommonPrefixes": {
							"shape": "Sa6"
						},
						"EncodingType": {}
					}
				}
			},
			"ListObjectVersions": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?versions"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Delimiter": {
							"location": "querystring",
							"locationName": "delimiter"
						},
						"EncodingType": {
							"location": "querystring",
							"locationName": "encoding-type"
						},
						"KeyMarker": {
							"location": "querystring",
							"locationName": "key-marker"
						},
						"MaxKeys": {
							"location": "querystring",
							"locationName": "max-keys",
							"type": "integer"
						},
						"Prefix": {
							"location": "querystring",
							"locationName": "prefix"
						},
						"VersionIdMarker": {
							"location": "querystring",
							"locationName": "version-id-marker"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsTruncated": {
							"type": "boolean"
						},
						"KeyMarker": {},
						"VersionIdMarker": {},
						"NextKeyMarker": {},
						"NextVersionIdMarker": {},
						"Versions": {
							"locationName": "Version",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ETag": {},
									"Size": {
										"type": "integer"
									},
									"StorageClass": {},
									"Key": {},
									"VersionId": {},
									"IsLatest": {
										"type": "boolean"
									},
									"LastModified": {
										"type": "timestamp"
									},
									"Owner": {
										"shape": "S32"
									}
								}
							},
							"flattened": true
						},
						"DeleteMarkers": {
							"locationName": "DeleteMarker",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Owner": {
										"shape": "S32"
									},
									"Key": {},
									"VersionId": {},
									"IsLatest": {
										"type": "boolean"
									},
									"LastModified": {
										"type": "timestamp"
									}
								}
							},
							"flattened": true
						},
						"Name": {},
						"Prefix": {},
						"Delimiter": {},
						"MaxKeys": {
							"type": "integer"
						},
						"CommonPrefixes": {
							"shape": "Sa6"
						},
						"EncodingType": {}
					}
				},
				"alias": "GetBucketObjectVersions"
			},
			"ListObjects": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Delimiter": {
							"location": "querystring",
							"locationName": "delimiter"
						},
						"EncodingType": {
							"location": "querystring",
							"locationName": "encoding-type"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"MaxKeys": {
							"location": "querystring",
							"locationName": "max-keys",
							"type": "integer"
						},
						"Prefix": {
							"location": "querystring",
							"locationName": "prefix"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {},
						"NextMarker": {},
						"Contents": {
							"shape": "Sao"
						},
						"Name": {},
						"Prefix": {},
						"Delimiter": {},
						"MaxKeys": {
							"type": "integer"
						},
						"CommonPrefixes": {
							"shape": "Sa6"
						},
						"EncodingType": {}
					}
				},
				"alias": "GetBucket"
			},
			"ListObjectsV2": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?list-type=2"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Delimiter": {
							"location": "querystring",
							"locationName": "delimiter"
						},
						"EncodingType": {
							"location": "querystring",
							"locationName": "encoding-type"
						},
						"MaxKeys": {
							"location": "querystring",
							"locationName": "max-keys",
							"type": "integer"
						},
						"Prefix": {
							"location": "querystring",
							"locationName": "prefix"
						},
						"ContinuationToken": {
							"location": "querystring",
							"locationName": "continuation-token"
						},
						"FetchOwner": {
							"location": "querystring",
							"locationName": "fetch-owner",
							"type": "boolean"
						},
						"StartAfter": {
							"location": "querystring",
							"locationName": "start-after"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsTruncated": {
							"type": "boolean"
						},
						"Contents": {
							"shape": "Sao"
						},
						"Name": {},
						"Prefix": {},
						"Delimiter": {},
						"MaxKeys": {
							"type": "integer"
						},
						"CommonPrefixes": {
							"shape": "Sa6"
						},
						"EncodingType": {},
						"KeyCount": {
							"type": "integer"
						},
						"ContinuationToken": {},
						"NextContinuationToken": {},
						"StartAfter": {}
					}
				}
			},
			"ListParts": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"UploadId"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"MaxParts": {
							"location": "querystring",
							"locationName": "max-parts",
							"type": "integer"
						},
						"PartNumberMarker": {
							"location": "querystring",
							"locationName": "part-number-marker",
							"type": "integer"
						},
						"UploadId": {
							"location": "querystring",
							"locationName": "uploadId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AbortDate": {
							"location": "header",
							"locationName": "x-amz-abort-date",
							"type": "timestamp"
						},
						"AbortRuleId": {
							"location": "header",
							"locationName": "x-amz-abort-rule-id"
						},
						"Bucket": {},
						"Key": {},
						"UploadId": {},
						"PartNumberMarker": {
							"type": "integer"
						},
						"NextPartNumberMarker": {
							"type": "integer"
						},
						"MaxParts": {
							"type": "integer"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Parts": {
							"locationName": "Part",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PartNumber": {
										"type": "integer"
									},
									"LastModified": {
										"type": "timestamp"
									},
									"ETag": {},
									"Size": {
										"type": "integer"
									}
								}
							},
							"flattened": true
						},
						"Initiator": {
							"shape": "Sa5"
						},
						"Owner": {
							"shape": "S32"
						},
						"StorageClass": {},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"PutBucketAccelerateConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?accelerate"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"AccelerateConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"AccelerateConfiguration": {
							"locationName": "AccelerateConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"Status": {}
							}
						}
					},
					"payload": "AccelerateConfiguration"
				}
			},
			"PutBucketAcl": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?acl"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"AccessControlPolicy": {
							"shape": "Sb6",
							"locationName": "AccessControlPolicy",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWrite": {
							"location": "header",
							"locationName": "x-amz-grant-write"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						}
					},
					"payload": "AccessControlPolicy"
				}
			},
			"PutBucketAnalyticsConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?analytics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id",
						"AnalyticsConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						},
						"AnalyticsConfiguration": {
							"shape": "S3e",
							"locationName": "AnalyticsConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "AnalyticsConfiguration"
				}
			},
			"PutBucketCors": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?cors"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"CORSConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CORSConfiguration": {
							"locationName": "CORSConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"required": [
								"CORSRules"
							],
							"members": {
								"CORSRules": {
									"shape": "S3u",
									"locationName": "CORSRule"
								}
							}
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						}
					},
					"payload": "CORSConfiguration"
				}
			},
			"PutBucketEncryption": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?encryption"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"ServerSideEncryptionConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"ServerSideEncryptionConfiguration": {
							"shape": "S47",
							"locationName": "ServerSideEncryptionConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "ServerSideEncryptionConfiguration"
				}
			},
			"PutBucketInventoryConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?inventory"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id",
						"InventoryConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						},
						"InventoryConfiguration": {
							"shape": "S4d",
							"locationName": "InventoryConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "InventoryConfiguration"
				}
			},
			"PutBucketLifecycle": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?lifecycle"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"LifecycleConfiguration": {
							"locationName": "LifecycleConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"required": [
								"Rules"
							],
							"members": {
								"Rules": {
									"shape": "S4t",
									"locationName": "Rule"
								}
							}
						}
					},
					"payload": "LifecycleConfiguration"
				},
				"deprecated": true
			},
			"PutBucketLifecycleConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?lifecycle"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"LifecycleConfiguration": {
							"locationName": "LifecycleConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"required": [
								"Rules"
							],
							"members": {
								"Rules": {
									"shape": "S58",
									"locationName": "Rule"
								}
							}
						}
					},
					"payload": "LifecycleConfiguration"
				}
			},
			"PutBucketLogging": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?logging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"BucketLoggingStatus"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"BucketLoggingStatus": {
							"locationName": "BucketLoggingStatus",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"LoggingEnabled": {
									"shape": "S5i"
								}
							}
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						}
					},
					"payload": "BucketLoggingStatus"
				}
			},
			"PutBucketMetricsConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?metrics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id",
						"MetricsConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						},
						"MetricsConfiguration": {
							"shape": "S5q",
							"locationName": "MetricsConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "MetricsConfiguration"
				}
			},
			"PutBucketNotification": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?notification"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"NotificationConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"NotificationConfiguration": {
							"shape": "S5u",
							"locationName": "NotificationConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "NotificationConfiguration"
				},
				"deprecated": true
			},
			"PutBucketNotificationConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?notification"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"NotificationConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"NotificationConfiguration": {
							"shape": "S65",
							"locationName": "NotificationConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "NotificationConfiguration"
				}
			},
			"PutBucketPolicy": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?policy"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Policy"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"ConfirmRemoveSelfBucketAccess": {
							"location": "header",
							"locationName": "x-amz-confirm-remove-self-bucket-access",
							"type": "boolean"
						},
						"Policy": {}
					},
					"payload": "Policy"
				}
			},
			"PutBucketReplication": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?replication"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"ReplicationConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"ReplicationConfiguration": {
							"shape": "S6s",
							"locationName": "ReplicationConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						},
						"Token": {
							"location": "header",
							"locationName": "x-amz-bucket-object-lock-token"
						}
					},
					"payload": "ReplicationConfiguration"
				}
			},
			"PutBucketRequestPayment": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?requestPayment"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"RequestPaymentConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"RequestPaymentConfiguration": {
							"locationName": "RequestPaymentConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"required": [
								"Payer"
							],
							"members": {
								"Payer": {}
							}
						}
					},
					"payload": "RequestPaymentConfiguration"
				}
			},
			"PutBucketTagging": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Tagging"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"Tagging": {
							"shape": "Sbt",
							"locationName": "Tagging",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "Tagging"
				}
			},
			"PutBucketVersioning": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?versioning"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"VersioningConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"MFA": {
							"location": "header",
							"locationName": "x-amz-mfa"
						},
						"VersioningConfiguration": {
							"locationName": "VersioningConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"MFADelete": {
									"locationName": "MfaDelete"
								},
								"Status": {}
							}
						}
					},
					"payload": "VersioningConfiguration"
				}
			},
			"PutBucketWebsite": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?website"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"WebsiteConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"WebsiteConfiguration": {
							"locationName": "WebsiteConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"ErrorDocument": {
									"shape": "S7q"
								},
								"IndexDocument": {
									"shape": "S7o"
								},
								"RedirectAllRequestsTo": {
									"shape": "S7l"
								},
								"RoutingRules": {
									"shape": "S7r"
								}
							}
						}
					},
					"payload": "WebsiteConfiguration"
				}
			},
			"PutObject": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"Body": {
							"streaming": true,
							"type": "blob"
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"ContentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"ContentEncoding": {
							"location": "header",
							"locationName": "Content-Encoding"
						},
						"ContentLanguage": {
							"location": "header",
							"locationName": "Content-Language"
						},
						"ContentLength": {
							"location": "header",
							"locationName": "Content-Length",
							"type": "long"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"Expires": {
							"location": "header",
							"locationName": "Expires",
							"type": "timestamp"
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Metadata": {
							"shape": "S11",
							"location": "headers",
							"locationName": "x-amz-meta-"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"StorageClass": {
							"location": "header",
							"locationName": "x-amz-storage-class"
						},
						"WebsiteRedirectLocation": {
							"location": "header",
							"locationName": "x-amz-website-redirect-location"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"SSEKMSEncryptionContext": {
							"shape": "S1b",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-context"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"Tagging": {
							"location": "header",
							"locationName": "x-amz-tagging"
						},
						"ObjectLockMode": {
							"location": "header",
							"locationName": "x-amz-object-lock-mode"
						},
						"ObjectLockRetainUntilDate": {
							"shape": "S1h",
							"location": "header",
							"locationName": "x-amz-object-lock-retain-until-date"
						},
						"ObjectLockLegalHoldStatus": {
							"location": "header",
							"locationName": "x-amz-object-lock-legal-hold"
						}
					},
					"payload": "Body"
				},
				"output": {
					"type": "structure",
					"members": {
						"Expiration": {
							"location": "header",
							"locationName": "x-amz-expiration"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"SSEKMSEncryptionContext": {
							"shape": "S1b",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-context"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"PutObjectAcl": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}?acl"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"AccessControlPolicy": {
							"shape": "Sb6",
							"locationName": "AccessControlPolicy",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWrite": {
							"location": "header",
							"locationName": "x-amz-grant-write"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						}
					},
					"payload": "AccessControlPolicy"
				},
				"output": {
					"type": "structure",
					"members": {
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"PutObjectLegalHold": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}?legal-hold"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"LegalHold": {
							"shape": "S8q",
							"locationName": "LegalHold",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						}
					},
					"payload": "LegalHold"
				},
				"output": {
					"type": "structure",
					"members": {
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"PutObjectLockConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?object-lock"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ObjectLockConfiguration": {
							"shape": "S8t",
							"locationName": "ObjectLockConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"Token": {
							"location": "header",
							"locationName": "x-amz-bucket-object-lock-token"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						}
					},
					"payload": "ObjectLockConfiguration"
				},
				"output": {
					"type": "structure",
					"members": {
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"PutObjectRetention": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}?retention"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Retention": {
							"shape": "S91",
							"locationName": "Retention",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"BypassGovernanceRetention": {
							"location": "header",
							"locationName": "x-amz-bypass-governance-retention",
							"type": "boolean"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						}
					},
					"payload": "Retention"
				},
				"output": {
					"type": "structure",
					"members": {
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"PutObjectTagging": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}?tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"Tagging"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"Tagging": {
							"shape": "Sbt",
							"locationName": "Tagging",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "Tagging"
				},
				"output": {
					"type": "structure",
					"members": {
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						}
					}
				}
			},
			"PutPublicAccessBlock": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?publicAccessBlock"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"PublicAccessBlockConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"PublicAccessBlockConfiguration": {
							"shape": "S98",
							"locationName": "PublicAccessBlockConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "PublicAccessBlockConfiguration"
				}
			},
			"RestoreObject": {
				"http": {
					"requestUri": "/{Bucket}/{Key+}?restore"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"RestoreRequest": {
							"locationName": "RestoreRequest",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"Days": {
									"type": "integer"
								},
								"GlacierJobParameters": {
									"type": "structure",
									"required": [
										"Tier"
									],
									"members": {
										"Tier": {}
									}
								},
								"Type": {},
								"Tier": {},
								"Description": {},
								"SelectParameters": {
									"type": "structure",
									"required": [
										"InputSerialization",
										"ExpressionType",
										"Expression",
										"OutputSerialization"
									],
									"members": {
										"InputSerialization": {
											"shape": "Scj"
										},
										"ExpressionType": {},
										"Expression": {},
										"OutputSerialization": {
											"shape": "Scy"
										}
									}
								},
								"OutputLocation": {
									"type": "structure",
									"members": {
										"S3": {
											"type": "structure",
											"required": [
												"BucketName",
												"Prefix"
											],
											"members": {
												"BucketName": {},
												"Prefix": {},
												"Encryption": {
													"type": "structure",
													"required": [
														"EncryptionType"
													],
													"members": {
														"EncryptionType": {},
														"KMSKeyId": {
															"shape": "Sj"
														},
														"KMSContext": {}
													}
												},
												"CannedACL": {},
												"AccessControlList": {
													"shape": "S35"
												},
												"Tagging": {
													"shape": "Sbt"
												},
												"UserMetadata": {
													"type": "list",
													"member": {
														"locationName": "MetadataEntry",
														"type": "structure",
														"members": {
															"Name": {},
															"Value": {}
														}
													}
												},
												"StorageClass": {}
											}
										}
									}
								}
							}
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					},
					"payload": "RestoreRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						},
						"RestoreOutputPath": {
							"location": "header",
							"locationName": "x-amz-restore-output-path"
						}
					}
				},
				"alias": "PostObjectRestore"
			},
			"SelectObjectContent": {
				"http": {
					"requestUri": "/{Bucket}/{Key+}?select&select-type=2"
				},
				"input": {
					"locationName": "SelectObjectContentRequest",
					"xmlNamespace": {
						"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
					},
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"Expression",
						"ExpressionType",
						"InputSerialization",
						"OutputSerialization"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"Expression": {},
						"ExpressionType": {},
						"RequestProgress": {
							"type": "structure",
							"members": {
								"Enabled": {
									"type": "boolean"
								}
							}
						},
						"InputSerialization": {
							"shape": "Scj"
						},
						"OutputSerialization": {
							"shape": "Scy"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Payload": {
							"type": "structure",
							"members": {
								"Records": {
									"type": "structure",
									"members": {
										"Payload": {
											"eventpayload": true,
											"type": "blob"
										}
									},
									"event": true
								},
								"Stats": {
									"type": "structure",
									"members": {
										"Details": {
											"eventpayload": true,
											"type": "structure",
											"members": {
												"BytesScanned": {
													"type": "long"
												},
												"BytesProcessed": {
													"type": "long"
												},
												"BytesReturned": {
													"type": "long"
												}
											}
										}
									},
									"event": true
								},
								"Progress": {
									"type": "structure",
									"members": {
										"Details": {
											"eventpayload": true,
											"type": "structure",
											"members": {
												"BytesScanned": {
													"type": "long"
												},
												"BytesProcessed": {
													"type": "long"
												},
												"BytesReturned": {
													"type": "long"
												}
											}
										}
									},
									"event": true
								},
								"Cont": {
									"type": "structure",
									"members": {},
									"event": true
								},
								"End": {
									"type": "structure",
									"members": {},
									"event": true
								}
							},
							"eventstream": true
						}
					},
					"payload": "Payload"
				}
			},
			"UploadPart": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"PartNumber",
						"UploadId"
					],
					"members": {
						"Body": {
							"streaming": true,
							"type": "blob"
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentLength": {
							"location": "header",
							"locationName": "Content-Length",
							"type": "long"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"PartNumber": {
							"location": "querystring",
							"locationName": "partNumber",
							"type": "integer"
						},
						"UploadId": {
							"location": "querystring",
							"locationName": "uploadId"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					},
					"payload": "Body"
				},
				"output": {
					"type": "structure",
					"members": {
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"UploadPartCopy": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"CopySource",
						"Key",
						"PartNumber",
						"UploadId"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CopySource": {
							"location": "header",
							"locationName": "x-amz-copy-source"
						},
						"CopySourceIfMatch": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-match"
						},
						"CopySourceIfModifiedSince": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-modified-since",
							"type": "timestamp"
						},
						"CopySourceIfNoneMatch": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-none-match"
						},
						"CopySourceIfUnmodifiedSince": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-unmodified-since",
							"type": "timestamp"
						},
						"CopySourceRange": {
							"location": "header",
							"locationName": "x-amz-copy-source-range"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"PartNumber": {
							"location": "querystring",
							"locationName": "partNumber",
							"type": "integer"
						},
						"UploadId": {
							"location": "querystring",
							"locationName": "uploadId"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"CopySourceSSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-algorithm"
						},
						"CopySourceSSECustomerKey": {
							"shape": "S1d",
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-key"
						},
						"CopySourceSSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-key-MD5"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CopySourceVersionId": {
							"location": "header",
							"locationName": "x-amz-copy-source-version-id"
						},
						"CopyPartResult": {
							"type": "structure",
							"members": {
								"ETag": {},
								"LastModified": {
									"type": "timestamp"
								}
							}
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					},
					"payload": "CopyPartResult"
				}
			}
		},
		"shapes": {
			"Sj": {
				"type": "string",
				"sensitive": true
			},
			"S11": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S19": {
				"type": "blob",
				"sensitive": true
			},
			"S1b": {
				"type": "string",
				"sensitive": true
			},
			"S1d": {
				"type": "blob",
				"sensitive": true
			},
			"S1h": {
				"type": "timestamp",
				"timestampFormat": "iso8601"
			},
			"S32": {
				"type": "structure",
				"members": {
					"DisplayName": {},
					"ID": {}
				}
			},
			"S35": {
				"type": "list",
				"member": {
					"locationName": "Grant",
					"type": "structure",
					"members": {
						"Grantee": {
							"shape": "S37"
						},
						"Permission": {}
					}
				}
			},
			"S37": {
				"type": "structure",
				"required": [
					"Type"
				],
				"members": {
					"DisplayName": {},
					"EmailAddress": {},
					"ID": {},
					"Type": {
						"locationName": "xsi:type",
						"xmlAttribute": true
					},
					"URI": {}
				},
				"xmlNamespace": {
					"prefix": "xsi",
					"uri": "http://www.w3.org/2001/XMLSchema-instance"
				}
			},
			"S3e": {
				"type": "structure",
				"required": [
					"Id",
					"StorageClassAnalysis"
				],
				"members": {
					"Id": {},
					"Filter": {
						"type": "structure",
						"members": {
							"Prefix": {},
							"Tag": {
								"shape": "S3h"
							},
							"And": {
								"type": "structure",
								"members": {
									"Prefix": {},
									"Tags": {
										"shape": "S3k",
										"flattened": true,
										"locationName": "Tag"
									}
								}
							}
						}
					},
					"StorageClassAnalysis": {
						"type": "structure",
						"members": {
							"DataExport": {
								"type": "structure",
								"required": [
									"OutputSchemaVersion",
									"Destination"
								],
								"members": {
									"OutputSchemaVersion": {},
									"Destination": {
										"type": "structure",
										"required": [
											"S3BucketDestination"
										],
										"members": {
											"S3BucketDestination": {
												"type": "structure",
												"required": [
													"Format",
													"Bucket"
												],
												"members": {
													"Format": {},
													"BucketAccountId": {},
													"Bucket": {},
													"Prefix": {}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"S3h": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			},
			"S3k": {
				"type": "list",
				"member": {
					"shape": "S3h",
					"locationName": "Tag"
				}
			},
			"S3u": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"AllowedMethods",
						"AllowedOrigins"
					],
					"members": {
						"AllowedHeaders": {
							"locationName": "AllowedHeader",
							"type": "list",
							"member": {},
							"flattened": true
						},
						"AllowedMethods": {
							"locationName": "AllowedMethod",
							"type": "list",
							"member": {},
							"flattened": true
						},
						"AllowedOrigins": {
							"locationName": "AllowedOrigin",
							"type": "list",
							"member": {},
							"flattened": true
						},
						"ExposeHeaders": {
							"locationName": "ExposeHeader",
							"type": "list",
							"member": {},
							"flattened": true
						},
						"MaxAgeSeconds": {
							"type": "integer"
						}
					}
				},
				"flattened": true
			},
			"S47": {
				"type": "structure",
				"required": [
					"Rules"
				],
				"members": {
					"Rules": {
						"locationName": "Rule",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ApplyServerSideEncryptionByDefault": {
									"type": "structure",
									"required": [
										"SSEAlgorithm"
									],
									"members": {
										"SSEAlgorithm": {},
										"KMSMasterKeyID": {
											"shape": "Sj"
										}
									}
								}
							}
						},
						"flattened": true
					}
				}
			},
			"S4d": {
				"type": "structure",
				"required": [
					"Destination",
					"IsEnabled",
					"Id",
					"IncludedObjectVersions",
					"Schedule"
				],
				"members": {
					"Destination": {
						"type": "structure",
						"required": [
							"S3BucketDestination"
						],
						"members": {
							"S3BucketDestination": {
								"type": "structure",
								"required": [
									"Bucket",
									"Format"
								],
								"members": {
									"AccountId": {},
									"Bucket": {},
									"Format": {},
									"Prefix": {},
									"Encryption": {
										"type": "structure",
										"members": {
											"SSES3": {
												"locationName": "SSE-S3",
												"type": "structure",
												"members": {}
											},
											"SSEKMS": {
												"locationName": "SSE-KMS",
												"type": "structure",
												"required": [
													"KeyId"
												],
												"members": {
													"KeyId": {
														"shape": "Sj"
													}
												}
											}
										}
									}
								}
							}
						}
					},
					"IsEnabled": {
						"type": "boolean"
					},
					"Filter": {
						"type": "structure",
						"required": [
							"Prefix"
						],
						"members": {
							"Prefix": {}
						}
					},
					"Id": {},
					"IncludedObjectVersions": {},
					"OptionalFields": {
						"type": "list",
						"member": {
							"locationName": "Field"
						}
					},
					"Schedule": {
						"type": "structure",
						"required": [
							"Frequency"
						],
						"members": {
							"Frequency": {}
						}
					}
				}
			},
			"S4t": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Prefix",
						"Status"
					],
					"members": {
						"Expiration": {
							"shape": "S4v"
						},
						"ID": {},
						"Prefix": {},
						"Status": {},
						"Transition": {
							"shape": "S50"
						},
						"NoncurrentVersionTransition": {
							"shape": "S52"
						},
						"NoncurrentVersionExpiration": {
							"shape": "S53"
						},
						"AbortIncompleteMultipartUpload": {
							"shape": "S54"
						}
					}
				},
				"flattened": true
			},
			"S4v": {
				"type": "structure",
				"members": {
					"Date": {
						"shape": "S4w"
					},
					"Days": {
						"type": "integer"
					},
					"ExpiredObjectDeleteMarker": {
						"type": "boolean"
					}
				}
			},
			"S4w": {
				"type": "timestamp",
				"timestampFormat": "iso8601"
			},
			"S50": {
				"type": "structure",
				"members": {
					"Date": {
						"shape": "S4w"
					},
					"Days": {
						"type": "integer"
					},
					"StorageClass": {}
				}
			},
			"S52": {
				"type": "structure",
				"members": {
					"NoncurrentDays": {
						"type": "integer"
					},
					"StorageClass": {}
				}
			},
			"S53": {
				"type": "structure",
				"members": {
					"NoncurrentDays": {
						"type": "integer"
					}
				}
			},
			"S54": {
				"type": "structure",
				"members": {
					"DaysAfterInitiation": {
						"type": "integer"
					}
				}
			},
			"S58": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Expiration": {
							"shape": "S4v"
						},
						"ID": {},
						"Prefix": {
							"deprecated": true
						},
						"Filter": {
							"type": "structure",
							"members": {
								"Prefix": {},
								"Tag": {
									"shape": "S3h"
								},
								"And": {
									"type": "structure",
									"members": {
										"Prefix": {},
										"Tags": {
											"shape": "S3k",
											"flattened": true,
											"locationName": "Tag"
										}
									}
								}
							}
						},
						"Status": {},
						"Transitions": {
							"locationName": "Transition",
							"type": "list",
							"member": {
								"shape": "S50"
							},
							"flattened": true
						},
						"NoncurrentVersionTransitions": {
							"locationName": "NoncurrentVersionTransition",
							"type": "list",
							"member": {
								"shape": "S52"
							},
							"flattened": true
						},
						"NoncurrentVersionExpiration": {
							"shape": "S53"
						},
						"AbortIncompleteMultipartUpload": {
							"shape": "S54"
						}
					}
				},
				"flattened": true
			},
			"S5i": {
				"type": "structure",
				"required": [
					"TargetBucket",
					"TargetPrefix"
				],
				"members": {
					"TargetBucket": {},
					"TargetGrants": {
						"type": "list",
						"member": {
							"locationName": "Grant",
							"type": "structure",
							"members": {
								"Grantee": {
									"shape": "S37"
								},
								"Permission": {}
							}
						}
					},
					"TargetPrefix": {}
				}
			},
			"S5q": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {},
					"Filter": {
						"type": "structure",
						"members": {
							"Prefix": {},
							"Tag": {
								"shape": "S3h"
							},
							"And": {
								"type": "structure",
								"members": {
									"Prefix": {},
									"Tags": {
										"shape": "S3k",
										"flattened": true,
										"locationName": "Tag"
									}
								}
							}
						}
					}
				}
			},
			"S5t": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"S5u": {
				"type": "structure",
				"members": {
					"TopicConfiguration": {
						"type": "structure",
						"members": {
							"Id": {},
							"Events": {
								"shape": "S5x",
								"locationName": "Event"
							},
							"Event": {
								"deprecated": true
							},
							"Topic": {}
						}
					},
					"QueueConfiguration": {
						"type": "structure",
						"members": {
							"Id": {},
							"Event": {
								"deprecated": true
							},
							"Events": {
								"shape": "S5x",
								"locationName": "Event"
							},
							"Queue": {}
						}
					},
					"CloudFunctionConfiguration": {
						"type": "structure",
						"members": {
							"Id": {},
							"Event": {
								"deprecated": true
							},
							"Events": {
								"shape": "S5x",
								"locationName": "Event"
							},
							"CloudFunction": {},
							"InvocationRole": {}
						}
					}
				}
			},
			"S5x": {
				"type": "list",
				"member": {},
				"flattened": true
			},
			"S65": {
				"type": "structure",
				"members": {
					"TopicConfigurations": {
						"locationName": "TopicConfiguration",
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"TopicArn",
								"Events"
							],
							"members": {
								"Id": {},
								"TopicArn": {
									"locationName": "Topic"
								},
								"Events": {
									"shape": "S5x",
									"locationName": "Event"
								},
								"Filter": {
									"shape": "S68"
								}
							}
						},
						"flattened": true
					},
					"QueueConfigurations": {
						"locationName": "QueueConfiguration",
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"QueueArn",
								"Events"
							],
							"members": {
								"Id": {},
								"QueueArn": {
									"locationName": "Queue"
								},
								"Events": {
									"shape": "S5x",
									"locationName": "Event"
								},
								"Filter": {
									"shape": "S68"
								}
							}
						},
						"flattened": true
					},
					"LambdaFunctionConfigurations": {
						"locationName": "CloudFunctionConfiguration",
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"LambdaFunctionArn",
								"Events"
							],
							"members": {
								"Id": {},
								"LambdaFunctionArn": {
									"locationName": "CloudFunction"
								},
								"Events": {
									"shape": "S5x",
									"locationName": "Event"
								},
								"Filter": {
									"shape": "S68"
								}
							}
						},
						"flattened": true
					}
				}
			},
			"S68": {
				"type": "structure",
				"members": {
					"Key": {
						"locationName": "S3Key",
						"type": "structure",
						"members": {
							"FilterRules": {
								"locationName": "FilterRule",
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Name": {},
										"Value": {}
									}
								},
								"flattened": true
							}
						}
					}
				}
			},
			"S6s": {
				"type": "structure",
				"required": [
					"Role",
					"Rules"
				],
				"members": {
					"Role": {},
					"Rules": {
						"locationName": "Rule",
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Status",
								"Destination"
							],
							"members": {
								"ID": {},
								"Priority": {
									"type": "integer"
								},
								"Prefix": {
									"deprecated": true
								},
								"Filter": {
									"type": "structure",
									"members": {
										"Prefix": {},
										"Tag": {
											"shape": "S3h"
										},
										"And": {
											"type": "structure",
											"members": {
												"Prefix": {},
												"Tags": {
													"shape": "S3k",
													"flattened": true,
													"locationName": "Tag"
												}
											}
										}
									}
								},
								"Status": {},
								"SourceSelectionCriteria": {
									"type": "structure",
									"members": {
										"SseKmsEncryptedObjects": {
											"type": "structure",
											"required": [
												"Status"
											],
											"members": {
												"Status": {}
											}
										}
									}
								},
								"Destination": {
									"type": "structure",
									"required": [
										"Bucket"
									],
									"members": {
										"Bucket": {},
										"Account": {},
										"StorageClass": {},
										"AccessControlTranslation": {
											"type": "structure",
											"required": [
												"Owner"
											],
											"members": {
												"Owner": {}
											}
										},
										"EncryptionConfiguration": {
											"type": "structure",
											"members": {
												"ReplicaKmsKeyID": {}
											}
										}
									}
								},
								"DeleteMarkerReplication": {
									"type": "structure",
									"members": {
										"Status": {}
									}
								}
							}
						},
						"flattened": true
					}
				}
			},
			"S7l": {
				"type": "structure",
				"required": [
					"HostName"
				],
				"members": {
					"HostName": {},
					"Protocol": {}
				}
			},
			"S7o": {
				"type": "structure",
				"required": [
					"Suffix"
				],
				"members": {
					"Suffix": {}
				}
			},
			"S7q": {
				"type": "structure",
				"required": [
					"Key"
				],
				"members": {
					"Key": {}
				}
			},
			"S7r": {
				"type": "list",
				"member": {
					"locationName": "RoutingRule",
					"type": "structure",
					"required": [
						"Redirect"
					],
					"members": {
						"Condition": {
							"type": "structure",
							"members": {
								"HttpErrorCodeReturnedEquals": {},
								"KeyPrefixEquals": {}
							}
						},
						"Redirect": {
							"type": "structure",
							"members": {
								"HostName": {},
								"HttpRedirectCode": {},
								"Protocol": {},
								"ReplaceKeyPrefixWith": {},
								"ReplaceKeyWith": {}
							}
						}
					}
				}
			},
			"S8q": {
				"type": "structure",
				"members": {
					"Status": {}
				}
			},
			"S8t": {
				"type": "structure",
				"members": {
					"ObjectLockEnabled": {},
					"Rule": {
						"type": "structure",
						"members": {
							"DefaultRetention": {
								"type": "structure",
								"members": {
									"Mode": {},
									"Days": {
										"type": "integer"
									},
									"Years": {
										"type": "integer"
									}
								}
							}
						}
					}
				}
			},
			"S91": {
				"type": "structure",
				"members": {
					"Mode": {},
					"RetainUntilDate": {
						"shape": "S4w"
					}
				}
			},
			"S98": {
				"type": "structure",
				"members": {
					"BlockPublicAcls": {
						"locationName": "BlockPublicAcls",
						"type": "boolean"
					},
					"IgnorePublicAcls": {
						"locationName": "IgnorePublicAcls",
						"type": "boolean"
					},
					"BlockPublicPolicy": {
						"locationName": "BlockPublicPolicy",
						"type": "boolean"
					},
					"RestrictPublicBuckets": {
						"locationName": "RestrictPublicBuckets",
						"type": "boolean"
					}
				}
			},
			"Sa5": {
				"type": "structure",
				"members": {
					"ID": {},
					"DisplayName": {}
				}
			},
			"Sa6": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Prefix": {}
					}
				},
				"flattened": true
			},
			"Sao": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"LastModified": {
							"type": "timestamp"
						},
						"ETag": {},
						"Size": {
							"type": "integer"
						},
						"StorageClass": {},
						"Owner": {
							"shape": "S32"
						}
					}
				},
				"flattened": true
			},
			"Sb6": {
				"type": "structure",
				"members": {
					"Grants": {
						"shape": "S35",
						"locationName": "AccessControlList"
					},
					"Owner": {
						"shape": "S32"
					}
				}
			},
			"Sbt": {
				"type": "structure",
				"required": [
					"TagSet"
				],
				"members": {
					"TagSet": {
						"shape": "S3k"
					}
				}
			},
			"Scj": {
				"type": "structure",
				"members": {
					"CSV": {
						"type": "structure",
						"members": {
							"FileHeaderInfo": {},
							"Comments": {},
							"QuoteEscapeCharacter": {},
							"RecordDelimiter": {},
							"FieldDelimiter": {},
							"QuoteCharacter": {},
							"AllowQuotedRecordDelimiter": {
								"type": "boolean"
							}
						}
					},
					"CompressionType": {},
					"JSON": {
						"type": "structure",
						"members": {
							"Type": {}
						}
					},
					"Parquet": {
						"type": "structure",
						"members": {}
					}
				}
			},
			"Scy": {
				"type": "structure",
				"members": {
					"CSV": {
						"type": "structure",
						"members": {
							"QuoteFields": {},
							"QuoteEscapeCharacter": {},
							"RecordDelimiter": {},
							"FieldDelimiter": {},
							"QuoteCharacter": {}
						}
					},
					"JSON": {
						"type": "structure",
						"members": {
							"RecordDelimiter": {}
						}
					}
				}
			}
		}
	};

/***/ },
/* 495 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListBuckets": {
				"result_key": "Buckets"
			},
			"ListMultipartUploads": {
				"input_token": [
					"KeyMarker",
					"UploadIdMarker"
				],
				"limit_key": "MaxUploads",
				"more_results": "IsTruncated",
				"output_token": [
					"NextKeyMarker",
					"NextUploadIdMarker"
				],
				"result_key": [
					"Uploads",
					"CommonPrefixes"
				]
			},
			"ListObjectVersions": {
				"input_token": [
					"KeyMarker",
					"VersionIdMarker"
				],
				"limit_key": "MaxKeys",
				"more_results": "IsTruncated",
				"output_token": [
					"NextKeyMarker",
					"NextVersionIdMarker"
				],
				"result_key": [
					"Versions",
					"DeleteMarkers",
					"CommonPrefixes"
				]
			},
			"ListObjects": {
				"input_token": "Marker",
				"limit_key": "MaxKeys",
				"more_results": "IsTruncated",
				"output_token": "NextMarker || Contents[-1].Key",
				"result_key": [
					"Contents",
					"CommonPrefixes"
				]
			},
			"ListObjectsV2": {
				"input_token": "ContinuationToken",
				"limit_key": "MaxKeys",
				"output_token": "NextContinuationToken",
				"result_key": [
					"Contents",
					"CommonPrefixes"
				]
			},
			"ListParts": {
				"input_token": "PartNumberMarker",
				"limit_key": "MaxParts",
				"more_results": "IsTruncated",
				"output_token": "NextPartNumberMarker",
				"result_key": "Parts"
			}
		}
	};

/***/ },
/* 496 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"BucketExists": {
				"delay": 5,
				"operation": "HeadBucket",
				"maxAttempts": 20,
				"acceptors": [
					{
						"expected": 200,
						"matcher": "status",
						"state": "success"
					},
					{
						"expected": 301,
						"matcher": "status",
						"state": "success"
					},
					{
						"expected": 403,
						"matcher": "status",
						"state": "success"
					},
					{
						"expected": 404,
						"matcher": "status",
						"state": "retry"
					}
				]
			},
			"BucketNotExists": {
				"delay": 5,
				"operation": "HeadBucket",
				"maxAttempts": 20,
				"acceptors": [
					{
						"expected": 404,
						"matcher": "status",
						"state": "success"
					}
				]
			},
			"ObjectExists": {
				"delay": 5,
				"operation": "HeadObject",
				"maxAttempts": 20,
				"acceptors": [
					{
						"expected": 200,
						"matcher": "status",
						"state": "success"
					},
					{
						"expected": 404,
						"matcher": "status",
						"state": "retry"
					}
				]
			},
			"ObjectNotExists": {
				"delay": 5,
				"operation": "HeadObject",
				"maxAttempts": 20,
				"acceptors": [
					{
						"expected": 404,
						"matcher": "status",
						"state": "success"
					}
				]
			}
		}
	};

/***/ },
/* 497 */
482,
/* 498 */
480,
/* 499 */
484,
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(219);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(219);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 502 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	module.exports = exports['default'];

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(504);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 504 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 505 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 506 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _uncontrollable = __webpack_require__(20);
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _AccordionToggle = _interopRequireDefault(__webpack_require__(224));
	
	var _SelectableContext = _interopRequireDefault(__webpack_require__(25));
	
	var _AccordionCollapse = _interopRequireDefault(__webpack_require__(223));
	
	var _AccordionContext = _interopRequireDefault(__webpack_require__(74));
	
	var _excluded = ["as", "activeKey", "bsPrefix", "children", "className", "onSelect"];
	
	var Accordion = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
	  var _useUncontrolled = (0, _uncontrollable.useUncontrolled)(props, {
	    activeKey: 'onSelect'
	  }),
	      _useUncontrolled$as = _useUncontrolled.as,
	      Component = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as,
	      activeKey = _useUncontrolled.activeKey,
	      bsPrefix = _useUncontrolled.bsPrefix,
	      children = _useUncontrolled.children,
	      className = _useUncontrolled.className,
	      onSelect = _useUncontrolled.onSelect,
	      controlledProps = (0, _objectWithoutPropertiesLoose2.default)(_useUncontrolled, _excluded);
	
	  var finalClassName = (0, _classnames.default)(className, (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'accordion'));
	  return /*#__PURE__*/_react.default.createElement(_AccordionContext.default.Provider, {
	    value: activeKey || null
	  }, /*#__PURE__*/_react.default.createElement(_SelectableContext.default.Provider, {
	    value: onSelect || null
	  }, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, controlledProps, {
	    className: finalClassName
	  }), children)));
	});
	
	Accordion.displayName = 'Accordion';
	Accordion.Toggle = _AccordionToggle.default;
	Accordion.Collapse = _AccordionCollapse.default;
	var _default = Accordion;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _uncontrollable = __webpack_require__(20);
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(18));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _Fade = _interopRequireDefault(__webpack_require__(43));
	
	var _CloseButton = _interopRequireDefault(__webpack_require__(76));
	
	var _divWithClassName = _interopRequireDefault(__webpack_require__(128));
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(35));
	
	var _excluded = ["bsPrefix", "show", "closeLabel", "className", "children", "variant", "onClose", "dismissible", "transition"];
	var DivStyledAsH4 = (0, _divWithClassName.default)('h4');
	DivStyledAsH4.displayName = 'DivStyledAsH4';
	var AlertHeading = (0, _createWithBsPrefix.default)('alert-heading', {
	  Component: DivStyledAsH4
	});
	var AlertLink = (0, _createWithBsPrefix.default)('alert-link', {
	  Component: _SafeAnchor.default
	});
	var defaultProps = {
	  show: true,
	  transition: _Fade.default,
	  closeLabel: 'Close alert'
	};
	
	var Alert = /*#__PURE__*/_react.default.forwardRef(function (uncontrolledProps, ref) {
	  var _useUncontrolled = (0, _uncontrollable.useUncontrolled)(uncontrolledProps, {
	    show: 'onClose'
	  }),
	      bsPrefix = _useUncontrolled.bsPrefix,
	      show = _useUncontrolled.show,
	      closeLabel = _useUncontrolled.closeLabel,
	      className = _useUncontrolled.className,
	      children = _useUncontrolled.children,
	      variant = _useUncontrolled.variant,
	      onClose = _useUncontrolled.onClose,
	      dismissible = _useUncontrolled.dismissible,
	      transition = _useUncontrolled.transition,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_useUncontrolled, _excluded);
	
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'alert');
	  var handleClose = (0, _useEventCallback.default)(function (e) {
	    if (onClose) {
	      onClose(false, e);
	    }
	  });
	  var Transition = transition === true ? _Fade.default : transition;
	
	  var alert = /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
	    role: "alert"
	  }, !Transition ? props : undefined, {
	    ref: ref,
	    className: (0, _classnames.default)(className, prefix, variant && prefix + "-" + variant, dismissible && prefix + "-dismissible")
	  }), dismissible && /*#__PURE__*/_react.default.createElement(_CloseButton.default, {
	    onClick: handleClose,
	    label: closeLabel
	  }), children);
	
	  if (!Transition) return show ? alert : null;
	  return /*#__PURE__*/_react.default.createElement(Transition, (0, _extends2.default)({
	    unmountOnExit: true
	  }, props, {
	    ref: undefined,
	    in: show
	  }), alert);
	});
	
	Alert.displayName = 'Alert';
	Alert.defaultProps = defaultProps;
	Alert.Link = AlertLink;
	Alert.Heading = AlertHeading;
	var _default = Alert;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "variant", "pill", "className", "as"];
	var defaultProps = {
	  pill: false
	};
	
	var Badge = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      variant = _ref.variant,
	      pill = _ref.pill,
	      className = _ref.className,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'span' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'badge');
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(className, prefix, pill && prefix + "-pill", variant && prefix + "-" + variant)
	  }));
	});
	
	Badge.displayName = 'Badge';
	Badge.defaultProps = defaultProps;
	var _default = Badge;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(38));
	
	var _css3 = _interopRequireDefault(__webpack_require__(50));
	
	var _querySelectorAll = _interopRequireDefault(__webpack_require__(99));
	
	var _scrollbarSize = _interopRequireDefault(__webpack_require__(100));
	
	var _ModalManager2 = _interopRequireDefault(__webpack_require__(262));
	
	var Selector = {
	  FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
	  STICKY_CONTENT: '.sticky-top',
	  NAVBAR_TOGGLER: '.navbar-toggler'
	};
	
	var BootstrapModalManager = /*#__PURE__*/function (_ModalManager) {
	  (0, _inheritsLoose2.default)(BootstrapModalManager, _ModalManager);
	
	  function BootstrapModalManager() {
	    return _ModalManager.apply(this, arguments) || this;
	  }
	
	  var _proto = BootstrapModalManager.prototype;
	
	  _proto.adjustAndStore = function adjustAndStore(prop, element, adjust) {
	    var _css;
	
	    var actual = element.style[prop]; // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
	    // @ts-ignore
	
	    element.dataset[prop] = actual;
	    (0, _css3.default)(element, (_css = {}, _css[prop] = parseFloat((0, _css3.default)(element, prop)) + adjust + "px", _css));
	  };
	
	  _proto.restore = function restore(prop, element) {
	    var value = element.dataset[prop];
	
	    if (value !== undefined) {
	      var _css2;
	
	      delete element.dataset[prop];
	      (0, _css3.default)(element, (_css2 = {}, _css2[prop] = value, _css2));
	    }
	  };
	
	  _proto.setContainerStyle = function setContainerStyle(containerState, container) {
	    var _this = this;
	
	    _ModalManager.prototype.setContainerStyle.call(this, containerState, container);
	
	    if (!containerState.overflowing) return;
	    var size = (0, _scrollbarSize.default)();
	    (0, _querySelectorAll.default)(container, Selector.FIXED_CONTENT).forEach(function (el) {
	      return _this.adjustAndStore('paddingRight', el, size);
	    });
	    (0, _querySelectorAll.default)(container, Selector.STICKY_CONTENT).forEach(function (el) {
	      return _this.adjustAndStore('marginRight', el, -size);
	    });
	    (0, _querySelectorAll.default)(container, Selector.NAVBAR_TOGGLER).forEach(function (el) {
	      return _this.adjustAndStore('marginRight', el, size);
	    });
	  };
	
	  _proto.removeContainerStyle = function removeContainerStyle(containerState, container) {
	    var _this2 = this;
	
	    _ModalManager.prototype.removeContainerStyle.call(this, containerState, container);
	
	    (0, _querySelectorAll.default)(container, Selector.FIXED_CONTENT).forEach(function (el) {
	      return _this2.restore('paddingRight', el);
	    });
	    (0, _querySelectorAll.default)(container, Selector.STICKY_CONTENT).forEach(function (el) {
	      return _this2.restore('marginRight', el);
	    });
	    (0, _querySelectorAll.default)(container, Selector.NAVBAR_TOGGLER).forEach(function (el) {
	      return _this2.restore('marginRight', el);
	    });
	  };
	
	  return BootstrapModalManager;
	}(_ModalManager2.default);
	
	exports.default = BootstrapModalManager;
	module.exports = exports["default"];

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(225));
	
	var _excluded = ["bsPrefix", "className", "listProps", "children", "label", "as"];
	var defaultProps = {
	  label: 'breadcrumb',
	  listProps: {}
	};
	
	var Breadcrumb = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      listProps = _ref.listProps,
	      children = _ref.children,
	      label = _ref.label,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'nav' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'breadcrumb');
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    "aria-label": label,
	    className: className,
	    ref: ref
	  }, props), /*#__PURE__*/_react.default.createElement("ol", (0, _extends2.default)({}, listProps, {
	    className: (0, _classnames.default)(prefix, listProps == null ? void 0 : listProps.className)
	  }), children));
	});
	
	Breadcrumb.displayName = 'Breadcrumb';
	Breadcrumb.defaultProps = defaultProps;
	Breadcrumb.Item = _BreadcrumbItem.default;
	var _default = Breadcrumb;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "className"];
	var defaultProps = {
	  role: 'toolbar'
	};
	
	var ButtonToolbar = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'btn-toolbar');
	  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(className, prefix)
	  }));
	});
	
	ButtonToolbar.displayName = 'ButtonToolbar';
	ButtonToolbar.defaultProps = defaultProps;
	var _default = ButtonToolbar;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var _divWithClassName = _interopRequireDefault(__webpack_require__(128));
	
	var _CardContext = _interopRequireDefault(__webpack_require__(226));
	
	var _CardImg = _interopRequireDefault(__webpack_require__(227));
	
	var _excluded = ["bsPrefix", "className", "bg", "text", "border", "body", "children", "as"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var DivStyledAsH5 = (0, _divWithClassName.default)('h5');
	var DivStyledAsH6 = (0, _divWithClassName.default)('h6');
	var CardBody = (0, _createWithBsPrefix.default)('card-body');
	var CardTitle = (0, _createWithBsPrefix.default)('card-title', {
	  Component: DivStyledAsH5
	});
	var CardSubtitle = (0, _createWithBsPrefix.default)('card-subtitle', {
	  Component: DivStyledAsH6
	});
	var CardLink = (0, _createWithBsPrefix.default)('card-link', {
	  Component: 'a'
	});
	var CardText = (0, _createWithBsPrefix.default)('card-text', {
	  Component: 'p'
	});
	var CardHeader = (0, _createWithBsPrefix.default)('card-header');
	var CardFooter = (0, _createWithBsPrefix.default)('card-footer');
	var CardImgOverlay = (0, _createWithBsPrefix.default)('card-img-overlay');
	var defaultProps = {
	  body: false
	};
	
	var Card = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      bg = _ref.bg,
	      text = _ref.text,
	      border = _ref.border,
	      body = _ref.body,
	      children = _ref.children,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'card');
	  var cardContext = (0, _react.useMemo)(function () {
	    return {
	      cardHeaderBsPrefix: prefix + "-header"
	    };
	  }, [prefix]);
	  return /*#__PURE__*/_react.default.createElement(_CardContext.default.Provider, {
	    value: cardContext
	  }, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(className, prefix, bg && "bg-" + bg, text && "text-" + text, border && "border-" + border)
	  }), body ?
	  /*#__PURE__*/
	  // @ts-ignore
	  _react.default.createElement(CardBody, null, children) : children));
	});
	
	Card.displayName = 'Card';
	Card.defaultProps = defaultProps;
	Card.Img = _CardImg.default;
	Card.Title = CardTitle;
	Card.Subtitle = CardSubtitle;
	Card.Body = CardBody;
	Card.Link = CardLink;
	Card.Text = CardText;
	Card.Header = CardHeader;
	Card.Footer = CardFooter;
	Card.ImgOverlay = CardImgOverlay;
	var _default = Card;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var _default = (0, _createWithBsPrefix.default)('card-columns');
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var _default = (0, _createWithBsPrefix.default)('card-deck');
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var _default = (0, _createWithBsPrefix.default)('card-group');
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(18));
	
	var _useUpdateEffect = _interopRequireDefault(__webpack_require__(357));
	
	var _useCommittedRef = _interopRequireDefault(__webpack_require__(160));
	
	var _useTimeout = _interopRequireDefault(__webpack_require__(90));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _Transition = _interopRequireDefault(__webpack_require__(134));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _uncontrollable = __webpack_require__(20);
	
	var _CarouselCaption = _interopRequireDefault(__webpack_require__(518));
	
	var _CarouselItem = _interopRequireDefault(__webpack_require__(228));
	
	var _ElementChildren = __webpack_require__(78);
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(35));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _transitionEndListener = _interopRequireDefault(__webpack_require__(129));
	
	var _triggerBrowserReflow = _interopRequireDefault(__webpack_require__(130));
	
	var _excluded = ["as", "bsPrefix", "slide", "fade", "controls", "indicators", "activeIndex", "onSelect", "onSlide", "onSlid", "interval", "keyboard", "onKeyDown", "pause", "onMouseOver", "onMouseOut", "wrap", "touch", "onTouchStart", "onTouchMove", "onTouchEnd", "prevIcon", "prevLabel", "nextIcon", "nextLabel", "className", "children"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var SWIPE_THRESHOLD = 40;
	var propTypes = {
	  /**
	   * @default 'carousel'
	   */
	  bsPrefix: _propTypes.default.string,
	  as: _propTypes.default.elementType,
	
	  /**
	   * Enables animation on the Carousel as it transitions between slides.
	   */
	  slide: _propTypes.default.bool,
	
	  /** Animates slides with a crossfade animation instead of the default slide animation */
	  fade: _propTypes.default.bool,
	
	  /**
	   * Show the Carousel previous and next arrows for changing the current slide
	   */
	  controls: _propTypes.default.bool,
	
	  /**
	   * Show a set of slide position indicators
	   */
	  indicators: _propTypes.default.bool,
	
	  /**
	   * Controls the current visible slide
	   *
	   * @controllable onSelect
	   */
	  activeIndex: _propTypes.default.number,
	
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: number, event: Object | null) => void
	   * ```
	   *
	   * @controllable activeIndex
	   */
	  onSelect: _propTypes.default.func,
	
	  /**
	   * Callback fired when a slide transition starts.
	   *
	   * ```js
	   * (eventKey: number, direction: 'left' | 'right') => void
	   */
	  onSlide: _propTypes.default.func,
	
	  /**
	   * Callback fired when a slide transition ends.
	   *
	   * ```js
	   * (eventKey: number, direction: 'left' | 'right') => void
	   */
	  onSlid: _propTypes.default.func,
	
	  /**
	   * The amount of time to delay between automatically cycling an item. If `null`, carousel will not automatically cycle.
	   */
	  interval: _propTypes.default.number,
	
	  /** Whether the carousel should react to keyboard events. */
	  keyboard: _propTypes.default.bool,
	
	  /**
	   * If set to `"hover"`, pauses the cycling of the carousel on `mouseenter` and resumes the cycling of the carousel on `mouseleave`. If set to `false`, hovering over the carousel won't pause it.
	   *
	   * On touch-enabled devices, when set to `"hover"`, cycling will pause on `touchend` (once the user finished interacting with the carousel) for two intervals, before automatically resuming. Note that this is in addition to the above mouse behavior.
	   */
	  pause: _propTypes.default.oneOf(['hover', false]),
	
	  /** Whether the carousel should cycle continuously or have hard stops. */
	  wrap: _propTypes.default.bool,
	
	  /**
	   * Whether the carousel should support left/right swipe interactions on touchscreen devices.
	   */
	  touch: _propTypes.default.bool,
	
	  /** Override the default button icon for the "previous" control */
	  prevIcon: _propTypes.default.node,
	
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _propTypes.default.string,
	
	  /** Override the default button icon for the "next" control */
	  nextIcon: _propTypes.default.node,
	
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _propTypes.default.string
	};
	var defaultProps = {
	  slide: true,
	  fade: false,
	  controls: true,
	  indicators: true,
	  defaultActiveIndex: 0,
	  interval: 5000,
	  keyboard: true,
	  pause: 'hover',
	  wrap: true,
	  touch: true,
	  prevIcon: /*#__PURE__*/_react.default.createElement("span", {
	    "aria-hidden": "true",
	    className: "carousel-control-prev-icon"
	  }),
	  prevLabel: 'Previous',
	  nextIcon: /*#__PURE__*/_react.default.createElement("span", {
	    "aria-hidden": "true",
	    className: "carousel-control-next-icon"
	  }),
	  nextLabel: 'Next'
	};
	
	function isVisible(element) {
	  if (!element || !element.style || !element.parentNode || !element.parentNode.style) {
	    return false;
	  }
	
	  var elementStyle = getComputedStyle(element);
	  return elementStyle.display !== 'none' && elementStyle.visibility !== 'hidden' && getComputedStyle(element.parentNode).display !== 'none';
	}
	
	function CarouselFunc(uncontrolledProps, ref) {
	  var _useUncontrolled = (0, _uncontrollable.useUncontrolled)(uncontrolledProps, {
	    activeIndex: 'onSelect'
	  }),
	      _useUncontrolled$as = _useUncontrolled.as,
	      Component = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as,
	      bsPrefix = _useUncontrolled.bsPrefix,
	      slide = _useUncontrolled.slide,
	      fade = _useUncontrolled.fade,
	      controls = _useUncontrolled.controls,
	      indicators = _useUncontrolled.indicators,
	      activeIndex = _useUncontrolled.activeIndex,
	      onSelect = _useUncontrolled.onSelect,
	      onSlide = _useUncontrolled.onSlide,
	      onSlid = _useUncontrolled.onSlid,
	      interval = _useUncontrolled.interval,
	      keyboard = _useUncontrolled.keyboard,
	      onKeyDown = _useUncontrolled.onKeyDown,
	      pause = _useUncontrolled.pause,
	      onMouseOver = _useUncontrolled.onMouseOver,
	      onMouseOut = _useUncontrolled.onMouseOut,
	      wrap = _useUncontrolled.wrap,
	      touch = _useUncontrolled.touch,
	      onTouchStart = _useUncontrolled.onTouchStart,
	      onTouchMove = _useUncontrolled.onTouchMove,
	      onTouchEnd = _useUncontrolled.onTouchEnd,
	      prevIcon = _useUncontrolled.prevIcon,
	      prevLabel = _useUncontrolled.prevLabel,
	      nextIcon = _useUncontrolled.nextIcon,
	      nextLabel = _useUncontrolled.nextLabel,
	      className = _useUncontrolled.className,
	      children = _useUncontrolled.children,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_useUncontrolled, _excluded);
	
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'carousel');
	  var nextDirectionRef = (0, _react.useRef)(null);
	
	  var _useState = (0, _react.useState)('next'),
	      direction = _useState[0],
	      setDirection = _useState[1];
	
	  var _useState2 = (0, _react.useState)(false),
	      paused = _useState2[0],
	      setPaused = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      isSliding = _useState3[0],
	      setIsSliding = _useState3[1];
	
	  var _useState4 = (0, _react.useState)(activeIndex || 0),
	      renderedActiveIndex = _useState4[0],
	      setRenderedActiveIndex = _useState4[1];
	
	  if (!isSliding && activeIndex !== renderedActiveIndex) {
	    if (nextDirectionRef.current) {
	      setDirection(nextDirectionRef.current);
	    } else {
	      setDirection((activeIndex || 0) > renderedActiveIndex ? 'next' : 'prev');
	    }
	
	    if (slide) {
	      setIsSliding(true);
	    }
	
	    setRenderedActiveIndex(activeIndex || 0);
	  }
	
	  (0, _react.useEffect)(function () {
	    if (nextDirectionRef.current) {
	      nextDirectionRef.current = null;
	    }
	  });
	  var numChildren = 0;
	  var activeChildInterval; // Iterate to grab all of the children's interval values
	  // (and count them, too)
	
	  (0, _ElementChildren.forEach)(children, function (child, index) {
	    ++numChildren;
	
	    if (index === activeIndex) {
	      activeChildInterval = child.props.interval;
	    }
	  });
	  var activeChildIntervalRef = (0, _useCommittedRef.default)(activeChildInterval);
	  var prev = (0, _react.useCallback)(function (event) {
	    if (isSliding) {
	      return;
	    }
	
	    var nextActiveIndex = renderedActiveIndex - 1;
	
	    if (nextActiveIndex < 0) {
	      if (!wrap) {
	        return;
	      }
	
	      nextActiveIndex = numChildren - 1;
	    }
	
	    nextDirectionRef.current = 'prev';
	
	    if (onSelect) {
	      onSelect(nextActiveIndex, event);
	    }
	  }, [isSliding, renderedActiveIndex, onSelect, wrap, numChildren]); // This is used in the setInterval, so it should not invalidate.
	
	  var next = (0, _useEventCallback.default)(function (event) {
	    if (isSliding) {
	      return;
	    }
	
	    var nextActiveIndex = renderedActiveIndex + 1;
	
	    if (nextActiveIndex >= numChildren) {
	      if (!wrap) {
	        return;
	      }
	
	      nextActiveIndex = 0;
	    }
	
	    nextDirectionRef.current = 'next';
	
	    if (onSelect) {
	      onSelect(nextActiveIndex, event);
	    }
	  });
	  var elementRef = (0, _react.useRef)();
	  (0, _react.useImperativeHandle)(ref, function () {
	    return {
	      element: elementRef.current,
	      prev: prev,
	      next: next
	    };
	  }); // This is used in the setInterval, so it should not invalidate.
	
	  var nextWhenVisible = (0, _useEventCallback.default)(function () {
	    if (!document.hidden && isVisible(elementRef.current)) {
	      next();
	    }
	  });
	  var slideDirection = direction === 'next' ? 'left' : 'right';
	  (0, _useUpdateEffect.default)(function () {
	    if (slide) {
	      // These callbacks will be handled by the <Transition> callbacks.
	      return;
	    }
	
	    if (onSlide) {
	      onSlide(renderedActiveIndex, slideDirection);
	    }
	
	    if (onSlid) {
	      onSlid(renderedActiveIndex, slideDirection);
	    }
	  }, [renderedActiveIndex]);
	  var orderClassName = prefix + "-item-" + direction;
	  var directionalClassName = prefix + "-item-" + slideDirection;
	  var handleEnter = (0, _react.useCallback)(function (node) {
	    (0, _triggerBrowserReflow.default)(node);
	
	    if (onSlide) {
	      onSlide(renderedActiveIndex, slideDirection);
	    }
	  }, [onSlide, renderedActiveIndex, slideDirection]);
	  var handleEntered = (0, _react.useCallback)(function () {
	    setIsSliding(false);
	
	    if (onSlid) {
	      onSlid(renderedActiveIndex, slideDirection);
	    }
	  }, [onSlid, renderedActiveIndex, slideDirection]);
	  var handleKeyDown = (0, _react.useCallback)(function (event) {
	    if (keyboard && !/input|textarea/i.test(event.target.tagName)) {
	      switch (event.key) {
	        case 'ArrowLeft':
	          event.preventDefault();
	          prev(event);
	          return;
	
	        case 'ArrowRight':
	          event.preventDefault();
	          next(event);
	          return;
	
	        default:
	      }
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    }
	  }, [keyboard, onKeyDown, prev, next]);
	  var handleMouseOver = (0, _react.useCallback)(function (event) {
	    if (pause === 'hover') {
	      setPaused(true);
	    }
	
	    if (onMouseOver) {
	      onMouseOver(event);
	    }
	  }, [pause, onMouseOver]);
	  var handleMouseOut = (0, _react.useCallback)(function (event) {
	    setPaused(false);
	
	    if (onMouseOut) {
	      onMouseOut(event);
	    }
	  }, [onMouseOut]);
	  var touchStartXRef = (0, _react.useRef)(0);
	  var touchDeltaXRef = (0, _react.useRef)(0);
	  var touchUnpauseTimeout = (0, _useTimeout.default)();
	  var handleTouchStart = (0, _react.useCallback)(function (event) {
	    touchStartXRef.current = event.touches[0].clientX;
	    touchDeltaXRef.current = 0;
	
	    if (pause === 'hover') {
	      setPaused(true);
	    }
	
	    if (onTouchStart) {
	      onTouchStart(event);
	    }
	  }, [pause, onTouchStart]);
	  var handleTouchMove = (0, _react.useCallback)(function (event) {
	    if (event.touches && event.touches.length > 1) {
	      touchDeltaXRef.current = 0;
	    } else {
	      touchDeltaXRef.current = event.touches[0].clientX - touchStartXRef.current;
	    }
	
	    if (onTouchMove) {
	      onTouchMove(event);
	    }
	  }, [onTouchMove]);
	  var handleTouchEnd = (0, _react.useCallback)(function (event) {
	    if (touch) {
	      var touchDeltaX = touchDeltaXRef.current;
	
	      if (Math.abs(touchDeltaX) > SWIPE_THRESHOLD) {
	        if (touchDeltaX > 0) {
	          prev(event);
	        } else {
	          next(event);
	        }
	      }
	    }
	
	    if (pause === 'hover') {
	      touchUnpauseTimeout.set(function () {
	        setPaused(false);
	      }, interval || undefined);
	    }
	
	    if (onTouchEnd) {
	      onTouchEnd(event);
	    }
	  }, [touch, pause, prev, next, touchUnpauseTimeout, interval, onTouchEnd]);
	  var shouldPlay = interval != null && !paused && !isSliding;
	  var intervalHandleRef = (0, _react.useRef)();
	  (0, _react.useEffect)(function () {
	    var _ref, _activeChildIntervalR;
	
	    if (!shouldPlay) {
	      return undefined;
	    }
	
	    intervalHandleRef.current = window.setInterval(document.visibilityState ? nextWhenVisible : next, (_ref = (_activeChildIntervalR = activeChildIntervalRef.current) != null ? _activeChildIntervalR : interval) != null ? _ref : undefined);
	    return function () {
	      if (intervalHandleRef.current !== null) {
	        clearInterval(intervalHandleRef.current);
	      }
	    };
	  }, [shouldPlay, next, activeChildIntervalRef, interval, nextWhenVisible]);
	  var indicatorOnClicks = (0, _react.useMemo)(function () {
	    return indicators && Array.from({
	      length: numChildren
	    }, function (_, index) {
	      return function (event) {
	        if (onSelect) {
	          onSelect(index, event);
	        }
	      };
	    });
	  }, [indicators, numChildren, onSelect]);
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: elementRef
	  }, props, {
	    onKeyDown: handleKeyDown,
	    onMouseOver: handleMouseOver,
	    onMouseOut: handleMouseOut,
	    onTouchStart: handleTouchStart,
	    onTouchMove: handleTouchMove,
	    onTouchEnd: handleTouchEnd,
	    className: (0, _classnames.default)(className, prefix, slide && 'slide', fade && prefix + "-fade")
	  }), indicators && /*#__PURE__*/_react.default.createElement("ol", {
	    className: prefix + "-indicators"
	  }, (0, _ElementChildren.map)(children, function (_child, index) {
	    return /*#__PURE__*/_react.default.createElement("li", {
	      key: index,
	      className: index === renderedActiveIndex ? 'active' : undefined,
	      onClick: indicatorOnClicks ? indicatorOnClicks[index] : undefined
	    });
	  })), /*#__PURE__*/_react.default.createElement("div", {
	    className: prefix + "-inner"
	  }, (0, _ElementChildren.map)(children, function (child, index) {
	    var isActive = index === renderedActiveIndex;
	    return slide ? /*#__PURE__*/_react.default.createElement(_Transition.default, {
	      in: isActive,
	      onEnter: isActive ? handleEnter : undefined,
	      onEntered: isActive ? handleEntered : undefined,
	      addEndListener: _transitionEndListener.default
	    }, function (status) {
	      return /*#__PURE__*/_react.default.cloneElement(child, {
	        className: (0, _classnames.default)(child.props.className, isActive && status !== 'entered' && orderClassName, (status === 'entered' || status === 'exiting') && 'active', (status === 'entering' || status === 'exiting') && directionalClassName)
	      });
	    }) : /*#__PURE__*/_react.default.cloneElement(child, {
	      className: (0, _classnames.default)(child.props.className, isActive && 'active')
	    });
	  })), controls && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (wrap || activeIndex !== 0) && /*#__PURE__*/_react.default.createElement(_SafeAnchor.default, {
	    className: prefix + "-control-prev",
	    onClick: prev
	  }, prevIcon, prevLabel && /*#__PURE__*/_react.default.createElement("span", {
	    className: "sr-only"
	  }, prevLabel)), (wrap || activeIndex !== numChildren - 1) && /*#__PURE__*/_react.default.createElement(_SafeAnchor.default, {
	    className: prefix + "-control-next",
	    onClick: next
	  }, nextIcon, nextLabel && /*#__PURE__*/_react.default.createElement("span", {
	    className: "sr-only"
	  }, nextLabel))));
	}
	
	var Carousel = /*#__PURE__*/_react.default.forwardRef(CarouselFunc);
	
	Carousel.displayName = 'Carousel';
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	Carousel.Caption = _CarouselCaption.default;
	Carousel.Item = _CarouselItem.default;
	var _default = Carousel;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var _default = (0, _createWithBsPrefix.default)('carousel-caption');
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "fluid", "as", "className"];
	var defaultProps = {
	  fluid: false
	};
	
	var Container = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      fluid = _ref.fluid,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      className = _ref.className,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'container');
	  var suffix = typeof fluid === 'string' ? "-" + fluid : '-fluid';
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(className, fluid ? "" + prefix + suffix : prefix)
	  }));
	});
	
	Container.displayName = 'Container';
	Container.defaultProps = defaultProps;
	var _default = Container;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(77));
	
	var _DropdownToggle = _interopRequireDefault(__webpack_require__(230));
	
	var _DropdownMenu = _interopRequireWildcard(__webpack_require__(118));
	
	var _excluded = ["title", "children", "bsPrefix", "rootCloseEvent", "variant", "size", "menuAlign", "menuRole", "renderMenuOnMount", "disabled", "href", "id"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var propTypes = {
	  /**
	   * An html id attribute for the Toggle button, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: _propTypes.default.any,
	
	  /** An `href` passed to the Toggle component */
	  href: _propTypes.default.string,
	
	  /** An `onClick` handler passed to the Toggle component */
	  onClick: _propTypes.default.func,
	
	  /** The content of the non-toggle Button.  */
	  title: _propTypes.default.node.isRequired,
	
	  /** Disables both Buttons  */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Aligns the dropdown menu responsively.
	   *
	   * _see [DropdownMenu](#dropdown-menu-props) for more details_
	   *
	   * @type {"left"|"right"|{ sm: "left"|"right" }|{ md: "left"|"right" }|{ lg: "left"|"right" }|{ xl: "left"|"right"} }
	   */
	  menuAlign: _DropdownMenu.alignPropType,
	
	  /** An ARIA accessible role applied to the Menu component. When set to 'menu', The dropdown */
	  menuRole: _propTypes.default.string,
	
	  /** Whether to render the dropdown menu in the DOM before the first time it is shown */
	  renderMenuOnMount: _propTypes.default.bool,
	
	  /**
	   *  Which event when fired outside the component will cause it to be closed.
	   *
	   * _see [DropdownMenu](#dropdown-menu-props) for more details_
	   */
	  rootCloseEvent: _propTypes.default.string,
	
	  /** @ignore */
	  bsPrefix: _propTypes.default.string,
	
	  /** @ignore */
	  variant: _propTypes.default.string,
	
	  /** @ignore */
	  size: _propTypes.default.string
	};
	/**
	 * A convenience component for simple or general use dropdowns. Renders a `Button` toggle and all `children`
	 * are passed directly to the default `Dropdown.Menu`. This component accepts all of
	 * [`Dropdown`'s props](#dropdown-props).
	 *
	 * _All unknown props are passed through to the `Dropdown` component._ Only
	 * the Button `variant`, `size` and `bsPrefix` props are passed to the toggle,
	 * along with menu-related props are passed to the `Dropdown.Menu`
	 */
	
	var DropdownButton = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var title = _ref.title,
	      children = _ref.children,
	      bsPrefix = _ref.bsPrefix,
	      rootCloseEvent = _ref.rootCloseEvent,
	      variant = _ref.variant,
	      size = _ref.size,
	      menuAlign = _ref.menuAlign,
	      menuRole = _ref.menuRole,
	      renderMenuOnMount = _ref.renderMenuOnMount,
	      disabled = _ref.disabled,
	      href = _ref.href,
	      id = _ref.id,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  return /*#__PURE__*/_react.default.createElement(_Dropdown.default, (0, _extends2.default)({
	    ref: ref
	  }, props), /*#__PURE__*/_react.default.createElement(_DropdownToggle.default, {
	    id: id,
	    href: href,
	    size: size,
	    variant: variant,
	    disabled: disabled,
	    childBsPrefix: bsPrefix
	  }, title), /*#__PURE__*/_react.default.createElement(_DropdownMenu.default, {
	    align: menuAlign,
	    role: menuRole,
	    renderOnMount: renderMenuOnMount,
	    rootCloseEvent: rootCloseEvent
	  }, children));
	});
	
	DropdownButton.displayName = 'DropdownButton';
	DropdownButton.propTypes = propTypes;
	var _default = DropdownButton;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(18));
	
	var _SelectableContext = _interopRequireWildcard(__webpack_require__(25));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _NavContext = _interopRequireDefault(__webpack_require__(121));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(35));
	
	var _excluded = ["bsPrefix", "className", "children", "eventKey", "disabled", "href", "onClick", "onSelect", "active", "as"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var defaultProps = {
	  as: _SafeAnchor.default,
	  disabled: false
	};
	
	var DropdownItem = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      children = _ref.children,
	      eventKey = _ref.eventKey,
	      disabled = _ref.disabled,
	      href = _ref.href,
	      onClick = _ref.onClick,
	      onSelect = _ref.onSelect,
	      propActive = _ref.active,
	      Component = _ref.as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-item');
	  var onSelectCtx = (0, _react.useContext)(_SelectableContext.default);
	  var navContext = (0, _react.useContext)(_NavContext.default);
	
	  var _ref2 = navContext || {},
	      activeKey = _ref2.activeKey;
	
	  var key = (0, _SelectableContext.makeEventKey)(eventKey, href);
	  var active = propActive == null && key != null ? (0, _SelectableContext.makeEventKey)(activeKey) === key : propActive;
	  var handleClick = (0, _useEventCallback.default)(function (event) {
	    // SafeAnchor handles the disabled case, but we handle it here
	    // for other components
	    if (disabled) return;
	    if (onClick) onClick(event);
	    if (onSelectCtx) onSelectCtx(key, event);
	    if (onSelect) onSelect(key, event);
	  });
	  return (
	    /*#__PURE__*/
	    // "TS2604: JSX element type 'Component' does not have any construct or call signatures."
	    // @ts-ignore
	    _react.default.createElement(Component, (0, _extends2.default)({}, props, {
	      ref: ref,
	      href: href,
	      disabled: disabled,
	      className: (0, _classnames.default)(className, prefix, active && 'active', disabled && 'disabled'),
	      onClick: handleClick
	    }), children)
	  );
	});
	
	DropdownItem.displayName = 'DropdownItem';
	DropdownItem.defaultProps = defaultProps;
	var _default = DropdownItem;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var _FigureImage = _interopRequireDefault(__webpack_require__(524));
	
	var _FigureCaption = _interopRequireDefault(__webpack_require__(523));
	
	var Figure = (0, _createWithBsPrefix.default)('figure', {
	  Component: 'figure'
	});
	Figure.Image = _FigureImage.default;
	Figure.Caption = _FigureCaption.default;
	var _default = Figure;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var FigureCaption = (0, _createWithBsPrefix.default)('figure-caption', {
	  Component: 'figcaption'
	});
	var _default = FigureCaption;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _Image = _interopRequireWildcard(__webpack_require__(236));
	
	var _excluded = ["className"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var defaultProps = {
	  fluid: true
	};
	
	var FigureImage = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var className = _ref.className,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  return /*#__PURE__*/_react.default.createElement(_Image.default, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(className, 'figure-img')
	  }));
	});
	
	FigureImage.displayName = 'FigureImage';
	FigureImage.propTypes = _Image.propTypes;
	FigureImage.defaultProps = defaultProps;
	var _default = FigureImage;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _FormCheck = _interopRequireDefault(__webpack_require__(120));
	
	var _FormFile = _interopRequireDefault(__webpack_require__(232));
	
	var _FormControl = _interopRequireDefault(__webpack_require__(231));
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(233));
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(234));
	
	var _FormText = _interopRequireDefault(__webpack_require__(235));
	
	var _Switch = _interopRequireDefault(__webpack_require__(548));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var _excluded = ["bsPrefix", "inline", "className", "validated", "as"];
	var FormRow = (0, _createWithBsPrefix.default)('form-row');
	var defaultProps = {
	  inline: false
	};
	
	var FormImpl = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      inline = _ref.inline,
	      className = _ref.className,
	      validated = _ref.validated,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'form' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'form');
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(className, validated && 'was-validated', inline && bsPrefix + "-inline")
	  }));
	});
	
	FormImpl.displayName = 'Form';
	FormImpl.defaultProps = defaultProps;
	FormImpl.Row = FormRow;
	FormImpl.Group = _FormGroup.default;
	FormImpl.Control = _FormControl.default;
	FormImpl.Check = _FormCheck.default;
	FormImpl.File = _FormFile.default;
	FormImpl.Switch = _Switch.default;
	FormImpl.Label = _FormLabel.default;
	FormImpl.Text = _FormText.default;
	var _default = FormImpl;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(30));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["id", "bsPrefix", "bsCustomPrefix", "className", "type", "isValid", "isInvalid", "isStatic", "as"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var FormCheckInput = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var id = _ref.id,
	      bsPrefix = _ref.bsPrefix,
	      bsCustomPrefix = _ref.bsCustomPrefix,
	      className = _ref.className,
	      _ref$type = _ref.type,
	      type = _ref$type === void 0 ? 'checkbox' : _ref$type,
	      _ref$isValid = _ref.isValid,
	      isValid = _ref$isValid === void 0 ? false : _ref$isValid,
	      _ref$isInvalid = _ref.isInvalid,
	      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
	      isStatic = _ref.isStatic,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'input' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	
	  var _useContext = (0, _react.useContext)(_FormContext.default),
	      controlId = _useContext.controlId,
	      custom = _useContext.custom;
	
	  var _ref2 = custom ? [bsCustomPrefix, 'custom-control-input'] : [bsPrefix, 'form-check-input'],
	      prefix = _ref2[0],
	      defaultPrefix = _ref2[1];
	
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(prefix, defaultPrefix);
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    type: type,
	    id: id || controlId,
	    className: (0, _classnames.default)(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid', isStatic && 'position-static')
	  }));
	});
	
	FormCheckInput.displayName = 'FormCheckInput';
	var _default = FormCheckInput;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(30));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "bsCustomPrefix", "className", "htmlFor"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var FormCheckLabel = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      bsCustomPrefix = _ref.bsCustomPrefix,
	      className = _ref.className,
	      htmlFor = _ref.htmlFor,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	
	  var _useContext = (0, _react.useContext)(_FormContext.default),
	      controlId = _useContext.controlId,
	      custom = _useContext.custom;
	
	  var _ref2 = custom ? [bsCustomPrefix, 'custom-control-label'] : [bsPrefix, 'form-check-label'],
	      prefix = _ref2[0],
	      defaultPrefix = _ref2[1];
	
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(prefix, defaultPrefix);
	  return /*#__PURE__*/_react.default.createElement("label", (0, _extends2.default)({}, props, {
	    ref: ref,
	    htmlFor: htmlFor || controlId,
	    className: (0, _classnames.default)(className, bsPrefix)
	  }));
	});
	
	FormCheckLabel.displayName = 'FormCheckLabel';
	var _default = FormCheckLabel;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(30));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["id", "bsPrefix", "bsCustomPrefix", "className", "isValid", "isInvalid", "lang", "as"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var FormFileInput = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var id = _ref.id,
	      bsPrefix = _ref.bsPrefix,
	      bsCustomPrefix = _ref.bsCustomPrefix,
	      className = _ref.className,
	      isValid = _ref.isValid,
	      isInvalid = _ref.isInvalid,
	      lang = _ref.lang,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'input' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	
	  var _useContext = (0, _react.useContext)(_FormContext.default),
	      controlId = _useContext.controlId,
	      custom = _useContext.custom;
	
	  var type = 'file';
	
	  var _ref2 = custom ? [bsCustomPrefix, 'custom-file-input'] : [bsPrefix, 'form-control-file'],
	      prefix = _ref2[0],
	      defaultPrefix = _ref2[1];
	
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(prefix, defaultPrefix);
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    id: id || controlId,
	    type: type,
	    lang: lang,
	    className: (0, _classnames.default)(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
	  }));
	});
	
	FormFileInput.displayName = 'FormFileInput';
	var _default = FormFileInput;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(30));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "bsCustomPrefix", "className", "htmlFor"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var FormFileLabel = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      bsCustomPrefix = _ref.bsCustomPrefix,
	      className = _ref.className,
	      htmlFor = _ref.htmlFor,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	
	  var _useContext = (0, _react.useContext)(_FormContext.default),
	      controlId = _useContext.controlId,
	      custom = _useContext.custom;
	
	  var _ref2 = custom ? [bsCustomPrefix, 'custom-file-label'] : [bsPrefix, 'form-file-label'],
	      prefix = _ref2[0],
	      defaultPrefix = _ref2[1];
	
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(prefix, defaultPrefix);
	  return /*#__PURE__*/_react.default.createElement("label", (0, _extends2.default)({}, props, {
	    ref: ref,
	    htmlFor: htmlFor || controlId,
	    className: (0, _classnames.default)(className, bsPrefix),
	    "data-browse": props['data-browse']
	  }));
	});
	
	FormFileLabel.displayName = 'FormFileLabel';
	var _default = FormFileLabel;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "size", "hasValidation", "className", "as"];
	var InputGroupAppend = (0, _createWithBsPrefix.default)('input-group-append');
	var InputGroupPrepend = (0, _createWithBsPrefix.default)('input-group-prepend');
	var InputGroupText = (0, _createWithBsPrefix.default)('input-group-text', {
	  Component: 'span'
	});
	
	var InputGroupCheckbox = function InputGroupCheckbox(props) {
	  return /*#__PURE__*/_react.default.createElement(InputGroupText, null, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
	    type: "checkbox"
	  }, props)));
	};
	
	var InputGroupRadio = function InputGroupRadio(props) {
	  return /*#__PURE__*/_react.default.createElement(InputGroupText, null, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
	    type: "radio"
	  }, props)));
	};
	
	/**
	 *
	 * @property {InputGroupAppend} Append
	 * @property {InputGroupPrepend} Prepend
	 * @property {InputGroupText} Text
	 * @property {InputGroupRadio} Radio
	 * @property {InputGroupCheckbox} Checkbox
	 */
	var InputGroup = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      size = _ref.size,
	      hasValidation = _ref.hasValidation,
	      className = _ref.className,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'input-group');
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(className, bsPrefix, size && bsPrefix + "-" + size, hasValidation && 'has-validation')
	  }));
	});
	
	InputGroup.displayName = 'InputGroup';
	var InputGroupWithExtras = (0, _extends2.default)({}, InputGroup, {
	  Text: InputGroupText,
	  Radio: InputGroupRadio,
	  Checkbox: InputGroupCheckbox,
	  Append: InputGroupAppend,
	  Prepend: InputGroupPrepend
	});
	var _default = InputGroupWithExtras;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["as", "className", "fluid", "bsPrefix"];
	var defaultProps = {
	  fluid: false
	};
	
	var Jumbotron = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var _classes;
	
	  var _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      className = _ref.className,
	      fluid = _ref.fluid,
	      bsPrefix = _ref.bsPrefix,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'jumbotron');
	  var classes = (_classes = {}, _classes[bsPrefix] = true, _classes[bsPrefix + "-fluid"] = fluid, _classes);
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(className, classes)
	  }));
	});
	
	Jumbotron.defaultProps = defaultProps;
	Jumbotron.displayName = 'Jumbotron';
	var _default = Jumbotron;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _warning = _interopRequireDefault(__webpack_require__(31));
	
	var _uncontrollable = __webpack_require__(20);
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _AbstractNav = _interopRequireDefault(__webpack_require__(221));
	
	var _ListGroupItem = _interopRequireDefault(__webpack_require__(237));
	
	var _excluded = ["className", "bsPrefix", "variant", "horizontal", "as"];
	var defaultProps = {
	  variant: undefined,
	  horizontal: undefined
	};
	
	var ListGroup = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
	  var _useUncontrolled = (0, _uncontrollable.useUncontrolled)(props, {
	    activeKey: 'onSelect'
	  }),
	      className = _useUncontrolled.className,
	      initialBsPrefix = _useUncontrolled.bsPrefix,
	      variant = _useUncontrolled.variant,
	      horizontal = _useUncontrolled.horizontal,
	      _useUncontrolled$as = _useUncontrolled.as,
	      as = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as,
	      controlledProps = (0, _objectWithoutPropertiesLoose2.default)(_useUncontrolled, _excluded);
	
	  var bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(initialBsPrefix, 'list-group');
	  var horizontalVariant;
	
	  if (horizontal) {
	    horizontalVariant = horizontal === true ? 'horizontal' : "horizontal-" + horizontal;
	  } else {
	    horizontalVariant = null;
	  }
	
	   false ? (0, _warning.default)(!(horizontal && variant === 'flush'), '`variant="flush"` and `horizontal` should not be used together.') : void 0;
	  return /*#__PURE__*/_react.default.createElement(_AbstractNav.default, (0, _extends2.default)({
	    ref: ref
	  }, controlledProps, {
	    as: as,
	    className: (0, _classnames.default)(className, bsPrefix, variant && bsPrefix + "-" + variant, horizontalVariant && bsPrefix + "-" + horizontalVariant)
	  }));
	});
	
	ListGroup.defaultProps = defaultProps;
	ListGroup.displayName = 'ListGroup';
	ListGroup.Item = _ListGroupItem.default;
	var _default = ListGroup;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "className", "as"];
	var MediaBody = (0, _createWithBsPrefix.default)('media-body');
	
	var Media = /*#__PURE__*/_react.default.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
	function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'media');
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(className, prefix)
	  }));
	});
	
	Media.displayName = 'Media';
	Media.Body = MediaBody;
	var _default = Media;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(96));
	
	var _canUseDOM = _interopRequireDefault(__webpack_require__(62));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(40));
	
	var _removeEventListener = _interopRequireDefault(__webpack_require__(182));
	
	var _scrollbarSize = _interopRequireDefault(__webpack_require__(100));
	
	var _useCallbackRef2 = _interopRequireDefault(__webpack_require__(88));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(18));
	
	var _useWillUnmount = _interopRequireDefault(__webpack_require__(91));
	
	var _transitionEnd = _interopRequireDefault(__webpack_require__(183));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _Modal = _interopRequireDefault(__webpack_require__(566));
	
	var _warning = _interopRequireDefault(__webpack_require__(31));
	
	var _BootstrapModalManager = _interopRequireDefault(__webpack_require__(510));
	
	var _Fade = _interopRequireDefault(__webpack_require__(43));
	
	var _ModalBody = _interopRequireDefault(__webpack_require__(238));
	
	var _ModalContext = _interopRequireDefault(__webpack_require__(239));
	
	var _ModalDialog = _interopRequireDefault(__webpack_require__(240));
	
	var _ModalFooter = _interopRequireDefault(__webpack_require__(241));
	
	var _ModalHeader = _interopRequireDefault(__webpack_require__(535));
	
	var _ModalTitle = _interopRequireDefault(__webpack_require__(242));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "className", "style", "dialogClassName", "contentClassName", "children", "dialogAs", "aria-labelledby", "show", "animation", "backdrop", "keyboard", "onEscapeKeyDown", "onShow", "onHide", "container", "autoFocus", "enforceFocus", "restoreFocus", "restoreFocusOptions", "onEntered", "onExit", "onExiting", "onEnter", "onEntering", "onExited", "backdropClassName", "manager"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var manager;
	var defaultProps = {
	  show: false,
	  backdrop: true,
	  keyboard: true,
	  autoFocus: true,
	  enforceFocus: true,
	  restoreFocus: true,
	  animation: true,
	  dialogAs: _ModalDialog.default
	};
	/* eslint-disable no-use-before-define, react/no-multi-comp */
	
	function DialogTransition(props) {
	  return /*#__PURE__*/_react.default.createElement(_Fade.default, (0, _extends2.default)({}, props, {
	    timeout: null
	  }));
	}
	
	function BackdropTransition(props) {
	  return /*#__PURE__*/_react.default.createElement(_Fade.default, (0, _extends2.default)({}, props, {
	    timeout: null
	  }));
	}
	/* eslint-enable no-use-before-define */
	
	
	var Modal = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      style = _ref.style,
	      dialogClassName = _ref.dialogClassName,
	      contentClassName = _ref.contentClassName,
	      children = _ref.children,
	      Dialog = _ref.dialogAs,
	      ariaLabelledby = _ref['aria-labelledby'],
	      show = _ref.show,
	      animation = _ref.animation,
	      backdrop = _ref.backdrop,
	      keyboard = _ref.keyboard,
	      onEscapeKeyDown = _ref.onEscapeKeyDown,
	      onShow = _ref.onShow,
	      onHide = _ref.onHide,
	      container = _ref.container,
	      autoFocus = _ref.autoFocus,
	      enforceFocus = _ref.enforceFocus,
	      restoreFocus = _ref.restoreFocus,
	      restoreFocusOptions = _ref.restoreFocusOptions,
	      onEntered = _ref.onEntered,
	      onExit = _ref.onExit,
	      onExiting = _ref.onExiting,
	      onEnter = _ref.onEnter,
	      onEntering = _ref.onEntering,
	      onExited = _ref.onExited,
	      backdropClassName = _ref.backdropClassName,
	      propsManager = _ref.manager,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	
	  var _useState = (0, _react.useState)({}),
	      modalStyle = _useState[0],
	      setStyle = _useState[1];
	
	  var _useState2 = (0, _react.useState)(false),
	      animateStaticModal = _useState2[0],
	      setAnimateStaticModal = _useState2[1];
	
	  var waitingForMouseUpRef = (0, _react.useRef)(false);
	  var ignoreBackdropClickRef = (0, _react.useRef)(false);
	  var removeStaticModalAnimationRef = (0, _react.useRef)(null); // TODO: what's this type
	
	  var _useCallbackRef = (0, _useCallbackRef2.default)(),
	      modal = _useCallbackRef[0],
	      setModalRef = _useCallbackRef[1];
	
	  var handleHide = (0, _useEventCallback.default)(onHide);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'modal');
	  (0, _react.useImperativeHandle)(ref, function () {
	    return {
	      get _modal() {
	         false ? (0, _warning.default)(false, 'Accessing `_modal` is not supported and will be removed in a future release') : void 0;
	        return modal;
	      }
	
	    };
	  }, [modal]);
	  var modalContext = (0, _react.useMemo)(function () {
	    return {
	      onHide: handleHide
	    };
	  }, [handleHide]);
	
	  function getModalManager() {
	    if (propsManager) return propsManager;
	    if (!manager) manager = new _BootstrapModalManager.default();
	    return manager;
	  }
	
	  function updateDialogStyle(node) {
	    if (!_canUseDOM.default) return;
	    var containerIsOverflowing = getModalManager().isContainerOverflowing(modal);
	    var modalIsOverflowing = node.scrollHeight > (0, _ownerDocument.default)(node).documentElement.clientHeight;
	    setStyle({
	      paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize.default)() : undefined,
	      paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize.default)() : undefined
	    });
	  }
	
	  var handleWindowResize = (0, _useEventCallback.default)(function () {
	    if (modal) {
	      updateDialogStyle(modal.dialog);
	    }
	  });
	  (0, _useWillUnmount.default)(function () {
	    (0, _removeEventListener.default)(window, 'resize', handleWindowResize);
	
	    if (removeStaticModalAnimationRef.current) {
	      removeStaticModalAnimationRef.current();
	    }
	  }); // We prevent the modal from closing during a drag by detecting where the
	  // the click originates from. If it starts in the modal and then ends outside
	  // don't close.
	
	  var handleDialogMouseDown = function handleDialogMouseDown() {
	    waitingForMouseUpRef.current = true;
	  };
	
	  var handleMouseUp = function handleMouseUp(e) {
	    if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) {
	      ignoreBackdropClickRef.current = true;
	    }
	
	    waitingForMouseUpRef.current = false;
	  };
	
	  var handleStaticModalAnimation = function handleStaticModalAnimation() {
	    setAnimateStaticModal(true);
	    removeStaticModalAnimationRef.current = (0, _transitionEnd.default)(modal.dialog, function () {
	      setAnimateStaticModal(false);
	    });
	  };
	
	  var handleStaticBackdropClick = function handleStaticBackdropClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    handleStaticModalAnimation();
	  };
	
	  var handleClick = function handleClick(e) {
	    if (backdrop === 'static') {
	      handleStaticBackdropClick(e);
	      return;
	    }
	
	    if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
	      ignoreBackdropClickRef.current = false;
	      return;
	    }
	
	    onHide();
	  };
	
	  var handleEscapeKeyDown = function handleEscapeKeyDown(e) {
	    if (!keyboard && backdrop === 'static') {
	      // Call preventDefault to stop modal from closing in react-overlays,
	      // then play our animation.
	      e.preventDefault();
	      handleStaticModalAnimation();
	    } else if (keyboard && onEscapeKeyDown) {
	      onEscapeKeyDown(e);
	    }
	  };
	
	  var handleEnter = function handleEnter(node) {
	    if (node) {
	      node.style.display = 'block';
	      updateDialogStyle(node);
	    }
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (onEnter) onEnter.apply(void 0, [node].concat(args));
	  };
	
	  var handleExit = function handleExit(node) {
	    if (removeStaticModalAnimationRef.current) {
	      removeStaticModalAnimationRef.current();
	    }
	
	    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    if (onExit) onExit.apply(void 0, [node].concat(args));
	  };
	
	  var handleEntering = function handleEntering(node) {
	    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      args[_key3 - 1] = arguments[_key3];
	    }
	
	    if (onEntering) onEntering.apply(void 0, [node].concat(args)); // FIXME: This should work even when animation is disabled.
	
	    (0, _addEventListener.default)(window, 'resize', handleWindowResize);
	  };
	
	  var handleExited = function handleExited(node) {
	    if (node) node.style.display = ''; // RHL removes it sometimes
	
	    for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	      args[_key4 - 1] = arguments[_key4];
	    }
	
	    if (onExited) onExited.apply(void 0, args); // FIXME: This should work even when animation is disabled.
	
	    (0, _removeEventListener.default)(window, 'resize', handleWindowResize);
	  };
	
	  var renderBackdrop = (0, _react.useCallback)(function (backdropProps) {
	    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, backdropProps, {
	      className: (0, _classnames.default)(bsPrefix + "-backdrop", backdropClassName, !animation && 'show')
	    }));
	  }, [animation, backdropClassName, bsPrefix]);
	  var baseModalStyle = (0, _extends2.default)({}, style, modalStyle); // Sets `display` always block when `animation` is false
	
	  if (!animation) {
	    baseModalStyle.display = 'block';
	  }
	
	  var renderDialog = function renderDialog(dialogProps) {
	    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
	      role: "dialog"
	    }, dialogProps, {
	      style: baseModalStyle,
	      className: (0, _classnames.default)(className, bsPrefix, animateStaticModal && bsPrefix + "-static"),
	      onClick: backdrop ? handleClick : undefined,
	      onMouseUp: handleMouseUp,
	      "aria-labelledby": ariaLabelledby
	    }), /*#__PURE__*/_react.default.createElement(Dialog, (0, _extends2.default)({}, props, {
	      onMouseDown: handleDialogMouseDown,
	      className: dialogClassName,
	      contentClassName: contentClassName
	    }), children));
	  };
	
	  return /*#__PURE__*/_react.default.createElement(_ModalContext.default.Provider, {
	    value: modalContext
	  }, /*#__PURE__*/_react.default.createElement(_Modal.default, {
	    show: show,
	    ref: setModalRef,
	    backdrop: backdrop,
	    container: container,
	    keyboard: true // Always set true - see handleEscapeKeyDown
	    ,
	    autoFocus: autoFocus,
	    enforceFocus: enforceFocus,
	    restoreFocus: restoreFocus,
	    restoreFocusOptions: restoreFocusOptions,
	    onEscapeKeyDown: handleEscapeKeyDown,
	    onShow: onShow,
	    onHide: onHide,
	    onEnter: handleEnter,
	    onEntering: handleEntering,
	    onEntered: onEntered,
	    onExit: handleExit,
	    onExiting: onExiting,
	    onExited: handleExited,
	    manager: getModalManager(),
	    containerClassName: bsPrefix + "-open",
	    transition: animation ? DialogTransition : undefined,
	    backdropTransition: animation ? BackdropTransition : undefined,
	    renderBackdrop: renderBackdrop,
	    renderDialog: renderDialog
	  }));
	});
	
	Modal.displayName = 'Modal';
	Modal.defaultProps = defaultProps;
	Modal.Body = _ModalBody.default;
	Modal.Header = _ModalHeader.default;
	Modal.Title = _ModalTitle.default;
	Modal.Footer = _ModalFooter.default;
	Modal.Dialog = _ModalDialog.default;
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	var _default = Modal;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(18));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _CloseButton = _interopRequireDefault(__webpack_require__(76));
	
	var _ModalContext = _interopRequireDefault(__webpack_require__(239));
	
	var _excluded = ["bsPrefix", "closeLabel", "closeButton", "onHide", "className", "children"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var defaultProps = {
	  closeLabel: 'Close',
	  closeButton: false
	};
	
	var ModalHeader = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      closeLabel = _ref.closeLabel,
	      closeButton = _ref.closeButton,
	      onHide = _ref.onHide,
	      className = _ref.className,
	      children = _ref.children,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'modal-header');
	  var context = (0, _react.useContext)(_ModalContext.default);
	  var handleClick = (0, _useEventCallback.default)(function () {
	    if (context) context.onHide();
	    if (onHide) onHide();
	  });
	  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(className, bsPrefix)
	  }), children, closeButton && /*#__PURE__*/_react.default.createElement(_CloseButton.default, {
	    label: closeLabel,
	    onClick: handleClick
	  }));
	});
	
	ModalHeader.displayName = 'ModalHeader';
	ModalHeader.defaultProps = defaultProps;
	var _default = ModalHeader;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(77));
	
	var _NavLink = _interopRequireDefault(__webpack_require__(79));
	
	var _excluded = ["id", "title", "children", "bsPrefix", "className", "rootCloseEvent", "menuRole", "disabled", "active", "renderMenuOnMount"];
	
	var NavDropdown = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var id = _ref.id,
	      title = _ref.title,
	      children = _ref.children,
	      bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      rootCloseEvent = _ref.rootCloseEvent,
	      menuRole = _ref.menuRole,
	      disabled = _ref.disabled,
	      active = _ref.active,
	      renderMenuOnMount = _ref.renderMenuOnMount,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	
	  /* NavItem has no additional logic, it's purely presentational. Can set nav item class here to support "as" */
	  var navItemPrefix = (0, _ThemeProvider.useBootstrapPrefix)(undefined, 'nav-item');
	  return /*#__PURE__*/_react.default.createElement(_Dropdown.default, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(className, navItemPrefix)
	  }), /*#__PURE__*/_react.default.createElement(_Dropdown.default.Toggle, {
	    id: id,
	    eventKey: null,
	    active: active,
	    disabled: disabled,
	    childBsPrefix: bsPrefix,
	    as: _NavLink.default
	  }, title), /*#__PURE__*/_react.default.createElement(_Dropdown.default.Menu, {
	    role: menuRole,
	    renderOnMount: renderMenuOnMount,
	    rootCloseEvent: rootCloseEvent
	  }, children));
	});
	
	NavDropdown.displayName = 'NavDropdown';
	NavDropdown.Item = _Dropdown.default.Item;
	NavDropdown.ItemText = _Dropdown.default.ItemText;
	NavDropdown.Divider = _Dropdown.default.Divider;
	NavDropdown.Header = _Dropdown.default.Header;
	var _default = NavDropdown;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _uncontrollable = __webpack_require__(20);
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(15));
	
	var _NavbarBrand = _interopRequireDefault(__webpack_require__(244));
	
	var _NavbarCollapse = _interopRequireDefault(__webpack_require__(538));
	
	var _NavbarToggle = _interopRequireDefault(__webpack_require__(539));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _NavbarContext = _interopRequireDefault(__webpack_require__(57));
	
	var _SelectableContext = _interopRequireDefault(__webpack_require__(25));
	
	var _excluded = ["bsPrefix", "expand", "variant", "bg", "fixed", "sticky", "className", "children", "as", "expanded", "onToggle", "onSelect", "collapseOnSelect"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var NavbarText = (0, _createWithBsPrefix.default)('navbar-text', {
	  Component: 'span'
	});
	var defaultProps = {
	  expand: true,
	  variant: 'light',
	  collapseOnSelect: false
	};
	
	var Navbar = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
	  var _useUncontrolled = (0, _uncontrollable.useUncontrolled)(props, {
	    expanded: 'onToggle'
	  }),
	      initialBsPrefix = _useUncontrolled.bsPrefix,
	      expand = _useUncontrolled.expand,
	      variant = _useUncontrolled.variant,
	      bg = _useUncontrolled.bg,
	      fixed = _useUncontrolled.fixed,
	      sticky = _useUncontrolled.sticky,
	      className = _useUncontrolled.className,
	      children = _useUncontrolled.children,
	      _useUncontrolled$as = _useUncontrolled.as,
	      Component = _useUncontrolled$as === void 0 ? 'nav' : _useUncontrolled$as,
	      expanded = _useUncontrolled.expanded,
	      _onToggle = _useUncontrolled.onToggle,
	      onSelect = _useUncontrolled.onSelect,
	      collapseOnSelect = _useUncontrolled.collapseOnSelect,
	      controlledProps = (0, _objectWithoutPropertiesLoose2.default)(_useUncontrolled, _excluded);
	
	  var bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(initialBsPrefix, 'navbar');
	  var handleCollapse = (0, _react.useCallback)(function () {
	    if (onSelect) onSelect.apply(void 0, arguments);
	
	    if (collapseOnSelect && expanded) {
	      if (_onToggle) {
	        _onToggle(false);
	      }
	    }
	  }, [onSelect, collapseOnSelect, expanded, _onToggle]); // will result in some false positives but that seems better
	  // than false negatives. strict `undefined` check allows explicit
	  // "nulling" of the role if the user really doesn't want one
	
	  if (controlledProps.role === undefined && Component !== 'nav') {
	    controlledProps.role = 'navigation';
	  }
	
	  var expandClass = bsPrefix + "-expand";
	  if (typeof expand === 'string') expandClass = expandClass + "-" + expand;
	  var navbarContext = (0, _react.useMemo)(function () {
	    return {
	      onToggle: function onToggle() {
	        return _onToggle && _onToggle(!expanded);
	      },
	      bsPrefix: bsPrefix,
	      expanded: !!expanded
	    };
	  }, [bsPrefix, expanded, _onToggle]);
	  return /*#__PURE__*/_react.default.createElement(_NavbarContext.default.Provider, {
	    value: navbarContext
	  }, /*#__PURE__*/_react.default.createElement(_SelectableContext.default.Provider, {
	    value: handleCollapse
	  }, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, controlledProps, {
	    className: (0, _classnames.default)(className, bsPrefix, expand && expandClass, variant && bsPrefix + "-" + variant, bg && "bg-" + bg, sticky && "sticky-" + sticky, fixed && "fixed-" + fixed)
	  }), children)));
	});
	
	Navbar.defaultProps = defaultProps;
	Navbar.displayName = 'Navbar';
	Navbar.Brand = _NavbarBrand.default;
	Navbar.Toggle = _NavbarToggle.default;
	Navbar.Collapse = _NavbarCollapse.default;
	Navbar.Text = NavbarText;
	var _default = Navbar;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(117));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _NavbarContext = _interopRequireDefault(__webpack_require__(57));
	
	var _excluded = ["children", "bsPrefix"];
	
	var NavbarCollapse = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var children = _ref.children,
	      bsPrefix = _ref.bsPrefix,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'navbar-collapse');
	  return /*#__PURE__*/_react.default.createElement(_NavbarContext.default.Consumer, null, function (context) {
	    return /*#__PURE__*/_react.default.createElement(_Collapse.default, (0, _extends2.default)({
	      in: !!(context && context.expanded)
	    }, props), /*#__PURE__*/_react.default.createElement("div", {
	      ref: ref,
	      className: bsPrefix
	    }, children));
	  });
	});
	
	NavbarCollapse.displayName = 'NavbarCollapse';
	var _default = NavbarCollapse;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(18));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _NavbarContext = _interopRequireDefault(__webpack_require__(57));
	
	var _excluded = ["bsPrefix", "className", "children", "label", "as", "onClick"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var defaultProps = {
	  label: 'Toggle navigation'
	};
	
	var NavbarToggle = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      children = _ref.children,
	      label = _ref.label,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'button' : _ref$as,
	      onClick = _ref.onClick,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'navbar-toggler');
	
	  var _ref2 = (0, _react.useContext)(_NavbarContext.default) || {},
	      onToggle = _ref2.onToggle,
	      expanded = _ref2.expanded;
	
	  var handleClick = (0, _useEventCallback.default)(function (e) {
	    if (onClick) onClick(e);
	    if (onToggle) onToggle();
	  });
	
	  if (Component === 'button') {
	    props.type = 'button';
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    onClick: handleClick,
	    "aria-label": label,
	    className: (0, _classnames.default)(className, bsPrefix, !expanded && 'collapsed')
	  }), children || /*#__PURE__*/_react.default.createElement("span", {
	    className: bsPrefix + "-icon"
	  }));
	});
	
	NavbarToggle.displayName = 'NavbarToggle';
	NavbarToggle.defaultProps = defaultProps;
	var _default = NavbarToggle;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(38));
	
	var _contains = _interopRequireDefault(__webpack_require__(97));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _useTimeout = _interopRequireDefault(__webpack_require__(90));
	
	var _safeFindDOMNode = _interopRequireDefault(__webpack_require__(133));
	
	var _warning = _interopRequireDefault(__webpack_require__(31));
	
	var _uncontrollable = __webpack_require__(20);
	
	var _Overlay = _interopRequireDefault(__webpack_require__(245));
	
	var _excluded = ["trigger", "overlay", "children", "popperConfig", "show", "defaultShow", "onToggle", "delay", "placement", "flip"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var RefHolder = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(RefHolder, _React$Component);
	
	  function RefHolder() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = RefHolder.prototype;
	
	  _proto.render = function render() {
	    return this.props.children;
	  };
	
	  return RefHolder;
	}(_react.default.Component);
	
	function normalizeDelay(delay) {
	  return delay && typeof delay === 'object' ? delay : {
	    show: delay,
	    hide: delay
	  };
	} // Simple implementation of mouseEnter and mouseLeave.
	// React's built version is broken: https://github.com/facebook/react/issues/4251
	// for cases when the trigger is disabled and mouseOut/Over can cause flicker
	// moving from one child element to another.
	
	
	function handleMouseOverOut( // eslint-disable-next-line @typescript-eslint/no-shadow
	handler, args, relatedNative) {
	  var e = args[0];
	  var target = e.currentTarget;
	  var related = e.relatedTarget || e.nativeEvent[relatedNative];
	
	  if ((!related || related !== target) && !(0, _contains.default)(target, related)) {
	    handler.apply(void 0, args);
	  }
	}
	
	var defaultProps = {
	  defaultShow: false,
	  trigger: ['hover', 'focus']
	};
	
	function OverlayTrigger(_ref) {
	  var trigger = _ref.trigger,
	      overlay = _ref.overlay,
	      children = _ref.children,
	      _ref$popperConfig = _ref.popperConfig,
	      popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig,
	      propsShow = _ref.show,
	      _ref$defaultShow = _ref.defaultShow,
	      defaultShow = _ref$defaultShow === void 0 ? false : _ref$defaultShow,
	      onToggle = _ref.onToggle,
	      propsDelay = _ref.delay,
	      placement = _ref.placement,
	      _ref$flip = _ref.flip,
	      flip = _ref$flip === void 0 ? placement && placement.indexOf('auto') !== -1 : _ref$flip,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var triggerNodeRef = (0, _react.useRef)(null);
	  var timeout = (0, _useTimeout.default)();
	  var hoverStateRef = (0, _react.useRef)('');
	
	  var _useUncontrolledProp = (0, _uncontrollable.useUncontrolledProp)(propsShow, defaultShow, onToggle),
	      show = _useUncontrolledProp[0],
	      setShow = _useUncontrolledProp[1];
	
	  var delay = normalizeDelay(propsDelay);
	
	  var _ref2 = typeof children !== 'function' ? _react.default.Children.only(children).props : {},
	      onFocus = _ref2.onFocus,
	      onBlur = _ref2.onBlur,
	      onClick = _ref2.onClick;
	
	  var getTarget = (0, _react.useCallback)(function () {
	    return (0, _safeFindDOMNode.default)(triggerNodeRef.current);
	  }, []);
	  var handleShow = (0, _react.useCallback)(function () {
	    timeout.clear();
	    hoverStateRef.current = 'show';
	
	    if (!delay.show) {
	      setShow(true);
	      return;
	    }
	
	    timeout.set(function () {
	      if (hoverStateRef.current === 'show') setShow(true);
	    }, delay.show);
	  }, [delay.show, setShow, timeout]);
	  var handleHide = (0, _react.useCallback)(function () {
	    timeout.clear();
	    hoverStateRef.current = 'hide';
	
	    if (!delay.hide) {
	      setShow(false);
	      return;
	    }
	
	    timeout.set(function () {
	      if (hoverStateRef.current === 'hide') setShow(false);
	    }, delay.hide);
	  }, [delay.hide, setShow, timeout]);
	  var handleFocus = (0, _react.useCallback)(function () {
	    handleShow();
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    onFocus == null ? void 0 : onFocus.apply(void 0, args);
	  }, [handleShow, onFocus]);
	  var handleBlur = (0, _react.useCallback)(function () {
	    handleHide();
	
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    onBlur == null ? void 0 : onBlur.apply(void 0, args);
	  }, [handleHide, onBlur]);
	  var handleClick = (0, _react.useCallback)(function () {
	    setShow(!show);
	    if (onClick) onClick.apply(void 0, arguments);
	  }, [onClick, setShow, show]);
	  var handleMouseOver = (0, _react.useCallback)(function () {
	    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    handleMouseOverOut(handleShow, args, 'fromElement');
	  }, [handleShow]);
	  var handleMouseOut = (0, _react.useCallback)(function () {
	    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    handleMouseOverOut(handleHide, args, 'toElement');
	  }, [handleHide]);
	  var triggers = trigger == null ? [] : [].concat(trigger);
	  var triggerProps = {};
	
	  if (triggers.indexOf('click') !== -1) {
	    triggerProps.onClick = handleClick;
	  }
	
	  if (triggers.indexOf('focus') !== -1) {
	    triggerProps.onFocus = handleFocus;
	    triggerProps.onBlur = handleBlur;
	  }
	
	  if (triggers.indexOf('hover') !== -1) {
	     false ? (0, _warning.default)(triggers.length > 1, '[react-bootstrap] Specifying only the `"hover"` trigger limits the visibility of the overlay to just mouse users. Consider also including the `"focus"` trigger so that touch and keyboard only users can see the overlay as well.') : void 0;
	    triggerProps.onMouseOver = handleMouseOver;
	    triggerProps.onMouseOut = handleMouseOut;
	  }
	
	  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, typeof children === 'function' ? children((0, _extends2.default)({}, triggerProps, {
	    ref: triggerNodeRef
	  })) : /*#__PURE__*/_react.default.createElement(RefHolder, {
	    ref: triggerNodeRef
	  }, /*#__PURE__*/(0, _react.cloneElement)(children, triggerProps)), /*#__PURE__*/_react.default.createElement(_Overlay.default, (0, _extends2.default)({}, props, {
	    show: show,
	    onHide: handleHide,
	    flip: flip,
	    placement: placement,
	    popperConfig: popperConfig,
	    target: getTarget
	  }), overlay));
	}
	
	OverlayTrigger.defaultProps = defaultProps;
	var _default = OverlayTrigger;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _PageItem = _interopRequireWildcard(__webpack_require__(246));
	
	var _excluded = ["bsPrefix", "className", "children", "size"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	/**
	 * @property {PageItem} Item
	 * @property {PageItem} First
	 * @property {PageItem} Prev
	 * @property {PageItem} Ellipsis
	 * @property {PageItem} Next
	 * @property {PageItem} Last
	 */
	var Pagination = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      children = _ref.children,
	      size = _ref.size,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var decoratedBsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'pagination');
	  return /*#__PURE__*/_react.default.createElement("ul", (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(className, decoratedBsPrefix, size && decoratedBsPrefix + "-" + size)
	  }), children);
	});
	
	Pagination.First = _PageItem.First;
	Pagination.Prev = _PageItem.Prev;
	Pagination.Ellipsis = _PageItem.Ellipsis;
	Pagination.Item = _PageItem.default;
	Pagination.Next = _PageItem.Next;
	Pagination.Last = _PageItem.Last;
	var _default = Pagination;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _isRequiredForA11y = _interopRequireDefault(__webpack_require__(72));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _PopoverTitle = _interopRequireDefault(__webpack_require__(248));
	
	var _PopoverContent = _interopRequireDefault(__webpack_require__(247));
	
	var _excluded = ["bsPrefix", "placement", "className", "style", "children", "content", "arrowProps", "popper", "show"];
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      placement = _ref.placement,
	      className = _ref.className,
	      style = _ref.style,
	      children = _ref.children,
	      content = _ref.content,
	      arrowProps = _ref.arrowProps,
	      _ = _ref.popper,
	      _1 = _ref.show,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var decoratedBsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'popover');
	
	  var _ref2 = (placement == null ? void 0 : placement.split('-')) || [],
	      primaryPlacement = _ref2[0];
	
	  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
	    ref: ref,
	    role: "tooltip",
	    style: style,
	    "x-placement": primaryPlacement,
	    className: (0, _classnames.default)(className, decoratedBsPrefix, primaryPlacement && "bs-popover-" + primaryPlacement)
	  }, props), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
	    className: "arrow"
	  }, arrowProps)), content ? /*#__PURE__*/_react.default.createElement(_PopoverContent.default, null, children) : children);
	});
	
	Popover.defaultProps = defaultProps;
	Popover.Title = _PopoverTitle.default;
	Popover.Content = _PopoverContent.default;
	var _default = Popover;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _ElementChildren = __webpack_require__(78);
	
	var _excluded = ["min", "now", "max", "label", "srOnly", "striped", "animated", "className", "style", "variant", "bsPrefix"],
	    _excluded2 = ["isChild"],
	    _excluded3 = ["min", "now", "max", "label", "srOnly", "striped", "animated", "bsPrefix", "variant", "className", "children"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var ROUND_PRECISION = 1000;
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react.default.Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	    /**
	     * Compare types in a way that works with libraries that patch and proxy
	     * components like react-hot-loader.
	     *
	     * see https://github.com/gaearon/react-hot-loader#checking-element-types
	     */
	    // eslint-disable-next-line @typescript-eslint/no-use-before-define
	
	
	    var element = /*#__PURE__*/_react.default.createElement(ProgressBar, null);
	
	    if (child.type === element.type) return;
	    var childType = child.type;
	    var childIdentifier = /*#__PURE__*/_react.default.isValidElement(child) ? childType.displayName || childType.name || childType : child;
	    error = new Error("Children of " + componentName + " can contain only ProgressBar " + ("components. Found " + childIdentifier + "."));
	  });
	
	  return error;
	}
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  animated: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	function renderProgressBar(_ref, ref) {
	  var _classNames;
	
	  var min = _ref.min,
	      now = _ref.now,
	      max = _ref.max,
	      label = _ref.label,
	      srOnly = _ref.srOnly,
	      striped = _ref.striped,
	      animated = _ref.animated,
	      className = _ref.className,
	      style = _ref.style,
	      variant = _ref.variant,
	      bsPrefix = _ref.bsPrefix,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    role: "progressbar",
	    className: (0, _classnames.default)(className, bsPrefix + "-bar", (_classNames = {}, _classNames["bg-" + variant] = variant, _classNames[bsPrefix + "-bar-animated"] = animated, _classNames[bsPrefix + "-bar-striped"] = animated || striped, _classNames)),
	    style: (0, _extends2.default)({
	      width: getPercentage(now, min, max) + "%"
	    }, style),
	    "aria-valuenow": now,
	    "aria-valuemin": min,
	    "aria-valuemax": max
	  }), srOnly ? /*#__PURE__*/_react.default.createElement("span", {
	    className: "sr-only"
	  }, label) : label);
	}
	
	var ProgressBar = /*#__PURE__*/_react.default.forwardRef(function (_ref2, ref) {
	  var isChild = _ref2.isChild,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref2, _excluded2);
	  props.bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(props.bsPrefix, 'progress');
	
	  if (isChild) {
	    return renderProgressBar(props, ref);
	  }
	
	  var min = props.min,
	      now = props.now,
	      max = props.max,
	      label = props.label,
	      srOnly = props.srOnly,
	      striped = props.striped,
	      animated = props.animated,
	      bsPrefix = props.bsPrefix,
	      variant = props.variant,
	      className = props.className,
	      children = props.children,
	      wrapperProps = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded3);
	  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
	    ref: ref
	  }, wrapperProps, {
	    className: (0, _classnames.default)(className, bsPrefix)
	  }), children ? (0, _ElementChildren.map)(children, function (child) {
	    return /*#__PURE__*/(0, _react.cloneElement)(child, {
	      isChild: true
	    });
	  }) : renderProgressBar({
	    min: min,
	    now: now,
	    max: max,
	    label: label,
	    srOnly: srOnly,
	    striped: striped,
	    animated: animated,
	    bsPrefix: bsPrefix,
	    variant: variant
	  }, ref));
	});
	
	ProgressBar.displayName = 'ProgressBar';
	ProgressBar.defaultProps = defaultProps;
	var _default = ProgressBar;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "className", "children", "aspectRatio"];
	var defaultProps = {
	  aspectRatio: '1by1'
	};
	
	var ResponsiveEmbed = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      children = _ref.children,
	      aspectRatio = _ref.aspectRatio,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var decoratedBsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'embed-responsive');
	
	  var child = _react.default.Children.only(children);
	
	  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(decoratedBsPrefix, className, aspectRatio && decoratedBsPrefix + "-" + aspectRatio)
	  }), /*#__PURE__*/_react.default.cloneElement(child, {
	    className: (0, _classnames.default)(child.props.className, decoratedBsPrefix + "-item")
	  }));
	});
	
	ResponsiveEmbed.defaultProps = defaultProps;
	var _default = ResponsiveEmbed;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "className", "noGutters", "as"];
	var DEVICE_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
	var defaultProps = {
	  noGutters: false
	};
	
	var Row = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      noGutters = _ref.noGutters,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var decoratedBsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'row');
	  var sizePrefix = decoratedBsPrefix + "-cols";
	  var classes = [];
	  DEVICE_SIZES.forEach(function (brkPoint) {
	    var propValue = props[brkPoint];
	    delete props[brkPoint];
	    var cols;
	
	    if (propValue != null && typeof propValue === 'object') {
	      cols = propValue.cols;
	    } else {
	      cols = propValue;
	    }
	
	    var infix = brkPoint !== 'xs' ? "-" + brkPoint : '';
	    if (cols != null) classes.push("" + sizePrefix + infix + "-" + cols);
	  });
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: _classnames.default.apply(void 0, [className, decoratedBsPrefix, noGutters && 'no-gutters'].concat(classes))
	  }));
	});
	
	Row.displayName = 'Row';
	Row.defaultProps = defaultProps;
	var _default = Row;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "variant", "animation", "size", "children", "as", "className"];
	
	var Spinner = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      variant = _ref.variant,
	      animation = _ref.animation,
	      size = _ref.size,
	      children = _ref.children,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      className = _ref.className,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'spinner');
	  var bsSpinnerPrefix = bsPrefix + "-" + animation;
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(className, bsSpinnerPrefix, size && bsSpinnerPrefix + "-" + size, variant && "text-" + variant)
	  }), children);
	});
	
	Spinner.displayName = 'Spinner';
	var _default = Spinner;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _Button = _interopRequireDefault(__webpack_require__(75));
	
	var _ButtonGroup = _interopRequireDefault(__webpack_require__(116));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(77));
	
	var _DropdownMenu = __webpack_require__(118);
	
	var _excluded = ["id", "bsPrefix", "size", "variant", "title", "type", "toggleLabel", "children", "onClick", "href", "target", "menuAlign", "menuRole", "renderMenuOnMount", "rootCloseEvent"];
	var propTypes = {
	  /**
	   * An html id attribute for the Toggle button, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: _propTypes.default.any,
	
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _propTypes.default.string,
	
	  /** An `href` passed to the non-toggle Button */
	  href: _propTypes.default.string,
	
	  /** An anchor `target` passed to the non-toggle Button */
	  target: _propTypes.default.string,
	
	  /** An `onClick` handler passed to the non-toggle Button */
	  onClick: _propTypes.default.func,
	
	  /** The content of the non-toggle Button.  */
	  title: _propTypes.default.node.isRequired,
	
	  /** A `type` passed to the non-toggle Button */
	  type: _propTypes.default.string,
	
	  /** Disables both Buttons  */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Aligns the dropdown menu responsively.
	   *
	   * _see [DropdownMenu](#dropdown-menu-props) for more details_
	   *
	   * @type {"left"|"right"|{ sm: "left"|"right" }|{ md: "left"|"right" }|{ lg: "left"|"right" }|{ xl: "left"|"right"} }
	   */
	  menuAlign: _DropdownMenu.alignPropType,
	
	  /** An ARIA accessible role applied to the Menu component. When set to 'menu', The dropdown */
	  menuRole: _propTypes.default.string,
	
	  /** Whether to render the dropdown menu in the DOM before the first time it is shown */
	  renderMenuOnMount: _propTypes.default.bool,
	
	  /**
	   *  Which event when fired outside the component will cause it to be closed.
	   *
	   * _see [DropdownMenu](#dropdown-menu-props) for more details_
	   */
	  rootCloseEvent: _propTypes.default.string,
	
	  /** @ignore */
	  bsPrefix: _propTypes.default.string,
	
	  /** @ignore */
	  variant: _propTypes.default.string,
	
	  /** @ignore */
	  size: _propTypes.default.string
	};
	var defaultProps = {
	  toggleLabel: 'Toggle dropdown',
	  type: 'button'
	};
	/**
	 * A convenience component for simple or general use split button dropdowns. Renders a
	 * `ButtonGroup` containing a `Button` and a `Button` toggle for the `Dropdown`. All `children`
	 * are passed directly to the default `Dropdown.Menu`. This component accepts all of [`Dropdown`'s
	 * props](#dropdown-props).
	 *
	 * _All unknown props are passed through to the `Dropdown` component._
	 * The Button `variant`, `size` and `bsPrefix` props are passed to the button and toggle,
	 * and menu-related props are passed to the `Dropdown.Menu`
	 */
	
	var SplitButton = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var id = _ref.id,
	      bsPrefix = _ref.bsPrefix,
	      size = _ref.size,
	      variant = _ref.variant,
	      title = _ref.title,
	      type = _ref.type,
	      toggleLabel = _ref.toggleLabel,
	      children = _ref.children,
	      onClick = _ref.onClick,
	      href = _ref.href,
	      target = _ref.target,
	      menuAlign = _ref.menuAlign,
	      menuRole = _ref.menuRole,
	      renderMenuOnMount = _ref.renderMenuOnMount,
	      rootCloseEvent = _ref.rootCloseEvent,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  return /*#__PURE__*/_react.default.createElement(_Dropdown.default, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    as: _ButtonGroup.default
	  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
	    size: size,
	    variant: variant,
	    disabled: props.disabled,
	    bsPrefix: bsPrefix,
	    href: href,
	    target: target,
	    onClick: onClick,
	    type: type
	  }, title), /*#__PURE__*/_react.default.createElement(_Dropdown.default.Toggle, {
	    split: true,
	    id: id ? id.toString() : undefined,
	    size: size,
	    variant: variant,
	    disabled: props.disabled,
	    childBsPrefix: bsPrefix
	  }, /*#__PURE__*/_react.default.createElement("span", {
	    className: "sr-only"
	  }, toggleLabel)), /*#__PURE__*/_react.default.createElement(_Dropdown.default.Menu, {
	    align: menuAlign,
	    role: menuRole,
	    renderOnMount: renderMenuOnMount,
	    rootCloseEvent: rootCloseEvent
	  }, children));
	});
	
	SplitButton.propTypes = propTypes;
	SplitButton.defaultProps = defaultProps;
	SplitButton.displayName = 'SplitButton';
	var _default = SplitButton;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _FormCheck = _interopRequireDefault(__webpack_require__(120));
	
	var Switch = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
	  return /*#__PURE__*/_react.default.createElement(_FormCheck.default, (0, _extends2.default)({}, props, {
	    ref: ref,
	    type: "switch"
	  }));
	});
	
	Switch.displayName = 'Switch';
	Switch.Input = _FormCheck.default.Input;
	Switch.Label = _FormCheck.default.Label;
	var _default = Switch;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _TabContainer = _interopRequireDefault(__webpack_require__(123));
	
	var _TabContent = _interopRequireDefault(__webpack_require__(124));
	
	var _TabPane = _interopRequireDefault(__webpack_require__(126));
	
	/* eslint-disable react/require-render-return, react/no-unused-prop-types */
	var Tab = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(Tab, _React$Component);
	
	  function Tab() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Tab.prototype;
	
	  _proto.render = function render() {
	    throw new Error('ReactBootstrap: The `Tab` component is not meant to be rendered! ' + "It's an abstract component that is only valid as a direct Child of the `Tabs` Component. " + 'For custom tabs components use TabPane and TabsContainer directly');
	    return null;
	  };
	
	  return Tab;
	}(_react.default.Component);
	
	Tab.Container = _TabContainer.default;
	Tab.Content = _TabContent.default;
	Tab.Pane = _TabPane.default;
	var _default = Tab;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "className", "striped", "bordered", "borderless", "hover", "size", "variant", "responsive"];
	
	var Table = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      striped = _ref.striped,
	      bordered = _ref.bordered,
	      borderless = _ref.borderless,
	      hover = _ref.hover,
	      size = _ref.size,
	      variant = _ref.variant,
	      responsive = _ref.responsive,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  var decoratedBsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'table');
	  var classes = (0, _classnames.default)(className, decoratedBsPrefix, variant && decoratedBsPrefix + "-" + variant, size && decoratedBsPrefix + "-" + size, striped && decoratedBsPrefix + "-striped", bordered && decoratedBsPrefix + "-bordered", borderless && decoratedBsPrefix + "-borderless", hover && decoratedBsPrefix + "-hover");
	
	  var table = /*#__PURE__*/_react.default.createElement("table", (0, _extends2.default)({}, props, {
	    className: classes,
	    ref: ref
	  }));
	
	  if (responsive) {
	    var responsiveClass = decoratedBsPrefix + "-responsive";
	
	    if (typeof responsive === 'string') {
	      responsiveClass = responsiveClass + "-" + responsive;
	    }
	
	    return /*#__PURE__*/_react.default.createElement("div", {
	      className: responsiveClass
	    }, table);
	  }
	
	  return table;
	});
	
	var _default = Table;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _isRequiredForA11y = _interopRequireDefault(__webpack_require__(72));
	
	var _uncontrollable = __webpack_require__(20);
	
	var _Nav = _interopRequireDefault(__webpack_require__(243));
	
	var _NavLink = _interopRequireDefault(__webpack_require__(79));
	
	var _NavItem = _interopRequireDefault(__webpack_require__(122));
	
	var _TabContainer = _interopRequireDefault(__webpack_require__(123));
	
	var _TabContent = _interopRequireDefault(__webpack_require__(124));
	
	var _TabPane = _interopRequireDefault(__webpack_require__(126));
	
	var _ElementChildren = __webpack_require__(78);
	
	var _excluded = ["id", "onSelect", "transition", "mountOnEnter", "unmountOnExit", "children", "activeKey"];
	var defaultProps = {
	  variant: 'tabs',
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey;
	  (0, _ElementChildren.forEach)(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	  return defaultActiveKey;
	}
	
	function renderTab(child) {
	  var _child$props = child.props,
	      title = _child$props.title,
	      eventKey = _child$props.eventKey,
	      disabled = _child$props.disabled,
	      tabClassName = _child$props.tabClassName,
	      id = _child$props.id;
	
	  if (title == null) {
	    return null;
	  }
	
	  return /*#__PURE__*/_react.default.createElement(_NavItem.default, {
	    as: _NavLink.default,
	    eventKey: eventKey,
	    disabled: disabled,
	    id: id,
	    className: tabClassName
	  }, title);
	}
	
	var Tabs = function Tabs(props) {
	  var _useUncontrolled = (0, _uncontrollable.useUncontrolled)(props, {
	    activeKey: 'onSelect'
	  }),
	      id = _useUncontrolled.id,
	      onSelect = _useUncontrolled.onSelect,
	      transition = _useUncontrolled.transition,
	      mountOnEnter = _useUncontrolled.mountOnEnter,
	      unmountOnExit = _useUncontrolled.unmountOnExit,
	      children = _useUncontrolled.children,
	      _useUncontrolled$acti = _useUncontrolled.activeKey,
	      activeKey = _useUncontrolled$acti === void 0 ? getDefaultActiveKey(children) : _useUncontrolled$acti,
	      controlledProps = (0, _objectWithoutPropertiesLoose2.default)(_useUncontrolled, _excluded);
	
	  return /*#__PURE__*/_react.default.createElement(_TabContainer.default, {
	    id: id,
	    activeKey: activeKey,
	    onSelect: onSelect,
	    transition: transition,
	    mountOnEnter: mountOnEnter,
	    unmountOnExit: unmountOnExit
	  }, /*#__PURE__*/_react.default.createElement(_Nav.default, (0, _extends2.default)({}, controlledProps, {
	    role: "tablist",
	    as: "nav"
	  }), (0, _ElementChildren.map)(children, renderTab)), /*#__PURE__*/_react.default.createElement(_TabContent.default, null, (0, _ElementChildren.map)(children, function (child) {
	    var childProps = (0, _extends2.default)({}, child.props);
	    delete childProps.title;
	    delete childProps.disabled;
	    delete childProps.tabClassName;
	    return /*#__PURE__*/_react.default.createElement(_TabPane.default, childProps);
	  })));
	};
	
	Tabs.defaultProps = defaultProps;
	Tabs.displayName = 'Tabs';
	var _default = Tabs;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _useTimeout = _interopRequireDefault(__webpack_require__(90));
	
	var _Fade = _interopRequireDefault(__webpack_require__(43));
	
	var _ToastHeader = _interopRequireDefault(__webpack_require__(251));
	
	var _ToastBody = _interopRequireDefault(__webpack_require__(249));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _ToastContext = _interopRequireDefault(__webpack_require__(250));
	
	var _excluded = ["bsPrefix", "className", "children", "transition", "show", "animation", "delay", "autohide", "onClose"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var Toast = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      children = _ref.children,
	      _ref$transition = _ref.transition,
	      Transition = _ref$transition === void 0 ? _Fade.default : _ref$transition,
	      _ref$show = _ref.show,
	      show = _ref$show === void 0 ? true : _ref$show,
	      _ref$animation = _ref.animation,
	      animation = _ref$animation === void 0 ? true : _ref$animation,
	      _ref$delay = _ref.delay,
	      delay = _ref$delay === void 0 ? 3000 : _ref$delay,
	      _ref$autohide = _ref.autohide,
	      autohide = _ref$autohide === void 0 ? false : _ref$autohide,
	      onClose = _ref.onClose,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'toast'); // We use refs for these, because we don't want to restart the autohide
	  // timer in case these values change.
	
	  var delayRef = (0, _react.useRef)(delay);
	  var onCloseRef = (0, _react.useRef)(onClose);
	  (0, _react.useEffect)(function () {
	    delayRef.current = delay;
	    onCloseRef.current = onClose;
	  }, [delay, onClose]);
	  var autohideTimeout = (0, _useTimeout.default)();
	  var autohideToast = !!(autohide && show);
	  var autohideFunc = (0, _react.useCallback)(function () {
	    if (autohideToast) {
	      onCloseRef.current == null ? void 0 : onCloseRef.current();
	    }
	  }, [autohideToast]);
	  (0, _react.useEffect)(function () {
	    // Only reset timer if show or autohide changes.
	    autohideTimeout.set(autohideFunc, delayRef.current);
	  }, [autohideTimeout, autohideFunc]);
	  var toastContext = (0, _react.useMemo)(function () {
	    return {
	      onClose: onClose
	    };
	  }, [onClose]);
	  var hasAnimation = !!(Transition && animation);
	
	  var toast = /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(bsPrefix, className, !hasAnimation && (show ? 'show' : 'hide')),
	    role: "alert",
	    "aria-live": "assertive",
	    "aria-atomic": "true"
	  }), children);
	
	  return /*#__PURE__*/_react.default.createElement(_ToastContext.default.Provider, {
	    value: toastContext
	  }, hasAnimation && Transition ? /*#__PURE__*/_react.default.createElement(Transition, {
	    in: show,
	    unmountOnExit: true
	  }, toast) : toast);
	});
	
	Toast.displayName = 'Toast';
	
	var _default = Object.assign(Toast, {
	  Body: _ToastBody.default,
	  Header: _ToastHeader.default
	});
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _invariant = _interopRequireDefault(__webpack_require__(70));
	
	var _uncontrollable = __webpack_require__(20);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(127));
	
	var _ElementChildren = __webpack_require__(78);
	
	var _ButtonGroup = _interopRequireDefault(__webpack_require__(116));
	
	var _ToggleButton = _interopRequireDefault(__webpack_require__(252));
	
	var _excluded = ["children", "type", "name", "value", "onChange"];
	var defaultProps = {
	  type: 'radio',
	  vertical: false
	};
	
	var ToggleButtonGroup = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
	  var _useUncontrolled = (0, _uncontrollable.useUncontrolled)(props, {
	    value: 'onChange'
	  }),
	      children = _useUncontrolled.children,
	      type = _useUncontrolled.type,
	      name = _useUncontrolled.name,
	      value = _useUncontrolled.value,
	      onChange = _useUncontrolled.onChange,
	      controlledProps = (0, _objectWithoutPropertiesLoose2.default)(_useUncontrolled, _excluded);
	
	  var getValues = function getValues() {
	    return value == null ? [] : [].concat(value);
	  };
	
	  var handleToggle = function handleToggle(inputVal, event) {
	    if (!onChange) {
	      return;
	    }
	
	    var values = getValues();
	    var isActive = values.indexOf(inputVal) !== -1;
	
	    if (type === 'radio') {
	      if (!isActive && onChange) onChange(inputVal, event);
	      return;
	    }
	
	    if (isActive) {
	      onChange(values.filter(function (n) {
	        return n !== inputVal;
	      }), event);
	    } else {
	      onChange([].concat(values, [inputVal]), event);
	    }
	  };
	
	  !(type !== 'radio' || !!name) ?  false ? (0, _invariant.default)(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : invariant(false) : void 0;
	  return /*#__PURE__*/_react.default.createElement(_ButtonGroup.default, (0, _extends2.default)({}, controlledProps, {
	    ref: ref,
	    toggle: true
	  }), (0, _ElementChildren.map)(children, function (child) {
	    var values = getValues();
	    var _child$props = child.props,
	        childVal = _child$props.value,
	        childOnChange = _child$props.onChange;
	
	    var handler = function handler(e) {
	      return handleToggle(childVal, e);
	    };
	
	    return /*#__PURE__*/_react.default.cloneElement(child, {
	      type: type,
	      name: child.name || name,
	      checked: values.indexOf(childVal) !== -1,
	      onChange: (0, _createChainedFunction.default)(childOnChange, handler)
	    });
	  }));
	});
	
	ToggleButtonGroup.defaultProps = defaultProps;
	ToggleButtonGroup.Button = _ToggleButton.default;
	var _default = ToggleButtonGroup;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _isRequiredForA11y = _interopRequireDefault(__webpack_require__(72));
	
	var _ThemeProvider = __webpack_require__(6);
	
	var _excluded = ["bsPrefix", "placement", "className", "style", "children", "arrowProps", "popper", "show"];
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      placement = _ref.placement,
	      className = _ref.className,
	      style = _ref.style,
	      children = _ref.children,
	      arrowProps = _ref.arrowProps,
	      _ = _ref.popper,
	      _2 = _ref.show,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'tooltip');
	
	  var _ref2 = (placement == null ? void 0 : placement.split('-')) || [],
	      primaryPlacement = _ref2[0];
	
	  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
	    ref: ref,
	    style: style,
	    role: "tooltip",
	    "x-placement": primaryPlacement,
	    className: (0, _classnames.default)(className, bsPrefix, "bs-tooltip-" + primaryPlacement)
	  }, props), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
	    className: "arrow"
	  }, arrowProps)), /*#__PURE__*/_react.default.createElement("div", {
	    className: bsPrefix + "-inner"
	  }, children));
	});
	
	Tooltip.defaultProps = defaultProps;
	Tooltip.displayName = 'Tooltip';
	var _default = Tooltip;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(2),n=__webpack_require__(115),r=__webpack_require__(580);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
	function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
	function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
	function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
	function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
	Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
	function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
	60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
	var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
	null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
	break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
	jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
	function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
	10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
	Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(2), __webpack_require__(14));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__14__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 11);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = warn;
	
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = trim;
	
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	function trim(s) {
	  return s && s.toString().replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addTrackers = addTrackers;
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	exports["default"] = exports.testModeAPI = exports.plugin = void 0;
	
	var _format2 = _interopRequireDefault(__webpack_require__(3));
	
	var _removeLeadingSlash = _interopRequireDefault(__webpack_require__(7));
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	var _loadGA = _interopRequireDefault(__webpack_require__(8));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _log = _interopRequireDefault(__webpack_require__(9));
	
	var _testModeAPI = _interopRequireDefault(__webpack_require__(10));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	var _alwaysSendToDefaultTracker = true;
	var _redactEmail = true;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI["default"].ga.apply(_testModeAPI["default"], arguments);
	  if (_isNotBrowser) return false;
	  if (!window.ga) return (0, _warn["default"])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format2["default"])(s, _titleCase, _redactEmail);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn["default"])('ga command must be a string');
	      return;
	    }
	
	    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);
	
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn["default"])('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	
	    if (options.redactEmail === false) {
	      _redactEmail = false;
	    }
	
	    if (options.useExistingGa) {
	      return;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function addTrackers(configsOrTrackingId, options) {
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if (_typeof(config) !== 'object') {
	        (0, _warn["default"])('All configs must be an object');
	        return;
	      }
	
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	
	  return true;
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (_isNotBrowser) {
	      return;
	    }
	
	    if (!options || options.standardImplementation !== true) (0, _loadGA["default"])(options);
	  }
	
	  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
	  addTrackers(configsOrTrackingId, options);
	}
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	
	
	function ga() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(void 0, args);
	
	    if (_debug) {
	      (0, _log["default"])("called ga('arguments');");
	      (0, _log["default"])("with arguments: ".concat(JSON.stringify(args)));
	    }
	  }
	
	  return window.ga;
	}
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn["default"])('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if (_typeof(fieldsObject) !== 'object') {
	    (0, _warn["default"])('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn["default"])('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log["default"])("called ga('set', fieldsObject);");
	    (0, _log["default"])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
	  }
	}
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	
	  if (_debug) {
	    (0, _log["default"])("called ga('send', fieldObject);");
	    (0, _log["default"])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
	    (0, _log["default"])("with trackers: ".concat(JSON.stringify(trackerNames)));
	  }
	}
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	
	
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn["default"])('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim["default"])(rawPath);
	
	  if (path === '') {
	    (0, _warn["default"])('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _objectSpread({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log["default"])("called ga('send', 'pageview', path);");
	      var extraLog = '';
	
	      if (title) {
	        extraLog = " and title: ".concat(title);
	      }
	
	      (0, _log["default"])("with path: ".concat(path).concat(extraLog));
	    }
	  }
	}
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn["default"])('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash["default"])((0, _trim["default"])(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn["default"])('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = "/modal/".concat(modalName);
	
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log["default"])("called ga('send', 'pageview', path);");
	      (0, _log["default"])("with path: ".concat(path));
	    }
	  }
	}
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || typeof value !== 'number') {
	      (0, _warn["default"])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {{action: string, category: string}} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn["default"])('args.category AND args.action are required in event()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    }; // Optional Fields
	
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn["default"])('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn["default"])('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn["default"])('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn["default"])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    }); // Send to GA
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    }; // Optional Fields
	
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn["default"])('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    } // Send to GA
	
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   * @param trackerName {String} optional e.g 'trackerName'
	   */
	  require: function require(rawName, options, trackerName) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn["default"])('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim["default"])(rawName);
	
	      if (name === '') {
	        (0, _warn["default"])('`name` cannot be an empty string in .require()');
	        return;
	      }
	
	      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields
	
	      if (options) {
	        if (_typeof(options) !== 'object') {
	          (0, _warn["default"])('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn["default"])('Empty `options` given to .require()');
	        }
	
	        ga(requireString, name, options);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
	        }
	      } else {
	        ga(requireString, name);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "');"));
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload;
	    var actionType;
	
	    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	      args[_key3 - 2] = arguments[_key3];
	    }
	
	    if (args.length === 1) {
	      payload = args[0];
	    } else {
	      actionType = args[0];
	      payload = args[1];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn["default"])('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn["default"])('Expected `action` arg to be a String.');
	      } else {
	        var command = "".concat(pluginName, ":").concat(action);
	        payload = payload || null;
	
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
	          }
	        } else if (payload) {
	          ga(command, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("with payload: ".concat(JSON.stringify(payload)));
	          }
	        } else {
	          ga(command);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	          }
	        }
	      }
	    }
	  }
	};
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	
	exports.plugin = plugin;
	
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn["default"])('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn["default"])('args.label is required in outboundLink()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	    var safetyCallbackCalled = false;
	
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	      hitCallback();
	    }; // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	    // register safety net timeout:
	
	
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA
	
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	var testModeAPI = _testModeAPI["default"];
	exports.testModeAPI = testModeAPI;
	var _default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  testModeAPI: _testModeAPI["default"]
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = format;
	
	var _redactEmail = _interopRequireDefault(__webpack_require__(4));
	
	var _toTitleCase = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function format() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var titleCase = arguments.length > 1 ? arguments[1] : undefined;
	  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  var _str = s || '';
	
	  if (titleCase) {
	    _str = (0, _toTitleCase["default"])(s);
	  }
	
	  if (redactingEmail) {
	    _str = (0, _redactEmail["default"])(_str);
	  }
	
	  return _str;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = redactEmail;
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _mightBeEmail = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function redactEmail(string) {
	  if ((0, _mightBeEmail["default"])(string)) {
	    (0, _warn["default"])('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = mightBeEmail;
	
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return typeof s === 'string' && s.indexOf('@') !== -1;
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = toTitleCase;
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * To Title Case 2.1 - http://individed.com/code/to-title-case/
	 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	 * https://github.com/gouch/to-title-case
	 */
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; // test
	
	function toTitleCase(string) {
	  return (0, _trim["default"])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = removeLeadingSlash;
	
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	var isLoaded = false;
	
	function _default(options) {
	  if (isLoaded) return;
	  isLoaded = true;
	  var gaAddress = 'https://www.google-analytics.com/analytics.js';
	
	  if (options && options.gaAddress) {
	    gaAddress = options.gaAddress;
	  } else if (options && options.debug) {
	    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
	  }
	
	  var onerror = options && options.onerror; // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	
	  /* eslint-disable */
	
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    a.onerror = onerror;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', gaAddress, 'ga');
	  /* eslint-enable */
	
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = log;
	
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.gaCalls = void 0;
	var gaCalls = [];
	exports.gaCalls = gaCalls;
	var _default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push([].concat(args));
	  },
	  resetCalls: function resetCalls() {
	    gaCalls.length = 0;
	  }
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.OutboundLink = exports.testModeAPI = exports.outboundLink = exports.plugin = exports.exception = exports.event = exports.timing = exports.modalview = exports.pageview = exports.send = exports.set = exports.ga = exports.addTrackers = exports.initialize = void 0;
	
	var _OutboundLink = _interopRequireDefault(__webpack_require__(12));
	
	var Defaults = _interopRequireWildcard(__webpack_require__(2));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialize = Defaults.initialize;
	exports.initialize = initialize;
	var addTrackers = Defaults.addTrackers;
	exports.addTrackers = addTrackers;
	var ga = Defaults.ga;
	exports.ga = ga;
	var set = Defaults.set;
	exports.set = set;
	var send = Defaults.send;
	exports.send = send;
	var pageview = Defaults.pageview;
	exports.pageview = pageview;
	var modalview = Defaults.modalview;
	exports.modalview = modalview;
	var timing = Defaults.timing;
	exports.timing = timing;
	var event = Defaults.event;
	exports.event = event;
	var exception = Defaults.exception;
	exports.exception = exception;
	var plugin = Defaults.plugin;
	exports.plugin = plugin;
	var outboundLink = Defaults.outboundLink;
	exports.outboundLink = outboundLink;
	var testModeAPI = Defaults.testModeAPI;
	exports.testModeAPI = testModeAPI;
	_OutboundLink["default"].origTrackLink = _OutboundLink["default"].trackLink;
	_OutboundLink["default"].trackLink = Defaults.outboundLink;
	var OutboundLink = _OutboundLink["default"];
	exports.OutboundLink = OutboundLink;
	
	var _default = _objectSpread(_objectSpread({}, Defaults), {}, {
	  OutboundLink: OutboundLink
	});
	
	exports["default"] = _default;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink = /*#__PURE__*/function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  var _super = _createSuper(OutboundLink);
	
	  function OutboundLink() {
	    var _this;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick,
	          trackerNames = _this$props.trackerNames;
	      var eventMeta = {
	        label: eventLabel
	      };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        }, trackerNames);
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(OutboundLink, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          href = _this$props2.to,
	          target = _this$props2.target,
	          oldProps = _objectWithoutProperties(_this$props2, ["to", "target"]);
	
	      var props = _objectSpread(_objectSpread({}, oldProps), {}, {
	        target: target,
	        href: href,
	        onClick: this.handleClick
	      });
	
	      if (target === NEWTAB) {
	        props.rel = "".concat(props.rel ? props.rel : '', " noopener noreferrer").trim();
	      }
	
	      delete props.eventLabel;
	      delete props.trackerNames;
	      return /*#__PURE__*/_react["default"].createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	exports["default"] = OutboundLink;
	
	_defineProperty(OutboundLink, "trackLink", function () {
	  (0, _warn["default"])('ga tracking not enabled');
	});
	
	OutboundLink.propTypes = {
	  eventLabel: _propTypes["default"].string.isRequired,
	  target: _propTypes["default"].string,
	  to: _propTypes["default"].string,
	  onClick: _propTypes["default"].func,
	  trackerNames: _propTypes["default"].arrayOf(_propTypes["default"].string)
	};
	OutboundLink.defaultProps = {
	  target: null,
	  to: null,
	  onClick: null,
	  trackerNames: null
	};
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__13__;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__14__;
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	(function(a,b){ true?module.exports=b(__webpack_require__(344),__webpack_require__(339),__webpack_require__(340),__webpack_require__(345),__webpack_require__(342),__webpack_require__(154),__webpack_require__(343),__webpack_require__(341),__webpack_require__(2),__webpack_require__(14)):"function"==typeof define&&define.amd?define(["@babel/runtime/helpers/objectWithoutProperties","@babel/runtime/helpers/classCallCheck","@babel/runtime/helpers/createClass","@babel/runtime/helpers/possibleConstructorReturn","@babel/runtime/helpers/getPrototypeOf","@babel/runtime/helpers/assertThisInitialized","@babel/runtime/helpers/inherits","@babel/runtime/helpers/defineProperty","react","prop-types"],b):(a=a||self,a.Img=b(a._objectWithoutProperties,a._classCallCheck,a._createClass,a._possibleConstructorReturn,a._getPrototypeOf,a._assertThisInitialized,a._inherits,a._defineProperty,a.React,a.propTypes))})(this,function(a,b,c,d,e,f,g,h,i,j){'use strict';function k(a,b){var c=Object.keys(a);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(a);b&&(d=d.filter(function(b){return Object.getOwnPropertyDescriptor(a,b).enumerable})),c.push.apply(c,d)}return c}function l(a){for(var b,c=1;c<arguments.length;c++)b=null==arguments[c]?{}:arguments[c],c%2?k(Object(b),!0).forEach(function(c){h(a,c,b[c])}):Object.getOwnPropertyDescriptors?Object.defineProperties(a,Object.getOwnPropertyDescriptors(b)):k(Object(b)).forEach(function(c){Object.defineProperty(a,c,Object.getOwnPropertyDescriptor(b,c))});return a}a=a&&a.hasOwnProperty("default")?a["default"]:a,b=b&&b.hasOwnProperty("default")?b["default"]:b,c=c&&c.hasOwnProperty("default")?c["default"]:c,d=d&&d.hasOwnProperty("default")?d["default"]:d,e=e&&e.hasOwnProperty("default")?e["default"]:e,f=f&&f.hasOwnProperty("default")?f["default"]:f,g=g&&g.hasOwnProperty("default")?g["default"]:g,h=h&&h.hasOwnProperty("default")?h["default"]:h;var m="default"in i?i["default"]:i,n={},o={loader:j.node,unloader:j.node,decode:j.bool,crossorigin:j.string,src:j.oneOfType([j.string,j.array]),container:j.func,loaderContainer:j.func,unloaderContainer:j.func},p=function(i){function j(a){var c;b(this,j),c=d(this,e(j).call(this,a)),h(f(c),"srcToArray",function(a){return(Array.isArray(a)?a:[a]).filter(function(a){return a})}),h(f(c),"onLoad",function(){n[c.sourceList[c.state.currentIndex]]=!0,c.i&&c.setState({isLoaded:!0})}),h(f(c),"onError",function(){if(n[c.sourceList[c.state.currentIndex]]=!1,!c.i)return!1;for(var a,b=c.state.currentIndex+1;b<c.sourceList.length;b++){if(a=c.sourceList[b],!(a in n)){c.setState({currentIndex:b});break}if(!0===n[a])return c.setState({currentIndex:b,isLoading:!1,isLoaded:!0}),!0;!1===n[a]}return b===c.sourceList.length?c.setState({isLoading:!1}):void c.loadImg()}),h(f(c),"loadImg",function(){c.i=new Image,c.i.src=c.sourceList[c.state.currentIndex],c.props.crossorigin&&(c.i.crossOrigin=c.props.crossorigin),c.props.decode&&c.i.decode?c.i.decode().then(c.onLoad)["catch"](c.onError):(c.i.onload=c.onLoad,c.i.onerror=c.onError)}),h(f(c),"unloadImg",function(){c.i.onerror=null,c.i.onload=null,c.i.src="";try{delete c.i.src}catch(a){}delete c.i}),c.loaderContainer=a.loaderContainer||a.container,c.unloaderContainer=a.unloaderContainer||a.container,c.sourceList=c.srcToArray(c.props.src);for(var g=0;g<c.sourceList.length&&!!(c.sourceList[g]in n);g++)if(!0===n[c.sourceList[g]])return c.state={currentIndex:g,isLoading:!1,isLoaded:!0},d(c);return c.state=c.sourceList.length?{currentIndex:0,isLoading:!0,isLoaded:!1}:{isLoading:!1,isLoaded:!1},c}return g(j,i),c(j,[{key:"componentDidMount",value:function(){this.state.isLoading&&this.loadImg()}},{key:"componentWillUnmount",value:function(){this.i&&this.unloadImg()}},{key:"UNSAFE_componentWillReceiveProps",value:function(a){var b=this;this.loaderContainer=a.loaderContainer||a.container,this.unloaderContainer=a.unloaderContainer||a.container;var c=this.srcToArray(a.src),d=c.filter(function(a){return-1===b.sourceList.indexOf(a)}),e=this.sourceList.filter(function(a){return-1===c.indexOf(a)});if(d.length||e.length){if(this.sourceList=c,!c.length)return this.setState({isLoading:!1,isLoaded:!1});this.setState({currentIndex:0,isLoading:!0,isLoaded:!1},this.loadImg)}}},{key:"render",value:function(){var b=this.props,c=b.container,d=b.loader,e=b.unloader,f=b.src,g=b.decode,h=b.loaderContainer,i=b.unloaderContainer,j=b.mockImage,k=a(b,["container","loader","unloader","src","decode","loaderContainer","unloaderContainer","mockImage"]);if(this.state.isLoaded){var n=l({},{src:this.sourceList[this.state.currentIndex]},{},k);return c(m.createElement("img",n))}return!this.state.isLoaded&&this.state.isLoading?d?this.loaderContainer(d):null:this.state.isLoaded||this.state.isLoading?void 0:e?this.unloaderContainer(e):null}}]),j}(i.Component);return h(p,"defaultProps",{loader:!1,unloader:!1,decode:!0,src:[],container:function(a){return a}}),p.propTypes={},p});
	//# sourceMappingURL=index.js.map


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyOpenClassName = exports.portalClassName = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(44);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalPortal = __webpack_require__(559);
	
	var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
	
	var _ariaAppHider = __webpack_require__(257);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _safeHTMLElement = __webpack_require__(131);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _reactLifecyclesCompat = __webpack_require__(256);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portalClassName = exports.portalClassName = "ReactModalPortal";
	var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
	
	var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;
	
	var createHTMLElement = function createHTMLElement(name) {
	  return document.createElement(name);
	};
	
	var getCreatePortal = function getCreatePortal() {
	  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
	};
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
	      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
	      var parent = getParentElement(_this.props.parentSelector);
	      if (parent && parent.contains(_this.node)) {
	        parent.removeChild(_this.node);
	      } else {
	        // eslint-disable-next-line no-console
	        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
	      }
	    }, _this.portalRef = function (ref) {
	      _this.portal = ref;
	    }, _this.renderPortal = function (props) {
	      var createPortal = getCreatePortal();
	      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
	      _this.portalRef(portal);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!_safeHTMLElement.canUseDOM) return;
	
	      if (!isReact16) {
	        this.node = createHTMLElement("div");
	      }
	      this.node.className = this.props.portalClassName;
	
	      var parent = getParentElement(this.props.parentSelector);
	      parent.appendChild(this.node);
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "getSnapshotBeforeUpdate",
	    value: function getSnapshotBeforeUpdate(prevProps) {
	      var prevParent = getParentElement(prevProps.parentSelector);
	      var nextParent = getParentElement(this.props.parentSelector);
	      return { prevParent: prevParent, nextParent: nextParent };
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, _, snapshot) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          portalClassName = _props.portalClassName;
	
	
	      if (prevProps.portalClassName !== portalClassName) {
	        this.node.className = portalClassName;
	      }
	
	      var prevParent = snapshot.prevParent,
	          nextParent = snapshot.nextParent;
	
	      if (nextParent !== prevParent) {
	        prevParent.removeChild(this.node);
	        nextParent.appendChild(this.node);
	      }
	
	      // Stop unnecessary renders if modal is remaining closed
	      if (!prevProps.isOpen && !isOpen) return;
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
	
	      var state = this.portal.state;
	      var now = Date.now();
	      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
	
	      if (closesAt) {
	        if (!state.beforeClose) {
	          this.portal.closeWithTimeout();
	        }
	
	        setTimeout(this.removePortal, closesAt - now);
	      } else {
	        this.removePortal();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!_safeHTMLElement.canUseDOM || !isReact16) {
	        return null;
	      }
	
	      if (!this.node && isReact16) {
	        this.node = createHTMLElement("div");
	      }
	
	      var createPortal = getCreatePortal();
	      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
	        ref: this.portalRef,
	        defaultStyles: Modal.defaultStyles
	      }, this.props)), this.node);
	    }
	  }], [{
	    key: "setAppElement",
	    value: function setAppElement(element) {
	      ariaAppHider.setElement(element);
	    }
	
	    /* eslint-disable react/no-unused-prop-types */
	
	    /* eslint-enable react/no-unused-prop-types */
	
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  portalClassName: _propTypes2.default.string,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  ariaHideApp: _propTypes2.default.bool,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  preventScroll: _propTypes2.default.bool,
	  parentSelector: _propTypes2.default.func,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  id: _propTypes2.default.string,
	  overlayElement: _propTypes2.default.func,
	  contentElement: _propTypes2.default.func
	};
	Modal.defaultProps = {
	  isOpen: false,
	  portalClassName: portalClassName,
	  bodyOpenClassName: bodyOpenClassName,
	  role: "dialog",
	  ariaHideApp: true,
	  closeTimeoutMS: 0,
	  shouldFocusAfterRender: true,
	  shouldCloseOnEsc: true,
	  shouldCloseOnOverlayClick: true,
	  shouldReturnFocusAfterClose: true,
	  preventScroll: false,
	  parentSelector: function parentSelector() {
	    return document.body;
	  },
	  overlayElement: function overlayElement(props, contentEl) {
	    return _react2.default.createElement(
	      "div",
	      props,
	      contentEl
	    );
	  },
	  contentElement: function contentElement(props, children) {
	    return _react2.default.createElement(
	      "div",
	      props,
	      children
	    );
	  }
	};
	Modal.defaultStyles = {
	  overlay: {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: "rgba(255, 255, 255, 0.75)"
	  },
	  content: {
	    position: "absolute",
	    top: "40px",
	    left: "40px",
	    right: "40px",
	    bottom: "40px",
	    border: "1px solid #ccc",
	    background: "#fff",
	    overflow: "auto",
	    WebkitOverflowScrolling: "touch",
	    borderRadius: "4px",
	    outline: "none",
	    padding: "20px"
	  }
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Modal);
	
	if (false) {
	  Modal.setCreateHTMLElement = function (fn) {
	    return createHTMLElement = fn;
	  };
	}
	
	exports.default = Modal;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _focusManager = __webpack_require__(562);
	
	var focusManager = _interopRequireWildcard(_focusManager);
	
	var _scopeTab = __webpack_require__(563);
	
	var _scopeTab2 = _interopRequireDefault(_scopeTab);
	
	var _ariaAppHider = __webpack_require__(257);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _classList = __webpack_require__(561);
	
	var classList = _interopRequireWildcard(_classList);
	
	var _safeHTMLElement = __webpack_require__(131);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _portalOpenInstances = __webpack_require__(258);
	
	var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
	
	__webpack_require__(560);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};
	
	var TAB_KEY = 9;
	var ESC_KEY = 27;
	
	var ariaHiddenInstances = 0;
	
	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);
	
	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);
	
	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
	
	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	      _this.props.overlayRef && _this.props.overlayRef(overlay);
	    };
	
	    _this.setContentRef = function (content) {
	      _this.content = content;
	      _this.props.contentRef && _this.props.contentRef(content);
	    };
	
	    _this.afterClose = function () {
	      var _this$props = _this.props,
	          appElement = _this$props.appElement,
	          ariaHideApp = _this$props.ariaHideApp,
	          htmlOpenClassName = _this$props.htmlOpenClassName,
	          bodyOpenClassName = _this$props.bodyOpenClassName;
	
	      // Remove classes.
	
	      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && ariaHiddenInstances > 0) {
	        ariaHiddenInstances -= 1;
	
	        if (ariaHiddenInstances === 0) {
	          ariaAppHider.show(appElement);
	        }
	      }
	
	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager.returnFocus(_this.props.preventScroll);
	          focusManager.teardownScopedFocus();
	        } else {
	          focusManager.popWithoutFocus();
	        }
	      }
	
	      if (_this.props.onAfterClose) {
	        _this.props.onAfterClose();
	      }
	
	      _portalOpenInstances2.default.deregister(_this);
	    };
	
	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager.setupScopedFocus(_this.node);
	          focusManager.markForFocusLater();
	        }
	
	        _this.setState({ isOpen: true }, function () {
	          _this.openAnimationFrame = requestAnimationFrame(function () {
	            _this.setState({ afterOpen: true });
	
	            if (_this.props.isOpen && _this.props.onAfterOpen) {
	              _this.props.onAfterOpen({
	                overlayEl: _this.overlay,
	                contentEl: _this.content
	              });
	            }
	          });
	        });
	      }
	    };
	
	    _this.close = function () {
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };
	
	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
	    };
	
	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };
	
	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };
	
	    _this.handleKeyDown = function (event) {
	      if (event.keyCode === TAB_KEY) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }
	
	      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
	        event.stopPropagation();
	        _this.requestClose(event);
	      }
	    };
	
	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	    };
	
	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleOverlayOnMouseDown = function (event) {
	      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };
	
	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };
	
	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };
	
	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };
	
	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };
	
	    _this.attributesFromObject = function (prefix, items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc[prefix + "-" + name] = items[name];
	        return acc;
	      }, {});
	    };
	
	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };
	
	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }
	
	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.isOpen) {
	        this.open();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (false) {
	        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }
	
	      if (this.props.isOpen && !prevProps.isOpen) {
	        this.open();
	      } else if (!this.props.isOpen && prevProps.isOpen) {
	        this.close();
	      }
	
	      // Focus only needs to be set once when the modal is being opened
	      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
	        this.focusContent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.state.isOpen) {
	        this.afterClose();
	      }
	      clearTimeout(this.closeTimer);
	      cancelAnimationFrame(this.openAnimationFrame);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          htmlOpenClassName = _props.htmlOpenClassName,
	          bodyOpenClassName = _props.bodyOpenClassName;
	
	      // Add classes.
	
	      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      if (ariaHideApp) {
	        ariaHiddenInstances += 1;
	        ariaAppHider.hide(appElement);
	      }
	
	      _portalOpenInstances2.default.register(this);
	    }
	
	    // Don't steal focus from inner elements
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          overlayClassName = _props2.overlayClassName,
	          defaultStyles = _props2.defaultStyles,
	          children = _props2.children;
	
	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
	
	      if (this.shouldBeClosed()) {
	        return null;
	      }
	
	      var overlayProps = {
	        ref: this.setOverlayRef,
	        className: this.buildClassName("overlay", overlayClassName),
	        style: _extends({}, overlayStyles, this.props.style.overlay),
	        onClick: this.handleOverlayOnClick,
	        onMouseDown: this.handleOverlayOnMouseDown
	      };
	
	      var contentProps = _extends({
	        id: id,
	        ref: this.setContentRef,
	        style: _extends({}, contentStyles, this.props.style.content),
	        className: this.buildClassName("content", className),
	        tabIndex: "-1",
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleContentOnMouseDown,
	        onMouseUp: this.handleContentOnMouseUp,
	        onClick: this.handleContentOnClick,
	        role: this.props.role,
	        "aria-label": this.props.contentLabel
	      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
	        "data-testid": this.props.testId
	      });
	
	      var contentElement = this.props.contentElement(contentProps, children);
	      return this.props.overlayElement(overlayProps, contentElement);
	    }
	  }]);
	
	  return ModalPortal;
	}(_react.Component);
	
	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  },
	  defaultStyles: {}
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
	  onAfterOpen: _propTypes2.default.func,
	  onAfterClose: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  preventScroll: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  id: _propTypes2.default.string,
	  overlayElement: _propTypes2.default.func,
	  contentElement: _propTypes2.default.func,
	  testId: _propTypes2.default.string
	};
	exports.default = ModalPortal;
	module.exports = exports["default"];

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	
	var _portalOpenInstances = __webpack_require__(258);
	
	var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Body focus trap see Issue #742
	
	var before = void 0,
	    after = void 0,
	    instances = [];
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function resetState() {
	  var _arr = [before, after];
	
	  for (var _i = 0; _i < _arr.length; _i++) {
	    var item = _arr[_i];
	    if (!item) continue;
	    item.parentNode && item.parentNode.removeChild(item);
	  }
	  before = after = null;
	  instances = [];
	}
	
	/* istanbul ignore next */
	function log() {
	  console.log("bodyTrap ----------");
	  console.log(instances.length);
	  var _arr2 = [before, after];
	  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
	    var item = _arr2[_i2];
	    var check = item || {};
	    console.log(check.nodeName, check.className, check.id);
	  }
	  console.log("edn bodyTrap ----------");
	}
	/* eslint-enable no-console */
	
	function focusContent() {
	  if (instances.length === 0) {
	    if (false) {
	      // eslint-disable-next-line no-console
	      console.warn("React-Modal: Open instances > 0 expected");
	    }
	    return;
	  }
	  instances[instances.length - 1].focusContent();
	}
	
	function bodyTrap(eventType, openInstances) {
	  if (!before && !after) {
	    before = document.createElement("div");
	    before.setAttribute("data-react-modal-body-trap", "");
	    before.style.position = "absolute";
	    before.style.opacity = "0";
	    before.setAttribute("tabindex", "0");
	    before.addEventListener("focus", focusContent);
	    after = before.cloneNode();
	    after.addEventListener("focus", focusContent);
	  }
	
	  instances = openInstances;
	
	  if (instances.length > 0) {
	    // Add focus trap
	    if (document.body.firstChild !== before) {
	      document.body.insertBefore(before, document.body.firstChild);
	    }
	    if (document.body.lastChild !== after) {
	      document.body.appendChild(after);
	    }
	  } else {
	    // Remove focus trap
	    if (before.parentElement) {
	      before.parentElement.removeChild(before);
	    }
	    if (after.parentElement) {
	      after.parentElement.removeChild(after);
	    }
	  }
	}
	
	_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	var htmlClassList = {};
	var docBodyClassList = {};
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function removeClass(at, cls) {
	  at.classList.remove(cls);
	}
	
	/* istanbul ignore next */
	function resetState() {
	  var htmlElement = document.getElementsByTagName("html")[0];
	  for (var cls in htmlClassList) {
	    removeClass(htmlElement, htmlClassList[cls]);
	  }
	
	  var body = document.body;
	  for (var _cls in docBodyClassList) {
	    removeClass(body, docBodyClassList[_cls]);
	  }
	
	  htmlClassList = {};
	  docBodyClassList = {};
	}
	
	/* istanbul ignore next */
	function log() {
	  if (true) return;
	
	  var classes = document.getElementsByTagName("html")[0].className;
	  var buffer = "Show tracked classes:\n\n";
	
	  buffer += "<html /> (" + classes + "):\n";
	  for (var x in htmlClassList) {
	    buffer += "  " + x + " " + htmlClassList[x] + "\n";
	  }
	
	  classes = document.body.className;
	
	  buffer += "\n\ndoc.body (" + classes + "):\n";
	  for (var _x in docBodyClassList) {
	    buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
	  }
	
	  buffer += "\n";
	
	  console.log(buffer);
	}
	/* eslint-enable no-console */
	
	/**
	 * Track the number of reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var incrementReference = function incrementReference(poll, className) {
	  if (!poll[className]) {
	    poll[className] = 0;
	  }
	  poll[className] += 1;
	  return className;
	};
	
	/**
	 * Drop the reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var decrementReference = function decrementReference(poll, className) {
	  if (poll[className]) {
	    poll[className] -= 1;
	  }
	  return className;
	};
	
	/**
	 * Track a class and add to the given class list.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be tracked.
	 */
	var trackClass = function trackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    incrementReference(poll, className);
	    classListRef.add(className);
	  });
	};
	
	/**
	 * Untrack a class and remove from the given class list if the reference
	 * reaches 0.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be untracked.
	 */
	var untrackClass = function untrackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    decrementReference(poll, className);
	    poll[className] === 0 && classListRef.remove(className);
	  });
	};
	
	/**
	 * Public inferface to add classes to the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var add = exports.add = function add(element, classString) {
	  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};
	
	/**
	 * Public inferface to remove classes from the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var remove = exports.remove = function remove(element, classString) {
	  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	exports.handleBlur = handleBlur;
	exports.handleFocus = handleFocus;
	exports.markForFocusLater = markForFocusLater;
	exports.returnFocus = returnFocus;
	exports.popWithoutFocus = popWithoutFocus;
	exports.setupScopedFocus = setupScopedFocus;
	exports.teardownScopedFocus = teardownScopedFocus;
	
	var _tabbable = __webpack_require__(259);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function resetState() {
	  focusLaterElements = [];
	}
	
	/* istanbul ignore next */
	function log() {
	  if (true) return;
	  console.log("focusManager ----------");
	  focusLaterElements.forEach(function (f) {
	    var check = f || {};
	    console.log(check.nodeName, check.className, check.id);
	  });
	  console.log("end focusManager ----------");
	}
	/* eslint-enable no-console */
	
	function handleBlur() {
	  needToFocus = true;
	}
	
	function handleFocus() {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function () {
	      if (modalElement.contains(document.activeElement)) {
	        return;
	      }
	      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
	      el.focus();
	    }, 0);
	  }
	}
	
	function markForFocusLater() {
	  focusLaterElements.push(document.activeElement);
	}
	
	/* eslint-disable no-console */
	function returnFocus() {
	  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	  var toFocus = null;
	  try {
	    if (focusLaterElements.length !== 0) {
	      toFocus = focusLaterElements.pop();
	      toFocus.focus({ preventScroll: preventScroll });
	    }
	    return;
	  } catch (e) {
	    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
	  }
	}
	/* eslint-enable no-console */
	
	function popWithoutFocus() {
	  focusLaterElements.length > 0 && focusLaterElements.pop();
	}
	
	function setupScopedFocus(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener("blur", handleBlur, false);
	    document.addEventListener("focus", handleFocus, true);
	  } else {
	    window.attachEvent("onBlur", handleBlur);
	    document.attachEvent("onFocus", handleFocus);
	  }
	}
	
	function teardownScopedFocus() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener("blur", handleBlur);
	    document.removeEventListener("focus", handleFocus);
	  } else {
	    window.detachEvent("onBlur", handleBlur);
	    document.detachEvent("onFocus", handleFocus);
	  }
	}

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;
	
	var _tabbable = __webpack_require__(259);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);
	
	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }
	
	  var target = void 0;
	
	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	
	  // proceed with default browser behavior on tab.
	  // Focus on last element on shift + tab.
	  if (node === document.activeElement) {
	    if (!shiftKey) return;
	    target = tail;
	  }
	
	  if (tail === document.activeElement && !shiftKey) {
	    target = head;
	  }
	
	  if (head === document.activeElement && shiftKey) {
	    target = tail;
	  }
	
	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }
	
	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prone, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
	
	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;
	
	  var x = tabbable.indexOf(document.activeElement);
	
	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }
	
	  target = tabbable[x];
	
	  // If the tabbable element does not exist,
	  // focus head/tail based on shiftKey
	  if (typeof target === "undefined") {
	    event.preventDefault();
	    target = shiftKey ? tail : head;
	    target.focus();
	    return;
	  }
	
	  event.preventDefault();
	
	  target.focus();
	}
	module.exports = exports["default"];

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(558);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports["default"];

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(32);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _matches = _interopRequireDefault(__webpack_require__(438));
	
	var _querySelectorAll = _interopRequireDefault(__webpack_require__(99));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(96));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _uncontrollable = __webpack_require__(20);
	
	var _usePrevious = _interopRequireDefault(__webpack_require__(162));
	
	var _useForceUpdate = _interopRequireDefault(__webpack_require__(161));
	
	var _useGlobalListener = _interopRequireDefault(__webpack_require__(355));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(18));
	
	var _DropdownContext = _interopRequireDefault(__webpack_require__(132));
	
	var _DropdownMenu = _interopRequireDefault(__webpack_require__(260));
	
	var _DropdownToggle = _interopRequireDefault(__webpack_require__(261));
	
	var propTypes = {
	  /**
	   * A render prop that returns the root dropdown element. The `props`
	   * argument should spread through to an element containing _both_ the
	   * menu and toggle in order to handle keyboard events for focus management.
	   *
	   * @type {Function ({
	   *   props: {
	   *     onKeyDown: (SyntheticEvent) => void,
	   *   },
	   * }) => React.Element}
	   */
	  children: _propTypes["default"].node,
	
	  /**
	   * Determines the direction and location of the Menu in relation to it's Toggle.
	   */
	  drop: _propTypes["default"].oneOf(['up', 'left', 'right', 'down']),
	
	  /**
	   * Controls the focus behavior for when the Dropdown is opened. Set to
	   * `true` to always focus the first menu item, `keyboard` to focus only when
	   * navigating via the keyboard, or `false` to disable completely
	   *
	   * The Default behavior is `false` **unless** the Menu has a `role="menu"`
	   * where it will default to `keyboard` to match the recommended [ARIA Authoring practices](https://www.w3.org/TR/wai-aria-practices-1.1/#menubutton).
	   */
	  focusFirstItemOnShow: _propTypes["default"].oneOf([false, true, 'keyboard']),
	
	  /**
	   * A css slector string that will return __focusable__ menu items.
	   * Selectors should be relative to the menu component:
	   * e.g. ` > li:not('.disabled')`
	   */
	  itemSelector: _propTypes["default"].string,
	
	  /**
	   * Align the menu to the 'end' side of the placement side of the Dropdown toggle. The default placement is `top-start` or `bottom-start`.
	   */
	  alignEnd: _propTypes["default"].bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  show: _propTypes["default"].bool,
	
	  /**
	   * Sets the initial show position of the Dropdown.
	   */
	  defaultShow: _propTypes["default"].bool,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `show` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
	   *
	   * ```ts static
	   * function(
	   *   isOpen: boolean,
	   *   event: SyntheticEvent,
	   * ): void
	   * ```
	   *
	   * @controllable show
	   */
	  onToggle: _propTypes["default"].func
	};
	
	function useRefWithUpdate() {
	  var forceUpdate = (0, _useForceUpdate["default"])();
	  var ref = (0, _react.useRef)(null);
	  var attachRef = (0, _react.useCallback)(function (element) {
	    ref.current = element; // ensure that a menu set triggers an update for consumers
	
	    forceUpdate();
	  }, [forceUpdate]);
	  return [ref, attachRef];
	}
	/**
	 * @displayName Dropdown
	 * @public
	 */
	
	
	function Dropdown(_ref) {
	  var drop = _ref.drop,
	      alignEnd = _ref.alignEnd,
	      defaultShow = _ref.defaultShow,
	      rawShow = _ref.show,
	      rawOnToggle = _ref.onToggle,
	      _ref$itemSelector = _ref.itemSelector,
	      itemSelector = _ref$itemSelector === void 0 ? '* > *' : _ref$itemSelector,
	      focusFirstItemOnShow = _ref.focusFirstItemOnShow,
	      children = _ref.children;
	
	  var _useUncontrolledProp = (0, _uncontrollable.useUncontrolledProp)(rawShow, defaultShow, rawOnToggle),
	      show = _useUncontrolledProp[0],
	      onToggle = _useUncontrolledProp[1]; // We use normal refs instead of useCallbackRef in order to populate the
	  // the value as quickly as possible, otherwise the effect to focus the element
	  // may run before the state value is set
	
	
	  var _useRefWithUpdate = useRefWithUpdate(),
	      menuRef = _useRefWithUpdate[0],
	      setMenu = _useRefWithUpdate[1];
	
	  var menuElement = menuRef.current;
	
	  var _useRefWithUpdate2 = useRefWithUpdate(),
	      toggleRef = _useRefWithUpdate2[0],
	      setToggle = _useRefWithUpdate2[1];
	
	  var toggleElement = toggleRef.current;
	  var lastShow = (0, _usePrevious["default"])(show);
	  var lastSourceEvent = (0, _react.useRef)(null);
	  var focusInDropdown = (0, _react.useRef)(false);
	  var toggle = (0, _react.useCallback)(function (nextShow, event) {
	    onToggle(nextShow, event);
	  }, [onToggle]);
	  var context = (0, _react.useMemo)(function () {
	    return {
	      toggle: toggle,
	      drop: drop,
	      show: show,
	      alignEnd: alignEnd,
	      menuElement: menuElement,
	      toggleElement: toggleElement,
	      setMenu: setMenu,
	      setToggle: setToggle
	    };
	  }, [toggle, drop, show, alignEnd, menuElement, toggleElement, setMenu, setToggle]);
	
	  if (menuElement && lastShow && !show) {
	    focusInDropdown.current = menuElement.contains(document.activeElement);
	  }
	
	  var focusToggle = (0, _useEventCallback["default"])(function () {
	    if (toggleElement && toggleElement.focus) {
	      toggleElement.focus();
	    }
	  });
	  var maybeFocusFirst = (0, _useEventCallback["default"])(function () {
	    var type = lastSourceEvent.current;
	    var focusType = focusFirstItemOnShow;
	
	    if (focusType == null) {
	      focusType = menuRef.current && (0, _matches["default"])(menuRef.current, '[role=menu]') ? 'keyboard' : false;
	    }
	
	    if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) {
	      return;
	    }
	
	    var first = (0, _querySelectorAll["default"])(menuRef.current, itemSelector)[0];
	    if (first && first.focus) first.focus();
	  });
	  (0, _react.useEffect)(function () {
	    if (show) maybeFocusFirst();else if (focusInDropdown.current) {
	      focusInDropdown.current = false;
	      focusToggle();
	    } // only `show` should be changing
	  }, [show, focusInDropdown, focusToggle, maybeFocusFirst]);
	  (0, _react.useEffect)(function () {
	    lastSourceEvent.current = null;
	  });
	
	  var getNextFocusedChild = function getNextFocusedChild(current, offset) {
	    if (!menuRef.current) return null;
	    var items = (0, _querySelectorAll["default"])(menuRef.current, itemSelector);
	    var index = items.indexOf(current) + offset;
	    index = Math.max(0, Math.min(index, items.length));
	    return items[index];
	  };
	
	  (0, _useGlobalListener["default"])('keydown', function (event) {
	    var _menuRef$current, _toggleRef$current;
	
	    var key = event.key;
	    var target = event.target;
	    var fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
	    var fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target); // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
	    // in inscrutability
	
	    var isInput = /input|textarea/i.test(target.tagName);
	
	    if (isInput && (key === ' ' || key !== 'Escape' && fromMenu)) {
	      return;
	    }
	
	    if (!fromMenu && !fromToggle) {
	      return;
	    }
	
	    if (!menuRef.current && key === 'Tab') {
	      return;
	    }
	
	    lastSourceEvent.current = event.type;
	
	    switch (key) {
	      case 'ArrowUp':
	        {
	          var next = getNextFocusedChild(target, -1);
	          if (next && next.focus) next.focus();
	          event.preventDefault();
	          return;
	        }
	
	      case 'ArrowDown':
	        event.preventDefault();
	
	        if (!show) {
	          onToggle(true, event);
	        } else {
	          var _next = getNextFocusedChild(target, 1);
	
	          if (_next && _next.focus) _next.focus();
	        }
	
	        return;
	
	      case 'Tab':
	        // on keydown the target is the element being tabbed FROM, we need that
	        // to know if this event is relevant to this dropdown (e.g. in this menu).
	        // On `keyup` the target is the element being tagged TO which we use to check
	        // if focus has left the menu
	        (0, _addEventListener["default"])(document, 'keyup', function (e) {
	          var _menuRef$current2;
	
	          if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) {
	            onToggle(false, event);
	          }
	        }, {
	          once: true
	        });
	        break;
	
	      case 'Escape':
	        event.preventDefault();
	        event.stopPropagation();
	        onToggle(false, event);
	        break;
	
	      default:
	    }
	  });
	  return /*#__PURE__*/_react["default"].createElement(_DropdownContext["default"].Provider, {
	    value: context
	  }, children);
	}
	
	Dropdown.displayName = 'ReactOverlaysDropdown';
	Dropdown.propTypes = propTypes;
	Dropdown.Menu = _DropdownMenu["default"];
	Dropdown.Toggle = _DropdownToggle["default"];
	var _default = Dropdown;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(32);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _activeElement = _interopRequireDefault(__webpack_require__(429));
	
	var _contains = _interopRequireDefault(__webpack_require__(97));
	
	var _canUseDOM = _interopRequireDefault(__webpack_require__(62));
	
	var _listen = _interopRequireDefault(__webpack_require__(98));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(44));
	
	var _useMounted = _interopRequireDefault(__webpack_require__(89));
	
	var _useWillUnmount = _interopRequireDefault(__webpack_require__(91));
	
	var _usePrevious = _interopRequireDefault(__webpack_require__(162));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(18));
	
	var _ModalManager = _interopRequireDefault(__webpack_require__(262));
	
	var _useWaitForDOMRef = _interopRequireDefault(__webpack_require__(267));
	
	/* eslint-disable @typescript-eslint/no-use-before-define, react/prop-types */
	var manager;
	
	function getManager() {
	  if (!manager) manager = new _ModalManager["default"]();
	  return manager;
	}
	
	function useModalManager(provided) {
	  var modalManager = provided || getManager();
	  var modal = (0, _react.useRef)({
	    dialog: null,
	    backdrop: null
	  });
	  return Object.assign(modal.current, {
	    add: function add(container, className) {
	      return modalManager.add(modal.current, container, className);
	    },
	    remove: function remove() {
	      return modalManager.remove(modal.current);
	    },
	    isTopModal: function isTopModal() {
	      return modalManager.isTopModal(modal.current);
	    },
	    setDialogRef: (0, _react.useCallback)(function (ref) {
	      modal.current.dialog = ref;
	    }, []),
	    setBackdropRef: (0, _react.useCallback)(function (ref) {
	      modal.current.backdrop = ref;
	    }, [])
	  });
	}
	
	var Modal = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
	  var _ref$show = _ref.show,
	      show = _ref$show === void 0 ? false : _ref$show,
	      _ref$role = _ref.role,
	      role = _ref$role === void 0 ? 'dialog' : _ref$role,
	      className = _ref.className,
	      style = _ref.style,
	      children = _ref.children,
	      _ref$backdrop = _ref.backdrop,
	      backdrop = _ref$backdrop === void 0 ? true : _ref$backdrop,
	      _ref$keyboard = _ref.keyboard,
	      keyboard = _ref$keyboard === void 0 ? true : _ref$keyboard,
	      onBackdropClick = _ref.onBackdropClick,
	      onEscapeKeyDown = _ref.onEscapeKeyDown,
	      transition = _ref.transition,
	      backdropTransition = _ref.backdropTransition,
	      _ref$autoFocus = _ref.autoFocus,
	      autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus,
	      _ref$enforceFocus = _ref.enforceFocus,
	      enforceFocus = _ref$enforceFocus === void 0 ? true : _ref$enforceFocus,
	      _ref$restoreFocus = _ref.restoreFocus,
	      restoreFocus = _ref$restoreFocus === void 0 ? true : _ref$restoreFocus,
	      restoreFocusOptions = _ref.restoreFocusOptions,
	      renderDialog = _ref.renderDialog,
	      _ref$renderBackdrop = _ref.renderBackdrop,
	      renderBackdrop = _ref$renderBackdrop === void 0 ? function (props) {
	    return /*#__PURE__*/_react["default"].createElement("div", props);
	  } : _ref$renderBackdrop,
	      providedManager = _ref.manager,
	      containerRef = _ref.container,
	      containerClassName = _ref.containerClassName,
	      onShow = _ref.onShow,
	      _ref$onHide = _ref.onHide,
	      onHide = _ref$onHide === void 0 ? function () {} : _ref$onHide,
	      onExit = _ref.onExit,
	      onExited = _ref.onExited,
	      onExiting = _ref.onExiting,
	      onEnter = _ref.onEnter,
	      onEntering = _ref.onEntering,
	      onEntered = _ref.onEntered,
	      rest = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["show", "role", "className", "style", "children", "backdrop", "keyboard", "onBackdropClick", "onEscapeKeyDown", "transition", "backdropTransition", "autoFocus", "enforceFocus", "restoreFocus", "restoreFocusOptions", "renderDialog", "renderBackdrop", "manager", "container", "containerClassName", "onShow", "onHide", "onExit", "onExited", "onExiting", "onEnter", "onEntering", "onEntered"]);
	  var container = (0, _useWaitForDOMRef["default"])(containerRef);
	  var modal = useModalManager(providedManager);
	  var isMounted = (0, _useMounted["default"])();
	  var prevShow = (0, _usePrevious["default"])(show);
	
	  var _useState = (0, _react.useState)(!show),
	      exited = _useState[0],
	      setExited = _useState[1];
	
	  var lastFocusRef = (0, _react.useRef)(null);
	  (0, _react.useImperativeHandle)(ref, function () {
	    return modal;
	  }, [modal]);
	
	  if (_canUseDOM["default"] && !prevShow && show) {
	    lastFocusRef.current = (0, _activeElement["default"])();
	  }
	
	  if (!transition && !show && !exited) {
	    setExited(true);
	  } else if (show && exited) {
	    setExited(false);
	  }
	
	  var handleShow = (0, _useEventCallback["default"])(function () {
	    modal.add(container, containerClassName);
	    removeKeydownListenerRef.current = (0, _listen["default"])(document, 'keydown', handleDocumentKeyDown);
	    removeFocusListenerRef.current = (0, _listen["default"])(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
	    // and so steals focus from it
	    function () {
	      return setTimeout(handleEnforceFocus);
	    }, true);
	
	    if (onShow) {
	      onShow();
	    } // autofocus after onShow to not trigger a focus event for previous
	    // modals before this one is shown.
	
	
	    if (autoFocus) {
	      var currentActiveElement = (0, _activeElement["default"])(document);
	
	      if (modal.dialog && currentActiveElement && !(0, _contains["default"])(modal.dialog, currentActiveElement)) {
	        lastFocusRef.current = currentActiveElement;
	        modal.dialog.focus();
	      }
	    }
	  });
	  var handleHide = (0, _useEventCallback["default"])(function () {
	    modal.remove();
	    removeKeydownListenerRef.current == null ? void 0 : removeKeydownListenerRef.current();
	    removeFocusListenerRef.current == null ? void 0 : removeFocusListenerRef.current();
	
	    if (restoreFocus) {
	      var _lastFocusRef$current;
	
	      // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	      (_lastFocusRef$current = lastFocusRef.current) == null ? void 0 : _lastFocusRef$current.focus == null ? void 0 : _lastFocusRef$current.focus(restoreFocusOptions);
	      lastFocusRef.current = null;
	    }
	  }); // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
	  // Show logic when:
	  //  - show is `true` _and_ `container` has resolved
	
	  (0, _react.useEffect)(function () {
	    if (!show || !container) return;
	    handleShow();
	  }, [show, container,
	  /* should never change: */
	  handleShow]); // Hide cleanup logic when:
	  //  - `exited` switches to true
	  //  - component unmounts;
	
	  (0, _react.useEffect)(function () {
	    if (!exited) return;
	    handleHide();
	  }, [exited, handleHide]);
	  (0, _useWillUnmount["default"])(function () {
	    handleHide();
	  }); // --------------------------------
	
	  var handleEnforceFocus = (0, _useEventCallback["default"])(function () {
	    if (!enforceFocus || !isMounted() || !modal.isTopModal()) {
	      return;
	    }
	
	    var currentActiveElement = (0, _activeElement["default"])();
	
	    if (modal.dialog && currentActiveElement && !(0, _contains["default"])(modal.dialog, currentActiveElement)) {
	      modal.dialog.focus();
	    }
	  });
	  var handleBackdropClick = (0, _useEventCallback["default"])(function (e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    onBackdropClick == null ? void 0 : onBackdropClick(e);
	
	    if (backdrop === true) {
	      onHide();
	    }
	  });
	  var handleDocumentKeyDown = (0, _useEventCallback["default"])(function (e) {
	    if (keyboard && e.keyCode === 27 && modal.isTopModal()) {
	      onEscapeKeyDown == null ? void 0 : onEscapeKeyDown(e);
	
	      if (!e.defaultPrevented) {
	        onHide();
	      }
	    }
	  });
	  var removeFocusListenerRef = (0, _react.useRef)();
	  var removeKeydownListenerRef = (0, _react.useRef)();
	
	  var handleHidden = function handleHidden() {
	    setExited(true);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    onExited == null ? void 0 : onExited.apply(void 0, args);
	  };
	
	  var Transition = transition;
	
	  if (!container || !(show || Transition && !exited)) {
	    return null;
	  }
	
	  var dialogProps = (0, _extends2["default"])({
	    role: role,
	    ref: modal.setDialogRef,
	    // apparently only works on the dialog role element
	    'aria-modal': role === 'dialog' ? true : undefined
	  }, rest, {
	    style: style,
	    className: className,
	    tabIndex: -1
	  });
	  var dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/_react["default"].createElement("div", dialogProps, /*#__PURE__*/_react["default"].cloneElement(children, {
	    role: 'document'
	  }));
	
	  if (Transition) {
	    dialog = /*#__PURE__*/_react["default"].createElement(Transition, {
	      appear: true,
	      unmountOnExit: true,
	      "in": !!show,
	      onExit: onExit,
	      onExiting: onExiting,
	      onExited: handleHidden,
	      onEnter: onEnter,
	      onEntering: onEntering,
	      onEntered: onEntered
	    }, dialog);
	  }
	
	  var backdropElement = null;
	
	  if (backdrop) {
	    var BackdropTransition = backdropTransition;
	    backdropElement = renderBackdrop({
	      ref: modal.setBackdropRef,
	      onClick: handleBackdropClick
	    });
	
	    if (BackdropTransition) {
	      backdropElement = /*#__PURE__*/_react["default"].createElement(BackdropTransition, {
	        appear: true,
	        "in": !!show
	      }, backdropElement);
	    }
	  }
	
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, backdropElement, dialog), container));
	});
	var propTypes = {
	  /**
	   * Set the visibility of the Modal
	   */
	  show: _propTypes["default"].bool,
	
	  /**
	   * A DOM element, a `ref` to an element, or function that returns either. The Modal is appended to it's `container` element.
	   *
	   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	   * page content can be placed behind a virtual backdrop as well as a visual one.
	   */
	  container: _propTypes["default"].any,
	
	  /**
	   * A callback fired when the Modal is opening.
	   */
	  onShow: _propTypes["default"].func,
	
	  /**
	   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	   *
	   * The `onHide` callback only signals intent from the Modal,
	   * you must actually set the `show` prop to `false` for the Modal to close.
	   */
	  onHide: _propTypes["default"].func,
	
	  /**
	   * Include a backdrop component.
	   */
	  backdrop: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['static'])]),
	
	  /**
	   * A function that returns the dialog component. Useful for custom
	   * rendering. **Note:** the component should make sure to apply the provided ref.
	   *
	   * ```js static
	   * renderDialog={props => <MyDialog {...props} />}
	   * ```
	   */
	  renderDialog: _propTypes["default"].func,
	
	  /**
	   * A function that returns a backdrop component. Useful for custom
	   * backdrop rendering.
	   *
	   * ```js
	   *  renderBackdrop={props => <MyBackdrop {...props} />}
	   * ```
	   */
	  renderBackdrop: _propTypes["default"].func,
	
	  /**
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   *
	   * If preventDefault() is called on the keyboard event, closing the modal will be cancelled.
	   */
	  onEscapeKeyDown: _propTypes["default"].func,
	
	  /**
	   * A callback fired when the backdrop, if specified, is clicked.
	   */
	  onBackdropClick: _propTypes["default"].func,
	
	  /**
	   * A css class or set of classes applied to the modal container when the modal is open,
	   * and removed when it is closed.
	   */
	  containerClassName: _propTypes["default"].string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes["default"].bool,
	
	  /**
	   * A `react-transition-group@2.0.0` `<Transition/>` component used
	   * to control animations for the dialog component.
	   */
	  transition: _propTypes["default"].elementType,
	
	  /**
	   * A `react-transition-group@2.0.0` `<Transition/>` component used
	   * to control animations for the backdrop components.
	   */
	  backdropTransition: _propTypes["default"].elementType,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes. This also
	   * works correctly with any Modal children that have the `autoFocus` prop.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  autoFocus: _propTypes["default"].bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while open.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  enforceFocus: _propTypes["default"].bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes["default"].bool,
	
	  /**
	   * Options passed to focus function when `restoreFocus` is set to `true`
	   *
	   * @link  https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Parameters
	   */
	  restoreFocusOptions: _propTypes["default"].shape({
	    preventScroll: _propTypes["default"].bool
	  }),
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes["default"].func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes["default"].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes["default"].func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes["default"].func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes["default"].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes["default"].func,
	
	  /**
	   * A ModalManager instance used to track and manage the state of open
	   * Modals. Useful when customizing how modals interact within a container
	   */
	  manager: _propTypes["default"].instanceOf(_ModalManager["default"])
	};
	Modal.displayName = 'Modal';
	Modal.propTypes = propTypes;
	
	var _default = Object.assign(Modal, {
	  Manager: _ModalManager["default"]
	});
	
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(32);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(44));
	
	var _useCallbackRef3 = _interopRequireDefault(__webpack_require__(88));
	
	var _useMergedRefs = _interopRequireDefault(__webpack_require__(47));
	
	var _popper = __webpack_require__(264);
	
	var _usePopper2 = _interopRequireDefault(__webpack_require__(265));
	
	var _useRootClose = _interopRequireDefault(__webpack_require__(266));
	
	var _useWaitForDOMRef = _interopRequireDefault(__webpack_require__(267));
	
	var _mergeOptionsWithPopperConfig = _interopRequireDefault(__webpack_require__(263));
	
	/**
	 * Built on top of `Popper.js`, the overlay component is
	 * great for custom tooltip overlays.
	 */
	var Overlay = /*#__PURE__*/_react["default"].forwardRef(function (props, outerRef) {
	  var flip = props.flip,
	      offset = props.offset,
	      placement = props.placement,
	      _props$containerPaddi = props.containerPadding,
	      containerPadding = _props$containerPaddi === void 0 ? 5 : _props$containerPaddi,
	      _props$popperConfig = props.popperConfig,
	      popperConfig = _props$popperConfig === void 0 ? {} : _props$popperConfig,
	      Transition = props.transition;
	
	  var _useCallbackRef = (0, _useCallbackRef3["default"])(),
	      rootElement = _useCallbackRef[0],
	      attachRef = _useCallbackRef[1];
	
	  var _useCallbackRef2 = (0, _useCallbackRef3["default"])(),
	      arrowElement = _useCallbackRef2[0],
	      attachArrowRef = _useCallbackRef2[1];
	
	  var mergedRef = (0, _useMergedRefs["default"])(attachRef, outerRef);
	  var container = (0, _useWaitForDOMRef["default"])(props.container);
	  var target = (0, _useWaitForDOMRef["default"])(props.target);
	
	  var _useState = (0, _react.useState)(!props.show),
	      exited = _useState[0],
	      setExited = _useState[1];
	
	  var _usePopper = (0, _usePopper2["default"])(target, rootElement, (0, _mergeOptionsWithPopperConfig["default"])({
	    placement: placement,
	    enableEvents: !!props.show,
	    containerPadding: containerPadding || 5,
	    flip: flip,
	    offset: offset,
	    arrowElement: arrowElement,
	    popperConfig: popperConfig
	  })),
	      styles = _usePopper.styles,
	      attributes = _usePopper.attributes,
	      popper = (0, _objectWithoutPropertiesLoose2["default"])(_usePopper, ["styles", "attributes"]);
	
	  if (props.show) {
	    if (exited) setExited(false);
	  } else if (!props.transition && !exited) {
	    setExited(true);
	  }
	
	  var handleHidden = function handleHidden() {
	    setExited(true);
	
	    if (props.onExited) {
	      props.onExited.apply(props, arguments);
	    }
	  }; // Don't un-render the overlay while it's transitioning out.
	
	
	  var mountOverlay = props.show || Transition && !exited;
	  (0, _useRootClose["default"])(rootElement, props.onHide, {
	    disabled: !props.rootClose || props.rootCloseDisabled,
	    clickTrigger: props.rootCloseEvent
	  });
	
	  if (!mountOverlay) {
	    // Don't bother showing anything if we don't have to.
	    return null;
	  }
	
	  var child = props.children((0, _extends2["default"])({}, popper, {
	    show: !!props.show,
	    props: (0, _extends2["default"])({}, attributes.popper, {
	      style: styles.popper,
	      ref: mergedRef
	    }),
	    arrowProps: (0, _extends2["default"])({}, attributes.arrow, {
	      style: styles.arrow,
	      ref: attachArrowRef
	    })
	  }));
	
	  if (Transition) {
	    var onExit = props.onExit,
	        onExiting = props.onExiting,
	        onEnter = props.onEnter,
	        onEntering = props.onEntering,
	        onEntered = props.onEntered;
	    child = /*#__PURE__*/_react["default"].createElement(Transition, {
	      "in": props.show,
	      appear: true,
	      onExit: onExit,
	      onExiting: onExiting,
	      onExited: handleHidden,
	      onEnter: onEnter,
	      onEntering: onEntering,
	      onEntered: onEntered
	    }, child);
	  }
	
	  return container ? /*#__PURE__*/_reactDom["default"].createPortal(child, container) : null;
	});
	
	Overlay.displayName = 'Overlay';
	Overlay.propTypes = {
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes["default"].bool,
	
	  /** Specify where the overlay element is positioned in relation to the target element */
	  placement: _propTypes["default"].oneOf(_popper.placements),
	
	  /**
	   * A DOM Element, Ref to an element, or function that returns either. The `target` element is where
	   * the overlay is positioned relative to.
	   */
	  target: _propTypes["default"].any,
	
	  /**
	   * A DOM Element, Ref to an element, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes["default"].any,
	
	  /**
	   * Enables the Popper.js `flip` modifier, allowing the Overlay to
	   * automatically adjust it's placement in case of overlap with the viewport or toggle.
	   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
	   */
	  flip: _propTypes["default"].bool,
	
	  /**
	   * A render prop that returns an element to overlay and position. See
	   * the [react-popper documentation](https://github.com/FezVrasta/react-popper#children) for more info.
	   *
	   * @type {Function ({
	   *   show: boolean,
	   *   placement: Placement,
	   *   update: () => void,
	   *   forceUpdate: () => void,
	   *   props: {
	   *     ref: (?HTMLElement) => void,
	   *     style: { [string]: string | number },
	   *     aria-labelledby: ?string
	   *     [string]: string | number,
	   *   },
	   *   arrowProps: {
	   *     ref: (?HTMLElement) => void,
	   *     style: { [string]: string | number },
	   *     [string]: string | number,
	   *   },
	   * }) => React.Element}
	   */
	  children: _propTypes["default"].func.isRequired,
	
	  /**
	   * Control how much space there is between the edge of the boundary element and overlay.
	   * A convenience shortcut to setting `popperConfig.modfiers.preventOverflow.padding`
	   */
	  containerPadding: _propTypes["default"].number,
	
	  /**
	   * A set of popper options and props passed directly to react-popper's Popper component.
	   */
	  popperConfig: _propTypes["default"].object,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _propTypes["default"].bool,
	
	  /**
	   * Specify event for toggling overlay
	   */
	  rootCloseEvent: _propTypes["default"].oneOf(['click', 'mousedown']),
	
	  /**
	   * Specify disabled for disable RootCloseWrapper
	   */
	  rootCloseDisabled: _propTypes["default"].bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (props.rootClose) {
	      var _PropTypes$func;
	
	      return (_PropTypes$func = _propTypes["default"].func).isRequired.apply(_PropTypes$func, [props].concat(args));
	    }
	
	    return _propTypes["default"].func.apply(_propTypes["default"], [props].concat(args));
	  },
	
	  /**
	   * A `react-transition-group@2.0.0` `<Transition/>` component
	   * used to animate the overlay as it changes visibility.
	   */
	  // @ts-ignore
	  transition: _propTypes["default"].elementType,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes["default"].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes["default"].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes["default"].func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes["default"].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes["default"].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes["default"].func
	};
	var _default = Overlay;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = isOverflowing;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(437));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(40));
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _isWindow["default"])(node) ? (0, _ownerDocument["default"])() : (0, _ownerDocument["default"])(node);
	  var win = (0, _isWindow["default"])(node) || doc.defaultView;
	  return doc.body.clientWidth < win.innerWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow["default"])(container);
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	
	module.exports = exports.default;

/***/ },
/* 569 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, exclude, cb) {
	  [].forEach.call(container.children, function (node) {
	    if (exclude.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(hide, node) {
	  if (!node) return;
	
	  if (hide) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, _ref2) {
	  var dialog = _ref2.dialog,
	      backdrop = _ref2.backdrop;
	  siblings(container, [dialog, backdrop], function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, _ref3) {
	  var dialog = _ref3.dialog,
	      backdrop = _ref3.backdrop;
	  siblings(container, [dialog, backdrop], function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(40));
	
	var _safeFindDOMNode = _interopRequireDefault(__webpack_require__(133));
	
	var _default = function _default(componentOrElement) {
	  return (0, _ownerDocument["default"])((0, _safeFindDOMNode["default"])(componentOrElement));
	};
	
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(501).enable();
	  window.Promise = __webpack_require__(500);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(590);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(115);


/***/ },
/* 572 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var BasicColors;
	(function (BasicColors) {
	    BasicColors["maroon"] = "#800000";
	    BasicColors["red"] = "#FF0000";
	    BasicColors["orange"] = "#FFA500";
	    BasicColors["yellow"] = "#FFFF00";
	    BasicColors["olive"] = "#808000";
	    BasicColors["green"] = "#008000";
	    BasicColors["purple"] = "#800080";
	    BasicColors["fuchsia"] = "#FF00FF";
	    BasicColors["lime"] = "#00FF00";
	    BasicColors["teal"] = "#008080";
	    BasicColors["aqua"] = "#00FFFF";
	    BasicColors["blue"] = "#0000FF";
	    BasicColors["navy"] = "#000080";
	    BasicColors["black"] = "#000000";
	    BasicColors["gray"] = "#808080";
	    BasicColors["silver"] = "#C0C0C0";
	    BasicColors["white"] = "#FFFFFF";
	})(BasicColors || (BasicColors = {}));
	exports.calculateRgba = function (color, opacity) {
	    if (Object.keys(BasicColors).includes(color)) {
	        color = BasicColors[color];
	    }
	    if (color[0] === "#") {
	        color = color.slice(1);
	    }
	    if (color.length === 3) {
	        var res_1 = "";
	        color.split("").forEach(function (c) {
	            res_1 += c;
	            res_1 += c;
	        });
	        color = res_1;
	    }
	    var rgbValues = color
	        .match(/.{2}/g)
	        .map(function (hex) { return parseInt(hex, 16); })
	        .join(", ");
	    return "rgba(" + rgbValues + ", " + opacity + ")";
	};


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(574));
	__export(__webpack_require__(572));


/***/ },
/* 574 */
/***/ function(module, exports) {

	"use strict";
	var _a;
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * List of string constants to represent different props
	 */
	var LOADING = "loading";
	var COLOR = "color";
	var CSS = "css";
	var SIZE = "size";
	var SIZE_UNIT = "sizeUnit";
	var WIDTH = "width";
	var WIDTH_UNIT = "widthUnit";
	var HEIGHT = "height";
	var HEIGHT_UNIT = "heightUnit";
	var RADIUS = "radius";
	var RADIUS_UNIT = "radiusUnit";
	var MARGIN = "margin";
	var commonValues = (_a = {},
	    _a[LOADING] = true,
	    _a[COLOR] = "#000000",
	    _a[CSS] = {},
	    _a);
	var heightWidthValues = function (height, width) {
	    var _a;
	    return (_a = {},
	        _a[HEIGHT] = height,
	        _a[HEIGHT_UNIT] = "px",
	        _a[WIDTH] = width,
	        _a[WIDTH_UNIT] = "px",
	        _a);
	};
	var sizeValues = function (sizeValue) {
	    var _a;
	    return (_a = {},
	        _a[SIZE] = sizeValue,
	        _a[SIZE_UNIT] = "px",
	        _a);
	};
	exports.sizeDefaults = function (sizeValue) {
	    return Object.assign({}, commonValues, sizeValues(sizeValue));
	};
	exports.sizeMarginDefaults = function (sizeValue) {
	    var _a;
	    return Object.assign({}, exports.sizeDefaults(sizeValue), (_a = {},
	        _a[MARGIN] = "2px",
	        _a));
	};
	exports.heightWidthDefaults = function (height, width) {
	    return Object.assign({}, commonValues, heightWidthValues(height, width));
	};
	exports.heightWidthRadiusDefaults = function (height, width, radius) {
	    var _a;
	    if (radius === void 0) { radius = 2; }
	    return Object.assign({}, exports.heightWidthDefaults(height, width), (_a = {},
	        _a[RADIUS] = radius,
	        _a[RADIUS_UNIT] = "px",
	        _a[MARGIN] = "2px",
	        _a));
	};


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _react.default.createContext(null);
	
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 576 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	var _default = {
	  disabled: false
	};
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(115),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ },
/* 579 */
/***/ function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(579);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(24)))

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(32);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.useUncontrolledProp = useUncontrolledProp;
	exports.default = useUncontrolled;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = __webpack_require__(2);
	
	var Utils = _interopRequireWildcard(__webpack_require__(270));
	
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
	
	function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	
	function useUncontrolledProp(propValue, defaultValue, handler) {
	  var wasPropRef = (0, _react.useRef)(propValue !== undefined);
	
	  var _useState = (0, _react.useState)(defaultValue),
	      stateValue = _useState[0],
	      setState = _useState[1];
	
	  var isProp = propValue !== undefined;
	  var wasProp = wasPropRef.current;
	  wasPropRef.current = isProp;
	  /**
	   * If a prop switches from controlled to Uncontrolled
	   * reset its value to the defaultValue
	   */
	
	  if (!isProp && wasProp && stateValue !== defaultValue) {
	    setState(defaultValue);
	  }
	
	  return [isProp ? propValue : stateValue, (0, _react.useCallback)(function (value) {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (handler) handler.apply(void 0, [value].concat(args));
	    setState(value);
	  }, [handler])];
	}
	
	function useUncontrolled(props, config) {
	  return Object.keys(config).reduce(function (result, fieldName) {
	    var _extends2;
	
	    var _ref = result,
	        defaultValue = _ref[Utils.defaultKey(fieldName)],
	        propsValue = _ref[fieldName],
	        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, [Utils.defaultKey(fieldName), fieldName].map(_toPropertyKey));
	
	    var handlerName = config[fieldName];
	
	    var _useUncontrolledProp = useUncontrolledProp(propsValue, defaultValue, props[handlerName]),
	        value = _useUncontrolledProp[0],
	        handler = _useUncontrolledProp[1];
	
	    return (0, _extends3.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
	  }, props);
	}

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(32);
	
	exports.__esModule = true;
	exports.default = uncontrollable;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(4));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(3));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactLifecyclesCompat = __webpack_require__(256);
	
	var _invariant = _interopRequireDefault(__webpack_require__(70));
	
	var Utils = _interopRequireWildcard(__webpack_require__(270));
	
	var _jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
	
	function uncontrollable(Component, controlledValues, methods) {
	  if (methods === void 0) {
	    methods = [];
	  }
	
	  var displayName = Component.displayName || Component.name || 'Component';
	  var canAcceptRef = Utils.canAcceptRef(Component);
	  var controlledProps = Object.keys(controlledValues);
	  var PROPS_TO_OMIT = controlledProps.map(Utils.defaultKey);
	  !(canAcceptRef || !methods.length) ?  false ? (0, _invariant.default)(false, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', ')) : invariant(false) : void 0;
	
	  var UncontrolledComponent =
	  /*#__PURE__*/
	  function (_React$Component) {
	    (0, _inheritsLoose2.default)(UncontrolledComponent, _React$Component);
	
	    function UncontrolledComponent() {
	      var _this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	      _this.handlers = Object.create(null);
	      controlledProps.forEach(function (propName) {
	        var handlerName = controlledValues[propName];
	
	        var handleChange = function handleChange(value) {
	          if (_this.props[handlerName]) {
	            var _this$props;
	
	            _this._notifying = true;
	
	            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	              args[_key2 - 1] = arguments[_key2];
	            }
	
	            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));
	
	            _this._notifying = false;
	          }
	
	          if (!_this.unmounted) _this.setState(function (_ref) {
	            var _extends2;
	
	            var values = _ref.values;
	            return {
	              values: (0, _extends3.default)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
	            };
	          });
	        };
	
	        _this.handlers[handlerName] = handleChange;
	      });
	      if (methods.length) _this.attachRef = function (ref) {
	        _this.inner = ref;
	      };
	      var values = Object.create(null);
	      controlledProps.forEach(function (key) {
	        values[key] = _this.props[Utils.defaultKey(key)];
	      });
	      _this.state = {
	        values: values,
	        prevProps: {}
	      };
	      return _this;
	    }
	
	    var _proto = UncontrolledComponent.prototype;
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
	      //let setState trigger the update
	      return !this._notifying;
	    };
	
	    UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
	      var values = _ref2.values,
	          prevProps = _ref2.prevProps;
	      var nextState = {
	        values: (0, _extends3.default)(Object.create(null), values),
	        prevProps: {}
	      };
	      controlledProps.forEach(function (key) {
	        /**
	         * If a prop switches from controlled to Uncontrolled
	         * reset its value to the defaultValue
	         */
	        nextState.prevProps[key] = props[key];
	
	        if (!Utils.isProp(props, key) && Utils.isProp(prevProps, key)) {
	          nextState.values[key] = props[Utils.defaultKey(key)];
	        }
	      });
	      return nextState;
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.unmounted = true;
	    };
	
	    _proto.render = function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          innerRef = _this$props2.innerRef,
	          props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["innerRef"]);
	      PROPS_TO_OMIT.forEach(function (prop) {
	        delete props[prop];
	      });
	      var newProps = {};
	      controlledProps.forEach(function (propName) {
	        var propValue = _this2.props[propName];
	        newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
	      });
	      return _react.default.createElement(Component, (0, _extends3.default)({}, props, newProps, this.handlers, {
	        ref: innerRef || this.attachRef
	      }));
	    };
	
	    return UncontrolledComponent;
	  }(_react.default.Component);
	
	  (0, _reactLifecyclesCompat.polyfill)(UncontrolledComponent);
	  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
	  UncontrolledComponent.propTypes = (0, _extends3.default)({
	    innerRef: function innerRef() {}
	  }, Utils.uncontrolledPropTypes(controlledValues, displayName));
	  methods.forEach(function (method) {
	    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
	      var _this$inner;
	
	      return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
	    };
	  });
	  var WrappedComponent = UncontrolledComponent;
	
	  if (_react.default.forwardRef) {
	    WrappedComponent = _react.default.forwardRef(function (props, ref) {
	      return _react.default.createElement(UncontrolledComponent, (0, _extends3.default)({}, props, {
	        innerRef: ref,
	        __source: {
	          fileName: _jsxFileName,
	          lineNumber: 128
	        },
	        __self: this
	      }));
	    });
	    WrappedComponent.propTypes = UncontrolledComponent.propTypes;
	  }
	
	  WrappedComponent.ControlledComponent = Component;
	  /**
	   * useful when wrapping a Component and you want to control
	   * everything
	   */
	
	  WrappedComponent.deferControlTo = function (newComponent, additions, nextMethods) {
	    if (additions === void 0) {
	      additions = {};
	    }
	
	    return uncontrollable(newComponent, (0, _extends3.default)({}, controlledValues, additions), nextMethods);
	  };
	
	  return WrappedComponent;
	}
	
	module.exports = exports["default"];

/***/ },
/* 584 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 585 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 586 */
/***/ function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]]
	  ]).join('');
	}
	
	module.exports = bytesToUuid;


/***/ },
/* 587 */
153,
/* 588 */
[657, 587, 586],
/* 589 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 590 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	__webpack_require__(__webpack_module_template_argument_0__);
	var AWS = __webpack_require__(__webpack_module_template_argument_1__);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cognitoidentity'] = {};
	AWS.CognitoIdentity = Service.defineService('cognitoidentity', ['2014-06-30']);
	__webpack_require__(__webpack_module_template_argument_2__);
	Object.defineProperty(apiLoader.services['cognitoidentity'], '2014-06-30', {
	  get: function get() {
	    var model = __webpack_require__(__webpack_module_template_argument_3__);
	    model.paginators = __webpack_require__(__webpack_module_template_argument_4__).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CognitoIdentity;


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	__webpack_require__(__webpack_module_template_argument_0__);
	var AWS = __webpack_require__(__webpack_module_template_argument_1__);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['sts'] = {};
	AWS.STS = Service.defineService('sts', ['2011-06-15']);
	__webpack_require__(__webpack_module_template_argument_2__);
	Object.defineProperty(apiLoader.services['sts'], '2011-06-15', {
	  get: function get() {
	    var model = __webpack_require__(__webpack_module_template_argument_3__);
	    model.paginators = __webpack_require__(__webpack_module_template_argument_4__).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.STS;


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var Hmac = __webpack_require__(__webpack_module_template_argument_0__);
	var Md5 = __webpack_require__(__webpack_module_template_argument_1__);
	var Sha1 = __webpack_require__(__webpack_module_template_argument_2__);
	var Sha256 = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * @api private
	 */
	module.exports = exports = {
	    createHash: function createHash(alg) {
	      alg = alg.toLowerCase();
	      if (alg === 'md5') {
	        return new Md5();
	      } else if (alg === 'sha256') {
	        return new Sha256();
	      } else if (alg === 'sha1') {
	        return new Sha1();
	      }
	
	      throw new Error('Hash algorithm ' + alg + ' is not supported in the browser SDK');
	    },
	    createHmac: function createHmac(alg, key) {
	      alg = alg.toLowerCase();
	      if (alg === 'md5') {
	        return new Hmac(Md5, key);
	      } else if (alg === 'sha256') {
	        return new Hmac(Sha256, key);
	      } else if (alg === 'sha1') {
	        return new Hmac(Sha1, key);
	      }
	
	      throw new Error('HMAC algorithm ' + alg + ' is not supported in the browser SDK');
	    },
	    createSign: function() {
	      throw new Error('createSign is not implemented in the browser');
	    }
	  };


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var hashUtils = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * @api private
	 */
	function Hmac(hashCtor, secret) {
	    this.hash = new hashCtor();
	    this.outer = new hashCtor();
	
	    var inner = bufferFromSecret(hashCtor, secret);
	    var outer = new Uint8Array(hashCtor.BLOCK_SIZE);
	    outer.set(inner);
	
	    for (var i = 0; i < hashCtor.BLOCK_SIZE; i++) {
	        inner[i] ^= 0x36;
	        outer[i] ^= 0x5c;
	    }
	
	    this.hash.update(inner);
	    this.outer.update(outer);
	
	    // Zero out the copied key buffer.
	    for (var i = 0; i < inner.byteLength; i++) {
	        inner[i] = 0;
	    }
	}
	
	/**
	 * @api private
	 */
	module.exports = exports = Hmac;
	
	Hmac.prototype.update = function (toHash) {
	    if (hashUtils.isEmptyData(toHash) || this.error) {
	        return this;
	    }
	
	    try {
	        this.hash.update(hashUtils.convertToBuffer(toHash));
	    } catch (e) {
	        this.error = e;
	    }
	
	    return this;
	};
	
	Hmac.prototype.digest = function (encoding) {
	    if (!this.outer.finished) {
	        this.outer.update(this.hash.digest());
	    }
	
	    return this.outer.digest(encoding);
	};
	
	function bufferFromSecret(hashCtor, secret) {
	    var input = hashUtils.convertToBuffer(secret);
	    if (input.byteLength > hashCtor.BLOCK_SIZE) {
	        var bufferHash = new hashCtor;
	        bufferHash.update(input);
	        input = bufferHash.digest();
	    }
	    var buffer = new Uint8Array(hashCtor.BLOCK_SIZE);
	    buffer.set(input);
	    return buffer;
	}


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var hashUtils = __webpack_require__(__webpack_module_template_argument_0__);
	var Buffer = __webpack_require__(21).Buffer;
	
	var BLOCK_SIZE = 64;
	
	var DIGEST_LENGTH = 16;
	
	var INIT = [
	    0x67452301,
	    0xefcdab89,
	    0x98badcfe,
	    0x10325476,
	];
	
	/**
	 * @api private
	 */
	function Md5() {
	    this.state = [
	        0x67452301,
	        0xefcdab89,
	        0x98badcfe,
	        0x10325476,
	    ];
	    this.buffer = new DataView(new ArrayBuffer(BLOCK_SIZE));
	    this.bufferLength = 0;
	    this.bytesHashed = 0;
	    this.finished = false;
	}
	
	/**
	 * @api private
	 */
	module.exports = exports = Md5;
	
	Md5.BLOCK_SIZE = BLOCK_SIZE;
	
	Md5.prototype.update = function (sourceData) {
	    if (hashUtils.isEmptyData(sourceData)) {
	        return this;
	    } else if (this.finished) {
	        throw new Error('Attempted to update an already finished hash.');
	    }
	
	    var data = hashUtils.convertToBuffer(sourceData);
	    var position = 0;
	    var byteLength = data.byteLength;
	    this.bytesHashed += byteLength;
	    while (byteLength > 0) {
	        this.buffer.setUint8(this.bufferLength++, data[position++]);
	        byteLength--;
	        if (this.bufferLength === BLOCK_SIZE) {
	            this.hashBuffer();
	            this.bufferLength = 0;
	        }
	    }
	
	    return this;
	};
	
	Md5.prototype.digest = function (encoding) {
	    if (!this.finished) {
	        var _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
	        var bitsHashed = bytesHashed * 8;
	        buffer.setUint8(this.bufferLength++, 128);
	        // Ensure the final block has enough room for the hashed length
	        if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
	            for (var i = this.bufferLength; i < BLOCK_SIZE; i++) {
	                buffer.setUint8(i, 0);
	            }
	            this.hashBuffer();
	            this.bufferLength = 0;
	        }
	        for (var i = this.bufferLength; i < BLOCK_SIZE - 8; i++) {
	            buffer.setUint8(i, 0);
	        }
	        buffer.setUint32(BLOCK_SIZE - 8, bitsHashed >>> 0, true);
	        buffer.setUint32(BLOCK_SIZE - 4, Math.floor(bitsHashed / 0x100000000), true);
	        this.hashBuffer();
	        this.finished = true;
	    }
	    var out = new DataView(new ArrayBuffer(DIGEST_LENGTH));
	    for (var i = 0; i < 4; i++) {
	        out.setUint32(i * 4, this.state[i], true);
	    }
	    var buff = new Buffer(out.buffer, out.byteOffset, out.byteLength);
	    return encoding ? buff.toString(encoding) : buff;
	};
	
	Md5.prototype.hashBuffer = function () {
	    var _a = this, buffer = _a.buffer, state = _a.state;
	    var a = state[0], b = state[1], c = state[2], d = state[3];
	    a = ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
	    d = ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
	    c = ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
	    b = ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
	    a = ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
	    d = ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
	    c = ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
	    b = ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
	    a = ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
	    d = ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
	    c = ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
	    b = ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
	    a = ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
	    d = ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
	    c = ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
	    b = ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
	    a = gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
	    d = gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
	    c = gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
	    b = gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
	    a = gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
	    d = gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
	    c = gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
	    b = gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
	    a = gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
	    d = gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
	    c = gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
	    b = gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
	    a = gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
	    d = gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
	    c = gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
	    b = gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
	    a = hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
	    d = hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
	    c = hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
	    b = hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
	    a = hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
	    d = hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
	    c = hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
	    b = hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
	    a = hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
	    d = hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
	    c = hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
	    b = hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
	    a = hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
	    d = hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
	    c = hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
	    b = hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
	    a = ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
	    d = ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
	    c = ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
	    b = ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
	    a = ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
	    d = ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
	    c = ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
	    b = ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
	    a = ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
	    d = ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
	    c = ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
	    b = ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
	    a = ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
	    d = ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
	    c = ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
	    b = ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
	    state[0] = (a + state[0]) & 0xFFFFFFFF;
	    state[1] = (b + state[1]) & 0xFFFFFFFF;
	    state[2] = (c + state[2]) & 0xFFFFFFFF;
	    state[3] = (d + state[3]) & 0xFFFFFFFF;
	};
	
	function cmn(q, a, b, x, s, t) {
	    a = (((a + q) & 0xFFFFFFFF) + ((x + t) & 0xFFFFFFFF)) & 0xFFFFFFFF;
	    return (((a << s) | (a >>> (32 - s))) + b) & 0xFFFFFFFF;
	}
	
	function ff(a, b, c, d, x, s, t) {
	    return cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	
	function gg(a, b, c, d, x, s, t) {
	    return cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	
	function hh(a, b, c, d, x, s, t) {
	    return cmn(b ^ c ^ d, a, b, x, s, t);
	}
	
	function ii(a, b, c, d, x, s, t) {
	    return cmn(c ^ (b | (~d)), a, b, x, s, t);
	}


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Buffer = __webpack_require__(21).Buffer;
	var hashUtils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var BLOCK_SIZE = 64;
	
	var DIGEST_LENGTH = 20;
	
	var KEY = new Uint32Array([
	    0x5a827999,
	    0x6ed9eba1,
	    0x8f1bbcdc | 0,
	    0xca62c1d6 | 0
	]);
	
	var INIT = [
	    0x6a09e667,
	    0xbb67ae85,
	    0x3c6ef372,
	    0xa54ff53a,
	    0x510e527f,
	    0x9b05688c,
	    0x1f83d9ab,
	    0x5be0cd19,
	];
	
	var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
	
	/**
	 * @api private
	 */
	function Sha1() {
	    this.h0 = 0x67452301;
	    this.h1 = 0xEFCDAB89;
	    this.h2 = 0x98BADCFE;
	    this.h3 = 0x10325476;
	    this.h4 = 0xC3D2E1F0;
	    // The first 64 bytes (16 words) is the data chunk
	    this.block = new Uint32Array(80);
	    this.offset = 0;
	    this.shift = 24;
	    this.totalLength = 0;
	}
	
	/**
	 * @api private
	 */
	module.exports = exports = Sha1;
	
	Sha1.BLOCK_SIZE = BLOCK_SIZE;
	
	Sha1.prototype.update = function (data) {
	    if (this.finished) {
	        throw new Error('Attempted to update an already finished hash.');
	    }
	
	    if (hashUtils.isEmptyData(data)) {
	        return this;
	    }
	
	    data = hashUtils.convertToBuffer(data);
	
	    var length = data.length;
	    this.totalLength += length * 8;
	    for (var i = 0; i < length; i++) {
	        this.write(data[i]);
	    }
	
	    return this;
	};
	
	Sha1.prototype.write = function write(byte) {
	    this.block[this.offset] |= (byte & 0xff) << this.shift;
	    if (this.shift) {
	        this.shift -= 8;
	    } else {
	        this.offset++;
	        this.shift = 24;
	    }
	
	    if (this.offset === 16) this.processBlock();
	};
	
	Sha1.prototype.digest = function (encoding) {
	    // Pad
	    this.write(0x80);
	    if (this.offset > 14 || (this.offset === 14 && this.shift < 24)) {
	      this.processBlock();
	    }
	    this.offset = 14;
	    this.shift = 24;
	
	    // 64-bit length big-endian
	    this.write(0x00); // numbers this big aren't accurate in javascript anyway
	    this.write(0x00); // ..So just hard-code to zero.
	    this.write(this.totalLength > 0xffffffffff ? this.totalLength / 0x10000000000 : 0x00);
	    this.write(this.totalLength > 0xffffffff ? this.totalLength / 0x100000000 : 0x00);
	    for (var s = 24; s >= 0; s -= 8) {
	        this.write(this.totalLength >> s);
	    }
	    // The value in state is little-endian rather than big-endian, so flip
	    // each word into a new Uint8Array
	    var out = new Buffer(DIGEST_LENGTH);
	    var outView = new DataView(out.buffer);
	    outView.setUint32(0, this.h0, false);
	    outView.setUint32(4, this.h1, false);
	    outView.setUint32(8, this.h2, false);
	    outView.setUint32(12, this.h3, false);
	    outView.setUint32(16, this.h4, false);
	
	    return encoding ? out.toString(encoding) : out;
	};
	
	Sha1.prototype.processBlock = function processBlock() {
	    // Extend the sixteen 32-bit words into eighty 32-bit words:
	    for (var i = 16; i < 80; i++) {
	      var w = this.block[i - 3] ^ this.block[i - 8] ^ this.block[i - 14] ^ this.block[i - 16];
	      this.block[i] = (w << 1) | (w >>> 31);
	    }
	
	    // Initialize hash value for this chunk:
	    var a = this.h0;
	    var b = this.h1;
	    var c = this.h2;
	    var d = this.h3;
	    var e = this.h4;
	    var f, k;
	
	    // Main loop:
	    for (i = 0; i < 80; i++) {
	      if (i < 20) {
	        f = d ^ (b & (c ^ d));
	        k = 0x5A827999;
	      }
	      else if (i < 40) {
	        f = b ^ c ^ d;
	        k = 0x6ED9EBA1;
	      }
	      else if (i < 60) {
	        f = (b & c) | (d & (b | c));
	        k = 0x8F1BBCDC;
	      }
	      else {
	        f = b ^ c ^ d;
	        k = 0xCA62C1D6;
	      }
	      var temp = (a << 5 | a >>> 27) + f + e + k + (this.block[i]|0);
	      e = d;
	      d = c;
	      c = (b << 30 | b >>> 2);
	      b = a;
	      a = temp;
	    }
	
	    // Add this chunk's hash to result so far:
	    this.h0 = (this.h0 + a) | 0;
	    this.h1 = (this.h1 + b) | 0;
	    this.h2 = (this.h2 + c) | 0;
	    this.h3 = (this.h3 + d) | 0;
	    this.h4 = (this.h4 + e) | 0;
	
	    // The block is now reusable.
	    this.offset = 0;
	    for (i = 0; i < 16; i++) {
	        this.block[i] = 0;
	    }
	};


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Buffer = __webpack_require__(21).Buffer;
	var hashUtils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var BLOCK_SIZE = 64;
	
	var DIGEST_LENGTH = 32;
	
	var KEY = new Uint32Array([
	    0x428a2f98,
	    0x71374491,
	    0xb5c0fbcf,
	    0xe9b5dba5,
	    0x3956c25b,
	    0x59f111f1,
	    0x923f82a4,
	    0xab1c5ed5,
	    0xd807aa98,
	    0x12835b01,
	    0x243185be,
	    0x550c7dc3,
	    0x72be5d74,
	    0x80deb1fe,
	    0x9bdc06a7,
	    0xc19bf174,
	    0xe49b69c1,
	    0xefbe4786,
	    0x0fc19dc6,
	    0x240ca1cc,
	    0x2de92c6f,
	    0x4a7484aa,
	    0x5cb0a9dc,
	    0x76f988da,
	    0x983e5152,
	    0xa831c66d,
	    0xb00327c8,
	    0xbf597fc7,
	    0xc6e00bf3,
	    0xd5a79147,
	    0x06ca6351,
	    0x14292967,
	    0x27b70a85,
	    0x2e1b2138,
	    0x4d2c6dfc,
	    0x53380d13,
	    0x650a7354,
	    0x766a0abb,
	    0x81c2c92e,
	    0x92722c85,
	    0xa2bfe8a1,
	    0xa81a664b,
	    0xc24b8b70,
	    0xc76c51a3,
	    0xd192e819,
	    0xd6990624,
	    0xf40e3585,
	    0x106aa070,
	    0x19a4c116,
	    0x1e376c08,
	    0x2748774c,
	    0x34b0bcb5,
	    0x391c0cb3,
	    0x4ed8aa4a,
	    0x5b9cca4f,
	    0x682e6ff3,
	    0x748f82ee,
	    0x78a5636f,
	    0x84c87814,
	    0x8cc70208,
	    0x90befffa,
	    0xa4506ceb,
	    0xbef9a3f7,
	    0xc67178f2
	]);
	
	var INIT = [
	    0x6a09e667,
	    0xbb67ae85,
	    0x3c6ef372,
	    0xa54ff53a,
	    0x510e527f,
	    0x9b05688c,
	    0x1f83d9ab,
	    0x5be0cd19,
	];
	
	var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
	
	/**
	 * @private
	 */
	function Sha256() {
	    this.state = [
	        0x6a09e667,
	        0xbb67ae85,
	        0x3c6ef372,
	        0xa54ff53a,
	        0x510e527f,
	        0x9b05688c,
	        0x1f83d9ab,
	        0x5be0cd19,
	    ];
	    this.temp = new Int32Array(64);
	    this.buffer = new Uint8Array(64);
	    this.bufferLength = 0;
	    this.bytesHashed = 0;
	    /**
	     * @private
	     */
	    this.finished = false;
	}
	
	/**
	 * @api private
	 */
	module.exports = exports = Sha256;
	
	Sha256.BLOCK_SIZE = BLOCK_SIZE;
	
	Sha256.prototype.update = function (data) {
	    if (this.finished) {
	        throw new Error('Attempted to update an already finished hash.');
	    }
	
	    if (hashUtils.isEmptyData(data)) {
	        return this;
	    }
	
	    data = hashUtils.convertToBuffer(data);
	
	    var position = 0;
	    var byteLength = data.byteLength;
	    this.bytesHashed += byteLength;
	    if (this.bytesHashed * 8 > MAX_HASHABLE_LENGTH) {
	        throw new Error('Cannot hash more than 2^53 - 1 bits');
	    }
	
	    while (byteLength > 0) {
	        this.buffer[this.bufferLength++] = data[position++];
	        byteLength--;
	        if (this.bufferLength === BLOCK_SIZE) {
	            this.hashBuffer();
	            this.bufferLength = 0;
	        }
	    }
	
	    return this;
	};
	
	Sha256.prototype.digest = function (encoding) {
	    if (!this.finished) {
	        var bitsHashed = this.bytesHashed * 8;
	        var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
	        var undecoratedLength = this.bufferLength;
	        bufferView.setUint8(this.bufferLength++, 0x80);
	        // Ensure the final block has enough room for the hashed length
	        if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
	            for (var i = this.bufferLength; i < BLOCK_SIZE; i++) {
	                bufferView.setUint8(i, 0);
	            }
	            this.hashBuffer();
	            this.bufferLength = 0;
	        }
	        for (var i = this.bufferLength; i < BLOCK_SIZE - 8; i++) {
	            bufferView.setUint8(i, 0);
	        }
	        bufferView.setUint32(BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
	        bufferView.setUint32(BLOCK_SIZE - 4, bitsHashed);
	        this.hashBuffer();
	        this.finished = true;
	    }
	    // The value in state is little-endian rather than big-endian, so flip
	    // each word into a new Uint8Array
	    var out = new Buffer(DIGEST_LENGTH);
	    for (var i = 0; i < 8; i++) {
	        out[i * 4] = (this.state[i] >>> 24) & 0xff;
	        out[i * 4 + 1] = (this.state[i] >>> 16) & 0xff;
	        out[i * 4 + 2] = (this.state[i] >>> 8) & 0xff;
	        out[i * 4 + 3] = (this.state[i] >>> 0) & 0xff;
	    }
	    return encoding ? out.toString(encoding) : out;
	};
	
	Sha256.prototype.hashBuffer = function () {
	    var _a = this,
	        buffer = _a.buffer,
	        state = _a.state;
	    var state0 = state[0],
	        state1 = state[1],
	        state2 = state[2],
	        state3 = state[3],
	        state4 = state[4],
	        state5 = state[5],
	        state6 = state[6],
	        state7 = state[7];
	    for (var i = 0; i < BLOCK_SIZE; i++) {
	        if (i < 16) {
	            this.temp[i] = (((buffer[i * 4] & 0xff) << 24) |
	                ((buffer[(i * 4) + 1] & 0xff) << 16) |
	                ((buffer[(i * 4) + 2] & 0xff) << 8) |
	                (buffer[(i * 4) + 3] & 0xff));
	        }
	        else {
	            var u = this.temp[i - 2];
	            var t1_1 = (u >>> 17 | u << 15) ^
	                (u >>> 19 | u << 13) ^
	                (u >>> 10);
	            u = this.temp[i - 15];
	            var t2_1 = (u >>> 7 | u << 25) ^
	                (u >>> 18 | u << 14) ^
	                (u >>> 3);
	            this.temp[i] = (t1_1 + this.temp[i - 7] | 0) +
	                (t2_1 + this.temp[i - 16] | 0);
	        }
	        var t1 = (((((state4 >>> 6 | state4 << 26) ^
	            (state4 >>> 11 | state4 << 21) ^
	            (state4 >>> 25 | state4 << 7))
	            + ((state4 & state5) ^ (~state4 & state6))) | 0)
	            + ((state7 + ((KEY[i] + this.temp[i]) | 0)) | 0)) | 0;
	        var t2 = (((state0 >>> 2 | state0 << 30) ^
	            (state0 >>> 13 | state0 << 19) ^
	            (state0 >>> 22 | state0 << 10)) + ((state0 & state1) ^ (state0 & state2) ^ (state1 & state2))) | 0;
	        state7 = state6;
	        state6 = state5;
	        state5 = state4;
	        state4 = (state3 + t1) | 0;
	        state3 = state2;
	        state2 = state1;
	        state1 = state0;
	        state0 = (t1 + t2) | 0;
	    }
	    state[0] += state0;
	    state[1] += state1;
	    state[2] += state2;
	    state[3] += state3;
	    state[4] += state4;
	    state[5] += state5;
	    state[6] += state6;
	    state[7] += state7;
	};


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__) {

	/* WEBPACK VAR INJECTION */(function(process) {var util = __webpack_require__(__webpack_module_template_argument_0__);
	
	// browser specific modules
	util.crypto.lib = __webpack_require__(__webpack_module_template_argument_1__);
	util.Buffer = __webpack_require__(21).Buffer;
	util.url = __webpack_require__(__webpack_module_template_argument_2__);
	util.querystring = __webpack_require__(73);
	util.realClock = __webpack_require__(__webpack_module_template_argument_3__);
	util.environment = 'js';
	util.createEventStream = __webpack_require__(__webpack_module_template_argument_4__).createEventStream;
	util.isBrowser = function() { return true; };
	util.isNode = function() { return false; };
	
	var AWS = __webpack_require__(__webpack_module_template_argument_5__);
	
	/**
	 * @api private
	 */
	module.exports = AWS;
	
	__webpack_require__(__webpack_module_template_argument_6__);
	__webpack_require__(__webpack_module_template_argument_7__);
	__webpack_require__(__webpack_module_template_argument_8__);
	__webpack_require__(__webpack_module_template_argument_9__);
	__webpack_require__(__webpack_module_template_argument_10__);
	__webpack_require__(__webpack_module_template_argument_11__);
	__webpack_require__(__webpack_module_template_argument_12__);
	
	// Load the DOMParser XML parser
	AWS.XML.Parser = __webpack_require__(__webpack_module_template_argument_13__);
	
	// Load the XHR HttpClient
	__webpack_require__(__webpack_module_template_argument_14__);
	
	if (typeof process === 'undefined') {
	  var process = {
	    browser: true
	  };
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	__webpack_require__(__webpack_module_template_argument_1__);
	__webpack_require__(__webpack_module_template_argument_2__);
	var PromisesDependency;
	
	/**
	 * The main configuration class used by all service objects to set
	 * the region, credentials, and other options for requests.
	 *
	 * By default, credentials and region settings are left unconfigured.
	 * This should be configured by the application before using any
	 * AWS service APIs.
	 *
	 * In order to set global configuration options, properties should
	 * be assigned to the global {AWS.config} object.
	 *
	 * @see AWS.config
	 *
	 * @!group General Configuration Options
	 *
	 * @!attribute credentials
	 *   @return [AWS.Credentials] the AWS credentials to sign requests with.
	 *
	 * @!attribute region
	 *   @example Set the global region setting to us-west-2
	 *     AWS.config.update({region: 'us-west-2'});
	 *   @return [AWS.Credentials] The region to send service requests to.
	 *   @see http://docs.amazonwebservices.com/general/latest/gr/rande.html
	 *     A list of available endpoints for each AWS service
	 *
	 * @!attribute maxRetries
	 *   @return [Integer] the maximum amount of retries to perform for a
	 *     service request. By default this value is calculated by the specific
	 *     service object that the request is being made to.
	 *
	 * @!attribute maxRedirects
	 *   @return [Integer] the maximum amount of redirects to follow for a
	 *     service request. Defaults to 10.
	 *
	 * @!attribute paramValidation
	 *   @return [Boolean|map] whether input parameters should be validated against
	 *     the operation description before sending the request. Defaults to true.
	 *     Pass a map to enable any of the following specific validation features:
	 *
	 *     * **min** [Boolean] &mdash; Validates that a value meets the min
	 *       constraint. This is enabled by default when paramValidation is set
	 *       to `true`.
	 *     * **max** [Boolean] &mdash; Validates that a value meets the max
	 *       constraint.
	 *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
	 *       regular expression.
	 *     * **enum** [Boolean] &mdash; Validates that a string value matches one
	 *       of the allowable enum values.
	 *
	 * @!attribute computeChecksums
	 *   @return [Boolean] whether to compute checksums for payload bodies when
	 *     the service accepts it (currently supported in S3 only).
	 *
	 * @!attribute convertResponseTypes
	 *   @return [Boolean] whether types are converted when parsing response data.
	 *     Currently only supported for JSON based services. Turning this off may
	 *     improve performance on large response payloads. Defaults to `true`.
	 *
	 * @!attribute correctClockSkew
	 *   @return [Boolean] whether to apply a clock skew correction and retry
	 *     requests that fail because of an skewed client clock. Defaults to
	 *     `false`.
	 *
	 * @!attribute sslEnabled
	 *   @return [Boolean] whether SSL is enabled for requests
	 *
	 * @!attribute s3ForcePathStyle
	 *   @return [Boolean] whether to force path style URLs for S3 objects
	 *
	 * @!attribute s3BucketEndpoint
	 *   @note Setting this configuration option requires an `endpoint` to be
	 *     provided explicitly to the service constructor.
	 *   @return [Boolean] whether the provided endpoint addresses an individual
	 *     bucket (false if it addresses the root API endpoint).
	 *
	 * @!attribute s3DisableBodySigning
	 *   @return [Boolean] whether to disable S3 body signing when using signature version `v4`.
	 *     Body signing can only be disabled when using https. Defaults to `true`.
	 *
	 * @!attribute useAccelerateEndpoint
	 *   @note This configuration option is only compatible with S3 while accessing
	 *     dns-compatible buckets.
	 *   @return [Boolean] Whether to use the Accelerate endpoint with the S3 service.
	 *     Defaults to `false`.
	 *
	 * @!attribute retryDelayOptions
	 *   @example Set the base retry delay for all services to 300 ms
	 *     AWS.config.update({retryDelayOptions: {base: 300}});
	 *     // Delays with maxRetries = 3: 300, 600, 1200
	 *   @example Set a custom backoff function to provide delay values on retries
	 *     AWS.config.update({retryDelayOptions: {customBackoff: function(retryCount) {
	 *       // returns delay in ms
	 *     }}});
	 *   @return [map] A set of options to configure the retry delay on retryable errors.
	 *     Currently supported options are:
	 *
	 *     * **base** [Integer] &mdash; The base number of milliseconds to use in the
	 *       exponential backoff for operation retries. Defaults to 100 ms for all services except
	 *       DynamoDB, where it defaults to 50ms.
	 *     * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
	 *       and returns the amount of time to delay in milliseconds. The `base` option will be
	 *       ignored if this option is supplied.
	 *
	 * @!attribute httpOptions
	 *   @return [map] A set of options to pass to the low-level HTTP request.
	 *     Currently supported options are:
	 *
	 *     * **proxy** [String] &mdash; the URL to proxy requests through
	 *     * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
	 *       HTTP requests with. Used for connection pooling. Note that for
	 *       SSL connections, a special Agent object is used in order to enable
	 *       peer certificate verification. This feature is only supported in the
	 *       Node.js environment.
	 *     * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
	 *       failing to establish a connection with the server after
	 *       `connectTimeout` milliseconds. This timeout has no effect once a socket
	 *       connection has been established.
	 *     * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
	 *       milliseconds of inactivity on the socket. Defaults to two minutes
	 *       (120000)
	 *     * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
	 *       HTTP requests. Used in the browser environment only. Set to false to
	 *       send requests synchronously. Defaults to true (async on).
	 *     * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
	 *       property of an XMLHttpRequest object. Used in the browser environment
	 *       only. Defaults to false.
	 * @!attribute logger
	 *   @return [#write,#log] an object that responds to .write() (like a stream)
	 *     or .log() (like the console object) in order to log information about
	 *     requests
	 *
	 * @!attribute systemClockOffset
	 *   @return [Number] an offset value in milliseconds to apply to all signing
	 *     times. Use this to compensate for clock skew when your system may be
	 *     out of sync with the service time. Note that this configuration option
	 *     can only be applied to the global `AWS.config` object and cannot be
	 *     overridden in service-specific configuration. Defaults to 0 milliseconds.
	 *
	 * @!attribute signatureVersion
	 *   @return [String] the signature version to sign requests with (overriding
	 *     the API configuration). Possible values are: 'v2', 'v3', 'v4'.
	 *
	 * @!attribute signatureCache
	 *   @return [Boolean] whether the signature to sign requests with (overriding
	 *     the API configuration) is cached. Only applies to the signature version 'v4'.
	 *     Defaults to `true`.
	 *
	 * @!attribute endpointDiscoveryEnabled
	 *   @return [Boolean] whether to enable endpoint discovery for operations that
	 *     allow optionally using an endpoint returned by the service.
	 *     Defaults to 'false'
	 *
	 * @!attribute endpointCacheSize
	 *   @return [Number] the size of the global cache storing endpoints from endpoint
	 *     discovery operations. Once endpoint cache is created, updating this setting
	 *     cannot change existing cache size.
	 *     Defaults to 1000
	 *
	 * @!attribute hostPrefixEnabled
	 *   @return [Boolean] whether to marshal request parameters to the prefix of
	 *     hostname. Defaults to `true`.
	 */
	AWS.Config = AWS.util.inherit({
	  /**
	   * @!endgroup
	   */
	
	  /**
	   * Creates a new configuration object. This is the object that passes
	   * option data along to service requests, including credentials, security,
	   * region information, and some service specific settings.
	   *
	   * @example Creating a new configuration object with credentials and region
	   *   var config = new AWS.Config({
	   *     accessKeyId: 'AKID', secretAccessKey: 'SECRET', region: 'us-west-2'
	   *   });
	   * @option options accessKeyId [String] your AWS access key ID.
	   * @option options secretAccessKey [String] your AWS secret access key.
	   * @option options sessionToken [AWS.Credentials] the optional AWS
	   *   session token to sign requests with.
	   * @option options credentials [AWS.Credentials] the AWS credentials
	   *   to sign requests with. You can either specify this object, or
	   *   specify the accessKeyId and secretAccessKey options directly.
	   * @option options credentialProvider [AWS.CredentialProviderChain] the
	   *   provider chain used to resolve credentials if no static `credentials`
	   *   property is set.
	   * @option options region [String] the region to send service requests to.
	   *   See {region} for more information.
	   * @option options maxRetries [Integer] the maximum amount of retries to
	   *   attempt with a request. See {maxRetries} for more information.
	   * @option options maxRedirects [Integer] the maximum amount of redirects to
	   *   follow with a request. See {maxRedirects} for more information.
	   * @option options sslEnabled [Boolean] whether to enable SSL for
	   *   requests.
	   * @option options paramValidation [Boolean|map] whether input parameters
	   *   should be validated against the operation description before sending
	   *   the request. Defaults to true. Pass a map to enable any of the
	   *   following specific validation features:
	   *
	   *   * **min** [Boolean] &mdash; Validates that a value meets the min
	   *     constraint. This is enabled by default when paramValidation is set
	   *     to `true`.
	   *   * **max** [Boolean] &mdash; Validates that a value meets the max
	   *     constraint.
	   *   * **pattern** [Boolean] &mdash; Validates that a string value matches a
	   *     regular expression.
	   *   * **enum** [Boolean] &mdash; Validates that a string value matches one
	   *     of the allowable enum values.
	   * @option options computeChecksums [Boolean] whether to compute checksums
	   *   for payload bodies when the service accepts it (currently supported
	   *   in S3 only)
	   * @option options convertResponseTypes [Boolean] whether types are converted
	   *     when parsing response data. Currently only supported for JSON based
	   *     services. Turning this off may improve performance on large response
	   *     payloads. Defaults to `true`.
	   * @option options correctClockSkew [Boolean] whether to apply a clock skew
	   *     correction and retry requests that fail because of an skewed client
	   *     clock. Defaults to `false`.
	   * @option options s3ForcePathStyle [Boolean] whether to force path
	   *   style URLs for S3 objects.
	   * @option options s3BucketEndpoint [Boolean] whether the provided endpoint
	   *   addresses an individual bucket (false if it addresses the root API
	   *   endpoint). Note that setting this configuration option requires an
	   *   `endpoint` to be provided explicitly to the service constructor.
	   * @option options s3DisableBodySigning [Boolean] whether S3 body signing
	   *   should be disabled when using signature version `v4`. Body signing
	   *   can only be disabled when using https. Defaults to `true`.
	   *
	   * @option options retryDelayOptions [map] A set of options to configure
	   *   the retry delay on retryable errors. Currently supported options are:
	   *
	   *   * **base** [Integer] &mdash; The base number of milliseconds to use in the
	   *     exponential backoff for operation retries. Defaults to 100 ms for all
	   *     services except DynamoDB, where it defaults to 50ms.
	   *   * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
	   *     and returns the amount of time to delay in milliseconds. The `base` option will be
	   *     ignored if this option is supplied.
	   * @option options httpOptions [map] A set of options to pass to the low-level
	   *   HTTP request. Currently supported options are:
	   *
	   *   * **proxy** [String] &mdash; the URL to proxy requests through
	   *   * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
	   *     HTTP requests with. Used for connection pooling. Defaults to the global
	   *     agent (`http.globalAgent`) for non-SSL connections. Note that for
	   *     SSL connections, a special Agent object is used in order to enable
	   *     peer certificate verification. This feature is only available in the
	   *     Node.js environment.
	   *   * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
	   *     failing to establish a connection with the server after
	   *     `connectTimeout` milliseconds. This timeout has no effect once a socket
	   *     connection has been established.
	   *   * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
	   *     milliseconds of inactivity on the socket. Defaults to two minutes
	   *     (120000).
	   *   * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
	   *     HTTP requests. Used in the browser environment only. Set to false to
	   *     send requests synchronously. Defaults to true (async on).
	   *   * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
	   *     property of an XMLHttpRequest object. Used in the browser environment
	   *     only. Defaults to false.
	   * @option options apiVersion [String, Date] a String in YYYY-MM-DD format
	   *   (or a date) that represents the latest possible API version that can be
	   *   used in all services (unless overridden by `apiVersions`). Specify
	   *   'latest' to use the latest possible version.
	   * @option options apiVersions [map<String, String|Date>] a map of service
	   *   identifiers (the lowercase service class name) with the API version to
	   *   use when instantiating a service. Specify 'latest' for each individual
	   *   that can use the latest available version.
	   * @option options logger [#write,#log] an object that responds to .write()
	   *   (like a stream) or .log() (like the console object) in order to log
	   *   information about requests
	   * @option options systemClockOffset [Number] an offset value in milliseconds
	   *   to apply to all signing times. Use this to compensate for clock skew
	   *   when your system may be out of sync with the service time. Note that
	   *   this configuration option can only be applied to the global `AWS.config`
	   *   object and cannot be overridden in service-specific configuration.
	   *   Defaults to 0 milliseconds.
	   * @option options signatureVersion [String] the signature version to sign
	   *   requests with (overriding the API configuration). Possible values are:
	   *   'v2', 'v3', 'v4'.
	   * @option options signatureCache [Boolean] whether the signature to sign
	   *   requests with (overriding the API configuration) is cached. Only applies
	   *   to the signature version 'v4'. Defaults to `true`.
	   * @option options dynamoDbCrc32 [Boolean] whether to validate the CRC32
	   *   checksum of HTTP response bodies returned by DynamoDB. Default: `true`.
	   * @option options useAccelerateEndpoint [Boolean] Whether to use the
	   *   S3 Transfer Acceleration endpoint with the S3 service. Default: `false`.
	   * @option options clientSideMonitoring [Boolean] whether to collect and
	   *   publish this client's performance metrics of all its API requests.
	   * @option options endpointDiscoveryEnabled [Boolean] whether to enable endpoint
	   *   discovery for operations that allow optionally using an endpoint returned by
	   *   the service.
	   *   Defaults to 'false'
	   * @option options endpointCacheSize [Number] the size of the global cache storing
	   *   endpoints from endpoint discovery operations. Once endpoint cache is created,
	   *   updating this setting cannot change existing cache size.
	   *   Defaults to 1000
	   * @option options hostPrefixEnabled [Boolean] whether to marshal request
	   *   parameters to the prefix of hostname.
	   *   Defaults to `true`.
	   */
	  constructor: function Config(options) {
	    if (options === undefined) options = {};
	    options = this.extractCredentials(options);
	
	    AWS.util.each.call(this, this.keys, function (key, value) {
	      this.set(key, options[key], value);
	    });
	  },
	
	  /**
	   * @!group Managing Credentials
	   */
	
	  /**
	   * Loads credentials from the configuration object. This is used internally
	   * by the SDK to ensure that refreshable {Credentials} objects are properly
	   * refreshed and loaded when sending a request. If you want to ensure that
	   * your credentials are loaded prior to a request, you can use this method
	   * directly to provide accurate credential data stored in the object.
	   *
	   * @note If you configure the SDK with static or environment credentials,
	   *   the credential data should already be present in {credentials} attribute.
	   *   This method is primarily necessary to load credentials from asynchronous
	   *   sources, or sources that can refresh credentials periodically.
	   * @example Getting your access key
	   *   AWS.config.getCredentials(function(err) {
	   *     if (err) console.log(err.stack); // credentials not loaded
	   *     else console.log("Access Key:", AWS.config.credentials.accessKeyId);
	   *   })
	   * @callback callback function(err)
	   *   Called when the {credentials} have been properly set on the configuration
	   *   object.
	   *
	   *   @param err [Error] if this is set, credentials were not successfully
	   *     loaded and this error provides information why.
	   * @see credentials
	   * @see Credentials
	   */
	  getCredentials: function getCredentials(callback) {
	    var self = this;
	
	    function finish(err) {
	      callback(err, err ? null : self.credentials);
	    }
	
	    function credError(msg, err) {
	      return new AWS.util.error(err || new Error(), {
	        code: 'CredentialsError',
	        message: msg,
	        name: 'CredentialsError'
	      });
	    }
	
	    function getAsyncCredentials() {
	      self.credentials.get(function(err) {
	        if (err) {
	          var msg = 'Could not load credentials from ' +
	            self.credentials.constructor.name;
	          err = credError(msg, err);
	        }
	        finish(err);
	      });
	    }
	
	    function getStaticCredentials() {
	      var err = null;
	      if (!self.credentials.accessKeyId || !self.credentials.secretAccessKey) {
	        err = credError('Missing credentials');
	      }
	      finish(err);
	    }
	
	    if (self.credentials) {
	      if (typeof self.credentials.get === 'function') {
	        getAsyncCredentials();
	      } else { // static credentials
	        getStaticCredentials();
	      }
	    } else if (self.credentialProvider) {
	      self.credentialProvider.resolve(function(err, creds) {
	        if (err) {
	          err = credError('Could not load credentials from any providers', err);
	        }
	        self.credentials = creds;
	        finish(err);
	      });
	    } else {
	      finish(credError('No credentials to load'));
	    }
	  },
	
	  /**
	   * @!group Loading and Setting Configuration Options
	   */
	
	  /**
	   * @overload update(options, allowUnknownKeys = false)
	   *   Updates the current configuration object with new options.
	   *
	   *   @example Update maxRetries property of a configuration object
	   *     config.update({maxRetries: 10});
	   *   @param [Object] options a map of option keys and values.
	   *   @param [Boolean] allowUnknownKeys whether unknown keys can be set on
	   *     the configuration object. Defaults to `false`.
	   *   @see constructor
	   */
	  update: function update(options, allowUnknownKeys) {
	    allowUnknownKeys = allowUnknownKeys || false;
	    options = this.extractCredentials(options);
	    AWS.util.each.call(this, options, function (key, value) {
	      if (allowUnknownKeys || Object.prototype.hasOwnProperty.call(this.keys, key) ||
	          AWS.Service.hasService(key)) {
	        this.set(key, value);
	      }
	    });
	  },
	
	  /**
	   * Loads configuration data from a JSON file into this config object.
	   * @note Loading configuration will reset all existing configuration
	   *   on the object.
	   * @!macro nobrowser
	   * @param path [String] the path relative to your process's current
	   *    working directory to load configuration from.
	   * @return [AWS.Config] the same configuration object
	   */
	  loadFromPath: function loadFromPath(path) {
	    this.clear();
	
	    var options = JSON.parse(AWS.util.readFileSync(path));
	    var fileSystemCreds = new AWS.FileSystemCredentials(path);
	    var chain = new AWS.CredentialProviderChain();
	    chain.providers.unshift(fileSystemCreds);
	    chain.resolve(function (err, creds) {
	      if (err) throw err;
	      else options.credentials = creds;
	    });
	
	    this.constructor(options);
	
	    return this;
	  },
	
	  /**
	   * Clears configuration data on this object
	   *
	   * @api private
	   */
	  clear: function clear() {
	    /*jshint forin:false */
	    AWS.util.each.call(this, this.keys, function (key) {
	      delete this[key];
	    });
	
	    // reset credential provider
	    this.set('credentials', undefined);
	    this.set('credentialProvider', undefined);
	  },
	
	  /**
	   * Sets a property on the configuration object, allowing for a
	   * default value
	   * @api private
	   */
	  set: function set(property, value, defaultValue) {
	    if (value === undefined) {
	      if (defaultValue === undefined) {
	        defaultValue = this.keys[property];
	      }
	      if (typeof defaultValue === 'function') {
	        this[property] = defaultValue.call(this);
	      } else {
	        this[property] = defaultValue;
	      }
	    } else if (property === 'httpOptions' && this[property]) {
	      // deep merge httpOptions
	      this[property] = AWS.util.merge(this[property], value);
	    } else {
	      this[property] = value;
	    }
	  },
	
	  /**
	   * All of the keys with their default values.
	   *
	   * @constant
	   * @api private
	   */
	  keys: {
	    credentials: null,
	    credentialProvider: null,
	    region: null,
	    logger: null,
	    apiVersions: {},
	    apiVersion: null,
	    endpoint: undefined,
	    httpOptions: {
	      timeout: 120000
	    },
	    maxRetries: undefined,
	    maxRedirects: 10,
	    paramValidation: true,
	    sslEnabled: true,
	    s3ForcePathStyle: false,
	    s3BucketEndpoint: false,
	    s3DisableBodySigning: true,
	    computeChecksums: true,
	    convertResponseTypes: true,
	    correctClockSkew: false,
	    customUserAgent: null,
	    dynamoDbCrc32: true,
	    systemClockOffset: 0,
	    signatureVersion: null,
	    signatureCache: true,
	    retryDelayOptions: {},
	    useAccelerateEndpoint: false,
	    clientSideMonitoring: false,
	    endpointDiscoveryEnabled: false,
	    endpointCacheSize: 1000,
	    hostPrefixEnabled: true
	  },
	
	  /**
	   * Extracts accessKeyId, secretAccessKey and sessionToken
	   * from a configuration hash.
	   *
	   * @api private
	   */
	  extractCredentials: function extractCredentials(options) {
	    if (options.accessKeyId && options.secretAccessKey) {
	      options = AWS.util.copy(options);
	      options.credentials = new AWS.Credentials(options);
	    }
	    return options;
	  },
	
	  /**
	   * Sets the promise dependency the SDK will use wherever Promises are returned.
	   * Passing `null` will force the SDK to use native Promises if they are available.
	   * If native Promises are not available, passing `null` will have no effect.
	   * @param [Constructor] dep A reference to a Promise constructor
	   */
	  setPromisesDependency: function setPromisesDependency(dep) {
	    PromisesDependency = dep;
	    // if null was passed in, we should try to use native promises
	    if (dep === null && typeof Promise === 'function') {
	      PromisesDependency = Promise;
	    }
	    var constructors = [AWS.Request, AWS.Credentials, AWS.CredentialProviderChain];
	    if (AWS.S3 && AWS.S3.ManagedUpload) constructors.push(AWS.S3.ManagedUpload);
	    AWS.util.addPromises(constructors, PromisesDependency);
	  },
	
	  /**
	   * Gets the promise dependency set by `AWS.config.setPromisesDependency`.
	   */
	  getPromisesDependency: function getPromisesDependency() {
	    return PromisesDependency;
	  }
	});
	
	/**
	 * @return [AWS.Config] The global configuration object singleton instance
	 * @readonly
	 * @see AWS.Config
	 */
	AWS.config = new AWS.Config();


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__, __webpack_module_template_argument_22__, __webpack_module_template_argument_23__, __webpack_module_template_argument_24__, __webpack_module_template_argument_25__) {

	/**
	 * The main AWS namespace
	 */
	var AWS = { util: __webpack_require__(__webpack_module_template_argument_0__) };
	
	/**
	 * @api private
	 * @!macro [new] nobrowser
	 *   @note This feature is not supported in the browser environment of the SDK.
	 */
	var _hidden = {}; _hidden.toString(); // hack to parse macro
	
	/**
	 * @api private
	 */
	module.exports = AWS;
	
	AWS.util.update(AWS, {
	
	  /**
	   * @constant
	   */
	  VERSION: '2.518.0',
	
	  /**
	   * @api private
	   */
	  Signers: {},
	
	  /**
	   * @api private
	   */
	  Protocol: {
	    Json: __webpack_require__(__webpack_module_template_argument_1__),
	    Query: __webpack_require__(__webpack_module_template_argument_2__),
	    Rest: __webpack_require__(__webpack_module_template_argument_3__),
	    RestJson: __webpack_require__(__webpack_module_template_argument_4__),
	    RestXml: __webpack_require__(__webpack_module_template_argument_5__)
	  },
	
	  /**
	   * @api private
	   */
	  XML: {
	    Builder: __webpack_require__(__webpack_module_template_argument_6__),
	    Parser: null // conditionally set based on environment
	  },
	
	  /**
	   * @api private
	   */
	  JSON: {
	    Builder: __webpack_require__(__webpack_module_template_argument_7__),
	    Parser: __webpack_require__(__webpack_module_template_argument_8__)
	  },
	
	  /**
	   * @api private
	   */
	  Model: {
	    Api: __webpack_require__(__webpack_module_template_argument_9__),
	    Operation: __webpack_require__(__webpack_module_template_argument_10__),
	    Shape: __webpack_require__(__webpack_module_template_argument_11__),
	    Paginator: __webpack_require__(__webpack_module_template_argument_12__),
	    ResourceWaiter: __webpack_require__(__webpack_module_template_argument_13__)
	  },
	
	  /**
	   * @api private
	   */
	  apiLoader: __webpack_require__(__webpack_module_template_argument_14__),
	
	  /**
	   * @api private
	   */
	  EndpointCache: __webpack_require__(__webpack_module_template_argument_15__).EndpointCache
	});
	__webpack_require__(__webpack_module_template_argument_16__);
	__webpack_require__(__webpack_module_template_argument_17__);
	__webpack_require__(__webpack_module_template_argument_18__);
	__webpack_require__(__webpack_module_template_argument_19__);
	__webpack_require__(__webpack_module_template_argument_20__);
	__webpack_require__(__webpack_module_template_argument_21__);
	__webpack_require__(__webpack_module_template_argument_22__);
	__webpack_require__(__webpack_module_template_argument_23__);
	__webpack_require__(__webpack_module_template_argument_24__);
	__webpack_require__(__webpack_module_template_argument_25__);
	
	/**
	 * @readonly
	 * @return [AWS.SequentialExecutor] a collection of global event listeners that
	 *   are attached to every sent request.
	 * @see AWS.Request AWS.Request for a list of events to listen for
	 * @example Logging the time taken to send a request
	 *   AWS.events.on('send', function startSend(resp) {
	 *     resp.startTime = new Date().getTime();
	 *   }).on('complete', function calculateTime(resp) {
	 *     var time = (new Date().getTime() - resp.startTime) / 1000;
	 *     console.log('Request took ' + time + ' seconds');
	 *   });
	 *
	 *   new AWS.S3().listBuckets(); // prints 'Request took 0.285 seconds'
	 */
	AWS.events = new AWS.SequentialExecutor();
	
	//create endpoint cache lazily
	AWS.util.memoizedProperty(AWS, 'endpointCache', function() {
	  return new AWS.EndpointCache(AWS.config.endpointCacheSize);
	}, true);


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Represents your AWS security credentials, specifically the
	 * {accessKeyId}, {secretAccessKey}, and optional {sessionToken}.
	 * Creating a `Credentials` object allows you to pass around your
	 * security information to configuration and service objects.
	 *
	 * Note that this class typically does not need to be constructed manually,
	 * as the {AWS.Config} and {AWS.Service} classes both accept simple
	 * options hashes with the three keys. These structures will be converted
	 * into Credentials objects automatically.
	 *
	 * ## Expiring and Refreshing Credentials
	 *
	 * Occasionally credentials can expire in the middle of a long-running
	 * application. In this case, the SDK will automatically attempt to
	 * refresh the credentials from the storage location if the Credentials
	 * class implements the {refresh} method.
	 *
	 * If you are implementing a credential storage location, you
	 * will want to create a subclass of the `Credentials` class and
	 * override the {refresh} method. This method allows credentials to be
	 * retrieved from the backing store, be it a file system, database, or
	 * some network storage. The method should reset the credential attributes
	 * on the object.
	 *
	 * @!attribute expired
	 *   @return [Boolean] whether the credentials have been expired and
	 *     require a refresh. Used in conjunction with {expireTime}.
	 * @!attribute expireTime
	 *   @return [Date] a time when credentials should be considered expired. Used
	 *     in conjunction with {expired}.
	 * @!attribute accessKeyId
	 *   @return [String] the AWS access key ID
	 * @!attribute secretAccessKey
	 *   @return [String] the AWS secret access key
	 * @!attribute sessionToken
	 *   @return [String] an optional AWS session token
	 */
	AWS.Credentials = AWS.util.inherit({
	  /**
	   * A credentials object can be created using positional arguments or an options
	   * hash.
	   *
	   * @overload AWS.Credentials(accessKeyId, secretAccessKey, sessionToken=null)
	   *   Creates a Credentials object with a given set of credential information
	   *   as positional arguments.
	   *   @param accessKeyId [String] the AWS access key ID
	   *   @param secretAccessKey [String] the AWS secret access key
	   *   @param sessionToken [String] the optional AWS session token
	   *   @example Create a credentials object with AWS credentials
	   *     var creds = new AWS.Credentials('akid', 'secret', 'session');
	   * @overload AWS.Credentials(options)
	   *   Creates a Credentials object with a given set of credential information
	   *   as an options hash.
	   *   @option options accessKeyId [String] the AWS access key ID
	   *   @option options secretAccessKey [String] the AWS secret access key
	   *   @option options sessionToken [String] the optional AWS session token
	   *   @example Create a credentials object with AWS credentials
	   *     var creds = new AWS.Credentials({
	   *       accessKeyId: 'akid', secretAccessKey: 'secret', sessionToken: 'session'
	   *     });
	   */
	  constructor: function Credentials() {
	    // hide secretAccessKey from being displayed with util.inspect
	    AWS.util.hideProperties(this, ['secretAccessKey']);
	
	    this.expired = false;
	    this.expireTime = null;
	    this.refreshCallbacks = [];
	    if (arguments.length === 1 && typeof arguments[0] === 'object') {
	      var creds = arguments[0].credentials || arguments[0];
	      this.accessKeyId = creds.accessKeyId;
	      this.secretAccessKey = creds.secretAccessKey;
	      this.sessionToken = creds.sessionToken;
	    } else {
	      this.accessKeyId = arguments[0];
	      this.secretAccessKey = arguments[1];
	      this.sessionToken = arguments[2];
	    }
	  },
	
	  /**
	   * @return [Integer] the number of seconds before {expireTime} during which
	   *   the credentials will be considered expired.
	   */
	  expiryWindow: 15,
	
	  /**
	   * @return [Boolean] whether the credentials object should call {refresh}
	   * @note Subclasses should override this method to provide custom refresh
	   *   logic.
	   */
	  needsRefresh: function needsRefresh() {
	    var currentTime = AWS.util.date.getDate().getTime();
	    var adjustedTime = new Date(currentTime + this.expiryWindow * 1000);
	
	    if (this.expireTime && adjustedTime > this.expireTime) {
	      return true;
	    } else {
	      return this.expired || !this.accessKeyId || !this.secretAccessKey;
	    }
	  },
	
	  /**
	   * Gets the existing credentials, refreshing them if they are not yet loaded
	   * or have expired. Users should call this method before using {refresh},
	   * as this will not attempt to reload credentials when they are already
	   * loaded into the object.
	   *
	   * @callback callback function(err)
	   *   When this callback is called with no error, it means either credentials
	   *   do not need to be refreshed or refreshed credentials information has
	   *   been loaded into the object (as the `accessKeyId`, `secretAccessKey`,
	   *   and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   */
	  get: function get(callback) {
	    var self = this;
	    if (this.needsRefresh()) {
	      this.refresh(function(err) {
	        if (!err) self.expired = false; // reset expired flag
	        if (callback) callback(err);
	      });
	    } else if (callback) {
	      callback();
	    }
	  },
	
	  /**
	   * @!method  getPromise()
	   *   Returns a 'thenable' promise.
	   *   Gets the existing credentials, refreshing them if they are not yet loaded
	   *   or have expired. Users should call this method before using {refresh},
	   *   as this will not attempt to reload credentials when they are already
	   *   loaded into the object.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function()
	   *     Called if the promise is fulfilled. When this callback is called, it
	   *     means either credentials do not need to be refreshed or refreshed
	   *     credentials information has been loaded into the object (as the
	   *     `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
	   *   @callback rejectedCallback function(err)
	   *     Called if the promise is rejected.
	   *     @param err [Error] if an error occurred, this value will be filled
	   *   @return [Promise] A promise that represents the state of the `get` call.
	   *   @example Calling the `getPromise` method.
	   *     var promise = credProvider.getPromise();
	   *     promise.then(function() { ... }, function(err) { ... });
	   */
	
	  /**
	   * @!method  refreshPromise()
	   *   Returns a 'thenable' promise.
	   *   Refreshes the credentials. Users should call {get} before attempting
	   *   to forcibly refresh credentials.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function()
	   *     Called if the promise is fulfilled. When this callback is called, it
	   *     means refreshed credentials information has been loaded into the object
	   *     (as the `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
	   *   @callback rejectedCallback function(err)
	   *     Called if the promise is rejected.
	   *     @param err [Error] if an error occurred, this value will be filled
	   *   @return [Promise] A promise that represents the state of the `refresh` call.
	   *   @example Calling the `refreshPromise` method.
	   *     var promise = credProvider.refreshPromise();
	   *     promise.then(function() { ... }, function(err) { ... });
	   */
	
	  /**
	   * Refreshes the credentials. Users should call {get} before attempting
	   * to forcibly refresh credentials.
	   *
	   * @callback callback function(err)
	   *   When this callback is called with no error, it means refreshed
	   *   credentials information has been loaded into the object (as the
	   *   `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @note Subclasses should override this class to reset the
	   *   {accessKeyId}, {secretAccessKey} and optional {sessionToken}
	   *   on the credentials object and then call the callback with
	   *   any error information.
	   * @see get
	   */
	  refresh: function refresh(callback) {
	    this.expired = false;
	    callback();
	  },
	
	  /**
	   * @api private
	   * @param callback
	   */
	  coalesceRefresh: function coalesceRefresh(callback, sync) {
	    var self = this;
	    if (self.refreshCallbacks.push(callback) === 1) {
	      self.load(function onLoad(err) {
	        AWS.util.arrayEach(self.refreshCallbacks, function(callback) {
	          if (sync) {
	            callback(err);
	          } else {
	            // callback could throw, so defer to ensure all callbacks are notified
	            AWS.util.defer(function () {
	              callback(err);
	            });
	          }
	        });
	        self.refreshCallbacks.length = 0;
	      });
	    }
	  },
	
	  /**
	   * @api private
	   * @param callback
	   */
	  load: function load(callback) {
	    callback();
	  }
	});
	
	/**
	 * @api private
	 */
	AWS.Credentials.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.getPromise = AWS.util.promisifyMethod('get', PromiseDependency);
	  this.prototype.refreshPromise = AWS.util.promisifyMethod('refresh', PromiseDependency);
	};
	
	/**
	 * @api private
	 */
	AWS.Credentials.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.getPromise;
	  delete this.prototype.refreshPromise;
	};
	
	AWS.util.addPromises(AWS.Credentials);


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var STS = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Represents temporary credentials retrieved from {AWS.STS}. Without any
	 * extra parameters, credentials will be fetched from the
	 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
	 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
	 * role instead.
	 *
	 * AWS.ChainableTemporaryCredentials differs from AWS.TemporaryCredentials in
	 * the way masterCredentials and refreshes are handled.
	 * AWS.ChainableTemporaryCredentials refreshes expired credentials using the
	 * masterCredentials passed by the user to support chaining of STS credentials.
	 * However, AWS.TemporaryCredentials recursively collapses the masterCredentials
	 * during instantiation, precluding the ability to refresh credentials which
	 * require intermediate, temporary credentials.
	 *
	 * For example, if the application should use RoleA, which must be assumed from
	 * RoleB, and the environment provides credentials which can assume RoleB, then
	 * AWS.ChainableTemporaryCredentials must be used to support refreshing the
	 * temporary credentials for RoleA:
	 *
	 * ```javascript
	 * var roleACreds = new AWS.ChainableTemporaryCredentials({
	 *   params: {RoleArn: 'RoleA'},
	 *   masterCredentials: new AWS.ChainableTemporaryCredentials({
	 *     params: {RoleArn: 'RoleB'},
	 *     masterCredentials: new AWS.EnvironmentCredentials('AWS')
	 *   })
	 * });
	 * ```
	 *
	 * If AWS.TemporaryCredentials had been used in the previous example,
	 * `roleACreds` would fail to refresh because `roleACreds` would
	 * use the environment credentials for the AssumeRole request.
	 *
	 * Another difference is that AWS.ChainableTemporaryCredentials creates the STS
	 * service instance during instantiation while AWS.TemporaryCredentials creates
	 * the STS service instance during the first refresh. Creating the service
	 * instance during instantiation effectively captures the master credentials
	 * from the global config, so that subsequent changes to the global config do
	 * not affect the master credentials used to refresh the temporary credentials.
	 *
	 * This allows an instance of AWS.ChainableTemporaryCredentials to be assigned
	 * to AWS.config.credentials:
	 *
	 * ```javascript
	 * var envCreds = new AWS.EnvironmentCredentials('AWS');
	 * AWS.config.credentials = envCreds;
	 * // masterCredentials will be envCreds
	 * AWS.config.credentials = new AWS.ChainableTemporaryCredentials({
	 *   params: {RoleArn: '...'}
	 * });
	 * ```
	 *
	 * Similarly, to use the CredentialProviderChain's default providers as the
	 * master credentials, simply create a new instance of
	 * AWS.ChainableTemporaryCredentials:
	 *
	 * ```javascript
	 * AWS.config.credentials = new ChainableTemporaryCredentials({
	 *   params: {RoleArn: '...'}
	 * });
	 * ```
	 *
	 * @!attribute service
	 *   @return [AWS.STS] the STS service instance used to
	 *     get and refresh temporary credentials from AWS STS.
	 * @note (see constructor)
	 */
	AWS.ChainableTemporaryCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new temporary credentials object.
	   *
	   * @param options [map] a set of options
	   * @option options params [map] ({}) a map of options that are passed to the
	   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
	   *   If a `RoleArn` parameter is passed in, credentials will be based on the
	   *   IAM role. If a `SerialNumber` parameter is passed in, {tokenCodeFn} must
	   *   also be passed in or an error will be thrown.
	   * @option options masterCredentials [AWS.Credentials] the master credentials
	   *   used to get and refresh temporary credentials from AWS STS. By default,
	   *   AWS.config.credentials or AWS.config.credentialProvider will be used.
	   * @option options tokenCodeFn [Function] (null) Function to provide
	   *   `TokenCode`, if `SerialNumber` is provided for profile in {params}. Function
	   *   is called with value of `SerialNumber` and `callback`, and should provide
	   *   the `TokenCode` or an error to the callback in the format
	   *   `callback(err, token)`.
	   * @example Creating a new credentials object for generic temporary credentials
	   *   AWS.config.credentials = new AWS.ChainableTemporaryCredentials();
	   * @example Creating a new credentials object for an IAM role
	   *   AWS.config.credentials = new AWS.ChainableTemporaryCredentials({
	   *     params: {
	   *       RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials'
	   *     }
	   *   });
	   * @see AWS.STS.assumeRole
	   * @see AWS.STS.getSessionToken
	   */
	  constructor: function ChainableTemporaryCredentials(options) {
	    AWS.Credentials.call(this);
	    options = options || {};
	    this.errorCode = 'ChainableTemporaryCredentialsProviderFailure';
	    this.expired = true;
	    this.tokenCodeFn = null;
	
	    var params = AWS.util.copy(options.params) || {};
	    if (params.RoleArn) {
	      params.RoleSessionName = params.RoleSessionName || 'temporary-credentials';
	    }
	    if (params.SerialNumber) {
	      if (!options.tokenCodeFn || (typeof options.tokenCodeFn !== 'function')) {
	        throw new AWS.util.error(
	          new Error('tokenCodeFn must be a function when params.SerialNumber is given'),
	          {code: this.errorCode}
	        );
	      } else {
	        this.tokenCodeFn = options.tokenCodeFn;
	      }
	    }
	    config = AWS.util.merge(
	      {
	        params: params,
	        credentials: options.masterCredentials || AWS.config.credentials
	      },
	      options.stsConfig || {}
	    );
	    this.service = new STS(config);
	  },
	
	  /**
	   * Refreshes credentials using {AWS.STS.assumeRole} or
	   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
	   * to the credentials {constructor}.
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see AWS.Credentials.get
	   */
	  refresh: function refresh(callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },
	
	  /**
	   * @api private
	   * @param callback
	   */
	  load: function load(callback) {
	    var self = this;
	    var operation = self.service.config.params.RoleArn ? 'assumeRole' : 'getSessionToken';
	    this.getTokenCode(function (err, tokenCode) {
	      var params = {};
	      if (err) {
	        callback(err);
	        return;
	      }
	      if (tokenCode) {
	        params.TokenCode = tokenCode;
	      }
	      self.service[operation](params, function (err, data) {
	        if (!err) {
	          self.service.credentialsFrom(data, self);
	        }
	        callback(err);
	      });
	    });
	  },
	
	  /**
	   * @api private
	   */
	  getTokenCode: function getTokenCode(callback) {
	    var self = this;
	    if (this.tokenCodeFn) {
	      this.tokenCodeFn(this.service.config.params.SerialNumber, function (err, token) {
	        if (err) {
	          var message = err;
	          if (err instanceof Error) {
	            message = err.message;
	          }
	          callback(
	            AWS.util.error(
	              new Error('Error fetching MFA token: ' + message),
	              { code: self.errorCode}
	            )
	          );
	          return;
	        }
	        callback(null, token);
	      });
	    } else {
	      callback(null);
	    }
	  }
	});


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var CognitoIdentity = __webpack_require__(__webpack_module_template_argument_1__);
	var STS = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Represents credentials retrieved from STS Web Identity Federation using
	 * the Amazon Cognito Identity service.
	 *
	 * By default this provider gets credentials using the
	 * {AWS.CognitoIdentity.getCredentialsForIdentity} service operation, which
	 * requires either an `IdentityId` or an `IdentityPoolId` (Amazon Cognito
	 * Identity Pool ID), which is used to call {AWS.CognitoIdentity.getId} to
	 * obtain an `IdentityId`. If the identity or identity pool is not configured in
	 * the Amazon Cognito Console to use IAM roles with the appropriate permissions,
	 * then additionally a `RoleArn` is required containing the ARN of the IAM trust
	 * policy for the Amazon Cognito role that the user will log into. If a `RoleArn`
	 * is provided, then this provider gets credentials using the
	 * {AWS.STS.assumeRoleWithWebIdentity} service operation, after first getting an
	 * Open ID token from {AWS.CognitoIdentity.getOpenIdToken}.
	 *
	 * In addition, if this credential provider is used to provide authenticated
	 * login, the `Logins` map may be set to the tokens provided by the respective
	 * identity providers. See {constructor} for an example on creating a credentials
	 * object with proper property values.
	 *
	 * ## Refreshing Credentials from Identity Service
	 *
	 * In addition to AWS credentials expiring after a given amount of time, the
	 * login token from the identity provider will also expire. Once this token
	 * expires, it will not be usable to refresh AWS credentials, and another
	 * token will be needed. The SDK does not manage refreshing of the token value,
	 * but this can be done through a "refresh token" supported by most identity
	 * providers. Consult the documentation for the identity provider for refreshing
	 * tokens. Once the refreshed token is acquired, you should make sure to update
	 * this new token in the credentials object's {params} property. The following
	 * code will update the WebIdentityToken, assuming you have retrieved an updated
	 * token from the identity provider:
	 *
	 * ```javascript
	 * AWS.config.credentials.params.Logins['graph.facebook.com'] = updatedToken;
	 * ```
	 *
	 * Future calls to `credentials.refresh()` will now use the new token.
	 *
	 * @!attribute params
	 *   @return [map] the map of params passed to
	 *     {AWS.CognitoIdentity.getId},
	 *     {AWS.CognitoIdentity.getOpenIdToken}, and
	 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
	 *     `params.WebIdentityToken` property.
	 * @!attribute data
	 *   @return [map] the raw data response from the call to
	 *     {AWS.CognitoIdentity.getCredentialsForIdentity}, or
	 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
	 *     access to other properties from the response.
	 * @!attribute identityId
	 *   @return [String] the Cognito ID returned by the last call to
	 *     {AWS.CognitoIdentity.getOpenIdToken}. This ID represents the actual
	 *     final resolved identity ID from Amazon Cognito.
	 */
	AWS.CognitoIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * @api private
	   */
	  localStorageKey: {
	    id: 'aws.cognito.identity-id.',
	    providers: 'aws.cognito.identity-providers.'
	  },
	
	  /**
	   * Creates a new credentials object.
	   * @example Creating a new credentials object
	   *   AWS.config.credentials = new AWS.CognitoIdentityCredentials({
	   *
	   *     // either IdentityPoolId or IdentityId is required
	   *     // See the IdentityPoolId param for AWS.CognitoIdentity.getID (linked below)
	   *     // See the IdentityId param for AWS.CognitoIdentity.getCredentialsForIdentity
	   *     // or AWS.CognitoIdentity.getOpenIdToken (linked below)
	   *     IdentityPoolId: 'us-east-1:1699ebc0-7900-4099-b910-2df94f52a030',
	   *     IdentityId: 'us-east-1:128d0a74-c82f-4553-916d-90053e4a8b0f'
	   *
	   *     // optional, only necessary when the identity pool is not configured
	   *     // to use IAM roles in the Amazon Cognito Console
	   *     // See the RoleArn param for AWS.STS.assumeRoleWithWebIdentity (linked below)
	   *     RoleArn: 'arn:aws:iam::1234567890:role/MYAPP-CognitoIdentity',
	   *
	   *     // optional tokens, used for authenticated login
	   *     // See the Logins param for AWS.CognitoIdentity.getID (linked below)
	   *     Logins: {
	   *       'graph.facebook.com': 'FBTOKEN',
	   *       'www.amazon.com': 'AMAZONTOKEN',
	   *       'accounts.google.com': 'GOOGLETOKEN',
	   *       'api.twitter.com': 'TWITTERTOKEN',
	   *       'www.digits.com': 'DIGITSTOKEN'
	   *     },
	   *
	   *     // optional name, defaults to web-identity
	   *     // See the RoleSessionName param for AWS.STS.assumeRoleWithWebIdentity (linked below)
	   *     RoleSessionName: 'web',
	   *
	   *     // optional, only necessary when application runs in a browser
	   *     // and multiple users are signed in at once, used for caching
	   *     LoginId: 'example@gmail.com'
	   *
	   *   }, {
	   *      // optionally provide configuration to apply to the underlying service clients
	   *      // if configuration is not provided, then configuration will be pulled from AWS.config
	   *
	   *      // region should match the region your identity pool is located in
	   *      region: 'us-east-1',
	   *
	   *      // specify timeout options
	   *      httpOptions: {
	   *        timeout: 100
	   *      }
	   *   });
	   * @see AWS.CognitoIdentity.getId
	   * @see AWS.CognitoIdentity.getCredentialsForIdentity
	   * @see AWS.STS.assumeRoleWithWebIdentity
	   * @see AWS.CognitoIdentity.getOpenIdToken
	   * @see AWS.Config
	   * @note If a region is not provided in the global AWS.config, or
	   *   specified in the `clientConfig` to the CognitoIdentityCredentials
	   *   constructor, you may encounter a 'Missing credentials in config' error
	   *   when calling making a service call.
	   */
	  constructor: function CognitoIdentityCredentials(params, clientConfig) {
	    AWS.Credentials.call(this);
	    this.expired = true;
	    this.params = params;
	    this.data = null;
	    this._identityId = null;
	    this._clientConfig = AWS.util.copy(clientConfig || {});
	    this.loadCachedId();
	    var self = this;
	    Object.defineProperty(this, 'identityId', {
	      get: function() {
	        self.loadCachedId();
	        return self._identityId || self.params.IdentityId;
	      },
	      set: function(identityId) {
	        self._identityId = identityId;
	      }
	    });
	  },
	
	  /**
	   * Refreshes credentials using {AWS.CognitoIdentity.getCredentialsForIdentity},
	   * or {AWS.STS.assumeRoleWithWebIdentity}.
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see AWS.Credentials.get
	   */
	  refresh: function refresh(callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },
	
	  /**
	   * @api private
	   * @param callback
	   */
	  load: function load(callback) {
	    var self = this;
	    self.createClients();
	    self.data = null;
	    self._identityId = null;
	    self.getId(function(err) {
	      if (!err) {
	        if (!self.params.RoleArn) {
	          self.getCredentialsForIdentity(callback);
	        } else {
	          self.getCredentialsFromSTS(callback);
	        }
	      } else {
	        self.clearIdOnNotAuthorized(err);
	        callback(err);
	      }
	    });
	  },
	
	  /**
	   * Clears the cached Cognito ID associated with the currently configured
	   * identity pool ID. Use this to manually invalidate your cache if
	   * the identity pool ID was deleted.
	   */
	  clearCachedId: function clearCache() {
	    this._identityId = null;
	    delete this.params.IdentityId;
	
	    var poolId = this.params.IdentityPoolId;
	    var loginId = this.params.LoginId || '';
	    delete this.storage[this.localStorageKey.id + poolId + loginId];
	    delete this.storage[this.localStorageKey.providers + poolId + loginId];
	  },
	
	  /**
	   * @api private
	   */
	  clearIdOnNotAuthorized: function clearIdOnNotAuthorized(err) {
	    var self = this;
	    if (err.code == 'NotAuthorizedException') {
	      self.clearCachedId();
	    }
	  },
	
	  /**
	   * Retrieves a Cognito ID, loading from cache if it was already retrieved
	   * on this device.
	   *
	   * @callback callback function(err, identityId)
	   *   @param err [Error, null] an error object if the call failed or null if
	   *     it succeeded.
	   *   @param identityId [String, null] if successful, the callback will return
	   *     the Cognito ID.
	   * @note If not loaded explicitly, the Cognito ID is loaded and stored in
	   *   localStorage in the browser environment of a device.
	   * @api private
	   */
	  getId: function getId(callback) {
	    var self = this;
	    if (typeof self.params.IdentityId === 'string') {
	      return callback(null, self.params.IdentityId);
	    }
	
	    self.cognito.getId(function(err, data) {
	      if (!err && data.IdentityId) {
	        self.params.IdentityId = data.IdentityId;
	        callback(null, data.IdentityId);
	      } else {
	        callback(err);
	      }
	    });
	  },
	
	
	  /**
	   * @api private
	   */
	  loadCredentials: function loadCredentials(data, credentials) {
	    if (!data || !credentials) return;
	    credentials.expired = false;
	    credentials.accessKeyId = data.Credentials.AccessKeyId;
	    credentials.secretAccessKey = data.Credentials.SecretKey;
	    credentials.sessionToken = data.Credentials.SessionToken;
	    credentials.expireTime = data.Credentials.Expiration;
	  },
	
	  /**
	   * @api private
	   */
	  getCredentialsForIdentity: function getCredentialsForIdentity(callback) {
	    var self = this;
	    self.cognito.getCredentialsForIdentity(function(err, data) {
	      if (!err) {
	        self.cacheId(data);
	        self.data = data;
	        self.loadCredentials(self.data, self);
	      } else {
	        self.clearIdOnNotAuthorized(err);
	      }
	      callback(err);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  getCredentialsFromSTS: function getCredentialsFromSTS(callback) {
	    var self = this;
	    self.cognito.getOpenIdToken(function(err, data) {
	      if (!err) {
	        self.cacheId(data);
	        self.params.WebIdentityToken = data.Token;
	        self.webIdentityCredentials.refresh(function(webErr) {
	          if (!webErr) {
	            self.data = self.webIdentityCredentials.data;
	            self.sts.credentialsFrom(self.data, self);
	          }
	          callback(webErr);
	        });
	      } else {
	        self.clearIdOnNotAuthorized(err);
	        callback(err);
	      }
	    });
	  },
	
	  /**
	   * @api private
	   */
	  loadCachedId: function loadCachedId() {
	    var self = this;
	
	    // in the browser we source default IdentityId from localStorage
	    if (AWS.util.isBrowser() && !self.params.IdentityId) {
	      var id = self.getStorage('id');
	      if (id && self.params.Logins) {
	        var actualProviders = Object.keys(self.params.Logins);
	        var cachedProviders =
	          (self.getStorage('providers') || '').split(',');
	
	        // only load ID if at least one provider used this ID before
	        var intersect = cachedProviders.filter(function(n) {
	          return actualProviders.indexOf(n) !== -1;
	        });
	        if (intersect.length !== 0) {
	          self.params.IdentityId = id;
	        }
	      } else if (id) {
	        self.params.IdentityId = id;
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  createClients: function() {
	    var clientConfig = this._clientConfig;
	    this.webIdentityCredentials = this.webIdentityCredentials ||
	      new AWS.WebIdentityCredentials(this.params, clientConfig);
	    if (!this.cognito) {
	      var cognitoConfig = AWS.util.merge({}, clientConfig);
	      cognitoConfig.params = this.params;
	      this.cognito = new CognitoIdentity(cognitoConfig);
	    }
	    this.sts = this.sts || new STS(clientConfig);
	  },
	
	  /**
	   * @api private
	   */
	  cacheId: function cacheId(data) {
	    this._identityId = data.IdentityId;
	    this.params.IdentityId = this._identityId;
	
	    // cache this IdentityId in browser localStorage if possible
	    if (AWS.util.isBrowser()) {
	      this.setStorage('id', data.IdentityId);
	
	      if (this.params.Logins) {
	        this.setStorage('providers', Object.keys(this.params.Logins).join(','));
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getStorage: function getStorage(key) {
	    return this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')];
	  },
	
	  /**
	   * @api private
	   */
	  setStorage: function setStorage(key, val) {
	    try {
	      this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')] = val;
	    } catch (_) {}
	  },
	
	  /**
	   * @api private
	   */
	  storage: (function() {
	    try {
	      var storage = AWS.util.isBrowser() && window.localStorage !== null && typeof window.localStorage === 'object' ?
	          window.localStorage : {};
	
	      // Test set/remove which would throw an error in Safari's private browsing
	      storage['aws.test-storage'] = 'foobar';
	      delete storage['aws.test-storage'];
	
	      return storage;
	    } catch (_) {
	      return {};
	    }
	  })()
	});


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Creates a credential provider chain that searches for AWS credentials
	 * in a list of credential providers specified by the {providers} property.
	 *
	 * By default, the chain will use the {defaultProviders} to resolve credentials.
	 * These providers will look in the environment using the
	 * {AWS.EnvironmentCredentials} class with the 'AWS' and 'AMAZON' prefixes.
	 *
	 * ## Setting Providers
	 *
	 * Each provider in the {providers} list should be a function that returns
	 * a {AWS.Credentials} object, or a hardcoded credentials object. The function
	 * form allows for delayed execution of the credential construction.
	 *
	 * ## Resolving Credentials from a Chain
	 *
	 * Call {resolve} to return the first valid credential object that can be
	 * loaded by the provider chain.
	 *
	 * For example, to resolve a chain with a custom provider that checks a file
	 * on disk after the set of {defaultProviders}:
	 *
	 * ```javascript
	 * var diskProvider = new AWS.FileSystemCredentials('./creds.json');
	 * var chain = new AWS.CredentialProviderChain();
	 * chain.providers.push(diskProvider);
	 * chain.resolve();
	 * ```
	 *
	 * The above code will return the `diskProvider` object if the
	 * file contains credentials and the `defaultProviders` do not contain
	 * any credential settings.
	 *
	 * @!attribute providers
	 *   @return [Array<AWS.Credentials, Function>]
	 *     a list of credentials objects or functions that return credentials
	 *     objects. If the provider is a function, the function will be
	 *     executed lazily when the provider needs to be checked for valid
	 *     credentials. By default, this object will be set to the
	 *     {defaultProviders}.
	 *   @see defaultProviders
	 */
	AWS.CredentialProviderChain = AWS.util.inherit(AWS.Credentials, {
	
	  /**
	   * Creates a new CredentialProviderChain with a default set of providers
	   * specified by {defaultProviders}.
	   */
	  constructor: function CredentialProviderChain(providers) {
	    if (providers) {
	      this.providers = providers;
	    } else {
	      this.providers = AWS.CredentialProviderChain.defaultProviders.slice(0);
	    }
	    this.resolveCallbacks = [];
	  },
	
	  /**
	   * @!method  resolvePromise()
	   *   Returns a 'thenable' promise.
	   *   Resolves the provider chain by searching for the first set of
	   *   credentials in {providers}.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function(credentials)
	   *     Called if the promise is fulfilled and the provider resolves the chain
	   *     to a credentials object
	   *     @param credentials [AWS.Credentials] the credentials object resolved
	   *       by the provider chain.
	   *   @callback rejectedCallback function(error)
	   *     Called if the promise is rejected.
	   *     @param err [Error] the error object returned if no credentials are found.
	   *   @return [Promise] A promise that represents the state of the `resolve` method call.
	   *   @example Calling the `resolvePromise` method.
	   *     var promise = chain.resolvePromise();
	   *     promise.then(function(credentials) { ... }, function(err) { ... });
	   */
	
	  /**
	   * Resolves the provider chain by searching for the first set of
	   * credentials in {providers}.
	   *
	   * @callback callback function(err, credentials)
	   *   Called when the provider resolves the chain to a credentials object
	   *   or null if no credentials can be found.
	   *
	   *   @param err [Error] the error object returned if no credentials are
	   *     found.
	   *   @param credentials [AWS.Credentials] the credentials object resolved
	   *     by the provider chain.
	   * @return [AWS.CredentialProviderChain] the provider, for chaining.
	   */
	  resolve: function resolve(callback) {
	    var self = this;
	    if (self.providers.length === 0) {
	      callback(new Error('No providers'));
	      return self;
	    }
	
	    if (self.resolveCallbacks.push(callback) === 1) {
	      var index = 0;
	      var providers = self.providers.slice(0);
	
	      function resolveNext(err, creds) {
	        if ((!err && creds) || index === providers.length) {
	          AWS.util.arrayEach(self.resolveCallbacks, function (callback) {
	            callback(err, creds);
	          });
	          self.resolveCallbacks.length = 0;
	          return;
	        }
	
	        var provider = providers[index++];
	        if (typeof provider === 'function') {
	          creds = provider.call();
	        } else {
	          creds = provider;
	        }
	
	        if (creds.get) {
	          creds.get(function (getErr) {
	            resolveNext(getErr, getErr ? null : creds);
	          });
	        } else {
	          resolveNext(null, creds);
	        }
	      }
	
	      resolveNext();
	    }
	
	    return self;
	  }
	});
	
	/**
	 * The default set of providers used by a vanilla CredentialProviderChain.
	 *
	 * In the browser:
	 *
	 * ```javascript
	 * AWS.CredentialProviderChain.defaultProviders = []
	 * ```
	 *
	 * In Node.js:
	 *
	 * ```javascript
	 * AWS.CredentialProviderChain.defaultProviders = [
	 *   function () { return new AWS.EnvironmentCredentials('AWS'); },
	 *   function () { return new AWS.EnvironmentCredentials('AMAZON'); },
	 *   function () { return new AWS.SharedIniFileCredentials(); },
	 *   function () { return new AWS.ECSCredentials(); },
	 *   function () { return new AWS.ProcessCredentials(); },
	 *   function () { return new AWS.EC2MetadataCredentials() }
	 * ]
	 * ```
	 */
	AWS.CredentialProviderChain.defaultProviders = [];
	
	/**
	 * @api private
	 */
	AWS.CredentialProviderChain.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.resolvePromise = AWS.util.promisifyMethod('resolve', PromiseDependency);
	};
	
	/**
	 * @api private
	 */
	AWS.CredentialProviderChain.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.resolvePromise;
	};
	
	AWS.util.addPromises(AWS.CredentialProviderChain);


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var STS = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Represents credentials retrieved from STS SAML support.
	 *
	 * By default this provider gets credentials using the
	 * {AWS.STS.assumeRoleWithSAML} service operation. This operation
	 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
	 * application for which credentials will be given, as well as a `PrincipalArn`
	 * representing the ARN for the SAML identity provider. In addition, the
	 * `SAMLAssertion` must be set to the token provided by the identity
	 * provider. See {constructor} for an example on creating a credentials
	 * object with proper `RoleArn`, `PrincipalArn`, and `SAMLAssertion` values.
	 *
	 * ## Refreshing Credentials from Identity Service
	 *
	 * In addition to AWS credentials expiring after a given amount of time, the
	 * login token from the identity provider will also expire. Once this token
	 * expires, it will not be usable to refresh AWS credentials, and another
	 * token will be needed. The SDK does not manage refreshing of the token value,
	 * but this can be done through a "refresh token" supported by most identity
	 * providers. Consult the documentation for the identity provider for refreshing
	 * tokens. Once the refreshed token is acquired, you should make sure to update
	 * this new token in the credentials object's {params} property. The following
	 * code will update the SAMLAssertion, assuming you have retrieved an updated
	 * token from the identity provider:
	 *
	 * ```javascript
	 * AWS.config.credentials.params.SAMLAssertion = updatedToken;
	 * ```
	 *
	 * Future calls to `credentials.refresh()` will now use the new token.
	 *
	 * @!attribute params
	 *   @return [map] the map of params passed to
	 *     {AWS.STS.assumeRoleWithSAML}. To update the token, set the
	 *     `params.SAMLAssertion` property.
	 */
	AWS.SAMLCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new credentials object.
	   * @param (see AWS.STS.assumeRoleWithSAML)
	   * @example Creating a new credentials object
	   *   AWS.config.credentials = new AWS.SAMLCredentials({
	   *     RoleArn: 'arn:aws:iam::1234567890:role/SAMLRole',
	   *     PrincipalArn: 'arn:aws:iam::1234567890:role/SAMLPrincipal',
	   *     SAMLAssertion: 'base64-token', // base64-encoded token from IdP
	   *   });
	   * @see AWS.STS.assumeRoleWithSAML
	   */
	  constructor: function SAMLCredentials(params) {
	    AWS.Credentials.call(this);
	    this.expired = true;
	    this.params = params;
	  },
	
	  /**
	   * Refreshes credentials using {AWS.STS.assumeRoleWithSAML}
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see get
	   */
	  refresh: function refresh(callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },
	
	  /**
	   * @api private
	   */
	  load: function load(callback) {
	    var self = this;
	    self.createClients();
	    self.service.assumeRoleWithSAML(function (err, data) {
	      if (!err) {
	        self.service.credentialsFrom(data, self);
	      }
	      callback(err);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  createClients: function() {
	    this.service = this.service || new STS({params: this.params});
	  }
	
	});


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var STS = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Represents temporary credentials retrieved from {AWS.STS}. Without any
	 * extra parameters, credentials will be fetched from the
	 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
	 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
	 * role instead.
	 *
	 * @note AWS.TemporaryCredentials is deprecated, but remains available for
	 *   backwards compatibility. {AWS.ChainableTemporaryCredentials} is the
	 *   preferred class for temporary credentials.
	 *
	 * To setup temporary credentials, configure a set of master credentials
	 * using the standard credentials providers (environment, EC2 instance metadata,
	 * or from the filesystem), then set the global credentials to a new
	 * temporary credentials object:
	 *
	 * ```javascript
	 * // Note that environment credentials are loaded by default,
	 * // the following line is shown for clarity:
	 * AWS.config.credentials = new AWS.EnvironmentCredentials('AWS');
	 *
	 * // Now set temporary credentials seeded from the master credentials
	 * AWS.config.credentials = new AWS.TemporaryCredentials();
	 *
	 * // subsequent requests will now use temporary credentials from AWS STS.
	 * new AWS.S3().listBucket(function(err, data) { ... });
	 * ```
	 *
	 * @!attribute masterCredentials
	 *   @return [AWS.Credentials] the master (non-temporary) credentials used to
	 *     get and refresh temporary credentials from AWS STS.
	 * @note (see constructor)
	 */
	AWS.TemporaryCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new temporary credentials object.
	   *
	   * @note In order to create temporary credentials, you first need to have
	   *   "master" credentials configured in {AWS.Config.credentials}. These
	   *   master credentials are necessary to retrieve the temporary credentials,
	   *   as well as refresh the credentials when they expire.
	   * @param params [map] a map of options that are passed to the
	   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
	   *   If a `RoleArn` parameter is passed in, credentials will be based on the
	   *   IAM role.
	   * @param masterCredentials [AWS.Credentials] the master (non-temporary) credentials
	   *  used to get and refresh temporary credentials from AWS STS.
	   * @example Creating a new credentials object for generic temporary credentials
	   *   AWS.config.credentials = new AWS.TemporaryCredentials();
	   * @example Creating a new credentials object for an IAM role
	   *   AWS.config.credentials = new AWS.TemporaryCredentials({
	   *     RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials',
	   *   });
	   * @see AWS.STS.assumeRole
	   * @see AWS.STS.getSessionToken
	   */
	  constructor: function TemporaryCredentials(params, masterCredentials) {
	    AWS.Credentials.call(this);
	    this.loadMasterCredentials(masterCredentials);
	    this.expired = true;
	
	    this.params = params || {};
	    if (this.params.RoleArn) {
	      this.params.RoleSessionName =
	        this.params.RoleSessionName || 'temporary-credentials';
	    }
	  },
	
	  /**
	   * Refreshes credentials using {AWS.STS.assumeRole} or
	   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
	   * to the credentials {constructor}.
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see get
	   */
	  refresh: function refresh (callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },
	
	  /**
	   * @api private
	   */
	  load: function load (callback) {
	    var self = this;
	    self.createClients();
	    self.masterCredentials.get(function () {
	      self.service.config.credentials = self.masterCredentials;
	      var operation = self.params.RoleArn ?
	        self.service.assumeRole : self.service.getSessionToken;
	      operation.call(self.service, function (err, data) {
	        if (!err) {
	          self.service.credentialsFrom(data, self);
	        }
	        callback(err);
	      });
	    });
	  },
	
	  /**
	   * @api private
	   */
	  loadMasterCredentials: function loadMasterCredentials (masterCredentials) {
	    this.masterCredentials = masterCredentials || AWS.config.credentials;
	    while (this.masterCredentials.masterCredentials) {
	      this.masterCredentials = this.masterCredentials.masterCredentials;
	    }
	
	    if (typeof this.masterCredentials.get !== 'function') {
	      this.masterCredentials = new AWS.Credentials(this.masterCredentials);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  createClients: function () {
	    this.service = this.service || new STS({params: this.params});
	  }
	
	});


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var STS = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Represents credentials retrieved from STS Web Identity Federation support.
	 *
	 * By default this provider gets credentials using the
	 * {AWS.STS.assumeRoleWithWebIdentity} service operation. This operation
	 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
	 * application for which credentials will be given. In addition, the
	 * `WebIdentityToken` must be set to the token provided by the identity
	 * provider. See {constructor} for an example on creating a credentials
	 * object with proper `RoleArn` and `WebIdentityToken` values.
	 *
	 * ## Refreshing Credentials from Identity Service
	 *
	 * In addition to AWS credentials expiring after a given amount of time, the
	 * login token from the identity provider will also expire. Once this token
	 * expires, it will not be usable to refresh AWS credentials, and another
	 * token will be needed. The SDK does not manage refreshing of the token value,
	 * but this can be done through a "refresh token" supported by most identity
	 * providers. Consult the documentation for the identity provider for refreshing
	 * tokens. Once the refreshed token is acquired, you should make sure to update
	 * this new token in the credentials object's {params} property. The following
	 * code will update the WebIdentityToken, assuming you have retrieved an updated
	 * token from the identity provider:
	 *
	 * ```javascript
	 * AWS.config.credentials.params.WebIdentityToken = updatedToken;
	 * ```
	 *
	 * Future calls to `credentials.refresh()` will now use the new token.
	 *
	 * @!attribute params
	 *   @return [map] the map of params passed to
	 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
	 *     `params.WebIdentityToken` property.
	 * @!attribute data
	 *   @return [map] the raw data response from the call to
	 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
	 *     access to other properties from the response.
	 */
	AWS.WebIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new credentials object.
	   * @param (see AWS.STS.assumeRoleWithWebIdentity)
	   * @example Creating a new credentials object
	   *   AWS.config.credentials = new AWS.WebIdentityCredentials({
	   *     RoleArn: 'arn:aws:iam::1234567890:role/WebIdentity',
	   *     WebIdentityToken: 'ABCDEFGHIJKLMNOP', // token from identity service
	   *     RoleSessionName: 'web' // optional name, defaults to web-identity
	   *   }, {
	   *     // optionally provide configuration to apply to the underlying AWS.STS service client
	   *     // if configuration is not provided, then configuration will be pulled from AWS.config
	   *
	   *     // specify timeout options
	   *     httpOptions: {
	   *       timeout: 100
	   *     }
	   *   });
	   * @see AWS.STS.assumeRoleWithWebIdentity
	   * @see AWS.Config
	   */
	  constructor: function WebIdentityCredentials(params, clientConfig) {
	    AWS.Credentials.call(this);
	    this.expired = true;
	    this.params = params;
	    this.params.RoleSessionName = this.params.RoleSessionName || 'web-identity';
	    this.data = null;
	    this._clientConfig = AWS.util.copy(clientConfig || {});
	  },
	
	  /**
	   * Refreshes credentials using {AWS.STS.assumeRoleWithWebIdentity}
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see get
	   */
	  refresh: function refresh(callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },
	
	  /**
	   * @api private
	   */
	  load: function load(callback) {
	    var self = this;
	    self.createClients();
	    self.service.assumeRoleWithWebIdentity(function (err, data) {
	      self.data = null;
	      if (!err) {
	        self.data = data;
	        self.service.credentialsFrom(data, self);
	      }
	      callback(err);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  createClients: function() {
	    if (!this.service) {
	      var stsConfig = AWS.util.merge({}, this._clientConfig);
	      stsConfig.params = this.params;
	      this.service = new STS(stsConfig);
	    }
	  }
	
	});


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var util = __webpack_require__(__webpack_module_template_argument_1__);
	var endpointDiscoveryEnabledEnvs = ['AWS_ENABLE_ENDPOINT_DISCOVERY', 'AWS_ENDPOINT_DISCOVERY_ENABLED'];
	
	/**
	 * Generate key (except resources and operation part) to index the endpoints in the cache
	 * If input shape has endpointdiscoveryid trait then use
	 *   accessKey + operation + resources + region + service as cache key
	 * If input shape doesn't have endpointdiscoveryid trait then use
	 *   accessKey + region + service as cache key
	 * @return [map<String,String>] object with keys to index endpoints.
	 * @api private
	 */
	function getCacheKey(request) {
	  var service = request.service;
	  var api = service.api || {};
	  var operations = api.operations;
	  var identifiers = {};
	  if (service.config.region) {
	    identifiers.region = service.config.region;
	  }
	  if (api.serviceId) {
	    identifiers.serviceId = api.serviceId;
	  }
	  if (service.config.credentials.accessKeyId) {
	    identifiers.accessKeyId = service.config.credentials.accessKeyId;
	  }
	  return identifiers;
	}
	
	/**
	 * Recursive helper for marshallCustomIdentifiers().
	 * Looks for required string input members that have 'endpointdiscoveryid' trait.
	 * @api private
	 */
	function marshallCustomIdentifiersHelper(result, params, shape) {
	  if (!shape || params === undefined || params === null) return;
	  if (shape.type === 'structure' && shape.required && shape.required.length > 0) {
	    util.arrayEach(shape.required, function(name) {
	      var memberShape = shape.members[name];
	      if (memberShape.endpointDiscoveryId === true) {
	        var locationName = memberShape.isLocationName ? memberShape.name : name;
	        result[locationName] = String(params[name]);
	      } else {
	        marshallCustomIdentifiersHelper(result, params[name], memberShape);
	      }
	    });
	  }
	}
	
	/**
	 * Get custom identifiers for cache key.
	 * Identifies custom identifiers by checking each shape's `endpointDiscoveryId` trait.
	 * @param [object] request object
	 * @param [object] input shape of the given operation's api
	 * @api private
	 */
	function marshallCustomIdentifiers(request, shape) {
	  var identifiers = {};
	  marshallCustomIdentifiersHelper(identifiers, request.params, shape);
	  return identifiers;
	}
	
	/**
	 * Call endpoint discovery operation when it's optional.
	 * When endpoint is available in cache then use the cached endpoints. If endpoints
	 * are unavailable then use regional endpoints and call endpoint discovery operation
	 * asynchronously. This is turned off by default.
	 * @param [object] request object
	 * @api private
	 */
	function optionalDiscoverEndpoint(request) {
	  var service = request.service;
	  var api = service.api;
	  var operationModel = api.operations ? api.operations[request.operation] : undefined;
	  var inputShape = operationModel ? operationModel.input : undefined;
	
	  var identifiers = marshallCustomIdentifiers(request, inputShape);
	  var cacheKey = getCacheKey(request);
	  if (Object.keys(identifiers).length > 0) {
	    cacheKey = util.update(cacheKey, identifiers);
	    if (operationModel) cacheKey.operation = operationModel.name;
	  }
	  var endpoints = AWS.endpointCache.get(cacheKey);
	  if (endpoints && endpoints.length === 1 && endpoints[0].Address === '') {
	    //endpoint operation is being made but response not yet received
	    //or endpoint operation just failed in 1 minute
	    return;
	  } else if (endpoints && endpoints.length > 0) {
	    //found endpoint record from cache
	    request.httpRequest.updateEndpoint(endpoints[0].Address);
	  } else {
	    //endpoint record not in cache or outdated. make discovery operation
	    var endpointRequest = service.makeRequest(api.endpointOperation, {
	      Operation: operationModel.name,
	      Identifiers: identifiers,
	    });
	    addApiVersionHeader(endpointRequest);
	    endpointRequest.removeListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	    endpointRequest.removeListener('retry', AWS.EventListeners.Core.RETRY_CHECK);
	    //put in a placeholder for endpoints already requested, prevent
	    //too much in-flight calls
	    AWS.endpointCache.put(cacheKey, [{
	      Address: '',
	      CachePeriodInMinutes: 1
	    }]);
	    endpointRequest.send(function(err, data) {
	      if (data && data.Endpoints) {
	        AWS.endpointCache.put(cacheKey, data.Endpoints);
	      } else if (err) {
	        AWS.endpointCache.put(cacheKey, [{
	          Address: '',
	          CachePeriodInMinutes: 1 //not to make more endpoint operation in next 1 minute
	        }]);
	      }
	    });
	  }
	}
	
	var requestQueue = {};
	
	/**
	 * Call endpoint discovery operation when it's required.
	 * When endpoint is available in cache then use cached ones. If endpoints are
	 * unavailable then SDK should call endpoint operation then use returned new
	 * endpoint for the api call. SDK will automatically attempt to do endpoint
	 * discovery. This is turned off by default
	 * @param [object] request object
	 * @api private
	 */
	function requiredDiscoverEndpoint(request, done) {
	  var service = request.service;
	  var api = service.api;
	  var operationModel = api.operations ? api.operations[request.operation] : undefined;
	  var inputShape = operationModel ? operationModel.input : undefined;
	
	  var identifiers = marshallCustomIdentifiers(request, inputShape);
	  var cacheKey = getCacheKey(request);
	  if (Object.keys(identifiers).length > 0) {
	    cacheKey = util.update(cacheKey, identifiers);
	    if (operationModel) cacheKey.operation = operationModel.name;
	  }
	  var cacheKeyStr = AWS.EndpointCache.getKeyString(cacheKey);
	  var endpoints = AWS.endpointCache.get(cacheKeyStr); //endpoint cache also accepts string keys
	  if (endpoints && endpoints.length === 1 && endpoints[0].Address === '') {
	    //endpoint operation is being made but response not yet received
	    //push request object to a pending queue
	    if (!requestQueue[cacheKeyStr]) requestQueue[cacheKeyStr] = [];
	    requestQueue[cacheKeyStr].push({request: request, callback: done});
	    return;
	  } else if (endpoints && endpoints.length > 0) {
	    request.httpRequest.updateEndpoint(endpoints[0].Address);
	    done();
	  } else {
	    var endpointRequest = service.makeRequest(api.endpointOperation, {
	      Operation: operationModel.name,
	      Identifiers: identifiers,
	    });
	    endpointRequest.removeListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	    addApiVersionHeader(endpointRequest);
	
	    //put in a placeholder for endpoints already requested, prevent
	    //too much in-flight calls
	    AWS.endpointCache.put(cacheKeyStr, [{
	      Address: '',
	      CachePeriodInMinutes: 60 //long-live cache
	    }]);
	    endpointRequest.send(function(err, data) {
	      if (err) {
	        var errorParams = {
	          code: 'EndpointDiscoveryException',
	          message: 'Request cannot be fulfilled without specifying an endpoint',
	          retryable: false
	        };
	        request.response.error = util.error(err, errorParams);
	        AWS.endpointCache.remove(cacheKey);
	
	        //fail all the pending requests in batch
	        if (requestQueue[cacheKeyStr]) {
	          var pendingRequests = requestQueue[cacheKeyStr];
	          util.arrayEach(pendingRequests, function(requestContext) {
	            requestContext.request.response.error = util.error(err, errorParams);
	            requestContext.callback();
	          });
	          delete requestQueue[cacheKeyStr];
	        }
	      } else if (data) {
	        AWS.endpointCache.put(cacheKeyStr, data.Endpoints);
	        request.httpRequest.updateEndpoint(data.Endpoints[0].Address);
	
	        //update the endpoint for all the pending requests in batch
	        if (requestQueue[cacheKeyStr]) {
	          var pendingRequests = requestQueue[cacheKeyStr];
	          util.arrayEach(pendingRequests, function(requestContext) {
	            requestContext.request.httpRequest.updateEndpoint(data.Endpoints[0].Address);
	            requestContext.callback();
	          });
	          delete requestQueue[cacheKeyStr];
	        }
	      }
	      done();
	    });
	  }
	}
	
	/**
	 * add api version header to endpoint operation
	 * @api private
	 */
	function addApiVersionHeader(endpointRequest) {
	  var api = endpointRequest.service.api;
	  var apiVersion = api.apiVersion;
	  if (apiVersion && !endpointRequest.httpRequest.headers['x-amz-api-version']) {
	    endpointRequest.httpRequest.headers['x-amz-api-version'] = apiVersion;
	  }
	}
	
	/**
	 * If api call gets invalid endpoint exception, SDK should attempt to remove the invalid
	 * endpoint from cache.
	 * @api private
	 */
	function invalidateCachedEndpoints(response) {
	  var error = response.error;
	  var httpResponse = response.httpResponse;
	  if (error &&
	    (error.code === 'InvalidEndpointException' || httpResponse.statusCode === 421)
	  ) {
	    var request = response.request;
	    var operations = request.service.api.operations || {};
	    var inputShape = operations[request.operation] ? operations[request.operation].input : undefined;
	    var identifiers = marshallCustomIdentifiers(request, inputShape);
	    var cacheKey = getCacheKey(request);
	    if (Object.keys(identifiers).length > 0) {
	      cacheKey = util.update(cacheKey, identifiers);
	      if (operations[request.operation]) cacheKey.operation = operations[request.operation].name;
	    }
	    AWS.endpointCache.remove(cacheKey);
	  }
	}
	
	/**
	 * If endpoint is explicitly configured, SDK should not do endpoint discovery in anytime.
	 * @param [object] client Service client object.
	 * @api private
	 */
	function hasCustomEndpoint(client) {
	  //if set endpoint is set for specific client, enable endpoint discovery will raise an error.
	  if (client._originalConfig && client._originalConfig.endpoint && client._originalConfig.endpointDiscoveryEnabled === true) {
	    throw util.error(new Error(), {
	      code: 'ConfigurationException',
	      message: 'Custom endpoint is supplied; endpointDiscoveryEnabled must not be true.'
	    });
	  };
	  var svcConfig = AWS.config[client.serviceIdentifier] || {};
	  return Boolean(AWS.config.endpoint || svcConfig.endpoint || (client._originalConfig && client._originalConfig.endpoint));
	}
	
	/**
	 * @api private
	 */
	function isFalsy(value) {
	  return ['false', '0'].indexOf(value) >= 0;
	}
	
	/**
	 * If endpoint discovery should perform for this request when endpoint discovery is optional.
	 * SDK performs config resolution in order like below:
	 * 1. If turned on client configuration(default to off) then turn on endpoint discovery.
	 * 2. If turned on in env AWS_ENABLE_ENDPOINT_DISCOVERY then turn on endpoint discovery.
	 * 3. If turned on in shared ini config file with key 'endpoint_discovery_enabled', then
	 *   turn on endpoint discovery.
	 * @param [object] request request object.
	 * @api private
	 */
	function isEndpointDiscoveryApplicable(request) {
	  var service = request.service || {};
	  if (service.config.endpointDiscoveryEnabled === true) return true;
	
	  //shared ini file is only available in Node
	  //not to check env in browser
	  if (util.isBrowser()) return false;
	
	  for (var i = 0; i < endpointDiscoveryEnabledEnvs.length; i++) {
	    var env = endpointDiscoveryEnabledEnvs[i];
	    if (Object.prototype.hasOwnProperty.call(({"NODE_ENV":"production","PUBLIC_URL":""}), env)) {
	      if (({"NODE_ENV":"production","PUBLIC_URL":""})[env] === '' || ({"NODE_ENV":"production","PUBLIC_URL":""})[env] === undefined) {
	        throw util.error(new Error(), {
	          code: 'ConfigurationException',
	          message: 'environmental variable ' + env + ' cannot be set to nothing'
	        });
	      }
	      if (!isFalsy(({"NODE_ENV":"production","PUBLIC_URL":""})[env])) return true;
	    }
	  }
	
	  var configFile = {};
	  try {
	    configFile = AWS.util.iniLoader ? AWS.util.iniLoader.loadFrom({
	      isConfig: true,
	      filename: ({"NODE_ENV":"production","PUBLIC_URL":""})[AWS.util.sharedConfigFileEnv]
	    }) : {};
	  } catch (e) {}
	  var sharedFileConfig = configFile[
	    ({"NODE_ENV":"production","PUBLIC_URL":""}).AWS_PROFILE || AWS.util.defaultProfile
	  ] || {};
	  if (Object.prototype.hasOwnProperty.call(sharedFileConfig, 'endpoint_discovery_enabled')) {
	    if (sharedFileConfig.endpoint_discovery_enabled === undefined) {
	      throw util.error(new Error(), {
	        code: 'ConfigurationException',
	        message: 'config file entry \'endpoint_discovery_enabled\' cannot be set to nothing'
	      });
	    }
	    if (!isFalsy(sharedFileConfig.endpoint_discovery_enabled)) return true;
	  }
	  return false;
	}
	
	/**
	 * attach endpoint discovery logic to request object
	 * @param [object] request
	 * @api private
	 */
	function discoverEndpoint(request, done) {
	  var service = request.service || {};
	  if (hasCustomEndpoint(service) || request.isPresigned()) return done();
	
	  if (!isEndpointDiscoveryApplicable(request)) return done();
	
	  request.httpRequest.appendToUserAgent('endpoint-discovery');
	
	  var operations = service.api.operations || {};
	  var operationModel = operations[request.operation];
	  var isEndpointDiscoveryRequired = operationModel ? operationModel.endpointDiscoveryRequired : 'NULL';
	  switch (isEndpointDiscoveryRequired) {
	    case 'OPTIONAL':
	      optionalDiscoverEndpoint(request);
	      request.addNamedListener('INVALIDATE_CACHED_ENDPOINTS', 'extractError', invalidateCachedEndpoints);
	      done();
	      break;
	    case 'REQUIRED':
	      request.addNamedListener('INVALIDATE_CACHED_ENDPOINTS', 'extractError', invalidateCachedEndpoints);
	      requiredDiscoverEndpoint(request, done);
	      break;
	    case 'NULL':
	    default:
	      done();
	      break;
	  }
	}
	
	module.exports = {
	  discoverEndpoint: discoverEndpoint,
	  requiredDiscoverEndpoint: requiredDiscoverEndpoint,
	  optionalDiscoverEndpoint: optionalDiscoverEndpoint,
	  marshallCustomIdentifiers: marshallCustomIdentifiers,
	  getCacheKey: getCacheKey,
	  invalidateCachedEndpoint: invalidateCachedEndpoints,
	};


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var eventMessageChunker = __webpack_require__(__webpack_module_template_argument_0__).eventMessageChunker;
	var parseEvent = __webpack_require__(__webpack_module_template_argument_1__).parseEvent;
	
	function createEventStream(body, parser, model) {
	    var eventMessages = eventMessageChunker(body);
	
	    var events = [];
	
	    for (var i = 0; i < eventMessages.length; i++) {
	        events.push(parseEvent(parser, eventMessages[i], model));
	    }
	
	    return events;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    createEventStream: createEventStream
	};


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var util = __webpack_require__(__webpack_module_template_argument_0__).util;
	var toBuffer = util.buffer.toBuffer;
	
	/**
	 * A lossless representation of a signed, 64-bit integer. Instances of this
	 * class may be used in arithmetic expressions as if they were numeric
	 * primitives, but the binary representation will be preserved unchanged as the
	 * `bytes` property of the object. The bytes should be encoded as big-endian,
	 * two's complement integers.
	 * @param {Buffer} bytes
	 *
	 * @api private
	 */
	function Int64(bytes) {
	    if (bytes.length !== 8) {
	        throw new Error('Int64 buffers must be exactly 8 bytes');
	    }
	    if (!util.Buffer.isBuffer(bytes)) bytes = toBuffer(bytes);
	
	    this.bytes = bytes;
	}
	
	/**
	 * @param {number} number
	 * @returns {Int64}
	 *
	 * @api private
	 */
	Int64.fromNumber = function(number) {
	    if (number > 9223372036854775807 || number < -9223372036854775808) {
	        throw new Error(
	            number + ' is too large (or, if negative, too small) to represent as an Int64'
	        );
	    }
	
	    var bytes = new Uint8Array(8);
	    for (
	        var i = 7, remaining = Math.abs(Math.round(number));
	        i > -1 && remaining > 0;
	        i--, remaining /= 256
	    ) {
	        bytes[i] = remaining;
	    }
	
	    if (number < 0) {
	        negate(bytes);
	    }
	
	    return new Int64(bytes);
	};
	
	/**
	 * @returns {number}
	 *
	 * @api private
	 */
	Int64.prototype.valueOf = function() {
	    var bytes = this.bytes.slice(0);
	    var negative = bytes[0] & 128;
	    if (negative) {
	        negate(bytes);
	    }
	
	    return parseInt(bytes.toString('hex'), 16) * (negative ? -1 : 1);
	};
	
	Int64.prototype.toString = function() {
	    return String(this.valueOf());
	};
	
	/**
	 * @param {Buffer} bytes
	 *
	 * @api private
	 */
	function negate(bytes) {
	    for (var i = 0; i < 8; i++) {
	        bytes[i] ^= 0xFF;
	    }
	    for (var i = 7; i > -1; i--) {
	        bytes[i]++;
	        if (bytes[i] !== 0) {
	            break;
	        }
	    }
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    Int64: Int64
	};


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var parseMessage = __webpack_require__(__webpack_module_template_argument_0__).parseMessage;
	
	/**
	 *
	 * @param {*} parser
	 * @param {Buffer} message
	 * @param {*} shape
	 * @api private
	 */
	function parseEvent(parser, message, shape) {
	    var parsedMessage = parseMessage(message);
	
	    // check if message is an event or error
	    var messageType = parsedMessage.headers[':message-type'];
	    if (messageType) {
	        if (messageType.value === 'error') {
	            throw parseError(parsedMessage);
	        } else if (messageType.value !== 'event') {
	            // not sure how to parse non-events/non-errors, ignore for now
	            return;
	        }
	    }
	
	    // determine event type
	    var eventType = parsedMessage.headers[':event-type'];
	    // check that the event type is modeled
	    var eventModel = shape.members[eventType.value];
	    if (!eventModel) {
	        return;
	    }
	
	    var result = {};
	    // check if an event payload exists
	    var eventPayloadMemberName = eventModel.eventPayloadMemberName;
	    if (eventPayloadMemberName) {
	        var payloadShape = eventModel.members[eventPayloadMemberName];
	        // if the shape is binary, return the byte array
	        if (payloadShape.type === 'binary') {
	            result[eventPayloadMemberName] = parsedMessage.body;
	        } else {
	            result[eventPayloadMemberName] = parser.parse(parsedMessage.body.toString(), payloadShape);
	        }
	    }
	
	    // read event headers
	    var eventHeaderNames = eventModel.eventHeaderMemberNames;
	    for (var i = 0; i < eventHeaderNames.length; i++) {
	        var name = eventHeaderNames[i];
	        if (parsedMessage.headers[name]) {
	            // parse the header!
	            result[name] = eventModel.members[name].toType(parsedMessage.headers[name].value);
	        }
	    }
	
	    var output = {};
	    output[eventType.value] = result;
	    return output;
	}
	
	function parseError(message) {
	    var errorCode = message.headers[':error-code'];
	    var errorMessage = message.headers[':error-message'];
	    var error = new Error(errorMessage.value || errorMessage);
	    error.code = error.name = errorCode.value || errorCode;
	    return error;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    parseEvent: parseEvent
	};


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var Int64 = __webpack_require__(__webpack_module_template_argument_0__).Int64;
	
	var splitMessage = __webpack_require__(__webpack_module_template_argument_1__).splitMessage;
	
	var BOOLEAN_TAG = 'boolean';
	var BYTE_TAG = 'byte';
	var SHORT_TAG = 'short';
	var INT_TAG = 'integer';
	var LONG_TAG = 'long';
	var BINARY_TAG = 'binary';
	var STRING_TAG = 'string';
	var TIMESTAMP_TAG = 'timestamp';
	var UUID_TAG = 'uuid';
	
	/**
	 * @api private
	 *
	 * @param {Buffer} headers
	 */
	function parseHeaders(headers) {
	    var out = {};
	    var position = 0;
	    while (position < headers.length) {
	        var nameLength = headers.readUInt8(position++);
	        var name = headers.slice(position, position + nameLength).toString();
	        position += nameLength;
	        switch (headers.readUInt8(position++)) {
	            case 0 /* boolTrue */:
	                out[name] = {
	                    type: BOOLEAN_TAG,
	                    value: true
	                };
	                break;
	            case 1 /* boolFalse */:
	                out[name] = {
	                    type: BOOLEAN_TAG,
	                    value: false
	                };
	                break;
	            case 2 /* byte */:
	                out[name] = {
	                    type: BYTE_TAG,
	                    value: headers.readInt8(position++)
	                };
	                break;
	            case 3 /* short */:
	                out[name] = {
	                    type: SHORT_TAG,
	                    value: headers.readInt16BE(position)
	                };
	                position += 2;
	                break;
	            case 4 /* integer */:
	                out[name] = {
	                    type: INT_TAG,
	                    value: headers.readInt32BE(position)
	                };
	                position += 4;
	                break;
	            case 5 /* long */:
	                out[name] = {
	                    type: LONG_TAG,
	                    value: new Int64(headers.slice(position, position + 8))
	                };
	                position += 8;
	                break;
	            case 6 /* byteArray */:
	                var binaryLength = headers.readUInt16BE(position);
	                position += 2;
	                out[name] = {
	                    type: BINARY_TAG,
	                    value: headers.slice(position, position + binaryLength)
	                };
	                position += binaryLength;
	                break;
	            case 7 /* string */:
	                var stringLength = headers.readUInt16BE(position);
	                position += 2;
	                out[name] = {
	                    type: STRING_TAG,
	                    value: headers.slice(
	                        position,
	                        position + stringLength
	                    ).toString()
	                };
	                position += stringLength;
	                break;
	            case 8 /* timestamp */:
	                out[name] = {
	                    type: TIMESTAMP_TAG,
	                    value: new Date(
	                        new Int64(headers.slice(position, position + 8))
	                            .valueOf()
	                    )
	                };
	                position += 8;
	                break;
	            case 9 /* uuid */:
	                var uuidChars = headers.slice(position, position + 16)
	                    .toString('hex');
	                position += 16;
	                out[name] = {
	                    type: UUID_TAG,
	                    value: uuidChars.substr(0, 8) + '-' +
	                        uuidChars.substr(8, 4) + '-' +
	                        uuidChars.substr(12, 4) + '-' +
	                        uuidChars.substr(16, 4) + '-' +
	                        uuidChars.substr(20)
	                };
	                break;
	            default:
	                throw new Error('Unrecognized header type tag');
	        }
	    }
	    return out;
	}
	
	function parseMessage(message) {
	    var parsed = splitMessage(message);
	    return { headers: parseHeaders(parsed.headers), body: parsed.body };
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    parseMessage: parseMessage
	};


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var util = __webpack_require__(__webpack_module_template_argument_0__).util;
	var toBuffer = util.buffer.toBuffer;
	
	// All prelude components are unsigned, 32-bit integers
	var PRELUDE_MEMBER_LENGTH = 4;
	// The prelude consists of two components
	var PRELUDE_LENGTH = PRELUDE_MEMBER_LENGTH * 2;
	// Checksums are always CRC32 hashes.
	var CHECKSUM_LENGTH = 4;
	// Messages must include a full prelude, a prelude checksum, and a message checksum
	var MINIMUM_MESSAGE_LENGTH = PRELUDE_LENGTH + CHECKSUM_LENGTH * 2;
	
	/**
	 * @api private
	 *
	 * @param {Buffer} message
	 */
	function splitMessage(message) {
	    if (!util.Buffer.isBuffer(message)) message = toBuffer(message);
	
	    if (message.length < MINIMUM_MESSAGE_LENGTH) {
	        throw new Error('Provided message too short to accommodate event stream message overhead');
	    }
	
	    if (message.length !== message.readUInt32BE(0)) {
	        throw new Error('Reported message length does not match received message length');
	    }
	
	    var expectedPreludeChecksum = message.readUInt32BE(PRELUDE_LENGTH);
	
	    if (
	        expectedPreludeChecksum !== util.crypto.crc32(
	            message.slice(0, PRELUDE_LENGTH)
	        )
	    ) {
	        throw new Error(
	            'The prelude checksum specified in the message (' +
	            expectedPreludeChecksum +
	            ') does not match the calculated CRC32 checksum.'
	        );
	    }
	
	    var expectedMessageChecksum = message.readUInt32BE(message.length - CHECKSUM_LENGTH);
	
	    if (
	        expectedMessageChecksum !== util.crypto.crc32(
	            message.slice(0, message.length - CHECKSUM_LENGTH)
	        )
	    ) {
	        throw new Error(
	            'The message checksum did not match the expected value of ' +
	                expectedMessageChecksum
	        );
	    }
	
	    var headersStart = PRELUDE_LENGTH + CHECKSUM_LENGTH;
	    var headersEnd = headersStart + message.readUInt32BE(PRELUDE_MEMBER_LENGTH);
	
	    return {
	        headers: message.slice(headersStart, headersEnd),
	        body: message.slice(headersEnd, message.length - CHECKSUM_LENGTH),
	    };
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    splitMessage: splitMessage
	};


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var SequentialExecutor = __webpack_require__(__webpack_module_template_argument_1__);
	var DISCOVER_ENDPOINT = __webpack_require__(__webpack_module_template_argument_2__).discoverEndpoint;
	/**
	 * The namespace used to register global event listeners for request building
	 * and sending.
	 */
	AWS.EventListeners = {
	  /**
	   * @!attribute VALIDATE_CREDENTIALS
	   *   A request listener that validates whether the request is being
	   *   sent with credentials.
	   *   Handles the {AWS.Request~validate 'validate' Request event}
	   *   @example Sending a request without validating credentials
	   *     var listener = AWS.EventListeners.Core.VALIDATE_CREDENTIALS;
	   *     request.removeListener('validate', listener);
	   *   @readonly
	   *   @return [Function]
	   * @!attribute VALIDATE_REGION
	   *   A request listener that validates whether the region is set
	   *   for a request.
	   *   Handles the {AWS.Request~validate 'validate' Request event}
	   *   @example Sending a request without validating region configuration
	   *     var listener = AWS.EventListeners.Core.VALIDATE_REGION;
	   *     request.removeListener('validate', listener);
	   *   @readonly
	   *   @return [Function]
	   * @!attribute VALIDATE_PARAMETERS
	   *   A request listener that validates input parameters in a request.
	   *   Handles the {AWS.Request~validate 'validate' Request event}
	   *   @example Sending a request without validating parameters
	   *     var listener = AWS.EventListeners.Core.VALIDATE_PARAMETERS;
	   *     request.removeListener('validate', listener);
	   *   @example Disable parameter validation globally
	   *     AWS.EventListeners.Core.removeListener('validate',
	   *       AWS.EventListeners.Core.VALIDATE_REGION);
	   *   @readonly
	   *   @return [Function]
	   * @!attribute SEND
	   *   A request listener that initiates the HTTP connection for a
	   *   request being sent. Handles the {AWS.Request~send 'send' Request event}
	   *   @example Replacing the HTTP handler
	   *     var listener = AWS.EventListeners.Core.SEND;
	   *     request.removeListener('send', listener);
	   *     request.on('send', function(response) {
	   *       customHandler.send(response);
	   *     });
	   *   @return [Function]
	   *   @readonly
	   * @!attribute HTTP_DATA
	   *   A request listener that reads data from the HTTP connection in order
	   *   to build the response data.
	   *   Handles the {AWS.Request~httpData 'httpData' Request event}.
	   *   Remove this handler if you are overriding the 'httpData' event and
	   *   do not want extra data processing and buffering overhead.
	   *   @example Disabling default data processing
	   *     var listener = AWS.EventListeners.Core.HTTP_DATA;
	   *     request.removeListener('httpData', listener);
	   *   @return [Function]
	   *   @readonly
	   */
	  Core: {} /* doc hack */
	};
	
	/**
	 * @api private
	 */
	function getOperationAuthtype(req) {
	  if (!req.service.api.operations) {
	    return '';
	  }
	  var operation = req.service.api.operations[req.operation];
	  return operation ? operation.authtype : '';
	}
	
	AWS.EventListeners = {
	  Core: new SequentialExecutor().addNamedListeners(function(add, addAsync) {
	    addAsync('VALIDATE_CREDENTIALS', 'validate',
	        function VALIDATE_CREDENTIALS(req, done) {
	      if (!req.service.api.signatureVersion) return done(); // none
	      req.service.config.getCredentials(function(err) {
	        if (err) {
	          req.response.error = AWS.util.error(err,
	            {code: 'CredentialsError', message: 'Missing credentials in config'});
	        }
	        done();
	      });
	    });
	
	    add('VALIDATE_REGION', 'validate', function VALIDATE_REGION(req) {
	      if (!req.service.config.region && !req.service.isGlobalEndpoint) {
	        req.response.error = AWS.util.error(new Error(),
	          {code: 'ConfigError', message: 'Missing region in config'});
	      }
	    });
	
	    add('BUILD_IDEMPOTENCY_TOKENS', 'validate', function BUILD_IDEMPOTENCY_TOKENS(req) {
	      if (!req.service.api.operations) {
	        return;
	      }
	      var operation = req.service.api.operations[req.operation];
	      if (!operation) {
	        return;
	      }
	      var idempotentMembers = operation.idempotentMembers;
	      if (!idempotentMembers.length) {
	        return;
	      }
	      // creates a copy of params so user's param object isn't mutated
	      var params = AWS.util.copy(req.params);
	      for (var i = 0, iLen = idempotentMembers.length; i < iLen; i++) {
	        if (!params[idempotentMembers[i]]) {
	          // add the member
	          params[idempotentMembers[i]] = AWS.util.uuid.v4();
	        }
	      }
	      req.params = params;
	    });
	
	    add('VALIDATE_PARAMETERS', 'validate', function VALIDATE_PARAMETERS(req) {
	      if (!req.service.api.operations) {
	        return;
	      }
	      var rules = req.service.api.operations[req.operation].input;
	      var validation = req.service.config.paramValidation;
	      new AWS.ParamValidator(validation).validate(rules, req.params);
	    });
	
	    addAsync('COMPUTE_SHA256', 'afterBuild', function COMPUTE_SHA256(req, done) {
	      req.haltHandlersOnError();
	      if (!req.service.api.operations) {
	        return;
	      }
	      var operation = req.service.api.operations[req.operation];
	      var authtype = operation ? operation.authtype : '';
	      if (!req.service.api.signatureVersion && !authtype) return done(); // none
	      if (req.service.getSignerClass(req) === AWS.Signers.V4) {
	        var body = req.httpRequest.body || '';
	        if (authtype.indexOf('unsigned-body') >= 0) {
	          req.httpRequest.headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
	          return done();
	        }
	        AWS.util.computeSha256(body, function(err, sha) {
	          if (err) {
	            done(err);
	          }
	          else {
	            req.httpRequest.headers['X-Amz-Content-Sha256'] = sha;
	            done();
	          }
	        });
	      } else {
	        done();
	      }
	    });
	
	    add('SET_CONTENT_LENGTH', 'afterBuild', function SET_CONTENT_LENGTH(req) {
	      var authtype = getOperationAuthtype(req);
	      var payloadMember = AWS.util.getRequestPayloadShape(req);
	      if (req.httpRequest.headers['Content-Length'] === undefined) {
	        try {
	          var length = AWS.util.string.byteLength(req.httpRequest.body);
	          req.httpRequest.headers['Content-Length'] = length;
	        } catch (err) {
	          if (payloadMember && payloadMember.isStreaming) {
	            if (payloadMember.requiresLength) {
	              //streaming payload requires length(s3, glacier)
	              throw err;
	            } else if (authtype.indexOf('unsigned-body') >= 0) {
	              //unbounded streaming payload(lex, mediastore)
	              req.httpRequest.headers['Transfer-Encoding'] = 'chunked';
	              return;
	            } else {
	              throw err;
	            }
	          }
	          throw err;
	        }
	      }
	    });
	
	    add('SET_HTTP_HOST', 'afterBuild', function SET_HTTP_HOST(req) {
	      req.httpRequest.headers['Host'] = req.httpRequest.endpoint.host;
	    });
	
	    add('RESTART', 'restart', function RESTART() {
	      var err = this.response.error;
	      if (!err || !err.retryable) return;
	
	      this.httpRequest = new AWS.HttpRequest(
	        this.service.endpoint,
	        this.service.region
	      );
	
	      if (this.response.retryCount < this.service.config.maxRetries) {
	        this.response.retryCount++;
	      } else {
	        this.response.error = null;
	      }
	    });
	
	    var addToHead = true;
	    addAsync('DISCOVER_ENDPOINT', 'sign', DISCOVER_ENDPOINT, addToHead);
	
	    addAsync('SIGN', 'sign', function SIGN(req, done) {
	      var service = req.service;
	      var operations = req.service.api.operations || {};
	      var operation = operations[req.operation];
	      var authtype = operation ? operation.authtype : '';
	      if (!service.api.signatureVersion && !authtype) return done(); // none
	
	      service.config.getCredentials(function (err, credentials) {
	        if (err) {
	          req.response.error = err;
	          return done();
	        }
	
	        try {
	          var date = service.getSkewCorrectedDate();
	          var SignerClass = service.getSignerClass(req);
	          var signer = new SignerClass(req.httpRequest,
	            service.api.signingName || service.api.endpointPrefix,
	            {
	              signatureCache: service.config.signatureCache,
	              operation: operation,
	              signatureVersion: service.api.signatureVersion
	            });
	          signer.setServiceClientId(service._clientId);
	
	          // clear old authorization headers
	          delete req.httpRequest.headers['Authorization'];
	          delete req.httpRequest.headers['Date'];
	          delete req.httpRequest.headers['X-Amz-Date'];
	
	          // add new authorization
	          signer.addAuthorization(credentials, date);
	          req.signedAt = date;
	        } catch (e) {
	          req.response.error = e;
	        }
	        done();
	      });
	    });
	
	    add('VALIDATE_RESPONSE', 'validateResponse', function VALIDATE_RESPONSE(resp) {
	      if (this.service.successfulResponse(resp, this)) {
	        resp.data = {};
	        resp.error = null;
	      } else {
	        resp.data = null;
	        resp.error = AWS.util.error(new Error(),
	          {code: 'UnknownError', message: 'An unknown error occurred.'});
	      }
	    });
	
	    addAsync('SEND', 'send', function SEND(resp, done) {
	      resp.httpResponse._abortCallback = done;
	      resp.error = null;
	      resp.data = null;
	
	      function callback(httpResp) {
	        resp.httpResponse.stream = httpResp;
	        var stream = resp.request.httpRequest.stream;
	        var service = resp.request.service;
	        var api = service.api;
	        var operationName = resp.request.operation;
	        var operation = api.operations[operationName] || {};
	
	        httpResp.on('headers', function onHeaders(statusCode, headers, statusMessage) {
	          resp.request.emit(
	            'httpHeaders',
	            [statusCode, headers, resp, statusMessage]
	          );
	
	          if (!resp.httpResponse.streaming) {
	            if (AWS.HttpClient.streamsApiVersion === 2) { // streams2 API check
	              // if we detect event streams, we're going to have to
	              // return the stream immediately
	              if (operation.hasEventOutput && service.successfulResponse(resp)) {
	                // skip reading the IncomingStream
	                resp.request.emit('httpDone');
	                done();
	                return;
	              }
	
	              httpResp.on('readable', function onReadable() {
	                var data = httpResp.read();
	                if (data !== null) {
	                  resp.request.emit('httpData', [data, resp]);
	                }
	              });
	            } else { // legacy streams API
	              httpResp.on('data', function onData(data) {
	                resp.request.emit('httpData', [data, resp]);
	              });
	            }
	          }
	        });
	
	        httpResp.on('end', function onEnd() {
	          if (!stream || !stream.didCallback) {
	            if (AWS.HttpClient.streamsApiVersion === 2 && (operation.hasEventOutput && service.successfulResponse(resp))) {
	              // don't concatenate response chunks when streaming event stream data when response is successful
	              return;
	            }
	            resp.request.emit('httpDone');
	            done();
	          }
	        });
	      }
	
	      function progress(httpResp) {
	        httpResp.on('sendProgress', function onSendProgress(value) {
	          resp.request.emit('httpUploadProgress', [value, resp]);
	        });
	
	        httpResp.on('receiveProgress', function onReceiveProgress(value) {
	          resp.request.emit('httpDownloadProgress', [value, resp]);
	        });
	      }
	
	      function error(err) {
	        if (err.code !== 'RequestAbortedError') {
	          var errCode = err.code === 'TimeoutError' ? err.code : 'NetworkingError';
	          err = AWS.util.error(err, {
	            code: errCode,
	            region: resp.request.httpRequest.region,
	            hostname: resp.request.httpRequest.endpoint.hostname,
	            retryable: true
	          });
	        }
	        resp.error = err;
	        resp.request.emit('httpError', [resp.error, resp], function() {
	          done();
	        });
	      }
	
	      function executeSend() {
	        var http = AWS.HttpClient.getInstance();
	        var httpOptions = resp.request.service.config.httpOptions || {};
	        try {
	          var stream = http.handleRequest(resp.request.httpRequest, httpOptions,
	                                          callback, error);
	          progress(stream);
	        } catch (err) {
	          error(err);
	        }
	      }
	      var timeDiff = (resp.request.service.getSkewCorrectedDate() - this.signedAt) / 1000;
	      if (timeDiff >= 60 * 10) { // if we signed 10min ago, re-sign
	        this.emit('sign', [this], function(err) {
	          if (err) done(err);
	          else executeSend();
	        });
	      } else {
	        executeSend();
	      }
	    });
	
	    add('HTTP_HEADERS', 'httpHeaders',
	        function HTTP_HEADERS(statusCode, headers, resp, statusMessage) {
	      resp.httpResponse.statusCode = statusCode;
	      resp.httpResponse.statusMessage = statusMessage;
	      resp.httpResponse.headers = headers;
	      resp.httpResponse.body = AWS.util.buffer.toBuffer('');
	      resp.httpResponse.buffers = [];
	      resp.httpResponse.numBytes = 0;
	      var dateHeader = headers.date || headers.Date;
	      var service = resp.request.service;
	      if (dateHeader) {
	        var serverTime = Date.parse(dateHeader);
	        if (service.config.correctClockSkew
	            && service.isClockSkewed(serverTime)) {
	          service.applyClockOffset(serverTime);
	        }
	      }
	    });
	
	    add('HTTP_DATA', 'httpData', function HTTP_DATA(chunk, resp) {
	      if (chunk) {
	        if (AWS.util.isNode()) {
	          resp.httpResponse.numBytes += chunk.length;
	
	          var total = resp.httpResponse.headers['content-length'];
	          var progress = { loaded: resp.httpResponse.numBytes, total: total };
	          resp.request.emit('httpDownloadProgress', [progress, resp]);
	        }
	
	        resp.httpResponse.buffers.push(AWS.util.buffer.toBuffer(chunk));
	      }
	    });
	
	    add('HTTP_DONE', 'httpDone', function HTTP_DONE(resp) {
	      // convert buffers array into single buffer
	      if (resp.httpResponse.buffers && resp.httpResponse.buffers.length > 0) {
	        var body = AWS.util.buffer.concat(resp.httpResponse.buffers);
	        resp.httpResponse.body = body;
	      }
	      delete resp.httpResponse.numBytes;
	      delete resp.httpResponse.buffers;
	    });
	
	    add('FINALIZE_ERROR', 'retry', function FINALIZE_ERROR(resp) {
	      if (resp.httpResponse.statusCode) {
	        resp.error.statusCode = resp.httpResponse.statusCode;
	        if (resp.error.retryable === undefined) {
	          resp.error.retryable = this.service.retryableError(resp.error, this);
	        }
	      }
	    });
	
	    add('INVALIDATE_CREDENTIALS', 'retry', function INVALIDATE_CREDENTIALS(resp) {
	      if (!resp.error) return;
	      switch (resp.error.code) {
	        case 'RequestExpired': // EC2 only
	        case 'ExpiredTokenException':
	        case 'ExpiredToken':
	          resp.error.retryable = true;
	          resp.request.service.config.credentials.expired = true;
	      }
	    });
	
	    add('EXPIRED_SIGNATURE', 'retry', function EXPIRED_SIGNATURE(resp) {
	      var err = resp.error;
	      if (!err) return;
	      if (typeof err.code === 'string' && typeof err.message === 'string') {
	        if (err.code.match(/Signature/) && err.message.match(/expired/)) {
	          resp.error.retryable = true;
	        }
	      }
	    });
	
	    add('CLOCK_SKEWED', 'retry', function CLOCK_SKEWED(resp) {
	      if (!resp.error) return;
	      if (this.service.clockSkewError(resp.error)
	          && this.service.config.correctClockSkew) {
	        resp.error.retryable = true;
	      }
	    });
	
	    add('REDIRECT', 'retry', function REDIRECT(resp) {
	      if (resp.error && resp.error.statusCode >= 300 &&
	          resp.error.statusCode < 400 && resp.httpResponse.headers['location']) {
	        this.httpRequest.endpoint =
	          new AWS.Endpoint(resp.httpResponse.headers['location']);
	        this.httpRequest.headers['Host'] = this.httpRequest.endpoint.host;
	        resp.error.redirect = true;
	        resp.error.retryable = true;
	      }
	    });
	
	    add('RETRY_CHECK', 'retry', function RETRY_CHECK(resp) {
	      if (resp.error) {
	        if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
	          resp.error.retryDelay = 0;
	        } else if (resp.retryCount < resp.maxRetries) {
	          resp.error.retryDelay = this.service.retryDelays(resp.retryCount) || 0;
	        }
	      }
	    });
	
	    addAsync('RESET_RETRY_STATE', 'afterRetry', function RESET_RETRY_STATE(resp, done) {
	      var delay, willRetry = false;
	
	      if (resp.error) {
	        delay = resp.error.retryDelay || 0;
	        if (resp.error.retryable && resp.retryCount < resp.maxRetries) {
	          resp.retryCount++;
	          willRetry = true;
	        } else if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
	          resp.redirectCount++;
	          willRetry = true;
	        }
	      }
	
	      if (willRetry) {
	        resp.error = null;
	        setTimeout(done, delay);
	      } else {
	        done();
	      }
	    });
	  }),
	
	  CorePost: new SequentialExecutor().addNamedListeners(function(add) {
	    add('EXTRACT_REQUEST_ID', 'extractData', AWS.util.extractRequestId);
	    add('EXTRACT_REQUEST_ID', 'extractError', AWS.util.extractRequestId);
	
	    add('ENOTFOUND_ERROR', 'httpError', function ENOTFOUND_ERROR(err) {
	      if (err.code === 'NetworkingError' && err.errno === 'ENOTFOUND') {
	        var message = 'Inaccessible host: `' + err.hostname +
	          '\'. This service may not be available in the `' + err.region +
	          '\' region.';
	        this.response.error = AWS.util.error(new Error(message), {
	          code: 'UnknownEndpoint',
	          region: err.region,
	          hostname: err.hostname,
	          retryable: true,
	          originalError: err
	        });
	      }
	    });
	  }),
	
	  Logger: new SequentialExecutor().addNamedListeners(function(add) {
	    add('LOG_REQUEST', 'complete', function LOG_REQUEST(resp) {
	      var req = resp.request;
	      var logger = req.service.config.logger;
	      if (!logger) return;
	      function filterSensitiveLog(inputShape, shape) {
	        if (!shape) {
	          return shape;
	        }
	        switch (inputShape.type) {
	          case 'structure':
	            var struct = {};
	            AWS.util.each(shape, function(subShapeName, subShape) {
	              if (Object.prototype.hasOwnProperty.call(inputShape.members, subShapeName)) {
	                struct[subShapeName] = filterSensitiveLog(inputShape.members[subShapeName], subShape);
	              } else {
	                struct[subShapeName] = subShape;
	              }
	            });
	            return struct;
	          case 'list':
	            var list = [];
	            AWS.util.arrayEach(shape, function(subShape, index) {
	              list.push(filterSensitiveLog(inputShape.member, subShape));
	            });
	            return list;
	          case 'map':
	            var map = {};
	            AWS.util.each(shape, function(key, value) {
	              map[key] = filterSensitiveLog(inputShape.value, value);
	            });
	            return map;
	          default:
	            if (inputShape.isSensitive) {
	              return '***SensitiveInformation***';
	            } else {
	              return shape;
	            }
	        }
	      }
	
	      function buildMessage() {
	        var time = resp.request.service.getSkewCorrectedDate().getTime();
	        var delta = (time - req.startTime.getTime()) / 1000;
	        var ansi = logger.isTTY ? true : false;
	        var status = resp.httpResponse.statusCode;
	        var censoredParams = req.params;
	        if (
	          req.service.api.operations &&
	              req.service.api.operations[req.operation] &&
	              req.service.api.operations[req.operation].input
	        ) {
	          var inputShape = req.service.api.operations[req.operation].input;
	          censoredParams = filterSensitiveLog(inputShape, req.params);
	        }
	        var params = __webpack_require__(271).inspect(censoredParams, true, null);
	        var message = '';
	        if (ansi) message += '\x1B[33m';
	        message += '[AWS ' + req.service.serviceIdentifier + ' ' + status;
	        message += ' ' + delta.toString() + 's ' + resp.retryCount + ' retries]';
	        if (ansi) message += '\x1B[0;1m';
	        message += ' ' + AWS.util.string.lowerFirst(req.operation);
	        message += '(' + params + ')';
	        if (ansi) message += '\x1B[0m';
	        return message;
	      }
	
	      var line = buildMessage();
	      if (typeof logger.log === 'function') {
	        logger.log(line);
	      } else if (typeof logger.write === 'function') {
	        logger.write(line + '\n');
	      }
	    });
	  }),
	
	  Json: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = __webpack_require__(__webpack_module_template_argument_3__);
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  }),
	
	  Rest: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = __webpack_require__(__webpack_module_template_argument_4__);
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  }),
	
	  RestJson: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = __webpack_require__(__webpack_module_template_argument_5__);
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  }),
	
	  RestXml: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = __webpack_require__(__webpack_module_template_argument_6__);
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  }),
	
	  Query: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = __webpack_require__(__webpack_module_template_argument_7__);
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  })
	};


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var inherit = AWS.util.inherit;
	
	/**
	 * The endpoint that a service will talk to, for example,
	 * `'https://ec2.ap-southeast-1.amazonaws.com'`. If
	 * you need to override an endpoint for a service, you can
	 * set the endpoint on a service by passing the endpoint
	 * object with the `endpoint` option key:
	 *
	 * ```javascript
	 * var ep = new AWS.Endpoint('awsproxy.example.com');
	 * var s3 = new AWS.S3({endpoint: ep});
	 * s3.service.endpoint.hostname == 'awsproxy.example.com'
	 * ```
	 *
	 * Note that if you do not specify a protocol, the protocol will
	 * be selected based on your current {AWS.config} configuration.
	 *
	 * @!attribute protocol
	 *   @return [String] the protocol (http or https) of the endpoint
	 *     URL
	 * @!attribute hostname
	 *   @return [String] the host portion of the endpoint, e.g.,
	 *     example.com
	 * @!attribute host
	 *   @return [String] the host portion of the endpoint including
	 *     the port, e.g., example.com:80
	 * @!attribute port
	 *   @return [Integer] the port of the endpoint
	 * @!attribute href
	 *   @return [String] the full URL of the endpoint
	 */
	AWS.Endpoint = inherit({
	
	  /**
	   * @overload Endpoint(endpoint)
	   *   Constructs a new endpoint given an endpoint URL. If the
	   *   URL omits a protocol (http or https), the default protocol
	   *   set in the global {AWS.config} will be used.
	   *   @param endpoint [String] the URL to construct an endpoint from
	   */
	  constructor: function Endpoint(endpoint, config) {
	    AWS.util.hideProperties(this, ['slashes', 'auth', 'hash', 'search', 'query']);
	
	    if (typeof endpoint === 'undefined' || endpoint === null) {
	      throw new Error('Invalid endpoint: ' + endpoint);
	    } else if (typeof endpoint !== 'string') {
	      return AWS.util.copy(endpoint);
	    }
	
	    if (!endpoint.match(/^http/)) {
	      var useSSL = config && config.sslEnabled !== undefined ?
	        config.sslEnabled : AWS.config.sslEnabled;
	      endpoint = (useSSL ? 'https' : 'http') + '://' + endpoint;
	    }
	
	    AWS.util.update(this, AWS.util.urlParse(endpoint));
	
	    // Ensure the port property is set as an integer
	    if (this.port) {
	      this.port = parseInt(this.port, 10);
	    } else {
	      this.port = this.protocol === 'https:' ? 443 : 80;
	    }
	  }
	
	});
	
	/**
	 * The low level HTTP request object, encapsulating all HTTP header
	 * and body data sent by a service request.
	 *
	 * @!attribute method
	 *   @return [String] the HTTP method of the request
	 * @!attribute path
	 *   @return [String] the path portion of the URI, e.g.,
	 *     "/list/?start=5&num=10"
	 * @!attribute headers
	 *   @return [map<String,String>]
	 *     a map of header keys and their respective values
	 * @!attribute body
	 *   @return [String] the request body payload
	 * @!attribute endpoint
	 *   @return [AWS.Endpoint] the endpoint for the request
	 * @!attribute region
	 *   @api private
	 *   @return [String] the region, for signing purposes only.
	 */
	AWS.HttpRequest = inherit({
	
	  /**
	   * @api private
	   */
	  constructor: function HttpRequest(endpoint, region) {
	    endpoint = new AWS.Endpoint(endpoint);
	    this.method = 'POST';
	    this.path = endpoint.path || '/';
	    this.headers = {};
	    this.body = '';
	    this.endpoint = endpoint;
	    this.region = region;
	    this._userAgent = '';
	    this.setUserAgent();
	  },
	
	  /**
	   * @api private
	   */
	  setUserAgent: function setUserAgent() {
	    this._userAgent = this.headers[this.getUserAgentHeaderName()] = AWS.util.userAgent();
	  },
	
	  getUserAgentHeaderName: function getUserAgentHeaderName() {
	    var prefix = AWS.util.isBrowser() ? 'X-Amz-' : '';
	    return prefix + 'User-Agent';
	  },
	
	  /**
	   * @api private
	   */
	  appendToUserAgent: function appendToUserAgent(agentPartial) {
	    if (typeof agentPartial === 'string' && agentPartial) {
	      this._userAgent += ' ' + agentPartial;
	    }
	    this.headers[this.getUserAgentHeaderName()] = this._userAgent;
	  },
	
	  /**
	   * @api private
	   */
	  getUserAgent: function getUserAgent() {
	    return this._userAgent;
	  },
	
	  /**
	   * @return [String] the part of the {path} excluding the
	   *   query string
	   */
	  pathname: function pathname() {
	    return this.path.split('?', 1)[0];
	  },
	
	  /**
	   * @return [String] the query string portion of the {path}
	   */
	  search: function search() {
	    var query = this.path.split('?', 2)[1];
	    if (query) {
	      query = AWS.util.queryStringParse(query);
	      return AWS.util.queryParamsToString(query);
	    }
	    return '';
	  },
	
	  /**
	   * @api private
	   * update httpRequest endpoint with endpoint string
	   */
	  updateEndpoint: function updateEndpoint(endpointStr) {
	    var newEndpoint = new AWS.Endpoint(endpointStr);
	    this.endpoint = newEndpoint;
	    this.path = newEndpoint.path || '/';
	  }
	});
	
	/**
	 * The low level HTTP response object, encapsulating all HTTP header
	 * and body data returned from the request.
	 *
	 * @!attribute statusCode
	 *   @return [Integer] the HTTP status code of the response (e.g., 200, 404)
	 * @!attribute headers
	 *   @return [map<String,String>]
	 *      a map of response header keys and their respective values
	 * @!attribute body
	 *   @return [String] the response body payload
	 * @!attribute [r] streaming
	 *   @return [Boolean] whether this response is being streamed at a low-level.
	 *     Defaults to `false` (buffered reads). Do not modify this manually, use
	 *     {createUnbufferedStream} to convert the stream to unbuffered mode
	 *     instead.
	 */
	AWS.HttpResponse = inherit({
	
	  /**
	   * @api private
	   */
	  constructor: function HttpResponse() {
	    this.statusCode = undefined;
	    this.headers = {};
	    this.body = undefined;
	    this.streaming = false;
	    this.stream = null;
	  },
	
	  /**
	   * Disables buffering on the HTTP response and returns the stream for reading.
	   * @return [Stream, XMLHttpRequest, null] the underlying stream object.
	   *   Use this object to directly read data off of the stream.
	   * @note This object is only available after the {AWS.Request~httpHeaders}
	   *   event has fired. This method must be called prior to
	   *   {AWS.Request~httpData}.
	   * @example Taking control of a stream
	   *   request.on('httpHeaders', function(statusCode, headers) {
	   *     if (statusCode < 300) {
	   *       if (headers.etag === 'xyz') {
	   *         // pipe the stream, disabling buffering
	   *         var stream = this.response.httpResponse.createUnbufferedStream();
	   *         stream.pipe(process.stdout);
	   *       } else { // abort this request and set a better error message
	   *         this.abort();
	   *         this.response.error = new Error('Invalid ETag');
	   *       }
	   *     }
	   *   }).send(console.log);
	   */
	  createUnbufferedStream: function createUnbufferedStream() {
	    this.streaming = true;
	    return this.stream;
	  }
	});
	
	
	AWS.HttpClient = inherit({});
	
	/**
	 * @api private
	 */
	AWS.HttpClient.getInstance = function getInstance() {
	  if (this.singleton === undefined) {
	    this.singleton = new this();
	  }
	  return this.singleton;
	};


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var EventEmitter = __webpack_require__(184).EventEmitter;
	__webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * @api private
	 */
	AWS.XHRClient = AWS.util.inherit({
	  handleRequest: function handleRequest(httpRequest, httpOptions, callback, errCallback) {
	    var self = this;
	    var endpoint = httpRequest.endpoint;
	    var emitter = new EventEmitter();
	    var href = endpoint.protocol + '//' + endpoint.hostname;
	    if (endpoint.port !== 80 && endpoint.port !== 443) {
	      href += ':' + endpoint.port;
	    }
	    href += httpRequest.path;
	
	    var xhr = new XMLHttpRequest(), headersEmitted = false;
	    httpRequest.stream = xhr;
	
	    xhr.addEventListener('readystatechange', function() {
	      try {
	        if (xhr.status === 0) return; // 0 code is invalid
	      } catch (e) { return; }
	
	      if (this.readyState >= this.HEADERS_RECEIVED && !headersEmitted) {
	        emitter.statusCode = xhr.status;
	        emitter.headers = self.parseHeaders(xhr.getAllResponseHeaders());
	        emitter.emit(
	          'headers',
	          emitter.statusCode,
	          emitter.headers,
	          xhr.statusText
	        );
	        headersEmitted = true;
	      }
	      if (this.readyState === this.DONE) {
	        self.finishRequest(xhr, emitter);
	      }
	    }, false);
	    xhr.upload.addEventListener('progress', function (evt) {
	      emitter.emit('sendProgress', evt);
	    });
	    xhr.addEventListener('progress', function (evt) {
	      emitter.emit('receiveProgress', evt);
	    }, false);
	    xhr.addEventListener('timeout', function () {
	      errCallback(AWS.util.error(new Error('Timeout'), {code: 'TimeoutError'}));
	    }, false);
	    xhr.addEventListener('error', function () {
	      errCallback(AWS.util.error(new Error('Network Failure'), {
	        code: 'NetworkingError'
	      }));
	    }, false);
	    xhr.addEventListener('abort', function () {
	      errCallback(AWS.util.error(new Error('Request aborted'), {
	        code: 'RequestAbortedError'
	      }));
	    }, false);
	
	    callback(emitter);
	    xhr.open(httpRequest.method, href, httpOptions.xhrAsync !== false);
	    AWS.util.each(httpRequest.headers, function (key, value) {
	      if (key !== 'Content-Length' && key !== 'User-Agent' && key !== 'Host') {
	        xhr.setRequestHeader(key, value);
	      }
	    });
	
	    if (httpOptions.timeout && httpOptions.xhrAsync !== false) {
	      xhr.timeout = httpOptions.timeout;
	    }
	
	    if (httpOptions.xhrWithCredentials) {
	      xhr.withCredentials = true;
	    }
	    try { xhr.responseType = 'arraybuffer'; } catch (e) {}
	
	    try {
	      if (httpRequest.body) {
	        xhr.send(httpRequest.body);
	      } else {
	        xhr.send();
	      }
	    } catch (err) {
	      if (httpRequest.body && typeof httpRequest.body.buffer === 'object') {
	        xhr.send(httpRequest.body.buffer); // send ArrayBuffer directly
	      } else {
	        throw err;
	      }
	    }
	
	    return emitter;
	  },
	
	  parseHeaders: function parseHeaders(rawHeaders) {
	    var headers = {};
	    AWS.util.arrayEach(rawHeaders.split(/\r?\n/), function (line) {
	      var key = line.split(':', 1)[0];
	      var value = line.substring(key.length + 2);
	      if (key.length > 0) headers[key.toLowerCase()] = value;
	    });
	    return headers;
	  },
	
	  finishRequest: function finishRequest(xhr, emitter) {
	    var buffer;
	    if (xhr.responseType === 'arraybuffer' && xhr.response) {
	      var ab = xhr.response;
	      buffer = new AWS.util.Buffer(ab.byteLength);
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < buffer.length; ++i) {
	        buffer[i] = view[i];
	      }
	    }
	
	    try {
	      if (!buffer && typeof xhr.responseText === 'string') {
	        buffer = new AWS.util.Buffer(xhr.responseText);
	      }
	    } catch (e) {}
	
	    if (buffer) emitter.emit('data', buffer);
	    emitter.emit('end');
	  }
	});
	
	/**
	 * @api private
	 */
	AWS.HttpClient.prototype = AWS.XHRClient.prototype;
	
	/**
	 * @api private
	 */
	AWS.HttpClient.streamsApiVersion = 1;


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var util = __webpack_require__(__webpack_module_template_argument_0__);
	
	function JsonBuilder() { }
	
	JsonBuilder.prototype.build = function(value, shape) {
	  return JSON.stringify(translate(value, shape));
	};
	
	function translate(value, shape) {
	  if (!shape || value === undefined || value === null) return undefined;
	
	  switch (shape.type) {
	    case 'structure': return translateStructure(value, shape);
	    case 'map': return translateMap(value, shape);
	    case 'list': return translateList(value, shape);
	    default: return translateScalar(value, shape);
	  }
	}
	
	function translateStructure(structure, shape) {
	  var struct = {};
	  util.each(structure, function(name, value) {
	    var memberShape = shape.members[name];
	    if (memberShape) {
	      if (memberShape.location !== 'body') return;
	      var locationName = memberShape.isLocationName ? memberShape.name : name;
	      var result = translate(value, memberShape);
	      if (result !== undefined) struct[locationName] = result;
	    }
	  });
	  return struct;
	}
	
	function translateList(list, shape) {
	  var out = [];
	  util.arrayEach(list, function(value) {
	    var result = translate(value, shape.member);
	    if (result !== undefined) out.push(result);
	  });
	  return out;
	}
	
	function translateMap(map, shape) {
	  var out = {};
	  util.each(map, function(key, value) {
	    var result = translate(value, shape.value);
	    if (result !== undefined) out[key] = result;
	  });
	  return out;
	}
	
	function translateScalar(value, shape) {
	  return shape.toWireFormat(value);
	}
	
	/**
	 * @api private
	 */
	module.exports = JsonBuilder;


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var util = __webpack_require__(__webpack_module_template_argument_0__);
	
	function JsonParser() { }
	
	JsonParser.prototype.parse = function(value, shape) {
	  return translate(JSON.parse(value), shape);
	};
	
	function translate(value, shape) {
	  if (!shape || value === undefined) return undefined;
	
	  switch (shape.type) {
	    case 'structure': return translateStructure(value, shape);
	    case 'map': return translateMap(value, shape);
	    case 'list': return translateList(value, shape);
	    default: return translateScalar(value, shape);
	  }
	}
	
	function translateStructure(structure, shape) {
	  if (structure == null) return undefined;
	
	  var struct = {};
	  var shapeMembers = shape.members;
	  util.each(shapeMembers, function(name, memberShape) {
	    var locationName = memberShape.isLocationName ? memberShape.name : name;
	    if (Object.prototype.hasOwnProperty.call(structure, locationName)) {
	      var value = structure[locationName];
	      var result = translate(value, memberShape);
	      if (result !== undefined) struct[name] = result;
	    }
	  });
	  return struct;
	}
	
	function translateList(list, shape) {
	  if (list == null) return undefined;
	
	  var out = [];
	  util.arrayEach(list, function(value) {
	    var result = translate(value, shape.member);
	    if (result === undefined) out.push(null);
	    else out.push(result);
	  });
	  return out;
	}
	
	function translateMap(map, shape) {
	  if (map == null) return undefined;
	
	  var out = {};
	  util.each(map, function(key, value) {
	    var result = translate(value, shape.value);
	    if (result === undefined) out[key] = null;
	    else out[key] = result;
	  });
	  return out;
	}
	
	function translateScalar(value, shape) {
	  return shape.toType(value);
	}
	
	/**
	 * @api private
	 */
	module.exports = JsonParser;


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var Collection = __webpack_require__(__webpack_module_template_argument_0__);
	var Operation = __webpack_require__(__webpack_module_template_argument_1__);
	var Shape = __webpack_require__(__webpack_module_template_argument_2__);
	var Paginator = __webpack_require__(__webpack_module_template_argument_3__);
	var ResourceWaiter = __webpack_require__(__webpack_module_template_argument_4__);
	
	var util = __webpack_require__(__webpack_module_template_argument_5__);
	var property = util.property;
	var memoizedProperty = util.memoizedProperty;
	
	function Api(api, options) {
	  var self = this;
	  api = api || {};
	  options = options || {};
	  options.api = this;
	
	  api.metadata = api.metadata || {};
	
	  property(this, 'isApi', true, false);
	  property(this, 'apiVersion', api.metadata.apiVersion);
	  property(this, 'endpointPrefix', api.metadata.endpointPrefix);
	  property(this, 'signingName', api.metadata.signingName);
	  property(this, 'globalEndpoint', api.metadata.globalEndpoint);
	  property(this, 'signatureVersion', api.metadata.signatureVersion);
	  property(this, 'jsonVersion', api.metadata.jsonVersion);
	  property(this, 'targetPrefix', api.metadata.targetPrefix);
	  property(this, 'protocol', api.metadata.protocol);
	  property(this, 'timestampFormat', api.metadata.timestampFormat);
	  property(this, 'xmlNamespaceUri', api.metadata.xmlNamespace);
	  property(this, 'abbreviation', api.metadata.serviceAbbreviation);
	  property(this, 'fullName', api.metadata.serviceFullName);
	  property(this, 'serviceId', api.metadata.serviceId);
	
	  memoizedProperty(this, 'className', function() {
	    var name = api.metadata.serviceAbbreviation || api.metadata.serviceFullName;
	    if (!name) return null;
	
	    name = name.replace(/^Amazon|AWS\s*|\(.*|\s+|\W+/g, '');
	    if (name === 'ElasticLoadBalancing') name = 'ELB';
	    return name;
	  });
	
	  function addEndpointOperation(name, operation) {
	    if (operation.endpointoperation === true) {
	      property(self, 'endpointOperation', util.string.lowerFirst(name));
	    }
	  }
	
	  property(this, 'operations', new Collection(api.operations, options, function(name, operation) {
	    return new Operation(name, operation, options);
	  }, util.string.lowerFirst, addEndpointOperation));
	
	  property(this, 'shapes', new Collection(api.shapes, options, function(name, shape) {
	    return Shape.create(shape, options);
	  }));
	
	  property(this, 'paginators', new Collection(api.paginators, options, function(name, paginator) {
	    return new Paginator(name, paginator, options);
	  }));
	
	  property(this, 'waiters', new Collection(api.waiters, options, function(name, waiter) {
	    return new ResourceWaiter(name, waiter, options);
	  }, util.string.lowerFirst));
	
	  if (options.documentation) {
	    property(this, 'documentation', api.documentation);
	    property(this, 'documentationUrl', api.documentationUrl);
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = Api;


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var memoizedProperty = __webpack_require__(__webpack_module_template_argument_0__).memoizedProperty;
	
	function memoize(name, value, factory, nameTr) {
	  memoizedProperty(this, nameTr(name), function() {
	    return factory(name, value);
	  });
	}
	
	function Collection(iterable, options, factory, nameTr, callback) {
	  nameTr = nameTr || String;
	  var self = this;
	
	  for (var id in iterable) {
	    if (Object.prototype.hasOwnProperty.call(iterable, id)) {
	      memoize.call(self, id, iterable[id], factory, nameTr);
	      if (callback) callback(id, iterable[id]);
	    }
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = Collection;


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var Shape = __webpack_require__(__webpack_module_template_argument_0__);
	
	var util = __webpack_require__(__webpack_module_template_argument_1__);
	var property = util.property;
	var memoizedProperty = util.memoizedProperty;
	
	function Operation(name, operation, options) {
	  var self = this;
	  options = options || {};
	
	  property(this, 'name', operation.name || name);
	  property(this, 'api', options.api, false);
	
	  operation.http = operation.http || {};
	  property(this, 'endpoint', operation.endpoint);
	  property(this, 'httpMethod', operation.http.method || 'POST');
	  property(this, 'httpPath', operation.http.requestUri || '/');
	  property(this, 'authtype', operation.authtype || '');
	  property(
	    this,
	    'endpointDiscoveryRequired',
	    operation.endpointdiscovery ?
	      (operation.endpointdiscovery.required ? 'REQUIRED' : 'OPTIONAL') :
	    'NULL'
	  );
	
	  memoizedProperty(this, 'input', function() {
	    if (!operation.input) {
	      return new Shape.create({type: 'structure'}, options);
	    }
	    return Shape.create(operation.input, options);
	  });
	
	  memoizedProperty(this, 'output', function() {
	    if (!operation.output) {
	      return new Shape.create({type: 'structure'}, options);
	    }
	    return Shape.create(operation.output, options);
	  });
	
	  memoizedProperty(this, 'errors', function() {
	    var list = [];
	    if (!operation.errors) return null;
	
	    for (var i = 0; i < operation.errors.length; i++) {
	      list.push(Shape.create(operation.errors[i], options));
	    }
	
	    return list;
	  });
	
	  memoizedProperty(this, 'paginator', function() {
	    return options.api.paginators[name];
	  });
	
	  if (options.documentation) {
	    property(this, 'documentation', operation.documentation);
	    property(this, 'documentationUrl', operation.documentationUrl);
	  }
	
	  // idempotentMembers only tracks top-level input shapes
	  memoizedProperty(this, 'idempotentMembers', function() {
	    var idempotentMembers = [];
	    var input = self.input;
	    var members = input.members;
	    if (!input.members) {
	      return idempotentMembers;
	    }
	    for (var name in members) {
	      if (!members.hasOwnProperty(name)) {
	        continue;
	      }
	      if (members[name].isIdempotent === true) {
	        idempotentMembers.push(name);
	      }
	    }
	    return idempotentMembers;
	  });
	
	  memoizedProperty(this, 'hasEventOutput', function() {
	    var output = self.output;
	    return hasEventStream(output);
	  });
	}
	
	function hasEventStream(topLevelShape) {
	  var members = topLevelShape.members;
	  var payload = topLevelShape.payload;
	
	  if (!topLevelShape.members) {
	    return false;
	  }
	
	  if (payload) {
	    var payloadMember = members[payload];
	    return payloadMember.isEventStream;
	  }
	
	  // check if any member is an event stream
	  for (var name in members) {
	    if (!members.hasOwnProperty(name)) {
	      if (members[name].isEventStream === true) {
	        return true;
	      }
	    }
	  }
	  return false;
	}
	
	/**
	 * @api private
	 */
	module.exports = Operation;


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var property = __webpack_require__(__webpack_module_template_argument_0__).property;
	
	function Paginator(name, paginator) {
	  property(this, 'inputToken', paginator.input_token);
	  property(this, 'limitKey', paginator.limit_key);
	  property(this, 'moreResults', paginator.more_results);
	  property(this, 'outputToken', paginator.output_token);
	  property(this, 'resultKey', paginator.result_key);
	}
	
	/**
	 * @api private
	 */
	module.exports = Paginator;


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var util = __webpack_require__(__webpack_module_template_argument_0__);
	var property = util.property;
	
	function ResourceWaiter(name, waiter, options) {
	  options = options || {};
	  property(this, 'name', name);
	  property(this, 'api', options.api, false);
	
	  if (waiter.operation) {
	    property(this, 'operation', util.string.lowerFirst(waiter.operation));
	  }
	
	  var self = this;
	  var keys = [
	    'type',
	    'description',
	    'delay',
	    'maxAttempts',
	    'acceptors'
	  ];
	
	  keys.forEach(function(key) {
	    var value = waiter[key];
	    if (value) {
	      property(self, key, value);
	    }
	  });
	}
	
	/**
	 * @api private
	 */
	module.exports = ResourceWaiter;


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var Collection = __webpack_require__(__webpack_module_template_argument_0__);
	
	var util = __webpack_require__(__webpack_module_template_argument_1__);
	
	function property(obj, name, value) {
	  if (value !== null && value !== undefined) {
	    util.property.apply(this, arguments);
	  }
	}
	
	function memoizedProperty(obj, name) {
	  if (!obj.constructor.prototype[name]) {
	    util.memoizedProperty.apply(this, arguments);
	  }
	}
	
	function Shape(shape, options, memberName) {
	  options = options || {};
	
	  property(this, 'shape', shape.shape);
	  property(this, 'api', options.api, false);
	  property(this, 'type', shape.type);
	  property(this, 'enum', shape.enum);
	  property(this, 'min', shape.min);
	  property(this, 'max', shape.max);
	  property(this, 'pattern', shape.pattern);
	  property(this, 'location', shape.location || this.location || 'body');
	  property(this, 'name', this.name || shape.xmlName || shape.queryName ||
	    shape.locationName || memberName);
	  property(this, 'isStreaming', shape.streaming || this.isStreaming || false);
	  property(this, 'requiresLength', shape.requiresLength, false);
	  property(this, 'isComposite', shape.isComposite || false);
	  property(this, 'isShape', true, false);
	  property(this, 'isQueryName', Boolean(shape.queryName), false);
	  property(this, 'isLocationName', Boolean(shape.locationName), false);
	  property(this, 'isIdempotent', shape.idempotencyToken === true);
	  property(this, 'isJsonValue', shape.jsonvalue === true);
	  property(this, 'isSensitive', shape.sensitive === true || shape.prototype && shape.prototype.sensitive === true);
	  property(this, 'isEventStream', Boolean(shape.eventstream), false);
	  property(this, 'isEvent', Boolean(shape.event), false);
	  property(this, 'isEventPayload', Boolean(shape.eventpayload), false);
	  property(this, 'isEventHeader', Boolean(shape.eventheader), false);
	  property(this, 'isTimestampFormatSet', Boolean(shape.timestampFormat) || shape.prototype && shape.prototype.isTimestampFormatSet === true, false);
	  property(this, 'endpointDiscoveryId', Boolean(shape.endpointdiscoveryid), false);
	  property(this, 'hostLabel', Boolean(shape.hostLabel), false);
	
	  if (options.documentation) {
	    property(this, 'documentation', shape.documentation);
	    property(this, 'documentationUrl', shape.documentationUrl);
	  }
	
	  if (shape.xmlAttribute) {
	    property(this, 'isXmlAttribute', shape.xmlAttribute || false);
	  }
	
	  // type conversion and parsing
	  property(this, 'defaultValue', null);
	  this.toWireFormat = function(value) {
	    if (value === null || value === undefined) return '';
	    return value;
	  };
	  this.toType = function(value) { return value; };
	}
	
	/**
	 * @api private
	 */
	Shape.normalizedTypes = {
	  character: 'string',
	  double: 'float',
	  long: 'integer',
	  short: 'integer',
	  biginteger: 'integer',
	  bigdecimal: 'float',
	  blob: 'binary'
	};
	
	/**
	 * @api private
	 */
	Shape.types = {
	  'structure': StructureShape,
	  'list': ListShape,
	  'map': MapShape,
	  'boolean': BooleanShape,
	  'timestamp': TimestampShape,
	  'float': FloatShape,
	  'integer': IntegerShape,
	  'string': StringShape,
	  'base64': Base64Shape,
	  'binary': BinaryShape
	};
	
	Shape.resolve = function resolve(shape, options) {
	  if (shape.shape) {
	    var refShape = options.api.shapes[shape.shape];
	    if (!refShape) {
	      throw new Error('Cannot find shape reference: ' + shape.shape);
	    }
	
	    return refShape;
	  } else {
	    return null;
	  }
	};
	
	Shape.create = function create(shape, options, memberName) {
	  if (shape.isShape) return shape;
	
	  var refShape = Shape.resolve(shape, options);
	  if (refShape) {
	    var filteredKeys = Object.keys(shape);
	    if (!options.documentation) {
	      filteredKeys = filteredKeys.filter(function(name) {
	        return !name.match(/documentation/);
	      });
	    }
	
	    // create an inline shape with extra members
	    var InlineShape = function() {
	      refShape.constructor.call(this, shape, options, memberName);
	    };
	    InlineShape.prototype = refShape;
	    return new InlineShape();
	  } else {
	    // set type if not set
	    if (!shape.type) {
	      if (shape.members) shape.type = 'structure';
	      else if (shape.member) shape.type = 'list';
	      else if (shape.key) shape.type = 'map';
	      else shape.type = 'string';
	    }
	
	    // normalize types
	    var origType = shape.type;
	    if (Shape.normalizedTypes[shape.type]) {
	      shape.type = Shape.normalizedTypes[shape.type];
	    }
	
	    if (Shape.types[shape.type]) {
	      return new Shape.types[shape.type](shape, options, memberName);
	    } else {
	      throw new Error('Unrecognized shape type: ' + origType);
	    }
	  }
	};
	
	function CompositeShape(shape) {
	  Shape.apply(this, arguments);
	  property(this, 'isComposite', true);
	
	  if (shape.flattened) {
	    property(this, 'flattened', shape.flattened || false);
	  }
	}
	
	function StructureShape(shape, options) {
	  var self = this;
	  var requiredMap = null, firstInit = !this.isShape;
	
	  CompositeShape.apply(this, arguments);
	
	  if (firstInit) {
	    property(this, 'defaultValue', function() { return {}; });
	    property(this, 'members', {});
	    property(this, 'memberNames', []);
	    property(this, 'required', []);
	    property(this, 'isRequired', function() { return false; });
	  }
	
	  if (shape.members) {
	    property(this, 'members', new Collection(shape.members, options, function(name, member) {
	      return Shape.create(member, options, name);
	    }));
	    memoizedProperty(this, 'memberNames', function() {
	      return shape.xmlOrder || Object.keys(shape.members);
	    });
	
	    if (shape.event) {
	      memoizedProperty(this, 'eventPayloadMemberName', function() {
	        var members = self.members;
	        var memberNames = self.memberNames;
	        // iterate over members to find ones that are event payloads
	        for (var i = 0, iLen = memberNames.length; i < iLen; i++) {
	          if (members[memberNames[i]].isEventPayload) {
	            return memberNames[i];
	          }
	        }
	      });
	
	      memoizedProperty(this, 'eventHeaderMemberNames', function() {
	        var members = self.members;
	        var memberNames = self.memberNames;
	        var eventHeaderMemberNames = [];
	        // iterate over members to find ones that are event headers
	        for (var i = 0, iLen = memberNames.length; i < iLen; i++) {
	          if (members[memberNames[i]].isEventHeader) {
	            eventHeaderMemberNames.push(memberNames[i]);
	          }
	        }
	        return eventHeaderMemberNames;
	      });
	    }
	  }
	
	  if (shape.required) {
	    property(this, 'required', shape.required);
	    property(this, 'isRequired', function(name) {
	      if (!requiredMap) {
	        requiredMap = {};
	        for (var i = 0; i < shape.required.length; i++) {
	          requiredMap[shape.required[i]] = true;
	        }
	      }
	
	      return requiredMap[name];
	    }, false, true);
	  }
	
	  property(this, 'resultWrapper', shape.resultWrapper || null);
	
	  if (shape.payload) {
	    property(this, 'payload', shape.payload);
	  }
	
	  if (typeof shape.xmlNamespace === 'string') {
	    property(this, 'xmlNamespaceUri', shape.xmlNamespace);
	  } else if (typeof shape.xmlNamespace === 'object') {
	    property(this, 'xmlNamespacePrefix', shape.xmlNamespace.prefix);
	    property(this, 'xmlNamespaceUri', shape.xmlNamespace.uri);
	  }
	}
	
	function ListShape(shape, options) {
	  var self = this, firstInit = !this.isShape;
	  CompositeShape.apply(this, arguments);
	
	  if (firstInit) {
	    property(this, 'defaultValue', function() { return []; });
	  }
	
	  if (shape.member) {
	    memoizedProperty(this, 'member', function() {
	      return Shape.create(shape.member, options);
	    });
	  }
	
	  if (this.flattened) {
	    var oldName = this.name;
	    memoizedProperty(this, 'name', function() {
	      return self.member.name || oldName;
	    });
	  }
	}
	
	function MapShape(shape, options) {
	  var firstInit = !this.isShape;
	  CompositeShape.apply(this, arguments);
	
	  if (firstInit) {
	    property(this, 'defaultValue', function() { return {}; });
	    property(this, 'key', Shape.create({type: 'string'}, options));
	    property(this, 'value', Shape.create({type: 'string'}, options));
	  }
	
	  if (shape.key) {
	    memoizedProperty(this, 'key', function() {
	      return Shape.create(shape.key, options);
	    });
	  }
	  if (shape.value) {
	    memoizedProperty(this, 'value', function() {
	      return Shape.create(shape.value, options);
	    });
	  }
	}
	
	function TimestampShape(shape) {
	  var self = this;
	  Shape.apply(this, arguments);
	
	  if (shape.timestampFormat) {
	    property(this, 'timestampFormat', shape.timestampFormat);
	  } else if (self.isTimestampFormatSet && this.timestampFormat) {
	    property(this, 'timestampFormat', this.timestampFormat);
	  } else if (this.location === 'header') {
	    property(this, 'timestampFormat', 'rfc822');
	  } else if (this.location === 'querystring') {
	    property(this, 'timestampFormat', 'iso8601');
	  } else if (this.api) {
	    switch (this.api.protocol) {
	      case 'json':
	      case 'rest-json':
	        property(this, 'timestampFormat', 'unixTimestamp');
	        break;
	      case 'rest-xml':
	      case 'query':
	      case 'ec2':
	        property(this, 'timestampFormat', 'iso8601');
	        break;
	    }
	  }
	
	  this.toType = function(value) {
	    if (value === null || value === undefined) return null;
	    if (typeof value.toUTCString === 'function') return value;
	    return typeof value === 'string' || typeof value === 'number' ?
	           util.date.parseTimestamp(value) : null;
	  };
	
	  this.toWireFormat = function(value) {
	    return util.date.format(value, self.timestampFormat);
	  };
	}
	
	function StringShape() {
	  Shape.apply(this, arguments);
	
	  var nullLessProtocols = ['rest-xml', 'query', 'ec2'];
	  this.toType = function(value) {
	    value = this.api && nullLessProtocols.indexOf(this.api.protocol) > -1 ?
	      value || '' : value;
	    if (this.isJsonValue) {
	      return JSON.parse(value);
	    }
	
	    return value && typeof value.toString === 'function' ?
	      value.toString() : value;
	  };
	
	  this.toWireFormat = function(value) {
	    return this.isJsonValue ? JSON.stringify(value) : value;
	  };
	}
	
	function FloatShape() {
	  Shape.apply(this, arguments);
	
	  this.toType = function(value) {
	    if (value === null || value === undefined) return null;
	    return parseFloat(value);
	  };
	  this.toWireFormat = this.toType;
	}
	
	function IntegerShape() {
	  Shape.apply(this, arguments);
	
	  this.toType = function(value) {
	    if (value === null || value === undefined) return null;
	    return parseInt(value, 10);
	  };
	  this.toWireFormat = this.toType;
	}
	
	function BinaryShape() {
	  Shape.apply(this, arguments);
	  this.toType = function(value) {
	    var buf = util.base64.decode(value);
	    if (this.isSensitive && util.isNode() && typeof util.Buffer.alloc === 'function') {
	  /* Node.js can create a Buffer that is not isolated.
	   * i.e. buf.byteLength !== buf.buffer.byteLength
	   * This means that the sensitive data is accessible to anyone with access to buf.buffer.
	   * If this is the node shared Buffer, then other code within this process _could_ find this secret.
	   * Copy sensitive data to an isolated Buffer and zero the sensitive data.
	   * While this is safe to do here, copying this code somewhere else may produce unexpected results.
	   */
	      var secureBuf = util.Buffer.alloc(buf.length, buf);
	      buf.fill(0);
	      buf = secureBuf;
	    }
	    return buf;
	  };
	  this.toWireFormat = util.base64.encode;
	}
	
	function Base64Shape() {
	  BinaryShape.apply(this, arguments);
	}
	
	function BooleanShape() {
	  Shape.apply(this, arguments);
	
	  this.toType = function(value) {
	    if (typeof value === 'boolean') return value;
	    if (value === null || value === undefined) return null;
	    return value === 'true';
	  };
	}
	
	/**
	 * @api private
	 */
	Shape.shapes = {
	  StructureShape: StructureShape,
	  ListShape: ListShape,
	  MapShape: MapShape,
	  StringShape: StringShape,
	  BooleanShape: BooleanShape,
	  Base64Shape: Base64Shape
	};
	
	/**
	 * @api private
	 */
	module.exports = Shape;


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * @api private
	 */
	AWS.ParamValidator = AWS.util.inherit({
	  /**
	   * Create a new validator object.
	   *
	   * @param validation [Boolean|map] whether input parameters should be
	   *     validated against the operation description before sending the
	   *     request. Pass a map to enable any of the following specific
	   *     validation features:
	   *
	   *     * **min** [Boolean] &mdash; Validates that a value meets the min
	   *       constraint. This is enabled by default when paramValidation is set
	   *       to `true`.
	   *     * **max** [Boolean] &mdash; Validates that a value meets the max
	   *       constraint.
	   *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
	   *       regular expression.
	   *     * **enum** [Boolean] &mdash; Validates that a string value matches one
	   *       of the allowable enum values.
	   */
	  constructor: function ParamValidator(validation) {
	    if (validation === true || validation === undefined) {
	      validation = {'min': true};
	    }
	    this.validation = validation;
	  },
	
	  validate: function validate(shape, params, context) {
	    this.errors = [];
	    this.validateMember(shape, params || {}, context || 'params');
	
	    if (this.errors.length > 1) {
	      var msg = this.errors.join('\n* ');
	      msg = 'There were ' + this.errors.length +
	        ' validation errors:\n* ' + msg;
	      throw AWS.util.error(new Error(msg),
	        {code: 'MultipleValidationErrors', errors: this.errors});
	    } else if (this.errors.length === 1) {
	      throw this.errors[0];
	    } else {
	      return true;
	    }
	  },
	
	  fail: function fail(code, message) {
	    this.errors.push(AWS.util.error(new Error(message), {code: code}));
	  },
	
	  validateStructure: function validateStructure(shape, params, context) {
	    this.validateType(params, context, ['object'], 'structure');
	
	    var paramName;
	    for (var i = 0; shape.required && i < shape.required.length; i++) {
	      paramName = shape.required[i];
	      var value = params[paramName];
	      if (value === undefined || value === null) {
	        this.fail('MissingRequiredParameter',
	          'Missing required key \'' + paramName + '\' in ' + context);
	      }
	    }
	
	    // validate hash members
	    for (paramName in params) {
	      if (!Object.prototype.hasOwnProperty.call(params, paramName)) continue;
	
	      var paramValue = params[paramName],
	          memberShape = shape.members[paramName];
	
	      if (memberShape !== undefined) {
	        var memberContext = [context, paramName].join('.');
	        this.validateMember(memberShape, paramValue, memberContext);
	      } else {
	        this.fail('UnexpectedParameter',
	          'Unexpected key \'' + paramName + '\' found in ' + context);
	      }
	    }
	
	    return true;
	  },
	
	  validateMember: function validateMember(shape, param, context) {
	    switch (shape.type) {
	      case 'structure':
	        return this.validateStructure(shape, param, context);
	      case 'list':
	        return this.validateList(shape, param, context);
	      case 'map':
	        return this.validateMap(shape, param, context);
	      default:
	        return this.validateScalar(shape, param, context);
	    }
	  },
	
	  validateList: function validateList(shape, params, context) {
	    if (this.validateType(params, context, [Array])) {
	      this.validateRange(shape, params.length, context, 'list member count');
	      // validate array members
	      for (var i = 0; i < params.length; i++) {
	        this.validateMember(shape.member, params[i], context + '[' + i + ']');
	      }
	    }
	  },
	
	  validateMap: function validateMap(shape, params, context) {
	    if (this.validateType(params, context, ['object'], 'map')) {
	      // Build up a count of map members to validate range traits.
	      var mapCount = 0;
	      for (var param in params) {
	        if (!Object.prototype.hasOwnProperty.call(params, param)) continue;
	        // Validate any map key trait constraints
	        this.validateMember(shape.key, param,
	                            context + '[key=\'' + param + '\']');
	        this.validateMember(shape.value, params[param],
	                            context + '[\'' + param + '\']');
	        mapCount++;
	      }
	      this.validateRange(shape, mapCount, context, 'map member count');
	    }
	  },
	
	  validateScalar: function validateScalar(shape, value, context) {
	    switch (shape.type) {
	      case null:
	      case undefined:
	      case 'string':
	        return this.validateString(shape, value, context);
	      case 'base64':
	      case 'binary':
	        return this.validatePayload(value, context);
	      case 'integer':
	      case 'float':
	        return this.validateNumber(shape, value, context);
	      case 'boolean':
	        return this.validateType(value, context, ['boolean']);
	      case 'timestamp':
	        return this.validateType(value, context, [Date,
	          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/, 'number'],
	          'Date object, ISO-8601 string, or a UNIX timestamp');
	      default:
	        return this.fail('UnkownType', 'Unhandled type ' +
	                         shape.type + ' for ' + context);
	    }
	  },
	
	  validateString: function validateString(shape, value, context) {
	    var validTypes = ['string'];
	    if (shape.isJsonValue) {
	      validTypes = validTypes.concat(['number', 'object', 'boolean']);
	    }
	    if (value !== null && this.validateType(value, context, validTypes)) {
	      this.validateEnum(shape, value, context);
	      this.validateRange(shape, value.length, context, 'string length');
	      this.validatePattern(shape, value, context);
	      this.validateUri(shape, value, context);
	    }
	  },
	
	  validateUri: function validateUri(shape, value, context) {
	    if (shape['location'] === 'uri') {
	      if (value.length === 0) {
	        this.fail('UriParameterError', 'Expected uri parameter to have length >= 1,'
	          + ' but found "' + value +'" for ' + context);
	      }
	    }
	  },
	
	  validatePattern: function validatePattern(shape, value, context) {
	    if (this.validation['pattern'] && shape['pattern'] !== undefined) {
	      if (!(new RegExp(shape['pattern'])).test(value)) {
	        this.fail('PatternMatchError', 'Provided value "' + value + '" '
	          + 'does not match regex pattern /' + shape['pattern'] + '/ for '
	          + context);
	      }
	    }
	  },
	
	  validateRange: function validateRange(shape, value, context, descriptor) {
	    if (this.validation['min']) {
	      if (shape['min'] !== undefined && value < shape['min']) {
	        this.fail('MinRangeError', 'Expected ' + descriptor + ' >= '
	          + shape['min'] + ', but found ' + value + ' for ' + context);
	      }
	    }
	    if (this.validation['max']) {
	      if (shape['max'] !== undefined && value > shape['max']) {
	        this.fail('MaxRangeError', 'Expected ' + descriptor + ' <= '
	          + shape['max'] + ', but found ' + value + ' for ' + context);
	      }
	    }
	  },
	
	  validateEnum: function validateRange(shape, value, context) {
	    if (this.validation['enum'] && shape['enum'] !== undefined) {
	      // Fail if the string value is not present in the enum list
	      if (shape['enum'].indexOf(value) === -1) {
	        this.fail('EnumError', 'Found string value of ' + value + ', but '
	          + 'expected ' + shape['enum'].join('|') + ' for ' + context);
	      }
	    }
	  },
	
	  validateType: function validateType(value, context, acceptedTypes, type) {
	    // We will not log an error for null or undefined, but we will return
	    // false so that callers know that the expected type was not strictly met.
	    if (value === null || value === undefined) return false;
	
	    var foundInvalidType = false;
	    for (var i = 0; i < acceptedTypes.length; i++) {
	      if (typeof acceptedTypes[i] === 'string') {
	        if (typeof value === acceptedTypes[i]) return true;
	      } else if (acceptedTypes[i] instanceof RegExp) {
	        if ((value || '').toString().match(acceptedTypes[i])) return true;
	      } else {
	        if (value instanceof acceptedTypes[i]) return true;
	        if (AWS.util.isType(value, acceptedTypes[i])) return true;
	        if (!type && !foundInvalidType) acceptedTypes = acceptedTypes.slice();
	        acceptedTypes[i] = AWS.util.typeName(acceptedTypes[i]);
	      }
	      foundInvalidType = true;
	    }
	
	    var acceptedType = type;
	    if (!acceptedType) {
	      acceptedType = acceptedTypes.join(', ').replace(/,([^,]+)$/, ', or$1');
	    }
	
	    var vowel = acceptedType.match(/^[aeiou]/i) ? 'n' : '';
	    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a' +
	              vowel + ' ' + acceptedType);
	    return false;
	  },
	
	  validateNumber: function validateNumber(shape, value, context) {
	    if (value === null || value === undefined) return;
	    if (typeof value === 'string') {
	      var castedValue = parseFloat(value);
	      if (castedValue.toString() === value) value = castedValue;
	    }
	    if (this.validateType(value, context, ['number'])) {
	      this.validateRange(shape, value, context, 'numeric value');
	    }
	  },
	
	  validatePayload: function validatePayload(value, context) {
	    if (value === null || value === undefined) return;
	    if (typeof value === 'string') return;
	    if (value && typeof value.byteLength === 'number') return; // typed arrays
	    if (AWS.util.isNode()) { // special check for buffer/stream in Node.js
	      var Stream = AWS.util.stream.Stream;
	      if (AWS.util.Buffer.isBuffer(value) || value instanceof Stream) return;
	    } else {
	      if (typeof Blob !== void 0 && value instanceof Blob) return;
	    }
	
	    var types = ['Buffer', 'Stream', 'File', 'Blob', 'ArrayBuffer', 'DataView'];
	    if (value) {
	      for (var i = 0; i < types.length; i++) {
	        if (AWS.util.isType(value, types[i])) return;
	        if (AWS.util.typeName(value.constructor) === types[i]) return;
	      }
	    }
	
	    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a ' +
	      'string, Buffer, Stream, Blob, or typed array object');
	  }
	});


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var util =  __webpack_require__(__webpack_module_template_argument_0__);
	var AWS = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Prepend prefix defined by API model to endpoint that's already
	 * constructed. This feature does not apply to operations using
	 * endpoint discovery and can be disabled.
	 * @api private
	 */
	function populateHostPrefix(request)  {
	  var enabled = request.service.config.hostPrefixEnabled;
	  if (!enabled) return request;
	  var operationModel = request.service.api.operations[request.operation];
	  //don't marshal host prefix when operation has endpoint discovery traits
	  if (hasEndpointDiscover(request)) return request;
	  if (operationModel.endpoint && operationModel.endpoint.hostPrefix) {
	    var hostPrefixNotation = operationModel.endpoint.hostPrefix;
	    var hostPrefix = expandHostPrefix(hostPrefixNotation, request.params, operationModel.input);
	    prependEndpointPrefix(request.httpRequest.endpoint, hostPrefix);
	    validateHostname(request.httpRequest.endpoint.hostname);
	  }
	  return request;
	}
	
	/**
	 * @api private
	 */
	function hasEndpointDiscover(request) {
	  var api = request.service.api;
	  var operationModel = api.operations[request.operation];
	  var isEndpointOperation = api.endpointOperation && (api.endpointOperation === util.string.lowerFirst(operationModel.name));
	  return (operationModel.endpointDiscoveryRequired !== 'NULL' || isEndpointOperation === true);
	}
	
	/**
	 * @api private
	 */
	function expandHostPrefix(hostPrefixNotation, params, shape) {
	  util.each(shape.members, function(name, member) {
	    if (member.hostLabel === true) {
	      if (typeof params[name] !== 'string' || params[name] === '') {
	        throw util.error(new Error(), {
	          message: 'Parameter ' + name + ' should be a non-empty string.',
	          code: 'InvalidParameter'
	        });
	      }
	      var regex = new RegExp('\\{' + name + '\\}', 'g');
	      hostPrefixNotation = hostPrefixNotation.replace(regex, params[name]);
	    }
	  });
	  return hostPrefixNotation;
	}
	
	/**
	 * @api private
	 */
	function prependEndpointPrefix(endpoint, prefix) {
	  if (endpoint.host) {
	    endpoint.host = prefix + endpoint.host;
	  }
	  if (endpoint.hostname) {
	    endpoint.hostname = prefix + endpoint.hostname;
	  }
	}
	
	/**
	 * @api private
	 */
	function validateHostname(hostname) {
	  var labels = hostname.split('.');
	  //Reference: https://tools.ietf.org/html/rfc1123#section-2
	  var hostPattern = /^[a-zA-Z0-9]{1}$|^[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]$/;
	  util.arrayEach(labels, function(label) {
	    if (!label.length || label.length < 1 || label.length > 63) {
	      throw util.error(new Error(), {
	        code: 'ValidationError',
	        message: 'Hostname label length should be between 1 to 63 characters, inclusive.'
	      });
	    }
	    if (!hostPattern.test(label)) {
	      throw AWS.util.error(new Error(),
	        {code: 'ValidationError', message: label + ' is not hostname compatible.'});
	    }
	  });
	}
	
	module.exports = {
	  populateHostPrefix: populateHostPrefix
	};


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var util = __webpack_require__(__webpack_module_template_argument_0__);
	var JsonBuilder = __webpack_require__(__webpack_module_template_argument_1__);
	var JsonParser = __webpack_require__(__webpack_module_template_argument_2__);
	var populateHostPrefix = __webpack_require__(__webpack_module_template_argument_3__).populateHostPrefix;
	
	function buildRequest(req) {
	  var httpRequest = req.httpRequest;
	  var api = req.service.api;
	  var target = api.targetPrefix + '.' + api.operations[req.operation].name;
	  var version = api.jsonVersion || '1.0';
	  var input = api.operations[req.operation].input;
	  var builder = new JsonBuilder();
	
	  if (version === 1) version = '1.0';
	  httpRequest.body = builder.build(req.params || {}, input);
	  httpRequest.headers['Content-Type'] = 'application/x-amz-json-' + version;
	  httpRequest.headers['X-Amz-Target'] = target;
	
	  populateHostPrefix(req);
	}
	
	function extractError(resp) {
	  var error = {};
	  var httpResponse = resp.httpResponse;
	
	  error.code = httpResponse.headers['x-amzn-errortype'] || 'UnknownError';
	  if (typeof error.code === 'string') {
	    error.code = error.code.split(':')[0];
	  }
	
	  if (httpResponse.body.length > 0) {
	    try {
	      var e = JSON.parse(httpResponse.body.toString());
	      if (e.__type || e.code) {
	        error.code = (e.__type || e.code).split('#').pop();
	      }
	      if (error.code === 'RequestEntityTooLarge') {
	        error.message = 'Request body must be less than 1 MB';
	      } else {
	        error.message = (e.message || e.Message || null);
	      }
	    } catch (e) {
	      error.statusCode = httpResponse.statusCode;
	      error.message = httpResponse.statusMessage;
	    }
	  } else {
	    error.statusCode = httpResponse.statusCode;
	    error.message = httpResponse.statusCode.toString();
	  }
	
	  resp.error = util.error(new Error(), error);
	}
	
	function extractData(resp) {
	  var body = resp.httpResponse.body.toString() || '{}';
	  if (resp.request.service.config.convertResponseTypes === false) {
	    resp.data = JSON.parse(body);
	  } else {
	    var operation = resp.request.service.api.operations[resp.request.operation];
	    var shape = operation.output || {};
	    var parser = new JsonParser();
	    resp.data = parser.parse(body, shape);
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData
	};


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var util = __webpack_require__(__webpack_module_template_argument_1__);
	var QueryParamSerializer = __webpack_require__(__webpack_module_template_argument_2__);
	var Shape = __webpack_require__(__webpack_module_template_argument_3__);
	var populateHostPrefix = __webpack_require__(__webpack_module_template_argument_4__).populateHostPrefix;
	
	function buildRequest(req) {
	  var operation = req.service.api.operations[req.operation];
	  var httpRequest = req.httpRequest;
	  httpRequest.headers['Content-Type'] =
	    'application/x-www-form-urlencoded; charset=utf-8';
	  httpRequest.params = {
	    Version: req.service.api.apiVersion,
	    Action: operation.name
	  };
	
	  // convert the request parameters into a list of query params,
	  // e.g. Deeply.NestedParam.0.Name=value
	  var builder = new QueryParamSerializer();
	  builder.serialize(req.params, operation.input, function(name, value) {
	    httpRequest.params[name] = value;
	  });
	  httpRequest.body = util.queryParamsToString(httpRequest.params);
	
	  populateHostPrefix(req);
	}
	
	function extractError(resp) {
	  var data, body = resp.httpResponse.body.toString();
	  if (body.match('<UnknownOperationException')) {
	    data = {
	      Code: 'UnknownOperation',
	      Message: 'Unknown operation ' + resp.request.operation
	    };
	  } else {
	    try {
	      data = new AWS.XML.Parser().parse(body);
	    } catch (e) {
	      data = {
	        Code: resp.httpResponse.statusCode,
	        Message: resp.httpResponse.statusMessage
	      };
	    }
	  }
	
	  if (data.requestId && !resp.requestId) resp.requestId = data.requestId;
	  if (data.Errors) data = data.Errors;
	  if (data.Error) data = data.Error;
	  if (data.Code) {
	    resp.error = util.error(new Error(), {
	      code: data.Code,
	      message: data.Message
	    });
	  } else {
	    resp.error = util.error(new Error(), {
	      code: resp.httpResponse.statusCode,
	      message: null
	    });
	  }
	}
	
	function extractData(resp) {
	  var req = resp.request;
	  var operation = req.service.api.operations[req.operation];
	  var shape = operation.output || {};
	  var origRules = shape;
	
	  if (origRules.resultWrapper) {
	    var tmp = Shape.create({type: 'structure'});
	    tmp.members[origRules.resultWrapper] = shape;
	    tmp.memberNames = [origRules.resultWrapper];
	    util.property(shape, 'name', shape.resultWrapper);
	    shape = tmp;
	  }
	
	  var parser = new AWS.XML.Parser();
	
	  // TODO: Refactor XML Parser to parse RequestId from response.
	  if (shape && shape.members && !shape.members._XAMZRequestId) {
	    var requestIdShape = Shape.create(
	      { type: 'string' },
	      { api: { protocol: 'query' } },
	      'requestId'
	    );
	    shape.members._XAMZRequestId = requestIdShape;
	  }
	
	  var data = parser.parse(resp.httpResponse.body.toString(), shape);
	  resp.requestId = data._XAMZRequestId || data.requestId;
	
	  if (data._XAMZRequestId) delete data._XAMZRequestId;
	
	  if (origRules.resultWrapper) {
	    if (data[origRules.resultWrapper]) {
	      util.update(data, data[origRules.resultWrapper]);
	      delete data[origRules.resultWrapper];
	    }
	  }
	
	  resp.data = data;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData
	};


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var util = __webpack_require__(__webpack_module_template_argument_0__);
	var populateHostPrefix = __webpack_require__(__webpack_module_template_argument_1__).populateHostPrefix;
	
	function populateMethod(req) {
	  req.httpRequest.method = req.service.api.operations[req.operation].httpMethod;
	}
	
	function generateURI(endpointPath, operationPath, input, params) {
	  var uri = [endpointPath, operationPath].join('/');
	  uri = uri.replace(/\/+/g, '/');
	
	  var queryString = {}, queryStringSet = false;
	  util.each(input.members, function (name, member) {
	    var paramValue = params[name];
	    if (paramValue === null || paramValue === undefined) return;
	    if (member.location === 'uri') {
	      var regex = new RegExp('\\{' + member.name + '(\\+)?\\}');
	      uri = uri.replace(regex, function(_, plus) {
	        var fn = plus ? util.uriEscapePath : util.uriEscape;
	        return fn(String(paramValue));
	      });
	    } else if (member.location === 'querystring') {
	      queryStringSet = true;
	
	      if (member.type === 'list') {
	        queryString[member.name] = paramValue.map(function(val) {
	          return util.uriEscape(member.member.toWireFormat(val).toString());
	        });
	      } else if (member.type === 'map') {
	        util.each(paramValue, function(key, value) {
	          if (Array.isArray(value)) {
	            queryString[key] = value.map(function(val) {
	              return util.uriEscape(String(val));
	            });
	          } else {
	            queryString[key] = util.uriEscape(String(value));
	          }
	        });
	      } else {
	        queryString[member.name] = util.uriEscape(member.toWireFormat(paramValue).toString());
	      }
	    }
	  });
	
	  if (queryStringSet) {
	    uri += (uri.indexOf('?') >= 0 ? '&' : '?');
	    var parts = [];
	    util.arrayEach(Object.keys(queryString).sort(), function(key) {
	      if (!Array.isArray(queryString[key])) {
	        queryString[key] = [queryString[key]];
	      }
	      for (var i = 0; i < queryString[key].length; i++) {
	        parts.push(util.uriEscape(String(key)) + '=' + queryString[key][i]);
	      }
	    });
	    uri += parts.join('&');
	  }
	
	  return uri;
	}
	
	function populateURI(req) {
	  var operation = req.service.api.operations[req.operation];
	  var input = operation.input;
	
	  var uri = generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);
	  req.httpRequest.path = uri;
	}
	
	function populateHeaders(req) {
	  var operation = req.service.api.operations[req.operation];
	  util.each(operation.input.members, function (name, member) {
	    var value = req.params[name];
	    if (value === null || value === undefined) return;
	
	    if (member.location === 'headers' && member.type === 'map') {
	      util.each(value, function(key, memberValue) {
	        req.httpRequest.headers[member.name + key] = memberValue;
	      });
	    } else if (member.location === 'header') {
	      value = member.toWireFormat(value).toString();
	      if (member.isJsonValue) {
	        value = util.base64.encode(value);
	      }
	      req.httpRequest.headers[member.name] = value;
	    }
	  });
	}
	
	function buildRequest(req) {
	  populateMethod(req);
	  populateURI(req);
	  populateHeaders(req);
	  populateHostPrefix(req);
	}
	
	function extractError() {
	}
	
	function extractData(resp) {
	  var req = resp.request;
	  var data = {};
	  var r = resp.httpResponse;
	  var operation = req.service.api.operations[req.operation];
	  var output = operation.output;
	
	  // normalize headers names to lower-cased keys for matching
	  var headers = {};
	  util.each(r.headers, function (k, v) {
	    headers[k.toLowerCase()] = v;
	  });
	
	  util.each(output.members, function(name, member) {
	    var header = (member.name || name).toLowerCase();
	    if (member.location === 'headers' && member.type === 'map') {
	      data[name] = {};
	      var location = member.isLocationName ? member.name : '';
	      var pattern = new RegExp('^' + location + '(.+)', 'i');
	      util.each(r.headers, function (k, v) {
	        var result = k.match(pattern);
	        if (result !== null) {
	          data[name][result[1]] = v;
	        }
	      });
	    } else if (member.location === 'header') {
	      if (headers[header] !== undefined) {
	        var value = member.isJsonValue ?
	          util.base64.decode(headers[header]) :
	          headers[header];
	        data[name] = member.toType(value);
	      }
	    } else if (member.location === 'statusCode') {
	      data[name] = parseInt(r.statusCode, 10);
	    }
	  });
	
	  resp.data = data;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData,
	  generateURI: generateURI
	};


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var util = __webpack_require__(__webpack_module_template_argument_0__);
	var Rest = __webpack_require__(__webpack_module_template_argument_1__);
	var Json = __webpack_require__(__webpack_module_template_argument_2__);
	var JsonBuilder = __webpack_require__(__webpack_module_template_argument_3__);
	var JsonParser = __webpack_require__(__webpack_module_template_argument_4__);
	
	function populateBody(req) {
	  var builder = new JsonBuilder();
	  var input = req.service.api.operations[req.operation].input;
	
	  if (input.payload) {
	    var params = {};
	    var payloadShape = input.members[input.payload];
	    params = req.params[input.payload];
	    if (params === undefined) return;
	
	    if (payloadShape.type === 'structure') {
	      req.httpRequest.body = builder.build(params, payloadShape);
	      applyContentTypeHeader(req);
	    } else { // non-JSON payload
	      req.httpRequest.body = params;
	      if (payloadShape.type === 'binary' || payloadShape.isStreaming) {
	        applyContentTypeHeader(req, true);
	      }
	    }
	  } else {
	    var body = builder.build(req.params, input);
	    if (body !== '{}' || req.httpRequest.method !== 'GET') { //don't send empty body for GET method
	      req.httpRequest.body = body;
	    }
	    applyContentTypeHeader(req);
	  }
	}
	
	function applyContentTypeHeader(req, isBinary) {
	  var operation = req.service.api.operations[req.operation];
	  var input = operation.input;
	
	  if (!req.httpRequest.headers['Content-Type']) {
	    var type = isBinary ? 'binary/octet-stream' : 'application/json';
	    req.httpRequest.headers['Content-Type'] = type;
	  }
	}
	
	function buildRequest(req) {
	  Rest.buildRequest(req);
	
	  // never send body payload on HEAD/DELETE
	  if (['HEAD', 'DELETE'].indexOf(req.httpRequest.method) < 0) {
	    populateBody(req);
	  }
	}
	
	function extractError(resp) {
	  Json.extractError(resp);
	}
	
	function extractData(resp) {
	  Rest.extractData(resp);
	
	  var req = resp.request;
	  var operation = req.service.api.operations[req.operation];
	  var rules = req.service.api.operations[req.operation].output || {};
	  var parser;
	  var hasEventOutput = operation.hasEventOutput;
	
	  if (rules.payload) {
	    var payloadMember = rules.members[rules.payload];
	    var body = resp.httpResponse.body;
	    if (payloadMember.isEventStream) {
	      parser = new JsonParser();
	      resp.data[payload] = util.createEventStream(
	        AWS.HttpClient.streamsApiVersion === 2 ? resp.httpResponse.stream : body,
	        parser,
	        payloadMember
	      );
	    } else if (payloadMember.type === 'structure' || payloadMember.type === 'list') {
	      var parser = new JsonParser();
	      resp.data[rules.payload] = parser.parse(body, payloadMember);
	    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
	      resp.data[rules.payload] = body;
	    } else {
	      resp.data[rules.payload] = payloadMember.toType(body);
	    }
	  } else {
	    var data = resp.data;
	    Json.extractData(resp);
	    resp.data = util.merge(data, resp.data);
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData
	};


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var util = __webpack_require__(__webpack_module_template_argument_1__);
	var Rest = __webpack_require__(__webpack_module_template_argument_2__);
	
	function populateBody(req) {
	  var input = req.service.api.operations[req.operation].input;
	  var builder = new AWS.XML.Builder();
	  var params = req.params;
	
	  var payload = input.payload;
	  if (payload) {
	    var payloadMember = input.members[payload];
	    params = params[payload];
	    if (params === undefined) return;
	
	    if (payloadMember.type === 'structure') {
	      var rootElement = payloadMember.name;
	      req.httpRequest.body = builder.toXML(params, payloadMember, rootElement, true);
	    } else { // non-xml payload
	      req.httpRequest.body = params;
	    }
	  } else {
	    req.httpRequest.body = builder.toXML(params, input, input.name ||
	      input.shape || util.string.upperFirst(req.operation) + 'Request');
	  }
	}
	
	function buildRequest(req) {
	  Rest.buildRequest(req);
	
	  // never send body payload on GET/HEAD
	  if (['GET', 'HEAD'].indexOf(req.httpRequest.method) < 0) {
	    populateBody(req);
	  }
	}
	
	function extractError(resp) {
	  Rest.extractError(resp);
	
	  var data;
	  try {
	    data = new AWS.XML.Parser().parse(resp.httpResponse.body.toString());
	  } catch (e) {
	    data = {
	      Code: resp.httpResponse.statusCode,
	      Message: resp.httpResponse.statusMessage
	    };
	  }
	
	  if (data.Errors) data = data.Errors;
	  if (data.Error) data = data.Error;
	  if (data.Code) {
	    resp.error = util.error(new Error(), {
	      code: data.Code,
	      message: data.Message
	    });
	  } else {
	    resp.error = util.error(new Error(), {
	      code: resp.httpResponse.statusCode,
	      message: null
	    });
	  }
	}
	
	function extractData(resp) {
	  Rest.extractData(resp);
	
	  var parser;
	  var req = resp.request;
	  var body = resp.httpResponse.body;
	  var operation = req.service.api.operations[req.operation];
	  var output = operation.output;
	
	  var hasEventOutput = operation.hasEventOutput;
	
	  var payload = output.payload;
	  if (payload) {
	    var payloadMember = output.members[payload];
	    if (payloadMember.isEventStream) {
	      parser = new AWS.XML.Parser();
	      resp.data[payload] = util.createEventStream(
	        AWS.HttpClient.streamsApiVersion === 2 ? resp.httpResponse.stream : resp.httpResponse.body,
	        parser,
	        payloadMember
	      );
	    } else if (payloadMember.type === 'structure') {
	      parser = new AWS.XML.Parser();
	      resp.data[payload] = parser.parse(body.toString(), payloadMember);
	    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
	      resp.data[payload] = body;
	    } else {
	      resp.data[payload] = payloadMember.toType(body);
	    }
	  } else if (body.length > 0) {
	    parser = new AWS.XML.Parser();
	    var data = parser.parse(body.toString(), output);
	    util.update(resp.data, data);
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData
	};


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var util = __webpack_require__(__webpack_module_template_argument_0__);
	
	function QueryParamSerializer() {
	}
	
	QueryParamSerializer.prototype.serialize = function(params, shape, fn) {
	  serializeStructure('', params, shape, fn);
	};
	
	function ucfirst(shape) {
	  if (shape.isQueryName || shape.api.protocol !== 'ec2') {
	    return shape.name;
	  } else {
	    return shape.name[0].toUpperCase() + shape.name.substr(1);
	  }
	}
	
	function serializeStructure(prefix, struct, rules, fn) {
	  util.each(rules.members, function(name, member) {
	    var value = struct[name];
	    if (value === null || value === undefined) return;
	
	    var memberName = ucfirst(member);
	    memberName = prefix ? prefix + '.' + memberName : memberName;
	    serializeMember(memberName, value, member, fn);
	  });
	}
	
	function serializeMap(name, map, rules, fn) {
	  var i = 1;
	  util.each(map, function (key, value) {
	    var prefix = rules.flattened ? '.' : '.entry.';
	    var position = prefix + (i++) + '.';
	    var keyName = position + (rules.key.name || 'key');
	    var valueName = position + (rules.value.name || 'value');
	    serializeMember(name + keyName, key, rules.key, fn);
	    serializeMember(name + valueName, value, rules.value, fn);
	  });
	}
	
	function serializeList(name, list, rules, fn) {
	  var memberRules = rules.member || {};
	
	  if (list.length === 0) {
	    fn.call(this, name, null);
	    return;
	  }
	
	  util.arrayEach(list, function (v, n) {
	    var suffix = '.' + (n + 1);
	    if (rules.api.protocol === 'ec2') {
	      // Do nothing for EC2
	      suffix = suffix + ''; // make linter happy
	    } else if (rules.flattened) {
	      if (memberRules.name) {
	        var parts = name.split('.');
	        parts.pop();
	        parts.push(ucfirst(memberRules));
	        name = parts.join('.');
	      }
	    } else {
	      suffix = '.' + (memberRules.name ? memberRules.name : 'member') + suffix;
	    }
	    serializeMember(name + suffix, v, memberRules, fn);
	  });
	}
	
	function serializeMember(name, value, rules, fn) {
	  if (value === null || value === undefined) return;
	  if (rules.type === 'structure') {
	    serializeStructure(name, value, rules, fn);
	  } else if (rules.type === 'list') {
	    serializeList(name, value, rules, fn);
	  } else if (rules.type === 'map') {
	    serializeMap(name, value, rules, fn);
	  } else {
	    fn(name, rules.toWireFormat(value).toString());
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = QueryParamSerializer;


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var util = __webpack_require__(__webpack_module_template_argument_0__);
	var regionConfig = __webpack_require__(__webpack_module_template_argument_1__);
	
	function generateRegionPrefix(region) {
	  if (!region) return null;
	
	  var parts = region.split('-');
	  if (parts.length < 3) return null;
	  return parts.slice(0, parts.length - 2).join('-') + '-*';
	}
	
	function derivedKeys(service) {
	  var region = service.config.region;
	  var regionPrefix = generateRegionPrefix(region);
	  var endpointPrefix = service.api.endpointPrefix;
	
	  return [
	    [region, endpointPrefix],
	    [regionPrefix, endpointPrefix],
	    [region, '*'],
	    [regionPrefix, '*'],
	    ['*', endpointPrefix],
	    ['*', '*']
	  ].map(function(item) {
	    return item[0] && item[1] ? item.join('/') : null;
	  });
	}
	
	function applyConfig(service, config) {
	  util.each(config, function(key, value) {
	    if (key === 'globalEndpoint') return;
	    if (service.config[key] === undefined || service.config[key] === null) {
	      service.config[key] = value;
	    }
	  });
	}
	
	function configureEndpoint(service) {
	  var keys = derivedKeys(service);
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!key) continue;
	
	    if (Object.prototype.hasOwnProperty.call(regionConfig.rules, key)) {
	      var config = regionConfig.rules[key];
	      if (typeof config === 'string') {
	        config = regionConfig.patterns[config];
	      }
	
	      // set dualstack endpoint
	      if (service.config.useDualstack && util.isDualstackAvailable(service)) {
	        config = util.copy(config);
	        config.endpoint = '{service}.dualstack.{region}.amazonaws.com';
	      }
	
	      // set global endpoint
	      service.isGlobalEndpoint = !!config.globalEndpoint;
	
	      // signature version
	      if (!config.signatureVersion) config.signatureVersion = 'v4';
	
	      // merge config
	      applyConfig(service, config);
	      return;
	    }
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = configureEndpoint;


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var AcceptorStateMachine = __webpack_require__(__webpack_module_template_argument_1__);
	var inherit = AWS.util.inherit;
	var domain = AWS.util.domain;
	var jmespath = __webpack_require__(42);
	
	/**
	 * @api private
	 */
	var hardErrorStates = {success: 1, error: 1, complete: 1};
	
	function isTerminalState(machine) {
	  return Object.prototype.hasOwnProperty.call(hardErrorStates, machine._asm.currentState);
	}
	
	var fsm = new AcceptorStateMachine();
	fsm.setupStates = function() {
	  var transition = function(_, done) {
	    var self = this;
	    self._haltHandlersOnError = false;
	
	    self.emit(self._asm.currentState, function(err) {
	      if (err) {
	        if (isTerminalState(self)) {
	          if (domain && self.domain instanceof domain.Domain) {
	            err.domainEmitter = self;
	            err.domain = self.domain;
	            err.domainThrown = false;
	            self.domain.emit('error', err);
	          } else {
	            throw err;
	          }
	        } else {
	          self.response.error = err;
	          done(err);
	        }
	      } else {
	        done(self.response.error);
	      }
	    });
	
	  };
	
	  this.addState('validate', 'build', 'error', transition);
	  this.addState('build', 'afterBuild', 'restart', transition);
	  this.addState('afterBuild', 'sign', 'restart', transition);
	  this.addState('sign', 'send', 'retry', transition);
	  this.addState('retry', 'afterRetry', 'afterRetry', transition);
	  this.addState('afterRetry', 'sign', 'error', transition);
	  this.addState('send', 'validateResponse', 'retry', transition);
	  this.addState('validateResponse', 'extractData', 'extractError', transition);
	  this.addState('extractError', 'extractData', 'retry', transition);
	  this.addState('extractData', 'success', 'retry', transition);
	  this.addState('restart', 'build', 'error', transition);
	  this.addState('success', 'complete', 'complete', transition);
	  this.addState('error', 'complete', 'complete', transition);
	  this.addState('complete', null, null, transition);
	};
	fsm.setupStates();
	
	/**
	 * ## Asynchronous Requests
	 *
	 * All requests made through the SDK are asynchronous and use a
	 * callback interface. Each service method that kicks off a request
	 * returns an `AWS.Request` object that you can use to register
	 * callbacks.
	 *
	 * For example, the following service method returns the request
	 * object as "request", which can be used to register callbacks:
	 *
	 * ```javascript
	 * // request is an AWS.Request object
	 * var request = ec2.describeInstances();
	 *
	 * // register callbacks on request to retrieve response data
	 * request.on('success', function(response) {
	 *   console.log(response.data);
	 * });
	 * ```
	 *
	 * When a request is ready to be sent, the {send} method should
	 * be called:
	 *
	 * ```javascript
	 * request.send();
	 * ```
	 *
	 * Since registered callbacks may or may not be idempotent, requests should only
	 * be sent once. To perform the same operation multiple times, you will need to
	 * create multiple request objects, each with its own registered callbacks.
	 *
	 * ## Removing Default Listeners for Events
	 *
	 * Request objects are built with default listeners for the various events,
	 * depending on the service type. In some cases, you may want to remove
	 * some built-in listeners to customize behaviour. Doing this requires
	 * access to the built-in listener functions, which are exposed through
	 * the {AWS.EventListeners.Core} namespace. For instance, you may
	 * want to customize the HTTP handler used when sending a request. In this
	 * case, you can remove the built-in listener associated with the 'send'
	 * event, the {AWS.EventListeners.Core.SEND} listener and add your own.
	 *
	 * ## Multiple Callbacks and Chaining
	 *
	 * You can register multiple callbacks on any request object. The
	 * callbacks can be registered for different events, or all for the
	 * same event. In addition, you can chain callback registration, for
	 * example:
	 *
	 * ```javascript
	 * request.
	 *   on('success', function(response) {
	 *     console.log("Success!");
	 *   }).
	 *   on('error', function(error, response) {
	 *     console.log("Error!");
	 *   }).
	 *   on('complete', function(response) {
	 *     console.log("Always!");
	 *   }).
	 *   send();
	 * ```
	 *
	 * The above example will print either "Success! Always!", or "Error! Always!",
	 * depending on whether the request succeeded or not.
	 *
	 * @!attribute httpRequest
	 *   @readonly
	 *   @!group HTTP Properties
	 *   @return [AWS.HttpRequest] the raw HTTP request object
	 *     containing request headers and body information
	 *     sent by the service.
	 *
	 * @!attribute startTime
	 *   @readonly
	 *   @!group Operation Properties
	 *   @return [Date] the time that the request started
	 *
	 * @!group Request Building Events
	 *
	 * @!event validate(request)
	 *   Triggered when a request is being validated. Listeners
	 *   should throw an error if the request should not be sent.
	 *   @param request [Request] the request object being sent
	 *   @see AWS.EventListeners.Core.VALIDATE_CREDENTIALS
	 *   @see AWS.EventListeners.Core.VALIDATE_REGION
	 *   @example Ensuring that a certain parameter is set before sending a request
	 *     var req = s3.putObject(params);
	 *     req.on('validate', function() {
	 *       if (!req.params.Body.match(/^Hello\s/)) {
	 *         throw new Error('Body must start with "Hello "');
	 *       }
	 *     });
	 *     req.send(function(err, data) { ... });
	 *
	 * @!event build(request)
	 *   Triggered when the request payload is being built. Listeners
	 *   should fill the necessary information to send the request
	 *   over HTTP.
	 *   @param (see AWS.Request~validate)
	 *   @example Add a custom HTTP header to a request
	 *     var req = s3.putObject(params);
	 *     req.on('build', function() {
	 *       req.httpRequest.headers['Custom-Header'] = 'value';
	 *     });
	 *     req.send(function(err, data) { ... });
	 *
	 * @!event sign(request)
	 *   Triggered when the request is being signed. Listeners should
	 *   add the correct authentication headers and/or adjust the body,
	 *   depending on the authentication mechanism being used.
	 *   @param (see AWS.Request~validate)
	 *
	 * @!group Request Sending Events
	 *
	 * @!event send(response)
	 *   Triggered when the request is ready to be sent. Listeners
	 *   should call the underlying transport layer to initiate
	 *   the sending of the request.
	 *   @param response [Response] the response object
	 *   @context [Request] the request object that was sent
	 *   @see AWS.EventListeners.Core.SEND
	 *
	 * @!event retry(response)
	 *   Triggered when a request failed and might need to be retried or redirected.
	 *   If the response is retryable, the listener should set the
	 *   `response.error.retryable` property to `true`, and optionally set
	 *   `response.error.retryDelay` to the millisecond delay for the next attempt.
	 *   In the case of a redirect, `response.error.redirect` should be set to
	 *   `true` with `retryDelay` set to an optional delay on the next request.
	 *
	 *   If a listener decides that a request should not be retried,
	 *   it should set both `retryable` and `redirect` to false.
	 *
	 *   Note that a retryable error will be retried at most
	 *   {AWS.Config.maxRetries} times (based on the service object's config).
	 *   Similarly, a request that is redirected will only redirect at most
	 *   {AWS.Config.maxRedirects} times.
	 *
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *   @example Adding a custom retry for a 404 response
	 *     request.on('retry', function(response) {
	 *       // this resource is not yet available, wait 10 seconds to get it again
	 *       if (response.httpResponse.statusCode === 404 && response.error) {
	 *         response.error.retryable = true;   // retry this error
	 *         response.error.retryDelay = 10000; // wait 10 seconds
	 *       }
	 *     });
	 *
	 * @!group Data Parsing Events
	 *
	 * @!event extractError(response)
	 *   Triggered on all non-2xx requests so that listeners can extract
	 *   error details from the response body. Listeners to this event
	 *   should set the `response.error` property.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!event extractData(response)
	 *   Triggered in successful requests to allow listeners to
	 *   de-serialize the response body into `response.data`.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!group Completion Events
	 *
	 * @!event success(response)
	 *   Triggered when the request completed successfully.
	 *   `response.data` will contain the response data and
	 *   `response.error` will be null.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!event error(error, response)
	 *   Triggered when an error occurs at any point during the
	 *   request. `response.error` will contain details about the error
	 *   that occurred. `response.data` will be null.
	 *   @param error [Error] the error object containing details about
	 *     the error that occurred.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!event complete(response)
	 *   Triggered whenever a request cycle completes. `response.error`
	 *   should be checked, since the request may have failed.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!group HTTP Events
	 *
	 * @!event httpHeaders(statusCode, headers, response, statusMessage)
	 *   Triggered when headers are sent by the remote server
	 *   @param statusCode [Integer] the HTTP response code
	 *   @param headers [map<String,String>] the response headers
	 *   @param (see AWS.Request~send)
	 *   @param statusMessage [String] A status message corresponding to the HTTP
	 *                                 response code
	 *   @context (see AWS.Request~send)
	 *
	 * @!event httpData(chunk, response)
	 *   Triggered when data is sent by the remote server
	 *   @param chunk [Buffer] the buffer data containing the next data chunk
	 *     from the server
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *   @see AWS.EventListeners.Core.HTTP_DATA
	 *
	 * @!event httpUploadProgress(progress, response)
	 *   Triggered when the HTTP request has uploaded more data
	 *   @param progress [map] An object containing the `loaded` and `total` bytes
	 *     of the request.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *   @note This event will not be emitted in Node.js 0.8.x.
	 *
	 * @!event httpDownloadProgress(progress, response)
	 *   Triggered when the HTTP request has downloaded more data
	 *   @param progress [map] An object containing the `loaded` and `total` bytes
	 *     of the request.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *   @note This event will not be emitted in Node.js 0.8.x.
	 *
	 * @!event httpError(error, response)
	 *   Triggered when the HTTP request failed
	 *   @param error [Error] the error object that was thrown
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!event httpDone(response)
	 *   Triggered when the server is finished sending data
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @see AWS.Response
	 */
	AWS.Request = inherit({
	
	  /**
	   * Creates a request for an operation on a given service with
	   * a set of input parameters.
	   *
	   * @param service [AWS.Service] the service to perform the operation on
	   * @param operation [String] the operation to perform on the service
	   * @param params [Object] parameters to send to the operation.
	   *   See the operation's documentation for the format of the
	   *   parameters.
	   */
	  constructor: function Request(service, operation, params) {
	    var endpoint = service.endpoint;
	    var region = service.config.region;
	    var customUserAgent = service.config.customUserAgent;
	
	    // global endpoints sign as us-east-1
	    if (service.isGlobalEndpoint) region = 'us-east-1';
	
	    this.domain = domain && domain.active;
	    this.service = service;
	    this.operation = operation;
	    this.params = params || {};
	    this.httpRequest = new AWS.HttpRequest(endpoint, region);
	    this.httpRequest.appendToUserAgent(customUserAgent);
	    this.startTime = service.getSkewCorrectedDate();
	
	    this.response = new AWS.Response(this);
	    this._asm = new AcceptorStateMachine(fsm.states, 'validate');
	    this._haltHandlersOnError = false;
	
	    AWS.SequentialExecutor.call(this);
	    this.emit = this.emitEvent;
	  },
	
	  /**
	   * @!group Sending a Request
	   */
	
	  /**
	   * @overload send(callback = null)
	   *   Sends the request object.
	   *
	   *   @callback callback function(err, data)
	   *     If a callback is supplied, it is called when a response is returned
	   *     from the service.
	   *     @context [AWS.Request] the request object being sent.
	   *     @param err [Error] the error object returned from the request.
	   *       Set to `null` if the request is successful.
	   *     @param data [Object] the de-serialized data returned from
	   *       the request. Set to `null` if a request error occurs.
	   *   @example Sending a request with a callback
	   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
	   *     request.send(function(err, data) { console.log(err, data); });
	   *   @example Sending a request with no callback (using event handlers)
	   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
	   *     request.on('complete', function(response) { ... }); // register a callback
	   *     request.send();
	   */
	  send: function send(callback) {
	    if (callback) {
	      // append to user agent
	      this.httpRequest.appendToUserAgent('callback');
	      this.on('complete', function (resp) {
	        callback.call(resp, resp.error, resp.data);
	      });
	    }
	    this.runTo();
	
	    return this.response;
	  },
	
	  /**
	   * @!method  promise()
	   *   Sends the request and returns a 'thenable' promise.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function(data)
	   *     Called if the promise is fulfilled.
	   *     @param data [Object] the de-serialized data returned from the request.
	   *   @callback rejectedCallback function(error)
	   *     Called if the promise is rejected.
	   *     @param error [Error] the error object returned from the request.
	   *   @return [Promise] A promise that represents the state of the request.
	   *   @example Sending a request using promises.
	   *     var request = s3.putObject({Bucket: 'bucket', Key: 'key'});
	   *     var result = request.promise();
	   *     result.then(function(data) { ... }, function(error) { ... });
	   */
	
	  /**
	   * @api private
	   */
	  build: function build(callback) {
	    return this.runTo('send', callback);
	  },
	
	  /**
	   * @api private
	   */
	  runTo: function runTo(state, done) {
	    this._asm.runTo(state, done, this);
	    return this;
	  },
	
	  /**
	   * Aborts a request, emitting the error and complete events.
	   *
	   * @!macro nobrowser
	   * @example Aborting a request after sending
	   *   var params = {
	   *     Bucket: 'bucket', Key: 'key',
	   *     Body: Buffer.alloc(1024 * 1024 * 5) // 5MB payload
	   *   };
	   *   var request = s3.putObject(params);
	   *   request.send(function (err, data) {
	   *     if (err) console.log("Error:", err.code, err.message);
	   *     else console.log(data);
	   *   });
	   *
	   *   // abort request in 1 second
	   *   setTimeout(request.abort.bind(request), 1000);
	   *
	   *   // prints "Error: RequestAbortedError Request aborted by user"
	   * @return [AWS.Request] the same request object, for chaining.
	   * @since v1.4.0
	   */
	  abort: function abort() {
	    this.removeAllListeners('validateResponse');
	    this.removeAllListeners('extractError');
	    this.on('validateResponse', function addAbortedError(resp) {
	      resp.error = AWS.util.error(new Error('Request aborted by user'), {
	         code: 'RequestAbortedError', retryable: false
	      });
	    });
	
	    if (this.httpRequest.stream && !this.httpRequest.stream.didCallback) { // abort HTTP stream
	      this.httpRequest.stream.abort();
	      if (this.httpRequest._abortCallback) {
	         this.httpRequest._abortCallback();
	      } else {
	        this.removeAllListeners('send'); // haven't sent yet, so let's not
	      }
	    }
	
	    return this;
	  },
	
	  /**
	   * Iterates over each page of results given a pageable request, calling
	   * the provided callback with each page of data. After all pages have been
	   * retrieved, the callback is called with `null` data.
	   *
	   * @note This operation can generate multiple requests to a service.
	   * @example Iterating over multiple pages of objects in an S3 bucket
	   *   var pages = 1;
	   *   s3.listObjects().eachPage(function(err, data) {
	   *     if (err) return;
	   *     console.log("Page", pages++);
	   *     console.log(data);
	   *   });
	   * @example Iterating over multiple pages with an asynchronous callback
	   *   s3.listObjects(params).eachPage(function(err, data, done) {
	   *     doSomethingAsyncAndOrExpensive(function() {
	   *       // The next page of results isn't fetched until done is called
	   *       done();
	   *     });
	   *   });
	   * @callback callback function(err, data, [doneCallback])
	   *   Called with each page of resulting data from the request. If the
	   *   optional `doneCallback` is provided in the function, it must be called
	   *   when the callback is complete.
	   *
	   *   @param err [Error] an error object, if an error occurred.
	   *   @param data [Object] a single page of response data. If there is no
	   *     more data, this object will be `null`.
	   *   @param doneCallback [Function] an optional done callback. If this
	   *     argument is defined in the function declaration, it should be called
	   *     when the next page is ready to be retrieved. This is useful for
	   *     controlling serial pagination across asynchronous operations.
	   *   @return [Boolean] if the callback returns `false`, pagination will
	   *     stop.
	   *
	   * @see AWS.Request.eachItem
	   * @see AWS.Response.nextPage
	   * @since v1.4.0
	   */
	  eachPage: function eachPage(callback) {
	    // Make all callbacks async-ish
	    callback = AWS.util.fn.makeAsync(callback, 3);
	
	    function wrappedCallback(response) {
	      callback.call(response, response.error, response.data, function (result) {
	        if (result === false) return;
	
	        if (response.hasNextPage()) {
	          response.nextPage().on('complete', wrappedCallback).send();
	        } else {
	          callback.call(response, null, null, AWS.util.fn.noop);
	        }
	      });
	    }
	
	    this.on('complete', wrappedCallback).send();
	  },
	
	  /**
	   * Enumerates over individual items of a request, paging the responses if
	   * necessary.
	   *
	   * @api experimental
	   * @since v1.4.0
	   */
	  eachItem: function eachItem(callback) {
	    var self = this;
	    function wrappedCallback(err, data) {
	      if (err) return callback(err, null);
	      if (data === null) return callback(null, null);
	
	      var config = self.service.paginationConfig(self.operation);
	      var resultKey = config.resultKey;
	      if (Array.isArray(resultKey)) resultKey = resultKey[0];
	      var items = jmespath.search(data, resultKey);
	      var continueIteration = true;
	      AWS.util.arrayEach(items, function(item) {
	        continueIteration = callback(null, item);
	        if (continueIteration === false) {
	          return AWS.util.abort;
	        }
	      });
	      return continueIteration;
	    }
	
	    this.eachPage(wrappedCallback);
	  },
	
	  /**
	   * @return [Boolean] whether the operation can return multiple pages of
	   *   response data.
	   * @see AWS.Response.eachPage
	   * @since v1.4.0
	   */
	  isPageable: function isPageable() {
	    return this.service.paginationConfig(this.operation) ? true : false;
	  },
	
	  /**
	   * Sends the request and converts the request object into a readable stream
	   * that can be read from or piped into a writable stream.
	   *
	   * @note The data read from a readable stream contains only
	   *   the raw HTTP body contents.
	   * @example Manually reading from a stream
	   *   request.createReadStream().on('data', function(data) {
	   *     console.log("Got data:", data.toString());
	   *   });
	   * @example Piping a request body into a file
	   *   var out = fs.createWriteStream('/path/to/outfile.jpg');
	   *   s3.service.getObject(params).createReadStream().pipe(out);
	   * @return [Stream] the readable stream object that can be piped
	   *   or read from (by registering 'data' event listeners).
	   * @!macro nobrowser
	   */
	  createReadStream: function createReadStream() {
	    var streams = AWS.util.stream;
	    var req = this;
	    var stream = null;
	
	    if (AWS.HttpClient.streamsApiVersion === 2) {
	      stream = new streams.PassThrough();
	      process.nextTick(function() { req.send(); });
	    } else {
	      stream = new streams.Stream();
	      stream.readable = true;
	
	      stream.sent = false;
	      stream.on('newListener', function(event) {
	        if (!stream.sent && event === 'data') {
	          stream.sent = true;
	          process.nextTick(function() { req.send(); });
	        }
	      });
	    }
	
	    this.on('error', function(err) {
	      stream.emit('error', err);
	    });
	
	    this.on('httpHeaders', function streamHeaders(statusCode, headers, resp) {
	      if (statusCode < 300) {
	        req.removeListener('httpData', AWS.EventListeners.Core.HTTP_DATA);
	        req.removeListener('httpError', AWS.EventListeners.Core.HTTP_ERROR);
	        req.on('httpError', function streamHttpError(error) {
	          resp.error = error;
	          resp.error.retryable = false;
	        });
	
	        var shouldCheckContentLength = false;
	        var expectedLen;
	        if (req.httpRequest.method !== 'HEAD') {
	          expectedLen = parseInt(headers['content-length'], 10);
	        }
	        if (expectedLen !== undefined && !isNaN(expectedLen) && expectedLen >= 0) {
	          shouldCheckContentLength = true;
	          var receivedLen = 0;
	        }
	
	        var checkContentLengthAndEmit = function checkContentLengthAndEmit() {
	          if (shouldCheckContentLength && receivedLen !== expectedLen) {
	            stream.emit('error', AWS.util.error(
	              new Error('Stream content length mismatch. Received ' +
	                receivedLen + ' of ' + expectedLen + ' bytes.'),
	              { code: 'StreamContentLengthMismatch' }
	            ));
	          } else if (AWS.HttpClient.streamsApiVersion === 2) {
	            stream.end();
	          } else {
	            stream.emit('end');
	          }
	        };
	
	        var httpStream = resp.httpResponse.createUnbufferedStream();
	
	        if (AWS.HttpClient.streamsApiVersion === 2) {
	          if (shouldCheckContentLength) {
	            var lengthAccumulator = new streams.PassThrough();
	            lengthAccumulator._write = function(chunk) {
	              if (chunk && chunk.length) {
	                receivedLen += chunk.length;
	              }
	              return streams.PassThrough.prototype._write.apply(this, arguments);
	            };
	
	            lengthAccumulator.on('end', checkContentLengthAndEmit);
	            stream.on('error', function(err) {
	              shouldCheckContentLength = false;
	              httpStream.unpipe(lengthAccumulator);
	              lengthAccumulator.emit('end');
	              lengthAccumulator.end();
	            });
	            httpStream.pipe(lengthAccumulator).pipe(stream, { end: false });
	          } else {
	            httpStream.pipe(stream);
	          }
	        } else {
	
	          if (shouldCheckContentLength) {
	            httpStream.on('data', function(arg) {
	              if (arg && arg.length) {
	                receivedLen += arg.length;
	              }
	            });
	          }
	
	          httpStream.on('data', function(arg) {
	            stream.emit('data', arg);
	          });
	          httpStream.on('end', checkContentLengthAndEmit);
	        }
	
	        httpStream.on('error', function(err) {
	          shouldCheckContentLength = false;
	          stream.emit('error', err);
	        });
	      }
	    });
	
	    return stream;
	  },
	
	  /**
	   * @param [Array,Response] args This should be the response object,
	   *   or an array of args to send to the event.
	   * @api private
	   */
	  emitEvent: function emit(eventName, args, done) {
	    if (typeof args === 'function') { done = args; args = null; }
	    if (!done) done = function() { };
	    if (!args) args = this.eventParameters(eventName, this.response);
	
	    var origEmit = AWS.SequentialExecutor.prototype.emit;
	    origEmit.call(this, eventName, args, function (err) {
	      if (err) this.response.error = err;
	      done.call(this, err);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  eventParameters: function eventParameters(eventName) {
	    switch (eventName) {
	      case 'restart':
	      case 'validate':
	      case 'sign':
	      case 'build':
	      case 'afterValidate':
	      case 'afterBuild':
	        return [this];
	      case 'error':
	        return [this.response.error, this.response];
	      default:
	        return [this.response];
	    }
	  },
	
	  /**
	   * @api private
	   */
	  presign: function presign(expires, callback) {
	    if (!callback && typeof expires === 'function') {
	      callback = expires;
	      expires = null;
	    }
	    return new AWS.Signers.Presign().sign(this.toGet(), expires, callback);
	  },
	
	  /**
	   * @api private
	   */
	  isPresigned: function isPresigned() {
	    return Object.prototype.hasOwnProperty.call(this.httpRequest.headers, 'presigned-expires');
	  },
	
	  /**
	   * @api private
	   */
	  toUnauthenticated: function toUnauthenticated() {
	    this._unAuthenticated = true;
	    this.removeListener('validate', AWS.EventListeners.Core.VALIDATE_CREDENTIALS);
	    this.removeListener('sign', AWS.EventListeners.Core.SIGN);
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  toGet: function toGet() {
	    if (this.service.api.protocol === 'query' ||
	        this.service.api.protocol === 'ec2') {
	      this.removeListener('build', this.buildAsGet);
	      this.addListener('build', this.buildAsGet);
	    }
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  buildAsGet: function buildAsGet(request) {
	    request.httpRequest.method = 'GET';
	    request.httpRequest.path = request.service.endpoint.path +
	                               '?' + request.httpRequest.body;
	    request.httpRequest.body = '';
	
	    // don't need these headers on a GET request
	    delete request.httpRequest.headers['Content-Length'];
	    delete request.httpRequest.headers['Content-Type'];
	  },
	
	  /**
	   * @api private
	   */
	  haltHandlersOnError: function haltHandlersOnError() {
	    this._haltHandlersOnError = true;
	  }
	});
	
	/**
	 * @api private
	 */
	AWS.Request.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.promise = function promise() {
	    var self = this;
	    // append to user agent
	    this.httpRequest.appendToUserAgent('promise');
	    return new PromiseDependency(function(resolve, reject) {
	      self.on('complete', function(resp) {
	        if (resp.error) {
	          reject(resp.error);
	        } else {
	          // define $response property so that it is not enumberable
	          // this prevents circular reference errors when stringifying the JSON object
	          resolve(Object.defineProperty(
	            resp.data || {},
	            '$response',
	            {value: resp}
	          ));
	        }
	      });
	      self.runTo();
	    });
	  };
	};
	
	/**
	 * @api private
	 */
	AWS.Request.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.promise;
	};
	
	AWS.util.addPromises(AWS.Request);
	
	AWS.util.mixin(AWS.Request, AWS.SequentialExecutor);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2012-2013 Amazon.com, Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"). You
	 * may not use this file except in compliance with the License. A copy of
	 * the License is located at
	 *
	 *     http://aws.amazon.com/apache2.0/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific
	 * language governing permissions and limitations under the License.
	 */
	
	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var inherit = AWS.util.inherit;
	var jmespath = __webpack_require__(42);
	
	/**
	 * @api private
	 */
	function CHECK_ACCEPTORS(resp) {
	  var waiter = resp.request._waiter;
	  var acceptors = waiter.config.acceptors;
	  var acceptorMatched = false;
	  var state = 'retry';
	
	  acceptors.forEach(function(acceptor) {
	    if (!acceptorMatched) {
	      var matcher = waiter.matchers[acceptor.matcher];
	      if (matcher && matcher(resp, acceptor.expected, acceptor.argument)) {
	        acceptorMatched = true;
	        state = acceptor.state;
	      }
	    }
	  });
	
	  if (!acceptorMatched && resp.error) state = 'failure';
	
	  if (state === 'success') {
	    waiter.setSuccess(resp);
	  } else {
	    waiter.setError(resp, state === 'retry');
	  }
	}
	
	/**
	 * @api private
	 */
	AWS.ResourceWaiter = inherit({
	  /**
	   * Waits for a given state on a service object
	   * @param service [Service] the service object to wait on
	   * @param state [String] the state (defined in waiter configuration) to wait
	   *   for.
	   * @example Create a waiter for running EC2 instances
	   *   var ec2 = new AWS.EC2;
	   *   var waiter = new AWS.ResourceWaiter(ec2, 'instanceRunning');
	   */
	  constructor: function constructor(service, state) {
	    this.service = service;
	    this.state = state;
	    this.loadWaiterConfig(this.state);
	  },
	
	  service: null,
	
	  state: null,
	
	  config: null,
	
	  matchers: {
	    path: function(resp, expected, argument) {
	      try {
	        var result = jmespath.search(resp.data, argument);
	      } catch (err) {
	        return false;
	      }
	
	      return jmespath.strictDeepEqual(result,expected);
	    },
	
	    pathAll: function(resp, expected, argument) {
	      try {
	        var results = jmespath.search(resp.data, argument);
	      } catch (err) {
	        return false;
	      }
	
	      if (!Array.isArray(results)) results = [results];
	      var numResults = results.length;
	      if (!numResults) return false;
	      for (var ind = 0 ; ind < numResults; ind++) {
	        if (!jmespath.strictDeepEqual(results[ind], expected)) {
	          return false;
	        }
	      }
	      return true;
	    },
	
	    pathAny: function(resp, expected, argument) {
	      try {
	        var results = jmespath.search(resp.data, argument);
	      } catch (err) {
	        return false;
	      }
	
	      if (!Array.isArray(results)) results = [results];
	      var numResults = results.length;
	      for (var ind = 0 ; ind < numResults; ind++) {
	        if (jmespath.strictDeepEqual(results[ind], expected)) {
	          return true;
	        }
	      }
	      return false;
	    },
	
	    status: function(resp, expected) {
	      var statusCode = resp.httpResponse.statusCode;
	      return (typeof statusCode === 'number') && (statusCode === expected);
	    },
	
	    error: function(resp, expected) {
	      if (typeof expected === 'string' && resp.error) {
	        return expected === resp.error.code;
	      }
	      // if expected is not string, can be boolean indicating presence of error
	      return expected === !!resp.error;
	    }
	  },
	
	  listeners: new AWS.SequentialExecutor().addNamedListeners(function(add) {
	    add('RETRY_CHECK', 'retry', function(resp) {
	      var waiter = resp.request._waiter;
	      if (resp.error && resp.error.code === 'ResourceNotReady') {
	        resp.error.retryDelay = (waiter.config.delay || 0) * 1000;
	      }
	    });
	
	    add('CHECK_OUTPUT', 'extractData', CHECK_ACCEPTORS);
	
	    add('CHECK_ERROR', 'extractError', CHECK_ACCEPTORS);
	  }),
	
	  /**
	   * @return [AWS.Request]
	   */
	  wait: function wait(params, callback) {
	    if (typeof params === 'function') {
	      callback = params; params = undefined;
	    }
	
	    if (params && params.$waiter) {
	      params = AWS.util.copy(params);
	      if (typeof params.$waiter.delay === 'number') {
	        this.config.delay = params.$waiter.delay;
	      }
	      if (typeof params.$waiter.maxAttempts === 'number') {
	        this.config.maxAttempts = params.$waiter.maxAttempts;
	      }
	      delete params.$waiter;
	    }
	
	    var request = this.service.makeRequest(this.config.operation, params);
	    request._waiter = this;
	    request.response.maxRetries = this.config.maxAttempts;
	    request.addListeners(this.listeners);
	
	    if (callback) request.send(callback);
	    return request;
	  },
	
	  setSuccess: function setSuccess(resp) {
	    resp.error = null;
	    resp.data = resp.data || {};
	    resp.request.removeAllListeners('extractData');
	  },
	
	  setError: function setError(resp, retryable) {
	    resp.data = null;
	    resp.error = AWS.util.error(resp.error || new Error(), {
	      code: 'ResourceNotReady',
	      message: 'Resource is not in the state ' + this.state,
	      retryable: retryable
	    });
	  },
	
	  /**
	   * Loads waiter configuration from API configuration
	   *
	   * @api private
	   */
	  loadWaiterConfig: function loadWaiterConfig(state) {
	    if (!this.service.api.waiters[state]) {
	      throw new AWS.util.error(new Error(), {
	        code: 'StateNotFoundError',
	        message: 'State ' + state + ' not found.'
	      });
	    }
	
	    this.config = AWS.util.copy(this.service.api.waiters[state]);
	  }
	});


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var inherit = AWS.util.inherit;
	var jmespath = __webpack_require__(42);
	
	/**
	 * This class encapsulates the response information
	 * from a service request operation sent through {AWS.Request}.
	 * The response object has two main properties for getting information
	 * back from a request:
	 *
	 * ## The `data` property
	 *
	 * The `response.data` property contains the serialized object data
	 * retrieved from the service request. For instance, for an
	 * Amazon DynamoDB `listTables` method call, the response data might
	 * look like:
	 *
	 * ```
	 * > resp.data
	 * { TableNames:
	 *    [ 'table1', 'table2', ... ] }
	 * ```
	 *
	 * The `data` property can be null if an error occurs (see below).
	 *
	 * ## The `error` property
	 *
	 * In the event of a service error (or transfer error), the
	 * `response.error` property will be filled with the given
	 * error data in the form:
	 *
	 * ```
	 * { code: 'SHORT_UNIQUE_ERROR_CODE',
	 *   message: 'Some human readable error message' }
	 * ```
	 *
	 * In the case of an error, the `data` property will be `null`.
	 * Note that if you handle events that can be in a failure state,
	 * you should always check whether `response.error` is set
	 * before attempting to access the `response.data` property.
	 *
	 * @!attribute data
	 *   @readonly
	 *   @!group Data Properties
	 *   @note Inside of a {AWS.Request~httpData} event, this
	 *     property contains a single raw packet instead of the
	 *     full de-serialized service response.
	 *   @return [Object] the de-serialized response data
	 *     from the service.
	 *
	 * @!attribute error
	 *   An structure containing information about a service
	 *   or networking error.
	 *   @readonly
	 *   @!group Data Properties
	 *   @note This attribute is only filled if a service or
	 *     networking error occurs.
	 *   @return [Error]
	 *     * code [String] a unique short code representing the
	 *       error that was emitted.
	 *     * message [String] a longer human readable error message
	 *     * retryable [Boolean] whether the error message is
	 *       retryable.
	 *     * statusCode [Numeric] in the case of a request that reached the service,
	 *       this value contains the response status code.
	 *     * time [Date] the date time object when the error occurred.
	 *     * hostname [String] set when a networking error occurs to easily
	 *       identify the endpoint of the request.
	 *     * region [String] set when a networking error occurs to easily
	 *       identify the region of the request.
	 *
	 * @!attribute requestId
	 *   @readonly
	 *   @!group Data Properties
	 *   @return [String] the unique request ID associated with the response.
	 *     Log this value when debugging requests for AWS support.
	 *
	 * @!attribute retryCount
	 *   @readonly
	 *   @!group Operation Properties
	 *   @return [Integer] the number of retries that were
	 *     attempted before the request was completed.
	 *
	 * @!attribute redirectCount
	 *   @readonly
	 *   @!group Operation Properties
	 *   @return [Integer] the number of redirects that were
	 *     followed before the request was completed.
	 *
	 * @!attribute httpResponse
	 *   @readonly
	 *   @!group HTTP Properties
	 *   @return [AWS.HttpResponse] the raw HTTP response object
	 *     containing the response headers and body information
	 *     from the server.
	 *
	 * @see AWS.Request
	 */
	AWS.Response = inherit({
	
	  /**
	   * @api private
	   */
	  constructor: function Response(request) {
	    this.request = request;
	    this.data = null;
	    this.error = null;
	    this.retryCount = 0;
	    this.redirectCount = 0;
	    this.httpResponse = new AWS.HttpResponse();
	    if (request) {
	      this.maxRetries = request.service.numRetries();
	      this.maxRedirects = request.service.config.maxRedirects;
	    }
	  },
	
	  /**
	   * Creates a new request for the next page of response data, calling the
	   * callback with the page data if a callback is provided.
	   *
	   * @callback callback function(err, data)
	   *   Called when a page of data is returned from the next request.
	   *
	   *   @param err [Error] an error object, if an error occurred in the request
	   *   @param data [Object] the next page of data, or null, if there are no
	   *     more pages left.
	   * @return [AWS.Request] the request object for the next page of data
	   * @return [null] if no callback is provided and there are no pages left
	   *   to retrieve.
	   * @since v1.4.0
	   */
	  nextPage: function nextPage(callback) {
	    var config;
	    var service = this.request.service;
	    var operation = this.request.operation;
	    try {
	      config = service.paginationConfig(operation, true);
	    } catch (e) { this.error = e; }
	
	    if (!this.hasNextPage()) {
	      if (callback) callback(this.error, null);
	      else if (this.error) throw this.error;
	      return null;
	    }
	
	    var params = AWS.util.copy(this.request.params);
	    if (!this.nextPageTokens) {
	      return callback ? callback(null, null) : null;
	    } else {
	      var inputTokens = config.inputToken;
	      if (typeof inputTokens === 'string') inputTokens = [inputTokens];
	      for (var i = 0; i < inputTokens.length; i++) {
	        params[inputTokens[i]] = this.nextPageTokens[i];
	      }
	      return service.makeRequest(this.request.operation, params, callback);
	    }
	  },
	
	  /**
	   * @return [Boolean] whether more pages of data can be returned by further
	   *   requests
	   * @since v1.4.0
	   */
	  hasNextPage: function hasNextPage() {
	    this.cacheNextPageTokens();
	    if (this.nextPageTokens) return true;
	    if (this.nextPageTokens === undefined) return undefined;
	    else return false;
	  },
	
	  /**
	   * @api private
	   */
	  cacheNextPageTokens: function cacheNextPageTokens() {
	    if (Object.prototype.hasOwnProperty.call(this, 'nextPageTokens')) return this.nextPageTokens;
	    this.nextPageTokens = undefined;
	
	    var config = this.request.service.paginationConfig(this.request.operation);
	    if (!config) return this.nextPageTokens;
	
	    this.nextPageTokens = null;
	    if (config.moreResults) {
	      if (!jmespath.search(this.data, config.moreResults)) {
	        return this.nextPageTokens;
	      }
	    }
	
	    var exprs = config.outputToken;
	    if (typeof exprs === 'string') exprs = [exprs];
	    AWS.util.arrayEach.call(this, exprs, function (expr) {
	      var output = jmespath.search(this.data, expr);
	      if (output) {
	        this.nextPageTokens = this.nextPageTokens || [];
	        this.nextPageTokens.push(output);
	      }
	    });
	
	    return this.nextPageTokens;
	  }
	
	});


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * @api private
	 * @!method on(eventName, callback)
	 *   Registers an event listener callback for the event given by `eventName`.
	 *   Parameters passed to the callback function depend on the individual event
	 *   being triggered. See the event documentation for those parameters.
	 *
	 *   @param eventName [String] the event name to register the listener for
	 *   @param callback [Function] the listener callback function
	 *   @param toHead [Boolean] attach the listener callback to the head of callback array if set to true.
	 *     Default to be false.
	 *   @return [AWS.SequentialExecutor] the same object for chaining
	 */
	AWS.SequentialExecutor = AWS.util.inherit({
	
	  constructor: function SequentialExecutor() {
	    this._events = {};
	  },
	
	  /**
	   * @api private
	   */
	  listeners: function listeners(eventName) {
	    return this._events[eventName] ? this._events[eventName].slice(0) : [];
	  },
	
	  on: function on(eventName, listener, toHead) {
	    if (this._events[eventName]) {
	      toHead ?
	        this._events[eventName].unshift(listener) :
	        this._events[eventName].push(listener);
	    } else {
	      this._events[eventName] = [listener];
	    }
	    return this;
	  },
	
	  onAsync: function onAsync(eventName, listener, toHead) {
	    listener._isAsync = true;
	    return this.on(eventName, listener, toHead);
	  },
	
	  removeListener: function removeListener(eventName, listener) {
	    var listeners = this._events[eventName];
	    if (listeners) {
	      var length = listeners.length;
	      var position = -1;
	      for (var i = 0; i < length; ++i) {
	        if (listeners[i] === listener) {
	          position = i;
	        }
	      }
	      if (position > -1) {
	        listeners.splice(position, 1);
	      }
	    }
	    return this;
	  },
	
	  removeAllListeners: function removeAllListeners(eventName) {
	    if (eventName) {
	      delete this._events[eventName];
	    } else {
	      this._events = {};
	    }
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  emit: function emit(eventName, eventArgs, doneCallback) {
	    if (!doneCallback) doneCallback = function() { };
	    var listeners = this.listeners(eventName);
	    var count = listeners.length;
	    this.callListeners(listeners, eventArgs, doneCallback);
	    return count > 0;
	  },
	
	  /**
	   * @api private
	   */
	  callListeners: function callListeners(listeners, args, doneCallback, prevError) {
	    var self = this;
	    var error = prevError || null;
	
	    function callNextListener(err) {
	      if (err) {
	        error = AWS.util.error(error || new Error(), err);
	        if (self._haltHandlersOnError) {
	          return doneCallback.call(self, error);
	        }
	      }
	      self.callListeners(listeners, args, doneCallback, error);
	    }
	
	    while (listeners.length > 0) {
	      var listener = listeners.shift();
	      if (listener._isAsync) { // asynchronous listener
	        listener.apply(self, args.concat([callNextListener]));
	        return; // stop here, callNextListener will continue
	      } else { // synchronous listener
	        try {
	          listener.apply(self, args);
	        } catch (err) {
	          error = AWS.util.error(error || new Error(), err);
	        }
	        if (error && self._haltHandlersOnError) {
	          doneCallback.call(self, error);
	          return;
	        }
	      }
	    }
	    doneCallback.call(self, error);
	  },
	
	  /**
	   * Adds or copies a set of listeners from another list of
	   * listeners or SequentialExecutor object.
	   *
	   * @param listeners [map<String,Array<Function>>, AWS.SequentialExecutor]
	   *   a list of events and callbacks, or an event emitter object
	   *   containing listeners to add to this emitter object.
	   * @return [AWS.SequentialExecutor] the emitter object, for chaining.
	   * @example Adding listeners from a map of listeners
	   *   emitter.addListeners({
	   *     event1: [function() { ... }, function() { ... }],
	   *     event2: [function() { ... }]
	   *   });
	   *   emitter.emit('event1'); // emitter has event1
	   *   emitter.emit('event2'); // emitter has event2
	   * @example Adding listeners from another emitter object
	   *   var emitter1 = new AWS.SequentialExecutor();
	   *   emitter1.on('event1', function() { ... });
	   *   emitter1.on('event2', function() { ... });
	   *   var emitter2 = new AWS.SequentialExecutor();
	   *   emitter2.addListeners(emitter1);
	   *   emitter2.emit('event1'); // emitter2 has event1
	   *   emitter2.emit('event2'); // emitter2 has event2
	   */
	  addListeners: function addListeners(listeners) {
	    var self = this;
	
	    // extract listeners if parameter is an SequentialExecutor object
	    if (listeners._events) listeners = listeners._events;
	
	    AWS.util.each(listeners, function(event, callbacks) {
	      if (typeof callbacks === 'function') callbacks = [callbacks];
	      AWS.util.arrayEach(callbacks, function(callback) {
	        self.on(event, callback);
	      });
	    });
	
	    return self;
	  },
	
	  /**
	   * Registers an event with {on} and saves the callback handle function
	   * as a property on the emitter object using a given `name`.
	   *
	   * @param name [String] the property name to set on this object containing
	   *   the callback function handle so that the listener can be removed in
	   *   the future.
	   * @param (see on)
	   * @return (see on)
	   * @example Adding a named listener DATA_CALLBACK
	   *   var listener = function() { doSomething(); };
	   *   emitter.addNamedListener('DATA_CALLBACK', 'data', listener);
	   *
	   *   // the following prints: true
	   *   console.log(emitter.DATA_CALLBACK == listener);
	   */
	  addNamedListener: function addNamedListener(name, eventName, callback, toHead) {
	    this[name] = callback;
	    this.addListener(eventName, callback, toHead);
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  addNamedAsyncListener: function addNamedAsyncListener(name, eventName, callback, toHead) {
	    callback._isAsync = true;
	    return this.addNamedListener(name, eventName, callback, toHead);
	  },
	
	  /**
	   * Helper method to add a set of named listeners using
	   * {addNamedListener}. The callback contains a parameter
	   * with a handle to the `addNamedListener` method.
	   *
	   * @callback callback function(add)
	   *   The callback function is called immediately in order to provide
	   *   the `add` function to the block. This simplifies the addition of
	   *   a large group of named listeners.
	   *   @param add [Function] the {addNamedListener} function to call
	   *     when registering listeners.
	   * @example Adding a set of named listeners
	   *   emitter.addNamedListeners(function(add) {
	   *     add('DATA_CALLBACK', 'data', function() { ... });
	   *     add('OTHER', 'otherEvent', function() { ... });
	   *     add('LAST', 'lastEvent', function() { ... });
	   *   });
	   *
	   *   // these properties are now set:
	   *   emitter.DATA_CALLBACK;
	   *   emitter.OTHER;
	   *   emitter.LAST;
	   */
	  addNamedListeners: function addNamedListeners(callback) {
	    var self = this;
	    callback(
	      function() {
	        self.addNamedListener.apply(self, arguments);
	      },
	      function() {
	        self.addNamedAsyncListener.apply(self, arguments);
	      }
	    );
	    return this;
	  }
	});
	
	/**
	 * {on} is the prefered method.
	 * @api private
	 */
	AWS.SequentialExecutor.prototype.addListener = AWS.SequentialExecutor.prototype.on;
	
	/**
	 * @api private
	 */
	module.exports = AWS.SequentialExecutor;


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var Api = __webpack_require__(__webpack_module_template_argument_1__);
	var regionConfig = __webpack_require__(__webpack_module_template_argument_2__);
	
	var inherit = AWS.util.inherit;
	var clientCount = 0;
	
	/**
	 * The service class representing an AWS service.
	 *
	 * @class_abstract This class is an abstract class.
	 *
	 * @!attribute apiVersions
	 *   @return [Array<String>] the list of API versions supported by this service.
	 *   @readonly
	 */
	AWS.Service = inherit({
	  /**
	   * Create a new service object with a configuration object
	   *
	   * @param config [map] a map of configuration options
	   */
	  constructor: function Service(config) {
	    if (!this.loadServiceClass) {
	      throw AWS.util.error(new Error(),
	        'Service must be constructed with `new\' operator');
	    }
	    var ServiceClass = this.loadServiceClass(config || {});
	    if (ServiceClass) {
	      var originalConfig = AWS.util.copy(config);
	      var svc = new ServiceClass(config);
	      Object.defineProperty(svc, '_originalConfig', {
	        get: function() { return originalConfig; },
	        enumerable: false,
	        configurable: true
	      });
	      svc._clientId = ++clientCount;
	      return svc;
	    }
	    this.initialize(config);
	  },
	
	  /**
	   * @api private
	   */
	  initialize: function initialize(config) {
	    var svcConfig = AWS.config[this.serviceIdentifier];
	    this.config = new AWS.Config(AWS.config);
	    if (svcConfig) this.config.update(svcConfig, true);
	    if (config) this.config.update(config, true);
	
	    this.validateService();
	    if (!this.config.endpoint) regionConfig(this);
	
	    this.config.endpoint = this.endpointFromTemplate(this.config.endpoint);
	    this.setEndpoint(this.config.endpoint);
	    //enable attaching listeners to service client
	    AWS.SequentialExecutor.call(this);
	    AWS.Service.addDefaultMonitoringListeners(this);
	    if ((this.config.clientSideMonitoring || AWS.Service._clientSideMonitoring) && this.publisher) {
	      var publisher = this.publisher;
	      this.addNamedListener('PUBLISH_API_CALL', 'apiCall', function PUBLISH_API_CALL(event) {
	        process.nextTick(function() {publisher.eventHandler(event);});
	      });
	      this.addNamedListener('PUBLISH_API_ATTEMPT', 'apiCallAttempt', function PUBLISH_API_ATTEMPT(event) {
	        process.nextTick(function() {publisher.eventHandler(event);});
	      });
	    }
	  },
	
	  /**
	   * @api private
	   */
	  validateService: function validateService() {
	  },
	
	  /**
	   * @api private
	   */
	  loadServiceClass: function loadServiceClass(serviceConfig) {
	    var config = serviceConfig;
	    if (!AWS.util.isEmpty(this.api)) {
	      return null;
	    } else if (config.apiConfig) {
	      return AWS.Service.defineServiceApi(this.constructor, config.apiConfig);
	    } else if (!this.constructor.services) {
	      return null;
	    } else {
	      config = new AWS.Config(AWS.config);
	      config.update(serviceConfig, true);
	      var version = config.apiVersions[this.constructor.serviceIdentifier];
	      version = version || config.apiVersion;
	      return this.getLatestServiceClass(version);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getLatestServiceClass: function getLatestServiceClass(version) {
	    version = this.getLatestServiceVersion(version);
	    if (this.constructor.services[version] === null) {
	      AWS.Service.defineServiceApi(this.constructor, version);
	    }
	
	    return this.constructor.services[version];
	  },
	
	  /**
	   * @api private
	   */
	  getLatestServiceVersion: function getLatestServiceVersion(version) {
	    if (!this.constructor.services || this.constructor.services.length === 0) {
	      throw new Error('No services defined on ' +
	                      this.constructor.serviceIdentifier);
	    }
	
	    if (!version) {
	      version = 'latest';
	    } else if (AWS.util.isType(version, Date)) {
	      version = AWS.util.date.iso8601(version).split('T')[0];
	    }
	
	    if (Object.hasOwnProperty(this.constructor.services, version)) {
	      return version;
	    }
	
	    var keys = Object.keys(this.constructor.services).sort();
	    var selectedVersion = null;
	    for (var i = keys.length - 1; i >= 0; i--) {
	      // versions that end in "*" are not available on disk and can be
	      // skipped, so do not choose these as selectedVersions
	      if (keys[i][keys[i].length - 1] !== '*') {
	        selectedVersion = keys[i];
	      }
	      if (keys[i].substr(0, 10) <= version) {
	        return selectedVersion;
	      }
	    }
	
	    throw new Error('Could not find ' + this.constructor.serviceIdentifier +
	                    ' API to satisfy version constraint `' + version + '\'');
	  },
	
	  /**
	   * @api private
	   */
	  api: {},
	
	  /**
	   * @api private
	   */
	  defaultRetryCount: 3,
	
	  /**
	   * @api private
	   */
	  customizeRequests: function customizeRequests(callback) {
	    if (!callback) {
	      this.customRequestHandler = null;
	    } else if (typeof callback === 'function') {
	      this.customRequestHandler = callback;
	    } else {
	      throw new Error('Invalid callback type \'' + typeof callback + '\' provided in customizeRequests');
	    }
	  },
	
	  /**
	   * Calls an operation on a service with the given input parameters.
	   *
	   * @param operation [String] the name of the operation to call on the service.
	   * @param params [map] a map of input options for the operation
	   * @callback callback function(err, data)
	   *   If a callback is supplied, it is called when a response is returned
	   *   from the service.
	   *   @param err [Error] the error object returned from the request.
	   *     Set to `null` if the request is successful.
	   *   @param data [Object] the de-serialized data returned from
	   *     the request. Set to `null` if a request error occurs.
	   */
	  makeRequest: function makeRequest(operation, params, callback) {
	    if (typeof params === 'function') {
	      callback = params;
	      params = null;
	    }
	
	    params = params || {};
	    if (this.config.params) { // copy only toplevel bound params
	      var rules = this.api.operations[operation];
	      if (rules) {
	        params = AWS.util.copy(params);
	        AWS.util.each(this.config.params, function(key, value) {
	          if (rules.input.members[key]) {
	            if (params[key] === undefined || params[key] === null) {
	              params[key] = value;
	            }
	          }
	        });
	      }
	    }
	
	    var request = new AWS.Request(this, operation, params);
	    this.addAllRequestListeners(request);
	    this.attachMonitoringEmitter(request);
	    if (callback) request.send(callback);
	    return request;
	  },
	
	  /**
	   * Calls an operation on a service with the given input parameters, without
	   * any authentication data. This method is useful for "public" API operations.
	   *
	   * @param operation [String] the name of the operation to call on the service.
	   * @param params [map] a map of input options for the operation
	   * @callback callback function(err, data)
	   *   If a callback is supplied, it is called when a response is returned
	   *   from the service.
	   *   @param err [Error] the error object returned from the request.
	   *     Set to `null` if the request is successful.
	   *   @param data [Object] the de-serialized data returned from
	   *     the request. Set to `null` if a request error occurs.
	   */
	  makeUnauthenticatedRequest: function makeUnauthenticatedRequest(operation, params, callback) {
	    if (typeof params === 'function') {
	      callback = params;
	      params = {};
	    }
	
	    var request = this.makeRequest(operation, params).toUnauthenticated();
	    return callback ? request.send(callback) : request;
	  },
	
	  /**
	   * Waits for a given state
	   *
	   * @param state [String] the state on the service to wait for
	   * @param params [map] a map of parameters to pass with each request
	   * @option params $waiter [map] a map of configuration options for the waiter
	   * @option params $waiter.delay [Number] The number of seconds to wait between
	   *                                       requests
	   * @option params $waiter.maxAttempts [Number] The maximum number of requests
	   *                                             to send while waiting
	   * @callback callback function(err, data)
	   *   If a callback is supplied, it is called when a response is returned
	   *   from the service.
	   *   @param err [Error] the error object returned from the request.
	   *     Set to `null` if the request is successful.
	   *   @param data [Object] the de-serialized data returned from
	   *     the request. Set to `null` if a request error occurs.
	   */
	  waitFor: function waitFor(state, params, callback) {
	    var waiter = new AWS.ResourceWaiter(this, state);
	    return waiter.wait(params, callback);
	  },
	
	  /**
	   * @api private
	   */
	  addAllRequestListeners: function addAllRequestListeners(request) {
	    var list = [AWS.events, AWS.EventListeners.Core, this.serviceInterface(),
	                AWS.EventListeners.CorePost];
	    for (var i = 0; i < list.length; i++) {
	      if (list[i]) request.addListeners(list[i]);
	    }
	
	    // disable parameter validation
	    if (!this.config.paramValidation) {
	      request.removeListener('validate',
	        AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	    }
	
	    if (this.config.logger) { // add logging events
	      request.addListeners(AWS.EventListeners.Logger);
	    }
	
	    this.setupRequestListeners(request);
	    // call prototype's customRequestHandler
	    if (typeof this.constructor.prototype.customRequestHandler === 'function') {
	      this.constructor.prototype.customRequestHandler(request);
	    }
	    // call instance's customRequestHandler
	    if (Object.prototype.hasOwnProperty.call(this, 'customRequestHandler') && typeof this.customRequestHandler === 'function') {
	      this.customRequestHandler(request);
	    }
	  },
	
	  /**
	   * Event recording metrics for a whole API call.
	   * @returns {object} a subset of api call metrics
	   * @api private
	   */
	  apiCallEvent: function apiCallEvent(request) {
	    var api = request.service.api.operations[request.operation];
	    var monitoringEvent = {
	      Type: 'ApiCall',
	      Api: api ? api.name : request.operation,
	      Version: 1,
	      Service: request.service.api.serviceId || request.service.api.endpointPrefix,
	      Region: request.httpRequest.region,
	      MaxRetriesExceeded: 0,
	      UserAgent: request.httpRequest.getUserAgent(),
	    };
	    var response = request.response;
	    if (response.httpResponse.statusCode) {
	      monitoringEvent.FinalHttpStatusCode = response.httpResponse.statusCode;
	    }
	    if (response.error) {
	      var error = response.error;
	      var statusCode = response.httpResponse.statusCode;
	      if (statusCode > 299) {
	        if (error.code) monitoringEvent.FinalAwsException = error.code;
	        if (error.message) monitoringEvent.FinalAwsExceptionMessage = error.message;
	      } else {
	        if (error.code || error.name) monitoringEvent.FinalSdkException = error.code || error.name;
	        if (error.message) monitoringEvent.FinalSdkExceptionMessage = error.message;
	      }
	    }
	    return monitoringEvent;
	  },
	
	  /**
	   * Event recording metrics for an API call attempt.
	   * @returns {object} a subset of api call attempt metrics
	   * @api private
	   */
	  apiAttemptEvent: function apiAttemptEvent(request) {
	    var api = request.service.api.operations[request.operation];
	    var monitoringEvent = {
	      Type: 'ApiCallAttempt',
	      Api: api ? api.name : request.operation,
	      Version: 1,
	      Service: request.service.api.serviceId || request.service.api.endpointPrefix,
	      Fqdn: request.httpRequest.endpoint.hostname,
	      UserAgent: request.httpRequest.getUserAgent(),
	    };
	    var response = request.response;
	    if (response.httpResponse.statusCode) {
	      monitoringEvent.HttpStatusCode = response.httpResponse.statusCode;
	    }
	    if (
	      !request._unAuthenticated &&
	      request.service.config.credentials &&
	      request.service.config.credentials.accessKeyId
	    ) {
	      monitoringEvent.AccessKey = request.service.config.credentials.accessKeyId;
	    }
	    if (!response.httpResponse.headers) return monitoringEvent;
	    if (request.httpRequest.headers['x-amz-security-token']) {
	      monitoringEvent.SessionToken = request.httpRequest.headers['x-amz-security-token'];
	    }
	    if (response.httpResponse.headers['x-amzn-requestid']) {
	      monitoringEvent.XAmznRequestId = response.httpResponse.headers['x-amzn-requestid'];
	    }
	    if (response.httpResponse.headers['x-amz-request-id']) {
	      monitoringEvent.XAmzRequestId = response.httpResponse.headers['x-amz-request-id'];
	    }
	    if (response.httpResponse.headers['x-amz-id-2']) {
	      monitoringEvent.XAmzId2 = response.httpResponse.headers['x-amz-id-2'];
	    }
	    return monitoringEvent;
	  },
	
	  /**
	   * Add metrics of failed request.
	   * @api private
	   */
	  attemptFailEvent: function attemptFailEvent(request) {
	    var monitoringEvent = this.apiAttemptEvent(request);
	    var response = request.response;
	    var error = response.error;
	    if (response.httpResponse.statusCode > 299 ) {
	      if (error.code) monitoringEvent.AwsException = error.code;
	      if (error.message) monitoringEvent.AwsExceptionMessage = error.message;
	    } else {
	      if (error.code || error.name) monitoringEvent.SdkException = error.code || error.name;
	      if (error.message) monitoringEvent.SdkExceptionMessage = error.message;
	    }
	    return monitoringEvent;
	  },
	
	  /**
	   * Attach listeners to request object to fetch metrics of each request
	   * and emit data object through \'ApiCall\' and \'ApiCallAttempt\' events.
	   * @api private
	   */
	  attachMonitoringEmitter: function attachMonitoringEmitter(request) {
	    var attemptTimestamp; //timestamp marking the beginning of a request attempt
	    var attemptStartRealTime; //Start time of request attempt. Used to calculating attemptLatency
	    var attemptLatency; //latency from request sent out to http response reaching SDK
	    var callStartRealTime; //Start time of API call. Used to calculating API call latency
	    var attemptCount = 0; //request.retryCount is not reliable here
	    var region; //region cache region for each attempt since it can be updated in plase (e.g. s3)
	    var callTimestamp; //timestamp when the request is created
	    var self = this;
	    var addToHead = true;
	
	    request.on('validate', function () {
	      callStartRealTime = AWS.util.realClock.now();
	      callTimestamp = Date.now();
	    }, addToHead);
	    request.on('sign', function () {
	      attemptStartRealTime = AWS.util.realClock.now();
	      attemptTimestamp = Date.now();
	      region = request.httpRequest.region;
	      attemptCount++;
	    }, addToHead);
	    request.on('validateResponse', function() {
	      attemptLatency = Math.round(AWS.util.realClock.now() - attemptStartRealTime);
	    });
	    request.addNamedListener('API_CALL_ATTEMPT', 'success', function API_CALL_ATTEMPT() {
	      var apiAttemptEvent = self.apiAttemptEvent(request);
	      apiAttemptEvent.Timestamp = attemptTimestamp;
	      apiAttemptEvent.AttemptLatency = attemptLatency >= 0 ? attemptLatency : 0;
	      apiAttemptEvent.Region = region;
	      self.emit('apiCallAttempt', [apiAttemptEvent]);
	    });
	    request.addNamedListener('API_CALL_ATTEMPT_RETRY', 'retry', function API_CALL_ATTEMPT_RETRY() {
	      var apiAttemptEvent = self.attemptFailEvent(request);
	      apiAttemptEvent.Timestamp = attemptTimestamp;
	      //attemptLatency may not be available if fail before response
	      attemptLatency = attemptLatency ||
	        Math.round(AWS.util.realClock.now() - attemptStartRealTime);
	      apiAttemptEvent.AttemptLatency = attemptLatency >= 0 ? attemptLatency : 0;
	      apiAttemptEvent.Region = region;
	      self.emit('apiCallAttempt', [apiAttemptEvent]);
	    });
	    request.addNamedListener('API_CALL', 'complete', function API_CALL() {
	      var apiCallEvent = self.apiCallEvent(request);
	      apiCallEvent.AttemptCount = attemptCount;
	      if (apiCallEvent.AttemptCount <= 0) return;
	      apiCallEvent.Timestamp = callTimestamp;
	      var latency = Math.round(AWS.util.realClock.now() - callStartRealTime);
	      apiCallEvent.Latency = latency >= 0 ? latency : 0;
	      var response = request.response;
	      if (
	        typeof response.retryCount === 'number' &&
	        typeof response.maxRetries === 'number' &&
	        (response.retryCount >= response.maxRetries)
	      ) {
	        apiCallEvent.MaxRetriesExceeded = 1;
	      }
	      self.emit('apiCall', [apiCallEvent]);
	    });
	  },
	
	  /**
	   * Override this method to setup any custom request listeners for each
	   * new request to the service.
	   *
	   * @method_abstract This is an abstract method.
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	  },
	
	  /**
	   * Gets the signer class for a given request
	   * @api private
	   */
	  getSignerClass: function getSignerClass(request) {
	    var version;
	    // get operation authtype if present
	    var operation = null;
	    var authtype = '';
	    if (request) {
	      var operations = request.service.api.operations || {};
	      operation = operations[request.operation] || null;
	      authtype = operation ? operation.authtype : '';
	    }
	    if (this.config.signatureVersion) {
	      version = this.config.signatureVersion;
	    } else if (authtype === 'v4' || authtype === 'v4-unsigned-body') {
	      version = 'v4';
	    } else {
	      version = this.api.signatureVersion;
	    }
	    return AWS.Signers.RequestSigner.getVersion(version);
	  },
	
	  /**
	   * @api private
	   */
	  serviceInterface: function serviceInterface() {
	    switch (this.api.protocol) {
	      case 'ec2': return AWS.EventListeners.Query;
	      case 'query': return AWS.EventListeners.Query;
	      case 'json': return AWS.EventListeners.Json;
	      case 'rest-json': return AWS.EventListeners.RestJson;
	      case 'rest-xml': return AWS.EventListeners.RestXml;
	    }
	    if (this.api.protocol) {
	      throw new Error('Invalid service `protocol\' ' +
	        this.api.protocol + ' in API config');
	    }
	  },
	
	  /**
	   * @api private
	   */
	  successfulResponse: function successfulResponse(resp) {
	    return resp.httpResponse.statusCode < 300;
	  },
	
	  /**
	   * How many times a failed request should be retried before giving up.
	   * the defaultRetryCount can be overriden by service classes.
	   *
	   * @api private
	   */
	  numRetries: function numRetries() {
	    if (this.config.maxRetries !== undefined) {
	      return this.config.maxRetries;
	    } else {
	      return this.defaultRetryCount;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  retryDelays: function retryDelays(retryCount) {
	    return AWS.util.calculateRetryDelay(retryCount, this.config.retryDelayOptions);
	  },
	
	  /**
	   * @api private
	   */
	  retryableError: function retryableError(error) {
	    if (this.timeoutError(error)) return true;
	    if (this.networkingError(error)) return true;
	    if (this.expiredCredentialsError(error)) return true;
	    if (this.throttledError(error)) return true;
	    if (error.statusCode >= 500) return true;
	    return false;
	  },
	
	  /**
	   * @api private
	   */
	  networkingError: function networkingError(error) {
	    return error.code === 'NetworkingError';
	  },
	
	  /**
	   * @api private
	   */
	  timeoutError: function timeoutError(error) {
	    return error.code === 'TimeoutError';
	  },
	
	  /**
	   * @api private
	   */
	  expiredCredentialsError: function expiredCredentialsError(error) {
	    // TODO : this only handles *one* of the expired credential codes
	    return (error.code === 'ExpiredTokenException');
	  },
	
	  /**
	   * @api private
	   */
	  clockSkewError: function clockSkewError(error) {
	    switch (error.code) {
	      case 'RequestTimeTooSkewed':
	      case 'RequestExpired':
	      case 'InvalidSignatureException':
	      case 'SignatureDoesNotMatch':
	      case 'AuthFailure':
	      case 'RequestInTheFuture':
	        return true;
	      default: return false;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getSkewCorrectedDate: function getSkewCorrectedDate() {
	    return new Date(Date.now() + this.config.systemClockOffset);
	  },
	
	  /**
	   * @api private
	   */
	  applyClockOffset: function applyClockOffset(newServerTime) {
	    if (newServerTime) {
	      this.config.systemClockOffset = newServerTime - Date.now();
	    }
	  },
	
	  /**
	   * @api private
	   */
	  isClockSkewed: function isClockSkewed(newServerTime) {
	    if (newServerTime) {
	      return Math.abs(this.getSkewCorrectedDate().getTime() - newServerTime) >= 30000;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  throttledError: function throttledError(error) {
	    // this logic varies between services
	    switch (error.code) {
	      case 'ProvisionedThroughputExceededException':
	      case 'Throttling':
	      case 'ThrottlingException':
	      case 'RequestLimitExceeded':
	      case 'RequestThrottled':
	      case 'RequestThrottledException':
	      case 'TooManyRequestsException':
	      case 'TransactionInProgressException': //dynamodb
	        return true;
	      default:
	        return false;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  endpointFromTemplate: function endpointFromTemplate(endpoint) {
	    if (typeof endpoint !== 'string') return endpoint;
	
	    var e = endpoint;
	    e = e.replace(/\{service\}/g, this.api.endpointPrefix);
	    e = e.replace(/\{region\}/g, this.config.region);
	    e = e.replace(/\{scheme\}/g, this.config.sslEnabled ? 'https' : 'http');
	    return e;
	  },
	
	  /**
	   * @api private
	   */
	  setEndpoint: function setEndpoint(endpoint) {
	    this.endpoint = new AWS.Endpoint(endpoint, this.config);
	  },
	
	  /**
	   * @api private
	   */
	  paginationConfig: function paginationConfig(operation, throwException) {
	    var paginator = this.api.operations[operation].paginator;
	    if (!paginator) {
	      if (throwException) {
	        var e = new Error();
	        throw AWS.util.error(e, 'No pagination configuration for ' + operation);
	      }
	      return null;
	    }
	
	    return paginator;
	  }
	});
	
	AWS.util.update(AWS.Service, {
	
	  /**
	   * Adds one method for each operation described in the api configuration
	   *
	   * @api private
	   */
	  defineMethods: function defineMethods(svc) {
	    AWS.util.each(svc.prototype.api.operations, function iterator(method) {
	      if (svc.prototype[method]) return;
	      var operation = svc.prototype.api.operations[method];
	      if (operation.authtype === 'none') {
	        svc.prototype[method] = function (params, callback) {
	          return this.makeUnauthenticatedRequest(method, params, callback);
	        };
	      } else {
	        svc.prototype[method] = function (params, callback) {
	          return this.makeRequest(method, params, callback);
	        };
	      }
	    });
	  },
	
	  /**
	   * Defines a new Service class using a service identifier and list of versions
	   * including an optional set of features (functions) to apply to the class
	   * prototype.
	   *
	   * @param serviceIdentifier [String] the identifier for the service
	   * @param versions [Array<String>] a list of versions that work with this
	   *   service
	   * @param features [Object] an object to attach to the prototype
	   * @return [Class<Service>] the service class defined by this function.
	   */
	  defineService: function defineService(serviceIdentifier, versions, features) {
	    AWS.Service._serviceMap[serviceIdentifier] = true;
	    if (!Array.isArray(versions)) {
	      features = versions;
	      versions = [];
	    }
	
	    var svc = inherit(AWS.Service, features || {});
	
	    if (typeof serviceIdentifier === 'string') {
	      AWS.Service.addVersions(svc, versions);
	
	      var identifier = svc.serviceIdentifier || serviceIdentifier;
	      svc.serviceIdentifier = identifier;
	    } else { // defineService called with an API
	      svc.prototype.api = serviceIdentifier;
	      AWS.Service.defineMethods(svc);
	    }
	    AWS.SequentialExecutor.call(this.prototype);
	    //util.clientSideMonitoring is only available in node
	    if (!this.prototype.publisher && AWS.util.clientSideMonitoring) {
	      var Publisher = AWS.util.clientSideMonitoring.Publisher;
	      var configProvider = AWS.util.clientSideMonitoring.configProvider;
	      var publisherConfig = configProvider();
	      this.prototype.publisher = new Publisher(publisherConfig);
	      if (publisherConfig.enabled) {
	        //if csm is enabled in environment, SDK should send all metrics
	        AWS.Service._clientSideMonitoring = true;
	      }
	    }
	    AWS.SequentialExecutor.call(svc.prototype);
	    AWS.Service.addDefaultMonitoringListeners(svc.prototype);
	    return svc;
	  },
	
	  /**
	   * @api private
	   */
	  addVersions: function addVersions(svc, versions) {
	    if (!Array.isArray(versions)) versions = [versions];
	
	    svc.services = svc.services || {};
	    for (var i = 0; i < versions.length; i++) {
	      if (svc.services[versions[i]] === undefined) {
	        svc.services[versions[i]] = null;
	      }
	    }
	
	    svc.apiVersions = Object.keys(svc.services).sort();
	  },
	
	  /**
	   * @api private
	   */
	  defineServiceApi: function defineServiceApi(superclass, version, apiConfig) {
	    var svc = inherit(superclass, {
	      serviceIdentifier: superclass.serviceIdentifier
	    });
	
	    function setApi(api) {
	      if (api.isApi) {
	        svc.prototype.api = api;
	      } else {
	        svc.prototype.api = new Api(api);
	      }
	    }
	
	    if (typeof version === 'string') {
	      if (apiConfig) {
	        setApi(apiConfig);
	      } else {
	        try {
	          setApi(AWS.apiLoader(superclass.serviceIdentifier, version));
	        } catch (err) {
	          throw AWS.util.error(err, {
	            message: 'Could not find API configuration ' +
	              superclass.serviceIdentifier + '-' + version
	          });
	        }
	      }
	      if (!Object.prototype.hasOwnProperty.call(superclass.services, version)) {
	        superclass.apiVersions = superclass.apiVersions.concat(version).sort();
	      }
	      superclass.services[version] = svc;
	    } else {
	      setApi(version);
	    }
	
	    AWS.Service.defineMethods(svc);
	    return svc;
	  },
	
	  /**
	   * @api private
	   */
	  hasService: function(identifier) {
	    return Object.prototype.hasOwnProperty.call(AWS.Service._serviceMap, identifier);
	  },
	
	  /**
	   * @param attachOn attach default monitoring listeners to object
	   *
	   * Each monitoring event should be emitted from service client to service constructor prototype and then
	   * to global service prototype like bubbling up. These default monitoring events listener will transfer
	   * the monitoring events to the upper layer.
	   * @api private
	   */
	  addDefaultMonitoringListeners: function addDefaultMonitoringListeners(attachOn) {
	    attachOn.addNamedListener('MONITOR_EVENTS_BUBBLE', 'apiCallAttempt', function EVENTS_BUBBLE(event) {
	      var baseClass = Object.getPrototypeOf(attachOn);
	      if (baseClass._events) baseClass.emit('apiCallAttempt', [event]);
	    });
	    attachOn.addNamedListener('CALL_EVENTS_BUBBLE', 'apiCall', function CALL_EVENTS_BUBBLE(event) {
	      var baseClass = Object.getPrototypeOf(attachOn);
	      if (baseClass._events) baseClass.emit('apiCall', [event]);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  _serviceMap: {}
	});
	
	AWS.util.mixin(AWS.Service, AWS.SequentialExecutor);
	
	/**
	 * @api private
	 */
	module.exports = AWS.Service;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	
	AWS.util.update(AWS.CognitoIdentity.prototype, {
	  getOpenIdToken: function getOpenIdToken(params, callback) {
	    return this.makeUnauthenticatedRequest('getOpenIdToken', params, callback);
	  },
	
	  getId: function getId(params, callback) {
	    return this.makeUnauthenticatedRequest('getId', params, callback);
	  },
	
	  getCredentialsForIdentity: function getCredentialsForIdentity(params, callback) {
	    return this.makeUnauthenticatedRequest('getCredentialsForIdentity', params, callback);
	  }
	});


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	
	AWS.util.update(AWS.STS.prototype, {
	  /**
	   * @overload credentialsFrom(data, credentials = null)
	   *   Creates a credentials object from STS response data containing
	   *   credentials information. Useful for quickly setting AWS credentials.
	   *
	   *   @note This is a low-level utility function. If you want to load temporary
	   *     credentials into your process for subsequent requests to AWS resources,
	   *     you should use {AWS.TemporaryCredentials} instead.
	   *   @param data [map] data retrieved from a call to {getFederatedToken},
	   *     {getSessionToken}, {assumeRole}, or {assumeRoleWithWebIdentity}.
	   *   @param credentials [AWS.Credentials] an optional credentials object to
	   *     fill instead of creating a new object. Useful when modifying an
	   *     existing credentials object from a refresh call.
	   *   @return [AWS.TemporaryCredentials] the set of temporary credentials
	   *     loaded from a raw STS operation response.
	   *   @example Using credentialsFrom to load global AWS credentials
	   *     var sts = new AWS.STS();
	   *     sts.getSessionToken(function (err, data) {
	   *       if (err) console.log("Error getting credentials");
	   *       else {
	   *         AWS.config.credentials = sts.credentialsFrom(data);
	   *       }
	   *     });
	   *   @see AWS.TemporaryCredentials
	   */
	  credentialsFrom: function credentialsFrom(data, credentials) {
	    if (!data) return null;
	    if (!credentials) credentials = new AWS.TemporaryCredentials();
	    credentials.expired = false;
	    credentials.accessKeyId = data.Credentials.AccessKeyId;
	    credentials.secretAccessKey = data.Credentials.SecretAccessKey;
	    credentials.sessionToken = data.Credentials.SessionToken;
	    credentials.expireTime = data.Credentials.Expiration;
	    return credentials;
	  },
	
	  assumeRoleWithWebIdentity: function assumeRoleWithWebIdentity(params, callback) {
	    return this.makeUnauthenticatedRequest('assumeRoleWithWebIdentity', params, callback);
	  },
	
	  assumeRoleWithSAML: function assumeRoleWithSAML(params, callback) {
	    return this.makeUnauthenticatedRequest('assumeRoleWithSAML', params, callback);
	  }
	});


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	var expiresHeader = 'presigned-expires';
	
	/**
	 * @api private
	 */
	function signedUrlBuilder(request) {
	  var expires = request.httpRequest.headers[expiresHeader];
	  var signerClass = request.service.getSignerClass(request);
	
	  delete request.httpRequest.headers['User-Agent'];
	  delete request.httpRequest.headers['X-Amz-User-Agent'];
	
	  if (signerClass === AWS.Signers.V4) {
	    if (expires > 604800) { // one week expiry is invalid
	      var message = 'Presigning does not support expiry time greater ' +
	                    'than a week with SigV4 signing.';
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidExpiryTime', message: message, retryable: false
	      });
	    }
	    request.httpRequest.headers[expiresHeader] = expires;
	  } else if (signerClass === AWS.Signers.S3) {
	    var now = request.service ? request.service.getSkewCorrectedDate() : AWS.util.date.getDate();
	    request.httpRequest.headers[expiresHeader] = parseInt(
	      AWS.util.date.unixTimestamp(now) + expires, 10).toString();
	  } else {
	    throw AWS.util.error(new Error(), {
	      message: 'Presigning only supports S3 or SigV4 signing.',
	      code: 'UnsupportedSigner', retryable: false
	    });
	  }
	}
	
	/**
	 * @api private
	 */
	function signedUrlSigner(request) {
	  var endpoint = request.httpRequest.endpoint;
	  var parsedUrl = AWS.util.urlParse(request.httpRequest.path);
	  var queryParams = {};
	
	  if (parsedUrl.search) {
	    queryParams = AWS.util.queryStringParse(parsedUrl.search.substr(1));
	  }
	
	  var auth = request.httpRequest.headers['Authorization'].split(' ');
	  if (auth[0] === 'AWS') {
	    auth = auth[1].split(':');
	    queryParams['AWSAccessKeyId'] = auth[0];
	    queryParams['Signature'] = auth[1];
	
	    AWS.util.each(request.httpRequest.headers, function (key, value) {
	      if (key === expiresHeader) key = 'Expires';
	      if (key.indexOf('x-amz-meta-') === 0) {
	        // Delete existing, potentially not normalized key
	        delete queryParams[key];
	        key = key.toLowerCase();
	      }
	      queryParams[key] = value;
	    });
	    delete request.httpRequest.headers[expiresHeader];
	    delete queryParams['Authorization'];
	    delete queryParams['Host'];
	  } else if (auth[0] === 'AWS4-HMAC-SHA256') { // SigV4 signing
	    auth.shift();
	    var rest = auth.join(' ');
	    var signature = rest.match(/Signature=(.*?)(?:,|\s|\r?\n|$)/)[1];
	    queryParams['X-Amz-Signature'] = signature;
	    delete queryParams['Expires'];
	  }
	
	  // build URL
	  endpoint.pathname = parsedUrl.pathname;
	  endpoint.search = AWS.util.queryParamsToString(queryParams);
	}
	
	/**
	 * @api private
	 */
	AWS.Signers.Presign = inherit({
	  /**
	   * @api private
	   */
	  sign: function sign(request, expireTime, callback) {
	    request.httpRequest.headers[expiresHeader] = expireTime || 3600;
	    request.on('build', signedUrlBuilder);
	    request.on('sign', signedUrlSigner);
	    request.removeListener('afterBuild',
	      AWS.EventListeners.Core.SET_CONTENT_LENGTH);
	    request.removeListener('afterBuild',
	      AWS.EventListeners.Core.COMPUTE_SHA256);
	
	    request.emit('beforePresign', [request]);
	
	    if (callback) {
	      request.build(function() {
	        if (this.response.error) callback(this.response.error);
	        else {
	          callback(null, AWS.util.urlFormat(request.httpRequest.endpoint));
	        }
	      });
	    } else {
	      request.build();
	      if (request.response.error) throw request.response.error;
	      return AWS.util.urlFormat(request.httpRequest.endpoint);
	    }
	  }
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.Presign;


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	AWS.Signers.RequestSigner = inherit({
	  constructor: function RequestSigner(request) {
	    this.request = request;
	  },
	
	  setServiceClientId: function setServiceClientId(id) {
	    this.serviceClientId = id;
	  },
	
	  getServiceClientId: function getServiceClientId() {
	    return this.serviceClientId;
	  }
	});
	
	AWS.Signers.RequestSigner.getVersion = function getVersion(version) {
	  switch (version) {
	    case 'v2': return AWS.Signers.V2;
	    case 'v3': return AWS.Signers.V3;
	    case 's3v4': return AWS.Signers.V4;
	    case 'v4': return AWS.Signers.V4;
	    case 's3': return AWS.Signers.S3;
	    case 'v3https': return AWS.Signers.V3Https;
	  }
	  throw new Error('Unknown signing version ' + version);
	};
	
	__webpack_require__(__webpack_module_template_argument_1__);
	__webpack_require__(__webpack_module_template_argument_2__);
	__webpack_require__(__webpack_module_template_argument_3__);
	__webpack_require__(__webpack_module_template_argument_4__);
	__webpack_require__(__webpack_module_template_argument_5__);
	__webpack_require__(__webpack_module_template_argument_6__);


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	AWS.Signers.S3 = inherit(AWS.Signers.RequestSigner, {
	  /**
	   * When building the stringToSign, these sub resource params should be
	   * part of the canonical resource string with their NON-decoded values
	   */
	  subResources: {
	    'acl': 1,
	    'accelerate': 1,
	    'analytics': 1,
	    'cors': 1,
	    'lifecycle': 1,
	    'delete': 1,
	    'inventory': 1,
	    'location': 1,
	    'logging': 1,
	    'metrics': 1,
	    'notification': 1,
	    'partNumber': 1,
	    'policy': 1,
	    'requestPayment': 1,
	    'replication': 1,
	    'restore': 1,
	    'tagging': 1,
	    'torrent': 1,
	    'uploadId': 1,
	    'uploads': 1,
	    'versionId': 1,
	    'versioning': 1,
	    'versions': 1,
	    'website': 1
	  },
	
	  // when building the stringToSign, these querystring params should be
	  // part of the canonical resource string with their NON-encoded values
	  responseHeaders: {
	    'response-content-type': 1,
	    'response-content-language': 1,
	    'response-expires': 1,
	    'response-cache-control': 1,
	    'response-content-disposition': 1,
	    'response-content-encoding': 1
	  },
	
	  addAuthorization: function addAuthorization(credentials, date) {
	    if (!this.request.headers['presigned-expires']) {
	      this.request.headers['X-Amz-Date'] = AWS.util.date.rfc822(date);
	    }
	
	    if (credentials.sessionToken) {
	      // presigned URLs require this header to be lowercased
	      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
	    }
	
	    var signature = this.sign(credentials.secretAccessKey, this.stringToSign());
	    var auth = 'AWS ' + credentials.accessKeyId + ':' + signature;
	
	    this.request.headers['Authorization'] = auth;
	  },
	
	  stringToSign: function stringToSign() {
	    var r = this.request;
	
	    var parts = [];
	    parts.push(r.method);
	    parts.push(r.headers['Content-MD5'] || '');
	    parts.push(r.headers['Content-Type'] || '');
	
	    // This is the "Date" header, but we use X-Amz-Date.
	    // The S3 signing mechanism requires us to pass an empty
	    // string for this Date header regardless.
	    parts.push(r.headers['presigned-expires'] || '');
	
	    var headers = this.canonicalizedAmzHeaders();
	    if (headers) parts.push(headers);
	    parts.push(this.canonicalizedResource());
	
	    return parts.join('\n');
	
	  },
	
	  canonicalizedAmzHeaders: function canonicalizedAmzHeaders() {
	
	    var amzHeaders = [];
	
	    AWS.util.each(this.request.headers, function (name) {
	      if (name.match(/^x-amz-/i))
	        amzHeaders.push(name);
	    });
	
	    amzHeaders.sort(function (a, b) {
	      return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
	    });
	
	    var parts = [];
	    AWS.util.arrayEach.call(this, amzHeaders, function (name) {
	      parts.push(name.toLowerCase() + ':' + String(this.request.headers[name]));
	    });
	
	    return parts.join('\n');
	
	  },
	
	  canonicalizedResource: function canonicalizedResource() {
	
	    var r = this.request;
	
	    var parts = r.path.split('?');
	    var path = parts[0];
	    var querystring = parts[1];
	
	    var resource = '';
	
	    if (r.virtualHostedBucket)
	      resource += '/' + r.virtualHostedBucket;
	
	    resource += path;
	
	    if (querystring) {
	
	      // collect a list of sub resources and query params that need to be signed
	      var resources = [];
	
	      AWS.util.arrayEach.call(this, querystring.split('&'), function (param) {
	        var name = param.split('=')[0];
	        var value = param.split('=')[1];
	        if (this.subResources[name] || this.responseHeaders[name]) {
	          var subresource = { name: name };
	          if (value !== undefined) {
	            if (this.subResources[name]) {
	              subresource.value = value;
	            } else {
	              subresource.value = decodeURIComponent(value);
	            }
	          }
	          resources.push(subresource);
	        }
	      });
	
	      resources.sort(function (a, b) { return a.name < b.name ? -1 : 1; });
	
	      if (resources.length) {
	
	        querystring = [];
	        AWS.util.arrayEach(resources, function (res) {
	          if (res.value === undefined) {
	            querystring.push(res.name);
	          } else {
	            querystring.push(res.name + '=' + res.value);
	          }
	        });
	
	        resource += '?' + querystring.join('&');
	      }
	
	    }
	
	    return resource;
	
	  },
	
	  sign: function sign(secret, string) {
	    return AWS.util.crypto.hmac(secret, string, 'base64', 'sha1');
	  }
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.S3;


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	AWS.Signers.V2 = inherit(AWS.Signers.RequestSigner, {
	  addAuthorization: function addAuthorization(credentials, date) {
	
	    if (!date) date = AWS.util.date.getDate();
	
	    var r = this.request;
	
	    r.params.Timestamp = AWS.util.date.iso8601(date);
	    r.params.SignatureVersion = '2';
	    r.params.SignatureMethod = 'HmacSHA256';
	    r.params.AWSAccessKeyId = credentials.accessKeyId;
	
	    if (credentials.sessionToken) {
	      r.params.SecurityToken = credentials.sessionToken;
	    }
	
	    delete r.params.Signature; // delete old Signature for re-signing
	    r.params.Signature = this.signature(credentials);
	
	    r.body = AWS.util.queryParamsToString(r.params);
	    r.headers['Content-Length'] = r.body.length;
	  },
	
	  signature: function signature(credentials) {
	    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
	  },
	
	  stringToSign: function stringToSign() {
	    var parts = [];
	    parts.push(this.request.method);
	    parts.push(this.request.endpoint.host.toLowerCase());
	    parts.push(this.request.pathname());
	    parts.push(AWS.util.queryParamsToString(this.request.params));
	    return parts.join('\n');
	  }
	
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.V2;


/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	AWS.Signers.V3 = inherit(AWS.Signers.RequestSigner, {
	  addAuthorization: function addAuthorization(credentials, date) {
	
	    var datetime = AWS.util.date.rfc822(date);
	
	    this.request.headers['X-Amz-Date'] = datetime;
	
	    if (credentials.sessionToken) {
	      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
	    }
	
	    this.request.headers['X-Amzn-Authorization'] =
	      this.authorization(credentials, datetime);
	
	  },
	
	  authorization: function authorization(credentials) {
	    return 'AWS3 ' +
	      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
	      'Algorithm=HmacSHA256,' +
	      'SignedHeaders=' + this.signedHeaders() + ',' +
	      'Signature=' + this.signature(credentials);
	  },
	
	  signedHeaders: function signedHeaders() {
	    var headers = [];
	    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
	      headers.push(h.toLowerCase());
	    });
	    return headers.sort().join(';');
	  },
	
	  canonicalHeaders: function canonicalHeaders() {
	    var headers = this.request.headers;
	    var parts = [];
	    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
	      parts.push(h.toLowerCase().trim() + ':' + String(headers[h]).trim());
	    });
	    return parts.sort().join('\n') + '\n';
	  },
	
	  headersToSign: function headersToSign() {
	    var headers = [];
	    AWS.util.each(this.request.headers, function iterator(k) {
	      if (k === 'Host' || k === 'Content-Encoding' || k.match(/^X-Amz/i)) {
	        headers.push(k);
	      }
	    });
	    return headers;
	  },
	
	  signature: function signature(credentials) {
	    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
	  },
	
	  stringToSign: function stringToSign() {
	    var parts = [];
	    parts.push(this.request.method);
	    parts.push('/');
	    parts.push('');
	    parts.push(this.canonicalHeaders());
	    parts.push(this.request.body);
	    return AWS.util.crypto.sha256(parts.join('\n'));
	  }
	
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.V3;


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var inherit = AWS.util.inherit;
	
	__webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * @api private
	 */
	AWS.Signers.V3Https = inherit(AWS.Signers.V3, {
	  authorization: function authorization(credentials) {
	    return 'AWS3-HTTPS ' +
	      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
	      'Algorithm=HmacSHA256,' +
	      'Signature=' + this.signature(credentials);
	  },
	
	  stringToSign: function stringToSign() {
	    return this.request.headers['X-Amz-Date'];
	  }
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.V3Https;


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var v4Credentials = __webpack_require__(__webpack_module_template_argument_1__);
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	var expiresHeader = 'presigned-expires';
	
	/**
	 * @api private
	 */
	AWS.Signers.V4 = inherit(AWS.Signers.RequestSigner, {
	  constructor: function V4(request, serviceName, options) {
	    AWS.Signers.RequestSigner.call(this, request);
	    this.serviceName = serviceName;
	    options = options || {};
	    this.signatureCache = typeof options.signatureCache === 'boolean' ? options.signatureCache : true;
	    this.operation = options.operation;
	    this.signatureVersion = options.signatureVersion;
	  },
	
	  algorithm: 'AWS4-HMAC-SHA256',
	
	  addAuthorization: function addAuthorization(credentials, date) {
	    var datetime = AWS.util.date.iso8601(date).replace(/[:\-]|\.\d{3}/g, '');
	
	    if (this.isPresigned()) {
	      this.updateForPresigned(credentials, datetime);
	    } else {
	      this.addHeaders(credentials, datetime);
	    }
	
	    this.request.headers['Authorization'] =
	      this.authorization(credentials, datetime);
	  },
	
	  addHeaders: function addHeaders(credentials, datetime) {
	    this.request.headers['X-Amz-Date'] = datetime;
	    if (credentials.sessionToken) {
	      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
	    }
	  },
	
	  updateForPresigned: function updateForPresigned(credentials, datetime) {
	    var credString = this.credentialString(datetime);
	    var qs = {
	      'X-Amz-Date': datetime,
	      'X-Amz-Algorithm': this.algorithm,
	      'X-Amz-Credential': credentials.accessKeyId + '/' + credString,
	      'X-Amz-Expires': this.request.headers[expiresHeader],
	      'X-Amz-SignedHeaders': this.signedHeaders()
	    };
	
	    if (credentials.sessionToken) {
	      qs['X-Amz-Security-Token'] = credentials.sessionToken;
	    }
	
	    if (this.request.headers['Content-Type']) {
	      qs['Content-Type'] = this.request.headers['Content-Type'];
	    }
	    if (this.request.headers['Content-MD5']) {
	      qs['Content-MD5'] = this.request.headers['Content-MD5'];
	    }
	    if (this.request.headers['Cache-Control']) {
	      qs['Cache-Control'] = this.request.headers['Cache-Control'];
	    }
	
	    // need to pull in any other X-Amz-* headers
	    AWS.util.each.call(this, this.request.headers, function(key, value) {
	      if (key === expiresHeader) return;
	      if (this.isSignableHeader(key)) {
	        var lowerKey = key.toLowerCase();
	        // Metadata should be normalized
	        if (lowerKey.indexOf('x-amz-meta-') === 0) {
	          qs[lowerKey] = value;
	        } else if (lowerKey.indexOf('x-amz-') === 0) {
	          qs[key] = value;
	        }
	      }
	    });
	
	    var sep = this.request.path.indexOf('?') >= 0 ? '&' : '?';
	    this.request.path += sep + AWS.util.queryParamsToString(qs);
	  },
	
	  authorization: function authorization(credentials, datetime) {
	    var parts = [];
	    var credString = this.credentialString(datetime);
	    parts.push(this.algorithm + ' Credential=' +
	      credentials.accessKeyId + '/' + credString);
	    parts.push('SignedHeaders=' + this.signedHeaders());
	    parts.push('Signature=' + this.signature(credentials, datetime));
	    return parts.join(', ');
	  },
	
	  signature: function signature(credentials, datetime) {
	    var signingKey = v4Credentials.getSigningKey(
	      credentials,
	      datetime.substr(0, 8),
	      this.request.region,
	      this.serviceName,
	      this.signatureCache
	    );
	    return AWS.util.crypto.hmac(signingKey, this.stringToSign(datetime), 'hex');
	  },
	
	  stringToSign: function stringToSign(datetime) {
	    var parts = [];
	    parts.push('AWS4-HMAC-SHA256');
	    parts.push(datetime);
	    parts.push(this.credentialString(datetime));
	    parts.push(this.hexEncodedHash(this.canonicalString()));
	    return parts.join('\n');
	  },
	
	  canonicalString: function canonicalString() {
	    var parts = [], pathname = this.request.pathname();
	    if (this.serviceName !== 's3' && this.signatureVersion !== 's3v4') pathname = AWS.util.uriEscapePath(pathname);
	
	    parts.push(this.request.method);
	    parts.push(pathname);
	    parts.push(this.request.search());
	    parts.push(this.canonicalHeaders() + '\n');
	    parts.push(this.signedHeaders());
	    parts.push(this.hexEncodedBodyHash());
	    return parts.join('\n');
	  },
	
	  canonicalHeaders: function canonicalHeaders() {
	    var headers = [];
	    AWS.util.each.call(this, this.request.headers, function (key, item) {
	      headers.push([key, item]);
	    });
	    headers.sort(function (a, b) {
	      return a[0].toLowerCase() < b[0].toLowerCase() ? -1 : 1;
	    });
	    var parts = [];
	    AWS.util.arrayEach.call(this, headers, function (item) {
	      var key = item[0].toLowerCase();
	      if (this.isSignableHeader(key)) {
	        var value = item[1];
	        if (typeof value === 'undefined' || value === null || typeof value.toString !== 'function') {
	          throw AWS.util.error(new Error('Header ' + key + ' contains invalid value'), {
	            code: 'InvalidHeader'
	          });
	        }
	        parts.push(key + ':' +
	          this.canonicalHeaderValues(value.toString()));
	      }
	    });
	    return parts.join('\n');
	  },
	
	  canonicalHeaderValues: function canonicalHeaderValues(values) {
	    return values.replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
	  },
	
	  signedHeaders: function signedHeaders() {
	    var keys = [];
	    AWS.util.each.call(this, this.request.headers, function (key) {
	      key = key.toLowerCase();
	      if (this.isSignableHeader(key)) keys.push(key);
	    });
	    return keys.sort().join(';');
	  },
	
	  credentialString: function credentialString(datetime) {
	    return v4Credentials.createScope(
	      datetime.substr(0, 8),
	      this.request.region,
	      this.serviceName
	    );
	  },
	
	  hexEncodedHash: function hash(string) {
	    return AWS.util.crypto.sha256(string, 'hex');
	  },
	
	  hexEncodedBodyHash: function hexEncodedBodyHash() {
	    var request = this.request;
	    if (this.isPresigned() && this.serviceName === 's3' && !request.body) {
	      return 'UNSIGNED-PAYLOAD';
	    } else if (request.headers['X-Amz-Content-Sha256']) {
	      return request.headers['X-Amz-Content-Sha256'];
	    } else {
	      return this.hexEncodedHash(this.request.body || '');
	    }
	  },
	
	  unsignableHeaders: [
	    'authorization',
	    'content-type',
	    'content-length',
	    'user-agent',
	    expiresHeader,
	    'expect',
	    'x-amzn-trace-id'
	  ],
	
	  isSignableHeader: function isSignableHeader(key) {
	    if (key.toLowerCase().indexOf('x-amz-') === 0) return true;
	    return this.unsignableHeaders.indexOf(key) < 0;
	  },
	
	  isPresigned: function isPresigned() {
	    return this.request.headers[expiresHeader] ? true : false;
	  }
	
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.V4;


/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * @api private
	 */
	var cachedSecret = {};
	
	/**
	 * @api private
	 */
	var cacheQueue = [];
	
	/**
	 * @api private
	 */
	var maxCacheEntries = 50;
	
	/**
	 * @api private
	 */
	var v4Identifier = 'aws4_request';
	
	/**
	 * @api private
	 */
	module.exports = {
	  /**
	   * @api private
	   *
	   * @param date [String]
	   * @param region [String]
	   * @param serviceName [String]
	   * @return [String]
	   */
	  createScope: function createScope(date, region, serviceName) {
	    return [
	      date.substr(0, 8),
	      region,
	      serviceName,
	      v4Identifier
	    ].join('/');
	  },
	
	  /**
	   * @api private
	   *
	   * @param credentials [Credentials]
	   * @param date [String]
	   * @param region [String]
	   * @param service [String]
	   * @param shouldCache [Boolean]
	   * @return [String]
	   */
	  getSigningKey: function getSigningKey(
	    credentials,
	    date,
	    region,
	    service,
	    shouldCache
	  ) {
	    var credsIdentifier = AWS.util.crypto
	      .hmac(credentials.secretAccessKey, credentials.accessKeyId, 'base64');
	    var cacheKey = [credsIdentifier, date, region, service].join('_');
	    shouldCache = shouldCache !== false;
	    if (shouldCache && (cacheKey in cachedSecret)) {
	      return cachedSecret[cacheKey];
	    }
	
	    var kDate = AWS.util.crypto.hmac(
	      'AWS4' + credentials.secretAccessKey,
	      date,
	      'buffer'
	    );
	    var kRegion = AWS.util.crypto.hmac(kDate, region, 'buffer');
	    var kService = AWS.util.crypto.hmac(kRegion, service, 'buffer');
	
	    var signingKey = AWS.util.crypto.hmac(kService, v4Identifier, 'buffer');
	    if (shouldCache) {
	      cachedSecret[cacheKey] = signingKey;
	      cacheQueue.push(cacheKey);
	      if (cacheQueue.length > maxCacheEntries) {
	        // remove the oldest entry (not the least recently used)
	        delete cachedSecret[cacheQueue.shift()];
	      }
	    }
	
	    return signingKey;
	  },
	
	  /**
	   * @api private
	   *
	   * Empties the derived signing key cache. Made available for testing purposes
	   * only.
	   */
	  emptyCache: function emptyCache() {
	    cachedSecret = {};
	    cacheQueue = [];
	  }
	};


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {/* eslint guard-for-in:0 */
	var AWS;
	
	/**
	 * A set of utility methods for use with the AWS SDK.
	 *
	 * @!attribute abort
	 *   Return this value from an iterator function {each} or {arrayEach}
	 *   to break out of the iteration.
	 *   @example Breaking out of an iterator function
	 *     AWS.util.each({a: 1, b: 2, c: 3}, function(key, value) {
	 *       if (key == 'b') return AWS.util.abort;
	 *     });
	 *   @see each
	 *   @see arrayEach
	 * @api private
	 */
	var util = {
	  environment: 'nodejs',
	  engine: function engine() {
	    if (util.isBrowser() && typeof navigator !== 'undefined') {
	      return navigator.userAgent;
	    } else {
	      var engine = process.platform + '/' + process.version;
	      if (({"NODE_ENV":"production","PUBLIC_URL":""}).AWS_EXECUTION_ENV) {
	        engine += ' exec-env/' + ({"NODE_ENV":"production","PUBLIC_URL":""}).AWS_EXECUTION_ENV;
	      }
	      return engine;
	    }
	  },
	
	  userAgent: function userAgent() {
	    var name = util.environment;
	    var agent = 'aws-sdk-' + name + '/' + __webpack_require__(__webpack_module_template_argument_0__).VERSION;
	    if (name === 'nodejs') agent += ' ' + util.engine();
	    return agent;
	  },
	
	  uriEscape: function uriEscape(string) {
	    var output = encodeURIComponent(string);
	    output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);
	
	    // AWS percent-encodes some extra non-standard characters in a URI
	    output = output.replace(/[*]/g, function(ch) {
	      return '%' + ch.charCodeAt(0).toString(16).toUpperCase();
	    });
	
	    return output;
	  },
	
	  uriEscapePath: function uriEscapePath(string) {
	    var parts = [];
	    util.arrayEach(string.split('/'), function (part) {
	      parts.push(util.uriEscape(part));
	    });
	    return parts.join('/');
	  },
	
	  urlParse: function urlParse(url) {
	    return util.url.parse(url);
	  },
	
	  urlFormat: function urlFormat(url) {
	    return util.url.format(url);
	  },
	
	  queryStringParse: function queryStringParse(qs) {
	    return util.querystring.parse(qs);
	  },
	
	  queryParamsToString: function queryParamsToString(params) {
	    var items = [];
	    var escape = util.uriEscape;
	    var sortedKeys = Object.keys(params).sort();
	
	    util.arrayEach(sortedKeys, function(name) {
	      var value = params[name];
	      var ename = escape(name);
	      var result = ename + '=';
	      if (Array.isArray(value)) {
	        var vals = [];
	        util.arrayEach(value, function(item) { vals.push(escape(item)); });
	        result = ename + '=' + vals.sort().join('&' + ename + '=');
	      } else if (value !== undefined && value !== null) {
	        result = ename + '=' + escape(value);
	      }
	      items.push(result);
	    });
	
	    return items.join('&');
	  },
	
	  readFileSync: function readFileSync(path) {
	    if (util.isBrowser()) return null;
	    return __webpack_require__(__webpack_module_template_argument_1__).readFileSync(path, 'utf-8');
	  },
	
	  base64: {
	    encode: function encode64(string) {
	      if (typeof string === 'number') {
	        throw util.error(new Error('Cannot base64 encode number ' + string));
	      }
	      if (string === null || typeof string === 'undefined') {
	        return string;
	      }
	      var buf = util.buffer.toBuffer(string);
	      return buf.toString('base64');
	    },
	
	    decode: function decode64(string) {
	      if (typeof string === 'number') {
	        throw util.error(new Error('Cannot base64 decode number ' + string));
	      }
	      if (string === null || typeof string === 'undefined') {
	        return string;
	      }
	      return util.buffer.toBuffer(string, 'base64');
	    }
	
	  },
	
	  buffer: {
	    /**
	     * Buffer constructor for Node buffer and buffer pollyfill
	     */
	    toBuffer: function(data, encoding) {
	      return (typeof util.Buffer.from === 'function' && util.Buffer.from !== Uint8Array.from) ?
	        util.Buffer.from(data, encoding) : new util.Buffer(data, encoding);
	    },
	
	    alloc: function(size, fill, encoding) {
	      if (typeof size !== 'number') {
	        throw new Error('size passed to alloc must be a number.');
	      }
	      if (typeof util.Buffer.alloc === 'function') {
	        return util.Buffer.alloc(size, fill, encoding);
	      } else {
	        var buf = new util.Buffer(size);
	        if (fill !== undefined && typeof buf.fill === 'function') {
	          buf.fill(fill, undefined, undefined, encoding);
	        }
	        return buf;
	      }
	    },
	
	    toStream: function toStream(buffer) {
	      if (!util.Buffer.isBuffer(buffer)) buffer =  util.buffer.toBuffer(buffer);
	
	      var readable = new (util.stream.Readable)();
	      var pos = 0;
	      readable._read = function(size) {
	        if (pos >= buffer.length) return readable.push(null);
	
	        var end = pos + size;
	        if (end > buffer.length) end = buffer.length;
	        readable.push(buffer.slice(pos, end));
	        pos = end;
	      };
	
	      return readable;
	    },
	
	    /**
	     * Concatenates a list of Buffer objects.
	     */
	    concat: function(buffers) {
	      var length = 0,
	          offset = 0,
	          buffer = null, i;
	
	      for (i = 0; i < buffers.length; i++) {
	        length += buffers[i].length;
	      }
	
	      buffer = util.buffer.alloc(length);
	
	      for (i = 0; i < buffers.length; i++) {
	        buffers[i].copy(buffer, offset);
	        offset += buffers[i].length;
	      }
	
	      return buffer;
	    }
	  },
	
	  string: {
	    byteLength: function byteLength(string) {
	      if (string === null || string === undefined) return 0;
	      if (typeof string === 'string') string = util.buffer.toBuffer(string);
	
	      if (typeof string.byteLength === 'number') {
	        return string.byteLength;
	      } else if (typeof string.length === 'number') {
	        return string.length;
	      } else if (typeof string.size === 'number') {
	        return string.size;
	      } else if (typeof string.path === 'string') {
	        return __webpack_require__(__webpack_module_template_argument_2__).lstatSync(string.path).size;
	      } else {
	        throw util.error(new Error('Cannot determine length of ' + string),
	          { object: string });
	      }
	    },
	
	    upperFirst: function upperFirst(string) {
	      return string[0].toUpperCase() + string.substr(1);
	    },
	
	    lowerFirst: function lowerFirst(string) {
	      return string[0].toLowerCase() + string.substr(1);
	    }
	  },
	
	  ini: {
	    parse: function string(ini) {
	      var currentSection, map = {};
	      util.arrayEach(ini.split(/\r?\n/), function(line) {
	        line = line.split(/(^|\s)[;#]/)[0]; // remove comments
	        var section = line.match(/^\s*\[([^\[\]]+)\]\s*$/);
	        if (section) {
	          currentSection = section[1];
	        } else if (currentSection) {
	          var item = line.match(/^\s*(.+?)\s*=\s*(.+?)\s*$/);
	          if (item) {
	            map[currentSection] = map[currentSection] || {};
	            map[currentSection][item[1]] = item[2];
	          }
	        }
	      });
	
	      return map;
	    }
	  },
	
	  fn: {
	    noop: function() {},
	    callback: function (err) { if (err) throw err; },
	
	    /**
	     * Turn a synchronous function into as "async" function by making it call
	     * a callback. The underlying function is called with all but the last argument,
	     * which is treated as the callback. The callback is passed passed a first argument
	     * of null on success to mimick standard node callbacks.
	     */
	    makeAsync: function makeAsync(fn, expectedArgs) {
	      if (expectedArgs && expectedArgs <= fn.length) {
	        return fn;
	      }
	
	      return function() {
	        var args = Array.prototype.slice.call(arguments, 0);
	        var callback = args.pop();
	        var result = fn.apply(null, args);
	        callback(result);
	      };
	    }
	  },
	
	  /**
	   * Date and time utility functions.
	   */
	  date: {
	
	    /**
	     * @return [Date] the current JavaScript date object. Since all
	     *   AWS services rely on this date object, you can override
	     *   this function to provide a special time value to AWS service
	     *   requests.
	     */
	    getDate: function getDate() {
	      if (!AWS) AWS = __webpack_require__(__webpack_module_template_argument_3__);
	      if (AWS.config.systemClockOffset) { // use offset when non-zero
	        return new Date(new Date().getTime() + AWS.config.systemClockOffset);
	      } else {
	        return new Date();
	      }
	    },
	
	    /**
	     * @return [String] the date in ISO-8601 format
	     */
	    iso8601: function iso8601(date) {
	      if (date === undefined) { date = util.date.getDate(); }
	      return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
	    },
	
	    /**
	     * @return [String] the date in RFC 822 format
	     */
	    rfc822: function rfc822(date) {
	      if (date === undefined) { date = util.date.getDate(); }
	      return date.toUTCString();
	    },
	
	    /**
	     * @return [Integer] the UNIX timestamp value for the current time
	     */
	    unixTimestamp: function unixTimestamp(date) {
	      if (date === undefined) { date = util.date.getDate(); }
	      return date.getTime() / 1000;
	    },
	
	    /**
	     * @param [String,number,Date] date
	     * @return [Date]
	     */
	    from: function format(date) {
	      if (typeof date === 'number') {
	        return new Date(date * 1000); // unix timestamp
	      } else {
	        return new Date(date);
	      }
	    },
	
	    /**
	     * Given a Date or date-like value, this function formats the
	     * date into a string of the requested value.
	     * @param [String,number,Date] date
	     * @param [String] formatter Valid formats are:
	     #   * 'iso8601'
	     #   * 'rfc822'
	     #   * 'unixTimestamp'
	     * @return [String]
	     */
	    format: function format(date, formatter) {
	      if (!formatter) formatter = 'iso8601';
	      return util.date[formatter](util.date.from(date));
	    },
	
	    parseTimestamp: function parseTimestamp(value) {
	      if (typeof value === 'number') { // unix timestamp (number)
	        return new Date(value * 1000);
	      } else if (value.match(/^\d+$/)) { // unix timestamp
	        return new Date(value * 1000);
	      } else if (value.match(/^\d{4}/)) { // iso8601
	        return new Date(value);
	      } else if (value.match(/^\w{3},/)) { // rfc822
	        return new Date(value);
	      } else {
	        throw util.error(
	          new Error('unhandled timestamp format: ' + value),
	          {code: 'TimestampParserError'});
	      }
	    }
	
	  },
	
	  crypto: {
	    crc32Table: [
	     0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419,
	     0x706AF48F, 0xE963A535, 0x9E6495A3, 0x0EDB8832, 0x79DCB8A4,
	     0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07,
	     0x90BF1D91, 0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
	     0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7, 0x136C9856,
	     0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9,
	     0xFA0F3D63, 0x8D080DF5, 0x3B6E20C8, 0x4C69105E, 0xD56041E4,
	     0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
	     0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3,
	     0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 0x26D930AC, 0x51DE003A,
	     0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599,
	     0xB8BDA50F, 0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
	     0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D, 0x76DC4190,
	     0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F,
	     0x9FBFE4A5, 0xE8B8D433, 0x7807C9A2, 0x0F00F934, 0x9609A88E,
	     0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
	     0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED,
	     0x1B01A57B, 0x8208F4C1, 0xF50FC457, 0x65B0D9C6, 0x12B7E950,
	     0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3,
	     0xFBD44C65, 0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
	     0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 0x4369E96A,
	     0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5,
	     0xAA0A4C5F, 0xDD0D7CC9, 0x5005713C, 0x270241AA, 0xBE0B1010,
	     0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
	     0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17,
	     0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 0xEDB88320, 0x9ABFB3B6,
	     0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615,
	     0x73DC1683, 0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
	     0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 0xF00F9344,
	     0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB,
	     0x196C3671, 0x6E6B06E7, 0xFED41B76, 0x89D32BE0, 0x10DA7A5A,
	     0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
	     0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1,
	     0xA6BC5767, 0x3FB506DD, 0x48B2364B, 0xD80D2BDA, 0xAF0A1B4C,
	     0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF,
	     0x4669BE79, 0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
	     0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 0xC5BA3BBE,
	     0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31,
	     0x2CD99E8B, 0x5BDEAE1D, 0x9B64C2B0, 0xEC63F226, 0x756AA39C,
	     0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
	     0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B,
	     0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 0x86D3D2D4, 0xF1D4E242,
	     0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1,
	     0x18B74777, 0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
	     0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 0xA00AE278,
	     0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7,
	     0x4969474D, 0x3E6E77DB, 0xAED16A4A, 0xD9D65ADC, 0x40DF0B66,
	     0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
	     0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605,
	     0xCDD70693, 0x54DE5729, 0x23D967BF, 0xB3667A2E, 0xC4614AB8,
	     0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B,
	     0x2D02EF8D],
	
	    crc32: function crc32(data) {
	      var tbl = util.crypto.crc32Table;
	      var crc = 0 ^ -1;
	
	      if (typeof data === 'string') {
	        data = util.buffer.toBuffer(data);
	      }
	
	      for (var i = 0; i < data.length; i++) {
	        var code = data.readUInt8(i);
	        crc = (crc >>> 8) ^ tbl[(crc ^ code) & 0xFF];
	      }
	      return (crc ^ -1) >>> 0;
	    },
	
	    hmac: function hmac(key, string, digest, fn) {
	      if (!digest) digest = 'binary';
	      if (digest === 'buffer') { digest = undefined; }
	      if (!fn) fn = 'sha256';
	      if (typeof string === 'string') string = util.buffer.toBuffer(string);
	      return util.crypto.lib.createHmac(fn, key).update(string).digest(digest);
	    },
	
	    md5: function md5(data, digest, callback) {
	      return util.crypto.hash('md5', data, digest, callback);
	    },
	
	    sha256: function sha256(data, digest, callback) {
	      return util.crypto.hash('sha256', data, digest, callback);
	    },
	
	    hash: function(algorithm, data, digest, callback) {
	      var hash = util.crypto.createHash(algorithm);
	      if (!digest) { digest = 'binary'; }
	      if (digest === 'buffer') { digest = undefined; }
	      if (typeof data === 'string') data = util.buffer.toBuffer(data);
	      var sliceFn = util.arraySliceFn(data);
	      var isBuffer = util.Buffer.isBuffer(data);
	      //Identifying objects with an ArrayBuffer as buffers
	      if (util.isBrowser() && typeof ArrayBuffer !== 'undefined' && data && data.buffer instanceof ArrayBuffer) isBuffer = true;
	
	      if (callback && typeof data === 'object' &&
	          typeof data.on === 'function' && !isBuffer) {
	        data.on('data', function(chunk) { hash.update(chunk); });
	        data.on('error', function(err) { callback(err); });
	        data.on('end', function() { callback(null, hash.digest(digest)); });
	      } else if (callback && sliceFn && !isBuffer &&
	                 typeof FileReader !== 'undefined') {
	        // this might be a File/Blob
	        var index = 0, size = 1024 * 512;
	        var reader = new FileReader();
	        reader.onerror = function() {
	          callback(new Error('Failed to read data.'));
	        };
	        reader.onload = function() {
	          var buf = new util.Buffer(new Uint8Array(reader.result));
	          hash.update(buf);
	          index += buf.length;
	          reader._continueReading();
	        };
	        reader._continueReading = function() {
	          if (index >= data.size) {
	            callback(null, hash.digest(digest));
	            return;
	          }
	
	          var back = index + size;
	          if (back > data.size) back = data.size;
	          reader.readAsArrayBuffer(sliceFn.call(data, index, back));
	        };
	
	        reader._continueReading();
	      } else {
	        if (util.isBrowser() && typeof data === 'object' && !isBuffer) {
	          data = new util.Buffer(new Uint8Array(data));
	        }
	        var out = hash.update(data).digest(digest);
	        if (callback) callback(null, out);
	        return out;
	      }
	    },
	
	    toHex: function toHex(data) {
	      var out = [];
	      for (var i = 0; i < data.length; i++) {
	        out.push(('0' + data.charCodeAt(i).toString(16)).substr(-2, 2));
	      }
	      return out.join('');
	    },
	
	    createHash: function createHash(algorithm) {
	      return util.crypto.lib.createHash(algorithm);
	    }
	
	  },
	
	  /** @!ignore */
	
	  /* Abort constant */
	  abort: {},
	
	  each: function each(object, iterFunction) {
	    for (var key in object) {
	      if (Object.prototype.hasOwnProperty.call(object, key)) {
	        var ret = iterFunction.call(this, key, object[key]);
	        if (ret === util.abort) break;
	      }
	    }
	  },
	
	  arrayEach: function arrayEach(array, iterFunction) {
	    for (var idx in array) {
	      if (Object.prototype.hasOwnProperty.call(array, idx)) {
	        var ret = iterFunction.call(this, array[idx], parseInt(idx, 10));
	        if (ret === util.abort) break;
	      }
	    }
	  },
	
	  update: function update(obj1, obj2) {
	    util.each(obj2, function iterator(key, item) {
	      obj1[key] = item;
	    });
	    return obj1;
	  },
	
	  merge: function merge(obj1, obj2) {
	    return util.update(util.copy(obj1), obj2);
	  },
	
	  copy: function copy(object) {
	    if (object === null || object === undefined) return object;
	    var dupe = {};
	    // jshint forin:false
	    for (var key in object) {
	      dupe[key] = object[key];
	    }
	    return dupe;
	  },
	
	  isEmpty: function isEmpty(obj) {
	    for (var prop in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
	        return false;
	      }
	    }
	    return true;
	  },
	
	  arraySliceFn: function arraySliceFn(obj) {
	    var fn = obj.slice || obj.webkitSlice || obj.mozSlice;
	    return typeof fn === 'function' ? fn : null;
	  },
	
	  isType: function isType(obj, type) {
	    // handle cross-"frame" objects
	    if (typeof type === 'function') type = util.typeName(type);
	    return Object.prototype.toString.call(obj) === '[object ' + type + ']';
	  },
	
	  typeName: function typeName(type) {
	    if (Object.prototype.hasOwnProperty.call(type, 'name')) return type.name;
	    var str = type.toString();
	    var match = str.match(/^\s*function (.+)\(/);
	    return match ? match[1] : str;
	  },
	
	  error: function error(err, options) {
	    var originalError = null;
	    if (typeof err.message === 'string' && err.message !== '') {
	      if (typeof options === 'string' || (options && options.message)) {
	        originalError = util.copy(err);
	        originalError.message = err.message;
	      }
	    }
	    err.message = err.message || null;
	
	    if (typeof options === 'string') {
	      err.message = options;
	    } else if (typeof options === 'object' && options !== null) {
	      util.update(err, options);
	      if (options.message)
	        err.message = options.message;
	      if (options.code || options.name)
	        err.code = options.code || options.name;
	      if (options.stack)
	        err.stack = options.stack;
	    }
	
	    if (typeof Object.defineProperty === 'function') {
	      Object.defineProperty(err, 'name', {writable: true, enumerable: false});
	      Object.defineProperty(err, 'message', {enumerable: true});
	    }
	
	    err.name = options && options.name || err.name || err.code || 'Error';
	    err.time = new Date();
	
	    if (originalError) err.originalError = originalError;
	
	    return err;
	  },
	
	  /**
	   * @api private
	   */
	  inherit: function inherit(klass, features) {
	    var newObject = null;
	    if (features === undefined) {
	      features = klass;
	      klass = Object;
	      newObject = {};
	    } else {
	      var ctor = function ConstructorWrapper() {};
	      ctor.prototype = klass.prototype;
	      newObject = new ctor();
	    }
	
	    // constructor not supplied, create pass-through ctor
	    if (features.constructor === Object) {
	      features.constructor = function() {
	        if (klass !== Object) {
	          return klass.apply(this, arguments);
	        }
	      };
	    }
	
	    features.constructor.prototype = newObject;
	    util.update(features.constructor.prototype, features);
	    features.constructor.__super__ = klass;
	    return features.constructor;
	  },
	
	  /**
	   * @api private
	   */
	  mixin: function mixin() {
	    var klass = arguments[0];
	    for (var i = 1; i < arguments.length; i++) {
	      // jshint forin:false
	      for (var prop in arguments[i].prototype) {
	        var fn = arguments[i].prototype[prop];
	        if (prop !== 'constructor') {
	          klass.prototype[prop] = fn;
	        }
	      }
	    }
	    return klass;
	  },
	
	  /**
	   * @api private
	   */
	  hideProperties: function hideProperties(obj, props) {
	    if (typeof Object.defineProperty !== 'function') return;
	
	    util.arrayEach(props, function (key) {
	      Object.defineProperty(obj, key, {
	        enumerable: false, writable: true, configurable: true });
	    });
	  },
	
	  /**
	   * @api private
	   */
	  property: function property(obj, name, value, enumerable, isValue) {
	    var opts = {
	      configurable: true,
	      enumerable: enumerable !== undefined ? enumerable : true
	    };
	    if (typeof value === 'function' && !isValue) {
	      opts.get = value;
	    }
	    else {
	      opts.value = value; opts.writable = true;
	    }
	
	    Object.defineProperty(obj, name, opts);
	  },
	
	  /**
	   * @api private
	   */
	  memoizedProperty: function memoizedProperty(obj, name, get, enumerable) {
	    var cachedValue = null;
	
	    // build enumerable attribute for each value with lazy accessor.
	    util.property(obj, name, function() {
	      if (cachedValue === null) {
	        cachedValue = get();
	      }
	      return cachedValue;
	    }, enumerable);
	  },
	
	  /**
	   * TODO Remove in major version revision
	   * This backfill populates response data without the
	   * top-level payload name.
	   *
	   * @api private
	   */
	  hoistPayloadMember: function hoistPayloadMember(resp) {
	    var req = resp.request;
	    var operationName = req.operation;
	    var operation = req.service.api.operations[operationName];
	    var output = operation.output;
	    if (output.payload && !operation.hasEventOutput) {
	      var payloadMember = output.members[output.payload];
	      var responsePayload = resp.data[output.payload];
	      if (payloadMember.type === 'structure') {
	        util.each(responsePayload, function(key, value) {
	          util.property(resp.data, key, value, false);
	        });
	      }
	    }
	  },
	
	  /**
	   * Compute SHA-256 checksums of streams
	   *
	   * @api private
	   */
	  computeSha256: function computeSha256(body, done) {
	    if (util.isNode()) {
	      var Stream = util.stream.Stream;
	      var fs = __webpack_require__(__webpack_module_template_argument_4__);
	      if (typeof Stream === 'function' && body instanceof Stream) {
	        if (typeof body.path === 'string') { // assume file object
	          var settings = {};
	          if (typeof body.start === 'number') {
	            settings.start = body.start;
	          }
	          if (typeof body.end === 'number') {
	            settings.end = body.end;
	          }
	          body = fs.createReadStream(body.path, settings);
	        } else { // TODO support other stream types
	          return done(new Error('Non-file stream objects are ' +
	                                'not supported with SigV4'));
	        }
	      }
	    }
	
	    util.crypto.sha256(body, 'hex', function(err, sha) {
	      if (err) done(err);
	      else done(null, sha);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  isClockSkewed: function isClockSkewed(serverTime) {
	    if (serverTime) {
	      util.property(AWS.config, 'isClockSkewed',
	        Math.abs(new Date().getTime() - serverTime) >= 300000, false);
	      return AWS.config.isClockSkewed;
	    }
	  },
	
	  applyClockOffset: function applyClockOffset(serverTime) {
	    if (serverTime)
	      AWS.config.systemClockOffset = serverTime - new Date().getTime();
	  },
	
	  /**
	   * @api private
	   */
	  extractRequestId: function extractRequestId(resp) {
	    var requestId = resp.httpResponse.headers['x-amz-request-id'] ||
	                     resp.httpResponse.headers['x-amzn-requestid'];
	
	    if (!requestId && resp.data && resp.data.ResponseMetadata) {
	      requestId = resp.data.ResponseMetadata.RequestId;
	    }
	
	    if (requestId) {
	      resp.requestId = requestId;
	    }
	
	    if (resp.error) {
	      resp.error.requestId = requestId;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  addPromises: function addPromises(constructors, PromiseDependency) {
	    var deletePromises = false;
	    if (PromiseDependency === undefined && AWS && AWS.config) {
	      PromiseDependency = AWS.config.getPromisesDependency();
	    }
	    if (PromiseDependency === undefined && typeof Promise !== 'undefined') {
	      PromiseDependency = Promise;
	    }
	    if (typeof PromiseDependency !== 'function') deletePromises = true;
	    if (!Array.isArray(constructors)) constructors = [constructors];
	
	    for (var ind = 0; ind < constructors.length; ind++) {
	      var constructor = constructors[ind];
	      if (deletePromises) {
	        if (constructor.deletePromisesFromClass) {
	          constructor.deletePromisesFromClass();
	        }
	      } else if (constructor.addPromisesToClass) {
	        constructor.addPromisesToClass(PromiseDependency);
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  promisifyMethod: function promisifyMethod(methodName, PromiseDependency) {
	    return function promise() {
	      var self = this;
	      return new PromiseDependency(function(resolve, reject) {
	        self[methodName](function(err, data) {
	          if (err) {
	            reject(err);
	          } else {
	            resolve(data);
	          }
	        });
	      });
	    };
	  },
	
	  /**
	   * @api private
	   */
	  isDualstackAvailable: function isDualstackAvailable(service) {
	    if (!service) return false;
	    var metadata = __webpack_require__(__webpack_module_template_argument_5__);
	    if (typeof service !== 'string') service = service.serviceIdentifier;
	    if (typeof service !== 'string' || !metadata.hasOwnProperty(service)) return false;
	    return !!metadata[service].dualstackAvailable;
	  },
	
	  /**
	   * @api private
	   */
	  calculateRetryDelay: function calculateRetryDelay(retryCount, retryDelayOptions) {
	    if (!retryDelayOptions) retryDelayOptions = {};
	    var customBackoff = retryDelayOptions.customBackoff || null;
	    if (typeof customBackoff === 'function') {
	      return customBackoff(retryCount);
	    }
	    var base = typeof retryDelayOptions.base === 'number' ? retryDelayOptions.base : 100;
	    var delay = Math.random() * (Math.pow(2, retryCount) * base);
	    return delay;
	  },
	
	  /**
	   * @api private
	   */
	  handleRequestWithRetries: function handleRequestWithRetries(httpRequest, options, cb) {
	    if (!options) options = {};
	    var http = AWS.HttpClient.getInstance();
	    var httpOptions = options.httpOptions || {};
	    var retryCount = 0;
	
	    var errCallback = function(err) {
	      var maxRetries = options.maxRetries || 0;
	      if (err && err.code === 'TimeoutError') err.retryable = true;
	      if (err && err.retryable && retryCount < maxRetries) {
	        retryCount++;
	        var delay = util.calculateRetryDelay(retryCount, options.retryDelayOptions);
	        setTimeout(sendRequest, delay + (err.retryAfter || 0));
	      } else {
	        cb(err);
	      }
	    };
	
	    var sendRequest = function() {
	      var data = '';
	      http.handleRequest(httpRequest, httpOptions, function(httpResponse) {
	        httpResponse.on('data', function(chunk) { data += chunk.toString(); });
	        httpResponse.on('end', function() {
	          var statusCode = httpResponse.statusCode;
	          if (statusCode < 300) {
	            cb(null, data);
	          } else {
	            var retryAfter = parseInt(httpResponse.headers['retry-after'], 10) * 1000 || 0;
	            var err = util.error(new Error(),
	              { retryable: statusCode >= 500 || statusCode === 429 }
	            );
	            if (retryAfter && err.retryable) err.retryAfter = retryAfter;
	            errCallback(err);
	          }
	        });
	      }, errCallback);
	    };
	
	    AWS.util.defer(sendRequest);
	  },
	
	  /**
	   * @api private
	   */
	  uuid: {
	    v4: function uuidV4() {
	      return __webpack_require__(__webpack_module_template_argument_6__).v4();
	    }
	  },
	
	  /**
	   * @api private
	   */
	  convertPayloadToString: function convertPayloadToString(resp) {
	    var req = resp.request;
	    var operation = req.operation;
	    var rules = req.service.api.operations[operation].output || {};
	    if (rules.payload && resp.data[rules.payload]) {
	      resp.data[rules.payload] = resp.data[rules.payload].toString();
	    }
	  },
	
	  /**
	   * @api private
	   */
	  defer: function defer(callback) {
	    if (typeof process === 'object' && typeof process.nextTick === 'function') {
	      process.nextTick(callback);
	    } else if (typeof setImmediate === 'function') {
	      setImmediate(callback);
	    } else {
	      setTimeout(callback, 0);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getRequestPayloadShape: function getRequestPayloadShape(req) {
	    var operations = req.service.api.operations;
	    if (!operations) return undefined;
	    var operation = (operations || {})[req.operation];
	    if (!operation || !operation.input || !operation.input.payload) return undefined;
	    return operation.input.members[operation.input.payload];
	  },
	
	  getProfilesFromSharedConfig: function getProfilesFromSharedConfig(iniLoader, filename) {
	    var profiles = {};
	    var profilesFromConfig = {};
	    if (({"NODE_ENV":"production","PUBLIC_URL":""})[util.configOptInEnv]) {
	      var profilesFromConfig = iniLoader.loadFrom({
	        isConfig: true,
	        filename: ({"NODE_ENV":"production","PUBLIC_URL":""})[util.sharedConfigFileEnv]
	      });
	    }
	    var profilesFromCreds = iniLoader.loadFrom({
	      filename: filename ||
	        (({"NODE_ENV":"production","PUBLIC_URL":""})[util.configOptInEnv] && ({"NODE_ENV":"production","PUBLIC_URL":""})[util.sharedCredentialsFileEnv])
	    });
	    for (var i = 0, profileNames = Object.keys(profilesFromConfig); i < profileNames.length; i++) {
	      profiles[profileNames[i]] = profilesFromConfig[profileNames[i]];
	    }
	    for (var i = 0, profileNames = Object.keys(profilesFromCreds); i < profileNames.length; i++) {
	      profiles[profileNames[i]] = profilesFromCreds[profileNames[i]];
	    }
	    return profiles;
	  },
	
	  /**
	   * @api private
	   */
	  defaultProfile: 'default',
	
	  /**
	   * @api private
	   */
	  configOptInEnv: 'AWS_SDK_LOAD_CONFIG',
	
	  /**
	   * @api private
	   */
	  sharedCredentialsFileEnv: 'AWS_SHARED_CREDENTIALS_FILE',
	
	  /**
	   * @api private
	   */
	  sharedConfigFileEnv: 'AWS_CONFIG_FILE',
	
	  /**
	   * @api private
	   */
	  imdsDisabledEnv: 'AWS_EC2_METADATA_DISABLED'
	};
	
	/**
	 * @api private
	 */
	module.exports = util;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(269).setImmediate))

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var util = __webpack_require__(__webpack_module_template_argument_0__);
	var Shape = __webpack_require__(__webpack_module_template_argument_1__);
	
	function DomXmlParser() { }
	
	DomXmlParser.prototype.parse = function(xml, shape) {
	  if (xml.replace(/^\s+/, '') === '') return {};
	
	  var result, error;
	  try {
	    if (window.DOMParser) {
	      try {
	        var parser = new DOMParser();
	        result = parser.parseFromString(xml, 'text/xml');
	      } catch (syntaxError) {
	        throw util.error(new Error('Parse error in document'),
	          {
	            originalError: syntaxError,
	            code: 'XMLParserError',
	            retryable: true
	          });
	      }
	
	      if (result.documentElement === null) {
	        throw util.error(new Error('Cannot parse empty document.'),
	          {
	            code: 'XMLParserError',
	            retryable: true
	          });
	      }
	
	      var isError = result.getElementsByTagName('parsererror')[0];
	      if (isError && (isError.parentNode === result ||
	          isError.parentNode.nodeName === 'body' ||
	          isError.parentNode.parentNode === result ||
	          isError.parentNode.parentNode.nodeName === 'body')) {
	        var errorElement = isError.getElementsByTagName('div')[0] || isError;
	        throw util.error(new Error(errorElement.textContent || 'Parser error in document'),
	          {
	            code: 'XMLParserError',
	            retryable: true
	          });
	      }
	    } else if (window.ActiveXObject) {
	      result = new window.ActiveXObject('Microsoft.XMLDOM');
	      result.async = false;
	
	      if (!result.loadXML(xml)) {
	        throw util.error(new Error('Parse error in document'),
	          {
	            code: 'XMLParserError',
	            retryable: true
	          });
	      }
	    } else {
	      throw new Error('Cannot load XML parser');
	    }
	  } catch (e) {
	    error = e;
	  }
	
	  if (result && result.documentElement && !error) {
	    var data = parseXml(result.documentElement, shape);
	    var metadata = getElementByTagName(result.documentElement, 'ResponseMetadata');
	    if (metadata) {
	      data.ResponseMetadata = parseXml(metadata, {});
	    }
	    return data;
	  } else if (error) {
	    throw util.error(error || new Error(), {code: 'XMLParserError', retryable: true});
	  } else { // empty xml document
	    return {};
	  }
	};
	
	function getElementByTagName(xml, tag) {
	  var elements = xml.getElementsByTagName(tag);
	  for (var i = 0, iLen = elements.length; i < iLen; i++) {
	    if (elements[i].parentNode === xml) {
	      return elements[i];
	    }
	  }
	}
	
	function parseXml(xml, shape) {
	  if (!shape) shape = {};
	  switch (shape.type) {
	    case 'structure': return parseStructure(xml, shape);
	    case 'map': return parseMap(xml, shape);
	    case 'list': return parseList(xml, shape);
	    case undefined: case null: return parseUnknown(xml);
	    default: return parseScalar(xml, shape);
	  }
	}
	
	function parseStructure(xml, shape) {
	  var data = {};
	  if (xml === null) return data;
	
	  util.each(shape.members, function(memberName, memberShape) {
	    if (memberShape.isXmlAttribute) {
	      if (Object.prototype.hasOwnProperty.call(xml.attributes, memberShape.name)) {
	        var value = xml.attributes[memberShape.name].value;
	        data[memberName] = parseXml({textContent: value}, memberShape);
	      }
	    } else {
	      var xmlChild = memberShape.flattened ? xml :
	        getElementByTagName(xml, memberShape.name);
	      if (xmlChild) {
	        data[memberName] = parseXml(xmlChild, memberShape);
	      } else if (!memberShape.flattened && memberShape.type === 'list') {
	        data[memberName] = memberShape.defaultValue;
	      }
	    }
	  });
	
	  return data;
	}
	
	function parseMap(xml, shape) {
	  var data = {};
	  var xmlKey = shape.key.name || 'key';
	  var xmlValue = shape.value.name || 'value';
	  var tagName = shape.flattened ? shape.name : 'entry';
	
	  var child = xml.firstElementChild;
	  while (child) {
	    if (child.nodeName === tagName) {
	      var key = getElementByTagName(child, xmlKey).textContent;
	      var value = getElementByTagName(child, xmlValue);
	      data[key] = parseXml(value, shape.value);
	    }
	    child = child.nextElementSibling;
	  }
	  return data;
	}
	
	function parseList(xml, shape) {
	  var data = [];
	  var tagName = shape.flattened ? shape.name : (shape.member.name || 'member');
	
	  var child = xml.firstElementChild;
	  while (child) {
	    if (child.nodeName === tagName) {
	      data.push(parseXml(child, shape.member));
	    }
	    child = child.nextElementSibling;
	  }
	  return data;
	}
	
	function parseScalar(xml, shape) {
	  if (xml.getAttribute) {
	    var encoding = xml.getAttribute('encoding');
	    if (encoding === 'base64') {
	      shape = new Shape.create({type: encoding});
	    }
	  }
	
	  var text = xml.textContent;
	  if (text === '') text = null;
	  if (typeof shape.toType === 'function') {
	    return shape.toType(text);
	  } else {
	    return text;
	  }
	}
	
	function parseUnknown(xml) {
	  if (xml === undefined || xml === null) return '';
	
	  // empty object
	  if (!xml.firstElementChild) {
	    if (xml.parentNode.parentNode === null) return {};
	    if (xml.childNodes.length === 0) return '';
	    else return xml.textContent;
	  }
	
	  // object, parse as structure
	  var shape = {type: 'structure', members: {}};
	  var child = xml.firstElementChild;
	  while (child) {
	    var tag = child.nodeName;
	    if (Object.prototype.hasOwnProperty.call(shape.members, tag)) {
	      // multiple tags of the same name makes it a list
	      shape.members[tag].type = 'list';
	    } else {
	      shape.members[tag] = {name: tag};
	    }
	    child = child.nextElementSibling;
	  }
	  return parseStructure(xml, shape);
	}
	
	/**
	 * @api private
	 */
	module.exports = DomXmlParser;


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var util = __webpack_require__(__webpack_module_template_argument_0__);
	var XmlNode = __webpack_require__(__webpack_module_template_argument_1__).XmlNode;
	var XmlText = __webpack_require__(__webpack_module_template_argument_2__).XmlText;
	
	function XmlBuilder() { }
	
	XmlBuilder.prototype.toXML = function(params, shape, rootElement, noEmpty) {
	  var xml = new XmlNode(rootElement);
	  applyNamespaces(xml, shape, true);
	  serialize(xml, params, shape);
	  return xml.children.length > 0 || noEmpty ? xml.toString() : '';
	};
	
	function serialize(xml, value, shape) {
	  switch (shape.type) {
	    case 'structure': return serializeStructure(xml, value, shape);
	    case 'map': return serializeMap(xml, value, shape);
	    case 'list': return serializeList(xml, value, shape);
	    default: return serializeScalar(xml, value, shape);
	  }
	}
	
	function serializeStructure(xml, params, shape) {
	  util.arrayEach(shape.memberNames, function(memberName) {
	    var memberShape = shape.members[memberName];
	    if (memberShape.location !== 'body') return;
	
	    var value = params[memberName];
	    var name = memberShape.name;
	    if (value !== undefined && value !== null) {
	      if (memberShape.isXmlAttribute) {
	        xml.addAttribute(name, value);
	      } else if (memberShape.flattened) {
	        serialize(xml, value, memberShape);
	      } else {
	        var element = new XmlNode(name);
	        xml.addChildNode(element);
	        applyNamespaces(element, memberShape);
	        serialize(element, value, memberShape);
	      }
	    }
	  });
	}
	
	function serializeMap(xml, map, shape) {
	  var xmlKey = shape.key.name || 'key';
	  var xmlValue = shape.value.name || 'value';
	
	  util.each(map, function(key, value) {
	    var entry = new XmlNode(shape.flattened ? shape.name : 'entry');
	    xml.addChildNode(entry);
	
	    var entryKey = new XmlNode(xmlKey);
	    var entryValue = new XmlNode(xmlValue);
	    entry.addChildNode(entryKey);
	    entry.addChildNode(entryValue);
	
	    serialize(entryKey, key, shape.key);
	    serialize(entryValue, value, shape.value);
	  });
	}
	
	function serializeList(xml, list, shape) {
	  if (shape.flattened) {
	    util.arrayEach(list, function(value) {
	      var name = shape.member.name || shape.name;
	      var element = new XmlNode(name);
	      xml.addChildNode(element);
	      serialize(element, value, shape.member);
	    });
	  } else {
	    util.arrayEach(list, function(value) {
	      var name = shape.member.name || 'member';
	      var element = new XmlNode(name);
	      xml.addChildNode(element);
	      serialize(element, value, shape.member);
	    });
	  }
	}
	
	function serializeScalar(xml, value, shape) {
	  xml.addChildNode(
	    new XmlText(shape.toWireFormat(value))
	  );
	}
	
	function applyNamespaces(xml, shape, isRoot) {
	  var uri, prefix = 'xmlns';
	  if (shape.xmlNamespaceUri) {
	    uri = shape.xmlNamespaceUri;
	    if (shape.xmlNamespacePrefix) prefix += ':' + shape.xmlNamespacePrefix;
	  } else if (isRoot && shape.api.xmlNamespaceUri) {
	    uri = shape.api.xmlNamespaceUri;
	  }
	
	  if (uri) xml.addAttribute(prefix, uri);
	}
	
	/**
	 * @api private
	 */
	module.exports = XmlBuilder;


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var escapeAttribute = __webpack_require__(__webpack_module_template_argument_0__).escapeAttribute;
	
	/**
	 * Represents an XML node.
	 * @api private
	 */
	function XmlNode(name, children) {
	    if (children === void 0) { children = []; }
	    this.name = name;
	    this.children = children;
	    this.attributes = {};
	}
	XmlNode.prototype.addAttribute = function (name, value) {
	    this.attributes[name] = value;
	    return this;
	};
	XmlNode.prototype.addChildNode = function (child) {
	    this.children.push(child);
	    return this;
	};
	XmlNode.prototype.removeAttribute = function (name) {
	    delete this.attributes[name];
	    return this;
	};
	XmlNode.prototype.toString = function () {
	    var hasChildren = Boolean(this.children.length);
	    var xmlText = '<' + this.name;
	    // add attributes
	    var attributes = this.attributes;
	    for (var i = 0, attributeNames = Object.keys(attributes); i < attributeNames.length; i++) {
	        var attributeName = attributeNames[i];
	        var attribute = attributes[attributeName];
	        if (typeof attribute !== 'undefined' && attribute !== null) {
	            xmlText += ' ' + attributeName + '=\"' + escapeAttribute('' + attribute) + '\"';
	        }
	    }
	    return xmlText += !hasChildren ? '/>' : '>' + this.children.map(function (c) { return c.toString(); }).join('') + '</' + this.name + '>';
	};
	
	/**
	 * @api private
	 */
	module.exports = {
	    XmlNode: XmlNode
	};


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var escapeElement = __webpack_require__(__webpack_module_template_argument_0__).escapeElement;
	
	/**
	 * Represents an XML text value.
	 * @api private
	 */
	function XmlText(value) {
	    this.value = value;
	}
	
	XmlText.prototype.toString = function () {
	    return escapeElement('' + this.value);
	};
	
	/**
	 * @api private
	 */
	module.exports = {
	    XmlText: XmlText
	};


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var LRU_1 = __webpack_require__(__webpack_module_template_argument_0__);
	var CACHE_SIZE = 1000;
	/**
	 * Inspired node-lru-cache[https://github.com/isaacs/node-lru-cache]
	 */
	var EndpointCache = /** @class */ (function () {
	    function EndpointCache(maxSize) {
	        if (maxSize === void 0) { maxSize = CACHE_SIZE; }
	        this.maxSize = maxSize;
	        this.cache = new LRU_1.LRUCache(maxSize);
	    }
	    ;
	    Object.defineProperty(EndpointCache.prototype, "size", {
	        get: function () {
	            return this.cache.length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    EndpointCache.prototype.put = function (key, value) {
	      var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
	        var endpointRecord = this.populateValue(value);
	        this.cache.put(keyString, endpointRecord);
	    };
	    EndpointCache.prototype.get = function (key) {
	      var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
	        var now = Date.now();
	        var records = this.cache.get(keyString);
	        if (records) {
	            for (var i = 0; i < records.length; i++) {
	                var record = records[i];
	                if (record.Expire < now) {
	                    this.cache.remove(keyString);
	                    return undefined;
	                }
	            }
	        }
	        return records;
	    };
	    EndpointCache.getKeyString = function (key) {
	        var identifiers = [];
	        var identifierNames = Object.keys(key).sort();
	        for (var i = 0; i < identifierNames.length; i++) {
	            var identifierName = identifierNames[i];
	            if (key[identifierName] === undefined)
	                continue;
	            identifiers.push(key[identifierName]);
	        }
	        return identifiers.join(' ');
	    };
	    EndpointCache.prototype.populateValue = function (endpoints) {
	        var now = Date.now();
	        return endpoints.map(function (endpoint) { return ({
	            Address: endpoint.Address || '',
	            Expire: now + (endpoint.CachePeriodInMinutes || 1) * 60 * 1000
	        }); });
	    };
	    EndpointCache.prototype.empty = function () {
	        this.cache.empty();
	    };
	    EndpointCache.prototype.remove = function (key) {
	      var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
	        this.cache.remove(keyString);
	    };
	    return EndpointCache;
	}());
	exports.EndpointCache = EndpointCache;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var v1 = __webpack_require__(__webpack_module_template_argument_0__);
	var v4 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var rng = __webpack_require__(__webpack_module_template_argument_0__);
	var bytesToUuid = __webpack_require__(__webpack_module_template_argument_1__);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var rng = __webpack_require__(__webpack_module_template_argument_0__);
	var bytesToUuid = __webpack_require__(__webpack_module_template_argument_1__);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.4baecdcd.js